function xP(n, e) {
  for (var t = 0; t < e.length; t++) {
    const i = e[t]
    if (typeof i != "string" && !Array.isArray(i)) {
      for (const r in i)
        if (r !== "default" && !(r in n)) {
          const s = Object.getOwnPropertyDescriptor(i, r)
          s &&
            Object.defineProperty(n, r, s.get ? s : { enumerable: !0, get: () => i[r] })
        }
    }
  }
  return Object.freeze(
    Object.defineProperty(n, Symbol.toStringTag, { value: "Module" }),
  )
}
;(function () {
  const e = document.createElement("link").relList
  if (e && e.supports && e.supports("modulepreload")) return
  for (const r of document.querySelectorAll('link[rel="modulepreload"]')) i(r)
  new MutationObserver((r) => {
    for (const s of r)
      if (s.type === "childList")
        for (const o of s.addedNodes)
          o.tagName === "LINK" && o.rel === "modulepreload" && i(o)
  }).observe(document, { childList: !0, subtree: !0 })
  function t(r) {
    const s = {}
    return (
      r.integrity && (s.integrity = r.integrity),
      r.referrerPolicy && (s.referrerPolicy = r.referrerPolicy),
      r.crossOrigin === "use-credentials"
        ? (s.credentials = "include")
        : r.crossOrigin === "anonymous"
        ? (s.credentials = "omit")
        : (s.credentials = "same-origin"),
      s
    )
  }
  function i(r) {
    if (r.ep) return
    r.ep = !0
    const s = t(r)
    fetch(r.href, s)
  }
})()
function rm(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default")
    ? n.default
    : n
}
var Zy = { exports: {} },
  Wh = {},
  Jy = { exports: {} },
  nn = {}
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var KS
function _P() {
  if (KS) return nn
  KS = 1
  var n = Symbol.for("react.element"),
    e = Symbol.for("react.portal"),
    t = Symbol.for("react.fragment"),
    i = Symbol.for("react.strict_mode"),
    r = Symbol.for("react.profiler"),
    s = Symbol.for("react.provider"),
    o = Symbol.for("react.context"),
    l = Symbol.for("react.forward_ref"),
    u = Symbol.for("react.suspense"),
    d = Symbol.for("react.memo"),
    p = Symbol.for("react.lazy"),
    m = Symbol.iterator
  function v(W) {
    return W === null || typeof W != "object"
      ? null
      : ((W = (m && W[m]) || W["@@iterator"]), typeof W == "function" ? W : null)
  }
  var y = {
      isMounted: function () {
        return !1
      },
      enqueueForceUpdate: function () {},
      enqueueReplaceState: function () {},
      enqueueSetState: function () {},
    },
    x = Object.assign,
    E = {}
  function M(W, ne, ye) {
    ;(this.props = W), (this.context = ne), (this.refs = E), (this.updater = ye || y)
  }
  ;(M.prototype.isReactComponent = {}),
    (M.prototype.setState = function (W, ne) {
      if (typeof W != "object" && typeof W != "function" && W != null)
        throw Error(
          "setState(...): takes an object of state variables to update or a function which returns an object of state variables.",
        )
      this.updater.enqueueSetState(this, W, ne, "setState")
    }),
    (M.prototype.forceUpdate = function (W) {
      this.updater.enqueueForceUpdate(this, W, "forceUpdate")
    })
  function w() {}
  w.prototype = M.prototype
  function A(W, ne, ye) {
    ;(this.props = W), (this.context = ne), (this.refs = E), (this.updater = ye || y)
  }
  var C = (A.prototype = new w())
  ;(C.constructor = A), x(C, M.prototype), (C.isPureReactComponent = !0)
  var R = Array.isArray,
    z = Object.prototype.hasOwnProperty,
    U = { current: null },
    O = { key: !0, ref: !0, __self: !0, __source: !0 }
  function N(W, ne, ye) {
    var oe,
      fe = {},
      we = null,
      me = null
    if (ne != null)
      for (oe in (ne.ref !== void 0 && (me = ne.ref),
      ne.key !== void 0 && (we = "" + ne.key),
      ne))
        z.call(ne, oe) && !O.hasOwnProperty(oe) && (fe[oe] = ne[oe])
    var Fe = arguments.length - 2
    if (Fe === 1) fe.children = ye
    else if (1 < Fe) {
      for (var ze = Array(Fe), Ge = 0; Ge < Fe; Ge++) ze[Ge] = arguments[Ge + 2]
      fe.children = ze
    }
    if (W && W.defaultProps)
      for (oe in ((Fe = W.defaultProps), Fe)) fe[oe] === void 0 && (fe[oe] = Fe[oe])
    return { $$typeof: n, type: W, key: we, ref: me, props: fe, _owner: U.current }
  }
  function k(W, ne) {
    return {
      $$typeof: n,
      type: W.type,
      key: ne,
      ref: W.ref,
      props: W.props,
      _owner: W._owner,
    }
  }
  function I(W) {
    return typeof W == "object" && W !== null && W.$$typeof === n
  }
  function V(W) {
    var ne = { "=": "=0", ":": "=2" }
    return (
      "$" +
      W.replace(/[=:]/g, function (ye) {
        return ne[ye]
      })
    )
  }
  var Z = /\/+/g
  function $(W, ne) {
    return typeof W == "object" && W !== null && W.key != null
      ? V("" + W.key)
      : ne.toString(36)
  }
  function ee(W, ne, ye, oe, fe) {
    var we = typeof W
    ;(we === "undefined" || we === "boolean") && (W = null)
    var me = !1
    if (W === null) me = !0
    else
      switch (we) {
        case "string":
        case "number":
          me = !0
          break
        case "object":
          switch (W.$$typeof) {
            case n:
            case e:
              me = !0
          }
      }
    if (me)
      return (
        (me = W),
        (fe = fe(me)),
        (W = oe === "" ? "." + $(me, 0) : oe),
        R(fe)
          ? ((ye = ""),
            W != null && (ye = W.replace(Z, "$&/") + "/"),
            ee(fe, ne, ye, "", function (Ge) {
              return Ge
            }))
          : fe != null &&
            (I(fe) &&
              (fe = k(
                fe,
                ye +
                  (!fe.key || (me && me.key === fe.key)
                    ? ""
                    : ("" + fe.key).replace(Z, "$&/") + "/") +
                  W,
              )),
            ne.push(fe)),
        1
      )
    if (((me = 0), (oe = oe === "" ? "." : oe + ":"), R(W)))
      for (var Fe = 0; Fe < W.length; Fe++) {
        we = W[Fe]
        var ze = oe + $(we, Fe)
        me += ee(we, ne, ye, ze, fe)
      }
    else if (((ze = v(W)), typeof ze == "function"))
      for (W = ze.call(W), Fe = 0; !(we = W.next()).done; )
        (we = we.value), (ze = oe + $(we, Fe++)), (me += ee(we, ne, ye, ze, fe))
    else if (we === "object")
      throw (
        ((ne = String(W)),
        Error(
          "Objects are not valid as a React child (found: " +
            (ne === "[object Object]"
              ? "object with keys {" + Object.keys(W).join(", ") + "}"
              : ne) +
            "). If you meant to render a collection of children, use an array instead.",
        ))
      )
    return me
  }
  function ue(W, ne, ye) {
    if (W == null) return W
    var oe = [],
      fe = 0
    return (
      ee(W, oe, "", "", function (we) {
        return ne.call(ye, we, fe++)
      }),
      oe
    )
  }
  function re(W) {
    if (W._status === -1) {
      var ne = W._result
      ;(ne = ne()),
        ne.then(
          function (ye) {
            ;(W._status === 0 || W._status === -1) &&
              ((W._status = 1), (W._result = ye))
          },
          function (ye) {
            ;(W._status === 0 || W._status === -1) &&
              ((W._status = 2), (W._result = ye))
          },
        ),
        W._status === -1 && ((W._status = 0), (W._result = ne))
    }
    if (W._status === 1) return W._result.default
    throw W._result
  }
  var se = { current: null },
    G = { transition: null },
    ie = {
      ReactCurrentDispatcher: se,
      ReactCurrentBatchConfig: G,
      ReactCurrentOwner: U,
    }
  function Q() {
    throw Error("act(...) is not supported in production builds of React.")
  }
  return (
    (nn.Children = {
      map: ue,
      forEach: function (W, ne, ye) {
        ue(
          W,
          function () {
            ne.apply(this, arguments)
          },
          ye,
        )
      },
      count: function (W) {
        var ne = 0
        return (
          ue(W, function () {
            ne++
          }),
          ne
        )
      },
      toArray: function (W) {
        return (
          ue(W, function (ne) {
            return ne
          }) || []
        )
      },
      only: function (W) {
        if (!I(W))
          throw Error(
            "React.Children.only expected to receive a single React element child.",
          )
        return W
      },
    }),
    (nn.Component = M),
    (nn.Fragment = t),
    (nn.Profiler = r),
    (nn.PureComponent = A),
    (nn.StrictMode = i),
    (nn.Suspense = u),
    (nn.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ie),
    (nn.act = Q),
    (nn.cloneElement = function (W, ne, ye) {
      if (W == null)
        throw Error(
          "React.cloneElement(...): The argument must be a React element, but you passed " +
            W +
            ".",
        )
      var oe = x({}, W.props),
        fe = W.key,
        we = W.ref,
        me = W._owner
      if (ne != null) {
        if (
          (ne.ref !== void 0 && ((we = ne.ref), (me = U.current)),
          ne.key !== void 0 && (fe = "" + ne.key),
          W.type && W.type.defaultProps)
        )
          var Fe = W.type.defaultProps
        for (ze in ne)
          z.call(ne, ze) &&
            !O.hasOwnProperty(ze) &&
            (oe[ze] = ne[ze] === void 0 && Fe !== void 0 ? Fe[ze] : ne[ze])
      }
      var ze = arguments.length - 2
      if (ze === 1) oe.children = ye
      else if (1 < ze) {
        Fe = Array(ze)
        for (var Ge = 0; Ge < ze; Ge++) Fe[Ge] = arguments[Ge + 2]
        oe.children = Fe
      }
      return { $$typeof: n, type: W.type, key: fe, ref: we, props: oe, _owner: me }
    }),
    (nn.createContext = function (W) {
      return (
        (W = {
          $$typeof: o,
          _currentValue: W,
          _currentValue2: W,
          _threadCount: 0,
          Provider: null,
          Consumer: null,
          _defaultValue: null,
          _globalName: null,
        }),
        (W.Provider = { $$typeof: s, _context: W }),
        (W.Consumer = W)
      )
    }),
    (nn.createElement = N),
    (nn.createFactory = function (W) {
      var ne = N.bind(null, W)
      return (ne.type = W), ne
    }),
    (nn.createRef = function () {
      return { current: null }
    }),
    (nn.forwardRef = function (W) {
      return { $$typeof: l, render: W }
    }),
    (nn.isValidElement = I),
    (nn.lazy = function (W) {
      return { $$typeof: p, _payload: { _status: -1, _result: W }, _init: re }
    }),
    (nn.memo = function (W, ne) {
      return { $$typeof: d, type: W, compare: ne === void 0 ? null : ne }
    }),
    (nn.startTransition = function (W) {
      var ne = G.transition
      G.transition = {}
      try {
        W()
      } finally {
        G.transition = ne
      }
    }),
    (nn.unstable_act = Q),
    (nn.useCallback = function (W, ne) {
      return se.current.useCallback(W, ne)
    }),
    (nn.useContext = function (W) {
      return se.current.useContext(W)
    }),
    (nn.useDebugValue = function () {}),
    (nn.useDeferredValue = function (W) {
      return se.current.useDeferredValue(W)
    }),
    (nn.useEffect = function (W, ne) {
      return se.current.useEffect(W, ne)
    }),
    (nn.useId = function () {
      return se.current.useId()
    }),
    (nn.useImperativeHandle = function (W, ne, ye) {
      return se.current.useImperativeHandle(W, ne, ye)
    }),
    (nn.useInsertionEffect = function (W, ne) {
      return se.current.useInsertionEffect(W, ne)
    }),
    (nn.useLayoutEffect = function (W, ne) {
      return se.current.useLayoutEffect(W, ne)
    }),
    (nn.useMemo = function (W, ne) {
      return se.current.useMemo(W, ne)
    }),
    (nn.useReducer = function (W, ne, ye) {
      return se.current.useReducer(W, ne, ye)
    }),
    (nn.useRef = function (W) {
      return se.current.useRef(W)
    }),
    (nn.useState = function (W) {
      return se.current.useState(W)
    }),
    (nn.useSyncExternalStore = function (W, ne, ye) {
      return se.current.useSyncExternalStore(W, ne, ye)
    }),
    (nn.useTransition = function () {
      return se.current.useTransition()
    }),
    (nn.version = "18.3.1"),
    nn
  )
}
var ZS
function sc() {
  return ZS || ((ZS = 1), (Jy.exports = _P())), Jy.exports
}
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var JS
function wP() {
  if (JS) return Wh
  JS = 1
  var n = sc(),
    e = Symbol.for("react.element"),
    t = Symbol.for("react.fragment"),
    i = Object.prototype.hasOwnProperty,
    r = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    s = { key: !0, ref: !0, __self: !0, __source: !0 }
  function o(l, u, d) {
    var p,
      m = {},
      v = null,
      y = null
    d !== void 0 && (v = "" + d),
      u.key !== void 0 && (v = "" + u.key),
      u.ref !== void 0 && (y = u.ref)
    for (p in u) i.call(u, p) && !s.hasOwnProperty(p) && (m[p] = u[p])
    if (l && l.defaultProps)
      for (p in ((u = l.defaultProps), u)) m[p] === void 0 && (m[p] = u[p])
    return { $$typeof: e, type: l, key: v, ref: y, props: m, _owner: r.current }
  }
  return (Wh.Fragment = t), (Wh.jsx = o), (Wh.jsxs = o), Wh
}
var QS
function SP() {
  return QS || ((QS = 1), (Zy.exports = wP())), Zy.exports
}
var D = SP(),
  Y = sc()
const Ht = rm(Y),
  eM = xP({ __proto__: null, default: Ht }, [Y])
var Sg = {},
  Qy = { exports: {} },
  Xr = {},
  ex = { exports: {} },
  tx = {}
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var tM
function MP() {
  return (
    tM ||
      ((tM = 1),
      (function (n) {
        function e(G, ie) {
          var Q = G.length
          G.push(ie)
          e: for (; 0 < Q; ) {
            var W = (Q - 1) >>> 1,
              ne = G[W]
            if (0 < r(ne, ie)) (G[W] = ie), (G[Q] = ne), (Q = W)
            else break e
          }
        }
        function t(G) {
          return G.length === 0 ? null : G[0]
        }
        function i(G) {
          if (G.length === 0) return null
          var ie = G[0],
            Q = G.pop()
          if (Q !== ie) {
            G[0] = Q
            e: for (var W = 0, ne = G.length, ye = ne >>> 1; W < ye; ) {
              var oe = 2 * (W + 1) - 1,
                fe = G[oe],
                we = oe + 1,
                me = G[we]
              if (0 > r(fe, Q))
                we < ne && 0 > r(me, fe)
                  ? ((G[W] = me), (G[we] = Q), (W = we))
                  : ((G[W] = fe), (G[oe] = Q), (W = oe))
              else if (we < ne && 0 > r(me, Q)) (G[W] = me), (G[we] = Q), (W = we)
              else break e
            }
          }
          return ie
        }
        function r(G, ie) {
          var Q = G.sortIndex - ie.sortIndex
          return Q !== 0 ? Q : G.id - ie.id
        }
        if (typeof performance == "object" && typeof performance.now == "function") {
          var s = performance
          n.unstable_now = function () {
            return s.now()
          }
        } else {
          var o = Date,
            l = o.now()
          n.unstable_now = function () {
            return o.now() - l
          }
        }
        var u = [],
          d = [],
          p = 1,
          m = null,
          v = 3,
          y = !1,
          x = !1,
          E = !1,
          M = typeof setTimeout == "function" ? setTimeout : null,
          w = typeof clearTimeout == "function" ? clearTimeout : null,
          A = typeof setImmediate < "u" ? setImmediate : null
        typeof navigator < "u" &&
          navigator.scheduling !== void 0 &&
          navigator.scheduling.isInputPending !== void 0 &&
          navigator.scheduling.isInputPending.bind(navigator.scheduling)
        function C(G) {
          for (var ie = t(d); ie !== null; ) {
            if (ie.callback === null) i(d)
            else if (ie.startTime <= G)
              i(d), (ie.sortIndex = ie.expirationTime), e(u, ie)
            else break
            ie = t(d)
          }
        }
        function R(G) {
          if (((E = !1), C(G), !x))
            if (t(u) !== null) (x = !0), re(z)
            else {
              var ie = t(d)
              ie !== null && se(R, ie.startTime - G)
            }
        }
        function z(G, ie) {
          ;(x = !1), E && ((E = !1), w(N), (N = -1)), (y = !0)
          var Q = v
          try {
            for (
              C(ie), m = t(u);
              m !== null && (!(m.expirationTime > ie) || (G && !V()));

            ) {
              var W = m.callback
              if (typeof W == "function") {
                ;(m.callback = null), (v = m.priorityLevel)
                var ne = W(m.expirationTime <= ie)
                ;(ie = n.unstable_now()),
                  typeof ne == "function" ? (m.callback = ne) : m === t(u) && i(u),
                  C(ie)
              } else i(u)
              m = t(u)
            }
            if (m !== null) var ye = !0
            else {
              var oe = t(d)
              oe !== null && se(R, oe.startTime - ie), (ye = !1)
            }
            return ye
          } finally {
            ;(m = null), (v = Q), (y = !1)
          }
        }
        var U = !1,
          O = null,
          N = -1,
          k = 5,
          I = -1
        function V() {
          return !(n.unstable_now() - I < k)
        }
        function Z() {
          if (O !== null) {
            var G = n.unstable_now()
            I = G
            var ie = !0
            try {
              ie = O(!0, G)
            } finally {
              ie ? $() : ((U = !1), (O = null))
            }
          } else U = !1
        }
        var $
        if (typeof A == "function")
          $ = function () {
            A(Z)
          }
        else if (typeof MessageChannel < "u") {
          var ee = new MessageChannel(),
            ue = ee.port2
          ;(ee.port1.onmessage = Z),
            ($ = function () {
              ue.postMessage(null)
            })
        } else
          $ = function () {
            M(Z, 0)
          }
        function re(G) {
          ;(O = G), U || ((U = !0), $())
        }
        function se(G, ie) {
          N = M(function () {
            G(n.unstable_now())
          }, ie)
        }
        ;(n.unstable_IdlePriority = 5),
          (n.unstable_ImmediatePriority = 1),
          (n.unstable_LowPriority = 4),
          (n.unstable_NormalPriority = 3),
          (n.unstable_Profiling = null),
          (n.unstable_UserBlockingPriority = 2),
          (n.unstable_cancelCallback = function (G) {
            G.callback = null
          }),
          (n.unstable_continueExecution = function () {
            x || y || ((x = !0), re(z))
          }),
          (n.unstable_forceFrameRate = function (G) {
            0 > G || 125 < G
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
              : (k = 0 < G ? Math.floor(1e3 / G) : 5)
          }),
          (n.unstable_getCurrentPriorityLevel = function () {
            return v
          }),
          (n.unstable_getFirstCallbackNode = function () {
            return t(u)
          }),
          (n.unstable_next = function (G) {
            switch (v) {
              case 1:
              case 2:
              case 3:
                var ie = 3
                break
              default:
                ie = v
            }
            var Q = v
            v = ie
            try {
              return G()
            } finally {
              v = Q
            }
          }),
          (n.unstable_pauseExecution = function () {}),
          (n.unstable_requestPaint = function () {}),
          (n.unstable_runWithPriority = function (G, ie) {
            switch (G) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break
              default:
                G = 3
            }
            var Q = v
            v = G
            try {
              return ie()
            } finally {
              v = Q
            }
          }),
          (n.unstable_scheduleCallback = function (G, ie, Q) {
            var W = n.unstable_now()
            switch (
              (typeof Q == "object" && Q !== null
                ? ((Q = Q.delay), (Q = typeof Q == "number" && 0 < Q ? W + Q : W))
                : (Q = W),
              G)
            ) {
              case 1:
                var ne = -1
                break
              case 2:
                ne = 250
                break
              case 5:
                ne = 1073741823
                break
              case 4:
                ne = 1e4
                break
              default:
                ne = 5e3
            }
            return (
              (ne = Q + ne),
              (G = {
                id: p++,
                callback: ie,
                priorityLevel: G,
                startTime: Q,
                expirationTime: ne,
                sortIndex: -1,
              }),
              Q > W
                ? ((G.sortIndex = Q),
                  e(d, G),
                  t(u) === null &&
                    G === t(d) &&
                    (E ? (w(N), (N = -1)) : (E = !0), se(R, Q - W)))
                : ((G.sortIndex = ne), e(u, G), x || y || ((x = !0), re(z))),
              G
            )
          }),
          (n.unstable_shouldYield = V),
          (n.unstable_wrapCallback = function (G) {
            var ie = v
            return function () {
              var Q = v
              v = ie
              try {
                return G.apply(this, arguments)
              } finally {
                v = Q
              }
            }
          })
      })(tx)),
    tx
  )
}
var nM
function EP() {
  return nM || ((nM = 1), (ex.exports = MP())), ex.exports
}
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var iM
function TP() {
  if (iM) return Xr
  iM = 1
  var n = sc(),
    e = EP()
  function t(a) {
    for (
      var c = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, g = 1;
      g < arguments.length;
      g++
    )
      c += "&args[]=" + encodeURIComponent(arguments[g])
    return (
      "Minified React error #" +
      a +
      "; visit " +
      c +
      " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
    )
  }
  var i = new Set(),
    r = {}
  function s(a, c) {
    o(a, c), o(a + "Capture", c)
  }
  function o(a, c) {
    for (r[a] = c, a = 0; a < c.length; a++) i.add(c[a])
  }
  var l = !(
      typeof window > "u" ||
      typeof window.document > "u" ||
      typeof window.document.createElement > "u"
    ),
    u = Object.prototype.hasOwnProperty,
    d =
      /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    p = {},
    m = {}
  function v(a) {
    return u.call(m, a)
      ? !0
      : u.call(p, a)
      ? !1
      : d.test(a)
      ? (m[a] = !0)
      : ((p[a] = !0), !1)
  }
  function y(a, c, g, S) {
    if (g !== null && g.type === 0) return !1
    switch (typeof c) {
      case "function":
      case "symbol":
        return !0
      case "boolean":
        return S
          ? !1
          : g !== null
          ? !g.acceptsBooleans
          : ((a = a.toLowerCase().slice(0, 5)), a !== "data-" && a !== "aria-")
      default:
        return !1
    }
  }
  function x(a, c, g, S) {
    if (c === null || typeof c > "u" || y(a, c, g, S)) return !0
    if (S) return !1
    if (g !== null)
      switch (g.type) {
        case 3:
          return !c
        case 4:
          return c === !1
        case 5:
          return isNaN(c)
        case 6:
          return isNaN(c) || 1 > c
      }
    return !1
  }
  function E(a, c, g, S, b, L, H) {
    ;(this.acceptsBooleans = c === 2 || c === 3 || c === 4),
      (this.attributeName = S),
      (this.attributeNamespace = b),
      (this.mustUseProperty = g),
      (this.propertyName = a),
      (this.type = c),
      (this.sanitizeURL = L),
      (this.removeEmptyString = H)
  }
  var M = {}
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
    .split(" ")
    .forEach(function (a) {
      M[a] = new E(a, 0, !1, a, null, !1, !1)
    }),
    [
      ["acceptCharset", "accept-charset"],
      ["className", "class"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
    ].forEach(function (a) {
      var c = a[0]
      M[c] = new E(c, 1, !1, a[1], null, !1, !1)
    }),
    ["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
      M[a] = new E(a, 2, !1, a.toLowerCase(), null, !1, !1)
    }),
    ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(
      function (a) {
        M[a] = new E(a, 2, !1, a, null, !1, !1)
      },
    ),
    "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
      .split(" ")
      .forEach(function (a) {
        M[a] = new E(a, 3, !1, a.toLowerCase(), null, !1, !1)
      }),
    ["checked", "multiple", "muted", "selected"].forEach(function (a) {
      M[a] = new E(a, 3, !0, a, null, !1, !1)
    }),
    ["capture", "download"].forEach(function (a) {
      M[a] = new E(a, 4, !1, a, null, !1, !1)
    }),
    ["cols", "rows", "size", "span"].forEach(function (a) {
      M[a] = new E(a, 6, !1, a, null, !1, !1)
    }),
    ["rowSpan", "start"].forEach(function (a) {
      M[a] = new E(a, 5, !1, a.toLowerCase(), null, !1, !1)
    })
  var w = /[\-:]([a-z])/g
  function A(a) {
    return a[1].toUpperCase()
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
    .split(" ")
    .forEach(function (a) {
      var c = a.replace(w, A)
      M[c] = new E(c, 1, !1, a, null, !1, !1)
    }),
    "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
      .split(" ")
      .forEach(function (a) {
        var c = a.replace(w, A)
        M[c] = new E(c, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1)
      }),
    ["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
      var c = a.replace(w, A)
      M[c] = new E(c, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1)
    }),
    ["tabIndex", "crossOrigin"].forEach(function (a) {
      M[a] = new E(a, 1, !1, a.toLowerCase(), null, !1, !1)
    }),
    (M.xlinkHref = new E(
      "xlinkHref",
      1,
      !1,
      "xlink:href",
      "http://www.w3.org/1999/xlink",
      !0,
      !1,
    )),
    ["src", "href", "action", "formAction"].forEach(function (a) {
      M[a] = new E(a, 1, !1, a.toLowerCase(), null, !0, !0)
    })
  function C(a, c, g, S) {
    var b = M.hasOwnProperty(c) ? M[c] : null
    ;(b !== null
      ? b.type !== 0
      : S ||
        !(2 < c.length) ||
        (c[0] !== "o" && c[0] !== "O") ||
        (c[1] !== "n" && c[1] !== "N")) &&
      (x(c, g, b, S) && (g = null),
      S || b === null
        ? v(c) && (g === null ? a.removeAttribute(c) : a.setAttribute(c, "" + g))
        : b.mustUseProperty
        ? (a[b.propertyName] = g === null ? (b.type === 3 ? !1 : "") : g)
        : ((c = b.attributeName),
          (S = b.attributeNamespace),
          g === null
            ? a.removeAttribute(c)
            : ((b = b.type),
              (g = b === 3 || (b === 4 && g === !0) ? "" : "" + g),
              S ? a.setAttributeNS(S, c, g) : a.setAttribute(c, g))))
  }
  var R = n.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
    z = Symbol.for("react.element"),
    U = Symbol.for("react.portal"),
    O = Symbol.for("react.fragment"),
    N = Symbol.for("react.strict_mode"),
    k = Symbol.for("react.profiler"),
    I = Symbol.for("react.provider"),
    V = Symbol.for("react.context"),
    Z = Symbol.for("react.forward_ref"),
    $ = Symbol.for("react.suspense"),
    ee = Symbol.for("react.suspense_list"),
    ue = Symbol.for("react.memo"),
    re = Symbol.for("react.lazy"),
    se = Symbol.for("react.offscreen"),
    G = Symbol.iterator
  function ie(a) {
    return a === null || typeof a != "object"
      ? null
      : ((a = (G && a[G]) || a["@@iterator"]), typeof a == "function" ? a : null)
  }
  var Q = Object.assign,
    W
  function ne(a) {
    if (W === void 0)
      try {
        throw Error()
      } catch (g) {
        var c = g.stack.trim().match(/\n( *(at )?)/)
        W = (c && c[1]) || ""
      }
    return (
      `
` +
      W +
      a
    )
  }
  var ye = !1
  function oe(a, c) {
    if (!a || ye) return ""
    ye = !0
    var g = Error.prepareStackTrace
    Error.prepareStackTrace = void 0
    try {
      if (c)
        if (
          ((c = function () {
            throw Error()
          }),
          Object.defineProperty(c.prototype, "props", {
            set: function () {
              throw Error()
            },
          }),
          typeof Reflect == "object" && Reflect.construct)
        ) {
          try {
            Reflect.construct(c, [])
          } catch (Re) {
            var S = Re
          }
          Reflect.construct(a, [], c)
        } else {
          try {
            c.call()
          } catch (Re) {
            S = Re
          }
          a.call(c.prototype)
        }
      else {
        try {
          throw Error()
        } catch (Re) {
          S = Re
        }
        a()
      }
    } catch (Re) {
      if (Re && S && typeof Re.stack == "string") {
        for (
          var b = Re.stack.split(`
`),
            L = S.stack.split(`
`),
            H = b.length - 1,
            te = L.length - 1;
          1 <= H && 0 <= te && b[H] !== L[te];

        )
          te--
        for (; 1 <= H && 0 <= te; H--, te--)
          if (b[H] !== L[te]) {
            if (H !== 1 || te !== 1)
              do
                if ((H--, te--, 0 > te || b[H] !== L[te])) {
                  var le =
                    `
` + b[H].replace(" at new ", " at ")
                  return (
                    a.displayName &&
                      le.includes("<anonymous>") &&
                      (le = le.replace("<anonymous>", a.displayName)),
                    le
                  )
                }
              while (1 <= H && 0 <= te)
            break
          }
      }
    } finally {
      ;(ye = !1), (Error.prepareStackTrace = g)
    }
    return (a = a ? a.displayName || a.name : "") ? ne(a) : ""
  }
  function fe(a) {
    switch (a.tag) {
      case 5:
        return ne(a.type)
      case 16:
        return ne("Lazy")
      case 13:
        return ne("Suspense")
      case 19:
        return ne("SuspenseList")
      case 0:
      case 2:
      case 15:
        return (a = oe(a.type, !1)), a
      case 11:
        return (a = oe(a.type.render, !1)), a
      case 1:
        return (a = oe(a.type, !0)), a
      default:
        return ""
    }
  }
  function we(a) {
    if (a == null) return null
    if (typeof a == "function") return a.displayName || a.name || null
    if (typeof a == "string") return a
    switch (a) {
      case O:
        return "Fragment"
      case U:
        return "Portal"
      case k:
        return "Profiler"
      case N:
        return "StrictMode"
      case $:
        return "Suspense"
      case ee:
        return "SuspenseList"
    }
    if (typeof a == "object")
      switch (a.$$typeof) {
        case V:
          return (a.displayName || "Context") + ".Consumer"
        case I:
          return (a._context.displayName || "Context") + ".Provider"
        case Z:
          var c = a.render
          return (
            (a = a.displayName),
            a ||
              ((a = c.displayName || c.name || ""),
              (a = a !== "" ? "ForwardRef(" + a + ")" : "ForwardRef")),
            a
          )
        case ue:
          return (c = a.displayName || null), c !== null ? c : we(a.type) || "Memo"
        case re:
          ;(c = a._payload), (a = a._init)
          try {
            return we(a(c))
          } catch {}
      }
    return null
  }
  function me(a) {
    var c = a.type
    switch (a.tag) {
      case 24:
        return "Cache"
      case 9:
        return (c.displayName || "Context") + ".Consumer"
      case 10:
        return (c._context.displayName || "Context") + ".Provider"
      case 18:
        return "DehydratedFragment"
      case 11:
        return (
          (a = c.render),
          (a = a.displayName || a.name || ""),
          c.displayName || (a !== "" ? "ForwardRef(" + a + ")" : "ForwardRef")
        )
      case 7:
        return "Fragment"
      case 5:
        return c
      case 4:
        return "Portal"
      case 3:
        return "Root"
      case 6:
        return "Text"
      case 16:
        return we(c)
      case 8:
        return c === N ? "StrictMode" : "Mode"
      case 22:
        return "Offscreen"
      case 12:
        return "Profiler"
      case 21:
        return "Scope"
      case 13:
        return "Suspense"
      case 19:
        return "SuspenseList"
      case 25:
        return "TracingMarker"
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof c == "function") return c.displayName || c.name || null
        if (typeof c == "string") return c
    }
    return null
  }
  function Fe(a) {
    switch (typeof a) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return a
      case "object":
        return a
      default:
        return ""
    }
  }
  function ze(a) {
    var c = a.type
    return (
      (a = a.nodeName) &&
      a.toLowerCase() === "input" &&
      (c === "checkbox" || c === "radio")
    )
  }
  function Ge(a) {
    var c = ze(a) ? "checked" : "value",
      g = Object.getOwnPropertyDescriptor(a.constructor.prototype, c),
      S = "" + a[c]
    if (
      !a.hasOwnProperty(c) &&
      typeof g < "u" &&
      typeof g.get == "function" &&
      typeof g.set == "function"
    ) {
      var b = g.get,
        L = g.set
      return (
        Object.defineProperty(a, c, {
          configurable: !0,
          get: function () {
            return b.call(this)
          },
          set: function (H) {
            ;(S = "" + H), L.call(this, H)
          },
        }),
        Object.defineProperty(a, c, { enumerable: g.enumerable }),
        {
          getValue: function () {
            return S
          },
          setValue: function (H) {
            S = "" + H
          },
          stopTracking: function () {
            ;(a._valueTracker = null), delete a[c]
          },
        }
      )
    }
  }
  function Ue(a) {
    a._valueTracker || (a._valueTracker = Ge(a))
  }
  function ae(a) {
    if (!a) return !1
    var c = a._valueTracker
    if (!c) return !0
    var g = c.getValue(),
      S = ""
    return (
      a && (S = ze(a) ? (a.checked ? "true" : "false") : a.value),
      (a = S),
      a !== g ? (c.setValue(a), !0) : !1
    )
  }
  function Ee(a) {
    if (((a = a || (typeof document < "u" ? document : void 0)), typeof a > "u"))
      return null
    try {
      return a.activeElement || a.body
    } catch {
      return a.body
    }
  }
  function K(a, c) {
    var g = c.checked
    return Q({}, c, {
      defaultChecked: void 0,
      defaultValue: void 0,
      value: void 0,
      checked: g ?? a._wrapperState.initialChecked,
    })
  }
  function Ke(a, c) {
    var g = c.defaultValue == null ? "" : c.defaultValue,
      S = c.checked != null ? c.checked : c.defaultChecked
    ;(g = Fe(c.value != null ? c.value : g)),
      (a._wrapperState = {
        initialChecked: S,
        initialValue: g,
        controlled:
          c.type === "checkbox" || c.type === "radio"
            ? c.checked != null
            : c.value != null,
      })
  }
  function Be(a, c) {
    ;(c = c.checked), c != null && C(a, "checked", c, !1)
  }
  function Oe(a, c) {
    Be(a, c)
    var g = Fe(c.value),
      S = c.type
    if (g != null)
      S === "number"
        ? ((g === 0 && a.value === "") || a.value != g) && (a.value = "" + g)
        : a.value !== "" + g && (a.value = "" + g)
    else if (S === "submit" || S === "reset") {
      a.removeAttribute("value")
      return
    }
    c.hasOwnProperty("value")
      ? He(a, c.type, g)
      : c.hasOwnProperty("defaultValue") && He(a, c.type, Fe(c.defaultValue)),
      c.checked == null &&
        c.defaultChecked != null &&
        (a.defaultChecked = !!c.defaultChecked)
  }
  function Pe(a, c, g) {
    if (c.hasOwnProperty("value") || c.hasOwnProperty("defaultValue")) {
      var S = c.type
      if (
        !((S !== "submit" && S !== "reset") || (c.value !== void 0 && c.value !== null))
      )
        return
      ;(c = "" + a._wrapperState.initialValue),
        g || c === a.value || (a.value = c),
        (a.defaultValue = c)
    }
    ;(g = a.name),
      g !== "" && (a.name = ""),
      (a.defaultChecked = !!a._wrapperState.initialChecked),
      g !== "" && (a.name = g)
  }
  function He(a, c, g) {
    ;(c !== "number" || Ee(a.ownerDocument) !== a) &&
      (g == null
        ? (a.defaultValue = "" + a._wrapperState.initialValue)
        : a.defaultValue !== "" + g && (a.defaultValue = "" + g))
  }
  var Se = Array.isArray
  function j(a, c, g, S) {
    if (((a = a.options), c)) {
      c = {}
      for (var b = 0; b < g.length; b++) c["$" + g[b]] = !0
      for (g = 0; g < a.length; g++)
        (b = c.hasOwnProperty("$" + a[g].value)),
          a[g].selected !== b && (a[g].selected = b),
          b && S && (a[g].defaultSelected = !0)
    } else {
      for (g = "" + Fe(g), c = null, b = 0; b < a.length; b++) {
        if (a[b].value === g) {
          ;(a[b].selected = !0), S && (a[b].defaultSelected = !0)
          return
        }
        c !== null || a[b].disabled || (c = a[b])
      }
      c !== null && (c.selected = !0)
    }
  }
  function B(a, c) {
    if (c.dangerouslySetInnerHTML != null) throw Error(t(91))
    return Q({}, c, {
      value: void 0,
      defaultValue: void 0,
      children: "" + a._wrapperState.initialValue,
    })
  }
  function ce(a, c) {
    var g = c.value
    if (g == null) {
      if (((g = c.children), (c = c.defaultValue), g != null)) {
        if (c != null) throw Error(t(92))
        if (Se(g)) {
          if (1 < g.length) throw Error(t(93))
          g = g[0]
        }
        c = g
      }
      c == null && (c = ""), (g = c)
    }
    a._wrapperState = { initialValue: Fe(g) }
  }
  function Me(a, c) {
    var g = Fe(c.value),
      S = Fe(c.defaultValue)
    g != null &&
      ((g = "" + g),
      g !== a.value && (a.value = g),
      c.defaultValue == null && a.defaultValue !== g && (a.defaultValue = g)),
      S != null && (a.defaultValue = "" + S)
  }
  function De(a) {
    var c = a.textContent
    c === a._wrapperState.initialValue && c !== "" && c !== null && (a.value = c)
  }
  function Ie(a) {
    switch (a) {
      case "svg":
        return "http://www.w3.org/2000/svg"
      case "math":
        return "http://www.w3.org/1998/Math/MathML"
      default:
        return "http://www.w3.org/1999/xhtml"
    }
  }
  function st(a, c) {
    return a == null || a === "http://www.w3.org/1999/xhtml"
      ? Ie(c)
      : a === "http://www.w3.org/2000/svg" && c === "foreignObject"
      ? "http://www.w3.org/1999/xhtml"
      : a
  }
  var tt,
    it = (function (a) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction
        ? function (c, g, S, b) {
            MSApp.execUnsafeLocalFunction(function () {
              return a(c, g, S, b)
            })
          }
        : a
    })(function (a, c) {
      if (a.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in a)
        a.innerHTML = c
      else {
        for (
          tt = tt || document.createElement("div"),
            tt.innerHTML = "<svg>" + c.valueOf().toString() + "</svg>",
            c = tt.firstChild;
          a.firstChild;

        )
          a.removeChild(a.firstChild)
        for (; c.firstChild; ) a.appendChild(c.firstChild)
      }
    })
  function Et(a, c) {
    if (c) {
      var g = a.firstChild
      if (g && g === a.lastChild && g.nodeType === 3) {
        g.nodeValue = c
        return
      }
    }
    a.textContent = c
  }
  var je = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0,
    },
    Je = ["Webkit", "ms", "Moz", "O"]
  Object.keys(je).forEach(function (a) {
    Je.forEach(function (c) {
      ;(c = c + a.charAt(0).toUpperCase() + a.substring(1)), (je[c] = je[a])
    })
  })
  function At(a, c, g) {
    return c == null || typeof c == "boolean" || c === ""
      ? ""
      : g || typeof c != "number" || c === 0 || (je.hasOwnProperty(a) && je[a])
      ? ("" + c).trim()
      : c + "px"
  }
  function Pt(a, c) {
    a = a.style
    for (var g in c)
      if (c.hasOwnProperty(g)) {
        var S = g.indexOf("--") === 0,
          b = At(g, c[g], S)
        g === "float" && (g = "cssFloat"), S ? a.setProperty(g, b) : (a[g] = b)
      }
  }
  var ft = Q(
    { menuitem: !0 },
    {
      area: !0,
      base: !0,
      br: !0,
      col: !0,
      embed: !0,
      hr: !0,
      img: !0,
      input: !0,
      keygen: !0,
      link: !0,
      meta: !0,
      param: !0,
      source: !0,
      track: !0,
      wbr: !0,
    },
  )
  function Wt(a, c) {
    if (c) {
      if (ft[a] && (c.children != null || c.dangerouslySetInnerHTML != null))
        throw Error(t(137, a))
      if (c.dangerouslySetInnerHTML != null) {
        if (c.children != null) throw Error(t(60))
        if (
          typeof c.dangerouslySetInnerHTML != "object" ||
          !("__html" in c.dangerouslySetInnerHTML)
        )
          throw Error(t(61))
      }
      if (c.style != null && typeof c.style != "object") throw Error(t(62))
    }
  }
  function Nt(a, c) {
    if (a.indexOf("-") === -1) return typeof c.is == "string"
    switch (a) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1
      default:
        return !0
    }
  }
  var dn = null
  function he(a) {
    return (
      (a = a.target || a.srcElement || window),
      a.correspondingUseElement && (a = a.correspondingUseElement),
      a.nodeType === 3 ? a.parentNode : a
    )
  }
  var rt = null,
    Ne = null,
    Ve = null
  function lt(a) {
    if ((a = Ys(a))) {
      if (typeof rt != "function") throw Error(t(280))
      var c = a.stateNode
      c && ((c = Cf(c)), rt(a.stateNode, a.type, c))
    }
  }
  function at(a) {
    Ne ? (Ve ? Ve.push(a) : (Ve = [a])) : (Ne = a)
  }
  function Ut() {
    if (Ne) {
      var a = Ne,
        c = Ve
      if (((Ve = Ne = null), lt(a), c)) for (a = 0; a < c.length; a++) lt(c[a])
    }
  }
  function vn(a, c) {
    return a(c)
  }
  function Vn() {}
  var an = !1
  function zi(a, c, g) {
    if (an) return a(c, g)
    an = !0
    try {
      return vn(a, c, g)
    } finally {
      ;(an = !1), (Ne !== null || Ve !== null) && (Vn(), Ut())
    }
  }
  function Vi(a, c) {
    var g = a.stateNode
    if (g === null) return null
    var S = Cf(g)
    if (S === null) return null
    g = S[c]
    e: switch (c) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        ;(S = !S.disabled) ||
          ((a = a.type),
          (S = !(
            a === "button" ||
            a === "input" ||
            a === "select" ||
            a === "textarea"
          ))),
          (a = !S)
        break e
      default:
        a = !1
    }
    if (a) return null
    if (g && typeof g != "function") throw Error(t(231, c, typeof g))
    return g
  }
  var tl = !1
  if (l)
    try {
      var To = {}
      Object.defineProperty(To, "passive", {
        get: function () {
          tl = !0
        },
      }),
        window.addEventListener("test", To, To),
        window.removeEventListener("test", To, To)
    } catch {
      tl = !1
    }
  function ys(a, c, g, S, b, L, H, te, le) {
    var Re = Array.prototype.slice.call(arguments, 3)
    try {
      c.apply(g, Re)
    } catch (Ye) {
      this.onError(Ye)
    }
  }
  var ns = !1,
    ea = null,
    is = !1,
    bo = null,
    Gu = {
      onError: function (a) {
        ;(ns = !0), (ea = a)
      },
    }
  function nl(a, c, g, S, b, L, H, te, le) {
    ;(ns = !1), (ea = null), ys.apply(Gu, arguments)
  }
  function Wu(a, c, g, S, b, L, H, te, le) {
    if ((nl.apply(this, arguments), ns)) {
      if (ns) {
        var Re = ea
        ;(ns = !1), (ea = null)
      } else throw Error(t(198))
      is || ((is = !0), (bo = Re))
    }
  }
  function xs(a) {
    var c = a,
      g = a
    if (a.alternate) for (; c.return; ) c = c.return
    else {
      a = c
      do (c = a), (c.flags & 4098) !== 0 && (g = c.return), (a = c.return)
      while (a)
    }
    return c.tag === 3 ? g : null
  }
  function ju(a) {
    if (a.tag === 13) {
      var c = a.memoizedState
      if (
        (c === null && ((a = a.alternate), a !== null && (c = a.memoizedState)),
        c !== null)
      )
        return c.dehydrated
    }
    return null
  }
  function Xu(a) {
    if (xs(a) !== a) throw Error(t(188))
  }
  function Yu(a) {
    var c = a.alternate
    if (!c) {
      if (((c = xs(a)), c === null)) throw Error(t(188))
      return c !== a ? null : a
    }
    for (var g = a, S = c; ; ) {
      var b = g.return
      if (b === null) break
      var L = b.alternate
      if (L === null) {
        if (((S = b.return), S !== null)) {
          g = S
          continue
        }
        break
      }
      if (b.child === L.child) {
        for (L = b.child; L; ) {
          if (L === g) return Xu(b), a
          if (L === S) return Xu(b), c
          L = L.sibling
        }
        throw Error(t(188))
      }
      if (g.return !== S.return) (g = b), (S = L)
      else {
        for (var H = !1, te = b.child; te; ) {
          if (te === g) {
            ;(H = !0), (g = b), (S = L)
            break
          }
          if (te === S) {
            ;(H = !0), (S = b), (g = L)
            break
          }
          te = te.sibling
        }
        if (!H) {
          for (te = L.child; te; ) {
            if (te === g) {
              ;(H = !0), (g = L), (S = b)
              break
            }
            if (te === S) {
              ;(H = !0), (S = L), (g = b)
              break
            }
            te = te.sibling
          }
          if (!H) throw Error(t(189))
        }
      }
      if (g.alternate !== S) throw Error(t(190))
    }
    if (g.tag !== 3) throw Error(t(188))
    return g.stateNode.current === g ? a : c
  }
  function X(a) {
    return (a = Yu(a)), a !== null ? ge(a) : null
  }
  function ge(a) {
    if (a.tag === 5 || a.tag === 6) return a
    for (a = a.child; a !== null; ) {
      var c = ge(a)
      if (c !== null) return c
      a = a.sibling
    }
    return null
  }
  var Ae = e.unstable_scheduleCallback,
    Ce = e.unstable_cancelCallback,
    xe = e.unstable_shouldYield,
    Qe = e.unstable_requestPaint,
    qe = e.unstable_now,
    yt = e.unstable_getCurrentPriorityLevel,
    xt = e.unstable_ImmediatePriority,
    kt = e.unstable_UserBlockingPriority,
    Ot = e.unstable_NormalPriority,
    wt = e.unstable_LowPriority,
    $t = e.unstable_IdlePriority,
    en = null,
    Tt = null
  function Yt(a) {
    if (Tt && typeof Tt.onCommitFiberRoot == "function")
      try {
        Tt.onCommitFiberRoot(en, a, void 0, (a.current.flags & 128) === 128)
      } catch {}
  }
  var Ft = Math.clz32 ? Math.clz32 : tn,
    dt = Math.log,
    In = Math.LN2
  function tn(a) {
    return (a >>>= 0), a === 0 ? 32 : (31 - ((dt(a) / In) | 0)) | 0
  }
  var Yn = 64,
    Ln = 4194304
  function Hn(a) {
    switch (a & -a) {
      case 1:
        return 1
      case 2:
        return 2
      case 4:
        return 4
      case 8:
        return 8
      case 16:
        return 16
      case 32:
        return 32
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return a & 4194240
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return a & 130023424
      case 134217728:
        return 134217728
      case 268435456:
        return 268435456
      case 536870912:
        return 536870912
      case 1073741824:
        return 1073741824
      default:
        return a
    }
  }
  function rs(a, c) {
    var g = a.pendingLanes
    if (g === 0) return 0
    var S = 0,
      b = a.suspendedLanes,
      L = a.pingedLanes,
      H = g & 268435455
    if (H !== 0) {
      var te = H & ~b
      te !== 0 ? (S = Hn(te)) : ((L &= H), L !== 0 && (S = Hn(L)))
    } else (H = g & ~b), H !== 0 ? (S = Hn(H)) : L !== 0 && (S = Hn(L))
    if (S === 0) return 0
    if (
      c !== 0 &&
      c !== S &&
      (c & b) === 0 &&
      ((b = S & -S), (L = c & -c), b >= L || (b === 16 && (L & 4194240) !== 0))
    )
      return c
    if (((S & 4) !== 0 && (S |= g & 16), (c = a.entangledLanes), c !== 0))
      for (a = a.entanglements, c &= S; 0 < c; )
        (g = 31 - Ft(c)), (b = 1 << g), (S |= a[g]), (c &= ~b)
    return S
  }
  function yn(a, c) {
    switch (a) {
      case 1:
      case 2:
      case 4:
        return c + 250
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return c + 5e3
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1
      default:
        return -1
    }
  }
  function Hi(a, c) {
    for (
      var g = a.suspendedLanes,
        S = a.pingedLanes,
        b = a.expirationTimes,
        L = a.pendingLanes;
      0 < L;

    ) {
      var H = 31 - Ft(L),
        te = 1 << H,
        le = b[H]
      le === -1
        ? ((te & g) === 0 || (te & S) !== 0) && (b[H] = yn(te, c))
        : le <= c && (a.expiredLanes |= te),
        (L &= ~te)
    }
  }
  function _s(a) {
    return (
      (a = a.pendingLanes & -1073741825), a !== 0 ? a : a & 1073741824 ? 1073741824 : 0
    )
  }
  function An() {
    var a = Yn
    return (Yn <<= 1), (Yn & 4194240) === 0 && (Yn = 64), a
  }
  function Nr(a) {
    for (var c = [], g = 0; 31 > g; g++) c.push(a)
    return c
  }
  function tr(a, c, g) {
    ;(a.pendingLanes |= c),
      c !== 536870912 && ((a.suspendedLanes = 0), (a.pingedLanes = 0)),
      (a = a.eventTimes),
      (c = 31 - Ft(c)),
      (a[c] = g)
  }
  function qu(a, c) {
    var g = a.pendingLanes & ~c
    ;(a.pendingLanes = c),
      (a.suspendedLanes = 0),
      (a.pingedLanes = 0),
      (a.expiredLanes &= c),
      (a.mutableReadLanes &= c),
      (a.entangledLanes &= c),
      (c = a.entanglements)
    var S = a.eventTimes
    for (a = a.expirationTimes; 0 < g; ) {
      var b = 31 - Ft(g),
        L = 1 << b
      ;(c[b] = 0), (S[b] = -1), (a[b] = -1), (g &= ~L)
    }
  }
  function il(a, c) {
    var g = (a.entangledLanes |= c)
    for (a = a.entanglements; g; ) {
      var S = 31 - Ft(g),
        b = 1 << S
      ;(b & c) | (a[S] & c) && (a[S] |= c), (g &= ~b)
    }
  }
  var hn = 0
  function rl(a) {
    return (a &= -a), 1 < a ? (4 < a ? ((a & 268435455) !== 0 ? 16 : 536870912) : 4) : 1
  }
  var uc,
    Kd,
    Pm,
    $u,
    Ku,
    ta = !1,
    Zu = [],
    ws = null,
    Jt = null,
    Bs = null,
    na = new Map(),
    sl = new Map(),
    Ao = [],
    Sy =
      "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
        " ",
      )
  function si(a, c) {
    switch (a) {
      case "focusin":
      case "focusout":
        ws = null
        break
      case "dragenter":
      case "dragleave":
        Jt = null
        break
      case "mouseover":
      case "mouseout":
        Bs = null
        break
      case "pointerover":
      case "pointerout":
        na.delete(c.pointerId)
        break
      case "gotpointercapture":
      case "lostpointercapture":
        sl.delete(c.pointerId)
    }
  }
  function ia(a, c, g, S, b, L) {
    return a === null || a.nativeEvent !== L
      ? ((a = {
          blockedOn: c,
          domEventName: g,
          eventSystemFlags: S,
          nativeEvent: L,
          targetContainers: [b],
        }),
        c !== null && ((c = Ys(c)), c !== null && Kd(c)),
        a)
      : ((a.eventSystemFlags |= S),
        (c = a.targetContainers),
        b !== null && c.indexOf(b) === -1 && c.push(b),
        a)
  }
  function My(a, c, g, S, b) {
    switch (c) {
      case "focusin":
        return (ws = ia(ws, a, c, g, S, b)), !0
      case "dragenter":
        return (Jt = ia(Jt, a, c, g, S, b)), !0
      case "mouseover":
        return (Bs = ia(Bs, a, c, g, S, b)), !0
      case "pointerover":
        var L = b.pointerId
        return na.set(L, ia(na.get(L) || null, a, c, g, S, b)), !0
      case "gotpointercapture":
        return (L = b.pointerId), sl.set(L, ia(sl.get(L) || null, a, c, g, S, b)), !0
    }
    return !1
  }
  function Ju(a) {
    var c = No(a.target)
    if (c !== null) {
      var g = xs(c)
      if (g !== null) {
        if (((c = g.tag), c === 13)) {
          if (((c = ju(g)), c !== null)) {
            ;(a.blockedOn = c),
              Ku(a.priority, function () {
                Pm(g)
              })
            return
          }
        } else if (c === 3 && g.stateNode.current.memoizedState.isDehydrated) {
          a.blockedOn = g.tag === 3 ? g.stateNode.containerInfo : null
          return
        }
      }
    }
    a.blockedOn = null
  }
  function Qu(a) {
    if (a.blockedOn !== null) return !1
    for (var c = a.targetContainers; 0 < c.length; ) {
      var g = Fr(a.domEventName, a.eventSystemFlags, c[0], a.nativeEvent)
      if (g === null) {
        g = a.nativeEvent
        var S = new g.constructor(g.type, g)
        ;(dn = S), g.target.dispatchEvent(S), (dn = null)
      } else return (c = Ys(g)), c !== null && Kd(c), (a.blockedOn = g), !1
      c.shift()
    }
    return !0
  }
  function fc(a, c, g) {
    Qu(a) && g.delete(c)
  }
  function Ss() {
    ;(ta = !1),
      ws !== null && Qu(ws) && (ws = null),
      Jt !== null && Qu(Jt) && (Jt = null),
      Bs !== null && Qu(Bs) && (Bs = null),
      na.forEach(fc),
      sl.forEach(fc)
  }
  function dc(a, c) {
    a.blockedOn === c &&
      ((a.blockedOn = null),
      ta || ((ta = !0), e.unstable_scheduleCallback(e.unstable_NormalPriority, Ss)))
  }
  function hc(a) {
    function c(b) {
      return dc(b, a)
    }
    if (0 < Zu.length) {
      dc(Zu[0], a)
      for (var g = 1; g < Zu.length; g++) {
        var S = Zu[g]
        S.blockedOn === a && (S.blockedOn = null)
      }
    }
    for (
      ws !== null && dc(ws, a),
        Jt !== null && dc(Jt, a),
        Bs !== null && dc(Bs, a),
        na.forEach(c),
        sl.forEach(c),
        g = 0;
      g < Ao.length;
      g++
    )
      (S = Ao[g]), S.blockedOn === a && (S.blockedOn = null)
    for (; 0 < Ao.length && ((g = Ao[0]), g.blockedOn === null); )
      Ju(g), g.blockedOn === null && Ao.shift()
  }
  var Gi = R.ReactCurrentBatchConfig,
    kr = !0
  function ef(a, c, g, S) {
    var b = hn,
      L = Gi.transition
    Gi.transition = null
    try {
      ;(hn = 1), tf(a, c, g, S)
    } finally {
      ;(hn = b), (Gi.transition = L)
    }
  }
  function Zd(a, c, g, S) {
    var b = hn,
      L = Gi.transition
    Gi.transition = null
    try {
      ;(hn = 4), tf(a, c, g, S)
    } finally {
      ;(hn = b), (Gi.transition = L)
    }
  }
  function tf(a, c, g, S) {
    if (kr) {
      var b = Fr(a, c, g, S)
      if (b === null) Sf(a, c, S, nf, g), si(a, S)
      else if (My(b, a, c, g, S)) S.stopPropagation()
      else if ((si(a, S), c & 4 && -1 < Sy.indexOf(a))) {
        for (; b !== null; ) {
          var L = Ys(b)
          if (
            (L !== null && uc(L),
            (L = Fr(a, c, g, S)),
            L === null && Sf(a, c, S, nf, g),
            L === b)
          )
            break
          b = L
        }
        b !== null && S.stopPropagation()
      } else Sf(a, c, S, null, g)
    }
  }
  var nf = null
  function Fr(a, c, g, S) {
    if (((nf = null), (a = he(S)), (a = No(a)), a !== null))
      if (((c = xs(a)), c === null)) a = null
      else if (((g = c.tag), g === 13)) {
        if (((a = ju(c)), a !== null)) return a
        a = null
      } else if (g === 3) {
        if (c.stateNode.current.memoizedState.isDehydrated)
          return c.tag === 3 ? c.stateNode.containerInfo : null
        a = null
      } else c !== a && (a = null)
    return (nf = a), null
  }
  function Im(a) {
    switch (a) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4
      case "message":
        switch (yt()) {
          case xt:
            return 1
          case kt:
            return 4
          case Ot:
          case wt:
            return 16
          case $t:
            return 536870912
          default:
            return 16
        }
      default:
        return 16
    }
  }
  var ss = null,
    Jd = null,
    nr = null
  function pc() {
    if (nr) return nr
    var a,
      c = Jd,
      g = c.length,
      S,
      b = "value" in ss ? ss.value : ss.textContent,
      L = b.length
    for (a = 0; a < g && c[a] === b[a]; a++);
    var H = g - a
    for (S = 1; S <= H && c[g - S] === b[L - S]; S++);
    return (nr = b.slice(a, 1 < S ? 1 - S : void 0))
  }
  function ra(a) {
    var c = a.keyCode
    return (
      "charCode" in a ? ((a = a.charCode), a === 0 && c === 13 && (a = 13)) : (a = c),
      a === 10 && (a = 13),
      32 <= a || a === 13 ? a : 0
    )
  }
  function zs() {
    return !0
  }
  function rf() {
    return !1
  }
  function Wi(a) {
    function c(g, S, b, L, H) {
      ;(this._reactName = g),
        (this._targetInst = b),
        (this.type = S),
        (this.nativeEvent = L),
        (this.target = H),
        (this.currentTarget = null)
      for (var te in a)
        a.hasOwnProperty(te) && ((g = a[te]), (this[te] = g ? g(L) : L[te]))
      return (
        (this.isDefaultPrevented = (
          L.defaultPrevented != null ? L.defaultPrevented : L.returnValue === !1
        )
          ? zs
          : rf),
        (this.isPropagationStopped = rf),
        this
      )
    }
    return (
      Q(c.prototype, {
        preventDefault: function () {
          this.defaultPrevented = !0
          var g = this.nativeEvent
          g &&
            (g.preventDefault
              ? g.preventDefault()
              : typeof g.returnValue != "unknown" && (g.returnValue = !1),
            (this.isDefaultPrevented = zs))
        },
        stopPropagation: function () {
          var g = this.nativeEvent
          g &&
            (g.stopPropagation
              ? g.stopPropagation()
              : typeof g.cancelBubble != "unknown" && (g.cancelBubble = !0),
            (this.isPropagationStopped = zs))
        },
        persist: function () {},
        isPersistent: zs,
      }),
      c
    )
  }
  var sa = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function (a) {
        return a.timeStamp || Date.now()
      },
      defaultPrevented: 0,
      isTrusted: 0,
    },
    mc = Wi(sa),
    oa = Q({}, sa, { view: 0, detail: 0 }),
    ol = Wi(oa),
    ir,
    Ur,
    Or,
    al = Q({}, oa, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: Ro,
      button: 0,
      buttons: 0,
      relatedTarget: function (a) {
        return a.relatedTarget === void 0
          ? a.fromElement === a.srcElement
            ? a.toElement
            : a.fromElement
          : a.relatedTarget
      },
      movementX: function (a) {
        return "movementX" in a
          ? a.movementX
          : (a !== Or &&
              (Or && a.type === "mousemove"
                ? ((ir = a.screenX - Or.screenX), (Ur = a.screenY - Or.screenY))
                : (Ur = ir = 0),
              (Or = a)),
            ir)
      },
      movementY: function (a) {
        return "movementY" in a ? a.movementY : Ur
      },
    }),
    Qd = Wi(al),
    Vs = Q({}, al, { dataTransfer: 0 }),
    Co = Wi(Vs),
    sf = Q({}, oa, { relatedTarget: 0 }),
    of = Wi(sf),
    af = Q({}, sa, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }),
    Lm = Wi(af),
    Dm = Q({}, sa, {
      clipboardData: function (a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData
      },
    }),
    eh = Wi(Dm),
    lf = Q({}, sa, { data: 0 }),
    th = Wi(lf),
    Nm = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified",
    },
    km = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta",
    },
    nh = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" }
  function ll(a) {
    var c = this.nativeEvent
    return c.getModifierState ? c.getModifierState(a) : (a = nh[a]) ? !!c[a] : !1
  }
  function Ro() {
    return ll
  }
  var cf = Q({}, oa, {
      key: function (a) {
        if (a.key) {
          var c = Nm[a.key] || a.key
          if (c !== "Unidentified") return c
        }
        return a.type === "keypress"
          ? ((a = ra(a)), a === 13 ? "Enter" : String.fromCharCode(a))
          : a.type === "keydown" || a.type === "keyup"
          ? km[a.keyCode] || "Unidentified"
          : ""
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: Ro,
      charCode: function (a) {
        return a.type === "keypress" ? ra(a) : 0
      },
      keyCode: function (a) {
        return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0
      },
      which: function (a) {
        return a.type === "keypress"
          ? ra(a)
          : a.type === "keydown" || a.type === "keyup"
          ? a.keyCode
          : 0
      },
    }),
    uf = Wi(cf),
    Br = Q({}, al, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0,
    }),
    gr = Wi(Br),
    aa = Q({}, oa, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: Ro,
    }),
    Hs = Wi(aa),
    Gs = Q({}, sa, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }),
    la = Wi(Gs),
    Fm = Q({}, al, {
      deltaX: function (a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0
      },
      deltaY: function (a) {
        return "deltaY" in a
          ? a.deltaY
          : "wheelDeltaY" in a
          ? -a.wheelDeltaY
          : "wheelDelta" in a
          ? -a.wheelDelta
          : 0
      },
      deltaZ: 0,
      deltaMode: 0,
    }),
    ih = Wi(Fm),
    rh = [9, 13, 27, 32],
    ji = l && "CompositionEvent" in window,
    xi = null
  l && "documentMode" in document && (xi = document.documentMode)
  var Dn = l && "TextEvent" in window && !xi,
    cl = l && (!ji || (xi && 8 < xi && 11 >= xi)),
    zr = " ",
    sh = !1
  function oh(a, c) {
    switch (a) {
      case "keyup":
        return rh.indexOf(c.keyCode) !== -1
      case "keydown":
        return c.keyCode !== 229
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0
      default:
        return !1
    }
  }
  function ff(a) {
    return (a = a.detail), typeof a == "object" && "data" in a ? a.data : null
  }
  var Po = !1
  function Um(a, c) {
    switch (a) {
      case "compositionend":
        return ff(c)
      case "keypress":
        return c.which !== 32 ? null : ((sh = !0), zr)
      case "textInput":
        return (a = c.data), a === zr && sh ? null : a
      default:
        return null
    }
  }
  function gc(a, c) {
    if (Po)
      return a === "compositionend" || (!ji && oh(a, c))
        ? ((a = pc()), (nr = Jd = ss = null), (Po = !1), a)
        : null
    switch (a) {
      case "paste":
        return null
      case "keypress":
        if (!(c.ctrlKey || c.altKey || c.metaKey) || (c.ctrlKey && c.altKey)) {
          if (c.char && 1 < c.char.length) return c.char
          if (c.which) return String.fromCharCode(c.which)
        }
        return null
      case "compositionend":
        return cl && c.locale !== "ko" ? null : c.data
      default:
        return null
    }
  }
  var ul = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0,
  }
  function df(a) {
    var c = a && a.nodeName && a.nodeName.toLowerCase()
    return c === "input" ? !!ul[a.type] : c === "textarea"
  }
  function fl(a, c, g, S) {
    at(S),
      (c = Mf(c, "onChange")),
      0 < c.length &&
        ((g = new mc("onChange", "change", null, g, S)),
        a.push({ event: g, listeners: c }))
  }
  var Io = null,
    dl = null
  function Om(a) {
    gl(a, 0)
  }
  function Ws(a) {
    var c = qn(a)
    if (ae(c)) return a
  }
  function Bm(a, c) {
    if (a === "change") return c
  }
  var hl = !1
  if (l) {
    var rr
    if (l) {
      var ca = "oninput" in document
      if (!ca) {
        var ua = document.createElement("div")
        ua.setAttribute("oninput", "return;"), (ca = typeof ua.oninput == "function")
      }
      rr = ca
    } else rr = !1
    hl = rr && (!document.documentMode || 9 < document.documentMode)
  }
  function os() {
    Io && (Io.detachEvent("onpropertychange", hf), (dl = Io = null))
  }
  function hf(a) {
    if (a.propertyName === "value" && Ws(dl)) {
      var c = []
      fl(c, dl, a, he(a)), zi(Om, c)
    }
  }
  function pl(a, c, g) {
    a === "focusin"
      ? (os(), (Io = c), (dl = g), Io.attachEvent("onpropertychange", hf))
      : a === "focusout" && os()
  }
  function zm(a) {
    if (a === "selectionchange" || a === "keyup" || a === "keydown") return Ws(dl)
  }
  function ah(a, c) {
    if (a === "click") return Ws(c)
  }
  function Un(a, c) {
    if (a === "input" || a === "change") return Ws(c)
  }
  function pf(a, c) {
    return (a === c && (a !== 0 || 1 / a === 1 / c)) || (a !== a && c !== c)
  }
  var vr = typeof Object.is == "function" ? Object.is : pf
  function fa(a, c) {
    if (vr(a, c)) return !0
    if (typeof a != "object" || a === null || typeof c != "object" || c === null)
      return !1
    var g = Object.keys(a),
      S = Object.keys(c)
    if (g.length !== S.length) return !1
    for (S = 0; S < g.length; S++) {
      var b = g[S]
      if (!u.call(c, b) || !vr(a[b], c[b])) return !1
    }
    return !0
  }
  function vc(a) {
    for (; a && a.firstChild; ) a = a.firstChild
    return a
  }
  function yr(a, c) {
    var g = vc(a)
    a = 0
    for (var S; g; ) {
      if (g.nodeType === 3) {
        if (((S = a + g.textContent.length), a <= c && S >= c))
          return { node: g, offset: c - a }
        a = S
      }
      e: {
        for (; g; ) {
          if (g.nextSibling) {
            g = g.nextSibling
            break e
          }
          g = g.parentNode
        }
        g = void 0
      }
      g = vc(g)
    }
  }
  function da(a, c) {
    return a && c
      ? a === c
        ? !0
        : a && a.nodeType === 3
        ? !1
        : c && c.nodeType === 3
        ? da(a, c.parentNode)
        : "contains" in a
        ? a.contains(c)
        : a.compareDocumentPosition
        ? !!(a.compareDocumentPosition(c) & 16)
        : !1
      : !1
  }
  function On() {
    for (var a = window, c = Ee(); c instanceof a.HTMLIFrameElement; ) {
      try {
        var g = typeof c.contentWindow.location.href == "string"
      } catch {
        g = !1
      }
      if (g) a = c.contentWindow
      else break
      c = Ee(a.document)
    }
    return c
  }
  function fi(a) {
    var c = a && a.nodeName && a.nodeName.toLowerCase()
    return (
      c &&
      ((c === "input" &&
        (a.type === "text" ||
          a.type === "search" ||
          a.type === "tel" ||
          a.type === "url" ||
          a.type === "password")) ||
        c === "textarea" ||
        a.contentEditable === "true")
    )
  }
  function di(a) {
    var c = On(),
      g = a.focusedElem,
      S = a.selectionRange
    if (c !== g && g && g.ownerDocument && da(g.ownerDocument.documentElement, g)) {
      if (S !== null && fi(g)) {
        if (
          ((c = S.start), (a = S.end), a === void 0 && (a = c), "selectionStart" in g)
        )
          (g.selectionStart = c), (g.selectionEnd = Math.min(a, g.value.length))
        else if (
          ((a = ((c = g.ownerDocument || document) && c.defaultView) || window),
          a.getSelection)
        ) {
          a = a.getSelection()
          var b = g.textContent.length,
            L = Math.min(S.start, b)
          ;(S = S.end === void 0 ? L : Math.min(S.end, b)),
            !a.extend && L > S && ((b = S), (S = L), (L = b)),
            (b = yr(g, L))
          var H = yr(g, S)
          b &&
            H &&
            (a.rangeCount !== 1 ||
              a.anchorNode !== b.node ||
              a.anchorOffset !== b.offset ||
              a.focusNode !== H.node ||
              a.focusOffset !== H.offset) &&
            ((c = c.createRange()),
            c.setStart(b.node, b.offset),
            a.removeAllRanges(),
            L > S
              ? (a.addRange(c), a.extend(H.node, H.offset))
              : (c.setEnd(H.node, H.offset), a.addRange(c)))
        }
      }
      for (c = [], a = g; (a = a.parentNode); )
        a.nodeType === 1 && c.push({ element: a, left: a.scrollLeft, top: a.scrollTop })
      for (typeof g.focus == "function" && g.focus(), g = 0; g < c.length; g++)
        (a = c[g]), (a.element.scrollLeft = a.left), (a.element.scrollTop = a.top)
    }
  }
  var mf = l && "documentMode" in document && 11 >= document.documentMode,
    Ms = null,
    ha = null,
    yc = null,
    hi = !1
  function gf(a, c, g) {
    var S = g.window === g ? g.document : g.nodeType === 9 ? g : g.ownerDocument
    hi ||
      Ms == null ||
      Ms !== Ee(S) ||
      ((S = Ms),
      "selectionStart" in S && fi(S)
        ? (S = { start: S.selectionStart, end: S.selectionEnd })
        : ((S = (
            (S.ownerDocument && S.ownerDocument.defaultView) ||
            window
          ).getSelection()),
          (S = {
            anchorNode: S.anchorNode,
            anchorOffset: S.anchorOffset,
            focusNode: S.focusNode,
            focusOffset: S.focusOffset,
          })),
      (yc && fa(yc, S)) ||
        ((yc = S),
        (S = Mf(ha, "onSelect")),
        0 < S.length &&
          ((c = new mc("onSelect", "select", null, c, g)),
          a.push({ event: c, listeners: S }),
          (c.target = Ms))))
  }
  function ml(a, c) {
    var g = {}
    return (
      (g[a.toLowerCase()] = c.toLowerCase()),
      (g["Webkit" + a] = "webkit" + c),
      (g["Moz" + a] = "moz" + c),
      g
    )
  }
  var Lo = {
      animationend: ml("Animation", "AnimationEnd"),
      animationiteration: ml("Animation", "AnimationIteration"),
      animationstart: ml("Animation", "AnimationStart"),
      transitionend: ml("Transition", "TransitionEnd"),
    },
    as = {},
    ls = {}
  l &&
    ((ls = document.createElement("div").style),
    "AnimationEvent" in window ||
      (delete Lo.animationend.animation,
      delete Lo.animationiteration.animation,
      delete Lo.animationstart.animation),
    "TransitionEvent" in window || delete Lo.transitionend.transition)
  function Es(a) {
    if (as[a]) return as[a]
    if (!Lo[a]) return a
    var c = Lo[a],
      g
    for (g in c) if (c.hasOwnProperty(g) && g in ls) return (as[a] = c[g])
    return a
  }
  var xc = Es("animationend"),
    _c = Es("animationiteration"),
    lh = Es("animationstart"),
    ch = Es("transitionend"),
    uh = new Map(),
    fh =
      "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
        " ",
      )
  function js(a, c) {
    uh.set(a, c), s(c, [a])
  }
  for (var vf = 0; vf < fh.length; vf++) {
    var wc = fh[vf],
      Sc = wc.toLowerCase(),
      Vm = wc[0].toUpperCase() + wc.slice(1)
    js(Sc, "on" + Vm)
  }
  js(xc, "onAnimationEnd"),
    js(_c, "onAnimationIteration"),
    js(lh, "onAnimationStart"),
    js("dblclick", "onDoubleClick"),
    js("focusin", "onFocus"),
    js("focusout", "onBlur"),
    js(ch, "onTransitionEnd"),
    o("onMouseEnter", ["mouseout", "mouseover"]),
    o("onMouseLeave", ["mouseout", "mouseover"]),
    o("onPointerEnter", ["pointerout", "pointerover"]),
    o("onPointerLeave", ["pointerout", "pointerover"]),
    s(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(" "),
    ),
    s(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " ",
      ),
    ),
    s("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]),
    s(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" "),
    ),
    s(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" "),
    ),
    s(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" "),
    )
  var Do =
      "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
        " ",
      ),
    yf = new Set("cancel close invalid load scroll toggle".split(" ").concat(Do))
  function xf(a, c, g) {
    var S = a.type || "unknown-event"
    ;(a.currentTarget = g), Wu(S, c, void 0, a), (a.currentTarget = null)
  }
  function gl(a, c) {
    c = (c & 4) !== 0
    for (var g = 0; g < a.length; g++) {
      var S = a[g],
        b = S.event
      S = S.listeners
      e: {
        var L = void 0
        if (c)
          for (var H = S.length - 1; 0 <= H; H--) {
            var te = S[H],
              le = te.instance,
              Re = te.currentTarget
            if (((te = te.listener), le !== L && b.isPropagationStopped())) break e
            xf(b, te, Re), (L = le)
          }
        else
          for (H = 0; H < S.length; H++) {
            if (
              ((te = S[H]),
              (le = te.instance),
              (Re = te.currentTarget),
              (te = te.listener),
              le !== L && b.isPropagationStopped())
            )
              break e
            xf(b, te, Re), (L = le)
          }
      }
    }
    if (is) throw ((a = bo), (is = !1), (bo = null), a)
  }
  function Mn(a, c) {
    var g = c[ga]
    g === void 0 && (g = c[ga] = new Set())
    var S = a + "__bubble"
    g.has(S) || (wf(c, a, 2, !1), g.add(S))
  }
  function _f(a, c, g) {
    var S = 0
    c && (S |= 4), wf(g, a, S, c)
  }
  var Mc = "_reactListening" + Math.random().toString(36).slice(2)
  function vl(a) {
    if (!a[Mc]) {
      ;(a[Mc] = !0),
        i.forEach(function (g) {
          g !== "selectionchange" && (yf.has(g) || _f(g, !1, a), _f(g, !0, a))
        })
      var c = a.nodeType === 9 ? a : a.ownerDocument
      c === null || c[Mc] || ((c[Mc] = !0), _f("selectionchange", !1, c))
    }
  }
  function wf(a, c, g, S) {
    switch (Im(c)) {
      case 1:
        var b = ef
        break
      case 4:
        b = Zd
        break
      default:
        b = tf
    }
    ;(g = b.bind(null, c, g, a)),
      (b = void 0),
      !tl || (c !== "touchstart" && c !== "touchmove" && c !== "wheel") || (b = !0),
      S
        ? b !== void 0
          ? a.addEventListener(c, g, { capture: !0, passive: b })
          : a.addEventListener(c, g, !0)
        : b !== void 0
        ? a.addEventListener(c, g, { passive: b })
        : a.addEventListener(c, g, !1)
  }
  function Sf(a, c, g, S, b) {
    var L = S
    if ((c & 1) === 0 && (c & 2) === 0 && S !== null)
      e: for (;;) {
        if (S === null) return
        var H = S.tag
        if (H === 3 || H === 4) {
          var te = S.stateNode.containerInfo
          if (te === b || (te.nodeType === 8 && te.parentNode === b)) break
          if (H === 4)
            for (H = S.return; H !== null; ) {
              var le = H.tag
              if (
                (le === 3 || le === 4) &&
                ((le = H.stateNode.containerInfo),
                le === b || (le.nodeType === 8 && le.parentNode === b))
              )
                return
              H = H.return
            }
          for (; te !== null; ) {
            if (((H = No(te)), H === null)) return
            if (((le = H.tag), le === 5 || le === 6)) {
              S = L = H
              continue e
            }
            te = te.parentNode
          }
        }
        S = S.return
      }
    zi(function () {
      var Re = L,
        Ye = he(g),
        $e = []
      e: {
        var Xe = uh.get(a)
        if (Xe !== void 0) {
          var pt = mc,
            St = a
          switch (a) {
            case "keypress":
              if (ra(g) === 0) break e
            case "keydown":
            case "keyup":
              pt = uf
              break
            case "focusin":
              ;(St = "focus"), (pt = of)
              break
            case "focusout":
              ;(St = "blur"), (pt = of)
              break
            case "beforeblur":
            case "afterblur":
              pt = of
              break
            case "click":
              if (g.button === 2) break e
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              pt = Qd
              break
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              pt = Co
              break
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              pt = Hs
              break
            case xc:
            case _c:
            case lh:
              pt = Lm
              break
            case ch:
              pt = la
              break
            case "scroll":
              pt = ol
              break
            case "wheel":
              pt = ih
              break
            case "copy":
            case "cut":
            case "paste":
              pt = eh
              break
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              pt = gr
          }
          var bt = (c & 4) !== 0,
            ai = !bt && a === "scroll",
            _e = bt ? (Xe !== null ? Xe + "Capture" : null) : Xe
          bt = []
          for (var de = Re, Te; de !== null; ) {
            Te = de
            var et = Te.stateNode
            if (
              (Te.tag === 5 &&
                et !== null &&
                ((Te = et),
                _e !== null &&
                  ((et = Vi(de, _e)), et != null && bt.push(yl(de, et, Te)))),
              ai)
            )
              break
            de = de.return
          }
          0 < bt.length &&
            ((Xe = new pt(Xe, St, null, g, Ye)), $e.push({ event: Xe, listeners: bt }))
        }
      }
      if ((c & 7) === 0) {
        e: {
          if (
            ((Xe = a === "mouseover" || a === "pointerover"),
            (pt = a === "mouseout" || a === "pointerout"),
            Xe &&
              g !== dn &&
              (St = g.relatedTarget || g.fromElement) &&
              (No(St) || St[xr]))
          )
            break e
          if (
            (pt || Xe) &&
            ((Xe =
              Ye.window === Ye
                ? Ye
                : (Xe = Ye.ownerDocument)
                ? Xe.defaultView || Xe.parentWindow
                : window),
            pt
              ? ((St = g.relatedTarget || g.toElement),
                (pt = Re),
                (St = St ? No(St) : null),
                St !== null &&
                  ((ai = xs(St)), St !== ai || (St.tag !== 5 && St.tag !== 6)) &&
                  (St = null))
              : ((pt = null), (St = Re)),
            pt !== St)
          ) {
            if (
              ((bt = Qd),
              (et = "onMouseLeave"),
              (_e = "onMouseEnter"),
              (de = "mouse"),
              (a === "pointerout" || a === "pointerover") &&
                ((bt = gr),
                (et = "onPointerLeave"),
                (_e = "onPointerEnter"),
                (de = "pointer")),
              (ai = pt == null ? Xe : qn(pt)),
              (Te = St == null ? Xe : qn(St)),
              (Xe = new bt(et, de + "leave", pt, g, Ye)),
              (Xe.target = ai),
              (Xe.relatedTarget = Te),
              (et = null),
              No(Ye) === Re &&
                ((bt = new bt(_e, de + "enter", St, g, Ye)),
                (bt.target = Te),
                (bt.relatedTarget = ai),
                (et = bt)),
              (ai = et),
              pt && St)
            )
              t: {
                for (bt = pt, _e = St, de = 0, Te = bt; Te; Te = pa(Te)) de++
                for (Te = 0, et = _e; et; et = pa(et)) Te++
                for (; 0 < de - Te; ) (bt = pa(bt)), de--
                for (; 0 < Te - de; ) (_e = pa(_e)), Te--
                for (; de--; ) {
                  if (bt === _e || (_e !== null && bt === _e.alternate)) break t
                  ;(bt = pa(bt)), (_e = pa(_e))
                }
                bt = null
              }
            else bt = null
            pt !== null && Hm($e, Xe, pt, bt, !1),
              St !== null && ai !== null && Hm($e, ai, St, bt, !0)
          }
        }
        e: {
          if (
            ((Xe = Re ? qn(Re) : window),
            (pt = Xe.nodeName && Xe.nodeName.toLowerCase()),
            pt === "select" || (pt === "input" && Xe.type === "file"))
          )
            var Rt = Bm
          else if (df(Xe))
            if (hl) Rt = Un
            else {
              Rt = zm
              var Lt = pl
            }
          else
            (pt = Xe.nodeName) &&
              pt.toLowerCase() === "input" &&
              (Xe.type === "checkbox" || Xe.type === "radio") &&
              (Rt = ah)
          if (Rt && (Rt = Rt(a, Re))) {
            fl($e, Rt, g, Ye)
            break e
          }
          Lt && Lt(a, Xe, Re),
            a === "focusout" &&
              (Lt = Xe._wrapperState) &&
              Lt.controlled &&
              Xe.type === "number" &&
              He(Xe, "number", Xe.value)
        }
        switch (((Lt = Re ? qn(Re) : window), a)) {
          case "focusin":
            ;(df(Lt) || Lt.contentEditable === "true") &&
              ((Ms = Lt), (ha = Re), (yc = null))
            break
          case "focusout":
            yc = ha = Ms = null
            break
          case "mousedown":
            hi = !0
            break
          case "contextmenu":
          case "mouseup":
          case "dragend":
            ;(hi = !1), gf($e, g, Ye)
            break
          case "selectionchange":
            if (mf) break
          case "keydown":
          case "keyup":
            gf($e, g, Ye)
        }
        var Dt
        if (ji)
          e: {
            switch (a) {
              case "compositionstart":
                var Bt = "onCompositionStart"
                break e
              case "compositionend":
                Bt = "onCompositionEnd"
                break e
              case "compositionupdate":
                Bt = "onCompositionUpdate"
                break e
            }
            Bt = void 0
          }
        else
          Po
            ? oh(a, g) && (Bt = "onCompositionEnd")
            : a === "keydown" && g.keyCode === 229 && (Bt = "onCompositionStart")
        Bt &&
          (cl &&
            g.locale !== "ko" &&
            (Po || Bt !== "onCompositionStart"
              ? Bt === "onCompositionEnd" && Po && (Dt = pc())
              : ((ss = Ye),
                (Jd = "value" in ss ? ss.value : ss.textContent),
                (Po = !0))),
          (Lt = Mf(Re, Bt)),
          0 < Lt.length &&
            ((Bt = new th(Bt, a, null, g, Ye)),
            $e.push({ event: Bt, listeners: Lt }),
            Dt ? (Bt.data = Dt) : ((Dt = ff(g)), Dt !== null && (Bt.data = Dt)))),
          (Dt = Dn ? Um(a, g) : gc(a, g)) &&
            ((Re = Mf(Re, "onBeforeInput")),
            0 < Re.length &&
              ((Ye = new th("onBeforeInput", "beforeinput", null, g, Ye)),
              $e.push({ event: Ye, listeners: Re }),
              (Ye.data = Dt)))
      }
      gl($e, c)
    })
  }
  function yl(a, c, g) {
    return { instance: a, listener: c, currentTarget: g }
  }
  function Mf(a, c) {
    for (var g = c + "Capture", S = []; a !== null; ) {
      var b = a,
        L = b.stateNode
      b.tag === 5 &&
        L !== null &&
        ((b = L),
        (L = Vi(a, g)),
        L != null && S.unshift(yl(a, L, b)),
        (L = Vi(a, c)),
        L != null && S.push(yl(a, L, b))),
        (a = a.return)
    }
    return S
  }
  function pa(a) {
    if (a === null) return null
    do a = a.return
    while (a && a.tag !== 5)
    return a || null
  }
  function Hm(a, c, g, S, b) {
    for (var L = c._reactName, H = []; g !== null && g !== S; ) {
      var te = g,
        le = te.alternate,
        Re = te.stateNode
      if (le !== null && le === S) break
      te.tag === 5 &&
        Re !== null &&
        ((te = Re),
        b
          ? ((le = Vi(g, L)), le != null && H.unshift(yl(g, le, te)))
          : b || ((le = Vi(g, L)), le != null && H.push(yl(g, le, te)))),
        (g = g.return)
    }
    H.length !== 0 && a.push({ event: c, listeners: H })
  }
  var Ey = /\r\n?/g,
    Gm = /\u0000|\uFFFD/g
  function dh(a) {
    return (typeof a == "string" ? a : "" + a)
      .replace(
        Ey,
        `
`,
      )
      .replace(Gm, "")
  }
  function Ec(a, c, g) {
    if (((c = dh(c)), dh(a) !== c && g)) throw Error(t(425))
  }
  function Tc() {}
  var xl = null,
    hh = null
  function ph(a, c) {
    return (
      a === "textarea" ||
      a === "noscript" ||
      typeof c.children == "string" ||
      typeof c.children == "number" ||
      (typeof c.dangerouslySetInnerHTML == "object" &&
        c.dangerouslySetInnerHTML !== null &&
        c.dangerouslySetInnerHTML.__html != null)
    )
  }
  var mh = typeof setTimeout == "function" ? setTimeout : void 0,
    gh = typeof clearTimeout == "function" ? clearTimeout : void 0,
    Ef = typeof Promise == "function" ? Promise : void 0,
    Ty =
      typeof queueMicrotask == "function"
        ? queueMicrotask
        : typeof Ef < "u"
        ? function (a) {
            return Ef.resolve(null).then(a).catch(Wm)
          }
        : mh
  function Wm(a) {
    setTimeout(function () {
      throw a
    })
  }
  function Tf(a, c) {
    var g = c,
      S = 0
    do {
      var b = g.nextSibling
      if ((a.removeChild(g), b && b.nodeType === 8))
        if (((g = b.data), g === "/$")) {
          if (S === 0) {
            a.removeChild(b), hc(c)
            return
          }
          S--
        } else (g !== "$" && g !== "$?" && g !== "$!") || S++
      g = b
    } while (g)
    hc(c)
  }
  function Xs(a) {
    for (; a != null; a = a.nextSibling) {
      var c = a.nodeType
      if (c === 1 || c === 3) break
      if (c === 8) {
        if (((c = a.data), c === "$" || c === "$!" || c === "$?")) break
        if (c === "/$") return null
      }
    }
    return a
  }
  function vh(a) {
    a = a.previousSibling
    for (var c = 0; a; ) {
      if (a.nodeType === 8) {
        var g = a.data
        if (g === "$" || g === "$!" || g === "$?") {
          if (c === 0) return a
          c--
        } else g === "/$" && c++
      }
      a = a.previousSibling
    }
    return null
  }
  var ma = Math.random().toString(36).slice(2),
    oi = "__reactFiber$" + ma,
    _l = "__reactProps$" + ma,
    xr = "__reactContainer$" + ma,
    ga = "__reactEvents$" + ma,
    bf = "__reactListeners$" + ma,
    Af = "__reactHandles$" + ma
  function No(a) {
    var c = a[oi]
    if (c) return c
    for (var g = a.parentNode; g; ) {
      if ((c = g[xr] || g[oi])) {
        if (((g = c.alternate), c.child !== null || (g !== null && g.child !== null)))
          for (a = vh(a); a !== null; ) {
            if ((g = a[oi])) return g
            a = vh(a)
          }
        return c
      }
      ;(a = g), (g = a.parentNode)
    }
    return null
  }
  function Ys(a) {
    return (
      (a = a[oi] || a[xr]),
      !a || (a.tag !== 5 && a.tag !== 6 && a.tag !== 13 && a.tag !== 3) ? null : a
    )
  }
  function qn(a) {
    if (a.tag === 5 || a.tag === 6) return a.stateNode
    throw Error(t(33))
  }
  function Cf(a) {
    return a[_l] || null
  }
  var yh = [],
    pi = -1
  function Gn(a) {
    return { current: a }
  }
  function En(a) {
    0 > pi || ((a.current = yh[pi]), (yh[pi] = null), pi--)
  }
  function wn(a, c) {
    pi++, (yh[pi] = a.current), (a.current = c)
  }
  var qs = {},
    _i = Gn(qs),
    Xi = Gn(!1),
    $s = qs
  function va(a, c) {
    var g = a.type.contextTypes
    if (!g) return qs
    var S = a.stateNode
    if (S && S.__reactInternalMemoizedUnmaskedChildContext === c)
      return S.__reactInternalMemoizedMaskedChildContext
    var b = {},
      L
    for (L in g) b[L] = c[L]
    return (
      S &&
        ((a = a.stateNode),
        (a.__reactInternalMemoizedUnmaskedChildContext = c),
        (a.__reactInternalMemoizedMaskedChildContext = b)),
      b
    )
  }
  function Li(a) {
    return (a = a.childContextTypes), a != null
  }
  function bc() {
    En(Xi), En(_i)
  }
  function xh(a, c, g) {
    if (_i.current !== qs) throw Error(t(168))
    wn(_i, c), wn(Xi, g)
  }
  function Ac(a, c, g) {
    var S = a.stateNode
    if (((c = c.childContextTypes), typeof S.getChildContext != "function")) return g
    S = S.getChildContext()
    for (var b in S) if (!(b in c)) throw Error(t(108, me(a) || "Unknown", b))
    return Q({}, g, S)
  }
  function ya(a) {
    return (
      (a = ((a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext) || qs),
      ($s = _i.current),
      wn(_i, a),
      wn(Xi, Xi.current),
      !0
    )
  }
  function _h(a, c, g) {
    var S = a.stateNode
    if (!S) throw Error(t(169))
    g
      ? ((a = Ac(a, c, $s)),
        (S.__reactInternalMemoizedMergedChildContext = a),
        En(Xi),
        En(_i),
        wn(_i, a))
      : En(Xi),
      wn(Xi, g)
  }
  var cs = null,
    Cc = !1,
    Rf = !1
  function Rc(a) {
    cs === null ? (cs = [a]) : cs.push(a)
  }
  function jm(a) {
    ;(Cc = !0), Rc(a)
  }
  function Ts() {
    if (!Rf && cs !== null) {
      Rf = !0
      var a = 0,
        c = hn
      try {
        var g = cs
        for (hn = 1; a < g.length; a++) {
          var S = g[a]
          do S = S(!0)
          while (S !== null)
        }
        ;(cs = null), (Cc = !1)
      } catch (b) {
        throw (cs !== null && (cs = cs.slice(a + 1)), Ae(xt, Ts), b)
      } finally {
        ;(hn = c), (Rf = !1)
      }
    }
    return null
  }
  var xa = [],
    sr = 0,
    Pf = null,
    If = 0,
    Yi = [],
    mi = 0,
    _a = null,
    nt = 1,
    Vr = ""
  function Ks(a, c) {
    ;(xa[sr++] = If), (xa[sr++] = Pf), (Pf = a), (If = c)
  }
  function wh(a, c, g) {
    ;(Yi[mi++] = nt), (Yi[mi++] = Vr), (Yi[mi++] = _a), (_a = a)
    var S = nt
    a = Vr
    var b = 32 - Ft(S) - 1
    ;(S &= ~(1 << b)), (g += 1)
    var L = 32 - Ft(c) + b
    if (30 < L) {
      var H = b - (b % 5)
      ;(L = (S & ((1 << H) - 1)).toString(32)),
        (S >>= H),
        (b -= H),
        (nt = (1 << (32 - Ft(c) + b)) | (g << b) | S),
        (Vr = L + a)
    } else (nt = (1 << L) | (g << b) | S), (Vr = a)
  }
  function Sh(a) {
    a.return !== null && (Ks(a, 1), wh(a, 1, 0))
  }
  function Zs(a) {
    for (; a === Pf; )
      (Pf = xa[--sr]), (xa[sr] = null), (If = xa[--sr]), (xa[sr] = null)
    for (; a === _a; )
      (_a = Yi[--mi]),
        (Yi[mi] = null),
        (Vr = Yi[--mi]),
        (Yi[mi] = null),
        (nt = Yi[--mi]),
        (Yi[mi] = null)
  }
  var wi = null,
    qi = null,
    Cn = !1,
    Hr = null
  function Mh(a, c) {
    var g = Ps(5, null, null, 0)
    ;(g.elementType = "DELETED"),
      (g.stateNode = c),
      (g.return = a),
      (c = a.deletions),
      c === null ? ((a.deletions = [g]), (a.flags |= 16)) : c.push(g)
  }
  function Eh(a, c) {
    switch (a.tag) {
      case 5:
        var g = a.type
        return (
          (c =
            c.nodeType !== 1 || g.toLowerCase() !== c.nodeName.toLowerCase()
              ? null
              : c),
          c !== null ? ((a.stateNode = c), (wi = a), (qi = Xs(c.firstChild)), !0) : !1
        )
      case 6:
        return (
          (c = a.pendingProps === "" || c.nodeType !== 3 ? null : c),
          c !== null ? ((a.stateNode = c), (wi = a), (qi = null), !0) : !1
        )
      case 13:
        return (
          (c = c.nodeType !== 8 ? null : c),
          c !== null
            ? ((g = _a !== null ? { id: nt, overflow: Vr } : null),
              (a.memoizedState = {
                dehydrated: c,
                treeContext: g,
                retryLane: 1073741824,
              }),
              (g = Ps(18, null, null, 0)),
              (g.stateNode = c),
              (g.return = a),
              (a.child = g),
              (wi = a),
              (qi = null),
              !0)
            : !1
        )
      default:
        return !1
    }
  }
  function Lf(a) {
    return (a.mode & 1) !== 0 && (a.flags & 128) === 0
  }
  function Df(a) {
    if (Cn) {
      var c = qi
      if (c) {
        var g = c
        if (!Eh(a, c)) {
          if (Lf(a)) throw Error(t(418))
          c = Xs(g.nextSibling)
          var S = wi
          c && Eh(a, c)
            ? Mh(S, g)
            : ((a.flags = (a.flags & -4097) | 2), (Cn = !1), (wi = a))
        }
      } else {
        if (Lf(a)) throw Error(t(418))
        ;(a.flags = (a.flags & -4097) | 2), (Cn = !1), (wi = a)
      }
    }
  }
  function Nf(a) {
    for (a = a.return; a !== null && a.tag !== 5 && a.tag !== 3 && a.tag !== 13; )
      a = a.return
    wi = a
  }
  function wl(a) {
    if (a !== wi) return !1
    if (!Cn) return Nf(a), (Cn = !0), !1
    var c
    if (
      ((c = a.tag !== 3) &&
        !(c = a.tag !== 5) &&
        ((c = a.type),
        (c = c !== "head" && c !== "body" && !ph(a.type, a.memoizedProps))),
      c && (c = qi))
    ) {
      if (Lf(a)) throw (Th(), Error(t(418)))
      for (; c; ) Mh(a, c), (c = Xs(c.nextSibling))
    }
    if ((Nf(a), a.tag === 13)) {
      if (((a = a.memoizedState), (a = a !== null ? a.dehydrated : null), !a))
        throw Error(t(317))
      e: {
        for (a = a.nextSibling, c = 0; a; ) {
          if (a.nodeType === 8) {
            var g = a.data
            if (g === "/$") {
              if (c === 0) {
                qi = Xs(a.nextSibling)
                break e
              }
              c--
            } else (g !== "$" && g !== "$!" && g !== "$?") || c++
          }
          a = a.nextSibling
        }
        qi = null
      }
    } else qi = wi ? Xs(a.stateNode.nextSibling) : null
    return !0
  }
  function Th() {
    for (var a = qi; a; ) a = Xs(a.nextSibling)
  }
  function ko() {
    ;(qi = wi = null), (Cn = !1)
  }
  function Sl(a) {
    Hr === null ? (Hr = [a]) : Hr.push(a)
  }
  var by = R.ReactCurrentBatchConfig
  function Pc(a, c, g) {
    if (((a = g.ref), a !== null && typeof a != "function" && typeof a != "object")) {
      if (g._owner) {
        if (((g = g._owner), g)) {
          if (g.tag !== 1) throw Error(t(309))
          var S = g.stateNode
        }
        if (!S) throw Error(t(147, a))
        var b = S,
          L = "" + a
        return c !== null &&
          c.ref !== null &&
          typeof c.ref == "function" &&
          c.ref._stringRef === L
          ? c.ref
          : ((c = function (H) {
              var te = b.refs
              H === null ? delete te[L] : (te[L] = H)
            }),
            (c._stringRef = L),
            c)
      }
      if (typeof a != "string") throw Error(t(284))
      if (!g._owner) throw Error(t(290, a))
    }
    return a
  }
  function Ic(a, c) {
    throw (
      ((a = Object.prototype.toString.call(c)),
      Error(
        t(
          31,
          a === "[object Object]"
            ? "object with keys {" + Object.keys(c).join(", ") + "}"
            : a,
        ),
      ))
    )
  }
  function bh(a) {
    var c = a._init
    return c(a._payload)
  }
  function Ah(a) {
    function c(_e, de) {
      if (a) {
        var Te = _e.deletions
        Te === null ? ((_e.deletions = [de]), (_e.flags |= 16)) : Te.push(de)
      }
    }
    function g(_e, de) {
      if (!a) return null
      for (; de !== null; ) c(_e, de), (de = de.sibling)
      return null
    }
    function S(_e, de) {
      for (_e = new Map(); de !== null; )
        de.key !== null ? _e.set(de.key, de) : _e.set(de.index, de), (de = de.sibling)
      return _e
    }
    function b(_e, de) {
      return (_e = Dl(_e, de)), (_e.index = 0), (_e.sibling = null), _e
    }
    function L(_e, de, Te) {
      return (
        (_e.index = Te),
        a
          ? ((Te = _e.alternate),
            Te !== null
              ? ((Te = Te.index), Te < de ? ((_e.flags |= 2), de) : Te)
              : ((_e.flags |= 2), de))
          : ((_e.flags |= 1048576), de)
      )
    }
    function H(_e) {
      return a && _e.alternate === null && (_e.flags |= 2), _e
    }
    function te(_e, de, Te, et) {
      return de === null || de.tag !== 6
        ? ((de = jy(Te, _e.mode, et)), (de.return = _e), de)
        : ((de = b(de, Te)), (de.return = _e), de)
    }
    function le(_e, de, Te, et) {
      var Rt = Te.type
      return Rt === O
        ? Ye(_e, de, Te.props.children, et, Te.key)
        : de !== null &&
          (de.elementType === Rt ||
            (typeof Rt == "object" &&
              Rt !== null &&
              Rt.$$typeof === re &&
              bh(Rt) === de.type))
        ? ((et = b(de, Te.props)), (et.ref = Pc(_e, de, Te)), (et.return = _e), et)
        : ((et = pg(Te.type, Te.key, Te.props, null, _e.mode, et)),
          (et.ref = Pc(_e, de, Te)),
          (et.return = _e),
          et)
    }
    function Re(_e, de, Te, et) {
      return de === null ||
        de.tag !== 4 ||
        de.stateNode.containerInfo !== Te.containerInfo ||
        de.stateNode.implementation !== Te.implementation
        ? ((de = Xy(Te, _e.mode, et)), (de.return = _e), de)
        : ((de = b(de, Te.children || [])), (de.return = _e), de)
    }
    function Ye(_e, de, Te, et, Rt) {
      return de === null || de.tag !== 7
        ? ((de = qc(Te, _e.mode, et, Rt)), (de.return = _e), de)
        : ((de = b(de, Te)), (de.return = _e), de)
    }
    function $e(_e, de, Te) {
      if ((typeof de == "string" && de !== "") || typeof de == "number")
        return (de = jy("" + de, _e.mode, Te)), (de.return = _e), de
      if (typeof de == "object" && de !== null) {
        switch (de.$$typeof) {
          case z:
            return (
              (Te = pg(de.type, de.key, de.props, null, _e.mode, Te)),
              (Te.ref = Pc(_e, null, de)),
              (Te.return = _e),
              Te
            )
          case U:
            return (de = Xy(de, _e.mode, Te)), (de.return = _e), de
          case re:
            var et = de._init
            return $e(_e, et(de._payload), Te)
        }
        if (Se(de) || ie(de))
          return (de = qc(de, _e.mode, Te, null)), (de.return = _e), de
        Ic(_e, de)
      }
      return null
    }
    function Xe(_e, de, Te, et) {
      var Rt = de !== null ? de.key : null
      if ((typeof Te == "string" && Te !== "") || typeof Te == "number")
        return Rt !== null ? null : te(_e, de, "" + Te, et)
      if (typeof Te == "object" && Te !== null) {
        switch (Te.$$typeof) {
          case z:
            return Te.key === Rt ? le(_e, de, Te, et) : null
          case U:
            return Te.key === Rt ? Re(_e, de, Te, et) : null
          case re:
            return (Rt = Te._init), Xe(_e, de, Rt(Te._payload), et)
        }
        if (Se(Te) || ie(Te)) return Rt !== null ? null : Ye(_e, de, Te, et, null)
        Ic(_e, Te)
      }
      return null
    }
    function pt(_e, de, Te, et, Rt) {
      if ((typeof et == "string" && et !== "") || typeof et == "number")
        return (_e = _e.get(Te) || null), te(de, _e, "" + et, Rt)
      if (typeof et == "object" && et !== null) {
        switch (et.$$typeof) {
          case z:
            return (
              (_e = _e.get(et.key === null ? Te : et.key) || null), le(de, _e, et, Rt)
            )
          case U:
            return (
              (_e = _e.get(et.key === null ? Te : et.key) || null), Re(de, _e, et, Rt)
            )
          case re:
            var Lt = et._init
            return pt(_e, de, Te, Lt(et._payload), Rt)
        }
        if (Se(et) || ie(et)) return (_e = _e.get(Te) || null), Ye(de, _e, et, Rt, null)
        Ic(de, et)
      }
      return null
    }
    function St(_e, de, Te, et) {
      for (
        var Rt = null, Lt = null, Dt = de, Bt = (de = 0), Fi = null;
        Dt !== null && Bt < Te.length;
        Bt++
      ) {
        Dt.index > Bt ? ((Fi = Dt), (Dt = null)) : (Fi = Dt.sibling)
        var gn = Xe(_e, Dt, Te[Bt], et)
        if (gn === null) {
          Dt === null && (Dt = Fi)
          break
        }
        a && Dt && gn.alternate === null && c(_e, Dt),
          (de = L(gn, de, Bt)),
          Lt === null ? (Rt = gn) : (Lt.sibling = gn),
          (Lt = gn),
          (Dt = Fi)
      }
      if (Bt === Te.length) return g(_e, Dt), Cn && Ks(_e, Bt), Rt
      if (Dt === null) {
        for (; Bt < Te.length; Bt++)
          (Dt = $e(_e, Te[Bt], et)),
            Dt !== null &&
              ((de = L(Dt, de, Bt)),
              Lt === null ? (Rt = Dt) : (Lt.sibling = Dt),
              (Lt = Dt))
        return Cn && Ks(_e, Bt), Rt
      }
      for (Dt = S(_e, Dt); Bt < Te.length; Bt++)
        (Fi = pt(Dt, _e, Bt, Te[Bt], et)),
          Fi !== null &&
            (a && Fi.alternate !== null && Dt.delete(Fi.key === null ? Bt : Fi.key),
            (de = L(Fi, de, Bt)),
            Lt === null ? (Rt = Fi) : (Lt.sibling = Fi),
            (Lt = Fi))
      return (
        a &&
          Dt.forEach(function (Nl) {
            return c(_e, Nl)
          }),
        Cn && Ks(_e, Bt),
        Rt
      )
    }
    function bt(_e, de, Te, et) {
      var Rt = ie(Te)
      if (typeof Rt != "function") throw Error(t(150))
      if (((Te = Rt.call(Te)), Te == null)) throw Error(t(151))
      for (
        var Lt = (Rt = null), Dt = de, Bt = (de = 0), Fi = null, gn = Te.next();
        Dt !== null && !gn.done;
        Bt++, gn = Te.next()
      ) {
        Dt.index > Bt ? ((Fi = Dt), (Dt = null)) : (Fi = Dt.sibling)
        var Nl = Xe(_e, Dt, gn.value, et)
        if (Nl === null) {
          Dt === null && (Dt = Fi)
          break
        }
        a && Dt && Nl.alternate === null && c(_e, Dt),
          (de = L(Nl, de, Bt)),
          Lt === null ? (Rt = Nl) : (Lt.sibling = Nl),
          (Lt = Nl),
          (Dt = Fi)
      }
      if (gn.done) return g(_e, Dt), Cn && Ks(_e, Bt), Rt
      if (Dt === null) {
        for (; !gn.done; Bt++, gn = Te.next())
          (gn = $e(_e, gn.value, et)),
            gn !== null &&
              ((de = L(gn, de, Bt)),
              Lt === null ? (Rt = gn) : (Lt.sibling = gn),
              (Lt = gn))
        return Cn && Ks(_e, Bt), Rt
      }
      for (Dt = S(_e, Dt); !gn.done; Bt++, gn = Te.next())
        (gn = pt(Dt, _e, Bt, gn.value, et)),
          gn !== null &&
            (a && gn.alternate !== null && Dt.delete(gn.key === null ? Bt : gn.key),
            (de = L(gn, de, Bt)),
            Lt === null ? (Rt = gn) : (Lt.sibling = gn),
            (Lt = gn))
      return (
        a &&
          Dt.forEach(function (yP) {
            return c(_e, yP)
          }),
        Cn && Ks(_e, Bt),
        Rt
      )
    }
    function ai(_e, de, Te, et) {
      if (
        (typeof Te == "object" &&
          Te !== null &&
          Te.type === O &&
          Te.key === null &&
          (Te = Te.props.children),
        typeof Te == "object" && Te !== null)
      ) {
        switch (Te.$$typeof) {
          case z:
            e: {
              for (var Rt = Te.key, Lt = de; Lt !== null; ) {
                if (Lt.key === Rt) {
                  if (((Rt = Te.type), Rt === O)) {
                    if (Lt.tag === 7) {
                      g(_e, Lt.sibling),
                        (de = b(Lt, Te.props.children)),
                        (de.return = _e),
                        (_e = de)
                      break e
                    }
                  } else if (
                    Lt.elementType === Rt ||
                    (typeof Rt == "object" &&
                      Rt !== null &&
                      Rt.$$typeof === re &&
                      bh(Rt) === Lt.type)
                  ) {
                    g(_e, Lt.sibling),
                      (de = b(Lt, Te.props)),
                      (de.ref = Pc(_e, Lt, Te)),
                      (de.return = _e),
                      (_e = de)
                    break e
                  }
                  g(_e, Lt)
                  break
                } else c(_e, Lt)
                Lt = Lt.sibling
              }
              Te.type === O
                ? ((de = qc(Te.props.children, _e.mode, et, Te.key)),
                  (de.return = _e),
                  (_e = de))
                : ((et = pg(Te.type, Te.key, Te.props, null, _e.mode, et)),
                  (et.ref = Pc(_e, de, Te)),
                  (et.return = _e),
                  (_e = et))
            }
            return H(_e)
          case U:
            e: {
              for (Lt = Te.key; de !== null; ) {
                if (de.key === Lt)
                  if (
                    de.tag === 4 &&
                    de.stateNode.containerInfo === Te.containerInfo &&
                    de.stateNode.implementation === Te.implementation
                  ) {
                    g(_e, de.sibling),
                      (de = b(de, Te.children || [])),
                      (de.return = _e),
                      (_e = de)
                    break e
                  } else {
                    g(_e, de)
                    break
                  }
                else c(_e, de)
                de = de.sibling
              }
              ;(de = Xy(Te, _e.mode, et)), (de.return = _e), (_e = de)
            }
            return H(_e)
          case re:
            return (Lt = Te._init), ai(_e, de, Lt(Te._payload), et)
        }
        if (Se(Te)) return St(_e, de, Te, et)
        if (ie(Te)) return bt(_e, de, Te, et)
        Ic(_e, Te)
      }
      return (typeof Te == "string" && Te !== "") || typeof Te == "number"
        ? ((Te = "" + Te),
          de !== null && de.tag === 6
            ? (g(_e, de.sibling), (de = b(de, Te)), (de.return = _e), (_e = de))
            : (g(_e, de), (de = jy(Te, _e.mode, et)), (de.return = _e), (_e = de)),
          H(_e))
        : g(_e, de)
    }
    return ai
  }
  var wa = Ah(!0),
    Lc = Ah(!1),
    Sa = Gn(null),
    Ma = null,
    Js = null,
    Ml = null
  function Ea() {
    Ml = Js = Ma = null
  }
  function Dc(a) {
    var c = Sa.current
    En(Sa), (a._currentValue = c)
  }
  function Nc(a, c, g) {
    for (; a !== null; ) {
      var S = a.alternate
      if (
        ((a.childLanes & c) !== c
          ? ((a.childLanes |= c), S !== null && (S.childLanes |= c))
          : S !== null && (S.childLanes & c) !== c && (S.childLanes |= c),
        a === g)
      )
        break
      a = a.return
    }
  }
  function Fo(a, c) {
    ;(Ma = a),
      (Ml = Js = null),
      (a = a.dependencies),
      a !== null &&
        a.firstContext !== null &&
        ((a.lanes & c) !== 0 && (Kt = !0), (a.firstContext = null))
  }
  function _r(a) {
    var c = a._currentValue
    if (Ml !== a)
      if (((a = { context: a, memoizedValue: c, next: null }), Js === null)) {
        if (Ma === null) throw Error(t(308))
        ;(Js = a), (Ma.dependencies = { lanes: 0, firstContext: a })
      } else Js = Js.next = a
    return c
  }
  var Qs = null
  function Ch(a) {
    Qs === null ? (Qs = [a]) : Qs.push(a)
  }
  function kc(a, c, g, S) {
    var b = c.interleaved
    return (
      b === null ? ((g.next = g), Ch(c)) : ((g.next = b.next), (b.next = g)),
      (c.interleaved = g),
      us(a, S)
    )
  }
  function us(a, c) {
    a.lanes |= c
    var g = a.alternate
    for (g !== null && (g.lanes |= c), g = a, a = a.return; a !== null; )
      (a.childLanes |= c),
        (g = a.alternate),
        g !== null && (g.childLanes |= c),
        (g = a),
        (a = a.return)
    return g.tag === 3 ? g.stateNode : null
  }
  var xn = !1
  function qt(a) {
    a.updateQueue = {
      baseState: a.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, interleaved: null, lanes: 0 },
      effects: null,
    }
  }
  function $n(a, c) {
    ;(a = a.updateQueue),
      c.updateQueue === a &&
        (c.updateQueue = {
          baseState: a.baseState,
          firstBaseUpdate: a.firstBaseUpdate,
          lastBaseUpdate: a.lastBaseUpdate,
          shared: a.shared,
          effects: a.effects,
        })
  }
  function _n(a, c) {
    return { eventTime: a, lane: c, tag: 0, payload: null, callback: null, next: null }
  }
  function Nn(a, c, g) {
    var S = a.updateQueue
    if (S === null) return null
    if (((S = S.shared), (mn & 2) !== 0)) {
      var b = S.pending
      return (
        b === null ? (c.next = c) : ((c.next = b.next), (b.next = c)),
        (S.pending = c),
        us(a, g)
      )
    }
    return (
      (b = S.interleaved),
      b === null ? ((c.next = c), Ch(S)) : ((c.next = b.next), (b.next = c)),
      (S.interleaved = c),
      us(a, g)
    )
  }
  function Di(a, c, g) {
    if (((c = c.updateQueue), c !== null && ((c = c.shared), (g & 4194240) !== 0))) {
      var S = c.lanes
      ;(S &= a.pendingLanes), (g |= S), (c.lanes = g), il(a, g)
    }
  }
  function Ta(a, c) {
    var g = a.updateQueue,
      S = a.alternate
    if (S !== null && ((S = S.updateQueue), g === S)) {
      var b = null,
        L = null
      if (((g = g.firstBaseUpdate), g !== null)) {
        do {
          var H = {
            eventTime: g.eventTime,
            lane: g.lane,
            tag: g.tag,
            payload: g.payload,
            callback: g.callback,
            next: null,
          }
          L === null ? (b = L = H) : (L = L.next = H), (g = g.next)
        } while (g !== null)
        L === null ? (b = L = c) : (L = L.next = c)
      } else b = L = c
      ;(g = {
        baseState: S.baseState,
        firstBaseUpdate: b,
        lastBaseUpdate: L,
        shared: S.shared,
        effects: S.effects,
      }),
        (a.updateQueue = g)
      return
    }
    ;(a = g.lastBaseUpdate),
      a === null ? (g.firstBaseUpdate = c) : (a.next = c),
      (g.lastBaseUpdate = c)
  }
  function Wn(a, c, g, S) {
    var b = a.updateQueue
    xn = !1
    var L = b.firstBaseUpdate,
      H = b.lastBaseUpdate,
      te = b.shared.pending
    if (te !== null) {
      b.shared.pending = null
      var le = te,
        Re = le.next
      ;(le.next = null), H === null ? (L = Re) : (H.next = Re), (H = le)
      var Ye = a.alternate
      Ye !== null &&
        ((Ye = Ye.updateQueue),
        (te = Ye.lastBaseUpdate),
        te !== H &&
          (te === null ? (Ye.firstBaseUpdate = Re) : (te.next = Re),
          (Ye.lastBaseUpdate = le)))
    }
    if (L !== null) {
      var $e = b.baseState
      ;(H = 0), (Ye = Re = le = null), (te = L)
      do {
        var Xe = te.lane,
          pt = te.eventTime
        if ((S & Xe) === Xe) {
          Ye !== null &&
            (Ye = Ye.next =
              {
                eventTime: pt,
                lane: 0,
                tag: te.tag,
                payload: te.payload,
                callback: te.callback,
                next: null,
              })
          e: {
            var St = a,
              bt = te
            switch (((Xe = c), (pt = g), bt.tag)) {
              case 1:
                if (((St = bt.payload), typeof St == "function")) {
                  $e = St.call(pt, $e, Xe)
                  break e
                }
                $e = St
                break e
              case 3:
                St.flags = (St.flags & -65537) | 128
              case 0:
                if (
                  ((St = bt.payload),
                  (Xe = typeof St == "function" ? St.call(pt, $e, Xe) : St),
                  Xe == null)
                )
                  break e
                $e = Q({}, $e, Xe)
                break e
              case 2:
                xn = !0
            }
          }
          te.callback !== null &&
            te.lane !== 0 &&
            ((a.flags |= 64),
            (Xe = b.effects),
            Xe === null ? (b.effects = [te]) : Xe.push(te))
        } else
          (pt = {
            eventTime: pt,
            lane: Xe,
            tag: te.tag,
            payload: te.payload,
            callback: te.callback,
            next: null,
          }),
            Ye === null ? ((Re = Ye = pt), (le = $e)) : (Ye = Ye.next = pt),
            (H |= Xe)
        if (((te = te.next), te === null)) {
          if (((te = b.shared.pending), te === null)) break
          ;(Xe = te),
            (te = Xe.next),
            (Xe.next = null),
            (b.lastBaseUpdate = Xe),
            (b.shared.pending = null)
        }
      } while (!0)
      if (
        (Ye === null && (le = $e),
        (b.baseState = le),
        (b.firstBaseUpdate = Re),
        (b.lastBaseUpdate = Ye),
        (c = b.shared.interleaved),
        c !== null)
      ) {
        b = c
        do (H |= b.lane), (b = b.next)
        while (b !== c)
      } else L === null && (b.shared.lanes = 0)
      ;(Wc |= H), (a.lanes = H), (a.memoizedState = $e)
    }
  }
  function El(a, c, g) {
    if (((a = c.effects), (c.effects = null), a !== null))
      for (c = 0; c < a.length; c++) {
        var S = a[c],
          b = S.callback
        if (b !== null) {
          if (((S.callback = null), (S = g), typeof b != "function"))
            throw Error(t(191, b))
          b.call(S)
        }
      }
  }
  var bs = {},
    wr = Gn(bs),
    ba = Gn(bs),
    eo = Gn(bs)
  function Qn(a) {
    if (a === bs) throw Error(t(174))
    return a
  }
  function Fc(a, c) {
    switch ((wn(eo, c), wn(ba, a), wn(wr, bs), (a = c.nodeType), a)) {
      case 9:
      case 11:
        c = (c = c.documentElement) ? c.namespaceURI : st(null, "")
        break
      default:
        ;(a = a === 8 ? c.parentNode : c),
          (c = a.namespaceURI || null),
          (a = a.tagName),
          (c = st(c, a))
    }
    En(wr), wn(wr, c)
  }
  function Uo() {
    En(wr), En(ba), En(eo)
  }
  function Aa(a) {
    Qn(eo.current)
    var c = Qn(wr.current),
      g = st(c, a.type)
    c !== g && (wn(ba, a), wn(wr, g))
  }
  function Tl(a) {
    ba.current === a && (En(wr), En(ba))
  }
  var Rn = Gn(0)
  function fs(a) {
    for (var c = a; c !== null; ) {
      if (c.tag === 13) {
        var g = c.memoizedState
        if (
          g !== null &&
          ((g = g.dehydrated), g === null || g.data === "$?" || g.data === "$!")
        )
          return c
      } else if (c.tag === 19 && c.memoizedProps.revealOrder !== void 0) {
        if ((c.flags & 128) !== 0) return c
      } else if (c.child !== null) {
        ;(c.child.return = c), (c = c.child)
        continue
      }
      if (c === a) break
      for (; c.sibling === null; ) {
        if (c.return === null || c.return === a) return null
        c = c.return
      }
      ;(c.sibling.return = c.return), (c = c.sibling)
    }
    return null
  }
  var bl = []
  function As() {
    for (var a = 0; a < bl.length; a++) bl[a]._workInProgressVersionPrimary = null
    bl.length = 0
  }
  var Ca = R.ReactCurrentDispatcher,
    Ra = R.ReactCurrentBatchConfig,
    to = 0,
    Tn = null,
    jn = null,
    pn = null,
    ds = !1,
    Ni = !1,
    Oo = 0,
    or = 0
  function Si() {
    throw Error(t(321))
  }
  function Uc(a, c) {
    if (c === null) return !1
    for (var g = 0; g < c.length && g < a.length; g++) if (!vr(a[g], c[g])) return !1
    return !0
  }
  function Oc(a, c, g, S, b, L) {
    if (
      ((to = L),
      (Tn = c),
      (c.memoizedState = null),
      (c.updateQueue = null),
      (c.lanes = 0),
      (Ca.current = a === null || a.memoizedState === null ? Jm : Qm),
      (a = g(S, b)),
      Ni)
    ) {
      L = 0
      do {
        if (((Ni = !1), (Oo = 0), 25 <= L)) throw Error(t(301))
        ;(L += 1),
          (pn = jn = null),
          (c.updateQueue = null),
          (Ca.current = eg),
          (a = g(S, b))
      } while (Ni)
    }
    if (
      ((Ca.current = Vf),
      (c = jn !== null && jn.next !== null),
      (to = 0),
      (pn = jn = Tn = null),
      (ds = !1),
      c)
    )
      throw Error(t(300))
    return a
  }
  function Rh() {
    var a = Oo !== 0
    return (Oo = 0), a
  }
  function Mi() {
    var a = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null,
    }
    return pn === null ? (Tn.memoizedState = pn = a) : (pn = pn.next = a), pn
  }
  function Sr() {
    if (jn === null) {
      var a = Tn.alternate
      a = a !== null ? a.memoizedState : null
    } else a = jn.next
    var c = pn === null ? Tn.memoizedState : pn.next
    if (c !== null) (pn = c), (jn = a)
    else {
      if (a === null) throw Error(t(310))
      ;(jn = a),
        (a = {
          memoizedState: jn.memoizedState,
          baseState: jn.baseState,
          baseQueue: jn.baseQueue,
          queue: jn.queue,
          next: null,
        }),
        pn === null ? (Tn.memoizedState = pn = a) : (pn = pn.next = a)
    }
    return pn
  }
  function Al(a, c) {
    return typeof c == "function" ? c(a) : c
  }
  function Bc(a) {
    var c = Sr(),
      g = c.queue
    if (g === null) throw Error(t(311))
    g.lastRenderedReducer = a
    var S = jn,
      b = S.baseQueue,
      L = g.pending
    if (L !== null) {
      if (b !== null) {
        var H = b.next
        ;(b.next = L.next), (L.next = H)
      }
      ;(S.baseQueue = b = L), (g.pending = null)
    }
    if (b !== null) {
      ;(L = b.next), (S = S.baseState)
      var te = (H = null),
        le = null,
        Re = L
      do {
        var Ye = Re.lane
        if ((to & Ye) === Ye)
          le !== null &&
            (le = le.next =
              {
                lane: 0,
                action: Re.action,
                hasEagerState: Re.hasEagerState,
                eagerState: Re.eagerState,
                next: null,
              }),
            (S = Re.hasEagerState ? Re.eagerState : a(S, Re.action))
        else {
          var $e = {
            lane: Ye,
            action: Re.action,
            hasEagerState: Re.hasEagerState,
            eagerState: Re.eagerState,
            next: null,
          }
          le === null ? ((te = le = $e), (H = S)) : (le = le.next = $e),
            (Tn.lanes |= Ye),
            (Wc |= Ye)
        }
        Re = Re.next
      } while (Re !== null && Re !== L)
      le === null ? (H = S) : (le.next = te),
        vr(S, c.memoizedState) || (Kt = !0),
        (c.memoizedState = S),
        (c.baseState = H),
        (c.baseQueue = le),
        (g.lastRenderedState = S)
    }
    if (((a = g.interleaved), a !== null)) {
      b = a
      do (L = b.lane), (Tn.lanes |= L), (Wc |= L), (b = b.next)
      while (b !== a)
    } else b === null && (g.lanes = 0)
    return [c.memoizedState, g.dispatch]
  }
  function no(a) {
    var c = Sr(),
      g = c.queue
    if (g === null) throw Error(t(311))
    g.lastRenderedReducer = a
    var S = g.dispatch,
      b = g.pending,
      L = c.memoizedState
    if (b !== null) {
      g.pending = null
      var H = (b = b.next)
      do (L = a(L, H.action)), (H = H.next)
      while (H !== b)
      vr(L, c.memoizedState) || (Kt = !0),
        (c.memoizedState = L),
        c.baseQueue === null && (c.baseState = L),
        (g.lastRenderedState = L)
    }
    return [L, S]
  }
  function Ph() {}
  function Ih(a, c) {
    var g = Tn,
      S = Sr(),
      b = c(),
      L = !vr(S.memoizedState, b)
    if (
      (L && ((S.memoizedState = b), (Kt = !0)),
      (S = S.queue),
      Nh(Xm.bind(null, g, S, a), [a]),
      S.getSnapshot !== c || L || (pn !== null && pn.memoizedState.tag & 1))
    ) {
      if (
        ((g.flags |= 2048), hs(9, zc.bind(null, g, S, b, c), void 0, null), ki === null)
      )
        throw Error(t(349))
      ;(to & 30) !== 0 || kf(g, c, b)
    }
    return b
  }
  function kf(a, c, g) {
    ;(a.flags |= 16384),
      (a = { getSnapshot: c, value: g }),
      (c = Tn.updateQueue),
      c === null
        ? ((c = { lastEffect: null, stores: null }),
          (Tn.updateQueue = c),
          (c.stores = [a]))
        : ((g = c.stores), g === null ? (c.stores = [a]) : g.push(a))
  }
  function zc(a, c, g, S) {
    ;(c.value = g), (c.getSnapshot = S), Ym(c) && Lh(a)
  }
  function Xm(a, c, g) {
    return g(function () {
      Ym(c) && Lh(a)
    })
  }
  function Ym(a) {
    var c = a.getSnapshot
    a = a.value
    try {
      var g = c()
      return !vr(a, g)
    } catch {
      return !0
    }
  }
  function Lh(a) {
    var c = us(a, 1)
    c !== null && ao(c, a, 1, -1)
  }
  function Dh(a) {
    var c = Mi()
    return (
      typeof a == "function" && (a = a()),
      (c.memoizedState = c.baseState = a),
      (a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: Al,
        lastRenderedState: a,
      }),
      (c.queue = a),
      (a = a.dispatch = Pa.bind(null, Tn, a)),
      [c.memoizedState, a]
    )
  }
  function hs(a, c, g, S) {
    return (
      (a = { tag: a, create: c, destroy: g, deps: S, next: null }),
      (c = Tn.updateQueue),
      c === null
        ? ((c = { lastEffect: null, stores: null }),
          (Tn.updateQueue = c),
          (c.lastEffect = a.next = a))
        : ((g = c.lastEffect),
          g === null
            ? (c.lastEffect = a.next = a)
            : ((S = g.next), (g.next = a), (a.next = S), (c.lastEffect = a))),
      a
    )
  }
  function qm() {
    return Sr().memoizedState
  }
  function Cs(a, c, g, S) {
    var b = Mi()
    ;(Tn.flags |= a), (b.memoizedState = hs(1 | c, g, void 0, S === void 0 ? null : S))
  }
  function Vc(a, c, g, S) {
    var b = Sr()
    S = S === void 0 ? null : S
    var L = void 0
    if (jn !== null) {
      var H = jn.memoizedState
      if (((L = H.destroy), S !== null && Uc(S, H.deps))) {
        b.memoizedState = hs(c, g, L, S)
        return
      }
    }
    ;(Tn.flags |= a), (b.memoizedState = hs(1 | c, g, L, S))
  }
  function $i(a, c) {
    return Cs(8390656, 8, a, c)
  }
  function Nh(a, c) {
    return Vc(2048, 8, a, c)
  }
  function kh(a, c) {
    return Vc(4, 2, a, c)
  }
  function $m(a, c) {
    return Vc(4, 4, a, c)
  }
  function Km(a, c) {
    if (typeof c == "function")
      return (
        (a = a()),
        c(a),
        function () {
          c(null)
        }
      )
    if (c != null)
      return (
        (a = a()),
        (c.current = a),
        function () {
          c.current = null
        }
      )
  }
  function Fh(a, c, g) {
    return (g = g != null ? g.concat([a]) : null), Vc(4, 4, Km.bind(null, c, a), g)
  }
  function Ff() {}
  function Zm(a, c) {
    var g = Sr()
    c = c === void 0 ? null : c
    var S = g.memoizedState
    return S !== null && c !== null && Uc(c, S[1])
      ? S[0]
      : ((g.memoizedState = [a, c]), a)
  }
  function Mr(a, c) {
    var g = Sr()
    c = c === void 0 ? null : c
    var S = g.memoizedState
    return S !== null && c !== null && Uc(c, S[1])
      ? S[0]
      : ((a = a()), (g.memoizedState = [a, c]), a)
  }
  function Uf(a, c, g) {
    return (to & 21) === 0
      ? (a.baseState && ((a.baseState = !1), (Kt = !0)), (a.memoizedState = g))
      : (vr(g, c) || ((g = An()), (Tn.lanes |= g), (Wc |= g), (a.baseState = !0)), c)
  }
  function Ay(a, c) {
    var g = hn
    ;(hn = g !== 0 && 4 > g ? g : 4), a(!0)
    var S = Ra.transition
    Ra.transition = {}
    try {
      a(!1), c()
    } finally {
      ;(hn = g), (Ra.transition = S)
    }
  }
  function io() {
    return Sr().memoizedState
  }
  function Of(a, c, g) {
    var S = Il(a)
    if (
      ((g = { lane: S, action: g, hasEagerState: !1, eagerState: null, next: null }),
      Hc(a))
    )
      Bf(c, g)
    else if (((g = kc(a, c, g, S)), g !== null)) {
      var b = Tr()
      ao(g, a, S, b), zf(g, c, S)
    }
  }
  function Pa(a, c, g) {
    var S = Il(a),
      b = { lane: S, action: g, hasEagerState: !1, eagerState: null, next: null }
    if (Hc(a)) Bf(c, b)
    else {
      var L = a.alternate
      if (
        a.lanes === 0 &&
        (L === null || L.lanes === 0) &&
        ((L = c.lastRenderedReducer), L !== null)
      )
        try {
          var H = c.lastRenderedState,
            te = L(H, g)
          if (((b.hasEagerState = !0), (b.eagerState = te), vr(te, H))) {
            var le = c.interleaved
            le === null ? ((b.next = b), Ch(c)) : ((b.next = le.next), (le.next = b)),
              (c.interleaved = b)
            return
          }
        } catch {
        } finally {
        }
      ;(g = kc(a, c, b, S)), g !== null && ((b = Tr()), ao(g, a, S, b), zf(g, c, S))
    }
  }
  function Hc(a) {
    var c = a.alternate
    return a === Tn || (c !== null && c === Tn)
  }
  function Bf(a, c) {
    Ni = ds = !0
    var g = a.pending
    g === null ? (c.next = c) : ((c.next = g.next), (g.next = c)), (a.pending = c)
  }
  function zf(a, c, g) {
    if ((g & 4194240) !== 0) {
      var S = c.lanes
      ;(S &= a.pendingLanes), (g |= S), (c.lanes = g), il(a, g)
    }
  }
  var Vf = {
      readContext: _r,
      useCallback: Si,
      useContext: Si,
      useEffect: Si,
      useImperativeHandle: Si,
      useInsertionEffect: Si,
      useLayoutEffect: Si,
      useMemo: Si,
      useReducer: Si,
      useRef: Si,
      useState: Si,
      useDebugValue: Si,
      useDeferredValue: Si,
      useTransition: Si,
      useMutableSource: Si,
      useSyncExternalStore: Si,
      useId: Si,
      unstable_isNewReconciler: !1,
    },
    Jm = {
      readContext: _r,
      useCallback: function (a, c) {
        return (Mi().memoizedState = [a, c === void 0 ? null : c]), a
      },
      useContext: _r,
      useEffect: $i,
      useImperativeHandle: function (a, c, g) {
        return (
          (g = g != null ? g.concat([a]) : null), Cs(4194308, 4, Km.bind(null, c, a), g)
        )
      },
      useLayoutEffect: function (a, c) {
        return Cs(4194308, 4, a, c)
      },
      useInsertionEffect: function (a, c) {
        return Cs(4, 2, a, c)
      },
      useMemo: function (a, c) {
        var g = Mi()
        return (c = c === void 0 ? null : c), (a = a()), (g.memoizedState = [a, c]), a
      },
      useReducer: function (a, c, g) {
        var S = Mi()
        return (
          (c = g !== void 0 ? g(c) : c),
          (S.memoizedState = S.baseState = c),
          (a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: c,
          }),
          (S.queue = a),
          (a = a.dispatch = Of.bind(null, Tn, a)),
          [S.memoizedState, a]
        )
      },
      useRef: function (a) {
        var c = Mi()
        return (a = { current: a }), (c.memoizedState = a)
      },
      useState: Dh,
      useDebugValue: Ff,
      useDeferredValue: function (a) {
        return (Mi().memoizedState = a)
      },
      useTransition: function () {
        var a = Dh(!1),
          c = a[0]
        return (a = Ay.bind(null, a[1])), (Mi().memoizedState = a), [c, a]
      },
      useMutableSource: function () {},
      useSyncExternalStore: function (a, c, g) {
        var S = Tn,
          b = Mi()
        if (Cn) {
          if (g === void 0) throw Error(t(407))
          g = g()
        } else {
          if (((g = c()), ki === null)) throw Error(t(349))
          ;(to & 30) !== 0 || kf(S, c, g)
        }
        b.memoizedState = g
        var L = { value: g, getSnapshot: c }
        return (
          (b.queue = L),
          $i(Xm.bind(null, S, L, a), [a]),
          (S.flags |= 2048),
          hs(9, zc.bind(null, S, L, g, c), void 0, null),
          g
        )
      },
      useId: function () {
        var a = Mi(),
          c = ki.identifierPrefix
        if (Cn) {
          var g = Vr,
            S = nt
          ;(g = (S & ~(1 << (32 - Ft(S) - 1))).toString(32) + g),
            (c = ":" + c + "R" + g),
            (g = Oo++),
            0 < g && (c += "H" + g.toString(32)),
            (c += ":")
        } else (g = or++), (c = ":" + c + "r" + g.toString(32) + ":")
        return (a.memoizedState = c)
      },
      unstable_isNewReconciler: !1,
    },
    Qm = {
      readContext: _r,
      useCallback: Zm,
      useContext: _r,
      useEffect: Nh,
      useImperativeHandle: Fh,
      useInsertionEffect: kh,
      useLayoutEffect: $m,
      useMemo: Mr,
      useReducer: Bc,
      useRef: qm,
      useState: function () {
        return Bc(Al)
      },
      useDebugValue: Ff,
      useDeferredValue: function (a) {
        var c = Sr()
        return Uf(c, jn.memoizedState, a)
      },
      useTransition: function () {
        var a = Bc(Al)[0],
          c = Sr().memoizedState
        return [a, c]
      },
      useMutableSource: Ph,
      useSyncExternalStore: Ih,
      useId: io,
      unstable_isNewReconciler: !1,
    },
    eg = {
      readContext: _r,
      useCallback: Zm,
      useContext: _r,
      useEffect: Nh,
      useImperativeHandle: Fh,
      useInsertionEffect: kh,
      useLayoutEffect: $m,
      useMemo: Mr,
      useReducer: no,
      useRef: qm,
      useState: function () {
        return no(Al)
      },
      useDebugValue: Ff,
      useDeferredValue: function (a) {
        var c = Sr()
        return jn === null ? (c.memoizedState = a) : Uf(c, jn.memoizedState, a)
      },
      useTransition: function () {
        var a = no(Al)[0],
          c = Sr().memoizedState
        return [a, c]
      },
      useMutableSource: Ph,
      useSyncExternalStore: Ih,
      useId: io,
      unstable_isNewReconciler: !1,
    }
  function Gr(a, c) {
    if (a && a.defaultProps) {
      ;(c = Q({}, c)), (a = a.defaultProps)
      for (var g in a) c[g] === void 0 && (c[g] = a[g])
      return c
    }
    return c
  }
  function Gc(a, c, g, S) {
    ;(c = a.memoizedState),
      (g = g(S, c)),
      (g = g == null ? c : Q({}, c, g)),
      (a.memoizedState = g),
      a.lanes === 0 && (a.updateQueue.baseState = g)
  }
  var Hf = {
    isMounted: function (a) {
      return (a = a._reactInternals) ? xs(a) === a : !1
    },
    enqueueSetState: function (a, c, g) {
      a = a._reactInternals
      var S = Tr(),
        b = Il(a),
        L = _n(S, b)
      ;(L.payload = c),
        g != null && (L.callback = g),
        (c = Nn(a, L, b)),
        c !== null && (ao(c, a, b, S), Di(c, a, b))
    },
    enqueueReplaceState: function (a, c, g) {
      a = a._reactInternals
      var S = Tr(),
        b = Il(a),
        L = _n(S, b)
      ;(L.tag = 1),
        (L.payload = c),
        g != null && (L.callback = g),
        (c = Nn(a, L, b)),
        c !== null && (ao(c, a, b, S), Di(c, a, b))
    },
    enqueueForceUpdate: function (a, c) {
      a = a._reactInternals
      var g = Tr(),
        S = Il(a),
        b = _n(g, S)
      ;(b.tag = 2),
        c != null && (b.callback = c),
        (c = Nn(a, b, S)),
        c !== null && (ao(c, a, S, g), Di(c, a, S))
    },
  }
  function tg(a, c, g, S, b, L, H) {
    return (
      (a = a.stateNode),
      typeof a.shouldComponentUpdate == "function"
        ? a.shouldComponentUpdate(S, L, H)
        : c.prototype && c.prototype.isPureReactComponent
        ? !fa(g, S) || !fa(b, L)
        : !0
    )
  }
  function f(a, c, g) {
    var S = !1,
      b = qs,
      L = c.contextType
    return (
      typeof L == "object" && L !== null
        ? (L = _r(L))
        : ((b = Li(c) ? $s : _i.current),
          (S = c.contextTypes),
          (L = (S = S != null) ? va(a, b) : qs)),
      (c = new c(g, L)),
      (a.memoizedState = c.state !== null && c.state !== void 0 ? c.state : null),
      (c.updater = Hf),
      (a.stateNode = c),
      (c._reactInternals = a),
      S &&
        ((a = a.stateNode),
        (a.__reactInternalMemoizedUnmaskedChildContext = b),
        (a.__reactInternalMemoizedMaskedChildContext = L)),
      c
    )
  }
  function h(a, c, g, S) {
    ;(a = c.state),
      typeof c.componentWillReceiveProps == "function" &&
        c.componentWillReceiveProps(g, S),
      typeof c.UNSAFE_componentWillReceiveProps == "function" &&
        c.UNSAFE_componentWillReceiveProps(g, S),
      c.state !== a && Hf.enqueueReplaceState(c, c.state, null)
  }
  function _(a, c, g, S) {
    var b = a.stateNode
    ;(b.props = g), (b.state = a.memoizedState), (b.refs = {}), qt(a)
    var L = c.contextType
    typeof L == "object" && L !== null
      ? (b.context = _r(L))
      : ((L = Li(c) ? $s : _i.current), (b.context = va(a, L))),
      (b.state = a.memoizedState),
      (L = c.getDerivedStateFromProps),
      typeof L == "function" && (Gc(a, c, L, g), (b.state = a.memoizedState)),
      typeof c.getDerivedStateFromProps == "function" ||
        typeof b.getSnapshotBeforeUpdate == "function" ||
        (typeof b.UNSAFE_componentWillMount != "function" &&
          typeof b.componentWillMount != "function") ||
        ((c = b.state),
        typeof b.componentWillMount == "function" && b.componentWillMount(),
        typeof b.UNSAFE_componentWillMount == "function" &&
          b.UNSAFE_componentWillMount(),
        c !== b.state && Hf.enqueueReplaceState(b, b.state, null),
        Wn(a, g, b, S),
        (b.state = a.memoizedState)),
      typeof b.componentDidMount == "function" && (a.flags |= 4194308)
  }
  function T(a, c) {
    try {
      var g = "",
        S = c
      do (g += fe(S)), (S = S.return)
      while (S)
      var b = g
    } catch (L) {
      b =
        `
Error generating stack: ` +
        L.message +
        `
` +
        L.stack
    }
    return { value: a, source: c, stack: b, digest: null }
  }
  function P(a, c, g) {
    return { value: a, source: null, stack: g ?? null, digest: c ?? null }
  }
  function F(a, c) {
    try {
      console.error(c.value)
    } catch (g) {
      setTimeout(function () {
        throw g
      })
    }
  }
  var J = typeof WeakMap == "function" ? WeakMap : Map
  function pe(a, c, g) {
    ;(g = _n(-1, g)), (g.tag = 3), (g.payload = { element: null })
    var S = c.value
    return (
      (g.callback = function () {
        lg || ((lg = !0), (Uy = S)), F(a, c)
      }),
      g
    )
  }
  function ke(a, c, g) {
    ;(g = _n(-1, g)), (g.tag = 3)
    var S = a.type.getDerivedStateFromError
    if (typeof S == "function") {
      var b = c.value
      ;(g.payload = function () {
        return S(b)
      }),
        (g.callback = function () {
          F(a, c)
        })
    }
    var L = a.stateNode
    return (
      L !== null &&
        typeof L.componentDidCatch == "function" &&
        (g.callback = function () {
          F(a, c),
            typeof S != "function" &&
              (Rl === null ? (Rl = new Set([this])) : Rl.add(this))
          var H = c.stack
          this.componentDidCatch(c.value, { componentStack: H !== null ? H : "" })
        }),
      g
    )
  }
  function Ze(a, c, g) {
    var S = a.pingCache
    if (S === null) {
      S = a.pingCache = new J()
      var b = new Set()
      S.set(c, b)
    } else (b = S.get(c)), b === void 0 && ((b = new Set()), S.set(c, b))
    b.has(g) || (b.add(g), (a = aP.bind(null, a, c, g)), c.then(a, a))
  }
  function gt(a) {
    do {
      var c
      if (
        ((c = a.tag === 13) &&
          ((c = a.memoizedState), (c = c !== null ? c.dehydrated !== null : !0)),
        c)
      )
        return a
      a = a.return
    } while (a !== null)
    return null
  }
  function zt(a, c, g, S, b) {
    return (a.mode & 1) === 0
      ? (a === c
          ? (a.flags |= 65536)
          : ((a.flags |= 128),
            (g.flags |= 131072),
            (g.flags &= -52805),
            g.tag === 1 &&
              (g.alternate === null
                ? (g.tag = 17)
                : ((c = _n(-1, 1)), (c.tag = 2), Nn(g, c, 1))),
            (g.lanes |= 1)),
        a)
      : ((a.flags |= 65536), (a.lanes = b), a)
  }
  var It = R.ReactCurrentOwner,
    Kt = !1
  function ht(a, c, g, S) {
    c.child = a === null ? Lc(c, null, g, S) : wa(c, a.child, g, S)
  }
  function Ei(a, c, g, S, b) {
    g = g.render
    var L = c.ref
    return (
      Fo(c, b),
      (S = Oc(a, c, g, S, L, b)),
      (g = Rh()),
      a !== null && !Kt
        ? ((c.updateQueue = a.updateQueue),
          (c.flags &= -2053),
          (a.lanes &= ~b),
          Ia(a, c, b))
        : (Cn && g && Sh(c), (c.flags |= 1), ht(a, c, S, b), c.child)
    )
  }
  function Er(a, c, g, S, b) {
    if (a === null) {
      var L = g.type
      return typeof L == "function" &&
        !Wy(L) &&
        L.defaultProps === void 0 &&
        g.compare === null &&
        g.defaultProps === void 0
        ? ((c.tag = 15), (c.type = L), be(a, c, L, S, b))
        : ((a = pg(g.type, null, S, c, c.mode, b)),
          (a.ref = c.ref),
          (a.return = c),
          (c.child = a))
    }
    if (((L = a.child), (a.lanes & b) === 0)) {
      var H = L.memoizedProps
      if (((g = g.compare), (g = g !== null ? g : fa), g(H, S) && a.ref === c.ref))
        return Ia(a, c, b)
    }
    return (
      (c.flags |= 1), (a = Dl(L, S)), (a.ref = c.ref), (a.return = c), (c.child = a)
    )
  }
  function be(a, c, g, S, b) {
    if (a !== null) {
      var L = a.memoizedProps
      if (fa(L, S) && a.ref === c.ref)
        if (((Kt = !1), (c.pendingProps = S = L), (a.lanes & b) !== 0))
          (a.flags & 131072) !== 0 && (Kt = !0)
        else return (c.lanes = a.lanes), Ia(a, c, b)
    }
    return ct(a, c, g, S, b)
  }
  function ve(a, c, g) {
    var S = c.pendingProps,
      b = S.children,
      L = a !== null ? a.memoizedState : null
    if (S.mode === "hidden")
      if ((c.mode & 1) === 0)
        (c.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
          wn(Wf, ps),
          (ps |= g)
      else {
        if ((g & 1073741824) === 0)
          return (
            (a = L !== null ? L.baseLanes | g : g),
            (c.lanes = c.childLanes = 1073741824),
            (c.memoizedState = { baseLanes: a, cachePool: null, transitions: null }),
            (c.updateQueue = null),
            wn(Wf, ps),
            (ps |= a),
            null
          )
        ;(c.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }),
          (S = L !== null ? L.baseLanes : g),
          wn(Wf, ps),
          (ps |= S)
      }
    else
      L !== null ? ((S = L.baseLanes | g), (c.memoizedState = null)) : (S = g),
        wn(Wf, ps),
        (ps |= S)
    return ht(a, c, b, g), c.child
  }
  function Le(a, c) {
    var g = c.ref
    ;((a === null && g !== null) || (a !== null && a.ref !== g)) &&
      ((c.flags |= 512), (c.flags |= 2097152))
  }
  function ct(a, c, g, S, b) {
    var L = Li(g) ? $s : _i.current
    return (
      (L = va(c, L)),
      Fo(c, b),
      (g = Oc(a, c, g, S, L, b)),
      (S = Rh()),
      a !== null && !Kt
        ? ((c.updateQueue = a.updateQueue),
          (c.flags &= -2053),
          (a.lanes &= ~b),
          Ia(a, c, b))
        : (Cn && S && Sh(c), (c.flags |= 1), ht(a, c, g, b), c.child)
    )
  }
  function Ct(a, c, g, S, b) {
    if (Li(g)) {
      var L = !0
      ya(c)
    } else L = !1
    if ((Fo(c, b), c.stateNode === null)) ig(a, c), f(c, g, S), _(c, g, S, b), (S = !0)
    else if (a === null) {
      var H = c.stateNode,
        te = c.memoizedProps
      H.props = te
      var le = H.context,
        Re = g.contextType
      typeof Re == "object" && Re !== null
        ? (Re = _r(Re))
        : ((Re = Li(g) ? $s : _i.current), (Re = va(c, Re)))
      var Ye = g.getDerivedStateFromProps,
        $e = typeof Ye == "function" || typeof H.getSnapshotBeforeUpdate == "function"
      $e ||
        (typeof H.UNSAFE_componentWillReceiveProps != "function" &&
          typeof H.componentWillReceiveProps != "function") ||
        ((te !== S || le !== Re) && h(c, H, S, Re)),
        (xn = !1)
      var Xe = c.memoizedState
      ;(H.state = Xe),
        Wn(c, S, H, b),
        (le = c.memoizedState),
        te !== S || Xe !== le || Xi.current || xn
          ? (typeof Ye == "function" && (Gc(c, g, Ye, S), (le = c.memoizedState)),
            (te = xn || tg(c, g, te, S, Xe, le, Re))
              ? ($e ||
                  (typeof H.UNSAFE_componentWillMount != "function" &&
                    typeof H.componentWillMount != "function") ||
                  (typeof H.componentWillMount == "function" && H.componentWillMount(),
                  typeof H.UNSAFE_componentWillMount == "function" &&
                    H.UNSAFE_componentWillMount()),
                typeof H.componentDidMount == "function" && (c.flags |= 4194308))
              : (typeof H.componentDidMount == "function" && (c.flags |= 4194308),
                (c.memoizedProps = S),
                (c.memoizedState = le)),
            (H.props = S),
            (H.state = le),
            (H.context = Re),
            (S = te))
          : (typeof H.componentDidMount == "function" && (c.flags |= 4194308), (S = !1))
    } else {
      ;(H = c.stateNode),
        $n(a, c),
        (te = c.memoizedProps),
        (Re = c.type === c.elementType ? te : Gr(c.type, te)),
        (H.props = Re),
        ($e = c.pendingProps),
        (Xe = H.context),
        (le = g.contextType),
        typeof le == "object" && le !== null
          ? (le = _r(le))
          : ((le = Li(g) ? $s : _i.current), (le = va(c, le)))
      var pt = g.getDerivedStateFromProps
      ;(Ye =
        typeof pt == "function" || typeof H.getSnapshotBeforeUpdate == "function") ||
        (typeof H.UNSAFE_componentWillReceiveProps != "function" &&
          typeof H.componentWillReceiveProps != "function") ||
        ((te !== $e || Xe !== le) && h(c, H, S, le)),
        (xn = !1),
        (Xe = c.memoizedState),
        (H.state = Xe),
        Wn(c, S, H, b)
      var St = c.memoizedState
      te !== $e || Xe !== St || Xi.current || xn
        ? (typeof pt == "function" && (Gc(c, g, pt, S), (St = c.memoizedState)),
          (Re = xn || tg(c, g, Re, S, Xe, St, le) || !1)
            ? (Ye ||
                (typeof H.UNSAFE_componentWillUpdate != "function" &&
                  typeof H.componentWillUpdate != "function") ||
                (typeof H.componentWillUpdate == "function" &&
                  H.componentWillUpdate(S, St, le),
                typeof H.UNSAFE_componentWillUpdate == "function" &&
                  H.UNSAFE_componentWillUpdate(S, St, le)),
              typeof H.componentDidUpdate == "function" && (c.flags |= 4),
              typeof H.getSnapshotBeforeUpdate == "function" && (c.flags |= 1024))
            : (typeof H.componentDidUpdate != "function" ||
                (te === a.memoizedProps && Xe === a.memoizedState) ||
                (c.flags |= 4),
              typeof H.getSnapshotBeforeUpdate != "function" ||
                (te === a.memoizedProps && Xe === a.memoizedState) ||
                (c.flags |= 1024),
              (c.memoizedProps = S),
              (c.memoizedState = St)),
          (H.props = S),
          (H.state = St),
          (H.context = le),
          (S = Re))
        : (typeof H.componentDidUpdate != "function" ||
            (te === a.memoizedProps && Xe === a.memoizedState) ||
            (c.flags |= 4),
          typeof H.getSnapshotBeforeUpdate != "function" ||
            (te === a.memoizedProps && Xe === a.memoizedState) ||
            (c.flags |= 1024),
          (S = !1))
    }
    return jt(a, c, g, S, L, b)
  }
  function jt(a, c, g, S, b, L) {
    Le(a, c)
    var H = (c.flags & 128) !== 0
    if (!S && !H) return b && _h(c, g, !1), Ia(a, c, L)
    ;(S = c.stateNode), (It.current = c)
    var te = H && typeof g.getDerivedStateFromError != "function" ? null : S.render()
    return (
      (c.flags |= 1),
      a !== null && H
        ? ((c.child = wa(c, a.child, null, L)), (c.child = wa(c, null, te, L)))
        : ht(a, c, te, L),
      (c.memoizedState = S.state),
      b && _h(c, g, !0),
      c.child
    )
  }
  function Vt(a) {
    var c = a.stateNode
    c.pendingContext
      ? xh(a, c.pendingContext, c.pendingContext !== c.context)
      : c.context && xh(a, c.context, !1),
      Fc(a, c.containerInfo)
  }
  function un(a, c, g, S, b) {
    return ko(), Sl(b), (c.flags |= 256), ht(a, c, g, S), c.child
  }
  var ei = { dehydrated: null, treeContext: null, retryLane: 0 }
  function ln(a) {
    return { baseLanes: a, cachePool: null, transitions: null }
  }
  function ro(a, c, g) {
    var S = c.pendingProps,
      b = Rn.current,
      L = !1,
      H = (c.flags & 128) !== 0,
      te
    if (
      ((te = H) || (te = a !== null && a.memoizedState === null ? !1 : (b & 2) !== 0),
      te
        ? ((L = !0), (c.flags &= -129))
        : (a === null || a.memoizedState !== null) && (b |= 1),
      wn(Rn, b & 1),
      a === null)
    )
      return (
        Df(c),
        (a = c.memoizedState),
        a !== null && ((a = a.dehydrated), a !== null)
          ? ((c.mode & 1) === 0
              ? (c.lanes = 1)
              : a.data === "$!"
              ? (c.lanes = 8)
              : (c.lanes = 1073741824),
            null)
          : ((H = S.children),
            (a = S.fallback),
            L
              ? ((S = c.mode),
                (L = c.child),
                (H = { mode: "hidden", children: H }),
                (S & 1) === 0 && L !== null
                  ? ((L.childLanes = 0), (L.pendingProps = H))
                  : (L = mg(H, S, 0, null)),
                (a = qc(a, S, g, null)),
                (L.return = c),
                (a.return = c),
                (L.sibling = a),
                (c.child = L),
                (c.child.memoizedState = ln(g)),
                (c.memoizedState = ei),
                a)
              : Uh(c, H))
      )
    if (((b = a.memoizedState), b !== null && ((te = b.dehydrated), te !== null)))
      return $R(a, c, H, S, te, b, g)
    if (L) {
      ;(L = S.fallback), (H = c.mode), (b = a.child), (te = b.sibling)
      var le = { mode: "hidden", children: S.children }
      return (
        (H & 1) === 0 && c.child !== b
          ? ((S = c.child),
            (S.childLanes = 0),
            (S.pendingProps = le),
            (c.deletions = null))
          : ((S = Dl(b, le)), (S.subtreeFlags = b.subtreeFlags & 14680064)),
        te !== null ? (L = Dl(te, L)) : ((L = qc(L, H, g, null)), (L.flags |= 2)),
        (L.return = c),
        (S.return = c),
        (S.sibling = L),
        (c.child = S),
        (S = L),
        (L = c.child),
        (H = a.child.memoizedState),
        (H =
          H === null
            ? ln(g)
            : {
                baseLanes: H.baseLanes | g,
                cachePool: null,
                transitions: H.transitions,
              }),
        (L.memoizedState = H),
        (L.childLanes = a.childLanes & ~g),
        (c.memoizedState = ei),
        S
      )
    }
    return (
      (L = a.child),
      (a = L.sibling),
      (S = Dl(L, { mode: "visible", children: S.children })),
      (c.mode & 1) === 0 && (S.lanes = g),
      (S.return = c),
      (S.sibling = null),
      a !== null &&
        ((g = c.deletions),
        g === null ? ((c.deletions = [a]), (c.flags |= 16)) : g.push(a)),
      (c.child = S),
      (c.memoizedState = null),
      S
    )
  }
  function Uh(a, c) {
    return (
      (c = mg({ mode: "visible", children: c }, a.mode, 0, null)),
      (c.return = a),
      (a.child = c)
    )
  }
  function ng(a, c, g, S) {
    return (
      S !== null && Sl(S),
      wa(c, a.child, null, g),
      (a = Uh(c, c.pendingProps.children)),
      (a.flags |= 2),
      (c.memoizedState = null),
      a
    )
  }
  function $R(a, c, g, S, b, L, H) {
    if (g)
      return c.flags & 256
        ? ((c.flags &= -257), (S = P(Error(t(422)))), ng(a, c, H, S))
        : c.memoizedState !== null
        ? ((c.child = a.child), (c.flags |= 128), null)
        : ((L = S.fallback),
          (b = c.mode),
          (S = mg({ mode: "visible", children: S.children }, b, 0, null)),
          (L = qc(L, b, H, null)),
          (L.flags |= 2),
          (S.return = c),
          (L.return = c),
          (S.sibling = L),
          (c.child = S),
          (c.mode & 1) !== 0 && wa(c, a.child, null, H),
          (c.child.memoizedState = ln(H)),
          (c.memoizedState = ei),
          L)
    if ((c.mode & 1) === 0) return ng(a, c, H, null)
    if (b.data === "$!") {
      if (((S = b.nextSibling && b.nextSibling.dataset), S)) var te = S.dgst
      return (S = te), (L = Error(t(419))), (S = P(L, S, void 0)), ng(a, c, H, S)
    }
    if (((te = (H & a.childLanes) !== 0), Kt || te)) {
      if (((S = ki), S !== null)) {
        switch (H & -H) {
          case 4:
            b = 2
            break
          case 16:
            b = 8
            break
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            b = 32
            break
          case 536870912:
            b = 268435456
            break
          default:
            b = 0
        }
        ;(b = (b & (S.suspendedLanes | H)) !== 0 ? 0 : b),
          b !== 0 && b !== L.retryLane && ((L.retryLane = b), us(a, b), ao(S, a, b, -1))
      }
      return Gy(), (S = P(Error(t(421)))), ng(a, c, H, S)
    }
    return b.data === "$?"
      ? ((c.flags |= 128),
        (c.child = a.child),
        (c = lP.bind(null, a)),
        (b._reactRetry = c),
        null)
      : ((a = L.treeContext),
        (qi = Xs(b.nextSibling)),
        (wi = c),
        (Cn = !0),
        (Hr = null),
        a !== null &&
          ((Yi[mi++] = nt),
          (Yi[mi++] = Vr),
          (Yi[mi++] = _a),
          (nt = a.id),
          (Vr = a.overflow),
          (_a = c)),
        (c = Uh(c, S.children)),
        (c.flags |= 4096),
        c)
  }
  function xS(a, c, g) {
    a.lanes |= c
    var S = a.alternate
    S !== null && (S.lanes |= c), Nc(a.return, c, g)
  }
  function Cy(a, c, g, S, b) {
    var L = a.memoizedState
    L === null
      ? (a.memoizedState = {
          isBackwards: c,
          rendering: null,
          renderingStartTime: 0,
          last: S,
          tail: g,
          tailMode: b,
        })
      : ((L.isBackwards = c),
        (L.rendering = null),
        (L.renderingStartTime = 0),
        (L.last = S),
        (L.tail = g),
        (L.tailMode = b))
  }
  function _S(a, c, g) {
    var S = c.pendingProps,
      b = S.revealOrder,
      L = S.tail
    if ((ht(a, c, S.children, g), (S = Rn.current), (S & 2) !== 0))
      (S = (S & 1) | 2), (c.flags |= 128)
    else {
      if (a !== null && (a.flags & 128) !== 0)
        e: for (a = c.child; a !== null; ) {
          if (a.tag === 13) a.memoizedState !== null && xS(a, g, c)
          else if (a.tag === 19) xS(a, g, c)
          else if (a.child !== null) {
            ;(a.child.return = a), (a = a.child)
            continue
          }
          if (a === c) break e
          for (; a.sibling === null; ) {
            if (a.return === null || a.return === c) break e
            a = a.return
          }
          ;(a.sibling.return = a.return), (a = a.sibling)
        }
      S &= 1
    }
    if ((wn(Rn, S), (c.mode & 1) === 0)) c.memoizedState = null
    else
      switch (b) {
        case "forwards":
          for (g = c.child, b = null; g !== null; )
            (a = g.alternate), a !== null && fs(a) === null && (b = g), (g = g.sibling)
          ;(g = b),
            g === null
              ? ((b = c.child), (c.child = null))
              : ((b = g.sibling), (g.sibling = null)),
            Cy(c, !1, b, g, L)
          break
        case "backwards":
          for (g = null, b = c.child, c.child = null; b !== null; ) {
            if (((a = b.alternate), a !== null && fs(a) === null)) {
              c.child = b
              break
            }
            ;(a = b.sibling), (b.sibling = g), (g = b), (b = a)
          }
          Cy(c, !0, g, null, L)
          break
        case "together":
          Cy(c, !1, null, null, void 0)
          break
        default:
          c.memoizedState = null
      }
    return c.child
  }
  function ig(a, c) {
    ;(c.mode & 1) === 0 &&
      a !== null &&
      ((a.alternate = null), (c.alternate = null), (c.flags |= 2))
  }
  function Ia(a, c, g) {
    if (
      (a !== null && (c.dependencies = a.dependencies),
      (Wc |= c.lanes),
      (g & c.childLanes) === 0)
    )
      return null
    if (a !== null && c.child !== a.child) throw Error(t(153))
    if (c.child !== null) {
      for (
        a = c.child, g = Dl(a, a.pendingProps), c.child = g, g.return = c;
        a.sibling !== null;

      )
        (a = a.sibling), (g = g.sibling = Dl(a, a.pendingProps)), (g.return = c)
      g.sibling = null
    }
    return c.child
  }
  function KR(a, c, g) {
    switch (c.tag) {
      case 3:
        Vt(c), ko()
        break
      case 5:
        Aa(c)
        break
      case 1:
        Li(c.type) && ya(c)
        break
      case 4:
        Fc(c, c.stateNode.containerInfo)
        break
      case 10:
        var S = c.type._context,
          b = c.memoizedProps.value
        wn(Sa, S._currentValue), (S._currentValue = b)
        break
      case 13:
        if (((S = c.memoizedState), S !== null))
          return S.dehydrated !== null
            ? (wn(Rn, Rn.current & 1), (c.flags |= 128), null)
            : (g & c.child.childLanes) !== 0
            ? ro(a, c, g)
            : (wn(Rn, Rn.current & 1), (a = Ia(a, c, g)), a !== null ? a.sibling : null)
        wn(Rn, Rn.current & 1)
        break
      case 19:
        if (((S = (g & c.childLanes) !== 0), (a.flags & 128) !== 0)) {
          if (S) return _S(a, c, g)
          c.flags |= 128
        }
        if (
          ((b = c.memoizedState),
          b !== null && ((b.rendering = null), (b.tail = null), (b.lastEffect = null)),
          wn(Rn, Rn.current),
          S)
        )
          break
        return null
      case 22:
      case 23:
        return (c.lanes = 0), ve(a, c, g)
    }
    return Ia(a, c, g)
  }
  var wS, Ry, SS, MS
  ;(wS = function (a, c) {
    for (var g = c.child; g !== null; ) {
      if (g.tag === 5 || g.tag === 6) a.appendChild(g.stateNode)
      else if (g.tag !== 4 && g.child !== null) {
        ;(g.child.return = g), (g = g.child)
        continue
      }
      if (g === c) break
      for (; g.sibling === null; ) {
        if (g.return === null || g.return === c) return
        g = g.return
      }
      ;(g.sibling.return = g.return), (g = g.sibling)
    }
  }),
    (Ry = function () {}),
    (SS = function (a, c, g, S) {
      var b = a.memoizedProps
      if (b !== S) {
        ;(a = c.stateNode), Qn(wr.current)
        var L = null
        switch (g) {
          case "input":
            ;(b = K(a, b)), (S = K(a, S)), (L = [])
            break
          case "select":
            ;(b = Q({}, b, { value: void 0 })),
              (S = Q({}, S, { value: void 0 })),
              (L = [])
            break
          case "textarea":
            ;(b = B(a, b)), (S = B(a, S)), (L = [])
            break
          default:
            typeof b.onClick != "function" &&
              typeof S.onClick == "function" &&
              (a.onclick = Tc)
        }
        Wt(g, S)
        var H
        g = null
        for (Re in b)
          if (!S.hasOwnProperty(Re) && b.hasOwnProperty(Re) && b[Re] != null)
            if (Re === "style") {
              var te = b[Re]
              for (H in te) te.hasOwnProperty(H) && (g || (g = {}), (g[H] = ""))
            } else
              Re !== "dangerouslySetInnerHTML" &&
                Re !== "children" &&
                Re !== "suppressContentEditableWarning" &&
                Re !== "suppressHydrationWarning" &&
                Re !== "autoFocus" &&
                (r.hasOwnProperty(Re) ? L || (L = []) : (L = L || []).push(Re, null))
        for (Re in S) {
          var le = S[Re]
          if (
            ((te = b != null ? b[Re] : void 0),
            S.hasOwnProperty(Re) && le !== te && (le != null || te != null))
          )
            if (Re === "style")
              if (te) {
                for (H in te)
                  !te.hasOwnProperty(H) ||
                    (le && le.hasOwnProperty(H)) ||
                    (g || (g = {}), (g[H] = ""))
                for (H in le)
                  le.hasOwnProperty(H) &&
                    te[H] !== le[H] &&
                    (g || (g = {}), (g[H] = le[H]))
              } else g || (L || (L = []), L.push(Re, g)), (g = le)
            else
              Re === "dangerouslySetInnerHTML"
                ? ((le = le ? le.__html : void 0),
                  (te = te ? te.__html : void 0),
                  le != null && te !== le && (L = L || []).push(Re, le))
                : Re === "children"
                ? (typeof le != "string" && typeof le != "number") ||
                  (L = L || []).push(Re, "" + le)
                : Re !== "suppressContentEditableWarning" &&
                  Re !== "suppressHydrationWarning" &&
                  (r.hasOwnProperty(Re)
                    ? (le != null && Re === "onScroll" && Mn("scroll", a),
                      L || te === le || (L = []))
                    : (L = L || []).push(Re, le))
        }
        g && (L = L || []).push("style", g)
        var Re = L
        ;(c.updateQueue = Re) && (c.flags |= 4)
      }
    }),
    (MS = function (a, c, g, S) {
      g !== S && (c.flags |= 4)
    })
  function Oh(a, c) {
    if (!Cn)
      switch (a.tailMode) {
        case "hidden":
          c = a.tail
          for (var g = null; c !== null; )
            c.alternate !== null && (g = c), (c = c.sibling)
          g === null ? (a.tail = null) : (g.sibling = null)
          break
        case "collapsed":
          g = a.tail
          for (var S = null; g !== null; )
            g.alternate !== null && (S = g), (g = g.sibling)
          S === null
            ? c || a.tail === null
              ? (a.tail = null)
              : (a.tail.sibling = null)
            : (S.sibling = null)
      }
  }
  function ar(a) {
    var c = a.alternate !== null && a.alternate.child === a.child,
      g = 0,
      S = 0
    if (c)
      for (var b = a.child; b !== null; )
        (g |= b.lanes | b.childLanes),
          (S |= b.subtreeFlags & 14680064),
          (S |= b.flags & 14680064),
          (b.return = a),
          (b = b.sibling)
    else
      for (b = a.child; b !== null; )
        (g |= b.lanes | b.childLanes),
          (S |= b.subtreeFlags),
          (S |= b.flags),
          (b.return = a),
          (b = b.sibling)
    return (a.subtreeFlags |= S), (a.childLanes = g), c
  }
  function ZR(a, c, g) {
    var S = c.pendingProps
    switch ((Zs(c), c.tag)) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return ar(c), null
      case 1:
        return Li(c.type) && bc(), ar(c), null
      case 3:
        return (
          (S = c.stateNode),
          Uo(),
          En(Xi),
          En(_i),
          As(),
          S.pendingContext &&
            ((S.context = S.pendingContext), (S.pendingContext = null)),
          (a === null || a.child === null) &&
            (wl(c)
              ? (c.flags |= 4)
              : a === null ||
                (a.memoizedState.isDehydrated && (c.flags & 256) === 0) ||
                ((c.flags |= 1024), Hr !== null && (zy(Hr), (Hr = null)))),
          Ry(a, c),
          ar(c),
          null
        )
      case 5:
        Tl(c)
        var b = Qn(eo.current)
        if (((g = c.type), a !== null && c.stateNode != null))
          SS(a, c, g, S, b), a.ref !== c.ref && ((c.flags |= 512), (c.flags |= 2097152))
        else {
          if (!S) {
            if (c.stateNode === null) throw Error(t(166))
            return ar(c), null
          }
          if (((a = Qn(wr.current)), wl(c))) {
            ;(S = c.stateNode), (g = c.type)
            var L = c.memoizedProps
            switch (((S[oi] = c), (S[_l] = L), (a = (c.mode & 1) !== 0), g)) {
              case "dialog":
                Mn("cancel", S), Mn("close", S)
                break
              case "iframe":
              case "object":
              case "embed":
                Mn("load", S)
                break
              case "video":
              case "audio":
                for (b = 0; b < Do.length; b++) Mn(Do[b], S)
                break
              case "source":
                Mn("error", S)
                break
              case "img":
              case "image":
              case "link":
                Mn("error", S), Mn("load", S)
                break
              case "details":
                Mn("toggle", S)
                break
              case "input":
                Ke(S, L), Mn("invalid", S)
                break
              case "select":
                ;(S._wrapperState = { wasMultiple: !!L.multiple }), Mn("invalid", S)
                break
              case "textarea":
                ce(S, L), Mn("invalid", S)
            }
            Wt(g, L), (b = null)
            for (var H in L)
              if (L.hasOwnProperty(H)) {
                var te = L[H]
                H === "children"
                  ? typeof te == "string"
                    ? S.textContent !== te &&
                      (L.suppressHydrationWarning !== !0 && Ec(S.textContent, te, a),
                      (b = ["children", te]))
                    : typeof te == "number" &&
                      S.textContent !== "" + te &&
                      (L.suppressHydrationWarning !== !0 && Ec(S.textContent, te, a),
                      (b = ["children", "" + te]))
                  : r.hasOwnProperty(H) &&
                    te != null &&
                    H === "onScroll" &&
                    Mn("scroll", S)
              }
            switch (g) {
              case "input":
                Ue(S), Pe(S, L, !0)
                break
              case "textarea":
                Ue(S), De(S)
                break
              case "select":
              case "option":
                break
              default:
                typeof L.onClick == "function" && (S.onclick = Tc)
            }
            ;(S = b), (c.updateQueue = S), S !== null && (c.flags |= 4)
          } else {
            ;(H = b.nodeType === 9 ? b : b.ownerDocument),
              a === "http://www.w3.org/1999/xhtml" && (a = Ie(g)),
              a === "http://www.w3.org/1999/xhtml"
                ? g === "script"
                  ? ((a = H.createElement("div")),
                    (a.innerHTML = "<script></script>"),
                    (a = a.removeChild(a.firstChild)))
                  : typeof S.is == "string"
                  ? (a = H.createElement(g, { is: S.is }))
                  : ((a = H.createElement(g)),
                    g === "select" &&
                      ((H = a),
                      S.multiple ? (H.multiple = !0) : S.size && (H.size = S.size)))
                : (a = H.createElementNS(a, g)),
              (a[oi] = c),
              (a[_l] = S),
              wS(a, c, !1, !1),
              (c.stateNode = a)
            e: {
              switch (((H = Nt(g, S)), g)) {
                case "dialog":
                  Mn("cancel", a), Mn("close", a), (b = S)
                  break
                case "iframe":
                case "object":
                case "embed":
                  Mn("load", a), (b = S)
                  break
                case "video":
                case "audio":
                  for (b = 0; b < Do.length; b++) Mn(Do[b], a)
                  b = S
                  break
                case "source":
                  Mn("error", a), (b = S)
                  break
                case "img":
                case "image":
                case "link":
                  Mn("error", a), Mn("load", a), (b = S)
                  break
                case "details":
                  Mn("toggle", a), (b = S)
                  break
                case "input":
                  Ke(a, S), (b = K(a, S)), Mn("invalid", a)
                  break
                case "option":
                  b = S
                  break
                case "select":
                  ;(a._wrapperState = { wasMultiple: !!S.multiple }),
                    (b = Q({}, S, { value: void 0 })),
                    Mn("invalid", a)
                  break
                case "textarea":
                  ce(a, S), (b = B(a, S)), Mn("invalid", a)
                  break
                default:
                  b = S
              }
              Wt(g, b), (te = b)
              for (L in te)
                if (te.hasOwnProperty(L)) {
                  var le = te[L]
                  L === "style"
                    ? Pt(a, le)
                    : L === "dangerouslySetInnerHTML"
                    ? ((le = le ? le.__html : void 0), le != null && it(a, le))
                    : L === "children"
                    ? typeof le == "string"
                      ? (g !== "textarea" || le !== "") && Et(a, le)
                      : typeof le == "number" && Et(a, "" + le)
                    : L !== "suppressContentEditableWarning" &&
                      L !== "suppressHydrationWarning" &&
                      L !== "autoFocus" &&
                      (r.hasOwnProperty(L)
                        ? le != null && L === "onScroll" && Mn("scroll", a)
                        : le != null && C(a, L, le, H))
                }
              switch (g) {
                case "input":
                  Ue(a), Pe(a, S, !1)
                  break
                case "textarea":
                  Ue(a), De(a)
                  break
                case "option":
                  S.value != null && a.setAttribute("value", "" + Fe(S.value))
                  break
                case "select":
                  ;(a.multiple = !!S.multiple),
                    (L = S.value),
                    L != null
                      ? j(a, !!S.multiple, L, !1)
                      : S.defaultValue != null && j(a, !!S.multiple, S.defaultValue, !0)
                  break
                default:
                  typeof b.onClick == "function" && (a.onclick = Tc)
              }
              switch (g) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  S = !!S.autoFocus
                  break e
                case "img":
                  S = !0
                  break e
                default:
                  S = !1
              }
            }
            S && (c.flags |= 4)
          }
          c.ref !== null && ((c.flags |= 512), (c.flags |= 2097152))
        }
        return ar(c), null
      case 6:
        if (a && c.stateNode != null) MS(a, c, a.memoizedProps, S)
        else {
          if (typeof S != "string" && c.stateNode === null) throw Error(t(166))
          if (((g = Qn(eo.current)), Qn(wr.current), wl(c))) {
            if (
              ((S = c.stateNode),
              (g = c.memoizedProps),
              (S[oi] = c),
              (L = S.nodeValue !== g) && ((a = wi), a !== null))
            )
              switch (a.tag) {
                case 3:
                  Ec(S.nodeValue, g, (a.mode & 1) !== 0)
                  break
                case 5:
                  a.memoizedProps.suppressHydrationWarning !== !0 &&
                    Ec(S.nodeValue, g, (a.mode & 1) !== 0)
              }
            L && (c.flags |= 4)
          } else
            (S = (g.nodeType === 9 ? g : g.ownerDocument).createTextNode(S)),
              (S[oi] = c),
              (c.stateNode = S)
        }
        return ar(c), null
      case 13:
        if (
          (En(Rn),
          (S = c.memoizedState),
          a === null ||
            (a.memoizedState !== null && a.memoizedState.dehydrated !== null))
        ) {
          if (Cn && qi !== null && (c.mode & 1) !== 0 && (c.flags & 128) === 0)
            Th(), ko(), (c.flags |= 98560), (L = !1)
          else if (((L = wl(c)), S !== null && S.dehydrated !== null)) {
            if (a === null) {
              if (!L) throw Error(t(318))
              if (((L = c.memoizedState), (L = L !== null ? L.dehydrated : null), !L))
                throw Error(t(317))
              L[oi] = c
            } else
              ko(), (c.flags & 128) === 0 && (c.memoizedState = null), (c.flags |= 4)
            ar(c), (L = !1)
          } else Hr !== null && (zy(Hr), (Hr = null)), (L = !0)
          if (!L) return c.flags & 65536 ? c : null
        }
        return (c.flags & 128) !== 0
          ? ((c.lanes = g), c)
          : ((S = S !== null),
            S !== (a !== null && a.memoizedState !== null) &&
              S &&
              ((c.child.flags |= 8192),
              (c.mode & 1) !== 0 &&
                (a === null || (Rn.current & 1) !== 0 ? Ti === 0 && (Ti = 3) : Gy())),
            c.updateQueue !== null && (c.flags |= 4),
            ar(c),
            null)
      case 4:
        return Uo(), Ry(a, c), a === null && vl(c.stateNode.containerInfo), ar(c), null
      case 10:
        return Dc(c.type._context), ar(c), null
      case 17:
        return Li(c.type) && bc(), ar(c), null
      case 19:
        if ((En(Rn), (L = c.memoizedState), L === null)) return ar(c), null
        if (((S = (c.flags & 128) !== 0), (H = L.rendering), H === null))
          if (S) Oh(L, !1)
          else {
            if (Ti !== 0 || (a !== null && (a.flags & 128) !== 0))
              for (a = c.child; a !== null; ) {
                if (((H = fs(a)), H !== null)) {
                  for (
                    c.flags |= 128,
                      Oh(L, !1),
                      S = H.updateQueue,
                      S !== null && ((c.updateQueue = S), (c.flags |= 4)),
                      c.subtreeFlags = 0,
                      S = g,
                      g = c.child;
                    g !== null;

                  )
                    (L = g),
                      (a = S),
                      (L.flags &= 14680066),
                      (H = L.alternate),
                      H === null
                        ? ((L.childLanes = 0),
                          (L.lanes = a),
                          (L.child = null),
                          (L.subtreeFlags = 0),
                          (L.memoizedProps = null),
                          (L.memoizedState = null),
                          (L.updateQueue = null),
                          (L.dependencies = null),
                          (L.stateNode = null))
                        : ((L.childLanes = H.childLanes),
                          (L.lanes = H.lanes),
                          (L.child = H.child),
                          (L.subtreeFlags = 0),
                          (L.deletions = null),
                          (L.memoizedProps = H.memoizedProps),
                          (L.memoizedState = H.memoizedState),
                          (L.updateQueue = H.updateQueue),
                          (L.type = H.type),
                          (a = H.dependencies),
                          (L.dependencies =
                            a === null
                              ? null
                              : { lanes: a.lanes, firstContext: a.firstContext })),
                      (g = g.sibling)
                  return wn(Rn, (Rn.current & 1) | 2), c.child
                }
                a = a.sibling
              }
            L.tail !== null &&
              qe() > jf &&
              ((c.flags |= 128), (S = !0), Oh(L, !1), (c.lanes = 4194304))
          }
        else {
          if (!S)
            if (((a = fs(H)), a !== null)) {
              if (
                ((c.flags |= 128),
                (S = !0),
                (g = a.updateQueue),
                g !== null && ((c.updateQueue = g), (c.flags |= 4)),
                Oh(L, !0),
                L.tail === null && L.tailMode === "hidden" && !H.alternate && !Cn)
              )
                return ar(c), null
            } else
              2 * qe() - L.renderingStartTime > jf &&
                g !== 1073741824 &&
                ((c.flags |= 128), (S = !0), Oh(L, !1), (c.lanes = 4194304))
          L.isBackwards
            ? ((H.sibling = c.child), (c.child = H))
            : ((g = L.last), g !== null ? (g.sibling = H) : (c.child = H), (L.last = H))
        }
        return L.tail !== null
          ? ((c = L.tail),
            (L.rendering = c),
            (L.tail = c.sibling),
            (L.renderingStartTime = qe()),
            (c.sibling = null),
            (g = Rn.current),
            wn(Rn, S ? (g & 1) | 2 : g & 1),
            c)
          : (ar(c), null)
      case 22:
      case 23:
        return (
          Hy(),
          (S = c.memoizedState !== null),
          a !== null && (a.memoizedState !== null) !== S && (c.flags |= 8192),
          S && (c.mode & 1) !== 0
            ? (ps & 1073741824) !== 0 &&
              (ar(c), c.subtreeFlags & 6 && (c.flags |= 8192))
            : ar(c),
          null
        )
      case 24:
        return null
      case 25:
        return null
    }
    throw Error(t(156, c.tag))
  }
  function JR(a, c) {
    switch ((Zs(c), c.tag)) {
      case 1:
        return (
          Li(c.type) && bc(),
          (a = c.flags),
          a & 65536 ? ((c.flags = (a & -65537) | 128), c) : null
        )
      case 3:
        return (
          Uo(),
          En(Xi),
          En(_i),
          As(),
          (a = c.flags),
          (a & 65536) !== 0 && (a & 128) === 0
            ? ((c.flags = (a & -65537) | 128), c)
            : null
        )
      case 5:
        return Tl(c), null
      case 13:
        if ((En(Rn), (a = c.memoizedState), a !== null && a.dehydrated !== null)) {
          if (c.alternate === null) throw Error(t(340))
          ko()
        }
        return (a = c.flags), a & 65536 ? ((c.flags = (a & -65537) | 128), c) : null
      case 19:
        return En(Rn), null
      case 4:
        return Uo(), null
      case 10:
        return Dc(c.type._context), null
      case 22:
      case 23:
        return Hy(), null
      case 24:
        return null
      default:
        return null
    }
  }
  var rg = !1,
    lr = !1,
    QR = typeof WeakSet == "function" ? WeakSet : Set,
    _t = null
  function Gf(a, c) {
    var g = a.ref
    if (g !== null)
      if (typeof g == "function")
        try {
          g(null)
        } catch (S) {
          ti(a, c, S)
        }
      else g.current = null
  }
  function Py(a, c, g) {
    try {
      g()
    } catch (S) {
      ti(a, c, S)
    }
  }
  var ES = !1
  function eP(a, c) {
    if (((xl = kr), (a = On()), fi(a))) {
      if ("selectionStart" in a)
        var g = { start: a.selectionStart, end: a.selectionEnd }
      else
        e: {
          g = ((g = a.ownerDocument) && g.defaultView) || window
          var S = g.getSelection && g.getSelection()
          if (S && S.rangeCount !== 0) {
            g = S.anchorNode
            var b = S.anchorOffset,
              L = S.focusNode
            S = S.focusOffset
            try {
              g.nodeType, L.nodeType
            } catch {
              g = null
              break e
            }
            var H = 0,
              te = -1,
              le = -1,
              Re = 0,
              Ye = 0,
              $e = a,
              Xe = null
            t: for (;;) {
              for (
                var pt;
                $e !== g || (b !== 0 && $e.nodeType !== 3) || (te = H + b),
                  $e !== L || (S !== 0 && $e.nodeType !== 3) || (le = H + S),
                  $e.nodeType === 3 && (H += $e.nodeValue.length),
                  (pt = $e.firstChild) !== null;

              )
                (Xe = $e), ($e = pt)
              for (;;) {
                if ($e === a) break t
                if (
                  (Xe === g && ++Re === b && (te = H),
                  Xe === L && ++Ye === S && (le = H),
                  (pt = $e.nextSibling) !== null)
                )
                  break
                ;($e = Xe), (Xe = $e.parentNode)
              }
              $e = pt
            }
            g = te === -1 || le === -1 ? null : { start: te, end: le }
          } else g = null
        }
      g = g || { start: 0, end: 0 }
    } else g = null
    for (hh = { focusedElem: a, selectionRange: g }, kr = !1, _t = c; _t !== null; )
      if (((c = _t), (a = c.child), (c.subtreeFlags & 1028) !== 0 && a !== null))
        (a.return = c), (_t = a)
      else
        for (; _t !== null; ) {
          c = _t
          try {
            var St = c.alternate
            if ((c.flags & 1024) !== 0)
              switch (c.tag) {
                case 0:
                case 11:
                case 15:
                  break
                case 1:
                  if (St !== null) {
                    var bt = St.memoizedProps,
                      ai = St.memoizedState,
                      _e = c.stateNode,
                      de = _e.getSnapshotBeforeUpdate(
                        c.elementType === c.type ? bt : Gr(c.type, bt),
                        ai,
                      )
                    _e.__reactInternalSnapshotBeforeUpdate = de
                  }
                  break
                case 3:
                  var Te = c.stateNode.containerInfo
                  Te.nodeType === 1
                    ? (Te.textContent = "")
                    : Te.nodeType === 9 &&
                      Te.documentElement &&
                      Te.removeChild(Te.documentElement)
                  break
                case 5:
                case 6:
                case 4:
                case 17:
                  break
                default:
                  throw Error(t(163))
              }
          } catch (et) {
            ti(c, c.return, et)
          }
          if (((a = c.sibling), a !== null)) {
            ;(a.return = c.return), (_t = a)
            break
          }
          _t = c.return
        }
    return (St = ES), (ES = !1), St
  }
  function Bh(a, c, g) {
    var S = c.updateQueue
    if (((S = S !== null ? S.lastEffect : null), S !== null)) {
      var b = (S = S.next)
      do {
        if ((b.tag & a) === a) {
          var L = b.destroy
          ;(b.destroy = void 0), L !== void 0 && Py(c, g, L)
        }
        b = b.next
      } while (b !== S)
    }
  }
  function sg(a, c) {
    if (((c = c.updateQueue), (c = c !== null ? c.lastEffect : null), c !== null)) {
      var g = (c = c.next)
      do {
        if ((g.tag & a) === a) {
          var S = g.create
          g.destroy = S()
        }
        g = g.next
      } while (g !== c)
    }
  }
  function Iy(a) {
    var c = a.ref
    if (c !== null) {
      var g = a.stateNode
      switch (a.tag) {
        case 5:
          a = g
          break
        default:
          a = g
      }
      typeof c == "function" ? c(a) : (c.current = a)
    }
  }
  function TS(a) {
    var c = a.alternate
    c !== null && ((a.alternate = null), TS(c)),
      (a.child = null),
      (a.deletions = null),
      (a.sibling = null),
      a.tag === 5 &&
        ((c = a.stateNode),
        c !== null &&
          (delete c[oi], delete c[_l], delete c[ga], delete c[bf], delete c[Af])),
      (a.stateNode = null),
      (a.return = null),
      (a.dependencies = null),
      (a.memoizedProps = null),
      (a.memoizedState = null),
      (a.pendingProps = null),
      (a.stateNode = null),
      (a.updateQueue = null)
  }
  function bS(a) {
    return a.tag === 5 || a.tag === 3 || a.tag === 4
  }
  function AS(a) {
    e: for (;;) {
      for (; a.sibling === null; ) {
        if (a.return === null || bS(a.return)) return null
        a = a.return
      }
      for (
        a.sibling.return = a.return, a = a.sibling;
        a.tag !== 5 && a.tag !== 6 && a.tag !== 18;

      ) {
        if (a.flags & 2 || a.child === null || a.tag === 4) continue e
        ;(a.child.return = a), (a = a.child)
      }
      if (!(a.flags & 2)) return a.stateNode
    }
  }
  function Ly(a, c, g) {
    var S = a.tag
    if (S === 5 || S === 6)
      (a = a.stateNode),
        c
          ? g.nodeType === 8
            ? g.parentNode.insertBefore(a, c)
            : g.insertBefore(a, c)
          : (g.nodeType === 8
              ? ((c = g.parentNode), c.insertBefore(a, g))
              : ((c = g), c.appendChild(a)),
            (g = g._reactRootContainer),
            g != null || c.onclick !== null || (c.onclick = Tc))
    else if (S !== 4 && ((a = a.child), a !== null))
      for (Ly(a, c, g), a = a.sibling; a !== null; ) Ly(a, c, g), (a = a.sibling)
  }
  function Dy(a, c, g) {
    var S = a.tag
    if (S === 5 || S === 6)
      (a = a.stateNode), c ? g.insertBefore(a, c) : g.appendChild(a)
    else if (S !== 4 && ((a = a.child), a !== null))
      for (Dy(a, c, g), a = a.sibling; a !== null; ) Dy(a, c, g), (a = a.sibling)
  }
  var Ki = null,
    so = !1
  function Cl(a, c, g) {
    for (g = g.child; g !== null; ) CS(a, c, g), (g = g.sibling)
  }
  function CS(a, c, g) {
    if (Tt && typeof Tt.onCommitFiberUnmount == "function")
      try {
        Tt.onCommitFiberUnmount(en, g)
      } catch {}
    switch (g.tag) {
      case 5:
        lr || Gf(g, c)
      case 6:
        var S = Ki,
          b = so
        ;(Ki = null),
          Cl(a, c, g),
          (Ki = S),
          (so = b),
          Ki !== null &&
            (so
              ? ((a = Ki),
                (g = g.stateNode),
                a.nodeType === 8 ? a.parentNode.removeChild(g) : a.removeChild(g))
              : Ki.removeChild(g.stateNode))
        break
      case 18:
        Ki !== null &&
          (so
            ? ((a = Ki),
              (g = g.stateNode),
              a.nodeType === 8 ? Tf(a.parentNode, g) : a.nodeType === 1 && Tf(a, g),
              hc(a))
            : Tf(Ki, g.stateNode))
        break
      case 4:
        ;(S = Ki),
          (b = so),
          (Ki = g.stateNode.containerInfo),
          (so = !0),
          Cl(a, c, g),
          (Ki = S),
          (so = b)
        break
      case 0:
      case 11:
      case 14:
      case 15:
        if (
          !lr &&
          ((S = g.updateQueue), S !== null && ((S = S.lastEffect), S !== null))
        ) {
          b = S = S.next
          do {
            var L = b,
              H = L.destroy
            ;(L = L.tag),
              H !== void 0 && ((L & 2) !== 0 || (L & 4) !== 0) && Py(g, c, H),
              (b = b.next)
          } while (b !== S)
        }
        Cl(a, c, g)
        break
      case 1:
        if (
          !lr &&
          (Gf(g, c), (S = g.stateNode), typeof S.componentWillUnmount == "function")
        )
          try {
            ;(S.props = g.memoizedProps),
              (S.state = g.memoizedState),
              S.componentWillUnmount()
          } catch (te) {
            ti(g, c, te)
          }
        Cl(a, c, g)
        break
      case 21:
        Cl(a, c, g)
        break
      case 22:
        g.mode & 1
          ? ((lr = (S = lr) || g.memoizedState !== null), Cl(a, c, g), (lr = S))
          : Cl(a, c, g)
        break
      default:
        Cl(a, c, g)
    }
  }
  function RS(a) {
    var c = a.updateQueue
    if (c !== null) {
      a.updateQueue = null
      var g = a.stateNode
      g === null && (g = a.stateNode = new QR()),
        c.forEach(function (S) {
          var b = cP.bind(null, a, S)
          g.has(S) || (g.add(S), S.then(b, b))
        })
    }
  }
  function oo(a, c) {
    var g = c.deletions
    if (g !== null)
      for (var S = 0; S < g.length; S++) {
        var b = g[S]
        try {
          var L = a,
            H = c,
            te = H
          e: for (; te !== null; ) {
            switch (te.tag) {
              case 5:
                ;(Ki = te.stateNode), (so = !1)
                break e
              case 3:
                ;(Ki = te.stateNode.containerInfo), (so = !0)
                break e
              case 4:
                ;(Ki = te.stateNode.containerInfo), (so = !0)
                break e
            }
            te = te.return
          }
          if (Ki === null) throw Error(t(160))
          CS(L, H, b), (Ki = null), (so = !1)
          var le = b.alternate
          le !== null && (le.return = null), (b.return = null)
        } catch (Re) {
          ti(b, c, Re)
        }
      }
    if (c.subtreeFlags & 12854)
      for (c = c.child; c !== null; ) PS(c, a), (c = c.sibling)
  }
  function PS(a, c) {
    var g = a.alternate,
      S = a.flags
    switch (a.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if ((oo(c, a), Bo(a), S & 4)) {
          try {
            Bh(3, a, a.return), sg(3, a)
          } catch (bt) {
            ti(a, a.return, bt)
          }
          try {
            Bh(5, a, a.return)
          } catch (bt) {
            ti(a, a.return, bt)
          }
        }
        break
      case 1:
        oo(c, a), Bo(a), S & 512 && g !== null && Gf(g, g.return)
        break
      case 5:
        if ((oo(c, a), Bo(a), S & 512 && g !== null && Gf(g, g.return), a.flags & 32)) {
          var b = a.stateNode
          try {
            Et(b, "")
          } catch (bt) {
            ti(a, a.return, bt)
          }
        }
        if (S & 4 && ((b = a.stateNode), b != null)) {
          var L = a.memoizedProps,
            H = g !== null ? g.memoizedProps : L,
            te = a.type,
            le = a.updateQueue
          if (((a.updateQueue = null), le !== null))
            try {
              te === "input" && L.type === "radio" && L.name != null && Be(b, L),
                Nt(te, H)
              var Re = Nt(te, L)
              for (H = 0; H < le.length; H += 2) {
                var Ye = le[H],
                  $e = le[H + 1]
                Ye === "style"
                  ? Pt(b, $e)
                  : Ye === "dangerouslySetInnerHTML"
                  ? it(b, $e)
                  : Ye === "children"
                  ? Et(b, $e)
                  : C(b, Ye, $e, Re)
              }
              switch (te) {
                case "input":
                  Oe(b, L)
                  break
                case "textarea":
                  Me(b, L)
                  break
                case "select":
                  var Xe = b._wrapperState.wasMultiple
                  b._wrapperState.wasMultiple = !!L.multiple
                  var pt = L.value
                  pt != null
                    ? j(b, !!L.multiple, pt, !1)
                    : Xe !== !!L.multiple &&
                      (L.defaultValue != null
                        ? j(b, !!L.multiple, L.defaultValue, !0)
                        : j(b, !!L.multiple, L.multiple ? [] : "", !1))
              }
              b[_l] = L
            } catch (bt) {
              ti(a, a.return, bt)
            }
        }
        break
      case 6:
        if ((oo(c, a), Bo(a), S & 4)) {
          if (a.stateNode === null) throw Error(t(162))
          ;(b = a.stateNode), (L = a.memoizedProps)
          try {
            b.nodeValue = L
          } catch (bt) {
            ti(a, a.return, bt)
          }
        }
        break
      case 3:
        if ((oo(c, a), Bo(a), S & 4 && g !== null && g.memoizedState.isDehydrated))
          try {
            hc(c.containerInfo)
          } catch (bt) {
            ti(a, a.return, bt)
          }
        break
      case 4:
        oo(c, a), Bo(a)
        break
      case 13:
        oo(c, a),
          Bo(a),
          (b = a.child),
          b.flags & 8192 &&
            ((L = b.memoizedState !== null),
            (b.stateNode.isHidden = L),
            !L ||
              (b.alternate !== null && b.alternate.memoizedState !== null) ||
              (Fy = qe())),
          S & 4 && RS(a)
        break
      case 22:
        if (
          ((Ye = g !== null && g.memoizedState !== null),
          a.mode & 1 ? ((lr = (Re = lr) || Ye), oo(c, a), (lr = Re)) : oo(c, a),
          Bo(a),
          S & 8192)
        ) {
          if (
            ((Re = a.memoizedState !== null),
            (a.stateNode.isHidden = Re) && !Ye && (a.mode & 1) !== 0)
          )
            for (_t = a, Ye = a.child; Ye !== null; ) {
              for ($e = _t = Ye; _t !== null; ) {
                switch (((Xe = _t), (pt = Xe.child), Xe.tag)) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    Bh(4, Xe, Xe.return)
                    break
                  case 1:
                    Gf(Xe, Xe.return)
                    var St = Xe.stateNode
                    if (typeof St.componentWillUnmount == "function") {
                      ;(S = Xe), (g = Xe.return)
                      try {
                        ;(c = S),
                          (St.props = c.memoizedProps),
                          (St.state = c.memoizedState),
                          St.componentWillUnmount()
                      } catch (bt) {
                        ti(S, g, bt)
                      }
                    }
                    break
                  case 5:
                    Gf(Xe, Xe.return)
                    break
                  case 22:
                    if (Xe.memoizedState !== null) {
                      DS($e)
                      continue
                    }
                }
                pt !== null ? ((pt.return = Xe), (_t = pt)) : DS($e)
              }
              Ye = Ye.sibling
            }
          e: for (Ye = null, $e = a; ; ) {
            if ($e.tag === 5) {
              if (Ye === null) {
                Ye = $e
                try {
                  ;(b = $e.stateNode),
                    Re
                      ? ((L = b.style),
                        typeof L.setProperty == "function"
                          ? L.setProperty("display", "none", "important")
                          : (L.display = "none"))
                      : ((te = $e.stateNode),
                        (le = $e.memoizedProps.style),
                        (H =
                          le != null && le.hasOwnProperty("display")
                            ? le.display
                            : null),
                        (te.style.display = At("display", H)))
                } catch (bt) {
                  ti(a, a.return, bt)
                }
              }
            } else if ($e.tag === 6) {
              if (Ye === null)
                try {
                  $e.stateNode.nodeValue = Re ? "" : $e.memoizedProps
                } catch (bt) {
                  ti(a, a.return, bt)
                }
            } else if (
              (($e.tag !== 22 && $e.tag !== 23) ||
                $e.memoizedState === null ||
                $e === a) &&
              $e.child !== null
            ) {
              ;($e.child.return = $e), ($e = $e.child)
              continue
            }
            if ($e === a) break e
            for (; $e.sibling === null; ) {
              if ($e.return === null || $e.return === a) break e
              Ye === $e && (Ye = null), ($e = $e.return)
            }
            Ye === $e && (Ye = null), ($e.sibling.return = $e.return), ($e = $e.sibling)
          }
        }
        break
      case 19:
        oo(c, a), Bo(a), S & 4 && RS(a)
        break
      case 21:
        break
      default:
        oo(c, a), Bo(a)
    }
  }
  function Bo(a) {
    var c = a.flags
    if (c & 2) {
      try {
        e: {
          for (var g = a.return; g !== null; ) {
            if (bS(g)) {
              var S = g
              break e
            }
            g = g.return
          }
          throw Error(t(160))
        }
        switch (S.tag) {
          case 5:
            var b = S.stateNode
            S.flags & 32 && (Et(b, ""), (S.flags &= -33))
            var L = AS(a)
            Dy(a, L, b)
            break
          case 3:
          case 4:
            var H = S.stateNode.containerInfo,
              te = AS(a)
            Ly(a, te, H)
            break
          default:
            throw Error(t(161))
        }
      } catch (le) {
        ti(a, a.return, le)
      }
      a.flags &= -3
    }
    c & 4096 && (a.flags &= -4097)
  }
  function tP(a, c, g) {
    ;(_t = a), IS(a)
  }
  function IS(a, c, g) {
    for (var S = (a.mode & 1) !== 0; _t !== null; ) {
      var b = _t,
        L = b.child
      if (b.tag === 22 && S) {
        var H = b.memoizedState !== null || rg
        if (!H) {
          var te = b.alternate,
            le = (te !== null && te.memoizedState !== null) || lr
          te = rg
          var Re = lr
          if (((rg = H), (lr = le) && !Re))
            for (_t = b; _t !== null; )
              (H = _t),
                (le = H.child),
                H.tag === 22 && H.memoizedState !== null
                  ? NS(b)
                  : le !== null
                  ? ((le.return = H), (_t = le))
                  : NS(b)
          for (; L !== null; ) (_t = L), IS(L), (L = L.sibling)
          ;(_t = b), (rg = te), (lr = Re)
        }
        LS(a)
      } else
        (b.subtreeFlags & 8772) !== 0 && L !== null ? ((L.return = b), (_t = L)) : LS(a)
    }
  }
  function LS(a) {
    for (; _t !== null; ) {
      var c = _t
      if ((c.flags & 8772) !== 0) {
        var g = c.alternate
        try {
          if ((c.flags & 8772) !== 0)
            switch (c.tag) {
              case 0:
              case 11:
              case 15:
                lr || sg(5, c)
                break
              case 1:
                var S = c.stateNode
                if (c.flags & 4 && !lr)
                  if (g === null) S.componentDidMount()
                  else {
                    var b =
                      c.elementType === c.type
                        ? g.memoizedProps
                        : Gr(c.type, g.memoizedProps)
                    S.componentDidUpdate(
                      b,
                      g.memoizedState,
                      S.__reactInternalSnapshotBeforeUpdate,
                    )
                  }
                var L = c.updateQueue
                L !== null && El(c, L, S)
                break
              case 3:
                var H = c.updateQueue
                if (H !== null) {
                  if (((g = null), c.child !== null))
                    switch (c.child.tag) {
                      case 5:
                        g = c.child.stateNode
                        break
                      case 1:
                        g = c.child.stateNode
                    }
                  El(c, H, g)
                }
                break
              case 5:
                var te = c.stateNode
                if (g === null && c.flags & 4) {
                  g = te
                  var le = c.memoizedProps
                  switch (c.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      le.autoFocus && g.focus()
                      break
                    case "img":
                      le.src && (g.src = le.src)
                  }
                }
                break
              case 6:
                break
              case 4:
                break
              case 12:
                break
              case 13:
                if (c.memoizedState === null) {
                  var Re = c.alternate
                  if (Re !== null) {
                    var Ye = Re.memoizedState
                    if (Ye !== null) {
                      var $e = Ye.dehydrated
                      $e !== null && hc($e)
                    }
                  }
                }
                break
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break
              default:
                throw Error(t(163))
            }
          lr || (c.flags & 512 && Iy(c))
        } catch (Xe) {
          ti(c, c.return, Xe)
        }
      }
      if (c === a) {
        _t = null
        break
      }
      if (((g = c.sibling), g !== null)) {
        ;(g.return = c.return), (_t = g)
        break
      }
      _t = c.return
    }
  }
  function DS(a) {
    for (; _t !== null; ) {
      var c = _t
      if (c === a) {
        _t = null
        break
      }
      var g = c.sibling
      if (g !== null) {
        ;(g.return = c.return), (_t = g)
        break
      }
      _t = c.return
    }
  }
  function NS(a) {
    for (; _t !== null; ) {
      var c = _t
      try {
        switch (c.tag) {
          case 0:
          case 11:
          case 15:
            var g = c.return
            try {
              sg(4, c)
            } catch (le) {
              ti(c, g, le)
            }
            break
          case 1:
            var S = c.stateNode
            if (typeof S.componentDidMount == "function") {
              var b = c.return
              try {
                S.componentDidMount()
              } catch (le) {
                ti(c, b, le)
              }
            }
            var L = c.return
            try {
              Iy(c)
            } catch (le) {
              ti(c, L, le)
            }
            break
          case 5:
            var H = c.return
            try {
              Iy(c)
            } catch (le) {
              ti(c, H, le)
            }
        }
      } catch (le) {
        ti(c, c.return, le)
      }
      if (c === a) {
        _t = null
        break
      }
      var te = c.sibling
      if (te !== null) {
        ;(te.return = c.return), (_t = te)
        break
      }
      _t = c.return
    }
  }
  var nP = Math.ceil,
    og = R.ReactCurrentDispatcher,
    Ny = R.ReactCurrentOwner,
    Rs = R.ReactCurrentBatchConfig,
    mn = 0,
    ki = null,
    gi = null,
    Zi = 0,
    ps = 0,
    Wf = Gn(0),
    Ti = 0,
    zh = null,
    Wc = 0,
    ag = 0,
    ky = 0,
    Vh = null,
    Wr = null,
    Fy = 0,
    jf = 1 / 0,
    La = null,
    lg = !1,
    Uy = null,
    Rl = null,
    cg = !1,
    Pl = null,
    ug = 0,
    Hh = 0,
    Oy = null,
    fg = -1,
    dg = 0
  function Tr() {
    return (mn & 6) !== 0 ? qe() : fg !== -1 ? fg : (fg = qe())
  }
  function Il(a) {
    return (a.mode & 1) === 0
      ? 1
      : (mn & 2) !== 0 && Zi !== 0
      ? Zi & -Zi
      : by.transition !== null
      ? (dg === 0 && (dg = An()), dg)
      : ((a = hn),
        a !== 0 || ((a = window.event), (a = a === void 0 ? 16 : Im(a.type))),
        a)
  }
  function ao(a, c, g, S) {
    if (50 < Hh) throw ((Hh = 0), (Oy = null), Error(t(185)))
    tr(a, g, S),
      ((mn & 2) === 0 || a !== ki) &&
        (a === ki && ((mn & 2) === 0 && (ag |= g), Ti === 4 && Ll(a, Zi)),
        jr(a, S),
        g === 1 && mn === 0 && (c.mode & 1) === 0 && ((jf = qe() + 500), Cc && Ts()))
  }
  function jr(a, c) {
    var g = a.callbackNode
    Hi(a, c)
    var S = rs(a, a === ki ? Zi : 0)
    if (S === 0) g !== null && Ce(g), (a.callbackNode = null), (a.callbackPriority = 0)
    else if (((c = S & -S), a.callbackPriority !== c)) {
      if ((g != null && Ce(g), c === 1))
        a.tag === 0 ? jm(FS.bind(null, a)) : Rc(FS.bind(null, a)),
          Ty(function () {
            ;(mn & 6) === 0 && Ts()
          }),
          (g = null)
      else {
        switch (rl(S)) {
          case 1:
            g = xt
            break
          case 4:
            g = kt
            break
          case 16:
            g = Ot
            break
          case 536870912:
            g = $t
            break
          default:
            g = Ot
        }
        g = WS(g, kS.bind(null, a))
      }
      ;(a.callbackPriority = c), (a.callbackNode = g)
    }
  }
  function kS(a, c) {
    if (((fg = -1), (dg = 0), (mn & 6) !== 0)) throw Error(t(327))
    var g = a.callbackNode
    if (Xf() && a.callbackNode !== g) return null
    var S = rs(a, a === ki ? Zi : 0)
    if (S === 0) return null
    if ((S & 30) !== 0 || (S & a.expiredLanes) !== 0 || c) c = hg(a, S)
    else {
      c = S
      var b = mn
      mn |= 2
      var L = OS()
      ;(ki !== a || Zi !== c) && ((La = null), (jf = qe() + 500), Xc(a, c))
      do
        try {
          sP()
          break
        } catch (te) {
          US(a, te)
        }
      while (!0)
      Ea(),
        (og.current = L),
        (mn = b),
        gi !== null ? (c = 0) : ((ki = null), (Zi = 0), (c = Ti))
    }
    if (c !== 0) {
      if ((c === 2 && ((b = _s(a)), b !== 0 && ((S = b), (c = By(a, b)))), c === 1))
        throw ((g = zh), Xc(a, 0), Ll(a, S), jr(a, qe()), g)
      if (c === 6) Ll(a, S)
      else {
        if (
          ((b = a.current.alternate),
          (S & 30) === 0 &&
            !iP(b) &&
            ((c = hg(a, S)),
            c === 2 && ((L = _s(a)), L !== 0 && ((S = L), (c = By(a, L)))),
            c === 1))
        )
          throw ((g = zh), Xc(a, 0), Ll(a, S), jr(a, qe()), g)
        switch (((a.finishedWork = b), (a.finishedLanes = S), c)) {
          case 0:
          case 1:
            throw Error(t(345))
          case 2:
            Yc(a, Wr, La)
            break
          case 3:
            if ((Ll(a, S), (S & 130023424) === S && ((c = Fy + 500 - qe()), 10 < c))) {
              if (rs(a, 0) !== 0) break
              if (((b = a.suspendedLanes), (b & S) !== S)) {
                Tr(), (a.pingedLanes |= a.suspendedLanes & b)
                break
              }
              a.timeoutHandle = mh(Yc.bind(null, a, Wr, La), c)
              break
            }
            Yc(a, Wr, La)
            break
          case 4:
            if ((Ll(a, S), (S & 4194240) === S)) break
            for (c = a.eventTimes, b = -1; 0 < S; ) {
              var H = 31 - Ft(S)
              ;(L = 1 << H), (H = c[H]), H > b && (b = H), (S &= ~L)
            }
            if (
              ((S = b),
              (S = qe() - S),
              (S =
                (120 > S
                  ? 120
                  : 480 > S
                  ? 480
                  : 1080 > S
                  ? 1080
                  : 1920 > S
                  ? 1920
                  : 3e3 > S
                  ? 3e3
                  : 4320 > S
                  ? 4320
                  : 1960 * nP(S / 1960)) - S),
              10 < S)
            ) {
              a.timeoutHandle = mh(Yc.bind(null, a, Wr, La), S)
              break
            }
            Yc(a, Wr, La)
            break
          case 5:
            Yc(a, Wr, La)
            break
          default:
            throw Error(t(329))
        }
      }
    }
    return jr(a, qe()), a.callbackNode === g ? kS.bind(null, a) : null
  }
  function By(a, c) {
    var g = Vh
    return (
      a.current.memoizedState.isDehydrated && (Xc(a, c).flags |= 256),
      (a = hg(a, c)),
      a !== 2 && ((c = Wr), (Wr = g), c !== null && zy(c)),
      a
    )
  }
  function zy(a) {
    Wr === null ? (Wr = a) : Wr.push.apply(Wr, a)
  }
  function iP(a) {
    for (var c = a; ; ) {
      if (c.flags & 16384) {
        var g = c.updateQueue
        if (g !== null && ((g = g.stores), g !== null))
          for (var S = 0; S < g.length; S++) {
            var b = g[S],
              L = b.getSnapshot
            b = b.value
            try {
              if (!vr(L(), b)) return !1
            } catch {
              return !1
            }
          }
      }
      if (((g = c.child), c.subtreeFlags & 16384 && g !== null)) (g.return = c), (c = g)
      else {
        if (c === a) break
        for (; c.sibling === null; ) {
          if (c.return === null || c.return === a) return !0
          c = c.return
        }
        ;(c.sibling.return = c.return), (c = c.sibling)
      }
    }
    return !0
  }
  function Ll(a, c) {
    for (
      c &= ~ky,
        c &= ~ag,
        a.suspendedLanes |= c,
        a.pingedLanes &= ~c,
        a = a.expirationTimes;
      0 < c;

    ) {
      var g = 31 - Ft(c),
        S = 1 << g
      ;(a[g] = -1), (c &= ~S)
    }
  }
  function FS(a) {
    if ((mn & 6) !== 0) throw Error(t(327))
    Xf()
    var c = rs(a, 0)
    if ((c & 1) === 0) return jr(a, qe()), null
    var g = hg(a, c)
    if (a.tag !== 0 && g === 2) {
      var S = _s(a)
      S !== 0 && ((c = S), (g = By(a, S)))
    }
    if (g === 1) throw ((g = zh), Xc(a, 0), Ll(a, c), jr(a, qe()), g)
    if (g === 6) throw Error(t(345))
    return (
      (a.finishedWork = a.current.alternate),
      (a.finishedLanes = c),
      Yc(a, Wr, La),
      jr(a, qe()),
      null
    )
  }
  function Vy(a, c) {
    var g = mn
    mn |= 1
    try {
      return a(c)
    } finally {
      ;(mn = g), mn === 0 && ((jf = qe() + 500), Cc && Ts())
    }
  }
  function jc(a) {
    Pl !== null && Pl.tag === 0 && (mn & 6) === 0 && Xf()
    var c = mn
    mn |= 1
    var g = Rs.transition,
      S = hn
    try {
      if (((Rs.transition = null), (hn = 1), a)) return a()
    } finally {
      ;(hn = S), (Rs.transition = g), (mn = c), (mn & 6) === 0 && Ts()
    }
  }
  function Hy() {
    ;(ps = Wf.current), En(Wf)
  }
  function Xc(a, c) {
    ;(a.finishedWork = null), (a.finishedLanes = 0)
    var g = a.timeoutHandle
    if ((g !== -1 && ((a.timeoutHandle = -1), gh(g)), gi !== null))
      for (g = gi.return; g !== null; ) {
        var S = g
        switch ((Zs(S), S.tag)) {
          case 1:
            ;(S = S.type.childContextTypes), S != null && bc()
            break
          case 3:
            Uo(), En(Xi), En(_i), As()
            break
          case 5:
            Tl(S)
            break
          case 4:
            Uo()
            break
          case 13:
            En(Rn)
            break
          case 19:
            En(Rn)
            break
          case 10:
            Dc(S.type._context)
            break
          case 22:
          case 23:
            Hy()
        }
        g = g.return
      }
    if (
      ((ki = a),
      (gi = a = Dl(a.current, null)),
      (Zi = ps = c),
      (Ti = 0),
      (zh = null),
      (ky = ag = Wc = 0),
      (Wr = Vh = null),
      Qs !== null)
    ) {
      for (c = 0; c < Qs.length; c++)
        if (((g = Qs[c]), (S = g.interleaved), S !== null)) {
          g.interleaved = null
          var b = S.next,
            L = g.pending
          if (L !== null) {
            var H = L.next
            ;(L.next = b), (S.next = H)
          }
          g.pending = S
        }
      Qs = null
    }
    return a
  }
  function US(a, c) {
    do {
      var g = gi
      try {
        if ((Ea(), (Ca.current = Vf), ds)) {
          for (var S = Tn.memoizedState; S !== null; ) {
            var b = S.queue
            b !== null && (b.pending = null), (S = S.next)
          }
          ds = !1
        }
        if (
          ((to = 0),
          (pn = jn = Tn = null),
          (Ni = !1),
          (Oo = 0),
          (Ny.current = null),
          g === null || g.return === null)
        ) {
          ;(Ti = 1), (zh = c), (gi = null)
          break
        }
        e: {
          var L = a,
            H = g.return,
            te = g,
            le = c
          if (
            ((c = Zi),
            (te.flags |= 32768),
            le !== null && typeof le == "object" && typeof le.then == "function")
          ) {
            var Re = le,
              Ye = te,
              $e = Ye.tag
            if ((Ye.mode & 1) === 0 && ($e === 0 || $e === 11 || $e === 15)) {
              var Xe = Ye.alternate
              Xe
                ? ((Ye.updateQueue = Xe.updateQueue),
                  (Ye.memoizedState = Xe.memoizedState),
                  (Ye.lanes = Xe.lanes))
                : ((Ye.updateQueue = null), (Ye.memoizedState = null))
            }
            var pt = gt(H)
            if (pt !== null) {
              ;(pt.flags &= -257),
                zt(pt, H, te, L, c),
                pt.mode & 1 && Ze(L, Re, c),
                (c = pt),
                (le = Re)
              var St = c.updateQueue
              if (St === null) {
                var bt = new Set()
                bt.add(le), (c.updateQueue = bt)
              } else St.add(le)
              break e
            } else {
              if ((c & 1) === 0) {
                Ze(L, Re, c), Gy()
                break e
              }
              le = Error(t(426))
            }
          } else if (Cn && te.mode & 1) {
            var ai = gt(H)
            if (ai !== null) {
              ;(ai.flags & 65536) === 0 && (ai.flags |= 256),
                zt(ai, H, te, L, c),
                Sl(T(le, te))
              break e
            }
          }
          ;(L = le = T(le, te)),
            Ti !== 4 && (Ti = 2),
            Vh === null ? (Vh = [L]) : Vh.push(L),
            (L = H)
          do {
            switch (L.tag) {
              case 3:
                ;(L.flags |= 65536), (c &= -c), (L.lanes |= c)
                var _e = pe(L, le, c)
                Ta(L, _e)
                break e
              case 1:
                te = le
                var de = L.type,
                  Te = L.stateNode
                if (
                  (L.flags & 128) === 0 &&
                  (typeof de.getDerivedStateFromError == "function" ||
                    (Te !== null &&
                      typeof Te.componentDidCatch == "function" &&
                      (Rl === null || !Rl.has(Te))))
                ) {
                  ;(L.flags |= 65536), (c &= -c), (L.lanes |= c)
                  var et = ke(L, te, c)
                  Ta(L, et)
                  break e
                }
            }
            L = L.return
          } while (L !== null)
        }
        zS(g)
      } catch (Rt) {
        ;(c = Rt), gi === g && g !== null && (gi = g = g.return)
        continue
      }
      break
    } while (!0)
  }
  function OS() {
    var a = og.current
    return (og.current = Vf), a === null ? Vf : a
  }
  function Gy() {
    ;(Ti === 0 || Ti === 3 || Ti === 2) && (Ti = 4),
      ki === null || ((Wc & 268435455) === 0 && (ag & 268435455) === 0) || Ll(ki, Zi)
  }
  function hg(a, c) {
    var g = mn
    mn |= 2
    var S = OS()
    ;(ki !== a || Zi !== c) && ((La = null), Xc(a, c))
    do
      try {
        rP()
        break
      } catch (b) {
        US(a, b)
      }
    while (!0)
    if ((Ea(), (mn = g), (og.current = S), gi !== null)) throw Error(t(261))
    return (ki = null), (Zi = 0), Ti
  }
  function rP() {
    for (; gi !== null; ) BS(gi)
  }
  function sP() {
    for (; gi !== null && !xe(); ) BS(gi)
  }
  function BS(a) {
    var c = GS(a.alternate, a, ps)
    ;(a.memoizedProps = a.pendingProps),
      c === null ? zS(a) : (gi = c),
      (Ny.current = null)
  }
  function zS(a) {
    var c = a
    do {
      var g = c.alternate
      if (((a = c.return), (c.flags & 32768) === 0)) {
        if (((g = ZR(g, c, ps)), g !== null)) {
          gi = g
          return
        }
      } else {
        if (((g = JR(g, c)), g !== null)) {
          ;(g.flags &= 32767), (gi = g)
          return
        }
        if (a !== null) (a.flags |= 32768), (a.subtreeFlags = 0), (a.deletions = null)
        else {
          ;(Ti = 6), (gi = null)
          return
        }
      }
      if (((c = c.sibling), c !== null)) {
        gi = c
        return
      }
      gi = c = a
    } while (c !== null)
    Ti === 0 && (Ti = 5)
  }
  function Yc(a, c, g) {
    var S = hn,
      b = Rs.transition
    try {
      ;(Rs.transition = null), (hn = 1), oP(a, c, g, S)
    } finally {
      ;(Rs.transition = b), (hn = S)
    }
    return null
  }
  function oP(a, c, g, S) {
    do Xf()
    while (Pl !== null)
    if ((mn & 6) !== 0) throw Error(t(327))
    g = a.finishedWork
    var b = a.finishedLanes
    if (g === null) return null
    if (((a.finishedWork = null), (a.finishedLanes = 0), g === a.current))
      throw Error(t(177))
    ;(a.callbackNode = null), (a.callbackPriority = 0)
    var L = g.lanes | g.childLanes
    if (
      (qu(a, L),
      a === ki && ((gi = ki = null), (Zi = 0)),
      ((g.subtreeFlags & 2064) === 0 && (g.flags & 2064) === 0) ||
        cg ||
        ((cg = !0),
        WS(Ot, function () {
          return Xf(), null
        })),
      (L = (g.flags & 15990) !== 0),
      (g.subtreeFlags & 15990) !== 0 || L)
    ) {
      ;(L = Rs.transition), (Rs.transition = null)
      var H = hn
      hn = 1
      var te = mn
      ;(mn |= 4),
        (Ny.current = null),
        eP(a, g),
        PS(g, a),
        di(hh),
        (kr = !!xl),
        (hh = xl = null),
        (a.current = g),
        tP(g),
        Qe(),
        (mn = te),
        (hn = H),
        (Rs.transition = L)
    } else a.current = g
    if (
      (cg && ((cg = !1), (Pl = a), (ug = b)),
      (L = a.pendingLanes),
      L === 0 && (Rl = null),
      Yt(g.stateNode),
      jr(a, qe()),
      c !== null)
    )
      for (S = a.onRecoverableError, g = 0; g < c.length; g++)
        (b = c[g]), S(b.value, { componentStack: b.stack, digest: b.digest })
    if (lg) throw ((lg = !1), (a = Uy), (Uy = null), a)
    return (
      (ug & 1) !== 0 && a.tag !== 0 && Xf(),
      (L = a.pendingLanes),
      (L & 1) !== 0 ? (a === Oy ? Hh++ : ((Hh = 0), (Oy = a))) : (Hh = 0),
      Ts(),
      null
    )
  }
  function Xf() {
    if (Pl !== null) {
      var a = rl(ug),
        c = Rs.transition,
        g = hn
      try {
        if (((Rs.transition = null), (hn = 16 > a ? 16 : a), Pl === null)) var S = !1
        else {
          if (((a = Pl), (Pl = null), (ug = 0), (mn & 6) !== 0)) throw Error(t(331))
          var b = mn
          for (mn |= 4, _t = a.current; _t !== null; ) {
            var L = _t,
              H = L.child
            if ((_t.flags & 16) !== 0) {
              var te = L.deletions
              if (te !== null) {
                for (var le = 0; le < te.length; le++) {
                  var Re = te[le]
                  for (_t = Re; _t !== null; ) {
                    var Ye = _t
                    switch (Ye.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Bh(8, Ye, L)
                    }
                    var $e = Ye.child
                    if ($e !== null) ($e.return = Ye), (_t = $e)
                    else
                      for (; _t !== null; ) {
                        Ye = _t
                        var Xe = Ye.sibling,
                          pt = Ye.return
                        if ((TS(Ye), Ye === Re)) {
                          _t = null
                          break
                        }
                        if (Xe !== null) {
                          ;(Xe.return = pt), (_t = Xe)
                          break
                        }
                        _t = pt
                      }
                  }
                }
                var St = L.alternate
                if (St !== null) {
                  var bt = St.child
                  if (bt !== null) {
                    St.child = null
                    do {
                      var ai = bt.sibling
                      ;(bt.sibling = null), (bt = ai)
                    } while (bt !== null)
                  }
                }
                _t = L
              }
            }
            if ((L.subtreeFlags & 2064) !== 0 && H !== null) (H.return = L), (_t = H)
            else
              e: for (; _t !== null; ) {
                if (((L = _t), (L.flags & 2048) !== 0))
                  switch (L.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Bh(9, L, L.return)
                  }
                var _e = L.sibling
                if (_e !== null) {
                  ;(_e.return = L.return), (_t = _e)
                  break e
                }
                _t = L.return
              }
          }
          var de = a.current
          for (_t = de; _t !== null; ) {
            H = _t
            var Te = H.child
            if ((H.subtreeFlags & 2064) !== 0 && Te !== null) (Te.return = H), (_t = Te)
            else
              e: for (H = de; _t !== null; ) {
                if (((te = _t), (te.flags & 2048) !== 0))
                  try {
                    switch (te.tag) {
                      case 0:
                      case 11:
                      case 15:
                        sg(9, te)
                    }
                  } catch (Rt) {
                    ti(te, te.return, Rt)
                  }
                if (te === H) {
                  _t = null
                  break e
                }
                var et = te.sibling
                if (et !== null) {
                  ;(et.return = te.return), (_t = et)
                  break e
                }
                _t = te.return
              }
          }
          if (((mn = b), Ts(), Tt && typeof Tt.onPostCommitFiberRoot == "function"))
            try {
              Tt.onPostCommitFiberRoot(en, a)
            } catch {}
          S = !0
        }
        return S
      } finally {
        ;(hn = g), (Rs.transition = c)
      }
    }
    return !1
  }
  function VS(a, c, g) {
    ;(c = T(g, c)),
      (c = pe(a, c, 1)),
      (a = Nn(a, c, 1)),
      (c = Tr()),
      a !== null && (tr(a, 1, c), jr(a, c))
  }
  function ti(a, c, g) {
    if (a.tag === 3) VS(a, a, g)
    else
      for (; c !== null; ) {
        if (c.tag === 3) {
          VS(c, a, g)
          break
        } else if (c.tag === 1) {
          var S = c.stateNode
          if (
            typeof c.type.getDerivedStateFromError == "function" ||
            (typeof S.componentDidCatch == "function" && (Rl === null || !Rl.has(S)))
          ) {
            ;(a = T(g, a)),
              (a = ke(c, a, 1)),
              (c = Nn(c, a, 1)),
              (a = Tr()),
              c !== null && (tr(c, 1, a), jr(c, a))
            break
          }
        }
        c = c.return
      }
  }
  function aP(a, c, g) {
    var S = a.pingCache
    S !== null && S.delete(c),
      (c = Tr()),
      (a.pingedLanes |= a.suspendedLanes & g),
      ki === a &&
        (Zi & g) === g &&
        (Ti === 4 || (Ti === 3 && (Zi & 130023424) === Zi && 500 > qe() - Fy)
          ? Xc(a, 0)
          : (ky |= g)),
      jr(a, c)
  }
  function HS(a, c) {
    c === 0 &&
      ((a.mode & 1) === 0
        ? (c = 1)
        : ((c = Ln), (Ln <<= 1), (Ln & 130023424) === 0 && (Ln = 4194304)))
    var g = Tr()
    ;(a = us(a, c)), a !== null && (tr(a, c, g), jr(a, g))
  }
  function lP(a) {
    var c = a.memoizedState,
      g = 0
    c !== null && (g = c.retryLane), HS(a, g)
  }
  function cP(a, c) {
    var g = 0
    switch (a.tag) {
      case 13:
        var S = a.stateNode,
          b = a.memoizedState
        b !== null && (g = b.retryLane)
        break
      case 19:
        S = a.stateNode
        break
      default:
        throw Error(t(314))
    }
    S !== null && S.delete(c), HS(a, g)
  }
  var GS
  GS = function (a, c, g) {
    if (a !== null)
      if (a.memoizedProps !== c.pendingProps || Xi.current) Kt = !0
      else {
        if ((a.lanes & g) === 0 && (c.flags & 128) === 0) return (Kt = !1), KR(a, c, g)
        Kt = (a.flags & 131072) !== 0
      }
    else (Kt = !1), Cn && (c.flags & 1048576) !== 0 && wh(c, If, c.index)
    switch (((c.lanes = 0), c.tag)) {
      case 2:
        var S = c.type
        ig(a, c), (a = c.pendingProps)
        var b = va(c, _i.current)
        Fo(c, g), (b = Oc(null, c, S, a, b, g))
        var L = Rh()
        return (
          (c.flags |= 1),
          typeof b == "object" &&
          b !== null &&
          typeof b.render == "function" &&
          b.$$typeof === void 0
            ? ((c.tag = 1),
              (c.memoizedState = null),
              (c.updateQueue = null),
              Li(S) ? ((L = !0), ya(c)) : (L = !1),
              (c.memoizedState =
                b.state !== null && b.state !== void 0 ? b.state : null),
              qt(c),
              (b.updater = Hf),
              (c.stateNode = b),
              (b._reactInternals = c),
              _(c, S, a, g),
              (c = jt(null, c, S, !0, L, g)))
            : ((c.tag = 0), Cn && L && Sh(c), ht(null, c, b, g), (c = c.child)),
          c
        )
      case 16:
        S = c.elementType
        e: {
          switch (
            (ig(a, c),
            (a = c.pendingProps),
            (b = S._init),
            (S = b(S._payload)),
            (c.type = S),
            (b = c.tag = fP(S)),
            (a = Gr(S, a)),
            b)
          ) {
            case 0:
              c = ct(null, c, S, a, g)
              break e
            case 1:
              c = Ct(null, c, S, a, g)
              break e
            case 11:
              c = Ei(null, c, S, a, g)
              break e
            case 14:
              c = Er(null, c, S, Gr(S.type, a), g)
              break e
          }
          throw Error(t(306, S, ""))
        }
        return c
      case 0:
        return (
          (S = c.type),
          (b = c.pendingProps),
          (b = c.elementType === S ? b : Gr(S, b)),
          ct(a, c, S, b, g)
        )
      case 1:
        return (
          (S = c.type),
          (b = c.pendingProps),
          (b = c.elementType === S ? b : Gr(S, b)),
          Ct(a, c, S, b, g)
        )
      case 3:
        e: {
          if ((Vt(c), a === null)) throw Error(t(387))
          ;(S = c.pendingProps),
            (L = c.memoizedState),
            (b = L.element),
            $n(a, c),
            Wn(c, S, null, g)
          var H = c.memoizedState
          if (((S = H.element), L.isDehydrated))
            if (
              ((L = {
                element: S,
                isDehydrated: !1,
                cache: H.cache,
                pendingSuspenseBoundaries: H.pendingSuspenseBoundaries,
                transitions: H.transitions,
              }),
              (c.updateQueue.baseState = L),
              (c.memoizedState = L),
              c.flags & 256)
            ) {
              ;(b = T(Error(t(423)), c)), (c = un(a, c, S, g, b))
              break e
            } else if (S !== b) {
              ;(b = T(Error(t(424)), c)), (c = un(a, c, S, g, b))
              break e
            } else
              for (
                qi = Xs(c.stateNode.containerInfo.firstChild),
                  wi = c,
                  Cn = !0,
                  Hr = null,
                  g = Lc(c, null, S, g),
                  c.child = g;
                g;

              )
                (g.flags = (g.flags & -3) | 4096), (g = g.sibling)
          else {
            if ((ko(), S === b)) {
              c = Ia(a, c, g)
              break e
            }
            ht(a, c, S, g)
          }
          c = c.child
        }
        return c
      case 5:
        return (
          Aa(c),
          a === null && Df(c),
          (S = c.type),
          (b = c.pendingProps),
          (L = a !== null ? a.memoizedProps : null),
          (H = b.children),
          ph(S, b) ? (H = null) : L !== null && ph(S, L) && (c.flags |= 32),
          Le(a, c),
          ht(a, c, H, g),
          c.child
        )
      case 6:
        return a === null && Df(c), null
      case 13:
        return ro(a, c, g)
      case 4:
        return (
          Fc(c, c.stateNode.containerInfo),
          (S = c.pendingProps),
          a === null ? (c.child = wa(c, null, S, g)) : ht(a, c, S, g),
          c.child
        )
      case 11:
        return (
          (S = c.type),
          (b = c.pendingProps),
          (b = c.elementType === S ? b : Gr(S, b)),
          Ei(a, c, S, b, g)
        )
      case 7:
        return ht(a, c, c.pendingProps, g), c.child
      case 8:
        return ht(a, c, c.pendingProps.children, g), c.child
      case 12:
        return ht(a, c, c.pendingProps.children, g), c.child
      case 10:
        e: {
          if (
            ((S = c.type._context),
            (b = c.pendingProps),
            (L = c.memoizedProps),
            (H = b.value),
            wn(Sa, S._currentValue),
            (S._currentValue = H),
            L !== null)
          )
            if (vr(L.value, H)) {
              if (L.children === b.children && !Xi.current) {
                c = Ia(a, c, g)
                break e
              }
            } else
              for (L = c.child, L !== null && (L.return = c); L !== null; ) {
                var te = L.dependencies
                if (te !== null) {
                  H = L.child
                  for (var le = te.firstContext; le !== null; ) {
                    if (le.context === S) {
                      if (L.tag === 1) {
                        ;(le = _n(-1, g & -g)), (le.tag = 2)
                        var Re = L.updateQueue
                        if (Re !== null) {
                          Re = Re.shared
                          var Ye = Re.pending
                          Ye === null
                            ? (le.next = le)
                            : ((le.next = Ye.next), (Ye.next = le)),
                            (Re.pending = le)
                        }
                      }
                      ;(L.lanes |= g),
                        (le = L.alternate),
                        le !== null && (le.lanes |= g),
                        Nc(L.return, g, c),
                        (te.lanes |= g)
                      break
                    }
                    le = le.next
                  }
                } else if (L.tag === 10) H = L.type === c.type ? null : L.child
                else if (L.tag === 18) {
                  if (((H = L.return), H === null)) throw Error(t(341))
                  ;(H.lanes |= g),
                    (te = H.alternate),
                    te !== null && (te.lanes |= g),
                    Nc(H, g, c),
                    (H = L.sibling)
                } else H = L.child
                if (H !== null) H.return = L
                else
                  for (H = L; H !== null; ) {
                    if (H === c) {
                      H = null
                      break
                    }
                    if (((L = H.sibling), L !== null)) {
                      ;(L.return = H.return), (H = L)
                      break
                    }
                    H = H.return
                  }
                L = H
              }
          ht(a, c, b.children, g), (c = c.child)
        }
        return c
      case 9:
        return (
          (b = c.type),
          (S = c.pendingProps.children),
          Fo(c, g),
          (b = _r(b)),
          (S = S(b)),
          (c.flags |= 1),
          ht(a, c, S, g),
          c.child
        )
      case 14:
        return (
          (S = c.type),
          (b = Gr(S, c.pendingProps)),
          (b = Gr(S.type, b)),
          Er(a, c, S, b, g)
        )
      case 15:
        return be(a, c, c.type, c.pendingProps, g)
      case 17:
        return (
          (S = c.type),
          (b = c.pendingProps),
          (b = c.elementType === S ? b : Gr(S, b)),
          ig(a, c),
          (c.tag = 1),
          Li(S) ? ((a = !0), ya(c)) : (a = !1),
          Fo(c, g),
          f(c, S, b),
          _(c, S, b, g),
          jt(null, c, S, !0, a, g)
        )
      case 19:
        return _S(a, c, g)
      case 22:
        return ve(a, c, g)
    }
    throw Error(t(156, c.tag))
  }
  function WS(a, c) {
    return Ae(a, c)
  }
  function uP(a, c, g, S) {
    ;(this.tag = a),
      (this.key = g),
      (this.sibling =
        this.child =
        this.return =
        this.stateNode =
        this.type =
        this.elementType =
          null),
      (this.index = 0),
      (this.ref = null),
      (this.pendingProps = c),
      (this.dependencies =
        this.memoizedState =
        this.updateQueue =
        this.memoizedProps =
          null),
      (this.mode = S),
      (this.subtreeFlags = this.flags = 0),
      (this.deletions = null),
      (this.childLanes = this.lanes = 0),
      (this.alternate = null)
  }
  function Ps(a, c, g, S) {
    return new uP(a, c, g, S)
  }
  function Wy(a) {
    return (a = a.prototype), !(!a || !a.isReactComponent)
  }
  function fP(a) {
    if (typeof a == "function") return Wy(a) ? 1 : 0
    if (a != null) {
      if (((a = a.$$typeof), a === Z)) return 11
      if (a === ue) return 14
    }
    return 2
  }
  function Dl(a, c) {
    var g = a.alternate
    return (
      g === null
        ? ((g = Ps(a.tag, c, a.key, a.mode)),
          (g.elementType = a.elementType),
          (g.type = a.type),
          (g.stateNode = a.stateNode),
          (g.alternate = a),
          (a.alternate = g))
        : ((g.pendingProps = c),
          (g.type = a.type),
          (g.flags = 0),
          (g.subtreeFlags = 0),
          (g.deletions = null)),
      (g.flags = a.flags & 14680064),
      (g.childLanes = a.childLanes),
      (g.lanes = a.lanes),
      (g.child = a.child),
      (g.memoizedProps = a.memoizedProps),
      (g.memoizedState = a.memoizedState),
      (g.updateQueue = a.updateQueue),
      (c = a.dependencies),
      (g.dependencies =
        c === null ? null : { lanes: c.lanes, firstContext: c.firstContext }),
      (g.sibling = a.sibling),
      (g.index = a.index),
      (g.ref = a.ref),
      g
    )
  }
  function pg(a, c, g, S, b, L) {
    var H = 2
    if (((S = a), typeof a == "function")) Wy(a) && (H = 1)
    else if (typeof a == "string") H = 5
    else
      e: switch (a) {
        case O:
          return qc(g.children, b, L, c)
        case N:
          ;(H = 8), (b |= 8)
          break
        case k:
          return (a = Ps(12, g, c, b | 2)), (a.elementType = k), (a.lanes = L), a
        case $:
          return (a = Ps(13, g, c, b)), (a.elementType = $), (a.lanes = L), a
        case ee:
          return (a = Ps(19, g, c, b)), (a.elementType = ee), (a.lanes = L), a
        case se:
          return mg(g, b, L, c)
        default:
          if (typeof a == "object" && a !== null)
            switch (a.$$typeof) {
              case I:
                H = 10
                break e
              case V:
                H = 9
                break e
              case Z:
                H = 11
                break e
              case ue:
                H = 14
                break e
              case re:
                ;(H = 16), (S = null)
                break e
            }
          throw Error(t(130, a == null ? a : typeof a, ""))
      }
    return (c = Ps(H, g, c, b)), (c.elementType = a), (c.type = S), (c.lanes = L), c
  }
  function qc(a, c, g, S) {
    return (a = Ps(7, a, S, c)), (a.lanes = g), a
  }
  function mg(a, c, g, S) {
    return (
      (a = Ps(22, a, S, c)),
      (a.elementType = se),
      (a.lanes = g),
      (a.stateNode = { isHidden: !1 }),
      a
    )
  }
  function jy(a, c, g) {
    return (a = Ps(6, a, null, c)), (a.lanes = g), a
  }
  function Xy(a, c, g) {
    return (
      (c = Ps(4, a.children !== null ? a.children : [], a.key, c)),
      (c.lanes = g),
      (c.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation,
      }),
      c
    )
  }
  function dP(a, c, g, S, b) {
    ;(this.tag = c),
      (this.containerInfo = a),
      (this.finishedWork = this.pingCache = this.current = this.pendingChildren = null),
      (this.timeoutHandle = -1),
      (this.callbackNode = this.pendingContext = this.context = null),
      (this.callbackPriority = 0),
      (this.eventTimes = Nr(0)),
      (this.expirationTimes = Nr(-1)),
      (this.entangledLanes =
        this.finishedLanes =
        this.mutableReadLanes =
        this.expiredLanes =
        this.pingedLanes =
        this.suspendedLanes =
        this.pendingLanes =
          0),
      (this.entanglements = Nr(0)),
      (this.identifierPrefix = S),
      (this.onRecoverableError = b),
      (this.mutableSourceEagerHydrationData = null)
  }
  function Yy(a, c, g, S, b, L, H, te, le) {
    return (
      (a = new dP(a, c, g, te, le)),
      c === 1 ? ((c = 1), L === !0 && (c |= 8)) : (c = 0),
      (L = Ps(3, null, null, c)),
      (a.current = L),
      (L.stateNode = a),
      (L.memoizedState = {
        element: S,
        isDehydrated: g,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null,
      }),
      qt(L),
      a
    )
  }
  function hP(a, c, g) {
    var S = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null
    return {
      $$typeof: U,
      key: S == null ? null : "" + S,
      children: a,
      containerInfo: c,
      implementation: g,
    }
  }
  function jS(a) {
    if (!a) return qs
    a = a._reactInternals
    e: {
      if (xs(a) !== a || a.tag !== 1) throw Error(t(170))
      var c = a
      do {
        switch (c.tag) {
          case 3:
            c = c.stateNode.context
            break e
          case 1:
            if (Li(c.type)) {
              c = c.stateNode.__reactInternalMemoizedMergedChildContext
              break e
            }
        }
        c = c.return
      } while (c !== null)
      throw Error(t(171))
    }
    if (a.tag === 1) {
      var g = a.type
      if (Li(g)) return Ac(a, g, c)
    }
    return c
  }
  function XS(a, c, g, S, b, L, H, te, le) {
    return (
      (a = Yy(g, S, !0, a, b, L, H, te, le)),
      (a.context = jS(null)),
      (g = a.current),
      (S = Tr()),
      (b = Il(g)),
      (L = _n(S, b)),
      (L.callback = c ?? null),
      Nn(g, L, b),
      (a.current.lanes = b),
      tr(a, b, S),
      jr(a, S),
      a
    )
  }
  function gg(a, c, g, S) {
    var b = c.current,
      L = Tr(),
      H = Il(b)
    return (
      (g = jS(g)),
      c.context === null ? (c.context = g) : (c.pendingContext = g),
      (c = _n(L, H)),
      (c.payload = { element: a }),
      (S = S === void 0 ? null : S),
      S !== null && (c.callback = S),
      (a = Nn(b, c, H)),
      a !== null && (ao(a, b, H, L), Di(a, b, H)),
      H
    )
  }
  function vg(a) {
    if (((a = a.current), !a.child)) return null
    switch (a.child.tag) {
      case 5:
        return a.child.stateNode
      default:
        return a.child.stateNode
    }
  }
  function YS(a, c) {
    if (((a = a.memoizedState), a !== null && a.dehydrated !== null)) {
      var g = a.retryLane
      a.retryLane = g !== 0 && g < c ? g : c
    }
  }
  function qy(a, c) {
    YS(a, c), (a = a.alternate) && YS(a, c)
  }
  function pP() {
    return null
  }
  var qS =
    typeof reportError == "function"
      ? reportError
      : function (a) {
          console.error(a)
        }
  function $y(a) {
    this._internalRoot = a
  }
  ;(yg.prototype.render = $y.prototype.render =
    function (a) {
      var c = this._internalRoot
      if (c === null) throw Error(t(409))
      gg(a, c, null, null)
    }),
    (yg.prototype.unmount = $y.prototype.unmount =
      function () {
        var a = this._internalRoot
        if (a !== null) {
          this._internalRoot = null
          var c = a.containerInfo
          jc(function () {
            gg(null, a, null, null)
          }),
            (c[xr] = null)
        }
      })
  function yg(a) {
    this._internalRoot = a
  }
  yg.prototype.unstable_scheduleHydration = function (a) {
    if (a) {
      var c = $u()
      a = { blockedOn: null, target: a, priority: c }
      for (var g = 0; g < Ao.length && c !== 0 && c < Ao[g].priority; g++);
      Ao.splice(g, 0, a), g === 0 && Ju(a)
    }
  }
  function Ky(a) {
    return !(!a || (a.nodeType !== 1 && a.nodeType !== 9 && a.nodeType !== 11))
  }
  function xg(a) {
    return !(
      !a ||
      (a.nodeType !== 1 &&
        a.nodeType !== 9 &&
        a.nodeType !== 11 &&
        (a.nodeType !== 8 || a.nodeValue !== " react-mount-point-unstable "))
    )
  }
  function $S() {}
  function mP(a, c, g, S, b) {
    if (b) {
      if (typeof S == "function") {
        var L = S
        S = function () {
          var Re = vg(H)
          L.call(Re)
        }
      }
      var H = XS(c, S, a, 0, null, !1, !1, "", $S)
      return (
        (a._reactRootContainer = H),
        (a[xr] = H.current),
        vl(a.nodeType === 8 ? a.parentNode : a),
        jc(),
        H
      )
    }
    for (; (b = a.lastChild); ) a.removeChild(b)
    if (typeof S == "function") {
      var te = S
      S = function () {
        var Re = vg(le)
        te.call(Re)
      }
    }
    var le = Yy(a, 0, !1, null, null, !1, !1, "", $S)
    return (
      (a._reactRootContainer = le),
      (a[xr] = le.current),
      vl(a.nodeType === 8 ? a.parentNode : a),
      jc(function () {
        gg(c, le, g, S)
      }),
      le
    )
  }
  function _g(a, c, g, S, b) {
    var L = g._reactRootContainer
    if (L) {
      var H = L
      if (typeof b == "function") {
        var te = b
        b = function () {
          var le = vg(H)
          te.call(le)
        }
      }
      gg(c, H, a, b)
    } else H = mP(g, c, a, b, S)
    return vg(H)
  }
  ;(uc = function (a) {
    switch (a.tag) {
      case 3:
        var c = a.stateNode
        if (c.current.memoizedState.isDehydrated) {
          var g = Hn(c.pendingLanes)
          g !== 0 &&
            (il(c, g | 1), jr(c, qe()), (mn & 6) === 0 && ((jf = qe() + 500), Ts()))
        }
        break
      case 13:
        jc(function () {
          var S = us(a, 1)
          if (S !== null) {
            var b = Tr()
            ao(S, a, 1, b)
          }
        }),
          qy(a, 1)
    }
  }),
    (Kd = function (a) {
      if (a.tag === 13) {
        var c = us(a, 134217728)
        if (c !== null) {
          var g = Tr()
          ao(c, a, 134217728, g)
        }
        qy(a, 134217728)
      }
    }),
    (Pm = function (a) {
      if (a.tag === 13) {
        var c = Il(a),
          g = us(a, c)
        if (g !== null) {
          var S = Tr()
          ao(g, a, c, S)
        }
        qy(a, c)
      }
    }),
    ($u = function () {
      return hn
    }),
    (Ku = function (a, c) {
      var g = hn
      try {
        return (hn = a), c()
      } finally {
        hn = g
      }
    }),
    (rt = function (a, c, g) {
      switch (c) {
        case "input":
          if ((Oe(a, g), (c = g.name), g.type === "radio" && c != null)) {
            for (g = a; g.parentNode; ) g = g.parentNode
            for (
              g = g.querySelectorAll(
                "input[name=" + JSON.stringify("" + c) + '][type="radio"]',
              ),
                c = 0;
              c < g.length;
              c++
            ) {
              var S = g[c]
              if (S !== a && S.form === a.form) {
                var b = Cf(S)
                if (!b) throw Error(t(90))
                ae(S), Oe(S, b)
              }
            }
          }
          break
        case "textarea":
          Me(a, g)
          break
        case "select":
          ;(c = g.value), c != null && j(a, !!g.multiple, c, !1)
      }
    }),
    (vn = Vy),
    (Vn = jc)
  var gP = { usingClientEntryPoint: !1, Events: [Ys, qn, Cf, at, Ut, Vy] },
    Gh = {
      findFiberByHostInstance: No,
      bundleType: 0,
      version: "18.3.1",
      rendererPackageName: "react-dom",
    },
    vP = {
      bundleType: Gh.bundleType,
      version: Gh.version,
      rendererPackageName: Gh.rendererPackageName,
      rendererConfig: Gh.rendererConfig,
      overrideHookState: null,
      overrideHookStateDeletePath: null,
      overrideHookStateRenamePath: null,
      overrideProps: null,
      overridePropsDeletePath: null,
      overridePropsRenamePath: null,
      setErrorHandler: null,
      setSuspenseHandler: null,
      scheduleUpdate: null,
      currentDispatcherRef: R.ReactCurrentDispatcher,
      findHostInstanceByFiber: function (a) {
        return (a = X(a)), a === null ? null : a.stateNode
      },
      findFiberByHostInstance: Gh.findFiberByHostInstance || pP,
      findHostInstancesForRefresh: null,
      scheduleRefresh: null,
      scheduleRoot: null,
      setRefreshHandler: null,
      getCurrentFiber: null,
      reconcilerVersion: "18.3.1-next-f1338f8080-20240426",
    }
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var wg = __REACT_DEVTOOLS_GLOBAL_HOOK__
    if (!wg.isDisabled && wg.supportsFiber)
      try {
        ;(en = wg.inject(vP)), (Tt = wg)
      } catch {}
  }
  return (
    (Xr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = gP),
    (Xr.createPortal = function (a, c) {
      var g = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null
      if (!Ky(c)) throw Error(t(200))
      return hP(a, c, null, g)
    }),
    (Xr.createRoot = function (a, c) {
      if (!Ky(a)) throw Error(t(299))
      var g = !1,
        S = "",
        b = qS
      return (
        c != null &&
          (c.unstable_strictMode === !0 && (g = !0),
          c.identifierPrefix !== void 0 && (S = c.identifierPrefix),
          c.onRecoverableError !== void 0 && (b = c.onRecoverableError)),
        (c = Yy(a, 1, !1, null, null, g, !1, S, b)),
        (a[xr] = c.current),
        vl(a.nodeType === 8 ? a.parentNode : a),
        new $y(c)
      )
    }),
    (Xr.findDOMNode = function (a) {
      if (a == null) return null
      if (a.nodeType === 1) return a
      var c = a._reactInternals
      if (c === void 0)
        throw typeof a.render == "function"
          ? Error(t(188))
          : ((a = Object.keys(a).join(",")), Error(t(268, a)))
      return (a = X(c)), (a = a === null ? null : a.stateNode), a
    }),
    (Xr.flushSync = function (a) {
      return jc(a)
    }),
    (Xr.hydrate = function (a, c, g) {
      if (!xg(c)) throw Error(t(200))
      return _g(null, a, c, !0, g)
    }),
    (Xr.hydrateRoot = function (a, c, g) {
      if (!Ky(a)) throw Error(t(405))
      var S = (g != null && g.hydratedSources) || null,
        b = !1,
        L = "",
        H = qS
      if (
        (g != null &&
          (g.unstable_strictMode === !0 && (b = !0),
          g.identifierPrefix !== void 0 && (L = g.identifierPrefix),
          g.onRecoverableError !== void 0 && (H = g.onRecoverableError)),
        (c = XS(c, null, a, 1, g ?? null, b, !1, L, H)),
        (a[xr] = c.current),
        vl(a),
        S)
      )
        for (a = 0; a < S.length; a++)
          (g = S[a]),
            (b = g._getVersion),
            (b = b(g._source)),
            c.mutableSourceEagerHydrationData == null
              ? (c.mutableSourceEagerHydrationData = [g, b])
              : c.mutableSourceEagerHydrationData.push(g, b)
      return new yg(c)
    }),
    (Xr.render = function (a, c, g) {
      if (!xg(c)) throw Error(t(200))
      return _g(null, a, c, !1, g)
    }),
    (Xr.unmountComponentAtNode = function (a) {
      if (!xg(a)) throw Error(t(40))
      return a._reactRootContainer
        ? (jc(function () {
            _g(null, null, a, !1, function () {
              ;(a._reactRootContainer = null), (a[xr] = null)
            })
          }),
          !0)
        : !1
    }),
    (Xr.unstable_batchedUpdates = Vy),
    (Xr.unstable_renderSubtreeIntoContainer = function (a, c, g, S) {
      if (!xg(g)) throw Error(t(200))
      if (a == null || a._reactInternals === void 0) throw Error(t(38))
      return _g(a, c, g, !1, S)
    }),
    (Xr.version = "18.3.1-next-f1338f8080-20240426"),
    Xr
  )
}
var rM
function oA() {
  if (rM) return Qy.exports
  rM = 1
  function n() {
    if (
      !(
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" ||
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"
      )
    )
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n)
      } catch (e) {
        console.error(e)
      }
  }
  return n(), (Qy.exports = TP()), Qy.exports
}
var sM
function bP() {
  if (sM) return Sg
  sM = 1
  var n = oA()
  return (Sg.createRoot = n.createRoot), (Sg.hydrateRoot = n.hydrateRoot), Sg
}
var AP = bP(),
  Mg = {},
  oM
function CP() {
  if (oM) return Mg
  ;(oM = 1), Object.defineProperty(Mg, "__esModule", { value: !0 })
  var n = sc()
  function e(N) {
    return Array.prototype.slice.call(N)
  }
  function t(N, k) {
    var I = Math.floor(N)
    return I === k || I + 1 === k ? N : k
  }
  function i() {
    return Date.now()
  }
  function r(N, k, I) {
    if (((k = "data-keen-slider-" + k), I === null)) return N.removeAttribute(k)
    N.setAttribute(k, I || "")
  }
  function s(N, k) {
    return (
      (k = k || document),
      typeof N == "function" && (N = N(k)),
      Array.isArray(N)
        ? N
        : typeof N == "string"
        ? e(k.querySelectorAll(N))
        : N instanceof HTMLElement
        ? [N]
        : N instanceof NodeList
        ? e(N)
        : []
    )
  }
  function o(N) {
    N.raw && (N = N.raw), N.cancelable && !N.defaultPrevented && N.preventDefault()
  }
  function l(N) {
    N.raw && (N = N.raw), N.stopPropagation && N.stopPropagation()
  }
  function u() {
    var N = []
    return {
      add: function (k, I, V, Z) {
        k.addListener ? k.addListener(V) : k.addEventListener(I, V, Z),
          N.push([k, I, V, Z])
      },
      input: function (k, I, V, Z) {
        this.add(
          k,
          I,
          (function ($) {
            return function (ee) {
              ee.nativeEvent && (ee = ee.nativeEvent)
              var ue = ee.changedTouches || [],
                re = ee.targetTouches || [],
                se = ee.detail && ee.detail.x ? ee.detail : null
              return $({
                id: se
                  ? se.identifier
                    ? se.identifier
                    : "i"
                  : re[0]
                  ? re[0]
                    ? re[0].identifier
                    : "e"
                  : "d",
                idChanged: se
                  ? se.identifier
                    ? se.identifier
                    : "i"
                  : ue[0]
                  ? ue[0]
                    ? ue[0].identifier
                    : "e"
                  : "d",
                raw: ee,
                x: se && se.x ? se.x : re[0] ? re[0].screenX : se ? se.x : ee.pageX,
                y: se && se.y ? se.y : re[0] ? re[0].screenY : se ? se.y : ee.pageY,
              })
            }
          })(V),
          Z,
        )
      },
      purge: function () {
        N.forEach(function (k) {
          k[0].removeListener
            ? k[0].removeListener(k[2])
            : k[0].removeEventListener(k[1], k[2], k[3])
        }),
          (N = [])
      },
    }
  }
  function d(N, k, I) {
    return Math.min(Math.max(N, k), I)
  }
  function p(N) {
    return (N > 0 ? 1 : 0) - (N < 0 ? 1 : 0) || +N
  }
  function m(N) {
    var k = N.getBoundingClientRect()
    return { height: t(k.height, N.offsetHeight), width: t(k.width, N.offsetWidth) }
  }
  function v(N, k, I, V) {
    var Z = N && N[k]
    return Z == null ? I : V && typeof Z == "function" ? Z() : Z
  }
  function y(N) {
    return Math.round(1e6 * N) / 1e6
  }
  function x(N, k) {
    if (N === k) return !0
    var I = typeof N
    if (I !== typeof k) return !1
    if (I !== "object" || N === null || k === null)
      return I === "function" && N.toString() === k.toString()
    if (
      N.length !== k.length ||
      Object.getOwnPropertyNames(N).length !== Object.getOwnPropertyNames(k).length
    )
      return !1
    for (var V in N) if (!x(N[V], k[V])) return !1
    return !0
  }
  var E = function () {
    return (
      (E =
        Object.assign ||
        function (N) {
          for (var k, I = 1, V = arguments.length; I < V; I++)
            for (var Z in (k = arguments[I]))
              Object.prototype.hasOwnProperty.call(k, Z) && (N[Z] = k[Z])
          return N
        }),
      E.apply(this, arguments)
    )
  }
  function M(N, k, I) {
    for (var V, Z = 0, $ = k.length; Z < $; Z++)
      (!V && Z in k) || (V || (V = Array.prototype.slice.call(k, 0, Z)), (V[Z] = k[Z]))
    return N.concat(V || Array.prototype.slice.call(k))
  }
  function w(N) {
    var k, I, V, Z, $, ee
    function ue(Q) {
      ee || (ee = Q), re(!0)
      var W = Q - ee
      W > V && (W = V)
      var ne = Z[I]
      if (ne[3] < W) return I++, ue(Q)
      var ye = ne[2],
        oe = ne[4],
        fe = ne[0],
        we = ne[1] * (0, ne[5])(oe === 0 ? 1 : (W - ye) / oe)
      if ((we && N.track.to(fe + we), W < V)) return G()
      ;(ee = null), re(!1), se(null), N.emit("animationEnded")
    }
    function re(Q) {
      k.active = Q
    }
    function se(Q) {
      k.targetIdx = Q
    }
    function G() {
      var Q
      ;(Q = ue), ($ = window.requestAnimationFrame(Q))
    }
    function ie() {
      var Q
      ;(Q = $),
        window.cancelAnimationFrame(Q),
        re(!1),
        se(null),
        ee && N.emit("animationStopped"),
        (ee = null)
    }
    return (k = {
      active: !1,
      start: function (Q) {
        if ((ie(), N.track.details)) {
          var W = 0,
            ne = N.track.details.position
          ;(I = 0),
            (V = 0),
            (Z = Q.map(function (ye) {
              var oe,
                fe = Number(ne),
                we = (oe = ye.earlyExit) !== null && oe !== void 0 ? oe : ye.duration,
                me = ye.easing,
                Fe = ye.distance * me(we / ye.duration) || 0
              ne += Fe
              var ze = V
              return (V += we), (W += Fe), [fe, ye.distance, ze, V, ye.duration, me]
            })),
            se(N.track.distToIdx(W)),
            G(),
            N.emit("animationStarted")
        }
      },
      stop: ie,
      targetIdx: null,
    })
  }
  function A(N) {
    var k,
      I,
      V,
      Z,
      $,
      ee,
      ue,
      re,
      se,
      G,
      ie,
      Q,
      W,
      ne,
      ye = 1 / 0,
      oe = [],
      fe = null,
      we = 0
    function me(Pe) {
      Be(we + Pe)
    }
    function Fe(Pe) {
      var He = ze(we + Pe).abs
      return ae(He) ? He : null
    }
    function ze(Pe) {
      var He = Math.floor(Math.abs(y(Pe / I))),
        Se = y(((Pe % I) + I) % I)
      Se === I && (Se = 0)
      var j = p(Pe),
        B = ue.indexOf(
          M([], ue).reduce(function (Me, De) {
            return Math.abs(De - Se) < Math.abs(Me - Se) ? De : Me
          }),
        ),
        ce = B
      return (
        j < 0 && He++,
        B === ee && ((ce = 0), (He += j > 0 ? 1 : -1)),
        { abs: ce + He * ee * j, origin: B, rel: ce }
      )
    }
    function Ge(Pe, He, Se) {
      var j
      if (He || !K()) return Ue(Pe, Se)
      if (!ae(Pe)) return null
      var B = ze(Se ?? we),
        ce = B.abs,
        Me = Pe - B.rel,
        De = ce + Me
      j = Ue(De)
      var Ie = Ue(De - ee * p(Me))
      return (
        ((Ie !== null && Math.abs(Ie) < Math.abs(j)) || j === null) && (j = Ie), y(j)
      )
    }
    function Ue(Pe, He) {
      if ((He == null && (He = y(we)), !ae(Pe) || Pe === null)) return null
      Pe = Math.round(Pe)
      var Se = ze(He),
        j = Se.abs,
        B = Se.rel,
        ce = Se.origin,
        Me = Ke(Pe),
        De = ((He % I) + I) % I,
        Ie = ue[ce],
        st = Math.floor((Pe - (j - B)) / ee) * I
      return y(Ie - De - Ie + ue[Me] + st + (ce === ee ? I : 0))
    }
    function ae(Pe) {
      return Ee(Pe) === Pe
    }
    function Ee(Pe) {
      return d(Pe, se, G)
    }
    function K() {
      return Z.loop
    }
    function Ke(Pe) {
      return ((Pe % ee) + ee) % ee
    }
    function Be(Pe) {
      var He
      ;(He = Pe - we),
        oe.push({ distance: He, timestamp: i() }),
        oe.length > 6 && (oe = oe.slice(-6)),
        (we = y(Pe))
      var Se = Oe().abs
      if (Se !== fe) {
        var j = fe !== null
        ;(fe = Se), j && N.emit("slideChanged")
      }
    }
    function Oe(Pe) {
      var He = Pe
        ? null
        : (function () {
            if (ee) {
              var Se = K(),
                j = Se ? ((we % I) + I) % I : we,
                B = (Se ? we % I : we) - $[0][2],
                ce = 0 - (B < 0 && Se ? I - Math.abs(B) : B),
                Me = 0,
                De = ze(we),
                Ie = De.abs,
                st = De.rel,
                tt = $[st][2],
                it = $.map(function (Et, je) {
                  var Je = ce + Me
                  ;(Je < 0 - Et[0] || Je > 1) &&
                    (Je += (Math.abs(Je) > I - 1 && Se ? I : 0) * p(-Je))
                  var At = je - st,
                    Pt = p(At),
                    ft = At + Ie
                  Se &&
                    (Pt === -1 && Je > tt && (ft += ee),
                    Pt === 1 && Je < tt && (ft -= ee),
                    ie !== null && ft < ie && (Je += I),
                    Q !== null && ft > Q && (Je -= I))
                  var Wt = Je + Et[0] + Et[1],
                    Nt = Math.max(
                      Je >= 0 && Wt <= 1
                        ? 1
                        : Wt < 0 || Je > 1
                        ? 0
                        : Je < 0
                        ? Math.min(1, (Et[0] + Je) / Et[0])
                        : (1 - Je) / Et[0],
                      0,
                    )
                  return (
                    (Me += Et[0] + Et[1]),
                    {
                      abs: ft,
                      distance: Z.rtl ? -1 * Je + 1 - Et[0] : Je,
                      portion: Nt,
                      size: Et[0],
                    }
                  )
                })
              return (
                (Ie = Ee(Ie)),
                (st = Ke(Ie)),
                {
                  abs: Ee(Ie),
                  length: V,
                  max: ne,
                  maxIdx: G,
                  min: W,
                  minIdx: se,
                  position: we,
                  progress: Se ? j / I : we / V,
                  rel: st,
                  slides: it,
                  slidesLength: I,
                }
              )
            }
          })()
      return (k.details = He), N.emit("detailsChanged"), He
    }
    return (k = {
      absToRel: Ke,
      add: me,
      details: null,
      distToIdx: Fe,
      idxToDist: Ge,
      init: function (Pe) {
        if (
          ((function () {
            if (
              ((Z = N.options),
              ($ = (Z.trackConfig || []).map(function (B) {
                return [v(B, "size", 1), v(B, "spacing", 0), v(B, "origin", 0)]
              })),
              (ee = $.length))
            ) {
              I = y(
                $.reduce(function (B, ce) {
                  return B + ce[0] + ce[1]
                }, 0),
              )
              var Se,
                j = ee - 1
              ;(V = y(I + $[0][2] - $[j][0] - $[j][2] - $[j][1])),
                (ue = $.reduce(function (B, ce) {
                  if (!B) return [0]
                  var Me = $[B.length - 1],
                    De = B[B.length - 1] + (Me[0] + Me[2]) + Me[1]
                  return (
                    (De -= ce[2]),
                    B[B.length - 1] > De && (De = B[B.length - 1]),
                    (De = y(De)),
                    B.push(De),
                    (!Se || Se < De) && (re = B.length - 1),
                    (Se = De),
                    B
                  )
                }, null)),
                V === 0 && (re = 0),
                ue.push(y(I))
            }
          })(),
          !ee)
        )
          return Oe(!0)
        var He
        ;(function () {
          var Se = N.options.range,
            j = N.options.loop
          ;(ie = se = j ? v(j, "min", -1 / 0) : 0), (Q = G = j ? v(j, "max", ye) : re)
          var B = v(Se, "min", null),
            ce = v(Se, "max", null)
          B !== null && (se = B),
            ce !== null && (G = ce),
            (W = se === -1 / 0 ? se : N.track.idxToDist(se || 0, !0, 0)),
            (ne = G === ye ? G : Ge(G, !0, 0)),
            ce === null && (Q = G),
            v(Se, "align", !1) &&
              G !== ye &&
              $[Ke(G)][2] === 0 &&
              ((ne -= 1 - $[Ke(G)][0]), (G = Fe(ne - we))),
            (W = y(W)),
            (ne = y(ne))
        })(),
          (He = Pe),
          Number(He) === He ? me(Ue(Ee(Pe))) : Oe()
      },
      to: Be,
      velocity: function () {
        var Pe = i(),
          He = oe.reduce(
            function (Se, j) {
              var B = j.distance,
                ce = j.timestamp
              return (
                Pe - ce > 200 ||
                  (p(B) !== p(Se.distance) &&
                    Se.distance &&
                    (Se = { distance: 0, lastTimestamp: 0, time: 0 }),
                  Se.time && (Se.distance += B),
                  Se.lastTimestamp && (Se.time += ce - Se.lastTimestamp),
                  (Se.lastTimestamp = ce)),
                Se
              )
            },
            { distance: 0, lastTimestamp: 0, time: 0 },
          )
        return He.distance / He.time || 0
      },
    })
  }
  function C(N) {
    var k, I, V, Z, $, ee, ue, re
    function se(fe) {
      return 2 * fe
    }
    function G(fe) {
      return d(fe, ue, re)
    }
    function ie(fe) {
      return 1 - Math.pow(1 - fe, 3)
    }
    function Q() {
      return V ? N.track.velocity() : 0
    }
    function W() {
      oe()
      var fe = N.options.mode === "free-snap",
        we = N.track,
        me = Q()
      Z = p(me)
      var Fe = N.track.details,
        ze = []
      if (me || !fe) {
        var Ge = ne(me),
          Ue = Ge.dist,
          ae = Ge.dur
        if (((ae = se(ae)), (Ue *= Z), fe)) {
          var Ee = we.idxToDist(we.distToIdx(Ue), !0)
          Ee && (Ue = Ee)
        }
        ze.push({ distance: Ue, duration: ae, easing: ie })
        var K = Fe.position,
          Ke = K + Ue
        if (Ke < $ || Ke > ee) {
          var Be = Ke < $ ? $ - K : ee - K,
            Oe = 0,
            Pe = me
          if (p(Be) === Z) {
            var He = Math.min(Math.abs(Be) / Math.abs(Ue), 1),
              Se =
                (function (ce) {
                  return 1 - Math.pow(1 - ce, 1 / 3)
                })(He) * ae
            ;(ze[0].earlyExit = Se), (Pe = me * (1 - He))
          } else (ze[0].earlyExit = 0), (Oe += Be)
          var j = ne(Pe, 100),
            B = j.dist * Z
          N.options.rubberband &&
            (ze.push({ distance: B, duration: se(j.dur), easing: ie }),
            ze.push({ distance: -B + Oe, duration: 500, easing: ie }))
        }
        N.animator.start(ze)
      } else
        N.moveToIdx(G(Fe.abs), !0, {
          duration: 500,
          easing: function (ce) {
            return 1 + --ce * ce * ce * ce * ce
          },
        })
    }
    function ne(fe, we) {
      we === void 0 && (we = 1e3)
      var me = 147e-9 + (fe = Math.abs(fe)) / we
      return { dist: Math.pow(fe, 2) / me, dur: fe / me }
    }
    function ye() {
      var fe = N.track.details
      fe && (($ = fe.min), (ee = fe.max), (ue = fe.minIdx), (re = fe.maxIdx))
    }
    function oe() {
      N.animator.stop()
    }
    N.on("updated", ye),
      N.on("optionsChanged", ye),
      N.on("created", ye),
      N.on("dragStarted", function () {
        ;(V = !1), oe(), (k = I = N.track.details.abs)
      }),
      N.on("dragChecked", function () {
        V = !0
      }),
      N.on("dragEnded", function () {
        var fe = N.options.mode
        fe === "snap" &&
          (function () {
            var we = N.track,
              me = N.track.details,
              Fe = me.position,
              ze = p(Q())
            ;(Fe > ee || Fe < $) && (ze = 0)
            var Ge = k + ze
            me.slides[we.absToRel(Ge)].portion === 0 && (Ge -= ze),
              k !== I && (Ge = I),
              p(we.idxToDist(Ge, !0)) !== ze && (Ge += ze),
              (Ge = G(Ge))
            var Ue = we.idxToDist(Ge, !0)
            N.animator.start([
              {
                distance: Ue,
                duration: 500,
                easing: function (ae) {
                  return 1 + --ae * ae * ae * ae * ae
                },
              },
            ])
          })(),
          (fe !== "free" && fe !== "free-snap") || W()
      }),
      N.on("dragged", function () {
        I = N.track.details.abs
      })
  }
  function R(N) {
    var k,
      I,
      V,
      Z,
      $,
      ee,
      ue,
      re,
      se,
      G,
      ie,
      Q,
      W,
      ne,
      ye,
      oe,
      fe,
      we,
      me = u()
    function Fe(Oe) {
      if (ee && re === Oe.id) {
        var Pe = ae(Oe)
        if (se) {
          if (!Ue(Oe)) return Ge(Oe)
          ;(G = Pe), (se = !1), N.emit("dragChecked")
        }
        if (oe) return (G = Pe)
        o(Oe)
        var He = (function (j) {
          if (fe === -1 / 0 && we === 1 / 0) return j
          var B = N.track.details,
            ce = B.length,
            Me = B.position,
            De = d(j, fe - Me, we - Me)
          if (ce === 0) return 0
          if (!N.options.rubberband) return De
          if ((Me <= we && Me >= fe) || (Me < fe && I > 0) || (Me > we && I < 0))
            return j
          var Ie = (Me < fe ? Me - fe : Me - we) / ce,
            st = Z * ce,
            tt = Math.abs(Ie * st),
            it = Math.max(0, 1 - (tt / $) * 2)
          return it * it * j
        })((ue(G - Pe) / Z) * V)
        I = p(He)
        var Se = N.track.details.position
        ;((Se > fe && Se < we) || (Se === fe && I > 0) || (Se === we && I < 0)) &&
          l(Oe),
          (ie += He),
          !Q && Math.abs(ie * Z) > 5 && (Q = !0),
          N.track.add(He),
          (G = Pe),
          N.emit("dragged")
      }
    }
    function ze(Oe) {
      !ee &&
        N.track.details &&
        N.track.details.length &&
        ((ie = 0),
        (ee = !0),
        (Q = !1),
        (se = !0),
        (re = Oe.id),
        Ue(Oe),
        (G = ae(Oe)),
        N.emit("dragStarted"))
    }
    function Ge(Oe) {
      ee && re === Oe.idChanged && ((ee = !1), N.emit("dragEnded"))
    }
    function Ue(Oe) {
      var Pe = Ee(),
        He = Pe ? Oe.y : Oe.x,
        Se = Pe ? Oe.x : Oe.y,
        j = W !== void 0 && ne !== void 0 && Math.abs(ne - Se) <= Math.abs(W - He)
      return (W = He), (ne = Se), j
    }
    function ae(Oe) {
      return Ee() ? Oe.y : Oe.x
    }
    function Ee() {
      return N.options.vertical
    }
    function K() {
      ;(Z = N.size), ($ = Ee() ? window.innerHeight : window.innerWidth)
      var Oe = N.track.details
      Oe && ((fe = Oe.min), (we = Oe.max))
    }
    function Ke(Oe) {
      Q && (l(Oe), o(Oe))
    }
    function Be() {
      if ((me.purge(), N.options.drag && !N.options.disabled)) {
        var Oe
        ;(Oe = N.options.dragSpeed || 1),
          (ue =
            typeof Oe == "function"
              ? Oe
              : function (He) {
                  return He * Oe
                }),
          (V = N.options.rtl ? -1 : 1),
          K(),
          (k = N.container),
          (function () {
            var He = "data-keen-slider-clickable"
            s("[".concat(He, "]:not([").concat(He, "=false])"), k).map(function (Se) {
              me.add(Se, "dragstart", l),
                me.add(Se, "mousedown", l),
                me.add(Se, "touchstart", l)
            })
          })(),
          me.add(k, "dragstart", function (He) {
            o(He)
          }),
          me.add(k, "click", Ke, { capture: !0 }),
          me.input(k, "ksDragStart", ze),
          me.input(k, "ksDrag", Fe),
          me.input(k, "ksDragEnd", Ge),
          me.input(k, "mousedown", ze),
          me.input(k, "mousemove", Fe),
          me.input(k, "mouseleave", Ge),
          me.input(k, "mouseup", Ge),
          me.input(k, "touchstart", ze, { passive: !0 }),
          me.input(k, "touchmove", Fe, { passive: !1 }),
          me.input(k, "touchend", Ge),
          me.input(k, "touchcancel", Ge),
          me.add(window, "wheel", function (He) {
            ee && o(He)
          })
        var Pe = "data-keen-slider-scrollable"
        s("[".concat(Pe, "]:not([").concat(Pe, "=false])"), N.container).map(function (
          He,
        ) {
          return (function (Se) {
            var j
            me.input(
              Se,
              "touchstart",
              function (B) {
                ;(j = ae(B)), (oe = !0), (ye = !0)
              },
              { passive: !0 },
            ),
              me.input(Se, "touchmove", function (B) {
                var ce = Ee(),
                  Me = ce
                    ? Se.scrollHeight - Se.clientHeight
                    : Se.scrollWidth - Se.clientWidth,
                  De = j - ae(B),
                  Ie = ce ? Se.scrollTop : Se.scrollLeft,
                  st =
                    (ce && Se.style.overflowY === "scroll") ||
                    (!ce && Se.style.overflowX === "scroll")
                if (
                  ((j = ae(B)), ((De < 0 && Ie > 0) || (De > 0 && Ie < Me)) && ye && st)
                )
                  return (oe = !0)
                ;(ye = !1), o(B), (oe = !1)
              }),
              me.input(Se, "touchend", function () {
                oe = !1
              })
          })(He)
        })
      }
    }
    N.on("updated", K),
      N.on("optionsChanged", Be),
      N.on("created", Be),
      N.on("destroyed", me.purge)
  }
  function z(N) {
    var k,
      I,
      V = null
    function Z(W, ne, ye) {
      N.animator.active
        ? ee(W, ne, ye)
        : requestAnimationFrame(function () {
            return ee(W, ne, ye)
          })
    }
    function $() {
      Z(!1, !1, I)
    }
    function ee(W, ne, ye) {
      var oe = 0,
        fe = N.size,
        we = N.track.details
      if (we && k) {
        var me = we.slides
        k.forEach(function (Fe, ze) {
          if (W) !V && ne && re(Fe, null, ye), se(Fe, null, ye)
          else {
            if (!me[ze]) return
            var Ge = me[ze].size * fe
            !V && ne && re(Fe, Ge, ye),
              se(Fe, me[ze].distance * fe - oe, ye),
              (oe += Ge)
          }
        })
      }
    }
    function ue(W) {
      return N.options.renderMode === "performance" ? Math.round(W) : W
    }
    function re(W, ne, ye) {
      var oe = ye ? "height" : "width"
      ne !== null && (ne = ue(ne) + "px"),
        (W.style["min-" + oe] = ne),
        (W.style["max-" + oe] = ne)
    }
    function se(W, ne, ye) {
      if (ne !== null) {
        ne = ue(ne)
        var oe = ye ? ne : 0
        ne = "translate3d(".concat(ye ? 0 : ne, "px, ").concat(oe, "px, 0)")
      }
      ;(W.style.transform = ne), (W.style["-webkit-transform"] = ne)
    }
    function G() {
      k && (ee(!0, !0, I), (k = null)), N.on("detailsChanged", $, !0)
    }
    function ie() {
      Z(!1, !0, I)
    }
    function Q() {
      G(),
        (I = N.options.vertical),
        N.options.disabled ||
          N.options.renderMode === "custom" ||
          ((V = v(N.options.slides, "perView", null) === "auto"),
          N.on("detailsChanged", $),
          (k = N.slides).length && ie())
    }
    N.on("created", Q),
      N.on("optionsChanged", Q),
      N.on("beforeOptionsChanged", function () {
        G()
      }),
      N.on("updated", ie),
      N.on("destroyed", G)
  }
  function U(N, k) {
    return function (I) {
      var V,
        Z,
        $,
        ee,
        ue,
        re = u()
      function se(Ue) {
        var ae
        r(
          I.container,
          "reverse",
          ((ae = I.container),
          window.getComputedStyle(ae, null).getPropertyValue("direction") !== "rtl" ||
          Ue
            ? null
            : ""),
        ),
          r(I.container, "v", I.options.vertical && !Ue ? "" : null),
          r(I.container, "disabled", I.options.disabled && !Ue ? "" : null)
      }
      function G() {
        ie() && oe()
      }
      function ie() {
        var Ue = null
        if (
          (ee.forEach(function (Ee) {
            Ee.matches && (Ue = Ee.__media)
          }),
          Ue === V)
        )
          return !1
        V || I.emit("beforeOptionsChanged"), (V = Ue)
        var ae = Ue ? $.breakpoints[Ue] : $
        return (I.options = E(E({}, $), ae)), se(), ze(), Ge(), we(), !0
      }
      function Q(Ue) {
        var ae = m(Ue)
        return (I.options.vertical ? ae.height : ae.width) / I.size || 1
      }
      function W() {
        return I.options.trackConfig.length
      }
      function ne(Ue) {
        for (var ae in ((V = !1),
        ($ = E(E({}, k), Ue)),
        re.purge(),
        (Z = I.size),
        (ee = []),
        $.breakpoints || [])) {
          var Ee = window.matchMedia(ae)
          ;(Ee.__media = ae), ee.push(Ee), re.add(Ee, "change", G)
        }
        re.add(window, "orientationchange", Fe), re.add(window, "resize", me), ie()
      }
      function ye(Ue) {
        I.animator.stop()
        var ae = I.track.details
        I.track.init(Ue ?? (ae ? ae.abs : 0))
      }
      function oe(Ue) {
        ye(Ue), I.emit("optionsChanged")
      }
      function fe(Ue, ae) {
        if (Ue) return ne(Ue), void oe(ae)
        ze(), Ge()
        var Ee = W()
        we(), W() !== Ee ? oe(ae) : ye(ae), I.emit("updated")
      }
      function we() {
        var Ue = I.options.slides
        if (typeof Ue == "function")
          return (I.options.trackConfig = Ue(I.size, I.slides))
        for (
          var ae = I.slides,
            Ee = ae.length,
            K = typeof Ue == "number" ? Ue : v(Ue, "number", Ee, !0),
            Ke = [],
            Be = v(Ue, "perView", 1, !0),
            Oe = v(Ue, "spacing", 0, !0) / I.size || 0,
            Pe = Be === "auto" ? Oe : Oe / Be,
            He = v(Ue, "origin", "auto"),
            Se = 0,
            j = 0;
          j < K;
          j++
        ) {
          var B = Be === "auto" ? Q(ae[j]) : 1 / Be - Oe + Pe,
            ce = He === "center" ? 0.5 - B / 2 : He === "auto" ? 0 : He
          Ke.push({ origin: ce, size: B, spacing: Oe }), (Se += B)
        }
        if (((Se += Oe * (K - 1)), He === "auto" && !I.options.loop && Be !== 1)) {
          var Me = 0
          Ke.map(function (De) {
            var Ie = Se - Me
            return (
              (Me += De.size + Oe),
              Ie >= 1 || (De.origin = 1 - Ie - (Se > 1 ? 0 : 1 - Se)),
              De
            )
          })
        }
        I.options.trackConfig = Ke
      }
      function me() {
        ze()
        var Ue = I.size
        I.options.disabled || Ue === Z || ((Z = Ue), fe())
      }
      function Fe() {
        me(), setTimeout(me, 500), setTimeout(me, 2e3)
      }
      function ze() {
        var Ue = m(I.container)
        I.size = (I.options.vertical ? Ue.height : Ue.width) || 1
      }
      function Ge() {
        I.slides = s(I.options.selector, I.container)
      }
      ;(I.container = (ue = s(N, document)).length ? ue[0] : null),
        (I.destroy = function () {
          re.purge(), I.emit("destroyed"), se(!0)
        }),
        (I.prev = function () {
          I.moveToIdx(I.track.details.abs - 1, !0)
        }),
        (I.next = function () {
          I.moveToIdx(I.track.details.abs + 1, !0)
        }),
        (I.update = fe),
        ne(I.options)
    }
  }
  var O = function (N, k, I) {
    try {
      return (function (V, Z) {
        var $,
          ee = {}
        return (
          ($ = {
            emit: function (ue) {
              ee[ue] &&
                ee[ue].forEach(function (se) {
                  se($)
                })
              var re = $.options && $.options[ue]
              re && re($)
            },
            moveToIdx: function (ue, re, se) {
              var G = $.track.idxToDist(ue, re)
              if (G) {
                var ie = $.options.defaultAnimation
                $.animator.start([
                  {
                    distance: G,
                    duration: v(se || ie, "duration", 500),
                    easing: v(se || ie, "easing", function (Q) {
                      return 1 + --Q * Q * Q * Q * Q
                    }),
                  },
                ])
              }
            },
            on: function (ue, re, se) {
              se === void 0 && (se = !1), ee[ue] || (ee[ue] = [])
              var G = ee[ue].indexOf(re)
              G > -1 ? se && delete ee[ue][G] : se || ee[ue].push(re)
            },
            options: V,
          }),
          (function () {
            if ((($.track = A($)), ($.animator = w($)), Z))
              for (var ue = 0, re = Z; ue < re.length; ue++) (0, re[ue])($)
            $.track.init($.options.initial || 0), $.emit("created")
          })(),
          $
        )
      })(
        k,
        M(
          [
            U(N, {
              drag: !0,
              mode: "snap",
              renderMode: "precision",
              rubberband: !0,
              selector: ".keen-slider__slide",
            }),
            z,
            R,
            C,
          ],
          I || [],
          !0,
        ),
      )
    } catch (V) {
      console.error(V)
    }
  }
  return (
    (Mg.useKeenSlider = function (N, k) {
      var I = n.useRef(null),
        V = n.useRef(!1),
        Z = n.useRef(N),
        $ = n.useCallback(function (ee) {
          ee
            ? ((Z.current = N), (I.current = new O(ee, N, k)), (V.current = !1))
            : (I.current && I.current.destroy && I.current.destroy(),
              (I.current = null))
        }, [])
      return (
        n.useEffect(
          function () {
            x(Z.current, N) ||
              ((Z.current = N), I.current && I.current.update(Z.current))
          },
          [N],
        ),
        [$, I]
      )
    }),
    Mg
  )
}
var RP = CP(),
  nx = { exports: {} }
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ var aM
function PP() {
  return (
    aM ||
      ((aM = 1),
      (function (n) {
        ;(function () {
          var e = {}.hasOwnProperty
          function t() {
            for (var s = "", o = 0; o < arguments.length; o++) {
              var l = arguments[o]
              l && (s = r(s, i(l)))
            }
            return s
          }
          function i(s) {
            if (typeof s == "string" || typeof s == "number") return s
            if (typeof s != "object") return ""
            if (Array.isArray(s)) return t.apply(null, s)
            if (
              s.toString !== Object.prototype.toString &&
              !s.toString.toString().includes("[native code]")
            )
              return s.toString()
            var o = ""
            for (var l in s) e.call(s, l) && s[l] && (o = r(o, l))
            return o
          }
          function r(s, o) {
            return o ? (s ? s + " " + o : s + o) : s
          }
          n.exports ? ((t.default = t), (n.exports = t)) : (window.classNames = t)
        })()
      })(nx)),
    nx.exports
  )
}
var IP = PP()
const Xn = rm(IP)
function aA(n, e) {
  if (Object.is(n, e)) return !0
  if (typeof n != "object" || n === null || typeof e != "object" || e === null)
    return !1
  if (n instanceof Map && e instanceof Map) {
    if (n.size !== e.size) return !1
    for (const [i, r] of n) if (!Object.is(r, e.get(i))) return !1
    return !0
  }
  if (n instanceof Set && e instanceof Set) {
    if (n.size !== e.size) return !1
    for (const i of n) if (!e.has(i)) return !1
    return !0
  }
  const t = Object.keys(n)
  if (t.length !== Object.keys(e).length) return !1
  for (const i of t)
    if (!Object.prototype.hasOwnProperty.call(e, i) || !Object.is(n[i], e[i])) return !1
  return !0
}
const LP = {},
  lM = (n) => {
    let e
    const t = new Set(),
      i = (p, m) => {
        const v = typeof p == "function" ? p(e) : p
        if (!Object.is(v, e)) {
          const y = e
          ;(e =
            m ?? (typeof v != "object" || v === null) ? v : Object.assign({}, e, v)),
            t.forEach((x) => x(e, y))
        }
      },
      r = () => e,
      u = {
        setState: i,
        getState: r,
        getInitialState: () => d,
        subscribe: (p) => (t.add(p), () => t.delete(p)),
        destroy: () => {
          ;(LP ? "production" : void 0) !== "production" &&
            console.warn(
              "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected.",
            ),
            t.clear()
        },
      },
      d = (e = n(i, r, u))
    return u
  },
  DP = (n) => (n ? lM(n) : lM)
var ix = { exports: {} },
  rx = {},
  sx = { exports: {} },
  ox = {}
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var cM
function NP() {
  if (cM) return ox
  cM = 1
  var n = sc()
  function e(m, v) {
    return (m === v && (m !== 0 || 1 / m === 1 / v)) || (m !== m && v !== v)
  }
  var t = typeof Object.is == "function" ? Object.is : e,
    i = n.useState,
    r = n.useEffect,
    s = n.useLayoutEffect,
    o = n.useDebugValue
  function l(m, v) {
    var y = v(),
      x = i({ inst: { value: y, getSnapshot: v } }),
      E = x[0].inst,
      M = x[1]
    return (
      s(
        function () {
          ;(E.value = y), (E.getSnapshot = v), u(E) && M({ inst: E })
        },
        [m, y, v],
      ),
      r(
        function () {
          return (
            u(E) && M({ inst: E }),
            m(function () {
              u(E) && M({ inst: E })
            })
          )
        },
        [m],
      ),
      o(y),
      y
    )
  }
  function u(m) {
    var v = m.getSnapshot
    m = m.value
    try {
      var y = v()
      return !t(m, y)
    } catch {
      return !0
    }
  }
  function d(m, v) {
    return v()
  }
  var p =
    typeof window > "u" ||
    typeof window.document > "u" ||
    typeof window.document.createElement > "u"
      ? d
      : l
  return (
    (ox.useSyncExternalStore =
      n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : p),
    ox
  )
}
var uM
function kP() {
  return uM || ((uM = 1), (sx.exports = NP())), sx.exports
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var fM
function FP() {
  if (fM) return rx
  fM = 1
  var n = sc(),
    e = kP()
  function t(d, p) {
    return (d === p && (d !== 0 || 1 / d === 1 / p)) || (d !== d && p !== p)
  }
  var i = typeof Object.is == "function" ? Object.is : t,
    r = e.useSyncExternalStore,
    s = n.useRef,
    o = n.useEffect,
    l = n.useMemo,
    u = n.useDebugValue
  return (
    (rx.useSyncExternalStoreWithSelector = function (d, p, m, v, y) {
      var x = s(null)
      if (x.current === null) {
        var E = { hasValue: !1, value: null }
        x.current = E
      } else E = x.current
      x = l(
        function () {
          function w(U) {
            if (!A) {
              if (((A = !0), (C = U), (U = v(U)), y !== void 0 && E.hasValue)) {
                var O = E.value
                if (y(O, U)) return (R = O)
              }
              return (R = U)
            }
            if (((O = R), i(C, U))) return O
            var N = v(U)
            return y !== void 0 && y(O, N) ? ((C = U), O) : ((C = U), (R = N))
          }
          var A = !1,
            C,
            R,
            z = m === void 0 ? null : m
          return [
            function () {
              return w(p())
            },
            z === null
              ? void 0
              : function () {
                  return w(z())
                },
          ]
        },
        [p, m, v, y],
      )
      var M = r(d, x[0], x[1])
      return (
        o(
          function () {
            ;(E.hasValue = !0), (E.value = M)
          },
          [M],
        ),
        u(M),
        M
      )
    }),
    rx
  )
}
var dM
function UP() {
  return dM || ((dM = 1), (ix.exports = FP())), ix.exports
}
var OP = UP()
const BP = rm(OP),
  lA = {},
  { useDebugValue: zP } = Ht,
  { useSyncExternalStoreWithSelector: VP } = BP
let hM = !1
const HP = (n) => n
function GP(n, e = HP, t) {
  ;(lA ? "production" : void 0) !== "production" &&
    t &&
    !hM &&
    (console.warn(
      "[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937",
    ),
    (hM = !0))
  const i = VP(n.subscribe, n.getState, n.getServerState || n.getInitialState, e, t)
  return zP(i), i
}
const pM = (n) => {
    ;(lA ? "production" : void 0) !== "production" &&
      typeof n != "function" &&
      console.warn(
        "[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.",
      )
    const e = typeof n == "function" ? DP(n) : n,
      t = (i, r) => GP(e, i, r)
    return Object.assign(t, e), t
  },
  WP = (n) => (n ? pM(n) : pM),
  jP = (n, e) => ({
    message:
      'hi !! hover over something +<span class="block" />i’ll tell u all abt it ★',
    ingredientHover: "",
  }),
  XP = (n) => async (e) => {
    localStorage.setItem("message", JSON.stringify(e)), n({ message: e })
  },
  YP = (n) => async (e) => {
    localStorage.setItem("ingredientHover", JSON.stringify(e)),
      n({ ingredientHover: e })
  },
  cA = WP((...n) => ({
    ...jP(...n),
    setMessage: XP(...n),
    setIngredientHover: YP(...n),
  }))
var qP = oA(),
  $P = Object.defineProperty,
  KP = (n, e, t) =>
    e in n
      ? $P(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t })
      : (n[e] = t),
  ax = (n, e, t) => (KP(n, typeof e != "symbol" ? e + "" : e, t), t)
let ZP = class {
    constructor() {
      ax(this, "current", this.detect()),
        ax(this, "handoffState", "pending"),
        ax(this, "currentId", 0)
    }
    set(e) {
      this.current !== e &&
        ((this.handoffState = "pending"), (this.currentId = 0), (this.current = e))
    }
    reset() {
      this.set(this.detect())
    }
    nextId() {
      return ++this.currentId
    }
    get isServer() {
      return this.current === "server"
    }
    get isClient() {
      return this.current === "client"
    }
    detect() {
      return typeof window > "u" || typeof document > "u" ? "server" : "client"
    }
    handoff() {
      this.handoffState === "pending" && (this.handoffState = "complete")
    }
    get isHandoffComplete() {
      return this.handoffState === "complete"
    }
  },
  Wo = new ZP()
function sm(n) {
  var e
  return Wo.isServer
    ? null
    : n == null
    ? document
    : (e = n == null ? void 0 : n.ownerDocument) != null
    ? e
    : document
}
function B_(n) {
  var e, t
  return Wo.isServer
    ? null
    : n == null
    ? document
    : (t = (e = n == null ? void 0 : n.getRootNode) == null ? void 0 : e.call(n)) !=
      null
    ? t
    : document
}
function uA(n) {
  var e, t
  return (t = (e = B_(n)) == null ? void 0 : e.activeElement) != null ? t : null
}
function JP(n) {
  return uA(n) === n
}
function Pv(n) {
  typeof queueMicrotask == "function"
    ? queueMicrotask(n)
    : Promise.resolve()
        .then(n)
        .catch((e) =>
          setTimeout(() => {
            throw e
          }),
        )
}
function Qa() {
  let n = [],
    e = {
      addEventListener(t, i, r, s) {
        return t.addEventListener(i, r, s), e.add(() => t.removeEventListener(i, r, s))
      },
      requestAnimationFrame(...t) {
        let i = requestAnimationFrame(...t)
        return e.add(() => cancelAnimationFrame(i))
      },
      nextFrame(...t) {
        return e.requestAnimationFrame(() => e.requestAnimationFrame(...t))
      },
      setTimeout(...t) {
        let i = setTimeout(...t)
        return e.add(() => clearTimeout(i))
      },
      microTask(...t) {
        let i = { current: !0 }
        return (
          Pv(() => {
            i.current && t[0]()
          }),
          e.add(() => {
            i.current = !1
          })
        )
      },
      style(t, i, r) {
        let s = t.style.getPropertyValue(i)
        return (
          Object.assign(t.style, { [i]: r }),
          this.add(() => {
            Object.assign(t.style, { [i]: s })
          })
        )
      },
      group(t) {
        let i = Qa()
        return t(i), this.add(() => i.dispose())
      },
      add(t) {
        return (
          n.includes(t) || n.push(t),
          () => {
            let i = n.indexOf(t)
            if (i >= 0) for (let r of n.splice(i, 1)) r()
          }
        )
      },
      dispose() {
        for (let t of n.splice(0)) t()
      },
    }
  return e
}
function Iv() {
  let [n] = Y.useState(Qa)
  return Y.useEffect(() => () => n.dispose(), [n]), n
}
let es = (n, e) => {
  Wo.isServer ? Y.useEffect(n, e) : Y.useLayoutEffect(n, e)
}
function Uu(n) {
  let e = Y.useRef(n)
  return (
    es(() => {
      e.current = n
    }, [n]),
    e
  )
}
let Pn = function (n) {
  let e = Uu(n)
  return Ht.useCallback((...t) => e.current(...t), [e])
}
function om(n) {
  return Y.useMemo(() => n, Object.values(n))
}
let QP = Y.createContext(void 0)
function eI() {
  return Y.useContext(QP)
}
function z_(...n) {
  return Array.from(
    new Set(n.flatMap((e) => (typeof e == "string" ? e.split(" ") : []))),
  )
    .filter(Boolean)
    .join(" ")
}
function Ya(n, e, ...t) {
  if (n in e) {
    let r = e[n]
    return typeof r == "function" ? r(...t) : r
  }
  let i = new Error(
    `Tried to handle "${n}" but there is no handler defined. Only defined handlers are: ${Object.keys(
      e,
    )
      .map((r) => `"${r}"`)
      .join(", ")}.`,
  )
  throw (Error.captureStackTrace && Error.captureStackTrace(i, Ya), i)
}
var I0 = ((n) => (
    (n[(n.None = 0)] = "None"),
    (n[(n.RenderStrategy = 1)] = "RenderStrategy"),
    (n[(n.Static = 2)] = "Static"),
    n
  ))(I0 || {}),
  Kl = ((n) => ((n[(n.Unmount = 0)] = "Unmount"), (n[(n.Hidden = 1)] = "Hidden"), n))(
    Kl || {},
  )
function Us() {
  let n = nI()
  return Y.useCallback((e) => tI({ mergeRefs: n, ...e }), [n])
}
function tI({
  ourProps: n,
  theirProps: e,
  slot: t,
  defaultTag: i,
  features: r,
  visible: s = !0,
  name: o,
  mergeRefs: l,
}) {
  l = l ?? iI
  let u = fA(e, n)
  if (s) return Eg(u, t, i, o, l)
  let d = r ?? 0
  if (d & 2) {
    let { static: p = !1, ...m } = u
    if (p) return Eg(m, t, i, o, l)
  }
  if (d & 1) {
    let { unmount: p = !0, ...m } = u
    return Ya(p ? 0 : 1, {
      0() {
        return null
      },
      1() {
        return Eg({ ...m, hidden: !0, style: { display: "none" } }, t, i, o, l)
      },
    })
  }
  return Eg(u, t, i, o, l)
}
function Eg(n, e = {}, t, i, r) {
  let {
      as: s = t,
      children: o,
      refName: l = "ref",
      ...u
    } = lx(n, ["unmount", "static"]),
    d = n.ref !== void 0 ? { [l]: n.ref } : {},
    p = typeof o == "function" ? o(e) : o
  "className" in u &&
    u.className &&
    typeof u.className == "function" &&
    (u.className = u.className(e)),
    u["aria-labelledby"] &&
      u["aria-labelledby"] === u.id &&
      (u["aria-labelledby"] = void 0)
  let m = {}
  if (e) {
    let v = !1,
      y = []
    for (let [x, E] of Object.entries(e))
      typeof E == "boolean" && (v = !0),
        E === !0 && y.push(x.replace(/([A-Z])/g, (M) => `-${M.toLowerCase()}`))
    if (v) {
      m["data-headlessui-state"] = y.join(" ")
      for (let x of y) m[`data-${x}`] = ""
    }
  }
  if (gp(s) && (Object.keys(cu(u)).length > 0 || Object.keys(cu(m)).length > 0))
    if (!Y.isValidElement(p) || (Array.isArray(p) && p.length > 1) || sI(p)) {
      if (Object.keys(cu(u)).length > 0)
        throw new Error(
          [
            'Passing props on "Fragment"!',
            "",
            `The current component <${i} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(cu(u))
              .concat(Object.keys(cu(m)))
              .map((v) => `  - ${v}`).join(`
`),
            "",
            "You can apply a few solutions:",
            [
              'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
              "Render a single element as the child so that we can forward the props onto that element.",
            ].map((v) => `  - ${v}`).join(`
`),
          ].join(`
`),
        )
    } else {
      let v = p.props,
        y = v == null ? void 0 : v.className,
        x =
          typeof y == "function"
            ? (...w) => z_(y(...w), u.className)
            : z_(y, u.className),
        E = x ? { className: x } : {},
        M = fA(p.props, cu(lx(u, ["ref"])))
      for (let w in m) w in M && delete m[w]
      return Y.cloneElement(p, Object.assign({}, M, m, d, { ref: r(rI(p), d.ref) }, E))
    }
  return Y.createElement(
    s,
    Object.assign({}, lx(u, ["ref"]), !gp(s) && d, !gp(s) && m),
    p,
  )
}
function nI() {
  let n = Y.useRef([]),
    e = Y.useCallback((t) => {
      for (let i of n.current)
        i != null && (typeof i == "function" ? i(t) : (i.current = t))
    }, [])
  return (...t) => {
    if (!t.every((i) => i == null)) return (n.current = t), e
  }
}
function iI(...n) {
  return n.every((e) => e == null)
    ? void 0
    : (e) => {
        for (let t of n) t != null && (typeof t == "function" ? t(e) : (t.current = e))
      }
}
function fA(...n) {
  if (n.length === 0) return {}
  if (n.length === 1) return n[0]
  let e = {},
    t = {}
  for (let i of n)
    for (let r in i)
      r.startsWith("on") && typeof i[r] == "function"
        ? (t[r] != null || (t[r] = []), t[r].push(i[r]))
        : (e[r] = i[r])
  if (e.disabled || e["aria-disabled"])
    for (let i in t)
      /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(i) &&
        (t[i] = [
          (r) => {
            var s
            return (s = r == null ? void 0 : r.preventDefault) == null
              ? void 0
              : s.call(r)
          },
        ])
  for (let i in t)
    Object.assign(e, {
      [i](r, ...s) {
        let o = t[i]
        for (let l of o) {
          if (
            (r instanceof Event ||
              (r == null ? void 0 : r.nativeEvent) instanceof Event) &&
            r.defaultPrevented
          )
            return
          l(r, ...s)
        }
      },
    })
  return e
}
function ts(n) {
  var e
  return Object.assign(Y.forwardRef(n), {
    displayName: (e = n.displayName) != null ? e : n.name,
  })
}
function cu(n) {
  let e = Object.assign({}, n)
  for (let t in e) e[t] === void 0 && delete e[t]
  return e
}
function lx(n, e = []) {
  let t = Object.assign({}, n)
  for (let i of e) i in t && delete t[i]
  return t
}
function rI(n) {
  return Ht.version.split(".")[0] >= "19" ? n.props.ref : n.ref
}
function gp(n) {
  return n === Y.Fragment || n === Symbol.for("react.fragment")
}
function sI(n) {
  return gp(n.type)
}
let oI = "span"
var L0 = ((n) => (
  (n[(n.None = 1)] = "None"),
  (n[(n.Focusable = 2)] = "Focusable"),
  (n[(n.Hidden = 4)] = "Hidden"),
  n
))(L0 || {})
function aI(n, e) {
  var t
  let { features: i = 1, ...r } = n,
    s = {
      ref: e,
      "aria-hidden": (i & 2) === 2 ? !0 : (t = r["aria-hidden"]) != null ? t : void 0,
      hidden: (i & 4) === 4 ? !0 : void 0,
      style: {
        position: "fixed",
        top: 1,
        left: 1,
        width: 1,
        height: 0,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        borderWidth: "0",
        ...((i & 4) === 4 && (i & 2) !== 2 && { display: "none" }),
      },
    }
  return Us()({ ourProps: s, theirProps: r, slot: {}, defaultTag: oI, name: "Hidden" })
}
let V_ = ts(aI)
function lI(n) {
  return typeof n != "object" || n === null ? !1 : "nodeType" in n
}
function tc(n) {
  return lI(n) && "tagName" in n
}
function Ru(n) {
  return tc(n) && "accessKey" in n
}
function Zl(n) {
  return tc(n) && "tabIndex" in n
}
function cI(n) {
  return tc(n) && "style" in n
}
function uI(n) {
  return Ru(n) && n.nodeName === "IFRAME"
}
function fI(n) {
  return Ru(n) && n.nodeName === "INPUT"
}
let dA = Symbol()
function dI(n, e = !0) {
  return Object.assign(n, { [dA]: e })
}
function Zo(...n) {
  let e = Y.useRef(n)
  Y.useEffect(() => {
    e.current = n
  }, [n])
  let t = Pn((i) => {
    for (let r of e.current)
      r != null && (typeof r == "function" ? r(i) : (r.current = i))
  })
  return n.every((i) => i == null || (i == null ? void 0 : i[dA])) ? void 0 : t
}
let F1 = Y.createContext(null)
F1.displayName = "DescriptionContext"
function hA() {
  let n = Y.useContext(F1)
  if (n === null) {
    let e = new Error(
      "You used a <Description /> component, but it is not inside a relevant parent.",
    )
    throw (Error.captureStackTrace && Error.captureStackTrace(e, hA), e)
  }
  return n
}
function hI() {
  let [n, e] = Y.useState([])
  return [
    n.length > 0 ? n.join(" ") : void 0,
    Y.useMemo(
      () =>
        function (t) {
          let i = Pn(
              (s) => (
                e((o) => [...o, s]),
                () =>
                  e((o) => {
                    let l = o.slice(),
                      u = l.indexOf(s)
                    return u !== -1 && l.splice(u, 1), l
                  })
              ),
            ),
            r = Y.useMemo(
              () => ({
                register: i,
                slot: t.slot,
                name: t.name,
                props: t.props,
                value: t.value,
              }),
              [i, t.slot, t.name, t.props, t.value],
            )
          return Ht.createElement(F1.Provider, { value: r }, t.children)
        },
      [e],
    ),
  ]
}
let pI = "p"
function mI(n, e) {
  let t = Y.useId(),
    i = eI(),
    { id: r = `headlessui-description-${t}`, ...s } = n,
    o = hA(),
    l = Zo(e)
  es(() => o.register(r), [r, o.register])
  let u = om({ ...o.slot, disabled: i || !1 }),
    d = { ref: l, ...o.props, id: r }
  return Us()({
    ourProps: d,
    theirProps: s,
    slot: u,
    defaultTag: pI,
    name: o.name || "Description",
  })
}
let gI = ts(mI),
  vI = Object.assign(gI, {})
var pA = ((n) => (
  (n.Space = " "),
  (n.Enter = "Enter"),
  (n.Escape = "Escape"),
  (n.Backspace = "Backspace"),
  (n.Delete = "Delete"),
  (n.ArrowLeft = "ArrowLeft"),
  (n.ArrowUp = "ArrowUp"),
  (n.ArrowRight = "ArrowRight"),
  (n.ArrowDown = "ArrowDown"),
  (n.Home = "Home"),
  (n.End = "End"),
  (n.PageUp = "PageUp"),
  (n.PageDown = "PageDown"),
  (n.Tab = "Tab"),
  n
))(pA || {})
let yI = Y.createContext(() => {})
function xI({ value: n, children: e }) {
  return Ht.createElement(yI.Provider, { value: n }, e)
}
let mA = class extends Map {
  constructor(e) {
    super(), (this.factory = e)
  }
  get(e) {
    let t = super.get(e)
    return t === void 0 && ((t = this.factory(e)), this.set(e, t)), t
  }
}
var _I = Object.defineProperty,
  wI = (n, e, t) =>
    e in n
      ? _I(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t })
      : (n[e] = t),
  SI = (n, e, t) => (wI(n, e + "", t), t),
  gA = (n, e, t) => {
    if (!e.has(n)) throw TypeError("Cannot " + t)
  },
  Is = (n, e, t) => (gA(n, e, "read from private field"), t ? t.call(n) : e.get(n)),
  cx = (n, e, t) => {
    if (e.has(n)) throw TypeError("Cannot add the same private member more than once")
    e instanceof WeakSet ? e.add(n) : e.set(n, t)
  },
  mM = (n, e, t, i) => (gA(n, e, "write to private field"), e.set(n, t), t),
  zo,
  ap,
  lp
let MI = class {
  constructor(e) {
    cx(this, zo, {}),
      cx(this, ap, new mA(() => new Set())),
      cx(this, lp, new Set()),
      SI(this, "disposables", Qa()),
      mM(this, zo, e),
      Wo.isServer &&
        this.disposables.microTask(() => {
          this.dispose()
        })
  }
  dispose() {
    this.disposables.dispose()
  }
  get state() {
    return Is(this, zo)
  }
  subscribe(e, t) {
    if (Wo.isServer) return () => {}
    let i = { selector: e, callback: t, current: e(Is(this, zo)) }
    return (
      Is(this, lp).add(i),
      this.disposables.add(() => {
        Is(this, lp).delete(i)
      })
    )
  }
  on(e, t) {
    return Wo.isServer
      ? () => {}
      : (Is(this, ap).get(e).add(t),
        this.disposables.add(() => {
          Is(this, ap).get(e).delete(t)
        }))
  }
  send(e) {
    let t = this.reduce(Is(this, zo), e)
    if (t !== Is(this, zo)) {
      mM(this, zo, t)
      for (let i of Is(this, lp)) {
        let r = i.selector(Is(this, zo))
        vA(i.current, r) || ((i.current = r), i.callback(r))
      }
      for (let i of Is(this, ap).get(e.type)) i(Is(this, zo), e)
    }
  }
}
;(zo = new WeakMap()), (ap = new WeakMap()), (lp = new WeakMap())
function vA(n, e) {
  return Object.is(n, e)
    ? !0
    : typeof n != "object" || n === null || typeof e != "object" || e === null
    ? !1
    : Array.isArray(n) && Array.isArray(e)
    ? n.length !== e.length
      ? !1
      : ux(n[Symbol.iterator](), e[Symbol.iterator]())
    : (n instanceof Map && e instanceof Map) || (n instanceof Set && e instanceof Set)
    ? n.size !== e.size
      ? !1
      : ux(n.entries(), e.entries())
    : gM(n) && gM(e)
    ? ux(Object.entries(n)[Symbol.iterator](), Object.entries(e)[Symbol.iterator]())
    : !1
}
function ux(n, e) {
  do {
    let t = n.next(),
      i = e.next()
    if (t.done && i.done) return !0
    if (t.done || i.done || !Object.is(t.value, i.value)) return !1
  } while (!0)
}
function gM(n) {
  if (Object.prototype.toString.call(n) !== "[object Object]") return !1
  let e = Object.getPrototypeOf(n)
  return e === null || Object.getPrototypeOf(e) === null
}
var EI = Object.defineProperty,
  TI = (n, e, t) =>
    e in n
      ? EI(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t })
      : (n[e] = t),
  vM = (n, e, t) => (TI(n, typeof e != "symbol" ? e + "" : e, t), t),
  bI = ((n) => ((n[(n.Push = 0)] = "Push"), (n[(n.Pop = 1)] = "Pop"), n))(bI || {})
let AI = {
    0(n, e) {
      let t = e.id,
        i = n.stack,
        r = n.stack.indexOf(t)
      if (r !== -1) {
        let s = n.stack.slice()
        return s.splice(r, 1), s.push(t), (i = s), { ...n, stack: i }
      }
      return { ...n, stack: [...n.stack, t] }
    },
    1(n, e) {
      let t = e.id,
        i = n.stack.indexOf(t)
      if (i === -1) return n
      let r = n.stack.slice()
      return r.splice(i, 1), { ...n, stack: r }
    },
  },
  CI = class yA extends MI {
    constructor() {
      super(...arguments),
        vM(this, "actions", {
          push: (e) => this.send({ type: 0, id: e }),
          pop: (e) => this.send({ type: 1, id: e }),
        }),
        vM(this, "selectors", {
          isTop: (e, t) => e.stack[e.stack.length - 1] === t,
          inStack: (e, t) => e.stack.includes(t),
        })
    }
    static new() {
      return new yA({ stack: [] })
    }
    reduce(e, t) {
      return Ya(t.type, AI, e, t)
    }
  }
const xA = new mA(() => CI.new())
var fx = { exports: {} },
  dx = {}
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var yM
function RI() {
  if (yM) return dx
  yM = 1
  var n = sc()
  function e(u, d) {
    return (u === d && (u !== 0 || 1 / u === 1 / d)) || (u !== u && d !== d)
  }
  var t = typeof Object.is == "function" ? Object.is : e,
    i = n.useSyncExternalStore,
    r = n.useRef,
    s = n.useEffect,
    o = n.useMemo,
    l = n.useDebugValue
  return (
    (dx.useSyncExternalStoreWithSelector = function (u, d, p, m, v) {
      var y = r(null)
      if (y.current === null) {
        var x = { hasValue: !1, value: null }
        y.current = x
      } else x = y.current
      y = o(
        function () {
          function M(z) {
            if (!w) {
              if (((w = !0), (A = z), (z = m(z)), v !== void 0 && x.hasValue)) {
                var U = x.value
                if (v(U, z)) return (C = U)
              }
              return (C = z)
            }
            if (((U = C), t(A, z))) return U
            var O = m(z)
            return v !== void 0 && v(U, O) ? ((A = z), U) : ((A = z), (C = O))
          }
          var w = !1,
            A,
            C,
            R = p === void 0 ? null : p
          return [
            function () {
              return M(d())
            },
            R === null
              ? void 0
              : function () {
                  return M(R())
                },
          ]
        },
        [d, p, m, v],
      )
      var E = i(u, y[0], y[1])
      return (
        s(
          function () {
            ;(x.hasValue = !0), (x.value = E)
          },
          [E],
        ),
        l(E),
        E
      )
    }),
    dx
  )
}
var xM
function PI() {
  return xM || ((xM = 1), (fx.exports = RI())), fx.exports
}
var II = PI()
function _A(n, e, t = vA) {
  return II.useSyncExternalStoreWithSelector(
    Pn((i) => n.subscribe(LI, i)),
    Pn(() => n.state),
    Pn(() => n.state),
    Pn(e),
    t,
  )
}
function LI(n) {
  return n
}
function am(n, e) {
  let t = Y.useId(),
    i = xA.get(e),
    [r, s] = _A(
      i,
      Y.useCallback(
        (o) => [i.selectors.isTop(o, t), i.selectors.inStack(o, t)],
        [i, t],
      ),
    )
  return (
    es(() => {
      if (n) return i.actions.push(t), () => i.actions.pop(t)
    }, [i, n, t]),
    n ? (s ? r : !0) : !1
  )
}
let H_ = new Map(),
  vp = new Map()
function _M(n) {
  var e
  let t = (e = vp.get(n)) != null ? e : 0
  return (
    vp.set(n, t + 1),
    t !== 0
      ? () => wM(n)
      : (H_.set(n, { "aria-hidden": n.getAttribute("aria-hidden"), inert: n.inert }),
        n.setAttribute("aria-hidden", "true"),
        (n.inert = !0),
        () => wM(n))
  )
}
function wM(n) {
  var e
  let t = (e = vp.get(n)) != null ? e : 1
  if ((t === 1 ? vp.delete(n) : vp.set(n, t - 1), t !== 1)) return
  let i = H_.get(n)
  i &&
    (i["aria-hidden"] === null
      ? n.removeAttribute("aria-hidden")
      : n.setAttribute("aria-hidden", i["aria-hidden"]),
    (n.inert = i.inert),
    H_.delete(n))
}
function DI(n, { allowed: e, disallowed: t } = {}) {
  let i = am(n, "inert-others")
  es(() => {
    var r, s
    if (!i) return
    let o = Qa()
    for (let u of (r = t == null ? void 0 : t()) != null ? r : []) u && o.add(_M(u))
    let l = (s = e == null ? void 0 : e()) != null ? s : []
    for (let u of l) {
      if (!u) continue
      let d = sm(u)
      if (!d) continue
      let p = u.parentElement
      for (; p && p !== d.body; ) {
        for (let m of p.children) l.some((v) => m.contains(v)) || o.add(_M(m))
        p = p.parentElement
      }
    }
    return o.dispose
  }, [i, e, t])
}
function NI(n, e, t) {
  let i = Uu((r) => {
    let s = r.getBoundingClientRect()
    s.x === 0 && s.y === 0 && s.width === 0 && s.height === 0 && t()
  })
  Y.useEffect(() => {
    if (!n) return
    let r = e === null ? null : Ru(e) ? e : e.current
    if (!r) return
    let s = Qa()
    if (typeof ResizeObserver < "u") {
      let o = new ResizeObserver(() => i.current(r))
      o.observe(r), s.add(() => o.disconnect())
    }
    if (typeof IntersectionObserver < "u") {
      let o = new IntersectionObserver(() => i.current(r))
      o.observe(r), s.add(() => o.disconnect())
    }
    return () => s.dispose()
  }, [e, i, n])
}
let D0 = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "details>summary",
    "textarea:not([disabled])",
  ]
    .map((n) => `${n}:not([tabindex='-1'])`)
    .join(","),
  kI = ["[data-autofocus]"].map((n) => `${n}:not([tabindex='-1'])`).join(",")
var Ba = ((n) => (
    (n[(n.First = 1)] = "First"),
    (n[(n.Previous = 2)] = "Previous"),
    (n[(n.Next = 4)] = "Next"),
    (n[(n.Last = 8)] = "Last"),
    (n[(n.WrapAround = 16)] = "WrapAround"),
    (n[(n.NoScroll = 32)] = "NoScroll"),
    (n[(n.AutoFocus = 64)] = "AutoFocus"),
    n
  ))(Ba || {}),
  G_ = ((n) => (
    (n[(n.Error = 0)] = "Error"),
    (n[(n.Overflow = 1)] = "Overflow"),
    (n[(n.Success = 2)] = "Success"),
    (n[(n.Underflow = 3)] = "Underflow"),
    n
  ))(G_ || {}),
  FI = ((n) => ((n[(n.Previous = -1)] = "Previous"), (n[(n.Next = 1)] = "Next"), n))(
    FI || {},
  )
function UI(n = document.body) {
  return n == null
    ? []
    : Array.from(n.querySelectorAll(D0)).sort((e, t) =>
        Math.sign(
          (e.tabIndex || Number.MAX_SAFE_INTEGER) -
            (t.tabIndex || Number.MAX_SAFE_INTEGER),
        ),
      )
}
function OI(n = document.body) {
  return n == null
    ? []
    : Array.from(n.querySelectorAll(kI)).sort((e, t) =>
        Math.sign(
          (e.tabIndex || Number.MAX_SAFE_INTEGER) -
            (t.tabIndex || Number.MAX_SAFE_INTEGER),
        ),
      )
}
var wA = ((n) => ((n[(n.Strict = 0)] = "Strict"), (n[(n.Loose = 1)] = "Loose"), n))(
  wA || {},
)
function BI(n, e = 0) {
  var t
  return n === ((t = sm(n)) == null ? void 0 : t.body)
    ? !1
    : Ya(e, {
        0() {
          return n.matches(D0)
        },
        1() {
          let i = n
          for (; i !== null; ) {
            if (i.matches(D0)) return !0
            i = i.parentElement
          }
          return !1
        },
      })
}
var zI = ((n) => ((n[(n.Keyboard = 0)] = "Keyboard"), (n[(n.Mouse = 1)] = "Mouse"), n))(
  zI || {},
)
typeof window < "u" &&
  typeof document < "u" &&
  (document.addEventListener(
    "keydown",
    (n) => {
      n.metaKey ||
        n.altKey ||
        n.ctrlKey ||
        (document.documentElement.dataset.headlessuiFocusVisible = "")
    },
    !0,
  ),
  document.addEventListener(
    "click",
    (n) => {
      n.detail === 1
        ? delete document.documentElement.dataset.headlessuiFocusVisible
        : n.detail === 0 &&
          (document.documentElement.dataset.headlessuiFocusVisible = "")
    },
    !0,
  ))
function Ga(n) {
  n == null || n.focus({ preventScroll: !0 })
}
let VI = ["textarea", "input"].join(",")
function HI(n) {
  var e, t
  return (t = (e = n == null ? void 0 : n.matches) == null ? void 0 : e.call(n, VI)) !=
    null
    ? t
    : !1
}
function GI(n, e = (t) => t) {
  return n.slice().sort((t, i) => {
    let r = e(t),
      s = e(i)
    if (r === null || s === null) return 0
    let o = r.compareDocumentPosition(s)
    return o & Node.DOCUMENT_POSITION_FOLLOWING
      ? -1
      : o & Node.DOCUMENT_POSITION_PRECEDING
      ? 1
      : 0
  })
}
function yp(n, e, { sorted: t = !0, relativeTo: i = null, skipElements: r = [] } = {}) {
  let s = Array.isArray(n) ? (n.length > 0 ? B_(n[0]) : document) : B_(n),
    o = Array.isArray(n) ? (t ? GI(n) : n) : e & 64 ? OI(n) : UI(n)
  r.length > 0 &&
    o.length > 1 &&
    (o = o.filter(
      (y) =>
        !r.some((x) =>
          x != null && "current" in x
            ? (x == null ? void 0 : x.current) === y
            : x === y,
        ),
    )),
    (i = i ?? (s == null ? void 0 : s.activeElement))
  let l = (() => {
      if (e & 5) return 1
      if (e & 10) return -1
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")
    })(),
    u = (() => {
      if (e & 1) return 0
      if (e & 2) return Math.max(0, o.indexOf(i)) - 1
      if (e & 4) return Math.max(0, o.indexOf(i)) + 1
      if (e & 8) return o.length - 1
      throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last")
    })(),
    d = e & 32 ? { preventScroll: !0 } : {},
    p = 0,
    m = o.length,
    v
  do {
    if (p >= m || p + m <= 0) return 0
    let y = u + p
    if (e & 16) y = (y + m) % m
    else {
      if (y < 0) return 3
      if (y >= m) return 1
    }
    ;(v = o[y]), v == null || v.focus(d), (p += l)
  } while (v !== uA(v))
  return e & 6 && HI(v) && v.select(), 2
}
function SA() {
  return (
    /iPhone/gi.test(window.navigator.platform) ||
    (/Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0)
  )
}
function WI() {
  return /Android/gi.test(window.navigator.userAgent)
}
function SM() {
  return SA() || WI()
}
function Tg(n, e, t, i) {
  let r = Uu(t)
  Y.useEffect(() => {
    if (!n) return
    function s(o) {
      r.current(o)
    }
    return (
      document.addEventListener(e, s, i), () => document.removeEventListener(e, s, i)
    )
  }, [n, e, i])
}
function MA(n, e, t, i) {
  let r = Uu(t)
  Y.useEffect(() => {
    if (!n) return
    function s(o) {
      r.current(o)
    }
    return window.addEventListener(e, s, i), () => window.removeEventListener(e, s, i)
  }, [n, e, i])
}
const MM = 30
function jI(n, e, t) {
  let i = Uu(t),
    r = Y.useCallback(
      function (l, u) {
        if (l.defaultPrevented) return
        let d = u(l)
        if (d === null || !d.getRootNode().contains(d) || !d.isConnected) return
        let p = (function m(v) {
          return typeof v == "function"
            ? m(v())
            : Array.isArray(v) || v instanceof Set
            ? v
            : [v]
        })(e)
        for (let m of p)
          if (
            m !== null &&
            (m.contains(d) || (l.composed && l.composedPath().includes(m)))
          )
            return
        return (
          !BI(d, wA.Loose) && d.tabIndex !== -1 && l.preventDefault(), i.current(l, d)
        )
      },
      [i, e],
    ),
    s = Y.useRef(null)
  Tg(
    n,
    "pointerdown",
    (l) => {
      var u, d
      SM() ||
        (s.current =
          ((d = (u = l.composedPath) == null ? void 0 : u.call(l)) == null
            ? void 0
            : d[0]) || l.target)
    },
    !0,
  ),
    Tg(
      n,
      "pointerup",
      (l) => {
        if (SM() || !s.current) return
        let u = s.current
        return (s.current = null), r(l, () => u)
      },
      !0,
    )
  let o = Y.useRef({ x: 0, y: 0 })
  Tg(
    n,
    "touchstart",
    (l) => {
      ;(o.current.x = l.touches[0].clientX), (o.current.y = l.touches[0].clientY)
    },
    !0,
  ),
    Tg(
      n,
      "touchend",
      (l) => {
        let u = { x: l.changedTouches[0].clientX, y: l.changedTouches[0].clientY }
        if (!(Math.abs(u.x - o.current.x) >= MM || Math.abs(u.y - o.current.y) >= MM))
          return r(l, () => (Zl(l.target) ? l.target : null))
      },
      !0,
    ),
    MA(
      n,
      "blur",
      (l) =>
        r(l, () =>
          uI(window.document.activeElement) ? window.document.activeElement : null,
        ),
      !0,
    )
}
function U1(...n) {
  return Y.useMemo(() => sm(...n), [...n])
}
function EA(n, e, t, i) {
  let r = Uu(t)
  Y.useEffect(() => {
    n = n ?? window
    function s(o) {
      r.current(o)
    }
    return n.addEventListener(e, s, i), () => n.removeEventListener(e, s, i)
  }, [n, e, i])
}
function XI(n) {
  return Y.useSyncExternalStore(n.subscribe, n.getSnapshot, n.getSnapshot)
}
function YI(n, e) {
  let t = n(),
    i = new Set()
  return {
    getSnapshot() {
      return t
    },
    subscribe(r) {
      return i.add(r), () => i.delete(r)
    },
    dispatch(r, ...s) {
      let o = e[r].call(t, ...s)
      o && ((t = o), i.forEach((l) => l()))
    },
  }
}
function qI() {
  let n
  return {
    before({ doc: e }) {
      var t
      let i = e.documentElement,
        r = (t = e.defaultView) != null ? t : window
      n = Math.max(0, r.innerWidth - i.clientWidth)
    },
    after({ doc: e, d: t }) {
      let i = e.documentElement,
        r = Math.max(0, i.clientWidth - i.offsetWidth),
        s = Math.max(0, n - r)
      t.style(i, "paddingRight", `${s}px`)
    },
  }
}
function $I() {
  return SA()
    ? {
        before({ doc: n, d: e, meta: t }) {
          function i(r) {
            for (let s of t().containers)
              for (let o of s()) if (o.contains(r)) return !0
            return !1
          }
          e.microTask(() => {
            var r
            if (window.getComputedStyle(n.documentElement).scrollBehavior !== "auto") {
              let l = Qa()
              l.style(n.documentElement, "scrollBehavior", "auto"),
                e.add(() => e.microTask(() => l.dispose()))
            }
            let s = (r = window.scrollY) != null ? r : window.pageYOffset,
              o = null
            e.addEventListener(
              n,
              "click",
              (l) => {
                if (Zl(l.target))
                  try {
                    let u = l.target.closest("a")
                    if (!u) return
                    let { hash: d } = new URL(u.href),
                      p = n.querySelector(d)
                    Zl(p) && !i(p) && (o = p)
                  } catch {}
              },
              !0,
            ),
              e.group((l) => {
                e.addEventListener(n, "touchstart", (u) => {
                  if ((l.dispose(), Zl(u.target) && cI(u.target)))
                    if (i(u.target)) {
                      let d = u.target
                      for (; d.parentElement && i(d.parentElement); )
                        d = d.parentElement
                      l.style(d, "overscrollBehavior", "contain")
                    } else l.style(u.target, "touchAction", "none")
                })
              }),
              e.addEventListener(
                n,
                "touchmove",
                (l) => {
                  if (Zl(l.target)) {
                    if (fI(l.target)) return
                    if (i(l.target)) {
                      let u = l.target
                      for (
                        ;
                        u.parentElement &&
                        u.dataset.headlessuiPortal !== "" &&
                        !(
                          u.scrollHeight > u.clientHeight ||
                          u.scrollWidth > u.clientWidth
                        );

                      )
                        u = u.parentElement
                      u.dataset.headlessuiPortal === "" && l.preventDefault()
                    } else l.preventDefault()
                  }
                },
                { passive: !1 },
              ),
              e.add(() => {
                var l
                let u = (l = window.scrollY) != null ? l : window.pageYOffset
                s !== u && window.scrollTo(0, s),
                  o &&
                    o.isConnected &&
                    (o.scrollIntoView({ block: "nearest" }), (o = null))
              })
          })
        },
      }
    : {}
}
function KI() {
  return {
    before({ doc: n, d: e }) {
      e.style(n.documentElement, "overflow", "hidden")
    },
  }
}
function EM(n) {
  let e = {}
  for (let t of n) Object.assign(e, t(e))
  return e
}
let mu = YI(() => new Map(), {
  PUSH(n, e) {
    var t
    let i =
      (t = this.get(n)) != null
        ? t
        : { doc: n, count: 0, d: Qa(), meta: new Set(), computedMeta: {} }
    return i.count++, i.meta.add(e), (i.computedMeta = EM(i.meta)), this.set(n, i), this
  },
  POP(n, e) {
    let t = this.get(n)
    return t && (t.count--, t.meta.delete(e), (t.computedMeta = EM(t.meta))), this
  },
  SCROLL_PREVENT(n) {
    let e = {
        doc: n.doc,
        d: n.d,
        meta() {
          return n.computedMeta
        },
      },
      t = [$I(), qI(), KI()]
    t.forEach(({ before: i }) => (i == null ? void 0 : i(e))),
      t.forEach(({ after: i }) => (i == null ? void 0 : i(e)))
  },
  SCROLL_ALLOW({ d: n }) {
    n.dispose()
  },
  TEARDOWN({ doc: n }) {
    this.delete(n)
  },
})
mu.subscribe(() => {
  let n = mu.getSnapshot(),
    e = new Map()
  for (let [t] of n) e.set(t, t.documentElement.style.overflow)
  for (let t of n.values()) {
    let i = e.get(t.doc) === "hidden",
      r = t.count !== 0
    ;((r && !i) || (!r && i)) &&
      mu.dispatch(t.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", t),
      t.count === 0 && mu.dispatch("TEARDOWN", t)
  }
})
function ZI(n, e, t = () => ({ containers: [] })) {
  let i = XI(mu),
    r = e ? i.get(e) : void 0,
    s = r ? r.count > 0 : !1
  return (
    es(() => {
      if (!(!e || !n)) return mu.dispatch("PUSH", e, t), () => mu.dispatch("POP", e, t)
    }, [n, e]),
    s
  )
}
function JI(n, e, t = () => [document.body]) {
  let i = am(n, "scroll-lock")
  ZI(i, e, (r) => {
    var s
    return { containers: [...((s = r.containers) != null ? s : []), t] }
  })
}
function QI(n = 0) {
  let [e, t] = Y.useState(n),
    i = Y.useCallback((u) => t(u), []),
    r = Y.useCallback((u) => t((d) => d | u), []),
    s = Y.useCallback((u) => (e & u) === u, [e]),
    o = Y.useCallback((u) => t((d) => d & ~u), []),
    l = Y.useCallback((u) => t((d) => d ^ u), [])
  return { flags: e, setFlag: i, addFlag: r, hasFlag: s, removeFlag: o, toggleFlag: l }
}
var eL = {},
  TM,
  bM
typeof process < "u" &&
  typeof globalThis < "u" &&
  typeof Element < "u" &&
  ((TM = process == null ? void 0 : eL) == null ? void 0 : TM.NODE_ENV) === "test" &&
  typeof ((bM = Element == null ? void 0 : Element.prototype) == null
    ? void 0
    : bM.getAnimations) > "u" &&
  (Element.prototype.getAnimations = function () {
    return (
      console.warn(
        [
          "Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.",
          "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.",
          "",
          "Example usage:",
          "```js",
          "import { mockAnimationsApi } from 'jsdom-testing-mocks'",
          "mockAnimationsApi()",
          "```",
        ].join(`
`),
      ),
      []
    )
  })
var tL = ((n) => (
  (n[(n.None = 0)] = "None"),
  (n[(n.Closed = 1)] = "Closed"),
  (n[(n.Enter = 2)] = "Enter"),
  (n[(n.Leave = 4)] = "Leave"),
  n
))(tL || {})
function nL(n) {
  let e = {}
  for (let t in n) n[t] === !0 && (e[`data-${t}`] = "")
  return e
}
function iL(n, e, t, i) {
  let [r, s] = Y.useState(t),
    { hasFlag: o, addFlag: l, removeFlag: u } = QI(n && r ? 3 : 0),
    d = Y.useRef(!1),
    p = Y.useRef(!1),
    m = Iv()
  return (
    es(() => {
      var v
      if (n) {
        if ((t && s(!0), !e)) {
          t && l(3)
          return
        }
        return (
          (v = i == null ? void 0 : i.start) == null || v.call(i, t),
          rL(e, {
            inFlight: d,
            prepare() {
              p.current ? (p.current = !1) : (p.current = d.current),
                (d.current = !0),
                !p.current && (t ? (l(3), u(4)) : (l(4), u(2)))
            },
            run() {
              p.current ? (t ? (u(3), l(4)) : (u(4), l(3))) : t ? u(1) : l(1)
            },
            done() {
              var y
              ;(p.current && aL(e)) ||
                ((d.current = !1),
                u(7),
                t || s(!1),
                (y = i == null ? void 0 : i.end) == null || y.call(i, t))
            },
          })
        )
      }
    }, [n, t, e, m]),
    n
      ? [r, { closed: o(1), enter: o(2), leave: o(4), transition: o(2) || o(4) }]
      : [t, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }]
  )
}
function rL(n, { prepare: e, run: t, done: i, inFlight: r }) {
  let s = Qa()
  return (
    oL(n, { prepare: e, inFlight: r }),
    s.nextFrame(() => {
      t(),
        s.requestAnimationFrame(() => {
          s.add(sL(n, i))
        })
    }),
    s.dispose
  )
}
function sL(n, e) {
  var t, i
  let r = Qa()
  if (!n) return r.dispose
  let s = !1
  r.add(() => {
    s = !0
  })
  let o =
    (i =
      (t = n.getAnimations) == null
        ? void 0
        : t.call(n).filter((l) => l instanceof CSSTransition)) != null
      ? i
      : []
  return o.length === 0
    ? (e(), r.dispose)
    : (Promise.allSettled(o.map((l) => l.finished)).then(() => {
        s || e()
      }),
      r.dispose)
}
function oL(n, { inFlight: e, prepare: t }) {
  if (e != null && e.current) {
    t()
    return
  }
  let i = n.style.transition
  ;(n.style.transition = "none"), t(), n.offsetHeight, (n.style.transition = i)
}
function aL(n) {
  var e, t
  return (
    (t = (e = n.getAnimations) == null ? void 0 : e.call(n)) != null ? t : []
  ).some((i) => i instanceof CSSTransition && i.playState !== "finished")
}
function O1(n, e) {
  let t = Y.useRef([]),
    i = Pn(n)
  Y.useEffect(() => {
    let r = [...t.current]
    for (let [s, o] of e.entries())
      if (t.current[s] !== o) {
        let l = i(e, r)
        return (t.current = e), l
      }
  }, [i, ...e])
}
let Lv = Y.createContext(null)
Lv.displayName = "OpenClosedContext"
var xo = ((n) => (
  (n[(n.Open = 1)] = "Open"),
  (n[(n.Closed = 2)] = "Closed"),
  (n[(n.Closing = 4)] = "Closing"),
  (n[(n.Opening = 8)] = "Opening"),
  n
))(xo || {})
function Dv() {
  return Y.useContext(Lv)
}
function lL({ value: n, children: e }) {
  return Ht.createElement(Lv.Provider, { value: n }, e)
}
function cL({ children: n }) {
  return Ht.createElement(Lv.Provider, { value: null }, n)
}
function uL(n) {
  function e() {
    document.readyState !== "loading" &&
      (n(), document.removeEventListener("DOMContentLoaded", e))
  }
  typeof window < "u" &&
    typeof document < "u" &&
    (document.addEventListener("DOMContentLoaded", e), e())
}
let ql = []
uL(() => {
  function n(e) {
    if (!Zl(e.target) || e.target === document.body || ql[0] === e.target) return
    let t = e.target
    ;(t = t.closest(D0)),
      ql.unshift(t ?? e.target),
      (ql = ql.filter((i) => i != null && i.isConnected)),
      ql.splice(10)
  }
  window.addEventListener("click", n, { capture: !0 }),
    window.addEventListener("mousedown", n, { capture: !0 }),
    window.addEventListener("focus", n, { capture: !0 }),
    document.body.addEventListener("click", n, { capture: !0 }),
    document.body.addEventListener("mousedown", n, { capture: !0 }),
    document.body.addEventListener("focus", n, { capture: !0 })
})
function TA(n) {
  let e = Pn(n),
    t = Y.useRef(!1)
  Y.useEffect(
    () => (
      (t.current = !1),
      () => {
        ;(t.current = !0),
          Pv(() => {
            t.current && e()
          })
      }
    ),
    [e],
  )
}
let bA = Y.createContext(!1)
function fL() {
  return Y.useContext(bA)
}
function AM(n) {
  return Ht.createElement(bA.Provider, { value: n.force }, n.children)
}
function dL(n) {
  let e = fL(),
    t = Y.useContext(CA),
    [i, r] = Y.useState(() => {
      var s
      if (!e && t !== null) return (s = t.current) != null ? s : null
      if (Wo.isServer) return null
      let o = n == null ? void 0 : n.getElementById("headlessui-portal-root")
      if (o) return o
      if (n === null) return null
      let l = n.createElement("div")
      return l.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(l)
    })
  return (
    Y.useEffect(() => {
      i !== null &&
        ((n != null && n.body.contains(i)) || n == null || n.body.appendChild(i))
    }, [i, n]),
    Y.useEffect(() => {
      e || (t !== null && r(t.current))
    }, [t, r, e]),
    i
  )
}
let AA = Y.Fragment,
  hL = ts(function (n, e) {
    let { ownerDocument: t = null, ...i } = n,
      r = Y.useRef(null),
      s = Zo(
        dI((v) => {
          r.current = v
        }),
        e,
      ),
      o = U1(r.current),
      l = t ?? o,
      u = dL(l),
      d = Y.useContext(W_),
      p = Iv(),
      m = Us()
    return (
      TA(() => {
        var v
        u &&
          u.childNodes.length <= 0 &&
          ((v = u.parentElement) == null || v.removeChild(u))
      }),
      u
        ? qP.createPortal(
            Ht.createElement(
              "div",
              {
                "data-headlessui-portal": "",
                ref: (v) => {
                  p.dispose(), d && v && p.add(d.register(v))
                },
              },
              m({
                ourProps: { ref: s },
                theirProps: i,
                slot: {},
                defaultTag: AA,
                name: "Portal",
              }),
            ),
            u,
          )
        : null
    )
  })
function pL(n, e) {
  let t = Zo(e),
    { enabled: i = !0, ownerDocument: r, ...s } = n,
    o = Us()
  return i
    ? Ht.createElement(hL, { ...s, ownerDocument: r, ref: t })
    : o({
        ourProps: { ref: t },
        theirProps: s,
        slot: {},
        defaultTag: AA,
        name: "Portal",
      })
}
let mL = Y.Fragment,
  CA = Y.createContext(null)
function gL(n, e) {
  let { target: t, ...i } = n,
    r = { ref: Zo(e) },
    s = Us()
  return Ht.createElement(
    CA.Provider,
    { value: t },
    s({ ourProps: r, theirProps: i, defaultTag: mL, name: "Popover.Group" }),
  )
}
let W_ = Y.createContext(null)
function vL() {
  let n = Y.useContext(W_),
    e = Y.useRef([]),
    t = Pn((s) => (e.current.push(s), n && n.register(s), () => i(s))),
    i = Pn((s) => {
      let o = e.current.indexOf(s)
      o !== -1 && e.current.splice(o, 1), n && n.unregister(s)
    }),
    r = Y.useMemo(() => ({ register: t, unregister: i, portals: e }), [t, i, e])
  return [
    e,
    Y.useMemo(
      () =>
        function ({ children: s }) {
          return Ht.createElement(W_.Provider, { value: r }, s)
        },
      [r],
    ),
  ]
}
let yL = ts(pL),
  RA = ts(gL),
  xL = Object.assign(yL, { Group: RA })
function _L(n, e = typeof document < "u" ? document.defaultView : null, t) {
  let i = am(n, "escape")
  EA(e, "keydown", (r) => {
    i && (r.defaultPrevented || (r.key === pA.Escape && t(r)))
  })
}
function wL() {
  var n
  let [e] = Y.useState(() =>
      typeof window < "u" && typeof window.matchMedia == "function"
        ? window.matchMedia("(pointer: coarse)")
        : null,
    ),
    [t, i] = Y.useState((n = e == null ? void 0 : e.matches) != null ? n : !1)
  return (
    es(() => {
      if (!e) return
      function r(s) {
        i(s.matches)
      }
      return e.addEventListener("change", r), () => e.removeEventListener("change", r)
    }, [e]),
    t
  )
}
function SL({ defaultContainers: n = [], portals: e, mainTreeNode: t } = {}) {
  let i = Pn(() => {
    var r, s
    let o = sm(t),
      l = []
    for (let u of n)
      u !== null &&
        (tc(u) ? l.push(u) : "current" in u && tc(u.current) && l.push(u.current))
    if (e != null && e.current) for (let u of e.current) l.push(u)
    for (let u of (r = o == null ? void 0 : o.querySelectorAll("html > *, body > *")) !=
    null
      ? r
      : [])
      u !== document.body &&
        u !== document.head &&
        tc(u) &&
        u.id !== "headlessui-portal-root" &&
        ((t &&
          (u.contains(t) ||
            u.contains(
              (s = t == null ? void 0 : t.getRootNode()) == null ? void 0 : s.host,
            ))) ||
          l.some((d) => u.contains(d)) ||
          l.push(u))
    return l
  })
  return { resolveContainers: i, contains: Pn((r) => i().some((s) => s.contains(r))) }
}
let PA = Y.createContext(null)
function CM({ children: n, node: e }) {
  let [t, i] = Y.useState(null),
    r = IA(e ?? t)
  return Ht.createElement(
    PA.Provider,
    { value: r },
    n,
    r === null &&
      Ht.createElement(V_, {
        features: L0.Hidden,
        ref: (s) => {
          var o, l
          if (s) {
            for (let u of (l =
              (o = sm(s)) == null
                ? void 0
                : o.querySelectorAll("html > *, body > *")) != null
              ? l
              : [])
              if (
                u !== document.body &&
                u !== document.head &&
                tc(u) &&
                u != null &&
                u.contains(s)
              ) {
                i(u)
                break
              }
          }
        },
      }),
  )
}
function IA(n = null) {
  var e
  return (e = Y.useContext(PA)) != null ? e : n
}
function ML() {
  let n = typeof document > "u"
  return "useSyncExternalStore" in eM
    ? ((e) => e.useSyncExternalStore)(eM)(
        () => () => {},
        () => !1,
        () => !n,
      )
    : !1
}
function Nv() {
  let n = ML(),
    [e, t] = Y.useState(Wo.isHandoffComplete)
  return (
    e && Wo.isHandoffComplete === !1 && t(!1),
    Y.useEffect(() => {
      e !== !0 && t(!0)
    }, [e]),
    Y.useEffect(() => Wo.handoff(), []),
    n ? !1 : e
  )
}
function B1() {
  let n = Y.useRef(!1)
  return (
    es(
      () => (
        (n.current = !0),
        () => {
          n.current = !1
        }
      ),
      [],
    ),
    n
  )
}
var cp = ((n) => (
  (n[(n.Forwards = 0)] = "Forwards"), (n[(n.Backwards = 1)] = "Backwards"), n
))(cp || {})
function EL() {
  let n = Y.useRef(0)
  return (
    MA(
      !0,
      "keydown",
      (e) => {
        e.key === "Tab" && (n.current = e.shiftKey ? 1 : 0)
      },
      !0,
    ),
    n
  )
}
function LA(n) {
  if (!n) return new Set()
  if (typeof n == "function") return new Set(n())
  let e = new Set()
  for (let t of n.current) tc(t.current) && e.add(t.current)
  return e
}
let TL = "div"
var hu = ((n) => (
  (n[(n.None = 0)] = "None"),
  (n[(n.InitialFocus = 1)] = "InitialFocus"),
  (n[(n.TabLock = 2)] = "TabLock"),
  (n[(n.FocusLock = 4)] = "FocusLock"),
  (n[(n.RestoreFocus = 8)] = "RestoreFocus"),
  (n[(n.AutoFocus = 16)] = "AutoFocus"),
  n
))(hu || {})
function bL(n, e) {
  let t = Y.useRef(null),
    i = Zo(t, e),
    {
      initialFocus: r,
      initialFocusFallback: s,
      containers: o,
      features: l = 15,
      ...u
    } = n
  Nv() || (l = 0)
  let d = U1(t.current)
  PL(l, { ownerDocument: d })
  let p = IL(l, {
    ownerDocument: d,
    container: t,
    initialFocus: r,
    initialFocusFallback: s,
  })
  LL(l, { ownerDocument: d, container: t, containers: o, previousActiveElement: p })
  let m = EL(),
    v = Pn((A) => {
      if (!Ru(t.current)) return
      let C = t.current
      ;((R) => R())(() => {
        Ya(m.current, {
          [cp.Forwards]: () => {
            yp(C, Ba.First, { skipElements: [A.relatedTarget, s] })
          },
          [cp.Backwards]: () => {
            yp(C, Ba.Last, { skipElements: [A.relatedTarget, s] })
          },
        })
      })
    }),
    y = am(!!(l & 2), "focus-trap#tab-lock"),
    x = Iv(),
    E = Y.useRef(!1),
    M = {
      ref: i,
      onKeyDown(A) {
        A.key == "Tab" &&
          ((E.current = !0),
          x.requestAnimationFrame(() => {
            E.current = !1
          }))
      },
      onBlur(A) {
        if (!(l & 4)) return
        let C = LA(o)
        Ru(t.current) && C.add(t.current)
        let R = A.relatedTarget
        Zl(R) &&
          R.dataset.headlessuiFocusGuard !== "true" &&
          (DA(C, R) ||
            (E.current
              ? yp(
                  t.current,
                  Ya(m.current, {
                    [cp.Forwards]: () => Ba.Next,
                    [cp.Backwards]: () => Ba.Previous,
                  }) | Ba.WrapAround,
                  { relativeTo: A.target },
                )
              : Zl(A.target) && Ga(A.target)))
      },
    },
    w = Us()
  return Ht.createElement(
    Ht.Fragment,
    null,
    y &&
      Ht.createElement(V_, {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: v,
        features: L0.Focusable,
      }),
    w({ ourProps: M, theirProps: u, defaultTag: TL, name: "FocusTrap" }),
    y &&
      Ht.createElement(V_, {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: v,
        features: L0.Focusable,
      }),
  )
}
let AL = ts(bL),
  CL = Object.assign(AL, { features: hu })
function RL(n = !0) {
  let e = Y.useRef(ql.slice())
  return (
    O1(
      ([t], [i]) => {
        i === !0 &&
          t === !1 &&
          Pv(() => {
            e.current.splice(0)
          }),
          i === !1 && t === !0 && (e.current = ql.slice())
      },
      [n, ql, e],
    ),
    Pn(() => {
      var t
      return (t = e.current.find((i) => i != null && i.isConnected)) != null ? t : null
    })
  )
}
function PL(n, { ownerDocument: e }) {
  let t = !!(n & 8),
    i = RL(t)
  O1(() => {
    t || (JP(e == null ? void 0 : e.body) && Ga(i()))
  }, [t]),
    TA(() => {
      t && Ga(i())
    })
}
function IL(
  n,
  { ownerDocument: e, container: t, initialFocus: i, initialFocusFallback: r },
) {
  let s = Y.useRef(null),
    o = am(!!(n & 1), "focus-trap#initial-focus"),
    l = B1()
  return (
    O1(() => {
      if (n === 0) return
      if (!o) {
        r != null && r.current && Ga(r.current)
        return
      }
      let u = t.current
      u &&
        Pv(() => {
          if (!l.current) return
          let d = e == null ? void 0 : e.activeElement
          if (i != null && i.current) {
            if ((i == null ? void 0 : i.current) === d) {
              s.current = d
              return
            }
          } else if (u.contains(d)) {
            s.current = d
            return
          }
          if (i != null && i.current) Ga(i.current)
          else {
            if (n & 16) {
              if (yp(u, Ba.First | Ba.AutoFocus) !== G_.Error) return
            } else if (yp(u, Ba.First) !== G_.Error) return
            if (
              r != null &&
              r.current &&
              (Ga(r.current), (e == null ? void 0 : e.activeElement) === r.current)
            )
              return
            console.warn("There are no focusable elements inside the <FocusTrap />")
          }
          s.current = e == null ? void 0 : e.activeElement
        })
    }, [r, o, n]),
    s
  )
}
function LL(
  n,
  { ownerDocument: e, container: t, containers: i, previousActiveElement: r },
) {
  let s = B1(),
    o = !!(n & 4)
  EA(
    e == null ? void 0 : e.defaultView,
    "focus",
    (l) => {
      if (!o || !s.current) return
      let u = LA(i)
      Ru(t.current) && u.add(t.current)
      let d = r.current
      if (!d) return
      let p = l.target
      Ru(p)
        ? DA(u, p)
          ? ((r.current = p), Ga(p))
          : (l.preventDefault(), l.stopPropagation(), Ga(d))
        : Ga(r.current)
    },
    !0,
  )
}
function DA(n, e) {
  for (let t of n) if (t.contains(e)) return !0
  return !1
}
function NA(n) {
  var e
  return (
    !!(n.enter || n.enterFrom || n.enterTo || n.leave || n.leaveFrom || n.leaveTo) ||
    !gp((e = n.as) != null ? e : FA) ||
    Ht.Children.count(n.children) === 1
  )
}
let kv = Y.createContext(null)
kv.displayName = "TransitionContext"
var DL = ((n) => ((n.Visible = "visible"), (n.Hidden = "hidden"), n))(DL || {})
function NL() {
  let n = Y.useContext(kv)
  if (n === null)
    throw new Error(
      "A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.",
    )
  return n
}
function kL() {
  let n = Y.useContext(Fv)
  if (n === null)
    throw new Error(
      "A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.",
    )
  return n
}
let Fv = Y.createContext(null)
Fv.displayName = "NestingContext"
function Uv(n) {
  return "children" in n
    ? Uv(n.children)
    : n.current
        .filter(({ el: e }) => e.current !== null)
        .filter(({ state: e }) => e === "visible").length > 0
}
function kA(n, e) {
  let t = Uu(n),
    i = Y.useRef([]),
    r = B1(),
    s = Iv(),
    o = Pn((y, x = Kl.Hidden) => {
      let E = i.current.findIndex(({ el: M }) => M === y)
      E !== -1 &&
        (Ya(x, {
          [Kl.Unmount]() {
            i.current.splice(E, 1)
          },
          [Kl.Hidden]() {
            i.current[E].state = "hidden"
          },
        }),
        s.microTask(() => {
          var M
          !Uv(i) && r.current && ((M = t.current) == null || M.call(t))
        }))
    }),
    l = Pn((y) => {
      let x = i.current.find(({ el: E }) => E === y)
      return (
        x
          ? x.state !== "visible" && (x.state = "visible")
          : i.current.push({ el: y, state: "visible" }),
        () => o(y, Kl.Unmount)
      )
    }),
    u = Y.useRef([]),
    d = Y.useRef(Promise.resolve()),
    p = Y.useRef({ enter: [], leave: [] }),
    m = Pn((y, x, E) => {
      u.current.splice(0),
        e && (e.chains.current[x] = e.chains.current[x].filter(([M]) => M !== y)),
        e == null ||
          e.chains.current[x].push([
            y,
            new Promise((M) => {
              u.current.push(M)
            }),
          ]),
        e == null ||
          e.chains.current[x].push([
            y,
            new Promise((M) => {
              Promise.all(p.current[x].map(([w, A]) => A)).then(() => M())
            }),
          ]),
        x === "enter"
          ? (d.current = d.current
              .then(() => (e == null ? void 0 : e.wait.current))
              .then(() => E(x)))
          : E(x)
    }),
    v = Pn((y, x, E) => {
      Promise.all(p.current[x].splice(0).map(([M, w]) => w))
        .then(() => {
          var M
          ;(M = u.current.shift()) == null || M()
        })
        .then(() => E(x))
    })
  return Y.useMemo(
    () => ({
      children: i,
      register: l,
      unregister: o,
      onStart: m,
      onStop: v,
      wait: d,
      chains: p,
    }),
    [l, o, i, m, v, p, d],
  )
}
let FA = Y.Fragment,
  UA = I0.RenderStrategy
function FL(n, e) {
  var t, i
  let {
      transition: r = !0,
      beforeEnter: s,
      afterEnter: o,
      beforeLeave: l,
      afterLeave: u,
      enter: d,
      enterFrom: p,
      enterTo: m,
      entered: v,
      leave: y,
      leaveFrom: x,
      leaveTo: E,
      ...M
    } = n,
    [w, A] = Y.useState(null),
    C = Y.useRef(null),
    R = NA(n),
    z = Zo(...(R ? [C, e, A] : e === null ? [] : [e])),
    U = (t = M.unmount) == null || t ? Kl.Unmount : Kl.Hidden,
    { show: O, appear: N, initial: k } = NL(),
    [I, V] = Y.useState(O ? "visible" : "hidden"),
    Z = kL(),
    { register: $, unregister: ee } = Z
  es(() => $(C), [$, C]),
    es(() => {
      if (U === Kl.Hidden && C.current) {
        if (O && I !== "visible") {
          V("visible")
          return
        }
        return Ya(I, { hidden: () => ee(C), visible: () => $(C) })
      }
    }, [I, C, $, ee, O, U])
  let ue = Nv()
  es(() => {
    if (R && ue && I === "visible" && C.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?")
  }, [C, I, ue, R])
  let re = k && !N,
    se = N && O && k,
    G = Y.useRef(!1),
    ie = kA(() => {
      G.current || (V("hidden"), ee(C))
    }, Z),
    Q = Pn((me) => {
      G.current = !0
      let Fe = me ? "enter" : "leave"
      ie.onStart(C, Fe, (ze) => {
        ze === "enter" ? s == null || s() : ze === "leave" && (l == null || l())
      })
    }),
    W = Pn((me) => {
      let Fe = me ? "enter" : "leave"
      ;(G.current = !1),
        ie.onStop(C, Fe, (ze) => {
          ze === "enter" ? o == null || o() : ze === "leave" && (u == null || u())
        }),
        Fe === "leave" && !Uv(ie) && (V("hidden"), ee(C))
    })
  Y.useEffect(() => {
    ;(R && r) || (Q(O), W(O))
  }, [O, R, r])
  let ne = !(!r || !R || !ue || re),
    [, ye] = iL(ne, w, O, { start: Q, end: W }),
    oe = cu({
      ref: z,
      className:
        ((i = z_(
          M.className,
          se && d,
          se && p,
          ye.enter && d,
          ye.enter && ye.closed && p,
          ye.enter && !ye.closed && m,
          ye.leave && y,
          ye.leave && !ye.closed && x,
          ye.leave && ye.closed && E,
          !ye.transition && O && v,
        )) == null
          ? void 0
          : i.trim()) || void 0,
      ...nL(ye),
    }),
    fe = 0
  I === "visible" && (fe |= xo.Open),
    I === "hidden" && (fe |= xo.Closed),
    O && I === "hidden" && (fe |= xo.Opening),
    !O && I === "visible" && (fe |= xo.Closing)
  let we = Us()
  return Ht.createElement(
    Fv.Provider,
    { value: ie },
    Ht.createElement(
      lL,
      { value: fe },
      we({
        ourProps: oe,
        theirProps: M,
        defaultTag: FA,
        features: UA,
        visible: I === "visible",
        name: "Transition.Child",
      }),
    ),
  )
}
function UL(n, e) {
  let { show: t, appear: i = !1, unmount: r = !0, ...s } = n,
    o = Y.useRef(null),
    l = NA(n),
    u = Zo(...(l ? [o, e] : e === null ? [] : [e]))
  Nv()
  let d = Dv()
  if ((t === void 0 && d !== null && (t = (d & xo.Open) === xo.Open), t === void 0))
    throw new Error(
      "A <Transition /> is used but it is missing a `show={true | false}` prop.",
    )
  let [p, m] = Y.useState(t ? "visible" : "hidden"),
    v = kA(() => {
      t || m("hidden")
    }),
    [y, x] = Y.useState(!0),
    E = Y.useRef([t])
  es(() => {
    y !== !1 && E.current[E.current.length - 1] !== t && (E.current.push(t), x(!1))
  }, [E, t])
  let M = Y.useMemo(() => ({ show: t, appear: i, initial: y }), [t, i, y])
  es(() => {
    t ? m("visible") : !Uv(v) && o.current !== null && m("hidden")
  }, [t, v])
  let w = { unmount: r },
    A = Pn(() => {
      var z
      y && x(!1), (z = n.beforeEnter) == null || z.call(n)
    }),
    C = Pn(() => {
      var z
      y && x(!1), (z = n.beforeLeave) == null || z.call(n)
    }),
    R = Us()
  return Ht.createElement(
    Fv.Provider,
    { value: v },
    Ht.createElement(
      kv.Provider,
      { value: M },
      R({
        ourProps: {
          ...w,
          as: Y.Fragment,
          children: Ht.createElement(OA, {
            ref: u,
            ...w,
            ...s,
            beforeEnter: A,
            beforeLeave: C,
          }),
        },
        theirProps: {},
        defaultTag: Y.Fragment,
        features: UA,
        visible: p === "visible",
        name: "Transition",
      }),
    ),
  )
}
function OL(n, e) {
  let t = Y.useContext(kv) !== null,
    i = Dv() !== null
  return Ht.createElement(
    Ht.Fragment,
    null,
    !t && i
      ? Ht.createElement(j_, { ref: e, ...n })
      : Ht.createElement(OA, { ref: e, ...n }),
  )
}
let j_ = ts(UL),
  OA = ts(FL),
  z1 = ts(OL),
  Ou = Object.assign(j_, { Child: z1, Root: j_ })
var BL = ((n) => ((n[(n.Open = 0)] = "Open"), (n[(n.Closed = 1)] = "Closed"), n))(
    BL || {},
  ),
  zL = ((n) => ((n[(n.SetTitleId = 0)] = "SetTitleId"), n))(zL || {})
let VL = {
    0(n, e) {
      return n.titleId === e.id ? n : { ...n, titleId: e.id }
    },
  },
  V1 = Y.createContext(null)
V1.displayName = "DialogContext"
function Ov(n) {
  let e = Y.useContext(V1)
  if (e === null) {
    let t = new Error(`<${n} /> is missing a parent <Dialog /> component.`)
    throw (Error.captureStackTrace && Error.captureStackTrace(t, Ov), t)
  }
  return e
}
function HL(n, e) {
  return Ya(e.type, VL, n, e)
}
let RM = ts(function (n, e) {
    let t = Y.useId(),
      {
        id: i = `headlessui-dialog-${t}`,
        open: r,
        onClose: s,
        initialFocus: o,
        role: l = "dialog",
        autoFocus: u = !0,
        __demoMode: d = !1,
        unmount: p = !1,
        ...m
      } = n,
      v = Y.useRef(!1)
    l = (function () {
      return l === "dialog" || l === "alertdialog"
        ? l
        : (v.current ||
            ((v.current = !0),
            console.warn(
              `Invalid role [${l}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`,
            )),
          "dialog")
    })()
    let y = Dv()
    r === void 0 && y !== null && (r = (y & xo.Open) === xo.Open)
    let x = Y.useRef(null),
      E = Zo(x, e),
      M = U1(x.current),
      w = r ? 0 : 1,
      [A, C] = Y.useReducer(HL, {
        titleId: null,
        descriptionId: null,
        panelRef: Y.createRef(),
      }),
      R = Pn(() => s(!1)),
      z = Pn((ye) => C({ type: 0, id: ye })),
      U = Nv() ? w === 0 : !1,
      [O, N] = vL(),
      k = {
        get current() {
          var ye
          return (ye = A.panelRef.current) != null ? ye : x.current
        },
      },
      I = IA(),
      { resolveContainers: V } = SL({
        mainTreeNode: I,
        portals: O,
        defaultContainers: [k],
      }),
      Z = y !== null ? (y & xo.Closing) === xo.Closing : !1
    DI(d || Z ? !1 : U, {
      allowed: Pn(() => {
        var ye, oe
        return [
          (oe =
            (ye = x.current) == null
              ? void 0
              : ye.closest("[data-headlessui-portal]")) != null
            ? oe
            : null,
        ]
      }),
      disallowed: Pn(() => {
        var ye
        return [
          (ye =
            I == null ? void 0 : I.closest("body > *:not(#headlessui-portal-root)")) !=
          null
            ? ye
            : null,
        ]
      }),
    })
    let $ = xA.get(null)
    es(() => {
      if (U) return $.actions.push(i), () => $.actions.pop(i)
    }, [$, i, U])
    let ee = _A(
      $,
      Y.useCallback((ye) => $.selectors.isTop(ye, i), [$, i]),
    )
    jI(ee, V, (ye) => {
      ye.preventDefault(), R()
    }),
      _L(ee, M == null ? void 0 : M.defaultView, (ye) => {
        ye.preventDefault(),
          ye.stopPropagation(),
          document.activeElement &&
            "blur" in document.activeElement &&
            typeof document.activeElement.blur == "function" &&
            document.activeElement.blur(),
          R()
      }),
      JI(d || Z ? !1 : U, M, V),
      NI(U, x, R)
    let [ue, re] = hI(),
      se = Y.useMemo(
        () => [{ dialogState: w, close: R, setTitleId: z, unmount: p }, A],
        [w, R, z, p, A],
      ),
      G = om({ open: w === 0 }),
      ie = {
        ref: E,
        id: i,
        role: l,
        tabIndex: -1,
        "aria-modal": d ? void 0 : w === 0 ? !0 : void 0,
        "aria-labelledby": A.titleId,
        "aria-describedby": ue,
        unmount: p,
      },
      Q = !wL(),
      W = hu.None
    U &&
      !d &&
      ((W |= hu.RestoreFocus),
      (W |= hu.TabLock),
      u && (W |= hu.AutoFocus),
      Q && (W |= hu.InitialFocus))
    let ne = Us()
    return Ht.createElement(
      cL,
      null,
      Ht.createElement(
        AM,
        { force: !0 },
        Ht.createElement(
          xL,
          null,
          Ht.createElement(
            V1.Provider,
            { value: se },
            Ht.createElement(
              RA,
              { target: x },
              Ht.createElement(
                AM,
                { force: !1 },
                Ht.createElement(
                  re,
                  { slot: G },
                  Ht.createElement(
                    N,
                    null,
                    Ht.createElement(
                      CL,
                      {
                        initialFocus: o,
                        initialFocusFallback: x,
                        containers: V,
                        features: W,
                      },
                      Ht.createElement(
                        xI,
                        { value: R },
                        ne({
                          ourProps: ie,
                          theirProps: m,
                          slot: G,
                          defaultTag: GL,
                          features: WL,
                          visible: w === 0,
                          name: "Dialog",
                        }),
                      ),
                    ),
                  ),
                ),
              ),
            ),
          ),
        ),
      ),
    )
  }),
  GL = "div",
  WL = I0.RenderStrategy | I0.Static
function jL(n, e) {
  let { transition: t = !1, open: i, ...r } = n,
    s = Dv(),
    o = n.hasOwnProperty("open") || s !== null,
    l = n.hasOwnProperty("onClose")
  if (!o && !l)
    throw new Error(
      "You have to provide an `open` and an `onClose` prop to the `Dialog` component.",
    )
  if (!o)
    throw new Error(
      "You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.",
    )
  if (!l)
    throw new Error(
      "You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.",
    )
  if (!s && typeof n.open != "boolean")
    throw new Error(
      `You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${n.open}`,
    )
  if (typeof n.onClose != "function")
    throw new Error(
      `You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${n.onClose}`,
    )
  return (i !== void 0 || t) && !r.static
    ? Ht.createElement(
        CM,
        null,
        Ht.createElement(
          Ou,
          { show: i, transition: t, unmount: r.unmount },
          Ht.createElement(RM, { ref: e, ...r }),
        ),
      )
    : Ht.createElement(CM, null, Ht.createElement(RM, { ref: e, open: i, ...r }))
}
let XL = "div"
function YL(n, e) {
  let t = Y.useId(),
    { id: i = `headlessui-dialog-panel-${t}`, transition: r = !1, ...s } = n,
    [{ dialogState: o, unmount: l }, u] = Ov("Dialog.Panel"),
    d = Zo(e, u.panelRef),
    p = om({ open: o === 0 }),
    m = Pn((M) => {
      M.stopPropagation()
    }),
    v = { ref: d, id: i, onClick: m },
    y = r ? z1 : Y.Fragment,
    x = r ? { unmount: l } : {},
    E = Us()
  return Ht.createElement(
    y,
    { ...x },
    E({ ourProps: v, theirProps: s, slot: p, defaultTag: XL, name: "Dialog.Panel" }),
  )
}
let qL = "div"
function $L(n, e) {
  let { transition: t = !1, ...i } = n,
    [{ dialogState: r, unmount: s }] = Ov("Dialog.Backdrop"),
    o = om({ open: r === 0 }),
    l = { ref: e, "aria-hidden": !0 },
    u = t ? z1 : Y.Fragment,
    d = t ? { unmount: s } : {},
    p = Us()
  return Ht.createElement(
    u,
    { ...d },
    p({ ourProps: l, theirProps: i, slot: o, defaultTag: qL, name: "Dialog.Backdrop" }),
  )
}
let KL = "h2"
function ZL(n, e) {
  let t = Y.useId(),
    { id: i = `headlessui-dialog-title-${t}`, ...r } = n,
    [{ dialogState: s, setTitleId: o }] = Ov("Dialog.Title"),
    l = Zo(e)
  Y.useEffect(() => (o(i), () => o(null)), [i, o])
  let u = om({ open: s === 0 }),
    d = { ref: l, id: i }
  return Us()({
    ourProps: d,
    theirProps: r,
    slot: u,
    defaultTag: KL,
    name: "Dialog.Title",
  })
}
let JL = ts(jL),
  QL = ts(YL)
ts($L)
let eD = ts(ZL),
  lm = Object.assign(JL, { Panel: QL, Title: eD, Description: vI })
const H1 = Y.createContext({})
function G1(n) {
  const e = Y.useRef(null)
  return e.current === null && (e.current = n()), e.current
}
const BA = typeof window < "u",
  zA = BA ? Y.useLayoutEffect : Y.useEffect,
  Bv = Y.createContext(null)
function W1(n, e) {
  n.indexOf(e) === -1 && n.push(e)
}
function j1(n, e) {
  const t = n.indexOf(e)
  t > -1 && n.splice(t, 1)
}
const $o = (n, e, t) => (t > e ? e : t < n ? n : t)
let X1 = () => {}
const qa = {},
  VA = (n) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(n)
function HA(n) {
  return typeof n == "object" && n !== null
}
const GA = (n) => /^0[^.\s]+$/u.test(n)
function Y1(n) {
  let e
  return () => (e === void 0 && (e = n()), e)
}
const Fs = (n) => n,
  tD = (n, e) => (t) => e(n(t)),
  cm = (...n) => n.reduce(tD),
  Fp = (n, e, t) => {
    const i = e - n
    return i === 0 ? 1 : (t - n) / i
  }
class q1 {
  constructor() {
    this.subscriptions = []
  }
  add(e) {
    return W1(this.subscriptions, e), () => j1(this.subscriptions, e)
  }
  notify(e, t, i) {
    const r = this.subscriptions.length
    if (r)
      if (r === 1) this.subscriptions[0](e, t, i)
      else
        for (let s = 0; s < r; s++) {
          const o = this.subscriptions[s]
          o && o(e, t, i)
        }
  }
  getSize() {
    return this.subscriptions.length
  }
  clear() {
    this.subscriptions.length = 0
  }
}
const Wa = (n) => n * 1e3,
  ks = (n) => n / 1e3
function WA(n, e) {
  return e ? n * (1e3 / e) : 0
}
const jA = (n, e, t) => (((1 - 3 * t + 3 * e) * n + (3 * t - 6 * e)) * n + 3 * e) * n,
  nD = 1e-7,
  iD = 12
function rD(n, e, t, i, r) {
  let s,
    o,
    l = 0
  do (o = e + (t - e) / 2), (s = jA(o, i, r) - n), s > 0 ? (t = o) : (e = o)
  while (Math.abs(s) > nD && ++l < iD)
  return o
}
function um(n, e, t, i) {
  if (n === e && t === i) return Fs
  const r = (s) => rD(s, 0, 1, n, t)
  return (s) => (s === 0 || s === 1 ? s : jA(r(s), e, i))
}
const XA = (n) => (e) => e <= 0.5 ? n(2 * e) / 2 : (2 - n(2 * (1 - e))) / 2,
  YA = (n) => (e) => 1 - n(1 - e),
  qA = um(0.33, 1.53, 0.69, 0.99),
  $1 = YA(qA),
  $A = XA($1),
  KA = (n) => ((n *= 2) < 1 ? 0.5 * $1(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1)))),
  K1 = (n) => 1 - Math.sin(Math.acos(n)),
  ZA = YA(K1),
  JA = XA(K1),
  sD = um(0.42, 0, 1, 1),
  oD = um(0, 0, 0.58, 1),
  QA = um(0.42, 0, 0.58, 1),
  aD = (n) => Array.isArray(n) && typeof n[0] != "number",
  e2 = (n) => Array.isArray(n) && typeof n[0] == "number",
  lD = {
    linear: Fs,
    easeIn: sD,
    easeInOut: QA,
    easeOut: oD,
    circIn: K1,
    circInOut: JA,
    circOut: ZA,
    backIn: $1,
    backInOut: $A,
    backOut: qA,
    anticipate: KA,
  },
  cD = (n) => typeof n == "string",
  PM = (n) => {
    if (e2(n)) {
      X1(n.length === 4)
      const [e, t, i, r] = n
      return um(e, t, i, r)
    } else if (cD(n)) return lD[n]
    return n
  },
  bg = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender",
  ]
function uD(n, e) {
  let t = new Set(),
    i = new Set(),
    r = !1,
    s = !1
  const o = new WeakSet()
  let l = { delta: 0, timestamp: 0, isProcessing: !1 }
  function u(p) {
    o.has(p) && (d.schedule(p), n()), p(l)
  }
  const d = {
    schedule: (p, m = !1, v = !1) => {
      const x = v && r ? t : i
      return m && o.add(p), x.has(p) || x.add(p), p
    },
    cancel: (p) => {
      i.delete(p), o.delete(p)
    },
    process: (p) => {
      if (((l = p), r)) {
        s = !0
        return
      }
      ;(r = !0),
        ([t, i] = [i, t]),
        t.forEach(u),
        t.clear(),
        (r = !1),
        s && ((s = !1), d.process(p))
    },
  }
  return d
}
const fD = 40
function t2(n, e) {
  let t = !1,
    i = !0
  const r = { delta: 0, timestamp: 0, isProcessing: !1 },
    s = () => (t = !0),
    o = bg.reduce((C, R) => ((C[R] = uD(s)), C), {}),
    {
      setup: l,
      read: u,
      resolveKeyframes: d,
      preUpdate: p,
      update: m,
      preRender: v,
      render: y,
      postRender: x,
    } = o,
    E = () => {
      const C = qa.useManualTiming ? r.timestamp : performance.now()
      ;(t = !1),
        qa.useManualTiming ||
          (r.delta = i ? 1e3 / 60 : Math.max(Math.min(C - r.timestamp, fD), 1)),
        (r.timestamp = C),
        (r.isProcessing = !0),
        l.process(r),
        u.process(r),
        d.process(r),
        p.process(r),
        m.process(r),
        v.process(r),
        y.process(r),
        x.process(r),
        (r.isProcessing = !1),
        t && e && ((i = !1), n(E))
    },
    M = () => {
      ;(t = !0), (i = !0), r.isProcessing || n(E)
    }
  return {
    schedule: bg.reduce((C, R) => {
      const z = o[R]
      return (C[R] = (U, O = !1, N = !1) => (t || M(), z.schedule(U, O, N))), C
    }, {}),
    cancel: (C) => {
      for (let R = 0; R < bg.length; R++) o[bg[R]].cancel(C)
    },
    state: r,
    steps: o,
  }
}
const {
  schedule: Fn,
  cancel: nc,
  state: Ji,
  steps: hx,
} = t2(typeof requestAnimationFrame < "u" ? requestAnimationFrame : Fs, !0)
let E0
function dD() {
  E0 = void 0
}
const Rr = {
    now: () => (
      E0 === void 0 &&
        Rr.set(
          Ji.isProcessing || qa.useManualTiming ? Ji.timestamp : performance.now(),
        ),
      E0
    ),
    set: (n) => {
      ;(E0 = n), queueMicrotask(dD)
    },
  },
  n2 = (n) => (e) => typeof e == "string" && e.startsWith(n),
  i2 = n2("--"),
  hD = n2("var(--"),
  Z1 = (n) => (hD(n) ? pD.test(n.split("/*")[0].trim()) : !1),
  pD =
    /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu
function IM(n) {
  return typeof n != "string" ? !1 : n.split("/*")[0].includes("var(--")
}
const Bd = {
    test: (n) => typeof n == "number",
    parse: parseFloat,
    transform: (n) => n,
  },
  Up = { ...Bd, transform: (n) => $o(0, 1, n) },
  Ag = { ...Bd, default: 1 },
  xp = (n) => Math.round(n * 1e5) / 1e5,
  J1 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu
function mD(n) {
  return n == null
}
const gD =
    /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
  Q1 = (n, e) => (t) =>
    !!(
      (typeof t == "string" && gD.test(t) && t.startsWith(n)) ||
      (e && !mD(t) && Object.prototype.hasOwnProperty.call(t, e))
    ),
  r2 = (n, e, t) => (i) => {
    if (typeof i != "string") return i
    const [r, s, o, l] = i.match(J1)
    return {
      [n]: parseFloat(r),
      [e]: parseFloat(s),
      [t]: parseFloat(o),
      alpha: l !== void 0 ? parseFloat(l) : 1,
    }
  },
  vD = (n) => $o(0, 255, n),
  px = { ...Bd, transform: (n) => Math.round(vD(n)) },
  gu = {
    test: Q1("rgb", "red"),
    parse: r2("red", "green", "blue"),
    transform: ({ red: n, green: e, blue: t, alpha: i = 1 }) =>
      "rgba(" +
      px.transform(n) +
      ", " +
      px.transform(e) +
      ", " +
      px.transform(t) +
      ", " +
      xp(Up.transform(i)) +
      ")",
  }
function yD(n) {
  let e = "",
    t = "",
    i = "",
    r = ""
  return (
    n.length > 5
      ? ((e = n.substring(1, 3)),
        (t = n.substring(3, 5)),
        (i = n.substring(5, 7)),
        (r = n.substring(7, 9)))
      : ((e = n.substring(1, 2)),
        (t = n.substring(2, 3)),
        (i = n.substring(3, 4)),
        (r = n.substring(4, 5)),
        (e += e),
        (t += t),
        (i += i),
        (r += r)),
    {
      red: parseInt(e, 16),
      green: parseInt(t, 16),
      blue: parseInt(i, 16),
      alpha: r ? parseInt(r, 16) / 255 : 1,
    }
  )
}
const X_ = { test: Q1("#"), parse: yD, transform: gu.transform },
  fm = (n) => ({
    test: (e) => typeof e == "string" && e.endsWith(n) && e.split(" ").length === 1,
    parse: parseFloat,
    transform: (e) => `${e}${n}`,
  }),
  Xl = fm("deg"),
  jo = fm("%"),
  Mt = fm("px"),
  xD = fm("vh"),
  _D = fm("vw"),
  LM = {
    ...jo,
    parse: (n) => jo.parse(n) / 100,
    transform: (n) => jo.transform(n * 100),
  },
  vd = {
    test: Q1("hsl", "hue"),
    parse: r2("hue", "saturation", "lightness"),
    transform: ({ hue: n, saturation: e, lightness: t, alpha: i = 1 }) =>
      "hsla(" +
      Math.round(n) +
      ", " +
      jo.transform(xp(e)) +
      ", " +
      jo.transform(xp(t)) +
      ", " +
      xp(Up.transform(i)) +
      ")",
  },
  yi = {
    test: (n) => gu.test(n) || X_.test(n) || vd.test(n),
    parse: (n) => (gu.test(n) ? gu.parse(n) : vd.test(n) ? vd.parse(n) : X_.parse(n)),
    transform: (n) =>
      typeof n == "string"
        ? n
        : n.hasOwnProperty("red")
        ? gu.transform(n)
        : vd.transform(n),
    getAnimatableNone: (n) => {
      const e = yi.parse(n)
      return (e.alpha = 0), yi.transform(e)
    },
  },
  wD =
    /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu
function SD(n) {
  var e, t
  return (
    isNaN(n) &&
    typeof n == "string" &&
    (((e = n.match(J1)) == null ? void 0 : e.length) || 0) +
      (((t = n.match(wD)) == null ? void 0 : t.length) || 0) >
      0
  )
}
const s2 = "number",
  o2 = "color",
  MD = "var",
  ED = "var(",
  DM = "${}",
  TD =
    /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu
function Op(n) {
  const e = n.toString(),
    t = [],
    i = { color: [], number: [], var: [] },
    r = []
  let s = 0
  const l = e
    .replace(
      TD,
      (u) => (
        yi.test(u)
          ? (i.color.push(s), r.push(o2), t.push(yi.parse(u)))
          : u.startsWith(ED)
          ? (i.var.push(s), r.push(MD), t.push(u))
          : (i.number.push(s), r.push(s2), t.push(parseFloat(u))),
        ++s,
        DM
      ),
    )
    .split(DM)
  return { values: t, split: l, indexes: i, types: r }
}
function a2(n) {
  return Op(n).values
}
function l2(n) {
  const { split: e, types: t } = Op(n),
    i = e.length
  return (r) => {
    let s = ""
    for (let o = 0; o < i; o++)
      if (((s += e[o]), r[o] !== void 0)) {
        const l = t[o]
        l === s2 ? (s += xp(r[o])) : l === o2 ? (s += yi.transform(r[o])) : (s += r[o])
      }
    return s
  }
}
const bD = (n) => (typeof n == "number" ? 0 : yi.test(n) ? yi.getAnimatableNone(n) : n)
function AD(n) {
  const e = a2(n)
  return l2(n)(e.map(bD))
}
const ic = { test: SD, parse: a2, createTransformer: l2, getAnimatableNone: AD }
function mx(n, e, t) {
  return (
    t < 0 && (t += 1),
    t > 1 && (t -= 1),
    t < 1 / 6
      ? n + (e - n) * 6 * t
      : t < 1 / 2
      ? e
      : t < 2 / 3
      ? n + (e - n) * (2 / 3 - t) * 6
      : n
  )
}
function CD({ hue: n, saturation: e, lightness: t, alpha: i }) {
  ;(n /= 360), (e /= 100), (t /= 100)
  let r = 0,
    s = 0,
    o = 0
  if (!e) r = s = o = t
  else {
    const l = t < 0.5 ? t * (1 + e) : t + e - t * e,
      u = 2 * t - l
    ;(r = mx(u, l, n + 1 / 3)), (s = mx(u, l, n)), (o = mx(u, l, n - 1 / 3))
  }
  return {
    red: Math.round(r * 255),
    green: Math.round(s * 255),
    blue: Math.round(o * 255),
    alpha: i,
  }
}
function N0(n, e) {
  return (t) => (t > 0 ? e : n)
}
const Kn = (n, e, t) => n + (e - n) * t,
  gx = (n, e, t) => {
    const i = n * n,
      r = t * (e * e - i) + i
    return r < 0 ? 0 : Math.sqrt(r)
  },
  RD = [X_, gu, vd],
  PD = (n) => RD.find((e) => e.test(n))
function NM(n) {
  const e = PD(n)
  if (!e) return !1
  let t = e.parse(n)
  return e === vd && (t = CD(t)), t
}
const kM = (n, e) => {
    const t = NM(n),
      i = NM(e)
    if (!t || !i) return N0(n, e)
    const r = { ...t }
    return (s) => (
      (r.red = gx(t.red, i.red, s)),
      (r.green = gx(t.green, i.green, s)),
      (r.blue = gx(t.blue, i.blue, s)),
      (r.alpha = Kn(t.alpha, i.alpha, s)),
      gu.transform(r)
    )
  },
  Y_ = new Set(["none", "hidden"])
function ID(n, e) {
  return Y_.has(n) ? (t) => (t <= 0 ? n : e) : (t) => (t >= 1 ? e : n)
}
function LD(n, e) {
  return (t) => Kn(n, e, t)
}
function ew(n) {
  return typeof n == "number"
    ? LD
    : typeof n == "string"
    ? Z1(n)
      ? N0
      : yi.test(n)
      ? kM
      : kD
    : Array.isArray(n)
    ? c2
    : typeof n == "object"
    ? yi.test(n)
      ? kM
      : DD
    : N0
}
function c2(n, e) {
  const t = [...n],
    i = t.length,
    r = n.map((s, o) => ew(s)(s, e[o]))
  return (s) => {
    for (let o = 0; o < i; o++) t[o] = r[o](s)
    return t
  }
}
function DD(n, e) {
  const t = { ...n, ...e },
    i = {}
  for (const r in t) n[r] !== void 0 && e[r] !== void 0 && (i[r] = ew(n[r])(n[r], e[r]))
  return (r) => {
    for (const s in i) t[s] = i[s](r)
    return t
  }
}
function ND(n, e) {
  const t = [],
    i = { color: 0, var: 0, number: 0 }
  for (let r = 0; r < e.values.length; r++) {
    const s = e.types[r],
      o = n.indexes[s][i[s]],
      l = n.values[o] ?? 0
    ;(t[r] = l), i[s]++
  }
  return t
}
const kD = (n, e) => {
  const t = ic.createTransformer(e),
    i = Op(n),
    r = Op(e)
  return i.indexes.var.length === r.indexes.var.length &&
    i.indexes.color.length === r.indexes.color.length &&
    i.indexes.number.length >= r.indexes.number.length
    ? (Y_.has(n) && !r.values.length) || (Y_.has(e) && !i.values.length)
      ? ID(n, e)
      : cm(c2(ND(i, r), r.values), t)
    : N0(n, e)
}
function u2(n, e, t) {
  return typeof n == "number" && typeof e == "number" && typeof t == "number"
    ? Kn(n, e, t)
    : ew(n)(n, e)
}
const FD = (n) => {
    const e = ({ timestamp: t }) => n(t)
    return {
      start: (t = !0) => Fn.update(e, t),
      stop: () => nc(e),
      now: () => (Ji.isProcessing ? Ji.timestamp : Rr.now()),
    }
  },
  f2 = (n, e, t = 10) => {
    let i = ""
    const r = Math.max(Math.round(e / t), 2)
    for (let s = 0; s < r; s++) i += Math.round(n(s / (r - 1)) * 1e4) / 1e4 + ", "
    return `linear(${i.substring(0, i.length - 2)})`
  },
  k0 = 2e4
function tw(n) {
  let e = 0
  const t = 50
  let i = n.next(e)
  for (; !i.done && e < k0; ) (e += t), (i = n.next(e))
  return e >= k0 ? 1 / 0 : e
}
function UD(n, e = 100, t) {
  const i = t({ ...n, keyframes: [0, e] }),
    r = Math.min(tw(i), k0)
  return { type: "keyframes", ease: (s) => i.next(r * s).value / e, duration: ks(r) }
}
const OD = 5
function d2(n, e, t) {
  const i = Math.max(e - OD, 0)
  return WA(t - n(i), e - i)
}
const ii = {
    stiffness: 100,
    damping: 10,
    mass: 1,
    velocity: 0,
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    restSpeed: { granular: 0.01, default: 2 },
    restDelta: { granular: 0.005, default: 0.5 },
    minDuration: 0.01,
    maxDuration: 10,
    minDamping: 0.05,
    maxDamping: 1,
  },
  vx = 0.001
function BD({
  duration: n = ii.duration,
  bounce: e = ii.bounce,
  velocity: t = ii.velocity,
  mass: i = ii.mass,
}) {
  let r,
    s,
    o = 1 - e
  ;(o = $o(ii.minDamping, ii.maxDamping, o)),
    (n = $o(ii.minDuration, ii.maxDuration, ks(n))),
    o < 1
      ? ((r = (d) => {
          const p = d * o,
            m = p * n,
            v = p - t,
            y = q_(d, o),
            x = Math.exp(-m)
          return vx - (v / y) * x
        }),
        (s = (d) => {
          const m = d * o * n,
            v = m * t + t,
            y = Math.pow(o, 2) * Math.pow(d, 2) * n,
            x = Math.exp(-m),
            E = q_(Math.pow(d, 2), o)
          return ((-r(d) + vx > 0 ? -1 : 1) * ((v - y) * x)) / E
        }))
      : ((r = (d) => {
          const p = Math.exp(-d * n),
            m = (d - t) * n + 1
          return -vx + p * m
        }),
        (s = (d) => {
          const p = Math.exp(-d * n),
            m = (t - d) * (n * n)
          return p * m
        }))
  const l = 5 / n,
    u = VD(r, s, l)
  if (((n = Wa(n)), isNaN(u)))
    return { stiffness: ii.stiffness, damping: ii.damping, duration: n }
  {
    const d = Math.pow(u, 2) * i
    return { stiffness: d, damping: o * 2 * Math.sqrt(i * d), duration: n }
  }
}
const zD = 12
function VD(n, e, t) {
  let i = t
  for (let r = 1; r < zD; r++) i = i - n(i) / e(i)
  return i
}
function q_(n, e) {
  return n * Math.sqrt(1 - e * e)
}
const HD = ["duration", "bounce"],
  GD = ["stiffness", "damping", "mass"]
function FM(n, e) {
  return e.some((t) => n[t] !== void 0)
}
function WD(n) {
  let e = {
    velocity: ii.velocity,
    stiffness: ii.stiffness,
    damping: ii.damping,
    mass: ii.mass,
    isResolvedFromDuration: !1,
    ...n,
  }
  if (!FM(n, GD) && FM(n, HD))
    if (n.visualDuration) {
      const t = n.visualDuration,
        i = (2 * Math.PI) / (t * 1.2),
        r = i * i,
        s = 2 * $o(0.05, 1, 1 - (n.bounce || 0)) * Math.sqrt(r)
      e = { ...e, mass: ii.mass, stiffness: r, damping: s }
    } else {
      const t = BD(n)
      ;(e = { ...e, ...t, mass: ii.mass }), (e.isResolvedFromDuration = !0)
    }
  return e
}
function F0(n = ii.visualDuration, e = ii.bounce) {
  const t =
    typeof n != "object" ? { visualDuration: n, keyframes: [0, 1], bounce: e } : n
  let { restSpeed: i, restDelta: r } = t
  const s = t.keyframes[0],
    o = t.keyframes[t.keyframes.length - 1],
    l = { done: !1, value: s },
    {
      stiffness: u,
      damping: d,
      mass: p,
      duration: m,
      velocity: v,
      isResolvedFromDuration: y,
    } = WD({ ...t, velocity: -ks(t.velocity || 0) }),
    x = v || 0,
    E = d / (2 * Math.sqrt(u * p)),
    M = o - s,
    w = ks(Math.sqrt(u / p)),
    A = Math.abs(M) < 5
  i || (i = A ? ii.restSpeed.granular : ii.restSpeed.default),
    r || (r = A ? ii.restDelta.granular : ii.restDelta.default)
  let C
  if (E < 1) {
    const z = q_(w, E)
    C = (U) => {
      const O = Math.exp(-E * w * U)
      return o - O * (((x + E * w * M) / z) * Math.sin(z * U) + M * Math.cos(z * U))
    }
  } else if (E === 1) C = (z) => o - Math.exp(-w * z) * (M + (x + w * M) * z)
  else {
    const z = w * Math.sqrt(E * E - 1)
    C = (U) => {
      const O = Math.exp(-E * w * U),
        N = Math.min(z * U, 300)
      return o - (O * ((x + E * w * M) * Math.sinh(N) + z * M * Math.cosh(N))) / z
    }
  }
  const R = {
    calculatedDuration: (y && m) || null,
    next: (z) => {
      const U = C(z)
      if (y) l.done = z >= m
      else {
        let O = z === 0 ? x : 0
        E < 1 && (O = z === 0 ? Wa(x) : d2(C, z, U))
        const N = Math.abs(O) <= i,
          k = Math.abs(o - U) <= r
        l.done = N && k
      }
      return (l.value = l.done ? o : U), l
    },
    toString: () => {
      const z = Math.min(tw(R), k0),
        U = f2((O) => R.next(z * O).value, z, 30)
      return z + "ms " + U
    },
    toTransition: () => {},
  }
  return R
}
F0.applyToOptions = (n) => {
  const e = UD(n, 100, F0)
  return (n.ease = e.ease), (n.duration = Wa(e.duration)), (n.type = "keyframes"), n
}
function $_({
  keyframes: n,
  velocity: e = 0,
  power: t = 0.8,
  timeConstant: i = 325,
  bounceDamping: r = 10,
  bounceStiffness: s = 500,
  modifyTarget: o,
  min: l,
  max: u,
  restDelta: d = 0.5,
  restSpeed: p,
}) {
  const m = n[0],
    v = { done: !1, value: m },
    y = (N) => (l !== void 0 && N < l) || (u !== void 0 && N > u),
    x = (N) =>
      l === void 0 ? u : u === void 0 || Math.abs(l - N) < Math.abs(u - N) ? l : u
  let E = t * e
  const M = m + E,
    w = o === void 0 ? M : o(M)
  w !== M && (E = w - m)
  const A = (N) => -E * Math.exp(-N / i),
    C = (N) => w + A(N),
    R = (N) => {
      const k = A(N),
        I = C(N)
      ;(v.done = Math.abs(k) <= d), (v.value = v.done ? w : I)
    }
  let z, U
  const O = (N) => {
    y(v.value) &&
      ((z = N),
      (U = F0({
        keyframes: [v.value, x(v.value)],
        velocity: d2(C, N, v.value),
        damping: r,
        stiffness: s,
        restDelta: d,
        restSpeed: p,
      })))
  }
  return (
    O(0),
    {
      calculatedDuration: null,
      next: (N) => {
        let k = !1
        return (
          !U && z === void 0 && ((k = !0), R(N), O(N)),
          z !== void 0 && N >= z ? U.next(N - z) : (!k && R(N), v)
        )
      },
    }
  )
}
function jD(n, e, t) {
  const i = [],
    r = t || qa.mix || u2,
    s = n.length - 1
  for (let o = 0; o < s; o++) {
    let l = r(n[o], n[o + 1])
    if (e) {
      const u = Array.isArray(e) ? e[o] || Fs : e
      l = cm(u, l)
    }
    i.push(l)
  }
  return i
}
function XD(n, e, { clamp: t = !0, ease: i, mixer: r } = {}) {
  const s = n.length
  if ((X1(s === e.length), s === 1)) return () => e[0]
  if (s === 2 && e[0] === e[1]) return () => e[1]
  const o = n[0] === n[1]
  n[0] > n[s - 1] && ((n = [...n].reverse()), (e = [...e].reverse()))
  const l = jD(e, i, r),
    u = l.length,
    d = (p) => {
      if (o && p < n[0]) return e[0]
      let m = 0
      if (u > 1) for (; m < n.length - 2 && !(p < n[m + 1]); m++);
      const v = Fp(n[m], n[m + 1], p)
      return l[m](v)
    }
  return t ? (p) => d($o(n[0], n[s - 1], p)) : d
}
function YD(n, e) {
  const t = n[n.length - 1]
  for (let i = 1; i <= e; i++) {
    const r = Fp(0, e, i)
    n.push(Kn(t, 1, r))
  }
}
function qD(n) {
  const e = [0]
  return YD(e, n.length - 1), e
}
function $D(n, e) {
  return n.map((t) => t * e)
}
function KD(n, e) {
  return n.map(() => e || QA).splice(0, n.length - 1)
}
function _p({ duration: n = 300, keyframes: e, times: t, ease: i = "easeInOut" }) {
  const r = aD(i) ? i.map(PM) : PM(i),
    s = { done: !1, value: e[0] },
    o = $D(t && t.length === e.length ? t : qD(e), n),
    l = XD(o, e, { ease: Array.isArray(r) ? r : KD(e, r) })
  return {
    calculatedDuration: n,
    next: (u) => ((s.value = l(u)), (s.done = u >= n), s),
  }
}
const ZD = (n) => n !== null
function nw(n, { repeat: e, repeatType: t = "loop" }, i, r = 1) {
  const s = n.filter(ZD),
    l = r < 0 || (e && t !== "loop" && e % 2 === 1) ? 0 : s.length - 1
  return !l || i === void 0 ? s[l] : i
}
const JD = { decay: $_, inertia: $_, tween: _p, keyframes: _p, spring: F0 }
function h2(n) {
  typeof n.type == "string" && (n.type = JD[n.type])
}
class iw {
  constructor() {
    this.updateFinished()
  }
  get finished() {
    return this._finished
  }
  updateFinished() {
    this._finished = new Promise((e) => {
      this.resolve = e
    })
  }
  notifyFinished() {
    this.resolve()
  }
  then(e, t) {
    return this.finished.then(e, t)
  }
}
const QD = (n) => n / 100
class rw extends iw {
  constructor(e) {
    super(),
      (this.state = "idle"),
      (this.startTime = null),
      (this.isStopped = !1),
      (this.currentTime = 0),
      (this.holdTime = null),
      (this.playbackSpeed = 1),
      (this.stop = () => {
        var i, r
        const { motionValue: t } = this.options
        t && t.updatedAt !== Rr.now() && this.tick(Rr.now()),
          (this.isStopped = !0),
          this.state !== "idle" &&
            (this.teardown(), (r = (i = this.options).onStop) == null || r.call(i))
      }),
      (this.options = e),
      this.initAnimation(),
      this.play(),
      e.autoplay === !1 && this.pause()
  }
  initAnimation() {
    const { options: e } = this
    h2(e)
    const {
      type: t = _p,
      repeat: i = 0,
      repeatDelay: r = 0,
      repeatType: s,
      velocity: o = 0,
    } = e
    let { keyframes: l } = e
    const u = t || _p
    u !== _p &&
      typeof l[0] != "number" &&
      ((this.mixKeyframes = cm(QD, u2(l[0], l[1]))), (l = [0, 100]))
    const d = u({ ...e, keyframes: l })
    s === "mirror" &&
      (this.mirroredGenerator = u({ ...e, keyframes: [...l].reverse(), velocity: -o })),
      d.calculatedDuration === null && (d.calculatedDuration = tw(d))
    const { calculatedDuration: p } = d
    ;(this.calculatedDuration = p),
      (this.resolvedDuration = p + r),
      (this.totalDuration = this.resolvedDuration * (i + 1) - r),
      (this.generator = d)
  }
  updateTime(e) {
    const t = Math.round(e - this.startTime) * this.playbackSpeed
    this.holdTime !== null ? (this.currentTime = this.holdTime) : (this.currentTime = t)
  }
  tick(e, t = !1) {
    const {
      generator: i,
      totalDuration: r,
      mixKeyframes: s,
      mirroredGenerator: o,
      resolvedDuration: l,
      calculatedDuration: u,
    } = this
    if (this.startTime === null) return i.next(0)
    const {
      delay: d = 0,
      keyframes: p,
      repeat: m,
      repeatType: v,
      repeatDelay: y,
      type: x,
      onUpdate: E,
      finalKeyframe: M,
    } = this.options
    this.speed > 0
      ? (this.startTime = Math.min(this.startTime, e))
      : this.speed < 0 &&
        (this.startTime = Math.min(e - r / this.speed, this.startTime)),
      t ? (this.currentTime = e) : this.updateTime(e)
    const w = this.currentTime - d * (this.playbackSpeed >= 0 ? 1 : -1),
      A = this.playbackSpeed >= 0 ? w < 0 : w > r
    ;(this.currentTime = Math.max(w, 0)),
      this.state === "finished" && this.holdTime === null && (this.currentTime = r)
    let C = this.currentTime,
      R = i
    if (m) {
      const N = Math.min(this.currentTime, r) / l
      let k = Math.floor(N),
        I = N % 1
      !I && N >= 1 && (I = 1),
        I === 1 && k--,
        (k = Math.min(k, m + 1)),
        !!(k % 2) &&
          (v === "reverse"
            ? ((I = 1 - I), y && (I -= y / l))
            : v === "mirror" && (R = o)),
        (C = $o(0, 1, I) * l)
    }
    const z = A ? { done: !1, value: p[0] } : R.next(C)
    s && (z.value = s(z.value))
    let { done: U } = z
    !A &&
      u !== null &&
      (U = this.playbackSpeed >= 0 ? this.currentTime >= r : this.currentTime <= 0)
    const O =
      this.holdTime === null &&
      (this.state === "finished" || (this.state === "running" && U))
    return (
      O && x !== $_ && (z.value = nw(p, this.options, M, this.speed)),
      E && E(z.value),
      O && this.finish(),
      z
    )
  }
  then(e, t) {
    return this.finished.then(e, t)
  }
  get duration() {
    return ks(this.calculatedDuration)
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {}
    return this.duration + ks(e)
  }
  get time() {
    return ks(this.currentTime)
  }
  set time(e) {
    var t
    ;(e = Wa(e)),
      (this.currentTime = e),
      this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0
        ? (this.holdTime = e)
        : this.driver && (this.startTime = this.driver.now() - e / this.playbackSpeed),
      (t = this.driver) == null || t.start(!1)
  }
  get speed() {
    return this.playbackSpeed
  }
  set speed(e) {
    this.updateTime(Rr.now())
    const t = this.playbackSpeed !== e
    ;(this.playbackSpeed = e), t && (this.time = ks(this.currentTime))
  }
  play() {
    var r, s
    if (this.isStopped) return
    const { driver: e = FD, startTime: t } = this.options
    this.driver || (this.driver = e((o) => this.tick(o))),
      (s = (r = this.options).onPlay) == null || s.call(r)
    const i = this.driver.now()
    this.state === "finished"
      ? (this.updateFinished(), (this.startTime = i))
      : this.holdTime !== null
      ? (this.startTime = i - this.holdTime)
      : this.startTime || (this.startTime = t ?? i),
      this.state === "finished" &&
        this.speed < 0 &&
        (this.startTime += this.calculatedDuration),
      (this.holdTime = null),
      (this.state = "running"),
      this.driver.start()
  }
  pause() {
    ;(this.state = "paused"),
      this.updateTime(Rr.now()),
      (this.holdTime = this.currentTime)
  }
  complete() {
    this.state !== "running" && this.play(),
      (this.state = "finished"),
      (this.holdTime = null)
  }
  finish() {
    var e, t
    this.notifyFinished(),
      this.teardown(),
      (this.state = "finished"),
      (t = (e = this.options).onComplete) == null || t.call(e)
  }
  cancel() {
    var e, t
    ;(this.holdTime = null),
      (this.startTime = 0),
      this.tick(0),
      this.teardown(),
      (t = (e = this.options).onCancel) == null || t.call(e)
  }
  teardown() {
    ;(this.state = "idle"), this.stopDriver(), (this.startTime = this.holdTime = null)
  }
  stopDriver() {
    this.driver && (this.driver.stop(), (this.driver = void 0))
  }
  sample(e) {
    return (this.startTime = 0), this.tick(e, !0)
  }
  attachTimeline(e) {
    var t
    return (
      this.options.allowFlatten &&
        ((this.options.type = "keyframes"),
        (this.options.ease = "linear"),
        this.initAnimation()),
      (t = this.driver) == null || t.stop(),
      e.observe(this)
    )
  }
}
function eN(n) {
  for (let e = 1; e < n.length; e++) n[e] ?? (n[e] = n[e - 1])
}
const vu = (n) => (n * 180) / Math.PI,
  K_ = (n) => {
    const e = vu(Math.atan2(n[1], n[0]))
    return Z_(e)
  },
  tN = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (n) => (Math.abs(n[0]) + Math.abs(n[3])) / 2,
    rotate: K_,
    rotateZ: K_,
    skewX: (n) => vu(Math.atan(n[1])),
    skewY: (n) => vu(Math.atan(n[2])),
    skew: (n) => (Math.abs(n[1]) + Math.abs(n[2])) / 2,
  },
  Z_ = (n) => ((n = n % 360), n < 0 && (n += 360), n),
  UM = K_,
  OM = (n) => Math.sqrt(n[0] * n[0] + n[1] * n[1]),
  BM = (n) => Math.sqrt(n[4] * n[4] + n[5] * n[5]),
  nN = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: OM,
    scaleY: BM,
    scale: (n) => (OM(n) + BM(n)) / 2,
    rotateX: (n) => Z_(vu(Math.atan2(n[6], n[5]))),
    rotateY: (n) => Z_(vu(Math.atan2(-n[2], n[0]))),
    rotateZ: UM,
    rotate: UM,
    skewX: (n) => vu(Math.atan(n[4])),
    skewY: (n) => vu(Math.atan(n[1])),
    skew: (n) => (Math.abs(n[1]) + Math.abs(n[4])) / 2,
  }
function J_(n) {
  return n.includes("scale") ? 1 : 0
}
function Q_(n, e) {
  if (!n || n === "none") return J_(e)
  const t = n.match(/^matrix3d\(([-\d.e\s,]+)\)$/u)
  let i, r
  if (t) (i = nN), (r = t)
  else {
    const l = n.match(/^matrix\(([-\d.e\s,]+)\)$/u)
    ;(i = tN), (r = l)
  }
  if (!r) return J_(e)
  const s = i[e],
    o = r[1].split(",").map(rN)
  return typeof s == "function" ? s(o) : o[s]
}
const iN = (n, e) => {
  const { transform: t = "none" } = getComputedStyle(n)
  return Q_(t, e)
}
function rN(n) {
  return parseFloat(n.trim())
}
const zd = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY",
  ],
  Vd = new Set(zd),
  zM = (n) => n === Bd || n === Mt,
  sN = new Set(["x", "y", "z"]),
  oN = zd.filter((n) => !sN.has(n))
function aN(n) {
  const e = []
  return (
    oN.forEach((t) => {
      const i = n.getValue(t)
      i !== void 0 && (e.push([t, i.get()]), i.set(t.startsWith("scale") ? 1 : 0))
    }),
    e
  )
}
const Jl = {
  width: ({ x: n }, { paddingLeft: e = "0", paddingRight: t = "0" }) =>
    n.max - n.min - parseFloat(e) - parseFloat(t),
  height: ({ y: n }, { paddingTop: e = "0", paddingBottom: t = "0" }) =>
    n.max - n.min - parseFloat(e) - parseFloat(t),
  top: (n, { top: e }) => parseFloat(e),
  left: (n, { left: e }) => parseFloat(e),
  bottom: ({ y: n }, { top: e }) => parseFloat(e) + (n.max - n.min),
  right: ({ x: n }, { left: e }) => parseFloat(e) + (n.max - n.min),
  x: (n, { transform: e }) => Q_(e, "x"),
  y: (n, { transform: e }) => Q_(e, "y"),
}
Jl.translateX = Jl.x
Jl.translateY = Jl.y
const Mu = new Set()
let e1 = !1,
  t1 = !1,
  n1 = !1
function p2() {
  if (t1) {
    const n = Array.from(Mu).filter((i) => i.needsMeasurement),
      e = new Set(n.map((i) => i.element)),
      t = new Map()
    e.forEach((i) => {
      const r = aN(i)
      r.length && (t.set(i, r), i.render())
    }),
      n.forEach((i) => i.measureInitialState()),
      e.forEach((i) => {
        i.render()
        const r = t.get(i)
        r &&
          r.forEach(([s, o]) => {
            var l
            ;(l = i.getValue(s)) == null || l.set(o)
          })
      }),
      n.forEach((i) => i.measureEndState()),
      n.forEach((i) => {
        i.suspendedScrollY !== void 0 && window.scrollTo(0, i.suspendedScrollY)
      })
  }
  ;(t1 = !1), (e1 = !1), Mu.forEach((n) => n.complete(n1)), Mu.clear()
}
function m2() {
  Mu.forEach((n) => {
    n.readKeyframes(), n.needsMeasurement && (t1 = !0)
  })
}
function lN() {
  ;(n1 = !0), m2(), p2(), (n1 = !1)
}
class sw {
  constructor(e, t, i, r, s, o = !1) {
    ;(this.state = "pending"),
      (this.isAsync = !1),
      (this.needsMeasurement = !1),
      (this.unresolvedKeyframes = [...e]),
      (this.onComplete = t),
      (this.name = i),
      (this.motionValue = r),
      (this.element = s),
      (this.isAsync = o)
  }
  scheduleResolve() {
    ;(this.state = "scheduled"),
      this.isAsync
        ? (Mu.add(this), e1 || ((e1 = !0), Fn.read(m2), Fn.resolveKeyframes(p2)))
        : (this.readKeyframes(), this.complete())
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, name: t, element: i, motionValue: r } = this
    if (e[0] === null) {
      const s = r == null ? void 0 : r.get(),
        o = e[e.length - 1]
      if (s !== void 0) e[0] = s
      else if (i && t) {
        const l = i.readValue(t, o)
        l != null && (e[0] = l)
      }
      e[0] === void 0 && (e[0] = o), r && s === void 0 && r.set(e[0])
    }
    eN(e)
  }
  setFinalKeyframe() {}
  measureInitialState() {}
  renderEndStyles() {}
  measureEndState() {}
  complete(e = !1) {
    ;(this.state = "complete"),
      this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, e),
      Mu.delete(this)
  }
  cancel() {
    this.state === "scheduled" && (Mu.delete(this), (this.state = "pending"))
  }
  resume() {
    this.state === "pending" && this.scheduleResolve()
  }
}
const cN = (n) => n.startsWith("--")
function uN(n, e, t) {
  cN(e) ? n.style.setProperty(e, t) : (n.style[e] = t)
}
const fN = Y1(() => window.ScrollTimeline !== void 0),
  dN = {}
function hN(n, e) {
  const t = Y1(n)
  return () => dN[e] ?? t()
}
const g2 = hN(() => {
    try {
      document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" })
    } catch {
      return !1
    }
    return !0
  }, "linearEasing"),
  up = ([n, e, t, i]) => `cubic-bezier(${n}, ${e}, ${t}, ${i})`,
  VM = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: up([0, 0.65, 0.55, 1]),
    circOut: up([0.55, 0, 1, 0.45]),
    backIn: up([0.31, 0.01, 0.66, -0.59]),
    backOut: up([0.33, 1.53, 0.69, 0.99]),
  }
function v2(n, e) {
  if (n)
    return typeof n == "function"
      ? g2()
        ? f2(n, e)
        : "ease-out"
      : e2(n)
      ? up(n)
      : Array.isArray(n)
      ? n.map((t) => v2(t, e) || VM.easeOut)
      : VM[n]
}
function pN(
  n,
  e,
  t,
  {
    delay: i = 0,
    duration: r = 300,
    repeat: s = 0,
    repeatType: o = "loop",
    ease: l = "easeOut",
    times: u,
  } = {},
  d = void 0,
) {
  const p = { [e]: t }
  u && (p.offset = u)
  const m = v2(l, r)
  Array.isArray(m) && (p.easing = m)
  const v = {
    delay: i,
    duration: r,
    easing: Array.isArray(m) ? "linear" : m,
    fill: "both",
    iterations: s + 1,
    direction: o === "reverse" ? "alternate" : "normal",
  }
  return d && (v.pseudoElement = d), n.animate(p, v)
}
function y2(n) {
  return typeof n == "function" && "applyToOptions" in n
}
function mN({ type: n, ...e }) {
  return y2(n) && g2()
    ? n.applyToOptions(e)
    : (e.duration ?? (e.duration = 300), e.ease ?? (e.ease = "easeOut"), e)
}
class gN extends iw {
  constructor(e) {
    if (
      (super(),
      (this.finishedTime = null),
      (this.isStopped = !1),
      (this.manualStartTime = null),
      !e)
    )
      return
    const {
      element: t,
      name: i,
      keyframes: r,
      pseudoElement: s,
      allowFlatten: o = !1,
      finalKeyframe: l,
      onComplete: u,
    } = e
    ;(this.isPseudoElement = !!s),
      (this.allowFlatten = o),
      (this.options = e),
      X1(typeof e.type != "string")
    const d = mN(e)
    ;(this.animation = pN(t, i, r, d, s)),
      d.autoplay === !1 && this.animation.pause(),
      (this.animation.onfinish = () => {
        if (((this.finishedTime = this.time), !s)) {
          const p = nw(r, this.options, l, this.speed)
          this.updateMotionValue ? this.updateMotionValue(p) : uN(t, i, p),
            this.animation.cancel()
        }
        u == null || u(), this.notifyFinished()
      })
  }
  play() {
    this.isStopped ||
      ((this.manualStartTime = null),
      this.animation.play(),
      this.state === "finished" && this.updateFinished())
  }
  pause() {
    this.animation.pause()
  }
  complete() {
    var e, t
    ;(t = (e = this.animation).finish) == null || t.call(e)
  }
  cancel() {
    try {
      this.animation.cancel()
    } catch {}
  }
  stop() {
    if (this.isStopped) return
    this.isStopped = !0
    const { state: e } = this
    e === "idle" ||
      e === "finished" ||
      (this.updateMotionValue ? this.updateMotionValue() : this.commitStyles(),
      this.isPseudoElement || this.cancel())
  }
  commitStyles() {
    var t, i, r
    const e = (t = this.options) == null ? void 0 : t.element
    !this.isPseudoElement &&
      e != null &&
      e.isConnected &&
      ((r = (i = this.animation).commitStyles) == null || r.call(i))
  }
  get duration() {
    var t, i
    const e =
      ((i = (t = this.animation.effect) == null ? void 0 : t.getComputedTiming) == null
        ? void 0
        : i.call(t).duration) || 0
    return ks(Number(e))
  }
  get iterationDuration() {
    const { delay: e = 0 } = this.options || {}
    return this.duration + ks(e)
  }
  get time() {
    return ks(Number(this.animation.currentTime) || 0)
  }
  set time(e) {
    ;(this.manualStartTime = null),
      (this.finishedTime = null),
      (this.animation.currentTime = Wa(e))
  }
  get speed() {
    return this.animation.playbackRate
  }
  set speed(e) {
    e < 0 && (this.finishedTime = null), (this.animation.playbackRate = e)
  }
  get state() {
    return this.finishedTime !== null ? "finished" : this.animation.playState
  }
  get startTime() {
    return this.manualStartTime ?? Number(this.animation.startTime)
  }
  set startTime(e) {
    this.manualStartTime = this.animation.startTime = e
  }
  attachTimeline({ timeline: e, observe: t }) {
    var i
    return (
      this.allowFlatten &&
        ((i = this.animation.effect) == null || i.updateTiming({ easing: "linear" })),
      (this.animation.onfinish = null),
      e && fN() ? ((this.animation.timeline = e), Fs) : t(this)
    )
  }
}
const x2 = { anticipate: KA, backInOut: $A, circInOut: JA }
function vN(n) {
  return n in x2
}
function yN(n) {
  typeof n.ease == "string" && vN(n.ease) && (n.ease = x2[n.ease])
}
const yx = 10
class xN extends gN {
  constructor(e) {
    yN(e),
      h2(e),
      super(e),
      e.startTime !== void 0 && (this.startTime = e.startTime),
      (this.options = e)
  }
  updateMotionValue(e) {
    const {
      motionValue: t,
      onUpdate: i,
      onComplete: r,
      element: s,
      ...o
    } = this.options
    if (!t) return
    if (e !== void 0) {
      t.set(e)
      return
    }
    const l = new rw({ ...o, autoplay: !1 }),
      u = Math.max(yx, Rr.now() - this.startTime),
      d = $o(0, yx, u - yx)
    t.setWithVelocity(l.sample(Math.max(0, u - d)).value, l.sample(u).value, d),
      l.stop()
  }
}
const HM = (n, e) =>
  e === "zIndex"
    ? !1
    : !!(
        typeof n == "number" ||
        Array.isArray(n) ||
        (typeof n == "string" && (ic.test(n) || n === "0") && !n.startsWith("url("))
      )
function _N(n) {
  const e = n[0]
  if (n.length === 1) return !0
  for (let t = 0; t < n.length; t++) if (n[t] !== e) return !0
}
function wN(n, e, t, i) {
  const r = n[0]
  if (r === null) return !1
  if (e === "display" || e === "visibility") return !0
  const s = n[n.length - 1],
    o = HM(r, e),
    l = HM(s, e)
  return !o || !l ? !1 : _N(n) || ((t === "spring" || y2(t)) && i)
}
function i1(n) {
  ;(n.duration = 0), (n.type = "keyframes")
}
const SN = new Set(["opacity", "clipPath", "filter", "transform"]),
  MN = Y1(() => Object.hasOwnProperty.call(Element.prototype, "animate"))
function EN(n) {
  var p
  const {
    motionValue: e,
    name: t,
    repeatDelay: i,
    repeatType: r,
    damping: s,
    type: o,
  } = n
  if (
    !(
      ((p = e == null ? void 0 : e.owner) == null ? void 0 : p.current) instanceof
      HTMLElement
    )
  )
    return !1
  const { onUpdate: u, transformTemplate: d } = e.owner.getProps()
  return (
    MN() &&
    t &&
    SN.has(t) &&
    (t !== "transform" || !d) &&
    !u &&
    !i &&
    r !== "mirror" &&
    s !== 0 &&
    o !== "inertia"
  )
}
const TN = 40
class bN extends iw {
  constructor({
    autoplay: e = !0,
    delay: t = 0,
    type: i = "keyframes",
    repeat: r = 0,
    repeatDelay: s = 0,
    repeatType: o = "loop",
    keyframes: l,
    name: u,
    motionValue: d,
    element: p,
    ...m
  }) {
    var x
    super(),
      (this.stop = () => {
        var E, M
        this._animation &&
          (this._animation.stop(), (E = this.stopTimeline) == null || E.call(this)),
          (M = this.keyframeResolver) == null || M.cancel()
      }),
      (this.createdAt = Rr.now())
    const v = {
        autoplay: e,
        delay: t,
        type: i,
        repeat: r,
        repeatDelay: s,
        repeatType: o,
        name: u,
        motionValue: d,
        element: p,
        ...m,
      },
      y = (p == null ? void 0 : p.KeyframeResolver) || sw
    ;(this.keyframeResolver = new y(
      l,
      (E, M, w) => this.onKeyframesResolved(E, M, v, !w),
      u,
      d,
      p,
    )),
      (x = this.keyframeResolver) == null || x.scheduleResolve()
  }
  onKeyframesResolved(e, t, i, r) {
    var M, w
    this.keyframeResolver = void 0
    const { name: s, type: o, velocity: l, delay: u, isHandoff: d, onUpdate: p } = i
    ;(this.resolvedAt = Rr.now()),
      wN(e, s, o, l) ||
        ((qa.instantAnimations || !u) && (p == null || p(nw(e, i, t))),
        (e[0] = e[e.length - 1]),
        i1(i),
        (i.repeat = 0))
    const v = {
        startTime: r
          ? this.resolvedAt
            ? this.resolvedAt - this.createdAt > TN
              ? this.resolvedAt
              : this.createdAt
            : this.createdAt
          : void 0,
        finalKeyframe: t,
        ...i,
        keyframes: e,
      },
      y = !d && EN(v),
      x =
        (w = (M = v.motionValue) == null ? void 0 : M.owner) == null
          ? void 0
          : w.current,
      E = y ? new xN({ ...v, element: x }) : new rw(v)
    E.finished
      .then(() => {
        this.notifyFinished()
      })
      .catch(Fs),
      this.pendingTimeline &&
        ((this.stopTimeline = E.attachTimeline(this.pendingTimeline)),
        (this.pendingTimeline = void 0)),
      (this._animation = E)
  }
  get finished() {
    return this._animation ? this.animation.finished : this._finished
  }
  then(e, t) {
    return this.finished.finally(e).then(() => {})
  }
  get animation() {
    var e
    return (
      this._animation || ((e = this.keyframeResolver) == null || e.resume(), lN()),
      this._animation
    )
  }
  get duration() {
    return this.animation.duration
  }
  get iterationDuration() {
    return this.animation.iterationDuration
  }
  get time() {
    return this.animation.time
  }
  set time(e) {
    this.animation.time = e
  }
  get speed() {
    return this.animation.speed
  }
  get state() {
    return this.animation.state
  }
  set speed(e) {
    this.animation.speed = e
  }
  get startTime() {
    return this.animation.startTime
  }
  attachTimeline(e) {
    return (
      this._animation
        ? (this.stopTimeline = this.animation.attachTimeline(e))
        : (this.pendingTimeline = e),
      () => this.stop()
    )
  }
  play() {
    this.animation.play()
  }
  pause() {
    this.animation.pause()
  }
  complete() {
    this.animation.complete()
  }
  cancel() {
    var e
    this._animation && this.animation.cancel(),
      (e = this.keyframeResolver) == null || e.cancel()
  }
}
function _2(n, e, t, i = 0, r = 1) {
  const s = Array.from(n)
      .sort((d, p) => d.sortNodePosition(p))
      .indexOf(e),
    o = n.size,
    l = (o - 1) * i
  return typeof t == "function" ? t(s, o) : r === 1 ? s * i : l - s * i
}
const AN = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u
function CN(n) {
  const e = AN.exec(n)
  if (!e) return [,]
  const [, t, i, r] = e
  return [`--${t ?? i}`, r]
}
function w2(n, e, t = 1) {
  const [i, r] = CN(n)
  if (!i) return
  const s = window.getComputedStyle(e).getPropertyValue(i)
  if (s) {
    const o = s.trim()
    return VA(o) ? parseFloat(o) : o
  }
  return Z1(r) ? w2(r, e, t + 1) : r
}
const RN = { type: "spring", stiffness: 500, damping: 25, restSpeed: 10 },
  PN = (n) => ({
    type: "spring",
    stiffness: 550,
    damping: n === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10,
  }),
  IN = { type: "keyframes", duration: 0.8 },
  LN = { type: "keyframes", ease: [0.25, 0.1, 0.35, 1], duration: 0.3 },
  DN = (n, { keyframes: e }) =>
    e.length > 2 ? IN : Vd.has(n) ? (n.startsWith("scale") ? PN(e[1]) : RN) : LN,
  NN = (n) => n !== null
function kN(n, { repeat: e, repeatType: t = "loop" }, i) {
  const r = n.filter(NN),
    s = e && t !== "loop" && e % 2 === 1 ? 0 : r.length - 1
  return r[s]
}
function ow(n, e) {
  return (n == null ? void 0 : n[e]) ?? (n == null ? void 0 : n.default) ?? n
}
function FN({
  when: n,
  delay: e,
  delayChildren: t,
  staggerChildren: i,
  staggerDirection: r,
  repeat: s,
  repeatType: o,
  repeatDelay: l,
  from: u,
  elapsed: d,
  ...p
}) {
  return !!Object.keys(p).length
}
const aw =
  (n, e, t, i = {}, r, s) =>
  (o) => {
    const l = ow(i, n) || {},
      u = l.delay || i.delay || 0
    let { elapsed: d = 0 } = i
    d = d - Wa(u)
    const p = {
      keyframes: Array.isArray(t) ? t : [null, t],
      ease: "easeOut",
      velocity: e.getVelocity(),
      ...l,
      delay: -d,
      onUpdate: (v) => {
        e.set(v), l.onUpdate && l.onUpdate(v)
      },
      onComplete: () => {
        o(), l.onComplete && l.onComplete()
      },
      name: n,
      motionValue: e,
      element: s ? void 0 : r,
    }
    FN(l) || Object.assign(p, DN(n, p)),
      p.duration && (p.duration = Wa(p.duration)),
      p.repeatDelay && (p.repeatDelay = Wa(p.repeatDelay)),
      p.from !== void 0 && (p.keyframes[0] = p.from)
    let m = !1
    if (
      ((p.type === !1 || (p.duration === 0 && !p.repeatDelay)) &&
        (i1(p), p.delay === 0 && (m = !0)),
      (qa.instantAnimations ||
        qa.skipAnimations ||
        (r != null && r.shouldSkipAnimations)) &&
        ((m = !0), i1(p), (p.delay = 0)),
      (p.allowFlatten = !l.type && !l.ease),
      m && !s && e.get() !== void 0)
    ) {
      const v = kN(p.keyframes, l)
      if (v !== void 0) {
        Fn.update(() => {
          p.onUpdate(v), p.onComplete()
        })
        return
      }
    }
    return l.isSync ? new rw(p) : new bN(p)
  }
function GM(n) {
  const e = [{}, {}]
  return (
    n == null ||
      n.values.forEach((t, i) => {
        ;(e[0][i] = t.get()), (e[1][i] = t.getVelocity())
      }),
    e
  )
}
function lw(n, e, t, i) {
  if (typeof e == "function") {
    const [r, s] = GM(i)
    e = e(t !== void 0 ? t : n.custom, r, s)
  }
  if (
    (typeof e == "string" && (e = n.variants && n.variants[e]), typeof e == "function")
  ) {
    const [r, s] = GM(i)
    e = e(t !== void 0 ? t : n.custom, r, s)
  }
  return e
}
function bd(n, e, t) {
  const i = n.getProps()
  return lw(i, e, t !== void 0 ? t : i.custom, n)
}
const S2 = new Set(["width", "height", "top", "left", "right", "bottom", ...zd]),
  WM = 30,
  UN = (n) => !isNaN(parseFloat(n))
class ON {
  constructor(e, t = {}) {
    ;(this.canTrackVelocity = null),
      (this.events = {}),
      (this.updateAndNotify = (i) => {
        var s
        const r = Rr.now()
        if (
          (this.updatedAt !== r && this.setPrevFrameValue(),
          (this.prev = this.current),
          this.setCurrent(i),
          this.current !== this.prev &&
            ((s = this.events.change) == null || s.notify(this.current),
            this.dependents))
        )
          for (const o of this.dependents) o.dirty()
      }),
      (this.hasAnimated = !1),
      this.setCurrent(e),
      (this.owner = t.owner)
  }
  setCurrent(e) {
    ;(this.current = e),
      (this.updatedAt = Rr.now()),
      this.canTrackVelocity === null &&
        e !== void 0 &&
        (this.canTrackVelocity = UN(this.current))
  }
  setPrevFrameValue(e = this.current) {
    ;(this.prevFrameValue = e), (this.prevUpdatedAt = this.updatedAt)
  }
  onChange(e) {
    return this.on("change", e)
  }
  on(e, t) {
    this.events[e] || (this.events[e] = new q1())
    const i = this.events[e].add(t)
    return e === "change"
      ? () => {
          i(),
            Fn.read(() => {
              this.events.change.getSize() || this.stop()
            })
        }
      : i
  }
  clearListeners() {
    for (const e in this.events) this.events[e].clear()
  }
  attach(e, t) {
    ;(this.passiveEffect = e), (this.stopPassiveEffect = t)
  }
  set(e) {
    this.passiveEffect
      ? this.passiveEffect(e, this.updateAndNotify)
      : this.updateAndNotify(e)
  }
  setWithVelocity(e, t, i) {
    this.set(t),
      (this.prev = void 0),
      (this.prevFrameValue = e),
      (this.prevUpdatedAt = this.updatedAt - i)
  }
  jump(e, t = !0) {
    this.updateAndNotify(e),
      (this.prev = e),
      (this.prevUpdatedAt = this.prevFrameValue = void 0),
      t && this.stop(),
      this.stopPassiveEffect && this.stopPassiveEffect()
  }
  dirty() {
    var e
    ;(e = this.events.change) == null || e.notify(this.current)
  }
  addDependent(e) {
    this.dependents || (this.dependents = new Set()), this.dependents.add(e)
  }
  removeDependent(e) {
    this.dependents && this.dependents.delete(e)
  }
  get() {
    return this.current
  }
  getPrevious() {
    return this.prev
  }
  getVelocity() {
    const e = Rr.now()
    if (
      !this.canTrackVelocity ||
      this.prevFrameValue === void 0 ||
      e - this.updatedAt > WM
    )
      return 0
    const t = Math.min(this.updatedAt - this.prevUpdatedAt, WM)
    return WA(parseFloat(this.current) - parseFloat(this.prevFrameValue), t)
  }
  start(e) {
    return (
      this.stop(),
      new Promise((t) => {
        ;(this.hasAnimated = !0),
          (this.animation = e(t)),
          this.events.animationStart && this.events.animationStart.notify()
      }).then(() => {
        this.events.animationComplete && this.events.animationComplete.notify(),
          this.clearAnimation()
      })
    )
  }
  stop() {
    this.animation &&
      (this.animation.stop(),
      this.events.animationCancel && this.events.animationCancel.notify()),
      this.clearAnimation()
  }
  isAnimating() {
    return !!this.animation
  }
  clearAnimation() {
    delete this.animation
  }
  destroy() {
    var e, t
    ;(e = this.dependents) == null || e.clear(),
      (t = this.events.destroy) == null || t.notify(),
      this.clearListeners(),
      this.stop(),
      this.stopPassiveEffect && this.stopPassiveEffect()
  }
}
function Cd(n, e) {
  return new ON(n, e)
}
const r1 = (n) => Array.isArray(n)
function BN(n, e, t) {
  n.hasValue(e) ? n.getValue(e).set(t) : n.addValue(e, Cd(t))
}
function zN(n) {
  return r1(n) ? n[n.length - 1] || 0 : n
}
function VN(n, e) {
  const t = bd(n, e)
  let { transitionEnd: i = {}, transition: r = {}, ...s } = t || {}
  s = { ...s, ...i }
  for (const o in s) {
    const l = zN(s[o])
    BN(n, o, l)
  }
}
const dr = (n) => !!(n && n.getVelocity)
function HN(n) {
  return !!(dr(n) && n.add)
}
function s1(n, e) {
  const t = n.getValue("willChange")
  if (HN(t)) return t.add(e)
  if (!t && qa.WillChange) {
    const i = new qa.WillChange("auto")
    n.addValue("willChange", i), i.add(e)
  }
}
function cw(n) {
  return n.replace(/([A-Z])/g, (e) => `-${e.toLowerCase()}`)
}
const GN = "framerAppearId",
  M2 = "data-" + cw(GN)
function E2(n) {
  return n.props[M2]
}
function WN({ protectedKeys: n, needsAnimating: e }, t) {
  const i = n.hasOwnProperty(t) && e[t] !== !0
  return (e[t] = !1), i
}
function T2(n, e, { delay: t = 0, transitionOverride: i, type: r } = {}) {
  let { transition: s = n.getDefaultTransition(), transitionEnd: o, ...l } = e
  const u = s == null ? void 0 : s.reduceMotion
  i && (s = i)
  const d = [],
    p = r && n.animationState && n.animationState.getState()[r]
  for (const m in l) {
    const v = n.getValue(m, n.latestValues[m] ?? null),
      y = l[m]
    if (y === void 0 || (p && WN(p, m))) continue
    const x = { delay: t, ...ow(s || {}, m) },
      E = v.get()
    if (E !== void 0 && !v.isAnimating && !Array.isArray(y) && y === E && !x.velocity)
      continue
    let M = !1
    if (window.MotionHandoffAnimation) {
      const C = E2(n)
      if (C) {
        const R = window.MotionHandoffAnimation(C, m, Fn)
        R !== null && ((x.startTime = R), (M = !0))
      }
    }
    s1(n, m)
    const w = u ?? n.shouldReduceMotion
    v.start(aw(m, v, y, w && S2.has(m) ? { type: !1 } : x, n, M))
    const A = v.animation
    A && d.push(A)
  }
  return (
    o &&
      Promise.all(d).then(() => {
        Fn.update(() => {
          o && VN(n, o)
        })
      }),
    d
  )
}
function o1(n, e, t = {}) {
  var u
  const i = bd(
    n,
    e,
    t.type === "exit" ? ((u = n.presenceContext) == null ? void 0 : u.custom) : void 0,
  )
  let { transition: r = n.getDefaultTransition() || {} } = i || {}
  t.transitionOverride && (r = t.transitionOverride)
  const s = i ? () => Promise.all(T2(n, i, t)) : () => Promise.resolve(),
    o =
      n.variantChildren && n.variantChildren.size
        ? (d = 0) => {
            const { delayChildren: p = 0, staggerChildren: m, staggerDirection: v } = r
            return jN(n, e, d, p, m, v, t)
          }
        : () => Promise.resolve(),
    { when: l } = r
  if (l) {
    const [d, p] = l === "beforeChildren" ? [s, o] : [o, s]
    return d().then(() => p())
  } else return Promise.all([s(), o(t.delay)])
}
function jN(n, e, t = 0, i = 0, r = 0, s = 1, o) {
  const l = []
  for (const u of n.variantChildren)
    u.notify("AnimationStart", e),
      l.push(
        o1(u, e, {
          ...o,
          delay:
            t + (typeof i == "function" ? 0 : i) + _2(n.variantChildren, u, i, r, s),
        }).then(() => u.notify("AnimationComplete", e)),
      )
  return Promise.all(l)
}
function XN(n, e, t = {}) {
  n.notify("AnimationStart", e)
  let i
  if (Array.isArray(e)) {
    const r = e.map((s) => o1(n, s, t))
    i = Promise.all(r)
  } else if (typeof e == "string") i = o1(n, e, t)
  else {
    const r = typeof e == "function" ? bd(n, e, t.custom) : e
    i = Promise.all(T2(n, r, t))
  }
  return i.then(() => {
    n.notify("AnimationComplete", e)
  })
}
const YN = { test: (n) => n === "auto", parse: (n) => n },
  b2 = (n) => (e) => e.test(n),
  A2 = [Bd, Mt, jo, Xl, _D, xD, YN],
  jM = (n) => A2.find(b2(n))
function qN(n) {
  return typeof n == "number"
    ? n === 0
    : n !== null
    ? n === "none" || n === "0" || GA(n)
    : !0
}
const $N = new Set(["brightness", "contrast", "saturate", "opacity"])
function KN(n) {
  const [e, t] = n.slice(0, -1).split("(")
  if (e === "drop-shadow") return n
  const [i] = t.match(J1) || []
  if (!i) return n
  const r = t.replace(i, "")
  let s = $N.has(e) ? 1 : 0
  return i !== t && (s *= 100), e + "(" + s + r + ")"
}
const ZN = /\b([a-z-]*)\(.*?\)/gu,
  a1 = {
    ...ic,
    getAnimatableNone: (n) => {
      const e = n.match(ZN)
      return e ? e.map(KN).join(" ") : n
    },
  },
  XM = { ...Bd, transform: Math.round },
  JN = {
    rotate: Xl,
    rotateX: Xl,
    rotateY: Xl,
    rotateZ: Xl,
    scale: Ag,
    scaleX: Ag,
    scaleY: Ag,
    scaleZ: Ag,
    skew: Xl,
    skewX: Xl,
    skewY: Xl,
    distance: Mt,
    translateX: Mt,
    translateY: Mt,
    translateZ: Mt,
    x: Mt,
    y: Mt,
    z: Mt,
    perspective: Mt,
    transformPerspective: Mt,
    opacity: Up,
    originX: LM,
    originY: LM,
    originZ: Mt,
  },
  uw = {
    borderWidth: Mt,
    borderTopWidth: Mt,
    borderRightWidth: Mt,
    borderBottomWidth: Mt,
    borderLeftWidth: Mt,
    borderRadius: Mt,
    borderTopLeftRadius: Mt,
    borderTopRightRadius: Mt,
    borderBottomRightRadius: Mt,
    borderBottomLeftRadius: Mt,
    width: Mt,
    maxWidth: Mt,
    height: Mt,
    maxHeight: Mt,
    top: Mt,
    right: Mt,
    bottom: Mt,
    left: Mt,
    inset: Mt,
    insetBlock: Mt,
    insetBlockStart: Mt,
    insetBlockEnd: Mt,
    insetInline: Mt,
    insetInlineStart: Mt,
    insetInlineEnd: Mt,
    padding: Mt,
    paddingTop: Mt,
    paddingRight: Mt,
    paddingBottom: Mt,
    paddingLeft: Mt,
    paddingBlock: Mt,
    paddingBlockStart: Mt,
    paddingBlockEnd: Mt,
    paddingInline: Mt,
    paddingInlineStart: Mt,
    paddingInlineEnd: Mt,
    margin: Mt,
    marginTop: Mt,
    marginRight: Mt,
    marginBottom: Mt,
    marginLeft: Mt,
    marginBlock: Mt,
    marginBlockStart: Mt,
    marginBlockEnd: Mt,
    marginInline: Mt,
    marginInlineStart: Mt,
    marginInlineEnd: Mt,
    fontSize: Mt,
    backgroundPositionX: Mt,
    backgroundPositionY: Mt,
    ...JN,
    zIndex: XM,
    fillOpacity: Up,
    strokeOpacity: Up,
    numOctaves: XM,
  },
  QN = {
    ...uw,
    color: yi,
    backgroundColor: yi,
    outlineColor: yi,
    fill: yi,
    stroke: yi,
    borderColor: yi,
    borderTopColor: yi,
    borderRightColor: yi,
    borderBottomColor: yi,
    borderLeftColor: yi,
    filter: a1,
    WebkitFilter: a1,
  },
  C2 = (n) => QN[n]
function R2(n, e) {
  let t = C2(n)
  return t !== a1 && (t = ic), t.getAnimatableNone ? t.getAnimatableNone(e) : void 0
}
const ek = new Set(["auto", "none", "0"])
function tk(n, e, t) {
  let i = 0,
    r
  for (; i < n.length && !r; ) {
    const s = n[i]
    typeof s == "string" && !ek.has(s) && Op(s).values.length && (r = n[i]), i++
  }
  if (r && t) for (const s of e) n[s] = R2(t, r)
}
class nk extends sw {
  constructor(e, t, i, r, s) {
    super(e, t, i, r, s, !0)
  }
  readKeyframes() {
    const { unresolvedKeyframes: e, element: t, name: i } = this
    if (!t || !t.current) return
    super.readKeyframes()
    for (let p = 0; p < e.length; p++) {
      let m = e[p]
      if (typeof m == "string" && ((m = m.trim()), Z1(m))) {
        const v = w2(m, t.current)
        v !== void 0 && (e[p] = v), p === e.length - 1 && (this.finalKeyframe = m)
      }
    }
    if ((this.resolveNoneKeyframes(), !S2.has(i) || e.length !== 2)) return
    const [r, s] = e,
      o = jM(r),
      l = jM(s),
      u = IM(r),
      d = IM(s)
    if (u !== d && Jl[i]) {
      this.needsMeasurement = !0
      return
    }
    if (o !== l)
      if (zM(o) && zM(l))
        for (let p = 0; p < e.length; p++) {
          const m = e[p]
          typeof m == "string" && (e[p] = parseFloat(m))
        }
      else Jl[i] && (this.needsMeasurement = !0)
  }
  resolveNoneKeyframes() {
    const { unresolvedKeyframes: e, name: t } = this,
      i = []
    for (let r = 0; r < e.length; r++) (e[r] === null || qN(e[r])) && i.push(r)
    i.length && tk(e, i, t)
  }
  measureInitialState() {
    const { element: e, unresolvedKeyframes: t, name: i } = this
    if (!e || !e.current) return
    i === "height" && (this.suspendedScrollY = window.pageYOffset),
      (this.measuredOrigin = Jl[i](
        e.measureViewportBox(),
        window.getComputedStyle(e.current),
      )),
      (t[0] = this.measuredOrigin)
    const r = t[t.length - 1]
    r !== void 0 && e.getValue(i, r).jump(r, !1)
  }
  measureEndState() {
    var l
    const { element: e, name: t, unresolvedKeyframes: i } = this
    if (!e || !e.current) return
    const r = e.getValue(t)
    r && r.jump(this.measuredOrigin, !1)
    const s = i.length - 1,
      o = i[s]
    ;(i[s] = Jl[t](e.measureViewportBox(), window.getComputedStyle(e.current))),
      o !== null && this.finalKeyframe === void 0 && (this.finalKeyframe = o),
      (l = this.removedTransforms) != null &&
        l.length &&
        this.removedTransforms.forEach(([u, d]) => {
          e.getValue(u).set(d)
        }),
      this.resolveNoneKeyframes()
  }
}
function ik(n, e, t) {
  if (n == null) return []
  if (n instanceof EventTarget) return [n]
  if (typeof n == "string") {
    let i = document
    const r = (t == null ? void 0 : t[n]) ?? i.querySelectorAll(n)
    return r ? Array.from(r) : []
  }
  return Array.from(n).filter((i) => i != null)
}
const P2 = (n, e) => (e && typeof n == "number" ? e.transform(n) : n)
function l1(n) {
  return HA(n) && "offsetHeight" in n
}
const { schedule: fw } = t2(queueMicrotask, !1),
  mo = { x: !1, y: !1 }
function I2() {
  return mo.x || mo.y
}
function rk(n) {
  return n === "x" || n === "y"
    ? mo[n]
      ? null
      : ((mo[n] = !0),
        () => {
          mo[n] = !1
        })
    : mo.x || mo.y
    ? null
    : ((mo.x = mo.y = !0),
      () => {
        mo.x = mo.y = !1
      })
}
function L2(n, e) {
  const t = ik(n),
    i = new AbortController(),
    r = { passive: !0, ...e, signal: i.signal }
  return [t, r, () => i.abort()]
}
function YM(n) {
  return !(n.pointerType === "touch" || I2())
}
function sk(n, e, t = {}) {
  const [i, r, s] = L2(n, t),
    o = (l) => {
      if (!YM(l)) return
      const { target: u } = l,
        d = e(u, l)
      if (typeof d != "function" || !u) return
      const p = (m) => {
        YM(m) && (d(m), u.removeEventListener("pointerleave", p))
      }
      u.addEventListener("pointerleave", p, r)
    }
  return (
    i.forEach((l) => {
      l.addEventListener("pointerenter", o, r)
    }),
    s
  )
}
const D2 = (n, e) => (e ? (n === e ? !0 : D2(n, e.parentElement)) : !1),
  dw = (n) =>
    n.pointerType === "mouse"
      ? typeof n.button != "number" || n.button <= 0
      : n.isPrimary !== !1,
  ok = new Set(["BUTTON", "INPUT", "SELECT", "TEXTAREA", "A"])
function ak(n) {
  return ok.has(n.tagName) || n.isContentEditable === !0
}
const lk = new Set(["INPUT", "SELECT", "TEXTAREA"])
function ck(n) {
  return lk.has(n.tagName) || n.isContentEditable === !0
}
const T0 = new WeakSet()
function qM(n) {
  return (e) => {
    e.key === "Enter" && n(e)
  }
}
function xx(n, e) {
  n.dispatchEvent(new PointerEvent("pointer" + e, { isPrimary: !0, bubbles: !0 }))
}
const uk = (n, e) => {
  const t = n.currentTarget
  if (!t) return
  const i = qM(() => {
    if (T0.has(t)) return
    xx(t, "down")
    const r = qM(() => {
        xx(t, "up")
      }),
      s = () => xx(t, "cancel")
    t.addEventListener("keyup", r, e), t.addEventListener("blur", s, e)
  })
  t.addEventListener("keydown", i, e),
    t.addEventListener("blur", () => t.removeEventListener("keydown", i), e)
}
function $M(n) {
  return dw(n) && !I2()
}
function fk(n, e, t = {}) {
  const [i, r, s] = L2(n, t),
    o = (l) => {
      const u = l.currentTarget
      if (!$M(l)) return
      T0.add(u)
      const d = e(u, l),
        p = (y, x) => {
          window.removeEventListener("pointerup", m),
            window.removeEventListener("pointercancel", v),
            T0.has(u) && T0.delete(u),
            $M(y) && typeof d == "function" && d(y, { success: x })
        },
        m = (y) => {
          p(y, u === window || u === document || t.useGlobalTarget || D2(u, y.target))
        },
        v = (y) => {
          p(y, !1)
        }
      window.addEventListener("pointerup", m, r),
        window.addEventListener("pointercancel", v, r)
    }
  return (
    i.forEach((l) => {
      ;(t.useGlobalTarget ? window : l).addEventListener("pointerdown", o, r),
        l1(l) &&
          (l.addEventListener("focus", (d) => uk(d, r)),
          !ak(l) && !l.hasAttribute("tabindex") && (l.tabIndex = 0))
    }),
    s
  )
}
function N2(n) {
  return HA(n) && "ownerSVGElement" in n
}
function dk(n) {
  return N2(n) && n.tagName === "svg"
}
const hk = [...A2, yi, ic],
  pk = (n) => hk.find(b2(n)),
  KM = () => ({ translate: 0, scale: 1, origin: 0, originPoint: 0 }),
  yd = () => ({ x: KM(), y: KM() }),
  ZM = () => ({ min: 0, max: 0 }),
  Ai = () => ({ x: ZM(), y: ZM() }),
  c1 = { current: null },
  k2 = { current: !1 },
  mk = typeof window < "u"
function gk() {
  if (((k2.current = !0), !!mk))
    if (window.matchMedia) {
      const n = window.matchMedia("(prefers-reduced-motion)"),
        e = () => (c1.current = n.matches)
      n.addEventListener("change", e), e()
    } else c1.current = !1
}
const vk = new WeakMap()
function zv(n) {
  return n !== null && typeof n == "object" && typeof n.start == "function"
}
function Bp(n) {
  return typeof n == "string" || Array.isArray(n)
}
const hw = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit",
  ],
  pw = ["initial", ...hw]
function Vv(n) {
  return zv(n.animate) || pw.some((e) => Bp(n[e]))
}
function F2(n) {
  return !!(Vv(n) || n.variants)
}
function yk(n, e, t) {
  for (const i in e) {
    const r = e[i],
      s = t[i]
    if (dr(r)) n.addValue(i, r)
    else if (dr(s)) n.addValue(i, Cd(r, { owner: n }))
    else if (s !== r)
      if (n.hasValue(i)) {
        const o = n.getValue(i)
        o.liveStyle === !0 ? o.jump(r) : o.hasAnimated || o.set(r)
      } else {
        const o = n.getStaticValue(i)
        n.addValue(i, Cd(o !== void 0 ? o : r, { owner: n }))
      }
  }
  for (const i in t) e[i] === void 0 && n.removeValue(i)
  return e
}
const JM = [
  "AnimationStart",
  "AnimationComplete",
  "Update",
  "BeforeLayoutMeasure",
  "LayoutMeasure",
  "LayoutAnimationStart",
  "LayoutAnimationComplete",
]
let U0 = {}
function U2(n) {
  U0 = n
}
function xk() {
  return U0
}
class _k {
  scrapeMotionValuesFromProps(e, t, i) {
    return {}
  }
  constructor(
    {
      parent: e,
      props: t,
      presenceContext: i,
      reducedMotionConfig: r,
      skipAnimations: s,
      blockInitialAnimation: o,
      visualState: l,
    },
    u = {},
  ) {
    ;(this.current = null),
      (this.children = new Set()),
      (this.isVariantNode = !1),
      (this.isControllingVariants = !1),
      (this.shouldReduceMotion = null),
      (this.shouldSkipAnimations = !1),
      (this.values = new Map()),
      (this.KeyframeResolver = sw),
      (this.features = {}),
      (this.valueSubscriptions = new Map()),
      (this.prevMotionValues = {}),
      (this.events = {}),
      (this.propEventSubscriptions = {}),
      (this.notifyUpdate = () => this.notify("Update", this.latestValues)),
      (this.render = () => {
        this.current &&
          (this.triggerBuild(),
          this.renderInstance(
            this.current,
            this.renderState,
            this.props.style,
            this.projection,
          ))
      }),
      (this.renderScheduledAt = 0),
      (this.scheduleRender = () => {
        const y = Rr.now()
        this.renderScheduledAt < y &&
          ((this.renderScheduledAt = y), Fn.render(this.render, !1, !0))
      })
    const { latestValues: d, renderState: p } = l
    ;(this.latestValues = d),
      (this.baseTarget = { ...d }),
      (this.initialValues = t.initial ? { ...d } : {}),
      (this.renderState = p),
      (this.parent = e),
      (this.props = t),
      (this.presenceContext = i),
      (this.depth = e ? e.depth + 1 : 0),
      (this.reducedMotionConfig = r),
      (this.skipAnimationsConfig = s),
      (this.options = u),
      (this.blockInitialAnimation = !!o),
      (this.isControllingVariants = Vv(t)),
      (this.isVariantNode = F2(t)),
      this.isVariantNode && (this.variantChildren = new Set()),
      (this.manuallyAnimateOnMount = !!(e && e.current))
    const { willChange: m, ...v } = this.scrapeMotionValuesFromProps(t, {}, this)
    for (const y in v) {
      const x = v[y]
      d[y] !== void 0 && dr(x) && x.set(d[y])
    }
  }
  mount(e) {
    var t
    ;(this.current = e),
      vk.set(e, this),
      this.projection && !this.projection.instance && this.projection.mount(e),
      this.parent &&
        this.isVariantNode &&
        !this.isControllingVariants &&
        (this.removeFromVariantTree = this.parent.addVariantChild(this)),
      this.values.forEach((i, r) => this.bindToMotionValue(r, i)),
      this.reducedMotionConfig === "never"
        ? (this.shouldReduceMotion = !1)
        : this.reducedMotionConfig === "always"
        ? (this.shouldReduceMotion = !0)
        : (k2.current || gk(), (this.shouldReduceMotion = c1.current)),
      (this.shouldSkipAnimations = this.skipAnimationsConfig ?? !1),
      (t = this.parent) == null || t.addChild(this),
      this.update(this.props, this.presenceContext)
  }
  unmount() {
    var e
    this.projection && this.projection.unmount(),
      nc(this.notifyUpdate),
      nc(this.render),
      this.valueSubscriptions.forEach((t) => t()),
      this.valueSubscriptions.clear(),
      this.removeFromVariantTree && this.removeFromVariantTree(),
      (e = this.parent) == null || e.removeChild(this)
    for (const t in this.events) this.events[t].clear()
    for (const t in this.features) {
      const i = this.features[t]
      i && (i.unmount(), (i.isMounted = !1))
    }
    this.current = null
  }
  addChild(e) {
    this.children.add(e),
      this.enteringChildren ?? (this.enteringChildren = new Set()),
      this.enteringChildren.add(e)
  }
  removeChild(e) {
    this.children.delete(e), this.enteringChildren && this.enteringChildren.delete(e)
  }
  bindToMotionValue(e, t) {
    this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)()
    const i = Vd.has(e)
    i && this.onBindTransform && this.onBindTransform()
    const r = t.on("change", (o) => {
      ;(this.latestValues[e] = o),
        this.props.onUpdate && Fn.preRender(this.notifyUpdate),
        i && this.projection && (this.projection.isTransformDirty = !0),
        this.scheduleRender()
    })
    let s
    typeof window < "u" &&
      window.MotionCheckAppearSync &&
      (s = window.MotionCheckAppearSync(this, e, t)),
      this.valueSubscriptions.set(e, () => {
        r(), s && s(), t.owner && t.stop()
      })
  }
  sortNodePosition(e) {
    return !this.current || !this.sortInstanceNodePosition || this.type !== e.type
      ? 0
      : this.sortInstanceNodePosition(this.current, e.current)
  }
  updateFeatures() {
    let e = "animation"
    for (e in U0) {
      const t = U0[e]
      if (!t) continue
      const { isEnabled: i, Feature: r } = t
      if (
        (!this.features[e] && r && i(this.props) && (this.features[e] = new r(this)),
        this.features[e])
      ) {
        const s = this.features[e]
        s.isMounted ? s.update() : (s.mount(), (s.isMounted = !0))
      }
    }
  }
  triggerBuild() {
    this.build(this.renderState, this.latestValues, this.props)
  }
  measureViewportBox() {
    return this.current
      ? this.measureInstanceViewportBox(this.current, this.props)
      : Ai()
  }
  getStaticValue(e) {
    return this.latestValues[e]
  }
  setStaticValue(e, t) {
    this.latestValues[e] = t
  }
  update(e, t) {
    ;(e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(),
      (this.prevProps = this.props),
      (this.props = e),
      (this.prevPresenceContext = this.presenceContext),
      (this.presenceContext = t)
    for (let i = 0; i < JM.length; i++) {
      const r = JM[i]
      this.propEventSubscriptions[r] &&
        (this.propEventSubscriptions[r](), delete this.propEventSubscriptions[r])
      const s = "on" + r,
        o = e[s]
      o && (this.propEventSubscriptions[r] = this.on(r, o))
    }
    ;(this.prevMotionValues = yk(
      this,
      this.scrapeMotionValuesFromProps(e, this.prevProps || {}, this),
      this.prevMotionValues,
    )),
      this.handleChildMotionValue && this.handleChildMotionValue()
  }
  getProps() {
    return this.props
  }
  getVariant(e) {
    return this.props.variants ? this.props.variants[e] : void 0
  }
  getDefaultTransition() {
    return this.props.transition
  }
  getTransformPagePoint() {
    return this.props.transformPagePoint
  }
  getClosestVariantNode() {
    return this.isVariantNode
      ? this
      : this.parent
      ? this.parent.getClosestVariantNode()
      : void 0
  }
  addVariantChild(e) {
    const t = this.getClosestVariantNode()
    if (t)
      return (
        t.variantChildren && t.variantChildren.add(e), () => t.variantChildren.delete(e)
      )
  }
  addValue(e, t) {
    const i = this.values.get(e)
    t !== i &&
      (i && this.removeValue(e),
      this.bindToMotionValue(e, t),
      this.values.set(e, t),
      (this.latestValues[e] = t.get()))
  }
  removeValue(e) {
    this.values.delete(e)
    const t = this.valueSubscriptions.get(e)
    t && (t(), this.valueSubscriptions.delete(e)),
      delete this.latestValues[e],
      this.removeValueFromRenderState(e, this.renderState)
  }
  hasValue(e) {
    return this.values.has(e)
  }
  getValue(e, t) {
    if (this.props.values && this.props.values[e]) return this.props.values[e]
    let i = this.values.get(e)
    return (
      i === void 0 &&
        t !== void 0 &&
        ((i = Cd(t === null ? void 0 : t, { owner: this })), this.addValue(e, i)),
      i
    )
  }
  readValue(e, t) {
    let i =
      this.latestValues[e] !== void 0 || !this.current
        ? this.latestValues[e]
        : this.getBaseTargetFromProps(this.props, e) ??
          this.readValueFromInstance(this.current, e, this.options)
    return (
      i != null &&
        (typeof i == "string" && (VA(i) || GA(i))
          ? (i = parseFloat(i))
          : !pk(i) && ic.test(t) && (i = R2(e, t)),
        this.setBaseTarget(e, dr(i) ? i.get() : i)),
      dr(i) ? i.get() : i
    )
  }
  setBaseTarget(e, t) {
    this.baseTarget[e] = t
  }
  getBaseTarget(e) {
    var s
    const { initial: t } = this.props
    let i
    if (typeof t == "string" || typeof t == "object") {
      const o = lw(
        this.props,
        t,
        (s = this.presenceContext) == null ? void 0 : s.custom,
      )
      o && (i = o[e])
    }
    if (t && i !== void 0) return i
    const r = this.getBaseTargetFromProps(this.props, e)
    return r !== void 0 && !dr(r)
      ? r
      : this.initialValues[e] !== void 0 && i === void 0
      ? void 0
      : this.baseTarget[e]
  }
  on(e, t) {
    return this.events[e] || (this.events[e] = new q1()), this.events[e].add(t)
  }
  notify(e, ...t) {
    this.events[e] && this.events[e].notify(...t)
  }
  scheduleRenderMicrotask() {
    fw.render(this.render)
  }
}
class O2 extends _k {
  constructor() {
    super(...arguments), (this.KeyframeResolver = nk)
  }
  sortInstanceNodePosition(e, t) {
    return e.compareDocumentPosition(t) & 2 ? 1 : -1
  }
  getBaseTargetFromProps(e, t) {
    const i = e.style
    return i ? i[t] : void 0
  }
  removeValueFromRenderState(e, { vars: t, style: i }) {
    delete t[e], delete i[e]
  }
  handleChildMotionValue() {
    this.childSubscription && (this.childSubscription(), delete this.childSubscription)
    const { children: e } = this.props
    dr(e) &&
      (this.childSubscription = e.on("change", (t) => {
        this.current && (this.current.textContent = `${t}`)
      }))
  }
}
class oc {
  constructor(e) {
    ;(this.isMounted = !1), (this.node = e)
  }
  update() {}
}
function B2({ top: n, left: e, right: t, bottom: i }) {
  return { x: { min: e, max: t }, y: { min: n, max: i } }
}
function wk({ x: n, y: e }) {
  return { top: e.min, right: n.max, bottom: e.max, left: n.min }
}
function Sk(n, e) {
  if (!e) return n
  const t = e({ x: n.left, y: n.top }),
    i = e({ x: n.right, y: n.bottom })
  return { top: t.y, left: t.x, bottom: i.y, right: i.x }
}
function _x(n) {
  return n === void 0 || n === 1
}
function u1({ scale: n, scaleX: e, scaleY: t }) {
  return !_x(n) || !_x(e) || !_x(t)
}
function uu(n) {
  return (
    u1(n) || z2(n) || n.z || n.rotate || n.rotateX || n.rotateY || n.skewX || n.skewY
  )
}
function z2(n) {
  return QM(n.x) || QM(n.y)
}
function QM(n) {
  return n && n !== "0%"
}
function O0(n, e, t) {
  const i = n - t,
    r = e * i
  return t + r
}
function eE(n, e, t, i, r) {
  return r !== void 0 && (n = O0(n, r, i)), O0(n, t, i) + e
}
function f1(n, e = 0, t = 1, i, r) {
  ;(n.min = eE(n.min, e, t, i, r)), (n.max = eE(n.max, e, t, i, r))
}
function V2(n, { x: e, y: t }) {
  f1(n.x, e.translate, e.scale, e.originPoint),
    f1(n.y, t.translate, t.scale, t.originPoint)
}
const tE = 0.999999999999,
  nE = 1.0000000000001
function Mk(n, e, t, i = !1) {
  const r = t.length
  if (!r) return
  e.x = e.y = 1
  let s, o
  for (let l = 0; l < r; l++) {
    ;(s = t[l]), (o = s.projectionDelta)
    const { visualElement: u } = s.options
    ;(u && u.props.style && u.props.style.display === "contents") ||
      (i &&
        s.options.layoutScroll &&
        s.scroll &&
        s !== s.root &&
        _d(n, { x: -s.scroll.offset.x, y: -s.scroll.offset.y }),
      o && ((e.x *= o.x.scale), (e.y *= o.y.scale), V2(n, o)),
      i && uu(s.latestValues) && _d(n, s.latestValues))
  }
  e.x < nE && e.x > tE && (e.x = 1), e.y < nE && e.y > tE && (e.y = 1)
}
function xd(n, e) {
  ;(n.min = n.min + e), (n.max = n.max + e)
}
function iE(n, e, t, i, r = 0.5) {
  const s = Kn(n.min, n.max, r)
  f1(n, e, t, s, i)
}
function _d(n, e) {
  iE(n.x, e.x, e.scaleX, e.scale, e.originX), iE(n.y, e.y, e.scaleY, e.scale, e.originY)
}
function H2(n, e) {
  return B2(Sk(n.getBoundingClientRect(), e))
}
function Ek(n, e, t) {
  const i = H2(n, t),
    { scroll: r } = e
  return r && (xd(i.x, r.offset.x), xd(i.y, r.offset.y)), i
}
const Tk = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective",
  },
  bk = zd.length
function Ak(n, e, t) {
  let i = "",
    r = !0
  for (let s = 0; s < bk; s++) {
    const o = zd[s],
      l = n[o]
    if (l === void 0) continue
    let u = !0
    if (typeof l == "number") u = l === (o.startsWith("scale") ? 1 : 0)
    else {
      const d = parseFloat(l)
      u = o.startsWith("scale") ? d === 1 : d === 0
    }
    if (!u || t) {
      const d = P2(l, uw[o])
      if (!u) {
        r = !1
        const p = Tk[o] || o
        i += `${p}(${d}) `
      }
      t && (e[o] = d)
    }
  }
  return (i = i.trim()), t ? (i = t(e, r ? "" : i)) : r && (i = "none"), i
}
function mw(n, e, t) {
  const { style: i, vars: r, transformOrigin: s } = n
  let o = !1,
    l = !1
  for (const u in e) {
    const d = e[u]
    if (Vd.has(u)) {
      o = !0
      continue
    } else if (i2(u)) {
      r[u] = d
      continue
    } else {
      const p = P2(d, uw[u])
      u.startsWith("origin") ? ((l = !0), (s[u] = p)) : (i[u] = p)
    }
  }
  if (
    (e.transform ||
      (o || t
        ? (i.transform = Ak(e, n.transform, t))
        : i.transform && (i.transform = "none")),
    l)
  ) {
    const { originX: u = "50%", originY: d = "50%", originZ: p = 0 } = s
    i.transformOrigin = `${u} ${d} ${p}`
  }
}
function G2(n, { style: e, vars: t }, i, r) {
  const s = n.style
  let o
  for (o in e) s[o] = e[o]
  r == null || r.applyProjectionStyles(s, i)
  for (o in t) s.setProperty(o, t[o])
}
function rE(n, e) {
  return e.max === e.min ? 0 : (n / (e.max - e.min)) * 100
}
const jh = {
    correct: (n, e) => {
      if (!e.target) return n
      if (typeof n == "string")
        if (Mt.test(n)) n = parseFloat(n)
        else return n
      const t = rE(n, e.target.x),
        i = rE(n, e.target.y)
      return `${t}% ${i}%`
    },
  },
  Ck = {
    correct: (n, { treeScale: e, projectionDelta: t }) => {
      const i = n,
        r = ic.parse(n)
      if (r.length > 5) return i
      const s = ic.createTransformer(n),
        o = typeof r[0] != "number" ? 1 : 0,
        l = t.x.scale * e.x,
        u = t.y.scale * e.y
      ;(r[0 + o] /= l), (r[1 + o] /= u)
      const d = Kn(l, u, 0.5)
      return (
        typeof r[2 + o] == "number" && (r[2 + o] /= d),
        typeof r[3 + o] == "number" && (r[3 + o] /= d),
        s(r)
      )
    },
  },
  d1 = {
    borderRadius: {
      ...jh,
      applyTo: [
        "borderTopLeftRadius",
        "borderTopRightRadius",
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
      ],
    },
    borderTopLeftRadius: jh,
    borderTopRightRadius: jh,
    borderBottomLeftRadius: jh,
    borderBottomRightRadius: jh,
    boxShadow: Ck,
  }
function W2(n, { layout: e, layoutId: t }) {
  return (
    Vd.has(n) ||
    n.startsWith("origin") ||
    ((e || t !== void 0) && (!!d1[n] || n === "opacity"))
  )
}
function gw(n, e, t) {
  var o
  const i = n.style,
    r = e == null ? void 0 : e.style,
    s = {}
  if (!i) return s
  for (const l in i)
    (dr(i[l]) ||
      (r && dr(r[l])) ||
      W2(l, n) ||
      ((o = t == null ? void 0 : t.getValue(l)) == null ? void 0 : o.liveStyle) !==
        void 0) &&
      (s[l] = i[l])
  return s
}
function Rk(n) {
  return window.getComputedStyle(n)
}
class Pk extends O2 {
  constructor() {
    super(...arguments), (this.type = "html"), (this.renderInstance = G2)
  }
  readValueFromInstance(e, t) {
    var i
    if (Vd.has(t))
      return (i = this.projection) != null && i.isProjecting ? J_(t) : iN(e, t)
    {
      const r = Rk(e),
        s = (i2(t) ? r.getPropertyValue(t) : r[t]) || 0
      return typeof s == "string" ? s.trim() : s
    }
  }
  measureInstanceViewportBox(e, { transformPagePoint: t }) {
    return H2(e, t)
  }
  build(e, t, i) {
    mw(e, t, i.transformTemplate)
  }
  scrapeMotionValuesFromProps(e, t, i) {
    return gw(e, t, i)
  }
}
const Ik = { offset: "stroke-dashoffset", array: "stroke-dasharray" },
  Lk = { offset: "strokeDashoffset", array: "strokeDasharray" }
function Dk(n, e, t = 1, i = 0, r = !0) {
  n.pathLength = 1
  const s = r ? Ik : Lk
  ;(n[s.offset] = `${-i}`), (n[s.array] = `${e} ${t}`)
}
const Nk = ["offsetDistance", "offsetPath", "offsetRotate", "offsetAnchor"]
function j2(
  n,
  {
    attrX: e,
    attrY: t,
    attrScale: i,
    pathLength: r,
    pathSpacing: s = 1,
    pathOffset: o = 0,
    ...l
  },
  u,
  d,
  p,
) {
  if ((mw(n, l, d), u)) {
    n.style.viewBox && (n.attrs.viewBox = n.style.viewBox)
    return
  }
  ;(n.attrs = n.style), (n.style = {})
  const { attrs: m, style: v } = n
  m.transform && ((v.transform = m.transform), delete m.transform),
    (v.transform || m.transformOrigin) &&
      ((v.transformOrigin = m.transformOrigin ?? "50% 50%"), delete m.transformOrigin),
    v.transform &&
      ((v.transformBox = (p == null ? void 0 : p.transformBox) ?? "fill-box"),
      delete m.transformBox)
  for (const y of Nk) m[y] !== void 0 && ((v[y] = m[y]), delete m[y])
  e !== void 0 && (m.x = e),
    t !== void 0 && (m.y = t),
    i !== void 0 && (m.scale = i),
    r !== void 0 && Dk(m, r, s, o, !1)
}
const X2 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust",
  ]),
  Y2 = (n) => typeof n == "string" && n.toLowerCase() === "svg"
function kk(n, e, t, i) {
  G2(n, e, void 0, i)
  for (const r in e.attrs) n.setAttribute(X2.has(r) ? r : cw(r), e.attrs[r])
}
function q2(n, e, t) {
  const i = gw(n, e, t)
  for (const r in n)
    if (dr(n[r]) || dr(e[r])) {
      const s =
        zd.indexOf(r) !== -1 ? "attr" + r.charAt(0).toUpperCase() + r.substring(1) : r
      i[s] = n[r]
    }
  return i
}
class Fk extends O2 {
  constructor() {
    super(...arguments),
      (this.type = "svg"),
      (this.isSVGTag = !1),
      (this.measureInstanceViewportBox = Ai)
  }
  getBaseTargetFromProps(e, t) {
    return e[t]
  }
  readValueFromInstance(e, t) {
    if (Vd.has(t)) {
      const i = C2(t)
      return (i && i.default) || 0
    }
    return (t = X2.has(t) ? t : cw(t)), e.getAttribute(t)
  }
  scrapeMotionValuesFromProps(e, t, i) {
    return q2(e, t, i)
  }
  build(e, t, i) {
    j2(e, t, this.isSVGTag, i.transformTemplate, i.style)
  }
  renderInstance(e, t, i, r) {
    kk(e, t, i, r)
  }
  mount(e) {
    ;(this.isSVGTag = Y2(e.tagName)), super.mount(e)
  }
}
const Uk = pw.length
function $2(n) {
  if (!n) return
  if (!n.isControllingVariants) {
    const t = n.parent ? $2(n.parent) || {} : {}
    return n.props.initial !== void 0 && (t.initial = n.props.initial), t
  }
  const e = {}
  for (let t = 0; t < Uk; t++) {
    const i = pw[t],
      r = n.props[i]
    ;(Bp(r) || r === !1) && (e[i] = r)
  }
  return e
}
function K2(n, e) {
  if (!Array.isArray(e)) return !1
  const t = e.length
  if (t !== n.length) return !1
  for (let i = 0; i < t; i++) if (e[i] !== n[i]) return !1
  return !0
}
const Ok = [...hw].reverse(),
  Bk = hw.length
function zk(n) {
  return (e) => Promise.all(e.map(({ animation: t, options: i }) => XN(n, t, i)))
}
function Vk(n) {
  let e = zk(n),
    t = sE(),
    i = !0
  const r = (u) => (d, p) => {
    var v
    const m = bd(
      n,
      p,
      u === "exit" ? ((v = n.presenceContext) == null ? void 0 : v.custom) : void 0,
    )
    if (m) {
      const { transition: y, transitionEnd: x, ...E } = m
      d = { ...d, ...E, ...x }
    }
    return d
  }
  function s(u) {
    e = u(n)
  }
  function o(u) {
    const { props: d } = n,
      p = $2(n.parent) || {},
      m = [],
      v = new Set()
    let y = {},
      x = 1 / 0
    for (let M = 0; M < Bk; M++) {
      const w = Ok[M],
        A = t[w],
        C = d[w] !== void 0 ? d[w] : p[w],
        R = Bp(C),
        z = w === u ? A.isActive : null
      z === !1 && (x = M)
      let U = C === p[w] && C !== d[w] && R
      if (
        (U && i && n.manuallyAnimateOnMount && (U = !1),
        (A.protectedKeys = { ...y }),
        (!A.isActive && z === null) ||
          (!C && !A.prevProp) ||
          zv(C) ||
          typeof C == "boolean")
      )
        continue
      const O = Hk(A.prevProp, C)
      let N = O || (w === u && A.isActive && !U && R) || (M > x && R),
        k = !1
      const I = Array.isArray(C) ? C : [C]
      let V = I.reduce(r(w), {})
      z === !1 && (V = {})
      const { prevResolvedValues: Z = {} } = A,
        $ = { ...Z, ...V },
        ee = (se) => {
          ;(N = !0), v.has(se) && ((k = !0), v.delete(se)), (A.needsAnimating[se] = !0)
          const G = n.getValue(se)
          G && (G.liveStyle = !1)
        }
      for (const se in $) {
        const G = V[se],
          ie = Z[se]
        if (y.hasOwnProperty(se)) continue
        let Q = !1
        r1(G) && r1(ie) ? (Q = !K2(G, ie)) : (Q = G !== ie),
          Q
            ? G != null
              ? ee(se)
              : v.add(se)
            : G !== void 0 && v.has(se)
            ? ee(se)
            : (A.protectedKeys[se] = !0)
      }
      ;(A.prevProp = C),
        (A.prevResolvedValues = V),
        A.isActive && (y = { ...y, ...V }),
        i && n.blockInitialAnimation && (N = !1)
      const ue = U && O
      N &&
        (!ue || k) &&
        m.push(
          ...I.map((se) => {
            const G = { type: w }
            if (
              typeof se == "string" &&
              i &&
              !ue &&
              n.manuallyAnimateOnMount &&
              n.parent
            ) {
              const { parent: ie } = n,
                Q = bd(ie, se)
              if (ie.enteringChildren && Q) {
                const { delayChildren: W } = Q.transition || {}
                G.delay = _2(ie.enteringChildren, n, W)
              }
            }
            return { animation: se, options: G }
          }),
        )
    }
    if (v.size) {
      const M = {}
      if (typeof d.initial != "boolean") {
        const w = bd(n, Array.isArray(d.initial) ? d.initial[0] : d.initial)
        w && w.transition && (M.transition = w.transition)
      }
      v.forEach((w) => {
        const A = n.getBaseTarget(w),
          C = n.getValue(w)
        C && (C.liveStyle = !0), (M[w] = A ?? null)
      }),
        m.push({ animation: M })
    }
    let E = !!m.length
    return (
      i &&
        (d.initial === !1 || d.initial === d.animate) &&
        !n.manuallyAnimateOnMount &&
        (E = !1),
      (i = !1),
      E ? e(m) : Promise.resolve()
    )
  }
  function l(u, d) {
    var m
    if (t[u].isActive === d) return Promise.resolve()
    ;(m = n.variantChildren) == null ||
      m.forEach((v) => {
        var y
        return (y = v.animationState) == null ? void 0 : y.setActive(u, d)
      }),
      (t[u].isActive = d)
    const p = o(u)
    for (const v in t) t[v].protectedKeys = {}
    return p
  }
  return {
    animateChanges: o,
    setActive: l,
    setAnimateFunction: s,
    getState: () => t,
    reset: () => {
      t = sE()
    },
  }
}
function Hk(n, e) {
  return typeof e == "string" ? e !== n : Array.isArray(e) ? !K2(e, n) : !1
}
function $c(n = !1) {
  return { isActive: n, protectedKeys: {}, needsAnimating: {}, prevResolvedValues: {} }
}
function sE() {
  return {
    animate: $c(!0),
    whileInView: $c(),
    whileHover: $c(),
    whileTap: $c(),
    whileDrag: $c(),
    whileFocus: $c(),
    exit: $c(),
  }
}
function oE(n, e) {
  ;(n.min = e.min), (n.max = e.max)
}
function lo(n, e) {
  oE(n.x, e.x), oE(n.y, e.y)
}
function aE(n, e) {
  ;(n.translate = e.translate),
    (n.scale = e.scale),
    (n.originPoint = e.originPoint),
    (n.origin = e.origin)
}
const Z2 = 1e-4,
  Gk = 1 - Z2,
  Wk = 1 + Z2,
  J2 = 0.01,
  jk = 0 - J2,
  Xk = 0 + J2
function Pr(n) {
  return n.max - n.min
}
function Yk(n, e, t) {
  return Math.abs(n - e) <= t
}
function lE(n, e, t, i = 0.5) {
  ;(n.origin = i),
    (n.originPoint = Kn(e.min, e.max, n.origin)),
    (n.scale = Pr(t) / Pr(e)),
    (n.translate = Kn(t.min, t.max, n.origin) - n.originPoint),
    ((n.scale >= Gk && n.scale <= Wk) || isNaN(n.scale)) && (n.scale = 1),
    ((n.translate >= jk && n.translate <= Xk) || isNaN(n.translate)) &&
      (n.translate = 0)
}
function wp(n, e, t, i) {
  lE(n.x, e.x, t.x, i ? i.originX : void 0), lE(n.y, e.y, t.y, i ? i.originY : void 0)
}
function cE(n, e, t) {
  ;(n.min = t.min + e.min), (n.max = n.min + Pr(e))
}
function qk(n, e, t) {
  cE(n.x, e.x, t.x), cE(n.y, e.y, t.y)
}
function uE(n, e, t) {
  ;(n.min = e.min - t.min), (n.max = n.min + Pr(e))
}
function B0(n, e, t) {
  uE(n.x, e.x, t.x), uE(n.y, e.y, t.y)
}
function fE(n, e, t, i, r) {
  return (n -= e), (n = O0(n, 1 / t, i)), r !== void 0 && (n = O0(n, 1 / r, i)), n
}
function $k(n, e = 0, t = 1, i = 0.5, r, s = n, o = n) {
  if (
    (jo.test(e) && ((e = parseFloat(e)), (e = Kn(o.min, o.max, e / 100) - o.min)),
    typeof e != "number")
  )
    return
  let l = Kn(s.min, s.max, i)
  n === s && (l -= e), (n.min = fE(n.min, e, t, l, r)), (n.max = fE(n.max, e, t, l, r))
}
function dE(n, e, [t, i, r], s, o) {
  $k(n, e[t], e[i], e[r], e.scale, s, o)
}
const Kk = ["x", "scaleX", "originX"],
  Zk = ["y", "scaleY", "originY"]
function hE(n, e, t, i) {
  dE(n.x, e, Kk, t ? t.x : void 0, i ? i.x : void 0),
    dE(n.y, e, Zk, t ? t.y : void 0, i ? i.y : void 0)
}
function pE(n) {
  return n.translate === 0 && n.scale === 1
}
function Q2(n) {
  return pE(n.x) && pE(n.y)
}
function mE(n, e) {
  return n.min === e.min && n.max === e.max
}
function Jk(n, e) {
  return mE(n.x, e.x) && mE(n.y, e.y)
}
function gE(n, e) {
  return (
    Math.round(n.min) === Math.round(e.min) && Math.round(n.max) === Math.round(e.max)
  )
}
function eC(n, e) {
  return gE(n.x, e.x) && gE(n.y, e.y)
}
function vE(n) {
  return Pr(n.x) / Pr(n.y)
}
function yE(n, e) {
  return (
    n.translate === e.translate &&
    n.scale === e.scale &&
    n.originPoint === e.originPoint
  )
}
function Ds(n) {
  return [n("x"), n("y")]
}
function Qk(n, e, t) {
  let i = ""
  const r = n.x.translate / e.x,
    s = n.y.translate / e.y,
    o = (t == null ? void 0 : t.z) || 0
  if (
    ((r || s || o) && (i = `translate3d(${r}px, ${s}px, ${o}px) `),
    (e.x !== 1 || e.y !== 1) && (i += `scale(${1 / e.x}, ${1 / e.y}) `),
    t)
  ) {
    const {
      transformPerspective: d,
      rotate: p,
      rotateX: m,
      rotateY: v,
      skewX: y,
      skewY: x,
    } = t
    d && (i = `perspective(${d}px) ${i}`),
      p && (i += `rotate(${p}deg) `),
      m && (i += `rotateX(${m}deg) `),
      v && (i += `rotateY(${v}deg) `),
      y && (i += `skewX(${y}deg) `),
      x && (i += `skewY(${x}deg) `)
  }
  const l = n.x.scale * e.x,
    u = n.y.scale * e.y
  return (l !== 1 || u !== 1) && (i += `scale(${l}, ${u})`), i || "none"
}
const tC = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"],
  e4 = tC.length,
  xE = (n) => (typeof n == "string" ? parseFloat(n) : n),
  _E = (n) => typeof n == "number" || Mt.test(n)
function t4(n, e, t, i, r, s) {
  r
    ? ((n.opacity = Kn(0, t.opacity ?? 1, n4(i))),
      (n.opacityExit = Kn(e.opacity ?? 1, 0, i4(i))))
    : s && (n.opacity = Kn(e.opacity ?? 1, t.opacity ?? 1, i))
  for (let o = 0; o < e4; o++) {
    const l = `border${tC[o]}Radius`
    let u = wE(e, l),
      d = wE(t, l)
    if (u === void 0 && d === void 0) continue
    u || (u = 0),
      d || (d = 0),
      u === 0 || d === 0 || _E(u) === _E(d)
        ? ((n[l] = Math.max(Kn(xE(u), xE(d), i), 0)),
          (jo.test(d) || jo.test(u)) && (n[l] += "%"))
        : (n[l] = d)
  }
  ;(e.rotate || t.rotate) && (n.rotate = Kn(e.rotate || 0, t.rotate || 0, i))
}
function wE(n, e) {
  return n[e] !== void 0 ? n[e] : n.borderRadius
}
const n4 = nC(0, 0.5, ZA),
  i4 = nC(0.5, 0.95, Fs)
function nC(n, e, t) {
  return (i) => (i < n ? 0 : i > e ? 1 : t(Fp(n, e, i)))
}
function r4(n, e, t) {
  const i = dr(n) ? n : Cd(n)
  return i.start(aw("", i, e, t)), i.animation
}
function zp(n, e, t, i = { passive: !0 }) {
  return n.addEventListener(e, t, i), () => n.removeEventListener(e, t)
}
const s4 = (n, e) => n.depth - e.depth
class o4 {
  constructor() {
    ;(this.children = []), (this.isDirty = !1)
  }
  add(e) {
    W1(this.children, e), (this.isDirty = !0)
  }
  remove(e) {
    j1(this.children, e), (this.isDirty = !0)
  }
  forEach(e) {
    this.isDirty && this.children.sort(s4),
      (this.isDirty = !1),
      this.children.forEach(e)
  }
}
function a4(n, e) {
  const t = Rr.now(),
    i = ({ timestamp: r }) => {
      const s = r - t
      s >= e && (nc(i), n(s - e))
    }
  return Fn.setup(i, !0), () => nc(i)
}
function b0(n) {
  return dr(n) ? n.get() : n
}
class l4 {
  constructor() {
    this.members = []
  }
  add(e) {
    W1(this.members, e), e.scheduleRender()
  }
  remove(e) {
    if (
      (j1(this.members, e),
      e === this.prevLead && (this.prevLead = void 0),
      e === this.lead)
    ) {
      const t = this.members[this.members.length - 1]
      t && this.promote(t)
    }
  }
  relegate(e) {
    const t = this.members.findIndex((r) => e === r)
    if (t === 0) return !1
    let i
    for (let r = t; r >= 0; r--) {
      const s = this.members[r]
      if (s.isPresent !== !1) {
        i = s
        break
      }
    }
    return i ? (this.promote(i), !0) : !1
  }
  promote(e, t) {
    const i = this.lead
    if (e !== i && ((this.prevLead = i), (this.lead = e), e.show(), i)) {
      i.instance && i.scheduleRender(), e.scheduleRender()
      const r = i.options.layoutDependency,
        s = e.options.layoutDependency
      ;(r !== void 0 && s !== void 0 && r === s) ||
        ((e.resumeFrom = i),
        t && (e.resumeFrom.preserveOpacity = !0),
        i.snapshot &&
          ((e.snapshot = i.snapshot),
          (e.snapshot.latestValues = i.animationValues || i.latestValues)),
        e.root && e.root.isUpdating && (e.isLayoutDirty = !0))
      const { crossfade: l } = e.options
      l === !1 && i.hide()
    }
  }
  exitAnimationComplete() {
    this.members.forEach((e) => {
      const { options: t, resumingFrom: i } = e
      t.onExitComplete && t.onExitComplete(),
        i && i.options.onExitComplete && i.options.onExitComplete()
    })
  }
  scheduleRender() {
    this.members.forEach((e) => {
      e.instance && e.scheduleRender(!1)
    })
  }
  removeLeadSnapshot() {
    this.lead && this.lead.snapshot && (this.lead.snapshot = void 0)
  }
}
const A0 = { hasAnimatedSinceResize: !0, hasEverUpdated: !1 },
  wx = ["", "X", "Y", "Z"],
  c4 = 1e3
let u4 = 0
function Sx(n, e, t, i) {
  const { latestValues: r } = e
  r[n] && ((t[n] = r[n]), e.setStaticValue(n, 0), i && (i[n] = 0))
}
function iC(n) {
  if (((n.hasCheckedOptimisedAppear = !0), n.root === n)) return
  const { visualElement: e } = n.options
  if (!e) return
  const t = E2(e)
  if (window.MotionHasOptimisedAnimation(t, "transform")) {
    const { layout: r, layoutId: s } = n.options
    window.MotionCancelOptimisedAnimation(t, "transform", Fn, !(r || s))
  }
  const { parent: i } = n
  i && !i.hasCheckedOptimisedAppear && iC(i)
}
function rC({
  attachResizeListener: n,
  defaultParent: e,
  measureScroll: t,
  checkIsScrollRoot: i,
  resetTransform: r,
}) {
  return class {
    constructor(o = {}, l = e == null ? void 0 : e()) {
      ;(this.id = u4++),
        (this.animationId = 0),
        (this.animationCommitId = 0),
        (this.children = new Set()),
        (this.options = {}),
        (this.isTreeAnimating = !1),
        (this.isAnimationBlocked = !1),
        (this.isLayoutDirty = !1),
        (this.isProjectionDirty = !1),
        (this.isSharedProjectionDirty = !1),
        (this.isTransformDirty = !1),
        (this.updateManuallyBlocked = !1),
        (this.updateBlockedByResize = !1),
        (this.isUpdating = !1),
        (this.isSVG = !1),
        (this.needsReset = !1),
        (this.shouldResetTransform = !1),
        (this.hasCheckedOptimisedAppear = !1),
        (this.treeScale = { x: 1, y: 1 }),
        (this.eventHandlers = new Map()),
        (this.hasTreeAnimated = !1),
        (this.layoutVersion = 0),
        (this.updateScheduled = !1),
        (this.scheduleUpdate = () => this.update()),
        (this.projectionUpdateScheduled = !1),
        (this.checkUpdateFailed = () => {
          this.isUpdating && ((this.isUpdating = !1), this.clearAllSnapshots())
        }),
        (this.updateProjection = () => {
          ;(this.projectionUpdateScheduled = !1),
            this.nodes.forEach(h4),
            this.nodes.forEach(v4),
            this.nodes.forEach(y4),
            this.nodes.forEach(p4)
        }),
        (this.resolvedRelativeTargetAt = 0),
        (this.linkedParentVersion = 0),
        (this.hasProjected = !1),
        (this.isVisible = !0),
        (this.animationProgress = 0),
        (this.sharedNodes = new Map()),
        (this.latestValues = o),
        (this.root = l ? l.root || l : this),
        (this.path = l ? [...l.path, l] : []),
        (this.parent = l),
        (this.depth = l ? l.depth + 1 : 0)
      for (let u = 0; u < this.path.length; u++) this.path[u].shouldResetTransform = !0
      this.root === this && (this.nodes = new o4())
    }
    addEventListener(o, l) {
      return (
        this.eventHandlers.has(o) || this.eventHandlers.set(o, new q1()),
        this.eventHandlers.get(o).add(l)
      )
    }
    notifyListeners(o, ...l) {
      const u = this.eventHandlers.get(o)
      u && u.notify(...l)
    }
    hasListeners(o) {
      return this.eventHandlers.has(o)
    }
    mount(o) {
      if (this.instance) return
      ;(this.isSVG = N2(o) && !dk(o)), (this.instance = o)
      const { layoutId: l, layout: u, visualElement: d } = this.options
      if (
        (d && !d.current && d.mount(o),
        this.root.nodes.add(this),
        this.parent && this.parent.children.add(this),
        this.root.hasTreeAnimated && (u || l) && (this.isLayoutDirty = !0),
        n)
      ) {
        let p,
          m = 0
        const v = () => (this.root.updateBlockedByResize = !1)
        Fn.read(() => {
          m = window.innerWidth
        }),
          n(o, () => {
            const y = window.innerWidth
            y !== m &&
              ((m = y),
              (this.root.updateBlockedByResize = !0),
              p && p(),
              (p = a4(v, 250)),
              A0.hasAnimatedSinceResize &&
                ((A0.hasAnimatedSinceResize = !1), this.nodes.forEach(EE)))
          })
      }
      l && this.root.registerSharedNode(l, this),
        this.options.animate !== !1 &&
          d &&
          (l || u) &&
          this.addEventListener(
            "didUpdate",
            ({
              delta: p,
              hasLayoutChanged: m,
              hasRelativeLayoutChanged: v,
              layout: y,
            }) => {
              if (this.isTreeAnimationBlocked()) {
                ;(this.target = void 0), (this.relativeTarget = void 0)
                return
              }
              const x = this.options.transition || d.getDefaultTransition() || M4,
                { onLayoutAnimationStart: E, onLayoutAnimationComplete: M } =
                  d.getProps(),
                w = !this.targetLayout || !eC(this.targetLayout, y),
                A = !m && v
              if (
                this.options.layoutRoot ||
                this.resumeFrom ||
                A ||
                (m && (w || !this.currentAnimation))
              ) {
                this.resumeFrom &&
                  ((this.resumingFrom = this.resumeFrom),
                  (this.resumingFrom.resumingFrom = void 0))
                const C = { ...ow(x, "layout"), onPlay: E, onComplete: M }
                ;(d.shouldReduceMotion || this.options.layoutRoot) &&
                  ((C.delay = 0), (C.type = !1)),
                  this.startAnimation(C),
                  this.setAnimationOrigin(p, A)
              } else
                m || EE(this),
                  this.isLead() &&
                    this.options.onExitComplete &&
                    this.options.onExitComplete()
              this.targetLayout = y
            },
          )
    }
    unmount() {
      this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this)
      const o = this.getStack()
      o && o.remove(this),
        this.parent && this.parent.children.delete(this),
        (this.instance = void 0),
        this.eventHandlers.clear(),
        nc(this.updateProjection)
    }
    blockUpdate() {
      this.updateManuallyBlocked = !0
    }
    unblockUpdate() {
      this.updateManuallyBlocked = !1
    }
    isUpdateBlocked() {
      return this.updateManuallyBlocked || this.updateBlockedByResize
    }
    isTreeAnimationBlocked() {
      return (
        this.isAnimationBlocked ||
        (this.parent && this.parent.isTreeAnimationBlocked()) ||
        !1
      )
    }
    startUpdate() {
      this.isUpdateBlocked() ||
        ((this.isUpdating = !0),
        this.nodes && this.nodes.forEach(x4),
        this.animationId++)
    }
    getTransformTemplate() {
      const { visualElement: o } = this.options
      return o && o.getProps().transformTemplate
    }
    willUpdate(o = !0) {
      if (((this.root.hasTreeAnimated = !0), this.root.isUpdateBlocked())) {
        this.options.onExitComplete && this.options.onExitComplete()
        return
      }
      if (
        (window.MotionCancelOptimisedAnimation &&
          !this.hasCheckedOptimisedAppear &&
          iC(this),
        !this.root.isUpdating && this.root.startUpdate(),
        this.isLayoutDirty)
      )
        return
      this.isLayoutDirty = !0
      for (let p = 0; p < this.path.length; p++) {
        const m = this.path[p]
        ;(m.shouldResetTransform = !0),
          m.updateScroll("snapshot"),
          m.options.layoutRoot && m.willUpdate(!1)
      }
      const { layoutId: l, layout: u } = this.options
      if (l === void 0 && !u) return
      const d = this.getTransformTemplate()
      ;(this.prevTransformTemplateValue = d ? d(this.latestValues, "") : void 0),
        this.updateSnapshot(),
        o && this.notifyListeners("willUpdate")
    }
    update() {
      if (((this.updateScheduled = !1), this.isUpdateBlocked())) {
        this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(SE)
        return
      }
      if (this.animationId <= this.animationCommitId) {
        this.nodes.forEach(ME)
        return
      }
      ;(this.animationCommitId = this.animationId),
        this.isUpdating
          ? ((this.isUpdating = !1),
            this.nodes.forEach(g4),
            this.nodes.forEach(f4),
            this.nodes.forEach(d4))
          : this.nodes.forEach(ME),
        this.clearAllSnapshots()
      const l = Rr.now()
      ;(Ji.delta = $o(0, 1e3 / 60, l - Ji.timestamp)),
        (Ji.timestamp = l),
        (Ji.isProcessing = !0),
        hx.update.process(Ji),
        hx.preRender.process(Ji),
        hx.render.process(Ji),
        (Ji.isProcessing = !1)
    }
    didUpdate() {
      this.updateScheduled ||
        ((this.updateScheduled = !0), fw.read(this.scheduleUpdate))
    }
    clearAllSnapshots() {
      this.nodes.forEach(m4), this.sharedNodes.forEach(_4)
    }
    scheduleUpdateProjection() {
      this.projectionUpdateScheduled ||
        ((this.projectionUpdateScheduled = !0),
        Fn.preRender(this.updateProjection, !1, !0))
    }
    scheduleCheckAfterUnmount() {
      Fn.postRender(() => {
        this.isLayoutDirty ? this.root.didUpdate() : this.root.checkUpdateFailed()
      })
    }
    updateSnapshot() {
      this.snapshot ||
        !this.instance ||
        ((this.snapshot = this.measure()),
        this.snapshot &&
          !Pr(this.snapshot.measuredBox.x) &&
          !Pr(this.snapshot.measuredBox.y) &&
          (this.snapshot = void 0))
    }
    updateLayout() {
      if (
        !this.instance ||
        (this.updateScroll(),
        !(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty)
      )
        return
      if (this.resumeFrom && !this.resumeFrom.instance)
        for (let u = 0; u < this.path.length; u++) this.path[u].updateScroll()
      const o = this.layout
      ;(this.layout = this.measure(!1)),
        this.layoutVersion++,
        (this.layoutCorrected = Ai()),
        (this.isLayoutDirty = !1),
        (this.projectionDelta = void 0),
        this.notifyListeners("measure", this.layout.layoutBox)
      const { visualElement: l } = this.options
      l && l.notify("LayoutMeasure", this.layout.layoutBox, o ? o.layoutBox : void 0)
    }
    updateScroll(o = "measure") {
      let l = !!(this.options.layoutScroll && this.instance)
      if (
        (this.scroll &&
          this.scroll.animationId === this.root.animationId &&
          this.scroll.phase === o &&
          (l = !1),
        l && this.instance)
      ) {
        const u = i(this.instance)
        this.scroll = {
          animationId: this.root.animationId,
          phase: o,
          isRoot: u,
          offset: t(this.instance),
          wasRoot: this.scroll ? this.scroll.isRoot : u,
        }
      }
    }
    resetTransform() {
      if (!r) return
      const o =
          this.isLayoutDirty ||
          this.shouldResetTransform ||
          this.options.alwaysMeasureLayout,
        l = this.projectionDelta && !Q2(this.projectionDelta),
        u = this.getTransformTemplate(),
        d = u ? u(this.latestValues, "") : void 0,
        p = d !== this.prevTransformTemplateValue
      o &&
        this.instance &&
        (l || uu(this.latestValues) || p) &&
        (r(this.instance, d), (this.shouldResetTransform = !1), this.scheduleRender())
    }
    measure(o = !0) {
      const l = this.measurePageBox()
      let u = this.removeElementScroll(l)
      return (
        o && (u = this.removeTransform(u)),
        E4(u),
        {
          animationId: this.root.animationId,
          measuredBox: l,
          layoutBox: u,
          latestValues: {},
          source: this.id,
        }
      )
    }
    measurePageBox() {
      var d
      const { visualElement: o } = this.options
      if (!o) return Ai()
      const l = o.measureViewportBox()
      if (!(((d = this.scroll) == null ? void 0 : d.wasRoot) || this.path.some(T4))) {
        const { scroll: p } = this.root
        p && (xd(l.x, p.offset.x), xd(l.y, p.offset.y))
      }
      return l
    }
    removeElementScroll(o) {
      var u
      const l = Ai()
      if ((lo(l, o), (u = this.scroll) != null && u.wasRoot)) return l
      for (let d = 0; d < this.path.length; d++) {
        const p = this.path[d],
          { scroll: m, options: v } = p
        p !== this.root &&
          m &&
          v.layoutScroll &&
          (m.wasRoot && lo(l, o), xd(l.x, m.offset.x), xd(l.y, m.offset.y))
      }
      return l
    }
    applyTransform(o, l = !1) {
      const u = Ai()
      lo(u, o)
      for (let d = 0; d < this.path.length; d++) {
        const p = this.path[d]
        !l &&
          p.options.layoutScroll &&
          p.scroll &&
          p !== p.root &&
          _d(u, { x: -p.scroll.offset.x, y: -p.scroll.offset.y }),
          uu(p.latestValues) && _d(u, p.latestValues)
      }
      return uu(this.latestValues) && _d(u, this.latestValues), u
    }
    removeTransform(o) {
      const l = Ai()
      lo(l, o)
      for (let u = 0; u < this.path.length; u++) {
        const d = this.path[u]
        if (!d.instance || !uu(d.latestValues)) continue
        u1(d.latestValues) && d.updateSnapshot()
        const p = Ai(),
          m = d.measurePageBox()
        lo(p, m), hE(l, d.latestValues, d.snapshot ? d.snapshot.layoutBox : void 0, p)
      }
      return uu(this.latestValues) && hE(l, this.latestValues), l
    }
    setTargetDelta(o) {
      ;(this.targetDelta = o),
        this.root.scheduleUpdateProjection(),
        (this.isProjectionDirty = !0)
    }
    setOptions(o) {
      this.options = {
        ...this.options,
        ...o,
        crossfade: o.crossfade !== void 0 ? o.crossfade : !0,
      }
    }
    clearMeasurements() {
      ;(this.scroll = void 0),
        (this.layout = void 0),
        (this.snapshot = void 0),
        (this.prevTransformTemplateValue = void 0),
        (this.targetDelta = void 0),
        (this.target = void 0),
        (this.isLayoutDirty = !1)
    }
    forceRelativeParentToResolveTarget() {
      this.relativeParent &&
        this.relativeParent.resolvedRelativeTargetAt !== Ji.timestamp &&
        this.relativeParent.resolveTargetDelta(!0)
    }
    resolveTargetDelta(o = !1) {
      var y
      const l = this.getLead()
      this.isProjectionDirty || (this.isProjectionDirty = l.isProjectionDirty),
        this.isTransformDirty || (this.isTransformDirty = l.isTransformDirty),
        this.isSharedProjectionDirty ||
          (this.isSharedProjectionDirty = l.isSharedProjectionDirty)
      const u = !!this.resumingFrom || this !== l
      if (
        !(
          o ||
          (u && this.isSharedProjectionDirty) ||
          this.isProjectionDirty ||
          ((y = this.parent) != null && y.isProjectionDirty) ||
          this.attemptToResolveRelativeTarget ||
          this.root.updateBlockedByResize
        )
      )
        return
      const { layout: p, layoutId: m } = this.options
      if (!this.layout || !(p || m)) return
      this.resolvedRelativeTargetAt = Ji.timestamp
      const v = this.getClosestProjectingParent()
      v &&
        this.linkedParentVersion !== v.layoutVersion &&
        !v.options.layoutRoot &&
        this.removeRelativeTarget(),
        !this.targetDelta &&
          !this.relativeTarget &&
          (v && v.layout
            ? this.createRelativeTarget(v, this.layout.layoutBox, v.layout.layoutBox)
            : this.removeRelativeTarget()),
        !(!this.relativeTarget && !this.targetDelta) &&
          (this.target || ((this.target = Ai()), (this.targetWithTransforms = Ai())),
          this.relativeTarget &&
          this.relativeTargetOrigin &&
          this.relativeParent &&
          this.relativeParent.target
            ? (this.forceRelativeParentToResolveTarget(),
              qk(this.target, this.relativeTarget, this.relativeParent.target))
            : this.targetDelta
            ? (this.resumingFrom
                ? (this.target = this.applyTransform(this.layout.layoutBox))
                : lo(this.target, this.layout.layoutBox),
              V2(this.target, this.targetDelta))
            : lo(this.target, this.layout.layoutBox),
          this.attemptToResolveRelativeTarget &&
            ((this.attemptToResolveRelativeTarget = !1),
            v &&
            !!v.resumingFrom == !!this.resumingFrom &&
            !v.options.layoutScroll &&
            v.target &&
            this.animationProgress !== 1
              ? this.createRelativeTarget(v, this.target, v.target)
              : (this.relativeParent = this.relativeTarget = void 0)))
    }
    getClosestProjectingParent() {
      if (
        !(!this.parent || u1(this.parent.latestValues) || z2(this.parent.latestValues))
      )
        return this.parent.isProjecting()
          ? this.parent
          : this.parent.getClosestProjectingParent()
    }
    isProjecting() {
      return !!(
        (this.relativeTarget || this.targetDelta || this.options.layoutRoot) &&
        this.layout
      )
    }
    createRelativeTarget(o, l, u) {
      ;(this.relativeParent = o),
        (this.linkedParentVersion = o.layoutVersion),
        this.forceRelativeParentToResolveTarget(),
        (this.relativeTarget = Ai()),
        (this.relativeTargetOrigin = Ai()),
        B0(this.relativeTargetOrigin, l, u),
        lo(this.relativeTarget, this.relativeTargetOrigin)
    }
    removeRelativeTarget() {
      this.relativeParent = this.relativeTarget = void 0
    }
    calcProjection() {
      var x
      const o = this.getLead(),
        l = !!this.resumingFrom || this !== o
      let u = !0
      if (
        ((this.isProjectionDirty ||
          ((x = this.parent) != null && x.isProjectionDirty)) &&
          (u = !1),
        l && (this.isSharedProjectionDirty || this.isTransformDirty) && (u = !1),
        this.resolvedRelativeTargetAt === Ji.timestamp && (u = !1),
        u)
      )
        return
      const { layout: d, layoutId: p } = this.options
      if (
        ((this.isTreeAnimating = !!(
          (this.parent && this.parent.isTreeAnimating) ||
          this.currentAnimation ||
          this.pendingAnimation
        )),
        this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0),
        !this.layout || !(d || p))
      )
        return
      lo(this.layoutCorrected, this.layout.layoutBox)
      const m = this.treeScale.x,
        v = this.treeScale.y
      Mk(this.layoutCorrected, this.treeScale, this.path, l),
        o.layout &&
          !o.target &&
          (this.treeScale.x !== 1 || this.treeScale.y !== 1) &&
          ((o.target = o.layout.layoutBox), (o.targetWithTransforms = Ai()))
      const { target: y } = o
      if (!y) {
        this.prevProjectionDelta &&
          (this.createProjectionDeltas(), this.scheduleRender())
        return
      }
      !this.projectionDelta || !this.prevProjectionDelta
        ? this.createProjectionDeltas()
        : (aE(this.prevProjectionDelta.x, this.projectionDelta.x),
          aE(this.prevProjectionDelta.y, this.projectionDelta.y)),
        wp(this.projectionDelta, this.layoutCorrected, y, this.latestValues),
        (this.treeScale.x !== m ||
          this.treeScale.y !== v ||
          !yE(this.projectionDelta.x, this.prevProjectionDelta.x) ||
          !yE(this.projectionDelta.y, this.prevProjectionDelta.y)) &&
          ((this.hasProjected = !0),
          this.scheduleRender(),
          this.notifyListeners("projectionUpdate", y))
    }
    hide() {
      this.isVisible = !1
    }
    show() {
      this.isVisible = !0
    }
    scheduleRender(o = !0) {
      var l
      if (((l = this.options.visualElement) == null || l.scheduleRender(), o)) {
        const u = this.getStack()
        u && u.scheduleRender()
      }
      this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0)
    }
    createProjectionDeltas() {
      ;(this.prevProjectionDelta = yd()),
        (this.projectionDelta = yd()),
        (this.projectionDeltaWithTransform = yd())
    }
    setAnimationOrigin(o, l = !1) {
      const u = this.snapshot,
        d = u ? u.latestValues : {},
        p = { ...this.latestValues },
        m = yd()
      ;(!this.relativeParent || !this.relativeParent.options.layoutRoot) &&
        (this.relativeTarget = this.relativeTargetOrigin = void 0),
        (this.attemptToResolveRelativeTarget = !l)
      const v = Ai(),
        y = u ? u.source : void 0,
        x = this.layout ? this.layout.source : void 0,
        E = y !== x,
        M = this.getStack(),
        w = !M || M.members.length <= 1,
        A = !!(E && !w && this.options.crossfade === !0 && !this.path.some(S4))
      this.animationProgress = 0
      let C
      ;(this.mixTargetDelta = (R) => {
        const z = R / 1e3
        TE(m.x, o.x, z),
          TE(m.y, o.y, z),
          this.setTargetDelta(m),
          this.relativeTarget &&
            this.relativeTargetOrigin &&
            this.layout &&
            this.relativeParent &&
            this.relativeParent.layout &&
            (B0(v, this.layout.layoutBox, this.relativeParent.layout.layoutBox),
            w4(this.relativeTarget, this.relativeTargetOrigin, v, z),
            C && Jk(this.relativeTarget, C) && (this.isProjectionDirty = !1),
            C || (C = Ai()),
            lo(C, this.relativeTarget)),
          E && ((this.animationValues = p), t4(p, d, this.latestValues, z, A, w)),
          this.root.scheduleUpdateProjection(),
          this.scheduleRender(),
          (this.animationProgress = z)
      }),
        this.mixTargetDelta(this.options.layoutRoot ? 1e3 : 0)
    }
    startAnimation(o) {
      var l, u, d
      this.notifyListeners("animationStart"),
        (l = this.currentAnimation) == null || l.stop(),
        (d = (u = this.resumingFrom) == null ? void 0 : u.currentAnimation) == null ||
          d.stop(),
        this.pendingAnimation &&
          (nc(this.pendingAnimation), (this.pendingAnimation = void 0)),
        (this.pendingAnimation = Fn.update(() => {
          ;(A0.hasAnimatedSinceResize = !0),
            this.motionValue || (this.motionValue = Cd(0)),
            (this.currentAnimation = r4(this.motionValue, [0, 1e3], {
              ...o,
              velocity: 0,
              isSync: !0,
              onUpdate: (p) => {
                this.mixTargetDelta(p), o.onUpdate && o.onUpdate(p)
              },
              onStop: () => {},
              onComplete: () => {
                o.onComplete && o.onComplete(), this.completeAnimation()
              },
            })),
            this.resumingFrom &&
              (this.resumingFrom.currentAnimation = this.currentAnimation),
            (this.pendingAnimation = void 0)
        }))
    }
    completeAnimation() {
      this.resumingFrom &&
        ((this.resumingFrom.currentAnimation = void 0),
        (this.resumingFrom.preserveOpacity = void 0))
      const o = this.getStack()
      o && o.exitAnimationComplete(),
        (this.resumingFrom = this.currentAnimation = this.animationValues = void 0),
        this.notifyListeners("animationComplete")
    }
    finishAnimation() {
      this.currentAnimation &&
        (this.mixTargetDelta && this.mixTargetDelta(c4), this.currentAnimation.stop()),
        this.completeAnimation()
    }
    applyTransformsToTarget() {
      const o = this.getLead()
      let { targetWithTransforms: l, target: u, layout: d, latestValues: p } = o
      if (!(!l || !u || !d)) {
        if (
          this !== o &&
          this.layout &&
          d &&
          sC(this.options.animationType, this.layout.layoutBox, d.layoutBox)
        ) {
          u = this.target || Ai()
          const m = Pr(this.layout.layoutBox.x)
          ;(u.x.min = o.target.x.min), (u.x.max = u.x.min + m)
          const v = Pr(this.layout.layoutBox.y)
          ;(u.y.min = o.target.y.min), (u.y.max = u.y.min + v)
        }
        lo(l, u),
          _d(l, p),
          wp(this.projectionDeltaWithTransform, this.layoutCorrected, l, p)
      }
    }
    registerSharedNode(o, l) {
      this.sharedNodes.has(o) || this.sharedNodes.set(o, new l4()),
        this.sharedNodes.get(o).add(l)
      const d = l.options.initialPromotionConfig
      l.promote({
        transition: d ? d.transition : void 0,
        preserveFollowOpacity:
          d && d.shouldPreserveFollowOpacity
            ? d.shouldPreserveFollowOpacity(l)
            : void 0,
      })
    }
    isLead() {
      const o = this.getStack()
      return o ? o.lead === this : !0
    }
    getLead() {
      var l
      const { layoutId: o } = this.options
      return o ? ((l = this.getStack()) == null ? void 0 : l.lead) || this : this
    }
    getPrevLead() {
      var l
      const { layoutId: o } = this.options
      return o ? ((l = this.getStack()) == null ? void 0 : l.prevLead) : void 0
    }
    getStack() {
      const { layoutId: o } = this.options
      if (o) return this.root.sharedNodes.get(o)
    }
    promote({ needsReset: o, transition: l, preserveFollowOpacity: u } = {}) {
      const d = this.getStack()
      d && d.promote(this, u),
        o && ((this.projectionDelta = void 0), (this.needsReset = !0)),
        l && this.setOptions({ transition: l })
    }
    relegate() {
      const o = this.getStack()
      return o ? o.relegate(this) : !1
    }
    resetSkewAndRotation() {
      const { visualElement: o } = this.options
      if (!o) return
      let l = !1
      const { latestValues: u } = o
      if (
        ((u.z ||
          u.rotate ||
          u.rotateX ||
          u.rotateY ||
          u.rotateZ ||
          u.skewX ||
          u.skewY) &&
          (l = !0),
        !l)
      )
        return
      const d = {}
      u.z && Sx("z", o, d, this.animationValues)
      for (let p = 0; p < wx.length; p++)
        Sx(`rotate${wx[p]}`, o, d, this.animationValues),
          Sx(`skew${wx[p]}`, o, d, this.animationValues)
      o.render()
      for (const p in d)
        o.setStaticValue(p, d[p]),
          this.animationValues && (this.animationValues[p] = d[p])
      o.scheduleRender()
    }
    applyProjectionStyles(o, l) {
      if (!this.instance || this.isSVG) return
      if (!this.isVisible) {
        o.visibility = "hidden"
        return
      }
      const u = this.getTransformTemplate()
      if (this.needsReset) {
        ;(this.needsReset = !1),
          (o.visibility = ""),
          (o.opacity = ""),
          (o.pointerEvents = b0(l == null ? void 0 : l.pointerEvents) || ""),
          (o.transform = u ? u(this.latestValues, "") : "none")
        return
      }
      const d = this.getLead()
      if (!this.projectionDelta || !this.layout || !d.target) {
        this.options.layoutId &&
          ((o.opacity =
            this.latestValues.opacity !== void 0 ? this.latestValues.opacity : 1),
          (o.pointerEvents = b0(l == null ? void 0 : l.pointerEvents) || "")),
          this.hasProjected &&
            !uu(this.latestValues) &&
            ((o.transform = u ? u({}, "") : "none"), (this.hasProjected = !1))
        return
      }
      o.visibility = ""
      const p = d.animationValues || d.latestValues
      this.applyTransformsToTarget()
      let m = Qk(this.projectionDeltaWithTransform, this.treeScale, p)
      u && (m = u(p, m)), (o.transform = m)
      const { x: v, y } = this.projectionDelta
      ;(o.transformOrigin = `${v.origin * 100}% ${y.origin * 100}% 0`),
        d.animationValues
          ? (o.opacity =
              d === this
                ? p.opacity ?? this.latestValues.opacity ?? 1
                : this.preserveOpacity
                ? this.latestValues.opacity
                : p.opacityExit)
          : (o.opacity =
              d === this
                ? p.opacity !== void 0
                  ? p.opacity
                  : ""
                : p.opacityExit !== void 0
                ? p.opacityExit
                : 0)
      for (const x in d1) {
        if (p[x] === void 0) continue
        const { correct: E, applyTo: M, isCSSVariable: w } = d1[x],
          A = m === "none" ? p[x] : E(p[x], d)
        if (M) {
          const C = M.length
          for (let R = 0; R < C; R++) o[M[R]] = A
        } else w ? (this.options.visualElement.renderState.vars[x] = A) : (o[x] = A)
      }
      this.options.layoutId &&
        (o.pointerEvents =
          d === this ? b0(l == null ? void 0 : l.pointerEvents) || "" : "none")
    }
    clearSnapshot() {
      this.resumeFrom = this.snapshot = void 0
    }
    resetTree() {
      this.root.nodes.forEach((o) => {
        var l
        return (l = o.currentAnimation) == null ? void 0 : l.stop()
      }),
        this.root.nodes.forEach(SE),
        this.root.sharedNodes.clear()
    }
  }
}
function f4(n) {
  n.updateLayout()
}
function d4(n) {
  var t
  const e = ((t = n.resumeFrom) == null ? void 0 : t.snapshot) || n.snapshot
  if (n.isLead() && n.layout && e && n.hasListeners("didUpdate")) {
    const { layoutBox: i, measuredBox: r } = n.layout,
      { animationType: s } = n.options,
      o = e.source !== n.layout.source
    s === "size"
      ? Ds((m) => {
          const v = o ? e.measuredBox[m] : e.layoutBox[m],
            y = Pr(v)
          ;(v.min = i[m].min), (v.max = v.min + y)
        })
      : sC(s, e.layoutBox, i) &&
        Ds((m) => {
          const v = o ? e.measuredBox[m] : e.layoutBox[m],
            y = Pr(i[m])
          ;(v.max = v.min + y),
            n.relativeTarget &&
              !n.currentAnimation &&
              ((n.isProjectionDirty = !0),
              (n.relativeTarget[m].max = n.relativeTarget[m].min + y))
        })
    const l = yd()
    wp(l, i, e.layoutBox)
    const u = yd()
    o ? wp(u, n.applyTransform(r, !0), e.measuredBox) : wp(u, i, e.layoutBox)
    const d = !Q2(l)
    let p = !1
    if (!n.resumeFrom) {
      const m = n.getClosestProjectingParent()
      if (m && !m.resumeFrom) {
        const { snapshot: v, layout: y } = m
        if (v && y) {
          const x = Ai()
          B0(x, e.layoutBox, v.layoutBox)
          const E = Ai()
          B0(E, i, y.layoutBox),
            eC(x, E) || (p = !0),
            m.options.layoutRoot &&
              ((n.relativeTarget = E),
              (n.relativeTargetOrigin = x),
              (n.relativeParent = m))
        }
      }
    }
    n.notifyListeners("didUpdate", {
      layout: i,
      snapshot: e,
      delta: u,
      layoutDelta: l,
      hasLayoutChanged: d,
      hasRelativeLayoutChanged: p,
    })
  } else if (n.isLead()) {
    const { onExitComplete: i } = n.options
    i && i()
  }
  n.options.transition = void 0
}
function h4(n) {
  n.parent &&
    (n.isProjecting() || (n.isProjectionDirty = n.parent.isProjectionDirty),
    n.isSharedProjectionDirty ||
      (n.isSharedProjectionDirty = !!(
        n.isProjectionDirty ||
        n.parent.isProjectionDirty ||
        n.parent.isSharedProjectionDirty
      )),
    n.isTransformDirty || (n.isTransformDirty = n.parent.isTransformDirty))
}
function p4(n) {
  n.isProjectionDirty = n.isSharedProjectionDirty = n.isTransformDirty = !1
}
function m4(n) {
  n.clearSnapshot()
}
function SE(n) {
  n.clearMeasurements()
}
function ME(n) {
  n.isLayoutDirty = !1
}
function g4(n) {
  const { visualElement: e } = n.options
  e && e.getProps().onBeforeLayoutMeasure && e.notify("BeforeLayoutMeasure"),
    n.resetTransform()
}
function EE(n) {
  n.finishAnimation(),
    (n.targetDelta = n.relativeTarget = n.target = void 0),
    (n.isProjectionDirty = !0)
}
function v4(n) {
  n.resolveTargetDelta()
}
function y4(n) {
  n.calcProjection()
}
function x4(n) {
  n.resetSkewAndRotation()
}
function _4(n) {
  n.removeLeadSnapshot()
}
function TE(n, e, t) {
  ;(n.translate = Kn(e.translate, 0, t)),
    (n.scale = Kn(e.scale, 1, t)),
    (n.origin = e.origin),
    (n.originPoint = e.originPoint)
}
function bE(n, e, t, i) {
  ;(n.min = Kn(e.min, t.min, i)), (n.max = Kn(e.max, t.max, i))
}
function w4(n, e, t, i) {
  bE(n.x, e.x, t.x, i), bE(n.y, e.y, t.y, i)
}
function S4(n) {
  return n.animationValues && n.animationValues.opacityExit !== void 0
}
const M4 = { duration: 0.45, ease: [0.4, 0, 0.1, 1] },
  AE = (n) =>
    typeof navigator < "u" &&
    navigator.userAgent &&
    navigator.userAgent.toLowerCase().includes(n),
  CE = AE("applewebkit/") && !AE("chrome/") ? Math.round : Fs
function RE(n) {
  ;(n.min = CE(n.min)), (n.max = CE(n.max))
}
function E4(n) {
  RE(n.x), RE(n.y)
}
function sC(n, e, t) {
  return n === "position" || (n === "preserve-aspect" && !Yk(vE(e), vE(t), 0.2))
}
function T4(n) {
  var e
  return n !== n.root && ((e = n.scroll) == null ? void 0 : e.wasRoot)
}
const b4 = rC({
    attachResizeListener: (n, e) => zp(n, "resize", e),
    measureScroll: () => {
      var n, e
      return {
        x:
          document.documentElement.scrollLeft ||
          ((n = document.body) == null ? void 0 : n.scrollLeft) ||
          0,
        y:
          document.documentElement.scrollTop ||
          ((e = document.body) == null ? void 0 : e.scrollTop) ||
          0,
      }
    },
    checkIsScrollRoot: () => !0,
  }),
  Mx = { current: void 0 },
  oC = rC({
    measureScroll: (n) => ({ x: n.scrollLeft, y: n.scrollTop }),
    defaultParent: () => {
      if (!Mx.current) {
        const n = new b4({})
        n.mount(window), n.setOptions({ layoutScroll: !0 }), (Mx.current = n)
      }
      return Mx.current
    },
    resetTransform: (n, e) => {
      n.style.transform = e !== void 0 ? e : "none"
    },
    checkIsScrollRoot: (n) => window.getComputedStyle(n).position === "fixed",
  }),
  vw = Y.createContext({
    transformPagePoint: (n) => n,
    isStatic: !1,
    reducedMotion: "never",
  })
function PE(n, e) {
  if (typeof n == "function") return n(e)
  n != null && (n.current = e)
}
function A4(...n) {
  return (e) => {
    let t = !1
    const i = n.map((r) => {
      const s = PE(r, e)
      return !t && typeof s == "function" && (t = !0), s
    })
    if (t)
      return () => {
        for (let r = 0; r < i.length; r++) {
          const s = i[r]
          typeof s == "function" ? s() : PE(n[r], null)
        }
      }
  }
}
function C4(...n) {
  return Y.useCallback(A4(...n), n)
}
class R4 extends Y.Component {
  getSnapshotBeforeUpdate(e) {
    const t = this.props.childRef.current
    if (t && e.isPresent && !this.props.isPresent) {
      const i = t.offsetParent,
        r = (l1(i) && i.offsetWidth) || 0,
        s = (l1(i) && i.offsetHeight) || 0,
        o = this.props.sizeRef.current
      ;(o.height = t.offsetHeight || 0),
        (o.width = t.offsetWidth || 0),
        (o.top = t.offsetTop),
        (o.left = t.offsetLeft),
        (o.right = r - o.width - o.left),
        (o.bottom = s - o.height - o.top)
    }
    return null
  }
  componentDidUpdate() {}
  render() {
    return this.props.children
  }
}
function P4({ children: n, isPresent: e, anchorX: t, anchorY: i, root: r }) {
  var m
  const s = Y.useId(),
    o = Y.useRef(null),
    l = Y.useRef({ width: 0, height: 0, top: 0, left: 0, right: 0, bottom: 0 }),
    { nonce: u } = Y.useContext(vw),
    d = ((m = n.props) == null ? void 0 : m.ref) ?? (n == null ? void 0 : n.ref),
    p = C4(o, d)
  return (
    Y.useInsertionEffect(() => {
      const { width: v, height: y, top: x, left: E, right: M, bottom: w } = l.current
      if (e || !o.current || !v || !y) return
      const A = t === "left" ? `left: ${E}` : `right: ${M}`,
        C = i === "bottom" ? `bottom: ${w}` : `top: ${x}`
      o.current.dataset.motionPopId = s
      const R = document.createElement("style")
      u && (R.nonce = u)
      const z = r ?? document.head
      return (
        z.appendChild(R),
        R.sheet &&
          R.sheet.insertRule(`
          [data-motion-pop-id="${s}"] {
            position: absolute !important;
            width: ${v}px !important;
            height: ${y}px !important;
            ${A}px !important;
            ${C}px !important;
          }
        `),
        () => {
          z.contains(R) && z.removeChild(R)
        }
      )
    }, [e]),
    D.jsx(R4, {
      isPresent: e,
      childRef: o,
      sizeRef: l,
      children: Y.cloneElement(n, { ref: p }),
    })
  )
}
const I4 = ({
  children: n,
  initial: e,
  isPresent: t,
  onExitComplete: i,
  custom: r,
  presenceAffectsLayout: s,
  mode: o,
  anchorX: l,
  anchorY: u,
  root: d,
}) => {
  const p = G1(L4),
    m = Y.useId()
  let v = !0,
    y = Y.useMemo(
      () => (
        (v = !1),
        {
          id: m,
          initial: e,
          isPresent: t,
          custom: r,
          onExitComplete: (x) => {
            p.set(x, !0)
            for (const E of p.values()) if (!E) return
            i && i()
          },
          register: (x) => (p.set(x, !1), () => p.delete(x)),
        }
      ),
      [t, p, i],
    )
  return (
    s && v && (y = { ...y }),
    Y.useMemo(() => {
      p.forEach((x, E) => p.set(E, !1))
    }, [t]),
    Y.useEffect(() => {
      !t && !p.size && i && i()
    }, [t]),
    o === "popLayout" &&
      (n = D.jsx(P4, { isPresent: t, anchorX: l, anchorY: u, root: d, children: n })),
    D.jsx(Bv.Provider, { value: y, children: n })
  )
}
function L4() {
  return new Map()
}
function aC(n = !0) {
  const e = Y.useContext(Bv)
  if (e === null) return [!0, null]
  const { isPresent: t, onExitComplete: i, register: r } = e,
    s = Y.useId()
  Y.useEffect(() => {
    if (n) return r(s)
  }, [n])
  const o = Y.useCallback(() => n && i && i(s), [s, i, n])
  return !t && i ? [!1, o] : [!0]
}
const Cg = (n) => n.key || ""
function IE(n) {
  const e = []
  return (
    Y.Children.forEach(n, (t) => {
      Y.isValidElement(t) && e.push(t)
    }),
    e
  )
}
const lC = ({
    children: n,
    custom: e,
    initial: t = !0,
    onExitComplete: i,
    presenceAffectsLayout: r = !0,
    mode: s = "sync",
    propagate: o = !1,
    anchorX: l = "left",
    anchorY: u = "top",
    root: d,
  }) => {
    const [p, m] = aC(o),
      v = Y.useMemo(() => IE(n), [n]),
      y = o && !p ? [] : v.map(Cg),
      x = Y.useRef(!0),
      E = Y.useRef(v),
      M = G1(() => new Map()),
      w = Y.useRef(new Set()),
      [A, C] = Y.useState(v),
      [R, z] = Y.useState(v)
    zA(() => {
      ;(x.current = !1), (E.current = v)
      for (let N = 0; N < R.length; N++) {
        const k = Cg(R[N])
        y.includes(k)
          ? (M.delete(k), w.current.delete(k))
          : M.get(k) !== !0 && M.set(k, !1)
      }
    }, [R, y.length, y.join("-")])
    const U = []
    if (v !== A) {
      let N = [...v]
      for (let k = 0; k < R.length; k++) {
        const I = R[k],
          V = Cg(I)
        y.includes(V) || (N.splice(k, 0, I), U.push(I))
      }
      return s === "wait" && U.length && (N = U), z(IE(N)), C(v), null
    }
    const { forceRender: O } = Y.useContext(H1)
    return D.jsx(D.Fragment, {
      children: R.map((N) => {
        const k = Cg(N),
          I = o && !p ? !1 : v === R || y.includes(k),
          V = () => {
            if (w.current.has(k)) return
            if ((w.current.add(k), M.has(k))) M.set(k, !0)
            else return
            let Z = !0
            M.forEach(($) => {
              $ || (Z = !1)
            }),
              Z && (O == null || O(), z(E.current), o && (m == null || m()), i && i())
          }
        return D.jsx(
          I4,
          {
            isPresent: I,
            initial: !x.current || t ? void 0 : !1,
            custom: e,
            presenceAffectsLayout: r,
            mode: s,
            root: d,
            onExitComplete: I ? void 0 : V,
            anchorX: l,
            anchorY: u,
            children: N,
          },
          k,
        )
      }),
    })
  },
  cC = Y.createContext({ strict: !1 }),
  LE = {
    animation: [
      "animate",
      "variants",
      "whileHover",
      "whileTap",
      "exit",
      "whileInView",
      "whileFocus",
      "whileDrag",
    ],
    exit: ["exit"],
    drag: ["drag", "dragControls"],
    focus: ["whileFocus"],
    hover: ["whileHover", "onHoverStart", "onHoverEnd"],
    tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
    pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
    inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
    layout: ["layout", "layoutId"],
  }
let DE = !1
function D4() {
  if (DE) return
  const n = {}
  for (const e in LE) n[e] = { isEnabled: (t) => LE[e].some((i) => !!t[i]) }
  U2(n), (DE = !0)
}
function uC() {
  return D4(), xk()
}
function N4(n) {
  const e = uC()
  for (const t in n) e[t] = { ...e[t], ...n[t] }
  U2(e)
}
const k4 = new Set([
  "animate",
  "exit",
  "variants",
  "initial",
  "style",
  "values",
  "variants",
  "transition",
  "transformTemplate",
  "custom",
  "inherit",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "_dragX",
  "_dragY",
  "onHoverStart",
  "onHoverEnd",
  "onViewportEnter",
  "onViewportLeave",
  "globalTapTarget",
  "ignoreStrict",
  "viewport",
])
function z0(n) {
  return (
    n.startsWith("while") ||
    (n.startsWith("drag") && n !== "draggable") ||
    n.startsWith("layout") ||
    n.startsWith("onTap") ||
    n.startsWith("onPan") ||
    n.startsWith("onLayout") ||
    k4.has(n)
  )
}
let fC = (n) => !z0(n)
function F4(n) {
  typeof n == "function" && (fC = (e) => (e.startsWith("on") ? !z0(e) : n(e)))
}
try {
  F4(require("@emotion/is-prop-valid").default)
} catch {}
function U4(n, e, t) {
  const i = {}
  for (const r in n)
    (r === "values" && typeof n.values == "object") ||
      ((fC(r) ||
        (t === !0 && z0(r)) ||
        (!e && !z0(r)) ||
        (n.draggable && r.startsWith("onDrag"))) &&
        (i[r] = n[r]))
  return i
}
const Hv = Y.createContext({})
function O4(n, e) {
  if (Vv(n)) {
    const { initial: t, animate: i } = n
    return { initial: t === !1 || Bp(t) ? t : void 0, animate: Bp(i) ? i : void 0 }
  }
  return n.inherit !== !1 ? e : {}
}
function B4(n) {
  const { initial: e, animate: t } = O4(n, Y.useContext(Hv))
  return Y.useMemo(() => ({ initial: e, animate: t }), [NE(e), NE(t)])
}
function NE(n) {
  return Array.isArray(n) ? n.join(" ") : n
}
const yw = () => ({ style: {}, transform: {}, transformOrigin: {}, vars: {} })
function dC(n, e, t) {
  for (const i in e) !dr(e[i]) && !W2(i, t) && (n[i] = e[i])
}
function z4({ transformTemplate: n }, e) {
  return Y.useMemo(() => {
    const t = yw()
    return mw(t, e, n), Object.assign({}, t.vars, t.style)
  }, [e])
}
function V4(n, e) {
  const t = n.style || {},
    i = {}
  return dC(i, t, n), Object.assign(i, z4(n, e)), i
}
function H4(n, e) {
  const t = {},
    i = V4(n, e)
  return (
    n.drag &&
      n.dragListener !== !1 &&
      ((t.draggable = !1),
      (i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none"),
      (i.touchAction = n.drag === !0 ? "none" : `pan-${n.drag === "x" ? "y" : "x"}`)),
    n.tabIndex === void 0 &&
      (n.onTap || n.onTapStart || n.whileTap) &&
      (t.tabIndex = 0),
    (t.style = i),
    t
  )
}
const hC = () => ({ ...yw(), attrs: {} })
function G4(n, e, t, i) {
  const r = Y.useMemo(() => {
    const s = hC()
    return (
      j2(s, e, Y2(i), n.transformTemplate, n.style),
      { ...s.attrs, style: { ...s.style } }
    )
  }, [e])
  if (n.style) {
    const s = {}
    dC(s, n.style, n), (r.style = { ...s, ...r.style })
  }
  return r
}
const W4 = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "switch",
  "symbol",
  "svg",
  "text",
  "tspan",
  "use",
  "view",
]
function xw(n) {
  return typeof n != "string" || n.includes("-")
    ? !1
    : !!(W4.indexOf(n) > -1 || /[A-Z]/u.test(n))
}
function j4(n, e, t, { latestValues: i }, r, s = !1, o) {
  const u = (o ?? xw(n) ? G4 : H4)(e, i, r, n),
    d = U4(e, typeof n == "string", s),
    p = n !== Y.Fragment ? { ...d, ...u, ref: t } : {},
    { children: m } = e,
    v = Y.useMemo(() => (dr(m) ? m.get() : m), [m])
  return Y.createElement(n, { ...p, children: v })
}
function X4({ scrapeMotionValuesFromProps: n, createRenderState: e }, t, i, r) {
  return { latestValues: Y4(t, i, r, n), renderState: e() }
}
function Y4(n, e, t, i) {
  const r = {},
    s = i(n, {})
  for (const v in s) r[v] = b0(s[v])
  let { initial: o, animate: l } = n
  const u = Vv(n),
    d = F2(n)
  e &&
    d &&
    !u &&
    n.inherit !== !1 &&
    (o === void 0 && (o = e.initial), l === void 0 && (l = e.animate))
  let p = t ? t.initial === !1 : !1
  p = p || o === !1
  const m = p ? l : o
  if (m && typeof m != "boolean" && !zv(m)) {
    const v = Array.isArray(m) ? m : [m]
    for (let y = 0; y < v.length; y++) {
      const x = lw(n, v[y])
      if (x) {
        const { transitionEnd: E, transition: M, ...w } = x
        for (const A in w) {
          let C = w[A]
          if (Array.isArray(C)) {
            const R = p ? C.length - 1 : 0
            C = C[R]
          }
          C !== null && (r[A] = C)
        }
        for (const A in E) r[A] = E[A]
      }
    }
  }
  return r
}
const pC = (n) => (e, t) => {
    const i = Y.useContext(Hv),
      r = Y.useContext(Bv),
      s = () => X4(n, e, i, r)
    return t ? s() : G1(s)
  },
  q4 = pC({ scrapeMotionValuesFromProps: gw, createRenderState: yw }),
  $4 = pC({ scrapeMotionValuesFromProps: q2, createRenderState: hC }),
  K4 = Symbol.for("motionComponentSymbol")
function Z4(n, e, t) {
  const i = Y.useRef(t)
  Y.useInsertionEffect(() => {
    i.current = t
  })
  const r = Y.useRef(null)
  return Y.useCallback(
    (s) => {
      var l
      s && ((l = n.onMount) == null || l.call(n, s)),
        e && (s ? e.mount(s) : e.unmount())
      const o = i.current
      if (typeof o == "function")
        if (s) {
          const u = o(s)
          typeof u == "function" && (r.current = u)
        } else r.current ? (r.current(), (r.current = null)) : o(s)
      else o && (o.current = s)
    },
    [e],
  )
}
const mC = Y.createContext({})
function fp(n) {
  return n && typeof n == "object" && Object.prototype.hasOwnProperty.call(n, "current")
}
function J4(n, e, t, i, r, s) {
  var C, R
  const { visualElement: o } = Y.useContext(Hv),
    l = Y.useContext(cC),
    u = Y.useContext(Bv),
    d = Y.useContext(vw),
    p = d.reducedMotion,
    m = d.skipAnimations,
    v = Y.useRef(null),
    y = Y.useRef(!1)
  ;(i = i || l.renderer),
    !v.current &&
      i &&
      ((v.current = i(n, {
        visualState: e,
        parent: o,
        props: t,
        presenceContext: u,
        blockInitialAnimation: u ? u.initial === !1 : !1,
        reducedMotionConfig: p,
        skipAnimations: m,
        isSVG: s,
      })),
      y.current && v.current && (v.current.manuallyAnimateOnMount = !0))
  const x = v.current,
    E = Y.useContext(mC)
  x &&
    !x.projection &&
    r &&
    (x.type === "html" || x.type === "svg") &&
    Q4(v.current, t, r, E)
  const M = Y.useRef(!1)
  Y.useInsertionEffect(() => {
    x && M.current && x.update(t, u)
  })
  const w = t[M2],
    A = Y.useRef(
      !!w &&
        !((C = window.MotionHandoffIsComplete) != null && C.call(window, w)) &&
        ((R = window.MotionHasOptimisedAnimation) == null ? void 0 : R.call(window, w)),
    )
  return (
    zA(() => {
      ;(y.current = !0),
        x &&
          ((M.current = !0),
          (window.MotionIsMounted = !0),
          x.updateFeatures(),
          x.scheduleRenderMicrotask(),
          A.current && x.animationState && x.animationState.animateChanges())
    }),
    Y.useEffect(() => {
      x &&
        (!A.current && x.animationState && x.animationState.animateChanges(),
        A.current &&
          (queueMicrotask(() => {
            var z
            ;(z = window.MotionHandoffMarkAsComplete) == null || z.call(window, w)
          }),
          (A.current = !1)),
        (x.enteringChildren = void 0))
    }),
    x
  )
}
function Q4(n, e, t, i) {
  const {
    layoutId: r,
    layout: s,
    drag: o,
    dragConstraints: l,
    layoutScroll: u,
    layoutRoot: d,
    layoutCrossfade: p,
  } = e
  ;(n.projection = new t(
    n.latestValues,
    e["data-framer-portal-id"] ? void 0 : gC(n.parent),
  )),
    n.projection.setOptions({
      layoutId: r,
      layout: s,
      alwaysMeasureLayout: !!o || (l && fp(l)),
      visualElement: n,
      animationType: typeof s == "string" ? s : "both",
      initialPromotionConfig: i,
      crossfade: p,
      layoutScroll: u,
      layoutRoot: d,
    })
}
function gC(n) {
  if (n) return n.options.allowProjection !== !1 ? n.projection : gC(n.parent)
}
function Ex(n, { forwardMotionProps: e = !1, type: t } = {}, i, r) {
  i && N4(i)
  const s = t ? t === "svg" : xw(n),
    o = s ? $4 : q4
  function l(d, p) {
    let m
    const v = { ...Y.useContext(vw), ...d, layoutId: eF(d) },
      { isStatic: y } = v,
      x = B4(d),
      E = o(d, y)
    if (!y && BA) {
      tF()
      const M = nF(v)
      ;(m = M.MeasureLayout), (x.visualElement = J4(n, E, v, r, M.ProjectionNode, s))
    }
    return D.jsxs(Hv.Provider, {
      value: x,
      children: [
        m && x.visualElement
          ? D.jsx(m, { visualElement: x.visualElement, ...v })
          : null,
        j4(n, d, Z4(E, x.visualElement, p), E, y, e, s),
      ],
    })
  }
  l.displayName = `motion.${
    typeof n == "string" ? n : `create(${n.displayName ?? n.name ?? ""})`
  }`
  const u = Y.forwardRef(l)
  return (u[K4] = n), u
}
function eF({ layoutId: n }) {
  const e = Y.useContext(H1).id
  return e && n !== void 0 ? e + "-" + n : n
}
function tF(n, e) {
  Y.useContext(cC).strict
}
function nF(n) {
  const e = uC(),
    { drag: t, layout: i } = e
  if (!t && !i) return {}
  const r = { ...t, ...i }
  return {
    MeasureLayout:
      (t != null && t.isEnabled(n)) || (i != null && i.isEnabled(n))
        ? r.MeasureLayout
        : void 0,
    ProjectionNode: r.ProjectionNode,
  }
}
function iF(n, e) {
  if (typeof Proxy > "u") return Ex
  const t = new Map(),
    i = (s, o) => Ex(s, o, n, e),
    r = (s, o) => i(s, o)
  return new Proxy(r, {
    get: (s, o) =>
      o === "create" ? i : (t.has(o) || t.set(o, Ex(o, void 0, n, e)), t.get(o)),
  })
}
const rF = (n, e) =>
  e.isSVG ?? xw(n) ? new Fk(e) : new Pk(e, { allowProjection: n !== Y.Fragment })
class sF extends oc {
  constructor(e) {
    super(e), e.animationState || (e.animationState = Vk(e))
  }
  updateAnimationControlsSubscription() {
    const { animate: e } = this.node.getProps()
    zv(e) && (this.unmountControls = e.subscribe(this.node))
  }
  mount() {
    this.updateAnimationControlsSubscription()
  }
  update() {
    const { animate: e } = this.node.getProps(),
      { animate: t } = this.node.prevProps || {}
    e !== t && this.updateAnimationControlsSubscription()
  }
  unmount() {
    var e
    this.node.animationState.reset(), (e = this.unmountControls) == null || e.call(this)
  }
}
let oF = 0
class aF extends oc {
  constructor() {
    super(...arguments), (this.id = oF++)
  }
  update() {
    if (!this.node.presenceContext) return
    const { isPresent: e, onExitComplete: t } = this.node.presenceContext,
      { isPresent: i } = this.node.prevPresenceContext || {}
    if (!this.node.animationState || e === i) return
    const r = this.node.animationState.setActive("exit", !e)
    t &&
      !e &&
      r.then(() => {
        t(this.id)
      })
  }
  mount() {
    const { register: e, onExitComplete: t } = this.node.presenceContext || {}
    t && t(this.id), e && (this.unmount = e(this.id))
  }
  unmount() {}
}
const lF = { animation: { Feature: sF }, exit: { Feature: aF } }
function dm(n) {
  return { point: { x: n.pageX, y: n.pageY } }
}
const cF = (n) => (e) => dw(e) && n(e, dm(e))
function Sp(n, e, t, i) {
  return zp(n, e, cF(t), i)
}
const vC = ({ current: n }) => (n ? n.ownerDocument.defaultView : null),
  kE = (n, e) => Math.abs(n - e)
function uF(n, e) {
  const t = kE(n.x, e.x),
    i = kE(n.y, e.y)
  return Math.sqrt(t ** 2 + i ** 2)
}
const FE = new Set(["auto", "scroll"])
class yC {
  constructor(
    e,
    t,
    {
      transformPagePoint: i,
      contextWindow: r = window,
      dragSnapToOrigin: s = !1,
      distanceThreshold: o = 3,
      element: l,
    } = {},
  ) {
    if (
      ((this.startEvent = null),
      (this.lastMoveEvent = null),
      (this.lastMoveEventInfo = null),
      (this.handlers = {}),
      (this.contextWindow = window),
      (this.scrollPositions = new Map()),
      (this.removeScrollListeners = null),
      (this.onElementScroll = (y) => {
        this.handleScroll(y.target)
      }),
      (this.onWindowScroll = () => {
        this.handleScroll(window)
      }),
      (this.updatePoint = () => {
        if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return
        const y = bx(this.lastMoveEventInfo, this.history),
          x = this.startEvent !== null,
          E = uF(y.offset, { x: 0, y: 0 }) >= this.distanceThreshold
        if (!x && !E) return
        const { point: M } = y,
          { timestamp: w } = Ji
        this.history.push({ ...M, timestamp: w })
        const { onStart: A, onMove: C } = this.handlers
        x || (A && A(this.lastMoveEvent, y), (this.startEvent = this.lastMoveEvent)),
          C && C(this.lastMoveEvent, y)
      }),
      (this.handlePointerMove = (y, x) => {
        ;(this.lastMoveEvent = y),
          (this.lastMoveEventInfo = Tx(x, this.transformPagePoint)),
          Fn.update(this.updatePoint, !0)
      }),
      (this.handlePointerUp = (y, x) => {
        this.end()
        const { onEnd: E, onSessionEnd: M, resumeAnimation: w } = this.handlers
        if (
          ((this.dragSnapToOrigin || !this.startEvent) && w && w(),
          !(this.lastMoveEvent && this.lastMoveEventInfo))
        )
          return
        const A = bx(
          y.type === "pointercancel"
            ? this.lastMoveEventInfo
            : Tx(x, this.transformPagePoint),
          this.history,
        )
        this.startEvent && E && E(y, A), M && M(y, A)
      }),
      !dw(e))
    )
      return
    ;(this.dragSnapToOrigin = s),
      (this.handlers = t),
      (this.transformPagePoint = i),
      (this.distanceThreshold = o),
      (this.contextWindow = r || window)
    const u = dm(e),
      d = Tx(u, this.transformPagePoint),
      { point: p } = d,
      { timestamp: m } = Ji
    this.history = [{ ...p, timestamp: m }]
    const { onSessionStart: v } = t
    v && v(e, bx(d, this.history)),
      (this.removeListeners = cm(
        Sp(this.contextWindow, "pointermove", this.handlePointerMove),
        Sp(this.contextWindow, "pointerup", this.handlePointerUp),
        Sp(this.contextWindow, "pointercancel", this.handlePointerUp),
      )),
      l && this.startScrollTracking(l)
  }
  startScrollTracking(e) {
    let t = e.parentElement
    for (; t; ) {
      const i = getComputedStyle(t)
      ;(FE.has(i.overflowX) || FE.has(i.overflowY)) &&
        this.scrollPositions.set(t, { x: t.scrollLeft, y: t.scrollTop }),
        (t = t.parentElement)
    }
    this.scrollPositions.set(window, { x: window.scrollX, y: window.scrollY }),
      window.addEventListener("scroll", this.onElementScroll, {
        capture: !0,
        passive: !0,
      }),
      window.addEventListener("scroll", this.onWindowScroll, { passive: !0 }),
      (this.removeScrollListeners = () => {
        window.removeEventListener("scroll", this.onElementScroll, { capture: !0 }),
          window.removeEventListener("scroll", this.onWindowScroll)
      })
  }
  handleScroll(e) {
    const t = this.scrollPositions.get(e)
    if (!t) return
    const i = e === window,
      r = i
        ? { x: window.scrollX, y: window.scrollY }
        : { x: e.scrollLeft, y: e.scrollTop },
      s = { x: r.x - t.x, y: r.y - t.y }
    ;(s.x === 0 && s.y === 0) ||
      (i
        ? this.lastMoveEventInfo &&
          ((this.lastMoveEventInfo.point.x += s.x),
          (this.lastMoveEventInfo.point.y += s.y))
        : this.history.length > 0 &&
          ((this.history[0].x -= s.x), (this.history[0].y -= s.y)),
      this.scrollPositions.set(e, r),
      Fn.update(this.updatePoint, !0))
  }
  updateHandlers(e) {
    this.handlers = e
  }
  end() {
    this.removeListeners && this.removeListeners(),
      this.removeScrollListeners && this.removeScrollListeners(),
      this.scrollPositions.clear(),
      nc(this.updatePoint)
  }
}
function Tx(n, e) {
  return e ? { point: e(n.point) } : n
}
function UE(n, e) {
  return { x: n.x - e.x, y: n.y - e.y }
}
function bx({ point: n }, e) {
  return { point: n, delta: UE(n, xC(e)), offset: UE(n, fF(e)), velocity: dF(e, 0.1) }
}
function fF(n) {
  return n[0]
}
function xC(n) {
  return n[n.length - 1]
}
function dF(n, e) {
  if (n.length < 2) return { x: 0, y: 0 }
  let t = n.length - 1,
    i = null
  const r = xC(n)
  for (; t >= 0 && ((i = n[t]), !(r.timestamp - i.timestamp > Wa(e))); ) t--
  if (!i) return { x: 0, y: 0 }
  const s = ks(r.timestamp - i.timestamp)
  if (s === 0) return { x: 0, y: 0 }
  const o = { x: (r.x - i.x) / s, y: (r.y - i.y) / s }
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o
}
function hF(n, { min: e, max: t }, i) {
  return (
    e !== void 0 && n < e
      ? (n = i ? Kn(e, n, i.min) : Math.max(n, e))
      : t !== void 0 && n > t && (n = i ? Kn(t, n, i.max) : Math.min(n, t)),
    n
  )
}
function OE(n, e, t) {
  return {
    min: e !== void 0 ? n.min + e : void 0,
    max: t !== void 0 ? n.max + t - (n.max - n.min) : void 0,
  }
}
function pF(n, { top: e, left: t, bottom: i, right: r }) {
  return { x: OE(n.x, t, r), y: OE(n.y, e, i) }
}
function BE(n, e) {
  let t = e.min - n.min,
    i = e.max - n.max
  return e.max - e.min < n.max - n.min && ([t, i] = [i, t]), { min: t, max: i }
}
function mF(n, e) {
  return { x: BE(n.x, e.x), y: BE(n.y, e.y) }
}
function gF(n, e) {
  let t = 0.5
  const i = Pr(n),
    r = Pr(e)
  return (
    r > i
      ? (t = Fp(e.min, e.max - i, n.min))
      : i > r && (t = Fp(n.min, n.max - r, e.min)),
    $o(0, 1, t)
  )
}
function vF(n, e) {
  const t = {}
  return (
    e.min !== void 0 && (t.min = e.min - n.min),
    e.max !== void 0 && (t.max = e.max - n.min),
    t
  )
}
const h1 = 0.35
function yF(n = h1) {
  return (
    n === !1 ? (n = 0) : n === !0 && (n = h1),
    { x: zE(n, "left", "right"), y: zE(n, "top", "bottom") }
  )
}
function zE(n, e, t) {
  return { min: VE(n, e), max: VE(n, t) }
}
function VE(n, e) {
  return typeof n == "number" ? n : n[e] || 0
}
const xF = new WeakMap()
class _F {
  constructor(e) {
    ;(this.openDragLock = null),
      (this.isDragging = !1),
      (this.currentDirection = null),
      (this.originPoint = { x: 0, y: 0 }),
      (this.constraints = !1),
      (this.hasMutatedConstraints = !1),
      (this.elastic = Ai()),
      (this.latestPointerEvent = null),
      (this.latestPanInfo = null),
      (this.visualElement = e)
  }
  start(e, { snapToCursor: t = !1, distanceThreshold: i } = {}) {
    const { presenceContext: r } = this.visualElement
    if (r && r.isPresent === !1) return
    const s = (m) => {
        t
          ? (this.stopAnimation(), this.snapToCursor(dm(m).point))
          : this.pauseAnimation()
      },
      o = (m, v) => {
        this.stopAnimation()
        const { drag: y, dragPropagation: x, onDragStart: E } = this.getProps()
        if (
          y &&
          !x &&
          (this.openDragLock && this.openDragLock(),
          (this.openDragLock = rk(y)),
          !this.openDragLock)
        )
          return
        ;(this.latestPointerEvent = m),
          (this.latestPanInfo = v),
          (this.isDragging = !0),
          (this.currentDirection = null),
          this.resolveConstraints(),
          this.visualElement.projection &&
            ((this.visualElement.projection.isAnimationBlocked = !0),
            (this.visualElement.projection.target = void 0)),
          Ds((w) => {
            let A = this.getAxisMotionValue(w).get() || 0
            if (jo.test(A)) {
              const { projection: C } = this.visualElement
              if (C && C.layout) {
                const R = C.layout.layoutBox[w]
                R && (A = Pr(R) * (parseFloat(A) / 100))
              }
            }
            this.originPoint[w] = A
          }),
          E && Fn.update(() => E(m, v), !1, !0),
          s1(this.visualElement, "transform")
        const { animationState: M } = this.visualElement
        M && M.setActive("whileDrag", !0)
      },
      l = (m, v) => {
        ;(this.latestPointerEvent = m), (this.latestPanInfo = v)
        const {
          dragPropagation: y,
          dragDirectionLock: x,
          onDirectionLock: E,
          onDrag: M,
        } = this.getProps()
        if (!y && !this.openDragLock) return
        const { offset: w } = v
        if (x && this.currentDirection === null) {
          ;(this.currentDirection = wF(w)),
            this.currentDirection !== null && E && E(this.currentDirection)
          return
        }
        this.updateAxis("x", v.point, w),
          this.updateAxis("y", v.point, w),
          this.visualElement.render(),
          M && Fn.update(() => M(m, v), !1, !0)
      },
      u = (m, v) => {
        ;(this.latestPointerEvent = m),
          (this.latestPanInfo = v),
          this.stop(m, v),
          (this.latestPointerEvent = null),
          (this.latestPanInfo = null)
      },
      d = () =>
        Ds((m) => {
          var v
          return (
            this.getAnimationState(m) === "paused" &&
            ((v = this.getAxisMotionValue(m).animation) == null ? void 0 : v.play())
          )
        }),
      { dragSnapToOrigin: p } = this.getProps()
    this.panSession = new yC(
      e,
      { onSessionStart: s, onStart: o, onMove: l, onSessionEnd: u, resumeAnimation: d },
      {
        transformPagePoint: this.visualElement.getTransformPagePoint(),
        dragSnapToOrigin: p,
        distanceThreshold: i,
        contextWindow: vC(this.visualElement),
        element: this.visualElement.current,
      },
    )
  }
  stop(e, t) {
    const i = e || this.latestPointerEvent,
      r = t || this.latestPanInfo,
      s = this.isDragging
    if ((this.cancel(), !s || !r || !i)) return
    const { velocity: o } = r
    this.startAnimation(o)
    const { onDragEnd: l } = this.getProps()
    l && Fn.postRender(() => l(i, r))
  }
  cancel() {
    this.isDragging = !1
    const { projection: e, animationState: t } = this.visualElement
    e && (e.isAnimationBlocked = !1), this.endPanSession()
    const { dragPropagation: i } = this.getProps()
    !i && this.openDragLock && (this.openDragLock(), (this.openDragLock = null)),
      t && t.setActive("whileDrag", !1)
  }
  endPanSession() {
    this.panSession && this.panSession.end(), (this.panSession = void 0)
  }
  updateAxis(e, t, i) {
    const { drag: r } = this.getProps()
    if (!i || !Rg(e, r, this.currentDirection)) return
    const s = this.getAxisMotionValue(e)
    let o = this.originPoint[e] + i[e]
    this.constraints &&
      this.constraints[e] &&
      (o = hF(o, this.constraints[e], this.elastic[e])),
      s.set(o)
  }
  resolveConstraints() {
    var s
    const { dragConstraints: e, dragElastic: t } = this.getProps(),
      i =
        this.visualElement.projection && !this.visualElement.projection.layout
          ? this.visualElement.projection.measure(!1)
          : (s = this.visualElement.projection) == null
          ? void 0
          : s.layout,
      r = this.constraints
    e && fp(e)
      ? this.constraints || (this.constraints = this.resolveRefConstraints())
      : e && i
      ? (this.constraints = pF(i.layoutBox, e))
      : (this.constraints = !1),
      (this.elastic = yF(t)),
      r !== this.constraints &&
        i &&
        this.constraints &&
        !this.hasMutatedConstraints &&
        Ds((o) => {
          this.constraints !== !1 &&
            this.getAxisMotionValue(o) &&
            (this.constraints[o] = vF(i.layoutBox[o], this.constraints[o]))
        })
  }
  resolveRefConstraints() {
    const { dragConstraints: e, onMeasureDragConstraints: t } = this.getProps()
    if (!e || !fp(e)) return !1
    const i = e.current,
      { projection: r } = this.visualElement
    if (!r || !r.layout) return !1
    const s = Ek(i, r.root, this.visualElement.getTransformPagePoint())
    let o = mF(r.layout.layoutBox, s)
    if (t) {
      const l = t(wk(o))
      ;(this.hasMutatedConstraints = !!l), l && (o = B2(l))
    }
    return o
  }
  startAnimation(e) {
    const {
        drag: t,
        dragMomentum: i,
        dragElastic: r,
        dragTransition: s,
        dragSnapToOrigin: o,
        onDragTransitionEnd: l,
      } = this.getProps(),
      u = this.constraints || {},
      d = Ds((p) => {
        if (!Rg(p, t, this.currentDirection)) return
        let m = (u && u[p]) || {}
        o && (m = { min: 0, max: 0 })
        const v = r ? 200 : 1e6,
          y = r ? 40 : 1e7,
          x = {
            type: "inertia",
            velocity: i ? e[p] : 0,
            bounceStiffness: v,
            bounceDamping: y,
            timeConstant: 750,
            restDelta: 1,
            restSpeed: 10,
            ...s,
            ...m,
          }
        return this.startAxisValueAnimation(p, x)
      })
    return Promise.all(d).then(l)
  }
  startAxisValueAnimation(e, t) {
    const i = this.getAxisMotionValue(e)
    return s1(this.visualElement, e), i.start(aw(e, i, 0, t, this.visualElement, !1))
  }
  stopAnimation() {
    Ds((e) => this.getAxisMotionValue(e).stop())
  }
  pauseAnimation() {
    Ds((e) => {
      var t
      return (t = this.getAxisMotionValue(e).animation) == null ? void 0 : t.pause()
    })
  }
  getAnimationState(e) {
    var t
    return (t = this.getAxisMotionValue(e).animation) == null ? void 0 : t.state
  }
  getAxisMotionValue(e) {
    const t = `_drag${e.toUpperCase()}`,
      i = this.visualElement.getProps(),
      r = i[t]
    return r || this.visualElement.getValue(e, (i.initial ? i.initial[e] : void 0) || 0)
  }
  snapToCursor(e) {
    Ds((t) => {
      const { drag: i } = this.getProps()
      if (!Rg(t, i, this.currentDirection)) return
      const { projection: r } = this.visualElement,
        s = this.getAxisMotionValue(t)
      if (r && r.layout) {
        const { min: o, max: l } = r.layout.layoutBox[t],
          u = s.get() || 0
        s.set(e[t] - Kn(o, l, 0.5) + u)
      }
    })
  }
  scalePositionWithinConstraints() {
    if (!this.visualElement.current) return
    const { drag: e, dragConstraints: t } = this.getProps(),
      { projection: i } = this.visualElement
    if (!fp(t) || !i || !this.constraints) return
    this.stopAnimation()
    const r = { x: 0, y: 0 }
    Ds((o) => {
      const l = this.getAxisMotionValue(o)
      if (l && this.constraints !== !1) {
        const u = l.get()
        r[o] = gF({ min: u, max: u }, this.constraints[o])
      }
    })
    const { transformTemplate: s } = this.visualElement.getProps()
    ;(this.visualElement.current.style.transform = s ? s({}, "") : "none"),
      i.root && i.root.updateScroll(),
      i.updateLayout(),
      this.resolveConstraints(),
      Ds((o) => {
        if (!Rg(o, e, null)) return
        const l = this.getAxisMotionValue(o),
          { min: u, max: d } = this.constraints[o]
        l.set(Kn(u, d, r[o]))
      })
  }
  addListeners() {
    if (!this.visualElement.current) return
    xF.set(this.visualElement, this)
    const e = this.visualElement.current,
      t = Sp(e, "pointerdown", (u) => {
        const { drag: d, dragListener: p = !0 } = this.getProps(),
          m = u.target,
          v = m !== e && ck(m)
        d && p && !v && this.start(u)
      }),
      i = () => {
        const { dragConstraints: u } = this.getProps()
        fp(u) && u.current && (this.constraints = this.resolveRefConstraints())
      },
      { projection: r } = this.visualElement,
      s = r.addEventListener("measure", i)
    r && !r.layout && (r.root && r.root.updateScroll(), r.updateLayout()), Fn.read(i)
    const o = zp(window, "resize", () => this.scalePositionWithinConstraints()),
      l = r.addEventListener("didUpdate", ({ delta: u, hasLayoutChanged: d }) => {
        this.isDragging &&
          d &&
          (Ds((p) => {
            const m = this.getAxisMotionValue(p)
            m &&
              ((this.originPoint[p] += u[p].translate), m.set(m.get() + u[p].translate))
          }),
          this.visualElement.render())
      })
    return () => {
      o(), t(), s(), l && l()
    }
  }
  getProps() {
    const e = this.visualElement.getProps(),
      {
        drag: t = !1,
        dragDirectionLock: i = !1,
        dragPropagation: r = !1,
        dragConstraints: s = !1,
        dragElastic: o = h1,
        dragMomentum: l = !0,
      } = e
    return {
      ...e,
      drag: t,
      dragDirectionLock: i,
      dragPropagation: r,
      dragConstraints: s,
      dragElastic: o,
      dragMomentum: l,
    }
  }
}
function Rg(n, e, t) {
  return (e === !0 || e === n) && (t === null || t === n)
}
function wF(n, e = 10) {
  let t = null
  return Math.abs(n.y) > e ? (t = "y") : Math.abs(n.x) > e && (t = "x"), t
}
class SF extends oc {
  constructor(e) {
    super(e),
      (this.removeGroupControls = Fs),
      (this.removeListeners = Fs),
      (this.controls = new _F(e))
  }
  mount() {
    const { dragControls: e } = this.node.getProps()
    e && (this.removeGroupControls = e.subscribe(this.controls)),
      (this.removeListeners = this.controls.addListeners() || Fs)
  }
  update() {
    const { dragControls: e } = this.node.getProps(),
      { dragControls: t } = this.node.prevProps || {}
    e !== t &&
      (this.removeGroupControls(),
      e && (this.removeGroupControls = e.subscribe(this.controls)))
  }
  unmount() {
    this.removeGroupControls(),
      this.removeListeners(),
      this.controls.isDragging || this.controls.endPanSession()
  }
}
const Ax = (n) => (e, t) => {
  n && Fn.update(() => n(e, t), !1, !0)
}
class MF extends oc {
  constructor() {
    super(...arguments), (this.removePointerDownListener = Fs)
  }
  onPointerDown(e) {
    this.session = new yC(e, this.createPanHandlers(), {
      transformPagePoint: this.node.getTransformPagePoint(),
      contextWindow: vC(this.node),
    })
  }
  createPanHandlers() {
    const {
      onPanSessionStart: e,
      onPanStart: t,
      onPan: i,
      onPanEnd: r,
    } = this.node.getProps()
    return {
      onSessionStart: Ax(e),
      onStart: Ax(t),
      onMove: Ax(i),
      onEnd: (s, o) => {
        delete this.session, r && Fn.postRender(() => r(s, o))
      },
    }
  }
  mount() {
    this.removePointerDownListener = Sp(this.node.current, "pointerdown", (e) =>
      this.onPointerDown(e),
    )
  }
  update() {
    this.session && this.session.updateHandlers(this.createPanHandlers())
  }
  unmount() {
    this.removePointerDownListener(), this.session && this.session.end()
  }
}
let Cx = !1
class EF extends Y.Component {
  componentDidMount() {
    const {
        visualElement: e,
        layoutGroup: t,
        switchLayoutGroup: i,
        layoutId: r,
      } = this.props,
      { projection: s } = e
    s &&
      (t.group && t.group.add(s),
      i && i.register && r && i.register(s),
      Cx && s.root.didUpdate(),
      s.addEventListener("animationComplete", () => {
        this.safeToRemove()
      }),
      s.setOptions({
        ...s.options,
        layoutDependency: this.props.layoutDependency,
        onExitComplete: () => this.safeToRemove(),
      })),
      (A0.hasEverUpdated = !0)
  }
  getSnapshotBeforeUpdate(e) {
    const { layoutDependency: t, visualElement: i, drag: r, isPresent: s } = this.props,
      { projection: o } = i
    return (
      o &&
        ((o.isPresent = s),
        e.layoutDependency !== t && o.setOptions({ ...o.options, layoutDependency: t }),
        (Cx = !0),
        r || e.layoutDependency !== t || t === void 0 || e.isPresent !== s
          ? o.willUpdate()
          : this.safeToRemove(),
        e.isPresent !== s &&
          (s
            ? o.promote()
            : o.relegate() ||
              Fn.postRender(() => {
                const l = o.getStack()
                ;(!l || !l.members.length) && this.safeToRemove()
              }))),
      null
    )
  }
  componentDidUpdate() {
    const { projection: e } = this.props.visualElement
    e &&
      (e.root.didUpdate(),
      fw.postRender(() => {
        !e.currentAnimation && e.isLead() && this.safeToRemove()
      }))
  }
  componentWillUnmount() {
    const { visualElement: e, layoutGroup: t, switchLayoutGroup: i } = this.props,
      { projection: r } = e
    ;(Cx = !0),
      r &&
        (r.scheduleCheckAfterUnmount(),
        t && t.group && t.group.remove(r),
        i && i.deregister && i.deregister(r))
  }
  safeToRemove() {
    const { safeToRemove: e } = this.props
    e && e()
  }
  render() {
    return null
  }
}
function _C(n) {
  const [e, t] = aC(),
    i = Y.useContext(H1)
  return D.jsx(EF, {
    ...n,
    layoutGroup: i,
    switchLayoutGroup: Y.useContext(mC),
    isPresent: e,
    safeToRemove: t,
  })
}
const TF = {
  pan: { Feature: MF },
  drag: { Feature: SF, ProjectionNode: oC, MeasureLayout: _C },
}
function HE(n, e, t) {
  const { props: i } = n
  n.animationState &&
    i.whileHover &&
    n.animationState.setActive("whileHover", t === "Start")
  const r = "onHover" + t,
    s = i[r]
  s && Fn.postRender(() => s(e, dm(e)))
}
class bF extends oc {
  mount() {
    const { current: e } = this.node
    e &&
      (this.unmount = sk(
        e,
        (t, i) => (HE(this.node, i, "Start"), (r) => HE(this.node, r, "End")),
      ))
  }
  unmount() {}
}
class AF extends oc {
  constructor() {
    super(...arguments), (this.isActive = !1)
  }
  onFocus() {
    let e = !1
    try {
      e = this.node.current.matches(":focus-visible")
    } catch {
      e = !0
    }
    !e ||
      !this.node.animationState ||
      (this.node.animationState.setActive("whileFocus", !0), (this.isActive = !0))
  }
  onBlur() {
    !this.isActive ||
      !this.node.animationState ||
      (this.node.animationState.setActive("whileFocus", !1), (this.isActive = !1))
  }
  mount() {
    this.unmount = cm(
      zp(this.node.current, "focus", () => this.onFocus()),
      zp(this.node.current, "blur", () => this.onBlur()),
    )
  }
  unmount() {}
}
function GE(n, e, t) {
  const { props: i } = n
  if (n.current instanceof HTMLButtonElement && n.current.disabled) return
  n.animationState &&
    i.whileTap &&
    n.animationState.setActive("whileTap", t === "Start")
  const r = "onTap" + (t === "End" ? "" : t),
    s = i[r]
  s && Fn.postRender(() => s(e, dm(e)))
}
class CF extends oc {
  mount() {
    const { current: e } = this.node
    e &&
      (this.unmount = fk(
        e,
        (t, i) => (
          GE(this.node, i, "Start"),
          (r, { success: s }) => GE(this.node, r, s ? "End" : "Cancel")
        ),
        { useGlobalTarget: this.node.props.globalTapTarget },
      ))
  }
  unmount() {}
}
const p1 = new WeakMap(),
  Rx = new WeakMap(),
  RF = (n) => {
    const e = p1.get(n.target)
    e && e(n)
  },
  PF = (n) => {
    n.forEach(RF)
  }
function IF({ root: n, ...e }) {
  const t = n || document
  Rx.has(t) || Rx.set(t, {})
  const i = Rx.get(t),
    r = JSON.stringify(e)
  return i[r] || (i[r] = new IntersectionObserver(PF, { root: n, ...e })), i[r]
}
function LF(n, e, t) {
  const i = IF(e)
  return (
    p1.set(n, t),
    i.observe(n),
    () => {
      p1.delete(n), i.unobserve(n)
    }
  )
}
const DF = { some: 0, all: 1 }
class NF extends oc {
  constructor() {
    super(...arguments), (this.hasEnteredView = !1), (this.isInView = !1)
  }
  startObserver() {
    this.unmount()
    const { viewport: e = {} } = this.node.getProps(),
      { root: t, margin: i, amount: r = "some", once: s } = e,
      o = {
        root: t ? t.current : void 0,
        rootMargin: i,
        threshold: typeof r == "number" ? r : DF[r],
      },
      l = (u) => {
        const { isIntersecting: d } = u
        if (
          this.isInView === d ||
          ((this.isInView = d), s && !d && this.hasEnteredView)
        )
          return
        d && (this.hasEnteredView = !0),
          this.node.animationState &&
            this.node.animationState.setActive("whileInView", d)
        const { onViewportEnter: p, onViewportLeave: m } = this.node.getProps(),
          v = d ? p : m
        v && v(u)
      }
    return LF(this.node.current, o, l)
  }
  mount() {
    this.startObserver()
  }
  update() {
    if (typeof IntersectionObserver > "u") return
    const { props: e, prevProps: t } = this.node
    ;["amount", "margin", "root"].some(kF(e, t)) && this.startObserver()
  }
  unmount() {}
}
function kF({ viewport: n = {} }, { viewport: e = {} } = {}) {
  return (t) => n[t] !== e[t]
}
const FF = {
    inView: { Feature: NF },
    tap: { Feature: CF },
    focus: { Feature: AF },
    hover: { Feature: bF },
  },
  UF = { layout: { ProjectionNode: oC, MeasureLayout: _C } },
  OF = { ...lF, ...FF, ...TF, ...UF },
  Rd = iF(OF, rF),
  hm = ({ onClick: n }) =>
    D.jsx("button", {
      onClick: n,
      className:
        "absolute no-bg-button top-[50%] -translate-y-1/2 transition-color duration-300 right-[20px] 800:right-[30px] z-20   rounded-full ",
      children: D.jsx("svg", {
        className: "w-[18px] h-[18px] 800:w-[25px] 800:h-[26px]",
        width: "25",
        height: "26",
        viewBox: "0 0 25 26",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: D.jsx("path", {
          d: "M0.523308 0.539573C0.688771 0.368536 0.885334 0.232836 1.10174 0.140247C1.31814 0.0476578 1.55014 0 1.78443 0C2.01873 0 2.25072 0.0476578 2.46713 0.140247C2.68353 0.232836 2.8801 0.368536 3.04556 0.539573L12.4719 10.2626L21.8983 0.539573C22.0639 0.368812 22.2605 0.233357 22.4769 0.140942C22.6933 0.0485271 22.9252 0.00096159 23.1594 0.00096159C23.3936 0.00096159 23.6256 0.0485271 23.8419 0.140942C24.0583 0.233357 24.2549 0.368812 24.4206 0.539573C24.5862 0.710334 24.7175 0.913056 24.8072 1.13617C24.8968 1.35928 24.9429 1.5984 24.9429 1.8399C24.9429 2.08139 24.8968 2.32052 24.8072 2.54363C24.7175 2.76674 24.5862 2.96946 24.4206 3.14022L14.9906 12.8596L24.4206 22.5789C24.5862 22.7497 24.7175 22.9524 24.8072 23.1755C24.8968 23.3986 24.9429 23.6378 24.9429 23.8793C24.9429 24.1207 24.8968 24.3599 24.8072 24.583C24.7175 24.8061 24.5862 25.0088 24.4206 25.1796C24.2549 25.3503 24.0583 25.4858 23.8419 25.5782C23.6256 25.6706 23.3936 25.7182 23.1594 25.7182C22.9252 25.7182 22.6933 25.6706 22.4769 25.5782C22.2605 25.4858 22.0639 25.3503 21.8983 25.1796L12.4719 15.4565L3.04556 25.1796C2.87995 25.3503 2.68333 25.4858 2.46695 25.5782C2.25057 25.6706 2.01865 25.7182 1.78443 25.7182C1.55022 25.7182 1.3183 25.6706 1.10192 25.5782C0.885533 25.4858 0.688921 25.3503 0.523308 25.1796C0.357695 25.0088 0.226323 24.8061 0.136694 24.583C0.0470643 24.3599 0.000932604 24.1207 0.000932604 23.8793C0.000932604 23.6378 0.0470643 23.3986 0.136694 23.1755C0.226323 22.9524 0.357695 22.7497 0.523308 22.5789L9.95325 12.8596L0.523308 3.14022C0.357427 2.96961 0.225817 2.76694 0.136019 2.54381C0.0462212 2.32068 0 2.08147 0 1.8399C0 1.59832 0.0462212 1.35911 0.136019 1.13598C0.225817 0.912851 0.357427 0.710179 0.523308 0.539573Z",
          fill: "black",
        }),
      }),
    })
function BF({ setIsOpen: n }) {
  const [e, t] = Y.useState(!1),
    [i, r] = Y.useState(0),
    [s, o] = Y.useState(!0)
  return (
    Y.useEffect(() => {
      let l
      return (
        i !== null &&
          (l = setInterval(() => {
            r((u) => (u === null ? 0 : (u + 1) % Xh.length))
          }, 5e3)),
        () => clearInterval(l)
      )
    }, [i]),
    D.jsxs("div", {
      className: "w-full h-full 800:flex 800:flex-col gap-[5px]",
      children: [
        D.jsxs("div", {
          className:
            "p-4 text-center h-[46px] 800:h-[86px] rounded-[40px] relative bg-dark-blue",
          children: [
            D.jsx(hm, {
              onClick: () => {
                n(!1)
              },
            }),
            D.jsx("h2", {
              className:
                "text-[20px] leading-[18px] 800:text-[34px] 800:leading-[52px] font-abc text-black font-black relative 800:top-[1px]",
              children: "how it works",
            }),
          ],
        }),
        D.jsx("div", {
          className:
            "w-full h-[calc(100dvh-58px)] 800:h-[calc(100vh-100px)] overflow-y-auto ",
          children: D.jsx(Ou, {
            show: s,
            enter: "transition duration-400 ease-out",
            enterFrom: "transform scale-95 opacity-0",
            enterTo: "transform scale-100 opacity-100",
            leave: "transition duration-400 ease-out",
            leaveFrom: "transform scale-100 opacity-100",
            leaveTo: "transform scale-95 opacity-0",
            as: Y.Fragment,
            className: " text-center w-full h-full  ",
            children: D.jsx("div", {
              className: "w-full h-full mt-[5px] 800:mt-0",
              children: D.jsxs("div", {
                className:
                  "grid 800:grid-cols-2 h-full gap-[5px] border-2 border-black",
                children: [
                  D.jsx("div", {
                    className:
                      "col-span-1 min-h-[58dvh] h-full relative 800:border-r-2 border-black rounded-[40px] overflow-hidden",
                    children: D.jsx(lC, {
                      children:
                        Xh[i || 0].image &&
                        D.jsx(
                          Rd.div,
                          {
                            initial: { opacity: 0 },
                            animate: { opacity: 1 },
                            exit: { opacity: 0 },
                            className: "w-full absolute top-0 left-0 h-full",
                            children: D.jsx("video", {
                              src: Xh[i || 0].longVideo,
                              autoPlay: !0,
                              muted: !0,
                              playsInline: !0,
                              loop: !0,
                              className: "w-full h-full object-cover",
                            }),
                          },
                          i,
                        ),
                    }),
                  }),
                  D.jsx("div", {
                    className:
                      "col-span-1 flex min-h-[26dvh] 800:min-h-[640px] pb-20 overflow-hidden pt-10 flex-col items-center justify-center h-full rounded-[40px] bg-dark-blue",
                    children: D.jsxs("div", {
                      className:
                        "max-w-[400px] w-full 800:max-w-[500px] mx-auto pt-8 px-4 pr-8 flex justify-start flex-col",
                      children: [
                        D.jsx("div", {
                          className: "flex justify-start 800:hidden ",
                          children: D.jsx("div", {
                            className: "border border-black border-b-0",
                            children: Xh.map((l, u) =>
                              D.jsxs(
                                "button",
                                {
                                  onClick: () => r(u),
                                  className: Xn(
                                    "text-left p-3 border-r-1 font-abc font-black  bg-white text-black",
                                    { "bg-yellow": u === i },
                                  ),
                                  children: ["step ", u + 1],
                                },
                                u,
                              ),
                            ),
                          }),
                        }),
                        Xh.map((l, u) =>
                          D.jsxs(
                            "button",
                            {
                              onClick: () => r(u),
                              className: Xn(
                                " hover:bg-yellow w-full min-h-[100px] 800:min-h-auto border-1 800:border-b-0 transition-color relative duration-300 text-left text-black flex-1 border-t-1 first:border-t-0",
                                {
                                  "bg-white hidden 800:block": u !== i,
                                  "bg-white 800:bg-yellow": u === i,
                                },
                              ),
                              children: [
                                D.jsx("h3", {
                                  className:
                                    "hidden 800:block text-[14px] font-abc border-b p-4 font-black 800:text-[20px]",
                                  children: l.title,
                                }),
                                D.jsx("div", {
                                  className:
                                    " text-[15px] font-gt max-w-[90%] p-4 800:text-[16px]",
                                  children: l.description(),
                                }),
                                D.jsx("div", {
                                  className: Xn(
                                    "absolute w-[80px] h-auto max-h-[80px] -right-[30px] top-0 z-2 inline-flex items-center justify-center",
                                    { "opacity-0": u !== i },
                                  ),
                                  children: l.productVideo
                                    ? D.jsxs(D.Fragment, {
                                        children: [
                                          D.jsx("video", {
                                            autoPlay: !0,
                                            muted: !0,
                                            playsInline: !0,
                                            loop: !0,
                                            className:
                                              "w-full h-full object-cover 800:hidden",
                                            children: D.jsx("source", {
                                              src: l.productVideo.mp4,
                                              type: "video/mp4",
                                            }),
                                          }),
                                          D.jsxs("video", {
                                            autoPlay: !0,
                                            muted: !0,
                                            playsInline: !0,
                                            loop: !0,
                                            className:
                                              "w-full h-full object-cover hidden 800:block",
                                            children: [
                                              D.jsx("source", {
                                                src: l.productVideo.mp4,
                                                type: "video/mp4",
                                              }),
                                              D.jsx("source", {
                                                src: l.productVideo.webm,
                                                type: "video/webm",
                                              }),
                                            ],
                                          }),
                                        ],
                                      })
                                    : D.jsx("img", {
                                        src: l.productImage,
                                        alt: l.title,
                                        className: "w-full how-bounce",
                                      }),
                                }),
                              ],
                            },
                            u,
                          ),
                        ),
                      ],
                    }),
                  }),
                ],
              }),
            }),
          }),
        }),
      ],
    })
  )
}
const Xh = [
  {
    title: "step 1",
    description: () =>
      D.jsxs("p", {
        children: [
          "wash your face with",
          " ",
          D.jsx("span", {
            className: "font-extrabold font-abc underline",
            children: "star wash",
          }),
          ".",
        ],
      }),
    shortVideo:
      "https://cdn.shopify.com/videos/c/o/v/13bbbb26d8304187b6034af05481e984.mov",
    longVideo:
      "https://cdn.shopify.com/videos/c/o/v/1f3f853c9f164562bee33ee81ad02c0d.mov",
    image:
      "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/step-1_de4c6937-f056-470c-803e-acda53476115.png?v=1740603216",
    productImage:
      "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/how-w-1.png?v=1740601961",
    productVideo: {
      webm: "https://cdn.shopify.com/videos/c/o/v/9ee06dd440414687a37e1f3cae6a558f.webm",
      mp4: "https://cdn.shopify.com/videos/c/o/v/d14d5f7564a84f89979af56a3965e847.mp4",
    },
  },
  {
    title: "step 2",
    description: () =>
      D.jsxs("p", {
        children: [
          "apply ",
          D.jsx("span", {
            className: "font-extrabold font-abc underline",
            children: "hydro-stars",
          }),
          " to any",
          D.jsx("span", { className: "block" }),
          "spots in need.",
        ],
      }),
    shortVideo:
      "https://cdn.shopify.com/videos/c/o/v/ca5c9eb2871b4725bb553e2fbe97ded2.mov",
    longVideo:
      "https://cdn.shopify.com/videos/c/o/v/4f5e970739814729a19e8479bf2dcec3.mov",
    productImage:
      "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/12_Big_Blue_HIW.png?v=1741066331",
    image:
      "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/step-2_8fd9740c-6493-415b-aae8-4a4150c379d7.png?v=1740603216",
  },
  {
    title: "step 3",
    description: () =>
      D.jsxs("p", {
        children: [
          "follow with ",
          D.jsx("span", {
            className: "font-extrabold font-abc underline",
            children: "star cream",
          }),
          " and the rest of your routine.",
        ],
      }),
    shortVideo:
      "https://cdn.shopify.com/videos/c/o/v/35e3334e05f24df0b639ede53f6aedb9.mov",
    longVideo:
      "https://cdn.shopify.com/videos/c/o/v/31a03e0c993f44169ee57b9c12ccd5f7.mov",
    productImage:
      "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/how-w-3.png?v=1740601961",
    image:
      "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/step-3_c9c22210-c859-4cbf-936c-21f6a150e92f.png?v=1740603216",
    productVideo: {
      webm: "https://cdn.shopify.com/videos/c/o/v/9a915eb471c84c839ab815ec43ebb6ea.webm",
      mp4: "https://cdn.shopify.com/videos/c/o/v/cbf06117a06f48ce93ea8626e8d3c52c.mp4",
    },
  },
  {
    title: "step 4",
    description: () =>
      D.jsxs("p", {
        children: [
          "swipe on your fav ",
          D.jsx("span", {
            className: "font-extrabold font-abc underline",
            children: "star balm",
          }),
          " ",
          "and feel cute.",
        ],
      }),
    productVideo: {
      webm: "https://cdn.shopify.com/videos/c/o/v/6bd3054d3cf742839317fb454e0a1851.webm",
      mp4: "https://cdn.shopify.com/videos/c/o/v/4435d238d7e2463ab187488ed2773838.mp4",
    },
    shortVideo:
      "https://cdn.shopify.com/videos/c/o/v/07852c31d6fe4435b199f9ef61ff5d3b.mov",
    longVideo:
      "https://cdn.shopify.com/videos/c/o/v/b9631940de5d481095efcb5c34c78cdc.mov",
    productImage:
      "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/how-w-4.png?v=1740601961",
    image:
      "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/step-2_8fd9740c-6493-415b-aae8-4a4150c379d7.png?v=1740603216",
  },
]
function zF(n) {
  return Object.prototype.toString.call(n) === "[object Object]"
}
function WE(n) {
  return zF(n) || Array.isArray(n)
}
function VF() {
  return !!(typeof window < "u" && window.document && window.document.createElement)
}
function _w(n, e) {
  const t = Object.keys(n),
    i = Object.keys(e)
  if (t.length !== i.length) return !1
  const r = JSON.stringify(Object.keys(n.breakpoints || {})),
    s = JSON.stringify(Object.keys(e.breakpoints || {}))
  return r !== s
    ? !1
    : t.every((o) => {
        const l = n[o],
          u = e[o]
        return typeof l == "function"
          ? `${l}` == `${u}`
          : !WE(l) || !WE(u)
          ? l === u
          : _w(l, u)
      })
}
function jE(n) {
  return n
    .concat()
    .sort((e, t) => (e.name > t.name ? 1 : -1))
    .map((e) => e.options)
}
function HF(n, e) {
  if (n.length !== e.length) return !1
  const t = jE(n),
    i = jE(e)
  return t.every((r, s) => {
    const o = i[s]
    return _w(r, o)
  })
}
function ww(n) {
  return typeof n == "number"
}
function m1(n) {
  return typeof n == "string"
}
function Gv(n) {
  return typeof n == "boolean"
}
function XE(n) {
  return Object.prototype.toString.call(n) === "[object Object]"
}
function Zn(n) {
  return Math.abs(n)
}
function Sw(n) {
  return Math.sign(n)
}
function Mp(n, e) {
  return Zn(n - e)
}
function GF(n, e) {
  if (n === 0 || e === 0 || Zn(n) <= Zn(e)) return 0
  const t = Mp(Zn(n), Zn(e))
  return Zn(t / n)
}
function WF(n) {
  return Math.round(n * 100) / 100
}
function Vp(n) {
  return Hp(n).map(Number)
}
function _o(n) {
  return n[pm(n)]
}
function pm(n) {
  return Math.max(0, n.length - 1)
}
function Mw(n, e) {
  return e === pm(n)
}
function YE(n, e = 0) {
  return Array.from(Array(n), (t, i) => e + i)
}
function Hp(n) {
  return Object.keys(n)
}
function wC(n, e) {
  return [n, e].reduce(
    (t, i) => (
      Hp(i).forEach((r) => {
        const s = t[r],
          o = i[r],
          l = XE(s) && XE(o)
        t[r] = l ? wC(s, o) : o
      }),
      t
    ),
    {},
  )
}
function g1(n, e) {
  return typeof e.MouseEvent < "u" && n instanceof e.MouseEvent
}
function jF(n, e) {
  const t = { start: i, center: r, end: s }
  function i() {
    return 0
  }
  function r(u) {
    return s(u) / 2
  }
  function s(u) {
    return e - u
  }
  function o(u, d) {
    return m1(n) ? t[n](u) : n(e, u, d)
  }
  return { measure: o }
}
function Gp() {
  let n = []
  function e(r, s, o, l = { passive: !0 }) {
    let u
    if ("addEventListener" in r)
      r.addEventListener(s, o, l), (u = () => r.removeEventListener(s, o, l))
    else {
      const d = r
      d.addListener(o), (u = () => d.removeListener(o))
    }
    return n.push(u), i
  }
  function t() {
    n = n.filter((r) => r())
  }
  const i = { add: e, clear: t }
  return i
}
function XF(n, e, t, i) {
  const r = Gp(),
    s = 1e3 / 60
  let o = null,
    l = 0,
    u = 0
  function d() {
    r.add(n, "visibilitychange", () => {
      n.hidden && x()
    })
  }
  function p() {
    y(), r.clear()
  }
  function m(M) {
    if (!u) return
    o || ((o = M), t(), t())
    const w = M - o
    for (o = M, l += w; l >= s; ) t(), (l -= s)
    const A = l / s
    i(A), u && (u = e.requestAnimationFrame(m))
  }
  function v() {
    u || (u = e.requestAnimationFrame(m))
  }
  function y() {
    e.cancelAnimationFrame(u), (o = null), (l = 0), (u = 0)
  }
  function x() {
    ;(o = null), (l = 0)
  }
  return { init: d, destroy: p, start: v, stop: y, update: t, render: i }
}
function YF(n, e) {
  const t = e === "rtl",
    i = n === "y",
    r = i ? "y" : "x",
    s = i ? "x" : "y",
    o = !i && t ? -1 : 1,
    l = p(),
    u = m()
  function d(x) {
    const { height: E, width: M } = x
    return i ? E : M
  }
  function p() {
    return i ? "top" : t ? "right" : "left"
  }
  function m() {
    return i ? "bottom" : t ? "left" : "right"
  }
  function v(x) {
    return x * o
  }
  return { scroll: r, cross: s, startEdge: l, endEdge: u, measureSize: d, direction: v }
}
function Pu(n = 0, e = 0) {
  const t = Zn(n - e)
  function i(d) {
    return d < n
  }
  function r(d) {
    return d > e
  }
  function s(d) {
    return i(d) || r(d)
  }
  function o(d) {
    return s(d) ? (i(d) ? n : e) : d
  }
  function l(d) {
    return t ? d - t * Math.ceil((d - e) / t) : d
  }
  return {
    length: t,
    max: e,
    min: n,
    constrain: o,
    reachedAny: s,
    reachedMax: r,
    reachedMin: i,
    removeOffset: l,
  }
}
function SC(n, e, t) {
  const { constrain: i } = Pu(0, n),
    r = n + 1
  let s = o(e)
  function o(v) {
    return t ? Zn((r + v) % r) : i(v)
  }
  function l() {
    return s
  }
  function u(v) {
    return (s = o(v)), m
  }
  function d(v) {
    return p().set(l() + v)
  }
  function p() {
    return SC(n, l(), t)
  }
  const m = { get: l, set: u, add: d, clone: p }
  return m
}
function qF(n, e, t, i, r, s, o, l, u, d, p, m, v, y, x, E, M, w, A) {
  const { cross: C, direction: R } = n,
    z = ["INPUT", "SELECT", "TEXTAREA"],
    U = { passive: !1 },
    O = Gp(),
    N = Gp(),
    k = Pu(50, 225).constrain(y.measure(20)),
    I = { mouse: 300, touch: 400 },
    V = { mouse: 500, touch: 600 },
    Z = x ? 43 : 25
  let $ = !1,
    ee = 0,
    ue = 0,
    re = !1,
    se = !1,
    G = !1,
    ie = !1
  function Q(ae) {
    if (!A) return
    function Ee(Ke) {
      ;(Gv(A) || A(ae, Ke)) && we(Ke)
    }
    const K = e
    O.add(K, "dragstart", (Ke) => Ke.preventDefault(), U)
      .add(K, "touchmove", () => {}, U)
      .add(K, "touchend", () => {})
      .add(K, "touchstart", Ee)
      .add(K, "mousedown", Ee)
      .add(K, "touchcancel", Fe)
      .add(K, "contextmenu", Fe)
      .add(K, "click", ze, !0)
  }
  function W() {
    O.clear(), N.clear()
  }
  function ne() {
    const ae = ie ? t : e
    N.add(ae, "touchmove", me, U)
      .add(ae, "touchend", Fe)
      .add(ae, "mousemove", me, U)
      .add(ae, "mouseup", Fe)
  }
  function ye(ae) {
    const Ee = ae.nodeName || ""
    return z.includes(Ee)
  }
  function oe() {
    return (x ? V : I)[ie ? "mouse" : "touch"]
  }
  function fe(ae, Ee) {
    const K = m.add(Sw(ae) * -1),
      Ke = p.byDistance(ae, !x).distance
    return x || Zn(ae) < k ? Ke : M && Ee ? Ke * 0.5 : p.byIndex(K.get(), 0).distance
  }
  function we(ae) {
    const Ee = g1(ae, i)
    ;(ie = Ee),
      (G = x && Ee && !ae.buttons && $),
      ($ = Mp(r.get(), o.get()) >= 2),
      !(Ee && ae.button !== 0) &&
        (ye(ae.target) ||
          ((re = !0),
          s.pointerDown(ae),
          d.useFriction(0).useDuration(0),
          r.set(o),
          ne(),
          (ee = s.readPoint(ae)),
          (ue = s.readPoint(ae, C)),
          v.emit("pointerDown")))
  }
  function me(ae) {
    if (!g1(ae, i) && ae.touches.length >= 2) return Fe(ae)
    const K = s.readPoint(ae),
      Ke = s.readPoint(ae, C),
      Be = Mp(K, ee),
      Oe = Mp(Ke, ue)
    if (!se && !ie && (!ae.cancelable || ((se = Be > Oe), !se))) return Fe(ae)
    const Pe = s.pointerMove(ae)
    Be > E && (G = !0),
      d.useFriction(0.3).useDuration(0.75),
      l.start(),
      r.add(R(Pe)),
      ae.preventDefault()
  }
  function Fe(ae) {
    const K = p.byDistance(0, !1).index !== m.get(),
      Ke = s.pointerUp(ae) * oe(),
      Be = fe(R(Ke), K),
      Oe = GF(Ke, Be),
      Pe = Z - 10 * Oe,
      He = w + Oe / 50
    ;(se = !1),
      (re = !1),
      N.clear(),
      d.useDuration(Pe).useFriction(He),
      u.distance(Be, !x),
      (ie = !1),
      v.emit("pointerUp")
  }
  function ze(ae) {
    G && (ae.stopPropagation(), ae.preventDefault(), (G = !1))
  }
  function Ge() {
    return re
  }
  return { init: Q, destroy: W, pointerDown: Ge }
}
function $F(n, e) {
  let i, r
  function s(m) {
    return m.timeStamp
  }
  function o(m, v) {
    const x = `client${(v || n.scroll) === "x" ? "X" : "Y"}`
    return (g1(m, e) ? m : m.touches[0])[x]
  }
  function l(m) {
    return (i = m), (r = m), o(m)
  }
  function u(m) {
    const v = o(m) - o(r),
      y = s(m) - s(i) > 170
    return (r = m), y && (i = m), v
  }
  function d(m) {
    if (!i || !r) return 0
    const v = o(r) - o(i),
      y = s(m) - s(i),
      x = s(m) - s(r) > 170,
      E = v / y
    return y && !x && Zn(E) > 0.1 ? E : 0
  }
  return { pointerDown: l, pointerMove: u, pointerUp: d, readPoint: o }
}
function KF() {
  function n(t) {
    const { offsetTop: i, offsetLeft: r, offsetWidth: s, offsetHeight: o } = t
    return { top: i, right: r + s, bottom: i + o, left: r, width: s, height: o }
  }
  return { measure: n }
}
function ZF(n) {
  function e(i) {
    return n * (i / 100)
  }
  return { measure: e }
}
function JF(n, e, t, i, r, s, o) {
  const l = [n].concat(i)
  let u,
    d,
    p = [],
    m = !1
  function v(M) {
    return r.measureSize(o.measure(M))
  }
  function y(M) {
    if (!s) return
    ;(d = v(n)), (p = i.map(v))
    function w(A) {
      for (const C of A) {
        if (m) return
        const R = C.target === n,
          z = i.indexOf(C.target),
          U = R ? d : p[z],
          O = v(R ? n : i[z])
        if (Zn(O - U) >= 0.5) {
          M.reInit(), e.emit("resize")
          break
        }
      }
    }
    ;(u = new ResizeObserver((A) => {
      ;(Gv(s) || s(M, A)) && w(A)
    })),
      t.requestAnimationFrame(() => {
        l.forEach((A) => u.observe(A))
      })
  }
  function x() {
    ;(m = !0), u && u.disconnect()
  }
  return { init: y, destroy: x }
}
function QF(n, e, t, i, r, s) {
  let o = 0,
    l = 0,
    u = r,
    d = s,
    p = n.get(),
    m = 0
  function v() {
    const U = i.get() - n.get(),
      O = !u
    let N = 0
    return (
      O
        ? ((o = 0), t.set(i), n.set(i), (N = U))
        : (t.set(n), (o += U / u), (o *= d), (p += o), n.add(o), (N = p - m)),
      (l = Sw(N)),
      (m = p),
      z
    )
  }
  function y() {
    const U = i.get() - e.get()
    return Zn(U) < 0.001
  }
  function x() {
    return u
  }
  function E() {
    return l
  }
  function M() {
    return o
  }
  function w() {
    return C(r)
  }
  function A() {
    return R(s)
  }
  function C(U) {
    return (u = U), z
  }
  function R(U) {
    return (d = U), z
  }
  const z = {
    direction: E,
    duration: x,
    velocity: M,
    seek: v,
    settled: y,
    useBaseFriction: A,
    useBaseDuration: w,
    useFriction: R,
    useDuration: C,
  }
  return z
}
function eU(n, e, t, i, r) {
  const s = r.measure(10),
    o = r.measure(50),
    l = Pu(0.1, 0.99)
  let u = !1
  function d() {
    return !(u || !n.reachedAny(t.get()) || !n.reachedAny(e.get()))
  }
  function p(y) {
    if (!d()) return
    const x = n.reachedMin(e.get()) ? "min" : "max",
      E = Zn(n[x] - e.get()),
      M = t.get() - e.get(),
      w = l.constrain(E / o)
    t.subtract(M * w),
      !y &&
        Zn(M) < s &&
        (t.set(n.constrain(t.get())), i.useDuration(25).useBaseFriction())
  }
  function m(y) {
    u = !y
  }
  return { shouldConstrain: d, constrain: p, toggleActive: m }
}
function tU(n, e, t, i, r) {
  const s = Pu(-e + n, 0),
    o = m(),
    l = p(),
    u = v()
  function d(x, E) {
    return Mp(x, E) <= 1
  }
  function p() {
    const x = o[0],
      E = _o(o),
      M = o.lastIndexOf(x),
      w = o.indexOf(E) + 1
    return Pu(M, w)
  }
  function m() {
    return t
      .map((x, E) => {
        const { min: M, max: w } = s,
          A = s.constrain(x),
          C = !E,
          R = Mw(t, E)
        return C ? w : R || d(M, A) ? M : d(w, A) ? w : A
      })
      .map((x) => parseFloat(x.toFixed(3)))
  }
  function v() {
    if (e <= n + r) return [s.max]
    if (i === "keepSnaps") return o
    const { min: x, max: E } = l
    return o.slice(x, E)
  }
  return { snapsContained: u, scrollContainLimit: l }
}
function nU(n, e, t) {
  const i = e[0],
    r = t ? i - n : _o(e)
  return { limit: Pu(r, i) }
}
function iU(n, e, t, i) {
  const s = e.min + 0.1,
    o = e.max + 0.1,
    { reachedMin: l, reachedMax: u } = Pu(s, o)
  function d(v) {
    return v === 1 ? u(t.get()) : v === -1 ? l(t.get()) : !1
  }
  function p(v) {
    if (!d(v)) return
    const y = n * (v * -1)
    i.forEach((x) => x.add(y))
  }
  return { loop: p }
}
function rU(n) {
  const { max: e, length: t } = n
  function i(s) {
    const o = s - e
    return t ? o / -t : 0
  }
  return { get: i }
}
function sU(n, e, t, i, r) {
  const { startEdge: s, endEdge: o } = n,
    { groupSlides: l } = r,
    u = m().map(e.measure),
    d = v(),
    p = y()
  function m() {
    return l(i)
      .map((E) => _o(E)[o] - E[0][s])
      .map(Zn)
  }
  function v() {
    return i.map((E) => t[s] - E[s]).map((E) => -Zn(E))
  }
  function y() {
    return l(d)
      .map((E) => E[0])
      .map((E, M) => E + u[M])
  }
  return { snaps: d, snapsAligned: p }
}
function oU(n, e, t, i, r, s) {
  const { groupSlides: o } = r,
    { min: l, max: u } = i,
    d = p()
  function p() {
    const v = o(s),
      y = !n || e === "keepSnaps"
    return t.length === 1
      ? [s]
      : y
      ? v
      : v.slice(l, u).map((x, E, M) => {
          const w = !E,
            A = Mw(M, E)
          if (w) {
            const C = _o(M[0]) + 1
            return YE(C)
          }
          if (A) {
            const C = pm(s) - _o(M)[0] + 1
            return YE(C, _o(M)[0])
          }
          return x
        })
  }
  return { slideRegistry: d }
}
function aU(n, e, t, i, r) {
  const { reachedAny: s, removeOffset: o, constrain: l } = i
  function u(x) {
    return x.concat().sort((E, M) => Zn(E) - Zn(M))[0]
  }
  function d(x) {
    const E = n ? o(x) : l(x),
      M = e
        .map((A, C) => ({ diff: p(A - E, 0), index: C }))
        .sort((A, C) => Zn(A.diff) - Zn(C.diff)),
      { index: w } = M[0]
    return { index: w, distance: E }
  }
  function p(x, E) {
    const M = [x, x + t, x - t]
    if (!n) return x
    if (!E) return u(M)
    const w = M.filter((A) => Sw(A) === E)
    return w.length ? u(w) : _o(M) - t
  }
  function m(x, E) {
    const M = e[x] - r.get(),
      w = p(M, E)
    return { index: x, distance: w }
  }
  function v(x, E) {
    const M = r.get() + x,
      { index: w, distance: A } = d(M),
      C = !n && s(M)
    if (!E || C) return { index: w, distance: x }
    const R = e[w] - A,
      z = x + p(R, 0)
    return { index: w, distance: z }
  }
  return { byDistance: v, byIndex: m, shortcut: p }
}
function lU(n, e, t, i, r, s, o) {
  function l(m) {
    const v = m.distance,
      y = m.index !== e.get()
    s.add(v),
      v && (i.duration() ? n.start() : (n.update(), n.render(1), n.update())),
      y && (t.set(e.get()), e.set(m.index), o.emit("select"))
  }
  function u(m, v) {
    const y = r.byDistance(m, v)
    l(y)
  }
  function d(m, v) {
    const y = e.clone().set(m),
      x = r.byIndex(y.get(), v)
    l(x)
  }
  return { distance: u, index: d }
}
function cU(n, e, t, i, r, s, o, l) {
  const u = { passive: !0, capture: !0 }
  let d = 0
  function p(y) {
    if (!l) return
    function x(E) {
      if (new Date().getTime() - d > 10) return
      o.emit("slideFocusStart"), (n.scrollLeft = 0)
      const A = t.findIndex((C) => C.includes(E))
      ww(A) && (r.useDuration(0), i.index(A, 0), o.emit("slideFocus"))
    }
    s.add(document, "keydown", m, !1),
      e.forEach((E, M) => {
        s.add(
          E,
          "focus",
          (w) => {
            ;(Gv(l) || l(y, w)) && x(M)
          },
          u,
        )
      })
  }
  function m(y) {
    y.code === "Tab" && (d = new Date().getTime())
  }
  return { init: p }
}
function dp(n) {
  let e = n
  function t() {
    return e
  }
  function i(u) {
    e = o(u)
  }
  function r(u) {
    e += o(u)
  }
  function s(u) {
    e -= o(u)
  }
  function o(u) {
    return ww(u) ? u : u.get()
  }
  return { get: t, set: i, add: r, subtract: s }
}
function MC(n, e) {
  const t = n.scroll === "x" ? o : l,
    i = e.style
  let r = null,
    s = !1
  function o(v) {
    return `translate3d(${v}px,0px,0px)`
  }
  function l(v) {
    return `translate3d(0px,${v}px,0px)`
  }
  function u(v) {
    if (s) return
    const y = WF(n.direction(v))
    y !== r && ((i.transform = t(y)), (r = y))
  }
  function d(v) {
    s = !v
  }
  function p() {
    s || ((i.transform = ""), e.getAttribute("style") || e.removeAttribute("style"))
  }
  return { clear: p, to: u, toggleActive: d }
}
function uU(n, e, t, i, r, s, o, l, u) {
  const p = Vp(r),
    m = Vp(r).reverse(),
    v = w().concat(A())
  function y(O, N) {
    return O.reduce((k, I) => k - r[I], N)
  }
  function x(O, N) {
    return O.reduce((k, I) => (y(k, N) > 0 ? k.concat([I]) : k), [])
  }
  function E(O) {
    return s.map((N, k) => ({ start: N - i[k] + 0.5 + O, end: N + e - 0.5 + O }))
  }
  function M(O, N, k) {
    const I = E(N)
    return O.map((V) => {
      const Z = k ? 0 : -t,
        $ = k ? t : 0,
        ee = k ? "end" : "start",
        ue = I[V][ee]
      return {
        index: V,
        loopPoint: ue,
        slideLocation: dp(-1),
        translate: MC(n, u[V]),
        target: () => (l.get() > ue ? Z : $),
      }
    })
  }
  function w() {
    const O = o[0],
      N = x(m, O)
    return M(N, t, !1)
  }
  function A() {
    const O = e - o[0] - 1,
      N = x(p, O)
    return M(N, -t, !0)
  }
  function C() {
    return v.every(({ index: O }) => {
      const N = p.filter((k) => k !== O)
      return y(N, e) <= 0.1
    })
  }
  function R() {
    v.forEach((O) => {
      const { target: N, translate: k, slideLocation: I } = O,
        V = N()
      V !== I.get() && (k.to(V), I.set(V))
    })
  }
  function z() {
    v.forEach((O) => O.translate.clear())
  }
  return { canLoop: C, clear: z, loop: R, loopPoints: v }
}
function fU(n, e, t) {
  let i,
    r = !1
  function s(u) {
    if (!t) return
    function d(p) {
      for (const m of p)
        if (m.type === "childList") {
          u.reInit(), e.emit("slidesChanged")
          break
        }
    }
    ;(i = new MutationObserver((p) => {
      r || ((Gv(t) || t(u, p)) && d(p))
    })),
      i.observe(n, { childList: !0 })
  }
  function o() {
    i && i.disconnect(), (r = !0)
  }
  return { init: s, destroy: o }
}
function dU(n, e, t, i) {
  const r = {}
  let s = null,
    o = null,
    l,
    u = !1
  function d() {
    ;(l = new IntersectionObserver(
      (x) => {
        u ||
          (x.forEach((E) => {
            const M = e.indexOf(E.target)
            r[M] = E
          }),
          (s = null),
          (o = null),
          t.emit("slidesInView"))
      },
      { root: n.parentElement, threshold: i },
    )),
      e.forEach((x) => l.observe(x))
  }
  function p() {
    l && l.disconnect(), (u = !0)
  }
  function m(x) {
    return Hp(r).reduce((E, M) => {
      const w = parseInt(M),
        { isIntersecting: A } = r[w]
      return ((x && A) || (!x && !A)) && E.push(w), E
    }, [])
  }
  function v(x = !0) {
    if (x && s) return s
    if (!x && o) return o
    const E = m(x)
    return x && (s = E), x || (o = E), E
  }
  return { init: d, destroy: p, get: v }
}
function hU(n, e, t, i, r, s) {
  const { measureSize: o, startEdge: l, endEdge: u } = n,
    d = t[0] && r,
    p = x(),
    m = E(),
    v = t.map(o),
    y = M()
  function x() {
    if (!d) return 0
    const A = t[0]
    return Zn(e[l] - A[l])
  }
  function E() {
    if (!d) return 0
    const A = s.getComputedStyle(_o(i))
    return parseFloat(A.getPropertyValue(`margin-${u}`))
  }
  function M() {
    return t
      .map((A, C, R) => {
        const z = !C,
          U = Mw(R, C)
        return z ? v[C] + p : U ? v[C] + m : R[C + 1][l] - A[l]
      })
      .map(Zn)
  }
  return { slideSizes: v, slideSizesWithGaps: y, startGap: p, endGap: m }
}
function pU(n, e, t, i, r, s, o, l, u) {
  const { startEdge: d, endEdge: p, direction: m } = n,
    v = ww(t)
  function y(w, A) {
    return Vp(w)
      .filter((C) => C % A === 0)
      .map((C) => w.slice(C, C + A))
  }
  function x(w) {
    return w.length
      ? Vp(w)
          .reduce((A, C, R) => {
            const z = _o(A) || 0,
              U = z === 0,
              O = C === pm(w),
              N = r[d] - s[z][d],
              k = r[d] - s[C][p],
              I = !i && U ? m(o) : 0,
              V = !i && O ? m(l) : 0,
              Z = Zn(k - V - (N + I))
            return R && Z > e + u && A.push(C), O && A.push(w.length), A
          }, [])
          .map((A, C, R) => {
            const z = Math.max(R[C - 1] || 0)
            return w.slice(z, A)
          })
      : []
  }
  function E(w) {
    return v ? y(w, t) : x(w)
  }
  return { groupSlides: E }
}
function mU(n, e, t, i, r, s, o) {
  const {
      align: l,
      axis: u,
      direction: d,
      startIndex: p,
      loop: m,
      duration: v,
      dragFree: y,
      dragThreshold: x,
      inViewThreshold: E,
      slidesToScroll: M,
      skipSnaps: w,
      containScroll: A,
      watchResize: C,
      watchSlides: R,
      watchDrag: z,
      watchFocus: U,
    } = s,
    O = 2,
    N = KF(),
    k = N.measure(e),
    I = t.map(N.measure),
    V = YF(u, d),
    Z = V.measureSize(k),
    $ = ZF(Z),
    ee = jF(l, Z),
    ue = !m && !!A,
    re = m || !!A,
    {
      slideSizes: se,
      slideSizesWithGaps: G,
      startGap: ie,
      endGap: Q,
    } = hU(V, k, I, t, re, r),
    W = pU(V, Z, M, m, k, I, ie, Q, O),
    { snaps: ne, snapsAligned: ye } = sU(V, ee, k, I, W),
    oe = -_o(ne) + _o(G),
    { snapsContained: fe, scrollContainLimit: we } = tU(Z, oe, ye, A, O),
    me = ue ? fe : ye,
    { limit: Fe } = nU(oe, me, m),
    ze = SC(pm(me), p, m),
    Ge = ze.clone(),
    Ue = Vp(t),
    ae = ({
      dragHandler: Et,
      scrollBody: je,
      scrollBounds: Je,
      options: { loop: At },
    }) => {
      At || Je.constrain(Et.pointerDown()), je.seek()
    },
    Ee = (
      {
        scrollBody: Et,
        translate: je,
        location: Je,
        offsetLocation: At,
        previousLocation: Pt,
        scrollLooper: ft,
        slideLooper: Wt,
        dragHandler: Nt,
        animation: dn,
        eventHandler: he,
        scrollBounds: rt,
        options: { loop: Ne },
      },
      Ve,
    ) => {
      const lt = Et.settled(),
        at = !rt.shouldConstrain(),
        Ut = Ne ? lt : lt && at,
        vn = Ut && !Nt.pointerDown()
      vn && dn.stop()
      const Vn = Je.get() * Ve + Pt.get() * (1 - Ve)
      At.set(Vn),
        Ne && (ft.loop(Et.direction()), Wt.loop()),
        je.to(At.get()),
        vn && he.emit("settle"),
        Ut || he.emit("scroll")
    },
    K = XF(
      i,
      r,
      () => ae(it),
      (Et) => Ee(it, Et),
    ),
    Ke = 0.68,
    Be = me[ze.get()],
    Oe = dp(Be),
    Pe = dp(Be),
    He = dp(Be),
    Se = dp(Be),
    j = QF(Oe, He, Pe, Se, v, Ke),
    B = aU(m, me, oe, Fe, Se),
    ce = lU(K, ze, Ge, j, B, Se, o),
    Me = rU(Fe),
    De = Gp(),
    Ie = dU(e, t, o, E),
    { slideRegistry: st } = oU(ue, A, me, we, W, Ue),
    tt = cU(n, t, st, ce, j, De, o, U),
    it = {
      ownerDocument: i,
      ownerWindow: r,
      eventHandler: o,
      containerRect: k,
      slideRects: I,
      animation: K,
      axis: V,
      dragHandler: qF(
        V,
        n,
        i,
        r,
        Se,
        $F(V, r),
        Oe,
        K,
        ce,
        j,
        B,
        ze,
        o,
        $,
        y,
        x,
        w,
        Ke,
        z,
      ),
      eventStore: De,
      percentOfView: $,
      index: ze,
      indexPrevious: Ge,
      limit: Fe,
      location: Oe,
      offsetLocation: He,
      previousLocation: Pe,
      options: s,
      resizeHandler: JF(e, o, r, t, V, C, N),
      scrollBody: j,
      scrollBounds: eU(Fe, He, Se, j, $),
      scrollLooper: iU(oe, Fe, He, [Oe, He, Pe, Se]),
      scrollProgress: Me,
      scrollSnapList: me.map(Me.get),
      scrollSnaps: me,
      scrollTarget: B,
      scrollTo: ce,
      slideLooper: uU(V, Z, oe, se, G, ne, me, He, t),
      slideFocus: tt,
      slidesHandler: fU(e, o, R),
      slidesInView: Ie,
      slideIndexes: Ue,
      slideRegistry: st,
      slidesToScroll: W,
      target: Se,
      translate: MC(V, e),
    }
  return it
}
function gU() {
  let n = {},
    e
  function t(d) {
    e = d
  }
  function i(d) {
    return n[d] || []
  }
  function r(d) {
    return i(d).forEach((p) => p(e, d)), u
  }
  function s(d, p) {
    return (n[d] = i(d).concat([p])), u
  }
  function o(d, p) {
    return (n[d] = i(d).filter((m) => m !== p)), u
  }
  function l() {
    n = {}
  }
  const u = { init: t, emit: r, off: o, on: s, clear: l }
  return u
}
const vU = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0,
}
function yU(n) {
  function e(s, o) {
    return wC(s, o || {})
  }
  function t(s) {
    const o = s.breakpoints || {},
      l = Hp(o)
        .filter((u) => n.matchMedia(u).matches)
        .map((u) => o[u])
        .reduce((u, d) => e(u, d), {})
    return e(s, l)
  }
  function i(s) {
    return s
      .map((o) => Hp(o.breakpoints || {}))
      .reduce((o, l) => o.concat(l), [])
      .map(n.matchMedia)
  }
  return { mergeOptions: e, optionsAtMedia: t, optionsMediaQueries: i }
}
function xU(n) {
  let e = []
  function t(s, o) {
    return (
      (e = o.filter(({ options: l }) => n.optionsAtMedia(l).active !== !1)),
      e.forEach((l) => l.init(s, n)),
      o.reduce((l, u) => Object.assign(l, { [u.name]: u }), {})
    )
  }
  function i() {
    e = e.filter((s) => s.destroy())
  }
  return { init: t, destroy: i }
}
function V0(n, e, t) {
  const i = n.ownerDocument,
    r = i.defaultView,
    s = yU(r),
    o = xU(s),
    l = Gp(),
    u = gU(),
    { mergeOptions: d, optionsAtMedia: p, optionsMediaQueries: m } = s,
    { on: v, off: y, emit: x } = u,
    E = V
  let M = !1,
    w,
    A = d(vU, V0.globalOptions),
    C = d(A),
    R = [],
    z,
    U,
    O
  function N() {
    const { container: Ue, slides: ae } = C
    U = (m1(Ue) ? n.querySelector(Ue) : Ue) || n.children[0]
    const K = m1(ae) ? U.querySelectorAll(ae) : ae
    O = [].slice.call(K || U.children)
  }
  function k(Ue) {
    const ae = mU(n, U, O, i, r, Ue, u)
    if (Ue.loop && !ae.slideLooper.canLoop()) {
      const Ee = Object.assign({}, Ue, { loop: !1 })
      return k(Ee)
    }
    return ae
  }
  function I(Ue, ae) {
    M ||
      ((A = d(A, Ue)),
      (C = p(A)),
      (R = ae || R),
      N(),
      (w = k(C)),
      m([A, ...R.map(({ options: Ee }) => Ee)]).forEach((Ee) => l.add(Ee, "change", V)),
      C.active &&
        (w.translate.to(w.location.get()),
        w.animation.init(),
        w.slidesInView.init(),
        w.slideFocus.init(Ge),
        w.eventHandler.init(Ge),
        w.resizeHandler.init(Ge),
        w.slidesHandler.init(Ge),
        w.options.loop && w.slideLooper.loop(),
        U.offsetParent && O.length && w.dragHandler.init(Ge),
        (z = o.init(Ge, R))))
  }
  function V(Ue, ae) {
    const Ee = W()
    Z(), I(d({ startIndex: Ee }, Ue), ae), u.emit("reInit")
  }
  function Z() {
    w.dragHandler.destroy(),
      w.eventStore.clear(),
      w.translate.clear(),
      w.slideLooper.clear(),
      w.resizeHandler.destroy(),
      w.slidesHandler.destroy(),
      w.slidesInView.destroy(),
      w.animation.destroy(),
      o.destroy(),
      l.clear()
  }
  function $() {
    M || ((M = !0), l.clear(), Z(), u.emit("destroy"), u.clear())
  }
  function ee(Ue, ae, Ee) {
    !C.active ||
      M ||
      (w.scrollBody.useBaseFriction().useDuration(ae === !0 ? 0 : C.duration),
      w.scrollTo.index(Ue, Ee || 0))
  }
  function ue(Ue) {
    const ae = w.index.add(1).get()
    ee(ae, Ue, -1)
  }
  function re(Ue) {
    const ae = w.index.add(-1).get()
    ee(ae, Ue, 1)
  }
  function se() {
    return w.index.add(1).get() !== W()
  }
  function G() {
    return w.index.add(-1).get() !== W()
  }
  function ie() {
    return w.scrollSnapList
  }
  function Q() {
    return w.scrollProgress.get(w.offsetLocation.get())
  }
  function W() {
    return w.index.get()
  }
  function ne() {
    return w.indexPrevious.get()
  }
  function ye() {
    return w.slidesInView.get()
  }
  function oe() {
    return w.slidesInView.get(!1)
  }
  function fe() {
    return z
  }
  function we() {
    return w
  }
  function me() {
    return n
  }
  function Fe() {
    return U
  }
  function ze() {
    return O
  }
  const Ge = {
    canScrollNext: se,
    canScrollPrev: G,
    containerNode: Fe,
    internalEngine: we,
    destroy: $,
    off: y,
    on: v,
    emit: x,
    plugins: fe,
    previousScrollSnap: ne,
    reInit: E,
    rootNode: me,
    scrollNext: ue,
    scrollPrev: re,
    scrollProgress: Q,
    scrollSnapList: ie,
    scrollTo: ee,
    selectedScrollSnap: W,
    slideNodes: ze,
    slidesInView: ye,
    slidesNotInView: oe,
  }
  return I(e, t), setTimeout(() => u.emit("init"), 0), Ge
}
V0.globalOptions = void 0
function Wv(n = {}, e = []) {
  const t = Y.useRef(n),
    i = Y.useRef(e),
    [r, s] = Y.useState(),
    [o, l] = Y.useState(),
    u = Y.useCallback(() => {
      r && r.reInit(t.current, i.current)
    }, [r])
  return (
    Y.useEffect(() => {
      _w(t.current, n) || ((t.current = n), u())
    }, [n, u]),
    Y.useEffect(() => {
      HF(i.current, e) || ((i.current = e), u())
    }, [e, u]),
    Y.useEffect(() => {
      if (VF() && o) {
        V0.globalOptions = Wv.globalOptions
        const d = V0(o, t.current, i.current)
        return s(d), () => d.destroy()
      } else s(void 0)
    }, [o, s]),
    [l, r]
  )
}
Wv.globalOptions = void 0
const _U = [
    { name: "starbalm", title: "star balm" },
    { name: "skincare", title: "skincare" },
    { name: "hydrostars", title: "hydro-stars" },
  ],
  wU = {
    heart: () =>
      D.jsx("svg", {
        width: "38",
        height: "32",
        viewBox: "0 0 38 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: D.jsx("path", {
          d: "M35.1786 2.82421C33.3628 1.00339 30.948 0 28.3788 0C25.8095 0 23.3948 1.00339 21.5789 2.82421C20.6787 3.73075 19.7437 4.70702 18.9942 5.73366C18.2447 4.70315 17.3136 3.72688 16.4134 2.82421C14.5975 1.00339 12.1828 0 9.61349 0C7.04423 0 4.62951 1.00339 2.81363 2.82421C-0.937878 6.58596 -0.937878 12.7031 2.81363 16.4649C2.85227 16.5036 17.866 31.5467 17.866 31.5467C18.1674 31.8489 18.5615 32 18.9594 32C19.3574 32 19.7476 31.8489 20.049 31.5506C20.6555 30.9462 34.9468 16.709 35.1864 16.4688C38.9379 12.707 38.9379 6.58983 35.1864 2.82809L35.1786 2.82421Z",
          fill: "currentColor",
        }),
      }),
    star: () =>
      D.jsx("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: D.jsx("path", {
          d: "M10.175 31.2993C9.16018 31.8568 7.19146 32.1739 6.25784 31.4732C5.32421 30.7726 4.86248 29.2792 5.19736 27.4227L6.27813 20.7128L1.16858 15.5883C0.34151 14.7547 -0.247079 13.2204 0.10303 12.0748C0.453138 10.9343 1.75717 10.0444 2.89882 9.86543L9.95681 8.77098L13.0875 2.11219C13.5949 1.03308 14.8025 0.00511427 15.9594 0C17.1112 0 18.2985 0.946141 18.8161 2.01502L22.033 8.71472L28.9895 9.73757C30.395 9.98817 31.5519 10.8013 31.9122 11.9367C32.2724 13.0772 31.4606 14.857 30.6386 15.6957L25.8081 20.631L27.0157 27.7756C27.2491 29.3764 26.8432 30.6805 25.9147 31.3914C25.387 31.7903 24.7628 32 24.1337 32C23.6516 32 22.1294 31.3249 21.688 31.0845L16.071 28.0467L10.175 31.2993Z",
          fill: "currentColor",
        }),
      }),
    star8: () =>
      D.jsx("svg", {
        width: "37",
        height: "32",
        viewBox: "0 0 37 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: D.jsx("path", {
          d: "M36.4259 15.1009L28.0792 11.1763C27.7021 10.9992 27.4748 10.6092 27.5084 10.1972L28.2496 1.07721C28.3178 0.241 27.3745 -0.298205 26.6768 0.17837L19.0707 5.37371C18.7273 5.60858 18.2727 5.60858 17.9293 5.37371L10.3232 0.17837C9.62599 -0.298205 8.68265 0.241 8.75035 1.07721L9.49158 10.1972C9.52518 10.6092 9.29787 10.9987 8.92083 11.1763L0.574083 15.1009C-0.191361 15.4606 -0.191361 16.5394 0.574083 16.8991L8.92083 20.8237C9.29787 21.0008 9.52518 21.3908 9.49158 21.8028L8.75035 30.9228C8.68216 31.759 9.62549 32.2982 10.3232 31.8216L17.9293 26.6263C18.2727 26.3914 18.7273 26.3914 19.0707 26.6263L26.6768 31.8216C27.374 32.2982 28.3173 31.759 28.2496 30.9228L27.5084 21.8028C27.4748 21.3908 27.7021 21.0013 28.0792 20.8237L36.4259 16.8991C37.1914 16.5394 37.1914 15.4606 36.4259 15.1009Z",
          fill: "currentColor",
        }),
      }),
    star9: () =>
      D.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        children: D.jsx("path", {
          d: "M16.8908 0.511567L22.1328 9.49568C22.2223 9.64932 22.3505 9.77703 22.5042 9.86706L31.4884 15.109C32.1705 15.5073 32.1705 16.4932 31.4884 16.891L22.5042 22.1329C22.3505 22.2225 22.2228 22.3507 22.1328 22.5043L16.8908 31.4884C16.4925 32.1705 15.5065 32.1705 15.1087 31.4884L9.86672 22.5043C9.77718 22.3507 9.64898 22.223 9.49533 22.1329L0.511575 16.8905C-0.170525 16.4922 -0.170525 15.5063 0.511575 15.1085L9.49582 9.86657C9.64947 9.77703 9.77718 9.64883 9.86721 9.49519L15.1087 0.511567C15.507 -0.170522 16.493 -0.170522 16.8908 0.511567Z",
          fill: "#FDFF00",
        }),
      }),
  },
  SU = ({ option: n, index: e, isActive: t, onClick: i }) =>
    D.jsxs("div", {
      onClick: i,
      className: "aspect-square w-full relative top-[50px] animation-bounce",
      children: [
        n != null && n.video
          ? D.jsxs(D.Fragment, {
              children: [
                D.jsxs("video", {
                  className: "w-full h-full object-contain hidden 800:block",
                  autoPlay: !0,
                  muted: !0,
                  loop: !0,
                  playsInline: !0,
                  poster: n.video.image,
                  children: [
                    D.jsx("source", { src: n.video.mp4, type: "video/mp4" }),
                    D.jsx("source", { src: n.video.webm, type: "video/webm" }),
                  ],
                }),
                D.jsx("video", {
                  className: "w-full h-full object-contain  800:hidden",
                  autoPlay: !0,
                  muted: !0,
                  loop: !0,
                  playsInline: !0,
                  poster: n.video.image,
                  children: D.jsx("source", { src: n.video.mp4, type: "video/mp4" }),
                }),
              ],
            })
          : D.jsx("img", {
              src: n.image,
              alt: n.name,
              className: "w-full user-select-none h-full object-contain",
            }),
        t &&
          D.jsx("div", {
            className: "h-[100px] block w-full relative -top-[20px]",
            children: D.jsx("p", {
              className:
                "text-black whitespace-nowrap font-gt absolute left-[50%] translate-x-[-50%] text-[14px] mt-20 800:mt-24 leading-[15px] max-w-[300px] 1000:mt-32 mx-auto",
              children: n.caption,
            }),
          }),
      ],
    })
function MU({
  setIsOpen: n,
  product: e,
  setProduct: t,
  setNestedProduct: i,
  nestedProduct: r,
}) {
  var M, w
  const [s, o] = Y.useState(!1),
    [l, u] = Y.useState(r),
    [d, p] = Y.useState("keep swiping to meet<span class='block' />all my friends :)"),
    [m, v] = Y.useState(!1),
    [y, x] = Wv({
      loop: !0,
      align: "center",
      onSelect: (A) => {
        u(A)
      },
    })
  Y.useEffect(() => {
    x && u(x == null ? void 0 : x.selectedScrollSnap()),
      x == null ||
        x.on("select", () => {
          u(x == null ? void 0 : x.selectedScrollSnap())
        })
  }, [x]),
    Y.useEffect(() => {
      x && (x == null || x.scrollTo(r))
    }, [r, x]),
    Y.useEffect(() => {
      m && clearTimeout(m)
      const A = setTimeout(() => {
          p("")
        }, 9e3),
        C = setTimeout(() => {
          p("keep swiping to meet<span class='block' />all my friends :)")
        }, 14e3)
      return (
        v(A),
        () => {
          m && clearTimeout(m), clearTimeout(C)
        }
      )
    }, [l]),
    Y.useEffect(() => {
      p(bi[e].options[l].message)
    }, [l, e])
  const E = (A) =>
    A === l
      ? ""
      : l === bi[e].options.length - 1
      ? A === 0
        ? "right-slide"
        : "left-slide"
      : l === 0
      ? A === 1
        ? "right-slide"
        : "left-slide"
      : l > A
      ? "left-slide"
      : "right-slide"
  return D.jsxs(
    "div",
    {
      className: "w-full h-full flex flex-col",
      children: [
        D.jsxs("div", {
          className:
            "p-4 text-center text-black relative rounded-[40px] h-[45px] 800:h-[125px]",
          style: { backgroundColor: bi[e].valueColor },
          children: [
            D.jsx(hm, {
              onClick: () => {
                n(!1)
              },
            }),
            D.jsx("div", {
              className:
                "flex fixed top-2 800:top-5 z-10 w-full justify-center items-center",
              children: D.jsxs("div", {
                className: Xn(
                  "p-0 pl-3 min-w-[170px] inlne-block text-left border-[2px] relative -left-[6px] 800:pl-9 800:pr-5 800:pt-3 800:pb-5 800:-top-[9px]",
                  { "border-black bg-white text-black": s, "border-transparent": !s },
                ),
                children: [
                  D.jsxs("button", {
                    onClick: () => o(!s),
                    className:
                      " text-[20px] 800:text-[32px] no-bg-button font-abc underline mb-2 font-extrabold inline-flex items-center gap-6 pr-3 800:gap-9 relative top-[2px] 800:top-[1px] 800:mb-2",
                    children: [
                      bi[e].name,
                      D.jsx("img", {
                        src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/carot.png?v=1741070429",
                        alt: "carot",
                        className: "w-[12px] 800:w-[20px] h-auto",
                      }),
                    ],
                  }),
                  s &&
                    D.jsx("div", {
                      className:
                        "flex flex-col gap-1 text-[18px] 800:text-[32px] font-abc font-extrabold pb-2 800:leading-[42px]",
                      children: _U.map((A) =>
                        D.jsx(
                          "button",
                          {
                            className: Xn("text-left", { hidden: A.name === e }),
                            onClick: () => {
                              o(!1), t(A.name), u(0), A.name, i(0)
                            },
                            children: A.title,
                          },
                          A.name,
                        ),
                      ),
                    }),
                ],
              }),
            }),
          ],
        }),
        D.jsx("div", {
          className:
            "text-center mt-[5px] w-full overflow-y-auto h-full 800:h-[calc(100vh-96px)] 800:overflow-visible",
          children: D.jsx("div", {
            className: "flex justify-center items-center w-full h-full",
            children: D.jsxs("div", {
              className: "grid 800:grid-cols-2 800:gap-[5px] items-start h-full",
              children: [
                D.jsxs("div", {
                  className:
                    "col-span-1 relative rounded-[40px] min-h-[350px] h-full flex items-center justify-center 800:h-[calc(100vh-98px)]",
                  style: { backgroundColor: bi[e].valueColor },
                  children: [
                    D.jsx("div", {
                      className:
                        "absolute top-0 right-[10%] 800:bottom-0 800:top-auto 800:left-[10%] 800:right-auto",
                      children: D.jsxs("div", {
                        className: "flex items-center gap-5 800:flex-row-reverse",
                        children: [
                          D.jsx("div", {
                            children: D.jsx("p", {
                              className: `\r
                      text-black font-abc max-w-[180px] text-right text-[14px] leading-[15px]\r
                      800:text-[15px] font-extrabold 800:leading-[18px] relative -top-[6px] \r
                      800:-top-[10px] -rotate-[3deg] 800:-rotate-[6deg] 800:text-left\r
                      800:max-w-[260px]`,
                              children: D.jsx(
                                Rd.span,
                                {
                                  initial: { scale: 0.8, opacity: 0, y: 10 },
                                  animate: { scale: 1, opacity: 1, y: 0 },
                                  transition: { duration: 0.3, ease: "easeOut" },
                                  dangerouslySetInnerHTML: { __html: d },
                                },
                                d,
                              ),
                            }),
                          }),
                          D.jsx("img", {
                            src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/mobile-star.png?v=1740602141",
                            alt: "star",
                            className: "w-[100px] h-auto 800:hidden",
                          }),
                          D.jsx("img", {
                            src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/desktop-star.png?v=1740601632",
                            alt: "star",
                            className: "w-[100px] h-auto 800:block hidden",
                          }),
                        ],
                      }),
                    }),
                    D.jsx("div", {
                      className:
                        "w-full h-full overflow-hidden flex items-center justify-center",
                      children: D.jsx("div", {
                        className: "w-full max-w-[80%] mx-auto 800:mb-14 ",
                        children: D.jsx("div", {
                          className: Xn("embla__viewport relative", bi[e].name, {
                            "top-[10px]": bi[e].name === "star balm",
                            "top-[20px]": bi[e].name !== "star balm",
                          }),
                          ref: y,
                          children: D.jsx("div", {
                            className: "embla__container",
                            children:
                              (M = bi[e].options) == null
                                ? void 0
                                : M.map((A, C) =>
                                    D.jsx(
                                      "div",
                                      {
                                        className: Xn(
                                          "embla__slide text-[white] relative",
                                          E(C),
                                          {
                                            activeEmblaSlide: l === C,
                                            "shrink-asset": A.shrink,
                                          },
                                        ),
                                        children: D.jsx(SU, {
                                          option: A,
                                          index: C,
                                          isActive: l === C,
                                          onClick: () => {
                                            x == null || x.scrollTo(C)
                                          },
                                        }),
                                      },
                                      A._id,
                                    ),
                                  ),
                          }),
                        }),
                      }),
                    }),
                  ],
                }),
                D.jsx("div", {
                  className: "col-span-1 h-full 800:overflow-y-scroll",
                  children: D.jsxs("div", {
                    className: "flex flex-col h-full ",
                    children: [
                      D.jsx("div", {
                        className:
                          "p-5 px-[20px] mt-[5px] 800:mt-0 min-h-[70px] 800:min-h-[150px] inline-flex items-center 800:px-[40px] 1200:px-[90px] rounded-[40px]",
                        style: { backgroundColor: bi[e].options[l].headerValueColor },
                        children: D.jsx("div", {
                          className: " text-left  gap-4 ",
                          children: D.jsx("h3", {
                            className:
                              "text-black text-[22px] 800:text-[45px] 800:leading-[48px] font-extrabold font-abc relative top-[1px]",
                            children: bi[e].options[l].name,
                          }),
                        }),
                      }),
                      D.jsx("div", {
                        className:
                          " font-abc rounded-[40px] mt-[5px] h-auto flex-1 800:flex 800:items-center",
                        style: { backgroundColor: bi[e].valueColor },
                        children: D.jsxs("div", {
                          className: "p-5  text-left  800:px-[40px] 1200:px-[90px]",
                          children: [
                            D.jsx("p", {
                              className:
                                "text-black py-4 text-[16px] 800:text-[25px] leading-[20px] 800:leading-[28px] 800:mb-8",
                              children: D.jsx("span", {
                                className: "font-abc font-extrabold extra-spacing",
                                children: bi[e].options[l].description(),
                              }),
                            }),
                            D.jsxs("div", {
                              className: "grid 1400:grid-cols-2 gap-2 800:gap-4 mt-4",
                              children: [
                                (w = bi[e].options[l].values) == null
                                  ? void 0
                                  : w.map((A, C) =>
                                      D.jsxs(
                                        "div",
                                        {
                                          className:
                                            "flex flex-col gap-2 border-2 border-black bg-white",
                                          children: [
                                            D.jsxs("div", {
                                              className: "flex border-b-2 border-black",
                                              children: [
                                                D.jsx("div", {
                                                  className:
                                                    "bg-black w-[58px] inline-flex items-center justify-center h-[42px]",
                                                  style: { color: bi[e].valueColor },
                                                  children: wU[A.icon](),
                                                }),
                                                D.jsx("span", {
                                                  className:
                                                    "text-black p-2 text-[16px] 800:text-[20px] font-black leading-[22px] relative top-[2px]",
                                                  children: A.name,
                                                }),
                                              ],
                                            }),
                                            D.jsx("p", {
                                              className:
                                                "text-black text-[16px] 800:text-[15px] leading-[20px] font-gt px-3 my-2 py-2 pt-0",
                                              children: A.description,
                                            }),
                                          ],
                                        },
                                        A._id,
                                      ),
                                    ),
                                bi[e].options[l].linkText &&
                                  D.jsx("div", {
                                    className:
                                      "grid-item inline-flex w-full justify-center items-center my-2 h-full 800:mb-1",
                                    children: D.jsx("a", {
                                      href: bi[e].options[l].url,
                                      target: "_blank",
                                      className:
                                        "font-extrabold underline text-black 800:text-[20px]",
                                      children: bi[e].options[l].linkText,
                                    }),
                                  }),
                              ],
                            }),
                          ],
                        }),
                      }),
                    ],
                  }),
                }),
              ],
            }),
          }),
        }),
      ],
    },
    bi[e].name,
  )
}
const bi = {
    starbalm: {
      name: "star balm",
      _type: "multi",
      coreColor: "bg-green",
      valueColor: "#2BFF00",
      options: [
        {
          name: "starfruit",
          _id: "star-balm",
          subtitle: "starfruit",
          caption: "bright, juicy, and tropical",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/balm-starfruit.png?v=1740601404",
          headerValueColor: "#F86AD9",
          linkText: "find ur fav flavor",
          message: "when u run out of balm, store ur tiny treasures in this lil tube!",
          url: "/collections/star-balm",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                D.jsx("span", { className: "gt-spacer" }),
                " ultra-cushiony cuties",
                " ",
                D.jsx("span", { className: "gt-spacer" }),
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with a powerful combo of",
                }),
                " ",
                D.jsx("span", { className: "gt-spacer" }),
                "shea butter, cocoa butter, ",
                D.jsx("span", { className: "gt-spacer" }),
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                D.jsx("span", { className: "gt-spacer" }),
                " coconut oil.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "moisturizes lips, soothes skin, and minimizes dryness",
            },
            {
              name: "star power",
              icon: "star",
              description: "delivers long-lasting hydration and tasty flavors",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "dry, chapped lips [or whenever your lips need a hug]",
            },
          ],
        },
        {
          name: "watermelon squeeze",
          _id: "star-balm-2",
          subtitle: "watermelon squeeze",
          caption: "fresh, juicy, and sweet",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/balm-watermelon.png?v=1740601404",
          headerValueColor: "#FD495C",
          linkText: "find ur fav flavor",
          url: "/collections/star-balm",
          message: "mmm delish :)",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " ultra-cushiony cuties",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with a powerful combo of",
                }),
                " ",
                "shea butter, cocoa butter,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " coconut oil.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "moisturizes lips, soothes skin, and minimizes dryness",
            },
            {
              name: "star power",
              icon: "star",
              description: "delivers long-lasting hydration and tasty flavors",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "dry, chapped lips [or whenever your lips need a hug]",
            },
          ],
        },
        {
          name: "very vanilla",
          _id: "star-balm-3",
          subtitle: "very vanilla",
          caption: "sweet, soft, and dreamy",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Star-Balm-Starfruit-Angled_1.png?v=1740697257",
          headerValueColor: "#F6F6F6",
          linkText: "find ur fav flavor",
          url: "/collections/star-balm",
          message: "i knew u had good taste <3",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " ultra-cushiony cuties",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with a powerful combo of",
                }),
                " ",
                "shea butter, cocoa butter,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " coconut oil.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "moisturizes lips, soothes skin, and minimizes dryness",
            },
            {
              name: "star power",
              icon: "star",
              description: "delivers long-lasting hydration and tasty flavors",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "dry, chapped lips [or whenever your lips need a hug]",
            },
          ],
        },
        {
          name: "mango mania",
          _id: "star-balm-4",
          subtitle: "mango mania",
          caption: "fresh, sweet, and citrusy",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/balm-mango.png?v=1740601404",
          message: "it’s like a bff that goes w<span class='block' />u everywhere!",
          headerValueColor: "#FFAD00",
          linkText: "find ur fav flavor",
          url: "/collections/star-balm",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " ultra-cushiony cuties",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with a powerful combo of",
                }),
                " ",
                "shea butter, cocoa butter,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " coconut oil.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "moisturizes lips, soothes skin, and minimizes dryness",
            },
            {
              name: "star power",
              icon: "star",
              description: "delivers long-lasting hydration and tasty flavors",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "dry, chapped lips [or whenever your lips need a hug]",
            },
          ],
        },
        {
          name: "coconut blast",
          _id: "star-balm-5",
          subtitle: "coconut blast",
          caption: "creamy, sweet, and refreshing",
          message: ":) ← me wearing my star balm",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/balm-coconut.png?v=1740601404",
          headerValueColor: "#78D5E1",
          linkText: "find ur fav flavor",
          url: "/collections/star-balm",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " ultra-cushiony cuties",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with a powerful combo of",
                }),
                " ",
                "shea butter, cocoa butter,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " coconut oil.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "moisturizes lips, soothes skin, and minimizes dryness",
            },
            {
              name: "star power",
              icon: "star",
              description: "delivers long-lasting hydration and tasty flavors",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "dry, chapped lips [or whenever your lips need a hug]",
            },
          ],
        },
        {
          name: "so strawberry",
          _id: "star-balm-6",
          subtitle: "so strawberry",
          caption: "juicy, sweet, and creamy",
          message: "cutest thing u've ever seen? yes",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/balm-strawberry.png?v=1740601404",
          headerValueColor: "#F469DB",
          linkText: "find ur fav flavor",
          url: "/collections/star-balm",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " ultra-cushiony cuties",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with a powerful combo of",
                }),
                " ",
                "shea butter, cocoa butter,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " coconut oil.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "moisturizes lips, soothes skin, and minimizes dryness",
            },
            {
              name: "star power",
              icon: "star",
              description: "delivers long-lasting hydration and tasty flavors",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "dry, chapped lips [or whenever your lips need a hug]",
            },
          ],
        },
        {
          name: "magic mint",
          _id: "star-balm-7",
          subtitle: "magic mint",
          caption: "fresh, sweet, and creamy",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/balm-mint.png?v=1740601404",
          message: "ur rly going 2 love this 1…",
          headerValueColor: "#76DED3",
          linkText: "find ur fav flavor",
          url: "/collections/star-balm",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " ultra-cushiony cuties",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with a powerful combo of",
                }),
                " ",
                "shea butter, cocoa butter,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " coconut oil.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "moisturizes lips, soothes skin, and minimizes dryness",
            },
            {
              name: "star power",
              icon: "star",
              description: "delivers long-lasting hydration and tasty flavors",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "dry, chapped lips [or whenever your lips need a hug]",
            },
          ],
        },
      ],
    },
    skincare: {
      name: "skincare",
      _type: "multi",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/skincare-product.png?v=1740602400",
      coreColor: "bg-blue",
      valueColor: "#00CCED",
      options: [
        {
          name: "star wash + salicylic acid",
          _id: "star-wash-1",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/skincare-wash.png?v=1740602400",
          headerValueColor: "#00CCED",
          url: "/products/star-wash-salicylic-acid",
          linkText: "try it here",
          video: {
            image:
              "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Starwash_Caro.png?v=1741197662",
            webm: "https://cdn.shopify.com/videos/c/o/v/9ee06dd440414687a37e1f3cae6a558f.webm",
            mp4: "https://cdn.shopify.com/videos/c/o/v/d14d5f7564a84f89979af56a3965e847.mp4",
          },
          message: "add a lil water to make a soft, sudsy foam!",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "this" }),
                " cleansing cutie",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "is made with a pore-clearing and hydrating combo of",
                }),
                " ",
                "salicylic acid, hyaluronic acid,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " glycerin.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description:
                "gently cleanses skin while minimizing breakouts and unclogging pores",
            },
            {
              name: "star power",
              icon: "star",
              description:
                "has the cutest mica-based, microplastic-free shimmer that disappears with water",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "breakout-prone and sensitive skin",
            },
          ],
        },
        {
          name: "star cream + salicylic acid",
          _id: "star-cream-1",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/skincare-cream.png?v=1740602400",
          headerValueColor: "#00CCED",
          linkText: "try it here",
          video: {
            video:
              "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Star_Cream_Caro.png?v=1741197661",
            webm: "https://cdn.shopify.com/videos/c/o/v/5cfd8293b4394e9ca5b7f3765c98576c.webm",
            mp4: "https://cdn.shopify.com/videos/c/o/v/1151102dfe0d48d3a99bcfd1bd96ccc6.mp4",
          },
          shrink: !0,
          message: "apply it in the am + pm, or any time you need xtra hydration <3",
          url: "/products/star-cream-salicylic-acid",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "this" }),
                " moisturizing cutie",
                " ",
                D.jsxs("span", {
                  className: "font-gt font-normal",
                  children: ["is made with a pore-clearing and soothing combo of", " "],
                }),
                " ",
                "salicylic acid, hyaluronic acid,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " niacinamide.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description:
                "minimizes breakouts and clears pores while locking in moisture",
            },
            {
              name: "star power",
              icon: "star",
              description: "absorbs into skin like a cloud with a cool, creamy feel",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "breakout-prone and sensitive skin",
            },
          ],
        },
        {
          name: "lift off pore strips",
          _id: "star-strips-1",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/skincare-strips.png?v=1740602400",
          headerValueColor: "#FDFF00",
          linkText: "try it here",
          video: {
            image:
              "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Pore_Strip.png?v=1741197661",
            webm: "https://cdn.shopify.com/videos/c/o/v/b602d71d154341caba3e17645fe4408d.webm",
            mp4: "https://cdn.shopify.com/videos/c/o/v/bc21b1433ea244d5b2fbd264279f0419.mp4",
          },
          message: "wet ur nose before applying for maximum stick!",
          url: "/products/lift-off-pore-strips",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "this" }),
                " powerful cutie",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "is made with a soothing combo of",
                }),
                " ",
                "aloe vera, witch hazel,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " allantoin.",
              ],
            }),
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "instantly removes blackheads and clears gunk from pores",
            },
            {
              name: "star power",
              icon: "star",
              description: "gently lifts away dirt, oil, and buildup",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "blackheads, oil, and clogged pores on your nose",
            },
          ],
        },
      ],
    },
    hydrostars: {
      name: "hydro-stars",
      _type: "multi",
      coreColor: "bg-yellow",
      valueColor: "#FDFF00",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Hydro-2.png?v=1741116229",
      options: [
        {
          name: "hydro-star® pimple patches",
          _id: "hydro-star-1",
          linkText: "find ur fav color",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Hydro.png?v=1741122596",
          url: "/collections/hydrocolloid-patch",
          message: "always apply hydro-stars to clean, dry skin so they can rly stick!",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " classic cuties",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with an award-winning",
                }),
                " ",
                "100% hydrocolloid",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "formula.",
                }),
              ],
            }),
          headerValueColor: "#FDFF00",
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "absorbs fluid, reduces redness, and shrinks spots",
            },
            {
              name: "star power",
              icon: "star",
              description: "a cute star shape that hugs your spots and sticks all day",
            },
            {
              name: "perf for",
              icon: "star8",
              description:
                "juicy spots and whiteheads [or whenever you want to feel cute]",
            },
            {
              name: "upgraded formula",
              icon: "star9",
              description:
                "now 2x stickier, 50% more absorbent, and easier to apply with perforated sheets.",
            },
          ],
        },
        {
          name: "hydro-star® + salicylic acid",
          _id: "hydro-star-2",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Sal-Acid_97d20e67-d683-4b66-9230-2d1089e12202.png?v=1741122596",
          url: "/products/salicylic-acid-hydro-stars",
          linkText: "try it here",
          message: "great for when ur spots need something a lil xtra powerful!",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " pore-clearing cuties ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with",
                }),
                " ",
                "hydrocolloid ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " ",
                "salicylic acid.",
              ],
            }),
          headerValueColor: "#00CCED",
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description: "helps unclog pores, visibly shrink spots, and absorb fluid",
            },
            {
              name: "star power",
              icon: "star",
              description: "cuts through oil, gunk, and dead skin cells",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "clogged pores and spots that need extra power",
            },
            {
              name: "upgraded formula",
              icon: "star9",
              description:
                "now 2x stickier, 50% more absorbent, and easier to apply with perforated sheets.",
            },
          ],
        },
        {
          name: "hydro-star® clear",
          _id: "hydro-star-3",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Clear.png?v=1741122596",
          url: "/products/hydro-star®-clear ",
          linkText: "try it here",
          message:
            "they’re xtra great for tight or awk spaces, like the corner of ur eyebrows!",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " invisible cuties",
                " ",
                D.jsxs("span", {
                  className: "font-gt font-normal",
                  children: ["are made with an award-winning", " "],
                }),
                " ",
                "100% hydrocolloid",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "formula.",
                }),
              ],
            }),
          headerValueColor: "#FF00D3",
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description:
                "absorbs fluid and blends seamlessly into skin with invisible, rounded edges",
            },
            {
              name: "star power",
              icon: "star",
              description:
                "comes in two sizes, classic and big, for all of your spot needs",
            },
            {
              name: "perf for",
              icon: "star8",
              description:
                "juicy spots and whiteheads [and when you’re feeling more lowkey]",
            },
            {
              name: "upgraded formula",
              icon: "star9",
              description:
                "now 2x stickier, 50% more absorbent, and easier to apply with perforated sheets.",
            },
          ],
        },
        {
          name: "hydro-star® recovery",
          _id: "hydro-star-4",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Recovery_3bd426cc-e2aa-4302-80cd-edc6ec196947.png?v=1741122596",
          url: "/products/hydro-star-recovery",
          linkText: "try it here",
          message:
            "they’re sooo sweet! try wearing them when ur skin needs a lil xtra care <3",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " soothing cuties",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with a powerful combo of",
                }),
                " ",
                "aloe vera, vitamin a,",
                " ",
                D.jsx("span", { className: "font-gt font-normal", children: "and" }),
                " licorice root.",
              ],
            }),
          headerValueColor: "#8D3EFF",
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description:
                "reduces the look of scars and helps heal skin after picking",
            },
            {
              name: "star power",
              icon: "star",
              description:
                "minimizes redness, soothes dry spots, and supports skin through the healing process",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "spots that are dry, flaky, or freshly picked",
            },
            {
              name: "upgraded formula",
              icon: "star9",
              description:
                "now 2x stickier, 50% more absorbent, and easier to apply with perforated sheets.",
            },
          ],
        },
        {
          name: "hydro-star® + tea tree",
          _id: "hydro-star-5",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Tearee_1b4ab565-87c0-4b4f-9917-2a06964c5059.png?v=1741122595",
          message: "mm… they smell<span class='block' />rly good too!",
          linkText: "try it here",
          url: "/products/tea-tree-hydro-stars",
          description: () =>
            D.jsxs(D.Fragment, {
              children: [
                D.jsx("span", { className: "font-gt font-normal", children: "these" }),
                " supernatural cuties ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "are made with",
                }),
                " ",
                "hydrocolloid",
                " ",
                D.jsx("span", {
                  className: "font-gt font-normal",
                  children: "and plant-based",
                }),
                " tea tree oil.",
              ],
            }),
          headerValueColor: "#2BFF00",
          values: [
            {
              name: "why u'll love it",
              icon: "heart",
              description:
                "naturally balances skin, reduces excess oil, and soothes spots ",
            },
            {
              name: "star power",
              icon: "star",
              description:
                "helps reduce the appearance of redness without irritating skin",
            },
            {
              name: "perf for",
              icon: "star8",
              description: "oily spots and clogged pores",
            },
            {
              name: "upgraded formula",
              icon: "star9",
              description:
                "now 2x stickier, 50% more absorbent, and easier to apply with perforated sheets.",
            },
          ],
        },
      ],
    },
  },
  EU = () => {
    const [n, e] = Y.useState(!1),
      [t, i] = Y.useState(""),
      {
        message: r,
        setMessage: s,
        ingredientHover: o,
      } = cA(
        (l) => ({
          message: l.message,
          setMessage: l.setMessage,
          ingredientHover: l.ingredientHover,
        }),
        aA,
      )
    return (
      Y.useEffect(() => {
        n && clearTimeout(n)
        const l = setTimeout(() => {
          s(
            "hi !! hover over something +<span class='block' />i'll tell u all abt it ★",
          )
        }, 6e3)
        return (
          e(l),
          () => {
            n && clearTimeout(n)
          }
        )
      }, [o]),
      D.jsx("div", {
        children: D.jsxs("div", {
          className: "fixed top-5 right-5 z-1",
          children: [
            D.jsx(
              Rd.span,
              {
                initial: { scale: 0.8, opacity: 0, y: 10 },
                animate: { scale: 1, opacity: 1, y: 0 },
                transition: { duration: 0.3, ease: "easeOut" },
                className:
                  "absolute hidden 800:block no-bg-button w-[180px] 800:w-[230px] top-[14px] 800:top-[20px] -left-[190px] 800:-left-[240px] -rotate-[2deg] text-right text-black ff text-[12px] 800:text-[16px] font-extrabold font-abc leading-[16px] 800:leading-[18px]",
                dangerouslySetInnerHTML: { __html: r },
              },
              r,
            ),
            D.jsxs("span", {
              className:
                "absolute  800:hidden no-bg-button w-[180px] 800:w-[230px] top-[14px] 800:top-[20px] -left-[190px] 800:-left-[240px] -rotate-[2deg] text-right text-black ff text-[14px] leading-[15px] 800:text-[16px] font-extrabold font-abc 800:leading-[18px]",
              children: [
                "scroll around 2 meet",
                D.jsx("span", { className: "block" }),
                "my friends!",
              ],
            }),
            D.jsx("img", {
              src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/cube-y.png?v=1740601632",
              alt: "cube-y",
              className:
                " transform -rotate-[15deg] relative 800:-top-[10px] h-[60px] 800:h-[100px] w-[60px] 800:w-[100px]",
            }),
          ],
        }),
      })
    )
  },
  po = [
    {
      id: 1,
      title: "aloe vera",
      pronounce: "[al-oh-ver-uh]",
      message: "omg my xtra soothing bff <3",
      quote: () =>
        D.jsxs("p", {
          children: [
            "“if i want to feel cozy, i make some tea and hangout with ",
            D.jsx("span", { className: "font-black", children: "aloe vera" }),
            ".”",
          ],
        }),
      description:
        "a plant-based extract that’s filled with powerful antioxidants and vitamins that moisturize and soothe skin.",
    },
    {
      id: 2,
      title: "glycerin",
      pronounce: "[gli-sir-in]",
      message: "omg funny running<span class='block' />into u here bff",
      quote: () =>
        D.jsxs("p", {
          children: [
            "“i never knew moisture until i met ",
            D.jsx("span", { className: "font-black", children: "glycerin" }),
            ".”",
          ],
        }),
      description:
        "a hydrating ingredient that helps soothe and calm skin while locking in moisture. ppl love it for its ability to pull in moisture from the air and deeper layers of the skin, leaving your face softer and happier. it also helps strengthen and protect your natural moisture barrier!",
    },
    {
      id: 3,
      title: "hyaluronic acid",
      pronounce: "[hi-uh-ler-on-ick-acid]",
      message: "have fun staying hydrated w this cutie :)",
      quote: () =>
        D.jsxs("p", {
          children: [
            "“between a beach day and ",
            D.jsx("span", { className: "font-black", children: "hyaluronic acid" }),
            ", i'd choose both!”",
          ],
        }),
      description:
        "a humectant [aka a substance that draws water into skin] that’s well-loved for its ability to hold on to just the right amount of moisture. that means it’s v effective at hydrating skin, leaving behind a softer, smoother feel.",
    },
    {
      id: 4,
      title: "hydrocolloid",
      message: "a classic 4 a reason!",
      pronounce: "[hy-droh-koh-loyd]",
      quote: () =>
        D.jsxs("p", {
          children: [
            "“",
            D.jsx("span", { className: "font-black", children: "hydrocolloid" }),
            " is always there for me.”",
          ],
        }),
      description:
        "everyone’s fav material that’s clinically proven to flatten spots and promote healing by absorbing bacteria and fluid. it’s also great bc it helps visibly reduce the appearance of inflammation and redness overnight. plus, it’s gentle enough for all skin types, even sensitive :)",
    },
    {
      id: 5,
      title: "niacinamide",
      pronounce: "[naya-sin-a-mide]",
      message: "talk abt a star !!",
      quote: () =>
        D.jsxs("p", {
          children: [
            "“",
            D.jsx("span", { className: "font-black", children: "niacinamide" }),
            " makes my skin as soft as a cloud!”",
          ],
        }),
      description:
        "a form of vitamin b3 that helps moisturize and soothe while also strengthening the skin barrier [aka the outermost layer of your skin]. it’s super gentle for all skin types <3 ",
    },
    {
      id: 6,
      title: "salicylic acid",
      pronounce: "[sal-uh-sill-ick-acid]",
      message:
        "i’ll bet u’ve never met<span class='block' />someone this powerful tbh ",
      quote: () =>
        D.jsxs("p", {
          children: [
            "“",
            D.jsx("span", { className: "font-black", children: "salicylic acid" }),
            " minimizes just about everything in my life.”",
          ],
        }),
      description:
        "a beta hydroxy acid [aka a chemical exfoliant] that cuts through oil, gunk, and dead skin cells. sal acid is oil soluble, which means it reaches deep inside your pores. ppl with breakout-prone and oily skin tend to love this ingredient most!",
    },
    {
      id: 7,
      title: "tea tree oil",
      pronounce: "[tee-tree-oil]",
      message: "omg this one is super ~naturally~ fun",
      quote: () =>
        D.jsxs("p", {
          children: [
            "“i always have sm fun with ",
            D.jsx("span", { className: "font-black", children: "tea tree oil" }),
            " .”",
          ],
        }),
      description:
        "an essential oil that helps naturally balance skin and clear pores by reducing excess oil and buildup. it also has a soft green, herbal smell :) ppl love it for its antimicrobial and anti-inflammatory properties.",
    },
  ]
function TU({ setIsOpen: n, ingredientIndex: e }) {
  const [t, i] = Y.useState(e),
    [r, s] = Wv({
      loop: !0,
      align: "center",
      drag: !0,
      startIndex: e,
      onSelect: (o) => {
        i(o)
      },
    })
  return (
    Y.useEffect(() => {
      s && i(s == null ? void 0 : s.selectedScrollSnap()),
        s == null ||
          s.on("select", () => {
            i(s == null ? void 0 : s.selectedScrollSnap())
          })
    }, [s]),
    Y.useEffect(() => {
      const o = (l) => {
        l.key === "ArrowLeft"
          ? i(t !== 0 ? t - 1 : po.length - 1)
          : l.key === "ArrowRight" && i(t !== po.length - 1 ? t + 1 : 0)
      }
      return (
        document.addEventListener("keydown", o),
        () => document.removeEventListener("keydown", o)
      )
    }, [t]),
    D.jsxs("div", {
      className: "w-full h-full",
      children: [
        D.jsxs("div", {
          className:
            "p-4 text-center h-[66px] 800:h-[86px] rounded-[40px] relative bg-pink",
          children: [
            D.jsx(hm, {
              onClick: () => {
                n(!1)
              },
            }),
            D.jsx("h2", {
              className:
                "text-[20px] leading-[18px] 800:text-[34px] 800:leading-[36px] font-abc text-black font-bold",
              children: "star ingredients",
            }),
            D.jsx("p", {
              className: "font-extrabold font-abc text-[14px] text-black",
              children: "starface world’s most trusted dictionary",
            }),
          ],
        }),
        D.jsxs("div", {
          className:
            "w-full h-[calc(100dvh-140px)] 800:h-[calc(100vh-208px)] bg-pink rounded-[40px] mt-[5px] overflow-y-auto pb-10 relative",
          children: [
            D.jsx("div", {
              className:
                "absolute w-full h-full top-0 left-0 touch-pan-y z-10 800:hidden",
              onTouchStart: (o) => {
                const u = o.touches[0].clientX,
                  d = (p) => {
                    const v = p.touches[0].clientX - u
                    Math.abs(v) > 50 &&
                      (v > 0
                        ? s == null || s.scrollTo(t !== 0 ? t - 1 : po.length - 1)
                        : s == null || s.scrollTo(t !== po.length - 1 ? t + 1 : 0),
                      document.removeEventListener("touchmove", d))
                  }
                document.addEventListener("touchmove", d),
                  document.addEventListener(
                    "touchend",
                    () => {
                      document.removeEventListener("touchmove", d)
                    },
                    { once: !0 },
                  )
              },
            }),
            D.jsx("button", {
              className: "no-bg-button 800:hidden absolute w-[50%] h-full top-0 left-0",
              onClick: () => {
                s == null || s.scrollTo(t !== 0 ? t - 1 : po.length - 1)
              },
            }),
            D.jsx("button", {
              className:
                "no-bg-button 800:hidden absolute w-[50%] h-full top-0 right-0",
              onClick: () => {
                s == null || s.scrollTo(t !== po.length - 1 ? t + 1 : 0)
              },
            }),
            D.jsx("div", {
              className:
                "w-full h-full overflow-hidden 800:h-[calc(100vh-282px)] 1200:h-full",
              children: D.jsx(bU, { activeCard: t, setActiveCard: i }),
            }),
            D.jsx("div", {
              className:
                "absolute top-0 right-[10%] 800:bottom-0 800:top-auto 800:left-[50%] 800:-translate-x-1/2 800:right-auto",
              children: D.jsxs("div", {
                className: "flex items-center gap-5 800:flex-row-reverse",
                children: [
                  D.jsx("div", {
                    children: D.jsx("p", {
                      className: `\r
                text-black font-abc w-[200px] text-right text-[14px] leading-[15px] \r
                800:text-[15px] font-bold 800:leading-[18px] relative top-[4px] \r
                800:-top-[10px] -rotate-[6deg] 800:text-left\r
                800:w-[260px]`,
                      children: D.jsx(
                        Rd.span,
                        {
                          initial: { scale: 0.8, opacity: 0, y: 10 },
                          animate: { scale: 1, opacity: 1, y: 0 },
                          transition: { duration: 0.3, ease: "easeOut" },
                          dangerouslySetInnerHTML: { __html: po[t].message },
                        },
                        po[t].message,
                      ),
                    }),
                  }),
                  D.jsx("img", {
                    src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/mobile-star.png?v=1740602141",
                    alt: "star",
                    className: "w-[70px] h-auto 800:hidden",
                  }),
                  D.jsx("img", {
                    src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/desktop-star.png?v=1740601632",
                    alt: "star",
                    className: "w-[90px] h-auto 800:block hidden",
                  }),
                ],
              }),
            }),
          ],
        }),
        D.jsxs("div", {
          className:
            "w-full h-[50px] 800:h-[100px] text-black bg-pink rounded-[40px] mt-[5px] flex items-center justify-center",
          children: [
            D.jsx("div", {
              className:
                "hidden 800:flex flex-wrap gap-2 justify-center items-center w-full text-center 800:max-w-[900px]",
              children: po.map((o, l) =>
                D.jsx(
                  "button",
                  {
                    onClick: () => i(l),
                    className: Xn("w-[18%]", { underline: t === l }),
                    children: D.jsx("span", {
                      className: "font-extrabold font-abc 800:text-[20px]",
                      children: o.title,
                    }),
                  },
                  o.id,
                ),
              ),
            }),
            D.jsx("div", {
              className: "w-full h-full 800:hidden",
              children: D.jsx("div", {
                ref: r,
                className: "embla__viewport",
                children: D.jsx("div", {
                  className: "embla__container ",
                  children: po.map((o, l) =>
                    D.jsx(
                      "div",
                      {
                        className: "embla__slide ingredients-slide",
                        children: D.jsx("div", {
                          className:
                            "w-full h-[50px] inline-flex items-center justify-center",
                          children: D.jsx(
                            "button",
                            {
                              onClick: () => {
                                s == null || s.scrollTo(l)
                              },
                              className: Xn("", { underline: t === l }),
                              children: D.jsx("span", {
                                className: "font-extrabold font-abc",
                                children: o.title,
                              }),
                            },
                            o.id,
                          ),
                        }),
                      },
                      o.id,
                    ),
                  ),
                }),
              }),
            }),
          ],
        }),
      ],
    })
  )
}
const bU = ({ activeCard: n, setActiveCard: e }) => {
    const [t, i] = Y.useState(1),
      r = Y.useRef(null)
    return D.jsx("div", {
      className: "w-full h-full px-4 flex justify-center items-center",
      children: D.jsx("div", {
        className:
          "flex justify-center items-center gap-4 mt-16 800:mt-4 h-[340px] perspective-[140px] 800:perspective-[320px]",
        ref: r,
        children: po.map((s, o) =>
          D.jsx(
            "div",
            {
              className: `
                border-black text-black
                pointer-events-none 800:pointer-events-auto
                user-select-none 800:user-select-auto
                transition-color duration-300 cursor-pointer bg-white
                absolute
                ${
                  o === n
                    ? "z-[30] border-2 w-[320px] 800:w-[420px] 1000:w-[500px] h-auto "
                    : " text-[15px] border-1 w-[300px] 800:w-[390px] h-auto overflow-visible"
                }
              `,
              style: {
                transform: `
               
                  ${
                    o === n
                      ? "translateX(0px)"
                      : window.innerWidth > 800
                      ? `translateX(calc(${(o > n ? 120 : -120) + (o - n) * 60}px))`
                      : `translateX(calc(${(o > n ? 40 : -40) + (o - n) * 60}px))`
                  }
                  rotateY(${o === n ? 0 : o > n ? -35 : 35}deg)
                  scale(${o === n ? 1 : window.innerWidth > 800 ? 0.7 : 0.6})
                `,
                zIndex: `${o === n ? 30 : o <= n ? 1 : 15 - o}`,
                boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
              },
              onClick: () => e(o),
              children: D.jsxs("div", {
                className: "flex h-full",
                children: [
                  D.jsx("div", {
                    className: "w-[50px]  bg-yellow relative border-r 800:w-[80px]",
                    children: D.jsx("span", {
                      className:
                        "vertical-rl whitespace-nowrap font-extrabold font-abc -rotate-90 absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 800:text-[32px] 800:leading-[18px] 1200:text-[40px] 1200:leading-[40px]",
                      children: s.title,
                    }),
                  }),
                  D.jsxs("div", {
                    className: "w-full h-full flex flex-col",
                    children: [
                      D.jsx("div", {
                        className: "border-b border-black",
                        children: D.jsxs("p", {
                          className:
                            "text-black font-gt text-left px-6 py-4 underline leading-[15px] 800:text-[17px]",
                          children: [s.pronounce, "    noun"],
                        }),
                      }),
                      D.jsx("p", {
                        className:
                          "text-black min-h-[180px] 800:min-h-[220px] inline-flex items-center text-left p-6 font-gt text-[14px] leading-[15px] 1200:text-[18px] 1200:leading-[20px] 1200:min-h-[300px] 1200:py-0",
                        children: s.description,
                      }),
                      D.jsx("div", {
                        className:
                          "border-t border-black  font-abc text-[14px] leading-[15px] p-6 800:text-[18px] 800:leading-[20px]",
                        children: s.quote(),
                      }),
                    ],
                  }),
                  D.jsx("div", {
                    className: Xn("w-[50px] bg-yellow relative border-l 800:w-[80px]", {
                      hidden: n >= o,
                    }),
                    children: D.jsx("span", {
                      className:
                        "vertical-rl whitespace-nowrap font-extrabold font-abc -rotate-90 absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2 800:text-[32px]",
                      children: s.title,
                    }),
                  }),
                ],
              }),
            },
            s.id,
          ),
        ),
      }),
    })
  },
  qE = {
    hidden: { opacity: 0, scale: 0 },
    visible: { opacity: 1, scale: 1, transition: { delay: 0.5, delayChildren: 1.5 } },
  }
function AU({ setIsOpen: n }) {
  const [e, t] = Y.useState([{ step: 0, answer: null }]),
    [i, r] = Y.useState([]),
    [s, o] = Y.useState([Px[0]]),
    [l, u] = Y.useState(!1),
    [d, p] = Y.useState(null),
    m = Y.useRef(null),
    v = Y.useRef(null)
  return (
    Y.useEffect(() => {
      m.current &&
        setTimeout(() => {
          window.innerWidth > 800
            ? m.current.scrollTo({ left: m.current.scrollWidth, behavior: "smooth" })
            : v.current.scrollTo({ top: v.current.scrollHeight, behavior: "smooth" })
        }, 100)
    }, [s, l]),
    D.jsxs("div", {
      className: "w-full h-full",
      children: [
        D.jsxs("div", {
          className:
            "p-4 text-center h-[46px] 800:h-[86px] rounded-[40px] relative bg-green",
          children: [
            D.jsx(hm, {
              onClick: () => {
                n(!1)
              },
            }),
            D.jsx("h2", {
              className:
                "text-[20px] leading-[20px] 800:text-[34px] 800:leading-[48px] font-abc text-black font-extrabold relative -top-[1px] 800:top-[5px]",
              children: "which star are u?",
            }),
          ],
        }),
        D.jsx("div", {
          ref: v,
          className:
            " h-[calc(100dvh-70px)] 800:h-[calc(100vh-102px)] mt-[5px] overflow-scroll ",
          children: D.jsx("div", {
            ref: m,
            className: Xn(
              "w-full pt-6 800:h-full bg-green overflow-x-auto  rounded-[40px] flex items-center",
              { "800:justify-center": s.length < 2, "h-full": s.length === 1 },
            ),
            children: D.jsx("div", {
              className: " 800:h-full flex items-center p-3 800:px-20 pb-10",
              children: D.jsx("div", {
                className: "flex gap-2 items-start flex-col 800:flex-row",
                children:
                  s == null
                    ? void 0
                    : s.map((y, x) => {
                        var E, M, w, A, C, R, z, U, O, N, k
                        return D.jsxs(
                          "div",
                          {
                            className: Xn(
                              "800:flex gap-2 w-[calc(100vw-34px)] 800:w-auto",
                              {
                                "flex flex-col 800:flex-row  800:w-auto":
                                  y.answer && y.finalAnswer,
                              },
                            ),
                            children: [
                              (y.answer || y.image) &&
                                D.jsx("div", {
                                  onClick: () => {
                                    y.answer && y.finalAnswer && u(!0)
                                  },
                                  className: Xn(
                                    "min-h-[200px]  800:w-[400px] bg-white p-2 border border-black  relative flex items-end justify-center",
                                    {
                                      "w-full  800:max-h-full py-6 800:min-h-[408px]":
                                        y.answer && y.finalAnswer,
                                      "opacity-50": x !== s.length - 1,
                                    },
                                  ),
                                  children: D.jsxs("div", {
                                    className: "800:max-w-full pt-4",
                                    children: [
                                      D.jsx("div", {
                                        className:
                                          "w-full h-[100px] inline-flex items-end",
                                        children: D.jsx("h3", {
                                          className:
                                            "text-[15px] leading-[16px] p-6 800:p-0 800:pb-3 800:text-[22px] relative -top-[10%] font-extrabold font-abc mx-auto -rotate-[2deg] 800:-rotate-[6deg] text-black  800:max-w-[300px] 800:leading-[28px]",
                                          children:
                                            y != null && y._customTitle
                                              ? CU[y.finalAnswer]()
                                              : y == null
                                              ? void 0
                                              : y.title(),
                                        }),
                                      }),
                                      D.jsx("div", {
                                        className: Xn(
                                          "max-w-[200px] 800:max-w-full mx-auto",
                                          {
                                            "w-full  max-w-full flex items-center justify-center px-6":
                                              y.answer && y.finalAnswer,
                                          },
                                        ),
                                        children: y.image
                                          ? D.jsx("img", {
                                              src: y.image,
                                              alt: y.title,
                                              className:
                                                "w-full min-h-[130px] max-h-[80px] 800:max-h-full object-contain 800:max-w-[60%] mx-auto 800:mt-8",
                                            })
                                          : D.jsxs(D.Fragment, {
                                              children: [
                                                y.answer &&
                                                  y.finalAnswer &&
                                                  D.jsx("p", {
                                                    className:
                                                      "underline font-abc leading-[18px] font-extrabold text-black",
                                                    children:
                                                      "click here 2 meet ur star",
                                                  }),
                                                D.jsx("img", {
                                                  src:
                                                    (E = $E[y.answer]) == null
                                                      ? void 0
                                                      : E.image,
                                                  alt:
                                                    (M = $E[y.answer]) == null
                                                      ? void 0
                                                      : M.title,
                                                  className:
                                                    "w-full object-contain min-h-[160px] max-h-[120px] 800:max-h-full 800:max-w-[60%] mx-auto 800:mt-8 800:scale-[1.2] relative bottom-[16px]",
                                                }),
                                              ],
                                            }),
                                      }),
                                    ],
                                  }),
                                }),
                              !y.answer &&
                                y.finalAnswer &&
                                D.jsx("div", {
                                  className:
                                    "800:w-[700px] min-h-[408px] bg-yellow p-[15px] border border-black text-black relative flex items-center justify-center",
                                  children: D.jsxs("div", {
                                    className:
                                      "800:grid grid-cols-5 gap-2 items-center",
                                    children: [
                                      D.jsx("div", {
                                        className: "col-span-2",
                                        children: D.jsx("img", {
                                          src:
                                            (w = Yf[y.finalAnswer]) == null
                                              ? void 0
                                              : w.image,
                                          alt:
                                            (A = Yf[y.finalAnswer]) == null
                                              ? void 0
                                              : A.title,
                                          className:
                                            "w-full object-cover max-w-[50%] 800:max-w-[80%] mx-auto mt-8 mb-6",
                                        }),
                                      }),
                                      D.jsx("div", {
                                        className:
                                          "col-span-3 font-gt leading- 800:text-[22px] 800:leading-[27px]",
                                        children:
                                          (C = Yf[y.finalAnswer]) == null
                                            ? void 0
                                            : C.description(),
                                      }),
                                    ],
                                  }),
                                }),
                              y.answer &&
                                y.finalAnswer &&
                                l &&
                                D.jsx("div", {
                                  className:
                                    "w-full 800:w-[700px] min-h-[408px] bg-yellow p-[15px] border border-black text-black relative flex items-center justify-center",
                                  children: D.jsxs("div", {
                                    className:
                                      "800:grid grid-cols-5 gap-2 items-center",
                                    children: [
                                      D.jsx("div", {
                                        className: "col-span-2",
                                        children: D.jsx("img", {
                                          src:
                                            (R = Yf[y.finalAnswer]) == null
                                              ? void 0
                                              : R.image,
                                          alt:
                                            (z = Yf[y.finalAnswer]) == null
                                              ? void 0
                                              : z.title,
                                          className:
                                            "w-full object-cover max-w-[50%] 800:max-w-[80%] mx-auto mt-8 mb-6",
                                        }),
                                      }),
                                      D.jsx("div", {
                                        className:
                                          "col-span-3 font-gt leading-[19px] 800:text-[22px] 800:leading-[27px]",
                                        children:
                                          (U = Yf[y.finalAnswer]) == null
                                            ? void 0
                                            : U.description(),
                                      }),
                                    ],
                                  }),
                                }),
                              y.options &&
                                D.jsx(lC, {
                                  children: D.jsx(Rd.div, {
                                    duration: { delayChildren: 0.5 },
                                    className: Xn(
                                      "grid mt-3 800:mt-0 grid-cols-2 800:w-auto  800:min-w-[400px]  gap-2",
                                      {
                                        "800:grid-cols-3 800:min-w-[600px]":
                                          ((O = y.options) == null
                                            ? void 0
                                            : O.length) > 4,
                                        "800:grid-cols-2 ":
                                          ((N = y.options) == null
                                            ? void 0
                                            : N.length) <= 4,
                                        "opacity-50": x !== s.length - 1,
                                      },
                                    ),
                                    children:
                                      (k = y.options) == null
                                        ? void 0
                                        : k.map((I) => {
                                            var V
                                            return D.jsxs(
                                              Rd.button,
                                              {
                                                initial: qE.hidden,
                                                transition: { duration: 0.2 },
                                                animate: qE.visible,
                                                onClick: () => {
                                                  const Z = Px.find(
                                                      (ee) =>
                                                        ee.id ===
                                                        (y == null
                                                          ? void 0
                                                          : y.nextStep),
                                                    ),
                                                    $ = s.findIndex(
                                                      (ee) =>
                                                        ee.id ===
                                                        (Z == null ? void 0 : Z.id),
                                                    )
                                                  if ($ >= 0) {
                                                    const ee = [...s]
                                                    ;(ee[$] = {
                                                      ...Z,
                                                      answer: I.answer,
                                                    }),
                                                      o(ee)
                                                  } else if (Z)
                                                    o([
                                                      ...s,
                                                      { ...Z, answer: I.answer },
                                                    ])
                                                  else {
                                                    const ee = Px.find(
                                                        (re) => re.id === I.nextStep,
                                                      ),
                                                      ue = s.findIndex(
                                                        (re) =>
                                                          re.id ===
                                                          (ee == null ? void 0 : ee.id),
                                                      )
                                                    if (I != null && I.clear) {
                                                      const re = s.filter(
                                                        (se) =>
                                                          se.id !== 3 && se.id !== 4,
                                                      )
                                                      o([
                                                        ...re,
                                                        {
                                                          ...ee,
                                                          answer: I.answer,
                                                          finalAnswer: I.finalAnswer,
                                                        },
                                                      ])
                                                      return
                                                    }
                                                    if (
                                                      ue >= 0 &&
                                                      !(I != null && I.clear)
                                                    ) {
                                                      const re = [...s]
                                                      ;(re[ue] = {
                                                        ...ee,
                                                        answer: I.answer,
                                                        finalAnswer: I.finalAnswer,
                                                        replaceMe: !0,
                                                      }),
                                                        o(re)
                                                    } else if (I != null && I.clear) {
                                                      const re = s.filter(
                                                        (se) =>
                                                          se.id === 3 && se.id === 4,
                                                      )
                                                      o([
                                                        ...re,
                                                        {
                                                          ...ee,
                                                          answer: I.answer,
                                                          finalAnswer: I.finalAnswer,
                                                        },
                                                      ])
                                                    } else
                                                      o([
                                                        ...s,
                                                        {
                                                          ...ee,
                                                          answer: I.answer,
                                                          finalAnswer: I.finalAnswer,
                                                        },
                                                      ])
                                                  }
                                                },
                                                className: Xn(
                                                  "w-full 800:w-[200px] 800:h-[200px] 800:hover:bg-yellow bg-white text-black border border-black p-2 text-left flex items-center flex-col justify-between",
                                                  {
                                                    "bg-yellow":
                                                      I.answer ===
                                                      ((V = s[s.length - 1]) == null
                                                        ? void 0
                                                        : V.answer),
                                                  },
                                                ),
                                                children: [
                                                  D.jsx("div", {
                                                    className:
                                                      "w-[100px] 800:w-full mb-4 800:mb-0",
                                                    children: D.jsx("div", {
                                                      className:
                                                        "h-[66px] 800:h-auto w-[100px] 800:w-[80%] mx-auto",
                                                      children: D.jsx("img", {
                                                        src: `${
                                                          I == null ? void 0 : I.image
                                                        }`,
                                                        alt: I.title,
                                                        className:
                                                          "w-full h-full max-h-[160px] object-contain",
                                                      }),
                                                    }),
                                                  }),
                                                  D.jsx("h3", {
                                                    className:
                                                      "text-[14px] text-center 800:text-left 800:w-full font-extrabold font-abc leading-[18px] pb-2",
                                                    children: I.title,
                                                  }),
                                                ],
                                              },
                                              I.title,
                                            )
                                          }),
                                  }),
                                }),
                            ],
                          },
                          y.title,
                        )
                      }),
              }),
            }),
          }),
        }),
      ],
    })
  )
}
const Yf = {
    "party-pack": {
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-1.png?v=1740600409",
      description: () =>
        D.jsxs("div", {
          children: [
            D.jsxs("p", {
              className: "my-3",
              children: [
                "the results r in...",
                D.jsx("br", {}),
                D.jsx("a", {
                  href: "/products/hydro-stars-party-pack",
                  target: "_blank",
                  className: "font-abc underline font-black",
                  children: "party pack !! ",
                }),
              ],
            }),
            D.jsx("p", {
              className: "my-3",
              children:
                "ur the kind of cutie who loves dancing, karaoke, and being the life of the party <3",
            }),
            D.jsx("p", {
              className: "my-3",
              children: "have fun w these favs for juicy spots!",
            }),
          ],
        }),
    },
    "black-star": {
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-2.png?v=1740600409",
      description: () =>
        D.jsxs("div", {
          children: [
            D.jsxs("p", {
              className: "my-3",
              children: [
                "the results r in...",
                D.jsx("br", {}),
                D.jsx("a", {
                  href: "/products/black-star",
                  target: "_blank",
                  className: "font-abc underline font-black",
                  children: "black star !! ",
                }),
              ],
            }),
            D.jsx("p", {
              className: "my-3",
              children:
                "ur the kind of cutie who loves chill days w friends, exploring in nice weather, and comfort food <3",
            }),
            D.jsx("p", {
              className: "my-3",
              children: "have fun w these favs for juicy spots!",
            }),
          ],
        }),
    },
    "yellow-star": {
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-3.png?v=1740600409",
      description: () =>
        D.jsxs("div", {
          children: [
            D.jsxs("p", {
              className: "my-3",
              children: [
                "the results r in...",
                D.jsx("br", {}),
                D.jsx("a", {
                  href: "/products/hydro-stars-refill",
                  target: "_blank",
                  className: "font-abc underline font-black",
                  children: "classic hydro-star !! ",
                }),
              ],
            }),
            D.jsx("p", {
              className: "my-3",
              children:
                "ur the kind of cutie who loves 1x1 time w friends, seeing the whole world, and picking up treats on the way  <3",
            }),
            D.jsx("p", {
              className: "my-3",
              children: "have fun w these favs for juicy spots!",
            }),
          ],
        }),
    },
    "clear-star": {
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-4.png?v=1740600409",
      description: () =>
        D.jsxs("div", {
          children: [
            D.jsxs("p", {
              className: "my-3",
              children: [
                "the results r in...",
                D.jsx("br", {}),
                D.jsx("a", {
                  href: "/products/hydro-star®-clear",
                  target: "_blank",
                  className: "font-abc underline font-black",
                  children: "clear star !! ",
                }),
              ],
            }),
            D.jsx("p", {
              className: "my-3",
              children:
                "ur the kind of cutie who loves flying under the radar, relaxing at home, and wearing something xtra cozy <3",
            }),
            D.jsx("p", {
              className: "my-3",
              children: "have fun w these favs for juicy spots!",
            }),
          ],
        }),
    },
    "blue-star": {
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-5.png?v=1740600409",
      description: () =>
        D.jsxs("div", {
          children: [
            D.jsxs("p", {
              className: "my-3",
              children: [
                "the results r in...",
                D.jsx("br", {}),
                D.jsx("a", {
                  href: "/products/salicylic-acid-hydro-stars",
                  target: "_blank",
                  className: "font-abc underline font-black",
                  children: "hydro-star + salicylic acid !! ",
                }),
              ],
            }),
            D.jsx("p", {
              className: "my-3",
              children:
                "ur the kind of cutie who loves getting to the bottom of things, sorting ur room, and splashing in the pool  <3",
            }),
            D.jsx("p", {
              className: "my-3",
              children: "have fun w these favs for clogged pores!",
            }),
          ],
        }),
    },
    "green-star": {
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-6.png?v=1740600409",
      description: () =>
        D.jsxs("div", {
          children: [
            D.jsxs("p", {
              className: "my-3",
              children: [
                "the results r in...",
                D.jsx("br", {}),
                D.jsx("a", {
                  href: "/products/tea-tree-hydro-stars",
                  target: "_blank",
                  className: "font-abc underline font-black",
                  children: "hydro-star + tea tree !! ",
                }),
              ],
            }),
            D.jsx("p", {
              className: "my-3",
              children:
                "ur the kind of cutie who loves star gazing, telling ghost stories, and costume parties <3",
            }),
            D.jsx("p", {
              className: "my-3",
              children: "have fun w these favs for reducing oil!",
            }),
          ],
        }),
    },
    "purple-star": {
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-7.png?v=1740600409",
      description: () =>
        D.jsxs("div", {
          children: [
            D.jsxs("p", {
              className: "my-3",
              children: [
                "the results r in...",
                D.jsx("br", {}),
                D.jsx("a", {
                  href: "/products/hydro-star-recovery",
                  target: "_blank",
                  className: "font-abc underline font-black",
                  children: "hydro-star recovery !! ",
                }),
              ],
            }),
            D.jsx("p", {
              className: "my-3",
              children:
                "ur the kind of cutie who loves collaging, giving hugs, and hosting dinner parties <3",
            }),
            D.jsx("p", {
              className: "my-3",
              children: "have fun w these favs for healing skin!",
            }),
          ],
        }),
    },
  },
  $E = {
    stepOneAnswer1: {
      title: "listening to playlists on the park swings",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer_1_a.png?v=1741132588",
    },
    stepOneAnswer2: {
      title: "taking polaroids out the movie theater",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer_1_b.png?v=1741132588",
    },
    stepOneAnswer3: {
      title: "watching beach sunsets from the boardwalk",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer_1_c.png?v=1741132588",
    },
    stepOneAnswer4: {
      title: "making friendship bracelets at a sleepover",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer_1_d.png?v=1741132588",
    },
    stepTwoAnswer1: {
      title: "anything matching w my bff",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer_2_a.png?v=1741115237",
    },
    stepTwoAnswer2: {
      title: "sweatpants or pjs",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer_2_b.png?v=1741115237",
    },
    stepTwoAnswer3: {
      title: "something special i never use",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer_2_c.png?v=1741115237",
    },
    stepTwoAnswer4: {
      title: "just my usual cutest favs",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer_2_d.png?v=1741115237",
    },
    stepThreeAnswer1: {
      title: "ready to pop!",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/BY-myspotis_1.png?v=1741132588",
    },
    stepThreeAnswer2: {
      title: "clogged!",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/BY-myspotis_3.png?v=1741132588",
    },
    stepThreeAnswer3: {
      title: "oily!",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/BY-myspotis_4.png?v=1741132588",
    },
    stepThreeAnswer4: {
      title: "irritated!",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/BY-myspotis_5.png?v=1741132588",
    },
    stepThreeAnswer5: {
      title: "it's complicated...",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-3-5.png?v=1740600409",
    },
    stepFourAnswer1: {
      title: "i like options :)",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/question_3_a.png?v=1741124394",
    },
    stepFourAnswer2: {
      title: "black",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-2.png?v=1740600409",
    },
    stepFourAnswer3: {
      title: "yellow",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-3.png?v=1740600409",
    },
    stepFourAnswer4: { title: "something lowkey tbh!", image: "/answer-4-4.png" },
    stepFiveAnswer1: {
      title: "party pack",
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/answer-4-5.png?v=1740600409",
    },
  },
  Px = [
    {
      id: 0,
      title: () =>
        D.jsx("div", {
          children: D.jsx("h3", { children: "what r u doing this weekend?" }),
        }),
      image:
        "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/question_1_a.png?v=1741132588",
      nextStep: 1,
      options: [
        {
          title: "listening to playlists at the park",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-1-1.png?v=1740602234",
          answer: "stepOneAnswer1",
        },
        {
          title: "taking polaroids outside the movie theater",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-1-2.png?v=1740602234",
          answer: "stepOneAnswer2",
        },
        {
          title: "watching beach sunsets from the boardwalk",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-1-3.png?v=1740602234",
          answer: "stepOneAnswer3",
        },
        {
          title: "making friendship bracelets at a sleepover",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-1-4.png?v=1740602234",
          answer: "stepOneAnswer4",
        },
      ],
    },
    {
      id: 1,
      title: () =>
        D.jsx("div", {
          children: D.jsx("h3", { children: "omg fun :) which outfit would u wear?" }),
        }),
      nextStep: 2,
      options: [
        {
          title: "anything matching w my bff",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-2-1.png?v=1740602234",
          answer: "stepTwoAnswer1",
        },
        {
          title: "sweatpants or pjs",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-2-2.png?v=1740602234",
          answer: "stepTwoAnswer2",
        },
        {
          title: "something special i never wear",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-2-3.png?v=1740602234",
          answer: "stepTwoAnswer3",
        },
        {
          title: "just my usual cutest favs",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-2-4.png?v=1740602234",
          answer: "stepTwoAnswer4",
        },
      ],
    },
    {
      id: 2,
      title: () =>
        D.jsx("div", {
          children: D.jsxs("p", {
            className: "mt-2 block ",
            children: [
              "ok complete this sentence:",
              D.jsx("br", {}),
              D.jsx("span", { className: "font-gt", children: '"my spot is so __"' }),
            ],
          }),
        }),
      options: [
        {
          title: "ready to pop",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-3-3.png?v=1740602234",
          nextStep: 3,
          clear: !0,
          answer: "stepThreeAnswer1",
        },
        {
          title: "clogged",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-3-2.png?v=1740602234",
          nextStep: 4,
          clear: !0,
          answer: "stepThreeAnswer2",
          finalAnswer: "blue-star",
        },
        {
          title: "oily",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-5-4.png?v=1740602234",
          nextStep: 4,
          clear: !0,
          answer: "stepThreeAnswer3",
          finalAnswer: "green-star",
        },
        {
          title: "irritated",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/irriated.png?v=1740777784",
          nextStep: 4,
          clear: !0,
          answer: "stepThreeAnswer4",
          finalAnswer: "purple-star",
        },
      ],
    },
    {
      id: 3,
      title: () =>
        D.jsxs("div", {
          children: [
            D.jsx("h3", { children: "last question..." }),
            D.jsx("span", { children: "what's ur fav color?" }),
          ],
        }),
      options: [
        {
          title: "i like options :)",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/question_3_a.png?v=1741124394",
          finalAnswer: "party-pack",
          nextStep: 4,
        },
        {
          title: "black",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-4-2.png?v=1740602234",
          finalAnswer: "black-star",
          nextStep: 4,
        },
        {
          title: "yellow",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-4-3.png?v=1740602234",
          finalAnswer: "yellow-star",
          nextStep: 4,
        },
        {
          title: "something lowkey tbh!",
          image:
            "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/quiz-step-4-4.png?v=1740602234",
          finalAnswer: "clear-star",
          nextStep: 4,
        },
      ],
    },
    {
      id: 4,
      _customTitle: !0,
      title: () =>
        D.jsx("div", {
          children: D.jsx("h3", {
            children:
              "omg seems like u have a spot that might need a lil xtra power :) ",
          }),
        }),
    },
  ],
  CU = {
    "blue-star": () =>
      D.jsx("span", {
        children: "omg seems like u have a spot that might need a lil xtra power :)",
      }),
    "green-star": () =>
      D.jsx("span", {
        children:
          "omg seems like u have a spot that might need some natural gunk removal :)",
      }),
    "purple-star": () =>
      D.jsx("span", {
        children:
          "omg seems like u have a spot that might need some love and soothing :)",
      }),
  }
function RU({
  setIsOpen: n,
  openProduct: e,
  setProduct: t,
  setNestedProduct: i,
  openQuiz: r,
  openHowTo: s,
  openIngredients: o,
  setIngredientIndex: l,
}) {
  return D.jsxs("div", {
    className: "w-full h-full",
    children: [
      D.jsxs("div", {
        className:
          "p-4 text-center h-[46px] 800:h-[86px] rounded-[40px] relative bg-yellow",
        children: [
          D.jsx(hm, {
            onClick: () => {
              n(!1)
            },
          }),
          D.jsx("h2", {
            className:
              "text-[20px] leading-[20px] 800:text-[34px] 800:leading-[52px] font-abc text-black font-bold",
            children: "index",
          }),
        ],
      }),
      D.jsx("div", {
        className: "w-full h-full overflow-y-auto mt-[5px] 800:h-[calc(100vh-12px)]",
        children: D.jsxs("div", {
          className:
            "800:grid grid-cols-2 gap-[5px] 1200:grid-cols-3 w-full h-auto  800:pb-22",
          children: [
            D.jsxs("div", {
              className: "col-span-1",
              children: [
                D.jsxs("div", {
                  className:
                    "w-full flex flex-col 800:flex-row gap-[5px] h-full 800:h-[300px]",
                  children: [
                    D.jsx("div", {
                      className:
                        "h-[60px] 800:hidden text-center 800:h-[80px] bg-yellow rounded-[40px] relative inline-flex items-center",
                      children: D.jsx("span", {
                        className:
                          " whitespace-nowrap pl-6 600:pl-10 font-black font-abc text-black text-[22px] 800:text-[34px]",
                        children: "hydro-stars",
                      }),
                    }),
                    D.jsx("div", {
                      className:
                        "h-[50px] hidden 800:block  800:w-[80px] 800:h-[300px] 1000:h-full bg-yellow rounded-[40px] relative",
                      children: D.jsx("span", {
                        className:
                          "800:vertical-rl whitespace-nowrap pl-6 600:pl-10 800:pl-0 font-black font-abc text-black text-[22px] leading-[44px] 800:text-[34px] 800:-rotate-90 800:absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2",
                        children: "hydro-stars",
                      }),
                    }),
                    D.jsx("div", {
                      className:
                        "bg-yellow rounded-[40px] p-4 pl-6 600:pl-10 flex items-center w-full",
                      children: D.jsxs("ul", {
                        children: [
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("hydrostars"), i(0)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "hydro-star pimple patches",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("hydrostars"), i(1)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "hydro-star + sal acid",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("hydrostars"), i(4)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "hydro-star + tea tree",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("hydrostars"), i(3)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "hydro-star recovery",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("hydrostars"), i(2)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "hydro-star clear",
                            }),
                          }),
                        ],
                      }),
                    }),
                  ],
                }),
                D.jsxs("div", {
                  className: "w-full flex flex-col mt-[5px] gap-[5px]",
                  children: [
                    D.jsx("div", {
                      className:
                        "h-[60px] text-center 800:h-[80px] bg-yellow rounded-[40px] relative inline-flex items-center",
                      children: D.jsx("span", {
                        className:
                          " whitespace-nowrap pl-6 600:pl-10 font-black font-abc text-black text-[22px] 800:text-[34px]",
                        children: "skincare",
                      }),
                    }),
                    D.jsx("div", {
                      className:
                        "bg-yellow index_skin rounded-[40px] p-4 flex items-center pl-6 600:pl-10 py-10 800:py-[43px]",
                      children: D.jsxs("ul", {
                        children: [
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("skincare"), i(0)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "star wash + salicylic acid",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("skincare"), i(1)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "star cream + salicylic acid",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("skincare"), i(2)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "lift off pore strips",
                            }),
                          }),
                        ],
                      }),
                    }),
                  ],
                }),
              ],
            }),
            D.jsxs("div", {
              className: "col-span-1 mt-[5px] 800:mt-0",
              children: [
                D.jsxs("div", {
                  className:
                    "w-full index_balm flex flex-col 800:flex-row gap-[5px] h-full 800:max-h-[366px]",
                  children: [
                    D.jsx("div", {
                      className:
                        "h-[60px] text-center 800:hidden bg-yellow rounded-[40px] relative inline-flex items-center",
                      children: D.jsx("span", {
                        className:
                          " whitespace-nowrap pl-6 600:pl-10 font-black font-abc text-black text-[22px] 800:text-[34px]",
                        children: "star balm",
                      }),
                    }),
                    D.jsx("div", {
                      className:
                        "h-[50px] 800:w-[80px] hidden 800:block 800:h-full bg-yellow rounded-[40px] relative",
                      children: D.jsx("span", {
                        className:
                          "800:vertical-rl whitespace-nowrap pl-6 600:pl-10 800:pl-0 font-black font-abc text-black text-[22px] leading-[44px] -rotate-90 800:absolute 800:text-[34px] top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2",
                        children: "star balm",
                      }),
                    }),
                    D.jsx("div", {
                      className:
                        "bg-yellow index_balms rounded-[40px] p-4 pl-6 600:pl-10 flex items-center w-full",
                      children: D.jsxs("ul", {
                        children: [
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("starbalm"), i(0)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "starfruit",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("starbalm"), i(2)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "very vanilla",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("starbalm"), i(6)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "magic mint",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("starbalm"), i(1)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "watermelon squeeze",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("starbalm"), i(3)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "mango mania",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("starbalm"), i(5)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "so strawberry",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), e(!0), t("starbalm"), i(4)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "coconut blast",
                            }),
                          }),
                        ],
                      }),
                    }),
                  ],
                }),
                D.jsxs("div", {
                  className: "w-full flex flex-col mt-[5px] gap-[5px]",
                  children: [
                    D.jsx("button", {
                      onClick: () => {
                        n(!1), s(!0)
                      },
                      className:
                        "h-[50px] 800:h-[100px] !bg-yellow rounded-[40px] relative inline-flex items-center",
                      children: D.jsx("span", {
                        className:
                          " whitespace-nowrap pl-6 600:pl-10 font-black font-abc text-black text-[22px] 800:text-[34px]",
                        children: "how it works",
                      }),
                    }),
                    D.jsx("button", {
                      onClick: () => {
                        n(!1), r(!0)
                      },
                      className:
                        "h-[50px] 800:h-[100px] !bg-yellow rounded-[40px] relative inline-flex items-center",
                      children: D.jsx("span", {
                        className:
                          " whitespace-nowrap pl-6 600:pl-10 font-black font-abc text-black text-[22px] 800:text-[34px]",
                        children: "quiz",
                      }),
                    }),
                  ],
                }),
              ],
            }),
            D.jsxs("div", {
              className:
                "col-span-2 gap-[5px] mt-[5px] 800:mt-0 pb-[50px] 800:pb-0 800:flex items-start 1200:block 1200:col-span-1",
              children: [
                D.jsxs("div", {
                  className: "w-full flex-col gap-[5px] ",
                  children: [
                    D.jsx("div", {
                      className:
                        "h-[50px] 800:h-[80px] inline-flex items-center w-full bg-yellow rounded-[40px] relative",
                      children: D.jsx("span", {
                        className:
                          "whitespace-nowrap pl-6 600:pl-10 font-black font-abc text-black text-[22px] 800:text-[34px]",
                        children: "star ingredients",
                      }),
                    }),
                    D.jsx("div", {
                      className:
                        "bg-yellow index_ingredients rounded-[40px] p-4 mt-[5px] flex items-center w-full pl-6 600:pl-10",
                      children: D.jsxs("ul", {
                        children: [
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), o(!0), l(0)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "aloe vera",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), o(!0), l(1)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "glycerin",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), o(!0), l(2)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "hyaluronic acid",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), o(!0), l(3)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "hydrocolloid",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), o(!0), l(4)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "niaciamide",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), o(!0), l(5)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "salicylic acid",
                            }),
                          }),
                          D.jsx("li", {
                            children: D.jsx("button", {
                              onClick: () => {
                                n(!1), o(!0), l(6)
                              },
                              className:
                                "text-[18px] no-bg-button 800:text-[22px] underline font-gt text-black ",
                              children: "tea tree oil",
                            }),
                          }),
                        ],
                      }),
                    }),
                  ],
                }),
                D.jsxs("div", {
                  className:
                    "w-full flex flex-col mt-[5px] 800:mt-0 1000:mt-[5px] gap-[5px]",
                  children: [
                    D.jsx("a", {
                      href: "https://starface.world/pages/privacy-policy",
                      target: "_blank",
                      className:
                        "h-[50px] 800:h-[155px] 1000:h-[150px] 1200:h-[125px] bg-yellow rounded-[40px] relative inline-flex items-center",
                      children: D.jsx("span", {
                        className:
                          " whitespace-nowrap pl-6 600:pl-10 font-black font-abc text-black text-[22px] 800:text-[34px]",
                        children: "privacy",
                      }),
                    }),
                    D.jsx("a", {
                      href: "https://starface.world/pages/terms-of-service",
                      target: "_blank",
                      className:
                        "h-[50px] 800:h-[155px] 1000:h-[150px] 1200:h-[125px] bg-yellow rounded-[40px] relative inline-flex items-center",
                      children: D.jsx("span", {
                        className:
                          " whitespace-nowrap pl-6 600:pl-10 font-black font-abc text-black text-[22px] 800:text-[34px]",
                        children: "terms",
                      }),
                    }),
                  ],
                }),
              ],
            }),
          ],
        }),
      }),
    ],
  })
}
/**
 * @license
 * Copyright 2010-2024 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const mm = "170",
  PU = { LEFT: 0, MIDDLE: 1, RIGHT: 2, ROTATE: 0, DOLLY: 1, PAN: 2 },
  IU = { ROTATE: 0, PAN: 1, DOLLY_PAN: 2, DOLLY_ROTATE: 3 },
  EC = 0,
  v1 = 1,
  TC = 2,
  LU = 3,
  bC = 0,
  jv = 1,
  Ep = 2,
  go = 3,
  $a = 0,
  Ir = 1,
  Vo = 2,
  ja = 0,
  Eu = 1,
  y1 = 2,
  x1 = 3,
  _1 = 4,
  AC = 5,
  $l = 100,
  CC = 101,
  RC = 102,
  PC = 103,
  IC = 104,
  LC = 200,
  DC = 201,
  NC = 202,
  kC = 203,
  H0 = 204,
  G0 = 205,
  FC = 206,
  UC = 207,
  OC = 208,
  BC = 209,
  zC = 210,
  VC = 211,
  HC = 212,
  GC = 213,
  WC = 214,
  W0 = 0,
  j0 = 1,
  X0 = 2,
  Iu = 3,
  Y0 = 4,
  q0 = 5,
  $0 = 6,
  K0 = 7,
  gm = 0,
  jC = 1,
  XC = 2,
  Xo = 0,
  YC = 1,
  qC = 2,
  $C = 3,
  Ew = 4,
  KC = 5,
  ZC = 6,
  JC = 7,
  w1 = "attached",
  QC = "detached",
  Xv = 300,
  Ka = 301,
  rc = 302,
  Pd = 303,
  Wp = 304,
  Hd = 306,
  Lu = 1e3,
  Jr = 1001,
  jp = 1002,
  Qi = 1003,
  Tw = 1004,
  DU = 1004,
  wd = 1005,
  NU = 1005,
  Ri = 1006,
  Tp = 1007,
  kU = 1007,
  Ho = 1008,
  FU = 1008,
  wo = 1009,
  bw = 1010,
  Aw = 1011,
  Id = 1012,
  Yv = 1013,
  Za = 1014,
  Qr = 1015,
  Gd = 1016,
  qv = 1017,
  $v = 1018,
  Du = 1020,
  Cw = 35902,
  Rw = 1021,
  Pw = 1022,
  hr = 1023,
  Iw = 1024,
  Lw = 1025,
  Tu = 1026,
  Nu = 1027,
  Kv = 1028,
  vm = 1029,
  Dw = 1030,
  Zv = 1031,
  UU = 1032,
  Jv = 1033,
  bp = 33776,
  Ap = 33777,
  Cp = 33778,
  Rp = 33779,
  Z0 = 35840,
  J0 = 35841,
  Q0 = 35842,
  ev = 35843,
  tv = 36196,
  nv = 37492,
  iv = 37496,
  rv = 37808,
  sv = 37809,
  ov = 37810,
  av = 37811,
  lv = 37812,
  cv = 37813,
  uv = 37814,
  fv = 37815,
  dv = 37816,
  hv = 37817,
  pv = 37818,
  mv = 37819,
  gv = 37820,
  vv = 37821,
  Pp = 36492,
  yv = 36494,
  xv = 36495,
  Nw = 36283,
  _v = 36284,
  wv = 36285,
  Sv = 36286,
  e3 = 2200,
  t3 = 2201,
  n3 = 2202,
  Xp = 2300,
  Mv = 2301,
  C0 = 2302,
  yu = 2400,
  xu = 2401,
  Yp = 2402,
  Qv = 2500,
  kw = 2501,
  OU = 0,
  BU = 1,
  zU = 2,
  i3 = 3200,
  r3 = 3201,
  VU = 3202,
  HU = 3203,
  ac = 0,
  s3 = 1,
  za = "",
  Kr = "srgb",
  Bu = "srgb-linear",
  ym = "linear",
  Sn = "srgb",
  GU = 0,
  fu = 7680,
  WU = 7681,
  jU = 7682,
  XU = 7683,
  YU = 34055,
  qU = 34056,
  $U = 5386,
  KU = 512,
  ZU = 513,
  JU = 514,
  QU = 515,
  eO = 516,
  tO = 517,
  nO = 518,
  S1 = 519,
  o3 = 512,
  a3 = 513,
  l3 = 514,
  Fw = 515,
  c3 = 516,
  u3 = 517,
  f3 = 518,
  d3 = 519,
  qp = 35044,
  iO = 35048,
  rO = 35040,
  sO = 35045,
  oO = 35049,
  aO = 35041,
  lO = 35046,
  cO = 35050,
  uO = 35042,
  fO = "100",
  M1 = "300 es",
  Go = 2e3,
  $p = 2001
class Jo {
  addEventListener(e, t) {
    this._listeners === void 0 && (this._listeners = {})
    const i = this._listeners
    i[e] === void 0 && (i[e] = []), i[e].indexOf(t) === -1 && i[e].push(t)
  }
  hasEventListener(e, t) {
    if (this._listeners === void 0) return !1
    const i = this._listeners
    return i[e] !== void 0 && i[e].indexOf(t) !== -1
  }
  removeEventListener(e, t) {
    if (this._listeners === void 0) return
    const r = this._listeners[e]
    if (r !== void 0) {
      const s = r.indexOf(t)
      s !== -1 && r.splice(s, 1)
    }
  }
  dispatchEvent(e) {
    if (this._listeners === void 0) return
    const i = this._listeners[e.type]
    if (i !== void 0) {
      e.target = this
      const r = i.slice(0)
      for (let s = 0, o = r.length; s < o; s++) r[s].call(this, e)
      e.target = null
    }
  }
}
const cr = [
  "00",
  "01",
  "02",
  "03",
  "04",
  "05",
  "06",
  "07",
  "08",
  "09",
  "0a",
  "0b",
  "0c",
  "0d",
  "0e",
  "0f",
  "10",
  "11",
  "12",
  "13",
  "14",
  "15",
  "16",
  "17",
  "18",
  "19",
  "1a",
  "1b",
  "1c",
  "1d",
  "1e",
  "1f",
  "20",
  "21",
  "22",
  "23",
  "24",
  "25",
  "26",
  "27",
  "28",
  "29",
  "2a",
  "2b",
  "2c",
  "2d",
  "2e",
  "2f",
  "30",
  "31",
  "32",
  "33",
  "34",
  "35",
  "36",
  "37",
  "38",
  "39",
  "3a",
  "3b",
  "3c",
  "3d",
  "3e",
  "3f",
  "40",
  "41",
  "42",
  "43",
  "44",
  "45",
  "46",
  "47",
  "48",
  "49",
  "4a",
  "4b",
  "4c",
  "4d",
  "4e",
  "4f",
  "50",
  "51",
  "52",
  "53",
  "54",
  "55",
  "56",
  "57",
  "58",
  "59",
  "5a",
  "5b",
  "5c",
  "5d",
  "5e",
  "5f",
  "60",
  "61",
  "62",
  "63",
  "64",
  "65",
  "66",
  "67",
  "68",
  "69",
  "6a",
  "6b",
  "6c",
  "6d",
  "6e",
  "6f",
  "70",
  "71",
  "72",
  "73",
  "74",
  "75",
  "76",
  "77",
  "78",
  "79",
  "7a",
  "7b",
  "7c",
  "7d",
  "7e",
  "7f",
  "80",
  "81",
  "82",
  "83",
  "84",
  "85",
  "86",
  "87",
  "88",
  "89",
  "8a",
  "8b",
  "8c",
  "8d",
  "8e",
  "8f",
  "90",
  "91",
  "92",
  "93",
  "94",
  "95",
  "96",
  "97",
  "98",
  "99",
  "9a",
  "9b",
  "9c",
  "9d",
  "9e",
  "9f",
  "a0",
  "a1",
  "a2",
  "a3",
  "a4",
  "a5",
  "a6",
  "a7",
  "a8",
  "a9",
  "aa",
  "ab",
  "ac",
  "ad",
  "ae",
  "af",
  "b0",
  "b1",
  "b2",
  "b3",
  "b4",
  "b5",
  "b6",
  "b7",
  "b8",
  "b9",
  "ba",
  "bb",
  "bc",
  "bd",
  "be",
  "bf",
  "c0",
  "c1",
  "c2",
  "c3",
  "c4",
  "c5",
  "c6",
  "c7",
  "c8",
  "c9",
  "ca",
  "cb",
  "cc",
  "cd",
  "ce",
  "cf",
  "d0",
  "d1",
  "d2",
  "d3",
  "d4",
  "d5",
  "d6",
  "d7",
  "d8",
  "d9",
  "da",
  "db",
  "dc",
  "dd",
  "de",
  "df",
  "e0",
  "e1",
  "e2",
  "e3",
  "e4",
  "e5",
  "e6",
  "e7",
  "e8",
  "e9",
  "ea",
  "eb",
  "ec",
  "ed",
  "ee",
  "ef",
  "f0",
  "f1",
  "f2",
  "f3",
  "f4",
  "f5",
  "f6",
  "f7",
  "f8",
  "f9",
  "fa",
  "fb",
  "fc",
  "fd",
  "fe",
  "ff",
]
let KE = 1234567
const bu = Math.PI / 180,
  Ld = 180 / Math.PI
function vs() {
  const n = (Math.random() * 4294967295) | 0,
    e = (Math.random() * 4294967295) | 0,
    t = (Math.random() * 4294967295) | 0,
    i = (Math.random() * 4294967295) | 0
  return (
    cr[n & 255] +
    cr[(n >> 8) & 255] +
    cr[(n >> 16) & 255] +
    cr[(n >> 24) & 255] +
    "-" +
    cr[e & 255] +
    cr[(e >> 8) & 255] +
    "-" +
    cr[((e >> 16) & 15) | 64] +
    cr[(e >> 24) & 255] +
    "-" +
    cr[(t & 63) | 128] +
    cr[(t >> 8) & 255] +
    "-" +
    cr[(t >> 16) & 255] +
    cr[(t >> 24) & 255] +
    cr[i & 255] +
    cr[(i >> 8) & 255] +
    cr[(i >> 16) & 255] +
    cr[(i >> 24) & 255]
  ).toLowerCase()
}
function ri(n, e, t) {
  return Math.max(e, Math.min(t, n))
}
function Uw(n, e) {
  return ((n % e) + e) % e
}
function dO(n, e, t, i, r) {
  return i + ((n - e) * (r - i)) / (t - e)
}
function hO(n, e, t) {
  return n !== e ? (t - n) / (e - n) : 0
}
function Ip(n, e, t) {
  return (1 - t) * n + t * e
}
function pO(n, e, t, i) {
  return Ip(n, e, 1 - Math.exp(-t * i))
}
function mO(n, e = 1) {
  return e - Math.abs(Uw(n, e * 2) - e)
}
function gO(n, e, t) {
  return n <= e ? 0 : n >= t ? 1 : ((n = (n - e) / (t - e)), n * n * (3 - 2 * n))
}
function vO(n, e, t) {
  return n <= e
    ? 0
    : n >= t
    ? 1
    : ((n = (n - e) / (t - e)), n * n * n * (n * (n * 6 - 15) + 10))
}
function yO(n, e) {
  return n + Math.floor(Math.random() * (e - n + 1))
}
function xO(n, e) {
  return n + Math.random() * (e - n)
}
function _O(n) {
  return n * (0.5 - Math.random())
}
function wO(n) {
  n !== void 0 && (KE = n)
  let e = (KE += 1831565813)
  return (
    (e = Math.imul(e ^ (e >>> 15), e | 1)),
    (e ^= e + Math.imul(e ^ (e >>> 7), e | 61)),
    ((e ^ (e >>> 14)) >>> 0) / 4294967296
  )
}
function SO(n) {
  return n * bu
}
function MO(n) {
  return n * Ld
}
function EO(n) {
  return (n & (n - 1)) === 0 && n !== 0
}
function TO(n) {
  return Math.pow(2, Math.ceil(Math.log(n) / Math.LN2))
}
function bO(n) {
  return Math.pow(2, Math.floor(Math.log(n) / Math.LN2))
}
function AO(n, e, t, i, r) {
  const s = Math.cos,
    o = Math.sin,
    l = s(t / 2),
    u = o(t / 2),
    d = s((e + i) / 2),
    p = o((e + i) / 2),
    m = s((e - i) / 2),
    v = o((e - i) / 2),
    y = s((i - e) / 2),
    x = o((i - e) / 2)
  switch (r) {
    case "XYX":
      n.set(l * p, u * m, u * v, l * d)
      break
    case "YZY":
      n.set(u * v, l * p, u * m, l * d)
      break
    case "ZXZ":
      n.set(u * m, u * v, l * p, l * d)
      break
    case "XZX":
      n.set(l * p, u * x, u * y, l * d)
      break
    case "YXY":
      n.set(u * y, l * p, u * x, l * d)
      break
    case "ZYZ":
      n.set(u * x, u * y, l * p, l * d)
      break
    default:
      console.warn(
        "THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " +
          r,
      )
  }
}
function Cr(n, e) {
  switch (e.constructor) {
    case Float32Array:
      return n
    case Uint32Array:
      return n / 4294967295
    case Uint16Array:
      return n / 65535
    case Uint8Array:
      return n / 255
    case Int32Array:
      return Math.max(n / 2147483647, -1)
    case Int16Array:
      return Math.max(n / 32767, -1)
    case Int8Array:
      return Math.max(n / 127, -1)
    default:
      throw new Error("Invalid component type.")
  }
}
function Zt(n, e) {
  switch (e.constructor) {
    case Float32Array:
      return n
    case Uint32Array:
      return Math.round(n * 4294967295)
    case Uint16Array:
      return Math.round(n * 65535)
    case Uint8Array:
      return Math.round(n * 255)
    case Int32Array:
      return Math.round(n * 2147483647)
    case Int16Array:
      return Math.round(n * 32767)
    case Int8Array:
      return Math.round(n * 127)
    default:
      throw new Error("Invalid component type.")
  }
}
const yo = {
  DEG2RAD: bu,
  RAD2DEG: Ld,
  generateUUID: vs,
  clamp: ri,
  euclideanModulo: Uw,
  mapLinear: dO,
  inverseLerp: hO,
  lerp: Ip,
  damp: pO,
  pingpong: mO,
  smoothstep: gO,
  smootherstep: vO,
  randInt: yO,
  randFloat: xO,
  randFloatSpread: _O,
  seededRandom: wO,
  degToRad: SO,
  radToDeg: MO,
  isPowerOfTwo: EO,
  ceilPowerOfTwo: TO,
  floorPowerOfTwo: bO,
  setQuaternionFromProperEuler: AO,
  normalize: Zt,
  denormalize: Cr,
}
class We {
  constructor(e = 0, t = 0) {
    ;(We.prototype.isVector2 = !0), (this.x = e), (this.y = t)
  }
  get width() {
    return this.x
  }
  set width(e) {
    this.x = e
  }
  get height() {
    return this.y
  }
  set height(e) {
    this.y = e
  }
  set(e, t) {
    return (this.x = e), (this.y = t), this
  }
  setScalar(e) {
    return (this.x = e), (this.y = e), this
  }
  setX(e) {
    return (this.x = e), this
  }
  setY(e) {
    return (this.y = e), this
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t
        break
      case 1:
        this.y = t
        break
      default:
        throw new Error("index is out of range: " + e)
    }
    return this
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x
      case 1:
        return this.y
      default:
        throw new Error("index is out of range: " + e)
    }
  }
  clone() {
    return new this.constructor(this.x, this.y)
  }
  copy(e) {
    return (this.x = e.x), (this.y = e.y), this
  }
  add(e) {
    return (this.x += e.x), (this.y += e.y), this
  }
  addScalar(e) {
    return (this.x += e), (this.y += e), this
  }
  addVectors(e, t) {
    return (this.x = e.x + t.x), (this.y = e.y + t.y), this
  }
  addScaledVector(e, t) {
    return (this.x += e.x * t), (this.y += e.y * t), this
  }
  sub(e) {
    return (this.x -= e.x), (this.y -= e.y), this
  }
  subScalar(e) {
    return (this.x -= e), (this.y -= e), this
  }
  subVectors(e, t) {
    return (this.x = e.x - t.x), (this.y = e.y - t.y), this
  }
  multiply(e) {
    return (this.x *= e.x), (this.y *= e.y), this
  }
  multiplyScalar(e) {
    return (this.x *= e), (this.y *= e), this
  }
  divide(e) {
    return (this.x /= e.x), (this.y /= e.y), this
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e)
  }
  applyMatrix3(e) {
    const t = this.x,
      i = this.y,
      r = e.elements
    return (
      (this.x = r[0] * t + r[3] * i + r[6]), (this.y = r[1] * t + r[4] * i + r[7]), this
    )
  }
  min(e) {
    return (this.x = Math.min(this.x, e.x)), (this.y = Math.min(this.y, e.y)), this
  }
  max(e) {
    return (this.x = Math.max(this.x, e.x)), (this.y = Math.max(this.y, e.y)), this
  }
  clamp(e, t) {
    return (
      (this.x = Math.max(e.x, Math.min(t.x, this.x))),
      (this.y = Math.max(e.y, Math.min(t.y, this.y))),
      this
    )
  }
  clampScalar(e, t) {
    return (
      (this.x = Math.max(e, Math.min(t, this.x))),
      (this.y = Math.max(e, Math.min(t, this.y))),
      this
    )
  }
  clampLength(e, t) {
    const i = this.length()
    return this.divideScalar(i || 1).multiplyScalar(Math.max(e, Math.min(t, i)))
  }
  floor() {
    return (this.x = Math.floor(this.x)), (this.y = Math.floor(this.y)), this
  }
  ceil() {
    return (this.x = Math.ceil(this.x)), (this.y = Math.ceil(this.y)), this
  }
  round() {
    return (this.x = Math.round(this.x)), (this.y = Math.round(this.y)), this
  }
  roundToZero() {
    return (this.x = Math.trunc(this.x)), (this.y = Math.trunc(this.y)), this
  }
  negate() {
    return (this.x = -this.x), (this.y = -this.y), this
  }
  dot(e) {
    return this.x * e.x + this.y * e.y
  }
  cross(e) {
    return this.x * e.y - this.y * e.x
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y)
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y)
  }
  normalize() {
    return this.divideScalar(this.length() || 1)
  }
  angle() {
    return Math.atan2(-this.y, -this.x) + Math.PI
  }
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq())
    if (t === 0) return Math.PI / 2
    const i = this.dot(e) / t
    return Math.acos(ri(i, -1, 1))
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e))
  }
  distanceToSquared(e) {
    const t = this.x - e.x,
      i = this.y - e.y
    return t * t + i * i
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y)
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e)
  }
  lerp(e, t) {
    return (this.x += (e.x - this.x) * t), (this.y += (e.y - this.y) * t), this
  }
  lerpVectors(e, t, i) {
    return (this.x = e.x + (t.x - e.x) * i), (this.y = e.y + (t.y - e.y) * i), this
  }
  equals(e) {
    return e.x === this.x && e.y === this.y
  }
  fromArray(e, t = 0) {
    return (this.x = e[t]), (this.y = e[t + 1]), this
  }
  toArray(e = [], t = 0) {
    return (e[t] = this.x), (e[t + 1] = this.y), e
  }
  fromBufferAttribute(e, t) {
    return (this.x = e.getX(t)), (this.y = e.getY(t)), this
  }
  rotateAround(e, t) {
    const i = Math.cos(t),
      r = Math.sin(t),
      s = this.x - e.x,
      o = this.y - e.y
    return (this.x = s * i - o * r + e.x), (this.y = s * r + o * i + e.y), this
  }
  random() {
    return (this.x = Math.random()), (this.y = Math.random()), this
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y
  }
}
class Xt {
  constructor(e, t, i, r, s, o, l, u, d) {
    ;(Xt.prototype.isMatrix3 = !0),
      (this.elements = [1, 0, 0, 0, 1, 0, 0, 0, 1]),
      e !== void 0 && this.set(e, t, i, r, s, o, l, u, d)
  }
  set(e, t, i, r, s, o, l, u, d) {
    const p = this.elements
    return (
      (p[0] = e),
      (p[1] = r),
      (p[2] = l),
      (p[3] = t),
      (p[4] = s),
      (p[5] = u),
      (p[6] = i),
      (p[7] = o),
      (p[8] = d),
      this
    )
  }
  identity() {
    return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this
  }
  copy(e) {
    const t = this.elements,
      i = e.elements
    return (
      (t[0] = i[0]),
      (t[1] = i[1]),
      (t[2] = i[2]),
      (t[3] = i[3]),
      (t[4] = i[4]),
      (t[5] = i[5]),
      (t[6] = i[6]),
      (t[7] = i[7]),
      (t[8] = i[8]),
      this
    )
  }
  extractBasis(e, t, i) {
    return (
      e.setFromMatrix3Column(this, 0),
      t.setFromMatrix3Column(this, 1),
      i.setFromMatrix3Column(this, 2),
      this
    )
  }
  setFromMatrix4(e) {
    const t = e.elements
    return this.set(t[0], t[4], t[8], t[1], t[5], t[9], t[2], t[6], t[10]), this
  }
  multiply(e) {
    return this.multiplyMatrices(this, e)
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this)
  }
  multiplyMatrices(e, t) {
    const i = e.elements,
      r = t.elements,
      s = this.elements,
      o = i[0],
      l = i[3],
      u = i[6],
      d = i[1],
      p = i[4],
      m = i[7],
      v = i[2],
      y = i[5],
      x = i[8],
      E = r[0],
      M = r[3],
      w = r[6],
      A = r[1],
      C = r[4],
      R = r[7],
      z = r[2],
      U = r[5],
      O = r[8]
    return (
      (s[0] = o * E + l * A + u * z),
      (s[3] = o * M + l * C + u * U),
      (s[6] = o * w + l * R + u * O),
      (s[1] = d * E + p * A + m * z),
      (s[4] = d * M + p * C + m * U),
      (s[7] = d * w + p * R + m * O),
      (s[2] = v * E + y * A + x * z),
      (s[5] = v * M + y * C + x * U),
      (s[8] = v * w + y * R + x * O),
      this
    )
  }
  multiplyScalar(e) {
    const t = this.elements
    return (
      (t[0] *= e),
      (t[3] *= e),
      (t[6] *= e),
      (t[1] *= e),
      (t[4] *= e),
      (t[7] *= e),
      (t[2] *= e),
      (t[5] *= e),
      (t[8] *= e),
      this
    )
  }
  determinant() {
    const e = this.elements,
      t = e[0],
      i = e[1],
      r = e[2],
      s = e[3],
      o = e[4],
      l = e[5],
      u = e[6],
      d = e[7],
      p = e[8]
    return t * o * p - t * l * d - i * s * p + i * l * u + r * s * d - r * o * u
  }
  invert() {
    const e = this.elements,
      t = e[0],
      i = e[1],
      r = e[2],
      s = e[3],
      o = e[4],
      l = e[5],
      u = e[6],
      d = e[7],
      p = e[8],
      m = p * o - l * d,
      v = l * u - p * s,
      y = d * s - o * u,
      x = t * m + i * v + r * y
    if (x === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0)
    const E = 1 / x
    return (
      (e[0] = m * E),
      (e[1] = (r * d - p * i) * E),
      (e[2] = (l * i - r * o) * E),
      (e[3] = v * E),
      (e[4] = (p * t - r * u) * E),
      (e[5] = (r * s - l * t) * E),
      (e[6] = y * E),
      (e[7] = (i * u - d * t) * E),
      (e[8] = (o * t - i * s) * E),
      this
    )
  }
  transpose() {
    let e
    const t = this.elements
    return (
      (e = t[1]),
      (t[1] = t[3]),
      (t[3] = e),
      (e = t[2]),
      (t[2] = t[6]),
      (t[6] = e),
      (e = t[5]),
      (t[5] = t[7]),
      (t[7] = e),
      this
    )
  }
  getNormalMatrix(e) {
    return this.setFromMatrix4(e).invert().transpose()
  }
  transposeIntoArray(e) {
    const t = this.elements
    return (
      (e[0] = t[0]),
      (e[1] = t[3]),
      (e[2] = t[6]),
      (e[3] = t[1]),
      (e[4] = t[4]),
      (e[5] = t[7]),
      (e[6] = t[2]),
      (e[7] = t[5]),
      (e[8] = t[8]),
      this
    )
  }
  setUvTransform(e, t, i, r, s, o, l) {
    const u = Math.cos(s),
      d = Math.sin(s)
    return (
      this.set(
        i * u,
        i * d,
        -i * (u * o + d * l) + o + e,
        -r * d,
        r * u,
        -r * (-d * o + u * l) + l + t,
        0,
        0,
        1,
      ),
      this
    )
  }
  scale(e, t) {
    return this.premultiply(Ix.makeScale(e, t)), this
  }
  rotate(e) {
    return this.premultiply(Ix.makeRotation(-e)), this
  }
  translate(e, t) {
    return this.premultiply(Ix.makeTranslation(e, t)), this
  }
  makeTranslation(e, t) {
    return (
      e.isVector2
        ? this.set(1, 0, e.x, 0, 1, e.y, 0, 0, 1)
        : this.set(1, 0, e, 0, 1, t, 0, 0, 1),
      this
    )
  }
  makeRotation(e) {
    const t = Math.cos(e),
      i = Math.sin(e)
    return this.set(t, -i, 0, i, t, 0, 0, 0, 1), this
  }
  makeScale(e, t) {
    return this.set(e, 0, 0, 0, t, 0, 0, 0, 1), this
  }
  equals(e) {
    const t = this.elements,
      i = e.elements
    for (let r = 0; r < 9; r++) if (t[r] !== i[r]) return !1
    return !0
  }
  fromArray(e, t = 0) {
    for (let i = 0; i < 9; i++) this.elements[i] = e[i + t]
    return this
  }
  toArray(e = [], t = 0) {
    const i = this.elements
    return (
      (e[t] = i[0]),
      (e[t + 1] = i[1]),
      (e[t + 2] = i[2]),
      (e[t + 3] = i[3]),
      (e[t + 4] = i[4]),
      (e[t + 5] = i[5]),
      (e[t + 6] = i[6]),
      (e[t + 7] = i[7]),
      (e[t + 8] = i[8]),
      e
    )
  }
  clone() {
    return new this.constructor().fromArray(this.elements)
  }
}
const Ix = new Xt()
function h3(n) {
  for (let e = n.length - 1; e >= 0; --e) if (n[e] >= 65535) return !0
  return !1
}
const CO = {
  Int8Array,
  Uint8Array,
  Uint8ClampedArray,
  Int16Array,
  Uint16Array,
  Int32Array,
  Uint32Array,
  Float32Array,
  Float64Array,
}
function Sd(n, e) {
  return new CO[n](e)
}
function Kp(n) {
  return document.createElementNS("http://www.w3.org/1999/xhtml", n)
}
function p3() {
  const n = Kp("canvas")
  return (n.style.display = "block"), n
}
const ZE = {}
function hp(n) {
  n in ZE || ((ZE[n] = !0), console.warn(n))
}
function RO(n, e, t) {
  return new Promise(function (i, r) {
    function s() {
      switch (n.clientWaitSync(e, n.SYNC_FLUSH_COMMANDS_BIT, 0)) {
        case n.WAIT_FAILED:
          r()
          break
        case n.TIMEOUT_EXPIRED:
          setTimeout(s, t)
          break
        default:
          i()
      }
    }
    setTimeout(s, t)
  })
}
function PO(n) {
  const e = n.elements
  ;(e[2] = 0.5 * e[2] + 0.5 * e[3]),
    (e[6] = 0.5 * e[6] + 0.5 * e[7]),
    (e[10] = 0.5 * e[10] + 0.5 * e[11]),
    (e[14] = 0.5 * e[14] + 0.5 * e[15])
}
function IO(n) {
  const e = n.elements
  e[11] === -1
    ? ((e[10] = -e[10] - 1), (e[14] = -e[14]))
    : ((e[10] = -e[10]), (e[14] = -e[14] + 1))
}
const fn = {
  enabled: !0,
  workingColorSpace: Bu,
  spaces: {},
  convert: function (n, e, t) {
    return (
      this.enabled === !1 ||
        e === t ||
        !e ||
        !t ||
        (this.spaces[e].transfer === Sn &&
          ((n.r = Xa(n.r)), (n.g = Xa(n.g)), (n.b = Xa(n.b))),
        this.spaces[e].primaries !== this.spaces[t].primaries &&
          (n.applyMatrix3(this.spaces[e].toXYZ),
          n.applyMatrix3(this.spaces[t].fromXYZ)),
        this.spaces[t].transfer === Sn &&
          ((n.r = Ad(n.r)), (n.g = Ad(n.g)), (n.b = Ad(n.b)))),
      n
    )
  },
  fromWorkingColorSpace: function (n, e) {
    return this.convert(n, this.workingColorSpace, e)
  },
  toWorkingColorSpace: function (n, e) {
    return this.convert(n, e, this.workingColorSpace)
  },
  getPrimaries: function (n) {
    return this.spaces[n].primaries
  },
  getTransfer: function (n) {
    return n === za ? ym : this.spaces[n].transfer
  },
  getLuminanceCoefficients: function (n, e = this.workingColorSpace) {
    return n.fromArray(this.spaces[e].luminanceCoefficients)
  },
  define: function (n) {
    Object.assign(this.spaces, n)
  },
  _getMatrix: function (n, e, t) {
    return n.copy(this.spaces[e].toXYZ).multiply(this.spaces[t].fromXYZ)
  },
  _getDrawingBufferColorSpace: function (n) {
    return this.spaces[n].outputColorSpaceConfig.drawingBufferColorSpace
  },
  _getUnpackColorSpace: function (n = this.workingColorSpace) {
    return this.spaces[n].workingColorSpaceConfig.unpackColorSpace
  },
}
function Xa(n) {
  return n < 0.04045 ? n * 0.0773993808 : Math.pow(n * 0.9478672986 + 0.0521327014, 2.4)
}
function Ad(n) {
  return n < 0.0031308 ? n * 12.92 : 1.055 * Math.pow(n, 0.41666) - 0.055
}
const JE = [0.64, 0.33, 0.3, 0.6, 0.15, 0.06],
  QE = [0.2126, 0.7152, 0.0722],
  eT = [0.3127, 0.329],
  tT = new Xt().set(
    0.4123908,
    0.3575843,
    0.1804808,
    0.212639,
    0.7151687,
    0.0721923,
    0.0193308,
    0.1191948,
    0.9505322,
  ),
  nT = new Xt().set(
    3.2409699,
    -1.5373832,
    -0.4986108,
    -0.9692436,
    1.8759675,
    0.0415551,
    0.0556301,
    -0.203977,
    1.0569715,
  )
fn.define({
  [Bu]: {
    primaries: JE,
    whitePoint: eT,
    transfer: ym,
    toXYZ: tT,
    fromXYZ: nT,
    luminanceCoefficients: QE,
    workingColorSpaceConfig: { unpackColorSpace: Kr },
    outputColorSpaceConfig: { drawingBufferColorSpace: Kr },
  },
  [Kr]: {
    primaries: JE,
    whitePoint: eT,
    transfer: Sn,
    toXYZ: tT,
    fromXYZ: nT,
    luminanceCoefficients: QE,
    outputColorSpaceConfig: { drawingBufferColorSpace: Kr },
  },
})
let qf
class m3 {
  static getDataURL(e) {
    if (/^data:/i.test(e.src) || typeof HTMLCanvasElement > "u") return e.src
    let t
    if (e instanceof HTMLCanvasElement) t = e
    else {
      qf === void 0 && (qf = Kp("canvas")), (qf.width = e.width), (qf.height = e.height)
      const i = qf.getContext("2d")
      e instanceof ImageData
        ? i.putImageData(e, 0, 0)
        : i.drawImage(e, 0, 0, e.width, e.height),
        (t = qf)
    }
    return t.width > 2048 || t.height > 2048
      ? (console.warn(
          "THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons",
          e,
        ),
        t.toDataURL("image/jpeg", 0.6))
      : t.toDataURL("image/png")
  }
  static sRGBToLinear(e) {
    if (
      (typeof HTMLImageElement < "u" && e instanceof HTMLImageElement) ||
      (typeof HTMLCanvasElement < "u" && e instanceof HTMLCanvasElement) ||
      (typeof ImageBitmap < "u" && e instanceof ImageBitmap)
    ) {
      const t = Kp("canvas")
      ;(t.width = e.width), (t.height = e.height)
      const i = t.getContext("2d")
      i.drawImage(e, 0, 0, e.width, e.height)
      const r = i.getImageData(0, 0, e.width, e.height),
        s = r.data
      for (let o = 0; o < s.length; o++) s[o] = Xa(s[o] / 255) * 255
      return i.putImageData(r, 0, 0), t
    } else if (e.data) {
      const t = e.data.slice(0)
      for (let i = 0; i < t.length; i++)
        t instanceof Uint8Array || t instanceof Uint8ClampedArray
          ? (t[i] = Math.floor(Xa(t[i] / 255) * 255))
          : (t[i] = Xa(t[i]))
      return { data: t, width: e.width, height: e.height }
    } else
      return (
        console.warn(
          "THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.",
        ),
        e
      )
  }
}
let LO = 0
class _u {
  constructor(e = null) {
    ;(this.isSource = !0),
      Object.defineProperty(this, "id", { value: LO++ }),
      (this.uuid = vs()),
      (this.data = e),
      (this.dataReady = !0),
      (this.version = 0)
  }
  set needsUpdate(e) {
    e === !0 && this.version++
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string"
    if (!t && e.images[this.uuid] !== void 0) return e.images[this.uuid]
    const i = { uuid: this.uuid, url: "" },
      r = this.data
    if (r !== null) {
      let s
      if (Array.isArray(r)) {
        s = []
        for (let o = 0, l = r.length; o < l; o++)
          r[o].isDataTexture ? s.push(Lx(r[o].image)) : s.push(Lx(r[o]))
      } else s = Lx(r)
      i.url = s
    }
    return t || (e.images[this.uuid] = i), i
  }
}
function Lx(n) {
  return (typeof HTMLImageElement < "u" && n instanceof HTMLImageElement) ||
    (typeof HTMLCanvasElement < "u" && n instanceof HTMLCanvasElement) ||
    (typeof ImageBitmap < "u" && n instanceof ImageBitmap)
    ? m3.getDataURL(n)
    : n.data
    ? {
        data: Array.from(n.data),
        width: n.width,
        height: n.height,
        type: n.data.constructor.name,
      }
    : (console.warn("THREE.Texture: Unable to serialize Texture."), {})
}
let DO = 0
class zn extends Jo {
  constructor(
    e = zn.DEFAULT_IMAGE,
    t = zn.DEFAULT_MAPPING,
    i = Jr,
    r = Jr,
    s = Ri,
    o = Ho,
    l = hr,
    u = wo,
    d = zn.DEFAULT_ANISOTROPY,
    p = za,
  ) {
    super(),
      (this.isTexture = !0),
      Object.defineProperty(this, "id", { value: DO++ }),
      (this.uuid = vs()),
      (this.name = ""),
      (this.source = new _u(e)),
      (this.mipmaps = []),
      (this.mapping = t),
      (this.channel = 0),
      (this.wrapS = i),
      (this.wrapT = r),
      (this.magFilter = s),
      (this.minFilter = o),
      (this.anisotropy = d),
      (this.format = l),
      (this.internalFormat = null),
      (this.type = u),
      (this.offset = new We(0, 0)),
      (this.repeat = new We(1, 1)),
      (this.center = new We(0, 0)),
      (this.rotation = 0),
      (this.matrixAutoUpdate = !0),
      (this.matrix = new Xt()),
      (this.generateMipmaps = !0),
      (this.premultiplyAlpha = !1),
      (this.flipY = !0),
      (this.unpackAlignment = 4),
      (this.colorSpace = p),
      (this.userData = {}),
      (this.version = 0),
      (this.onUpdate = null),
      (this.isRenderTargetTexture = !1),
      (this.pmremVersion = 0)
  }
  get image() {
    return this.source.data
  }
  set image(e = null) {
    this.source.data = e
  }
  updateMatrix() {
    this.matrix.setUvTransform(
      this.offset.x,
      this.offset.y,
      this.repeat.x,
      this.repeat.y,
      this.rotation,
      this.center.x,
      this.center.y,
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(e) {
    return (
      (this.name = e.name),
      (this.source = e.source),
      (this.mipmaps = e.mipmaps.slice(0)),
      (this.mapping = e.mapping),
      (this.channel = e.channel),
      (this.wrapS = e.wrapS),
      (this.wrapT = e.wrapT),
      (this.magFilter = e.magFilter),
      (this.minFilter = e.minFilter),
      (this.anisotropy = e.anisotropy),
      (this.format = e.format),
      (this.internalFormat = e.internalFormat),
      (this.type = e.type),
      this.offset.copy(e.offset),
      this.repeat.copy(e.repeat),
      this.center.copy(e.center),
      (this.rotation = e.rotation),
      (this.matrixAutoUpdate = e.matrixAutoUpdate),
      this.matrix.copy(e.matrix),
      (this.generateMipmaps = e.generateMipmaps),
      (this.premultiplyAlpha = e.premultiplyAlpha),
      (this.flipY = e.flipY),
      (this.unpackAlignment = e.unpackAlignment),
      (this.colorSpace = e.colorSpace),
      (this.userData = JSON.parse(JSON.stringify(e.userData))),
      (this.needsUpdate = !0),
      this
    )
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string"
    if (!t && e.textures[this.uuid] !== void 0) return e.textures[this.uuid]
    const i = {
      metadata: { version: 4.6, type: "Texture", generator: "Texture.toJSON" },
      uuid: this.uuid,
      name: this.name,
      image: this.source.toJSON(e).uuid,
      mapping: this.mapping,
      channel: this.channel,
      repeat: [this.repeat.x, this.repeat.y],
      offset: [this.offset.x, this.offset.y],
      center: [this.center.x, this.center.y],
      rotation: this.rotation,
      wrap: [this.wrapS, this.wrapT],
      format: this.format,
      internalFormat: this.internalFormat,
      type: this.type,
      colorSpace: this.colorSpace,
      minFilter: this.minFilter,
      magFilter: this.magFilter,
      anisotropy: this.anisotropy,
      flipY: this.flipY,
      generateMipmaps: this.generateMipmaps,
      premultiplyAlpha: this.premultiplyAlpha,
      unpackAlignment: this.unpackAlignment,
    }
    return (
      Object.keys(this.userData).length > 0 && (i.userData = this.userData),
      t || (e.textures[this.uuid] = i),
      i
    )
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" })
  }
  transformUv(e) {
    if (this.mapping !== Xv) return e
    if ((e.applyMatrix3(this.matrix), e.x < 0 || e.x > 1))
      switch (this.wrapS) {
        case Lu:
          e.x = e.x - Math.floor(e.x)
          break
        case Jr:
          e.x = e.x < 0 ? 0 : 1
          break
        case jp:
          Math.abs(Math.floor(e.x) % 2) === 1
            ? (e.x = Math.ceil(e.x) - e.x)
            : (e.x = e.x - Math.floor(e.x))
          break
      }
    if (e.y < 0 || e.y > 1)
      switch (this.wrapT) {
        case Lu:
          e.y = e.y - Math.floor(e.y)
          break
        case Jr:
          e.y = e.y < 0 ? 0 : 1
          break
        case jp:
          Math.abs(Math.floor(e.y) % 2) === 1
            ? (e.y = Math.ceil(e.y) - e.y)
            : (e.y = e.y - Math.floor(e.y))
          break
      }
    return this.flipY && (e.y = 1 - e.y), e
  }
  set needsUpdate(e) {
    e === !0 && (this.version++, (this.source.needsUpdate = !0))
  }
  set needsPMREMUpdate(e) {
    e === !0 && this.pmremVersion++
  }
}
zn.DEFAULT_IMAGE = null
zn.DEFAULT_MAPPING = Xv
zn.DEFAULT_ANISOTROPY = 1
class on {
  constructor(e = 0, t = 0, i = 0, r = 1) {
    ;(on.prototype.isVector4 = !0),
      (this.x = e),
      (this.y = t),
      (this.z = i),
      (this.w = r)
  }
  get width() {
    return this.z
  }
  set width(e) {
    this.z = e
  }
  get height() {
    return this.w
  }
  set height(e) {
    this.w = e
  }
  set(e, t, i, r) {
    return (this.x = e), (this.y = t), (this.z = i), (this.w = r), this
  }
  setScalar(e) {
    return (this.x = e), (this.y = e), (this.z = e), (this.w = e), this
  }
  setX(e) {
    return (this.x = e), this
  }
  setY(e) {
    return (this.y = e), this
  }
  setZ(e) {
    return (this.z = e), this
  }
  setW(e) {
    return (this.w = e), this
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t
        break
      case 1:
        this.y = t
        break
      case 2:
        this.z = t
        break
      case 3:
        this.w = t
        break
      default:
        throw new Error("index is out of range: " + e)
    }
    return this
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x
      case 1:
        return this.y
      case 2:
        return this.z
      case 3:
        return this.w
      default:
        throw new Error("index is out of range: " + e)
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z, this.w)
  }
  copy(e) {
    return (
      (this.x = e.x),
      (this.y = e.y),
      (this.z = e.z),
      (this.w = e.w !== void 0 ? e.w : 1),
      this
    )
  }
  add(e) {
    return (this.x += e.x), (this.y += e.y), (this.z += e.z), (this.w += e.w), this
  }
  addScalar(e) {
    return (this.x += e), (this.y += e), (this.z += e), (this.w += e), this
  }
  addVectors(e, t) {
    return (
      (this.x = e.x + t.x),
      (this.y = e.y + t.y),
      (this.z = e.z + t.z),
      (this.w = e.w + t.w),
      this
    )
  }
  addScaledVector(e, t) {
    return (
      (this.x += e.x * t),
      (this.y += e.y * t),
      (this.z += e.z * t),
      (this.w += e.w * t),
      this
    )
  }
  sub(e) {
    return (this.x -= e.x), (this.y -= e.y), (this.z -= e.z), (this.w -= e.w), this
  }
  subScalar(e) {
    return (this.x -= e), (this.y -= e), (this.z -= e), (this.w -= e), this
  }
  subVectors(e, t) {
    return (
      (this.x = e.x - t.x),
      (this.y = e.y - t.y),
      (this.z = e.z - t.z),
      (this.w = e.w - t.w),
      this
    )
  }
  multiply(e) {
    return (this.x *= e.x), (this.y *= e.y), (this.z *= e.z), (this.w *= e.w), this
  }
  multiplyScalar(e) {
    return (this.x *= e), (this.y *= e), (this.z *= e), (this.w *= e), this
  }
  applyMatrix4(e) {
    const t = this.x,
      i = this.y,
      r = this.z,
      s = this.w,
      o = e.elements
    return (
      (this.x = o[0] * t + o[4] * i + o[8] * r + o[12] * s),
      (this.y = o[1] * t + o[5] * i + o[9] * r + o[13] * s),
      (this.z = o[2] * t + o[6] * i + o[10] * r + o[14] * s),
      (this.w = o[3] * t + o[7] * i + o[11] * r + o[15] * s),
      this
    )
  }
  divide(e) {
    return (this.x /= e.x), (this.y /= e.y), (this.z /= e.z), (this.w /= e.w), this
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e)
  }
  setAxisAngleFromQuaternion(e) {
    this.w = 2 * Math.acos(e.w)
    const t = Math.sqrt(1 - e.w * e.w)
    return (
      t < 1e-4
        ? ((this.x = 1), (this.y = 0), (this.z = 0))
        : ((this.x = e.x / t), (this.y = e.y / t), (this.z = e.z / t)),
      this
    )
  }
  setAxisAngleFromRotationMatrix(e) {
    let t, i, r, s
    const u = e.elements,
      d = u[0],
      p = u[4],
      m = u[8],
      v = u[1],
      y = u[5],
      x = u[9],
      E = u[2],
      M = u[6],
      w = u[10]
    if (Math.abs(p - v) < 0.01 && Math.abs(m - E) < 0.01 && Math.abs(x - M) < 0.01) {
      if (
        Math.abs(p + v) < 0.1 &&
        Math.abs(m + E) < 0.1 &&
        Math.abs(x + M) < 0.1 &&
        Math.abs(d + y + w - 3) < 0.1
      )
        return this.set(1, 0, 0, 0), this
      t = Math.PI
      const C = (d + 1) / 2,
        R = (y + 1) / 2,
        z = (w + 1) / 2,
        U = (p + v) / 4,
        O = (m + E) / 4,
        N = (x + M) / 4
      return (
        C > R && C > z
          ? C < 0.01
            ? ((i = 0), (r = 0.707106781), (s = 0.707106781))
            : ((i = Math.sqrt(C)), (r = U / i), (s = O / i))
          : R > z
          ? R < 0.01
            ? ((i = 0.707106781), (r = 0), (s = 0.707106781))
            : ((r = Math.sqrt(R)), (i = U / r), (s = N / r))
          : z < 0.01
          ? ((i = 0.707106781), (r = 0.707106781), (s = 0))
          : ((s = Math.sqrt(z)), (i = O / s), (r = N / s)),
        this.set(i, r, s, t),
        this
      )
    }
    let A = Math.sqrt((M - x) * (M - x) + (m - E) * (m - E) + (v - p) * (v - p))
    return (
      Math.abs(A) < 0.001 && (A = 1),
      (this.x = (M - x) / A),
      (this.y = (m - E) / A),
      (this.z = (v - p) / A),
      (this.w = Math.acos((d + y + w - 1) / 2)),
      this
    )
  }
  setFromMatrixPosition(e) {
    const t = e.elements
    return (this.x = t[12]), (this.y = t[13]), (this.z = t[14]), (this.w = t[15]), this
  }
  min(e) {
    return (
      (this.x = Math.min(this.x, e.x)),
      (this.y = Math.min(this.y, e.y)),
      (this.z = Math.min(this.z, e.z)),
      (this.w = Math.min(this.w, e.w)),
      this
    )
  }
  max(e) {
    return (
      (this.x = Math.max(this.x, e.x)),
      (this.y = Math.max(this.y, e.y)),
      (this.z = Math.max(this.z, e.z)),
      (this.w = Math.max(this.w, e.w)),
      this
    )
  }
  clamp(e, t) {
    return (
      (this.x = Math.max(e.x, Math.min(t.x, this.x))),
      (this.y = Math.max(e.y, Math.min(t.y, this.y))),
      (this.z = Math.max(e.z, Math.min(t.z, this.z))),
      (this.w = Math.max(e.w, Math.min(t.w, this.w))),
      this
    )
  }
  clampScalar(e, t) {
    return (
      (this.x = Math.max(e, Math.min(t, this.x))),
      (this.y = Math.max(e, Math.min(t, this.y))),
      (this.z = Math.max(e, Math.min(t, this.z))),
      (this.w = Math.max(e, Math.min(t, this.w))),
      this
    )
  }
  clampLength(e, t) {
    const i = this.length()
    return this.divideScalar(i || 1).multiplyScalar(Math.max(e, Math.min(t, i)))
  }
  floor() {
    return (
      (this.x = Math.floor(this.x)),
      (this.y = Math.floor(this.y)),
      (this.z = Math.floor(this.z)),
      (this.w = Math.floor(this.w)),
      this
    )
  }
  ceil() {
    return (
      (this.x = Math.ceil(this.x)),
      (this.y = Math.ceil(this.y)),
      (this.z = Math.ceil(this.z)),
      (this.w = Math.ceil(this.w)),
      this
    )
  }
  round() {
    return (
      (this.x = Math.round(this.x)),
      (this.y = Math.round(this.y)),
      (this.z = Math.round(this.z)),
      (this.w = Math.round(this.w)),
      this
    )
  }
  roundToZero() {
    return (
      (this.x = Math.trunc(this.x)),
      (this.y = Math.trunc(this.y)),
      (this.z = Math.trunc(this.z)),
      (this.w = Math.trunc(this.w)),
      this
    )
  }
  negate() {
    return (
      (this.x = -this.x),
      (this.y = -this.y),
      (this.z = -this.z),
      (this.w = -this.w),
      this
    )
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z + this.w * e.w
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w
  }
  length() {
    return Math.sqrt(
      this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w,
    )
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w)
  }
  normalize() {
    return this.divideScalar(this.length() || 1)
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e)
  }
  lerp(e, t) {
    return (
      (this.x += (e.x - this.x) * t),
      (this.y += (e.y - this.y) * t),
      (this.z += (e.z - this.z) * t),
      (this.w += (e.w - this.w) * t),
      this
    )
  }
  lerpVectors(e, t, i) {
    return (
      (this.x = e.x + (t.x - e.x) * i),
      (this.y = e.y + (t.y - e.y) * i),
      (this.z = e.z + (t.z - e.z) * i),
      (this.w = e.w + (t.w - e.w) * i),
      this
    )
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z && e.w === this.w
  }
  fromArray(e, t = 0) {
    return (
      (this.x = e[t]),
      (this.y = e[t + 1]),
      (this.z = e[t + 2]),
      (this.w = e[t + 3]),
      this
    )
  }
  toArray(e = [], t = 0) {
    return (
      (e[t] = this.x), (e[t + 1] = this.y), (e[t + 2] = this.z), (e[t + 3] = this.w), e
    )
  }
  fromBufferAttribute(e, t) {
    return (
      (this.x = e.getX(t)),
      (this.y = e.getY(t)),
      (this.z = e.getZ(t)),
      (this.w = e.getW(t)),
      this
    )
  }
  random() {
    return (
      (this.x = Math.random()),
      (this.y = Math.random()),
      (this.z = Math.random()),
      (this.w = Math.random()),
      this
    )
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z, yield this.w
  }
}
class g3 extends Jo {
  constructor(e = 1, t = 1, i = {}) {
    super(),
      (this.isRenderTarget = !0),
      (this.width = e),
      (this.height = t),
      (this.depth = 1),
      (this.scissor = new on(0, 0, e, t)),
      (this.scissorTest = !1),
      (this.viewport = new on(0, 0, e, t))
    const r = { width: e, height: t, depth: 1 }
    i = Object.assign(
      {
        generateMipmaps: !1,
        internalFormat: null,
        minFilter: Ri,
        depthBuffer: !0,
        stencilBuffer: !1,
        resolveDepthBuffer: !0,
        resolveStencilBuffer: !0,
        depthTexture: null,
        samples: 0,
        count: 1,
      },
      i,
    )
    const s = new zn(
      r,
      i.mapping,
      i.wrapS,
      i.wrapT,
      i.magFilter,
      i.minFilter,
      i.format,
      i.type,
      i.anisotropy,
      i.colorSpace,
    )
    ;(s.flipY = !1),
      (s.generateMipmaps = i.generateMipmaps),
      (s.internalFormat = i.internalFormat),
      (this.textures = [])
    const o = i.count
    for (let l = 0; l < o; l++)
      (this.textures[l] = s.clone()), (this.textures[l].isRenderTargetTexture = !0)
    ;(this.depthBuffer = i.depthBuffer),
      (this.stencilBuffer = i.stencilBuffer),
      (this.resolveDepthBuffer = i.resolveDepthBuffer),
      (this.resolveStencilBuffer = i.resolveStencilBuffer),
      (this.depthTexture = i.depthTexture),
      (this.samples = i.samples)
  }
  get texture() {
    return this.textures[0]
  }
  set texture(e) {
    this.textures[0] = e
  }
  setSize(e, t, i = 1) {
    if (this.width !== e || this.height !== t || this.depth !== i) {
      ;(this.width = e), (this.height = t), (this.depth = i)
      for (let r = 0, s = this.textures.length; r < s; r++)
        (this.textures[r].image.width = e),
          (this.textures[r].image.height = t),
          (this.textures[r].image.depth = i)
      this.dispose()
    }
    this.viewport.set(0, 0, e, t), this.scissor.set(0, 0, e, t)
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(e) {
    ;(this.width = e.width),
      (this.height = e.height),
      (this.depth = e.depth),
      this.scissor.copy(e.scissor),
      (this.scissorTest = e.scissorTest),
      this.viewport.copy(e.viewport),
      (this.textures.length = 0)
    for (let i = 0, r = e.textures.length; i < r; i++)
      (this.textures[i] = e.textures[i].clone()),
        (this.textures[i].isRenderTargetTexture = !0)
    const t = Object.assign({}, e.texture.image)
    return (
      (this.texture.source = new _u(t)),
      (this.depthBuffer = e.depthBuffer),
      (this.stencilBuffer = e.stencilBuffer),
      (this.resolveDepthBuffer = e.resolveDepthBuffer),
      (this.resolveStencilBuffer = e.resolveStencilBuffer),
      e.depthTexture !== null && (this.depthTexture = e.depthTexture.clone()),
      (this.samples = e.samples),
      this
    )
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" })
  }
}
class So extends g3 {
  constructor(e = 1, t = 1, i = {}) {
    super(e, t, i), (this.isWebGLRenderTarget = !0)
  }
}
class ey extends zn {
  constructor(e = null, t = 1, i = 1, r = 1) {
    super(null),
      (this.isDataArrayTexture = !0),
      (this.image = { data: e, width: t, height: i, depth: r }),
      (this.magFilter = Qi),
      (this.minFilter = Qi),
      (this.wrapR = Jr),
      (this.generateMipmaps = !1),
      (this.flipY = !1),
      (this.unpackAlignment = 1),
      (this.layerUpdates = new Set())
  }
  addLayerUpdate(e) {
    this.layerUpdates.add(e)
  }
  clearLayerUpdates() {
    this.layerUpdates.clear()
  }
}
class NO extends So {
  constructor(e = 1, t = 1, i = 1, r = {}) {
    super(e, t, r),
      (this.isWebGLArrayRenderTarget = !0),
      (this.depth = i),
      (this.texture = new ey(null, e, t, i)),
      (this.texture.isRenderTargetTexture = !0)
  }
}
class Ow extends zn {
  constructor(e = null, t = 1, i = 1, r = 1) {
    super(null),
      (this.isData3DTexture = !0),
      (this.image = { data: e, width: t, height: i, depth: r }),
      (this.magFilter = Qi),
      (this.minFilter = Qi),
      (this.wrapR = Jr),
      (this.generateMipmaps = !1),
      (this.flipY = !1),
      (this.unpackAlignment = 1)
  }
}
class kO extends So {
  constructor(e = 1, t = 1, i = 1, r = {}) {
    super(e, t, r),
      (this.isWebGL3DRenderTarget = !0),
      (this.depth = i),
      (this.texture = new Ow(null, e, t, i)),
      (this.texture.isRenderTargetTexture = !0)
  }
}
class Oi {
  constructor(e = 0, t = 0, i = 0, r = 1) {
    ;(this.isQuaternion = !0),
      (this._x = e),
      (this._y = t),
      (this._z = i),
      (this._w = r)
  }
  static slerpFlat(e, t, i, r, s, o, l) {
    let u = i[r + 0],
      d = i[r + 1],
      p = i[r + 2],
      m = i[r + 3]
    const v = s[o + 0],
      y = s[o + 1],
      x = s[o + 2],
      E = s[o + 3]
    if (l === 0) {
      ;(e[t + 0] = u), (e[t + 1] = d), (e[t + 2] = p), (e[t + 3] = m)
      return
    }
    if (l === 1) {
      ;(e[t + 0] = v), (e[t + 1] = y), (e[t + 2] = x), (e[t + 3] = E)
      return
    }
    if (m !== E || u !== v || d !== y || p !== x) {
      let M = 1 - l
      const w = u * v + d * y + p * x + m * E,
        A = w >= 0 ? 1 : -1,
        C = 1 - w * w
      if (C > Number.EPSILON) {
        const z = Math.sqrt(C),
          U = Math.atan2(z, w * A)
        ;(M = Math.sin(M * U) / z), (l = Math.sin(l * U) / z)
      }
      const R = l * A
      if (
        ((u = u * M + v * R),
        (d = d * M + y * R),
        (p = p * M + x * R),
        (m = m * M + E * R),
        M === 1 - l)
      ) {
        const z = 1 / Math.sqrt(u * u + d * d + p * p + m * m)
        ;(u *= z), (d *= z), (p *= z), (m *= z)
      }
    }
    ;(e[t] = u), (e[t + 1] = d), (e[t + 2] = p), (e[t + 3] = m)
  }
  static multiplyQuaternionsFlat(e, t, i, r, s, o) {
    const l = i[r],
      u = i[r + 1],
      d = i[r + 2],
      p = i[r + 3],
      m = s[o],
      v = s[o + 1],
      y = s[o + 2],
      x = s[o + 3]
    return (
      (e[t] = l * x + p * m + u * y - d * v),
      (e[t + 1] = u * x + p * v + d * m - l * y),
      (e[t + 2] = d * x + p * y + l * v - u * m),
      (e[t + 3] = p * x - l * m - u * v - d * y),
      e
    )
  }
  get x() {
    return this._x
  }
  set x(e) {
    ;(this._x = e), this._onChangeCallback()
  }
  get y() {
    return this._y
  }
  set y(e) {
    ;(this._y = e), this._onChangeCallback()
  }
  get z() {
    return this._z
  }
  set z(e) {
    ;(this._z = e), this._onChangeCallback()
  }
  get w() {
    return this._w
  }
  set w(e) {
    ;(this._w = e), this._onChangeCallback()
  }
  set(e, t, i, r) {
    return (
      (this._x = e),
      (this._y = t),
      (this._z = i),
      (this._w = r),
      this._onChangeCallback(),
      this
    )
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._w)
  }
  copy(e) {
    return (
      (this._x = e.x),
      (this._y = e.y),
      (this._z = e.z),
      (this._w = e.w),
      this._onChangeCallback(),
      this
    )
  }
  setFromEuler(e, t = !0) {
    const i = e._x,
      r = e._y,
      s = e._z,
      o = e._order,
      l = Math.cos,
      u = Math.sin,
      d = l(i / 2),
      p = l(r / 2),
      m = l(s / 2),
      v = u(i / 2),
      y = u(r / 2),
      x = u(s / 2)
    switch (o) {
      case "XYZ":
        ;(this._x = v * p * m + d * y * x),
          (this._y = d * y * m - v * p * x),
          (this._z = d * p * x + v * y * m),
          (this._w = d * p * m - v * y * x)
        break
      case "YXZ":
        ;(this._x = v * p * m + d * y * x),
          (this._y = d * y * m - v * p * x),
          (this._z = d * p * x - v * y * m),
          (this._w = d * p * m + v * y * x)
        break
      case "ZXY":
        ;(this._x = v * p * m - d * y * x),
          (this._y = d * y * m + v * p * x),
          (this._z = d * p * x + v * y * m),
          (this._w = d * p * m - v * y * x)
        break
      case "ZYX":
        ;(this._x = v * p * m - d * y * x),
          (this._y = d * y * m + v * p * x),
          (this._z = d * p * x - v * y * m),
          (this._w = d * p * m + v * y * x)
        break
      case "YZX":
        ;(this._x = v * p * m + d * y * x),
          (this._y = d * y * m + v * p * x),
          (this._z = d * p * x - v * y * m),
          (this._w = d * p * m - v * y * x)
        break
      case "XZY":
        ;(this._x = v * p * m - d * y * x),
          (this._y = d * y * m - v * p * x),
          (this._z = d * p * x + v * y * m),
          (this._w = d * p * m + v * y * x)
        break
      default:
        console.warn(
          "THREE.Quaternion: .setFromEuler() encountered an unknown order: " + o,
        )
    }
    return t === !0 && this._onChangeCallback(), this
  }
  setFromAxisAngle(e, t) {
    const i = t / 2,
      r = Math.sin(i)
    return (
      (this._x = e.x * r),
      (this._y = e.y * r),
      (this._z = e.z * r),
      (this._w = Math.cos(i)),
      this._onChangeCallback(),
      this
    )
  }
  setFromRotationMatrix(e) {
    const t = e.elements,
      i = t[0],
      r = t[4],
      s = t[8],
      o = t[1],
      l = t[5],
      u = t[9],
      d = t[2],
      p = t[6],
      m = t[10],
      v = i + l + m
    if (v > 0) {
      const y = 0.5 / Math.sqrt(v + 1)
      ;(this._w = 0.25 / y),
        (this._x = (p - u) * y),
        (this._y = (s - d) * y),
        (this._z = (o - r) * y)
    } else if (i > l && i > m) {
      const y = 2 * Math.sqrt(1 + i - l - m)
      ;(this._w = (p - u) / y),
        (this._x = 0.25 * y),
        (this._y = (r + o) / y),
        (this._z = (s + d) / y)
    } else if (l > m) {
      const y = 2 * Math.sqrt(1 + l - i - m)
      ;(this._w = (s - d) / y),
        (this._x = (r + o) / y),
        (this._y = 0.25 * y),
        (this._z = (u + p) / y)
    } else {
      const y = 2 * Math.sqrt(1 + m - i - l)
      ;(this._w = (o - r) / y),
        (this._x = (s + d) / y),
        (this._y = (u + p) / y),
        (this._z = 0.25 * y)
    }
    return this._onChangeCallback(), this
  }
  setFromUnitVectors(e, t) {
    let i = e.dot(t) + 1
    return (
      i < Number.EPSILON
        ? ((i = 0),
          Math.abs(e.x) > Math.abs(e.z)
            ? ((this._x = -e.y), (this._y = e.x), (this._z = 0), (this._w = i))
            : ((this._x = 0), (this._y = -e.z), (this._z = e.y), (this._w = i)))
        : ((this._x = e.y * t.z - e.z * t.y),
          (this._y = e.z * t.x - e.x * t.z),
          (this._z = e.x * t.y - e.y * t.x),
          (this._w = i)),
      this.normalize()
    )
  }
  angleTo(e) {
    return 2 * Math.acos(Math.abs(ri(this.dot(e), -1, 1)))
  }
  rotateTowards(e, t) {
    const i = this.angleTo(e)
    if (i === 0) return this
    const r = Math.min(1, t / i)
    return this.slerp(e, r), this
  }
  identity() {
    return this.set(0, 0, 0, 1)
  }
  invert() {
    return this.conjugate()
  }
  conjugate() {
    return (
      (this._x *= -1), (this._y *= -1), (this._z *= -1), this._onChangeCallback(), this
    )
  }
  dot(e) {
    return this._x * e._x + this._y * e._y + this._z * e._z + this._w * e._w
  }
  lengthSq() {
    return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w
  }
  length() {
    return Math.sqrt(
      this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w,
    )
  }
  normalize() {
    let e = this.length()
    return (
      e === 0
        ? ((this._x = 0), (this._y = 0), (this._z = 0), (this._w = 1))
        : ((e = 1 / e),
          (this._x = this._x * e),
          (this._y = this._y * e),
          (this._z = this._z * e),
          (this._w = this._w * e)),
      this._onChangeCallback(),
      this
    )
  }
  multiply(e) {
    return this.multiplyQuaternions(this, e)
  }
  premultiply(e) {
    return this.multiplyQuaternions(e, this)
  }
  multiplyQuaternions(e, t) {
    const i = e._x,
      r = e._y,
      s = e._z,
      o = e._w,
      l = t._x,
      u = t._y,
      d = t._z,
      p = t._w
    return (
      (this._x = i * p + o * l + r * d - s * u),
      (this._y = r * p + o * u + s * l - i * d),
      (this._z = s * p + o * d + i * u - r * l),
      (this._w = o * p - i * l - r * u - s * d),
      this._onChangeCallback(),
      this
    )
  }
  slerp(e, t) {
    if (t === 0) return this
    if (t === 1) return this.copy(e)
    const i = this._x,
      r = this._y,
      s = this._z,
      o = this._w
    let l = o * e._w + i * e._x + r * e._y + s * e._z
    if (
      (l < 0
        ? ((this._w = -e._w),
          (this._x = -e._x),
          (this._y = -e._y),
          (this._z = -e._z),
          (l = -l))
        : this.copy(e),
      l >= 1)
    )
      return (this._w = o), (this._x = i), (this._y = r), (this._z = s), this
    const u = 1 - l * l
    if (u <= Number.EPSILON) {
      const y = 1 - t
      return (
        (this._w = y * o + t * this._w),
        (this._x = y * i + t * this._x),
        (this._y = y * r + t * this._y),
        (this._z = y * s + t * this._z),
        this.normalize(),
        this
      )
    }
    const d = Math.sqrt(u),
      p = Math.atan2(d, l),
      m = Math.sin((1 - t) * p) / d,
      v = Math.sin(t * p) / d
    return (
      (this._w = o * m + this._w * v),
      (this._x = i * m + this._x * v),
      (this._y = r * m + this._y * v),
      (this._z = s * m + this._z * v),
      this._onChangeCallback(),
      this
    )
  }
  slerpQuaternions(e, t, i) {
    return this.copy(e).slerp(t, i)
  }
  random() {
    const e = 2 * Math.PI * Math.random(),
      t = 2 * Math.PI * Math.random(),
      i = Math.random(),
      r = Math.sqrt(1 - i),
      s = Math.sqrt(i)
    return this.set(r * Math.sin(e), r * Math.cos(e), s * Math.sin(t), s * Math.cos(t))
  }
  equals(e) {
    return e._x === this._x && e._y === this._y && e._z === this._z && e._w === this._w
  }
  fromArray(e, t = 0) {
    return (
      (this._x = e[t]),
      (this._y = e[t + 1]),
      (this._z = e[t + 2]),
      (this._w = e[t + 3]),
      this._onChangeCallback(),
      this
    )
  }
  toArray(e = [], t = 0) {
    return (
      (e[t] = this._x),
      (e[t + 1] = this._y),
      (e[t + 2] = this._z),
      (e[t + 3] = this._w),
      e
    )
  }
  fromBufferAttribute(e, t) {
    return (
      (this._x = e.getX(t)),
      (this._y = e.getY(t)),
      (this._z = e.getZ(t)),
      (this._w = e.getW(t)),
      this._onChangeCallback(),
      this
    )
  }
  toJSON() {
    return this.toArray()
  }
  _onChange(e) {
    return (this._onChangeCallback = e), this
  }
  _onChangeCallback() {}
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._w
  }
}
class q {
  constructor(e = 0, t = 0, i = 0) {
    ;(q.prototype.isVector3 = !0), (this.x = e), (this.y = t), (this.z = i)
  }
  set(e, t, i) {
    return i === void 0 && (i = this.z), (this.x = e), (this.y = t), (this.z = i), this
  }
  setScalar(e) {
    return (this.x = e), (this.y = e), (this.z = e), this
  }
  setX(e) {
    return (this.x = e), this
  }
  setY(e) {
    return (this.y = e), this
  }
  setZ(e) {
    return (this.z = e), this
  }
  setComponent(e, t) {
    switch (e) {
      case 0:
        this.x = t
        break
      case 1:
        this.y = t
        break
      case 2:
        this.z = t
        break
      default:
        throw new Error("index is out of range: " + e)
    }
    return this
  }
  getComponent(e) {
    switch (e) {
      case 0:
        return this.x
      case 1:
        return this.y
      case 2:
        return this.z
      default:
        throw new Error("index is out of range: " + e)
    }
  }
  clone() {
    return new this.constructor(this.x, this.y, this.z)
  }
  copy(e) {
    return (this.x = e.x), (this.y = e.y), (this.z = e.z), this
  }
  add(e) {
    return (this.x += e.x), (this.y += e.y), (this.z += e.z), this
  }
  addScalar(e) {
    return (this.x += e), (this.y += e), (this.z += e), this
  }
  addVectors(e, t) {
    return (this.x = e.x + t.x), (this.y = e.y + t.y), (this.z = e.z + t.z), this
  }
  addScaledVector(e, t) {
    return (this.x += e.x * t), (this.y += e.y * t), (this.z += e.z * t), this
  }
  sub(e) {
    return (this.x -= e.x), (this.y -= e.y), (this.z -= e.z), this
  }
  subScalar(e) {
    return (this.x -= e), (this.y -= e), (this.z -= e), this
  }
  subVectors(e, t) {
    return (this.x = e.x - t.x), (this.y = e.y - t.y), (this.z = e.z - t.z), this
  }
  multiply(e) {
    return (this.x *= e.x), (this.y *= e.y), (this.z *= e.z), this
  }
  multiplyScalar(e) {
    return (this.x *= e), (this.y *= e), (this.z *= e), this
  }
  multiplyVectors(e, t) {
    return (this.x = e.x * t.x), (this.y = e.y * t.y), (this.z = e.z * t.z), this
  }
  applyEuler(e) {
    return this.applyQuaternion(iT.setFromEuler(e))
  }
  applyAxisAngle(e, t) {
    return this.applyQuaternion(iT.setFromAxisAngle(e, t))
  }
  applyMatrix3(e) {
    const t = this.x,
      i = this.y,
      r = this.z,
      s = e.elements
    return (
      (this.x = s[0] * t + s[3] * i + s[6] * r),
      (this.y = s[1] * t + s[4] * i + s[7] * r),
      (this.z = s[2] * t + s[5] * i + s[8] * r),
      this
    )
  }
  applyNormalMatrix(e) {
    return this.applyMatrix3(e).normalize()
  }
  applyMatrix4(e) {
    const t = this.x,
      i = this.y,
      r = this.z,
      s = e.elements,
      o = 1 / (s[3] * t + s[7] * i + s[11] * r + s[15])
    return (
      (this.x = (s[0] * t + s[4] * i + s[8] * r + s[12]) * o),
      (this.y = (s[1] * t + s[5] * i + s[9] * r + s[13]) * o),
      (this.z = (s[2] * t + s[6] * i + s[10] * r + s[14]) * o),
      this
    )
  }
  applyQuaternion(e) {
    const t = this.x,
      i = this.y,
      r = this.z,
      s = e.x,
      o = e.y,
      l = e.z,
      u = e.w,
      d = 2 * (o * r - l * i),
      p = 2 * (l * t - s * r),
      m = 2 * (s * i - o * t)
    return (
      (this.x = t + u * d + o * m - l * p),
      (this.y = i + u * p + l * d - s * m),
      (this.z = r + u * m + s * p - o * d),
      this
    )
  }
  project(e) {
    return this.applyMatrix4(e.matrixWorldInverse).applyMatrix4(e.projectionMatrix)
  }
  unproject(e) {
    return this.applyMatrix4(e.projectionMatrixInverse).applyMatrix4(e.matrixWorld)
  }
  transformDirection(e) {
    const t = this.x,
      i = this.y,
      r = this.z,
      s = e.elements
    return (
      (this.x = s[0] * t + s[4] * i + s[8] * r),
      (this.y = s[1] * t + s[5] * i + s[9] * r),
      (this.z = s[2] * t + s[6] * i + s[10] * r),
      this.normalize()
    )
  }
  divide(e) {
    return (this.x /= e.x), (this.y /= e.y), (this.z /= e.z), this
  }
  divideScalar(e) {
    return this.multiplyScalar(1 / e)
  }
  min(e) {
    return (
      (this.x = Math.min(this.x, e.x)),
      (this.y = Math.min(this.y, e.y)),
      (this.z = Math.min(this.z, e.z)),
      this
    )
  }
  max(e) {
    return (
      (this.x = Math.max(this.x, e.x)),
      (this.y = Math.max(this.y, e.y)),
      (this.z = Math.max(this.z, e.z)),
      this
    )
  }
  clamp(e, t) {
    return (
      (this.x = Math.max(e.x, Math.min(t.x, this.x))),
      (this.y = Math.max(e.y, Math.min(t.y, this.y))),
      (this.z = Math.max(e.z, Math.min(t.z, this.z))),
      this
    )
  }
  clampScalar(e, t) {
    return (
      (this.x = Math.max(e, Math.min(t, this.x))),
      (this.y = Math.max(e, Math.min(t, this.y))),
      (this.z = Math.max(e, Math.min(t, this.z))),
      this
    )
  }
  clampLength(e, t) {
    const i = this.length()
    return this.divideScalar(i || 1).multiplyScalar(Math.max(e, Math.min(t, i)))
  }
  floor() {
    return (
      (this.x = Math.floor(this.x)),
      (this.y = Math.floor(this.y)),
      (this.z = Math.floor(this.z)),
      this
    )
  }
  ceil() {
    return (
      (this.x = Math.ceil(this.x)),
      (this.y = Math.ceil(this.y)),
      (this.z = Math.ceil(this.z)),
      this
    )
  }
  round() {
    return (
      (this.x = Math.round(this.x)),
      (this.y = Math.round(this.y)),
      (this.z = Math.round(this.z)),
      this
    )
  }
  roundToZero() {
    return (
      (this.x = Math.trunc(this.x)),
      (this.y = Math.trunc(this.y)),
      (this.z = Math.trunc(this.z)),
      this
    )
  }
  negate() {
    return (this.x = -this.x), (this.y = -this.y), (this.z = -this.z), this
  }
  dot(e) {
    return this.x * e.x + this.y * e.y + this.z * e.z
  }
  lengthSq() {
    return this.x * this.x + this.y * this.y + this.z * this.z
  }
  length() {
    return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z)
  }
  manhattanLength() {
    return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z)
  }
  normalize() {
    return this.divideScalar(this.length() || 1)
  }
  setLength(e) {
    return this.normalize().multiplyScalar(e)
  }
  lerp(e, t) {
    return (
      (this.x += (e.x - this.x) * t),
      (this.y += (e.y - this.y) * t),
      (this.z += (e.z - this.z) * t),
      this
    )
  }
  lerpVectors(e, t, i) {
    return (
      (this.x = e.x + (t.x - e.x) * i),
      (this.y = e.y + (t.y - e.y) * i),
      (this.z = e.z + (t.z - e.z) * i),
      this
    )
  }
  cross(e) {
    return this.crossVectors(this, e)
  }
  crossVectors(e, t) {
    const i = e.x,
      r = e.y,
      s = e.z,
      o = t.x,
      l = t.y,
      u = t.z
    return (
      (this.x = r * u - s * l), (this.y = s * o - i * u), (this.z = i * l - r * o), this
    )
  }
  projectOnVector(e) {
    const t = e.lengthSq()
    if (t === 0) return this.set(0, 0, 0)
    const i = e.dot(this) / t
    return this.copy(e).multiplyScalar(i)
  }
  projectOnPlane(e) {
    return Dx.copy(this).projectOnVector(e), this.sub(Dx)
  }
  reflect(e) {
    return this.sub(Dx.copy(e).multiplyScalar(2 * this.dot(e)))
  }
  angleTo(e) {
    const t = Math.sqrt(this.lengthSq() * e.lengthSq())
    if (t === 0) return Math.PI / 2
    const i = this.dot(e) / t
    return Math.acos(ri(i, -1, 1))
  }
  distanceTo(e) {
    return Math.sqrt(this.distanceToSquared(e))
  }
  distanceToSquared(e) {
    const t = this.x - e.x,
      i = this.y - e.y,
      r = this.z - e.z
    return t * t + i * i + r * r
  }
  manhattanDistanceTo(e) {
    return Math.abs(this.x - e.x) + Math.abs(this.y - e.y) + Math.abs(this.z - e.z)
  }
  setFromSpherical(e) {
    return this.setFromSphericalCoords(e.radius, e.phi, e.theta)
  }
  setFromSphericalCoords(e, t, i) {
    const r = Math.sin(t) * e
    return (
      (this.x = r * Math.sin(i)),
      (this.y = Math.cos(t) * e),
      (this.z = r * Math.cos(i)),
      this
    )
  }
  setFromCylindrical(e) {
    return this.setFromCylindricalCoords(e.radius, e.theta, e.y)
  }
  setFromCylindricalCoords(e, t, i) {
    return (this.x = e * Math.sin(t)), (this.y = i), (this.z = e * Math.cos(t)), this
  }
  setFromMatrixPosition(e) {
    const t = e.elements
    return (this.x = t[12]), (this.y = t[13]), (this.z = t[14]), this
  }
  setFromMatrixScale(e) {
    const t = this.setFromMatrixColumn(e, 0).length(),
      i = this.setFromMatrixColumn(e, 1).length(),
      r = this.setFromMatrixColumn(e, 2).length()
    return (this.x = t), (this.y = i), (this.z = r), this
  }
  setFromMatrixColumn(e, t) {
    return this.fromArray(e.elements, t * 4)
  }
  setFromMatrix3Column(e, t) {
    return this.fromArray(e.elements, t * 3)
  }
  setFromEuler(e) {
    return (this.x = e._x), (this.y = e._y), (this.z = e._z), this
  }
  setFromColor(e) {
    return (this.x = e.r), (this.y = e.g), (this.z = e.b), this
  }
  equals(e) {
    return e.x === this.x && e.y === this.y && e.z === this.z
  }
  fromArray(e, t = 0) {
    return (this.x = e[t]), (this.y = e[t + 1]), (this.z = e[t + 2]), this
  }
  toArray(e = [], t = 0) {
    return (e[t] = this.x), (e[t + 1] = this.y), (e[t + 2] = this.z), e
  }
  fromBufferAttribute(e, t) {
    return (this.x = e.getX(t)), (this.y = e.getY(t)), (this.z = e.getZ(t)), this
  }
  random() {
    return (
      (this.x = Math.random()), (this.y = Math.random()), (this.z = Math.random()), this
    )
  }
  randomDirection() {
    const e = Math.random() * Math.PI * 2,
      t = Math.random() * 2 - 1,
      i = Math.sqrt(1 - t * t)
    return (this.x = i * Math.cos(e)), (this.y = t), (this.z = i * Math.sin(e)), this
  }
  *[Symbol.iterator]() {
    yield this.x, yield this.y, yield this.z
  }
}
const Dx = new q(),
  iT = new Oi()
class Lr {
  constructor(e = new q(1 / 0, 1 / 0, 1 / 0), t = new q(-1 / 0, -1 / 0, -1 / 0)) {
    ;(this.isBox3 = !0), (this.min = e), (this.max = t)
  }
  set(e, t) {
    return this.min.copy(e), this.max.copy(t), this
  }
  setFromArray(e) {
    this.makeEmpty()
    for (let t = 0, i = e.length; t < i; t += 3) this.expandByPoint(co.fromArray(e, t))
    return this
  }
  setFromBufferAttribute(e) {
    this.makeEmpty()
    for (let t = 0, i = e.count; t < i; t++)
      this.expandByPoint(co.fromBufferAttribute(e, t))
    return this
  }
  setFromPoints(e) {
    this.makeEmpty()
    for (let t = 0, i = e.length; t < i; t++) this.expandByPoint(e[t])
    return this
  }
  setFromCenterAndSize(e, t) {
    const i = co.copy(t).multiplyScalar(0.5)
    return this.min.copy(e).sub(i), this.max.copy(e).add(i), this
  }
  setFromObject(e, t = !1) {
    return this.makeEmpty(), this.expandByObject(e, t)
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this
  }
  makeEmpty() {
    return (
      (this.min.x = this.min.y = this.min.z = 1 / 0),
      (this.max.x = this.max.y = this.max.z = -1 / 0),
      this
    )
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z
  }
  getCenter(e) {
    return this.isEmpty()
      ? e.set(0, 0, 0)
      : e.addVectors(this.min, this.max).multiplyScalar(0.5)
  }
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0, 0) : e.subVectors(this.max, this.min)
  }
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this
  }
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this
  }
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this
  }
  expandByObject(e, t = !1) {
    e.updateWorldMatrix(!1, !1)
    const i = e.geometry
    if (i !== void 0) {
      const s = i.getAttribute("position")
      if (t === !0 && s !== void 0 && e.isInstancedMesh !== !0)
        for (let o = 0, l = s.count; o < l; o++)
          e.isMesh === !0 ? e.getVertexPosition(o, co) : co.fromBufferAttribute(s, o),
            co.applyMatrix4(e.matrixWorld),
            this.expandByPoint(co)
      else
        e.boundingBox !== void 0
          ? (e.boundingBox === null && e.computeBoundingBox(), Pg.copy(e.boundingBox))
          : (i.boundingBox === null && i.computeBoundingBox(), Pg.copy(i.boundingBox)),
          Pg.applyMatrix4(e.matrixWorld),
          this.union(Pg)
    }
    const r = e.children
    for (let s = 0, o = r.length; s < o; s++) this.expandByObject(r[s], t)
    return this
  }
  containsPoint(e) {
    return (
      e.x >= this.min.x &&
      e.x <= this.max.x &&
      e.y >= this.min.y &&
      e.y <= this.max.y &&
      e.z >= this.min.z &&
      e.z <= this.max.z
    )
  }
  containsBox(e) {
    return (
      this.min.x <= e.min.x &&
      e.max.x <= this.max.x &&
      this.min.y <= e.min.y &&
      e.max.y <= this.max.y &&
      this.min.z <= e.min.z &&
      e.max.z <= this.max.z
    )
  }
  getParameter(e, t) {
    return t.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
      (e.z - this.min.z) / (this.max.z - this.min.z),
    )
  }
  intersectsBox(e) {
    return (
      e.max.x >= this.min.x &&
      e.min.x <= this.max.x &&
      e.max.y >= this.min.y &&
      e.min.y <= this.max.y &&
      e.max.z >= this.min.z &&
      e.min.z <= this.max.z
    )
  }
  intersectsSphere(e) {
    return (
      this.clampPoint(e.center, co),
      co.distanceToSquared(e.center) <= e.radius * e.radius
    )
  }
  intersectsPlane(e) {
    let t, i
    return (
      e.normal.x > 0
        ? ((t = e.normal.x * this.min.x), (i = e.normal.x * this.max.x))
        : ((t = e.normal.x * this.max.x), (i = e.normal.x * this.min.x)),
      e.normal.y > 0
        ? ((t += e.normal.y * this.min.y), (i += e.normal.y * this.max.y))
        : ((t += e.normal.y * this.max.y), (i += e.normal.y * this.min.y)),
      e.normal.z > 0
        ? ((t += e.normal.z * this.min.z), (i += e.normal.z * this.max.z))
        : ((t += e.normal.z * this.max.z), (i += e.normal.z * this.min.z)),
      t <= -e.constant && i >= -e.constant
    )
  }
  intersectsTriangle(e) {
    if (this.isEmpty()) return !1
    this.getCenter(Yh),
      Ig.subVectors(this.max, Yh),
      $f.subVectors(e.a, Yh),
      Kf.subVectors(e.b, Yh),
      Zf.subVectors(e.c, Yh),
      kl.subVectors(Kf, $f),
      Fl.subVectors(Zf, Kf),
      Kc.subVectors($f, Zf)
    let t = [
      0,
      -kl.z,
      kl.y,
      0,
      -Fl.z,
      Fl.y,
      0,
      -Kc.z,
      Kc.y,
      kl.z,
      0,
      -kl.x,
      Fl.z,
      0,
      -Fl.x,
      Kc.z,
      0,
      -Kc.x,
      -kl.y,
      kl.x,
      0,
      -Fl.y,
      Fl.x,
      0,
      -Kc.y,
      Kc.x,
      0,
    ]
    return !Nx(t, $f, Kf, Zf, Ig) ||
      ((t = [1, 0, 0, 0, 1, 0, 0, 0, 1]), !Nx(t, $f, Kf, Zf, Ig))
      ? !1
      : (Lg.crossVectors(kl, Fl), (t = [Lg.x, Lg.y, Lg.z]), Nx(t, $f, Kf, Zf, Ig))
  }
  clampPoint(e, t) {
    return t.copy(e).clamp(this.min, this.max)
  }
  distanceToPoint(e) {
    return this.clampPoint(e, co).distanceTo(e)
  }
  getBoundingSphere(e) {
    return (
      this.isEmpty()
        ? e.makeEmpty()
        : (this.getCenter(e.center), (e.radius = this.getSize(co).length() * 0.5)),
      e
    )
  }
  intersect(e) {
    return (
      this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this
    )
  }
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this
  }
  applyMatrix4(e) {
    return this.isEmpty()
      ? this
      : (Da[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(e),
        Da[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(e),
        Da[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(e),
        Da[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(e),
        Da[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(e),
        Da[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(e),
        Da[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(e),
        Da[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(e),
        this.setFromPoints(Da),
        this)
  }
  translate(e) {
    return this.min.add(e), this.max.add(e), this
  }
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max)
  }
}
const Da = [new q(), new q(), new q(), new q(), new q(), new q(), new q(), new q()],
  co = new q(),
  Pg = new Lr(),
  $f = new q(),
  Kf = new q(),
  Zf = new q(),
  kl = new q(),
  Fl = new q(),
  Kc = new q(),
  Yh = new q(),
  Ig = new q(),
  Lg = new q(),
  Zc = new q()
function Nx(n, e, t, i, r) {
  for (let s = 0, o = n.length - 3; s <= o; s += 3) {
    Zc.fromArray(n, s)
    const l = r.x * Math.abs(Zc.x) + r.y * Math.abs(Zc.y) + r.z * Math.abs(Zc.z),
      u = e.dot(Zc),
      d = t.dot(Zc),
      p = i.dot(Zc)
    if (Math.max(-Math.max(u, d, p), Math.min(u, d, p)) > l) return !1
  }
  return !0
}
const FO = new Lr(),
  qh = new q(),
  kx = new q()
class pr {
  constructor(e = new q(), t = -1) {
    ;(this.isSphere = !0), (this.center = e), (this.radius = t)
  }
  set(e, t) {
    return this.center.copy(e), (this.radius = t), this
  }
  setFromPoints(e, t) {
    const i = this.center
    t !== void 0 ? i.copy(t) : FO.setFromPoints(e).getCenter(i)
    let r = 0
    for (let s = 0, o = e.length; s < o; s++) r = Math.max(r, i.distanceToSquared(e[s]))
    return (this.radius = Math.sqrt(r)), this
  }
  copy(e) {
    return this.center.copy(e.center), (this.radius = e.radius), this
  }
  isEmpty() {
    return this.radius < 0
  }
  makeEmpty() {
    return this.center.set(0, 0, 0), (this.radius = -1), this
  }
  containsPoint(e) {
    return e.distanceToSquared(this.center) <= this.radius * this.radius
  }
  distanceToPoint(e) {
    return e.distanceTo(this.center) - this.radius
  }
  intersectsSphere(e) {
    const t = this.radius + e.radius
    return e.center.distanceToSquared(this.center) <= t * t
  }
  intersectsBox(e) {
    return e.intersectsSphere(this)
  }
  intersectsPlane(e) {
    return Math.abs(e.distanceToPoint(this.center)) <= this.radius
  }
  clampPoint(e, t) {
    const i = this.center.distanceToSquared(e)
    return (
      t.copy(e),
      i > this.radius * this.radius &&
        (t.sub(this.center).normalize(),
        t.multiplyScalar(this.radius).add(this.center)),
      t
    )
  }
  getBoundingBox(e) {
    return this.isEmpty()
      ? (e.makeEmpty(), e)
      : (e.set(this.center, this.center), e.expandByScalar(this.radius), e)
  }
  applyMatrix4(e) {
    return (
      this.center.applyMatrix4(e),
      (this.radius = this.radius * e.getMaxScaleOnAxis()),
      this
    )
  }
  translate(e) {
    return this.center.add(e), this
  }
  expandByPoint(e) {
    if (this.isEmpty()) return this.center.copy(e), (this.radius = 0), this
    qh.subVectors(e, this.center)
    const t = qh.lengthSq()
    if (t > this.radius * this.radius) {
      const i = Math.sqrt(t),
        r = (i - this.radius) * 0.5
      this.center.addScaledVector(qh, r / i), (this.radius += r)
    }
    return this
  }
  union(e) {
    return e.isEmpty()
      ? this
      : this.isEmpty()
      ? (this.copy(e), this)
      : (this.center.equals(e.center) === !0
          ? (this.radius = Math.max(this.radius, e.radius))
          : (kx.subVectors(e.center, this.center).setLength(e.radius),
            this.expandByPoint(qh.copy(e.center).add(kx)),
            this.expandByPoint(qh.copy(e.center).sub(kx))),
        this)
  }
  equals(e) {
    return e.center.equals(this.center) && e.radius === this.radius
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
const Na = new q(),
  Fx = new q(),
  Dg = new q(),
  Ul = new q(),
  Ux = new q(),
  Ng = new q(),
  Ox = new q()
class Wd {
  constructor(e = new q(), t = new q(0, 0, -1)) {
    ;(this.origin = e), (this.direction = t)
  }
  set(e, t) {
    return this.origin.copy(e), this.direction.copy(t), this
  }
  copy(e) {
    return this.origin.copy(e.origin), this.direction.copy(e.direction), this
  }
  at(e, t) {
    return t.copy(this.origin).addScaledVector(this.direction, e)
  }
  lookAt(e) {
    return this.direction.copy(e).sub(this.origin).normalize(), this
  }
  recast(e) {
    return this.origin.copy(this.at(e, Na)), this
  }
  closestPointToPoint(e, t) {
    t.subVectors(e, this.origin)
    const i = t.dot(this.direction)
    return i < 0
      ? t.copy(this.origin)
      : t.copy(this.origin).addScaledVector(this.direction, i)
  }
  distanceToPoint(e) {
    return Math.sqrt(this.distanceSqToPoint(e))
  }
  distanceSqToPoint(e) {
    const t = Na.subVectors(e, this.origin).dot(this.direction)
    return t < 0
      ? this.origin.distanceToSquared(e)
      : (Na.copy(this.origin).addScaledVector(this.direction, t),
        Na.distanceToSquared(e))
  }
  distanceSqToSegment(e, t, i, r) {
    Fx.copy(e).add(t).multiplyScalar(0.5),
      Dg.copy(t).sub(e).normalize(),
      Ul.copy(this.origin).sub(Fx)
    const s = e.distanceTo(t) * 0.5,
      o = -this.direction.dot(Dg),
      l = Ul.dot(this.direction),
      u = -Ul.dot(Dg),
      d = Ul.lengthSq(),
      p = Math.abs(1 - o * o)
    let m, v, y, x
    if (p > 0)
      if (((m = o * u - l), (v = o * l - u), (x = s * p), m >= 0))
        if (v >= -x)
          if (v <= x) {
            const E = 1 / p
            ;(m *= E),
              (v *= E),
              (y = m * (m + o * v + 2 * l) + v * (o * m + v + 2 * u) + d)
          } else
            (v = s), (m = Math.max(0, -(o * v + l))), (y = -m * m + v * (v + 2 * u) + d)
        else
          (v = -s), (m = Math.max(0, -(o * v + l))), (y = -m * m + v * (v + 2 * u) + d)
      else
        v <= -x
          ? ((m = Math.max(0, -(-o * s + l))),
            (v = m > 0 ? -s : Math.min(Math.max(-s, -u), s)),
            (y = -m * m + v * (v + 2 * u) + d))
          : v <= x
          ? ((m = 0), (v = Math.min(Math.max(-s, -u), s)), (y = v * (v + 2 * u) + d))
          : ((m = Math.max(0, -(o * s + l))),
            (v = m > 0 ? s : Math.min(Math.max(-s, -u), s)),
            (y = -m * m + v * (v + 2 * u) + d))
    else
      (v = o > 0 ? -s : s),
        (m = Math.max(0, -(o * v + l))),
        (y = -m * m + v * (v + 2 * u) + d)
    return (
      i && i.copy(this.origin).addScaledVector(this.direction, m),
      r && r.copy(Fx).addScaledVector(Dg, v),
      y
    )
  }
  intersectSphere(e, t) {
    Na.subVectors(e.center, this.origin)
    const i = Na.dot(this.direction),
      r = Na.dot(Na) - i * i,
      s = e.radius * e.radius
    if (r > s) return null
    const o = Math.sqrt(s - r),
      l = i - o,
      u = i + o
    return u < 0 ? null : l < 0 ? this.at(u, t) : this.at(l, t)
  }
  intersectsSphere(e) {
    return this.distanceSqToPoint(e.center) <= e.radius * e.radius
  }
  distanceToPlane(e) {
    const t = e.normal.dot(this.direction)
    if (t === 0) return e.distanceToPoint(this.origin) === 0 ? 0 : null
    const i = -(this.origin.dot(e.normal) + e.constant) / t
    return i >= 0 ? i : null
  }
  intersectPlane(e, t) {
    const i = this.distanceToPlane(e)
    return i === null ? null : this.at(i, t)
  }
  intersectsPlane(e) {
    const t = e.distanceToPoint(this.origin)
    return t === 0 || e.normal.dot(this.direction) * t < 0
  }
  intersectBox(e, t) {
    let i, r, s, o, l, u
    const d = 1 / this.direction.x,
      p = 1 / this.direction.y,
      m = 1 / this.direction.z,
      v = this.origin
    return (
      d >= 0
        ? ((i = (e.min.x - v.x) * d), (r = (e.max.x - v.x) * d))
        : ((i = (e.max.x - v.x) * d), (r = (e.min.x - v.x) * d)),
      p >= 0
        ? ((s = (e.min.y - v.y) * p), (o = (e.max.y - v.y) * p))
        : ((s = (e.max.y - v.y) * p), (o = (e.min.y - v.y) * p)),
      i > o ||
      s > r ||
      ((s > i || isNaN(i)) && (i = s),
      (o < r || isNaN(r)) && (r = o),
      m >= 0
        ? ((l = (e.min.z - v.z) * m), (u = (e.max.z - v.z) * m))
        : ((l = (e.max.z - v.z) * m), (u = (e.min.z - v.z) * m)),
      i > u || l > r) ||
      ((l > i || i !== i) && (i = l), (u < r || r !== r) && (r = u), r < 0)
        ? null
        : this.at(i >= 0 ? i : r, t)
    )
  }
  intersectsBox(e) {
    return this.intersectBox(e, Na) !== null
  }
  intersectTriangle(e, t, i, r, s) {
    Ux.subVectors(t, e), Ng.subVectors(i, e), Ox.crossVectors(Ux, Ng)
    let o = this.direction.dot(Ox),
      l
    if (o > 0) {
      if (r) return null
      l = 1
    } else if (o < 0) (l = -1), (o = -o)
    else return null
    Ul.subVectors(this.origin, e)
    const u = l * this.direction.dot(Ng.crossVectors(Ul, Ng))
    if (u < 0) return null
    const d = l * this.direction.dot(Ux.cross(Ul))
    if (d < 0 || u + d > o) return null
    const p = -l * Ul.dot(Ox)
    return p < 0 ? null : this.at(p / o, s)
  }
  applyMatrix4(e) {
    return this.origin.applyMatrix4(e), this.direction.transformDirection(e), this
  }
  equals(e) {
    return e.origin.equals(this.origin) && e.direction.equals(this.direction)
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
class mt {
  constructor(e, t, i, r, s, o, l, u, d, p, m, v, y, x, E, M) {
    ;(mt.prototype.isMatrix4 = !0),
      (this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]),
      e !== void 0 && this.set(e, t, i, r, s, o, l, u, d, p, m, v, y, x, E, M)
  }
  set(e, t, i, r, s, o, l, u, d, p, m, v, y, x, E, M) {
    const w = this.elements
    return (
      (w[0] = e),
      (w[4] = t),
      (w[8] = i),
      (w[12] = r),
      (w[1] = s),
      (w[5] = o),
      (w[9] = l),
      (w[13] = u),
      (w[2] = d),
      (w[6] = p),
      (w[10] = m),
      (w[14] = v),
      (w[3] = y),
      (w[7] = x),
      (w[11] = E),
      (w[15] = M),
      this
    )
  }
  identity() {
    return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this
  }
  clone() {
    return new mt().fromArray(this.elements)
  }
  copy(e) {
    const t = this.elements,
      i = e.elements
    return (
      (t[0] = i[0]),
      (t[1] = i[1]),
      (t[2] = i[2]),
      (t[3] = i[3]),
      (t[4] = i[4]),
      (t[5] = i[5]),
      (t[6] = i[6]),
      (t[7] = i[7]),
      (t[8] = i[8]),
      (t[9] = i[9]),
      (t[10] = i[10]),
      (t[11] = i[11]),
      (t[12] = i[12]),
      (t[13] = i[13]),
      (t[14] = i[14]),
      (t[15] = i[15]),
      this
    )
  }
  copyPosition(e) {
    const t = this.elements,
      i = e.elements
    return (t[12] = i[12]), (t[13] = i[13]), (t[14] = i[14]), this
  }
  setFromMatrix3(e) {
    const t = e.elements
    return (
      this.set(
        t[0],
        t[3],
        t[6],
        0,
        t[1],
        t[4],
        t[7],
        0,
        t[2],
        t[5],
        t[8],
        0,
        0,
        0,
        0,
        1,
      ),
      this
    )
  }
  extractBasis(e, t, i) {
    return (
      e.setFromMatrixColumn(this, 0),
      t.setFromMatrixColumn(this, 1),
      i.setFromMatrixColumn(this, 2),
      this
    )
  }
  makeBasis(e, t, i) {
    return (
      this.set(e.x, t.x, i.x, 0, e.y, t.y, i.y, 0, e.z, t.z, i.z, 0, 0, 0, 0, 1), this
    )
  }
  extractRotation(e) {
    const t = this.elements,
      i = e.elements,
      r = 1 / Jf.setFromMatrixColumn(e, 0).length(),
      s = 1 / Jf.setFromMatrixColumn(e, 1).length(),
      o = 1 / Jf.setFromMatrixColumn(e, 2).length()
    return (
      (t[0] = i[0] * r),
      (t[1] = i[1] * r),
      (t[2] = i[2] * r),
      (t[3] = 0),
      (t[4] = i[4] * s),
      (t[5] = i[5] * s),
      (t[6] = i[6] * s),
      (t[7] = 0),
      (t[8] = i[8] * o),
      (t[9] = i[9] * o),
      (t[10] = i[10] * o),
      (t[11] = 0),
      (t[12] = 0),
      (t[13] = 0),
      (t[14] = 0),
      (t[15] = 1),
      this
    )
  }
  makeRotationFromEuler(e) {
    const t = this.elements,
      i = e.x,
      r = e.y,
      s = e.z,
      o = Math.cos(i),
      l = Math.sin(i),
      u = Math.cos(r),
      d = Math.sin(r),
      p = Math.cos(s),
      m = Math.sin(s)
    if (e.order === "XYZ") {
      const v = o * p,
        y = o * m,
        x = l * p,
        E = l * m
      ;(t[0] = u * p),
        (t[4] = -u * m),
        (t[8] = d),
        (t[1] = y + x * d),
        (t[5] = v - E * d),
        (t[9] = -l * u),
        (t[2] = E - v * d),
        (t[6] = x + y * d),
        (t[10] = o * u)
    } else if (e.order === "YXZ") {
      const v = u * p,
        y = u * m,
        x = d * p,
        E = d * m
      ;(t[0] = v + E * l),
        (t[4] = x * l - y),
        (t[8] = o * d),
        (t[1] = o * m),
        (t[5] = o * p),
        (t[9] = -l),
        (t[2] = y * l - x),
        (t[6] = E + v * l),
        (t[10] = o * u)
    } else if (e.order === "ZXY") {
      const v = u * p,
        y = u * m,
        x = d * p,
        E = d * m
      ;(t[0] = v - E * l),
        (t[4] = -o * m),
        (t[8] = x + y * l),
        (t[1] = y + x * l),
        (t[5] = o * p),
        (t[9] = E - v * l),
        (t[2] = -o * d),
        (t[6] = l),
        (t[10] = o * u)
    } else if (e.order === "ZYX") {
      const v = o * p,
        y = o * m,
        x = l * p,
        E = l * m
      ;(t[0] = u * p),
        (t[4] = x * d - y),
        (t[8] = v * d + E),
        (t[1] = u * m),
        (t[5] = E * d + v),
        (t[9] = y * d - x),
        (t[2] = -d),
        (t[6] = l * u),
        (t[10] = o * u)
    } else if (e.order === "YZX") {
      const v = o * u,
        y = o * d,
        x = l * u,
        E = l * d
      ;(t[0] = u * p),
        (t[4] = E - v * m),
        (t[8] = x * m + y),
        (t[1] = m),
        (t[5] = o * p),
        (t[9] = -l * p),
        (t[2] = -d * p),
        (t[6] = y * m + x),
        (t[10] = v - E * m)
    } else if (e.order === "XZY") {
      const v = o * u,
        y = o * d,
        x = l * u,
        E = l * d
      ;(t[0] = u * p),
        (t[4] = -m),
        (t[8] = d * p),
        (t[1] = v * m + E),
        (t[5] = o * p),
        (t[9] = y * m - x),
        (t[2] = x * m - y),
        (t[6] = l * p),
        (t[10] = E * m + v)
    }
    return (
      (t[3] = 0),
      (t[7] = 0),
      (t[11] = 0),
      (t[12] = 0),
      (t[13] = 0),
      (t[14] = 0),
      (t[15] = 1),
      this
    )
  }
  makeRotationFromQuaternion(e) {
    return this.compose(UO, e, OO)
  }
  lookAt(e, t, i) {
    const r = this.elements
    return (
      ms.subVectors(e, t),
      ms.lengthSq() === 0 && (ms.z = 1),
      ms.normalize(),
      Ol.crossVectors(i, ms),
      Ol.lengthSq() === 0 &&
        (Math.abs(i.z) === 1 ? (ms.x += 1e-4) : (ms.z += 1e-4),
        ms.normalize(),
        Ol.crossVectors(i, ms)),
      Ol.normalize(),
      kg.crossVectors(ms, Ol),
      (r[0] = Ol.x),
      (r[4] = kg.x),
      (r[8] = ms.x),
      (r[1] = Ol.y),
      (r[5] = kg.y),
      (r[9] = ms.y),
      (r[2] = Ol.z),
      (r[6] = kg.z),
      (r[10] = ms.z),
      this
    )
  }
  multiply(e) {
    return this.multiplyMatrices(this, e)
  }
  premultiply(e) {
    return this.multiplyMatrices(e, this)
  }
  multiplyMatrices(e, t) {
    const i = e.elements,
      r = t.elements,
      s = this.elements,
      o = i[0],
      l = i[4],
      u = i[8],
      d = i[12],
      p = i[1],
      m = i[5],
      v = i[9],
      y = i[13],
      x = i[2],
      E = i[6],
      M = i[10],
      w = i[14],
      A = i[3],
      C = i[7],
      R = i[11],
      z = i[15],
      U = r[0],
      O = r[4],
      N = r[8],
      k = r[12],
      I = r[1],
      V = r[5],
      Z = r[9],
      $ = r[13],
      ee = r[2],
      ue = r[6],
      re = r[10],
      se = r[14],
      G = r[3],
      ie = r[7],
      Q = r[11],
      W = r[15]
    return (
      (s[0] = o * U + l * I + u * ee + d * G),
      (s[4] = o * O + l * V + u * ue + d * ie),
      (s[8] = o * N + l * Z + u * re + d * Q),
      (s[12] = o * k + l * $ + u * se + d * W),
      (s[1] = p * U + m * I + v * ee + y * G),
      (s[5] = p * O + m * V + v * ue + y * ie),
      (s[9] = p * N + m * Z + v * re + y * Q),
      (s[13] = p * k + m * $ + v * se + y * W),
      (s[2] = x * U + E * I + M * ee + w * G),
      (s[6] = x * O + E * V + M * ue + w * ie),
      (s[10] = x * N + E * Z + M * re + w * Q),
      (s[14] = x * k + E * $ + M * se + w * W),
      (s[3] = A * U + C * I + R * ee + z * G),
      (s[7] = A * O + C * V + R * ue + z * ie),
      (s[11] = A * N + C * Z + R * re + z * Q),
      (s[15] = A * k + C * $ + R * se + z * W),
      this
    )
  }
  multiplyScalar(e) {
    const t = this.elements
    return (
      (t[0] *= e),
      (t[4] *= e),
      (t[8] *= e),
      (t[12] *= e),
      (t[1] *= e),
      (t[5] *= e),
      (t[9] *= e),
      (t[13] *= e),
      (t[2] *= e),
      (t[6] *= e),
      (t[10] *= e),
      (t[14] *= e),
      (t[3] *= e),
      (t[7] *= e),
      (t[11] *= e),
      (t[15] *= e),
      this
    )
  }
  determinant() {
    const e = this.elements,
      t = e[0],
      i = e[4],
      r = e[8],
      s = e[12],
      o = e[1],
      l = e[5],
      u = e[9],
      d = e[13],
      p = e[2],
      m = e[6],
      v = e[10],
      y = e[14],
      x = e[3],
      E = e[7],
      M = e[11],
      w = e[15]
    return (
      x * (+s * u * m - r * d * m - s * l * v + i * d * v + r * l * y - i * u * y) +
      E * (+t * u * y - t * d * v + s * o * v - r * o * y + r * d * p - s * u * p) +
      M * (+t * d * m - t * l * y - s * o * m + i * o * y + s * l * p - i * d * p) +
      w * (-r * l * p - t * u * m + t * l * v + r * o * m - i * o * v + i * u * p)
    )
  }
  transpose() {
    const e = this.elements
    let t
    return (
      (t = e[1]),
      (e[1] = e[4]),
      (e[4] = t),
      (t = e[2]),
      (e[2] = e[8]),
      (e[8] = t),
      (t = e[6]),
      (e[6] = e[9]),
      (e[9] = t),
      (t = e[3]),
      (e[3] = e[12]),
      (e[12] = t),
      (t = e[7]),
      (e[7] = e[13]),
      (e[13] = t),
      (t = e[11]),
      (e[11] = e[14]),
      (e[14] = t),
      this
    )
  }
  setPosition(e, t, i) {
    const r = this.elements
    return (
      e.isVector3
        ? ((r[12] = e.x), (r[13] = e.y), (r[14] = e.z))
        : ((r[12] = e), (r[13] = t), (r[14] = i)),
      this
    )
  }
  invert() {
    const e = this.elements,
      t = e[0],
      i = e[1],
      r = e[2],
      s = e[3],
      o = e[4],
      l = e[5],
      u = e[6],
      d = e[7],
      p = e[8],
      m = e[9],
      v = e[10],
      y = e[11],
      x = e[12],
      E = e[13],
      M = e[14],
      w = e[15],
      A = m * M * d - E * v * d + E * u * y - l * M * y - m * u * w + l * v * w,
      C = x * v * d - p * M * d - x * u * y + o * M * y + p * u * w - o * v * w,
      R = p * E * d - x * m * d + x * l * y - o * E * y - p * l * w + o * m * w,
      z = x * m * u - p * E * u - x * l * v + o * E * v + p * l * M - o * m * M,
      U = t * A + i * C + r * R + s * z
    if (U === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0)
    const O = 1 / U
    return (
      (e[0] = A * O),
      (e[1] =
        (E * v * s - m * M * s - E * r * y + i * M * y + m * r * w - i * v * w) * O),
      (e[2] =
        (l * M * s - E * u * s + E * r * d - i * M * d - l * r * w + i * u * w) * O),
      (e[3] =
        (m * u * s - l * v * s - m * r * d + i * v * d + l * r * y - i * u * y) * O),
      (e[4] = C * O),
      (e[5] =
        (p * M * s - x * v * s + x * r * y - t * M * y - p * r * w + t * v * w) * O),
      (e[6] =
        (x * u * s - o * M * s - x * r * d + t * M * d + o * r * w - t * u * w) * O),
      (e[7] =
        (o * v * s - p * u * s + p * r * d - t * v * d - o * r * y + t * u * y) * O),
      (e[8] = R * O),
      (e[9] =
        (x * m * s - p * E * s - x * i * y + t * E * y + p * i * w - t * m * w) * O),
      (e[10] =
        (o * E * s - x * l * s + x * i * d - t * E * d - o * i * w + t * l * w) * O),
      (e[11] =
        (p * l * s - o * m * s - p * i * d + t * m * d + o * i * y - t * l * y) * O),
      (e[12] = z * O),
      (e[13] =
        (p * E * r - x * m * r + x * i * v - t * E * v - p * i * M + t * m * M) * O),
      (e[14] =
        (x * l * r - o * E * r - x * i * u + t * E * u + o * i * M - t * l * M) * O),
      (e[15] =
        (o * m * r - p * l * r + p * i * u - t * m * u - o * i * v + t * l * v) * O),
      this
    )
  }
  scale(e) {
    const t = this.elements,
      i = e.x,
      r = e.y,
      s = e.z
    return (
      (t[0] *= i),
      (t[4] *= r),
      (t[8] *= s),
      (t[1] *= i),
      (t[5] *= r),
      (t[9] *= s),
      (t[2] *= i),
      (t[6] *= r),
      (t[10] *= s),
      (t[3] *= i),
      (t[7] *= r),
      (t[11] *= s),
      this
    )
  }
  getMaxScaleOnAxis() {
    const e = this.elements,
      t = e[0] * e[0] + e[1] * e[1] + e[2] * e[2],
      i = e[4] * e[4] + e[5] * e[5] + e[6] * e[6],
      r = e[8] * e[8] + e[9] * e[9] + e[10] * e[10]
    return Math.sqrt(Math.max(t, i, r))
  }
  makeTranslation(e, t, i) {
    return (
      e.isVector3
        ? this.set(1, 0, 0, e.x, 0, 1, 0, e.y, 0, 0, 1, e.z, 0, 0, 0, 1)
        : this.set(1, 0, 0, e, 0, 1, 0, t, 0, 0, 1, i, 0, 0, 0, 1),
      this
    )
  }
  makeRotationX(e) {
    const t = Math.cos(e),
      i = Math.sin(e)
    return this.set(1, 0, 0, 0, 0, t, -i, 0, 0, i, t, 0, 0, 0, 0, 1), this
  }
  makeRotationY(e) {
    const t = Math.cos(e),
      i = Math.sin(e)
    return this.set(t, 0, i, 0, 0, 1, 0, 0, -i, 0, t, 0, 0, 0, 0, 1), this
  }
  makeRotationZ(e) {
    const t = Math.cos(e),
      i = Math.sin(e)
    return this.set(t, -i, 0, 0, i, t, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this
  }
  makeRotationAxis(e, t) {
    const i = Math.cos(t),
      r = Math.sin(t),
      s = 1 - i,
      o = e.x,
      l = e.y,
      u = e.z,
      d = s * o,
      p = s * l
    return (
      this.set(
        d * o + i,
        d * l - r * u,
        d * u + r * l,
        0,
        d * l + r * u,
        p * l + i,
        p * u - r * o,
        0,
        d * u - r * l,
        p * u + r * o,
        s * u * u + i,
        0,
        0,
        0,
        0,
        1,
      ),
      this
    )
  }
  makeScale(e, t, i) {
    return this.set(e, 0, 0, 0, 0, t, 0, 0, 0, 0, i, 0, 0, 0, 0, 1), this
  }
  makeShear(e, t, i, r, s, o) {
    return this.set(1, i, s, 0, e, 1, o, 0, t, r, 1, 0, 0, 0, 0, 1), this
  }
  compose(e, t, i) {
    const r = this.elements,
      s = t._x,
      o = t._y,
      l = t._z,
      u = t._w,
      d = s + s,
      p = o + o,
      m = l + l,
      v = s * d,
      y = s * p,
      x = s * m,
      E = o * p,
      M = o * m,
      w = l * m,
      A = u * d,
      C = u * p,
      R = u * m,
      z = i.x,
      U = i.y,
      O = i.z
    return (
      (r[0] = (1 - (E + w)) * z),
      (r[1] = (y + R) * z),
      (r[2] = (x - C) * z),
      (r[3] = 0),
      (r[4] = (y - R) * U),
      (r[5] = (1 - (v + w)) * U),
      (r[6] = (M + A) * U),
      (r[7] = 0),
      (r[8] = (x + C) * O),
      (r[9] = (M - A) * O),
      (r[10] = (1 - (v + E)) * O),
      (r[11] = 0),
      (r[12] = e.x),
      (r[13] = e.y),
      (r[14] = e.z),
      (r[15] = 1),
      this
    )
  }
  decompose(e, t, i) {
    const r = this.elements
    let s = Jf.set(r[0], r[1], r[2]).length()
    const o = Jf.set(r[4], r[5], r[6]).length(),
      l = Jf.set(r[8], r[9], r[10]).length()
    this.determinant() < 0 && (s = -s),
      (e.x = r[12]),
      (e.y = r[13]),
      (e.z = r[14]),
      uo.copy(this)
    const d = 1 / s,
      p = 1 / o,
      m = 1 / l
    return (
      (uo.elements[0] *= d),
      (uo.elements[1] *= d),
      (uo.elements[2] *= d),
      (uo.elements[4] *= p),
      (uo.elements[5] *= p),
      (uo.elements[6] *= p),
      (uo.elements[8] *= m),
      (uo.elements[9] *= m),
      (uo.elements[10] *= m),
      t.setFromRotationMatrix(uo),
      (i.x = s),
      (i.y = o),
      (i.z = l),
      this
    )
  }
  makePerspective(e, t, i, r, s, o, l = Go) {
    const u = this.elements,
      d = (2 * s) / (t - e),
      p = (2 * s) / (i - r),
      m = (t + e) / (t - e),
      v = (i + r) / (i - r)
    let y, x
    if (l === Go) (y = -(o + s) / (o - s)), (x = (-2 * o * s) / (o - s))
    else if (l === $p) (y = -o / (o - s)), (x = (-o * s) / (o - s))
    else
      throw new Error(
        "THREE.Matrix4.makePerspective(): Invalid coordinate system: " + l,
      )
    return (
      (u[0] = d),
      (u[4] = 0),
      (u[8] = m),
      (u[12] = 0),
      (u[1] = 0),
      (u[5] = p),
      (u[9] = v),
      (u[13] = 0),
      (u[2] = 0),
      (u[6] = 0),
      (u[10] = y),
      (u[14] = x),
      (u[3] = 0),
      (u[7] = 0),
      (u[11] = -1),
      (u[15] = 0),
      this
    )
  }
  makeOrthographic(e, t, i, r, s, o, l = Go) {
    const u = this.elements,
      d = 1 / (t - e),
      p = 1 / (i - r),
      m = 1 / (o - s),
      v = (t + e) * d,
      y = (i + r) * p
    let x, E
    if (l === Go) (x = (o + s) * m), (E = -2 * m)
    else if (l === $p) (x = s * m), (E = -1 * m)
    else
      throw new Error(
        "THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + l,
      )
    return (
      (u[0] = 2 * d),
      (u[4] = 0),
      (u[8] = 0),
      (u[12] = -v),
      (u[1] = 0),
      (u[5] = 2 * p),
      (u[9] = 0),
      (u[13] = -y),
      (u[2] = 0),
      (u[6] = 0),
      (u[10] = E),
      (u[14] = -x),
      (u[3] = 0),
      (u[7] = 0),
      (u[11] = 0),
      (u[15] = 1),
      this
    )
  }
  equals(e) {
    const t = this.elements,
      i = e.elements
    for (let r = 0; r < 16; r++) if (t[r] !== i[r]) return !1
    return !0
  }
  fromArray(e, t = 0) {
    for (let i = 0; i < 16; i++) this.elements[i] = e[i + t]
    return this
  }
  toArray(e = [], t = 0) {
    const i = this.elements
    return (
      (e[t] = i[0]),
      (e[t + 1] = i[1]),
      (e[t + 2] = i[2]),
      (e[t + 3] = i[3]),
      (e[t + 4] = i[4]),
      (e[t + 5] = i[5]),
      (e[t + 6] = i[6]),
      (e[t + 7] = i[7]),
      (e[t + 8] = i[8]),
      (e[t + 9] = i[9]),
      (e[t + 10] = i[10]),
      (e[t + 11] = i[11]),
      (e[t + 12] = i[12]),
      (e[t + 13] = i[13]),
      (e[t + 14] = i[14]),
      (e[t + 15] = i[15]),
      e
    )
  }
}
const Jf = new q(),
  uo = new mt(),
  UO = new q(0, 0, 0),
  OO = new q(1, 1, 1),
  Ol = new q(),
  kg = new q(),
  ms = new q(),
  rT = new mt(),
  sT = new Oi()
class Bi {
  constructor(e = 0, t = 0, i = 0, r = Bi.DEFAULT_ORDER) {
    ;(this.isEuler = !0), (this._x = e), (this._y = t), (this._z = i), (this._order = r)
  }
  get x() {
    return this._x
  }
  set x(e) {
    ;(this._x = e), this._onChangeCallback()
  }
  get y() {
    return this._y
  }
  set y(e) {
    ;(this._y = e), this._onChangeCallback()
  }
  get z() {
    return this._z
  }
  set z(e) {
    ;(this._z = e), this._onChangeCallback()
  }
  get order() {
    return this._order
  }
  set order(e) {
    ;(this._order = e), this._onChangeCallback()
  }
  set(e, t, i, r = this._order) {
    return (
      (this._x = e),
      (this._y = t),
      (this._z = i),
      (this._order = r),
      this._onChangeCallback(),
      this
    )
  }
  clone() {
    return new this.constructor(this._x, this._y, this._z, this._order)
  }
  copy(e) {
    return (
      (this._x = e._x),
      (this._y = e._y),
      (this._z = e._z),
      (this._order = e._order),
      this._onChangeCallback(),
      this
    )
  }
  setFromRotationMatrix(e, t = this._order, i = !0) {
    const r = e.elements,
      s = r[0],
      o = r[4],
      l = r[8],
      u = r[1],
      d = r[5],
      p = r[9],
      m = r[2],
      v = r[6],
      y = r[10]
    switch (t) {
      case "XYZ":
        ;(this._y = Math.asin(ri(l, -1, 1))),
          Math.abs(l) < 0.9999999
            ? ((this._x = Math.atan2(-p, y)), (this._z = Math.atan2(-o, s)))
            : ((this._x = Math.atan2(v, d)), (this._z = 0))
        break
      case "YXZ":
        ;(this._x = Math.asin(-ri(p, -1, 1))),
          Math.abs(p) < 0.9999999
            ? ((this._y = Math.atan2(l, y)), (this._z = Math.atan2(u, d)))
            : ((this._y = Math.atan2(-m, s)), (this._z = 0))
        break
      case "ZXY":
        ;(this._x = Math.asin(ri(v, -1, 1))),
          Math.abs(v) < 0.9999999
            ? ((this._y = Math.atan2(-m, y)), (this._z = Math.atan2(-o, d)))
            : ((this._y = 0), (this._z = Math.atan2(u, s)))
        break
      case "ZYX":
        ;(this._y = Math.asin(-ri(m, -1, 1))),
          Math.abs(m) < 0.9999999
            ? ((this._x = Math.atan2(v, y)), (this._z = Math.atan2(u, s)))
            : ((this._x = 0), (this._z = Math.atan2(-o, d)))
        break
      case "YZX":
        ;(this._z = Math.asin(ri(u, -1, 1))),
          Math.abs(u) < 0.9999999
            ? ((this._x = Math.atan2(-p, d)), (this._y = Math.atan2(-m, s)))
            : ((this._x = 0), (this._y = Math.atan2(l, y)))
        break
      case "XZY":
        ;(this._z = Math.asin(-ri(o, -1, 1))),
          Math.abs(o) < 0.9999999
            ? ((this._x = Math.atan2(v, d)), (this._y = Math.atan2(l, s)))
            : ((this._x = Math.atan2(-p, y)), (this._y = 0))
        break
      default:
        console.warn(
          "THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + t,
        )
    }
    return (this._order = t), i === !0 && this._onChangeCallback(), this
  }
  setFromQuaternion(e, t, i) {
    return rT.makeRotationFromQuaternion(e), this.setFromRotationMatrix(rT, t, i)
  }
  setFromVector3(e, t = this._order) {
    return this.set(e.x, e.y, e.z, t)
  }
  reorder(e) {
    return sT.setFromEuler(this), this.setFromQuaternion(sT, e)
  }
  equals(e) {
    return (
      e._x === this._x &&
      e._y === this._y &&
      e._z === this._z &&
      e._order === this._order
    )
  }
  fromArray(e) {
    return (
      (this._x = e[0]),
      (this._y = e[1]),
      (this._z = e[2]),
      e[3] !== void 0 && (this._order = e[3]),
      this._onChangeCallback(),
      this
    )
  }
  toArray(e = [], t = 0) {
    return (
      (e[t] = this._x),
      (e[t + 1] = this._y),
      (e[t + 2] = this._z),
      (e[t + 3] = this._order),
      e
    )
  }
  _onChange(e) {
    return (this._onChangeCallback = e), this
  }
  _onChangeCallback() {}
  *[Symbol.iterator]() {
    yield this._x, yield this._y, yield this._z, yield this._order
  }
}
Bi.DEFAULT_ORDER = "XYZ"
class Au {
  constructor() {
    this.mask = 1
  }
  set(e) {
    this.mask = ((1 << e) | 0) >>> 0
  }
  enable(e) {
    this.mask |= (1 << e) | 0
  }
  enableAll() {
    this.mask = -1
  }
  toggle(e) {
    this.mask ^= (1 << e) | 0
  }
  disable(e) {
    this.mask &= ~((1 << e) | 0)
  }
  disableAll() {
    this.mask = 0
  }
  test(e) {
    return (this.mask & e.mask) !== 0
  }
  isEnabled(e) {
    return (this.mask & ((1 << e) | 0)) !== 0
  }
}
let BO = 0
const oT = new q(),
  Qf = new Oi(),
  ka = new mt(),
  Fg = new q(),
  $h = new q(),
  zO = new q(),
  VO = new Oi(),
  aT = new q(1, 0, 0),
  lT = new q(0, 1, 0),
  cT = new q(0, 0, 1),
  uT = { type: "added" },
  HO = { type: "removed" },
  ed = { type: "childadded", child: null },
  Bx = { type: "childremoved", child: null }
class cn extends Jo {
  constructor() {
    super(),
      (this.isObject3D = !0),
      Object.defineProperty(this, "id", { value: BO++ }),
      (this.uuid = vs()),
      (this.name = ""),
      (this.type = "Object3D"),
      (this.parent = null),
      (this.children = []),
      (this.up = cn.DEFAULT_UP.clone())
    const e = new q(),
      t = new Bi(),
      i = new Oi(),
      r = new q(1, 1, 1)
    function s() {
      i.setFromEuler(t, !1)
    }
    function o() {
      t.setFromQuaternion(i, void 0, !1)
    }
    t._onChange(s),
      i._onChange(o),
      Object.defineProperties(this, {
        position: { configurable: !0, enumerable: !0, value: e },
        rotation: { configurable: !0, enumerable: !0, value: t },
        quaternion: { configurable: !0, enumerable: !0, value: i },
        scale: { configurable: !0, enumerable: !0, value: r },
        modelViewMatrix: { value: new mt() },
        normalMatrix: { value: new Xt() },
      }),
      (this.matrix = new mt()),
      (this.matrixWorld = new mt()),
      (this.matrixAutoUpdate = cn.DEFAULT_MATRIX_AUTO_UPDATE),
      (this.matrixWorldAutoUpdate = cn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE),
      (this.matrixWorldNeedsUpdate = !1),
      (this.layers = new Au()),
      (this.visible = !0),
      (this.castShadow = !1),
      (this.receiveShadow = !1),
      (this.frustumCulled = !0),
      (this.renderOrder = 0),
      (this.animations = []),
      (this.userData = {})
  }
  onBeforeShadow() {}
  onAfterShadow() {}
  onBeforeRender() {}
  onAfterRender() {}
  applyMatrix4(e) {
    this.matrixAutoUpdate && this.updateMatrix(),
      this.matrix.premultiply(e),
      this.matrix.decompose(this.position, this.quaternion, this.scale)
  }
  applyQuaternion(e) {
    return this.quaternion.premultiply(e), this
  }
  setRotationFromAxisAngle(e, t) {
    this.quaternion.setFromAxisAngle(e, t)
  }
  setRotationFromEuler(e) {
    this.quaternion.setFromEuler(e, !0)
  }
  setRotationFromMatrix(e) {
    this.quaternion.setFromRotationMatrix(e)
  }
  setRotationFromQuaternion(e) {
    this.quaternion.copy(e)
  }
  rotateOnAxis(e, t) {
    return Qf.setFromAxisAngle(e, t), this.quaternion.multiply(Qf), this
  }
  rotateOnWorldAxis(e, t) {
    return Qf.setFromAxisAngle(e, t), this.quaternion.premultiply(Qf), this
  }
  rotateX(e) {
    return this.rotateOnAxis(aT, e)
  }
  rotateY(e) {
    return this.rotateOnAxis(lT, e)
  }
  rotateZ(e) {
    return this.rotateOnAxis(cT, e)
  }
  translateOnAxis(e, t) {
    return (
      oT.copy(e).applyQuaternion(this.quaternion),
      this.position.add(oT.multiplyScalar(t)),
      this
    )
  }
  translateX(e) {
    return this.translateOnAxis(aT, e)
  }
  translateY(e) {
    return this.translateOnAxis(lT, e)
  }
  translateZ(e) {
    return this.translateOnAxis(cT, e)
  }
  localToWorld(e) {
    return this.updateWorldMatrix(!0, !1), e.applyMatrix4(this.matrixWorld)
  }
  worldToLocal(e) {
    return (
      this.updateWorldMatrix(!0, !1), e.applyMatrix4(ka.copy(this.matrixWorld).invert())
    )
  }
  lookAt(e, t, i) {
    e.isVector3 ? Fg.copy(e) : Fg.set(e, t, i)
    const r = this.parent
    this.updateWorldMatrix(!0, !1),
      $h.setFromMatrixPosition(this.matrixWorld),
      this.isCamera || this.isLight
        ? ka.lookAt($h, Fg, this.up)
        : ka.lookAt(Fg, $h, this.up),
      this.quaternion.setFromRotationMatrix(ka),
      r &&
        (ka.extractRotation(r.matrixWorld),
        Qf.setFromRotationMatrix(ka),
        this.quaternion.premultiply(Qf.invert()))
  }
  add(e) {
    if (arguments.length > 1) {
      for (let t = 0; t < arguments.length; t++) this.add(arguments[t])
      return this
    }
    return e === this
      ? (console.error(
          "THREE.Object3D.add: object can't be added as a child of itself.",
          e,
        ),
        this)
      : (e && e.isObject3D
          ? (e.removeFromParent(),
            (e.parent = this),
            this.children.push(e),
            e.dispatchEvent(uT),
            (ed.child = e),
            this.dispatchEvent(ed),
            (ed.child = null))
          : console.error(
              "THREE.Object3D.add: object not an instance of THREE.Object3D.",
              e,
            ),
        this)
  }
  remove(e) {
    if (arguments.length > 1) {
      for (let i = 0; i < arguments.length; i++) this.remove(arguments[i])
      return this
    }
    const t = this.children.indexOf(e)
    return (
      t !== -1 &&
        ((e.parent = null),
        this.children.splice(t, 1),
        e.dispatchEvent(HO),
        (Bx.child = e),
        this.dispatchEvent(Bx),
        (Bx.child = null)),
      this
    )
  }
  removeFromParent() {
    const e = this.parent
    return e !== null && e.remove(this), this
  }
  clear() {
    return this.remove(...this.children)
  }
  attach(e) {
    return (
      this.updateWorldMatrix(!0, !1),
      ka.copy(this.matrixWorld).invert(),
      e.parent !== null &&
        (e.parent.updateWorldMatrix(!0, !1), ka.multiply(e.parent.matrixWorld)),
      e.applyMatrix4(ka),
      e.removeFromParent(),
      (e.parent = this),
      this.children.push(e),
      e.updateWorldMatrix(!1, !0),
      e.dispatchEvent(uT),
      (ed.child = e),
      this.dispatchEvent(ed),
      (ed.child = null),
      this
    )
  }
  getObjectById(e) {
    return this.getObjectByProperty("id", e)
  }
  getObjectByName(e) {
    return this.getObjectByProperty("name", e)
  }
  getObjectByProperty(e, t) {
    if (this[e] === t) return this
    for (let i = 0, r = this.children.length; i < r; i++) {
      const o = this.children[i].getObjectByProperty(e, t)
      if (o !== void 0) return o
    }
  }
  getObjectsByProperty(e, t, i = []) {
    this[e] === t && i.push(this)
    const r = this.children
    for (let s = 0, o = r.length; s < o; s++) r[s].getObjectsByProperty(e, t, i)
    return i
  }
  getWorldPosition(e) {
    return this.updateWorldMatrix(!0, !1), e.setFromMatrixPosition(this.matrixWorld)
  }
  getWorldQuaternion(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($h, e, zO), e
  }
  getWorldScale(e) {
    return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose($h, VO, e), e
  }
  getWorldDirection(e) {
    this.updateWorldMatrix(!0, !1)
    const t = this.matrixWorld.elements
    return e.set(t[8], t[9], t[10]).normalize()
  }
  raycast() {}
  traverse(e) {
    e(this)
    const t = this.children
    for (let i = 0, r = t.length; i < r; i++) t[i].traverse(e)
  }
  traverseVisible(e) {
    if (this.visible === !1) return
    e(this)
    const t = this.children
    for (let i = 0, r = t.length; i < r; i++) t[i].traverseVisible(e)
  }
  traverseAncestors(e) {
    const t = this.parent
    t !== null && (e(t), t.traverseAncestors(e))
  }
  updateMatrix() {
    this.matrix.compose(this.position, this.quaternion, this.scale),
      (this.matrixWorldNeedsUpdate = !0)
  }
  updateMatrixWorld(e) {
    this.matrixAutoUpdate && this.updateMatrix(),
      (this.matrixWorldNeedsUpdate || e) &&
        (this.matrixWorldAutoUpdate === !0 &&
          (this.parent === null
            ? this.matrixWorld.copy(this.matrix)
            : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)),
        (this.matrixWorldNeedsUpdate = !1),
        (e = !0))
    const t = this.children
    for (let i = 0, r = t.length; i < r; i++) t[i].updateMatrixWorld(e)
  }
  updateWorldMatrix(e, t) {
    const i = this.parent
    if (
      (e === !0 && i !== null && i.updateWorldMatrix(!0, !1),
      this.matrixAutoUpdate && this.updateMatrix(),
      this.matrixWorldAutoUpdate === !0 &&
        (this.parent === null
          ? this.matrixWorld.copy(this.matrix)
          : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)),
      t === !0)
    ) {
      const r = this.children
      for (let s = 0, o = r.length; s < o; s++) r[s].updateWorldMatrix(!1, !0)
    }
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string",
      i = {}
    t &&
      ((e = {
        geometries: {},
        materials: {},
        textures: {},
        images: {},
        shapes: {},
        skeletons: {},
        animations: {},
        nodes: {},
      }),
      (i.metadata = { version: 4.6, type: "Object", generator: "Object3D.toJSON" }))
    const r = {}
    ;(r.uuid = this.uuid),
      (r.type = this.type),
      this.name !== "" && (r.name = this.name),
      this.castShadow === !0 && (r.castShadow = !0),
      this.receiveShadow === !0 && (r.receiveShadow = !0),
      this.visible === !1 && (r.visible = !1),
      this.frustumCulled === !1 && (r.frustumCulled = !1),
      this.renderOrder !== 0 && (r.renderOrder = this.renderOrder),
      Object.keys(this.userData).length > 0 && (r.userData = this.userData),
      (r.layers = this.layers.mask),
      (r.matrix = this.matrix.toArray()),
      (r.up = this.up.toArray()),
      this.matrixAutoUpdate === !1 && (r.matrixAutoUpdate = !1),
      this.isInstancedMesh &&
        ((r.type = "InstancedMesh"),
        (r.count = this.count),
        (r.instanceMatrix = this.instanceMatrix.toJSON()),
        this.instanceColor !== null && (r.instanceColor = this.instanceColor.toJSON())),
      this.isBatchedMesh &&
        ((r.type = "BatchedMesh"),
        (r.perObjectFrustumCulled = this.perObjectFrustumCulled),
        (r.sortObjects = this.sortObjects),
        (r.drawRanges = this._drawRanges),
        (r.reservedRanges = this._reservedRanges),
        (r.visibility = this._visibility),
        (r.active = this._active),
        (r.bounds = this._bounds.map((l) => ({
          boxInitialized: l.boxInitialized,
          boxMin: l.box.min.toArray(),
          boxMax: l.box.max.toArray(),
          sphereInitialized: l.sphereInitialized,
          sphereRadius: l.sphere.radius,
          sphereCenter: l.sphere.center.toArray(),
        }))),
        (r.maxInstanceCount = this._maxInstanceCount),
        (r.maxVertexCount = this._maxVertexCount),
        (r.maxIndexCount = this._maxIndexCount),
        (r.geometryInitialized = this._geometryInitialized),
        (r.geometryCount = this._geometryCount),
        (r.matricesTexture = this._matricesTexture.toJSON(e)),
        this._colorsTexture !== null &&
          (r.colorsTexture = this._colorsTexture.toJSON(e)),
        this.boundingSphere !== null &&
          (r.boundingSphere = {
            center: r.boundingSphere.center.toArray(),
            radius: r.boundingSphere.radius,
          }),
        this.boundingBox !== null &&
          (r.boundingBox = {
            min: r.boundingBox.min.toArray(),
            max: r.boundingBox.max.toArray(),
          }))
    function s(l, u) {
      return l[u.uuid] === void 0 && (l[u.uuid] = u.toJSON(e)), u.uuid
    }
    if (this.isScene)
      this.background &&
        (this.background.isColor
          ? (r.background = this.background.toJSON())
          : this.background.isTexture &&
            (r.background = this.background.toJSON(e).uuid)),
        this.environment &&
          this.environment.isTexture &&
          this.environment.isRenderTargetTexture !== !0 &&
          (r.environment = this.environment.toJSON(e).uuid)
    else if (this.isMesh || this.isLine || this.isPoints) {
      r.geometry = s(e.geometries, this.geometry)
      const l = this.geometry.parameters
      if (l !== void 0 && l.shapes !== void 0) {
        const u = l.shapes
        if (Array.isArray(u))
          for (let d = 0, p = u.length; d < p; d++) {
            const m = u[d]
            s(e.shapes, m)
          }
        else s(e.shapes, u)
      }
    }
    if (
      (this.isSkinnedMesh &&
        ((r.bindMode = this.bindMode),
        (r.bindMatrix = this.bindMatrix.toArray()),
        this.skeleton !== void 0 &&
          (s(e.skeletons, this.skeleton), (r.skeleton = this.skeleton.uuid))),
      this.material !== void 0)
    )
      if (Array.isArray(this.material)) {
        const l = []
        for (let u = 0, d = this.material.length; u < d; u++)
          l.push(s(e.materials, this.material[u]))
        r.material = l
      } else r.material = s(e.materials, this.material)
    if (this.children.length > 0) {
      r.children = []
      for (let l = 0; l < this.children.length; l++)
        r.children.push(this.children[l].toJSON(e).object)
    }
    if (this.animations.length > 0) {
      r.animations = []
      for (let l = 0; l < this.animations.length; l++) {
        const u = this.animations[l]
        r.animations.push(s(e.animations, u))
      }
    }
    if (t) {
      const l = o(e.geometries),
        u = o(e.materials),
        d = o(e.textures),
        p = o(e.images),
        m = o(e.shapes),
        v = o(e.skeletons),
        y = o(e.animations),
        x = o(e.nodes)
      l.length > 0 && (i.geometries = l),
        u.length > 0 && (i.materials = u),
        d.length > 0 && (i.textures = d),
        p.length > 0 && (i.images = p),
        m.length > 0 && (i.shapes = m),
        v.length > 0 && (i.skeletons = v),
        y.length > 0 && (i.animations = y),
        x.length > 0 && (i.nodes = x)
    }
    return (i.object = r), i
    function o(l) {
      const u = []
      for (const d in l) {
        const p = l[d]
        delete p.metadata, u.push(p)
      }
      return u
    }
  }
  clone(e) {
    return new this.constructor().copy(this, e)
  }
  copy(e, t = !0) {
    if (
      ((this.name = e.name),
      this.up.copy(e.up),
      this.position.copy(e.position),
      (this.rotation.order = e.rotation.order),
      this.quaternion.copy(e.quaternion),
      this.scale.copy(e.scale),
      this.matrix.copy(e.matrix),
      this.matrixWorld.copy(e.matrixWorld),
      (this.matrixAutoUpdate = e.matrixAutoUpdate),
      (this.matrixWorldAutoUpdate = e.matrixWorldAutoUpdate),
      (this.matrixWorldNeedsUpdate = e.matrixWorldNeedsUpdate),
      (this.layers.mask = e.layers.mask),
      (this.visible = e.visible),
      (this.castShadow = e.castShadow),
      (this.receiveShadow = e.receiveShadow),
      (this.frustumCulled = e.frustumCulled),
      (this.renderOrder = e.renderOrder),
      (this.animations = e.animations.slice()),
      (this.userData = JSON.parse(JSON.stringify(e.userData))),
      t === !0)
    )
      for (let i = 0; i < e.children.length; i++) {
        const r = e.children[i]
        this.add(r.clone())
      }
    return this
  }
}
cn.DEFAULT_UP = new q(0, 1, 0)
cn.DEFAULT_MATRIX_AUTO_UPDATE = !0
cn.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0
const fo = new q(),
  Fa = new q(),
  zx = new q(),
  Ua = new q(),
  td = new q(),
  nd = new q(),
  fT = new q(),
  Vx = new q(),
  Hx = new q(),
  Gx = new q(),
  Wx = new on(),
  jx = new on(),
  Xx = new on()
class Zr {
  constructor(e = new q(), t = new q(), i = new q()) {
    ;(this.a = e), (this.b = t), (this.c = i)
  }
  static getNormal(e, t, i, r) {
    r.subVectors(i, t), fo.subVectors(e, t), r.cross(fo)
    const s = r.lengthSq()
    return s > 0 ? r.multiplyScalar(1 / Math.sqrt(s)) : r.set(0, 0, 0)
  }
  static getBarycoord(e, t, i, r, s) {
    fo.subVectors(r, t), Fa.subVectors(i, t), zx.subVectors(e, t)
    const o = fo.dot(fo),
      l = fo.dot(Fa),
      u = fo.dot(zx),
      d = Fa.dot(Fa),
      p = Fa.dot(zx),
      m = o * d - l * l
    if (m === 0) return s.set(0, 0, 0), null
    const v = 1 / m,
      y = (d * u - l * p) * v,
      x = (o * p - l * u) * v
    return s.set(1 - y - x, x, y)
  }
  static containsPoint(e, t, i, r) {
    return this.getBarycoord(e, t, i, r, Ua) === null
      ? !1
      : Ua.x >= 0 && Ua.y >= 0 && Ua.x + Ua.y <= 1
  }
  static getInterpolation(e, t, i, r, s, o, l, u) {
    return this.getBarycoord(e, t, i, r, Ua) === null
      ? ((u.x = 0), (u.y = 0), "z" in u && (u.z = 0), "w" in u && (u.w = 0), null)
      : (u.setScalar(0),
        u.addScaledVector(s, Ua.x),
        u.addScaledVector(o, Ua.y),
        u.addScaledVector(l, Ua.z),
        u)
  }
  static getInterpolatedAttribute(e, t, i, r, s, o) {
    return (
      Wx.setScalar(0),
      jx.setScalar(0),
      Xx.setScalar(0),
      Wx.fromBufferAttribute(e, t),
      jx.fromBufferAttribute(e, i),
      Xx.fromBufferAttribute(e, r),
      o.setScalar(0),
      o.addScaledVector(Wx, s.x),
      o.addScaledVector(jx, s.y),
      o.addScaledVector(Xx, s.z),
      o
    )
  }
  static isFrontFacing(e, t, i, r) {
    return fo.subVectors(i, t), Fa.subVectors(e, t), fo.cross(Fa).dot(r) < 0
  }
  set(e, t, i) {
    return this.a.copy(e), this.b.copy(t), this.c.copy(i), this
  }
  setFromPointsAndIndices(e, t, i, r) {
    return this.a.copy(e[t]), this.b.copy(e[i]), this.c.copy(e[r]), this
  }
  setFromAttributeAndIndices(e, t, i, r) {
    return (
      this.a.fromBufferAttribute(e, t),
      this.b.fromBufferAttribute(e, i),
      this.c.fromBufferAttribute(e, r),
      this
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(e) {
    return this.a.copy(e.a), this.b.copy(e.b), this.c.copy(e.c), this
  }
  getArea() {
    return (
      fo.subVectors(this.c, this.b),
      Fa.subVectors(this.a, this.b),
      fo.cross(Fa).length() * 0.5
    )
  }
  getMidpoint(e) {
    return e
      .addVectors(this.a, this.b)
      .add(this.c)
      .multiplyScalar(1 / 3)
  }
  getNormal(e) {
    return Zr.getNormal(this.a, this.b, this.c, e)
  }
  getPlane(e) {
    return e.setFromCoplanarPoints(this.a, this.b, this.c)
  }
  getBarycoord(e, t) {
    return Zr.getBarycoord(e, this.a, this.b, this.c, t)
  }
  getInterpolation(e, t, i, r, s) {
    return Zr.getInterpolation(e, this.a, this.b, this.c, t, i, r, s)
  }
  containsPoint(e) {
    return Zr.containsPoint(e, this.a, this.b, this.c)
  }
  isFrontFacing(e) {
    return Zr.isFrontFacing(this.a, this.b, this.c, e)
  }
  intersectsBox(e) {
    return e.intersectsTriangle(this)
  }
  closestPointToPoint(e, t) {
    const i = this.a,
      r = this.b,
      s = this.c
    let o, l
    td.subVectors(r, i), nd.subVectors(s, i), Vx.subVectors(e, i)
    const u = td.dot(Vx),
      d = nd.dot(Vx)
    if (u <= 0 && d <= 0) return t.copy(i)
    Hx.subVectors(e, r)
    const p = td.dot(Hx),
      m = nd.dot(Hx)
    if (p >= 0 && m <= p) return t.copy(r)
    const v = u * m - p * d
    if (v <= 0 && u >= 0 && p <= 0)
      return (o = u / (u - p)), t.copy(i).addScaledVector(td, o)
    Gx.subVectors(e, s)
    const y = td.dot(Gx),
      x = nd.dot(Gx)
    if (x >= 0 && y <= x) return t.copy(s)
    const E = y * d - u * x
    if (E <= 0 && d >= 0 && x <= 0)
      return (l = d / (d - x)), t.copy(i).addScaledVector(nd, l)
    const M = p * x - y * m
    if (M <= 0 && m - p >= 0 && y - x >= 0)
      return (
        fT.subVectors(s, r),
        (l = (m - p) / (m - p + (y - x))),
        t.copy(r).addScaledVector(fT, l)
      )
    const w = 1 / (M + E + v)
    return (
      (o = E * w), (l = v * w), t.copy(i).addScaledVector(td, o).addScaledVector(nd, l)
    )
  }
  equals(e) {
    return e.a.equals(this.a) && e.b.equals(this.b) && e.c.equals(this.c)
  }
}
const v3 = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074,
  },
  Bl = { h: 0, s: 0, l: 0 },
  Ug = { h: 0, s: 0, l: 0 }
function Yx(n, e, t) {
  return (
    t < 0 && (t += 1),
    t > 1 && (t -= 1),
    t < 1 / 6
      ? n + (e - n) * 6 * t
      : t < 1 / 2
      ? e
      : t < 2 / 3
      ? n + (e - n) * 6 * (2 / 3 - t)
      : n
  )
}
class ot {
  constructor(e, t, i) {
    return (
      (this.isColor = !0), (this.r = 1), (this.g = 1), (this.b = 1), this.set(e, t, i)
    )
  }
  set(e, t, i) {
    if (t === void 0 && i === void 0) {
      const r = e
      r && r.isColor
        ? this.copy(r)
        : typeof r == "number"
        ? this.setHex(r)
        : typeof r == "string" && this.setStyle(r)
    } else this.setRGB(e, t, i)
    return this
  }
  setScalar(e) {
    return (this.r = e), (this.g = e), (this.b = e), this
  }
  setHex(e, t = Kr) {
    return (
      (e = Math.floor(e)),
      (this.r = ((e >> 16) & 255) / 255),
      (this.g = ((e >> 8) & 255) / 255),
      (this.b = (e & 255) / 255),
      fn.toWorkingColorSpace(this, t),
      this
    )
  }
  setRGB(e, t, i, r = fn.workingColorSpace) {
    return (
      (this.r = e), (this.g = t), (this.b = i), fn.toWorkingColorSpace(this, r), this
    )
  }
  setHSL(e, t, i, r = fn.workingColorSpace) {
    if (((e = Uw(e, 1)), (t = ri(t, 0, 1)), (i = ri(i, 0, 1)), t === 0))
      this.r = this.g = this.b = i
    else {
      const s = i <= 0.5 ? i * (1 + t) : i + t - i * t,
        o = 2 * i - s
      ;(this.r = Yx(o, s, e + 1 / 3)),
        (this.g = Yx(o, s, e)),
        (this.b = Yx(o, s, e - 1 / 3))
    }
    return fn.toWorkingColorSpace(this, r), this
  }
  setStyle(e, t = Kr) {
    function i(s) {
      s !== void 0 &&
        parseFloat(s) < 1 &&
        console.warn("THREE.Color: Alpha component of " + e + " will be ignored.")
    }
    let r
    if ((r = /^(\w+)\(([^\)]*)\)/.exec(e))) {
      let s
      const o = r[1],
        l = r[2]
      switch (o) {
        case "rgb":
        case "rgba":
          if (
            (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(l))
          )
            return (
              i(s[4]),
              this.setRGB(
                Math.min(255, parseInt(s[1], 10)) / 255,
                Math.min(255, parseInt(s[2], 10)) / 255,
                Math.min(255, parseInt(s[3], 10)) / 255,
                t,
              )
            )
          if (
            (s =
              /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                l,
              ))
          )
            return (
              i(s[4]),
              this.setRGB(
                Math.min(100, parseInt(s[1], 10)) / 100,
                Math.min(100, parseInt(s[2], 10)) / 100,
                Math.min(100, parseInt(s[3], 10)) / 100,
                t,
              )
            )
          break
        case "hsl":
        case "hsla":
          if (
            (s =
              /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(
                l,
              ))
          )
            return (
              i(s[4]),
              this.setHSL(
                parseFloat(s[1]) / 360,
                parseFloat(s[2]) / 100,
                parseFloat(s[3]) / 100,
                t,
              )
            )
          break
        default:
          console.warn("THREE.Color: Unknown color model " + e)
      }
    } else if ((r = /^\#([A-Fa-f\d]+)$/.exec(e))) {
      const s = r[1],
        o = s.length
      if (o === 3)
        return this.setRGB(
          parseInt(s.charAt(0), 16) / 15,
          parseInt(s.charAt(1), 16) / 15,
          parseInt(s.charAt(2), 16) / 15,
          t,
        )
      if (o === 6) return this.setHex(parseInt(s, 16), t)
      console.warn("THREE.Color: Invalid hex color " + e)
    } else if (e && e.length > 0) return this.setColorName(e, t)
    return this
  }
  setColorName(e, t = Kr) {
    const i = v3[e.toLowerCase()]
    return (
      i !== void 0
        ? this.setHex(i, t)
        : console.warn("THREE.Color: Unknown color " + e),
      this
    )
  }
  clone() {
    return new this.constructor(this.r, this.g, this.b)
  }
  copy(e) {
    return (this.r = e.r), (this.g = e.g), (this.b = e.b), this
  }
  copySRGBToLinear(e) {
    return (this.r = Xa(e.r)), (this.g = Xa(e.g)), (this.b = Xa(e.b)), this
  }
  copyLinearToSRGB(e) {
    return (this.r = Ad(e.r)), (this.g = Ad(e.g)), (this.b = Ad(e.b)), this
  }
  convertSRGBToLinear() {
    return this.copySRGBToLinear(this), this
  }
  convertLinearToSRGB() {
    return this.copyLinearToSRGB(this), this
  }
  getHex(e = Kr) {
    return (
      fn.fromWorkingColorSpace(ur.copy(this), e),
      Math.round(ri(ur.r * 255, 0, 255)) * 65536 +
        Math.round(ri(ur.g * 255, 0, 255)) * 256 +
        Math.round(ri(ur.b * 255, 0, 255))
    )
  }
  getHexString(e = Kr) {
    return ("000000" + this.getHex(e).toString(16)).slice(-6)
  }
  getHSL(e, t = fn.workingColorSpace) {
    fn.fromWorkingColorSpace(ur.copy(this), t)
    const i = ur.r,
      r = ur.g,
      s = ur.b,
      o = Math.max(i, r, s),
      l = Math.min(i, r, s)
    let u, d
    const p = (l + o) / 2
    if (l === o) (u = 0), (d = 0)
    else {
      const m = o - l
      switch (((d = p <= 0.5 ? m / (o + l) : m / (2 - o - l)), o)) {
        case i:
          u = (r - s) / m + (r < s ? 6 : 0)
          break
        case r:
          u = (s - i) / m + 2
          break
        case s:
          u = (i - r) / m + 4
          break
      }
      u /= 6
    }
    return (e.h = u), (e.s = d), (e.l = p), e
  }
  getRGB(e, t = fn.workingColorSpace) {
    return (
      fn.fromWorkingColorSpace(ur.copy(this), t),
      (e.r = ur.r),
      (e.g = ur.g),
      (e.b = ur.b),
      e
    )
  }
  getStyle(e = Kr) {
    fn.fromWorkingColorSpace(ur.copy(this), e)
    const t = ur.r,
      i = ur.g,
      r = ur.b
    return e !== Kr
      ? `color(${e} ${t.toFixed(3)} ${i.toFixed(3)} ${r.toFixed(3)})`
      : `rgb(${Math.round(t * 255)},${Math.round(i * 255)},${Math.round(r * 255)})`
  }
  offsetHSL(e, t, i) {
    return this.getHSL(Bl), this.setHSL(Bl.h + e, Bl.s + t, Bl.l + i)
  }
  add(e) {
    return (this.r += e.r), (this.g += e.g), (this.b += e.b), this
  }
  addColors(e, t) {
    return (this.r = e.r + t.r), (this.g = e.g + t.g), (this.b = e.b + t.b), this
  }
  addScalar(e) {
    return (this.r += e), (this.g += e), (this.b += e), this
  }
  sub(e) {
    return (
      (this.r = Math.max(0, this.r - e.r)),
      (this.g = Math.max(0, this.g - e.g)),
      (this.b = Math.max(0, this.b - e.b)),
      this
    )
  }
  multiply(e) {
    return (this.r *= e.r), (this.g *= e.g), (this.b *= e.b), this
  }
  multiplyScalar(e) {
    return (this.r *= e), (this.g *= e), (this.b *= e), this
  }
  lerp(e, t) {
    return (
      (this.r += (e.r - this.r) * t),
      (this.g += (e.g - this.g) * t),
      (this.b += (e.b - this.b) * t),
      this
    )
  }
  lerpColors(e, t, i) {
    return (
      (this.r = e.r + (t.r - e.r) * i),
      (this.g = e.g + (t.g - e.g) * i),
      (this.b = e.b + (t.b - e.b) * i),
      this
    )
  }
  lerpHSL(e, t) {
    this.getHSL(Bl), e.getHSL(Ug)
    const i = Ip(Bl.h, Ug.h, t),
      r = Ip(Bl.s, Ug.s, t),
      s = Ip(Bl.l, Ug.l, t)
    return this.setHSL(i, r, s), this
  }
  setFromVector3(e) {
    return (this.r = e.x), (this.g = e.y), (this.b = e.z), this
  }
  applyMatrix3(e) {
    const t = this.r,
      i = this.g,
      r = this.b,
      s = e.elements
    return (
      (this.r = s[0] * t + s[3] * i + s[6] * r),
      (this.g = s[1] * t + s[4] * i + s[7] * r),
      (this.b = s[2] * t + s[5] * i + s[8] * r),
      this
    )
  }
  equals(e) {
    return e.r === this.r && e.g === this.g && e.b === this.b
  }
  fromArray(e, t = 0) {
    return (this.r = e[t]), (this.g = e[t + 1]), (this.b = e[t + 2]), this
  }
  toArray(e = [], t = 0) {
    return (e[t] = this.r), (e[t + 1] = this.g), (e[t + 2] = this.b), e
  }
  fromBufferAttribute(e, t) {
    return (this.r = e.getX(t)), (this.g = e.getY(t)), (this.b = e.getZ(t)), this
  }
  toJSON() {
    return this.getHex()
  }
  *[Symbol.iterator]() {
    yield this.r, yield this.g, yield this.b
  }
}
const ur = new ot()
ot.NAMES = v3
let GO = 0
class er extends Jo {
  static get type() {
    return "Material"
  }
  get type() {
    return this.constructor.type
  }
  set type(e) {}
  constructor() {
    super(),
      (this.isMaterial = !0),
      Object.defineProperty(this, "id", { value: GO++ }),
      (this.uuid = vs()),
      (this.name = ""),
      (this.blending = Eu),
      (this.side = $a),
      (this.vertexColors = !1),
      (this.opacity = 1),
      (this.transparent = !1),
      (this.alphaHash = !1),
      (this.blendSrc = H0),
      (this.blendDst = G0),
      (this.blendEquation = $l),
      (this.blendSrcAlpha = null),
      (this.blendDstAlpha = null),
      (this.blendEquationAlpha = null),
      (this.blendColor = new ot(0, 0, 0)),
      (this.blendAlpha = 0),
      (this.depthFunc = Iu),
      (this.depthTest = !0),
      (this.depthWrite = !0),
      (this.stencilWriteMask = 255),
      (this.stencilFunc = S1),
      (this.stencilRef = 0),
      (this.stencilFuncMask = 255),
      (this.stencilFail = fu),
      (this.stencilZFail = fu),
      (this.stencilZPass = fu),
      (this.stencilWrite = !1),
      (this.clippingPlanes = null),
      (this.clipIntersection = !1),
      (this.clipShadows = !1),
      (this.shadowSide = null),
      (this.colorWrite = !0),
      (this.precision = null),
      (this.polygonOffset = !1),
      (this.polygonOffsetFactor = 0),
      (this.polygonOffsetUnits = 0),
      (this.dithering = !1),
      (this.alphaToCoverage = !1),
      (this.premultipliedAlpha = !1),
      (this.forceSinglePass = !1),
      (this.visible = !0),
      (this.toneMapped = !0),
      (this.userData = {}),
      (this.version = 0),
      (this._alphaTest = 0)
  }
  get alphaTest() {
    return this._alphaTest
  }
  set alphaTest(e) {
    this._alphaTest > 0 != e > 0 && this.version++, (this._alphaTest = e)
  }
  onBeforeRender() {}
  onBeforeCompile() {}
  customProgramCacheKey() {
    return this.onBeforeCompile.toString()
  }
  setValues(e) {
    if (e !== void 0)
      for (const t in e) {
        const i = e[t]
        if (i === void 0) {
          console.warn(`THREE.Material: parameter '${t}' has value of undefined.`)
          continue
        }
        const r = this[t]
        if (r === void 0) {
          console.warn(
            `THREE.Material: '${t}' is not a property of THREE.${this.type}.`,
          )
          continue
        }
        r && r.isColor
          ? r.set(i)
          : r && r.isVector3 && i && i.isVector3
          ? r.copy(i)
          : (this[t] = i)
      }
  }
  toJSON(e) {
    const t = e === void 0 || typeof e == "string"
    t && (e = { textures: {}, images: {} })
    const i = {
      metadata: { version: 4.6, type: "Material", generator: "Material.toJSON" },
    }
    ;(i.uuid = this.uuid),
      (i.type = this.type),
      this.name !== "" && (i.name = this.name),
      this.color && this.color.isColor && (i.color = this.color.getHex()),
      this.roughness !== void 0 && (i.roughness = this.roughness),
      this.metalness !== void 0 && (i.metalness = this.metalness),
      this.sheen !== void 0 && (i.sheen = this.sheen),
      this.sheenColor &&
        this.sheenColor.isColor &&
        (i.sheenColor = this.sheenColor.getHex()),
      this.sheenRoughness !== void 0 && (i.sheenRoughness = this.sheenRoughness),
      this.emissive && this.emissive.isColor && (i.emissive = this.emissive.getHex()),
      this.emissiveIntensity !== void 0 &&
        this.emissiveIntensity !== 1 &&
        (i.emissiveIntensity = this.emissiveIntensity),
      this.specular && this.specular.isColor && (i.specular = this.specular.getHex()),
      this.specularIntensity !== void 0 &&
        (i.specularIntensity = this.specularIntensity),
      this.specularColor &&
        this.specularColor.isColor &&
        (i.specularColor = this.specularColor.getHex()),
      this.shininess !== void 0 && (i.shininess = this.shininess),
      this.clearcoat !== void 0 && (i.clearcoat = this.clearcoat),
      this.clearcoatRoughness !== void 0 &&
        (i.clearcoatRoughness = this.clearcoatRoughness),
      this.clearcoatMap &&
        this.clearcoatMap.isTexture &&
        (i.clearcoatMap = this.clearcoatMap.toJSON(e).uuid),
      this.clearcoatRoughnessMap &&
        this.clearcoatRoughnessMap.isTexture &&
        (i.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(e).uuid),
      this.clearcoatNormalMap &&
        this.clearcoatNormalMap.isTexture &&
        ((i.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(e).uuid),
        (i.clearcoatNormalScale = this.clearcoatNormalScale.toArray())),
      this.dispersion !== void 0 && (i.dispersion = this.dispersion),
      this.iridescence !== void 0 && (i.iridescence = this.iridescence),
      this.iridescenceIOR !== void 0 && (i.iridescenceIOR = this.iridescenceIOR),
      this.iridescenceThicknessRange !== void 0 &&
        (i.iridescenceThicknessRange = this.iridescenceThicknessRange),
      this.iridescenceMap &&
        this.iridescenceMap.isTexture &&
        (i.iridescenceMap = this.iridescenceMap.toJSON(e).uuid),
      this.iridescenceThicknessMap &&
        this.iridescenceThicknessMap.isTexture &&
        (i.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(e).uuid),
      this.anisotropy !== void 0 && (i.anisotropy = this.anisotropy),
      this.anisotropyRotation !== void 0 &&
        (i.anisotropyRotation = this.anisotropyRotation),
      this.anisotropyMap &&
        this.anisotropyMap.isTexture &&
        (i.anisotropyMap = this.anisotropyMap.toJSON(e).uuid),
      this.map && this.map.isTexture && (i.map = this.map.toJSON(e).uuid),
      this.matcap && this.matcap.isTexture && (i.matcap = this.matcap.toJSON(e).uuid),
      this.alphaMap &&
        this.alphaMap.isTexture &&
        (i.alphaMap = this.alphaMap.toJSON(e).uuid),
      this.lightMap &&
        this.lightMap.isTexture &&
        ((i.lightMap = this.lightMap.toJSON(e).uuid),
        (i.lightMapIntensity = this.lightMapIntensity)),
      this.aoMap &&
        this.aoMap.isTexture &&
        ((i.aoMap = this.aoMap.toJSON(e).uuid),
        (i.aoMapIntensity = this.aoMapIntensity)),
      this.bumpMap &&
        this.bumpMap.isTexture &&
        ((i.bumpMap = this.bumpMap.toJSON(e).uuid), (i.bumpScale = this.bumpScale)),
      this.normalMap &&
        this.normalMap.isTexture &&
        ((i.normalMap = this.normalMap.toJSON(e).uuid),
        (i.normalMapType = this.normalMapType),
        (i.normalScale = this.normalScale.toArray())),
      this.displacementMap &&
        this.displacementMap.isTexture &&
        ((i.displacementMap = this.displacementMap.toJSON(e).uuid),
        (i.displacementScale = this.displacementScale),
        (i.displacementBias = this.displacementBias)),
      this.roughnessMap &&
        this.roughnessMap.isTexture &&
        (i.roughnessMap = this.roughnessMap.toJSON(e).uuid),
      this.metalnessMap &&
        this.metalnessMap.isTexture &&
        (i.metalnessMap = this.metalnessMap.toJSON(e).uuid),
      this.emissiveMap &&
        this.emissiveMap.isTexture &&
        (i.emissiveMap = this.emissiveMap.toJSON(e).uuid),
      this.specularMap &&
        this.specularMap.isTexture &&
        (i.specularMap = this.specularMap.toJSON(e).uuid),
      this.specularIntensityMap &&
        this.specularIntensityMap.isTexture &&
        (i.specularIntensityMap = this.specularIntensityMap.toJSON(e).uuid),
      this.specularColorMap &&
        this.specularColorMap.isTexture &&
        (i.specularColorMap = this.specularColorMap.toJSON(e).uuid),
      this.envMap &&
        this.envMap.isTexture &&
        ((i.envMap = this.envMap.toJSON(e).uuid),
        this.combine !== void 0 && (i.combine = this.combine)),
      this.envMapRotation !== void 0 &&
        (i.envMapRotation = this.envMapRotation.toArray()),
      this.envMapIntensity !== void 0 && (i.envMapIntensity = this.envMapIntensity),
      this.reflectivity !== void 0 && (i.reflectivity = this.reflectivity),
      this.refractionRatio !== void 0 && (i.refractionRatio = this.refractionRatio),
      this.gradientMap &&
        this.gradientMap.isTexture &&
        (i.gradientMap = this.gradientMap.toJSON(e).uuid),
      this.transmission !== void 0 && (i.transmission = this.transmission),
      this.transmissionMap &&
        this.transmissionMap.isTexture &&
        (i.transmissionMap = this.transmissionMap.toJSON(e).uuid),
      this.thickness !== void 0 && (i.thickness = this.thickness),
      this.thicknessMap &&
        this.thicknessMap.isTexture &&
        (i.thicknessMap = this.thicknessMap.toJSON(e).uuid),
      this.attenuationDistance !== void 0 &&
        this.attenuationDistance !== 1 / 0 &&
        (i.attenuationDistance = this.attenuationDistance),
      this.attenuationColor !== void 0 &&
        (i.attenuationColor = this.attenuationColor.getHex()),
      this.size !== void 0 && (i.size = this.size),
      this.shadowSide !== null && (i.shadowSide = this.shadowSide),
      this.sizeAttenuation !== void 0 && (i.sizeAttenuation = this.sizeAttenuation),
      this.blending !== Eu && (i.blending = this.blending),
      this.side !== $a && (i.side = this.side),
      this.vertexColors === !0 && (i.vertexColors = !0),
      this.opacity < 1 && (i.opacity = this.opacity),
      this.transparent === !0 && (i.transparent = !0),
      this.blendSrc !== H0 && (i.blendSrc = this.blendSrc),
      this.blendDst !== G0 && (i.blendDst = this.blendDst),
      this.blendEquation !== $l && (i.blendEquation = this.blendEquation),
      this.blendSrcAlpha !== null && (i.blendSrcAlpha = this.blendSrcAlpha),
      this.blendDstAlpha !== null && (i.blendDstAlpha = this.blendDstAlpha),
      this.blendEquationAlpha !== null &&
        (i.blendEquationAlpha = this.blendEquationAlpha),
      this.blendColor &&
        this.blendColor.isColor &&
        (i.blendColor = this.blendColor.getHex()),
      this.blendAlpha !== 0 && (i.blendAlpha = this.blendAlpha),
      this.depthFunc !== Iu && (i.depthFunc = this.depthFunc),
      this.depthTest === !1 && (i.depthTest = this.depthTest),
      this.depthWrite === !1 && (i.depthWrite = this.depthWrite),
      this.colorWrite === !1 && (i.colorWrite = this.colorWrite),
      this.stencilWriteMask !== 255 && (i.stencilWriteMask = this.stencilWriteMask),
      this.stencilFunc !== S1 && (i.stencilFunc = this.stencilFunc),
      this.stencilRef !== 0 && (i.stencilRef = this.stencilRef),
      this.stencilFuncMask !== 255 && (i.stencilFuncMask = this.stencilFuncMask),
      this.stencilFail !== fu && (i.stencilFail = this.stencilFail),
      this.stencilZFail !== fu && (i.stencilZFail = this.stencilZFail),
      this.stencilZPass !== fu && (i.stencilZPass = this.stencilZPass),
      this.stencilWrite === !0 && (i.stencilWrite = this.stencilWrite),
      this.rotation !== void 0 && this.rotation !== 0 && (i.rotation = this.rotation),
      this.polygonOffset === !0 && (i.polygonOffset = !0),
      this.polygonOffsetFactor !== 0 &&
        (i.polygonOffsetFactor = this.polygonOffsetFactor),
      this.polygonOffsetUnits !== 0 && (i.polygonOffsetUnits = this.polygonOffsetUnits),
      this.linewidth !== void 0 &&
        this.linewidth !== 1 &&
        (i.linewidth = this.linewidth),
      this.dashSize !== void 0 && (i.dashSize = this.dashSize),
      this.gapSize !== void 0 && (i.gapSize = this.gapSize),
      this.scale !== void 0 && (i.scale = this.scale),
      this.dithering === !0 && (i.dithering = !0),
      this.alphaTest > 0 && (i.alphaTest = this.alphaTest),
      this.alphaHash === !0 && (i.alphaHash = !0),
      this.alphaToCoverage === !0 && (i.alphaToCoverage = !0),
      this.premultipliedAlpha === !0 && (i.premultipliedAlpha = !0),
      this.forceSinglePass === !0 && (i.forceSinglePass = !0),
      this.wireframe === !0 && (i.wireframe = !0),
      this.wireframeLinewidth > 1 && (i.wireframeLinewidth = this.wireframeLinewidth),
      this.wireframeLinecap !== "round" && (i.wireframeLinecap = this.wireframeLinecap),
      this.wireframeLinejoin !== "round" &&
        (i.wireframeLinejoin = this.wireframeLinejoin),
      this.flatShading === !0 && (i.flatShading = !0),
      this.visible === !1 && (i.visible = !1),
      this.toneMapped === !1 && (i.toneMapped = !1),
      this.fog === !1 && (i.fog = !1),
      Object.keys(this.userData).length > 0 && (i.userData = this.userData)
    function r(s) {
      const o = []
      for (const l in s) {
        const u = s[l]
        delete u.metadata, o.push(u)
      }
      return o
    }
    if (t) {
      const s = r(e.textures),
        o = r(e.images)
      s.length > 0 && (i.textures = s), o.length > 0 && (i.images = o)
    }
    return i
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(e) {
    ;(this.name = e.name),
      (this.blending = e.blending),
      (this.side = e.side),
      (this.vertexColors = e.vertexColors),
      (this.opacity = e.opacity),
      (this.transparent = e.transparent),
      (this.blendSrc = e.blendSrc),
      (this.blendDst = e.blendDst),
      (this.blendEquation = e.blendEquation),
      (this.blendSrcAlpha = e.blendSrcAlpha),
      (this.blendDstAlpha = e.blendDstAlpha),
      (this.blendEquationAlpha = e.blendEquationAlpha),
      this.blendColor.copy(e.blendColor),
      (this.blendAlpha = e.blendAlpha),
      (this.depthFunc = e.depthFunc),
      (this.depthTest = e.depthTest),
      (this.depthWrite = e.depthWrite),
      (this.stencilWriteMask = e.stencilWriteMask),
      (this.stencilFunc = e.stencilFunc),
      (this.stencilRef = e.stencilRef),
      (this.stencilFuncMask = e.stencilFuncMask),
      (this.stencilFail = e.stencilFail),
      (this.stencilZFail = e.stencilZFail),
      (this.stencilZPass = e.stencilZPass),
      (this.stencilWrite = e.stencilWrite)
    const t = e.clippingPlanes
    let i = null
    if (t !== null) {
      const r = t.length
      i = new Array(r)
      for (let s = 0; s !== r; ++s) i[s] = t[s].clone()
    }
    return (
      (this.clippingPlanes = i),
      (this.clipIntersection = e.clipIntersection),
      (this.clipShadows = e.clipShadows),
      (this.shadowSide = e.shadowSide),
      (this.colorWrite = e.colorWrite),
      (this.precision = e.precision),
      (this.polygonOffset = e.polygonOffset),
      (this.polygonOffsetFactor = e.polygonOffsetFactor),
      (this.polygonOffsetUnits = e.polygonOffsetUnits),
      (this.dithering = e.dithering),
      (this.alphaTest = e.alphaTest),
      (this.alphaHash = e.alphaHash),
      (this.alphaToCoverage = e.alphaToCoverage),
      (this.premultipliedAlpha = e.premultipliedAlpha),
      (this.forceSinglePass = e.forceSinglePass),
      (this.visible = e.visible),
      (this.toneMapped = e.toneMapped),
      (this.userData = JSON.parse(JSON.stringify(e.userData))),
      this
    )
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" })
  }
  set needsUpdate(e) {
    e === !0 && this.version++
  }
  onBuild() {
    console.warn("Material: onBuild() has been removed.")
  }
}
class el extends er {
  static get type() {
    return "MeshBasicMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshBasicMaterial = !0),
      (this.color = new ot(16777215)),
      (this.map = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.specularMap = null),
      (this.alphaMap = null),
      (this.envMap = null),
      (this.envMapRotation = new Bi()),
      (this.combine = gm),
      (this.reflectivity = 1),
      (this.refractionRatio = 0.98),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      this.color.copy(e.color),
      (this.map = e.map),
      (this.lightMap = e.lightMap),
      (this.lightMapIntensity = e.lightMapIntensity),
      (this.aoMap = e.aoMap),
      (this.aoMapIntensity = e.aoMapIntensity),
      (this.specularMap = e.specularMap),
      (this.alphaMap = e.alphaMap),
      (this.envMap = e.envMap),
      this.envMapRotation.copy(e.envMapRotation),
      (this.combine = e.combine),
      (this.reflectivity = e.reflectivity),
      (this.refractionRatio = e.refractionRatio),
      (this.wireframe = e.wireframe),
      (this.wireframeLinewidth = e.wireframeLinewidth),
      (this.wireframeLinecap = e.wireframeLinecap),
      (this.wireframeLinejoin = e.wireframeLinejoin),
      (this.fog = e.fog),
      this
    )
  }
}
const Va = WO()
function WO() {
  const n = new ArrayBuffer(4),
    e = new Float32Array(n),
    t = new Uint32Array(n),
    i = new Uint32Array(512),
    r = new Uint32Array(512)
  for (let u = 0; u < 256; ++u) {
    const d = u - 127
    d < -27
      ? ((i[u] = 0), (i[u | 256] = 32768), (r[u] = 24), (r[u | 256] = 24))
      : d < -14
      ? ((i[u] = 1024 >> (-d - 14)),
        (i[u | 256] = (1024 >> (-d - 14)) | 32768),
        (r[u] = -d - 1),
        (r[u | 256] = -d - 1))
      : d <= 15
      ? ((i[u] = (d + 15) << 10),
        (i[u | 256] = ((d + 15) << 10) | 32768),
        (r[u] = 13),
        (r[u | 256] = 13))
      : d < 128
      ? ((i[u] = 31744), (i[u | 256] = 64512), (r[u] = 24), (r[u | 256] = 24))
      : ((i[u] = 31744), (i[u | 256] = 64512), (r[u] = 13), (r[u | 256] = 13))
  }
  const s = new Uint32Array(2048),
    o = new Uint32Array(64),
    l = new Uint32Array(64)
  for (let u = 1; u < 1024; ++u) {
    let d = u << 13,
      p = 0
    for (; (d & 8388608) === 0; ) (d <<= 1), (p -= 8388608)
    ;(d &= -8388609), (p += 947912704), (s[u] = d | p)
  }
  for (let u = 1024; u < 2048; ++u) s[u] = 939524096 + ((u - 1024) << 13)
  for (let u = 1; u < 31; ++u) o[u] = u << 23
  ;(o[31] = 1199570944), (o[32] = 2147483648)
  for (let u = 33; u < 63; ++u) o[u] = 2147483648 + ((u - 32) << 23)
  o[63] = 3347054592
  for (let u = 1; u < 64; ++u) u !== 32 && (l[u] = 1024)
  return {
    floatView: e,
    uint32View: t,
    baseTable: i,
    shiftTable: r,
    mantissaTable: s,
    exponentTable: o,
    offsetTable: l,
  }
}
function qr(n) {
  Math.abs(n) > 65504 &&
    console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."),
    (n = ri(n, -65504, 65504)),
    (Va.floatView[0] = n)
  const e = Va.uint32View[0],
    t = (e >> 23) & 511
  return Va.baseTable[t] + ((e & 8388607) >> Va.shiftTable[t])
}
function pp(n) {
  const e = n >> 10
  return (
    (Va.uint32View[0] =
      Va.mantissaTable[Va.offsetTable[e] + (n & 1023)] + Va.exponentTable[e]),
    Va.floatView[0]
  )
}
const jO = { toHalfFloat: qr, fromHalfFloat: pp },
  vi = new q(),
  Og = new We()
class bn {
  constructor(e, t, i = !1) {
    if (Array.isArray(e))
      throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.")
    ;(this.isBufferAttribute = !0),
      (this.name = ""),
      (this.array = e),
      (this.itemSize = t),
      (this.count = e !== void 0 ? e.length / t : 0),
      (this.normalized = i),
      (this.usage = qp),
      (this.updateRanges = []),
      (this.gpuType = Qr),
      (this.version = 0)
  }
  onUploadCallback() {}
  set needsUpdate(e) {
    e === !0 && this.version++
  }
  setUsage(e) {
    return (this.usage = e), this
  }
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t })
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0
  }
  copy(e) {
    return (
      (this.name = e.name),
      (this.array = new e.array.constructor(e.array)),
      (this.itemSize = e.itemSize),
      (this.count = e.count),
      (this.normalized = e.normalized),
      (this.usage = e.usage),
      (this.gpuType = e.gpuType),
      this
    )
  }
  copyAt(e, t, i) {
    ;(e *= this.itemSize), (i *= t.itemSize)
    for (let r = 0, s = this.itemSize; r < s; r++) this.array[e + r] = t.array[i + r]
    return this
  }
  copyArray(e) {
    return this.array.set(e), this
  }
  applyMatrix3(e) {
    if (this.itemSize === 2)
      for (let t = 0, i = this.count; t < i; t++)
        Og.fromBufferAttribute(this, t), Og.applyMatrix3(e), this.setXY(t, Og.x, Og.y)
    else if (this.itemSize === 3)
      for (let t = 0, i = this.count; t < i; t++)
        vi.fromBufferAttribute(this, t),
          vi.applyMatrix3(e),
          this.setXYZ(t, vi.x, vi.y, vi.z)
    return this
  }
  applyMatrix4(e) {
    for (let t = 0, i = this.count; t < i; t++)
      vi.fromBufferAttribute(this, t),
        vi.applyMatrix4(e),
        this.setXYZ(t, vi.x, vi.y, vi.z)
    return this
  }
  applyNormalMatrix(e) {
    for (let t = 0, i = this.count; t < i; t++)
      vi.fromBufferAttribute(this, t),
        vi.applyNormalMatrix(e),
        this.setXYZ(t, vi.x, vi.y, vi.z)
    return this
  }
  transformDirection(e) {
    for (let t = 0, i = this.count; t < i; t++)
      vi.fromBufferAttribute(this, t),
        vi.transformDirection(e),
        this.setXYZ(t, vi.x, vi.y, vi.z)
    return this
  }
  set(e, t = 0) {
    return this.array.set(e, t), this
  }
  getComponent(e, t) {
    let i = this.array[e * this.itemSize + t]
    return this.normalized && (i = Cr(i, this.array)), i
  }
  setComponent(e, t, i) {
    return (
      this.normalized && (i = Zt(i, this.array)),
      (this.array[e * this.itemSize + t] = i),
      this
    )
  }
  getX(e) {
    let t = this.array[e * this.itemSize]
    return this.normalized && (t = Cr(t, this.array)), t
  }
  setX(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.array[e * this.itemSize] = t),
      this
    )
  }
  getY(e) {
    let t = this.array[e * this.itemSize + 1]
    return this.normalized && (t = Cr(t, this.array)), t
  }
  setY(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.array[e * this.itemSize + 1] = t),
      this
    )
  }
  getZ(e) {
    let t = this.array[e * this.itemSize + 2]
    return this.normalized && (t = Cr(t, this.array)), t
  }
  setZ(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.array[e * this.itemSize + 2] = t),
      this
    )
  }
  getW(e) {
    let t = this.array[e * this.itemSize + 3]
    return this.normalized && (t = Cr(t, this.array)), t
  }
  setW(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.array[e * this.itemSize + 3] = t),
      this
    )
  }
  setXY(e, t, i) {
    return (
      (e *= this.itemSize),
      this.normalized && ((t = Zt(t, this.array)), (i = Zt(i, this.array))),
      (this.array[e + 0] = t),
      (this.array[e + 1] = i),
      this
    )
  }
  setXYZ(e, t, i, r) {
    return (
      (e *= this.itemSize),
      this.normalized &&
        ((t = Zt(t, this.array)), (i = Zt(i, this.array)), (r = Zt(r, this.array))),
      (this.array[e + 0] = t),
      (this.array[e + 1] = i),
      (this.array[e + 2] = r),
      this
    )
  }
  setXYZW(e, t, i, r, s) {
    return (
      (e *= this.itemSize),
      this.normalized &&
        ((t = Zt(t, this.array)),
        (i = Zt(i, this.array)),
        (r = Zt(r, this.array)),
        (s = Zt(s, this.array))),
      (this.array[e + 0] = t),
      (this.array[e + 1] = i),
      (this.array[e + 2] = r),
      (this.array[e + 3] = s),
      this
    )
  }
  onUpload(e) {
    return (this.onUploadCallback = e), this
  }
  clone() {
    return new this.constructor(this.array, this.itemSize).copy(this)
  }
  toJSON() {
    const e = {
      itemSize: this.itemSize,
      type: this.array.constructor.name,
      array: Array.from(this.array),
      normalized: this.normalized,
    }
    return (
      this.name !== "" && (e.name = this.name),
      this.usage !== qp && (e.usage = this.usage),
      e
    )
  }
}
class XO extends bn {
  constructor(e, t, i) {
    super(new Int8Array(e), t, i)
  }
}
class YO extends bn {
  constructor(e, t, i) {
    super(new Uint8Array(e), t, i)
  }
}
class qO extends bn {
  constructor(e, t, i) {
    super(new Uint8ClampedArray(e), t, i)
  }
}
class $O extends bn {
  constructor(e, t, i) {
    super(new Int16Array(e), t, i)
  }
}
class ty extends bn {
  constructor(e, t, i) {
    super(new Uint16Array(e), t, i)
  }
}
class KO extends bn {
  constructor(e, t, i) {
    super(new Int32Array(e), t, i)
  }
}
class Bw extends bn {
  constructor(e, t, i) {
    super(new Uint32Array(e), t, i)
  }
}
class ZO extends bn {
  constructor(e, t, i) {
    super(new Uint16Array(e), t, i), (this.isFloat16BufferAttribute = !0)
  }
  getX(e) {
    let t = pp(this.array[e * this.itemSize])
    return this.normalized && (t = Cr(t, this.array)), t
  }
  setX(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.array[e * this.itemSize] = qr(t)),
      this
    )
  }
  getY(e) {
    let t = pp(this.array[e * this.itemSize + 1])
    return this.normalized && (t = Cr(t, this.array)), t
  }
  setY(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.array[e * this.itemSize + 1] = qr(t)),
      this
    )
  }
  getZ(e) {
    let t = pp(this.array[e * this.itemSize + 2])
    return this.normalized && (t = Cr(t, this.array)), t
  }
  setZ(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.array[e * this.itemSize + 2] = qr(t)),
      this
    )
  }
  getW(e) {
    let t = pp(this.array[e * this.itemSize + 3])
    return this.normalized && (t = Cr(t, this.array)), t
  }
  setW(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.array[e * this.itemSize + 3] = qr(t)),
      this
    )
  }
  setXY(e, t, i) {
    return (
      (e *= this.itemSize),
      this.normalized && ((t = Zt(t, this.array)), (i = Zt(i, this.array))),
      (this.array[e + 0] = qr(t)),
      (this.array[e + 1] = qr(i)),
      this
    )
  }
  setXYZ(e, t, i, r) {
    return (
      (e *= this.itemSize),
      this.normalized &&
        ((t = Zt(t, this.array)), (i = Zt(i, this.array)), (r = Zt(r, this.array))),
      (this.array[e + 0] = qr(t)),
      (this.array[e + 1] = qr(i)),
      (this.array[e + 2] = qr(r)),
      this
    )
  }
  setXYZW(e, t, i, r, s) {
    return (
      (e *= this.itemSize),
      this.normalized &&
        ((t = Zt(t, this.array)),
        (i = Zt(i, this.array)),
        (r = Zt(r, this.array)),
        (s = Zt(s, this.array))),
      (this.array[e + 0] = qr(t)),
      (this.array[e + 1] = qr(i)),
      (this.array[e + 2] = qr(r)),
      (this.array[e + 3] = qr(s)),
      this
    )
  }
}
class vt extends bn {
  constructor(e, t, i) {
    super(new Float32Array(e), t, i)
  }
}
let JO = 0
const Ls = new mt(),
  qx = new cn(),
  id = new q(),
  gs = new Lr(),
  Kh = new Lr(),
  Ui = new q()
class Gt extends Jo {
  constructor() {
    super(),
      (this.isBufferGeometry = !0),
      Object.defineProperty(this, "id", { value: JO++ }),
      (this.uuid = vs()),
      (this.name = ""),
      (this.type = "BufferGeometry"),
      (this.index = null),
      (this.indirect = null),
      (this.attributes = {}),
      (this.morphAttributes = {}),
      (this.morphTargetsRelative = !1),
      (this.groups = []),
      (this.boundingBox = null),
      (this.boundingSphere = null),
      (this.drawRange = { start: 0, count: 1 / 0 }),
      (this.userData = {})
  }
  getIndex() {
    return this.index
  }
  setIndex(e) {
    return (
      Array.isArray(e) ? (this.index = new (h3(e) ? Bw : ty)(e, 1)) : (this.index = e),
      this
    )
  }
  setIndirect(e) {
    return (this.indirect = e), this
  }
  getIndirect() {
    return this.indirect
  }
  getAttribute(e) {
    return this.attributes[e]
  }
  setAttribute(e, t) {
    return (this.attributes[e] = t), this
  }
  deleteAttribute(e) {
    return delete this.attributes[e], this
  }
  hasAttribute(e) {
    return this.attributes[e] !== void 0
  }
  addGroup(e, t, i = 0) {
    this.groups.push({ start: e, count: t, materialIndex: i })
  }
  clearGroups() {
    this.groups = []
  }
  setDrawRange(e, t) {
    ;(this.drawRange.start = e), (this.drawRange.count = t)
  }
  applyMatrix4(e) {
    const t = this.attributes.position
    t !== void 0 && (t.applyMatrix4(e), (t.needsUpdate = !0))
    const i = this.attributes.normal
    if (i !== void 0) {
      const s = new Xt().getNormalMatrix(e)
      i.applyNormalMatrix(s), (i.needsUpdate = !0)
    }
    const r = this.attributes.tangent
    return (
      r !== void 0 && (r.transformDirection(e), (r.needsUpdate = !0)),
      this.boundingBox !== null && this.computeBoundingBox(),
      this.boundingSphere !== null && this.computeBoundingSphere(),
      this
    )
  }
  applyQuaternion(e) {
    return Ls.makeRotationFromQuaternion(e), this.applyMatrix4(Ls), this
  }
  rotateX(e) {
    return Ls.makeRotationX(e), this.applyMatrix4(Ls), this
  }
  rotateY(e) {
    return Ls.makeRotationY(e), this.applyMatrix4(Ls), this
  }
  rotateZ(e) {
    return Ls.makeRotationZ(e), this.applyMatrix4(Ls), this
  }
  translate(e, t, i) {
    return Ls.makeTranslation(e, t, i), this.applyMatrix4(Ls), this
  }
  scale(e, t, i) {
    return Ls.makeScale(e, t, i), this.applyMatrix4(Ls), this
  }
  lookAt(e) {
    return qx.lookAt(e), qx.updateMatrix(), this.applyMatrix4(qx.matrix), this
  }
  center() {
    return (
      this.computeBoundingBox(),
      this.boundingBox.getCenter(id).negate(),
      this.translate(id.x, id.y, id.z),
      this
    )
  }
  setFromPoints(e) {
    const t = this.getAttribute("position")
    if (t === void 0) {
      const i = []
      for (let r = 0, s = e.length; r < s; r++) {
        const o = e[r]
        i.push(o.x, o.y, o.z || 0)
      }
      this.setAttribute("position", new vt(i, 3))
    } else {
      for (let i = 0, r = t.count; i < r; i++) {
        const s = e[i]
        t.setXYZ(i, s.x, s.y, s.z || 0)
      }
      e.length > t.count &&
        console.warn(
          "THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.",
        ),
        (t.needsUpdate = !0)
    }
    return this
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Lr())
    const e = this.attributes.position,
      t = this.morphAttributes.position
    if (e && e.isGLBufferAttribute) {
      console.error(
        "THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.",
        this,
      ),
        this.boundingBox.set(new q(-1 / 0, -1 / 0, -1 / 0), new q(1 / 0, 1 / 0, 1 / 0))
      return
    }
    if (e !== void 0) {
      if ((this.boundingBox.setFromBufferAttribute(e), t))
        for (let i = 0, r = t.length; i < r; i++) {
          const s = t[i]
          gs.setFromBufferAttribute(s),
            this.morphTargetsRelative
              ? (Ui.addVectors(this.boundingBox.min, gs.min),
                this.boundingBox.expandByPoint(Ui),
                Ui.addVectors(this.boundingBox.max, gs.max),
                this.boundingBox.expandByPoint(Ui))
              : (this.boundingBox.expandByPoint(gs.min),
                this.boundingBox.expandByPoint(gs.max))
        }
    } else this.boundingBox.makeEmpty()
    ;(isNaN(this.boundingBox.min.x) ||
      isNaN(this.boundingBox.min.y) ||
      isNaN(this.boundingBox.min.z)) &&
      console.error(
        'THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.',
        this,
      )
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new pr())
    const e = this.attributes.position,
      t = this.morphAttributes.position
    if (e && e.isGLBufferAttribute) {
      console.error(
        "THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.",
        this,
      ),
        this.boundingSphere.set(new q(), 1 / 0)
      return
    }
    if (e) {
      const i = this.boundingSphere.center
      if ((gs.setFromBufferAttribute(e), t))
        for (let s = 0, o = t.length; s < o; s++) {
          const l = t[s]
          Kh.setFromBufferAttribute(l),
            this.morphTargetsRelative
              ? (Ui.addVectors(gs.min, Kh.min),
                gs.expandByPoint(Ui),
                Ui.addVectors(gs.max, Kh.max),
                gs.expandByPoint(Ui))
              : (gs.expandByPoint(Kh.min), gs.expandByPoint(Kh.max))
        }
      gs.getCenter(i)
      let r = 0
      for (let s = 0, o = e.count; s < o; s++)
        Ui.fromBufferAttribute(e, s), (r = Math.max(r, i.distanceToSquared(Ui)))
      if (t)
        for (let s = 0, o = t.length; s < o; s++) {
          const l = t[s],
            u = this.morphTargetsRelative
          for (let d = 0, p = l.count; d < p; d++)
            Ui.fromBufferAttribute(l, d),
              u && (id.fromBufferAttribute(e, d), Ui.add(id)),
              (r = Math.max(r, i.distanceToSquared(Ui)))
        }
      ;(this.boundingSphere.radius = Math.sqrt(r)),
        isNaN(this.boundingSphere.radius) &&
          console.error(
            'THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.',
            this,
          )
    }
  }
  computeTangents() {
    const e = this.index,
      t = this.attributes
    if (e === null || t.position === void 0 || t.normal === void 0 || t.uv === void 0) {
      console.error(
        "THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)",
      )
      return
    }
    const i = t.position,
      r = t.normal,
      s = t.uv
    this.hasAttribute("tangent") === !1 &&
      this.setAttribute("tangent", new bn(new Float32Array(4 * i.count), 4))
    const o = this.getAttribute("tangent"),
      l = [],
      u = []
    for (let N = 0; N < i.count; N++) (l[N] = new q()), (u[N] = new q())
    const d = new q(),
      p = new q(),
      m = new q(),
      v = new We(),
      y = new We(),
      x = new We(),
      E = new q(),
      M = new q()
    function w(N, k, I) {
      d.fromBufferAttribute(i, N),
        p.fromBufferAttribute(i, k),
        m.fromBufferAttribute(i, I),
        v.fromBufferAttribute(s, N),
        y.fromBufferAttribute(s, k),
        x.fromBufferAttribute(s, I),
        p.sub(d),
        m.sub(d),
        y.sub(v),
        x.sub(v)
      const V = 1 / (y.x * x.y - x.x * y.y)
      isFinite(V) &&
        (E.copy(p).multiplyScalar(x.y).addScaledVector(m, -y.y).multiplyScalar(V),
        M.copy(m).multiplyScalar(y.x).addScaledVector(p, -x.x).multiplyScalar(V),
        l[N].add(E),
        l[k].add(E),
        l[I].add(E),
        u[N].add(M),
        u[k].add(M),
        u[I].add(M))
    }
    let A = this.groups
    A.length === 0 && (A = [{ start: 0, count: e.count }])
    for (let N = 0, k = A.length; N < k; ++N) {
      const I = A[N],
        V = I.start,
        Z = I.count
      for (let $ = V, ee = V + Z; $ < ee; $ += 3)
        w(e.getX($ + 0), e.getX($ + 1), e.getX($ + 2))
    }
    const C = new q(),
      R = new q(),
      z = new q(),
      U = new q()
    function O(N) {
      z.fromBufferAttribute(r, N), U.copy(z)
      const k = l[N]
      C.copy(k), C.sub(z.multiplyScalar(z.dot(k))).normalize(), R.crossVectors(U, k)
      const V = R.dot(u[N]) < 0 ? -1 : 1
      o.setXYZW(N, C.x, C.y, C.z, V)
    }
    for (let N = 0, k = A.length; N < k; ++N) {
      const I = A[N],
        V = I.start,
        Z = I.count
      for (let $ = V, ee = V + Z; $ < ee; $ += 3)
        O(e.getX($ + 0)), O(e.getX($ + 1)), O(e.getX($ + 2))
    }
  }
  computeVertexNormals() {
    const e = this.index,
      t = this.getAttribute("position")
    if (t !== void 0) {
      let i = this.getAttribute("normal")
      if (i === void 0)
        (i = new bn(new Float32Array(t.count * 3), 3)), this.setAttribute("normal", i)
      else for (let v = 0, y = i.count; v < y; v++) i.setXYZ(v, 0, 0, 0)
      const r = new q(),
        s = new q(),
        o = new q(),
        l = new q(),
        u = new q(),
        d = new q(),
        p = new q(),
        m = new q()
      if (e)
        for (let v = 0, y = e.count; v < y; v += 3) {
          const x = e.getX(v + 0),
            E = e.getX(v + 1),
            M = e.getX(v + 2)
          r.fromBufferAttribute(t, x),
            s.fromBufferAttribute(t, E),
            o.fromBufferAttribute(t, M),
            p.subVectors(o, s),
            m.subVectors(r, s),
            p.cross(m),
            l.fromBufferAttribute(i, x),
            u.fromBufferAttribute(i, E),
            d.fromBufferAttribute(i, M),
            l.add(p),
            u.add(p),
            d.add(p),
            i.setXYZ(x, l.x, l.y, l.z),
            i.setXYZ(E, u.x, u.y, u.z),
            i.setXYZ(M, d.x, d.y, d.z)
        }
      else
        for (let v = 0, y = t.count; v < y; v += 3)
          r.fromBufferAttribute(t, v + 0),
            s.fromBufferAttribute(t, v + 1),
            o.fromBufferAttribute(t, v + 2),
            p.subVectors(o, s),
            m.subVectors(r, s),
            p.cross(m),
            i.setXYZ(v + 0, p.x, p.y, p.z),
            i.setXYZ(v + 1, p.x, p.y, p.z),
            i.setXYZ(v + 2, p.x, p.y, p.z)
      this.normalizeNormals(), (i.needsUpdate = !0)
    }
  }
  normalizeNormals() {
    const e = this.attributes.normal
    for (let t = 0, i = e.count; t < i; t++)
      Ui.fromBufferAttribute(e, t), Ui.normalize(), e.setXYZ(t, Ui.x, Ui.y, Ui.z)
  }
  toNonIndexed() {
    function e(l, u) {
      const d = l.array,
        p = l.itemSize,
        m = l.normalized,
        v = new d.constructor(u.length * p)
      let y = 0,
        x = 0
      for (let E = 0, M = u.length; E < M; E++) {
        l.isInterleavedBufferAttribute
          ? (y = u[E] * l.data.stride + l.offset)
          : (y = u[E] * p)
        for (let w = 0; w < p; w++) v[x++] = d[y++]
      }
      return new bn(v, p, m)
    }
    if (this.index === null)
      return (
        console.warn(
          "THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.",
        ),
        this
      )
    const t = new Gt(),
      i = this.index.array,
      r = this.attributes
    for (const l in r) {
      const u = r[l],
        d = e(u, i)
      t.setAttribute(l, d)
    }
    const s = this.morphAttributes
    for (const l in s) {
      const u = [],
        d = s[l]
      for (let p = 0, m = d.length; p < m; p++) {
        const v = d[p],
          y = e(v, i)
        u.push(y)
      }
      t.morphAttributes[l] = u
    }
    t.morphTargetsRelative = this.morphTargetsRelative
    const o = this.groups
    for (let l = 0, u = o.length; l < u; l++) {
      const d = o[l]
      t.addGroup(d.start, d.count, d.materialIndex)
    }
    return t
  }
  toJSON() {
    const e = {
      metadata: {
        version: 4.6,
        type: "BufferGeometry",
        generator: "BufferGeometry.toJSON",
      },
    }
    if (
      ((e.uuid = this.uuid),
      (e.type = this.type),
      this.name !== "" && (e.name = this.name),
      Object.keys(this.userData).length > 0 && (e.userData = this.userData),
      this.parameters !== void 0)
    ) {
      const u = this.parameters
      for (const d in u) u[d] !== void 0 && (e[d] = u[d])
      return e
    }
    e.data = { attributes: {} }
    const t = this.index
    t !== null &&
      (e.data.index = {
        type: t.array.constructor.name,
        array: Array.prototype.slice.call(t.array),
      })
    const i = this.attributes
    for (const u in i) {
      const d = i[u]
      e.data.attributes[u] = d.toJSON(e.data)
    }
    const r = {}
    let s = !1
    for (const u in this.morphAttributes) {
      const d = this.morphAttributes[u],
        p = []
      for (let m = 0, v = d.length; m < v; m++) {
        const y = d[m]
        p.push(y.toJSON(e.data))
      }
      p.length > 0 && ((r[u] = p), (s = !0))
    }
    s &&
      ((e.data.morphAttributes = r),
      (e.data.morphTargetsRelative = this.morphTargetsRelative))
    const o = this.groups
    o.length > 0 && (e.data.groups = JSON.parse(JSON.stringify(o)))
    const l = this.boundingSphere
    return (
      l !== null &&
        (e.data.boundingSphere = { center: l.center.toArray(), radius: l.radius }),
      e
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(e) {
    ;(this.index = null),
      (this.attributes = {}),
      (this.morphAttributes = {}),
      (this.groups = []),
      (this.boundingBox = null),
      (this.boundingSphere = null)
    const t = {}
    this.name = e.name
    const i = e.index
    i !== null && this.setIndex(i.clone(t))
    const r = e.attributes
    for (const d in r) {
      const p = r[d]
      this.setAttribute(d, p.clone(t))
    }
    const s = e.morphAttributes
    for (const d in s) {
      const p = [],
        m = s[d]
      for (let v = 0, y = m.length; v < y; v++) p.push(m[v].clone(t))
      this.morphAttributes[d] = p
    }
    this.morphTargetsRelative = e.morphTargetsRelative
    const o = e.groups
    for (let d = 0, p = o.length; d < p; d++) {
      const m = o[d]
      this.addGroup(m.start, m.count, m.materialIndex)
    }
    const l = e.boundingBox
    l !== null && (this.boundingBox = l.clone())
    const u = e.boundingSphere
    return (
      u !== null && (this.boundingSphere = u.clone()),
      (this.drawRange.start = e.drawRange.start),
      (this.drawRange.count = e.drawRange.count),
      (this.userData = e.userData),
      this
    )
  }
  dispose() {
    this.dispatchEvent({ type: "dispose" })
  }
}
const dT = new mt(),
  Jc = new Wd(),
  Bg = new pr(),
  hT = new q(),
  zg = new q(),
  Vg = new q(),
  Hg = new q(),
  $x = new q(),
  Gg = new q(),
  pT = new q(),
  Wg = new q()
class ui extends cn {
  constructor(e = new Gt(), t = new el()) {
    super(),
      (this.isMesh = !0),
      (this.type = "Mesh"),
      (this.geometry = e),
      (this.material = t),
      this.updateMorphTargets()
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      e.morphTargetInfluences !== void 0 &&
        (this.morphTargetInfluences = e.morphTargetInfluences.slice()),
      e.morphTargetDictionary !== void 0 &&
        (this.morphTargetDictionary = Object.assign({}, e.morphTargetDictionary)),
      (this.material = Array.isArray(e.material) ? e.material.slice() : e.material),
      (this.geometry = e.geometry),
      this
    )
  }
  updateMorphTargets() {
    const t = this.geometry.morphAttributes,
      i = Object.keys(t)
    if (i.length > 0) {
      const r = t[i[0]]
      if (r !== void 0) {
        ;(this.morphTargetInfluences = []), (this.morphTargetDictionary = {})
        for (let s = 0, o = r.length; s < o; s++) {
          const l = r[s].name || String(s)
          this.morphTargetInfluences.push(0), (this.morphTargetDictionary[l] = s)
        }
      }
    }
  }
  getVertexPosition(e, t) {
    const i = this.geometry,
      r = i.attributes.position,
      s = i.morphAttributes.position,
      o = i.morphTargetsRelative
    t.fromBufferAttribute(r, e)
    const l = this.morphTargetInfluences
    if (s && l) {
      Gg.set(0, 0, 0)
      for (let u = 0, d = s.length; u < d; u++) {
        const p = l[u],
          m = s[u]
        p !== 0 &&
          ($x.fromBufferAttribute(m, e),
          o ? Gg.addScaledVector($x, p) : Gg.addScaledVector($x.sub(t), p))
      }
      t.add(Gg)
    }
    return t
  }
  raycast(e, t) {
    const i = this.geometry,
      r = this.material,
      s = this.matrixWorld
    r !== void 0 &&
      (i.boundingSphere === null && i.computeBoundingSphere(),
      Bg.copy(i.boundingSphere),
      Bg.applyMatrix4(s),
      Jc.copy(e.ray).recast(e.near),
      !(
        Bg.containsPoint(Jc.origin) === !1 &&
        (Jc.intersectSphere(Bg, hT) === null ||
          Jc.origin.distanceToSquared(hT) > (e.far - e.near) ** 2)
      ) &&
        (dT.copy(s).invert(),
        Jc.copy(e.ray).applyMatrix4(dT),
        !(i.boundingBox !== null && Jc.intersectsBox(i.boundingBox) === !1) &&
          this._computeIntersections(e, t, Jc)))
  }
  _computeIntersections(e, t, i) {
    let r
    const s = this.geometry,
      o = this.material,
      l = s.index,
      u = s.attributes.position,
      d = s.attributes.uv,
      p = s.attributes.uv1,
      m = s.attributes.normal,
      v = s.groups,
      y = s.drawRange
    if (l !== null)
      if (Array.isArray(o))
        for (let x = 0, E = v.length; x < E; x++) {
          const M = v[x],
            w = o[M.materialIndex],
            A = Math.max(M.start, y.start),
            C = Math.min(l.count, Math.min(M.start + M.count, y.start + y.count))
          for (let R = A, z = C; R < z; R += 3) {
            const U = l.getX(R),
              O = l.getX(R + 1),
              N = l.getX(R + 2)
            ;(r = jg(this, w, e, i, d, p, m, U, O, N)),
              r &&
                ((r.faceIndex = Math.floor(R / 3)),
                (r.face.materialIndex = M.materialIndex),
                t.push(r))
          }
        }
      else {
        const x = Math.max(0, y.start),
          E = Math.min(l.count, y.start + y.count)
        for (let M = x, w = E; M < w; M += 3) {
          const A = l.getX(M),
            C = l.getX(M + 1),
            R = l.getX(M + 2)
          ;(r = jg(this, o, e, i, d, p, m, A, C, R)),
            r && ((r.faceIndex = Math.floor(M / 3)), t.push(r))
        }
      }
    else if (u !== void 0)
      if (Array.isArray(o))
        for (let x = 0, E = v.length; x < E; x++) {
          const M = v[x],
            w = o[M.materialIndex],
            A = Math.max(M.start, y.start),
            C = Math.min(u.count, Math.min(M.start + M.count, y.start + y.count))
          for (let R = A, z = C; R < z; R += 3) {
            const U = R,
              O = R + 1,
              N = R + 2
            ;(r = jg(this, w, e, i, d, p, m, U, O, N)),
              r &&
                ((r.faceIndex = Math.floor(R / 3)),
                (r.face.materialIndex = M.materialIndex),
                t.push(r))
          }
        }
      else {
        const x = Math.max(0, y.start),
          E = Math.min(u.count, y.start + y.count)
        for (let M = x, w = E; M < w; M += 3) {
          const A = M,
            C = M + 1,
            R = M + 2
          ;(r = jg(this, o, e, i, d, p, m, A, C, R)),
            r && ((r.faceIndex = Math.floor(M / 3)), t.push(r))
        }
      }
  }
}
function QO(n, e, t, i, r, s, o, l) {
  let u
  if (
    (e.side === Ir
      ? (u = i.intersectTriangle(o, s, r, !0, l))
      : (u = i.intersectTriangle(r, s, o, e.side === $a, l)),
    u === null)
  )
    return null
  Wg.copy(l), Wg.applyMatrix4(n.matrixWorld)
  const d = t.ray.origin.distanceTo(Wg)
  return d < t.near || d > t.far ? null : { distance: d, point: Wg.clone(), object: n }
}
function jg(n, e, t, i, r, s, o, l, u, d) {
  n.getVertexPosition(l, zg), n.getVertexPosition(u, Vg), n.getVertexPosition(d, Hg)
  const p = QO(n, e, t, i, zg, Vg, Hg, pT)
  if (p) {
    const m = new q()
    Zr.getBarycoord(pT, zg, Vg, Hg, m),
      r && (p.uv = Zr.getInterpolatedAttribute(r, l, u, d, m, new We())),
      s && (p.uv1 = Zr.getInterpolatedAttribute(s, l, u, d, m, new We())),
      o &&
        ((p.normal = Zr.getInterpolatedAttribute(o, l, u, d, m, new q())),
        p.normal.dot(i.direction) > 0 && p.normal.multiplyScalar(-1))
    const v = { a: l, b: u, c: d, normal: new q(), materialIndex: 0 }
    Zr.getNormal(zg, Vg, Hg, v.normal), (p.face = v), (p.barycoord = m)
  }
  return p
}
class zu extends Gt {
  constructor(e = 1, t = 1, i = 1, r = 1, s = 1, o = 1) {
    super(),
      (this.type = "BoxGeometry"),
      (this.parameters = {
        width: e,
        height: t,
        depth: i,
        widthSegments: r,
        heightSegments: s,
        depthSegments: o,
      })
    const l = this
    ;(r = Math.floor(r)), (s = Math.floor(s)), (o = Math.floor(o))
    const u = [],
      d = [],
      p = [],
      m = []
    let v = 0,
      y = 0
    x("z", "y", "x", -1, -1, i, t, e, o, s, 0),
      x("z", "y", "x", 1, -1, i, t, -e, o, s, 1),
      x("x", "z", "y", 1, 1, e, i, t, r, o, 2),
      x("x", "z", "y", 1, -1, e, i, -t, r, o, 3),
      x("x", "y", "z", 1, -1, e, t, i, r, s, 4),
      x("x", "y", "z", -1, -1, e, t, -i, r, s, 5),
      this.setIndex(u),
      this.setAttribute("position", new vt(d, 3)),
      this.setAttribute("normal", new vt(p, 3)),
      this.setAttribute("uv", new vt(m, 2))
    function x(E, M, w, A, C, R, z, U, O, N, k) {
      const I = R / O,
        V = z / N,
        Z = R / 2,
        $ = z / 2,
        ee = U / 2,
        ue = O + 1,
        re = N + 1
      let se = 0,
        G = 0
      const ie = new q()
      for (let Q = 0; Q < re; Q++) {
        const W = Q * V - $
        for (let ne = 0; ne < ue; ne++) {
          const ye = ne * I - Z
          ;(ie[E] = ye * A),
            (ie[M] = W * C),
            (ie[w] = ee),
            d.push(ie.x, ie.y, ie.z),
            (ie[E] = 0),
            (ie[M] = 0),
            (ie[w] = U > 0 ? 1 : -1),
            p.push(ie.x, ie.y, ie.z),
            m.push(ne / O),
            m.push(1 - Q / N),
            (se += 1)
        }
      }
      for (let Q = 0; Q < N; Q++)
        for (let W = 0; W < O; W++) {
          const ne = v + W + ue * Q,
            ye = v + W + ue * (Q + 1),
            oe = v + (W + 1) + ue * (Q + 1),
            fe = v + (W + 1) + ue * Q
          u.push(ne, ye, fe), u.push(ye, oe, fe), (G += 6)
        }
      l.addGroup(y, G, k), (y += G), (v += se)
    }
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new zu(
      e.width,
      e.height,
      e.depth,
      e.widthSegments,
      e.heightSegments,
      e.depthSegments,
    )
  }
}
function Dd(n) {
  const e = {}
  for (const t in n) {
    e[t] = {}
    for (const i in n[t]) {
      const r = n[t][i]
      r &&
      (r.isColor ||
        r.isMatrix3 ||
        r.isMatrix4 ||
        r.isVector2 ||
        r.isVector3 ||
        r.isVector4 ||
        r.isTexture ||
        r.isQuaternion)
        ? r.isRenderTargetTexture
          ? (console.warn(
              "UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().",
            ),
            (e[t][i] = null))
          : (e[t][i] = r.clone())
        : Array.isArray(r)
        ? (e[t][i] = r.slice())
        : (e[t][i] = r)
    }
  }
  return e
}
function Ar(n) {
  const e = {}
  for (let t = 0; t < n.length; t++) {
    const i = Dd(n[t])
    for (const r in i) e[r] = i[r]
  }
  return e
}
function e8(n) {
  const e = []
  for (let t = 0; t < n.length; t++) e.push(n[t].clone())
  return e
}
function y3(n) {
  const e = n.getRenderTarget()
  return e === null
    ? n.outputColorSpace
    : e.isXRRenderTarget === !0
    ? e.texture.colorSpace
    : fn.workingColorSpace
}
const x3 = { clone: Dd, merge: Ar }
var t8 = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`,
  n8 = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`
class Mo extends er {
  static get type() {
    return "ShaderMaterial"
  }
  constructor(e) {
    super(),
      (this.isShaderMaterial = !0),
      (this.defines = {}),
      (this.uniforms = {}),
      (this.uniformsGroups = []),
      (this.vertexShader = t8),
      (this.fragmentShader = n8),
      (this.linewidth = 1),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.fog = !1),
      (this.lights = !1),
      (this.clipping = !1),
      (this.forceSinglePass = !0),
      (this.extensions = { clipCullDistance: !1, multiDraw: !1 }),
      (this.defaultAttributeValues = { color: [1, 1, 1], uv: [0, 0], uv1: [0, 0] }),
      (this.index0AttributeName = void 0),
      (this.uniformsNeedUpdate = !1),
      (this.glslVersion = null),
      e !== void 0 && this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.fragmentShader = e.fragmentShader),
      (this.vertexShader = e.vertexShader),
      (this.uniforms = Dd(e.uniforms)),
      (this.uniformsGroups = e8(e.uniformsGroups)),
      (this.defines = Object.assign({}, e.defines)),
      (this.wireframe = e.wireframe),
      (this.wireframeLinewidth = e.wireframeLinewidth),
      (this.fog = e.fog),
      (this.lights = e.lights),
      (this.clipping = e.clipping),
      (this.extensions = Object.assign({}, e.extensions)),
      (this.glslVersion = e.glslVersion),
      this
    )
  }
  toJSON(e) {
    const t = super.toJSON(e)
    ;(t.glslVersion = this.glslVersion), (t.uniforms = {})
    for (const r in this.uniforms) {
      const o = this.uniforms[r].value
      o && o.isTexture
        ? (t.uniforms[r] = { type: "t", value: o.toJSON(e).uuid })
        : o && o.isColor
        ? (t.uniforms[r] = { type: "c", value: o.getHex() })
        : o && o.isVector2
        ? (t.uniforms[r] = { type: "v2", value: o.toArray() })
        : o && o.isVector3
        ? (t.uniforms[r] = { type: "v3", value: o.toArray() })
        : o && o.isVector4
        ? (t.uniforms[r] = { type: "v4", value: o.toArray() })
        : o && o.isMatrix3
        ? (t.uniforms[r] = { type: "m3", value: o.toArray() })
        : o && o.isMatrix4
        ? (t.uniforms[r] = { type: "m4", value: o.toArray() })
        : (t.uniforms[r] = { value: o })
    }
    Object.keys(this.defines).length > 0 && (t.defines = this.defines),
      (t.vertexShader = this.vertexShader),
      (t.fragmentShader = this.fragmentShader),
      (t.lights = this.lights),
      (t.clipping = this.clipping)
    const i = {}
    for (const r in this.extensions) this.extensions[r] === !0 && (i[r] = !0)
    return Object.keys(i).length > 0 && (t.extensions = i), t
  }
}
class xm extends cn {
  constructor() {
    super(),
      (this.isCamera = !0),
      (this.type = "Camera"),
      (this.matrixWorldInverse = new mt()),
      (this.projectionMatrix = new mt()),
      (this.projectionMatrixInverse = new mt()),
      (this.coordinateSystem = Go)
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      this.matrixWorldInverse.copy(e.matrixWorldInverse),
      this.projectionMatrix.copy(e.projectionMatrix),
      this.projectionMatrixInverse.copy(e.projectionMatrixInverse),
      (this.coordinateSystem = e.coordinateSystem),
      this
    )
  }
  getWorldDirection(e) {
    return super.getWorldDirection(e).negate()
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert()
  }
  updateWorldMatrix(e, t) {
    super.updateWorldMatrix(e, t),
      this.matrixWorldInverse.copy(this.matrixWorld).invert()
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
const zl = new q(),
  mT = new We(),
  gT = new We()
class Ci extends xm {
  constructor(e = 50, t = 1, i = 0.1, r = 2e3) {
    super(),
      (this.isPerspectiveCamera = !0),
      (this.type = "PerspectiveCamera"),
      (this.fov = e),
      (this.zoom = 1),
      (this.near = i),
      (this.far = r),
      (this.focus = 10),
      (this.aspect = t),
      (this.view = null),
      (this.filmGauge = 35),
      (this.filmOffset = 0),
      this.updateProjectionMatrix()
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      (this.fov = e.fov),
      (this.zoom = e.zoom),
      (this.near = e.near),
      (this.far = e.far),
      (this.focus = e.focus),
      (this.aspect = e.aspect),
      (this.view = e.view === null ? null : Object.assign({}, e.view)),
      (this.filmGauge = e.filmGauge),
      (this.filmOffset = e.filmOffset),
      this
    )
  }
  setFocalLength(e) {
    const t = (0.5 * this.getFilmHeight()) / e
    ;(this.fov = Ld * 2 * Math.atan(t)), this.updateProjectionMatrix()
  }
  getFocalLength() {
    const e = Math.tan(bu * 0.5 * this.fov)
    return (0.5 * this.getFilmHeight()) / e
  }
  getEffectiveFOV() {
    return Ld * 2 * Math.atan(Math.tan(bu * 0.5 * this.fov) / this.zoom)
  }
  getFilmWidth() {
    return this.filmGauge * Math.min(this.aspect, 1)
  }
  getFilmHeight() {
    return this.filmGauge / Math.max(this.aspect, 1)
  }
  getViewBounds(e, t, i) {
    zl.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse),
      t.set(zl.x, zl.y).multiplyScalar(-e / zl.z),
      zl.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse),
      i.set(zl.x, zl.y).multiplyScalar(-e / zl.z)
  }
  getViewSize(e, t) {
    return this.getViewBounds(e, mT, gT), t.subVectors(gT, mT)
  }
  setViewOffset(e, t, i, r, s, o) {
    ;(this.aspect = e / t),
      this.view === null &&
        (this.view = {
          enabled: !0,
          fullWidth: 1,
          fullHeight: 1,
          offsetX: 0,
          offsetY: 0,
          width: 1,
          height: 1,
        }),
      (this.view.enabled = !0),
      (this.view.fullWidth = e),
      (this.view.fullHeight = t),
      (this.view.offsetX = i),
      (this.view.offsetY = r),
      (this.view.width = s),
      (this.view.height = o),
      this.updateProjectionMatrix()
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix()
  }
  updateProjectionMatrix() {
    const e = this.near
    let t = (e * Math.tan(bu * 0.5 * this.fov)) / this.zoom,
      i = 2 * t,
      r = this.aspect * i,
      s = -0.5 * r
    const o = this.view
    if (this.view !== null && this.view.enabled) {
      const u = o.fullWidth,
        d = o.fullHeight
      ;(s += (o.offsetX * r) / u),
        (t -= (o.offsetY * i) / d),
        (r *= o.width / u),
        (i *= o.height / d)
    }
    const l = this.filmOffset
    l !== 0 && (s += (e * l) / this.getFilmWidth()),
      this.projectionMatrix.makePerspective(
        s,
        s + r,
        t,
        t - i,
        e,
        this.far,
        this.coordinateSystem,
      ),
      this.projectionMatrixInverse.copy(this.projectionMatrix).invert()
  }
  toJSON(e) {
    const t = super.toJSON(e)
    return (
      (t.object.fov = this.fov),
      (t.object.zoom = this.zoom),
      (t.object.near = this.near),
      (t.object.far = this.far),
      (t.object.focus = this.focus),
      (t.object.aspect = this.aspect),
      this.view !== null && (t.object.view = Object.assign({}, this.view)),
      (t.object.filmGauge = this.filmGauge),
      (t.object.filmOffset = this.filmOffset),
      t
    )
  }
}
const rd = -90,
  sd = 1
class _3 extends cn {
  constructor(e, t, i) {
    super(),
      (this.type = "CubeCamera"),
      (this.renderTarget = i),
      (this.coordinateSystem = null),
      (this.activeMipmapLevel = 0)
    const r = new Ci(rd, sd, e, t)
    ;(r.layers = this.layers), this.add(r)
    const s = new Ci(rd, sd, e, t)
    ;(s.layers = this.layers), this.add(s)
    const o = new Ci(rd, sd, e, t)
    ;(o.layers = this.layers), this.add(o)
    const l = new Ci(rd, sd, e, t)
    ;(l.layers = this.layers), this.add(l)
    const u = new Ci(rd, sd, e, t)
    ;(u.layers = this.layers), this.add(u)
    const d = new Ci(rd, sd, e, t)
    ;(d.layers = this.layers), this.add(d)
  }
  updateCoordinateSystem() {
    const e = this.coordinateSystem,
      t = this.children.concat(),
      [i, r, s, o, l, u] = t
    for (const d of t) this.remove(d)
    if (e === Go)
      i.up.set(0, 1, 0),
        i.lookAt(1, 0, 0),
        r.up.set(0, 1, 0),
        r.lookAt(-1, 0, 0),
        s.up.set(0, 0, -1),
        s.lookAt(0, 1, 0),
        o.up.set(0, 0, 1),
        o.lookAt(0, -1, 0),
        l.up.set(0, 1, 0),
        l.lookAt(0, 0, 1),
        u.up.set(0, 1, 0),
        u.lookAt(0, 0, -1)
    else if (e === $p)
      i.up.set(0, -1, 0),
        i.lookAt(-1, 0, 0),
        r.up.set(0, -1, 0),
        r.lookAt(1, 0, 0),
        s.up.set(0, 0, 1),
        s.lookAt(0, 1, 0),
        o.up.set(0, 0, -1),
        o.lookAt(0, -1, 0),
        l.up.set(0, -1, 0),
        l.lookAt(0, 0, 1),
        u.up.set(0, -1, 0),
        u.lookAt(0, 0, -1)
    else
      throw new Error(
        "THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + e,
      )
    for (const d of t) this.add(d), d.updateMatrixWorld()
  }
  update(e, t) {
    this.parent === null && this.updateMatrixWorld()
    const { renderTarget: i, activeMipmapLevel: r } = this
    this.coordinateSystem !== e.coordinateSystem &&
      ((this.coordinateSystem = e.coordinateSystem), this.updateCoordinateSystem())
    const [s, o, l, u, d, p] = this.children,
      m = e.getRenderTarget(),
      v = e.getActiveCubeFace(),
      y = e.getActiveMipmapLevel(),
      x = e.xr.enabled
    e.xr.enabled = !1
    const E = i.texture.generateMipmaps
    ;(i.texture.generateMipmaps = !1),
      e.setRenderTarget(i, 0, r),
      e.render(t, s),
      e.setRenderTarget(i, 1, r),
      e.render(t, o),
      e.setRenderTarget(i, 2, r),
      e.render(t, l),
      e.setRenderTarget(i, 3, r),
      e.render(t, u),
      e.setRenderTarget(i, 4, r),
      e.render(t, d),
      (i.texture.generateMipmaps = E),
      e.setRenderTarget(i, 5, r),
      e.render(t, p),
      e.setRenderTarget(m, v, y),
      (e.xr.enabled = x),
      (i.texture.needsPMREMUpdate = !0)
  }
}
class _m extends zn {
  constructor(e, t, i, r, s, o, l, u, d, p) {
    ;(e = e !== void 0 ? e : []),
      (t = t !== void 0 ? t : Ka),
      super(e, t, i, r, s, o, l, u, d, p),
      (this.isCubeTexture = !0),
      (this.flipY = !1)
  }
  get images() {
    return this.image
  }
  set images(e) {
    this.image = e
  }
}
class w3 extends So {
  constructor(e = 1, t = {}) {
    super(e, e, t), (this.isWebGLCubeRenderTarget = !0)
    const i = { width: e, height: e, depth: 1 },
      r = [i, i, i, i, i, i]
    ;(this.texture = new _m(
      r,
      t.mapping,
      t.wrapS,
      t.wrapT,
      t.magFilter,
      t.minFilter,
      t.format,
      t.type,
      t.anisotropy,
      t.colorSpace,
    )),
      (this.texture.isRenderTargetTexture = !0),
      (this.texture.generateMipmaps =
        t.generateMipmaps !== void 0 ? t.generateMipmaps : !1),
      (this.texture.minFilter = t.minFilter !== void 0 ? t.minFilter : Ri)
  }
  fromEquirectangularTexture(e, t) {
    ;(this.texture.type = t.type),
      (this.texture.colorSpace = t.colorSpace),
      (this.texture.generateMipmaps = t.generateMipmaps),
      (this.texture.minFilter = t.minFilter),
      (this.texture.magFilter = t.magFilter)
    const i = {
        uniforms: { tEquirect: { value: null } },
        vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
        fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`,
      },
      r = new zu(5, 5, 5),
      s = new Mo({
        name: "CubemapFromEquirect",
        uniforms: Dd(i.uniforms),
        vertexShader: i.vertexShader,
        fragmentShader: i.fragmentShader,
        side: Ir,
        blending: ja,
      })
    s.uniforms.tEquirect.value = t
    const o = new ui(r, s),
      l = t.minFilter
    return (
      t.minFilter === Ho && (t.minFilter = Ri),
      new _3(1, 10, this).update(e, o),
      (t.minFilter = l),
      o.geometry.dispose(),
      o.material.dispose(),
      this
    )
  }
  clear(e, t, i, r) {
    const s = e.getRenderTarget()
    for (let o = 0; o < 6; o++) e.setRenderTarget(this, o), e.clear(t, i, r)
    e.setRenderTarget(s)
  }
}
const Kx = new q(),
  i8 = new q(),
  r8 = new Xt()
class Yl {
  constructor(e = new q(1, 0, 0), t = 0) {
    ;(this.isPlane = !0), (this.normal = e), (this.constant = t)
  }
  set(e, t) {
    return this.normal.copy(e), (this.constant = t), this
  }
  setComponents(e, t, i, r) {
    return this.normal.set(e, t, i), (this.constant = r), this
  }
  setFromNormalAndCoplanarPoint(e, t) {
    return this.normal.copy(e), (this.constant = -t.dot(this.normal)), this
  }
  setFromCoplanarPoints(e, t, i) {
    const r = Kx.subVectors(i, t).cross(i8.subVectors(e, t)).normalize()
    return this.setFromNormalAndCoplanarPoint(r, e), this
  }
  copy(e) {
    return this.normal.copy(e.normal), (this.constant = e.constant), this
  }
  normalize() {
    const e = 1 / this.normal.length()
    return this.normal.multiplyScalar(e), (this.constant *= e), this
  }
  negate() {
    return (this.constant *= -1), this.normal.negate(), this
  }
  distanceToPoint(e) {
    return this.normal.dot(e) + this.constant
  }
  distanceToSphere(e) {
    return this.distanceToPoint(e.center) - e.radius
  }
  projectPoint(e, t) {
    return t.copy(e).addScaledVector(this.normal, -this.distanceToPoint(e))
  }
  intersectLine(e, t) {
    const i = e.delta(Kx),
      r = this.normal.dot(i)
    if (r === 0) return this.distanceToPoint(e.start) === 0 ? t.copy(e.start) : null
    const s = -(e.start.dot(this.normal) + this.constant) / r
    return s < 0 || s > 1 ? null : t.copy(e.start).addScaledVector(i, s)
  }
  intersectsLine(e) {
    const t = this.distanceToPoint(e.start),
      i = this.distanceToPoint(e.end)
    return (t < 0 && i > 0) || (i < 0 && t > 0)
  }
  intersectsBox(e) {
    return e.intersectsPlane(this)
  }
  intersectsSphere(e) {
    return e.intersectsPlane(this)
  }
  coplanarPoint(e) {
    return e.copy(this.normal).multiplyScalar(-this.constant)
  }
  applyMatrix4(e, t) {
    const i = t || r8.getNormalMatrix(e),
      r = this.coplanarPoint(Kx).applyMatrix4(e),
      s = this.normal.applyMatrix3(i).normalize()
    return (this.constant = -r.dot(s)), this
  }
  translate(e) {
    return (this.constant -= e.dot(this.normal)), this
  }
  equals(e) {
    return e.normal.equals(this.normal) && e.constant === this.constant
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
const Qc = new pr(),
  Xg = new q()
class wm {
  constructor(
    e = new Yl(),
    t = new Yl(),
    i = new Yl(),
    r = new Yl(),
    s = new Yl(),
    o = new Yl(),
  ) {
    this.planes = [e, t, i, r, s, o]
  }
  set(e, t, i, r, s, o) {
    const l = this.planes
    return (
      l[0].copy(e),
      l[1].copy(t),
      l[2].copy(i),
      l[3].copy(r),
      l[4].copy(s),
      l[5].copy(o),
      this
    )
  }
  copy(e) {
    const t = this.planes
    for (let i = 0; i < 6; i++) t[i].copy(e.planes[i])
    return this
  }
  setFromProjectionMatrix(e, t = Go) {
    const i = this.planes,
      r = e.elements,
      s = r[0],
      o = r[1],
      l = r[2],
      u = r[3],
      d = r[4],
      p = r[5],
      m = r[6],
      v = r[7],
      y = r[8],
      x = r[9],
      E = r[10],
      M = r[11],
      w = r[12],
      A = r[13],
      C = r[14],
      R = r[15]
    if (
      (i[0].setComponents(u - s, v - d, M - y, R - w).normalize(),
      i[1].setComponents(u + s, v + d, M + y, R + w).normalize(),
      i[2].setComponents(u + o, v + p, M + x, R + A).normalize(),
      i[3].setComponents(u - o, v - p, M - x, R - A).normalize(),
      i[4].setComponents(u - l, v - m, M - E, R - C).normalize(),
      t === Go)
    )
      i[5].setComponents(u + l, v + m, M + E, R + C).normalize()
    else if (t === $p) i[5].setComponents(l, m, E, C).normalize()
    else
      throw new Error(
        "THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + t,
      )
    return this
  }
  intersectsObject(e) {
    if (e.boundingSphere !== void 0)
      e.boundingSphere === null && e.computeBoundingSphere(),
        Qc.copy(e.boundingSphere).applyMatrix4(e.matrixWorld)
    else {
      const t = e.geometry
      t.boundingSphere === null && t.computeBoundingSphere(),
        Qc.copy(t.boundingSphere).applyMatrix4(e.matrixWorld)
    }
    return this.intersectsSphere(Qc)
  }
  intersectsSprite(e) {
    return (
      Qc.center.set(0, 0, 0),
      (Qc.radius = 0.7071067811865476),
      Qc.applyMatrix4(e.matrixWorld),
      this.intersectsSphere(Qc)
    )
  }
  intersectsSphere(e) {
    const t = this.planes,
      i = e.center,
      r = -e.radius
    for (let s = 0; s < 6; s++) if (t[s].distanceToPoint(i) < r) return !1
    return !0
  }
  intersectsBox(e) {
    const t = this.planes
    for (let i = 0; i < 6; i++) {
      const r = t[i]
      if (
        ((Xg.x = r.normal.x > 0 ? e.max.x : e.min.x),
        (Xg.y = r.normal.y > 0 ? e.max.y : e.min.y),
        (Xg.z = r.normal.z > 0 ? e.max.z : e.min.z),
        r.distanceToPoint(Xg) < 0)
      )
        return !1
    }
    return !0
  }
  containsPoint(e) {
    const t = this.planes
    for (let i = 0; i < 6; i++) if (t[i].distanceToPoint(e) < 0) return !1
    return !0
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
function S3() {
  let n = null,
    e = !1,
    t = null,
    i = null
  function r(s, o) {
    t(s, o), (i = n.requestAnimationFrame(r))
  }
  return {
    start: function () {
      e !== !0 && t !== null && ((i = n.requestAnimationFrame(r)), (e = !0))
    },
    stop: function () {
      n.cancelAnimationFrame(i), (e = !1)
    },
    setAnimationLoop: function (s) {
      t = s
    },
    setContext: function (s) {
      n = s
    },
  }
}
function s8(n) {
  const e = new WeakMap()
  function t(l, u) {
    const d = l.array,
      p = l.usage,
      m = d.byteLength,
      v = n.createBuffer()
    n.bindBuffer(u, v), n.bufferData(u, d, p), l.onUploadCallback()
    let y
    if (d instanceof Float32Array) y = n.FLOAT
    else if (d instanceof Uint16Array)
      l.isFloat16BufferAttribute ? (y = n.HALF_FLOAT) : (y = n.UNSIGNED_SHORT)
    else if (d instanceof Int16Array) y = n.SHORT
    else if (d instanceof Uint32Array) y = n.UNSIGNED_INT
    else if (d instanceof Int32Array) y = n.INT
    else if (d instanceof Int8Array) y = n.BYTE
    else if (d instanceof Uint8Array) y = n.UNSIGNED_BYTE
    else if (d instanceof Uint8ClampedArray) y = n.UNSIGNED_BYTE
    else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + d)
    return {
      buffer: v,
      type: y,
      bytesPerElement: d.BYTES_PER_ELEMENT,
      version: l.version,
      size: m,
    }
  }
  function i(l, u, d) {
    const p = u.array,
      m = u.updateRanges
    if ((n.bindBuffer(d, l), m.length === 0)) n.bufferSubData(d, 0, p)
    else {
      m.sort((y, x) => y.start - x.start)
      let v = 0
      for (let y = 1; y < m.length; y++) {
        const x = m[v],
          E = m[y]
        E.start <= x.start + x.count + 1
          ? (x.count = Math.max(x.count, E.start + E.count - x.start))
          : (++v, (m[v] = E))
      }
      m.length = v + 1
      for (let y = 0, x = m.length; y < x; y++) {
        const E = m[y]
        n.bufferSubData(d, E.start * p.BYTES_PER_ELEMENT, p, E.start, E.count)
      }
      u.clearUpdateRanges()
    }
    u.onUploadCallback()
  }
  function r(l) {
    return l.isInterleavedBufferAttribute && (l = l.data), e.get(l)
  }
  function s(l) {
    l.isInterleavedBufferAttribute && (l = l.data)
    const u = e.get(l)
    u && (n.deleteBuffer(u.buffer), e.delete(l))
  }
  function o(l, u) {
    if ((l.isInterleavedBufferAttribute && (l = l.data), l.isGLBufferAttribute)) {
      const p = e.get(l)
      ;(!p || p.version < l.version) &&
        e.set(l, {
          buffer: l.buffer,
          type: l.type,
          bytesPerElement: l.elementSize,
          version: l.version,
        })
      return
    }
    const d = e.get(l)
    if (d === void 0) e.set(l, t(l, u))
    else if (d.version < l.version) {
      if (d.size !== l.array.byteLength)
        throw new Error(
          "THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.",
        )
      i(d.buffer, l, u), (d.version = l.version)
    }
  }
  return { get: r, remove: s, update: o }
}
class jd extends Gt {
  constructor(e = 1, t = 1, i = 1, r = 1) {
    super(),
      (this.type = "PlaneGeometry"),
      (this.parameters = { width: e, height: t, widthSegments: i, heightSegments: r })
    const s = e / 2,
      o = t / 2,
      l = Math.floor(i),
      u = Math.floor(r),
      d = l + 1,
      p = u + 1,
      m = e / l,
      v = t / u,
      y = [],
      x = [],
      E = [],
      M = []
    for (let w = 0; w < p; w++) {
      const A = w * v - o
      for (let C = 0; C < d; C++) {
        const R = C * m - s
        x.push(R, -A, 0), E.push(0, 0, 1), M.push(C / l), M.push(1 - w / u)
      }
    }
    for (let w = 0; w < u; w++)
      for (let A = 0; A < l; A++) {
        const C = A + d * w,
          R = A + d * (w + 1),
          z = A + 1 + d * (w + 1),
          U = A + 1 + d * w
        y.push(C, R, U), y.push(R, z, U)
      }
    this.setIndex(y),
      this.setAttribute("position", new vt(x, 3)),
      this.setAttribute("normal", new vt(E, 3)),
      this.setAttribute("uv", new vt(M, 2))
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new jd(e.width, e.height, e.widthSegments, e.heightSegments)
  }
}
var o8 = `#ifdef USE_ALPHAHASH
	if ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;
#endif`,
  a8 = `#ifdef USE_ALPHAHASH
	const float ALPHA_HASH_SCALE = 0.05;
	float hash2D( vec2 value ) {
		return fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );
	}
	float hash3D( vec3 value ) {
		return hash2D( vec2( hash2D( value.xy ), value.z ) );
	}
	float getAlphaHashThreshold( vec3 position ) {
		float maxDeriv = max(
			length( dFdx( position.xyz ) ),
			length( dFdy( position.xyz ) )
		);
		float pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );
		vec2 pixScales = vec2(
			exp2( floor( log2( pixScale ) ) ),
			exp2( ceil( log2( pixScale ) ) )
		);
		vec2 alpha = vec2(
			hash3D( floor( pixScales.x * position.xyz ) ),
			hash3D( floor( pixScales.y * position.xyz ) )
		);
		float lerpFactor = fract( log2( pixScale ) );
		float x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;
		float a = min( lerpFactor, 1.0 - lerpFactor );
		vec3 cases = vec3(
			x * x / ( 2.0 * a * ( 1.0 - a ) ),
			( x - 0.5 * a ) / ( 1.0 - a ),
			1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )
		);
		float threshold = ( x < ( 1.0 - a ) )
			? ( ( x < a ) ? cases.x : cases.y )
			: cases.z;
		return clamp( threshold , 1.0e-6, 1.0 );
	}
#endif`,
  l8 = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;
#endif`,
  c8 = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
  u8 = `#ifdef USE_ALPHATEST
	#ifdef ALPHA_TO_COVERAGE
	diffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );
	if ( diffuseColor.a == 0.0 ) discard;
	#else
	if ( diffuseColor.a < alphaTest ) discard;
	#endif
#endif`,
  f8 = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`,
  d8 = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_CLEARCOAT ) 
		clearcoatSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_SHEEN ) 
		sheenSpecularIndirect *= ambientOcclusion;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometryNormal, geometryViewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`,
  h8 = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`,
  p8 = `#ifdef USE_BATCHING
	#if ! defined( GL_ANGLE_multi_draw )
	#define gl_DrawID _gl_DrawID
	uniform int _gl_DrawID;
	#endif
	uniform highp sampler2D batchingTexture;
	uniform highp usampler2D batchingIdTexture;
	mat4 getBatchingMatrix( const in float i ) {
		int size = textureSize( batchingTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
	float getIndirectIndex( const in int i ) {
		int size = textureSize( batchingIdTexture, 0 ).x;
		int x = i % size;
		int y = i / size;
		return float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );
	}
#endif
#ifdef USE_BATCHING_COLOR
	uniform sampler2D batchingColorTexture;
	vec3 getBatchingColor( const in float i ) {
		int size = textureSize( batchingColorTexture, 0 ).x;
		int j = int( i );
		int x = j % size;
		int y = j / size;
		return texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;
	}
#endif`,
  m8 = `#ifdef USE_BATCHING
	mat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );
#endif`,
  g8 = `vec3 transformed = vec3( position );
#ifdef USE_ALPHAHASH
	vPosition = vec3( position );
#endif`,
  v8 = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`,
  y8 = `float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
} // validated`,
  x8 = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`,
  _8 = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vBumpMapUv );
		vec2 dSTdy = dFdy( vBumpMapUv );
		float Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );
		vec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`,
  w8 = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#ifdef ALPHA_TO_COVERAGE
		float distanceToPlane, distanceGradient;
		float clipOpacity = 1.0;
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
			distanceGradient = fwidth( distanceToPlane ) / 2.0;
			clipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			if ( clipOpacity == 0.0 ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			float unionClipOpacity = 1.0;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				distanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;
				distanceGradient = fwidth( distanceToPlane ) / 2.0;
				unionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );
			}
			#pragma unroll_loop_end
			clipOpacity *= 1.0 - unionClipOpacity;
		#endif
		diffuseColor.a *= clipOpacity;
		if ( diffuseColor.a == 0.0 ) discard;
	#else
		#pragma unroll_loop_start
		for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
		}
		#pragma unroll_loop_end
		#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
			bool clipped = true;
			#pragma unroll_loop_start
			for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
				plane = clippingPlanes[ i ];
				clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
			}
			#pragma unroll_loop_end
			if ( clipped ) discard;
		#endif
	#endif
#endif`,
  S8 = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`,
  M8 = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`,
  E8 = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`,
  T8 = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`,
  b8 = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`,
  A8 = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	varying vec3 vColor;
#endif`,
  C8 = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif
#ifdef USE_BATCHING_COLOR
	vec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );
	vColor.xyz *= batchingColor.xyz;
#endif`,
  R8 = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
#ifdef USE_ALPHAHASH
	varying vec3 vPosition;
#endif
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}
vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
} // validated`,
  P8 = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`,
  I8 = `vec3 transformedNormal = objectNormal;
#ifdef USE_TANGENT
	vec3 transformedTangent = objectTangent;
#endif
#ifdef USE_BATCHING
	mat3 bm = mat3( batchingMatrix );
	transformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );
	transformedNormal = bm * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = bm * transformedTangent;
	#endif
#endif
#ifdef USE_INSTANCING
	mat3 im = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );
	transformedNormal = im * transformedNormal;
	#ifdef USE_TANGENT
		transformedTangent = im * transformedTangent;
	#endif
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	transformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`,
  L8 = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`,
  D8 = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );
#endif`,
  N8 = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );
	#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE
		emissiveColor = sRGBTransferEOTF( emissiveColor );
	#endif
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`,
  k8 = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`,
  F8 = "gl_FragColor = linearToOutputTexel( gl_FragColor );",
  U8 = `vec4 LinearTransferOETF( in vec4 value ) {
	return value;
}
vec4 sRGBTransferEOTF( in vec4 value ) {
	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );
}
vec4 sRGBTransferOETF( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`,
  O8 = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`,
  B8 = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	uniform mat3 envMapRotation;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`,
  z8 = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`,
  V8 = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`,
  H8 = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`,
  G8 = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`,
  W8 = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`,
  j8 = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`,
  X8 = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`,
  Y8 = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`,
  q8 = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`,
  $8 = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`,
  K8 = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`,
  Z8 = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
#if defined( USE_LIGHT_PROBES )
	uniform vec3 lightProbe[ 9 ];
#endif
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
	if ( cutoffDistance > 0.0 ) {
		distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
	}
	return distanceFalloff;
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometryPosition;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`,
  J8 = `#ifdef USE_ENVMAP
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#ifdef ENVMAP_TYPE_CUBE_UV
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	#ifdef USE_ANISOTROPY
		vec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {
			#ifdef ENVMAP_TYPE_CUBE_UV
				vec3 bentNormal = cross( bitangent, viewDir );
				bentNormal = normalize( cross( bentNormal, bitangent ) );
				bentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );
				return getIBLRadiance( viewDir, bentNormal, roughness );
			#else
				return vec3( 0.0 );
			#endif
		}
	#endif
#endif`,
  Q8 = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`,
  eB = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`,
  tB = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`,
  nB = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`,
  iB = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef USE_SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULAR_COLORMAP
			specularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;
		#endif
		#ifdef USE_SPECULAR_INTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_DISPERSION
	material.dispersion = dispersion;
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEEN_COLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEEN_ROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;
	#endif
#endif
#ifdef USE_ANISOTROPY
	#ifdef USE_ANISOTROPYMAP
		mat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );
		vec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;
		vec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;
	#else
		vec2 anisotropyV = anisotropyVector;
	#endif
	material.anisotropy = length( anisotropyV );
	if( material.anisotropy == 0.0 ) {
		anisotropyV = vec2( 1.0, 0.0 );
	} else {
		anisotropyV /= material.anisotropy;
		material.anisotropy = saturate( material.anisotropy );
	}
	material.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );
	material.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;
	material.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;
#endif`,
  rB = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	float dispersion;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
	#ifdef USE_ANISOTROPY
		float anisotropy;
		float alphaT;
		vec3 anisotropyT;
		vec3 anisotropyB;
	#endif
};
vec3 clearcoatSpecularDirect = vec3( 0.0 );
vec3 clearcoatSpecularIndirect = vec3( 0.0 );
vec3 sheenSpecularDirect = vec3( 0.0 );
vec3 sheenSpecularIndirect = vec3(0.0 );
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
#ifdef USE_ANISOTROPY
	float V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {
		float gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );
		float gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );
		float v = 0.5 / ( gv + gl );
		return saturate(v);
	}
	float D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {
		float a2 = alphaT * alphaB;
		highp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );
		highp float v2 = dot( v, v );
		float w2 = a2 / v2;
		return RECIPROCAL_PI * a2 * pow2 ( w2 );
	}
#endif
#ifdef USE_CLEARCOAT
	vec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {
		vec3 f0 = material.clearcoatF0;
		float f90 = material.clearcoatF90;
		float roughness = material.clearcoatRoughness;
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = F_Schlick( f0, f90, dotVH );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {
	vec3 f0 = material.specularColor;
	float f90 = material.specularF90;
	float roughness = material.roughness;
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	#ifdef USE_IRIDESCENCE
		F = mix( F, material.iridescenceFresnel, material.iridescence );
	#endif
	#ifdef USE_ANISOTROPY
		float dotTL = dot( material.anisotropyT, lightDir );
		float dotTV = dot( material.anisotropyT, viewDir );
		float dotTH = dot( material.anisotropyT, halfDir );
		float dotBL = dot( material.anisotropyB, lightDir );
		float dotBV = dot( material.anisotropyB, viewDir );
		float dotBH = dot( material.anisotropyB, halfDir );
		float V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );
		float D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );
	#else
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
	#endif
	return F * ( V * D );
}
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometryNormal;
		vec3 viewDir = geometryViewDir;
		vec3 position = geometryPosition;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometryNormal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );
	#endif
	reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`,
  sB = `
vec3 geometryPosition = - vViewPosition;
vec3 geometryNormal = normal;
vec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
vec3 geometryClearcoatNormal = vec3( 0.0 );
#ifdef USE_CLEARCOAT
	geometryClearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometryViewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometryPosition, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometryPosition, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	#if defined( USE_LIGHT_PROBES )
		irradiance += getLightProbeIrradiance( lightProbe, geometryNormal );
	#endif
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`,
  oB = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometryNormal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	#ifdef USE_ANISOTROPY
		radiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );
	#else
		radiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );
	#endif
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`,
  aB = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );
#endif`,
  lB = `#if defined( USE_LOGDEPTHBUF )
	gl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`,
  cB = `#if defined( USE_LOGDEPTHBUF )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
  uB = `#ifdef USE_LOGDEPTHBUF
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`,
  fB = `#ifdef USE_LOGDEPTHBUF
	vFragDepth = 1.0 + gl_Position.w;
	vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
#endif`,
  dB = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vMapUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`,
  hB = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`,
  pB = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	#if defined( USE_POINTS_UV )
		vec2 uv = vUv;
	#else
		vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
	#endif
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`,
  mB = `#if defined( USE_POINTS_UV )
	varying vec2 vUv;
#else
	#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
		uniform mat3 uvTransform;
	#endif
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`,
  gB = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );
	metalnessFactor *= texelMetalness.b;
#endif`,
  vB = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`,
  yB = `#ifdef USE_INSTANCING_MORPH
	float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	float morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		morphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;
	}
#endif`,
  xB = `#if defined( USE_MORPHCOLORS )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`,
  _B = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
  wB = `#ifdef USE_MORPHTARGETS
	#ifndef USE_INSTANCING_MORPH
		uniform float morphTargetBaseInfluence;
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
	#endif
	uniform sampler2DArray morphTargetsTexture;
	uniform ivec2 morphTargetsTextureSize;
	vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
		int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
		int y = texelIndex / morphTargetsTextureSize.x;
		int x = texelIndex - y * morphTargetsTextureSize.x;
		ivec3 morphUV = ivec3( x, y, morphTargetIndex );
		return texelFetch( morphTargetsTexture, morphUV, 0 );
	}
#endif`,
  SB = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
	}
#endif`,
  MB = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal *= faceDirection;
	#endif
#endif
#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )
	#ifdef USE_TANGENT
		mat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn = getTangentFrame( - vViewPosition, normal,
		#if defined( USE_NORMALMAP )
			vNormalMapUv
		#elif defined( USE_CLEARCOAT_NORMALMAP )
			vClearcoatNormalMapUv
		#else
			vUv
		#endif
		);
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn[0] *= faceDirection;
		tbn[1] *= faceDirection;
	#endif
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	#ifdef USE_TANGENT
		mat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );
	#else
		mat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );
	#endif
	#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )
		tbn2[0] *= faceDirection;
		tbn2[1] *= faceDirection;
	#endif
#endif
vec3 nonPerturbedNormal = normal;`,
  EB = `#ifdef USE_NORMALMAP_OBJECTSPACE
	normal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( USE_NORMALMAP_TANGENTSPACE )
	vec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	normal = normalize( tbn * mapN );
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`,
  TB = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
  bB = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`,
  AB = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`,
  CB = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef USE_NORMALMAP_OBJECTSPACE
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )
	mat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( uv.st );
		vec2 st1 = dFdy( uv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );
		return mat3( T * scale, B * scale, N );
	}
#endif`,
  RB = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = nonPerturbedNormal;
#endif`,
  PB = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	clearcoatNormal = normalize( tbn2 * clearcoatMapN );
#endif`,
  IB = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif`,
  LB = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`,
  DB = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`,
  NB = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;
const float Inv255 = 1. / 255.;
const vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );
const vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );
const vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );
const vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );
vec4 packDepthToRGBA( const in float v ) {
	if( v <= 0.0 )
		return vec4( 0., 0., 0., 0. );
	if( v >= 1.0 )
		return vec4( 1., 1., 1., 1. );
	float vuf;
	float af = modf( v * PackFactors.a, vuf );
	float bf = modf( vuf * ShiftRight8, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );
}
vec3 packDepthToRGB( const in float v ) {
	if( v <= 0.0 )
		return vec3( 0., 0., 0. );
	if( v >= 1.0 )
		return vec3( 1., 1., 1. );
	float vuf;
	float bf = modf( v * PackFactors.b, vuf );
	float gf = modf( vuf * ShiftRight8, vuf );
	return vec3( vuf * Inv255, gf * PackUpscale, bf );
}
vec2 packDepthToRG( const in float v ) {
	if( v <= 0.0 )
		return vec2( 0., 0. );
	if( v >= 1.0 )
		return vec2( 1., 1. );
	float vuf;
	float gf = modf( v * 256., vuf );
	return vec2( vuf * Inv255, gf );
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors4 );
}
float unpackRGBToDepth( const in vec3 v ) {
	return dot( v, UnpackFactors3 );
}
float unpackRGToDepth( const in vec2 v ) {
	return v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;
}
vec4 pack2HalfToRGBA( const in vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( const in vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return depth * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * depth - far );
}`,
  kB = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`,
  FB = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_BATCHING
	mvPosition = batchingMatrix * mvPosition;
#endif
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`,
  UB = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`,
  OB = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`,
  BB = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );
	roughnessFactor *= texelRoughness.g;
#endif`,
  zB = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`,
  VB = `#if NUM_SPOT_LIGHT_COORDS > 0
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
	uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		float shadow = 1.0;
		vec3 lightToPosition = shadowCoord.xyz;
		
		float lightToPositionLength = length( lightToPosition );
		if ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {
			float dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );			dp += shadowBias;
			vec3 bd3D = normalize( lightToPosition );
			vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
			#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
				vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
				shadow = (
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
					texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
				) * ( 1.0 / 9.0 );
			#else
				shadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
			#endif
		}
		return mix( 1.0, shadow, shadowIntensity );
	}
#endif`,
  HB = `#if NUM_SPOT_LIGHT_COORDS > 0
	uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
	varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowIntensity;
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`,
  GB = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`,
  WB = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`,
  jB = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`,
  XB = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	mat4 getBoneMatrix( const in float i ) {
		int size = textureSize( boneTexture, 0 ).x;
		int j = int( i ) * 4;
		int x = j % size;
		int y = j / size;
		vec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );
		vec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );
		vec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );
		vec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );
		return mat4( v1, v2, v3, v4 );
	}
#endif`,
  YB = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`,
  qB = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`,
  $B = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`,
  KB = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`,
  ZB = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`,
  JB = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return saturate( toneMappingExposure * color );
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 CineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
const mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(
	vec3( 1.6605, - 0.1246, - 0.0182 ),
	vec3( - 0.5876, 1.1329, - 0.1006 ),
	vec3( - 0.0728, - 0.0083, 1.1187 )
);
const mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(
	vec3( 0.6274, 0.0691, 0.0164 ),
	vec3( 0.3293, 0.9195, 0.0880 ),
	vec3( 0.0433, 0.0113, 0.8956 )
);
vec3 agxDefaultContrastApprox( vec3 x ) {
	vec3 x2 = x * x;
	vec3 x4 = x2 * x2;
	return + 15.5 * x4 * x2
		- 40.14 * x4 * x
		+ 31.96 * x4
		- 6.868 * x2 * x
		+ 0.4298 * x2
		+ 0.1191 * x
		- 0.00232;
}
vec3 AgXToneMapping( vec3 color ) {
	const mat3 AgXInsetMatrix = mat3(
		vec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),
		vec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),
		vec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )
	);
	const mat3 AgXOutsetMatrix = mat3(
		vec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),
		vec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),
		vec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )
	);
	const float AgxMinEv = - 12.47393;	const float AgxMaxEv = 4.026069;
	color *= toneMappingExposure;
	color = LINEAR_SRGB_TO_LINEAR_REC2020 * color;
	color = AgXInsetMatrix * color;
	color = max( color, 1e-10 );	color = log2( color );
	color = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );
	color = clamp( color, 0.0, 1.0 );
	color = agxDefaultContrastApprox( color );
	color = AgXOutsetMatrix * color;
	color = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );
	color = LINEAR_REC2020_TO_LINEAR_SRGB * color;
	color = clamp( color, 0.0, 1.0 );
	return color;
}
vec3 NeutralToneMapping( vec3 color ) {
	const float StartCompression = 0.8 - 0.04;
	const float Desaturation = 0.15;
	color *= toneMappingExposure;
	float x = min( color.r, min( color.g, color.b ) );
	float offset = x < 0.08 ? x - 6.25 * x * x : 0.04;
	color -= offset;
	float peak = max( color.r, max( color.g, color.b ) );
	if ( peak < StartCompression ) return color;
	float d = 1. - StartCompression;
	float newPeak = 1. - d * d / ( peak + d - StartCompression );
	color *= newPeak / peak;
	float g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );
	return mix( color, vec3( newPeak ), g );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`,
  QB = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmitted = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );
#endif`,
  e5 = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	float w0( float a ) {
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );
	}
	float w1( float a ) {
		return ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );
	}
	float w2( float a ){
		return ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );
	}
	float w3( float a ) {
		return ( 1.0 / 6.0 ) * ( a * a * a );
	}
	float g0( float a ) {
		return w0( a ) + w1( a );
	}
	float g1( float a ) {
		return w2( a ) + w3( a );
	}
	float h0( float a ) {
		return - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );
	}
	float h1( float a ) {
		return 1.0 + w3( a ) / ( w2( a ) + w3( a ) );
	}
	vec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {
		uv = uv * texelSize.zw + 0.5;
		vec2 iuv = floor( uv );
		vec2 fuv = fract( uv );
		float g0x = g0( fuv.x );
		float g1x = g1( fuv.x );
		float h0x = h0( fuv.x );
		float h1x = h1( fuv.x );
		float h0y = h0( fuv.y );
		float h1y = h1( fuv.y );
		vec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;
		vec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		vec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;
		return g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +
			g1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );
	}
	vec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {
		vec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );
		vec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );
		vec2 fLodSizeInv = 1.0 / fLodSize;
		vec2 cLodSizeInv = 1.0 / cLodSize;
		vec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );
		vec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );
		return mix( fSample, cSample, fract( lod ) );
	}
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		return textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );
	}
	vec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return vec3( 1.0 );
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec4 transmittedLight;
		vec3 transmittance;
		#ifdef USE_DISPERSION
			float halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;
			vec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );
			for ( int i = 0; i < 3; i ++ ) {
				vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );
				vec3 refractedRayExit = position + transmissionRay;
		
				vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
				vec2 refractionCoords = ndcPos.xy / ndcPos.w;
				refractionCoords += 1.0;
				refractionCoords /= 2.0;
		
				vec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );
				transmittedLight[ i ] = transmissionSample[ i ];
				transmittedLight.a += transmissionSample.a;
				transmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];
			}
			transmittedLight.a /= 3.0;
		
		#else
		
			vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
			vec3 refractedRayExit = position + transmissionRay;
			vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
			vec2 refractionCoords = ndcPos.xy / ndcPos.w;
			refractionCoords += 1.0;
			refractionCoords /= 2.0;
			transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
			transmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );
		
		#endif
		vec3 attenuatedColor = transmittance * transmittedLight.rgb;
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		float transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;
		return vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );
	}
#endif`,
  t5 = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_SPECULARMAP
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
  n5 = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	varying vec2 vUv;
#endif
#ifdef USE_MAP
	uniform mat3 mapTransform;
	varying vec2 vMapUv;
#endif
#ifdef USE_ALPHAMAP
	uniform mat3 alphaMapTransform;
	varying vec2 vAlphaMapUv;
#endif
#ifdef USE_LIGHTMAP
	uniform mat3 lightMapTransform;
	varying vec2 vLightMapUv;
#endif
#ifdef USE_AOMAP
	uniform mat3 aoMapTransform;
	varying vec2 vAoMapUv;
#endif
#ifdef USE_BUMPMAP
	uniform mat3 bumpMapTransform;
	varying vec2 vBumpMapUv;
#endif
#ifdef USE_NORMALMAP
	uniform mat3 normalMapTransform;
	varying vec2 vNormalMapUv;
#endif
#ifdef USE_DISPLACEMENTMAP
	uniform mat3 displacementMapTransform;
	varying vec2 vDisplacementMapUv;
#endif
#ifdef USE_EMISSIVEMAP
	uniform mat3 emissiveMapTransform;
	varying vec2 vEmissiveMapUv;
#endif
#ifdef USE_METALNESSMAP
	uniform mat3 metalnessMapTransform;
	varying vec2 vMetalnessMapUv;
#endif
#ifdef USE_ROUGHNESSMAP
	uniform mat3 roughnessMapTransform;
	varying vec2 vRoughnessMapUv;
#endif
#ifdef USE_ANISOTROPYMAP
	uniform mat3 anisotropyMapTransform;
	varying vec2 vAnisotropyMapUv;
#endif
#ifdef USE_CLEARCOATMAP
	uniform mat3 clearcoatMapTransform;
	varying vec2 vClearcoatMapUv;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform mat3 clearcoatNormalMapTransform;
	varying vec2 vClearcoatNormalMapUv;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform mat3 clearcoatRoughnessMapTransform;
	varying vec2 vClearcoatRoughnessMapUv;
#endif
#ifdef USE_SHEEN_COLORMAP
	uniform mat3 sheenColorMapTransform;
	varying vec2 vSheenColorMapUv;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	uniform mat3 sheenRoughnessMapTransform;
	varying vec2 vSheenRoughnessMapUv;
#endif
#ifdef USE_IRIDESCENCEMAP
	uniform mat3 iridescenceMapTransform;
	varying vec2 vIridescenceMapUv;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform mat3 iridescenceThicknessMapTransform;
	varying vec2 vIridescenceThicknessMapUv;
#endif
#ifdef USE_SPECULARMAP
	uniform mat3 specularMapTransform;
	varying vec2 vSpecularMapUv;
#endif
#ifdef USE_SPECULAR_COLORMAP
	uniform mat3 specularColorMapTransform;
	varying vec2 vSpecularColorMapUv;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	uniform mat3 specularIntensityMapTransform;
	varying vec2 vSpecularIntensityMapUv;
#endif
#ifdef USE_TRANSMISSIONMAP
	uniform mat3 transmissionMapTransform;
	varying vec2 vTransmissionMapUv;
#endif
#ifdef USE_THICKNESSMAP
	uniform mat3 thicknessMapTransform;
	varying vec2 vThicknessMapUv;
#endif`,
  i5 = `#if defined( USE_UV ) || defined( USE_ANISOTROPY )
	vUv = vec3( uv, 1 ).xy;
#endif
#ifdef USE_MAP
	vMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ALPHAMAP
	vAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_LIGHTMAP
	vLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_AOMAP
	vAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_BUMPMAP
	vBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_NORMALMAP
	vNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_DISPLACEMENTMAP
	vDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_EMISSIVEMAP
	vEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_METALNESSMAP
	vMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ROUGHNESSMAP
	vRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_ANISOTROPYMAP
	vAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOATMAP
	vClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	vClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	vClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCEMAP
	vIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	vIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_COLORMAP
	vSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SHEEN_ROUGHNESSMAP
	vSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULARMAP
	vSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_COLORMAP
	vSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_SPECULAR_INTENSITYMAP
	vSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_TRANSMISSIONMAP
	vTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;
#endif
#ifdef USE_THICKNESSMAP
	vThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;
#endif`,
  r5 = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_BATCHING
		worldPosition = batchingMatrix * worldPosition;
	#endif
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`
const s5 = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`,
  o5 = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  a5 = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
  l5 = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
uniform mat3 backgroundRotation;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  c5 = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`,
  u5 = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  f5 = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`,
  d5 = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#elif DEPTH_PACKING == 3202
		gl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );
	#elif DEPTH_PACKING == 3203
		gl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );
	#endif
}`,
  h5 = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <skinbase_vertex>
	#include <morphinstance_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`,
  p5 = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	vec4 diffuseColor = vec4( 1.0 );
	#include <clipping_planes_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`,
  m5 = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`,
  g5 = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
}`,
  v5 = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
  y5 = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
  x5 = `#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`,
  _5 = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vLightMapUv );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  w5 = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  S5 = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  M5 = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`,
  E5 = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  T5 = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	vViewPosition = - mvPosition.xyz;
#endif
}`,
  b5 = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`,
  A5 = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  C5 = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  R5 = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`,
  P5 = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define USE_SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef USE_SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULAR_COLORMAP
		uniform sampler2D specularColorMap;
	#endif
	#ifdef USE_SPECULAR_INTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_DISPERSION
	uniform float dispersion;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEEN_COLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEEN_ROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
#ifdef USE_ANISOTROPY
	uniform vec2 anisotropyVector;
	#ifdef USE_ANISOTROPYMAP
		uniform sampler2D anisotropyMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;
	#endif
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  I5 = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <batching_pars_vertex>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  L5 = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`,
  D5 = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
#ifdef USE_POINTS_UV
	varying vec2 vUv;
	uniform mat3 uvTransform;
#endif
void main() {
	#ifdef USE_POINTS_UV
		vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	#endif
	#include <color_vertex>
	#include <morphinstance_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`,
  N5 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`,
  k5 = `#include <common>
#include <batching_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <batching_vertex>
	#include <beginnormal_vertex>
	#include <morphinstance_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`,
  F5 = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <logdepthbuf_pars_fragment>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	#include <logdepthbuf_fragment>
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`,
  U5 = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix[ 3 ];
	vec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`,
  O5 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <alphahash_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <alphahash_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <opaque_fragment>
	#include <tonemapping_fragment>
	#include <colorspace_fragment>
	#include <fog_fragment>
}`,
  Qt = {
    alphahash_fragment: o8,
    alphahash_pars_fragment: a8,
    alphamap_fragment: l8,
    alphamap_pars_fragment: c8,
    alphatest_fragment: u8,
    alphatest_pars_fragment: f8,
    aomap_fragment: d8,
    aomap_pars_fragment: h8,
    batching_pars_vertex: p8,
    batching_vertex: m8,
    begin_vertex: g8,
    beginnormal_vertex: v8,
    bsdfs: y8,
    iridescence_fragment: x8,
    bumpmap_pars_fragment: _8,
    clipping_planes_fragment: w8,
    clipping_planes_pars_fragment: S8,
    clipping_planes_pars_vertex: M8,
    clipping_planes_vertex: E8,
    color_fragment: T8,
    color_pars_fragment: b8,
    color_pars_vertex: A8,
    color_vertex: C8,
    common: R8,
    cube_uv_reflection_fragment: P8,
    defaultnormal_vertex: I8,
    displacementmap_pars_vertex: L8,
    displacementmap_vertex: D8,
    emissivemap_fragment: N8,
    emissivemap_pars_fragment: k8,
    colorspace_fragment: F8,
    colorspace_pars_fragment: U8,
    envmap_fragment: O8,
    envmap_common_pars_fragment: B8,
    envmap_pars_fragment: z8,
    envmap_pars_vertex: V8,
    envmap_physical_pars_fragment: J8,
    envmap_vertex: H8,
    fog_vertex: G8,
    fog_pars_vertex: W8,
    fog_fragment: j8,
    fog_pars_fragment: X8,
    gradientmap_pars_fragment: Y8,
    lightmap_pars_fragment: q8,
    lights_lambert_fragment: $8,
    lights_lambert_pars_fragment: K8,
    lights_pars_begin: Z8,
    lights_toon_fragment: Q8,
    lights_toon_pars_fragment: eB,
    lights_phong_fragment: tB,
    lights_phong_pars_fragment: nB,
    lights_physical_fragment: iB,
    lights_physical_pars_fragment: rB,
    lights_fragment_begin: sB,
    lights_fragment_maps: oB,
    lights_fragment_end: aB,
    logdepthbuf_fragment: lB,
    logdepthbuf_pars_fragment: cB,
    logdepthbuf_pars_vertex: uB,
    logdepthbuf_vertex: fB,
    map_fragment: dB,
    map_pars_fragment: hB,
    map_particle_fragment: pB,
    map_particle_pars_fragment: mB,
    metalnessmap_fragment: gB,
    metalnessmap_pars_fragment: vB,
    morphinstance_vertex: yB,
    morphcolor_vertex: xB,
    morphnormal_vertex: _B,
    morphtarget_pars_vertex: wB,
    morphtarget_vertex: SB,
    normal_fragment_begin: MB,
    normal_fragment_maps: EB,
    normal_pars_fragment: TB,
    normal_pars_vertex: bB,
    normal_vertex: AB,
    normalmap_pars_fragment: CB,
    clearcoat_normal_fragment_begin: RB,
    clearcoat_normal_fragment_maps: PB,
    clearcoat_pars_fragment: IB,
    iridescence_pars_fragment: LB,
    opaque_fragment: DB,
    packing: NB,
    premultiplied_alpha_fragment: kB,
    project_vertex: FB,
    dithering_fragment: UB,
    dithering_pars_fragment: OB,
    roughnessmap_fragment: BB,
    roughnessmap_pars_fragment: zB,
    shadowmap_pars_fragment: VB,
    shadowmap_pars_vertex: HB,
    shadowmap_vertex: GB,
    shadowmask_pars_fragment: WB,
    skinbase_vertex: jB,
    skinning_pars_vertex: XB,
    skinning_vertex: YB,
    skinnormal_vertex: qB,
    specularmap_fragment: $B,
    specularmap_pars_fragment: KB,
    tonemapping_fragment: ZB,
    tonemapping_pars_fragment: JB,
    transmission_fragment: QB,
    transmission_pars_fragment: e5,
    uv_pars_fragment: t5,
    uv_pars_vertex: n5,
    uv_vertex: i5,
    worldpos_vertex: r5,
    background_vert: s5,
    background_frag: o5,
    backgroundCube_vert: a5,
    backgroundCube_frag: l5,
    cube_vert: c5,
    cube_frag: u5,
    depth_vert: f5,
    depth_frag: d5,
    distanceRGBA_vert: h5,
    distanceRGBA_frag: p5,
    equirect_vert: m5,
    equirect_frag: g5,
    linedashed_vert: v5,
    linedashed_frag: y5,
    meshbasic_vert: x5,
    meshbasic_frag: _5,
    meshlambert_vert: w5,
    meshlambert_frag: S5,
    meshmatcap_vert: M5,
    meshmatcap_frag: E5,
    meshnormal_vert: T5,
    meshnormal_frag: b5,
    meshphong_vert: A5,
    meshphong_frag: C5,
    meshphysical_vert: R5,
    meshphysical_frag: P5,
    meshtoon_vert: I5,
    meshtoon_frag: L5,
    points_vert: D5,
    points_frag: N5,
    shadow_vert: k5,
    shadow_frag: F5,
    sprite_vert: U5,
    sprite_frag: O5,
  },
  ut = {
    common: {
      diffuse: { value: new ot(16777215) },
      opacity: { value: 1 },
      map: { value: null },
      mapTransform: { value: new Xt() },
      alphaMap: { value: null },
      alphaMapTransform: { value: new Xt() },
      alphaTest: { value: 0 },
    },
    specularmap: {
      specularMap: { value: null },
      specularMapTransform: { value: new Xt() },
    },
    envmap: {
      envMap: { value: null },
      envMapRotation: { value: new Xt() },
      flipEnvMap: { value: -1 },
      reflectivity: { value: 1 },
      ior: { value: 1.5 },
      refractionRatio: { value: 0.98 },
    },
    aomap: {
      aoMap: { value: null },
      aoMapIntensity: { value: 1 },
      aoMapTransform: { value: new Xt() },
    },
    lightmap: {
      lightMap: { value: null },
      lightMapIntensity: { value: 1 },
      lightMapTransform: { value: new Xt() },
    },
    bumpmap: {
      bumpMap: { value: null },
      bumpMapTransform: { value: new Xt() },
      bumpScale: { value: 1 },
    },
    normalmap: {
      normalMap: { value: null },
      normalMapTransform: { value: new Xt() },
      normalScale: { value: new We(1, 1) },
    },
    displacementmap: {
      displacementMap: { value: null },
      displacementMapTransform: { value: new Xt() },
      displacementScale: { value: 1 },
      displacementBias: { value: 0 },
    },
    emissivemap: {
      emissiveMap: { value: null },
      emissiveMapTransform: { value: new Xt() },
    },
    metalnessmap: {
      metalnessMap: { value: null },
      metalnessMapTransform: { value: new Xt() },
    },
    roughnessmap: {
      roughnessMap: { value: null },
      roughnessMapTransform: { value: new Xt() },
    },
    gradientmap: { gradientMap: { value: null } },
    fog: {
      fogDensity: { value: 25e-5 },
      fogNear: { value: 1 },
      fogFar: { value: 2e3 },
      fogColor: { value: new ot(16777215) },
    },
    lights: {
      ambientLightColor: { value: [] },
      lightProbe: { value: [] },
      directionalLights: { value: [], properties: { direction: {}, color: {} } },
      directionalLightShadows: {
        value: [],
        properties: {
          shadowIntensity: 1,
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {},
        },
      },
      directionalShadowMap: { value: [] },
      directionalShadowMatrix: { value: [] },
      spotLights: {
        value: [],
        properties: {
          color: {},
          position: {},
          direction: {},
          distance: {},
          coneCos: {},
          penumbraCos: {},
          decay: {},
        },
      },
      spotLightShadows: {
        value: [],
        properties: {
          shadowIntensity: 1,
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {},
        },
      },
      spotLightMap: { value: [] },
      spotShadowMap: { value: [] },
      spotLightMatrix: { value: [] },
      pointLights: {
        value: [],
        properties: { color: {}, position: {}, decay: {}, distance: {} },
      },
      pointLightShadows: {
        value: [],
        properties: {
          shadowIntensity: 1,
          shadowBias: {},
          shadowNormalBias: {},
          shadowRadius: {},
          shadowMapSize: {},
          shadowCameraNear: {},
          shadowCameraFar: {},
        },
      },
      pointShadowMap: { value: [] },
      pointShadowMatrix: { value: [] },
      hemisphereLights: {
        value: [],
        properties: { direction: {}, skyColor: {}, groundColor: {} },
      },
      rectAreaLights: {
        value: [],
        properties: { color: {}, position: {}, width: {}, height: {} },
      },
      ltc_1: { value: null },
      ltc_2: { value: null },
    },
    points: {
      diffuse: { value: new ot(16777215) },
      opacity: { value: 1 },
      size: { value: 1 },
      scale: { value: 1 },
      map: { value: null },
      alphaMap: { value: null },
      alphaMapTransform: { value: new Xt() },
      alphaTest: { value: 0 },
      uvTransform: { value: new Xt() },
    },
    sprite: {
      diffuse: { value: new ot(16777215) },
      opacity: { value: 1 },
      center: { value: new We(0.5, 0.5) },
      rotation: { value: 0 },
      map: { value: null },
      mapTransform: { value: new Xt() },
      alphaMap: { value: null },
      alphaMapTransform: { value: new Xt() },
      alphaTest: { value: 0 },
    },
  },
  vo = {
    basic: {
      uniforms: Ar([
        ut.common,
        ut.specularmap,
        ut.envmap,
        ut.aomap,
        ut.lightmap,
        ut.fog,
      ]),
      vertexShader: Qt.meshbasic_vert,
      fragmentShader: Qt.meshbasic_frag,
    },
    lambert: {
      uniforms: Ar([
        ut.common,
        ut.specularmap,
        ut.envmap,
        ut.aomap,
        ut.lightmap,
        ut.emissivemap,
        ut.bumpmap,
        ut.normalmap,
        ut.displacementmap,
        ut.fog,
        ut.lights,
        { emissive: { value: new ot(0) } },
      ]),
      vertexShader: Qt.meshlambert_vert,
      fragmentShader: Qt.meshlambert_frag,
    },
    phong: {
      uniforms: Ar([
        ut.common,
        ut.specularmap,
        ut.envmap,
        ut.aomap,
        ut.lightmap,
        ut.emissivemap,
        ut.bumpmap,
        ut.normalmap,
        ut.displacementmap,
        ut.fog,
        ut.lights,
        {
          emissive: { value: new ot(0) },
          specular: { value: new ot(1118481) },
          shininess: { value: 30 },
        },
      ]),
      vertexShader: Qt.meshphong_vert,
      fragmentShader: Qt.meshphong_frag,
    },
    standard: {
      uniforms: Ar([
        ut.common,
        ut.envmap,
        ut.aomap,
        ut.lightmap,
        ut.emissivemap,
        ut.bumpmap,
        ut.normalmap,
        ut.displacementmap,
        ut.roughnessmap,
        ut.metalnessmap,
        ut.fog,
        ut.lights,
        {
          emissive: { value: new ot(0) },
          roughness: { value: 1 },
          metalness: { value: 0 },
          envMapIntensity: { value: 1 },
        },
      ]),
      vertexShader: Qt.meshphysical_vert,
      fragmentShader: Qt.meshphysical_frag,
    },
    toon: {
      uniforms: Ar([
        ut.common,
        ut.aomap,
        ut.lightmap,
        ut.emissivemap,
        ut.bumpmap,
        ut.normalmap,
        ut.displacementmap,
        ut.gradientmap,
        ut.fog,
        ut.lights,
        { emissive: { value: new ot(0) } },
      ]),
      vertexShader: Qt.meshtoon_vert,
      fragmentShader: Qt.meshtoon_frag,
    },
    matcap: {
      uniforms: Ar([
        ut.common,
        ut.bumpmap,
        ut.normalmap,
        ut.displacementmap,
        ut.fog,
        { matcap: { value: null } },
      ]),
      vertexShader: Qt.meshmatcap_vert,
      fragmentShader: Qt.meshmatcap_frag,
    },
    points: {
      uniforms: Ar([ut.points, ut.fog]),
      vertexShader: Qt.points_vert,
      fragmentShader: Qt.points_frag,
    },
    dashed: {
      uniforms: Ar([
        ut.common,
        ut.fog,
        { scale: { value: 1 }, dashSize: { value: 1 }, totalSize: { value: 2 } },
      ]),
      vertexShader: Qt.linedashed_vert,
      fragmentShader: Qt.linedashed_frag,
    },
    depth: {
      uniforms: Ar([ut.common, ut.displacementmap]),
      vertexShader: Qt.depth_vert,
      fragmentShader: Qt.depth_frag,
    },
    normal: {
      uniforms: Ar([
        ut.common,
        ut.bumpmap,
        ut.normalmap,
        ut.displacementmap,
        { opacity: { value: 1 } },
      ]),
      vertexShader: Qt.meshnormal_vert,
      fragmentShader: Qt.meshnormal_frag,
    },
    sprite: {
      uniforms: Ar([ut.sprite, ut.fog]),
      vertexShader: Qt.sprite_vert,
      fragmentShader: Qt.sprite_frag,
    },
    background: {
      uniforms: {
        uvTransform: { value: new Xt() },
        t2D: { value: null },
        backgroundIntensity: { value: 1 },
      },
      vertexShader: Qt.background_vert,
      fragmentShader: Qt.background_frag,
    },
    backgroundCube: {
      uniforms: {
        envMap: { value: null },
        flipEnvMap: { value: -1 },
        backgroundBlurriness: { value: 0 },
        backgroundIntensity: { value: 1 },
        backgroundRotation: { value: new Xt() },
      },
      vertexShader: Qt.backgroundCube_vert,
      fragmentShader: Qt.backgroundCube_frag,
    },
    cube: {
      uniforms: { tCube: { value: null }, tFlip: { value: -1 }, opacity: { value: 1 } },
      vertexShader: Qt.cube_vert,
      fragmentShader: Qt.cube_frag,
    },
    equirect: {
      uniforms: { tEquirect: { value: null } },
      vertexShader: Qt.equirect_vert,
      fragmentShader: Qt.equirect_frag,
    },
    distanceRGBA: {
      uniforms: Ar([
        ut.common,
        ut.displacementmap,
        {
          referencePosition: { value: new q() },
          nearDistance: { value: 1 },
          farDistance: { value: 1e3 },
        },
      ]),
      vertexShader: Qt.distanceRGBA_vert,
      fragmentShader: Qt.distanceRGBA_frag,
    },
    shadow: {
      uniforms: Ar([
        ut.lights,
        ut.fog,
        { color: { value: new ot(0) }, opacity: { value: 1 } },
      ]),
      vertexShader: Qt.shadow_vert,
      fragmentShader: Qt.shadow_frag,
    },
  }
vo.physical = {
  uniforms: Ar([
    vo.standard.uniforms,
    {
      clearcoat: { value: 0 },
      clearcoatMap: { value: null },
      clearcoatMapTransform: { value: new Xt() },
      clearcoatNormalMap: { value: null },
      clearcoatNormalMapTransform: { value: new Xt() },
      clearcoatNormalScale: { value: new We(1, 1) },
      clearcoatRoughness: { value: 0 },
      clearcoatRoughnessMap: { value: null },
      clearcoatRoughnessMapTransform: { value: new Xt() },
      dispersion: { value: 0 },
      iridescence: { value: 0 },
      iridescenceMap: { value: null },
      iridescenceMapTransform: { value: new Xt() },
      iridescenceIOR: { value: 1.3 },
      iridescenceThicknessMinimum: { value: 100 },
      iridescenceThicknessMaximum: { value: 400 },
      iridescenceThicknessMap: { value: null },
      iridescenceThicknessMapTransform: { value: new Xt() },
      sheen: { value: 0 },
      sheenColor: { value: new ot(0) },
      sheenColorMap: { value: null },
      sheenColorMapTransform: { value: new Xt() },
      sheenRoughness: { value: 1 },
      sheenRoughnessMap: { value: null },
      sheenRoughnessMapTransform: { value: new Xt() },
      transmission: { value: 0 },
      transmissionMap: { value: null },
      transmissionMapTransform: { value: new Xt() },
      transmissionSamplerSize: { value: new We() },
      transmissionSamplerMap: { value: null },
      thickness: { value: 0 },
      thicknessMap: { value: null },
      thicknessMapTransform: { value: new Xt() },
      attenuationDistance: { value: 0 },
      attenuationColor: { value: new ot(0) },
      specularColor: { value: new ot(1, 1, 1) },
      specularColorMap: { value: null },
      specularColorMapTransform: { value: new Xt() },
      specularIntensity: { value: 1 },
      specularIntensityMap: { value: null },
      specularIntensityMapTransform: { value: new Xt() },
      anisotropyVector: { value: new We() },
      anisotropyMap: { value: null },
      anisotropyMapTransform: { value: new Xt() },
    },
  ]),
  vertexShader: Qt.meshphysical_vert,
  fragmentShader: Qt.meshphysical_frag,
}
const Yg = { r: 0, b: 0, g: 0 },
  eu = new Bi(),
  B5 = new mt()
function z5(n, e, t, i, r, s, o) {
  const l = new ot(0)
  let u = s === !0 ? 0 : 1,
    d,
    p,
    m = null,
    v = 0,
    y = null
  function x(A) {
    let C = A.isScene === !0 ? A.background : null
    return C && C.isTexture && (C = (A.backgroundBlurriness > 0 ? t : e).get(C)), C
  }
  function E(A) {
    let C = !1
    const R = x(A)
    R === null ? w(l, u) : R && R.isColor && (w(R, 1), (C = !0))
    const z = n.xr.getEnvironmentBlendMode()
    z === "additive"
      ? i.buffers.color.setClear(0, 0, 0, 1, o)
      : z === "alpha-blend" && i.buffers.color.setClear(0, 0, 0, 0, o),
      (n.autoClear || C) &&
        (i.buffers.depth.setTest(!0),
        i.buffers.depth.setMask(!0),
        i.buffers.color.setMask(!0),
        n.clear(n.autoClearColor, n.autoClearDepth, n.autoClearStencil))
  }
  function M(A, C) {
    const R = x(C)
    R && (R.isCubeTexture || R.mapping === Hd)
      ? (p === void 0 &&
          ((p = new ui(
            new zu(1, 1, 1),
            new Mo({
              name: "BackgroundCubeMaterial",
              uniforms: Dd(vo.backgroundCube.uniforms),
              vertexShader: vo.backgroundCube.vertexShader,
              fragmentShader: vo.backgroundCube.fragmentShader,
              side: Ir,
              depthTest: !1,
              depthWrite: !1,
              fog: !1,
            }),
          )),
          p.geometry.deleteAttribute("normal"),
          p.geometry.deleteAttribute("uv"),
          (p.onBeforeRender = function (z, U, O) {
            this.matrixWorld.copyPosition(O.matrixWorld)
          }),
          Object.defineProperty(p.material, "envMap", {
            get: function () {
              return this.uniforms.envMap.value
            },
          }),
          r.update(p)),
        eu.copy(C.backgroundRotation),
        (eu.x *= -1),
        (eu.y *= -1),
        (eu.z *= -1),
        R.isCubeTexture &&
          R.isRenderTargetTexture === !1 &&
          ((eu.y *= -1), (eu.z *= -1)),
        (p.material.uniforms.envMap.value = R),
        (p.material.uniforms.flipEnvMap.value =
          R.isCubeTexture && R.isRenderTargetTexture === !1 ? -1 : 1),
        (p.material.uniforms.backgroundBlurriness.value = C.backgroundBlurriness),
        (p.material.uniforms.backgroundIntensity.value = C.backgroundIntensity),
        p.material.uniforms.backgroundRotation.value.setFromMatrix4(
          B5.makeRotationFromEuler(eu),
        ),
        (p.material.toneMapped = fn.getTransfer(R.colorSpace) !== Sn),
        (m !== R || v !== R.version || y !== n.toneMapping) &&
          ((p.material.needsUpdate = !0),
          (m = R),
          (v = R.version),
          (y = n.toneMapping)),
        p.layers.enableAll(),
        A.unshift(p, p.geometry, p.material, 0, 0, null))
      : R &&
        R.isTexture &&
        (d === void 0 &&
          ((d = new ui(
            new jd(2, 2),
            new Mo({
              name: "BackgroundMaterial",
              uniforms: Dd(vo.background.uniforms),
              vertexShader: vo.background.vertexShader,
              fragmentShader: vo.background.fragmentShader,
              side: $a,
              depthTest: !1,
              depthWrite: !1,
              fog: !1,
            }),
          )),
          d.geometry.deleteAttribute("normal"),
          Object.defineProperty(d.material, "map", {
            get: function () {
              return this.uniforms.t2D.value
            },
          }),
          r.update(d)),
        (d.material.uniforms.t2D.value = R),
        (d.material.uniforms.backgroundIntensity.value = C.backgroundIntensity),
        (d.material.toneMapped = fn.getTransfer(R.colorSpace) !== Sn),
        R.matrixAutoUpdate === !0 && R.updateMatrix(),
        d.material.uniforms.uvTransform.value.copy(R.matrix),
        (m !== R || v !== R.version || y !== n.toneMapping) &&
          ((d.material.needsUpdate = !0),
          (m = R),
          (v = R.version),
          (y = n.toneMapping)),
        d.layers.enableAll(),
        A.unshift(d, d.geometry, d.material, 0, 0, null))
  }
  function w(A, C) {
    A.getRGB(Yg, y3(n)), i.buffers.color.setClear(Yg.r, Yg.g, Yg.b, C, o)
  }
  return {
    getClearColor: function () {
      return l
    },
    setClearColor: function (A, C = 1) {
      l.set(A), (u = C), w(l, u)
    },
    getClearAlpha: function () {
      return u
    },
    setClearAlpha: function (A) {
      ;(u = A), w(l, u)
    },
    render: E,
    addToRenderList: M,
  }
}
function V5(n, e) {
  const t = n.getParameter(n.MAX_VERTEX_ATTRIBS),
    i = {},
    r = v(null)
  let s = r,
    o = !1
  function l(I, V, Z, $, ee) {
    let ue = !1
    const re = m($, Z, V)
    s !== re && ((s = re), d(s.object)),
      (ue = y(I, $, Z, ee)),
      ue && x(I, $, Z, ee),
      ee !== null && e.update(ee, n.ELEMENT_ARRAY_BUFFER),
      (ue || o) &&
        ((o = !1),
        R(I, V, Z, $),
        ee !== null && n.bindBuffer(n.ELEMENT_ARRAY_BUFFER, e.get(ee).buffer))
  }
  function u() {
    return n.createVertexArray()
  }
  function d(I) {
    return n.bindVertexArray(I)
  }
  function p(I) {
    return n.deleteVertexArray(I)
  }
  function m(I, V, Z) {
    const $ = Z.wireframe === !0
    let ee = i[I.id]
    ee === void 0 && ((ee = {}), (i[I.id] = ee))
    let ue = ee[V.id]
    ue === void 0 && ((ue = {}), (ee[V.id] = ue))
    let re = ue[$]
    return re === void 0 && ((re = v(u())), (ue[$] = re)), re
  }
  function v(I) {
    const V = [],
      Z = [],
      $ = []
    for (let ee = 0; ee < t; ee++) (V[ee] = 0), (Z[ee] = 0), ($[ee] = 0)
    return {
      geometry: null,
      program: null,
      wireframe: !1,
      newAttributes: V,
      enabledAttributes: Z,
      attributeDivisors: $,
      object: I,
      attributes: {},
      index: null,
    }
  }
  function y(I, V, Z, $) {
    const ee = s.attributes,
      ue = V.attributes
    let re = 0
    const se = Z.getAttributes()
    for (const G in se)
      if (se[G].location >= 0) {
        const Q = ee[G]
        let W = ue[G]
        if (
          (W === void 0 &&
            (G === "instanceMatrix" && I.instanceMatrix && (W = I.instanceMatrix),
            G === "instanceColor" && I.instanceColor && (W = I.instanceColor)),
          Q === void 0 || Q.attribute !== W || (W && Q.data !== W.data))
        )
          return !0
        re++
      }
    return s.attributesNum !== re || s.index !== $
  }
  function x(I, V, Z, $) {
    const ee = {},
      ue = V.attributes
    let re = 0
    const se = Z.getAttributes()
    for (const G in se)
      if (se[G].location >= 0) {
        let Q = ue[G]
        Q === void 0 &&
          (G === "instanceMatrix" && I.instanceMatrix && (Q = I.instanceMatrix),
          G === "instanceColor" && I.instanceColor && (Q = I.instanceColor))
        const W = {}
        ;(W.attribute = Q), Q && Q.data && (W.data = Q.data), (ee[G] = W), re++
      }
    ;(s.attributes = ee), (s.attributesNum = re), (s.index = $)
  }
  function E() {
    const I = s.newAttributes
    for (let V = 0, Z = I.length; V < Z; V++) I[V] = 0
  }
  function M(I) {
    w(I, 0)
  }
  function w(I, V) {
    const Z = s.newAttributes,
      $ = s.enabledAttributes,
      ee = s.attributeDivisors
    ;(Z[I] = 1),
      $[I] === 0 && (n.enableVertexAttribArray(I), ($[I] = 1)),
      ee[I] !== V && (n.vertexAttribDivisor(I, V), (ee[I] = V))
  }
  function A() {
    const I = s.newAttributes,
      V = s.enabledAttributes
    for (let Z = 0, $ = V.length; Z < $; Z++)
      V[Z] !== I[Z] && (n.disableVertexAttribArray(Z), (V[Z] = 0))
  }
  function C(I, V, Z, $, ee, ue, re) {
    re === !0
      ? n.vertexAttribIPointer(I, V, Z, ee, ue)
      : n.vertexAttribPointer(I, V, Z, $, ee, ue)
  }
  function R(I, V, Z, $) {
    E()
    const ee = $.attributes,
      ue = Z.getAttributes(),
      re = V.defaultAttributeValues
    for (const se in ue) {
      const G = ue[se]
      if (G.location >= 0) {
        let ie = ee[se]
        if (
          (ie === void 0 &&
            (se === "instanceMatrix" && I.instanceMatrix && (ie = I.instanceMatrix),
            se === "instanceColor" && I.instanceColor && (ie = I.instanceColor)),
          ie !== void 0)
        ) {
          const Q = ie.normalized,
            W = ie.itemSize,
            ne = e.get(ie)
          if (ne === void 0) continue
          const ye = ne.buffer,
            oe = ne.type,
            fe = ne.bytesPerElement,
            we = oe === n.INT || oe === n.UNSIGNED_INT || ie.gpuType === Yv
          if (ie.isInterleavedBufferAttribute) {
            const me = ie.data,
              Fe = me.stride,
              ze = ie.offset
            if (me.isInstancedInterleavedBuffer) {
              for (let Ge = 0; Ge < G.locationSize; Ge++)
                w(G.location + Ge, me.meshPerAttribute)
              I.isInstancedMesh !== !0 &&
                $._maxInstanceCount === void 0 &&
                ($._maxInstanceCount = me.meshPerAttribute * me.count)
            } else for (let Ge = 0; Ge < G.locationSize; Ge++) M(G.location + Ge)
            n.bindBuffer(n.ARRAY_BUFFER, ye)
            for (let Ge = 0; Ge < G.locationSize; Ge++)
              C(
                G.location + Ge,
                W / G.locationSize,
                oe,
                Q,
                Fe * fe,
                (ze + (W / G.locationSize) * Ge) * fe,
                we,
              )
          } else {
            if (ie.isInstancedBufferAttribute) {
              for (let me = 0; me < G.locationSize; me++)
                w(G.location + me, ie.meshPerAttribute)
              I.isInstancedMesh !== !0 &&
                $._maxInstanceCount === void 0 &&
                ($._maxInstanceCount = ie.meshPerAttribute * ie.count)
            } else for (let me = 0; me < G.locationSize; me++) M(G.location + me)
            n.bindBuffer(n.ARRAY_BUFFER, ye)
            for (let me = 0; me < G.locationSize; me++)
              C(
                G.location + me,
                W / G.locationSize,
                oe,
                Q,
                W * fe,
                (W / G.locationSize) * me * fe,
                we,
              )
          }
        } else if (re !== void 0) {
          const Q = re[se]
          if (Q !== void 0)
            switch (Q.length) {
              case 2:
                n.vertexAttrib2fv(G.location, Q)
                break
              case 3:
                n.vertexAttrib3fv(G.location, Q)
                break
              case 4:
                n.vertexAttrib4fv(G.location, Q)
                break
              default:
                n.vertexAttrib1fv(G.location, Q)
            }
        }
      }
    }
    A()
  }
  function z() {
    N()
    for (const I in i) {
      const V = i[I]
      for (const Z in V) {
        const $ = V[Z]
        for (const ee in $) p($[ee].object), delete $[ee]
        delete V[Z]
      }
      delete i[I]
    }
  }
  function U(I) {
    if (i[I.id] === void 0) return
    const V = i[I.id]
    for (const Z in V) {
      const $ = V[Z]
      for (const ee in $) p($[ee].object), delete $[ee]
      delete V[Z]
    }
    delete i[I.id]
  }
  function O(I) {
    for (const V in i) {
      const Z = i[V]
      if (Z[I.id] === void 0) continue
      const $ = Z[I.id]
      for (const ee in $) p($[ee].object), delete $[ee]
      delete Z[I.id]
    }
  }
  function N() {
    k(), (o = !0), s !== r && ((s = r), d(s.object))
  }
  function k() {
    ;(r.geometry = null), (r.program = null), (r.wireframe = !1)
  }
  return {
    setup: l,
    reset: N,
    resetDefaultState: k,
    dispose: z,
    releaseStatesOfGeometry: U,
    releaseStatesOfProgram: O,
    initAttributes: E,
    enableAttribute: M,
    disableUnusedAttributes: A,
  }
}
function H5(n, e, t) {
  let i
  function r(d) {
    i = d
  }
  function s(d, p) {
    n.drawArrays(i, d, p), t.update(p, i, 1)
  }
  function o(d, p, m) {
    m !== 0 && (n.drawArraysInstanced(i, d, p, m), t.update(p, i, m))
  }
  function l(d, p, m) {
    if (m === 0) return
    e.get("WEBGL_multi_draw").multiDrawArraysWEBGL(i, d, 0, p, 0, m)
    let y = 0
    for (let x = 0; x < m; x++) y += p[x]
    t.update(y, i, 1)
  }
  function u(d, p, m, v) {
    if (m === 0) return
    const y = e.get("WEBGL_multi_draw")
    if (y === null) for (let x = 0; x < d.length; x++) o(d[x], p[x], v[x])
    else {
      y.multiDrawArraysInstancedWEBGL(i, d, 0, p, 0, v, 0, m)
      let x = 0
      for (let E = 0; E < m; E++) x += p[E] * v[E]
      t.update(x, i, 1)
    }
  }
  ;(this.setMode = r),
    (this.render = s),
    (this.renderInstances = o),
    (this.renderMultiDraw = l),
    (this.renderMultiDrawInstances = u)
}
function G5(n, e, t, i) {
  let r
  function s() {
    if (r !== void 0) return r
    if (e.has("EXT_texture_filter_anisotropic") === !0) {
      const O = e.get("EXT_texture_filter_anisotropic")
      r = n.getParameter(O.MAX_TEXTURE_MAX_ANISOTROPY_EXT)
    } else r = 0
    return r
  }
  function o(O) {
    return !(
      O !== hr && i.convert(O) !== n.getParameter(n.IMPLEMENTATION_COLOR_READ_FORMAT)
    )
  }
  function l(O) {
    const N =
      O === Gd &&
      (e.has("EXT_color_buffer_half_float") || e.has("EXT_color_buffer_float"))
    return !(
      O !== wo &&
      i.convert(O) !== n.getParameter(n.IMPLEMENTATION_COLOR_READ_TYPE) &&
      O !== Qr &&
      !N
    )
  }
  function u(O) {
    if (O === "highp") {
      if (
        n.getShaderPrecisionFormat(n.VERTEX_SHADER, n.HIGH_FLOAT).precision > 0 &&
        n.getShaderPrecisionFormat(n.FRAGMENT_SHADER, n.HIGH_FLOAT).precision > 0
      )
        return "highp"
      O = "mediump"
    }
    return O === "mediump" &&
      n.getShaderPrecisionFormat(n.VERTEX_SHADER, n.MEDIUM_FLOAT).precision > 0 &&
      n.getShaderPrecisionFormat(n.FRAGMENT_SHADER, n.MEDIUM_FLOAT).precision > 0
      ? "mediump"
      : "lowp"
  }
  let d = t.precision !== void 0 ? t.precision : "highp"
  const p = u(d)
  p !== d &&
    (console.warn("THREE.WebGLRenderer:", d, "not supported, using", p, "instead."),
    (d = p))
  const m = t.logarithmicDepthBuffer === !0,
    v = t.reverseDepthBuffer === !0 && e.has("EXT_clip_control"),
    y = n.getParameter(n.MAX_TEXTURE_IMAGE_UNITS),
    x = n.getParameter(n.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
    E = n.getParameter(n.MAX_TEXTURE_SIZE),
    M = n.getParameter(n.MAX_CUBE_MAP_TEXTURE_SIZE),
    w = n.getParameter(n.MAX_VERTEX_ATTRIBS),
    A = n.getParameter(n.MAX_VERTEX_UNIFORM_VECTORS),
    C = n.getParameter(n.MAX_VARYING_VECTORS),
    R = n.getParameter(n.MAX_FRAGMENT_UNIFORM_VECTORS),
    z = x > 0,
    U = n.getParameter(n.MAX_SAMPLES)
  return {
    isWebGL2: !0,
    getMaxAnisotropy: s,
    getMaxPrecision: u,
    textureFormatReadable: o,
    textureTypeReadable: l,
    precision: d,
    logarithmicDepthBuffer: m,
    reverseDepthBuffer: v,
    maxTextures: y,
    maxVertexTextures: x,
    maxTextureSize: E,
    maxCubemapSize: M,
    maxAttributes: w,
    maxVertexUniforms: A,
    maxVaryings: C,
    maxFragmentUniforms: R,
    vertexTextures: z,
    maxSamples: U,
  }
}
function W5(n) {
  const e = this
  let t = null,
    i = 0,
    r = !1,
    s = !1
  const o = new Yl(),
    l = new Xt(),
    u = { value: null, needsUpdate: !1 }
  ;(this.uniform = u),
    (this.numPlanes = 0),
    (this.numIntersection = 0),
    (this.init = function (m, v) {
      const y = m.length !== 0 || v || i !== 0 || r
      return (r = v), (i = m.length), y
    }),
    (this.beginShadows = function () {
      ;(s = !0), p(null)
    }),
    (this.endShadows = function () {
      s = !1
    }),
    (this.setGlobalState = function (m, v) {
      t = p(m, v, 0)
    }),
    (this.setState = function (m, v, y) {
      const x = m.clippingPlanes,
        E = m.clipIntersection,
        M = m.clipShadows,
        w = n.get(m)
      if (!r || x === null || x.length === 0 || (s && !M)) s ? p(null) : d()
      else {
        const A = s ? 0 : i,
          C = A * 4
        let R = w.clippingState || null
        ;(u.value = R), (R = p(x, v, C, y))
        for (let z = 0; z !== C; ++z) R[z] = t[z]
        ;(w.clippingState = R),
          (this.numIntersection = E ? this.numPlanes : 0),
          (this.numPlanes += A)
      }
    })
  function d() {
    u.value !== t && ((u.value = t), (u.needsUpdate = i > 0)),
      (e.numPlanes = i),
      (e.numIntersection = 0)
  }
  function p(m, v, y, x) {
    const E = m !== null ? m.length : 0
    let M = null
    if (E !== 0) {
      if (((M = u.value), x !== !0 || M === null)) {
        const w = y + E * 4,
          A = v.matrixWorldInverse
        l.getNormalMatrix(A), (M === null || M.length < w) && (M = new Float32Array(w))
        for (let C = 0, R = y; C !== E; ++C, R += 4)
          o.copy(m[C]).applyMatrix4(A, l),
            o.normal.toArray(M, R),
            (M[R + 3] = o.constant)
      }
      ;(u.value = M), (u.needsUpdate = !0)
    }
    return (e.numPlanes = E), (e.numIntersection = 0), M
  }
}
function j5(n) {
  let e = new WeakMap()
  function t(o, l) {
    return l === Pd ? (o.mapping = Ka) : l === Wp && (o.mapping = rc), o
  }
  function i(o) {
    if (o && o.isTexture) {
      const l = o.mapping
      if (l === Pd || l === Wp)
        if (e.has(o)) {
          const u = e.get(o).texture
          return t(u, o.mapping)
        } else {
          const u = o.image
          if (u && u.height > 0) {
            const d = new w3(u.height)
            return (
              d.fromEquirectangularTexture(n, o),
              e.set(o, d),
              o.addEventListener("dispose", r),
              t(d.texture, o.mapping)
            )
          } else return null
        }
    }
    return o
  }
  function r(o) {
    const l = o.target
    l.removeEventListener("dispose", r)
    const u = e.get(l)
    u !== void 0 && (e.delete(l), u.dispose())
  }
  function s() {
    e = new WeakMap()
  }
  return { get: i, dispose: s }
}
class Xd extends xm {
  constructor(e = -1, t = 1, i = 1, r = -1, s = 0.1, o = 2e3) {
    super(),
      (this.isOrthographicCamera = !0),
      (this.type = "OrthographicCamera"),
      (this.zoom = 1),
      (this.view = null),
      (this.left = e),
      (this.right = t),
      (this.top = i),
      (this.bottom = r),
      (this.near = s),
      (this.far = o),
      this.updateProjectionMatrix()
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      (this.left = e.left),
      (this.right = e.right),
      (this.top = e.top),
      (this.bottom = e.bottom),
      (this.near = e.near),
      (this.far = e.far),
      (this.zoom = e.zoom),
      (this.view = e.view === null ? null : Object.assign({}, e.view)),
      this
    )
  }
  setViewOffset(e, t, i, r, s, o) {
    this.view === null &&
      (this.view = {
        enabled: !0,
        fullWidth: 1,
        fullHeight: 1,
        offsetX: 0,
        offsetY: 0,
        width: 1,
        height: 1,
      }),
      (this.view.enabled = !0),
      (this.view.fullWidth = e),
      (this.view.fullHeight = t),
      (this.view.offsetX = i),
      (this.view.offsetY = r),
      (this.view.width = s),
      (this.view.height = o),
      this.updateProjectionMatrix()
  }
  clearViewOffset() {
    this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix()
  }
  updateProjectionMatrix() {
    const e = (this.right - this.left) / (2 * this.zoom),
      t = (this.top - this.bottom) / (2 * this.zoom),
      i = (this.right + this.left) / 2,
      r = (this.top + this.bottom) / 2
    let s = i - e,
      o = i + e,
      l = r + t,
      u = r - t
    if (this.view !== null && this.view.enabled) {
      const d = (this.right - this.left) / this.view.fullWidth / this.zoom,
        p = (this.top - this.bottom) / this.view.fullHeight / this.zoom
      ;(s += d * this.view.offsetX),
        (o = s + d * this.view.width),
        (l -= p * this.view.offsetY),
        (u = l - p * this.view.height)
    }
    this.projectionMatrix.makeOrthographic(
      s,
      o,
      l,
      u,
      this.near,
      this.far,
      this.coordinateSystem,
    ),
      this.projectionMatrixInverse.copy(this.projectionMatrix).invert()
  }
  toJSON(e) {
    const t = super.toJSON(e)
    return (
      (t.object.zoom = this.zoom),
      (t.object.left = this.left),
      (t.object.right = this.right),
      (t.object.top = this.top),
      (t.object.bottom = this.bottom),
      (t.object.near = this.near),
      (t.object.far = this.far),
      this.view !== null && (t.object.view = Object.assign({}, this.view)),
      t
    )
  }
}
const Md = 4,
  vT = [0.125, 0.215, 0.35, 0.446, 0.526, 0.582],
  pu = 20,
  Zx = new Xd(),
  yT = new ot()
let Jx = null,
  Qx = 0,
  e_ = 0,
  t_ = !1
const du = (1 + Math.sqrt(5)) / 2,
  od = 1 / du,
  xT = [
    new q(-du, od, 0),
    new q(du, od, 0),
    new q(-od, 0, du),
    new q(od, 0, du),
    new q(0, du, -od),
    new q(0, du, od),
    new q(-1, 1, -1),
    new q(1, 1, -1),
    new q(-1, 1, 1),
    new q(1, 1, 1),
  ]
class E1 {
  constructor(e) {
    ;(this._renderer = e),
      (this._pingPongRenderTarget = null),
      (this._lodMax = 0),
      (this._cubeSize = 0),
      (this._lodPlanes = []),
      (this._sizeLods = []),
      (this._sigmas = []),
      (this._blurMaterial = null),
      (this._cubemapMaterial = null),
      (this._equirectMaterial = null),
      this._compileMaterial(this._blurMaterial)
  }
  fromScene(e, t = 0, i = 0.1, r = 100) {
    ;(Jx = this._renderer.getRenderTarget()),
      (Qx = this._renderer.getActiveCubeFace()),
      (e_ = this._renderer.getActiveMipmapLevel()),
      (t_ = this._renderer.xr.enabled),
      (this._renderer.xr.enabled = !1),
      this._setSize(256)
    const s = this._allocateTargets()
    return (
      (s.depthBuffer = !0),
      this._sceneToCubeUV(e, i, r, s),
      t > 0 && this._blur(s, 0, 0, t),
      this._applyPMREM(s),
      this._cleanup(s),
      s
    )
  }
  fromEquirectangular(e, t = null) {
    return this._fromTexture(e, t)
  }
  fromCubemap(e, t = null) {
    return this._fromTexture(e, t)
  }
  compileCubemapShader() {
    this._cubemapMaterial === null &&
      ((this._cubemapMaterial = ST()), this._compileMaterial(this._cubemapMaterial))
  }
  compileEquirectangularShader() {
    this._equirectMaterial === null &&
      ((this._equirectMaterial = wT()), this._compileMaterial(this._equirectMaterial))
  }
  dispose() {
    this._dispose(),
      this._cubemapMaterial !== null && this._cubemapMaterial.dispose(),
      this._equirectMaterial !== null && this._equirectMaterial.dispose()
  }
  _setSize(e) {
    ;(this._lodMax = Math.floor(Math.log2(e))),
      (this._cubeSize = Math.pow(2, this._lodMax))
  }
  _dispose() {
    this._blurMaterial !== null && this._blurMaterial.dispose(),
      this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose()
    for (let e = 0; e < this._lodPlanes.length; e++) this._lodPlanes[e].dispose()
  }
  _cleanup(e) {
    this._renderer.setRenderTarget(Jx, Qx, e_),
      (this._renderer.xr.enabled = t_),
      (e.scissorTest = !1),
      qg(e, 0, 0, e.width, e.height)
  }
  _fromTexture(e, t) {
    e.mapping === Ka || e.mapping === rc
      ? this._setSize(
          e.image.length === 0 ? 16 : e.image[0].width || e.image[0].image.width,
        )
      : this._setSize(e.image.width / 4),
      (Jx = this._renderer.getRenderTarget()),
      (Qx = this._renderer.getActiveCubeFace()),
      (e_ = this._renderer.getActiveMipmapLevel()),
      (t_ = this._renderer.xr.enabled),
      (this._renderer.xr.enabled = !1)
    const i = t || this._allocateTargets()
    return this._textureToCubeUV(e, i), this._applyPMREM(i), this._cleanup(i), i
  }
  _allocateTargets() {
    const e = 3 * Math.max(this._cubeSize, 112),
      t = 4 * this._cubeSize,
      i = {
        magFilter: Ri,
        minFilter: Ri,
        generateMipmaps: !1,
        type: Gd,
        format: hr,
        colorSpace: Bu,
        depthBuffer: !1,
      },
      r = _T(e, t, i)
    if (
      this._pingPongRenderTarget === null ||
      this._pingPongRenderTarget.width !== e ||
      this._pingPongRenderTarget.height !== t
    ) {
      this._pingPongRenderTarget !== null && this._dispose(),
        (this._pingPongRenderTarget = _T(e, t, i))
      const { _lodMax: s } = this
      ;({
        sizeLods: this._sizeLods,
        lodPlanes: this._lodPlanes,
        sigmas: this._sigmas,
      } = X5(s)),
        (this._blurMaterial = Y5(s, e, t))
    }
    return r
  }
  _compileMaterial(e) {
    const t = new ui(this._lodPlanes[0], e)
    this._renderer.compile(t, Zx)
  }
  _sceneToCubeUV(e, t, i, r) {
    const l = new Ci(90, 1, t, i),
      u = [1, -1, 1, 1, 1, 1],
      d = [1, 1, 1, -1, -1, -1],
      p = this._renderer,
      m = p.autoClear,
      v = p.toneMapping
    p.getClearColor(yT), (p.toneMapping = Xo), (p.autoClear = !1)
    const y = new el({
        name: "PMREM.Background",
        side: Ir,
        depthWrite: !1,
        depthTest: !1,
      }),
      x = new ui(new zu(), y)
    let E = !1
    const M = e.background
    M
      ? M.isColor && (y.color.copy(M), (e.background = null), (E = !0))
      : (y.color.copy(yT), (E = !0))
    for (let w = 0; w < 6; w++) {
      const A = w % 3
      A === 0
        ? (l.up.set(0, u[w], 0), l.lookAt(d[w], 0, 0))
        : A === 1
        ? (l.up.set(0, 0, u[w]), l.lookAt(0, d[w], 0))
        : (l.up.set(0, u[w], 0), l.lookAt(0, 0, d[w]))
      const C = this._cubeSize
      qg(r, A * C, w > 2 ? C : 0, C, C),
        p.setRenderTarget(r),
        E && p.render(x, l),
        p.render(e, l)
    }
    x.geometry.dispose(),
      x.material.dispose(),
      (p.toneMapping = v),
      (p.autoClear = m),
      (e.background = M)
  }
  _textureToCubeUV(e, t) {
    const i = this._renderer,
      r = e.mapping === Ka || e.mapping === rc
    r
      ? (this._cubemapMaterial === null && (this._cubemapMaterial = ST()),
        (this._cubemapMaterial.uniforms.flipEnvMap.value =
          e.isRenderTargetTexture === !1 ? -1 : 1))
      : this._equirectMaterial === null && (this._equirectMaterial = wT())
    const s = r ? this._cubemapMaterial : this._equirectMaterial,
      o = new ui(this._lodPlanes[0], s),
      l = s.uniforms
    l.envMap.value = e
    const u = this._cubeSize
    qg(t, 0, 0, 3 * u, 2 * u), i.setRenderTarget(t), i.render(o, Zx)
  }
  _applyPMREM(e) {
    const t = this._renderer,
      i = t.autoClear
    t.autoClear = !1
    const r = this._lodPlanes.length
    for (let s = 1; s < r; s++) {
      const o = Math.sqrt(
          this._sigmas[s] * this._sigmas[s] - this._sigmas[s - 1] * this._sigmas[s - 1],
        ),
        l = xT[(r - s - 1) % xT.length]
      this._blur(e, s - 1, s, o, l)
    }
    t.autoClear = i
  }
  _blur(e, t, i, r, s) {
    const o = this._pingPongRenderTarget
    this._halfBlur(e, o, t, i, r, "latitudinal", s),
      this._halfBlur(o, e, i, i, r, "longitudinal", s)
  }
  _halfBlur(e, t, i, r, s, o, l) {
    const u = this._renderer,
      d = this._blurMaterial
    o !== "latitudinal" &&
      o !== "longitudinal" &&
      console.error("blur direction must be either latitudinal or longitudinal!")
    const p = 3,
      m = new ui(this._lodPlanes[r], d),
      v = d.uniforms,
      y = this._sizeLods[i] - 1,
      x = isFinite(s) ? Math.PI / (2 * y) : (2 * Math.PI) / (2 * pu - 1),
      E = s / x,
      M = isFinite(s) ? 1 + Math.floor(p * E) : pu
    M > pu &&
      console.warn(
        `sigmaRadians, ${s}, is too large and will clip, as it requested ${M} samples when the maximum is set to ${pu}`,
      )
    const w = []
    let A = 0
    for (let O = 0; O < pu; ++O) {
      const N = O / E,
        k = Math.exp((-N * N) / 2)
      w.push(k), O === 0 ? (A += k) : O < M && (A += 2 * k)
    }
    for (let O = 0; O < w.length; O++) w[O] = w[O] / A
    ;(v.envMap.value = e.texture),
      (v.samples.value = M),
      (v.weights.value = w),
      (v.latitudinal.value = o === "latitudinal"),
      l && (v.poleAxis.value = l)
    const { _lodMax: C } = this
    ;(v.dTheta.value = x), (v.mipInt.value = C - i)
    const R = this._sizeLods[r],
      z = 3 * R * (r > C - Md ? r - C + Md : 0),
      U = 4 * (this._cubeSize - R)
    qg(t, z, U, 3 * R, 2 * R), u.setRenderTarget(t), u.render(m, Zx)
  }
}
function X5(n) {
  const e = [],
    t = [],
    i = []
  let r = n
  const s = n - Md + 1 + vT.length
  for (let o = 0; o < s; o++) {
    const l = Math.pow(2, r)
    t.push(l)
    let u = 1 / l
    o > n - Md ? (u = vT[o - n + Md - 1]) : o === 0 && (u = 0), i.push(u)
    const d = 1 / (l - 2),
      p = -d,
      m = 1 + d,
      v = [p, p, m, p, m, m, p, p, m, m, p, m],
      y = 6,
      x = 6,
      E = 3,
      M = 2,
      w = 1,
      A = new Float32Array(E * x * y),
      C = new Float32Array(M * x * y),
      R = new Float32Array(w * x * y)
    for (let U = 0; U < y; U++) {
      const O = ((U % 3) * 2) / 3 - 1,
        N = U > 2 ? 0 : -1,
        k = [
          O,
          N,
          0,
          O + 2 / 3,
          N,
          0,
          O + 2 / 3,
          N + 1,
          0,
          O,
          N,
          0,
          O + 2 / 3,
          N + 1,
          0,
          O,
          N + 1,
          0,
        ]
      A.set(k, E * x * U), C.set(v, M * x * U)
      const I = [U, U, U, U, U, U]
      R.set(I, w * x * U)
    }
    const z = new Gt()
    z.setAttribute("position", new bn(A, E)),
      z.setAttribute("uv", new bn(C, M)),
      z.setAttribute("faceIndex", new bn(R, w)),
      e.push(z),
      r > Md && r--
  }
  return { lodPlanes: e, sizeLods: t, sigmas: i }
}
function _T(n, e, t) {
  const i = new So(n, e, t)
  return (
    (i.texture.mapping = Hd), (i.texture.name = "PMREM.cubeUv"), (i.scissorTest = !0), i
  )
}
function qg(n, e, t, i, r) {
  n.viewport.set(e, t, i, r), n.scissor.set(e, t, i, r)
}
function Y5(n, e, t) {
  const i = new Float32Array(pu),
    r = new q(0, 1, 0)
  return new Mo({
    name: "SphericalGaussianBlur",
    defines: {
      n: pu,
      CUBEUV_TEXEL_WIDTH: 1 / e,
      CUBEUV_TEXEL_HEIGHT: 1 / t,
      CUBEUV_MAX_MIP: `${n}.0`,
    },
    uniforms: {
      envMap: { value: null },
      samples: { value: 1 },
      weights: { value: i },
      latitudinal: { value: !1 },
      dTheta: { value: 0 },
      mipInt: { value: 0 },
      poleAxis: { value: r },
    },
    vertexShader: zw(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
    blending: ja,
    depthTest: !1,
    depthWrite: !1,
  })
}
function wT() {
  return new Mo({
    name: "EquirectangularToCubeUV",
    uniforms: { envMap: { value: null } },
    vertexShader: zw(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
    blending: ja,
    depthTest: !1,
    depthWrite: !1,
  })
}
function ST() {
  return new Mo({
    name: "CubemapToCubeUV",
    uniforms: { envMap: { value: null }, flipEnvMap: { value: -1 } },
    vertexShader: zw(),
    fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
    blending: ja,
    depthTest: !1,
    depthWrite: !1,
  })
}
function zw() {
  return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`
}
function q5(n) {
  let e = new WeakMap(),
    t = null
  function i(l) {
    if (l && l.isTexture) {
      const u = l.mapping,
        d = u === Pd || u === Wp,
        p = u === Ka || u === rc
      if (d || p) {
        let m = e.get(l)
        const v = m !== void 0 ? m.texture.pmremVersion : 0
        if (l.isRenderTargetTexture && l.pmremVersion !== v)
          return (
            t === null && (t = new E1(n)),
            (m = d ? t.fromEquirectangular(l, m) : t.fromCubemap(l, m)),
            (m.texture.pmremVersion = l.pmremVersion),
            e.set(l, m),
            m.texture
          )
        if (m !== void 0) return m.texture
        {
          const y = l.image
          return (d && y && y.height > 0) || (p && y && r(y))
            ? (t === null && (t = new E1(n)),
              (m = d ? t.fromEquirectangular(l) : t.fromCubemap(l)),
              (m.texture.pmremVersion = l.pmremVersion),
              e.set(l, m),
              l.addEventListener("dispose", s),
              m.texture)
            : null
        }
      }
    }
    return l
  }
  function r(l) {
    let u = 0
    const d = 6
    for (let p = 0; p < d; p++) l[p] !== void 0 && u++
    return u === d
  }
  function s(l) {
    const u = l.target
    u.removeEventListener("dispose", s)
    const d = e.get(u)
    d !== void 0 && (e.delete(u), d.dispose())
  }
  function o() {
    ;(e = new WeakMap()), t !== null && (t.dispose(), (t = null))
  }
  return { get: i, dispose: o }
}
function $5(n) {
  const e = {}
  function t(i) {
    if (e[i] !== void 0) return e[i]
    let r
    switch (i) {
      case "WEBGL_depth_texture":
        r =
          n.getExtension("WEBGL_depth_texture") ||
          n.getExtension("MOZ_WEBGL_depth_texture") ||
          n.getExtension("WEBKIT_WEBGL_depth_texture")
        break
      case "EXT_texture_filter_anisotropic":
        r =
          n.getExtension("EXT_texture_filter_anisotropic") ||
          n.getExtension("MOZ_EXT_texture_filter_anisotropic") ||
          n.getExtension("WEBKIT_EXT_texture_filter_anisotropic")
        break
      case "WEBGL_compressed_texture_s3tc":
        r =
          n.getExtension("WEBGL_compressed_texture_s3tc") ||
          n.getExtension("MOZ_WEBGL_compressed_texture_s3tc") ||
          n.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc")
        break
      case "WEBGL_compressed_texture_pvrtc":
        r =
          n.getExtension("WEBGL_compressed_texture_pvrtc") ||
          n.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc")
        break
      default:
        r = n.getExtension(i)
    }
    return (e[i] = r), r
  }
  return {
    has: function (i) {
      return t(i) !== null
    },
    init: function () {
      t("EXT_color_buffer_float"),
        t("WEBGL_clip_cull_distance"),
        t("OES_texture_float_linear"),
        t("EXT_color_buffer_half_float"),
        t("WEBGL_multisampled_render_to_texture"),
        t("WEBGL_render_shared_exponent")
    },
    get: function (i) {
      const r = t(i)
      return (
        r === null && hp("THREE.WebGLRenderer: " + i + " extension not supported."), r
      )
    },
  }
}
function K5(n, e, t, i) {
  const r = {},
    s = new WeakMap()
  function o(m) {
    const v = m.target
    v.index !== null && e.remove(v.index)
    for (const x in v.attributes) e.remove(v.attributes[x])
    for (const x in v.morphAttributes) {
      const E = v.morphAttributes[x]
      for (let M = 0, w = E.length; M < w; M++) e.remove(E[M])
    }
    v.removeEventListener("dispose", o), delete r[v.id]
    const y = s.get(v)
    y && (e.remove(y), s.delete(v)),
      i.releaseStatesOfGeometry(v),
      v.isInstancedBufferGeometry === !0 && delete v._maxInstanceCount,
      t.memory.geometries--
  }
  function l(m, v) {
    return (
      r[v.id] === !0 ||
        (v.addEventListener("dispose", o), (r[v.id] = !0), t.memory.geometries++),
      v
    )
  }
  function u(m) {
    const v = m.attributes
    for (const x in v) e.update(v[x], n.ARRAY_BUFFER)
    const y = m.morphAttributes
    for (const x in y) {
      const E = y[x]
      for (let M = 0, w = E.length; M < w; M++) e.update(E[M], n.ARRAY_BUFFER)
    }
  }
  function d(m) {
    const v = [],
      y = m.index,
      x = m.attributes.position
    let E = 0
    if (y !== null) {
      const A = y.array
      E = y.version
      for (let C = 0, R = A.length; C < R; C += 3) {
        const z = A[C + 0],
          U = A[C + 1],
          O = A[C + 2]
        v.push(z, U, U, O, O, z)
      }
    } else if (x !== void 0) {
      const A = x.array
      E = x.version
      for (let C = 0, R = A.length / 3 - 1; C < R; C += 3) {
        const z = C + 0,
          U = C + 1,
          O = C + 2
        v.push(z, U, U, O, O, z)
      }
    } else return
    const M = new (h3(v) ? Bw : ty)(v, 1)
    M.version = E
    const w = s.get(m)
    w && e.remove(w), s.set(m, M)
  }
  function p(m) {
    const v = s.get(m)
    if (v) {
      const y = m.index
      y !== null && v.version < y.version && d(m)
    } else d(m)
    return s.get(m)
  }
  return { get: l, update: u, getWireframeAttribute: p }
}
function Z5(n, e, t) {
  let i
  function r(v) {
    i = v
  }
  let s, o
  function l(v) {
    ;(s = v.type), (o = v.bytesPerElement)
  }
  function u(v, y) {
    n.drawElements(i, y, s, v * o), t.update(y, i, 1)
  }
  function d(v, y, x) {
    x !== 0 && (n.drawElementsInstanced(i, y, s, v * o, x), t.update(y, i, x))
  }
  function p(v, y, x) {
    if (x === 0) return
    e.get("WEBGL_multi_draw").multiDrawElementsWEBGL(i, y, 0, s, v, 0, x)
    let M = 0
    for (let w = 0; w < x; w++) M += y[w]
    t.update(M, i, 1)
  }
  function m(v, y, x, E) {
    if (x === 0) return
    const M = e.get("WEBGL_multi_draw")
    if (M === null) for (let w = 0; w < v.length; w++) d(v[w] / o, y[w], E[w])
    else {
      M.multiDrawElementsInstancedWEBGL(i, y, 0, s, v, 0, E, 0, x)
      let w = 0
      for (let A = 0; A < x; A++) w += y[A] * E[A]
      t.update(w, i, 1)
    }
  }
  ;(this.setMode = r),
    (this.setIndex = l),
    (this.render = u),
    (this.renderInstances = d),
    (this.renderMultiDraw = p),
    (this.renderMultiDrawInstances = m)
}
function J5(n) {
  const e = { geometries: 0, textures: 0 },
    t = { frame: 0, calls: 0, triangles: 0, points: 0, lines: 0 }
  function i(s, o, l) {
    switch ((t.calls++, o)) {
      case n.TRIANGLES:
        t.triangles += l * (s / 3)
        break
      case n.LINES:
        t.lines += l * (s / 2)
        break
      case n.LINE_STRIP:
        t.lines += l * (s - 1)
        break
      case n.LINE_LOOP:
        t.lines += l * s
        break
      case n.POINTS:
        t.points += l * s
        break
      default:
        console.error("THREE.WebGLInfo: Unknown draw mode:", o)
        break
    }
  }
  function r() {
    ;(t.calls = 0), (t.triangles = 0), (t.points = 0), (t.lines = 0)
  }
  return { memory: e, render: t, programs: null, autoReset: !0, reset: r, update: i }
}
function Q5(n, e, t) {
  const i = new WeakMap(),
    r = new on()
  function s(o, l, u) {
    const d = o.morphTargetInfluences,
      p =
        l.morphAttributes.position ||
        l.morphAttributes.normal ||
        l.morphAttributes.color,
      m = p !== void 0 ? p.length : 0
    let v = i.get(l)
    if (v === void 0 || v.count !== m) {
      let I = function () {
        N.dispose(), i.delete(l), l.removeEventListener("dispose", I)
      }
      var y = I
      v !== void 0 && v.texture.dispose()
      const x = l.morphAttributes.position !== void 0,
        E = l.morphAttributes.normal !== void 0,
        M = l.morphAttributes.color !== void 0,
        w = l.morphAttributes.position || [],
        A = l.morphAttributes.normal || [],
        C = l.morphAttributes.color || []
      let R = 0
      x === !0 && (R = 1), E === !0 && (R = 2), M === !0 && (R = 3)
      let z = l.attributes.position.count * R,
        U = 1
      z > e.maxTextureSize &&
        ((U = Math.ceil(z / e.maxTextureSize)), (z = e.maxTextureSize))
      const O = new Float32Array(z * U * 4 * m),
        N = new ey(O, z, U, m)
      ;(N.type = Qr), (N.needsUpdate = !0)
      const k = R * 4
      for (let V = 0; V < m; V++) {
        const Z = w[V],
          $ = A[V],
          ee = C[V],
          ue = z * U * 4 * V
        for (let re = 0; re < Z.count; re++) {
          const se = re * k
          x === !0 &&
            (r.fromBufferAttribute(Z, re),
            (O[ue + se + 0] = r.x),
            (O[ue + se + 1] = r.y),
            (O[ue + se + 2] = r.z),
            (O[ue + se + 3] = 0)),
            E === !0 &&
              (r.fromBufferAttribute($, re),
              (O[ue + se + 4] = r.x),
              (O[ue + se + 5] = r.y),
              (O[ue + se + 6] = r.z),
              (O[ue + se + 7] = 0)),
            M === !0 &&
              (r.fromBufferAttribute(ee, re),
              (O[ue + se + 8] = r.x),
              (O[ue + se + 9] = r.y),
              (O[ue + se + 10] = r.z),
              (O[ue + se + 11] = ee.itemSize === 4 ? r.w : 1))
        }
      }
      ;(v = { count: m, texture: N, size: new We(z, U) }),
        i.set(l, v),
        l.addEventListener("dispose", I)
    }
    if (o.isInstancedMesh === !0 && o.morphTexture !== null)
      u.getUniforms().setValue(n, "morphTexture", o.morphTexture, t)
    else {
      let x = 0
      for (let M = 0; M < d.length; M++) x += d[M]
      const E = l.morphTargetsRelative ? 1 : 1 - x
      u.getUniforms().setValue(n, "morphTargetBaseInfluence", E),
        u.getUniforms().setValue(n, "morphTargetInfluences", d)
    }
    u.getUniforms().setValue(n, "morphTargetsTexture", v.texture, t),
      u.getUniforms().setValue(n, "morphTargetsTextureSize", v.size)
  }
  return { update: s }
}
function ez(n, e, t, i) {
  let r = new WeakMap()
  function s(u) {
    const d = i.render.frame,
      p = u.geometry,
      m = e.get(u, p)
    if (
      (r.get(m) !== d && (e.update(m), r.set(m, d)),
      u.isInstancedMesh &&
        (u.hasEventListener("dispose", l) === !1 && u.addEventListener("dispose", l),
        r.get(u) !== d &&
          (t.update(u.instanceMatrix, n.ARRAY_BUFFER),
          u.instanceColor !== null && t.update(u.instanceColor, n.ARRAY_BUFFER),
          r.set(u, d))),
      u.isSkinnedMesh)
    ) {
      const v = u.skeleton
      r.get(v) !== d && (v.update(), r.set(v, d))
    }
    return m
  }
  function o() {
    r = new WeakMap()
  }
  function l(u) {
    const d = u.target
    d.removeEventListener("dispose", l),
      t.remove(d.instanceMatrix),
      d.instanceColor !== null && t.remove(d.instanceColor)
  }
  return { update: s, dispose: o }
}
class Vw extends zn {
  constructor(e, t, i, r, s, o, l, u, d, p = Tu) {
    if (p !== Tu && p !== Nu)
      throw new Error(
        "DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat",
      )
    i === void 0 && p === Tu && (i = Za),
      i === void 0 && p === Nu && (i = Du),
      super(null, r, s, o, l, u, p, i, d),
      (this.isDepthTexture = !0),
      (this.image = { width: e, height: t }),
      (this.magFilter = l !== void 0 ? l : Qi),
      (this.minFilter = u !== void 0 ? u : Qi),
      (this.flipY = !1),
      (this.generateMipmaps = !1),
      (this.compareFunction = null)
  }
  copy(e) {
    return super.copy(e), (this.compareFunction = e.compareFunction), this
  }
  toJSON(e) {
    const t = super.toJSON(e)
    return (
      this.compareFunction !== null && (t.compareFunction = this.compareFunction), t
    )
  }
}
const M3 = new zn(),
  MT = new Vw(1, 1),
  E3 = new ey(),
  T3 = new Ow(),
  b3 = new _m(),
  ET = [],
  TT = [],
  bT = new Float32Array(16),
  AT = new Float32Array(9),
  CT = new Float32Array(4)
function Yd(n, e, t) {
  const i = n[0]
  if (i <= 0 || i > 0) return n
  const r = e * t
  let s = ET[r]
  if ((s === void 0 && ((s = new Float32Array(r)), (ET[r] = s)), e !== 0)) {
    i.toArray(s, 0)
    for (let o = 1, l = 0; o !== e; ++o) (l += t), n[o].toArray(s, l)
  }
  return s
}
function Pi(n, e) {
  if (n.length !== e.length) return !1
  for (let t = 0, i = n.length; t < i; t++) if (n[t] !== e[t]) return !1
  return !0
}
function Ii(n, e) {
  for (let t = 0, i = e.length; t < i; t++) n[t] = e[t]
}
function ny(n, e) {
  let t = TT[e]
  t === void 0 && ((t = new Int32Array(e)), (TT[e] = t))
  for (let i = 0; i !== e; ++i) t[i] = n.allocateTextureUnit()
  return t
}
function tz(n, e) {
  const t = this.cache
  t[0] !== e && (n.uniform1f(this.addr, e), (t[0] = e))
}
function nz(n, e) {
  const t = this.cache
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) &&
      (n.uniform2f(this.addr, e.x, e.y), (t[0] = e.x), (t[1] = e.y))
  else {
    if (Pi(t, e)) return
    n.uniform2fv(this.addr, e), Ii(t, e)
  }
}
function iz(n, e) {
  const t = this.cache
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) &&
      (n.uniform3f(this.addr, e.x, e.y, e.z), (t[0] = e.x), (t[1] = e.y), (t[2] = e.z))
  else if (e.r !== void 0)
    (t[0] !== e.r || t[1] !== e.g || t[2] !== e.b) &&
      (n.uniform3f(this.addr, e.r, e.g, e.b), (t[0] = e.r), (t[1] = e.g), (t[2] = e.b))
  else {
    if (Pi(t, e)) return
    n.uniform3fv(this.addr, e), Ii(t, e)
  }
}
function rz(n, e) {
  const t = this.cache
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) &&
      (n.uniform4f(this.addr, e.x, e.y, e.z, e.w),
      (t[0] = e.x),
      (t[1] = e.y),
      (t[2] = e.z),
      (t[3] = e.w))
  else {
    if (Pi(t, e)) return
    n.uniform4fv(this.addr, e), Ii(t, e)
  }
}
function sz(n, e) {
  const t = this.cache,
    i = e.elements
  if (i === void 0) {
    if (Pi(t, e)) return
    n.uniformMatrix2fv(this.addr, !1, e), Ii(t, e)
  } else {
    if (Pi(t, i)) return
    CT.set(i), n.uniformMatrix2fv(this.addr, !1, CT), Ii(t, i)
  }
}
function oz(n, e) {
  const t = this.cache,
    i = e.elements
  if (i === void 0) {
    if (Pi(t, e)) return
    n.uniformMatrix3fv(this.addr, !1, e), Ii(t, e)
  } else {
    if (Pi(t, i)) return
    AT.set(i), n.uniformMatrix3fv(this.addr, !1, AT), Ii(t, i)
  }
}
function az(n, e) {
  const t = this.cache,
    i = e.elements
  if (i === void 0) {
    if (Pi(t, e)) return
    n.uniformMatrix4fv(this.addr, !1, e), Ii(t, e)
  } else {
    if (Pi(t, i)) return
    bT.set(i), n.uniformMatrix4fv(this.addr, !1, bT), Ii(t, i)
  }
}
function lz(n, e) {
  const t = this.cache
  t[0] !== e && (n.uniform1i(this.addr, e), (t[0] = e))
}
function cz(n, e) {
  const t = this.cache
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) &&
      (n.uniform2i(this.addr, e.x, e.y), (t[0] = e.x), (t[1] = e.y))
  else {
    if (Pi(t, e)) return
    n.uniform2iv(this.addr, e), Ii(t, e)
  }
}
function uz(n, e) {
  const t = this.cache
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) &&
      (n.uniform3i(this.addr, e.x, e.y, e.z), (t[0] = e.x), (t[1] = e.y), (t[2] = e.z))
  else {
    if (Pi(t, e)) return
    n.uniform3iv(this.addr, e), Ii(t, e)
  }
}
function fz(n, e) {
  const t = this.cache
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) &&
      (n.uniform4i(this.addr, e.x, e.y, e.z, e.w),
      (t[0] = e.x),
      (t[1] = e.y),
      (t[2] = e.z),
      (t[3] = e.w))
  else {
    if (Pi(t, e)) return
    n.uniform4iv(this.addr, e), Ii(t, e)
  }
}
function dz(n, e) {
  const t = this.cache
  t[0] !== e && (n.uniform1ui(this.addr, e), (t[0] = e))
}
function hz(n, e) {
  const t = this.cache
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y) &&
      (n.uniform2ui(this.addr, e.x, e.y), (t[0] = e.x), (t[1] = e.y))
  else {
    if (Pi(t, e)) return
    n.uniform2uiv(this.addr, e), Ii(t, e)
  }
}
function pz(n, e) {
  const t = this.cache
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z) &&
      (n.uniform3ui(this.addr, e.x, e.y, e.z), (t[0] = e.x), (t[1] = e.y), (t[2] = e.z))
  else {
    if (Pi(t, e)) return
    n.uniform3uiv(this.addr, e), Ii(t, e)
  }
}
function mz(n, e) {
  const t = this.cache
  if (e.x !== void 0)
    (t[0] !== e.x || t[1] !== e.y || t[2] !== e.z || t[3] !== e.w) &&
      (n.uniform4ui(this.addr, e.x, e.y, e.z, e.w),
      (t[0] = e.x),
      (t[1] = e.y),
      (t[2] = e.z),
      (t[3] = e.w))
  else {
    if (Pi(t, e)) return
    n.uniform4uiv(this.addr, e), Ii(t, e)
  }
}
function gz(n, e, t) {
  const i = this.cache,
    r = t.allocateTextureUnit()
  i[0] !== r && (n.uniform1i(this.addr, r), (i[0] = r))
  let s
  this.type === n.SAMPLER_2D_SHADOW ? ((MT.compareFunction = Fw), (s = MT)) : (s = M3),
    t.setTexture2D(e || s, r)
}
function vz(n, e, t) {
  const i = this.cache,
    r = t.allocateTextureUnit()
  i[0] !== r && (n.uniform1i(this.addr, r), (i[0] = r)), t.setTexture3D(e || T3, r)
}
function yz(n, e, t) {
  const i = this.cache,
    r = t.allocateTextureUnit()
  i[0] !== r && (n.uniform1i(this.addr, r), (i[0] = r)), t.setTextureCube(e || b3, r)
}
function xz(n, e, t) {
  const i = this.cache,
    r = t.allocateTextureUnit()
  i[0] !== r && (n.uniform1i(this.addr, r), (i[0] = r)), t.setTexture2DArray(e || E3, r)
}
function _z(n) {
  switch (n) {
    case 5126:
      return tz
    case 35664:
      return nz
    case 35665:
      return iz
    case 35666:
      return rz
    case 35674:
      return sz
    case 35675:
      return oz
    case 35676:
      return az
    case 5124:
    case 35670:
      return lz
    case 35667:
    case 35671:
      return cz
    case 35668:
    case 35672:
      return uz
    case 35669:
    case 35673:
      return fz
    case 5125:
      return dz
    case 36294:
      return hz
    case 36295:
      return pz
    case 36296:
      return mz
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return gz
    case 35679:
    case 36299:
    case 36307:
      return vz
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return yz
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return xz
  }
}
function wz(n, e) {
  n.uniform1fv(this.addr, e)
}
function Sz(n, e) {
  const t = Yd(e, this.size, 2)
  n.uniform2fv(this.addr, t)
}
function Mz(n, e) {
  const t = Yd(e, this.size, 3)
  n.uniform3fv(this.addr, t)
}
function Ez(n, e) {
  const t = Yd(e, this.size, 4)
  n.uniform4fv(this.addr, t)
}
function Tz(n, e) {
  const t = Yd(e, this.size, 4)
  n.uniformMatrix2fv(this.addr, !1, t)
}
function bz(n, e) {
  const t = Yd(e, this.size, 9)
  n.uniformMatrix3fv(this.addr, !1, t)
}
function Az(n, e) {
  const t = Yd(e, this.size, 16)
  n.uniformMatrix4fv(this.addr, !1, t)
}
function Cz(n, e) {
  n.uniform1iv(this.addr, e)
}
function Rz(n, e) {
  n.uniform2iv(this.addr, e)
}
function Pz(n, e) {
  n.uniform3iv(this.addr, e)
}
function Iz(n, e) {
  n.uniform4iv(this.addr, e)
}
function Lz(n, e) {
  n.uniform1uiv(this.addr, e)
}
function Dz(n, e) {
  n.uniform2uiv(this.addr, e)
}
function Nz(n, e) {
  n.uniform3uiv(this.addr, e)
}
function kz(n, e) {
  n.uniform4uiv(this.addr, e)
}
function Fz(n, e, t) {
  const i = this.cache,
    r = e.length,
    s = ny(t, r)
  Pi(i, s) || (n.uniform1iv(this.addr, s), Ii(i, s))
  for (let o = 0; o !== r; ++o) t.setTexture2D(e[o] || M3, s[o])
}
function Uz(n, e, t) {
  const i = this.cache,
    r = e.length,
    s = ny(t, r)
  Pi(i, s) || (n.uniform1iv(this.addr, s), Ii(i, s))
  for (let o = 0; o !== r; ++o) t.setTexture3D(e[o] || T3, s[o])
}
function Oz(n, e, t) {
  const i = this.cache,
    r = e.length,
    s = ny(t, r)
  Pi(i, s) || (n.uniform1iv(this.addr, s), Ii(i, s))
  for (let o = 0; o !== r; ++o) t.setTextureCube(e[o] || b3, s[o])
}
function Bz(n, e, t) {
  const i = this.cache,
    r = e.length,
    s = ny(t, r)
  Pi(i, s) || (n.uniform1iv(this.addr, s), Ii(i, s))
  for (let o = 0; o !== r; ++o) t.setTexture2DArray(e[o] || E3, s[o])
}
function zz(n) {
  switch (n) {
    case 5126:
      return wz
    case 35664:
      return Sz
    case 35665:
      return Mz
    case 35666:
      return Ez
    case 35674:
      return Tz
    case 35675:
      return bz
    case 35676:
      return Az
    case 5124:
    case 35670:
      return Cz
    case 35667:
    case 35671:
      return Rz
    case 35668:
    case 35672:
      return Pz
    case 35669:
    case 35673:
      return Iz
    case 5125:
      return Lz
    case 36294:
      return Dz
    case 36295:
      return Nz
    case 36296:
      return kz
    case 35678:
    case 36198:
    case 36298:
    case 36306:
    case 35682:
      return Fz
    case 35679:
    case 36299:
    case 36307:
      return Uz
    case 35680:
    case 36300:
    case 36308:
    case 36293:
      return Oz
    case 36289:
    case 36303:
    case 36311:
    case 36292:
      return Bz
  }
}
class Vz {
  constructor(e, t, i) {
    ;(this.id = e),
      (this.addr = i),
      (this.cache = []),
      (this.type = t.type),
      (this.setValue = _z(t.type))
  }
}
class Hz {
  constructor(e, t, i) {
    ;(this.id = e),
      (this.addr = i),
      (this.cache = []),
      (this.type = t.type),
      (this.size = t.size),
      (this.setValue = zz(t.type))
  }
}
class Gz {
  constructor(e) {
    ;(this.id = e), (this.seq = []), (this.map = {})
  }
  setValue(e, t, i) {
    const r = this.seq
    for (let s = 0, o = r.length; s !== o; ++s) {
      const l = r[s]
      l.setValue(e, t[l.id], i)
    }
  }
}
const n_ = /(\w+)(\])?(\[|\.)?/g
function RT(n, e) {
  n.seq.push(e), (n.map[e.id] = e)
}
function Wz(n, e, t) {
  const i = n.name,
    r = i.length
  for (n_.lastIndex = 0; ; ) {
    const s = n_.exec(i),
      o = n_.lastIndex
    let l = s[1]
    const u = s[2] === "]",
      d = s[3]
    if ((u && (l = l | 0), d === void 0 || (d === "[" && o + 2 === r))) {
      RT(t, d === void 0 ? new Vz(l, n, e) : new Hz(l, n, e))
      break
    } else {
      let m = t.map[l]
      m === void 0 && ((m = new Gz(l)), RT(t, m)), (t = m)
    }
  }
}
class R0 {
  constructor(e, t) {
    ;(this.seq = []), (this.map = {})
    const i = e.getProgramParameter(t, e.ACTIVE_UNIFORMS)
    for (let r = 0; r < i; ++r) {
      const s = e.getActiveUniform(t, r),
        o = e.getUniformLocation(t, s.name)
      Wz(s, o, this)
    }
  }
  setValue(e, t, i, r) {
    const s = this.map[t]
    s !== void 0 && s.setValue(e, i, r)
  }
  setOptional(e, t, i) {
    const r = t[i]
    r !== void 0 && this.setValue(e, i, r)
  }
  static upload(e, t, i, r) {
    for (let s = 0, o = t.length; s !== o; ++s) {
      const l = t[s],
        u = i[l.id]
      u.needsUpdate !== !1 && l.setValue(e, u.value, r)
    }
  }
  static seqWithValue(e, t) {
    const i = []
    for (let r = 0, s = e.length; r !== s; ++r) {
      const o = e[r]
      o.id in t && i.push(o)
    }
    return i
  }
}
function PT(n, e, t) {
  const i = n.createShader(e)
  return n.shaderSource(i, t), n.compileShader(i), i
}
const jz = 37297
let Xz = 0
function Yz(n, e) {
  const t = n.split(`
`),
    i = [],
    r = Math.max(e - 6, 0),
    s = Math.min(e + 6, t.length)
  for (let o = r; o < s; o++) {
    const l = o + 1
    i.push(`${l === e ? ">" : " "} ${l}: ${t[o]}`)
  }
  return i.join(`
`)
}
const IT = new Xt()
function qz(n) {
  fn._getMatrix(IT, fn.workingColorSpace, n)
  const e = `mat3( ${IT.elements.map((t) => t.toFixed(4))} )`
  switch (fn.getTransfer(n)) {
    case ym:
      return [e, "LinearTransferOETF"]
    case Sn:
      return [e, "sRGBTransferOETF"]
    default:
      return (
        console.warn("THREE.WebGLProgram: Unsupported color space: ", n),
        [e, "LinearTransferOETF"]
      )
  }
}
function LT(n, e, t) {
  const i = n.getShaderParameter(e, n.COMPILE_STATUS),
    r = n.getShaderInfoLog(e).trim()
  if (i && r === "") return ""
  const s = /ERROR: 0:(\d+)/.exec(r)
  if (s) {
    const o = parseInt(s[1])
    return (
      t.toUpperCase() +
      `

` +
      r +
      `

` +
      Yz(n.getShaderSource(e), o)
    )
  } else return r
}
function $z(n, e) {
  const t = qz(e)
  return [
    `vec4 ${n}( vec4 value ) {`,
    `	return ${t[1]}( vec4( value.rgb * ${t[0]}, value.a ) );`,
    "}",
  ].join(`
`)
}
function Kz(n, e) {
  let t
  switch (e) {
    case YC:
      t = "Linear"
      break
    case qC:
      t = "Reinhard"
      break
    case $C:
      t = "Cineon"
      break
    case Ew:
      t = "ACESFilmic"
      break
    case ZC:
      t = "AgX"
      break
    case JC:
      t = "Neutral"
      break
    case KC:
      t = "Custom"
      break
    default:
      console.warn("THREE.WebGLProgram: Unsupported toneMapping:", e), (t = "Linear")
  }
  return "vec3 " + n + "( vec3 color ) { return " + t + "ToneMapping( color ); }"
}
const $g = new q()
function Zz() {
  fn.getLuminanceCoefficients($g)
  const n = $g.x.toFixed(4),
    e = $g.y.toFixed(4),
    t = $g.z.toFixed(4)
  return [
    "float luminance( const in vec3 rgb ) {",
    `	const vec3 weights = vec3( ${n}, ${e}, ${t} );`,
    "	return dot( weights, rgb );",
    "}",
  ].join(`
`)
}
function Jz(n) {
  return [
    n.extensionClipCullDistance
      ? "#extension GL_ANGLE_clip_cull_distance : require"
      : "",
    n.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : "",
  ].filter(mp).join(`
`)
}
function Qz(n) {
  const e = []
  for (const t in n) {
    const i = n[t]
    i !== !1 && e.push("#define " + t + " " + i)
  }
  return e.join(`
`)
}
function eV(n, e) {
  const t = {},
    i = n.getProgramParameter(e, n.ACTIVE_ATTRIBUTES)
  for (let r = 0; r < i; r++) {
    const s = n.getActiveAttrib(e, r),
      o = s.name
    let l = 1
    s.type === n.FLOAT_MAT2 && (l = 2),
      s.type === n.FLOAT_MAT3 && (l = 3),
      s.type === n.FLOAT_MAT4 && (l = 4),
      (t[o] = { type: s.type, location: n.getAttribLocation(e, o), locationSize: l })
  }
  return t
}
function mp(n) {
  return n !== ""
}
function DT(n, e) {
  const t = e.numSpotLightShadows + e.numSpotLightMaps - e.numSpotLightShadowsWithMaps
  return n
    .replace(/NUM_DIR_LIGHTS/g, e.numDirLights)
    .replace(/NUM_SPOT_LIGHTS/g, e.numSpotLights)
    .replace(/NUM_SPOT_LIGHT_MAPS/g, e.numSpotLightMaps)
    .replace(/NUM_SPOT_LIGHT_COORDS/g, t)
    .replace(/NUM_RECT_AREA_LIGHTS/g, e.numRectAreaLights)
    .replace(/NUM_POINT_LIGHTS/g, e.numPointLights)
    .replace(/NUM_HEMI_LIGHTS/g, e.numHemiLights)
    .replace(/NUM_DIR_LIGHT_SHADOWS/g, e.numDirLightShadows)
    .replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, e.numSpotLightShadowsWithMaps)
    .replace(/NUM_SPOT_LIGHT_SHADOWS/g, e.numSpotLightShadows)
    .replace(/NUM_POINT_LIGHT_SHADOWS/g, e.numPointLightShadows)
}
function NT(n, e) {
  return n
    .replace(/NUM_CLIPPING_PLANES/g, e.numClippingPlanes)
    .replace(/UNION_CLIPPING_PLANES/g, e.numClippingPlanes - e.numClipIntersection)
}
const tV = /^[ \t]*#include +<([\w\d./]+)>/gm
function T1(n) {
  return n.replace(tV, iV)
}
const nV = new Map()
function iV(n, e) {
  let t = Qt[e]
  if (t === void 0) {
    const i = nV.get(e)
    if (i !== void 0)
      (t = Qt[i]),
        console.warn(
          'THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.',
          e,
          i,
        )
    else throw new Error("Can not resolve #include <" + e + ">")
  }
  return T1(t)
}
const rV =
  /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g
function kT(n) {
  return n.replace(rV, sV)
}
function sV(n, e, t, i) {
  let r = ""
  for (let s = parseInt(e); s < parseInt(t); s++)
    r += i.replace(/\[\s*i\s*\]/g, "[ " + s + " ]").replace(/UNROLLED_LOOP_INDEX/g, s)
  return r
}
function FT(n) {
  let e = `precision ${n.precision} float;
	precision ${n.precision} int;
	precision ${n.precision} sampler2D;
	precision ${n.precision} samplerCube;
	precision ${n.precision} sampler3D;
	precision ${n.precision} sampler2DArray;
	precision ${n.precision} sampler2DShadow;
	precision ${n.precision} samplerCubeShadow;
	precision ${n.precision} sampler2DArrayShadow;
	precision ${n.precision} isampler2D;
	precision ${n.precision} isampler3D;
	precision ${n.precision} isamplerCube;
	precision ${n.precision} isampler2DArray;
	precision ${n.precision} usampler2D;
	precision ${n.precision} usampler3D;
	precision ${n.precision} usamplerCube;
	precision ${n.precision} usampler2DArray;
	`
  return (
    n.precision === "highp"
      ? (e += `
#define HIGH_PRECISION`)
      : n.precision === "mediump"
      ? (e += `
#define MEDIUM_PRECISION`)
      : n.precision === "lowp" &&
        (e += `
#define LOW_PRECISION`),
    e
  )
}
function oV(n) {
  let e = "SHADOWMAP_TYPE_BASIC"
  return (
    n.shadowMapType === jv
      ? (e = "SHADOWMAP_TYPE_PCF")
      : n.shadowMapType === Ep
      ? (e = "SHADOWMAP_TYPE_PCF_SOFT")
      : n.shadowMapType === go && (e = "SHADOWMAP_TYPE_VSM"),
    e
  )
}
function aV(n) {
  let e = "ENVMAP_TYPE_CUBE"
  if (n.envMap)
    switch (n.envMapMode) {
      case Ka:
      case rc:
        e = "ENVMAP_TYPE_CUBE"
        break
      case Hd:
        e = "ENVMAP_TYPE_CUBE_UV"
        break
    }
  return e
}
function lV(n) {
  let e = "ENVMAP_MODE_REFLECTION"
  if (n.envMap)
    switch (n.envMapMode) {
      case rc:
        e = "ENVMAP_MODE_REFRACTION"
        break
    }
  return e
}
function cV(n) {
  let e = "ENVMAP_BLENDING_NONE"
  if (n.envMap)
    switch (n.combine) {
      case gm:
        e = "ENVMAP_BLENDING_MULTIPLY"
        break
      case jC:
        e = "ENVMAP_BLENDING_MIX"
        break
      case XC:
        e = "ENVMAP_BLENDING_ADD"
        break
    }
  return e
}
function uV(n) {
  const e = n.envMapCubeUVHeight
  if (e === null) return null
  const t = Math.log2(e) - 2,
    i = 1 / e
  return {
    texelWidth: 1 / (3 * Math.max(Math.pow(2, t), 112)),
    texelHeight: i,
    maxMip: t,
  }
}
function fV(n, e, t, i) {
  const r = n.getContext(),
    s = t.defines
  let o = t.vertexShader,
    l = t.fragmentShader
  const u = oV(t),
    d = aV(t),
    p = lV(t),
    m = cV(t),
    v = uV(t),
    y = Jz(t),
    x = Qz(s),
    E = r.createProgram()
  let M,
    w,
    A = t.glslVersion
      ? "#version " +
        t.glslVersion +
        `
`
      : ""
  t.isRawShaderMaterial
    ? ((M = [
        "#define SHADER_TYPE " + t.shaderType,
        "#define SHADER_NAME " + t.shaderName,
        x,
      ].filter(mp).join(`
`)),
      M.length > 0 &&
        (M += `
`),
      (w = [
        "#define SHADER_TYPE " + t.shaderType,
        "#define SHADER_NAME " + t.shaderName,
        x,
      ].filter(mp).join(`
`)),
      w.length > 0 &&
        (w += `
`))
    : ((M = [
        FT(t),
        "#define SHADER_TYPE " + t.shaderType,
        "#define SHADER_NAME " + t.shaderName,
        x,
        t.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
        t.batching ? "#define USE_BATCHING" : "",
        t.batchingColor ? "#define USE_BATCHING_COLOR" : "",
        t.instancing ? "#define USE_INSTANCING" : "",
        t.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        t.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
        t.useFog && t.fog ? "#define USE_FOG" : "",
        t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
        t.map ? "#define USE_MAP" : "",
        t.envMap ? "#define USE_ENVMAP" : "",
        t.envMap ? "#define " + p : "",
        t.lightMap ? "#define USE_LIGHTMAP" : "",
        t.aoMap ? "#define USE_AOMAP" : "",
        t.bumpMap ? "#define USE_BUMPMAP" : "",
        t.normalMap ? "#define USE_NORMALMAP" : "",
        t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        t.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
        t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        t.anisotropy ? "#define USE_ANISOTROPY" : "",
        t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        t.specularMap ? "#define USE_SPECULARMAP" : "",
        t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        t.metalnessMap ? "#define USE_METALNESSMAP" : "",
        t.alphaMap ? "#define USE_ALPHAMAP" : "",
        t.alphaHash ? "#define USE_ALPHAHASH" : "",
        t.transmission ? "#define USE_TRANSMISSION" : "",
        t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        t.mapUv ? "#define MAP_UV " + t.mapUv : "",
        t.alphaMapUv ? "#define ALPHAMAP_UV " + t.alphaMapUv : "",
        t.lightMapUv ? "#define LIGHTMAP_UV " + t.lightMapUv : "",
        t.aoMapUv ? "#define AOMAP_UV " + t.aoMapUv : "",
        t.emissiveMapUv ? "#define EMISSIVEMAP_UV " + t.emissiveMapUv : "",
        t.bumpMapUv ? "#define BUMPMAP_UV " + t.bumpMapUv : "",
        t.normalMapUv ? "#define NORMALMAP_UV " + t.normalMapUv : "",
        t.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + t.displacementMapUv : "",
        t.metalnessMapUv ? "#define METALNESSMAP_UV " + t.metalnessMapUv : "",
        t.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + t.roughnessMapUv : "",
        t.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + t.anisotropyMapUv : "",
        t.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + t.clearcoatMapUv : "",
        t.clearcoatNormalMapUv
          ? "#define CLEARCOAT_NORMALMAP_UV " + t.clearcoatNormalMapUv
          : "",
        t.clearcoatRoughnessMapUv
          ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + t.clearcoatRoughnessMapUv
          : "",
        t.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + t.iridescenceMapUv : "",
        t.iridescenceThicknessMapUv
          ? "#define IRIDESCENCE_THICKNESSMAP_UV " + t.iridescenceThicknessMapUv
          : "",
        t.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + t.sheenColorMapUv : "",
        t.sheenRoughnessMapUv
          ? "#define SHEEN_ROUGHNESSMAP_UV " + t.sheenRoughnessMapUv
          : "",
        t.specularMapUv ? "#define SPECULARMAP_UV " + t.specularMapUv : "",
        t.specularColorMapUv
          ? "#define SPECULAR_COLORMAP_UV " + t.specularColorMapUv
          : "",
        t.specularIntensityMapUv
          ? "#define SPECULAR_INTENSITYMAP_UV " + t.specularIntensityMapUv
          : "",
        t.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + t.transmissionMapUv : "",
        t.thicknessMapUv ? "#define THICKNESSMAP_UV " + t.thicknessMapUv : "",
        t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
        t.vertexColors ? "#define USE_COLOR" : "",
        t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        t.vertexUv1s ? "#define USE_UV1" : "",
        t.vertexUv2s ? "#define USE_UV2" : "",
        t.vertexUv3s ? "#define USE_UV3" : "",
        t.pointsUvs ? "#define USE_POINTS_UV" : "",
        t.flatShading ? "#define FLAT_SHADED" : "",
        t.skinning ? "#define USE_SKINNING" : "",
        t.morphTargets ? "#define USE_MORPHTARGETS" : "",
        t.morphNormals && t.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
        t.morphColors ? "#define USE_MORPHCOLORS" : "",
        t.morphTargetsCount > 0
          ? "#define MORPHTARGETS_TEXTURE_STRIDE " + t.morphTextureStride
          : "",
        t.morphTargetsCount > 0
          ? "#define MORPHTARGETS_COUNT " + t.morphTargetsCount
          : "",
        t.doubleSided ? "#define DOUBLE_SIDED" : "",
        t.flipSided ? "#define FLIP_SIDED" : "",
        t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        t.shadowMapEnabled ? "#define " + u : "",
        t.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        t.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "	attribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "	attribute vec3 instanceColor;",
        "#endif",
        "#ifdef USE_INSTANCING_MORPH",
        "	uniform sampler2D morphTexture;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_UV1",
        "	attribute vec2 uv1;",
        "#endif",
        "#ifdef USE_UV2",
        "	attribute vec2 uv2;",
        "#endif",
        "#ifdef USE_UV3",
        "	attribute vec2 uv3;",
        "#endif",
        "#ifdef USE_TANGENT",
        "	attribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "	attribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "	attribute vec3 color;",
        "#endif",
        "#ifdef USE_SKINNING",
        "	attribute vec4 skinIndex;",
        "	attribute vec4 skinWeight;",
        "#endif",
        `
`,
      ].filter(mp).join(`
`)),
      (w = [
        FT(t),
        "#define SHADER_TYPE " + t.shaderType,
        "#define SHADER_NAME " + t.shaderName,
        x,
        t.useFog && t.fog ? "#define USE_FOG" : "",
        t.useFog && t.fogExp2 ? "#define FOG_EXP2" : "",
        t.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
        t.map ? "#define USE_MAP" : "",
        t.matcap ? "#define USE_MATCAP" : "",
        t.envMap ? "#define USE_ENVMAP" : "",
        t.envMap ? "#define " + d : "",
        t.envMap ? "#define " + p : "",
        t.envMap ? "#define " + m : "",
        v ? "#define CUBEUV_TEXEL_WIDTH " + v.texelWidth : "",
        v ? "#define CUBEUV_TEXEL_HEIGHT " + v.texelHeight : "",
        v ? "#define CUBEUV_MAX_MIP " + v.maxMip + ".0" : "",
        t.lightMap ? "#define USE_LIGHTMAP" : "",
        t.aoMap ? "#define USE_AOMAP" : "",
        t.bumpMap ? "#define USE_BUMPMAP" : "",
        t.normalMap ? "#define USE_NORMALMAP" : "",
        t.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
        t.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
        t.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        t.anisotropy ? "#define USE_ANISOTROPY" : "",
        t.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
        t.clearcoat ? "#define USE_CLEARCOAT" : "",
        t.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        t.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        t.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        t.dispersion ? "#define USE_DISPERSION" : "",
        t.iridescence ? "#define USE_IRIDESCENCE" : "",
        t.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        t.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        t.specularMap ? "#define USE_SPECULARMAP" : "",
        t.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
        t.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
        t.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        t.metalnessMap ? "#define USE_METALNESSMAP" : "",
        t.alphaMap ? "#define USE_ALPHAMAP" : "",
        t.alphaTest ? "#define USE_ALPHATEST" : "",
        t.alphaHash ? "#define USE_ALPHAHASH" : "",
        t.sheen ? "#define USE_SHEEN" : "",
        t.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
        t.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
        t.transmission ? "#define USE_TRANSMISSION" : "",
        t.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        t.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        t.vertexTangents && t.flatShading === !1 ? "#define USE_TANGENT" : "",
        t.vertexColors || t.instancingColor || t.batchingColor
          ? "#define USE_COLOR"
          : "",
        t.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        t.vertexUv1s ? "#define USE_UV1" : "",
        t.vertexUv2s ? "#define USE_UV2" : "",
        t.vertexUv3s ? "#define USE_UV3" : "",
        t.pointsUvs ? "#define USE_POINTS_UV" : "",
        t.gradientMap ? "#define USE_GRADIENTMAP" : "",
        t.flatShading ? "#define FLAT_SHADED" : "",
        t.doubleSided ? "#define DOUBLE_SIDED" : "",
        t.flipSided ? "#define FLIP_SIDED" : "",
        t.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        t.shadowMapEnabled ? "#define " + u : "",
        t.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        t.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
        t.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        t.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
        t.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        t.reverseDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        t.toneMapping !== Xo ? "#define TONE_MAPPING" : "",
        t.toneMapping !== Xo ? Qt.tonemapping_pars_fragment : "",
        t.toneMapping !== Xo ? Kz("toneMapping", t.toneMapping) : "",
        t.dithering ? "#define DITHERING" : "",
        t.opaque ? "#define OPAQUE" : "",
        Qt.colorspace_pars_fragment,
        $z("linearToOutputTexel", t.outputColorSpace),
        Zz(),
        t.useDepthPacking ? "#define DEPTH_PACKING " + t.depthPacking : "",
        `
`,
      ].filter(mp).join(`
`))),
    (o = T1(o)),
    (o = DT(o, t)),
    (o = NT(o, t)),
    (l = T1(l)),
    (l = DT(l, t)),
    (l = NT(l, t)),
    (o = kT(o)),
    (l = kT(l)),
    t.isRawShaderMaterial !== !0 &&
      ((A = `#version 300 es
`),
      (M =
        [y, "#define attribute in", "#define varying out", "#define texture2D texture"]
          .join(`
`) +
        `
` +
        M),
      (w =
        [
          "#define varying in",
          t.glslVersion === M1
            ? ""
            : "layout(location = 0) out highp vec4 pc_fragColor;",
          t.glslVersion === M1 ? "" : "#define gl_FragColor pc_fragColor",
          "#define gl_FragDepthEXT gl_FragDepth",
          "#define texture2D texture",
          "#define textureCube texture",
          "#define texture2DProj textureProj",
          "#define texture2DLodEXT textureLod",
          "#define texture2DProjLodEXT textureProjLod",
          "#define textureCubeLodEXT textureLod",
          "#define texture2DGradEXT textureGrad",
          "#define texture2DProjGradEXT textureProjGrad",
          "#define textureCubeGradEXT textureGrad",
        ].join(`
`) +
        `
` +
        w))
  const C = A + M + o,
    R = A + w + l,
    z = PT(r, r.VERTEX_SHADER, C),
    U = PT(r, r.FRAGMENT_SHADER, R)
  r.attachShader(E, z),
    r.attachShader(E, U),
    t.index0AttributeName !== void 0
      ? r.bindAttribLocation(E, 0, t.index0AttributeName)
      : t.morphTargets === !0 && r.bindAttribLocation(E, 0, "position"),
    r.linkProgram(E)
  function O(V) {
    if (n.debug.checkShaderErrors) {
      const Z = r.getProgramInfoLog(E).trim(),
        $ = r.getShaderInfoLog(z).trim(),
        ee = r.getShaderInfoLog(U).trim()
      let ue = !0,
        re = !0
      if (r.getProgramParameter(E, r.LINK_STATUS) === !1)
        if (((ue = !1), typeof n.debug.onShaderError == "function"))
          n.debug.onShaderError(r, E, z, U)
        else {
          const se = LT(r, z, "vertex"),
            G = LT(r, U, "fragment")
          console.error(
            "THREE.WebGLProgram: Shader Error " +
              r.getError() +
              " - VALIDATE_STATUS " +
              r.getProgramParameter(E, r.VALIDATE_STATUS) +
              `

Material Name: ` +
              V.name +
              `
Material Type: ` +
              V.type +
              `

Program Info Log: ` +
              Z +
              `
` +
              se +
              `
` +
              G,
          )
        }
      else
        Z !== ""
          ? console.warn("THREE.WebGLProgram: Program Info Log:", Z)
          : ($ === "" || ee === "") && (re = !1)
      re &&
        (V.diagnostics = {
          runnable: ue,
          programLog: Z,
          vertexShader: { log: $, prefix: M },
          fragmentShader: { log: ee, prefix: w },
        })
    }
    r.deleteShader(z), r.deleteShader(U), (N = new R0(r, E)), (k = eV(r, E))
  }
  let N
  this.getUniforms = function () {
    return N === void 0 && O(this), N
  }
  let k
  this.getAttributes = function () {
    return k === void 0 && O(this), k
  }
  let I = t.rendererExtensionParallelShaderCompile === !1
  return (
    (this.isReady = function () {
      return I === !1 && (I = r.getProgramParameter(E, jz)), I
    }),
    (this.destroy = function () {
      i.releaseStatesOfProgram(this), r.deleteProgram(E), (this.program = void 0)
    }),
    (this.type = t.shaderType),
    (this.name = t.shaderName),
    (this.id = Xz++),
    (this.cacheKey = e),
    (this.usedTimes = 1),
    (this.program = E),
    (this.vertexShader = z),
    (this.fragmentShader = U),
    this
  )
}
let dV = 0
class hV {
  constructor() {
    ;(this.shaderCache = new Map()), (this.materialCache = new Map())
  }
  update(e) {
    const t = e.vertexShader,
      i = e.fragmentShader,
      r = this._getShaderStage(t),
      s = this._getShaderStage(i),
      o = this._getShaderCacheForMaterial(e)
    return (
      o.has(r) === !1 && (o.add(r), r.usedTimes++),
      o.has(s) === !1 && (o.add(s), s.usedTimes++),
      this
    )
  }
  remove(e) {
    const t = this.materialCache.get(e)
    for (const i of t)
      i.usedTimes--, i.usedTimes === 0 && this.shaderCache.delete(i.code)
    return this.materialCache.delete(e), this
  }
  getVertexShaderID(e) {
    return this._getShaderStage(e.vertexShader).id
  }
  getFragmentShaderID(e) {
    return this._getShaderStage(e.fragmentShader).id
  }
  dispose() {
    this.shaderCache.clear(), this.materialCache.clear()
  }
  _getShaderCacheForMaterial(e) {
    const t = this.materialCache
    let i = t.get(e)
    return i === void 0 && ((i = new Set()), t.set(e, i)), i
  }
  _getShaderStage(e) {
    const t = this.shaderCache
    let i = t.get(e)
    return i === void 0 && ((i = new pV(e)), t.set(e, i)), i
  }
}
class pV {
  constructor(e) {
    ;(this.id = dV++), (this.code = e), (this.usedTimes = 0)
  }
}
function mV(n, e, t, i, r, s, o) {
  const l = new Au(),
    u = new hV(),
    d = new Set(),
    p = [],
    m = r.logarithmicDepthBuffer,
    v = r.vertexTextures
  let y = r.precision
  const x = {
    MeshDepthMaterial: "depth",
    MeshDistanceMaterial: "distanceRGBA",
    MeshNormalMaterial: "normal",
    MeshBasicMaterial: "basic",
    MeshLambertMaterial: "lambert",
    MeshPhongMaterial: "phong",
    MeshToonMaterial: "toon",
    MeshStandardMaterial: "physical",
    MeshPhysicalMaterial: "physical",
    MeshMatcapMaterial: "matcap",
    LineBasicMaterial: "basic",
    LineDashedMaterial: "dashed",
    PointsMaterial: "points",
    ShadowMaterial: "shadow",
    SpriteMaterial: "sprite",
  }
  function E(k) {
    return d.add(k), k === 0 ? "uv" : `uv${k}`
  }
  function M(k, I, V, Z, $) {
    const ee = Z.fog,
      ue = $.geometry,
      re = k.isMeshStandardMaterial ? Z.environment : null,
      se = (k.isMeshStandardMaterial ? t : e).get(k.envMap || re),
      G = se && se.mapping === Hd ? se.image.height : null,
      ie = x[k.type]
    k.precision !== null &&
      ((y = r.getMaxPrecision(k.precision)),
      y !== k.precision &&
        console.warn(
          "THREE.WebGLProgram.getParameters:",
          k.precision,
          "not supported, using",
          y,
          "instead.",
        ))
    const Q =
        ue.morphAttributes.position ||
        ue.morphAttributes.normal ||
        ue.morphAttributes.color,
      W = Q !== void 0 ? Q.length : 0
    let ne = 0
    ue.morphAttributes.position !== void 0 && (ne = 1),
      ue.morphAttributes.normal !== void 0 && (ne = 2),
      ue.morphAttributes.color !== void 0 && (ne = 3)
    let ye, oe, fe, we
    if (ie) {
      const an = vo[ie]
      ;(ye = an.vertexShader), (oe = an.fragmentShader)
    } else
      (ye = k.vertexShader),
        (oe = k.fragmentShader),
        u.update(k),
        (fe = u.getVertexShaderID(k)),
        (we = u.getFragmentShaderID(k))
    const me = n.getRenderTarget(),
      Fe = n.state.buffers.depth.getReversed(),
      ze = $.isInstancedMesh === !0,
      Ge = $.isBatchedMesh === !0,
      Ue = !!k.map,
      ae = !!k.matcap,
      Ee = !!se,
      K = !!k.aoMap,
      Ke = !!k.lightMap,
      Be = !!k.bumpMap,
      Oe = !!k.normalMap,
      Pe = !!k.displacementMap,
      He = !!k.emissiveMap,
      Se = !!k.metalnessMap,
      j = !!k.roughnessMap,
      B = k.anisotropy > 0,
      ce = k.clearcoat > 0,
      Me = k.dispersion > 0,
      De = k.iridescence > 0,
      Ie = k.sheen > 0,
      st = k.transmission > 0,
      tt = B && !!k.anisotropyMap,
      it = ce && !!k.clearcoatMap,
      Et = ce && !!k.clearcoatNormalMap,
      je = ce && !!k.clearcoatRoughnessMap,
      Je = De && !!k.iridescenceMap,
      At = De && !!k.iridescenceThicknessMap,
      Pt = Ie && !!k.sheenColorMap,
      ft = Ie && !!k.sheenRoughnessMap,
      Wt = !!k.specularMap,
      Nt = !!k.specularColorMap,
      dn = !!k.specularIntensityMap,
      he = st && !!k.transmissionMap,
      rt = st && !!k.thicknessMap,
      Ne = !!k.gradientMap,
      Ve = !!k.alphaMap,
      lt = k.alphaTest > 0,
      at = !!k.alphaHash,
      Ut = !!k.extensions
    let vn = Xo
    k.toneMapped && (me === null || me.isXRRenderTarget === !0) && (vn = n.toneMapping)
    const Vn = {
      shaderID: ie,
      shaderType: k.type,
      shaderName: k.name,
      vertexShader: ye,
      fragmentShader: oe,
      defines: k.defines,
      customVertexShaderID: fe,
      customFragmentShaderID: we,
      isRawShaderMaterial: k.isRawShaderMaterial === !0,
      glslVersion: k.glslVersion,
      precision: y,
      batching: Ge,
      batchingColor: Ge && $._colorsTexture !== null,
      instancing: ze,
      instancingColor: ze && $.instanceColor !== null,
      instancingMorph: ze && $.morphTexture !== null,
      supportsVertexTextures: v,
      outputColorSpace:
        me === null
          ? n.outputColorSpace
          : me.isXRRenderTarget === !0
          ? me.texture.colorSpace
          : Bu,
      alphaToCoverage: !!k.alphaToCoverage,
      map: Ue,
      matcap: ae,
      envMap: Ee,
      envMapMode: Ee && se.mapping,
      envMapCubeUVHeight: G,
      aoMap: K,
      lightMap: Ke,
      bumpMap: Be,
      normalMap: Oe,
      displacementMap: v && Pe,
      emissiveMap: He,
      normalMapObjectSpace: Oe && k.normalMapType === s3,
      normalMapTangentSpace: Oe && k.normalMapType === ac,
      metalnessMap: Se,
      roughnessMap: j,
      anisotropy: B,
      anisotropyMap: tt,
      clearcoat: ce,
      clearcoatMap: it,
      clearcoatNormalMap: Et,
      clearcoatRoughnessMap: je,
      dispersion: Me,
      iridescence: De,
      iridescenceMap: Je,
      iridescenceThicknessMap: At,
      sheen: Ie,
      sheenColorMap: Pt,
      sheenRoughnessMap: ft,
      specularMap: Wt,
      specularColorMap: Nt,
      specularIntensityMap: dn,
      transmission: st,
      transmissionMap: he,
      thicknessMap: rt,
      gradientMap: Ne,
      opaque: k.transparent === !1 && k.blending === Eu && k.alphaToCoverage === !1,
      alphaMap: Ve,
      alphaTest: lt,
      alphaHash: at,
      combine: k.combine,
      mapUv: Ue && E(k.map.channel),
      aoMapUv: K && E(k.aoMap.channel),
      lightMapUv: Ke && E(k.lightMap.channel),
      bumpMapUv: Be && E(k.bumpMap.channel),
      normalMapUv: Oe && E(k.normalMap.channel),
      displacementMapUv: Pe && E(k.displacementMap.channel),
      emissiveMapUv: He && E(k.emissiveMap.channel),
      metalnessMapUv: Se && E(k.metalnessMap.channel),
      roughnessMapUv: j && E(k.roughnessMap.channel),
      anisotropyMapUv: tt && E(k.anisotropyMap.channel),
      clearcoatMapUv: it && E(k.clearcoatMap.channel),
      clearcoatNormalMapUv: Et && E(k.clearcoatNormalMap.channel),
      clearcoatRoughnessMapUv: je && E(k.clearcoatRoughnessMap.channel),
      iridescenceMapUv: Je && E(k.iridescenceMap.channel),
      iridescenceThicknessMapUv: At && E(k.iridescenceThicknessMap.channel),
      sheenColorMapUv: Pt && E(k.sheenColorMap.channel),
      sheenRoughnessMapUv: ft && E(k.sheenRoughnessMap.channel),
      specularMapUv: Wt && E(k.specularMap.channel),
      specularColorMapUv: Nt && E(k.specularColorMap.channel),
      specularIntensityMapUv: dn && E(k.specularIntensityMap.channel),
      transmissionMapUv: he && E(k.transmissionMap.channel),
      thicknessMapUv: rt && E(k.thicknessMap.channel),
      alphaMapUv: Ve && E(k.alphaMap.channel),
      vertexTangents: !!ue.attributes.tangent && (Oe || B),
      vertexColors: k.vertexColors,
      vertexAlphas:
        k.vertexColors === !0 &&
        !!ue.attributes.color &&
        ue.attributes.color.itemSize === 4,
      pointsUvs: $.isPoints === !0 && !!ue.attributes.uv && (Ue || Ve),
      fog: !!ee,
      useFog: k.fog === !0,
      fogExp2: !!ee && ee.isFogExp2,
      flatShading: k.flatShading === !0,
      sizeAttenuation: k.sizeAttenuation === !0,
      logarithmicDepthBuffer: m,
      reverseDepthBuffer: Fe,
      skinning: $.isSkinnedMesh === !0,
      morphTargets: ue.morphAttributes.position !== void 0,
      morphNormals: ue.morphAttributes.normal !== void 0,
      morphColors: ue.morphAttributes.color !== void 0,
      morphTargetsCount: W,
      morphTextureStride: ne,
      numDirLights: I.directional.length,
      numPointLights: I.point.length,
      numSpotLights: I.spot.length,
      numSpotLightMaps: I.spotLightMap.length,
      numRectAreaLights: I.rectArea.length,
      numHemiLights: I.hemi.length,
      numDirLightShadows: I.directionalShadowMap.length,
      numPointLightShadows: I.pointShadowMap.length,
      numSpotLightShadows: I.spotShadowMap.length,
      numSpotLightShadowsWithMaps: I.numSpotLightShadowsWithMaps,
      numLightProbes: I.numLightProbes,
      numClippingPlanes: o.numPlanes,
      numClipIntersection: o.numIntersection,
      dithering: k.dithering,
      shadowMapEnabled: n.shadowMap.enabled && V.length > 0,
      shadowMapType: n.shadowMap.type,
      toneMapping: vn,
      decodeVideoTexture:
        Ue && k.map.isVideoTexture === !0 && fn.getTransfer(k.map.colorSpace) === Sn,
      decodeVideoTextureEmissive:
        He &&
        k.emissiveMap.isVideoTexture === !0 &&
        fn.getTransfer(k.emissiveMap.colorSpace) === Sn,
      premultipliedAlpha: k.premultipliedAlpha,
      doubleSided: k.side === Vo,
      flipSided: k.side === Ir,
      useDepthPacking: k.depthPacking >= 0,
      depthPacking: k.depthPacking || 0,
      index0AttributeName: k.index0AttributeName,
      extensionClipCullDistance:
        Ut && k.extensions.clipCullDistance === !0 && i.has("WEBGL_clip_cull_distance"),
      extensionMultiDraw:
        ((Ut && k.extensions.multiDraw === !0) || Ge) && i.has("WEBGL_multi_draw"),
      rendererExtensionParallelShaderCompile: i.has("KHR_parallel_shader_compile"),
      customProgramCacheKey: k.customProgramCacheKey(),
    }
    return (
      (Vn.vertexUv1s = d.has(1)),
      (Vn.vertexUv2s = d.has(2)),
      (Vn.vertexUv3s = d.has(3)),
      d.clear(),
      Vn
    )
  }
  function w(k) {
    const I = []
    if (
      (k.shaderID
        ? I.push(k.shaderID)
        : (I.push(k.customVertexShaderID), I.push(k.customFragmentShaderID)),
      k.defines !== void 0)
    )
      for (const V in k.defines) I.push(V), I.push(k.defines[V])
    return (
      k.isRawShaderMaterial === !1 && (A(I, k), C(I, k), I.push(n.outputColorSpace)),
      I.push(k.customProgramCacheKey),
      I.join()
    )
  }
  function A(k, I) {
    k.push(I.precision),
      k.push(I.outputColorSpace),
      k.push(I.envMapMode),
      k.push(I.envMapCubeUVHeight),
      k.push(I.mapUv),
      k.push(I.alphaMapUv),
      k.push(I.lightMapUv),
      k.push(I.aoMapUv),
      k.push(I.bumpMapUv),
      k.push(I.normalMapUv),
      k.push(I.displacementMapUv),
      k.push(I.emissiveMapUv),
      k.push(I.metalnessMapUv),
      k.push(I.roughnessMapUv),
      k.push(I.anisotropyMapUv),
      k.push(I.clearcoatMapUv),
      k.push(I.clearcoatNormalMapUv),
      k.push(I.clearcoatRoughnessMapUv),
      k.push(I.iridescenceMapUv),
      k.push(I.iridescenceThicknessMapUv),
      k.push(I.sheenColorMapUv),
      k.push(I.sheenRoughnessMapUv),
      k.push(I.specularMapUv),
      k.push(I.specularColorMapUv),
      k.push(I.specularIntensityMapUv),
      k.push(I.transmissionMapUv),
      k.push(I.thicknessMapUv),
      k.push(I.combine),
      k.push(I.fogExp2),
      k.push(I.sizeAttenuation),
      k.push(I.morphTargetsCount),
      k.push(I.morphAttributeCount),
      k.push(I.numDirLights),
      k.push(I.numPointLights),
      k.push(I.numSpotLights),
      k.push(I.numSpotLightMaps),
      k.push(I.numHemiLights),
      k.push(I.numRectAreaLights),
      k.push(I.numDirLightShadows),
      k.push(I.numPointLightShadows),
      k.push(I.numSpotLightShadows),
      k.push(I.numSpotLightShadowsWithMaps),
      k.push(I.numLightProbes),
      k.push(I.shadowMapType),
      k.push(I.toneMapping),
      k.push(I.numClippingPlanes),
      k.push(I.numClipIntersection),
      k.push(I.depthPacking)
  }
  function C(k, I) {
    l.disableAll(),
      I.supportsVertexTextures && l.enable(0),
      I.instancing && l.enable(1),
      I.instancingColor && l.enable(2),
      I.instancingMorph && l.enable(3),
      I.matcap && l.enable(4),
      I.envMap && l.enable(5),
      I.normalMapObjectSpace && l.enable(6),
      I.normalMapTangentSpace && l.enable(7),
      I.clearcoat && l.enable(8),
      I.iridescence && l.enable(9),
      I.alphaTest && l.enable(10),
      I.vertexColors && l.enable(11),
      I.vertexAlphas && l.enable(12),
      I.vertexUv1s && l.enable(13),
      I.vertexUv2s && l.enable(14),
      I.vertexUv3s && l.enable(15),
      I.vertexTangents && l.enable(16),
      I.anisotropy && l.enable(17),
      I.alphaHash && l.enable(18),
      I.batching && l.enable(19),
      I.dispersion && l.enable(20),
      I.batchingColor && l.enable(21),
      k.push(l.mask),
      l.disableAll(),
      I.fog && l.enable(0),
      I.useFog && l.enable(1),
      I.flatShading && l.enable(2),
      I.logarithmicDepthBuffer && l.enable(3),
      I.reverseDepthBuffer && l.enable(4),
      I.skinning && l.enable(5),
      I.morphTargets && l.enable(6),
      I.morphNormals && l.enable(7),
      I.morphColors && l.enable(8),
      I.premultipliedAlpha && l.enable(9),
      I.shadowMapEnabled && l.enable(10),
      I.doubleSided && l.enable(11),
      I.flipSided && l.enable(12),
      I.useDepthPacking && l.enable(13),
      I.dithering && l.enable(14),
      I.transmission && l.enable(15),
      I.sheen && l.enable(16),
      I.opaque && l.enable(17),
      I.pointsUvs && l.enable(18),
      I.decodeVideoTexture && l.enable(19),
      I.decodeVideoTextureEmissive && l.enable(20),
      I.alphaToCoverage && l.enable(21),
      k.push(l.mask)
  }
  function R(k) {
    const I = x[k.type]
    let V
    if (I) {
      const Z = vo[I]
      V = x3.clone(Z.uniforms)
    } else V = k.uniforms
    return V
  }
  function z(k, I) {
    let V
    for (let Z = 0, $ = p.length; Z < $; Z++) {
      const ee = p[Z]
      if (ee.cacheKey === I) {
        ;(V = ee), ++V.usedTimes
        break
      }
    }
    return V === void 0 && ((V = new fV(n, I, k, s)), p.push(V)), V
  }
  function U(k) {
    if (--k.usedTimes === 0) {
      const I = p.indexOf(k)
      ;(p[I] = p[p.length - 1]), p.pop(), k.destroy()
    }
  }
  function O(k) {
    u.remove(k)
  }
  function N() {
    u.dispose()
  }
  return {
    getParameters: M,
    getProgramCacheKey: w,
    getUniforms: R,
    acquireProgram: z,
    releaseProgram: U,
    releaseShaderCache: O,
    programs: p,
    dispose: N,
  }
}
function gV() {
  let n = new WeakMap()
  function e(o) {
    return n.has(o)
  }
  function t(o) {
    let l = n.get(o)
    return l === void 0 && ((l = {}), n.set(o, l)), l
  }
  function i(o) {
    n.delete(o)
  }
  function r(o, l, u) {
    n.get(o)[l] = u
  }
  function s() {
    n = new WeakMap()
  }
  return { has: e, get: t, remove: i, update: r, dispose: s }
}
function vV(n, e) {
  return n.groupOrder !== e.groupOrder
    ? n.groupOrder - e.groupOrder
    : n.renderOrder !== e.renderOrder
    ? n.renderOrder - e.renderOrder
    : n.material.id !== e.material.id
    ? n.material.id - e.material.id
    : n.z !== e.z
    ? n.z - e.z
    : n.id - e.id
}
function UT(n, e) {
  return n.groupOrder !== e.groupOrder
    ? n.groupOrder - e.groupOrder
    : n.renderOrder !== e.renderOrder
    ? n.renderOrder - e.renderOrder
    : n.z !== e.z
    ? e.z - n.z
    : n.id - e.id
}
function OT() {
  const n = []
  let e = 0
  const t = [],
    i = [],
    r = []
  function s() {
    ;(e = 0), (t.length = 0), (i.length = 0), (r.length = 0)
  }
  function o(m, v, y, x, E, M) {
    let w = n[e]
    return (
      w === void 0
        ? ((w = {
            id: m.id,
            object: m,
            geometry: v,
            material: y,
            groupOrder: x,
            renderOrder: m.renderOrder,
            z: E,
            group: M,
          }),
          (n[e] = w))
        : ((w.id = m.id),
          (w.object = m),
          (w.geometry = v),
          (w.material = y),
          (w.groupOrder = x),
          (w.renderOrder = m.renderOrder),
          (w.z = E),
          (w.group = M)),
      e++,
      w
    )
  }
  function l(m, v, y, x, E, M) {
    const w = o(m, v, y, x, E, M)
    y.transmission > 0 ? i.push(w) : y.transparent === !0 ? r.push(w) : t.push(w)
  }
  function u(m, v, y, x, E, M) {
    const w = o(m, v, y, x, E, M)
    y.transmission > 0
      ? i.unshift(w)
      : y.transparent === !0
      ? r.unshift(w)
      : t.unshift(w)
  }
  function d(m, v) {
    t.length > 1 && t.sort(m || vV),
      i.length > 1 && i.sort(v || UT),
      r.length > 1 && r.sort(v || UT)
  }
  function p() {
    for (let m = e, v = n.length; m < v; m++) {
      const y = n[m]
      if (y.id === null) break
      ;(y.id = null),
        (y.object = null),
        (y.geometry = null),
        (y.material = null),
        (y.group = null)
    }
  }
  return {
    opaque: t,
    transmissive: i,
    transparent: r,
    init: s,
    push: l,
    unshift: u,
    finish: p,
    sort: d,
  }
}
function yV() {
  let n = new WeakMap()
  function e(i, r) {
    const s = n.get(i)
    let o
    return (
      s === void 0
        ? ((o = new OT()), n.set(i, [o]))
        : r >= s.length
        ? ((o = new OT()), s.push(o))
        : (o = s[r]),
      o
    )
  }
  function t() {
    n = new WeakMap()
  }
  return { get: e, dispose: t }
}
function xV() {
  const n = {}
  return {
    get: function (e) {
      if (n[e.id] !== void 0) return n[e.id]
      let t
      switch (e.type) {
        case "DirectionalLight":
          t = { direction: new q(), color: new ot() }
          break
        case "SpotLight":
          t = {
            position: new q(),
            direction: new q(),
            color: new ot(),
            distance: 0,
            coneCos: 0,
            penumbraCos: 0,
            decay: 0,
          }
          break
        case "PointLight":
          t = { position: new q(), color: new ot(), distance: 0, decay: 0 }
          break
        case "HemisphereLight":
          t = { direction: new q(), skyColor: new ot(), groundColor: new ot() }
          break
        case "RectAreaLight":
          t = {
            color: new ot(),
            position: new q(),
            halfWidth: new q(),
            halfHeight: new q(),
          }
          break
      }
      return (n[e.id] = t), t
    },
  }
}
function _V() {
  const n = {}
  return {
    get: function (e) {
      if (n[e.id] !== void 0) return n[e.id]
      let t
      switch (e.type) {
        case "DirectionalLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new We(),
          }
          break
        case "SpotLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new We(),
          }
          break
        case "PointLight":
          t = {
            shadowIntensity: 1,
            shadowBias: 0,
            shadowNormalBias: 0,
            shadowRadius: 1,
            shadowMapSize: new We(),
            shadowCameraNear: 1,
            shadowCameraFar: 1e3,
          }
          break
      }
      return (n[e.id] = t), t
    },
  }
}
let wV = 0
function SV(n, e) {
  return (
    (e.castShadow ? 2 : 0) - (n.castShadow ? 2 : 0) + (e.map ? 1 : 0) - (n.map ? 1 : 0)
  )
}
function MV(n) {
  const e = new xV(),
    t = _V(),
    i = {
      version: 0,
      hash: {
        directionalLength: -1,
        pointLength: -1,
        spotLength: -1,
        rectAreaLength: -1,
        hemiLength: -1,
        numDirectionalShadows: -1,
        numPointShadows: -1,
        numSpotShadows: -1,
        numSpotMaps: -1,
        numLightProbes: -1,
      },
      ambient: [0, 0, 0],
      probe: [],
      directional: [],
      directionalShadow: [],
      directionalShadowMap: [],
      directionalShadowMatrix: [],
      spot: [],
      spotLightMap: [],
      spotShadow: [],
      spotShadowMap: [],
      spotLightMatrix: [],
      rectArea: [],
      rectAreaLTC1: null,
      rectAreaLTC2: null,
      point: [],
      pointShadow: [],
      pointShadowMap: [],
      pointShadowMatrix: [],
      hemi: [],
      numSpotLightShadowsWithMaps: 0,
      numLightProbes: 0,
    }
  for (let d = 0; d < 9; d++) i.probe.push(new q())
  const r = new q(),
    s = new mt(),
    o = new mt()
  function l(d) {
    let p = 0,
      m = 0,
      v = 0
    for (let k = 0; k < 9; k++) i.probe[k].set(0, 0, 0)
    let y = 0,
      x = 0,
      E = 0,
      M = 0,
      w = 0,
      A = 0,
      C = 0,
      R = 0,
      z = 0,
      U = 0,
      O = 0
    d.sort(SV)
    for (let k = 0, I = d.length; k < I; k++) {
      const V = d[k],
        Z = V.color,
        $ = V.intensity,
        ee = V.distance,
        ue = V.shadow && V.shadow.map ? V.shadow.map.texture : null
      if (V.isAmbientLight) (p += Z.r * $), (m += Z.g * $), (v += Z.b * $)
      else if (V.isLightProbe) {
        for (let re = 0; re < 9; re++)
          i.probe[re].addScaledVector(V.sh.coefficients[re], $)
        O++
      } else if (V.isDirectionalLight) {
        const re = e.get(V)
        if ((re.color.copy(V.color).multiplyScalar(V.intensity), V.castShadow)) {
          const se = V.shadow,
            G = t.get(V)
          ;(G.shadowIntensity = se.intensity),
            (G.shadowBias = se.bias),
            (G.shadowNormalBias = se.normalBias),
            (G.shadowRadius = se.radius),
            (G.shadowMapSize = se.mapSize),
            (i.directionalShadow[y] = G),
            (i.directionalShadowMap[y] = ue),
            (i.directionalShadowMatrix[y] = V.shadow.matrix),
            A++
        }
        ;(i.directional[y] = re), y++
      } else if (V.isSpotLight) {
        const re = e.get(V)
        re.position.setFromMatrixPosition(V.matrixWorld),
          re.color.copy(Z).multiplyScalar($),
          (re.distance = ee),
          (re.coneCos = Math.cos(V.angle)),
          (re.penumbraCos = Math.cos(V.angle * (1 - V.penumbra))),
          (re.decay = V.decay),
          (i.spot[E] = re)
        const se = V.shadow
        if (
          (V.map &&
            ((i.spotLightMap[z] = V.map),
            z++,
            se.updateMatrices(V),
            V.castShadow && U++),
          (i.spotLightMatrix[E] = se.matrix),
          V.castShadow)
        ) {
          const G = t.get(V)
          ;(G.shadowIntensity = se.intensity),
            (G.shadowBias = se.bias),
            (G.shadowNormalBias = se.normalBias),
            (G.shadowRadius = se.radius),
            (G.shadowMapSize = se.mapSize),
            (i.spotShadow[E] = G),
            (i.spotShadowMap[E] = ue),
            R++
        }
        E++
      } else if (V.isRectAreaLight) {
        const re = e.get(V)
        re.color.copy(Z).multiplyScalar($),
          re.halfWidth.set(V.width * 0.5, 0, 0),
          re.halfHeight.set(0, V.height * 0.5, 0),
          (i.rectArea[M] = re),
          M++
      } else if (V.isPointLight) {
        const re = e.get(V)
        if (
          (re.color.copy(V.color).multiplyScalar(V.intensity),
          (re.distance = V.distance),
          (re.decay = V.decay),
          V.castShadow)
        ) {
          const se = V.shadow,
            G = t.get(V)
          ;(G.shadowIntensity = se.intensity),
            (G.shadowBias = se.bias),
            (G.shadowNormalBias = se.normalBias),
            (G.shadowRadius = se.radius),
            (G.shadowMapSize = se.mapSize),
            (G.shadowCameraNear = se.camera.near),
            (G.shadowCameraFar = se.camera.far),
            (i.pointShadow[x] = G),
            (i.pointShadowMap[x] = ue),
            (i.pointShadowMatrix[x] = V.shadow.matrix),
            C++
        }
        ;(i.point[x] = re), x++
      } else if (V.isHemisphereLight) {
        const re = e.get(V)
        re.skyColor.copy(V.color).multiplyScalar($),
          re.groundColor.copy(V.groundColor).multiplyScalar($),
          (i.hemi[w] = re),
          w++
      }
    }
    M > 0 &&
      (n.has("OES_texture_float_linear") === !0
        ? ((i.rectAreaLTC1 = ut.LTC_FLOAT_1), (i.rectAreaLTC2 = ut.LTC_FLOAT_2))
        : ((i.rectAreaLTC1 = ut.LTC_HALF_1), (i.rectAreaLTC2 = ut.LTC_HALF_2))),
      (i.ambient[0] = p),
      (i.ambient[1] = m),
      (i.ambient[2] = v)
    const N = i.hash
    ;(N.directionalLength !== y ||
      N.pointLength !== x ||
      N.spotLength !== E ||
      N.rectAreaLength !== M ||
      N.hemiLength !== w ||
      N.numDirectionalShadows !== A ||
      N.numPointShadows !== C ||
      N.numSpotShadows !== R ||
      N.numSpotMaps !== z ||
      N.numLightProbes !== O) &&
      ((i.directional.length = y),
      (i.spot.length = E),
      (i.rectArea.length = M),
      (i.point.length = x),
      (i.hemi.length = w),
      (i.directionalShadow.length = A),
      (i.directionalShadowMap.length = A),
      (i.pointShadow.length = C),
      (i.pointShadowMap.length = C),
      (i.spotShadow.length = R),
      (i.spotShadowMap.length = R),
      (i.directionalShadowMatrix.length = A),
      (i.pointShadowMatrix.length = C),
      (i.spotLightMatrix.length = R + z - U),
      (i.spotLightMap.length = z),
      (i.numSpotLightShadowsWithMaps = U),
      (i.numLightProbes = O),
      (N.directionalLength = y),
      (N.pointLength = x),
      (N.spotLength = E),
      (N.rectAreaLength = M),
      (N.hemiLength = w),
      (N.numDirectionalShadows = A),
      (N.numPointShadows = C),
      (N.numSpotShadows = R),
      (N.numSpotMaps = z),
      (N.numLightProbes = O),
      (i.version = wV++))
  }
  function u(d, p) {
    let m = 0,
      v = 0,
      y = 0,
      x = 0,
      E = 0
    const M = p.matrixWorldInverse
    for (let w = 0, A = d.length; w < A; w++) {
      const C = d[w]
      if (C.isDirectionalLight) {
        const R = i.directional[m]
        R.direction.setFromMatrixPosition(C.matrixWorld),
          r.setFromMatrixPosition(C.target.matrixWorld),
          R.direction.sub(r),
          R.direction.transformDirection(M),
          m++
      } else if (C.isSpotLight) {
        const R = i.spot[y]
        R.position.setFromMatrixPosition(C.matrixWorld),
          R.position.applyMatrix4(M),
          R.direction.setFromMatrixPosition(C.matrixWorld),
          r.setFromMatrixPosition(C.target.matrixWorld),
          R.direction.sub(r),
          R.direction.transformDirection(M),
          y++
      } else if (C.isRectAreaLight) {
        const R = i.rectArea[x]
        R.position.setFromMatrixPosition(C.matrixWorld),
          R.position.applyMatrix4(M),
          o.identity(),
          s.copy(C.matrixWorld),
          s.premultiply(M),
          o.extractRotation(s),
          R.halfWidth.set(C.width * 0.5, 0, 0),
          R.halfHeight.set(0, C.height * 0.5, 0),
          R.halfWidth.applyMatrix4(o),
          R.halfHeight.applyMatrix4(o),
          x++
      } else if (C.isPointLight) {
        const R = i.point[v]
        R.position.setFromMatrixPosition(C.matrixWorld), R.position.applyMatrix4(M), v++
      } else if (C.isHemisphereLight) {
        const R = i.hemi[E]
        R.direction.setFromMatrixPosition(C.matrixWorld),
          R.direction.transformDirection(M),
          E++
      }
    }
  }
  return { setup: l, setupView: u, state: i }
}
function BT(n) {
  const e = new MV(n),
    t = [],
    i = []
  function r(p) {
    ;(d.camera = p), (t.length = 0), (i.length = 0)
  }
  function s(p) {
    t.push(p)
  }
  function o(p) {
    i.push(p)
  }
  function l() {
    e.setup(t)
  }
  function u(p) {
    e.setupView(t, p)
  }
  const d = {
    lightsArray: t,
    shadowsArray: i,
    camera: null,
    lights: e,
    transmissionRenderTarget: {},
  }
  return {
    init: r,
    state: d,
    setupLights: l,
    setupLightsView: u,
    pushLight: s,
    pushShadow: o,
  }
}
function EV(n) {
  let e = new WeakMap()
  function t(r, s = 0) {
    const o = e.get(r)
    let l
    return (
      o === void 0
        ? ((l = new BT(n)), e.set(r, [l]))
        : s >= o.length
        ? ((l = new BT(n)), o.push(l))
        : (l = o[s]),
      l
    )
  }
  function i() {
    e = new WeakMap()
  }
  return { get: t, dispose: i }
}
class Hw extends er {
  static get type() {
    return "MeshDepthMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshDepthMaterial = !0),
      (this.depthPacking = i3),
      (this.map = null),
      (this.alphaMap = null),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.depthPacking = e.depthPacking),
      (this.map = e.map),
      (this.alphaMap = e.alphaMap),
      (this.displacementMap = e.displacementMap),
      (this.displacementScale = e.displacementScale),
      (this.displacementBias = e.displacementBias),
      (this.wireframe = e.wireframe),
      (this.wireframeLinewidth = e.wireframeLinewidth),
      this
    )
  }
}
class Gw extends er {
  static get type() {
    return "MeshDistanceMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshDistanceMaterial = !0),
      (this.map = null),
      (this.alphaMap = null),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.map = e.map),
      (this.alphaMap = e.alphaMap),
      (this.displacementMap = e.displacementMap),
      (this.displacementScale = e.displacementScale),
      (this.displacementBias = e.displacementBias),
      this
    )
  }
}
const TV = `void main() {
	gl_Position = vec4( position, 1.0 );
}`,
  bV = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`
function AV(n, e, t) {
  let i = new wm()
  const r = new We(),
    s = new We(),
    o = new on(),
    l = new Hw({ depthPacking: r3 }),
    u = new Gw(),
    d = {},
    p = t.maxTextureSize,
    m = { [$a]: Ir, [Ir]: $a, [Vo]: Vo },
    v = new Mo({
      defines: { VSM_SAMPLES: 8 },
      uniforms: {
        shadow_pass: { value: null },
        resolution: { value: new We() },
        radius: { value: 4 },
      },
      vertexShader: TV,
      fragmentShader: bV,
    }),
    y = v.clone()
  y.defines.HORIZONTAL_PASS = 1
  const x = new Gt()
  x.setAttribute(
    "position",
    new bn(new Float32Array([-1, -1, 0.5, 3, -1, 0.5, -1, 3, 0.5]), 3),
  )
  const E = new ui(x, v),
    M = this
  ;(this.enabled = !1),
    (this.autoUpdate = !0),
    (this.needsUpdate = !1),
    (this.type = jv)
  let w = this.type
  this.render = function (U, O, N) {
    if (
      M.enabled === !1 ||
      (M.autoUpdate === !1 && M.needsUpdate === !1) ||
      U.length === 0
    )
      return
    const k = n.getRenderTarget(),
      I = n.getActiveCubeFace(),
      V = n.getActiveMipmapLevel(),
      Z = n.state
    Z.setBlending(ja),
      Z.buffers.color.setClear(1, 1, 1, 1),
      Z.buffers.depth.setTest(!0),
      Z.setScissorTest(!1)
    const $ = w !== go && this.type === go,
      ee = w === go && this.type !== go
    for (let ue = 0, re = U.length; ue < re; ue++) {
      const se = U[ue],
        G = se.shadow
      if (G === void 0) {
        console.warn("THREE.WebGLShadowMap:", se, "has no shadow.")
        continue
      }
      if (G.autoUpdate === !1 && G.needsUpdate === !1) continue
      r.copy(G.mapSize)
      const ie = G.getFrameExtents()
      if (
        (r.multiply(ie),
        s.copy(G.mapSize),
        (r.x > p || r.y > p) &&
          (r.x > p &&
            ((s.x = Math.floor(p / ie.x)), (r.x = s.x * ie.x), (G.mapSize.x = s.x)),
          r.y > p &&
            ((s.y = Math.floor(p / ie.y)), (r.y = s.y * ie.y), (G.mapSize.y = s.y))),
        G.map === null || $ === !0 || ee === !0)
      ) {
        const W = this.type !== go ? { minFilter: Qi, magFilter: Qi } : {}
        G.map !== null && G.map.dispose(),
          (G.map = new So(r.x, r.y, W)),
          (G.map.texture.name = se.name + ".shadowMap"),
          G.camera.updateProjectionMatrix()
      }
      n.setRenderTarget(G.map), n.clear()
      const Q = G.getViewportCount()
      for (let W = 0; W < Q; W++) {
        const ne = G.getViewport(W)
        o.set(s.x * ne.x, s.y * ne.y, s.x * ne.z, s.y * ne.w),
          Z.viewport(o),
          G.updateMatrices(se, W),
          (i = G.getFrustum()),
          R(O, N, G.camera, se, this.type)
      }
      G.isPointLightShadow !== !0 && this.type === go && A(G, N), (G.needsUpdate = !1)
    }
    ;(w = this.type), (M.needsUpdate = !1), n.setRenderTarget(k, I, V)
  }
  function A(U, O) {
    const N = e.update(E)
    v.defines.VSM_SAMPLES !== U.blurSamples &&
      ((v.defines.VSM_SAMPLES = U.blurSamples),
      (y.defines.VSM_SAMPLES = U.blurSamples),
      (v.needsUpdate = !0),
      (y.needsUpdate = !0)),
      U.mapPass === null && (U.mapPass = new So(r.x, r.y)),
      (v.uniforms.shadow_pass.value = U.map.texture),
      (v.uniforms.resolution.value = U.mapSize),
      (v.uniforms.radius.value = U.radius),
      n.setRenderTarget(U.mapPass),
      n.clear(),
      n.renderBufferDirect(O, null, N, v, E, null),
      (y.uniforms.shadow_pass.value = U.mapPass.texture),
      (y.uniforms.resolution.value = U.mapSize),
      (y.uniforms.radius.value = U.radius),
      n.setRenderTarget(U.map),
      n.clear(),
      n.renderBufferDirect(O, null, N, y, E, null)
  }
  function C(U, O, N, k) {
    let I = null
    const V = N.isPointLight === !0 ? U.customDistanceMaterial : U.customDepthMaterial
    if (V !== void 0) I = V
    else if (
      ((I = N.isPointLight === !0 ? u : l),
      (n.localClippingEnabled &&
        O.clipShadows === !0 &&
        Array.isArray(O.clippingPlanes) &&
        O.clippingPlanes.length !== 0) ||
        (O.displacementMap && O.displacementScale !== 0) ||
        (O.alphaMap && O.alphaTest > 0) ||
        (O.map && O.alphaTest > 0))
    ) {
      const Z = I.uuid,
        $ = O.uuid
      let ee = d[Z]
      ee === void 0 && ((ee = {}), (d[Z] = ee))
      let ue = ee[$]
      ue === void 0 &&
        ((ue = I.clone()), (ee[$] = ue), O.addEventListener("dispose", z)),
        (I = ue)
    }
    if (
      ((I.visible = O.visible),
      (I.wireframe = O.wireframe),
      k === go
        ? (I.side = O.shadowSide !== null ? O.shadowSide : O.side)
        : (I.side = O.shadowSide !== null ? O.shadowSide : m[O.side]),
      (I.alphaMap = O.alphaMap),
      (I.alphaTest = O.alphaTest),
      (I.map = O.map),
      (I.clipShadows = O.clipShadows),
      (I.clippingPlanes = O.clippingPlanes),
      (I.clipIntersection = O.clipIntersection),
      (I.displacementMap = O.displacementMap),
      (I.displacementScale = O.displacementScale),
      (I.displacementBias = O.displacementBias),
      (I.wireframeLinewidth = O.wireframeLinewidth),
      (I.linewidth = O.linewidth),
      N.isPointLight === !0 && I.isMeshDistanceMaterial === !0)
    ) {
      const Z = n.properties.get(I)
      Z.light = N
    }
    return I
  }
  function R(U, O, N, k, I) {
    if (U.visible === !1) return
    if (
      U.layers.test(O.layers) &&
      (U.isMesh || U.isLine || U.isPoints) &&
      (U.castShadow || (U.receiveShadow && I === go)) &&
      (!U.frustumCulled || i.intersectsObject(U))
    ) {
      U.modelViewMatrix.multiplyMatrices(N.matrixWorldInverse, U.matrixWorld)
      const $ = e.update(U),
        ee = U.material
      if (Array.isArray(ee)) {
        const ue = $.groups
        for (let re = 0, se = ue.length; re < se; re++) {
          const G = ue[re],
            ie = ee[G.materialIndex]
          if (ie && ie.visible) {
            const Q = C(U, ie, k, I)
            U.onBeforeShadow(n, U, O, N, $, Q, G),
              n.renderBufferDirect(N, null, $, Q, U, G),
              U.onAfterShadow(n, U, O, N, $, Q, G)
          }
        }
      } else if (ee.visible) {
        const ue = C(U, ee, k, I)
        U.onBeforeShadow(n, U, O, N, $, ue, null),
          n.renderBufferDirect(N, null, $, ue, U, null),
          U.onAfterShadow(n, U, O, N, $, ue, null)
      }
    }
    const Z = U.children
    for (let $ = 0, ee = Z.length; $ < ee; $++) R(Z[$], O, N, k, I)
  }
  function z(U) {
    U.target.removeEventListener("dispose", z)
    for (const N in d) {
      const k = d[N],
        I = U.target.uuid
      I in k && (k[I].dispose(), delete k[I])
    }
  }
}
const CV = {
  [W0]: j0,
  [X0]: $0,
  [Y0]: K0,
  [Iu]: q0,
  [j0]: W0,
  [$0]: X0,
  [K0]: Y0,
  [q0]: Iu,
}
function RV(n, e) {
  function t() {
    let he = !1
    const rt = new on()
    let Ne = null
    const Ve = new on(0, 0, 0, 0)
    return {
      setMask: function (lt) {
        Ne !== lt && !he && (n.colorMask(lt, lt, lt, lt), (Ne = lt))
      },
      setLocked: function (lt) {
        he = lt
      },
      setClear: function (lt, at, Ut, vn, Vn) {
        Vn === !0 && ((lt *= vn), (at *= vn), (Ut *= vn)),
          rt.set(lt, at, Ut, vn),
          Ve.equals(rt) === !1 && (n.clearColor(lt, at, Ut, vn), Ve.copy(rt))
      },
      reset: function () {
        ;(he = !1), (Ne = null), Ve.set(-1, 0, 0, 0)
      },
    }
  }
  function i() {
    let he = !1,
      rt = !1,
      Ne = null,
      Ve = null,
      lt = null
    return {
      setReversed: function (at) {
        if (rt !== at) {
          const Ut = e.get("EXT_clip_control")
          rt
            ? Ut.clipControlEXT(Ut.LOWER_LEFT_EXT, Ut.ZERO_TO_ONE_EXT)
            : Ut.clipControlEXT(Ut.LOWER_LEFT_EXT, Ut.NEGATIVE_ONE_TO_ONE_EXT)
          const vn = lt
          ;(lt = null), this.setClear(vn)
        }
        rt = at
      },
      getReversed: function () {
        return rt
      },
      setTest: function (at) {
        at ? me(n.DEPTH_TEST) : Fe(n.DEPTH_TEST)
      },
      setMask: function (at) {
        Ne !== at && !he && (n.depthMask(at), (Ne = at))
      },
      setFunc: function (at) {
        if ((rt && (at = CV[at]), Ve !== at)) {
          switch (at) {
            case W0:
              n.depthFunc(n.NEVER)
              break
            case j0:
              n.depthFunc(n.ALWAYS)
              break
            case X0:
              n.depthFunc(n.LESS)
              break
            case Iu:
              n.depthFunc(n.LEQUAL)
              break
            case Y0:
              n.depthFunc(n.EQUAL)
              break
            case q0:
              n.depthFunc(n.GEQUAL)
              break
            case $0:
              n.depthFunc(n.GREATER)
              break
            case K0:
              n.depthFunc(n.NOTEQUAL)
              break
            default:
              n.depthFunc(n.LEQUAL)
          }
          Ve = at
        }
      },
      setLocked: function (at) {
        he = at
      },
      setClear: function (at) {
        lt !== at && (rt && (at = 1 - at), n.clearDepth(at), (lt = at))
      },
      reset: function () {
        ;(he = !1), (Ne = null), (Ve = null), (lt = null), (rt = !1)
      },
    }
  }
  function r() {
    let he = !1,
      rt = null,
      Ne = null,
      Ve = null,
      lt = null,
      at = null,
      Ut = null,
      vn = null,
      Vn = null
    return {
      setTest: function (an) {
        he || (an ? me(n.STENCIL_TEST) : Fe(n.STENCIL_TEST))
      },
      setMask: function (an) {
        rt !== an && !he && (n.stencilMask(an), (rt = an))
      },
      setFunc: function (an, zi, Vi) {
        ;(Ne !== an || Ve !== zi || lt !== Vi) &&
          (n.stencilFunc(an, zi, Vi), (Ne = an), (Ve = zi), (lt = Vi))
      },
      setOp: function (an, zi, Vi) {
        ;(at !== an || Ut !== zi || vn !== Vi) &&
          (n.stencilOp(an, zi, Vi), (at = an), (Ut = zi), (vn = Vi))
      },
      setLocked: function (an) {
        he = an
      },
      setClear: function (an) {
        Vn !== an && (n.clearStencil(an), (Vn = an))
      },
      reset: function () {
        ;(he = !1),
          (rt = null),
          (Ne = null),
          (Ve = null),
          (lt = null),
          (at = null),
          (Ut = null),
          (vn = null),
          (Vn = null)
      },
    }
  }
  const s = new t(),
    o = new i(),
    l = new r(),
    u = new WeakMap(),
    d = new WeakMap()
  let p = {},
    m = {},
    v = new WeakMap(),
    y = [],
    x = null,
    E = !1,
    M = null,
    w = null,
    A = null,
    C = null,
    R = null,
    z = null,
    U = null,
    O = new ot(0, 0, 0),
    N = 0,
    k = !1,
    I = null,
    V = null,
    Z = null,
    $ = null,
    ee = null
  const ue = n.getParameter(n.MAX_COMBINED_TEXTURE_IMAGE_UNITS)
  let re = !1,
    se = 0
  const G = n.getParameter(n.VERSION)
  G.indexOf("WebGL") !== -1
    ? ((se = parseFloat(/^WebGL (\d)/.exec(G)[1])), (re = se >= 1))
    : G.indexOf("OpenGL ES") !== -1 &&
      ((se = parseFloat(/^OpenGL ES (\d)/.exec(G)[1])), (re = se >= 2))
  let ie = null,
    Q = {}
  const W = n.getParameter(n.SCISSOR_BOX),
    ne = n.getParameter(n.VIEWPORT),
    ye = new on().fromArray(W),
    oe = new on().fromArray(ne)
  function fe(he, rt, Ne, Ve) {
    const lt = new Uint8Array(4),
      at = n.createTexture()
    n.bindTexture(he, at),
      n.texParameteri(he, n.TEXTURE_MIN_FILTER, n.NEAREST),
      n.texParameteri(he, n.TEXTURE_MAG_FILTER, n.NEAREST)
    for (let Ut = 0; Ut < Ne; Ut++)
      he === n.TEXTURE_3D || he === n.TEXTURE_2D_ARRAY
        ? n.texImage3D(rt, 0, n.RGBA, 1, 1, Ve, 0, n.RGBA, n.UNSIGNED_BYTE, lt)
        : n.texImage2D(rt + Ut, 0, n.RGBA, 1, 1, 0, n.RGBA, n.UNSIGNED_BYTE, lt)
    return at
  }
  const we = {}
  ;(we[n.TEXTURE_2D] = fe(n.TEXTURE_2D, n.TEXTURE_2D, 1)),
    (we[n.TEXTURE_CUBE_MAP] = fe(n.TEXTURE_CUBE_MAP, n.TEXTURE_CUBE_MAP_POSITIVE_X, 6)),
    (we[n.TEXTURE_2D_ARRAY] = fe(n.TEXTURE_2D_ARRAY, n.TEXTURE_2D_ARRAY, 1, 1)),
    (we[n.TEXTURE_3D] = fe(n.TEXTURE_3D, n.TEXTURE_3D, 1, 1)),
    s.setClear(0, 0, 0, 1),
    o.setClear(1),
    l.setClear(0),
    me(n.DEPTH_TEST),
    o.setFunc(Iu),
    Be(!1),
    Oe(v1),
    me(n.CULL_FACE),
    K(ja)
  function me(he) {
    p[he] !== !0 && (n.enable(he), (p[he] = !0))
  }
  function Fe(he) {
    p[he] !== !1 && (n.disable(he), (p[he] = !1))
  }
  function ze(he, rt) {
    return m[he] !== rt
      ? (n.bindFramebuffer(he, rt),
        (m[he] = rt),
        he === n.DRAW_FRAMEBUFFER && (m[n.FRAMEBUFFER] = rt),
        he === n.FRAMEBUFFER && (m[n.DRAW_FRAMEBUFFER] = rt),
        !0)
      : !1
  }
  function Ge(he, rt) {
    let Ne = y,
      Ve = !1
    if (he) {
      ;(Ne = v.get(rt)), Ne === void 0 && ((Ne = []), v.set(rt, Ne))
      const lt = he.textures
      if (Ne.length !== lt.length || Ne[0] !== n.COLOR_ATTACHMENT0) {
        for (let at = 0, Ut = lt.length; at < Ut; at++)
          Ne[at] = n.COLOR_ATTACHMENT0 + at
        ;(Ne.length = lt.length), (Ve = !0)
      }
    } else Ne[0] !== n.BACK && ((Ne[0] = n.BACK), (Ve = !0))
    Ve && n.drawBuffers(Ne)
  }
  function Ue(he) {
    return x !== he ? (n.useProgram(he), (x = he), !0) : !1
  }
  const ae = { [$l]: n.FUNC_ADD, [CC]: n.FUNC_SUBTRACT, [RC]: n.FUNC_REVERSE_SUBTRACT }
  ;(ae[PC] = n.MIN), (ae[IC] = n.MAX)
  const Ee = {
    [LC]: n.ZERO,
    [DC]: n.ONE,
    [NC]: n.SRC_COLOR,
    [H0]: n.SRC_ALPHA,
    [zC]: n.SRC_ALPHA_SATURATE,
    [OC]: n.DST_COLOR,
    [FC]: n.DST_ALPHA,
    [kC]: n.ONE_MINUS_SRC_COLOR,
    [G0]: n.ONE_MINUS_SRC_ALPHA,
    [BC]: n.ONE_MINUS_DST_COLOR,
    [UC]: n.ONE_MINUS_DST_ALPHA,
    [VC]: n.CONSTANT_COLOR,
    [HC]: n.ONE_MINUS_CONSTANT_COLOR,
    [GC]: n.CONSTANT_ALPHA,
    [WC]: n.ONE_MINUS_CONSTANT_ALPHA,
  }
  function K(he, rt, Ne, Ve, lt, at, Ut, vn, Vn, an) {
    if (he === ja) {
      E === !0 && (Fe(n.BLEND), (E = !1))
      return
    }
    if ((E === !1 && (me(n.BLEND), (E = !0)), he !== AC)) {
      if (he !== M || an !== k) {
        if (
          ((w !== $l || R !== $l) && (n.blendEquation(n.FUNC_ADD), (w = $l), (R = $l)),
          an)
        )
          switch (he) {
            case Eu:
              n.blendFuncSeparate(
                n.ONE,
                n.ONE_MINUS_SRC_ALPHA,
                n.ONE,
                n.ONE_MINUS_SRC_ALPHA,
              )
              break
            case y1:
              n.blendFunc(n.ONE, n.ONE)
              break
            case x1:
              n.blendFuncSeparate(n.ZERO, n.ONE_MINUS_SRC_COLOR, n.ZERO, n.ONE)
              break
            case _1:
              n.blendFuncSeparate(n.ZERO, n.SRC_COLOR, n.ZERO, n.SRC_ALPHA)
              break
            default:
              console.error("THREE.WebGLState: Invalid blending: ", he)
              break
          }
        else
          switch (he) {
            case Eu:
              n.blendFuncSeparate(
                n.SRC_ALPHA,
                n.ONE_MINUS_SRC_ALPHA,
                n.ONE,
                n.ONE_MINUS_SRC_ALPHA,
              )
              break
            case y1:
              n.blendFunc(n.SRC_ALPHA, n.ONE)
              break
            case x1:
              n.blendFuncSeparate(n.ZERO, n.ONE_MINUS_SRC_COLOR, n.ZERO, n.ONE)
              break
            case _1:
              n.blendFunc(n.ZERO, n.SRC_COLOR)
              break
            default:
              console.error("THREE.WebGLState: Invalid blending: ", he)
              break
          }
        ;(A = null),
          (C = null),
          (z = null),
          (U = null),
          O.set(0, 0, 0),
          (N = 0),
          (M = he),
          (k = an)
      }
      return
    }
    ;(lt = lt || rt),
      (at = at || Ne),
      (Ut = Ut || Ve),
      (rt !== w || lt !== R) &&
        (n.blendEquationSeparate(ae[rt], ae[lt]), (w = rt), (R = lt)),
      (Ne !== A || Ve !== C || at !== z || Ut !== U) &&
        (n.blendFuncSeparate(Ee[Ne], Ee[Ve], Ee[at], Ee[Ut]),
        (A = Ne),
        (C = Ve),
        (z = at),
        (U = Ut)),
      (vn.equals(O) === !1 || Vn !== N) &&
        (n.blendColor(vn.r, vn.g, vn.b, Vn), O.copy(vn), (N = Vn)),
      (M = he),
      (k = !1)
  }
  function Ke(he, rt) {
    he.side === Vo ? Fe(n.CULL_FACE) : me(n.CULL_FACE)
    let Ne = he.side === Ir
    rt && (Ne = !Ne),
      Be(Ne),
      he.blending === Eu && he.transparent === !1
        ? K(ja)
        : K(
            he.blending,
            he.blendEquation,
            he.blendSrc,
            he.blendDst,
            he.blendEquationAlpha,
            he.blendSrcAlpha,
            he.blendDstAlpha,
            he.blendColor,
            he.blendAlpha,
            he.premultipliedAlpha,
          ),
      o.setFunc(he.depthFunc),
      o.setTest(he.depthTest),
      o.setMask(he.depthWrite),
      s.setMask(he.colorWrite)
    const Ve = he.stencilWrite
    l.setTest(Ve),
      Ve &&
        (l.setMask(he.stencilWriteMask),
        l.setFunc(he.stencilFunc, he.stencilRef, he.stencilFuncMask),
        l.setOp(he.stencilFail, he.stencilZFail, he.stencilZPass)),
      He(he.polygonOffset, he.polygonOffsetFactor, he.polygonOffsetUnits),
      he.alphaToCoverage === !0
        ? me(n.SAMPLE_ALPHA_TO_COVERAGE)
        : Fe(n.SAMPLE_ALPHA_TO_COVERAGE)
  }
  function Be(he) {
    I !== he && (he ? n.frontFace(n.CW) : n.frontFace(n.CCW), (I = he))
  }
  function Oe(he) {
    he !== EC
      ? (me(n.CULL_FACE),
        he !== V &&
          (he === v1
            ? n.cullFace(n.BACK)
            : he === TC
            ? n.cullFace(n.FRONT)
            : n.cullFace(n.FRONT_AND_BACK)))
      : Fe(n.CULL_FACE),
      (V = he)
  }
  function Pe(he) {
    he !== Z && (re && n.lineWidth(he), (Z = he))
  }
  function He(he, rt, Ne) {
    he
      ? (me(n.POLYGON_OFFSET_FILL),
        ($ !== rt || ee !== Ne) && (n.polygonOffset(rt, Ne), ($ = rt), (ee = Ne)))
      : Fe(n.POLYGON_OFFSET_FILL)
  }
  function Se(he) {
    he ? me(n.SCISSOR_TEST) : Fe(n.SCISSOR_TEST)
  }
  function j(he) {
    he === void 0 && (he = n.TEXTURE0 + ue - 1),
      ie !== he && (n.activeTexture(he), (ie = he))
  }
  function B(he, rt, Ne) {
    Ne === void 0 && (ie === null ? (Ne = n.TEXTURE0 + ue - 1) : (Ne = ie))
    let Ve = Q[Ne]
    Ve === void 0 && ((Ve = { type: void 0, texture: void 0 }), (Q[Ne] = Ve)),
      (Ve.type !== he || Ve.texture !== rt) &&
        (ie !== Ne && (n.activeTexture(Ne), (ie = Ne)),
        n.bindTexture(he, rt || we[he]),
        (Ve.type = he),
        (Ve.texture = rt))
  }
  function ce() {
    const he = Q[ie]
    he !== void 0 &&
      he.type !== void 0 &&
      (n.bindTexture(he.type, null), (he.type = void 0), (he.texture = void 0))
  }
  function Me() {
    try {
      n.compressedTexImage2D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function De() {
    try {
      n.compressedTexImage3D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function Ie() {
    try {
      n.texSubImage2D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function st() {
    try {
      n.texSubImage3D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function tt() {
    try {
      n.compressedTexSubImage2D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function it() {
    try {
      n.compressedTexSubImage3D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function Et() {
    try {
      n.texStorage2D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function je() {
    try {
      n.texStorage3D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function Je() {
    try {
      n.texImage2D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function At() {
    try {
      n.texImage3D.apply(n, arguments)
    } catch (he) {
      console.error("THREE.WebGLState:", he)
    }
  }
  function Pt(he) {
    ye.equals(he) === !1 && (n.scissor(he.x, he.y, he.z, he.w), ye.copy(he))
  }
  function ft(he) {
    oe.equals(he) === !1 && (n.viewport(he.x, he.y, he.z, he.w), oe.copy(he))
  }
  function Wt(he, rt) {
    let Ne = d.get(rt)
    Ne === void 0 && ((Ne = new WeakMap()), d.set(rt, Ne))
    let Ve = Ne.get(he)
    Ve === void 0 && ((Ve = n.getUniformBlockIndex(rt, he.name)), Ne.set(he, Ve))
  }
  function Nt(he, rt) {
    const Ve = d.get(rt).get(he)
    u.get(rt) !== Ve &&
      (n.uniformBlockBinding(rt, Ve, he.__bindingPointIndex), u.set(rt, Ve))
  }
  function dn() {
    n.disable(n.BLEND),
      n.disable(n.CULL_FACE),
      n.disable(n.DEPTH_TEST),
      n.disable(n.POLYGON_OFFSET_FILL),
      n.disable(n.SCISSOR_TEST),
      n.disable(n.STENCIL_TEST),
      n.disable(n.SAMPLE_ALPHA_TO_COVERAGE),
      n.blendEquation(n.FUNC_ADD),
      n.blendFunc(n.ONE, n.ZERO),
      n.blendFuncSeparate(n.ONE, n.ZERO, n.ONE, n.ZERO),
      n.blendColor(0, 0, 0, 0),
      n.colorMask(!0, !0, !0, !0),
      n.clearColor(0, 0, 0, 0),
      n.depthMask(!0),
      n.depthFunc(n.LESS),
      o.setReversed(!1),
      n.clearDepth(1),
      n.stencilMask(4294967295),
      n.stencilFunc(n.ALWAYS, 0, 4294967295),
      n.stencilOp(n.KEEP, n.KEEP, n.KEEP),
      n.clearStencil(0),
      n.cullFace(n.BACK),
      n.frontFace(n.CCW),
      n.polygonOffset(0, 0),
      n.activeTexture(n.TEXTURE0),
      n.bindFramebuffer(n.FRAMEBUFFER, null),
      n.bindFramebuffer(n.DRAW_FRAMEBUFFER, null),
      n.bindFramebuffer(n.READ_FRAMEBUFFER, null),
      n.useProgram(null),
      n.lineWidth(1),
      n.scissor(0, 0, n.canvas.width, n.canvas.height),
      n.viewport(0, 0, n.canvas.width, n.canvas.height),
      (p = {}),
      (ie = null),
      (Q = {}),
      (m = {}),
      (v = new WeakMap()),
      (y = []),
      (x = null),
      (E = !1),
      (M = null),
      (w = null),
      (A = null),
      (C = null),
      (R = null),
      (z = null),
      (U = null),
      (O = new ot(0, 0, 0)),
      (N = 0),
      (k = !1),
      (I = null),
      (V = null),
      (Z = null),
      ($ = null),
      (ee = null),
      ye.set(0, 0, n.canvas.width, n.canvas.height),
      oe.set(0, 0, n.canvas.width, n.canvas.height),
      s.reset(),
      o.reset(),
      l.reset()
  }
  return {
    buffers: { color: s, depth: o, stencil: l },
    enable: me,
    disable: Fe,
    bindFramebuffer: ze,
    drawBuffers: Ge,
    useProgram: Ue,
    setBlending: K,
    setMaterial: Ke,
    setFlipSided: Be,
    setCullFace: Oe,
    setLineWidth: Pe,
    setPolygonOffset: He,
    setScissorTest: Se,
    activeTexture: j,
    bindTexture: B,
    unbindTexture: ce,
    compressedTexImage2D: Me,
    compressedTexImage3D: De,
    texImage2D: Je,
    texImage3D: At,
    updateUBOMapping: Wt,
    uniformBlockBinding: Nt,
    texStorage2D: Et,
    texStorage3D: je,
    texSubImage2D: Ie,
    texSubImage3D: st,
    compressedTexSubImage2D: tt,
    compressedTexSubImage3D: it,
    scissor: Pt,
    viewport: ft,
    reset: dn,
  }
}
function PV(n, e) {
  const t = n.image && n.image.width ? n.image.width / n.image.height : 1
  return (
    t > e
      ? ((n.repeat.x = 1),
        (n.repeat.y = t / e),
        (n.offset.x = 0),
        (n.offset.y = (1 - n.repeat.y) / 2))
      : ((n.repeat.x = e / t),
        (n.repeat.y = 1),
        (n.offset.x = (1 - n.repeat.x) / 2),
        (n.offset.y = 0)),
    n
  )
}
function IV(n, e) {
  const t = n.image && n.image.width ? n.image.width / n.image.height : 1
  return (
    t > e
      ? ((n.repeat.x = e / t),
        (n.repeat.y = 1),
        (n.offset.x = (1 - n.repeat.x) / 2),
        (n.offset.y = 0))
      : ((n.repeat.x = 1),
        (n.repeat.y = t / e),
        (n.offset.x = 0),
        (n.offset.y = (1 - n.repeat.y) / 2)),
    n
  )
}
function LV(n) {
  return (n.repeat.x = 1), (n.repeat.y = 1), (n.offset.x = 0), (n.offset.y = 0), n
}
function b1(n, e, t, i) {
  const r = DV(i)
  switch (t) {
    case Rw:
      return n * e
    case Iw:
      return n * e
    case Lw:
      return n * e * 2
    case Kv:
      return ((n * e) / r.components) * r.byteLength
    case vm:
      return ((n * e) / r.components) * r.byteLength
    case Dw:
      return ((n * e * 2) / r.components) * r.byteLength
    case Zv:
      return ((n * e * 2) / r.components) * r.byteLength
    case Pw:
      return ((n * e * 3) / r.components) * r.byteLength
    case hr:
      return ((n * e * 4) / r.components) * r.byteLength
    case Jv:
      return ((n * e * 4) / r.components) * r.byteLength
    case bp:
    case Ap:
      return Math.floor((n + 3) / 4) * Math.floor((e + 3) / 4) * 8
    case Cp:
    case Rp:
      return Math.floor((n + 3) / 4) * Math.floor((e + 3) / 4) * 16
    case J0:
    case ev:
      return (Math.max(n, 16) * Math.max(e, 8)) / 4
    case Z0:
    case Q0:
      return (Math.max(n, 8) * Math.max(e, 8)) / 2
    case tv:
    case nv:
      return Math.floor((n + 3) / 4) * Math.floor((e + 3) / 4) * 8
    case iv:
      return Math.floor((n + 3) / 4) * Math.floor((e + 3) / 4) * 16
    case rv:
      return Math.floor((n + 3) / 4) * Math.floor((e + 3) / 4) * 16
    case sv:
      return Math.floor((n + 4) / 5) * Math.floor((e + 3) / 4) * 16
    case ov:
      return Math.floor((n + 4) / 5) * Math.floor((e + 4) / 5) * 16
    case av:
      return Math.floor((n + 5) / 6) * Math.floor((e + 4) / 5) * 16
    case lv:
      return Math.floor((n + 5) / 6) * Math.floor((e + 5) / 6) * 16
    case cv:
      return Math.floor((n + 7) / 8) * Math.floor((e + 4) / 5) * 16
    case uv:
      return Math.floor((n + 7) / 8) * Math.floor((e + 5) / 6) * 16
    case fv:
      return Math.floor((n + 7) / 8) * Math.floor((e + 7) / 8) * 16
    case dv:
      return Math.floor((n + 9) / 10) * Math.floor((e + 4) / 5) * 16
    case hv:
      return Math.floor((n + 9) / 10) * Math.floor((e + 5) / 6) * 16
    case pv:
      return Math.floor((n + 9) / 10) * Math.floor((e + 7) / 8) * 16
    case mv:
      return Math.floor((n + 9) / 10) * Math.floor((e + 9) / 10) * 16
    case gv:
      return Math.floor((n + 11) / 12) * Math.floor((e + 9) / 10) * 16
    case vv:
      return Math.floor((n + 11) / 12) * Math.floor((e + 11) / 12) * 16
    case Pp:
    case yv:
    case xv:
      return Math.ceil(n / 4) * Math.ceil(e / 4) * 16
    case Nw:
    case _v:
      return Math.ceil(n / 4) * Math.ceil(e / 4) * 8
    case wv:
    case Sv:
      return Math.ceil(n / 4) * Math.ceil(e / 4) * 16
  }
  throw new Error(`Unable to determine texture byte length for ${t} format.`)
}
function DV(n) {
  switch (n) {
    case wo:
    case bw:
      return { byteLength: 1, components: 1 }
    case Id:
    case Aw:
    case Gd:
      return { byteLength: 2, components: 1 }
    case qv:
    case $v:
      return { byteLength: 2, components: 4 }
    case Za:
    case Yv:
    case Qr:
      return { byteLength: 4, components: 1 }
    case Cw:
      return { byteLength: 4, components: 3 }
  }
  throw new Error(`Unknown texture type ${n}.`)
}
const NV = { contain: PV, cover: IV, fill: LV, getByteLength: b1 }
function kV(n, e, t, i, r, s, o) {
  const l = e.has("WEBGL_multisampled_render_to_texture")
      ? e.get("WEBGL_multisampled_render_to_texture")
      : null,
    u = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent),
    d = new We(),
    p = new WeakMap()
  let m
  const v = new WeakMap()
  let y = !1
  try {
    y =
      typeof OffscreenCanvas < "u" &&
      new OffscreenCanvas(1, 1).getContext("2d") !== null
  } catch {}
  function x(j, B) {
    return y ? new OffscreenCanvas(j, B) : Kp("canvas")
  }
  function E(j, B, ce) {
    let Me = 1
    const De = Se(j)
    if (
      ((De.width > ce || De.height > ce) && (Me = ce / Math.max(De.width, De.height)),
      Me < 1)
    )
      if (
        (typeof HTMLImageElement < "u" && j instanceof HTMLImageElement) ||
        (typeof HTMLCanvasElement < "u" && j instanceof HTMLCanvasElement) ||
        (typeof ImageBitmap < "u" && j instanceof ImageBitmap) ||
        (typeof VideoFrame < "u" && j instanceof VideoFrame)
      ) {
        const Ie = Math.floor(Me * De.width),
          st = Math.floor(Me * De.height)
        m === void 0 && (m = x(Ie, st))
        const tt = B ? x(Ie, st) : m
        return (
          (tt.width = Ie),
          (tt.height = st),
          tt.getContext("2d").drawImage(j, 0, 0, Ie, st),
          console.warn(
            "THREE.WebGLRenderer: Texture has been resized from (" +
              De.width +
              "x" +
              De.height +
              ") to (" +
              Ie +
              "x" +
              st +
              ").",
          ),
          tt
        )
      } else
        return (
          "data" in j &&
            console.warn(
              "THREE.WebGLRenderer: Image in DataTexture is too big (" +
                De.width +
                "x" +
                De.height +
                ").",
            ),
          j
        )
    return j
  }
  function M(j) {
    return j.generateMipmaps
  }
  function w(j) {
    n.generateMipmap(j)
  }
  function A(j) {
    return j.isWebGLCubeRenderTarget
      ? n.TEXTURE_CUBE_MAP
      : j.isWebGL3DRenderTarget
      ? n.TEXTURE_3D
      : j.isWebGLArrayRenderTarget || j.isCompressedArrayTexture
      ? n.TEXTURE_2D_ARRAY
      : n.TEXTURE_2D
  }
  function C(j, B, ce, Me, De = !1) {
    if (j !== null) {
      if (n[j] !== void 0) return n[j]
      console.warn(
        "THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" +
          j +
          "'",
      )
    }
    let Ie = B
    if (
      (B === n.RED &&
        (ce === n.FLOAT && (Ie = n.R32F),
        ce === n.HALF_FLOAT && (Ie = n.R16F),
        ce === n.UNSIGNED_BYTE && (Ie = n.R8)),
      B === n.RED_INTEGER &&
        (ce === n.UNSIGNED_BYTE && (Ie = n.R8UI),
        ce === n.UNSIGNED_SHORT && (Ie = n.R16UI),
        ce === n.UNSIGNED_INT && (Ie = n.R32UI),
        ce === n.BYTE && (Ie = n.R8I),
        ce === n.SHORT && (Ie = n.R16I),
        ce === n.INT && (Ie = n.R32I)),
      B === n.RG &&
        (ce === n.FLOAT && (Ie = n.RG32F),
        ce === n.HALF_FLOAT && (Ie = n.RG16F),
        ce === n.UNSIGNED_BYTE && (Ie = n.RG8)),
      B === n.RG_INTEGER &&
        (ce === n.UNSIGNED_BYTE && (Ie = n.RG8UI),
        ce === n.UNSIGNED_SHORT && (Ie = n.RG16UI),
        ce === n.UNSIGNED_INT && (Ie = n.RG32UI),
        ce === n.BYTE && (Ie = n.RG8I),
        ce === n.SHORT && (Ie = n.RG16I),
        ce === n.INT && (Ie = n.RG32I)),
      B === n.RGB_INTEGER &&
        (ce === n.UNSIGNED_BYTE && (Ie = n.RGB8UI),
        ce === n.UNSIGNED_SHORT && (Ie = n.RGB16UI),
        ce === n.UNSIGNED_INT && (Ie = n.RGB32UI),
        ce === n.BYTE && (Ie = n.RGB8I),
        ce === n.SHORT && (Ie = n.RGB16I),
        ce === n.INT && (Ie = n.RGB32I)),
      B === n.RGBA_INTEGER &&
        (ce === n.UNSIGNED_BYTE && (Ie = n.RGBA8UI),
        ce === n.UNSIGNED_SHORT && (Ie = n.RGBA16UI),
        ce === n.UNSIGNED_INT && (Ie = n.RGBA32UI),
        ce === n.BYTE && (Ie = n.RGBA8I),
        ce === n.SHORT && (Ie = n.RGBA16I),
        ce === n.INT && (Ie = n.RGBA32I)),
      B === n.RGB && ce === n.UNSIGNED_INT_5_9_9_9_REV && (Ie = n.RGB9_E5),
      B === n.RGBA)
    ) {
      const st = De ? ym : fn.getTransfer(Me)
      ce === n.FLOAT && (Ie = n.RGBA32F),
        ce === n.HALF_FLOAT && (Ie = n.RGBA16F),
        ce === n.UNSIGNED_BYTE && (Ie = st === Sn ? n.SRGB8_ALPHA8 : n.RGBA8),
        ce === n.UNSIGNED_SHORT_4_4_4_4 && (Ie = n.RGBA4),
        ce === n.UNSIGNED_SHORT_5_5_5_1 && (Ie = n.RGB5_A1)
    }
    return (
      (Ie === n.R16F ||
        Ie === n.R32F ||
        Ie === n.RG16F ||
        Ie === n.RG32F ||
        Ie === n.RGBA16F ||
        Ie === n.RGBA32F) &&
        e.get("EXT_color_buffer_float"),
      Ie
    )
  }
  function R(j, B) {
    let ce
    return (
      j
        ? B === null || B === Za || B === Du
          ? (ce = n.DEPTH24_STENCIL8)
          : B === Qr
          ? (ce = n.DEPTH32F_STENCIL8)
          : B === Id &&
            ((ce = n.DEPTH24_STENCIL8),
            console.warn(
              "DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.",
            ))
        : B === null || B === Za || B === Du
        ? (ce = n.DEPTH_COMPONENT24)
        : B === Qr
        ? (ce = n.DEPTH_COMPONENT32F)
        : B === Id && (ce = n.DEPTH_COMPONENT16),
      ce
    )
  }
  function z(j, B) {
    return M(j) === !0 ||
      (j.isFramebufferTexture && j.minFilter !== Qi && j.minFilter !== Ri)
      ? Math.log2(Math.max(B.width, B.height)) + 1
      : j.mipmaps !== void 0 && j.mipmaps.length > 0
      ? j.mipmaps.length
      : j.isCompressedTexture && Array.isArray(j.image)
      ? B.mipmaps.length
      : 1
  }
  function U(j) {
    const B = j.target
    B.removeEventListener("dispose", U), N(B), B.isVideoTexture && p.delete(B)
  }
  function O(j) {
    const B = j.target
    B.removeEventListener("dispose", O), I(B)
  }
  function N(j) {
    const B = i.get(j)
    if (B.__webglInit === void 0) return
    const ce = j.source,
      Me = v.get(ce)
    if (Me) {
      const De = Me[B.__cacheKey]
      De.usedTimes--,
        De.usedTimes === 0 && k(j),
        Object.keys(Me).length === 0 && v.delete(ce)
    }
    i.remove(j)
  }
  function k(j) {
    const B = i.get(j)
    n.deleteTexture(B.__webglTexture)
    const ce = j.source,
      Me = v.get(ce)
    delete Me[B.__cacheKey], o.memory.textures--
  }
  function I(j) {
    const B = i.get(j)
    if (
      (j.depthTexture && (j.depthTexture.dispose(), i.remove(j.depthTexture)),
      j.isWebGLCubeRenderTarget)
    )
      for (let Me = 0; Me < 6; Me++) {
        if (Array.isArray(B.__webglFramebuffer[Me]))
          for (let De = 0; De < B.__webglFramebuffer[Me].length; De++)
            n.deleteFramebuffer(B.__webglFramebuffer[Me][De])
        else n.deleteFramebuffer(B.__webglFramebuffer[Me])
        B.__webglDepthbuffer && n.deleteRenderbuffer(B.__webglDepthbuffer[Me])
      }
    else {
      if (Array.isArray(B.__webglFramebuffer))
        for (let Me = 0; Me < B.__webglFramebuffer.length; Me++)
          n.deleteFramebuffer(B.__webglFramebuffer[Me])
      else n.deleteFramebuffer(B.__webglFramebuffer)
      if (
        (B.__webglDepthbuffer && n.deleteRenderbuffer(B.__webglDepthbuffer),
        B.__webglMultisampledFramebuffer &&
          n.deleteFramebuffer(B.__webglMultisampledFramebuffer),
        B.__webglColorRenderbuffer)
      )
        for (let Me = 0; Me < B.__webglColorRenderbuffer.length; Me++)
          B.__webglColorRenderbuffer[Me] &&
            n.deleteRenderbuffer(B.__webglColorRenderbuffer[Me])
      B.__webglDepthRenderbuffer && n.deleteRenderbuffer(B.__webglDepthRenderbuffer)
    }
    const ce = j.textures
    for (let Me = 0, De = ce.length; Me < De; Me++) {
      const Ie = i.get(ce[Me])
      Ie.__webglTexture && (n.deleteTexture(Ie.__webglTexture), o.memory.textures--),
        i.remove(ce[Me])
    }
    i.remove(j)
  }
  let V = 0
  function Z() {
    V = 0
  }
  function $() {
    const j = V
    return (
      j >= r.maxTextures &&
        console.warn(
          "THREE.WebGLTextures: Trying to use " +
            j +
            " texture units while this GPU supports only " +
            r.maxTextures,
        ),
      (V += 1),
      j
    )
  }
  function ee(j) {
    const B = []
    return (
      B.push(j.wrapS),
      B.push(j.wrapT),
      B.push(j.wrapR || 0),
      B.push(j.magFilter),
      B.push(j.minFilter),
      B.push(j.anisotropy),
      B.push(j.internalFormat),
      B.push(j.format),
      B.push(j.type),
      B.push(j.generateMipmaps),
      B.push(j.premultiplyAlpha),
      B.push(j.flipY),
      B.push(j.unpackAlignment),
      B.push(j.colorSpace),
      B.join()
    )
  }
  function ue(j, B) {
    const ce = i.get(j)
    if (
      (j.isVideoTexture && Pe(j),
      j.isRenderTargetTexture === !1 && j.version > 0 && ce.__version !== j.version)
    ) {
      const Me = j.image
      if (Me === null)
        console.warn(
          "THREE.WebGLRenderer: Texture marked for update but no image data found.",
        )
      else if (Me.complete === !1)
        console.warn(
          "THREE.WebGLRenderer: Texture marked for update but image is incomplete",
        )
      else {
        oe(ce, j, B)
        return
      }
    }
    t.bindTexture(n.TEXTURE_2D, ce.__webglTexture, n.TEXTURE0 + B)
  }
  function re(j, B) {
    const ce = i.get(j)
    if (j.version > 0 && ce.__version !== j.version) {
      oe(ce, j, B)
      return
    }
    t.bindTexture(n.TEXTURE_2D_ARRAY, ce.__webglTexture, n.TEXTURE0 + B)
  }
  function se(j, B) {
    const ce = i.get(j)
    if (j.version > 0 && ce.__version !== j.version) {
      oe(ce, j, B)
      return
    }
    t.bindTexture(n.TEXTURE_3D, ce.__webglTexture, n.TEXTURE0 + B)
  }
  function G(j, B) {
    const ce = i.get(j)
    if (j.version > 0 && ce.__version !== j.version) {
      fe(ce, j, B)
      return
    }
    t.bindTexture(n.TEXTURE_CUBE_MAP, ce.__webglTexture, n.TEXTURE0 + B)
  }
  const ie = { [Lu]: n.REPEAT, [Jr]: n.CLAMP_TO_EDGE, [jp]: n.MIRRORED_REPEAT },
    Q = {
      [Qi]: n.NEAREST,
      [Tw]: n.NEAREST_MIPMAP_NEAREST,
      [wd]: n.NEAREST_MIPMAP_LINEAR,
      [Ri]: n.LINEAR,
      [Tp]: n.LINEAR_MIPMAP_NEAREST,
      [Ho]: n.LINEAR_MIPMAP_LINEAR,
    },
    W = {
      [o3]: n.NEVER,
      [d3]: n.ALWAYS,
      [a3]: n.LESS,
      [Fw]: n.LEQUAL,
      [l3]: n.EQUAL,
      [f3]: n.GEQUAL,
      [c3]: n.GREATER,
      [u3]: n.NOTEQUAL,
    }
  function ne(j, B) {
    if (
      (B.type === Qr &&
        e.has("OES_texture_float_linear") === !1 &&
        (B.magFilter === Ri ||
          B.magFilter === Tp ||
          B.magFilter === wd ||
          B.magFilter === Ho ||
          B.minFilter === Ri ||
          B.minFilter === Tp ||
          B.minFilter === wd ||
          B.minFilter === Ho) &&
        console.warn(
          "THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.",
        ),
      n.texParameteri(j, n.TEXTURE_WRAP_S, ie[B.wrapS]),
      n.texParameteri(j, n.TEXTURE_WRAP_T, ie[B.wrapT]),
      (j === n.TEXTURE_3D || j === n.TEXTURE_2D_ARRAY) &&
        n.texParameteri(j, n.TEXTURE_WRAP_R, ie[B.wrapR]),
      n.texParameteri(j, n.TEXTURE_MAG_FILTER, Q[B.magFilter]),
      n.texParameteri(j, n.TEXTURE_MIN_FILTER, Q[B.minFilter]),
      B.compareFunction &&
        (n.texParameteri(j, n.TEXTURE_COMPARE_MODE, n.COMPARE_REF_TO_TEXTURE),
        n.texParameteri(j, n.TEXTURE_COMPARE_FUNC, W[B.compareFunction])),
      e.has("EXT_texture_filter_anisotropic") === !0)
    ) {
      if (
        B.magFilter === Qi ||
        (B.minFilter !== wd && B.minFilter !== Ho) ||
        (B.type === Qr && e.has("OES_texture_float_linear") === !1)
      )
        return
      if (B.anisotropy > 1 || i.get(B).__currentAnisotropy) {
        const ce = e.get("EXT_texture_filter_anisotropic")
        n.texParameterf(
          j,
          ce.TEXTURE_MAX_ANISOTROPY_EXT,
          Math.min(B.anisotropy, r.getMaxAnisotropy()),
        ),
          (i.get(B).__currentAnisotropy = B.anisotropy)
      }
    }
  }
  function ye(j, B) {
    let ce = !1
    j.__webglInit === void 0 && ((j.__webglInit = !0), B.addEventListener("dispose", U))
    const Me = B.source
    let De = v.get(Me)
    De === void 0 && ((De = {}), v.set(Me, De))
    const Ie = ee(B)
    if (Ie !== j.__cacheKey) {
      De[Ie] === void 0 &&
        ((De[Ie] = { texture: n.createTexture(), usedTimes: 0 }),
        o.memory.textures++,
        (ce = !0)),
        De[Ie].usedTimes++
      const st = De[j.__cacheKey]
      st !== void 0 && (De[j.__cacheKey].usedTimes--, st.usedTimes === 0 && k(B)),
        (j.__cacheKey = Ie),
        (j.__webglTexture = De[Ie].texture)
    }
    return ce
  }
  function oe(j, B, ce) {
    let Me = n.TEXTURE_2D
    ;(B.isDataArrayTexture || B.isCompressedArrayTexture) && (Me = n.TEXTURE_2D_ARRAY),
      B.isData3DTexture && (Me = n.TEXTURE_3D)
    const De = ye(j, B),
      Ie = B.source
    t.bindTexture(Me, j.__webglTexture, n.TEXTURE0 + ce)
    const st = i.get(Ie)
    if (Ie.version !== st.__version || De === !0) {
      t.activeTexture(n.TEXTURE0 + ce)
      const tt = fn.getPrimaries(fn.workingColorSpace),
        it = B.colorSpace === za ? null : fn.getPrimaries(B.colorSpace),
        Et = B.colorSpace === za || tt === it ? n.NONE : n.BROWSER_DEFAULT_WEBGL
      n.pixelStorei(n.UNPACK_FLIP_Y_WEBGL, B.flipY),
        n.pixelStorei(n.UNPACK_PREMULTIPLY_ALPHA_WEBGL, B.premultiplyAlpha),
        n.pixelStorei(n.UNPACK_ALIGNMENT, B.unpackAlignment),
        n.pixelStorei(n.UNPACK_COLORSPACE_CONVERSION_WEBGL, Et)
      let je = E(B.image, !1, r.maxTextureSize)
      je = He(B, je)
      const Je = s.convert(B.format, B.colorSpace),
        At = s.convert(B.type)
      let Pt = C(B.internalFormat, Je, At, B.colorSpace, B.isVideoTexture)
      ne(Me, B)
      let ft
      const Wt = B.mipmaps,
        Nt = B.isVideoTexture !== !0,
        dn = st.__version === void 0 || De === !0,
        he = Ie.dataReady,
        rt = z(B, je)
      if (B.isDepthTexture)
        (Pt = R(B.format === Nu, B.type)),
          dn &&
            (Nt
              ? t.texStorage2D(n.TEXTURE_2D, 1, Pt, je.width, je.height)
              : t.texImage2D(n.TEXTURE_2D, 0, Pt, je.width, je.height, 0, Je, At, null))
      else if (B.isDataTexture)
        if (Wt.length > 0) {
          Nt && dn && t.texStorage2D(n.TEXTURE_2D, rt, Pt, Wt[0].width, Wt[0].height)
          for (let Ne = 0, Ve = Wt.length; Ne < Ve; Ne++)
            (ft = Wt[Ne]),
              Nt
                ? he &&
                  t.texSubImage2D(
                    n.TEXTURE_2D,
                    Ne,
                    0,
                    0,
                    ft.width,
                    ft.height,
                    Je,
                    At,
                    ft.data,
                  )
                : t.texImage2D(
                    n.TEXTURE_2D,
                    Ne,
                    Pt,
                    ft.width,
                    ft.height,
                    0,
                    Je,
                    At,
                    ft.data,
                  )
          B.generateMipmaps = !1
        } else
          Nt
            ? (dn && t.texStorage2D(n.TEXTURE_2D, rt, Pt, je.width, je.height),
              he &&
                t.texSubImage2D(
                  n.TEXTURE_2D,
                  0,
                  0,
                  0,
                  je.width,
                  je.height,
                  Je,
                  At,
                  je.data,
                ))
            : t.texImage2D(n.TEXTURE_2D, 0, Pt, je.width, je.height, 0, Je, At, je.data)
      else if (B.isCompressedTexture)
        if (B.isCompressedArrayTexture) {
          Nt &&
            dn &&
            t.texStorage3D(
              n.TEXTURE_2D_ARRAY,
              rt,
              Pt,
              Wt[0].width,
              Wt[0].height,
              je.depth,
            )
          for (let Ne = 0, Ve = Wt.length; Ne < Ve; Ne++)
            if (((ft = Wt[Ne]), B.format !== hr))
              if (Je !== null)
                if (Nt) {
                  if (he)
                    if (B.layerUpdates.size > 0) {
                      const lt = b1(ft.width, ft.height, B.format, B.type)
                      for (const at of B.layerUpdates) {
                        const Ut = ft.data.subarray(
                          (at * lt) / ft.data.BYTES_PER_ELEMENT,
                          ((at + 1) * lt) / ft.data.BYTES_PER_ELEMENT,
                        )
                        t.compressedTexSubImage3D(
                          n.TEXTURE_2D_ARRAY,
                          Ne,
                          0,
                          0,
                          at,
                          ft.width,
                          ft.height,
                          1,
                          Je,
                          Ut,
                        )
                      }
                      B.clearLayerUpdates()
                    } else
                      t.compressedTexSubImage3D(
                        n.TEXTURE_2D_ARRAY,
                        Ne,
                        0,
                        0,
                        0,
                        ft.width,
                        ft.height,
                        je.depth,
                        Je,
                        ft.data,
                      )
                } else
                  t.compressedTexImage3D(
                    n.TEXTURE_2D_ARRAY,
                    Ne,
                    Pt,
                    ft.width,
                    ft.height,
                    je.depth,
                    0,
                    ft.data,
                    0,
                    0,
                  )
              else
                console.warn(
                  "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()",
                )
            else
              Nt
                ? he &&
                  t.texSubImage3D(
                    n.TEXTURE_2D_ARRAY,
                    Ne,
                    0,
                    0,
                    0,
                    ft.width,
                    ft.height,
                    je.depth,
                    Je,
                    At,
                    ft.data,
                  )
                : t.texImage3D(
                    n.TEXTURE_2D_ARRAY,
                    Ne,
                    Pt,
                    ft.width,
                    ft.height,
                    je.depth,
                    0,
                    Je,
                    At,
                    ft.data,
                  )
        } else {
          Nt && dn && t.texStorage2D(n.TEXTURE_2D, rt, Pt, Wt[0].width, Wt[0].height)
          for (let Ne = 0, Ve = Wt.length; Ne < Ve; Ne++)
            (ft = Wt[Ne]),
              B.format !== hr
                ? Je !== null
                  ? Nt
                    ? he &&
                      t.compressedTexSubImage2D(
                        n.TEXTURE_2D,
                        Ne,
                        0,
                        0,
                        ft.width,
                        ft.height,
                        Je,
                        ft.data,
                      )
                    : t.compressedTexImage2D(
                        n.TEXTURE_2D,
                        Ne,
                        Pt,
                        ft.width,
                        ft.height,
                        0,
                        ft.data,
                      )
                  : console.warn(
                      "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()",
                    )
                : Nt
                ? he &&
                  t.texSubImage2D(
                    n.TEXTURE_2D,
                    Ne,
                    0,
                    0,
                    ft.width,
                    ft.height,
                    Je,
                    At,
                    ft.data,
                  )
                : t.texImage2D(
                    n.TEXTURE_2D,
                    Ne,
                    Pt,
                    ft.width,
                    ft.height,
                    0,
                    Je,
                    At,
                    ft.data,
                  )
        }
      else if (B.isDataArrayTexture)
        if (Nt) {
          if (
            (dn &&
              t.texStorage3D(n.TEXTURE_2D_ARRAY, rt, Pt, je.width, je.height, je.depth),
            he)
          )
            if (B.layerUpdates.size > 0) {
              const Ne = b1(je.width, je.height, B.format, B.type)
              for (const Ve of B.layerUpdates) {
                const lt = je.data.subarray(
                  (Ve * Ne) / je.data.BYTES_PER_ELEMENT,
                  ((Ve + 1) * Ne) / je.data.BYTES_PER_ELEMENT,
                )
                t.texSubImage3D(
                  n.TEXTURE_2D_ARRAY,
                  0,
                  0,
                  0,
                  Ve,
                  je.width,
                  je.height,
                  1,
                  Je,
                  At,
                  lt,
                )
              }
              B.clearLayerUpdates()
            } else
              t.texSubImage3D(
                n.TEXTURE_2D_ARRAY,
                0,
                0,
                0,
                0,
                je.width,
                je.height,
                je.depth,
                Je,
                At,
                je.data,
              )
        } else
          t.texImage3D(
            n.TEXTURE_2D_ARRAY,
            0,
            Pt,
            je.width,
            je.height,
            je.depth,
            0,
            Je,
            At,
            je.data,
          )
      else if (B.isData3DTexture)
        Nt
          ? (dn && t.texStorage3D(n.TEXTURE_3D, rt, Pt, je.width, je.height, je.depth),
            he &&
              t.texSubImage3D(
                n.TEXTURE_3D,
                0,
                0,
                0,
                0,
                je.width,
                je.height,
                je.depth,
                Je,
                At,
                je.data,
              ))
          : t.texImage3D(
              n.TEXTURE_3D,
              0,
              Pt,
              je.width,
              je.height,
              je.depth,
              0,
              Je,
              At,
              je.data,
            )
      else if (B.isFramebufferTexture) {
        if (dn)
          if (Nt) t.texStorage2D(n.TEXTURE_2D, rt, Pt, je.width, je.height)
          else {
            let Ne = je.width,
              Ve = je.height
            for (let lt = 0; lt < rt; lt++)
              t.texImage2D(n.TEXTURE_2D, lt, Pt, Ne, Ve, 0, Je, At, null),
                (Ne >>= 1),
                (Ve >>= 1)
          }
      } else if (Wt.length > 0) {
        if (Nt && dn) {
          const Ne = Se(Wt[0])
          t.texStorage2D(n.TEXTURE_2D, rt, Pt, Ne.width, Ne.height)
        }
        for (let Ne = 0, Ve = Wt.length; Ne < Ve; Ne++)
          (ft = Wt[Ne]),
            Nt
              ? he && t.texSubImage2D(n.TEXTURE_2D, Ne, 0, 0, Je, At, ft)
              : t.texImage2D(n.TEXTURE_2D, Ne, Pt, Je, At, ft)
        B.generateMipmaps = !1
      } else if (Nt) {
        if (dn) {
          const Ne = Se(je)
          t.texStorage2D(n.TEXTURE_2D, rt, Pt, Ne.width, Ne.height)
        }
        he && t.texSubImage2D(n.TEXTURE_2D, 0, 0, 0, Je, At, je)
      } else t.texImage2D(n.TEXTURE_2D, 0, Pt, Je, At, je)
      M(B) && w(Me), (st.__version = Ie.version), B.onUpdate && B.onUpdate(B)
    }
    j.__version = B.version
  }
  function fe(j, B, ce) {
    if (B.image.length !== 6) return
    const Me = ye(j, B),
      De = B.source
    t.bindTexture(n.TEXTURE_CUBE_MAP, j.__webglTexture, n.TEXTURE0 + ce)
    const Ie = i.get(De)
    if (De.version !== Ie.__version || Me === !0) {
      t.activeTexture(n.TEXTURE0 + ce)
      const st = fn.getPrimaries(fn.workingColorSpace),
        tt = B.colorSpace === za ? null : fn.getPrimaries(B.colorSpace),
        it = B.colorSpace === za || st === tt ? n.NONE : n.BROWSER_DEFAULT_WEBGL
      n.pixelStorei(n.UNPACK_FLIP_Y_WEBGL, B.flipY),
        n.pixelStorei(n.UNPACK_PREMULTIPLY_ALPHA_WEBGL, B.premultiplyAlpha),
        n.pixelStorei(n.UNPACK_ALIGNMENT, B.unpackAlignment),
        n.pixelStorei(n.UNPACK_COLORSPACE_CONVERSION_WEBGL, it)
      const Et = B.isCompressedTexture || B.image[0].isCompressedTexture,
        je = B.image[0] && B.image[0].isDataTexture,
        Je = []
      for (let Ve = 0; Ve < 6; Ve++)
        !Et && !je
          ? (Je[Ve] = E(B.image[Ve], !0, r.maxCubemapSize))
          : (Je[Ve] = je ? B.image[Ve].image : B.image[Ve]),
          (Je[Ve] = He(B, Je[Ve]))
      const At = Je[0],
        Pt = s.convert(B.format, B.colorSpace),
        ft = s.convert(B.type),
        Wt = C(B.internalFormat, Pt, ft, B.colorSpace),
        Nt = B.isVideoTexture !== !0,
        dn = Ie.__version === void 0 || Me === !0,
        he = De.dataReady
      let rt = z(B, At)
      ne(n.TEXTURE_CUBE_MAP, B)
      let Ne
      if (Et) {
        Nt && dn && t.texStorage2D(n.TEXTURE_CUBE_MAP, rt, Wt, At.width, At.height)
        for (let Ve = 0; Ve < 6; Ve++) {
          Ne = Je[Ve].mipmaps
          for (let lt = 0; lt < Ne.length; lt++) {
            const at = Ne[lt]
            B.format !== hr
              ? Pt !== null
                ? Nt
                  ? he &&
                    t.compressedTexSubImage2D(
                      n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                      lt,
                      0,
                      0,
                      at.width,
                      at.height,
                      Pt,
                      at.data,
                    )
                  : t.compressedTexImage2D(
                      n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                      lt,
                      Wt,
                      at.width,
                      at.height,
                      0,
                      at.data,
                    )
                : console.warn(
                    "THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()",
                  )
              : Nt
              ? he &&
                t.texSubImage2D(
                  n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                  lt,
                  0,
                  0,
                  at.width,
                  at.height,
                  Pt,
                  ft,
                  at.data,
                )
              : t.texImage2D(
                  n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                  lt,
                  Wt,
                  at.width,
                  at.height,
                  0,
                  Pt,
                  ft,
                  at.data,
                )
          }
        }
      } else {
        if (((Ne = B.mipmaps), Nt && dn)) {
          Ne.length > 0 && rt++
          const Ve = Se(Je[0])
          t.texStorage2D(n.TEXTURE_CUBE_MAP, rt, Wt, Ve.width, Ve.height)
        }
        for (let Ve = 0; Ve < 6; Ve++)
          if (je) {
            Nt
              ? he &&
                t.texSubImage2D(
                  n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                  0,
                  0,
                  0,
                  Je[Ve].width,
                  Je[Ve].height,
                  Pt,
                  ft,
                  Je[Ve].data,
                )
              : t.texImage2D(
                  n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                  0,
                  Wt,
                  Je[Ve].width,
                  Je[Ve].height,
                  0,
                  Pt,
                  ft,
                  Je[Ve].data,
                )
            for (let lt = 0; lt < Ne.length; lt++) {
              const Ut = Ne[lt].image[Ve].image
              Nt
                ? he &&
                  t.texSubImage2D(
                    n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                    lt + 1,
                    0,
                    0,
                    Ut.width,
                    Ut.height,
                    Pt,
                    ft,
                    Ut.data,
                  )
                : t.texImage2D(
                    n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                    lt + 1,
                    Wt,
                    Ut.width,
                    Ut.height,
                    0,
                    Pt,
                    ft,
                    Ut.data,
                  )
            }
          } else {
            Nt
              ? he &&
                t.texSubImage2D(
                  n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                  0,
                  0,
                  0,
                  Pt,
                  ft,
                  Je[Ve],
                )
              : t.texImage2D(n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve, 0, Wt, Pt, ft, Je[Ve])
            for (let lt = 0; lt < Ne.length; lt++) {
              const at = Ne[lt]
              Nt
                ? he &&
                  t.texSubImage2D(
                    n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                    lt + 1,
                    0,
                    0,
                    Pt,
                    ft,
                    at.image[Ve],
                  )
                : t.texImage2D(
                    n.TEXTURE_CUBE_MAP_POSITIVE_X + Ve,
                    lt + 1,
                    Wt,
                    Pt,
                    ft,
                    at.image[Ve],
                  )
            }
          }
      }
      M(B) && w(n.TEXTURE_CUBE_MAP),
        (Ie.__version = De.version),
        B.onUpdate && B.onUpdate(B)
    }
    j.__version = B.version
  }
  function we(j, B, ce, Me, De, Ie) {
    const st = s.convert(ce.format, ce.colorSpace),
      tt = s.convert(ce.type),
      it = C(ce.internalFormat, st, tt, ce.colorSpace),
      Et = i.get(B),
      je = i.get(ce)
    if (((je.__renderTarget = B), !Et.__hasExternalTextures)) {
      const Je = Math.max(1, B.width >> Ie),
        At = Math.max(1, B.height >> Ie)
      De === n.TEXTURE_3D || De === n.TEXTURE_2D_ARRAY
        ? t.texImage3D(De, Ie, it, Je, At, B.depth, 0, st, tt, null)
        : t.texImage2D(De, Ie, it, Je, At, 0, st, tt, null)
    }
    t.bindFramebuffer(n.FRAMEBUFFER, j),
      Oe(B)
        ? l.framebufferTexture2DMultisampleEXT(
            n.FRAMEBUFFER,
            Me,
            De,
            je.__webglTexture,
            0,
            Be(B),
          )
        : (De === n.TEXTURE_2D ||
            (De >= n.TEXTURE_CUBE_MAP_POSITIVE_X &&
              De <= n.TEXTURE_CUBE_MAP_NEGATIVE_Z)) &&
          n.framebufferTexture2D(n.FRAMEBUFFER, Me, De, je.__webglTexture, Ie),
      t.bindFramebuffer(n.FRAMEBUFFER, null)
  }
  function me(j, B, ce) {
    if ((n.bindRenderbuffer(n.RENDERBUFFER, j), B.depthBuffer)) {
      const Me = B.depthTexture,
        De = Me && Me.isDepthTexture ? Me.type : null,
        Ie = R(B.stencilBuffer, De),
        st = B.stencilBuffer ? n.DEPTH_STENCIL_ATTACHMENT : n.DEPTH_ATTACHMENT,
        tt = Be(B)
      Oe(B)
        ? l.renderbufferStorageMultisampleEXT(n.RENDERBUFFER, tt, Ie, B.width, B.height)
        : ce
        ? n.renderbufferStorageMultisample(n.RENDERBUFFER, tt, Ie, B.width, B.height)
        : n.renderbufferStorage(n.RENDERBUFFER, Ie, B.width, B.height),
        n.framebufferRenderbuffer(n.FRAMEBUFFER, st, n.RENDERBUFFER, j)
    } else {
      const Me = B.textures
      for (let De = 0; De < Me.length; De++) {
        const Ie = Me[De],
          st = s.convert(Ie.format, Ie.colorSpace),
          tt = s.convert(Ie.type),
          it = C(Ie.internalFormat, st, tt, Ie.colorSpace),
          Et = Be(B)
        ce && Oe(B) === !1
          ? n.renderbufferStorageMultisample(n.RENDERBUFFER, Et, it, B.width, B.height)
          : Oe(B)
          ? l.renderbufferStorageMultisampleEXT(
              n.RENDERBUFFER,
              Et,
              it,
              B.width,
              B.height,
            )
          : n.renderbufferStorage(n.RENDERBUFFER, it, B.width, B.height)
      }
    }
    n.bindRenderbuffer(n.RENDERBUFFER, null)
  }
  function Fe(j, B) {
    if (B && B.isWebGLCubeRenderTarget)
      throw new Error("Depth Texture with cube render targets is not supported")
    if (
      (t.bindFramebuffer(n.FRAMEBUFFER, j),
      !(B.depthTexture && B.depthTexture.isDepthTexture))
    )
      throw new Error(
        "renderTarget.depthTexture must be an instance of THREE.DepthTexture",
      )
    const Me = i.get(B.depthTexture)
    ;(Me.__renderTarget = B),
      (!Me.__webglTexture ||
        B.depthTexture.image.width !== B.width ||
        B.depthTexture.image.height !== B.height) &&
        ((B.depthTexture.image.width = B.width),
        (B.depthTexture.image.height = B.height),
        (B.depthTexture.needsUpdate = !0)),
      ue(B.depthTexture, 0)
    const De = Me.__webglTexture,
      Ie = Be(B)
    if (B.depthTexture.format === Tu)
      Oe(B)
        ? l.framebufferTexture2DMultisampleEXT(
            n.FRAMEBUFFER,
            n.DEPTH_ATTACHMENT,
            n.TEXTURE_2D,
            De,
            0,
            Ie,
          )
        : n.framebufferTexture2D(n.FRAMEBUFFER, n.DEPTH_ATTACHMENT, n.TEXTURE_2D, De, 0)
    else if (B.depthTexture.format === Nu)
      Oe(B)
        ? l.framebufferTexture2DMultisampleEXT(
            n.FRAMEBUFFER,
            n.DEPTH_STENCIL_ATTACHMENT,
            n.TEXTURE_2D,
            De,
            0,
            Ie,
          )
        : n.framebufferTexture2D(
            n.FRAMEBUFFER,
            n.DEPTH_STENCIL_ATTACHMENT,
            n.TEXTURE_2D,
            De,
            0,
          )
    else throw new Error("Unknown depthTexture format")
  }
  function ze(j) {
    const B = i.get(j),
      ce = j.isWebGLCubeRenderTarget === !0
    if (B.__boundDepthTexture !== j.depthTexture) {
      const Me = j.depthTexture
      if ((B.__depthDisposeCallback && B.__depthDisposeCallback(), Me)) {
        const De = () => {
          delete B.__boundDepthTexture,
            delete B.__depthDisposeCallback,
            Me.removeEventListener("dispose", De)
        }
        Me.addEventListener("dispose", De), (B.__depthDisposeCallback = De)
      }
      B.__boundDepthTexture = Me
    }
    if (j.depthTexture && !B.__autoAllocateDepthBuffer) {
      if (ce)
        throw new Error("target.depthTexture not supported in Cube render targets")
      Fe(B.__webglFramebuffer, j)
    } else if (ce) {
      B.__webglDepthbuffer = []
      for (let Me = 0; Me < 6; Me++)
        if (
          (t.bindFramebuffer(n.FRAMEBUFFER, B.__webglFramebuffer[Me]),
          B.__webglDepthbuffer[Me] === void 0)
        )
          (B.__webglDepthbuffer[Me] = n.createRenderbuffer()),
            me(B.__webglDepthbuffer[Me], j, !1)
        else {
          const De = j.stencilBuffer ? n.DEPTH_STENCIL_ATTACHMENT : n.DEPTH_ATTACHMENT,
            Ie = B.__webglDepthbuffer[Me]
          n.bindRenderbuffer(n.RENDERBUFFER, Ie),
            n.framebufferRenderbuffer(n.FRAMEBUFFER, De, n.RENDERBUFFER, Ie)
        }
    } else if (
      (t.bindFramebuffer(n.FRAMEBUFFER, B.__webglFramebuffer),
      B.__webglDepthbuffer === void 0)
    )
      (B.__webglDepthbuffer = n.createRenderbuffer()), me(B.__webglDepthbuffer, j, !1)
    else {
      const Me = j.stencilBuffer ? n.DEPTH_STENCIL_ATTACHMENT : n.DEPTH_ATTACHMENT,
        De = B.__webglDepthbuffer
      n.bindRenderbuffer(n.RENDERBUFFER, De),
        n.framebufferRenderbuffer(n.FRAMEBUFFER, Me, n.RENDERBUFFER, De)
    }
    t.bindFramebuffer(n.FRAMEBUFFER, null)
  }
  function Ge(j, B, ce) {
    const Me = i.get(j)
    B !== void 0 &&
      we(Me.__webglFramebuffer, j, j.texture, n.COLOR_ATTACHMENT0, n.TEXTURE_2D, 0),
      ce !== void 0 && ze(j)
  }
  function Ue(j) {
    const B = j.texture,
      ce = i.get(j),
      Me = i.get(B)
    j.addEventListener("dispose", O)
    const De = j.textures,
      Ie = j.isWebGLCubeRenderTarget === !0,
      st = De.length > 1
    if (
      (st ||
        (Me.__webglTexture === void 0 && (Me.__webglTexture = n.createTexture()),
        (Me.__version = B.version),
        o.memory.textures++),
      Ie)
    ) {
      ce.__webglFramebuffer = []
      for (let tt = 0; tt < 6; tt++)
        if (B.mipmaps && B.mipmaps.length > 0) {
          ce.__webglFramebuffer[tt] = []
          for (let it = 0; it < B.mipmaps.length; it++)
            ce.__webglFramebuffer[tt][it] = n.createFramebuffer()
        } else ce.__webglFramebuffer[tt] = n.createFramebuffer()
    } else {
      if (B.mipmaps && B.mipmaps.length > 0) {
        ce.__webglFramebuffer = []
        for (let tt = 0; tt < B.mipmaps.length; tt++)
          ce.__webglFramebuffer[tt] = n.createFramebuffer()
      } else ce.__webglFramebuffer = n.createFramebuffer()
      if (st)
        for (let tt = 0, it = De.length; tt < it; tt++) {
          const Et = i.get(De[tt])
          Et.__webglTexture === void 0 &&
            ((Et.__webglTexture = n.createTexture()), o.memory.textures++)
        }
      if (j.samples > 0 && Oe(j) === !1) {
        ;(ce.__webglMultisampledFramebuffer = n.createFramebuffer()),
          (ce.__webglColorRenderbuffer = []),
          t.bindFramebuffer(n.FRAMEBUFFER, ce.__webglMultisampledFramebuffer)
        for (let tt = 0; tt < De.length; tt++) {
          const it = De[tt]
          ;(ce.__webglColorRenderbuffer[tt] = n.createRenderbuffer()),
            n.bindRenderbuffer(n.RENDERBUFFER, ce.__webglColorRenderbuffer[tt])
          const Et = s.convert(it.format, it.colorSpace),
            je = s.convert(it.type),
            Je = C(it.internalFormat, Et, je, it.colorSpace, j.isXRRenderTarget === !0),
            At = Be(j)
          n.renderbufferStorageMultisample(n.RENDERBUFFER, At, Je, j.width, j.height),
            n.framebufferRenderbuffer(
              n.FRAMEBUFFER,
              n.COLOR_ATTACHMENT0 + tt,
              n.RENDERBUFFER,
              ce.__webglColorRenderbuffer[tt],
            )
        }
        n.bindRenderbuffer(n.RENDERBUFFER, null),
          j.depthBuffer &&
            ((ce.__webglDepthRenderbuffer = n.createRenderbuffer()),
            me(ce.__webglDepthRenderbuffer, j, !0)),
          t.bindFramebuffer(n.FRAMEBUFFER, null)
      }
    }
    if (Ie) {
      t.bindTexture(n.TEXTURE_CUBE_MAP, Me.__webglTexture), ne(n.TEXTURE_CUBE_MAP, B)
      for (let tt = 0; tt < 6; tt++)
        if (B.mipmaps && B.mipmaps.length > 0)
          for (let it = 0; it < B.mipmaps.length; it++)
            we(
              ce.__webglFramebuffer[tt][it],
              j,
              B,
              n.COLOR_ATTACHMENT0,
              n.TEXTURE_CUBE_MAP_POSITIVE_X + tt,
              it,
            )
        else
          we(
            ce.__webglFramebuffer[tt],
            j,
            B,
            n.COLOR_ATTACHMENT0,
            n.TEXTURE_CUBE_MAP_POSITIVE_X + tt,
            0,
          )
      M(B) && w(n.TEXTURE_CUBE_MAP), t.unbindTexture()
    } else if (st) {
      for (let tt = 0, it = De.length; tt < it; tt++) {
        const Et = De[tt],
          je = i.get(Et)
        t.bindTexture(n.TEXTURE_2D, je.__webglTexture),
          ne(n.TEXTURE_2D, Et),
          we(ce.__webglFramebuffer, j, Et, n.COLOR_ATTACHMENT0 + tt, n.TEXTURE_2D, 0),
          M(Et) && w(n.TEXTURE_2D)
      }
      t.unbindTexture()
    } else {
      let tt = n.TEXTURE_2D
      if (
        ((j.isWebGL3DRenderTarget || j.isWebGLArrayRenderTarget) &&
          (tt = j.isWebGL3DRenderTarget ? n.TEXTURE_3D : n.TEXTURE_2D_ARRAY),
        t.bindTexture(tt, Me.__webglTexture),
        ne(tt, B),
        B.mipmaps && B.mipmaps.length > 0)
      )
        for (let it = 0; it < B.mipmaps.length; it++)
          we(ce.__webglFramebuffer[it], j, B, n.COLOR_ATTACHMENT0, tt, it)
      else we(ce.__webglFramebuffer, j, B, n.COLOR_ATTACHMENT0, tt, 0)
      M(B) && w(tt), t.unbindTexture()
    }
    j.depthBuffer && ze(j)
  }
  function ae(j) {
    const B = j.textures
    for (let ce = 0, Me = B.length; ce < Me; ce++) {
      const De = B[ce]
      if (M(De)) {
        const Ie = A(j),
          st = i.get(De).__webglTexture
        t.bindTexture(Ie, st), w(Ie), t.unbindTexture()
      }
    }
  }
  const Ee = [],
    K = []
  function Ke(j) {
    if (j.samples > 0) {
      if (Oe(j) === !1) {
        const B = j.textures,
          ce = j.width,
          Me = j.height
        let De = n.COLOR_BUFFER_BIT
        const Ie = j.stencilBuffer ? n.DEPTH_STENCIL_ATTACHMENT : n.DEPTH_ATTACHMENT,
          st = i.get(j),
          tt = B.length > 1
        if (tt)
          for (let it = 0; it < B.length; it++)
            t.bindFramebuffer(n.FRAMEBUFFER, st.__webglMultisampledFramebuffer),
              n.framebufferRenderbuffer(
                n.FRAMEBUFFER,
                n.COLOR_ATTACHMENT0 + it,
                n.RENDERBUFFER,
                null,
              ),
              t.bindFramebuffer(n.FRAMEBUFFER, st.__webglFramebuffer),
              n.framebufferTexture2D(
                n.DRAW_FRAMEBUFFER,
                n.COLOR_ATTACHMENT0 + it,
                n.TEXTURE_2D,
                null,
                0,
              )
        t.bindFramebuffer(n.READ_FRAMEBUFFER, st.__webglMultisampledFramebuffer),
          t.bindFramebuffer(n.DRAW_FRAMEBUFFER, st.__webglFramebuffer)
        for (let it = 0; it < B.length; it++) {
          if (
            (j.resolveDepthBuffer &&
              (j.depthBuffer && (De |= n.DEPTH_BUFFER_BIT),
              j.stencilBuffer &&
                j.resolveStencilBuffer &&
                (De |= n.STENCIL_BUFFER_BIT)),
            tt)
          ) {
            n.framebufferRenderbuffer(
              n.READ_FRAMEBUFFER,
              n.COLOR_ATTACHMENT0,
              n.RENDERBUFFER,
              st.__webglColorRenderbuffer[it],
            )
            const Et = i.get(B[it]).__webglTexture
            n.framebufferTexture2D(
              n.DRAW_FRAMEBUFFER,
              n.COLOR_ATTACHMENT0,
              n.TEXTURE_2D,
              Et,
              0,
            )
          }
          n.blitFramebuffer(0, 0, ce, Me, 0, 0, ce, Me, De, n.NEAREST),
            u === !0 &&
              ((Ee.length = 0),
              (K.length = 0),
              Ee.push(n.COLOR_ATTACHMENT0 + it),
              j.depthBuffer &&
                j.resolveDepthBuffer === !1 &&
                (Ee.push(Ie),
                K.push(Ie),
                n.invalidateFramebuffer(n.DRAW_FRAMEBUFFER, K)),
              n.invalidateFramebuffer(n.READ_FRAMEBUFFER, Ee))
        }
        if (
          (t.bindFramebuffer(n.READ_FRAMEBUFFER, null),
          t.bindFramebuffer(n.DRAW_FRAMEBUFFER, null),
          tt)
        )
          for (let it = 0; it < B.length; it++) {
            t.bindFramebuffer(n.FRAMEBUFFER, st.__webglMultisampledFramebuffer),
              n.framebufferRenderbuffer(
                n.FRAMEBUFFER,
                n.COLOR_ATTACHMENT0 + it,
                n.RENDERBUFFER,
                st.__webglColorRenderbuffer[it],
              )
            const Et = i.get(B[it]).__webglTexture
            t.bindFramebuffer(n.FRAMEBUFFER, st.__webglFramebuffer),
              n.framebufferTexture2D(
                n.DRAW_FRAMEBUFFER,
                n.COLOR_ATTACHMENT0 + it,
                n.TEXTURE_2D,
                Et,
                0,
              )
          }
        t.bindFramebuffer(n.DRAW_FRAMEBUFFER, st.__webglMultisampledFramebuffer)
      } else if (j.depthBuffer && j.resolveDepthBuffer === !1 && u) {
        const B = j.stencilBuffer ? n.DEPTH_STENCIL_ATTACHMENT : n.DEPTH_ATTACHMENT
        n.invalidateFramebuffer(n.DRAW_FRAMEBUFFER, [B])
      }
    }
  }
  function Be(j) {
    return Math.min(r.maxSamples, j.samples)
  }
  function Oe(j) {
    const B = i.get(j)
    return (
      j.samples > 0 &&
      e.has("WEBGL_multisampled_render_to_texture") === !0 &&
      B.__useRenderToTexture !== !1
    )
  }
  function Pe(j) {
    const B = o.render.frame
    p.get(j) !== B && (p.set(j, B), j.update())
  }
  function He(j, B) {
    const ce = j.colorSpace,
      Me = j.format,
      De = j.type
    return (
      j.isCompressedTexture === !0 ||
        j.isVideoTexture === !0 ||
        (ce !== Bu &&
          ce !== za &&
          (fn.getTransfer(ce) === Sn
            ? (Me !== hr || De !== wo) &&
              console.warn(
                "THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.",
              )
            : console.error(
                "THREE.WebGLTextures: Unsupported texture color space:",
                ce,
              ))),
      B
    )
  }
  function Se(j) {
    return (
      typeof HTMLImageElement < "u" && j instanceof HTMLImageElement
        ? ((d.width = j.naturalWidth || j.width),
          (d.height = j.naturalHeight || j.height))
        : typeof VideoFrame < "u" && j instanceof VideoFrame
        ? ((d.width = j.displayWidth), (d.height = j.displayHeight))
        : ((d.width = j.width), (d.height = j.height)),
      d
    )
  }
  ;(this.allocateTextureUnit = $),
    (this.resetTextureUnits = Z),
    (this.setTexture2D = ue),
    (this.setTexture2DArray = re),
    (this.setTexture3D = se),
    (this.setTextureCube = G),
    (this.rebindTextures = Ge),
    (this.setupRenderTarget = Ue),
    (this.updateRenderTargetMipmap = ae),
    (this.updateMultisampleRenderTarget = Ke),
    (this.setupDepthRenderbuffer = ze),
    (this.setupFrameBufferTexture = we),
    (this.useMultisampledRTT = Oe)
}
function A3(n, e) {
  function t(i, r = za) {
    let s
    const o = fn.getTransfer(r)
    if (i === wo) return n.UNSIGNED_BYTE
    if (i === qv) return n.UNSIGNED_SHORT_4_4_4_4
    if (i === $v) return n.UNSIGNED_SHORT_5_5_5_1
    if (i === Cw) return n.UNSIGNED_INT_5_9_9_9_REV
    if (i === bw) return n.BYTE
    if (i === Aw) return n.SHORT
    if (i === Id) return n.UNSIGNED_SHORT
    if (i === Yv) return n.INT
    if (i === Za) return n.UNSIGNED_INT
    if (i === Qr) return n.FLOAT
    if (i === Gd) return n.HALF_FLOAT
    if (i === Rw) return n.ALPHA
    if (i === Pw) return n.RGB
    if (i === hr) return n.RGBA
    if (i === Iw) return n.LUMINANCE
    if (i === Lw) return n.LUMINANCE_ALPHA
    if (i === Tu) return n.DEPTH_COMPONENT
    if (i === Nu) return n.DEPTH_STENCIL
    if (i === Kv) return n.RED
    if (i === vm) return n.RED_INTEGER
    if (i === Dw) return n.RG
    if (i === Zv) return n.RG_INTEGER
    if (i === Jv) return n.RGBA_INTEGER
    if (i === bp || i === Ap || i === Cp || i === Rp)
      if (o === Sn)
        if (((s = e.get("WEBGL_compressed_texture_s3tc_srgb")), s !== null)) {
          if (i === bp) return s.COMPRESSED_SRGB_S3TC_DXT1_EXT
          if (i === Ap) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT
          if (i === Cp) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT
          if (i === Rp) return s.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT
        } else return null
      else if (((s = e.get("WEBGL_compressed_texture_s3tc")), s !== null)) {
        if (i === bp) return s.COMPRESSED_RGB_S3TC_DXT1_EXT
        if (i === Ap) return s.COMPRESSED_RGBA_S3TC_DXT1_EXT
        if (i === Cp) return s.COMPRESSED_RGBA_S3TC_DXT3_EXT
        if (i === Rp) return s.COMPRESSED_RGBA_S3TC_DXT5_EXT
      } else return null
    if (i === Z0 || i === J0 || i === Q0 || i === ev)
      if (((s = e.get("WEBGL_compressed_texture_pvrtc")), s !== null)) {
        if (i === Z0) return s.COMPRESSED_RGB_PVRTC_4BPPV1_IMG
        if (i === J0) return s.COMPRESSED_RGB_PVRTC_2BPPV1_IMG
        if (i === Q0) return s.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG
        if (i === ev) return s.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG
      } else return null
    if (i === tv || i === nv || i === iv)
      if (((s = e.get("WEBGL_compressed_texture_etc")), s !== null)) {
        if (i === tv || i === nv)
          return o === Sn ? s.COMPRESSED_SRGB8_ETC2 : s.COMPRESSED_RGB8_ETC2
        if (i === iv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC
            : s.COMPRESSED_RGBA8_ETC2_EAC
      } else return null
    if (
      i === rv ||
      i === sv ||
      i === ov ||
      i === av ||
      i === lv ||
      i === cv ||
      i === uv ||
      i === fv ||
      i === dv ||
      i === hv ||
      i === pv ||
      i === mv ||
      i === gv ||
      i === vv
    )
      if (((s = e.get("WEBGL_compressed_texture_astc")), s !== null)) {
        if (i === rv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR
            : s.COMPRESSED_RGBA_ASTC_4x4_KHR
        if (i === sv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR
            : s.COMPRESSED_RGBA_ASTC_5x4_KHR
        if (i === ov)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR
            : s.COMPRESSED_RGBA_ASTC_5x5_KHR
        if (i === av)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR
            : s.COMPRESSED_RGBA_ASTC_6x5_KHR
        if (i === lv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR
            : s.COMPRESSED_RGBA_ASTC_6x6_KHR
        if (i === cv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR
            : s.COMPRESSED_RGBA_ASTC_8x5_KHR
        if (i === uv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR
            : s.COMPRESSED_RGBA_ASTC_8x6_KHR
        if (i === fv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR
            : s.COMPRESSED_RGBA_ASTC_8x8_KHR
        if (i === dv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR
            : s.COMPRESSED_RGBA_ASTC_10x5_KHR
        if (i === hv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR
            : s.COMPRESSED_RGBA_ASTC_10x6_KHR
        if (i === pv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR
            : s.COMPRESSED_RGBA_ASTC_10x8_KHR
        if (i === mv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR
            : s.COMPRESSED_RGBA_ASTC_10x10_KHR
        if (i === gv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR
            : s.COMPRESSED_RGBA_ASTC_12x10_KHR
        if (i === vv)
          return o === Sn
            ? s.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR
            : s.COMPRESSED_RGBA_ASTC_12x12_KHR
      } else return null
    if (i === Pp || i === yv || i === xv)
      if (((s = e.get("EXT_texture_compression_bptc")), s !== null)) {
        if (i === Pp)
          return o === Sn
            ? s.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT
            : s.COMPRESSED_RGBA_BPTC_UNORM_EXT
        if (i === yv) return s.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT
        if (i === xv) return s.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT
      } else return null
    if (i === Nw || i === _v || i === wv || i === Sv)
      if (((s = e.get("EXT_texture_compression_rgtc")), s !== null)) {
        if (i === Pp) return s.COMPRESSED_RED_RGTC1_EXT
        if (i === _v) return s.COMPRESSED_SIGNED_RED_RGTC1_EXT
        if (i === wv) return s.COMPRESSED_RED_GREEN_RGTC2_EXT
        if (i === Sv) return s.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT
      } else return null
    return i === Du ? n.UNSIGNED_INT_24_8 : n[i] !== void 0 ? n[i] : null
  }
  return { convert: t }
}
class C3 extends Ci {
  constructor(e = []) {
    super(), (this.isArrayCamera = !0), (this.cameras = e)
  }
}
class Ql extends cn {
  constructor() {
    super(), (this.isGroup = !0), (this.type = "Group")
  }
}
const FV = { type: "move" }
class i_ {
  constructor() {
    ;(this._targetRay = null), (this._grip = null), (this._hand = null)
  }
  getHandSpace() {
    return (
      this._hand === null &&
        ((this._hand = new Ql()),
        (this._hand.matrixAutoUpdate = !1),
        (this._hand.visible = !1),
        (this._hand.joints = {}),
        (this._hand.inputState = { pinching: !1 })),
      this._hand
    )
  }
  getTargetRaySpace() {
    return (
      this._targetRay === null &&
        ((this._targetRay = new Ql()),
        (this._targetRay.matrixAutoUpdate = !1),
        (this._targetRay.visible = !1),
        (this._targetRay.hasLinearVelocity = !1),
        (this._targetRay.linearVelocity = new q()),
        (this._targetRay.hasAngularVelocity = !1),
        (this._targetRay.angularVelocity = new q())),
      this._targetRay
    )
  }
  getGripSpace() {
    return (
      this._grip === null &&
        ((this._grip = new Ql()),
        (this._grip.matrixAutoUpdate = !1),
        (this._grip.visible = !1),
        (this._grip.hasLinearVelocity = !1),
        (this._grip.linearVelocity = new q()),
        (this._grip.hasAngularVelocity = !1),
        (this._grip.angularVelocity = new q())),
      this._grip
    )
  }
  dispatchEvent(e) {
    return (
      this._targetRay !== null && this._targetRay.dispatchEvent(e),
      this._grip !== null && this._grip.dispatchEvent(e),
      this._hand !== null && this._hand.dispatchEvent(e),
      this
    )
  }
  connect(e) {
    if (e && e.hand) {
      const t = this._hand
      if (t) for (const i of e.hand.values()) this._getHandJoint(t, i)
    }
    return this.dispatchEvent({ type: "connected", data: e }), this
  }
  disconnect(e) {
    return (
      this.dispatchEvent({ type: "disconnected", data: e }),
      this._targetRay !== null && (this._targetRay.visible = !1),
      this._grip !== null && (this._grip.visible = !1),
      this._hand !== null && (this._hand.visible = !1),
      this
    )
  }
  update(e, t, i) {
    let r = null,
      s = null,
      o = null
    const l = this._targetRay,
      u = this._grip,
      d = this._hand
    if (e && t.session.visibilityState !== "visible-blurred") {
      if (d && e.hand) {
        o = !0
        for (const E of e.hand.values()) {
          const M = t.getJointPose(E, i),
            w = this._getHandJoint(d, E)
          M !== null &&
            (w.matrix.fromArray(M.transform.matrix),
            w.matrix.decompose(w.position, w.rotation, w.scale),
            (w.matrixWorldNeedsUpdate = !0),
            (w.jointRadius = M.radius)),
            (w.visible = M !== null)
        }
        const p = d.joints["index-finger-tip"],
          m = d.joints["thumb-tip"],
          v = p.position.distanceTo(m.position),
          y = 0.02,
          x = 0.005
        d.inputState.pinching && v > y + x
          ? ((d.inputState.pinching = !1),
            this.dispatchEvent({
              type: "pinchend",
              handedness: e.handedness,
              target: this,
            }))
          : !d.inputState.pinching &&
            v <= y - x &&
            ((d.inputState.pinching = !0),
            this.dispatchEvent({
              type: "pinchstart",
              handedness: e.handedness,
              target: this,
            }))
      } else
        u !== null &&
          e.gripSpace &&
          ((s = t.getPose(e.gripSpace, i)),
          s !== null &&
            (u.matrix.fromArray(s.transform.matrix),
            u.matrix.decompose(u.position, u.rotation, u.scale),
            (u.matrixWorldNeedsUpdate = !0),
            s.linearVelocity
              ? ((u.hasLinearVelocity = !0), u.linearVelocity.copy(s.linearVelocity))
              : (u.hasLinearVelocity = !1),
            s.angularVelocity
              ? ((u.hasAngularVelocity = !0), u.angularVelocity.copy(s.angularVelocity))
              : (u.hasAngularVelocity = !1)))
      l !== null &&
        ((r = t.getPose(e.targetRaySpace, i)),
        r === null && s !== null && (r = s),
        r !== null &&
          (l.matrix.fromArray(r.transform.matrix),
          l.matrix.decompose(l.position, l.rotation, l.scale),
          (l.matrixWorldNeedsUpdate = !0),
          r.linearVelocity
            ? ((l.hasLinearVelocity = !0), l.linearVelocity.copy(r.linearVelocity))
            : (l.hasLinearVelocity = !1),
          r.angularVelocity
            ? ((l.hasAngularVelocity = !0), l.angularVelocity.copy(r.angularVelocity))
            : (l.hasAngularVelocity = !1),
          this.dispatchEvent(FV)))
    }
    return (
      l !== null && (l.visible = r !== null),
      u !== null && (u.visible = s !== null),
      d !== null && (d.visible = o !== null),
      this
    )
  }
  _getHandJoint(e, t) {
    if (e.joints[t.jointName] === void 0) {
      const i = new Ql()
      ;(i.matrixAutoUpdate = !1),
        (i.visible = !1),
        (e.joints[t.jointName] = i),
        e.add(i)
    }
    return e.joints[t.jointName]
  }
}
const UV = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`,
  OV = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`
class BV {
  constructor() {
    ;(this.texture = null),
      (this.mesh = null),
      (this.depthNear = 0),
      (this.depthFar = 0)
  }
  init(e, t, i) {
    if (this.texture === null) {
      const r = new zn(),
        s = e.properties.get(r)
      ;(s.__webglTexture = t.texture),
        (t.depthNear != i.depthNear || t.depthFar != i.depthFar) &&
          ((this.depthNear = t.depthNear), (this.depthFar = t.depthFar)),
        (this.texture = r)
    }
  }
  getMesh(e) {
    if (this.texture !== null && this.mesh === null) {
      const t = e.cameras[0].viewport,
        i = new Mo({
          vertexShader: UV,
          fragmentShader: OV,
          uniforms: {
            depthColor: { value: this.texture },
            depthWidth: { value: t.z },
            depthHeight: { value: t.w },
          },
        })
      this.mesh = new ui(new jd(20, 20), i)
    }
    return this.mesh
  }
  reset() {
    ;(this.texture = null), (this.mesh = null)
  }
  getDepthTexture() {
    return this.texture
  }
}
class zV extends Jo {
  constructor(e, t) {
    super()
    const i = this
    let r = null,
      s = 1,
      o = null,
      l = "local-floor",
      u = 1,
      d = null,
      p = null,
      m = null,
      v = null,
      y = null,
      x = null
    const E = new BV(),
      M = t.getContextAttributes()
    let w = null,
      A = null
    const C = [],
      R = [],
      z = new We()
    let U = null
    const O = new Ci()
    O.viewport = new on()
    const N = new Ci()
    N.viewport = new on()
    const k = [O, N],
      I = new C3()
    let V = null,
      Z = null
    ;(this.cameraAutoUpdate = !0),
      (this.enabled = !1),
      (this.isPresenting = !1),
      (this.getController = function (oe) {
        let fe = C[oe]
        return fe === void 0 && ((fe = new i_()), (C[oe] = fe)), fe.getTargetRaySpace()
      }),
      (this.getControllerGrip = function (oe) {
        let fe = C[oe]
        return fe === void 0 && ((fe = new i_()), (C[oe] = fe)), fe.getGripSpace()
      }),
      (this.getHand = function (oe) {
        let fe = C[oe]
        return fe === void 0 && ((fe = new i_()), (C[oe] = fe)), fe.getHandSpace()
      })
    function $(oe) {
      const fe = R.indexOf(oe.inputSource)
      if (fe === -1) return
      const we = C[fe]
      we !== void 0 &&
        (we.update(oe.inputSource, oe.frame, d || o),
        we.dispatchEvent({ type: oe.type, data: oe.inputSource }))
    }
    function ee() {
      r.removeEventListener("select", $),
        r.removeEventListener("selectstart", $),
        r.removeEventListener("selectend", $),
        r.removeEventListener("squeeze", $),
        r.removeEventListener("squeezestart", $),
        r.removeEventListener("squeezeend", $),
        r.removeEventListener("end", ee),
        r.removeEventListener("inputsourceschange", ue)
      for (let oe = 0; oe < C.length; oe++) {
        const fe = R[oe]
        fe !== null && ((R[oe] = null), C[oe].disconnect(fe))
      }
      ;(V = null),
        (Z = null),
        E.reset(),
        e.setRenderTarget(w),
        (y = null),
        (v = null),
        (m = null),
        (r = null),
        (A = null),
        ye.stop(),
        (i.isPresenting = !1),
        e.setPixelRatio(U),
        e.setSize(z.width, z.height, !1),
        i.dispatchEvent({ type: "sessionend" })
    }
    ;(this.setFramebufferScaleFactor = function (oe) {
      ;(s = oe),
        i.isPresenting === !0 &&
          console.warn(
            "THREE.WebXRManager: Cannot change framebuffer scale while presenting.",
          )
    }),
      (this.setReferenceSpaceType = function (oe) {
        ;(l = oe),
          i.isPresenting === !0 &&
            console.warn(
              "THREE.WebXRManager: Cannot change reference space type while presenting.",
            )
      }),
      (this.getReferenceSpace = function () {
        return d || o
      }),
      (this.setReferenceSpace = function (oe) {
        d = oe
      }),
      (this.getBaseLayer = function () {
        return v !== null ? v : y
      }),
      (this.getBinding = function () {
        return m
      }),
      (this.getFrame = function () {
        return x
      }),
      (this.getSession = function () {
        return r
      }),
      (this.setSession = async function (oe) {
        if (((r = oe), r !== null)) {
          if (
            ((w = e.getRenderTarget()),
            r.addEventListener("select", $),
            r.addEventListener("selectstart", $),
            r.addEventListener("selectend", $),
            r.addEventListener("squeeze", $),
            r.addEventListener("squeezestart", $),
            r.addEventListener("squeezeend", $),
            r.addEventListener("end", ee),
            r.addEventListener("inputsourceschange", ue),
            M.xrCompatible !== !0 && (await t.makeXRCompatible()),
            (U = e.getPixelRatio()),
            e.getSize(z),
            r.renderState.layers === void 0)
          ) {
            const fe = {
              antialias: M.antialias,
              alpha: !0,
              depth: M.depth,
              stencil: M.stencil,
              framebufferScaleFactor: s,
            }
            ;(y = new XRWebGLLayer(r, t, fe)),
              r.updateRenderState({ baseLayer: y }),
              e.setPixelRatio(1),
              e.setSize(y.framebufferWidth, y.framebufferHeight, !1),
              (A = new So(y.framebufferWidth, y.framebufferHeight, {
                format: hr,
                type: wo,
                colorSpace: e.outputColorSpace,
                stencilBuffer: M.stencil,
              }))
          } else {
            let fe = null,
              we = null,
              me = null
            M.depth &&
              ((me = M.stencil ? t.DEPTH24_STENCIL8 : t.DEPTH_COMPONENT24),
              (fe = M.stencil ? Nu : Tu),
              (we = M.stencil ? Du : Za))
            const Fe = { colorFormat: t.RGBA8, depthFormat: me, scaleFactor: s }
            ;(m = new XRWebGLBinding(r, t)),
              (v = m.createProjectionLayer(Fe)),
              r.updateRenderState({ layers: [v] }),
              e.setPixelRatio(1),
              e.setSize(v.textureWidth, v.textureHeight, !1),
              (A = new So(v.textureWidth, v.textureHeight, {
                format: hr,
                type: wo,
                depthTexture: new Vw(
                  v.textureWidth,
                  v.textureHeight,
                  we,
                  void 0,
                  void 0,
                  void 0,
                  void 0,
                  void 0,
                  void 0,
                  fe,
                ),
                stencilBuffer: M.stencil,
                colorSpace: e.outputColorSpace,
                samples: M.antialias ? 4 : 0,
                resolveDepthBuffer: v.ignoreDepthValues === !1,
              }))
          }
          ;(A.isXRRenderTarget = !0),
            this.setFoveation(u),
            (d = null),
            (o = await r.requestReferenceSpace(l)),
            ye.setContext(r),
            ye.start(),
            (i.isPresenting = !0),
            i.dispatchEvent({ type: "sessionstart" })
        }
      }),
      (this.getEnvironmentBlendMode = function () {
        if (r !== null) return r.environmentBlendMode
      }),
      (this.getDepthTexture = function () {
        return E.getDepthTexture()
      })
    function ue(oe) {
      for (let fe = 0; fe < oe.removed.length; fe++) {
        const we = oe.removed[fe],
          me = R.indexOf(we)
        me >= 0 && ((R[me] = null), C[me].disconnect(we))
      }
      for (let fe = 0; fe < oe.added.length; fe++) {
        const we = oe.added[fe]
        let me = R.indexOf(we)
        if (me === -1) {
          for (let ze = 0; ze < C.length; ze++)
            if (ze >= R.length) {
              R.push(we), (me = ze)
              break
            } else if (R[ze] === null) {
              ;(R[ze] = we), (me = ze)
              break
            }
          if (me === -1) break
        }
        const Fe = C[me]
        Fe && Fe.connect(we)
      }
    }
    const re = new q(),
      se = new q()
    function G(oe, fe, we) {
      re.setFromMatrixPosition(fe.matrixWorld), se.setFromMatrixPosition(we.matrixWorld)
      const me = re.distanceTo(se),
        Fe = fe.projectionMatrix.elements,
        ze = we.projectionMatrix.elements,
        Ge = Fe[14] / (Fe[10] - 1),
        Ue = Fe[14] / (Fe[10] + 1),
        ae = (Fe[9] + 1) / Fe[5],
        Ee = (Fe[9] - 1) / Fe[5],
        K = (Fe[8] - 1) / Fe[0],
        Ke = (ze[8] + 1) / ze[0],
        Be = Ge * K,
        Oe = Ge * Ke,
        Pe = me / (-K + Ke),
        He = Pe * -K
      if (
        (fe.matrixWorld.decompose(oe.position, oe.quaternion, oe.scale),
        oe.translateX(He),
        oe.translateZ(Pe),
        oe.matrixWorld.compose(oe.position, oe.quaternion, oe.scale),
        oe.matrixWorldInverse.copy(oe.matrixWorld).invert(),
        Fe[10] === -1)
      )
        oe.projectionMatrix.copy(fe.projectionMatrix),
          oe.projectionMatrixInverse.copy(fe.projectionMatrixInverse)
      else {
        const Se = Ge + Pe,
          j = Ue + Pe,
          B = Be - He,
          ce = Oe + (me - He),
          Me = ((ae * Ue) / j) * Se,
          De = ((Ee * Ue) / j) * Se
        oe.projectionMatrix.makePerspective(B, ce, Me, De, Se, j),
          oe.projectionMatrixInverse.copy(oe.projectionMatrix).invert()
      }
    }
    function ie(oe, fe) {
      fe === null
        ? oe.matrixWorld.copy(oe.matrix)
        : oe.matrixWorld.multiplyMatrices(fe.matrixWorld, oe.matrix),
        oe.matrixWorldInverse.copy(oe.matrixWorld).invert()
    }
    this.updateCamera = function (oe) {
      if (r === null) return
      let fe = oe.near,
        we = oe.far
      E.texture !== null &&
        (E.depthNear > 0 && (fe = E.depthNear), E.depthFar > 0 && (we = E.depthFar)),
        (I.near = N.near = O.near = fe),
        (I.far = N.far = O.far = we),
        (V !== I.near || Z !== I.far) &&
          (r.updateRenderState({ depthNear: I.near, depthFar: I.far }),
          (V = I.near),
          (Z = I.far)),
        (O.layers.mask = oe.layers.mask | 2),
        (N.layers.mask = oe.layers.mask | 4),
        (I.layers.mask = O.layers.mask | N.layers.mask)
      const me = oe.parent,
        Fe = I.cameras
      ie(I, me)
      for (let ze = 0; ze < Fe.length; ze++) ie(Fe[ze], me)
      Fe.length === 2 ? G(I, O, N) : I.projectionMatrix.copy(O.projectionMatrix),
        Q(oe, I, me)
    }
    function Q(oe, fe, we) {
      we === null
        ? oe.matrix.copy(fe.matrixWorld)
        : (oe.matrix.copy(we.matrixWorld),
          oe.matrix.invert(),
          oe.matrix.multiply(fe.matrixWorld)),
        oe.matrix.decompose(oe.position, oe.quaternion, oe.scale),
        oe.updateMatrixWorld(!0),
        oe.projectionMatrix.copy(fe.projectionMatrix),
        oe.projectionMatrixInverse.copy(fe.projectionMatrixInverse),
        oe.isPerspectiveCamera &&
          ((oe.fov = Ld * 2 * Math.atan(1 / oe.projectionMatrix.elements[5])),
          (oe.zoom = 1))
    }
    ;(this.getCamera = function () {
      return I
    }),
      (this.getFoveation = function () {
        if (!(v === null && y === null)) return u
      }),
      (this.setFoveation = function (oe) {
        ;(u = oe),
          v !== null && (v.fixedFoveation = oe),
          y !== null && y.fixedFoveation !== void 0 && (y.fixedFoveation = oe)
      }),
      (this.hasDepthSensing = function () {
        return E.texture !== null
      }),
      (this.getDepthSensingMesh = function () {
        return E.getMesh(I)
      })
    let W = null
    function ne(oe, fe) {
      if (((p = fe.getViewerPose(d || o)), (x = fe), p !== null)) {
        const we = p.views
        y !== null &&
          (e.setRenderTargetFramebuffer(A, y.framebuffer), e.setRenderTarget(A))
        let me = !1
        we.length !== I.cameras.length && ((I.cameras.length = 0), (me = !0))
        for (let ze = 0; ze < we.length; ze++) {
          const Ge = we[ze]
          let Ue = null
          if (y !== null) Ue = y.getViewport(Ge)
          else {
            const Ee = m.getViewSubImage(v, Ge)
            ;(Ue = Ee.viewport),
              ze === 0 &&
                (e.setRenderTargetTextures(
                  A,
                  Ee.colorTexture,
                  v.ignoreDepthValues ? void 0 : Ee.depthStencilTexture,
                ),
                e.setRenderTarget(A))
          }
          let ae = k[ze]
          ae === void 0 &&
            ((ae = new Ci()),
            ae.layers.enable(ze),
            (ae.viewport = new on()),
            (k[ze] = ae)),
            ae.matrix.fromArray(Ge.transform.matrix),
            ae.matrix.decompose(ae.position, ae.quaternion, ae.scale),
            ae.projectionMatrix.fromArray(Ge.projectionMatrix),
            ae.projectionMatrixInverse.copy(ae.projectionMatrix).invert(),
            ae.viewport.set(Ue.x, Ue.y, Ue.width, Ue.height),
            ze === 0 &&
              (I.matrix.copy(ae.matrix),
              I.matrix.decompose(I.position, I.quaternion, I.scale)),
            me === !0 && I.cameras.push(ae)
        }
        const Fe = r.enabledFeatures
        if (Fe && Fe.includes("depth-sensing")) {
          const ze = m.getDepthInformation(we[0])
          ze && ze.isValid && ze.texture && E.init(e, ze, r.renderState)
        }
      }
      for (let we = 0; we < C.length; we++) {
        const me = R[we],
          Fe = C[we]
        me !== null && Fe !== void 0 && Fe.update(me, fe, d || o)
      }
      W && W(oe, fe),
        fe.detectedPlanes && i.dispatchEvent({ type: "planesdetected", data: fe }),
        (x = null)
    }
    const ye = new S3()
    ye.setAnimationLoop(ne),
      (this.setAnimationLoop = function (oe) {
        W = oe
      }),
      (this.dispose = function () {})
  }
}
const tu = new Bi(),
  VV = new mt()
function HV(n, e) {
  function t(M, w) {
    M.matrixAutoUpdate === !0 && M.updateMatrix(), w.value.copy(M.matrix)
  }
  function i(M, w) {
    w.color.getRGB(M.fogColor.value, y3(n)),
      w.isFog
        ? ((M.fogNear.value = w.near), (M.fogFar.value = w.far))
        : w.isFogExp2 && (M.fogDensity.value = w.density)
  }
  function r(M, w, A, C, R) {
    w.isMeshBasicMaterial || w.isMeshLambertMaterial
      ? s(M, w)
      : w.isMeshToonMaterial
      ? (s(M, w), m(M, w))
      : w.isMeshPhongMaterial
      ? (s(M, w), p(M, w))
      : w.isMeshStandardMaterial
      ? (s(M, w), v(M, w), w.isMeshPhysicalMaterial && y(M, w, R))
      : w.isMeshMatcapMaterial
      ? (s(M, w), x(M, w))
      : w.isMeshDepthMaterial
      ? s(M, w)
      : w.isMeshDistanceMaterial
      ? (s(M, w), E(M, w))
      : w.isMeshNormalMaterial
      ? s(M, w)
      : w.isLineBasicMaterial
      ? (o(M, w), w.isLineDashedMaterial && l(M, w))
      : w.isPointsMaterial
      ? u(M, w, A, C)
      : w.isSpriteMaterial
      ? d(M, w)
      : w.isShadowMaterial
      ? (M.color.value.copy(w.color), (M.opacity.value = w.opacity))
      : w.isShaderMaterial && (w.uniformsNeedUpdate = !1)
  }
  function s(M, w) {
    ;(M.opacity.value = w.opacity),
      w.color && M.diffuse.value.copy(w.color),
      w.emissive &&
        M.emissive.value.copy(w.emissive).multiplyScalar(w.emissiveIntensity),
      w.map && ((M.map.value = w.map), t(w.map, M.mapTransform)),
      w.alphaMap &&
        ((M.alphaMap.value = w.alphaMap), t(w.alphaMap, M.alphaMapTransform)),
      w.bumpMap &&
        ((M.bumpMap.value = w.bumpMap),
        t(w.bumpMap, M.bumpMapTransform),
        (M.bumpScale.value = w.bumpScale),
        w.side === Ir && (M.bumpScale.value *= -1)),
      w.normalMap &&
        ((M.normalMap.value = w.normalMap),
        t(w.normalMap, M.normalMapTransform),
        M.normalScale.value.copy(w.normalScale),
        w.side === Ir && M.normalScale.value.negate()),
      w.displacementMap &&
        ((M.displacementMap.value = w.displacementMap),
        t(w.displacementMap, M.displacementMapTransform),
        (M.displacementScale.value = w.displacementScale),
        (M.displacementBias.value = w.displacementBias)),
      w.emissiveMap &&
        ((M.emissiveMap.value = w.emissiveMap),
        t(w.emissiveMap, M.emissiveMapTransform)),
      w.specularMap &&
        ((M.specularMap.value = w.specularMap),
        t(w.specularMap, M.specularMapTransform)),
      w.alphaTest > 0 && (M.alphaTest.value = w.alphaTest)
    const A = e.get(w),
      C = A.envMap,
      R = A.envMapRotation
    C &&
      ((M.envMap.value = C),
      tu.copy(R),
      (tu.x *= -1),
      (tu.y *= -1),
      (tu.z *= -1),
      C.isCubeTexture && C.isRenderTargetTexture === !1 && ((tu.y *= -1), (tu.z *= -1)),
      M.envMapRotation.value.setFromMatrix4(VV.makeRotationFromEuler(tu)),
      (M.flipEnvMap.value = C.isCubeTexture && C.isRenderTargetTexture === !1 ? -1 : 1),
      (M.reflectivity.value = w.reflectivity),
      (M.ior.value = w.ior),
      (M.refractionRatio.value = w.refractionRatio)),
      w.lightMap &&
        ((M.lightMap.value = w.lightMap),
        (M.lightMapIntensity.value = w.lightMapIntensity),
        t(w.lightMap, M.lightMapTransform)),
      w.aoMap &&
        ((M.aoMap.value = w.aoMap),
        (M.aoMapIntensity.value = w.aoMapIntensity),
        t(w.aoMap, M.aoMapTransform))
  }
  function o(M, w) {
    M.diffuse.value.copy(w.color),
      (M.opacity.value = w.opacity),
      w.map && ((M.map.value = w.map), t(w.map, M.mapTransform))
  }
  function l(M, w) {
    ;(M.dashSize.value = w.dashSize),
      (M.totalSize.value = w.dashSize + w.gapSize),
      (M.scale.value = w.scale)
  }
  function u(M, w, A, C) {
    M.diffuse.value.copy(w.color),
      (M.opacity.value = w.opacity),
      (M.size.value = w.size * A),
      (M.scale.value = C * 0.5),
      w.map && ((M.map.value = w.map), t(w.map, M.uvTransform)),
      w.alphaMap &&
        ((M.alphaMap.value = w.alphaMap), t(w.alphaMap, M.alphaMapTransform)),
      w.alphaTest > 0 && (M.alphaTest.value = w.alphaTest)
  }
  function d(M, w) {
    M.diffuse.value.copy(w.color),
      (M.opacity.value = w.opacity),
      (M.rotation.value = w.rotation),
      w.map && ((M.map.value = w.map), t(w.map, M.mapTransform)),
      w.alphaMap &&
        ((M.alphaMap.value = w.alphaMap), t(w.alphaMap, M.alphaMapTransform)),
      w.alphaTest > 0 && (M.alphaTest.value = w.alphaTest)
  }
  function p(M, w) {
    M.specular.value.copy(w.specular), (M.shininess.value = Math.max(w.shininess, 1e-4))
  }
  function m(M, w) {
    w.gradientMap && (M.gradientMap.value = w.gradientMap)
  }
  function v(M, w) {
    ;(M.metalness.value = w.metalness),
      w.metalnessMap &&
        ((M.metalnessMap.value = w.metalnessMap),
        t(w.metalnessMap, M.metalnessMapTransform)),
      (M.roughness.value = w.roughness),
      w.roughnessMap &&
        ((M.roughnessMap.value = w.roughnessMap),
        t(w.roughnessMap, M.roughnessMapTransform)),
      w.envMap && (M.envMapIntensity.value = w.envMapIntensity)
  }
  function y(M, w, A) {
    ;(M.ior.value = w.ior),
      w.sheen > 0 &&
        (M.sheenColor.value.copy(w.sheenColor).multiplyScalar(w.sheen),
        (M.sheenRoughness.value = w.sheenRoughness),
        w.sheenColorMap &&
          ((M.sheenColorMap.value = w.sheenColorMap),
          t(w.sheenColorMap, M.sheenColorMapTransform)),
        w.sheenRoughnessMap &&
          ((M.sheenRoughnessMap.value = w.sheenRoughnessMap),
          t(w.sheenRoughnessMap, M.sheenRoughnessMapTransform))),
      w.clearcoat > 0 &&
        ((M.clearcoat.value = w.clearcoat),
        (M.clearcoatRoughness.value = w.clearcoatRoughness),
        w.clearcoatMap &&
          ((M.clearcoatMap.value = w.clearcoatMap),
          t(w.clearcoatMap, M.clearcoatMapTransform)),
        w.clearcoatRoughnessMap &&
          ((M.clearcoatRoughnessMap.value = w.clearcoatRoughnessMap),
          t(w.clearcoatRoughnessMap, M.clearcoatRoughnessMapTransform)),
        w.clearcoatNormalMap &&
          ((M.clearcoatNormalMap.value = w.clearcoatNormalMap),
          t(w.clearcoatNormalMap, M.clearcoatNormalMapTransform),
          M.clearcoatNormalScale.value.copy(w.clearcoatNormalScale),
          w.side === Ir && M.clearcoatNormalScale.value.negate())),
      w.dispersion > 0 && (M.dispersion.value = w.dispersion),
      w.iridescence > 0 &&
        ((M.iridescence.value = w.iridescence),
        (M.iridescenceIOR.value = w.iridescenceIOR),
        (M.iridescenceThicknessMinimum.value = w.iridescenceThicknessRange[0]),
        (M.iridescenceThicknessMaximum.value = w.iridescenceThicknessRange[1]),
        w.iridescenceMap &&
          ((M.iridescenceMap.value = w.iridescenceMap),
          t(w.iridescenceMap, M.iridescenceMapTransform)),
        w.iridescenceThicknessMap &&
          ((M.iridescenceThicknessMap.value = w.iridescenceThicknessMap),
          t(w.iridescenceThicknessMap, M.iridescenceThicknessMapTransform))),
      w.transmission > 0 &&
        ((M.transmission.value = w.transmission),
        (M.transmissionSamplerMap.value = A.texture),
        M.transmissionSamplerSize.value.set(A.width, A.height),
        w.transmissionMap &&
          ((M.transmissionMap.value = w.transmissionMap),
          t(w.transmissionMap, M.transmissionMapTransform)),
        (M.thickness.value = w.thickness),
        w.thicknessMap &&
          ((M.thicknessMap.value = w.thicknessMap),
          t(w.thicknessMap, M.thicknessMapTransform)),
        (M.attenuationDistance.value = w.attenuationDistance),
        M.attenuationColor.value.copy(w.attenuationColor)),
      w.anisotropy > 0 &&
        (M.anisotropyVector.value.set(
          w.anisotropy * Math.cos(w.anisotropyRotation),
          w.anisotropy * Math.sin(w.anisotropyRotation),
        ),
        w.anisotropyMap &&
          ((M.anisotropyMap.value = w.anisotropyMap),
          t(w.anisotropyMap, M.anisotropyMapTransform))),
      (M.specularIntensity.value = w.specularIntensity),
      M.specularColor.value.copy(w.specularColor),
      w.specularColorMap &&
        ((M.specularColorMap.value = w.specularColorMap),
        t(w.specularColorMap, M.specularColorMapTransform)),
      w.specularIntensityMap &&
        ((M.specularIntensityMap.value = w.specularIntensityMap),
        t(w.specularIntensityMap, M.specularIntensityMapTransform))
  }
  function x(M, w) {
    w.matcap && (M.matcap.value = w.matcap)
  }
  function E(M, w) {
    const A = e.get(w).light
    M.referencePosition.value.setFromMatrixPosition(A.matrixWorld),
      (M.nearDistance.value = A.shadow.camera.near),
      (M.farDistance.value = A.shadow.camera.far)
  }
  return { refreshFogUniforms: i, refreshMaterialUniforms: r }
}
function GV(n, e, t, i) {
  let r = {},
    s = {},
    o = []
  const l = n.getParameter(n.MAX_UNIFORM_BUFFER_BINDINGS)
  function u(A, C) {
    const R = C.program
    i.uniformBlockBinding(A, R)
  }
  function d(A, C) {
    let R = r[A.id]
    R === void 0 && (x(A), (R = p(A)), (r[A.id] = R), A.addEventListener("dispose", M))
    const z = C.program
    i.updateUBOMapping(A, z)
    const U = e.render.frame
    s[A.id] !== U && (v(A), (s[A.id] = U))
  }
  function p(A) {
    const C = m()
    A.__bindingPointIndex = C
    const R = n.createBuffer(),
      z = A.__size,
      U = A.usage
    return (
      n.bindBuffer(n.UNIFORM_BUFFER, R),
      n.bufferData(n.UNIFORM_BUFFER, z, U),
      n.bindBuffer(n.UNIFORM_BUFFER, null),
      n.bindBufferBase(n.UNIFORM_BUFFER, C, R),
      R
    )
  }
  function m() {
    for (let A = 0; A < l; A++) if (o.indexOf(A) === -1) return o.push(A), A
    return (
      console.error(
        "THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.",
      ),
      0
    )
  }
  function v(A) {
    const C = r[A.id],
      R = A.uniforms,
      z = A.__cache
    n.bindBuffer(n.UNIFORM_BUFFER, C)
    for (let U = 0, O = R.length; U < O; U++) {
      const N = Array.isArray(R[U]) ? R[U] : [R[U]]
      for (let k = 0, I = N.length; k < I; k++) {
        const V = N[k]
        if (y(V, U, k, z) === !0) {
          const Z = V.__offset,
            $ = Array.isArray(V.value) ? V.value : [V.value]
          let ee = 0
          for (let ue = 0; ue < $.length; ue++) {
            const re = $[ue],
              se = E(re)
            typeof re == "number" || typeof re == "boolean"
              ? ((V.__data[0] = re),
                n.bufferSubData(n.UNIFORM_BUFFER, Z + ee, V.__data))
              : re.isMatrix3
              ? ((V.__data[0] = re.elements[0]),
                (V.__data[1] = re.elements[1]),
                (V.__data[2] = re.elements[2]),
                (V.__data[3] = 0),
                (V.__data[4] = re.elements[3]),
                (V.__data[5] = re.elements[4]),
                (V.__data[6] = re.elements[5]),
                (V.__data[7] = 0),
                (V.__data[8] = re.elements[6]),
                (V.__data[9] = re.elements[7]),
                (V.__data[10] = re.elements[8]),
                (V.__data[11] = 0))
              : (re.toArray(V.__data, ee),
                (ee += se.storage / Float32Array.BYTES_PER_ELEMENT))
          }
          n.bufferSubData(n.UNIFORM_BUFFER, Z, V.__data)
        }
      }
    }
    n.bindBuffer(n.UNIFORM_BUFFER, null)
  }
  function y(A, C, R, z) {
    const U = A.value,
      O = C + "_" + R
    if (z[O] === void 0)
      return (
        typeof U == "number" || typeof U == "boolean" ? (z[O] = U) : (z[O] = U.clone()),
        !0
      )
    {
      const N = z[O]
      if (typeof U == "number" || typeof U == "boolean") {
        if (N !== U) return (z[O] = U), !0
      } else if (N.equals(U) === !1) return N.copy(U), !0
    }
    return !1
  }
  function x(A) {
    const C = A.uniforms
    let R = 0
    const z = 16
    for (let O = 0, N = C.length; O < N; O++) {
      const k = Array.isArray(C[O]) ? C[O] : [C[O]]
      for (let I = 0, V = k.length; I < V; I++) {
        const Z = k[I],
          $ = Array.isArray(Z.value) ? Z.value : [Z.value]
        for (let ee = 0, ue = $.length; ee < ue; ee++) {
          const re = $[ee],
            se = E(re),
            G = R % z,
            ie = G % se.boundary,
            Q = G + ie
          ;(R += ie),
            Q !== 0 && z - Q < se.storage && (R += z - Q),
            (Z.__data = new Float32Array(se.storage / Float32Array.BYTES_PER_ELEMENT)),
            (Z.__offset = R),
            (R += se.storage)
        }
      }
    }
    const U = R % z
    return U > 0 && (R += z - U), (A.__size = R), (A.__cache = {}), this
  }
  function E(A) {
    const C = { boundary: 0, storage: 0 }
    return (
      typeof A == "number" || typeof A == "boolean"
        ? ((C.boundary = 4), (C.storage = 4))
        : A.isVector2
        ? ((C.boundary = 8), (C.storage = 8))
        : A.isVector3 || A.isColor
        ? ((C.boundary = 16), (C.storage = 12))
        : A.isVector4
        ? ((C.boundary = 16), (C.storage = 16))
        : A.isMatrix3
        ? ((C.boundary = 48), (C.storage = 48))
        : A.isMatrix4
        ? ((C.boundary = 64), (C.storage = 64))
        : A.isTexture
        ? console.warn(
            "THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.",
          )
        : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", A),
      C
    )
  }
  function M(A) {
    const C = A.target
    C.removeEventListener("dispose", M)
    const R = o.indexOf(C.__bindingPointIndex)
    o.splice(R, 1), n.deleteBuffer(r[C.id]), delete r[C.id], delete s[C.id]
  }
  function w() {
    for (const A in r) n.deleteBuffer(r[A])
    ;(o = []), (r = {}), (s = {})
  }
  return { bind: u, update: d, dispose: w }
}
class R3 {
  constructor(e = {}) {
    const {
      canvas: t = p3(),
      context: i = null,
      depth: r = !0,
      stencil: s = !1,
      alpha: o = !1,
      antialias: l = !1,
      premultipliedAlpha: u = !0,
      preserveDrawingBuffer: d = !1,
      powerPreference: p = "default",
      failIfMajorPerformanceCaveat: m = !1,
      reverseDepthBuffer: v = !1,
    } = e
    this.isWebGLRenderer = !0
    let y
    if (i !== null) {
      if (typeof WebGLRenderingContext < "u" && i instanceof WebGLRenderingContext)
        throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.")
      y = i.getContextAttributes().alpha
    } else y = o
    const x = new Uint32Array(4),
      E = new Int32Array(4)
    let M = null,
      w = null
    const A = [],
      C = []
    ;(this.domElement = t),
      (this.debug = { checkShaderErrors: !0, onShaderError: null }),
      (this.autoClear = !0),
      (this.autoClearColor = !0),
      (this.autoClearDepth = !0),
      (this.autoClearStencil = !0),
      (this.sortObjects = !0),
      (this.clippingPlanes = []),
      (this.localClippingEnabled = !1),
      (this._outputColorSpace = Kr),
      (this.toneMapping = Xo),
      (this.toneMappingExposure = 1)
    const R = this
    let z = !1,
      U = 0,
      O = 0,
      N = null,
      k = -1,
      I = null
    const V = new on(),
      Z = new on()
    let $ = null
    const ee = new ot(0)
    let ue = 0,
      re = t.width,
      se = t.height,
      G = 1,
      ie = null,
      Q = null
    const W = new on(0, 0, re, se),
      ne = new on(0, 0, re, se)
    let ye = !1
    const oe = new wm()
    let fe = !1,
      we = !1
    const me = new mt(),
      Fe = new mt(),
      ze = new q(),
      Ge = new on(),
      Ue = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: !0,
      }
    let ae = !1
    function Ee() {
      return N === null ? G : 1
    }
    let K = i
    function Ke(X, ge) {
      return t.getContext(X, ge)
    }
    try {
      const X = {
        alpha: !0,
        depth: r,
        stencil: s,
        antialias: l,
        premultipliedAlpha: u,
        preserveDrawingBuffer: d,
        powerPreference: p,
        failIfMajorPerformanceCaveat: m,
      }
      if (
        ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${mm}`),
        t.addEventListener("webglcontextlost", Ve, !1),
        t.addEventListener("webglcontextrestored", lt, !1),
        t.addEventListener("webglcontextcreationerror", at, !1),
        K === null)
      ) {
        const ge = "webgl2"
        if (((K = Ke(ge, X)), K === null))
          throw Ke(ge)
            ? new Error("Error creating WebGL context with your selected attributes.")
            : new Error("Error creating WebGL context.")
      }
    } catch (X) {
      throw (console.error("THREE.WebGLRenderer: " + X.message), X)
    }
    let Be,
      Oe,
      Pe,
      He,
      Se,
      j,
      B,
      ce,
      Me,
      De,
      Ie,
      st,
      tt,
      it,
      Et,
      je,
      Je,
      At,
      Pt,
      ft,
      Wt,
      Nt,
      dn,
      he
    function rt() {
      ;(Be = new $5(K)),
        Be.init(),
        (Nt = new A3(K, Be)),
        (Oe = new G5(K, Be, e, Nt)),
        (Pe = new RV(K, Be)),
        Oe.reverseDepthBuffer && v && Pe.buffers.depth.setReversed(!0),
        (He = new J5(K)),
        (Se = new gV()),
        (j = new kV(K, Be, Pe, Se, Oe, Nt, He)),
        (B = new j5(R)),
        (ce = new q5(R)),
        (Me = new s8(K)),
        (dn = new V5(K, Me)),
        (De = new K5(K, Me, He, dn)),
        (Ie = new ez(K, De, Me, He)),
        (Pt = new Q5(K, Oe, j)),
        (je = new W5(Se)),
        (st = new mV(R, B, ce, Be, Oe, dn, je)),
        (tt = new HV(R, Se)),
        (it = new yV()),
        (Et = new EV(Be)),
        (At = new z5(R, B, ce, Pe, Ie, y, u)),
        (Je = new AV(R, Ie, Oe)),
        (he = new GV(K, He, Oe, Pe)),
        (ft = new H5(K, Be, He)),
        (Wt = new Z5(K, Be, He)),
        (He.programs = st.programs),
        (R.capabilities = Oe),
        (R.extensions = Be),
        (R.properties = Se),
        (R.renderLists = it),
        (R.shadowMap = Je),
        (R.state = Pe),
        (R.info = He)
    }
    rt()
    const Ne = new zV(R, K)
    ;(this.xr = Ne),
      (this.getContext = function () {
        return K
      }),
      (this.getContextAttributes = function () {
        return K.getContextAttributes()
      }),
      (this.forceContextLoss = function () {
        const X = Be.get("WEBGL_lose_context")
        X && X.loseContext()
      }),
      (this.forceContextRestore = function () {
        const X = Be.get("WEBGL_lose_context")
        X && X.restoreContext()
      }),
      (this.getPixelRatio = function () {
        return G
      }),
      (this.setPixelRatio = function (X) {
        X !== void 0 && ((G = X), this.setSize(re, se, !1))
      }),
      (this.getSize = function (X) {
        return X.set(re, se)
      }),
      (this.setSize = function (X, ge, Ae = !0) {
        if (Ne.isPresenting) {
          console.warn(
            "THREE.WebGLRenderer: Can't change size while VR device is presenting.",
          )
          return
        }
        ;(re = X),
          (se = ge),
          (t.width = Math.floor(X * G)),
          (t.height = Math.floor(ge * G)),
          Ae === !0 && ((t.style.width = X + "px"), (t.style.height = ge + "px")),
          this.setViewport(0, 0, X, ge)
      }),
      (this.getDrawingBufferSize = function (X) {
        return X.set(re * G, se * G).floor()
      }),
      (this.setDrawingBufferSize = function (X, ge, Ae) {
        ;(re = X),
          (se = ge),
          (G = Ae),
          (t.width = Math.floor(X * Ae)),
          (t.height = Math.floor(ge * Ae)),
          this.setViewport(0, 0, X, ge)
      }),
      (this.getCurrentViewport = function (X) {
        return X.copy(V)
      }),
      (this.getViewport = function (X) {
        return X.copy(W)
      }),
      (this.setViewport = function (X, ge, Ae, Ce) {
        X.isVector4 ? W.set(X.x, X.y, X.z, X.w) : W.set(X, ge, Ae, Ce),
          Pe.viewport(V.copy(W).multiplyScalar(G).round())
      }),
      (this.getScissor = function (X) {
        return X.copy(ne)
      }),
      (this.setScissor = function (X, ge, Ae, Ce) {
        X.isVector4 ? ne.set(X.x, X.y, X.z, X.w) : ne.set(X, ge, Ae, Ce),
          Pe.scissor(Z.copy(ne).multiplyScalar(G).round())
      }),
      (this.getScissorTest = function () {
        return ye
      }),
      (this.setScissorTest = function (X) {
        Pe.setScissorTest((ye = X))
      }),
      (this.setOpaqueSort = function (X) {
        ie = X
      }),
      (this.setTransparentSort = function (X) {
        Q = X
      }),
      (this.getClearColor = function (X) {
        return X.copy(At.getClearColor())
      }),
      (this.setClearColor = function () {
        At.setClearColor.apply(At, arguments)
      }),
      (this.getClearAlpha = function () {
        return At.getClearAlpha()
      }),
      (this.setClearAlpha = function () {
        At.setClearAlpha.apply(At, arguments)
      }),
      (this.clear = function (X = !0, ge = !0, Ae = !0) {
        let Ce = 0
        if (X) {
          let xe = !1
          if (N !== null) {
            const Qe = N.texture.format
            xe = Qe === Jv || Qe === Zv || Qe === vm
          }
          if (xe) {
            const Qe = N.texture.type,
              qe =
                Qe === wo ||
                Qe === Za ||
                Qe === Id ||
                Qe === Du ||
                Qe === qv ||
                Qe === $v,
              yt = At.getClearColor(),
              xt = At.getClearAlpha(),
              kt = yt.r,
              Ot = yt.g,
              wt = yt.b
            qe
              ? ((x[0] = kt),
                (x[1] = Ot),
                (x[2] = wt),
                (x[3] = xt),
                K.clearBufferuiv(K.COLOR, 0, x))
              : ((E[0] = kt),
                (E[1] = Ot),
                (E[2] = wt),
                (E[3] = xt),
                K.clearBufferiv(K.COLOR, 0, E))
          } else Ce |= K.COLOR_BUFFER_BIT
        }
        ge && (Ce |= K.DEPTH_BUFFER_BIT),
          Ae &&
            ((Ce |= K.STENCIL_BUFFER_BIT),
            this.state.buffers.stencil.setMask(4294967295)),
          K.clear(Ce)
      }),
      (this.clearColor = function () {
        this.clear(!0, !1, !1)
      }),
      (this.clearDepth = function () {
        this.clear(!1, !0, !1)
      }),
      (this.clearStencil = function () {
        this.clear(!1, !1, !0)
      }),
      (this.dispose = function () {
        t.removeEventListener("webglcontextlost", Ve, !1),
          t.removeEventListener("webglcontextrestored", lt, !1),
          t.removeEventListener("webglcontextcreationerror", at, !1),
          it.dispose(),
          Et.dispose(),
          Se.dispose(),
          B.dispose(),
          ce.dispose(),
          Ie.dispose(),
          dn.dispose(),
          he.dispose(),
          st.dispose(),
          Ne.dispose(),
          Ne.removeEventListener("sessionstart", tl),
          Ne.removeEventListener("sessionend", To),
          ys.stop()
      })
    function Ve(X) {
      X.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), (z = !0)
    }
    function lt() {
      console.log("THREE.WebGLRenderer: Context Restored."), (z = !1)
      const X = He.autoReset,
        ge = Je.enabled,
        Ae = Je.autoUpdate,
        Ce = Je.needsUpdate,
        xe = Je.type
      rt(),
        (He.autoReset = X),
        (Je.enabled = ge),
        (Je.autoUpdate = Ae),
        (Je.needsUpdate = Ce),
        (Je.type = xe)
    }
    function at(X) {
      console.error(
        "THREE.WebGLRenderer: A WebGL context could not be created. Reason: ",
        X.statusMessage,
      )
    }
    function Ut(X) {
      const ge = X.target
      ge.removeEventListener("dispose", Ut), vn(ge)
    }
    function vn(X) {
      Vn(X), Se.remove(X)
    }
    function Vn(X) {
      const ge = Se.get(X).programs
      ge !== void 0 &&
        (ge.forEach(function (Ae) {
          st.releaseProgram(Ae)
        }),
        X.isShaderMaterial && st.releaseShaderCache(X))
    }
    this.renderBufferDirect = function (X, ge, Ae, Ce, xe, Qe) {
      ge === null && (ge = Ue)
      const qe = xe.isMesh && xe.matrixWorld.determinant() < 0,
        yt = ju(X, ge, Ae, Ce, xe)
      Pe.setMaterial(Ce, qe)
      let xt = Ae.index,
        kt = 1
      if (Ce.wireframe === !0) {
        if (((xt = De.getWireframeAttribute(Ae)), xt === void 0)) return
        kt = 2
      }
      const Ot = Ae.drawRange,
        wt = Ae.attributes.position
      let $t = Ot.start * kt,
        en = (Ot.start + Ot.count) * kt
      Qe !== null &&
        (($t = Math.max($t, Qe.start * kt)),
        (en = Math.min(en, (Qe.start + Qe.count) * kt))),
        xt !== null
          ? (($t = Math.max($t, 0)), (en = Math.min(en, xt.count)))
          : wt != null && (($t = Math.max($t, 0)), (en = Math.min(en, wt.count)))
      const Tt = en - $t
      if (Tt < 0 || Tt === 1 / 0) return
      dn.setup(xe, Ce, yt, Ae, xt)
      let Yt,
        Ft = ft
      if ((xt !== null && ((Yt = Me.get(xt)), (Ft = Wt), Ft.setIndex(Yt)), xe.isMesh))
        Ce.wireframe === !0
          ? (Pe.setLineWidth(Ce.wireframeLinewidth * Ee()), Ft.setMode(K.LINES))
          : Ft.setMode(K.TRIANGLES)
      else if (xe.isLine) {
        let dt = Ce.linewidth
        dt === void 0 && (dt = 1),
          Pe.setLineWidth(dt * Ee()),
          xe.isLineSegments
            ? Ft.setMode(K.LINES)
            : xe.isLineLoop
            ? Ft.setMode(K.LINE_LOOP)
            : Ft.setMode(K.LINE_STRIP)
      } else xe.isPoints ? Ft.setMode(K.POINTS) : xe.isSprite && Ft.setMode(K.TRIANGLES)
      if (xe.isBatchedMesh)
        if (xe._multiDrawInstances !== null)
          Ft.renderMultiDrawInstances(
            xe._multiDrawStarts,
            xe._multiDrawCounts,
            xe._multiDrawCount,
            xe._multiDrawInstances,
          )
        else if (Be.get("WEBGL_multi_draw"))
          Ft.renderMultiDraw(
            xe._multiDrawStarts,
            xe._multiDrawCounts,
            xe._multiDrawCount,
          )
        else {
          const dt = xe._multiDrawStarts,
            In = xe._multiDrawCounts,
            tn = xe._multiDrawCount,
            Yn = xt ? Me.get(xt).bytesPerElement : 1,
            Ln = Se.get(Ce).currentProgram.getUniforms()
          for (let Hn = 0; Hn < tn; Hn++)
            Ln.setValue(K, "_gl_DrawID", Hn), Ft.render(dt[Hn] / Yn, In[Hn])
        }
      else if (xe.isInstancedMesh) Ft.renderInstances($t, Tt, xe.count)
      else if (Ae.isInstancedBufferGeometry) {
        const dt = Ae._maxInstanceCount !== void 0 ? Ae._maxInstanceCount : 1 / 0,
          In = Math.min(Ae.instanceCount, dt)
        Ft.renderInstances($t, Tt, In)
      } else Ft.render($t, Tt)
    }
    function an(X, ge, Ae) {
      X.transparent === !0 && X.side === Vo && X.forceSinglePass === !1
        ? ((X.side = Ir),
          (X.needsUpdate = !0),
          nl(X, ge, Ae),
          (X.side = $a),
          (X.needsUpdate = !0),
          nl(X, ge, Ae),
          (X.side = Vo))
        : nl(X, ge, Ae)
    }
    ;(this.compile = function (X, ge, Ae = null) {
      Ae === null && (Ae = X),
        (w = Et.get(Ae)),
        w.init(ge),
        C.push(w),
        Ae.traverseVisible(function (xe) {
          xe.isLight &&
            xe.layers.test(ge.layers) &&
            (w.pushLight(xe), xe.castShadow && w.pushShadow(xe))
        }),
        X !== Ae &&
          X.traverseVisible(function (xe) {
            xe.isLight &&
              xe.layers.test(ge.layers) &&
              (w.pushLight(xe), xe.castShadow && w.pushShadow(xe))
          }),
        w.setupLights()
      const Ce = new Set()
      return (
        X.traverse(function (xe) {
          if (!(xe.isMesh || xe.isPoints || xe.isLine || xe.isSprite)) return
          const Qe = xe.material
          if (Qe)
            if (Array.isArray(Qe))
              for (let qe = 0; qe < Qe.length; qe++) {
                const yt = Qe[qe]
                an(yt, Ae, xe), Ce.add(yt)
              }
            else an(Qe, Ae, xe), Ce.add(Qe)
        }),
        C.pop(),
        (w = null),
        Ce
      )
    }),
      (this.compileAsync = function (X, ge, Ae = null) {
        const Ce = this.compile(X, ge, Ae)
        return new Promise((xe) => {
          function Qe() {
            if (
              (Ce.forEach(function (qe) {
                Se.get(qe).currentProgram.isReady() && Ce.delete(qe)
              }),
              Ce.size === 0)
            ) {
              xe(X)
              return
            }
            setTimeout(Qe, 10)
          }
          Be.get("KHR_parallel_shader_compile") !== null ? Qe() : setTimeout(Qe, 10)
        })
      })
    let zi = null
    function Vi(X) {
      zi && zi(X)
    }
    function tl() {
      ys.stop()
    }
    function To() {
      ys.start()
    }
    const ys = new S3()
    ys.setAnimationLoop(Vi),
      typeof self < "u" && ys.setContext(self),
      (this.setAnimationLoop = function (X) {
        ;(zi = X), Ne.setAnimationLoop(X), X === null ? ys.stop() : ys.start()
      }),
      Ne.addEventListener("sessionstart", tl),
      Ne.addEventListener("sessionend", To),
      (this.render = function (X, ge) {
        if (ge !== void 0 && ge.isCamera !== !0) {
          console.error(
            "THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.",
          )
          return
        }
        if (z === !0) return
        if (
          (X.matrixWorldAutoUpdate === !0 && X.updateMatrixWorld(),
          ge.parent === null &&
            ge.matrixWorldAutoUpdate === !0 &&
            ge.updateMatrixWorld(),
          Ne.enabled === !0 &&
            Ne.isPresenting === !0 &&
            (Ne.cameraAutoUpdate === !0 && Ne.updateCamera(ge), (ge = Ne.getCamera())),
          X.isScene === !0 && X.onBeforeRender(R, X, ge, N),
          (w = Et.get(X, C.length)),
          w.init(ge),
          C.push(w),
          Fe.multiplyMatrices(ge.projectionMatrix, ge.matrixWorldInverse),
          oe.setFromProjectionMatrix(Fe),
          (we = this.localClippingEnabled),
          (fe = je.init(this.clippingPlanes, we)),
          (M = it.get(X, A.length)),
          M.init(),
          A.push(M),
          Ne.enabled === !0 && Ne.isPresenting === !0)
        ) {
          const Qe = R.xr.getDepthSensingMesh()
          Qe !== null && ns(Qe, ge, -1 / 0, R.sortObjects)
        }
        ns(X, ge, 0, R.sortObjects),
          M.finish(),
          R.sortObjects === !0 && M.sort(ie, Q),
          (ae =
            Ne.enabled === !1 || Ne.isPresenting === !1 || Ne.hasDepthSensing() === !1),
          ae && At.addToRenderList(M, X),
          this.info.render.frame++,
          fe === !0 && je.beginShadows()
        const Ae = w.state.shadowsArray
        Je.render(Ae, X, ge),
          fe === !0 && je.endShadows(),
          this.info.autoReset === !0 && this.info.reset()
        const Ce = M.opaque,
          xe = M.transmissive
        if ((w.setupLights(), ge.isArrayCamera)) {
          const Qe = ge.cameras
          if (xe.length > 0)
            for (let qe = 0, yt = Qe.length; qe < yt; qe++) {
              const xt = Qe[qe]
              is(Ce, xe, X, xt)
            }
          ae && At.render(X)
          for (let qe = 0, yt = Qe.length; qe < yt; qe++) {
            const xt = Qe[qe]
            ea(M, X, xt, xt.viewport)
          }
        } else xe.length > 0 && is(Ce, xe, X, ge), ae && At.render(X), ea(M, X, ge)
        N !== null &&
          (j.updateMultisampleRenderTarget(N), j.updateRenderTargetMipmap(N)),
          X.isScene === !0 && X.onAfterRender(R, X, ge),
          dn.resetDefaultState(),
          (k = -1),
          (I = null),
          C.pop(),
          C.length > 0
            ? ((w = C[C.length - 1]),
              fe === !0 && je.setGlobalState(R.clippingPlanes, w.state.camera))
            : (w = null),
          A.pop(),
          A.length > 0 ? (M = A[A.length - 1]) : (M = null)
      })
    function ns(X, ge, Ae, Ce) {
      if (X.visible === !1) return
      if (X.layers.test(ge.layers)) {
        if (X.isGroup) Ae = X.renderOrder
        else if (X.isLOD) X.autoUpdate === !0 && X.update(ge)
        else if (X.isLight) w.pushLight(X), X.castShadow && w.pushShadow(X)
        else if (X.isSprite) {
          if (!X.frustumCulled || oe.intersectsSprite(X)) {
            Ce && Ge.setFromMatrixPosition(X.matrixWorld).applyMatrix4(Fe)
            const qe = Ie.update(X),
              yt = X.material
            yt.visible && M.push(X, qe, yt, Ae, Ge.z, null)
          }
        } else if (
          (X.isMesh || X.isLine || X.isPoints) &&
          (!X.frustumCulled || oe.intersectsObject(X))
        ) {
          const qe = Ie.update(X),
            yt = X.material
          if (
            (Ce &&
              (X.boundingSphere !== void 0
                ? (X.boundingSphere === null && X.computeBoundingSphere(),
                  Ge.copy(X.boundingSphere.center))
                : (qe.boundingSphere === null && qe.computeBoundingSphere(),
                  Ge.copy(qe.boundingSphere.center)),
              Ge.applyMatrix4(X.matrixWorld).applyMatrix4(Fe)),
            Array.isArray(yt))
          ) {
            const xt = qe.groups
            for (let kt = 0, Ot = xt.length; kt < Ot; kt++) {
              const wt = xt[kt],
                $t = yt[wt.materialIndex]
              $t && $t.visible && M.push(X, qe, $t, Ae, Ge.z, wt)
            }
          } else yt.visible && M.push(X, qe, yt, Ae, Ge.z, null)
        }
      }
      const Qe = X.children
      for (let qe = 0, yt = Qe.length; qe < yt; qe++) ns(Qe[qe], ge, Ae, Ce)
    }
    function ea(X, ge, Ae, Ce) {
      const xe = X.opaque,
        Qe = X.transmissive,
        qe = X.transparent
      w.setupLightsView(Ae),
        fe === !0 && je.setGlobalState(R.clippingPlanes, Ae),
        Ce && Pe.viewport(V.copy(Ce)),
        xe.length > 0 && bo(xe, ge, Ae),
        Qe.length > 0 && bo(Qe, ge, Ae),
        qe.length > 0 && bo(qe, ge, Ae),
        Pe.buffers.depth.setTest(!0),
        Pe.buffers.depth.setMask(!0),
        Pe.buffers.color.setMask(!0),
        Pe.setPolygonOffset(!1)
    }
    function is(X, ge, Ae, Ce) {
      if ((Ae.isScene === !0 ? Ae.overrideMaterial : null) !== null) return
      w.state.transmissionRenderTarget[Ce.id] === void 0 &&
        (w.state.transmissionRenderTarget[Ce.id] = new So(1, 1, {
          generateMipmaps: !0,
          type:
            Be.has("EXT_color_buffer_half_float") || Be.has("EXT_color_buffer_float")
              ? Gd
              : wo,
          minFilter: Ho,
          samples: 4,
          stencilBuffer: s,
          resolveDepthBuffer: !1,
          resolveStencilBuffer: !1,
          colorSpace: fn.workingColorSpace,
        }))
      const Qe = w.state.transmissionRenderTarget[Ce.id],
        qe = Ce.viewport || V
      Qe.setSize(qe.z, qe.w)
      const yt = R.getRenderTarget()
      R.setRenderTarget(Qe),
        R.getClearColor(ee),
        (ue = R.getClearAlpha()),
        ue < 1 && R.setClearColor(16777215, 0.5),
        R.clear(),
        ae && At.render(Ae)
      const xt = R.toneMapping
      R.toneMapping = Xo
      const kt = Ce.viewport
      if (
        (Ce.viewport !== void 0 && (Ce.viewport = void 0),
        w.setupLightsView(Ce),
        fe === !0 && je.setGlobalState(R.clippingPlanes, Ce),
        bo(X, Ae, Ce),
        j.updateMultisampleRenderTarget(Qe),
        j.updateRenderTargetMipmap(Qe),
        Be.has("WEBGL_multisampled_render_to_texture") === !1)
      ) {
        let Ot = !1
        for (let wt = 0, $t = ge.length; wt < $t; wt++) {
          const en = ge[wt],
            Tt = en.object,
            Yt = en.geometry,
            Ft = en.material,
            dt = en.group
          if (Ft.side === Vo && Tt.layers.test(Ce.layers)) {
            const In = Ft.side
            ;(Ft.side = Ir),
              (Ft.needsUpdate = !0),
              Gu(Tt, Ae, Ce, Yt, Ft, dt),
              (Ft.side = In),
              (Ft.needsUpdate = !0),
              (Ot = !0)
          }
        }
        Ot === !0 &&
          (j.updateMultisampleRenderTarget(Qe), j.updateRenderTargetMipmap(Qe))
      }
      R.setRenderTarget(yt),
        R.setClearColor(ee, ue),
        kt !== void 0 && (Ce.viewport = kt),
        (R.toneMapping = xt)
    }
    function bo(X, ge, Ae) {
      const Ce = ge.isScene === !0 ? ge.overrideMaterial : null
      for (let xe = 0, Qe = X.length; xe < Qe; xe++) {
        const qe = X[xe],
          yt = qe.object,
          xt = qe.geometry,
          kt = Ce === null ? qe.material : Ce,
          Ot = qe.group
        yt.layers.test(Ae.layers) && Gu(yt, ge, Ae, xt, kt, Ot)
      }
    }
    function Gu(X, ge, Ae, Ce, xe, Qe) {
      X.onBeforeRender(R, ge, Ae, Ce, xe, Qe),
        X.modelViewMatrix.multiplyMatrices(Ae.matrixWorldInverse, X.matrixWorld),
        X.normalMatrix.getNormalMatrix(X.modelViewMatrix),
        xe.onBeforeRender(R, ge, Ae, Ce, X, Qe),
        xe.transparent === !0 && xe.side === Vo && xe.forceSinglePass === !1
          ? ((xe.side = Ir),
            (xe.needsUpdate = !0),
            R.renderBufferDirect(Ae, ge, Ce, xe, X, Qe),
            (xe.side = $a),
            (xe.needsUpdate = !0),
            R.renderBufferDirect(Ae, ge, Ce, xe, X, Qe),
            (xe.side = Vo))
          : R.renderBufferDirect(Ae, ge, Ce, xe, X, Qe),
        X.onAfterRender(R, ge, Ae, Ce, xe, Qe)
    }
    function nl(X, ge, Ae) {
      ge.isScene !== !0 && (ge = Ue)
      const Ce = Se.get(X),
        xe = w.state.lights,
        Qe = w.state.shadowsArray,
        qe = xe.state.version,
        yt = st.getParameters(X, xe.state, Qe, ge, Ae),
        xt = st.getProgramCacheKey(yt)
      let kt = Ce.programs
      ;(Ce.environment = X.isMeshStandardMaterial ? ge.environment : null),
        (Ce.fog = ge.fog),
        (Ce.envMap = (X.isMeshStandardMaterial ? ce : B).get(
          X.envMap || Ce.environment,
        )),
        (Ce.envMapRotation =
          Ce.environment !== null && X.envMap === null
            ? ge.environmentRotation
            : X.envMapRotation),
        kt === void 0 &&
          (X.addEventListener("dispose", Ut), (kt = new Map()), (Ce.programs = kt))
      let Ot = kt.get(xt)
      if (Ot !== void 0) {
        if (Ce.currentProgram === Ot && Ce.lightsStateVersion === qe)
          return xs(X, yt), Ot
      } else
        (yt.uniforms = st.getUniforms(X)),
          X.onBeforeCompile(yt, R),
          (Ot = st.acquireProgram(yt, xt)),
          kt.set(xt, Ot),
          (Ce.uniforms = yt.uniforms)
      const wt = Ce.uniforms
      return (
        ((!X.isShaderMaterial && !X.isRawShaderMaterial) || X.clipping === !0) &&
          (wt.clippingPlanes = je.uniform),
        xs(X, yt),
        (Ce.needsLights = Yu(X)),
        (Ce.lightsStateVersion = qe),
        Ce.needsLights &&
          ((wt.ambientLightColor.value = xe.state.ambient),
          (wt.lightProbe.value = xe.state.probe),
          (wt.directionalLights.value = xe.state.directional),
          (wt.directionalLightShadows.value = xe.state.directionalShadow),
          (wt.spotLights.value = xe.state.spot),
          (wt.spotLightShadows.value = xe.state.spotShadow),
          (wt.rectAreaLights.value = xe.state.rectArea),
          (wt.ltc_1.value = xe.state.rectAreaLTC1),
          (wt.ltc_2.value = xe.state.rectAreaLTC2),
          (wt.pointLights.value = xe.state.point),
          (wt.pointLightShadows.value = xe.state.pointShadow),
          (wt.hemisphereLights.value = xe.state.hemi),
          (wt.directionalShadowMap.value = xe.state.directionalShadowMap),
          (wt.directionalShadowMatrix.value = xe.state.directionalShadowMatrix),
          (wt.spotShadowMap.value = xe.state.spotShadowMap),
          (wt.spotLightMatrix.value = xe.state.spotLightMatrix),
          (wt.spotLightMap.value = xe.state.spotLightMap),
          (wt.pointShadowMap.value = xe.state.pointShadowMap),
          (wt.pointShadowMatrix.value = xe.state.pointShadowMatrix)),
        (Ce.currentProgram = Ot),
        (Ce.uniformsList = null),
        Ot
      )
    }
    function Wu(X) {
      if (X.uniformsList === null) {
        const ge = X.currentProgram.getUniforms()
        X.uniformsList = R0.seqWithValue(ge.seq, X.uniforms)
      }
      return X.uniformsList
    }
    function xs(X, ge) {
      const Ae = Se.get(X)
      ;(Ae.outputColorSpace = ge.outputColorSpace),
        (Ae.batching = ge.batching),
        (Ae.batchingColor = ge.batchingColor),
        (Ae.instancing = ge.instancing),
        (Ae.instancingColor = ge.instancingColor),
        (Ae.instancingMorph = ge.instancingMorph),
        (Ae.skinning = ge.skinning),
        (Ae.morphTargets = ge.morphTargets),
        (Ae.morphNormals = ge.morphNormals),
        (Ae.morphColors = ge.morphColors),
        (Ae.morphTargetsCount = ge.morphTargetsCount),
        (Ae.numClippingPlanes = ge.numClippingPlanes),
        (Ae.numIntersection = ge.numClipIntersection),
        (Ae.vertexAlphas = ge.vertexAlphas),
        (Ae.vertexTangents = ge.vertexTangents),
        (Ae.toneMapping = ge.toneMapping)
    }
    function ju(X, ge, Ae, Ce, xe) {
      ge.isScene !== !0 && (ge = Ue), j.resetTextureUnits()
      const Qe = ge.fog,
        qe = Ce.isMeshStandardMaterial ? ge.environment : null,
        yt =
          N === null
            ? R.outputColorSpace
            : N.isXRRenderTarget === !0
            ? N.texture.colorSpace
            : Bu,
        xt = (Ce.isMeshStandardMaterial ? ce : B).get(Ce.envMap || qe),
        kt =
          Ce.vertexColors === !0 &&
          !!Ae.attributes.color &&
          Ae.attributes.color.itemSize === 4,
        Ot = !!Ae.attributes.tangent && (!!Ce.normalMap || Ce.anisotropy > 0),
        wt = !!Ae.morphAttributes.position,
        $t = !!Ae.morphAttributes.normal,
        en = !!Ae.morphAttributes.color
      let Tt = Xo
      Ce.toneMapped && (N === null || N.isXRRenderTarget === !0) && (Tt = R.toneMapping)
      const Yt =
          Ae.morphAttributes.position ||
          Ae.morphAttributes.normal ||
          Ae.morphAttributes.color,
        Ft = Yt !== void 0 ? Yt.length : 0,
        dt = Se.get(Ce),
        In = w.state.lights
      if (fe === !0 && (we === !0 || X !== I)) {
        const An = X === I && Ce.id === k
        je.setState(Ce, X, An)
      }
      let tn = !1
      Ce.version === dt.__version
        ? ((dt.needsLights && dt.lightsStateVersion !== In.state.version) ||
            dt.outputColorSpace !== yt ||
            (xe.isBatchedMesh && dt.batching === !1) ||
            (!xe.isBatchedMesh && dt.batching === !0) ||
            (xe.isBatchedMesh && dt.batchingColor === !0 && xe.colorTexture === null) ||
            (xe.isBatchedMesh && dt.batchingColor === !1 && xe.colorTexture !== null) ||
            (xe.isInstancedMesh && dt.instancing === !1) ||
            (!xe.isInstancedMesh && dt.instancing === !0) ||
            (xe.isSkinnedMesh && dt.skinning === !1) ||
            (!xe.isSkinnedMesh && dt.skinning === !0) ||
            (xe.isInstancedMesh &&
              dt.instancingColor === !0 &&
              xe.instanceColor === null) ||
            (xe.isInstancedMesh &&
              dt.instancingColor === !1 &&
              xe.instanceColor !== null) ||
            (xe.isInstancedMesh &&
              dt.instancingMorph === !0 &&
              xe.morphTexture === null) ||
            (xe.isInstancedMesh &&
              dt.instancingMorph === !1 &&
              xe.morphTexture !== null) ||
            dt.envMap !== xt ||
            (Ce.fog === !0 && dt.fog !== Qe) ||
            (dt.numClippingPlanes !== void 0 &&
              (dt.numClippingPlanes !== je.numPlanes ||
                dt.numIntersection !== je.numIntersection)) ||
            dt.vertexAlphas !== kt ||
            dt.vertexTangents !== Ot ||
            dt.morphTargets !== wt ||
            dt.morphNormals !== $t ||
            dt.morphColors !== en ||
            dt.toneMapping !== Tt ||
            dt.morphTargetsCount !== Ft) &&
          (tn = !0)
        : ((tn = !0), (dt.__version = Ce.version))
      let Yn = dt.currentProgram
      tn === !0 && (Yn = nl(Ce, ge, xe))
      let Ln = !1,
        Hn = !1,
        rs = !1
      const yn = Yn.getUniforms(),
        Hi = dt.uniforms
      if (
        (Pe.useProgram(Yn.program) && ((Ln = !0), (Hn = !0), (rs = !0)),
        Ce.id !== k && ((k = Ce.id), (Hn = !0)),
        Ln || I !== X)
      ) {
        Pe.buffers.depth.getReversed()
          ? (me.copy(X.projectionMatrix),
            PO(me),
            IO(me),
            yn.setValue(K, "projectionMatrix", me))
          : yn.setValue(K, "projectionMatrix", X.projectionMatrix),
          yn.setValue(K, "viewMatrix", X.matrixWorldInverse)
        const Nr = yn.map.cameraPosition
        Nr !== void 0 && Nr.setValue(K, ze.setFromMatrixPosition(X.matrixWorld)),
          Oe.logarithmicDepthBuffer &&
            yn.setValue(K, "logDepthBufFC", 2 / (Math.log(X.far + 1) / Math.LN2)),
          (Ce.isMeshPhongMaterial ||
            Ce.isMeshToonMaterial ||
            Ce.isMeshLambertMaterial ||
            Ce.isMeshBasicMaterial ||
            Ce.isMeshStandardMaterial ||
            Ce.isShaderMaterial) &&
            yn.setValue(K, "isOrthographic", X.isOrthographicCamera === !0),
          I !== X && ((I = X), (Hn = !0), (rs = !0))
      }
      if (xe.isSkinnedMesh) {
        yn.setOptional(K, xe, "bindMatrix"), yn.setOptional(K, xe, "bindMatrixInverse")
        const An = xe.skeleton
        An &&
          (An.boneTexture === null && An.computeBoneTexture(),
          yn.setValue(K, "boneTexture", An.boneTexture, j))
      }
      xe.isBatchedMesh &&
        (yn.setOptional(K, xe, "batchingTexture"),
        yn.setValue(K, "batchingTexture", xe._matricesTexture, j),
        yn.setOptional(K, xe, "batchingIdTexture"),
        yn.setValue(K, "batchingIdTexture", xe._indirectTexture, j),
        yn.setOptional(K, xe, "batchingColorTexture"),
        xe._colorsTexture !== null &&
          yn.setValue(K, "batchingColorTexture", xe._colorsTexture, j))
      const _s = Ae.morphAttributes
      if (
        ((_s.position !== void 0 || _s.normal !== void 0 || _s.color !== void 0) &&
          Pt.update(xe, Ae, Yn),
        (Hn || dt.receiveShadow !== xe.receiveShadow) &&
          ((dt.receiveShadow = xe.receiveShadow),
          yn.setValue(K, "receiveShadow", xe.receiveShadow)),
        Ce.isMeshGouraudMaterial &&
          Ce.envMap !== null &&
          ((Hi.envMap.value = xt),
          (Hi.flipEnvMap.value =
            xt.isCubeTexture && xt.isRenderTargetTexture === !1 ? -1 : 1)),
        Ce.isMeshStandardMaterial &&
          Ce.envMap === null &&
          ge.environment !== null &&
          (Hi.envMapIntensity.value = ge.environmentIntensity),
        Hn &&
          (yn.setValue(K, "toneMappingExposure", R.toneMappingExposure),
          dt.needsLights && Xu(Hi, rs),
          Qe && Ce.fog === !0 && tt.refreshFogUniforms(Hi, Qe),
          tt.refreshMaterialUniforms(
            Hi,
            Ce,
            G,
            se,
            w.state.transmissionRenderTarget[X.id],
          ),
          R0.upload(K, Wu(dt), Hi, j)),
        Ce.isShaderMaterial &&
          Ce.uniformsNeedUpdate === !0 &&
          (R0.upload(K, Wu(dt), Hi, j), (Ce.uniformsNeedUpdate = !1)),
        Ce.isSpriteMaterial && yn.setValue(K, "center", xe.center),
        yn.setValue(K, "modelViewMatrix", xe.modelViewMatrix),
        yn.setValue(K, "normalMatrix", xe.normalMatrix),
        yn.setValue(K, "modelMatrix", xe.matrixWorld),
        Ce.isShaderMaterial || Ce.isRawShaderMaterial)
      ) {
        const An = Ce.uniformsGroups
        for (let Nr = 0, tr = An.length; Nr < tr; Nr++) {
          const qu = An[Nr]
          he.update(qu, Yn), he.bind(qu, Yn)
        }
      }
      return Yn
    }
    function Xu(X, ge) {
      ;(X.ambientLightColor.needsUpdate = ge),
        (X.lightProbe.needsUpdate = ge),
        (X.directionalLights.needsUpdate = ge),
        (X.directionalLightShadows.needsUpdate = ge),
        (X.pointLights.needsUpdate = ge),
        (X.pointLightShadows.needsUpdate = ge),
        (X.spotLights.needsUpdate = ge),
        (X.spotLightShadows.needsUpdate = ge),
        (X.rectAreaLights.needsUpdate = ge),
        (X.hemisphereLights.needsUpdate = ge)
    }
    function Yu(X) {
      return (
        X.isMeshLambertMaterial ||
        X.isMeshToonMaterial ||
        X.isMeshPhongMaterial ||
        X.isMeshStandardMaterial ||
        X.isShadowMaterial ||
        (X.isShaderMaterial && X.lights === !0)
      )
    }
    ;(this.getActiveCubeFace = function () {
      return U
    }),
      (this.getActiveMipmapLevel = function () {
        return O
      }),
      (this.getRenderTarget = function () {
        return N
      }),
      (this.setRenderTargetTextures = function (X, ge, Ae) {
        ;(Se.get(X.texture).__webglTexture = ge),
          (Se.get(X.depthTexture).__webglTexture = Ae)
        const Ce = Se.get(X)
        ;(Ce.__hasExternalTextures = !0),
          (Ce.__autoAllocateDepthBuffer = Ae === void 0),
          Ce.__autoAllocateDepthBuffer ||
            (Be.has("WEBGL_multisampled_render_to_texture") === !0 &&
              (console.warn(
                "THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided",
              ),
              (Ce.__useRenderToTexture = !1)))
      }),
      (this.setRenderTargetFramebuffer = function (X, ge) {
        const Ae = Se.get(X)
        ;(Ae.__webglFramebuffer = ge), (Ae.__useDefaultFramebuffer = ge === void 0)
      }),
      (this.setRenderTarget = function (X, ge = 0, Ae = 0) {
        ;(N = X), (U = ge), (O = Ae)
        let Ce = !0,
          xe = null,
          Qe = !1,
          qe = !1
        if (X) {
          const xt = Se.get(X)
          if (xt.__useDefaultFramebuffer !== void 0)
            Pe.bindFramebuffer(K.FRAMEBUFFER, null), (Ce = !1)
          else if (xt.__webglFramebuffer === void 0) j.setupRenderTarget(X)
          else if (xt.__hasExternalTextures)
            j.rebindTextures(
              X,
              Se.get(X.texture).__webglTexture,
              Se.get(X.depthTexture).__webglTexture,
            )
          else if (X.depthBuffer) {
            const wt = X.depthTexture
            if (xt.__boundDepthTexture !== wt) {
              if (
                wt !== null &&
                Se.has(wt) &&
                (X.width !== wt.image.width || X.height !== wt.image.height)
              )
                throw new Error(
                  "WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.",
                )
              j.setupDepthRenderbuffer(X)
            }
          }
          const kt = X.texture
          ;(kt.isData3DTexture ||
            kt.isDataArrayTexture ||
            kt.isCompressedArrayTexture) &&
            (qe = !0)
          const Ot = Se.get(X).__webglFramebuffer
          X.isWebGLCubeRenderTarget
            ? (Array.isArray(Ot[ge]) ? (xe = Ot[ge][Ae]) : (xe = Ot[ge]), (Qe = !0))
            : X.samples > 0 && j.useMultisampledRTT(X) === !1
            ? (xe = Se.get(X).__webglMultisampledFramebuffer)
            : Array.isArray(Ot)
            ? (xe = Ot[Ae])
            : (xe = Ot),
            V.copy(X.viewport),
            Z.copy(X.scissor),
            ($ = X.scissorTest)
        } else
          V.copy(W).multiplyScalar(G).floor(),
            Z.copy(ne).multiplyScalar(G).floor(),
            ($ = ye)
        if (
          (Pe.bindFramebuffer(K.FRAMEBUFFER, xe) && Ce && Pe.drawBuffers(X, xe),
          Pe.viewport(V),
          Pe.scissor(Z),
          Pe.setScissorTest($),
          Qe)
        ) {
          const xt = Se.get(X.texture)
          K.framebufferTexture2D(
            K.FRAMEBUFFER,
            K.COLOR_ATTACHMENT0,
            K.TEXTURE_CUBE_MAP_POSITIVE_X + ge,
            xt.__webglTexture,
            Ae,
          )
        } else if (qe) {
          const xt = Se.get(X.texture),
            kt = ge || 0
          K.framebufferTextureLayer(
            K.FRAMEBUFFER,
            K.COLOR_ATTACHMENT0,
            xt.__webglTexture,
            Ae || 0,
            kt,
          )
        }
        k = -1
      }),
      (this.readRenderTargetPixels = function (X, ge, Ae, Ce, xe, Qe, qe) {
        if (!(X && X.isWebGLRenderTarget)) {
          console.error(
            "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.",
          )
          return
        }
        let yt = Se.get(X).__webglFramebuffer
        if ((X.isWebGLCubeRenderTarget && qe !== void 0 && (yt = yt[qe]), yt)) {
          Pe.bindFramebuffer(K.FRAMEBUFFER, yt)
          try {
            const xt = X.texture,
              kt = xt.format,
              Ot = xt.type
            if (!Oe.textureFormatReadable(kt)) {
              console.error(
                "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.",
              )
              return
            }
            if (!Oe.textureTypeReadable(Ot)) {
              console.error(
                "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.",
              )
              return
            }
            ge >= 0 &&
              ge <= X.width - Ce &&
              Ae >= 0 &&
              Ae <= X.height - xe &&
              K.readPixels(ge, Ae, Ce, xe, Nt.convert(kt), Nt.convert(Ot), Qe)
          } finally {
            const xt = N !== null ? Se.get(N).__webglFramebuffer : null
            Pe.bindFramebuffer(K.FRAMEBUFFER, xt)
          }
        }
      }),
      (this.readRenderTargetPixelsAsync = async function (X, ge, Ae, Ce, xe, Qe, qe) {
        if (!(X && X.isWebGLRenderTarget))
          throw new Error(
            "THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.",
          )
        let yt = Se.get(X).__webglFramebuffer
        if ((X.isWebGLCubeRenderTarget && qe !== void 0 && (yt = yt[qe]), yt)) {
          const xt = X.texture,
            kt = xt.format,
            Ot = xt.type
          if (!Oe.textureFormatReadable(kt))
            throw new Error(
              "THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.",
            )
          if (!Oe.textureTypeReadable(Ot))
            throw new Error(
              "THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.",
            )
          if (ge >= 0 && ge <= X.width - Ce && Ae >= 0 && Ae <= X.height - xe) {
            Pe.bindFramebuffer(K.FRAMEBUFFER, yt)
            const wt = K.createBuffer()
            K.bindBuffer(K.PIXEL_PACK_BUFFER, wt),
              K.bufferData(K.PIXEL_PACK_BUFFER, Qe.byteLength, K.STREAM_READ),
              K.readPixels(ge, Ae, Ce, xe, Nt.convert(kt), Nt.convert(Ot), 0)
            const $t = N !== null ? Se.get(N).__webglFramebuffer : null
            Pe.bindFramebuffer(K.FRAMEBUFFER, $t)
            const en = K.fenceSync(K.SYNC_GPU_COMMANDS_COMPLETE, 0)
            return (
              K.flush(),
              await RO(K, en, 4),
              K.bindBuffer(K.PIXEL_PACK_BUFFER, wt),
              K.getBufferSubData(K.PIXEL_PACK_BUFFER, 0, Qe),
              K.deleteBuffer(wt),
              K.deleteSync(en),
              Qe
            )
          } else
            throw new Error(
              "THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.",
            )
        }
      }),
      (this.copyFramebufferToTexture = function (X, ge = null, Ae = 0) {
        X.isTexture !== !0 &&
          (hp(
            "WebGLRenderer: copyFramebufferToTexture function signature has changed.",
          ),
          (ge = arguments[0] || null),
          (X = arguments[1]))
        const Ce = Math.pow(2, -Ae),
          xe = Math.floor(X.image.width * Ce),
          Qe = Math.floor(X.image.height * Ce),
          qe = ge !== null ? ge.x : 0,
          yt = ge !== null ? ge.y : 0
        j.setTexture2D(X, 0),
          K.copyTexSubImage2D(K.TEXTURE_2D, Ae, 0, 0, qe, yt, xe, Qe),
          Pe.unbindTexture()
      }),
      (this.copyTextureToTexture = function (X, ge, Ae = null, Ce = null, xe = 0) {
        X.isTexture !== !0 &&
          (hp("WebGLRenderer: copyTextureToTexture function signature has changed."),
          (Ce = arguments[0] || null),
          (X = arguments[1]),
          (ge = arguments[2]),
          (xe = arguments[3] || 0),
          (Ae = null))
        let Qe, qe, yt, xt, kt, Ot, wt, $t, en
        const Tt = X.isCompressedTexture ? X.mipmaps[xe] : X.image
        Ae !== null
          ? ((Qe = Ae.max.x - Ae.min.x),
            (qe = Ae.max.y - Ae.min.y),
            (yt = Ae.isBox3 ? Ae.max.z - Ae.min.z : 1),
            (xt = Ae.min.x),
            (kt = Ae.min.y),
            (Ot = Ae.isBox3 ? Ae.min.z : 0))
          : ((Qe = Tt.width),
            (qe = Tt.height),
            (yt = Tt.depth || 1),
            (xt = 0),
            (kt = 0),
            (Ot = 0)),
          Ce !== null
            ? ((wt = Ce.x), ($t = Ce.y), (en = Ce.z))
            : ((wt = 0), ($t = 0), (en = 0))
        const Yt = Nt.convert(ge.format),
          Ft = Nt.convert(ge.type)
        let dt
        ge.isData3DTexture
          ? (j.setTexture3D(ge, 0), (dt = K.TEXTURE_3D))
          : ge.isDataArrayTexture || ge.isCompressedArrayTexture
          ? (j.setTexture2DArray(ge, 0), (dt = K.TEXTURE_2D_ARRAY))
          : (j.setTexture2D(ge, 0), (dt = K.TEXTURE_2D)),
          K.pixelStorei(K.UNPACK_FLIP_Y_WEBGL, ge.flipY),
          K.pixelStorei(K.UNPACK_PREMULTIPLY_ALPHA_WEBGL, ge.premultiplyAlpha),
          K.pixelStorei(K.UNPACK_ALIGNMENT, ge.unpackAlignment)
        const In = K.getParameter(K.UNPACK_ROW_LENGTH),
          tn = K.getParameter(K.UNPACK_IMAGE_HEIGHT),
          Yn = K.getParameter(K.UNPACK_SKIP_PIXELS),
          Ln = K.getParameter(K.UNPACK_SKIP_ROWS),
          Hn = K.getParameter(K.UNPACK_SKIP_IMAGES)
        K.pixelStorei(K.UNPACK_ROW_LENGTH, Tt.width),
          K.pixelStorei(K.UNPACK_IMAGE_HEIGHT, Tt.height),
          K.pixelStorei(K.UNPACK_SKIP_PIXELS, xt),
          K.pixelStorei(K.UNPACK_SKIP_ROWS, kt),
          K.pixelStorei(K.UNPACK_SKIP_IMAGES, Ot)
        const rs = X.isDataArrayTexture || X.isData3DTexture,
          yn = ge.isDataArrayTexture || ge.isData3DTexture
        if (X.isRenderTargetTexture || X.isDepthTexture) {
          const Hi = Se.get(X),
            _s = Se.get(ge),
            An = Se.get(Hi.__renderTarget),
            Nr = Se.get(_s.__renderTarget)
          Pe.bindFramebuffer(K.READ_FRAMEBUFFER, An.__webglFramebuffer),
            Pe.bindFramebuffer(K.DRAW_FRAMEBUFFER, Nr.__webglFramebuffer)
          for (let tr = 0; tr < yt; tr++)
            rs &&
              K.framebufferTextureLayer(
                K.READ_FRAMEBUFFER,
                K.COLOR_ATTACHMENT0,
                Se.get(X).__webglTexture,
                xe,
                Ot + tr,
              ),
              X.isDepthTexture
                ? (yn &&
                    K.framebufferTextureLayer(
                      K.DRAW_FRAMEBUFFER,
                      K.COLOR_ATTACHMENT0,
                      Se.get(ge).__webglTexture,
                      xe,
                      en + tr,
                    ),
                  K.blitFramebuffer(
                    xt,
                    kt,
                    Qe,
                    qe,
                    wt,
                    $t,
                    Qe,
                    qe,
                    K.DEPTH_BUFFER_BIT,
                    K.NEAREST,
                  ))
                : yn
                ? K.copyTexSubImage3D(dt, xe, wt, $t, en + tr, xt, kt, Qe, qe)
                : K.copyTexSubImage2D(dt, xe, wt, $t, en + tr, xt, kt, Qe, qe)
          Pe.bindFramebuffer(K.READ_FRAMEBUFFER, null),
            Pe.bindFramebuffer(K.DRAW_FRAMEBUFFER, null)
        } else
          yn
            ? X.isDataTexture || X.isData3DTexture
              ? K.texSubImage3D(dt, xe, wt, $t, en, Qe, qe, yt, Yt, Ft, Tt.data)
              : ge.isCompressedArrayTexture
              ? K.compressedTexSubImage3D(dt, xe, wt, $t, en, Qe, qe, yt, Yt, Tt.data)
              : K.texSubImage3D(dt, xe, wt, $t, en, Qe, qe, yt, Yt, Ft, Tt)
            : X.isDataTexture
            ? K.texSubImage2D(K.TEXTURE_2D, xe, wt, $t, Qe, qe, Yt, Ft, Tt.data)
            : X.isCompressedTexture
            ? K.compressedTexSubImage2D(
                K.TEXTURE_2D,
                xe,
                wt,
                $t,
                Tt.width,
                Tt.height,
                Yt,
                Tt.data,
              )
            : K.texSubImage2D(K.TEXTURE_2D, xe, wt, $t, Qe, qe, Yt, Ft, Tt)
        K.pixelStorei(K.UNPACK_ROW_LENGTH, In),
          K.pixelStorei(K.UNPACK_IMAGE_HEIGHT, tn),
          K.pixelStorei(K.UNPACK_SKIP_PIXELS, Yn),
          K.pixelStorei(K.UNPACK_SKIP_ROWS, Ln),
          K.pixelStorei(K.UNPACK_SKIP_IMAGES, Hn),
          xe === 0 && ge.generateMipmaps && K.generateMipmap(dt),
          Pe.unbindTexture()
      }),
      (this.copyTextureToTexture3D = function (X, ge, Ae = null, Ce = null, xe = 0) {
        return (
          X.isTexture !== !0 &&
            (hp(
              "WebGLRenderer: copyTextureToTexture3D function signature has changed.",
            ),
            (Ae = arguments[0] || null),
            (Ce = arguments[1] || null),
            (X = arguments[2]),
            (ge = arguments[3]),
            (xe = arguments[4] || 0)),
          hp(
            'WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.',
          ),
          this.copyTextureToTexture(X, ge, Ae, Ce, xe)
        )
      }),
      (this.initRenderTarget = function (X) {
        Se.get(X).__webglFramebuffer === void 0 && j.setupRenderTarget(X)
      }),
      (this.initTexture = function (X) {
        X.isCubeTexture
          ? j.setTextureCube(X, 0)
          : X.isData3DTexture
          ? j.setTexture3D(X, 0)
          : X.isDataArrayTexture || X.isCompressedArrayTexture
          ? j.setTexture2DArray(X, 0)
          : j.setTexture2D(X, 0),
          Pe.unbindTexture()
      }),
      (this.resetState = function () {
        ;(U = 0), (O = 0), (N = null), Pe.reset(), dn.reset()
      }),
      typeof __THREE_DEVTOOLS__ < "u" &&
        __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }))
  }
  get coordinateSystem() {
    return Go
  }
  get outputColorSpace() {
    return this._outputColorSpace
  }
  set outputColorSpace(e) {
    this._outputColorSpace = e
    const t = this.getContext()
    ;(t.drawingBufferColorspace = fn._getDrawingBufferColorSpace(e)),
      (t.unpackColorSpace = fn._getUnpackColorSpace())
  }
}
class iy {
  constructor(e, t = 25e-5) {
    ;(this.isFogExp2 = !0),
      (this.name = ""),
      (this.color = new ot(e)),
      (this.density = t)
  }
  clone() {
    return new iy(this.color, this.density)
  }
  toJSON() {
    return {
      type: "FogExp2",
      name: this.name,
      color: this.color.getHex(),
      density: this.density,
    }
  }
}
class ry {
  constructor(e, t = 1, i = 1e3) {
    ;(this.isFog = !0),
      (this.name = ""),
      (this.color = new ot(e)),
      (this.near = t),
      (this.far = i)
  }
  clone() {
    return new ry(this.color, this.near, this.far)
  }
  toJSON() {
    return {
      type: "Fog",
      name: this.name,
      color: this.color.getHex(),
      near: this.near,
      far: this.far,
    }
  }
}
let Zp = class extends cn {
  constructor() {
    super(),
      (this.isScene = !0),
      (this.type = "Scene"),
      (this.background = null),
      (this.environment = null),
      (this.fog = null),
      (this.backgroundBlurriness = 0),
      (this.backgroundIntensity = 1),
      (this.backgroundRotation = new Bi()),
      (this.environmentIntensity = 1),
      (this.environmentRotation = new Bi()),
      (this.overrideMaterial = null),
      typeof __THREE_DEVTOOLS__ < "u" &&
        __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", { detail: this }))
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      e.background !== null && (this.background = e.background.clone()),
      e.environment !== null && (this.environment = e.environment.clone()),
      e.fog !== null && (this.fog = e.fog.clone()),
      (this.backgroundBlurriness = e.backgroundBlurriness),
      (this.backgroundIntensity = e.backgroundIntensity),
      this.backgroundRotation.copy(e.backgroundRotation),
      (this.environmentIntensity = e.environmentIntensity),
      this.environmentRotation.copy(e.environmentRotation),
      e.overrideMaterial !== null &&
        (this.overrideMaterial = e.overrideMaterial.clone()),
      (this.matrixAutoUpdate = e.matrixAutoUpdate),
      this
    )
  }
  toJSON(e) {
    const t = super.toJSON(e)
    return (
      this.fog !== null && (t.object.fog = this.fog.toJSON()),
      this.backgroundBlurriness > 0 &&
        (t.object.backgroundBlurriness = this.backgroundBlurriness),
      this.backgroundIntensity !== 1 &&
        (t.object.backgroundIntensity = this.backgroundIntensity),
      (t.object.backgroundRotation = this.backgroundRotation.toArray()),
      this.environmentIntensity !== 1 &&
        (t.object.environmentIntensity = this.environmentIntensity),
      (t.object.environmentRotation = this.environmentRotation.toArray()),
      t
    )
  }
}
class sy {
  constructor(e, t) {
    ;(this.isInterleavedBuffer = !0),
      (this.array = e),
      (this.stride = t),
      (this.count = e !== void 0 ? e.length / t : 0),
      (this.usage = qp),
      (this.updateRanges = []),
      (this.version = 0),
      (this.uuid = vs())
  }
  onUploadCallback() {}
  set needsUpdate(e) {
    e === !0 && this.version++
  }
  setUsage(e) {
    return (this.usage = e), this
  }
  addUpdateRange(e, t) {
    this.updateRanges.push({ start: e, count: t })
  }
  clearUpdateRanges() {
    this.updateRanges.length = 0
  }
  copy(e) {
    return (
      (this.array = new e.array.constructor(e.array)),
      (this.count = e.count),
      (this.stride = e.stride),
      (this.usage = e.usage),
      this
    )
  }
  copyAt(e, t, i) {
    ;(e *= this.stride), (i *= t.stride)
    for (let r = 0, s = this.stride; r < s; r++) this.array[e + r] = t.array[i + r]
    return this
  }
  set(e, t = 0) {
    return this.array.set(e, t), this
  }
  clone(e) {
    e.arrayBuffers === void 0 && (e.arrayBuffers = {}),
      this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = vs()),
      e.arrayBuffers[this.array.buffer._uuid] === void 0 &&
        (e.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer)
    const t = new this.array.constructor(e.arrayBuffers[this.array.buffer._uuid]),
      i = new this.constructor(t, this.stride)
    return i.setUsage(this.usage), i
  }
  onUpload(e) {
    return (this.onUploadCallback = e), this
  }
  toJSON(e) {
    return (
      e.arrayBuffers === void 0 && (e.arrayBuffers = {}),
      this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = vs()),
      e.arrayBuffers[this.array.buffer._uuid] === void 0 &&
        (e.arrayBuffers[this.array.buffer._uuid] = Array.from(
          new Uint32Array(this.array.buffer),
        )),
      {
        uuid: this.uuid,
        buffer: this.array.buffer._uuid,
        type: this.array.constructor.name,
        stride: this.stride,
      }
    )
  }
}
const br = new q()
class ku {
  constructor(e, t, i, r = !1) {
    ;(this.isInterleavedBufferAttribute = !0),
      (this.name = ""),
      (this.data = e),
      (this.itemSize = t),
      (this.offset = i),
      (this.normalized = r)
  }
  get count() {
    return this.data.count
  }
  get array() {
    return this.data.array
  }
  set needsUpdate(e) {
    this.data.needsUpdate = e
  }
  applyMatrix4(e) {
    for (let t = 0, i = this.data.count; t < i; t++)
      br.fromBufferAttribute(this, t),
        br.applyMatrix4(e),
        this.setXYZ(t, br.x, br.y, br.z)
    return this
  }
  applyNormalMatrix(e) {
    for (let t = 0, i = this.count; t < i; t++)
      br.fromBufferAttribute(this, t),
        br.applyNormalMatrix(e),
        this.setXYZ(t, br.x, br.y, br.z)
    return this
  }
  transformDirection(e) {
    for (let t = 0, i = this.count; t < i; t++)
      br.fromBufferAttribute(this, t),
        br.transformDirection(e),
        this.setXYZ(t, br.x, br.y, br.z)
    return this
  }
  getComponent(e, t) {
    let i = this.array[e * this.data.stride + this.offset + t]
    return this.normalized && (i = Cr(i, this.array)), i
  }
  setComponent(e, t, i) {
    return (
      this.normalized && (i = Zt(i, this.array)),
      (this.data.array[e * this.data.stride + this.offset + t] = i),
      this
    )
  }
  setX(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.data.array[e * this.data.stride + this.offset] = t),
      this
    )
  }
  setY(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.data.array[e * this.data.stride + this.offset + 1] = t),
      this
    )
  }
  setZ(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.data.array[e * this.data.stride + this.offset + 2] = t),
      this
    )
  }
  setW(e, t) {
    return (
      this.normalized && (t = Zt(t, this.array)),
      (this.data.array[e * this.data.stride + this.offset + 3] = t),
      this
    )
  }
  getX(e) {
    let t = this.data.array[e * this.data.stride + this.offset]
    return this.normalized && (t = Cr(t, this.array)), t
  }
  getY(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 1]
    return this.normalized && (t = Cr(t, this.array)), t
  }
  getZ(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 2]
    return this.normalized && (t = Cr(t, this.array)), t
  }
  getW(e) {
    let t = this.data.array[e * this.data.stride + this.offset + 3]
    return this.normalized && (t = Cr(t, this.array)), t
  }
  setXY(e, t, i) {
    return (
      (e = e * this.data.stride + this.offset),
      this.normalized && ((t = Zt(t, this.array)), (i = Zt(i, this.array))),
      (this.data.array[e + 0] = t),
      (this.data.array[e + 1] = i),
      this
    )
  }
  setXYZ(e, t, i, r) {
    return (
      (e = e * this.data.stride + this.offset),
      this.normalized &&
        ((t = Zt(t, this.array)), (i = Zt(i, this.array)), (r = Zt(r, this.array))),
      (this.data.array[e + 0] = t),
      (this.data.array[e + 1] = i),
      (this.data.array[e + 2] = r),
      this
    )
  }
  setXYZW(e, t, i, r, s) {
    return (
      (e = e * this.data.stride + this.offset),
      this.normalized &&
        ((t = Zt(t, this.array)),
        (i = Zt(i, this.array)),
        (r = Zt(r, this.array)),
        (s = Zt(s, this.array))),
      (this.data.array[e + 0] = t),
      (this.data.array[e + 1] = i),
      (this.data.array[e + 2] = r),
      (this.data.array[e + 3] = s),
      this
    )
  }
  clone(e) {
    if (e === void 0) {
      console.log(
        "THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.",
      )
      const t = []
      for (let i = 0; i < this.count; i++) {
        const r = i * this.data.stride + this.offset
        for (let s = 0; s < this.itemSize; s++) t.push(this.data.array[r + s])
      }
      return new bn(new this.array.constructor(t), this.itemSize, this.normalized)
    } else
      return (
        e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}),
        e.interleavedBuffers[this.data.uuid] === void 0 &&
          (e.interleavedBuffers[this.data.uuid] = this.data.clone(e)),
        new ku(
          e.interleavedBuffers[this.data.uuid],
          this.itemSize,
          this.offset,
          this.normalized,
        )
      )
  }
  toJSON(e) {
    if (e === void 0) {
      console.log(
        "THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.",
      )
      const t = []
      for (let i = 0; i < this.count; i++) {
        const r = i * this.data.stride + this.offset
        for (let s = 0; s < this.itemSize; s++) t.push(this.data.array[r + s])
      }
      return {
        itemSize: this.itemSize,
        type: this.array.constructor.name,
        array: t,
        normalized: this.normalized,
      }
    } else
      return (
        e.interleavedBuffers === void 0 && (e.interleavedBuffers = {}),
        e.interleavedBuffers[this.data.uuid] === void 0 &&
          (e.interleavedBuffers[this.data.uuid] = this.data.toJSON(e)),
        {
          isInterleavedBufferAttribute: !0,
          itemSize: this.itemSize,
          data: this.data.uuid,
          offset: this.offset,
          normalized: this.normalized,
        }
      )
  }
}
class Ww extends er {
  static get type() {
    return "SpriteMaterial"
  }
  constructor(e) {
    super(),
      (this.isSpriteMaterial = !0),
      (this.color = new ot(16777215)),
      (this.map = null),
      (this.alphaMap = null),
      (this.rotation = 0),
      (this.sizeAttenuation = !0),
      (this.transparent = !0),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      this.color.copy(e.color),
      (this.map = e.map),
      (this.alphaMap = e.alphaMap),
      (this.rotation = e.rotation),
      (this.sizeAttenuation = e.sizeAttenuation),
      (this.fog = e.fog),
      this
    )
  }
}
let ad
const Zh = new q(),
  ld = new q(),
  cd = new q(),
  ud = new We(),
  Jh = new We(),
  P3 = new mt(),
  Kg = new q(),
  Qh = new q(),
  Zg = new q(),
  zT = new We(),
  r_ = new We(),
  VT = new We()
class I3 extends cn {
  constructor(e = new Ww()) {
    if ((super(), (this.isSprite = !0), (this.type = "Sprite"), ad === void 0)) {
      ad = new Gt()
      const t = new Float32Array([
          -0.5, -0.5, 0, 0, 0, 0.5, -0.5, 0, 1, 0, 0.5, 0.5, 0, 1, 1, -0.5, 0.5, 0, 0,
          1,
        ]),
        i = new sy(t, 5)
      ad.setIndex([0, 1, 2, 0, 2, 3]),
        ad.setAttribute("position", new ku(i, 3, 0, !1)),
        ad.setAttribute("uv", new ku(i, 2, 3, !1))
    }
    ;(this.geometry = ad), (this.material = e), (this.center = new We(0.5, 0.5))
  }
  raycast(e, t) {
    e.camera === null &&
      console.error(
        'THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.',
      ),
      ld.setFromMatrixScale(this.matrixWorld),
      P3.copy(e.camera.matrixWorld),
      this.modelViewMatrix.multiplyMatrices(
        e.camera.matrixWorldInverse,
        this.matrixWorld,
      ),
      cd.setFromMatrixPosition(this.modelViewMatrix),
      e.camera.isPerspectiveCamera &&
        this.material.sizeAttenuation === !1 &&
        ld.multiplyScalar(-cd.z)
    const i = this.material.rotation
    let r, s
    i !== 0 && ((s = Math.cos(i)), (r = Math.sin(i)))
    const o = this.center
    Jg(Kg.set(-0.5, -0.5, 0), cd, o, ld, r, s),
      Jg(Qh.set(0.5, -0.5, 0), cd, o, ld, r, s),
      Jg(Zg.set(0.5, 0.5, 0), cd, o, ld, r, s),
      zT.set(0, 0),
      r_.set(1, 0),
      VT.set(1, 1)
    let l = e.ray.intersectTriangle(Kg, Qh, Zg, !1, Zh)
    if (
      l === null &&
      (Jg(Qh.set(-0.5, 0.5, 0), cd, o, ld, r, s),
      r_.set(0, 1),
      (l = e.ray.intersectTriangle(Kg, Zg, Qh, !1, Zh)),
      l === null)
    )
      return
    const u = e.ray.origin.distanceTo(Zh)
    u < e.near ||
      u > e.far ||
      t.push({
        distance: u,
        point: Zh.clone(),
        uv: Zr.getInterpolation(Zh, Kg, Qh, Zg, zT, r_, VT, new We()),
        face: null,
        object: this,
      })
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      e.center !== void 0 && this.center.copy(e.center),
      (this.material = e.material),
      this
    )
  }
}
function Jg(n, e, t, i, r, s) {
  ud.subVectors(n, t).addScalar(0.5).multiply(i),
    r !== void 0
      ? ((Jh.x = s * ud.x - r * ud.y), (Jh.y = r * ud.x + s * ud.y))
      : Jh.copy(ud),
    n.copy(e),
    (n.x += Jh.x),
    (n.y += Jh.y),
    n.applyMatrix4(P3)
}
const Qg = new q(),
  HT = new q()
class L3 extends cn {
  constructor() {
    super(),
      (this._currentLevel = 0),
      (this.type = "LOD"),
      Object.defineProperties(this, {
        levels: { enumerable: !0, value: [] },
        isLOD: { value: !0 },
      }),
      (this.autoUpdate = !0)
  }
  copy(e) {
    super.copy(e, !1)
    const t = e.levels
    for (let i = 0, r = t.length; i < r; i++) {
      const s = t[i]
      this.addLevel(s.object.clone(), s.distance, s.hysteresis)
    }
    return (this.autoUpdate = e.autoUpdate), this
  }
  addLevel(e, t = 0, i = 0) {
    t = Math.abs(t)
    const r = this.levels
    let s
    for (s = 0; s < r.length && !(t < r[s].distance); s++);
    return r.splice(s, 0, { distance: t, hysteresis: i, object: e }), this.add(e), this
  }
  removeLevel(e) {
    const t = this.levels
    for (let i = 0; i < t.length; i++)
      if (t[i].distance === e) {
        const r = t.splice(i, 1)
        return this.remove(r[0].object), !0
      }
    return !1
  }
  getCurrentLevel() {
    return this._currentLevel
  }
  getObjectForDistance(e) {
    const t = this.levels
    if (t.length > 0) {
      let i, r
      for (i = 1, r = t.length; i < r; i++) {
        let s = t[i].distance
        if ((t[i].object.visible && (s -= s * t[i].hysteresis), e < s)) break
      }
      return t[i - 1].object
    }
    return null
  }
  raycast(e, t) {
    if (this.levels.length > 0) {
      Qg.setFromMatrixPosition(this.matrixWorld)
      const r = e.ray.origin.distanceTo(Qg)
      this.getObjectForDistance(r).raycast(e, t)
    }
  }
  update(e) {
    const t = this.levels
    if (t.length > 1) {
      Qg.setFromMatrixPosition(e.matrixWorld),
        HT.setFromMatrixPosition(this.matrixWorld)
      const i = Qg.distanceTo(HT) / e.zoom
      t[0].object.visible = !0
      let r, s
      for (r = 1, s = t.length; r < s; r++) {
        let o = t[r].distance
        if ((t[r].object.visible && (o -= o * t[r].hysteresis), i >= o))
          (t[r - 1].object.visible = !1), (t[r].object.visible = !0)
        else break
      }
      for (this._currentLevel = r - 1; r < s; r++) t[r].object.visible = !1
    }
  }
  toJSON(e) {
    const t = super.toJSON(e)
    this.autoUpdate === !1 && (t.object.autoUpdate = !1), (t.object.levels = [])
    const i = this.levels
    for (let r = 0, s = i.length; r < s; r++) {
      const o = i[r]
      t.object.levels.push({
        object: o.object.uuid,
        distance: o.distance,
        hysteresis: o.hysteresis,
      })
    }
    return t
  }
}
const GT = new q(),
  WT = new on(),
  jT = new on(),
  WV = new q(),
  XT = new mt(),
  e0 = new q(),
  s_ = new pr(),
  YT = new mt(),
  o_ = new Wd()
class jw extends ui {
  constructor(e, t) {
    super(e, t),
      (this.isSkinnedMesh = !0),
      (this.type = "SkinnedMesh"),
      (this.bindMode = w1),
      (this.bindMatrix = new mt()),
      (this.bindMatrixInverse = new mt()),
      (this.boundingBox = null),
      (this.boundingSphere = null)
  }
  computeBoundingBox() {
    const e = this.geometry
    this.boundingBox === null && (this.boundingBox = new Lr()),
      this.boundingBox.makeEmpty()
    const t = e.getAttribute("position")
    for (let i = 0; i < t.count; i++)
      this.getVertexPosition(i, e0), this.boundingBox.expandByPoint(e0)
  }
  computeBoundingSphere() {
    const e = this.geometry
    this.boundingSphere === null && (this.boundingSphere = new pr()),
      this.boundingSphere.makeEmpty()
    const t = e.getAttribute("position")
    for (let i = 0; i < t.count; i++)
      this.getVertexPosition(i, e0), this.boundingSphere.expandByPoint(e0)
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      (this.bindMode = e.bindMode),
      this.bindMatrix.copy(e.bindMatrix),
      this.bindMatrixInverse.copy(e.bindMatrixInverse),
      (this.skeleton = e.skeleton),
      e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()),
      e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()),
      this
    )
  }
  raycast(e, t) {
    const i = this.material,
      r = this.matrixWorld
    i !== void 0 &&
      (this.boundingSphere === null && this.computeBoundingSphere(),
      s_.copy(this.boundingSphere),
      s_.applyMatrix4(r),
      e.ray.intersectsSphere(s_) !== !1 &&
        (YT.copy(r).invert(),
        o_.copy(e.ray).applyMatrix4(YT),
        !(this.boundingBox !== null && o_.intersectsBox(this.boundingBox) === !1) &&
          this._computeIntersections(e, t, o_)))
  }
  getVertexPosition(e, t) {
    return super.getVertexPosition(e, t), this.applyBoneTransform(e, t), t
  }
  bind(e, t) {
    ;(this.skeleton = e),
      t === void 0 &&
        (this.updateMatrixWorld(!0),
        this.skeleton.calculateInverses(),
        (t = this.matrixWorld)),
      this.bindMatrix.copy(t),
      this.bindMatrixInverse.copy(t).invert()
  }
  pose() {
    this.skeleton.pose()
  }
  normalizeSkinWeights() {
    const e = new on(),
      t = this.geometry.attributes.skinWeight
    for (let i = 0, r = t.count; i < r; i++) {
      e.fromBufferAttribute(t, i)
      const s = 1 / e.manhattanLength()
      s !== 1 / 0 ? e.multiplyScalar(s) : e.set(1, 0, 0, 0),
        t.setXYZW(i, e.x, e.y, e.z, e.w)
    }
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e),
      this.bindMode === w1
        ? this.bindMatrixInverse.copy(this.matrixWorld).invert()
        : this.bindMode === QC
        ? this.bindMatrixInverse.copy(this.bindMatrix).invert()
        : console.warn("THREE.SkinnedMesh: Unrecognized bindMode: " + this.bindMode)
  }
  applyBoneTransform(e, t) {
    const i = this.skeleton,
      r = this.geometry
    WT.fromBufferAttribute(r.attributes.skinIndex, e),
      jT.fromBufferAttribute(r.attributes.skinWeight, e),
      GT.copy(t).applyMatrix4(this.bindMatrix),
      t.set(0, 0, 0)
    for (let s = 0; s < 4; s++) {
      const o = jT.getComponent(s)
      if (o !== 0) {
        const l = WT.getComponent(s)
        XT.multiplyMatrices(i.bones[l].matrixWorld, i.boneInverses[l]),
          t.addScaledVector(WV.copy(GT).applyMatrix4(XT), o)
      }
    }
    return t.applyMatrix4(this.bindMatrixInverse)
  }
}
class Jp extends cn {
  constructor() {
    super(), (this.isBone = !0), (this.type = "Bone")
  }
}
class Yo extends zn {
  constructor(e = null, t = 1, i = 1, r, s, o, l, u, d = Qi, p = Qi, m, v) {
    super(null, o, l, u, d, p, r, s, m, v),
      (this.isDataTexture = !0),
      (this.image = { data: e, width: t, height: i }),
      (this.generateMipmaps = !1),
      (this.flipY = !1),
      (this.unpackAlignment = 1)
  }
}
const qT = new mt(),
  jV = new mt()
class Sm {
  constructor(e = [], t = []) {
    ;(this.uuid = vs()),
      (this.bones = e.slice(0)),
      (this.boneInverses = t),
      (this.boneMatrices = null),
      (this.boneTexture = null),
      this.init()
  }
  init() {
    const e = this.bones,
      t = this.boneInverses
    if (((this.boneMatrices = new Float32Array(e.length * 16)), t.length === 0))
      this.calculateInverses()
    else if (e.length !== t.length) {
      console.warn(
        "THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.",
      ),
        (this.boneInverses = [])
      for (let i = 0, r = this.bones.length; i < r; i++)
        this.boneInverses.push(new mt())
    }
  }
  calculateInverses() {
    this.boneInverses.length = 0
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const i = new mt()
      this.bones[e] && i.copy(this.bones[e].matrixWorld).invert(),
        this.boneInverses.push(i)
    }
  }
  pose() {
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const i = this.bones[e]
      i && i.matrixWorld.copy(this.boneInverses[e]).invert()
    }
    for (let e = 0, t = this.bones.length; e < t; e++) {
      const i = this.bones[e]
      i &&
        (i.parent && i.parent.isBone
          ? (i.matrix.copy(i.parent.matrixWorld).invert(),
            i.matrix.multiply(i.matrixWorld))
          : i.matrix.copy(i.matrixWorld),
        i.matrix.decompose(i.position, i.quaternion, i.scale))
    }
  }
  update() {
    const e = this.bones,
      t = this.boneInverses,
      i = this.boneMatrices,
      r = this.boneTexture
    for (let s = 0, o = e.length; s < o; s++) {
      const l = e[s] ? e[s].matrixWorld : jV
      qT.multiplyMatrices(l, t[s]), qT.toArray(i, s * 16)
    }
    r !== null && (r.needsUpdate = !0)
  }
  clone() {
    return new Sm(this.bones, this.boneInverses)
  }
  computeBoneTexture() {
    let e = Math.sqrt(this.bones.length * 4)
    ;(e = Math.ceil(e / 4) * 4), (e = Math.max(e, 4))
    const t = new Float32Array(e * e * 4)
    t.set(this.boneMatrices)
    const i = new Yo(t, e, e, hr, Qr)
    return (i.needsUpdate = !0), (this.boneMatrices = t), (this.boneTexture = i), this
  }
  getBoneByName(e) {
    for (let t = 0, i = this.bones.length; t < i; t++) {
      const r = this.bones[t]
      if (r.name === e) return r
    }
  }
  dispose() {
    this.boneTexture !== null && (this.boneTexture.dispose(), (this.boneTexture = null))
  }
  fromJSON(e, t) {
    this.uuid = e.uuid
    for (let i = 0, r = e.bones.length; i < r; i++) {
      const s = e.bones[i]
      let o = t[s]
      o === void 0 &&
        (console.warn("THREE.Skeleton: No bone found with UUID:", s), (o = new Jp())),
        this.bones.push(o),
        this.boneInverses.push(new mt().fromArray(e.boneInverses[i]))
    }
    return this.init(), this
  }
  toJSON() {
    const e = {
      metadata: { version: 4.6, type: "Skeleton", generator: "Skeleton.toJSON" },
      bones: [],
      boneInverses: [],
    }
    e.uuid = this.uuid
    const t = this.bones,
      i = this.boneInverses
    for (let r = 0, s = t.length; r < s; r++) {
      const o = t[r]
      e.bones.push(o.uuid)
      const l = i[r]
      e.boneInverses.push(l.toArray())
    }
    return e
  }
}
class Nd extends bn {
  constructor(e, t, i, r = 1) {
    super(e, t, i), (this.isInstancedBufferAttribute = !0), (this.meshPerAttribute = r)
  }
  copy(e) {
    return super.copy(e), (this.meshPerAttribute = e.meshPerAttribute), this
  }
  toJSON() {
    const e = super.toJSON()
    return (
      (e.meshPerAttribute = this.meshPerAttribute),
      (e.isInstancedBufferAttribute = !0),
      e
    )
  }
}
const fd = new mt(),
  $T = new mt(),
  t0 = [],
  KT = new Lr(),
  XV = new mt(),
  ep = new ui(),
  tp = new pr()
class D3 extends ui {
  constructor(e, t, i) {
    super(e, t),
      (this.isInstancedMesh = !0),
      (this.instanceMatrix = new Nd(new Float32Array(i * 16), 16)),
      (this.instanceColor = null),
      (this.morphTexture = null),
      (this.count = i),
      (this.boundingBox = null),
      (this.boundingSphere = null)
    for (let r = 0; r < i; r++) this.setMatrixAt(r, XV)
  }
  computeBoundingBox() {
    const e = this.geometry,
      t = this.count
    this.boundingBox === null && (this.boundingBox = new Lr()),
      e.boundingBox === null && e.computeBoundingBox(),
      this.boundingBox.makeEmpty()
    for (let i = 0; i < t; i++)
      this.getMatrixAt(i, fd),
        KT.copy(e.boundingBox).applyMatrix4(fd),
        this.boundingBox.union(KT)
  }
  computeBoundingSphere() {
    const e = this.geometry,
      t = this.count
    this.boundingSphere === null && (this.boundingSphere = new pr()),
      e.boundingSphere === null && e.computeBoundingSphere(),
      this.boundingSphere.makeEmpty()
    for (let i = 0; i < t; i++)
      this.getMatrixAt(i, fd),
        tp.copy(e.boundingSphere).applyMatrix4(fd),
        this.boundingSphere.union(tp)
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      this.instanceMatrix.copy(e.instanceMatrix),
      e.morphTexture !== null && (this.morphTexture = e.morphTexture.clone()),
      e.instanceColor !== null && (this.instanceColor = e.instanceColor.clone()),
      (this.count = e.count),
      e.boundingBox !== null && (this.boundingBox = e.boundingBox.clone()),
      e.boundingSphere !== null && (this.boundingSphere = e.boundingSphere.clone()),
      this
    )
  }
  getColorAt(e, t) {
    t.fromArray(this.instanceColor.array, e * 3)
  }
  getMatrixAt(e, t) {
    t.fromArray(this.instanceMatrix.array, e * 16)
  }
  getMorphAt(e, t) {
    const i = t.morphTargetInfluences,
      r = this.morphTexture.source.data.data,
      s = i.length + 1,
      o = e * s + 1
    for (let l = 0; l < i.length; l++) i[l] = r[o + l]
  }
  raycast(e, t) {
    const i = this.matrixWorld,
      r = this.count
    if (
      ((ep.geometry = this.geometry),
      (ep.material = this.material),
      ep.material !== void 0 &&
        (this.boundingSphere === null && this.computeBoundingSphere(),
        tp.copy(this.boundingSphere),
        tp.applyMatrix4(i),
        e.ray.intersectsSphere(tp) !== !1))
    )
      for (let s = 0; s < r; s++) {
        this.getMatrixAt(s, fd),
          $T.multiplyMatrices(i, fd),
          (ep.matrixWorld = $T),
          ep.raycast(e, t0)
        for (let o = 0, l = t0.length; o < l; o++) {
          const u = t0[o]
          ;(u.instanceId = s), (u.object = this), t.push(u)
        }
        t0.length = 0
      }
  }
  setColorAt(e, t) {
    this.instanceColor === null &&
      (this.instanceColor = new Nd(
        new Float32Array(this.instanceMatrix.count * 3).fill(1),
        3,
      )),
      t.toArray(this.instanceColor.array, e * 3)
  }
  setMatrixAt(e, t) {
    t.toArray(this.instanceMatrix.array, e * 16)
  }
  setMorphAt(e, t) {
    const i = t.morphTargetInfluences,
      r = i.length + 1
    this.morphTexture === null &&
      (this.morphTexture = new Yo(
        new Float32Array(r * this.count),
        r,
        this.count,
        Kv,
        Qr,
      ))
    const s = this.morphTexture.source.data.data
    let o = 0
    for (let d = 0; d < i.length; d++) o += i[d]
    const l = this.geometry.morphTargetsRelative ? 1 : 1 - o,
      u = r * e
    ;(s[u] = l), s.set(i, u + 1)
  }
  updateMorphTargets() {}
  dispose() {
    return (
      this.dispatchEvent({ type: "dispose" }),
      this.morphTexture !== null &&
        (this.morphTexture.dispose(), (this.morphTexture = null)),
      this
    )
  }
}
function a_(n, e) {
  return n - e
}
function YV(n, e) {
  return n.z - e.z
}
function qV(n, e) {
  return e.z - n.z
}
class $V {
  constructor() {
    ;(this.index = 0), (this.pool = []), (this.list = [])
  }
  push(e, t, i, r) {
    const s = this.pool,
      o = this.list
    this.index >= s.length && s.push({ start: -1, count: -1, z: -1, index: -1 })
    const l = s[this.index]
    o.push(l), this.index++, (l.start = e), (l.count = t), (l.z = i), (l.index = r)
  }
  reset() {
    ;(this.list.length = 0), (this.index = 0)
  }
}
const Yr = new mt(),
  KV = new ot(1, 1, 1),
  l_ = new wm(),
  n0 = new Lr(),
  nu = new pr(),
  np = new q(),
  ZT = new q(),
  ZV = new q(),
  c_ = new $V(),
  fr = new ui(),
  i0 = []
function JV(n, e, t = 0) {
  const i = e.itemSize
  if (n.isInterleavedBufferAttribute || n.array.constructor !== e.array.constructor) {
    const r = n.count
    for (let s = 0; s < r; s++)
      for (let o = 0; o < i; o++) e.setComponent(s + t, o, n.getComponent(s, o))
  } else e.array.set(n.array, t * i)
  e.needsUpdate = !0
}
function iu(n, e) {
  if (n.constructor !== e.constructor) {
    const t = Math.min(n.length, e.length)
    for (let i = 0; i < t; i++) e[i] = n[i]
  } else {
    const t = Math.min(n.length, e.length)
    e.set(new n.constructor(n.buffer, 0, t))
  }
}
class N3 extends ui {
  get maxInstanceCount() {
    return this._maxInstanceCount
  }
  get instanceCount() {
    return this._instanceInfo.length - this._availableInstanceIds.length
  }
  get unusedVertexCount() {
    return this._maxVertexCount - this._nextVertexStart
  }
  get unusedIndexCount() {
    return this._maxIndexCount - this._nextIndexStart
  }
  constructor(e, t, i = t * 2, r) {
    super(new Gt(), r),
      (this.isBatchedMesh = !0),
      (this.perObjectFrustumCulled = !0),
      (this.sortObjects = !0),
      (this.boundingBox = null),
      (this.boundingSphere = null),
      (this.customSort = null),
      (this._instanceInfo = []),
      (this._geometryInfo = []),
      (this._availableInstanceIds = []),
      (this._availableGeometryIds = []),
      (this._nextIndexStart = 0),
      (this._nextVertexStart = 0),
      (this._geometryCount = 0),
      (this._visibilityChanged = !0),
      (this._geometryInitialized = !1),
      (this._maxInstanceCount = e),
      (this._maxVertexCount = t),
      (this._maxIndexCount = i),
      (this._multiDrawCounts = new Int32Array(e)),
      (this._multiDrawStarts = new Int32Array(e)),
      (this._multiDrawCount = 0),
      (this._multiDrawInstances = null),
      (this._matricesTexture = null),
      (this._indirectTexture = null),
      (this._colorsTexture = null),
      this._initMatricesTexture(),
      this._initIndirectTexture()
  }
  _initMatricesTexture() {
    let e = Math.sqrt(this._maxInstanceCount * 4)
    ;(e = Math.ceil(e / 4) * 4), (e = Math.max(e, 4))
    const t = new Float32Array(e * e * 4),
      i = new Yo(t, e, e, hr, Qr)
    this._matricesTexture = i
  }
  _initIndirectTexture() {
    let e = Math.sqrt(this._maxInstanceCount)
    e = Math.ceil(e)
    const t = new Uint32Array(e * e),
      i = new Yo(t, e, e, vm, Za)
    this._indirectTexture = i
  }
  _initColorsTexture() {
    let e = Math.sqrt(this._maxInstanceCount)
    e = Math.ceil(e)
    const t = new Float32Array(e * e * 4).fill(1),
      i = new Yo(t, e, e, hr, Qr)
    ;(i.colorSpace = fn.workingColorSpace), (this._colorsTexture = i)
  }
  _initializeGeometry(e) {
    const t = this.geometry,
      i = this._maxVertexCount,
      r = this._maxIndexCount
    if (this._geometryInitialized === !1) {
      for (const s in e.attributes) {
        const o = e.getAttribute(s),
          { array: l, itemSize: u, normalized: d } = o,
          p = new l.constructor(i * u),
          m = new bn(p, u, d)
        t.setAttribute(s, m)
      }
      if (e.getIndex() !== null) {
        const s = i > 65535 ? new Uint32Array(r) : new Uint16Array(r)
        t.setIndex(new bn(s, 1))
      }
      this._geometryInitialized = !0
    }
  }
  _validateGeometry(e) {
    const t = this.geometry
    if (!!e.getIndex() != !!t.getIndex())
      throw new Error('BatchedMesh: All geometries must consistently have "index".')
    for (const i in t.attributes) {
      if (!e.hasAttribute(i))
        throw new Error(
          `BatchedMesh: Added geometry missing "${i}". All geometries must have consistent attributes.`,
        )
      const r = e.getAttribute(i),
        s = t.getAttribute(i)
      if (r.itemSize !== s.itemSize || r.normalized !== s.normalized)
        throw new Error(
          "BatchedMesh: All attributes must have a consistent itemSize and normalized value.",
        )
    }
  }
  setCustomSort(e) {
    return (this.customSort = e), this
  }
  computeBoundingBox() {
    this.boundingBox === null && (this.boundingBox = new Lr())
    const e = this.boundingBox,
      t = this._instanceInfo
    e.makeEmpty()
    for (let i = 0, r = t.length; i < r; i++) {
      if (t[i].active === !1) continue
      const s = t[i].geometryIndex
      this.getMatrixAt(i, Yr),
        this.getBoundingBoxAt(s, n0).applyMatrix4(Yr),
        e.union(n0)
    }
  }
  computeBoundingSphere() {
    this.boundingSphere === null && (this.boundingSphere = new pr())
    const e = this.boundingSphere,
      t = this._instanceInfo
    e.makeEmpty()
    for (let i = 0, r = t.length; i < r; i++) {
      if (t[i].active === !1) continue
      const s = t[i].geometryIndex
      this.getMatrixAt(i, Yr),
        this.getBoundingSphereAt(s, nu).applyMatrix4(Yr),
        e.union(nu)
    }
  }
  addInstance(e) {
    if (
      this._instanceInfo.length >= this.maxInstanceCount &&
      this._availableInstanceIds.length === 0
    )
      throw new Error("BatchedMesh: Maximum item count reached.")
    const i = { visible: !0, active: !0, geometryIndex: e }
    let r = null
    this._availableInstanceIds.length > 0
      ? (this._availableInstanceIds.sort(a_),
        (r = this._availableInstanceIds.shift()),
        (this._instanceInfo[r] = i))
      : ((r = this._instanceInfo.length), this._instanceInfo.push(i))
    const s = this._matricesTexture
    Yr.identity().toArray(s.image.data, r * 16), (s.needsUpdate = !0)
    const o = this._colorsTexture
    return (
      o && (KV.toArray(o.image.data, r * 4), (o.needsUpdate = !0)),
      (this._visibilityChanged = !0),
      r
    )
  }
  addGeometry(e, t = -1, i = -1) {
    this._initializeGeometry(e), this._validateGeometry(e)
    const r = {
        vertexStart: -1,
        vertexCount: -1,
        reservedVertexCount: -1,
        indexStart: -1,
        indexCount: -1,
        reservedIndexCount: -1,
        start: -1,
        count: -1,
        boundingBox: null,
        boundingSphere: null,
        active: !0,
      },
      s = this._geometryInfo
    ;(r.vertexStart = this._nextVertexStart),
      (r.reservedVertexCount = t === -1 ? e.getAttribute("position").count : t)
    const o = e.getIndex()
    if (
      (o !== null &&
        ((r.indexStart = this._nextIndexStart),
        (r.reservedIndexCount = i === -1 ? o.count : i)),
      (r.indexStart !== -1 &&
        r.indexStart + r.reservedIndexCount > this._maxIndexCount) ||
        r.vertexStart + r.reservedVertexCount > this._maxVertexCount)
    )
      throw new Error(
        "BatchedMesh: Reserved space request exceeds the maximum buffer size.",
      )
    let u
    return (
      this._availableGeometryIds.length > 0
        ? (this._availableGeometryIds.sort(a_),
          (u = this._availableGeometryIds.shift()),
          (s[u] = r))
        : ((u = this._geometryCount), this._geometryCount++, s.push(r)),
      this.setGeometryAt(u, e),
      (this._nextIndexStart = r.indexStart + r.reservedIndexCount),
      (this._nextVertexStart = r.vertexStart + r.reservedVertexCount),
      u
    )
  }
  setGeometryAt(e, t) {
    if (e >= this._geometryCount)
      throw new Error("BatchedMesh: Maximum geometry count reached.")
    this._validateGeometry(t)
    const i = this.geometry,
      r = i.getIndex() !== null,
      s = i.getIndex(),
      o = t.getIndex(),
      l = this._geometryInfo[e]
    if (
      (r && o.count > l.reservedIndexCount) ||
      t.attributes.position.count > l.reservedVertexCount
    )
      throw new Error(
        "BatchedMesh: Reserved space not large enough for provided geometry.",
      )
    const u = l.vertexStart,
      d = l.reservedVertexCount
    l.vertexCount = t.getAttribute("position").count
    for (const p in i.attributes) {
      const m = t.getAttribute(p),
        v = i.getAttribute(p)
      JV(m, v, u)
      const y = m.itemSize
      for (let x = m.count, E = d; x < E; x++) {
        const M = u + x
        for (let w = 0; w < y; w++) v.setComponent(M, w, 0)
      }
      ;(v.needsUpdate = !0), v.addUpdateRange(u * y, d * y)
    }
    if (r) {
      const p = l.indexStart,
        m = l.reservedIndexCount
      l.indexCount = t.getIndex().count
      for (let v = 0; v < o.count; v++) s.setX(p + v, u + o.getX(v))
      for (let v = o.count, y = m; v < y; v++) s.setX(p + v, u)
      ;(s.needsUpdate = !0), s.addUpdateRange(p, l.reservedIndexCount)
    }
    return (
      (l.start = r ? l.indexStart : l.vertexStart),
      (l.count = r ? l.indexCount : l.vertexCount),
      (l.boundingBox = null),
      t.boundingBox !== null && (l.boundingBox = t.boundingBox.clone()),
      (l.boundingSphere = null),
      t.boundingSphere !== null && (l.boundingSphere = t.boundingSphere.clone()),
      (this._visibilityChanged = !0),
      e
    )
  }
  deleteGeometry(e) {
    const t = this._geometryInfo
    if (e >= t.length || t[e].active === !1) return this
    const i = this._instanceInfo
    for (let r = 0, s = i.length; r < s; r++)
      i[r].geometryIndex === e && this.deleteInstance(r)
    return (
      (t[e].active = !1),
      this._availableGeometryIds.push(e),
      (this._visibilityChanged = !0),
      this
    )
  }
  deleteInstance(e) {
    const t = this._instanceInfo
    return e >= t.length || t[e].active === !1
      ? this
      : ((t[e].active = !1),
        this._availableInstanceIds.push(e),
        (this._visibilityChanged = !0),
        this)
  }
  optimize() {
    let e = 0,
      t = 0
    const i = this._geometryInfo,
      r = i.map((o, l) => l).sort((o, l) => i[o].vertexStart - i[l].vertexStart),
      s = this.geometry
    for (let o = 0, l = i.length; o < l; o++) {
      const u = r[o],
        d = i[u]
      if (d.active !== !1) {
        if (s.index !== null) {
          if (d.indexStart !== t) {
            const { indexStart: p, vertexStart: m, reservedIndexCount: v } = d,
              y = s.index,
              x = y.array,
              E = e - m
            for (let M = p; M < p + v; M++) x[M] = x[M] + E
            y.array.copyWithin(t, p, p + v), y.addUpdateRange(t, v), (d.indexStart = t)
          }
          t += d.reservedIndexCount
        }
        if (d.vertexStart !== e) {
          const { vertexStart: p, reservedVertexCount: m } = d,
            v = s.attributes
          for (const y in v) {
            const x = v[y],
              { array: E, itemSize: M } = x
            E.copyWithin(e * M, p * M, (p + m) * M), x.addUpdateRange(e * M, m * M)
          }
          d.vertexStart = e
        }
        ;(e += d.reservedVertexCount),
          (d.start = s.index ? d.indexStart : d.vertexStart),
          (this._nextIndexStart = s.index ? d.indexStart + d.reservedIndexCount : 0),
          (this._nextVertexStart = d.vertexStart + d.reservedVertexCount)
      }
    }
    return this
  }
  getBoundingBoxAt(e, t) {
    if (e >= this._geometryCount) return null
    const i = this.geometry,
      r = this._geometryInfo[e]
    if (r.boundingBox === null) {
      const s = new Lr(),
        o = i.index,
        l = i.attributes.position
      for (let u = r.start, d = r.start + r.count; u < d; u++) {
        let p = u
        o && (p = o.getX(p)), s.expandByPoint(np.fromBufferAttribute(l, p))
      }
      r.boundingBox = s
    }
    return t.copy(r.boundingBox), t
  }
  getBoundingSphereAt(e, t) {
    if (e >= this._geometryCount) return null
    const i = this.geometry,
      r = this._geometryInfo[e]
    if (r.boundingSphere === null) {
      const s = new pr()
      this.getBoundingBoxAt(e, n0), n0.getCenter(s.center)
      const o = i.index,
        l = i.attributes.position
      let u = 0
      for (let d = r.start, p = r.start + r.count; d < p; d++) {
        let m = d
        o && (m = o.getX(m)),
          np.fromBufferAttribute(l, m),
          (u = Math.max(u, s.center.distanceToSquared(np)))
      }
      ;(s.radius = Math.sqrt(u)), (r.boundingSphere = s)
    }
    return t.copy(r.boundingSphere), t
  }
  setMatrixAt(e, t) {
    const i = this._instanceInfo,
      r = this._matricesTexture,
      s = this._matricesTexture.image.data
    return e >= i.length || i[e].active === !1
      ? this
      : (t.toArray(s, e * 16), (r.needsUpdate = !0), this)
  }
  getMatrixAt(e, t) {
    const i = this._instanceInfo,
      r = this._matricesTexture.image.data
    return e >= i.length || i[e].active === !1 ? null : t.fromArray(r, e * 16)
  }
  setColorAt(e, t) {
    this._colorsTexture === null && this._initColorsTexture()
    const i = this._colorsTexture,
      r = this._colorsTexture.image.data,
      s = this._instanceInfo
    return e >= s.length || s[e].active === !1
      ? this
      : (t.toArray(r, e * 4), (i.needsUpdate = !0), this)
  }
  getColorAt(e, t) {
    const i = this._colorsTexture.image.data,
      r = this._instanceInfo
    return e >= r.length || r[e].active === !1 ? null : t.fromArray(i, e * 4)
  }
  setVisibleAt(e, t) {
    const i = this._instanceInfo
    return e >= i.length || i[e].active === !1 || i[e].visible === t
      ? this
      : ((i[e].visible = t), (this._visibilityChanged = !0), this)
  }
  getVisibleAt(e) {
    const t = this._instanceInfo
    return e >= t.length || t[e].active === !1 ? !1 : t[e].visible
  }
  setGeometryIdAt(e, t) {
    const i = this._instanceInfo,
      r = this._geometryInfo
    return e >= i.length || i[e].active === !1 || t >= r.length || r[t].active === !1
      ? null
      : ((i[e].geometryIndex = t), this)
  }
  getGeometryIdAt(e) {
    const t = this._instanceInfo
    return e >= t.length || t[e].active === !1 ? -1 : t[e].geometryIndex
  }
  getGeometryRangeAt(e, t = {}) {
    if (e < 0 || e >= this._geometryCount) return null
    const i = this._geometryInfo[e]
    return (
      (t.vertexStart = i.vertexStart),
      (t.vertexCount = i.vertexCount),
      (t.reservedVertexCount = i.reservedVertexCount),
      (t.indexStart = i.indexStart),
      (t.indexCount = i.indexCount),
      (t.reservedIndexCount = i.reservedIndexCount),
      (t.start = i.start),
      (t.count = i.count),
      t
    )
  }
  setInstanceCount(e) {
    const t = this._availableInstanceIds,
      i = this._instanceInfo
    for (t.sort(a_); t[t.length - 1] === i.length; ) i.pop(), t.pop()
    if (e < i.length)
      throw new Error(
        `BatchedMesh: Instance ids outside the range ${e} are being used. Cannot shrink instance count.`,
      )
    const r = new Int32Array(e),
      s = new Int32Array(e)
    iu(this._multiDrawCounts, r),
      iu(this._multiDrawStarts, s),
      (this._multiDrawCounts = r),
      (this._multiDrawStarts = s),
      (this._maxInstanceCount = e)
    const o = this._indirectTexture,
      l = this._matricesTexture,
      u = this._colorsTexture
    o.dispose(),
      this._initIndirectTexture(),
      iu(o.image.data, this._indirectTexture.image.data),
      l.dispose(),
      this._initMatricesTexture(),
      iu(l.image.data, this._matricesTexture.image.data),
      u &&
        (u.dispose(),
        this._initColorsTexture(),
        iu(u.image.data, this._colorsTexture.image.data))
  }
  setGeometrySize(e, t) {
    const i = [...this._geometryInfo].filter((l) => l.active)
    if (Math.max(...i.map((l) => l.vertexStart + l.reservedVertexCount)) > e)
      throw new Error(
        `BatchedMesh: Geometry vertex values are being used outside the range ${t}. Cannot shrink further.`,
      )
    if (
      this.geometry.index &&
      Math.max(...i.map((u) => u.indexStart + u.reservedIndexCount)) > t
    )
      throw new Error(
        `BatchedMesh: Geometry index values are being used outside the range ${t}. Cannot shrink further.`,
      )
    const s = this.geometry
    s.dispose(),
      (this._maxVertexCount = e),
      (this._maxIndexCount = t),
      this._geometryInitialized &&
        ((this._geometryInitialized = !1),
        (this.geometry = new Gt()),
        this._initializeGeometry(s))
    const o = this.geometry
    s.index && iu(s.index.array, o.index.array)
    for (const l in s.attributes) iu(s.attributes[l].array, o.attributes[l].array)
  }
  raycast(e, t) {
    const i = this._instanceInfo,
      r = this._geometryInfo,
      s = this.matrixWorld,
      o = this.geometry
    ;(fr.material = this.material),
      (fr.geometry.index = o.index),
      (fr.geometry.attributes = o.attributes),
      fr.geometry.boundingBox === null && (fr.geometry.boundingBox = new Lr()),
      fr.geometry.boundingSphere === null && (fr.geometry.boundingSphere = new pr())
    for (let l = 0, u = i.length; l < u; l++) {
      if (!i[l].visible || !i[l].active) continue
      const d = i[l].geometryIndex,
        p = r[d]
      fr.geometry.setDrawRange(p.start, p.count),
        this.getMatrixAt(l, fr.matrixWorld).premultiply(s),
        this.getBoundingBoxAt(d, fr.geometry.boundingBox),
        this.getBoundingSphereAt(d, fr.geometry.boundingSphere),
        fr.raycast(e, i0)
      for (let m = 0, v = i0.length; m < v; m++) {
        const y = i0[m]
        ;(y.object = this), (y.batchId = l), t.push(y)
      }
      i0.length = 0
    }
    ;(fr.material = null),
      (fr.geometry.index = null),
      (fr.geometry.attributes = {}),
      fr.geometry.setDrawRange(0, 1 / 0)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.geometry = e.geometry.clone()),
      (this.perObjectFrustumCulled = e.perObjectFrustumCulled),
      (this.sortObjects = e.sortObjects),
      (this.boundingBox = e.boundingBox !== null ? e.boundingBox.clone() : null),
      (this.boundingSphere =
        e.boundingSphere !== null ? e.boundingSphere.clone() : null),
      (this._geometryInfo = e._geometryInfo.map((t) => ({
        ...t,
        boundingBox: t.boundingBox !== null ? t.boundingBox.clone() : null,
        boundingSphere: t.boundingSphere !== null ? t.boundingSphere.clone() : null,
      }))),
      (this._instanceInfo = e._instanceInfo.map((t) => ({ ...t }))),
      (this._maxInstanceCount = e._maxInstanceCount),
      (this._maxVertexCount = e._maxVertexCount),
      (this._maxIndexCount = e._maxIndexCount),
      (this._geometryInitialized = e._geometryInitialized),
      (this._geometryCount = e._geometryCount),
      (this._multiDrawCounts = e._multiDrawCounts.slice()),
      (this._multiDrawStarts = e._multiDrawStarts.slice()),
      (this._matricesTexture = e._matricesTexture.clone()),
      (this._matricesTexture.image.data = this._matricesTexture.image.data.slice()),
      this._colorsTexture !== null &&
        ((this._colorsTexture = e._colorsTexture.clone()),
        (this._colorsTexture.image.data = this._colorsTexture.image.data.slice())),
      this
    )
  }
  dispose() {
    return (
      this.geometry.dispose(),
      this._matricesTexture.dispose(),
      (this._matricesTexture = null),
      this._indirectTexture.dispose(),
      (this._indirectTexture = null),
      this._colorsTexture !== null &&
        (this._colorsTexture.dispose(), (this._colorsTexture = null)),
      this
    )
  }
  onBeforeRender(e, t, i, r, s) {
    if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects)
      return
    const o = r.getIndex(),
      l = o === null ? 1 : o.array.BYTES_PER_ELEMENT,
      u = this._instanceInfo,
      d = this._multiDrawStarts,
      p = this._multiDrawCounts,
      m = this._geometryInfo,
      v = this.perObjectFrustumCulled,
      y = this._indirectTexture,
      x = y.image.data
    v &&
      (Yr.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse).multiply(
        this.matrixWorld,
      ),
      l_.setFromProjectionMatrix(Yr, e.coordinateSystem))
    let E = 0
    if (this.sortObjects) {
      Yr.copy(this.matrixWorld).invert(),
        np.setFromMatrixPosition(i.matrixWorld).applyMatrix4(Yr),
        ZT.set(0, 0, -1).transformDirection(i.matrixWorld).transformDirection(Yr)
      for (let A = 0, C = u.length; A < C; A++)
        if (u[A].visible && u[A].active) {
          const R = u[A].geometryIndex
          this.getMatrixAt(A, Yr), this.getBoundingSphereAt(R, nu).applyMatrix4(Yr)
          let z = !1
          if ((v && (z = !l_.intersectsSphere(nu)), !z)) {
            const U = m[R],
              O = ZV.subVectors(nu.center, np).dot(ZT)
            c_.push(U.start, U.count, O, A)
          }
        }
      const M = c_.list,
        w = this.customSort
      w === null ? M.sort(s.transparent ? qV : YV) : w.call(this, M, i)
      for (let A = 0, C = M.length; A < C; A++) {
        const R = M[A]
        ;(d[E] = R.start * l), (p[E] = R.count), (x[E] = R.index), E++
      }
      c_.reset()
    } else
      for (let M = 0, w = u.length; M < w; M++)
        if (u[M].visible && u[M].active) {
          const A = u[M].geometryIndex
          let C = !1
          if (
            (v &&
              (this.getMatrixAt(M, Yr),
              this.getBoundingSphereAt(A, nu).applyMatrix4(Yr),
              (C = !l_.intersectsSphere(nu))),
            !C)
          ) {
            const R = m[A]
            ;(d[E] = R.start * l), (p[E] = R.count), (x[E] = M), E++
          }
        }
    ;(y.needsUpdate = !0), (this._multiDrawCount = E), (this._visibilityChanged = !1)
  }
  onBeforeShadow(e, t, i, r, s, o) {
    this.onBeforeRender(e, null, r, s, o)
  }
}
class mr extends er {
  static get type() {
    return "LineBasicMaterial"
  }
  constructor(e) {
    super(),
      (this.isLineBasicMaterial = !0),
      (this.color = new ot(16777215)),
      (this.map = null),
      (this.linewidth = 1),
      (this.linecap = "round"),
      (this.linejoin = "round"),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      this.color.copy(e.color),
      (this.map = e.map),
      (this.linewidth = e.linewidth),
      (this.linecap = e.linecap),
      (this.linejoin = e.linejoin),
      (this.fog = e.fog),
      this
    )
  }
}
const Ev = new q(),
  Tv = new q(),
  JT = new mt(),
  ip = new Wd(),
  r0 = new pr(),
  u_ = new q(),
  QT = new q()
class Ja extends cn {
  constructor(e = new Gt(), t = new mr()) {
    super(),
      (this.isLine = !0),
      (this.type = "Line"),
      (this.geometry = e),
      (this.material = t),
      this.updateMorphTargets()
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      (this.material = Array.isArray(e.material) ? e.material.slice() : e.material),
      (this.geometry = e.geometry),
      this
    )
  }
  computeLineDistances() {
    const e = this.geometry
    if (e.index === null) {
      const t = e.attributes.position,
        i = [0]
      for (let r = 1, s = t.count; r < s; r++)
        Ev.fromBufferAttribute(t, r - 1),
          Tv.fromBufferAttribute(t, r),
          (i[r] = i[r - 1]),
          (i[r] += Ev.distanceTo(Tv))
      e.setAttribute("lineDistance", new vt(i, 1))
    } else
      console.warn(
        "THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.",
      )
    return this
  }
  raycast(e, t) {
    const i = this.geometry,
      r = this.matrixWorld,
      s = e.params.Line.threshold,
      o = i.drawRange
    if (
      (i.boundingSphere === null && i.computeBoundingSphere(),
      r0.copy(i.boundingSphere),
      r0.applyMatrix4(r),
      (r0.radius += s),
      e.ray.intersectsSphere(r0) === !1)
    )
      return
    JT.copy(r).invert(), ip.copy(e.ray).applyMatrix4(JT)
    const l = s / ((this.scale.x + this.scale.y + this.scale.z) / 3),
      u = l * l,
      d = this.isLineSegments ? 2 : 1,
      p = i.index,
      v = i.attributes.position
    if (p !== null) {
      const y = Math.max(0, o.start),
        x = Math.min(p.count, o.start + o.count)
      for (let E = y, M = x - 1; E < M; E += d) {
        const w = p.getX(E),
          A = p.getX(E + 1),
          C = s0(this, e, ip, u, w, A)
        C && t.push(C)
      }
      if (this.isLineLoop) {
        const E = p.getX(x - 1),
          M = p.getX(y),
          w = s0(this, e, ip, u, E, M)
        w && t.push(w)
      }
    } else {
      const y = Math.max(0, o.start),
        x = Math.min(v.count, o.start + o.count)
      for (let E = y, M = x - 1; E < M; E += d) {
        const w = s0(this, e, ip, u, E, E + 1)
        w && t.push(w)
      }
      if (this.isLineLoop) {
        const E = s0(this, e, ip, u, x - 1, y)
        E && t.push(E)
      }
    }
  }
  updateMorphTargets() {
    const t = this.geometry.morphAttributes,
      i = Object.keys(t)
    if (i.length > 0) {
      const r = t[i[0]]
      if (r !== void 0) {
        ;(this.morphTargetInfluences = []), (this.morphTargetDictionary = {})
        for (let s = 0, o = r.length; s < o; s++) {
          const l = r[s].name || String(s)
          this.morphTargetInfluences.push(0), (this.morphTargetDictionary[l] = s)
        }
      }
    }
  }
}
function s0(n, e, t, i, r, s) {
  const o = n.geometry.attributes.position
  if (
    (Ev.fromBufferAttribute(o, r),
    Tv.fromBufferAttribute(o, s),
    t.distanceSqToSegment(Ev, Tv, u_, QT) > i)
  )
    return
  u_.applyMatrix4(n.matrixWorld)
  const u = e.ray.origin.distanceTo(u_)
  if (!(u < e.near || u > e.far))
    return {
      distance: u,
      point: QT.clone().applyMatrix4(n.matrixWorld),
      index: r,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: n,
    }
}
const eb = new q(),
  tb = new q()
class Qo extends Ja {
  constructor(e, t) {
    super(e, t), (this.isLineSegments = !0), (this.type = "LineSegments")
  }
  computeLineDistances() {
    const e = this.geometry
    if (e.index === null) {
      const t = e.attributes.position,
        i = []
      for (let r = 0, s = t.count; r < s; r += 2)
        eb.fromBufferAttribute(t, r),
          tb.fromBufferAttribute(t, r + 1),
          (i[r] = r === 0 ? 0 : i[r - 1]),
          (i[r + 1] = i[r] + eb.distanceTo(tb))
      e.setAttribute("lineDistance", new vt(i, 1))
    } else
      console.warn(
        "THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.",
      )
    return this
  }
}
class k3 extends Ja {
  constructor(e, t) {
    super(e, t), (this.isLineLoop = !0), (this.type = "LineLoop")
  }
}
class Xw extends er {
  static get type() {
    return "PointsMaterial"
  }
  constructor(e) {
    super(),
      (this.isPointsMaterial = !0),
      (this.color = new ot(16777215)),
      (this.map = null),
      (this.alphaMap = null),
      (this.size = 1),
      (this.sizeAttenuation = !0),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      this.color.copy(e.color),
      (this.map = e.map),
      (this.alphaMap = e.alphaMap),
      (this.size = e.size),
      (this.sizeAttenuation = e.sizeAttenuation),
      (this.fog = e.fog),
      this
    )
  }
}
const nb = new mt(),
  A1 = new Wd(),
  o0 = new pr(),
  a0 = new q()
class F3 extends cn {
  constructor(e = new Gt(), t = new Xw()) {
    super(),
      (this.isPoints = !0),
      (this.type = "Points"),
      (this.geometry = e),
      (this.material = t),
      this.updateMorphTargets()
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      (this.material = Array.isArray(e.material) ? e.material.slice() : e.material),
      (this.geometry = e.geometry),
      this
    )
  }
  raycast(e, t) {
    const i = this.geometry,
      r = this.matrixWorld,
      s = e.params.Points.threshold,
      o = i.drawRange
    if (
      (i.boundingSphere === null && i.computeBoundingSphere(),
      o0.copy(i.boundingSphere),
      o0.applyMatrix4(r),
      (o0.radius += s),
      e.ray.intersectsSphere(o0) === !1)
    )
      return
    nb.copy(r).invert(), A1.copy(e.ray).applyMatrix4(nb)
    const l = s / ((this.scale.x + this.scale.y + this.scale.z) / 3),
      u = l * l,
      d = i.index,
      m = i.attributes.position
    if (d !== null) {
      const v = Math.max(0, o.start),
        y = Math.min(d.count, o.start + o.count)
      for (let x = v, E = y; x < E; x++) {
        const M = d.getX(x)
        a0.fromBufferAttribute(m, M), ib(a0, M, u, r, e, t, this)
      }
    } else {
      const v = Math.max(0, o.start),
        y = Math.min(m.count, o.start + o.count)
      for (let x = v, E = y; x < E; x++)
        a0.fromBufferAttribute(m, x), ib(a0, x, u, r, e, t, this)
    }
  }
  updateMorphTargets() {
    const t = this.geometry.morphAttributes,
      i = Object.keys(t)
    if (i.length > 0) {
      const r = t[i[0]]
      if (r !== void 0) {
        ;(this.morphTargetInfluences = []), (this.morphTargetDictionary = {})
        for (let s = 0, o = r.length; s < o; s++) {
          const l = r[s].name || String(s)
          this.morphTargetInfluences.push(0), (this.morphTargetDictionary[l] = s)
        }
      }
    }
  }
}
function ib(n, e, t, i, r, s, o) {
  const l = A1.distanceSqToPoint(n)
  if (l < t) {
    const u = new q()
    A1.closestPointToPoint(n, u), u.applyMatrix4(i)
    const d = r.ray.origin.distanceTo(u)
    if (d < r.near || d > r.far) return
    s.push({
      distance: d,
      distanceToRay: Math.sqrt(l),
      point: u,
      index: e,
      face: null,
      faceIndex: null,
      barycoord: null,
      object: o,
    })
  }
}
class QV extends zn {
  constructor(e, t, i, r, s, o, l, u, d) {
    super(e, t, i, r, s, o, l, u, d),
      (this.isVideoTexture = !0),
      (this.minFilter = o !== void 0 ? o : Ri),
      (this.magFilter = s !== void 0 ? s : Ri),
      (this.generateMipmaps = !1)
    const p = this
    function m() {
      ;(p.needsUpdate = !0), e.requestVideoFrameCallback(m)
    }
    "requestVideoFrameCallback" in e && e.requestVideoFrameCallback(m)
  }
  clone() {
    return new this.constructor(this.image).copy(this)
  }
  update() {
    const e = this.image
    "requestVideoFrameCallback" in e === !1 &&
      e.readyState >= e.HAVE_CURRENT_DATA &&
      (this.needsUpdate = !0)
  }
}
class e6 extends zn {
  constructor(e, t) {
    super({ width: e, height: t }),
      (this.isFramebufferTexture = !0),
      (this.magFilter = Qi),
      (this.minFilter = Qi),
      (this.generateMipmaps = !1),
      (this.needsUpdate = !0)
  }
}
class oy extends zn {
  constructor(e, t, i, r, s, o, l, u, d, p, m, v) {
    super(null, o, l, u, d, p, r, s, m, v),
      (this.isCompressedTexture = !0),
      (this.image = { width: t, height: i }),
      (this.mipmaps = e),
      (this.flipY = !1),
      (this.generateMipmaps = !1)
  }
}
class t6 extends oy {
  constructor(e, t, i, r, s, o) {
    super(e, t, i, s, o),
      (this.isCompressedArrayTexture = !0),
      (this.image.depth = r),
      (this.wrapR = Jr),
      (this.layerUpdates = new Set())
  }
  addLayerUpdate(e) {
    this.layerUpdates.add(e)
  }
  clearLayerUpdates() {
    this.layerUpdates.clear()
  }
}
class n6 extends oy {
  constructor(e, t, i) {
    super(void 0, e[0].width, e[0].height, t, i, Ka),
      (this.isCompressedCubeTexture = !0),
      (this.isCubeTexture = !0),
      (this.image = e)
  }
}
class i6 extends zn {
  constructor(e, t, i, r, s, o, l, u, d) {
    super(e, t, i, r, s, o, l, u, d),
      (this.isCanvasTexture = !0),
      (this.needsUpdate = !0)
  }
}
class Os {
  constructor() {
    ;(this.type = "Curve"), (this.arcLengthDivisions = 200)
  }
  getPoint() {
    return console.warn("THREE.Curve: .getPoint() not implemented."), null
  }
  getPointAt(e, t) {
    const i = this.getUtoTmapping(e)
    return this.getPoint(i, t)
  }
  getPoints(e = 5) {
    const t = []
    for (let i = 0; i <= e; i++) t.push(this.getPoint(i / e))
    return t
  }
  getSpacedPoints(e = 5) {
    const t = []
    for (let i = 0; i <= e; i++) t.push(this.getPointAt(i / e))
    return t
  }
  getLength() {
    const e = this.getLengths()
    return e[e.length - 1]
  }
  getLengths(e = this.arcLengthDivisions) {
    if (
      this.cacheArcLengths &&
      this.cacheArcLengths.length === e + 1 &&
      !this.needsUpdate
    )
      return this.cacheArcLengths
    this.needsUpdate = !1
    const t = []
    let i,
      r = this.getPoint(0),
      s = 0
    t.push(0)
    for (let o = 1; o <= e; o++)
      (i = this.getPoint(o / e)), (s += i.distanceTo(r)), t.push(s), (r = i)
    return (this.cacheArcLengths = t), t
  }
  updateArcLengths() {
    ;(this.needsUpdate = !0), this.getLengths()
  }
  getUtoTmapping(e, t) {
    const i = this.getLengths()
    let r = 0
    const s = i.length
    let o
    t ? (o = t) : (o = e * i[s - 1])
    let l = 0,
      u = s - 1,
      d
    for (; l <= u; )
      if (((r = Math.floor(l + (u - l) / 2)), (d = i[r] - o), d < 0)) l = r + 1
      else if (d > 0) u = r - 1
      else {
        u = r
        break
      }
    if (((r = u), i[r] === o)) return r / (s - 1)
    const p = i[r],
      v = i[r + 1] - p,
      y = (o - p) / v
    return (r + y) / (s - 1)
  }
  getTangent(e, t) {
    let r = e - 1e-4,
      s = e + 1e-4
    r < 0 && (r = 0), s > 1 && (s = 1)
    const o = this.getPoint(r),
      l = this.getPoint(s),
      u = t || (o.isVector2 ? new We() : new q())
    return u.copy(l).sub(o).normalize(), u
  }
  getTangentAt(e, t) {
    const i = this.getUtoTmapping(e)
    return this.getTangent(i, t)
  }
  computeFrenetFrames(e, t) {
    const i = new q(),
      r = [],
      s = [],
      o = [],
      l = new q(),
      u = new mt()
    for (let y = 0; y <= e; y++) {
      const x = y / e
      r[y] = this.getTangentAt(x, new q())
    }
    ;(s[0] = new q()), (o[0] = new q())
    let d = Number.MAX_VALUE
    const p = Math.abs(r[0].x),
      m = Math.abs(r[0].y),
      v = Math.abs(r[0].z)
    p <= d && ((d = p), i.set(1, 0, 0)),
      m <= d && ((d = m), i.set(0, 1, 0)),
      v <= d && i.set(0, 0, 1),
      l.crossVectors(r[0], i).normalize(),
      s[0].crossVectors(r[0], l),
      o[0].crossVectors(r[0], s[0])
    for (let y = 1; y <= e; y++) {
      if (
        ((s[y] = s[y - 1].clone()),
        (o[y] = o[y - 1].clone()),
        l.crossVectors(r[y - 1], r[y]),
        l.length() > Number.EPSILON)
      ) {
        l.normalize()
        const x = Math.acos(ri(r[y - 1].dot(r[y]), -1, 1))
        s[y].applyMatrix4(u.makeRotationAxis(l, x))
      }
      o[y].crossVectors(r[y], s[y])
    }
    if (t === !0) {
      let y = Math.acos(ri(s[0].dot(s[e]), -1, 1))
      ;(y /= e), r[0].dot(l.crossVectors(s[0], s[e])) > 0 && (y = -y)
      for (let x = 1; x <= e; x++)
        s[x].applyMatrix4(u.makeRotationAxis(r[x], y * x)),
          o[x].crossVectors(r[x], s[x])
    }
    return { tangents: r, normals: s, binormals: o }
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(e) {
    return (this.arcLengthDivisions = e.arcLengthDivisions), this
  }
  toJSON() {
    const e = { metadata: { version: 4.6, type: "Curve", generator: "Curve.toJSON" } }
    return (e.arcLengthDivisions = this.arcLengthDivisions), (e.type = this.type), e
  }
  fromJSON(e) {
    return (this.arcLengthDivisions = e.arcLengthDivisions), this
  }
}
class ay extends Os {
  constructor(e = 0, t = 0, i = 1, r = 1, s = 0, o = Math.PI * 2, l = !1, u = 0) {
    super(),
      (this.isEllipseCurve = !0),
      (this.type = "EllipseCurve"),
      (this.aX = e),
      (this.aY = t),
      (this.xRadius = i),
      (this.yRadius = r),
      (this.aStartAngle = s),
      (this.aEndAngle = o),
      (this.aClockwise = l),
      (this.aRotation = u)
  }
  getPoint(e, t = new We()) {
    const i = t,
      r = Math.PI * 2
    let s = this.aEndAngle - this.aStartAngle
    const o = Math.abs(s) < Number.EPSILON
    for (; s < 0; ) s += r
    for (; s > r; ) s -= r
    s < Number.EPSILON && (o ? (s = 0) : (s = r)),
      this.aClockwise === !0 && !o && (s === r ? (s = -r) : (s = s - r))
    const l = this.aStartAngle + e * s
    let u = this.aX + this.xRadius * Math.cos(l),
      d = this.aY + this.yRadius * Math.sin(l)
    if (this.aRotation !== 0) {
      const p = Math.cos(this.aRotation),
        m = Math.sin(this.aRotation),
        v = u - this.aX,
        y = d - this.aY
      ;(u = v * p - y * m + this.aX), (d = v * m + y * p + this.aY)
    }
    return i.set(u, d)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.aX = e.aX),
      (this.aY = e.aY),
      (this.xRadius = e.xRadius),
      (this.yRadius = e.yRadius),
      (this.aStartAngle = e.aStartAngle),
      (this.aEndAngle = e.aEndAngle),
      (this.aClockwise = e.aClockwise),
      (this.aRotation = e.aRotation),
      this
    )
  }
  toJSON() {
    const e = super.toJSON()
    return (
      (e.aX = this.aX),
      (e.aY = this.aY),
      (e.xRadius = this.xRadius),
      (e.yRadius = this.yRadius),
      (e.aStartAngle = this.aStartAngle),
      (e.aEndAngle = this.aEndAngle),
      (e.aClockwise = this.aClockwise),
      (e.aRotation = this.aRotation),
      e
    )
  }
  fromJSON(e) {
    return (
      super.fromJSON(e),
      (this.aX = e.aX),
      (this.aY = e.aY),
      (this.xRadius = e.xRadius),
      (this.yRadius = e.yRadius),
      (this.aStartAngle = e.aStartAngle),
      (this.aEndAngle = e.aEndAngle),
      (this.aClockwise = e.aClockwise),
      (this.aRotation = e.aRotation),
      this
    )
  }
}
class U3 extends ay {
  constructor(e, t, i, r, s, o) {
    super(e, t, i, i, r, s, o), (this.isArcCurve = !0), (this.type = "ArcCurve")
  }
}
function Yw() {
  let n = 0,
    e = 0,
    t = 0,
    i = 0
  function r(s, o, l, u) {
    ;(n = s), (e = l), (t = -3 * s + 3 * o - 2 * l - u), (i = 2 * s - 2 * o + l + u)
  }
  return {
    initCatmullRom: function (s, o, l, u, d) {
      r(o, l, d * (l - s), d * (u - o))
    },
    initNonuniformCatmullRom: function (s, o, l, u, d, p, m) {
      let v = (o - s) / d - (l - s) / (d + p) + (l - o) / p,
        y = (l - o) / p - (u - o) / (p + m) + (u - l) / m
      ;(v *= p), (y *= p), r(o, l, v, y)
    },
    calc: function (s) {
      const o = s * s,
        l = o * s
      return n + e * s + t * o + i * l
    },
  }
}
const l0 = new q(),
  f_ = new Yw(),
  d_ = new Yw(),
  h_ = new Yw()
class O3 extends Os {
  constructor(e = [], t = !1, i = "centripetal", r = 0.5) {
    super(),
      (this.isCatmullRomCurve3 = !0),
      (this.type = "CatmullRomCurve3"),
      (this.points = e),
      (this.closed = t),
      (this.curveType = i),
      (this.tension = r)
  }
  getPoint(e, t = new q()) {
    const i = t,
      r = this.points,
      s = r.length,
      o = (s - (this.closed ? 0 : 1)) * e
    let l = Math.floor(o),
      u = o - l
    this.closed
      ? (l += l > 0 ? 0 : (Math.floor(Math.abs(l) / s) + 1) * s)
      : u === 0 && l === s - 1 && ((l = s - 2), (u = 1))
    let d, p
    this.closed || l > 0
      ? (d = r[(l - 1) % s])
      : (l0.subVectors(r[0], r[1]).add(r[0]), (d = l0))
    const m = r[l % s],
      v = r[(l + 1) % s]
    if (
      (this.closed || l + 2 < s
        ? (p = r[(l + 2) % s])
        : (l0.subVectors(r[s - 1], r[s - 2]).add(r[s - 1]), (p = l0)),
      this.curveType === "centripetal" || this.curveType === "chordal")
    ) {
      const y = this.curveType === "chordal" ? 0.5 : 0.25
      let x = Math.pow(d.distanceToSquared(m), y),
        E = Math.pow(m.distanceToSquared(v), y),
        M = Math.pow(v.distanceToSquared(p), y)
      E < 1e-4 && (E = 1),
        x < 1e-4 && (x = E),
        M < 1e-4 && (M = E),
        f_.initNonuniformCatmullRom(d.x, m.x, v.x, p.x, x, E, M),
        d_.initNonuniformCatmullRom(d.y, m.y, v.y, p.y, x, E, M),
        h_.initNonuniformCatmullRom(d.z, m.z, v.z, p.z, x, E, M)
    } else
      this.curveType === "catmullrom" &&
        (f_.initCatmullRom(d.x, m.x, v.x, p.x, this.tension),
        d_.initCatmullRom(d.y, m.y, v.y, p.y, this.tension),
        h_.initCatmullRom(d.z, m.z, v.z, p.z, this.tension))
    return i.set(f_.calc(u), d_.calc(u), h_.calc(u)), i
  }
  copy(e) {
    super.copy(e), (this.points = [])
    for (let t = 0, i = e.points.length; t < i; t++) {
      const r = e.points[t]
      this.points.push(r.clone())
    }
    return (
      (this.closed = e.closed),
      (this.curveType = e.curveType),
      (this.tension = e.tension),
      this
    )
  }
  toJSON() {
    const e = super.toJSON()
    e.points = []
    for (let t = 0, i = this.points.length; t < i; t++) {
      const r = this.points[t]
      e.points.push(r.toArray())
    }
    return (
      (e.closed = this.closed),
      (e.curveType = this.curveType),
      (e.tension = this.tension),
      e
    )
  }
  fromJSON(e) {
    super.fromJSON(e), (this.points = [])
    for (let t = 0, i = e.points.length; t < i; t++) {
      const r = e.points[t]
      this.points.push(new q().fromArray(r))
    }
    return (
      (this.closed = e.closed),
      (this.curveType = e.curveType),
      (this.tension = e.tension),
      this
    )
  }
}
function rb(n, e, t, i, r) {
  const s = (i - e) * 0.5,
    o = (r - t) * 0.5,
    l = n * n,
    u = n * l
  return (2 * t - 2 * i + s + o) * u + (-3 * t + 3 * i - 2 * s - o) * l + s * n + t
}
function r6(n, e) {
  const t = 1 - n
  return t * t * e
}
function s6(n, e) {
  return 2 * (1 - n) * n * e
}
function o6(n, e) {
  return n * n * e
}
function Lp(n, e, t, i) {
  return r6(n, e) + s6(n, t) + o6(n, i)
}
function a6(n, e) {
  const t = 1 - n
  return t * t * t * e
}
function l6(n, e) {
  const t = 1 - n
  return 3 * t * t * n * e
}
function c6(n, e) {
  return 3 * (1 - n) * n * n * e
}
function u6(n, e) {
  return n * n * n * e
}
function Dp(n, e, t, i, r) {
  return a6(n, e) + l6(n, t) + c6(n, i) + u6(n, r)
}
class qw extends Os {
  constructor(e = new We(), t = new We(), i = new We(), r = new We()) {
    super(),
      (this.isCubicBezierCurve = !0),
      (this.type = "CubicBezierCurve"),
      (this.v0 = e),
      (this.v1 = t),
      (this.v2 = i),
      (this.v3 = r)
  }
  getPoint(e, t = new We()) {
    const i = t,
      r = this.v0,
      s = this.v1,
      o = this.v2,
      l = this.v3
    return i.set(Dp(e, r.x, s.x, o.x, l.x), Dp(e, r.y, s.y, o.y, l.y)), i
  }
  copy(e) {
    return (
      super.copy(e),
      this.v0.copy(e.v0),
      this.v1.copy(e.v1),
      this.v2.copy(e.v2),
      this.v3.copy(e.v3),
      this
    )
  }
  toJSON() {
    const e = super.toJSON()
    return (
      (e.v0 = this.v0.toArray()),
      (e.v1 = this.v1.toArray()),
      (e.v2 = this.v2.toArray()),
      (e.v3 = this.v3.toArray()),
      e
    )
  }
  fromJSON(e) {
    return (
      super.fromJSON(e),
      this.v0.fromArray(e.v0),
      this.v1.fromArray(e.v1),
      this.v2.fromArray(e.v2),
      this.v3.fromArray(e.v3),
      this
    )
  }
}
class B3 extends Os {
  constructor(e = new q(), t = new q(), i = new q(), r = new q()) {
    super(),
      (this.isCubicBezierCurve3 = !0),
      (this.type = "CubicBezierCurve3"),
      (this.v0 = e),
      (this.v1 = t),
      (this.v2 = i),
      (this.v3 = r)
  }
  getPoint(e, t = new q()) {
    const i = t,
      r = this.v0,
      s = this.v1,
      o = this.v2,
      l = this.v3
    return (
      i.set(
        Dp(e, r.x, s.x, o.x, l.x),
        Dp(e, r.y, s.y, o.y, l.y),
        Dp(e, r.z, s.z, o.z, l.z),
      ),
      i
    )
  }
  copy(e) {
    return (
      super.copy(e),
      this.v0.copy(e.v0),
      this.v1.copy(e.v1),
      this.v2.copy(e.v2),
      this.v3.copy(e.v3),
      this
    )
  }
  toJSON() {
    const e = super.toJSON()
    return (
      (e.v0 = this.v0.toArray()),
      (e.v1 = this.v1.toArray()),
      (e.v2 = this.v2.toArray()),
      (e.v3 = this.v3.toArray()),
      e
    )
  }
  fromJSON(e) {
    return (
      super.fromJSON(e),
      this.v0.fromArray(e.v0),
      this.v1.fromArray(e.v1),
      this.v2.fromArray(e.v2),
      this.v3.fromArray(e.v3),
      this
    )
  }
}
class $w extends Os {
  constructor(e = new We(), t = new We()) {
    super(),
      (this.isLineCurve = !0),
      (this.type = "LineCurve"),
      (this.v1 = e),
      (this.v2 = t)
  }
  getPoint(e, t = new We()) {
    const i = t
    return (
      e === 1
        ? i.copy(this.v2)
        : (i.copy(this.v2).sub(this.v1), i.multiplyScalar(e).add(this.v1)),
      i
    )
  }
  getPointAt(e, t) {
    return this.getPoint(e, t)
  }
  getTangent(e, t = new We()) {
    return t.subVectors(this.v2, this.v1).normalize()
  }
  getTangentAt(e, t) {
    return this.getTangent(e, t)
  }
  copy(e) {
    return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this
  }
  toJSON() {
    const e = super.toJSON()
    return (e.v1 = this.v1.toArray()), (e.v2 = this.v2.toArray()), e
  }
  fromJSON(e) {
    return super.fromJSON(e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this
  }
}
class z3 extends Os {
  constructor(e = new q(), t = new q()) {
    super(),
      (this.isLineCurve3 = !0),
      (this.type = "LineCurve3"),
      (this.v1 = e),
      (this.v2 = t)
  }
  getPoint(e, t = new q()) {
    const i = t
    return (
      e === 1
        ? i.copy(this.v2)
        : (i.copy(this.v2).sub(this.v1), i.multiplyScalar(e).add(this.v1)),
      i
    )
  }
  getPointAt(e, t) {
    return this.getPoint(e, t)
  }
  getTangent(e, t = new q()) {
    return t.subVectors(this.v2, this.v1).normalize()
  }
  getTangentAt(e, t) {
    return this.getTangent(e, t)
  }
  copy(e) {
    return super.copy(e), this.v1.copy(e.v1), this.v2.copy(e.v2), this
  }
  toJSON() {
    const e = super.toJSON()
    return (e.v1 = this.v1.toArray()), (e.v2 = this.v2.toArray()), e
  }
  fromJSON(e) {
    return super.fromJSON(e), this.v1.fromArray(e.v1), this.v2.fromArray(e.v2), this
  }
}
class Kw extends Os {
  constructor(e = new We(), t = new We(), i = new We()) {
    super(),
      (this.isQuadraticBezierCurve = !0),
      (this.type = "QuadraticBezierCurve"),
      (this.v0 = e),
      (this.v1 = t),
      (this.v2 = i)
  }
  getPoint(e, t = new We()) {
    const i = t,
      r = this.v0,
      s = this.v1,
      o = this.v2
    return i.set(Lp(e, r.x, s.x, o.x), Lp(e, r.y, s.y, o.y)), i
  }
  copy(e) {
    return (
      super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this
    )
  }
  toJSON() {
    const e = super.toJSON()
    return (
      (e.v0 = this.v0.toArray()),
      (e.v1 = this.v1.toArray()),
      (e.v2 = this.v2.toArray()),
      e
    )
  }
  fromJSON(e) {
    return (
      super.fromJSON(e),
      this.v0.fromArray(e.v0),
      this.v1.fromArray(e.v1),
      this.v2.fromArray(e.v2),
      this
    )
  }
}
class Zw extends Os {
  constructor(e = new q(), t = new q(), i = new q()) {
    super(),
      (this.isQuadraticBezierCurve3 = !0),
      (this.type = "QuadraticBezierCurve3"),
      (this.v0 = e),
      (this.v1 = t),
      (this.v2 = i)
  }
  getPoint(e, t = new q()) {
    const i = t,
      r = this.v0,
      s = this.v1,
      o = this.v2
    return i.set(Lp(e, r.x, s.x, o.x), Lp(e, r.y, s.y, o.y), Lp(e, r.z, s.z, o.z)), i
  }
  copy(e) {
    return (
      super.copy(e), this.v0.copy(e.v0), this.v1.copy(e.v1), this.v2.copy(e.v2), this
    )
  }
  toJSON() {
    const e = super.toJSON()
    return (
      (e.v0 = this.v0.toArray()),
      (e.v1 = this.v1.toArray()),
      (e.v2 = this.v2.toArray()),
      e
    )
  }
  fromJSON(e) {
    return (
      super.fromJSON(e),
      this.v0.fromArray(e.v0),
      this.v1.fromArray(e.v1),
      this.v2.fromArray(e.v2),
      this
    )
  }
}
class Jw extends Os {
  constructor(e = []) {
    super(), (this.isSplineCurve = !0), (this.type = "SplineCurve"), (this.points = e)
  }
  getPoint(e, t = new We()) {
    const i = t,
      r = this.points,
      s = (r.length - 1) * e,
      o = Math.floor(s),
      l = s - o,
      u = r[o === 0 ? o : o - 1],
      d = r[o],
      p = r[o > r.length - 2 ? r.length - 1 : o + 1],
      m = r[o > r.length - 3 ? r.length - 1 : o + 2]
    return i.set(rb(l, u.x, d.x, p.x, m.x), rb(l, u.y, d.y, p.y, m.y)), i
  }
  copy(e) {
    super.copy(e), (this.points = [])
    for (let t = 0, i = e.points.length; t < i; t++) {
      const r = e.points[t]
      this.points.push(r.clone())
    }
    return this
  }
  toJSON() {
    const e = super.toJSON()
    e.points = []
    for (let t = 0, i = this.points.length; t < i; t++) {
      const r = this.points[t]
      e.points.push(r.toArray())
    }
    return e
  }
  fromJSON(e) {
    super.fromJSON(e), (this.points = [])
    for (let t = 0, i = e.points.length; t < i; t++) {
      const r = e.points[t]
      this.points.push(new We().fromArray(r))
    }
    return this
  }
}
var bv = Object.freeze({
  __proto__: null,
  ArcCurve: U3,
  CatmullRomCurve3: O3,
  CubicBezierCurve: qw,
  CubicBezierCurve3: B3,
  EllipseCurve: ay,
  LineCurve: $w,
  LineCurve3: z3,
  QuadraticBezierCurve: Kw,
  QuadraticBezierCurve3: Zw,
  SplineCurve: Jw,
})
class V3 extends Os {
  constructor() {
    super(), (this.type = "CurvePath"), (this.curves = []), (this.autoClose = !1)
  }
  add(e) {
    this.curves.push(e)
  }
  closePath() {
    const e = this.curves[0].getPoint(0),
      t = this.curves[this.curves.length - 1].getPoint(1)
    if (!e.equals(t)) {
      const i = e.isVector2 === !0 ? "LineCurve" : "LineCurve3"
      this.curves.push(new bv[i](t, e))
    }
    return this
  }
  getPoint(e, t) {
    const i = e * this.getLength(),
      r = this.getCurveLengths()
    let s = 0
    for (; s < r.length; ) {
      if (r[s] >= i) {
        const o = r[s] - i,
          l = this.curves[s],
          u = l.getLength(),
          d = u === 0 ? 0 : 1 - o / u
        return l.getPointAt(d, t)
      }
      s++
    }
    return null
  }
  getLength() {
    const e = this.getCurveLengths()
    return e[e.length - 1]
  }
  updateArcLengths() {
    ;(this.needsUpdate = !0), (this.cacheLengths = null), this.getCurveLengths()
  }
  getCurveLengths() {
    if (this.cacheLengths && this.cacheLengths.length === this.curves.length)
      return this.cacheLengths
    const e = []
    let t = 0
    for (let i = 0, r = this.curves.length; i < r; i++)
      (t += this.curves[i].getLength()), e.push(t)
    return (this.cacheLengths = e), e
  }
  getSpacedPoints(e = 40) {
    const t = []
    for (let i = 0; i <= e; i++) t.push(this.getPoint(i / e))
    return this.autoClose && t.push(t[0]), t
  }
  getPoints(e = 12) {
    const t = []
    let i
    for (let r = 0, s = this.curves; r < s.length; r++) {
      const o = s[r],
        l = o.isEllipseCurve
          ? e * 2
          : o.isLineCurve || o.isLineCurve3
          ? 1
          : o.isSplineCurve
          ? e * o.points.length
          : e,
        u = o.getPoints(l)
      for (let d = 0; d < u.length; d++) {
        const p = u[d]
        ;(i && i.equals(p)) || (t.push(p), (i = p))
      }
    }
    return (
      this.autoClose && t.length > 1 && !t[t.length - 1].equals(t[0]) && t.push(t[0]), t
    )
  }
  copy(e) {
    super.copy(e), (this.curves = [])
    for (let t = 0, i = e.curves.length; t < i; t++) {
      const r = e.curves[t]
      this.curves.push(r.clone())
    }
    return (this.autoClose = e.autoClose), this
  }
  toJSON() {
    const e = super.toJSON()
    ;(e.autoClose = this.autoClose), (e.curves = [])
    for (let t = 0, i = this.curves.length; t < i; t++) {
      const r = this.curves[t]
      e.curves.push(r.toJSON())
    }
    return e
  }
  fromJSON(e) {
    super.fromJSON(e), (this.autoClose = e.autoClose), (this.curves = [])
    for (let t = 0, i = e.curves.length; t < i; t++) {
      const r = e.curves[t]
      this.curves.push(new bv[r.type]().fromJSON(r))
    }
    return this
  }
}
class Qp extends V3 {
  constructor(e) {
    super(),
      (this.type = "Path"),
      (this.currentPoint = new We()),
      e && this.setFromPoints(e)
  }
  setFromPoints(e) {
    this.moveTo(e[0].x, e[0].y)
    for (let t = 1, i = e.length; t < i; t++) this.lineTo(e[t].x, e[t].y)
    return this
  }
  moveTo(e, t) {
    return this.currentPoint.set(e, t), this
  }
  lineTo(e, t) {
    const i = new $w(this.currentPoint.clone(), new We(e, t))
    return this.curves.push(i), this.currentPoint.set(e, t), this
  }
  quadraticCurveTo(e, t, i, r) {
    const s = new Kw(this.currentPoint.clone(), new We(e, t), new We(i, r))
    return this.curves.push(s), this.currentPoint.set(i, r), this
  }
  bezierCurveTo(e, t, i, r, s, o) {
    const l = new qw(
      this.currentPoint.clone(),
      new We(e, t),
      new We(i, r),
      new We(s, o),
    )
    return this.curves.push(l), this.currentPoint.set(s, o), this
  }
  splineThru(e) {
    const t = [this.currentPoint.clone()].concat(e),
      i = new Jw(t)
    return this.curves.push(i), this.currentPoint.copy(e[e.length - 1]), this
  }
  arc(e, t, i, r, s, o) {
    const l = this.currentPoint.x,
      u = this.currentPoint.y
    return this.absarc(e + l, t + u, i, r, s, o), this
  }
  absarc(e, t, i, r, s, o) {
    return this.absellipse(e, t, i, i, r, s, o), this
  }
  ellipse(e, t, i, r, s, o, l, u) {
    const d = this.currentPoint.x,
      p = this.currentPoint.y
    return this.absellipse(e + d, t + p, i, r, s, o, l, u), this
  }
  absellipse(e, t, i, r, s, o, l, u) {
    const d = new ay(e, t, i, r, s, o, l, u)
    if (this.curves.length > 0) {
      const m = d.getPoint(0)
      m.equals(this.currentPoint) || this.lineTo(m.x, m.y)
    }
    this.curves.push(d)
    const p = d.getPoint(1)
    return this.currentPoint.copy(p), this
  }
  copy(e) {
    return super.copy(e), this.currentPoint.copy(e.currentPoint), this
  }
  toJSON() {
    const e = super.toJSON()
    return (e.currentPoint = this.currentPoint.toArray()), e
  }
  fromJSON(e) {
    return super.fromJSON(e), this.currentPoint.fromArray(e.currentPoint), this
  }
}
class Mm extends Gt {
  constructor(
    e = [new We(0, -0.5), new We(0.5, 0), new We(0, 0.5)],
    t = 12,
    i = 0,
    r = Math.PI * 2,
  ) {
    super(),
      (this.type = "LatheGeometry"),
      (this.parameters = { points: e, segments: t, phiStart: i, phiLength: r }),
      (t = Math.floor(t)),
      (r = ri(r, 0, Math.PI * 2))
    const s = [],
      o = [],
      l = [],
      u = [],
      d = [],
      p = 1 / t,
      m = new q(),
      v = new We(),
      y = new q(),
      x = new q(),
      E = new q()
    let M = 0,
      w = 0
    for (let A = 0; A <= e.length - 1; A++)
      switch (A) {
        case 0:
          ;(M = e[A + 1].x - e[A].x),
            (w = e[A + 1].y - e[A].y),
            (y.x = w * 1),
            (y.y = -M),
            (y.z = w * 0),
            E.copy(y),
            y.normalize(),
            u.push(y.x, y.y, y.z)
          break
        case e.length - 1:
          u.push(E.x, E.y, E.z)
          break
        default:
          ;(M = e[A + 1].x - e[A].x),
            (w = e[A + 1].y - e[A].y),
            (y.x = w * 1),
            (y.y = -M),
            (y.z = w * 0),
            x.copy(y),
            (y.x += E.x),
            (y.y += E.y),
            (y.z += E.z),
            y.normalize(),
            u.push(y.x, y.y, y.z),
            E.copy(x)
      }
    for (let A = 0; A <= t; A++) {
      const C = i + A * p * r,
        R = Math.sin(C),
        z = Math.cos(C)
      for (let U = 0; U <= e.length - 1; U++) {
        ;(m.x = e[U].x * R),
          (m.y = e[U].y),
          (m.z = e[U].x * z),
          o.push(m.x, m.y, m.z),
          (v.x = A / t),
          (v.y = U / (e.length - 1)),
          l.push(v.x, v.y)
        const O = u[3 * U + 0] * R,
          N = u[3 * U + 1],
          k = u[3 * U + 0] * z
        d.push(O, N, k)
      }
    }
    for (let A = 0; A < t; A++)
      for (let C = 0; C < e.length - 1; C++) {
        const R = C + A * e.length,
          z = R,
          U = R + e.length,
          O = R + e.length + 1,
          N = R + 1
        s.push(z, U, N), s.push(O, N, U)
      }
    this.setIndex(s),
      this.setAttribute("position", new vt(o, 3)),
      this.setAttribute("uv", new vt(l, 2)),
      this.setAttribute("normal", new vt(d, 3))
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new Mm(e.points, e.segments, e.phiStart, e.phiLength)
  }
}
class ly extends Mm {
  constructor(e = 1, t = 1, i = 4, r = 8) {
    const s = new Qp()
    s.absarc(0, -t / 2, e, Math.PI * 1.5, 0),
      s.absarc(0, t / 2, e, 0, Math.PI * 0.5),
      super(s.getPoints(i), r),
      (this.type = "CapsuleGeometry"),
      (this.parameters = { radius: e, length: t, capSegments: i, radialSegments: r })
  }
  static fromJSON(e) {
    return new ly(e.radius, e.length, e.capSegments, e.radialSegments)
  }
}
class cy extends Gt {
  constructor(e = 1, t = 32, i = 0, r = Math.PI * 2) {
    super(),
      (this.type = "CircleGeometry"),
      (this.parameters = { radius: e, segments: t, thetaStart: i, thetaLength: r }),
      (t = Math.max(3, t))
    const s = [],
      o = [],
      l = [],
      u = [],
      d = new q(),
      p = new We()
    o.push(0, 0, 0), l.push(0, 0, 1), u.push(0.5, 0.5)
    for (let m = 0, v = 3; m <= t; m++, v += 3) {
      const y = i + (m / t) * r
      ;(d.x = e * Math.cos(y)),
        (d.y = e * Math.sin(y)),
        o.push(d.x, d.y, d.z),
        l.push(0, 0, 1),
        (p.x = (o[v] / e + 1) / 2),
        (p.y = (o[v + 1] / e + 1) / 2),
        u.push(p.x, p.y)
    }
    for (let m = 1; m <= t; m++) s.push(m, m + 1, 0)
    this.setIndex(s),
      this.setAttribute("position", new vt(o, 3)),
      this.setAttribute("normal", new vt(l, 3)),
      this.setAttribute("uv", new vt(u, 2))
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new cy(e.radius, e.segments, e.thetaStart, e.thetaLength)
  }
}
class qd extends Gt {
  constructor(e = 1, t = 1, i = 1, r = 32, s = 1, o = !1, l = 0, u = Math.PI * 2) {
    super(),
      (this.type = "CylinderGeometry"),
      (this.parameters = {
        radiusTop: e,
        radiusBottom: t,
        height: i,
        radialSegments: r,
        heightSegments: s,
        openEnded: o,
        thetaStart: l,
        thetaLength: u,
      })
    const d = this
    ;(r = Math.floor(r)), (s = Math.floor(s))
    const p = [],
      m = [],
      v = [],
      y = []
    let x = 0
    const E = [],
      M = i / 2
    let w = 0
    A(),
      o === !1 && (e > 0 && C(!0), t > 0 && C(!1)),
      this.setIndex(p),
      this.setAttribute("position", new vt(m, 3)),
      this.setAttribute("normal", new vt(v, 3)),
      this.setAttribute("uv", new vt(y, 2))
    function A() {
      const R = new q(),
        z = new q()
      let U = 0
      const O = (t - e) / i
      for (let N = 0; N <= s; N++) {
        const k = [],
          I = N / s,
          V = I * (t - e) + e
        for (let Z = 0; Z <= r; Z++) {
          const $ = Z / r,
            ee = $ * u + l,
            ue = Math.sin(ee),
            re = Math.cos(ee)
          ;(z.x = V * ue),
            (z.y = -I * i + M),
            (z.z = V * re),
            m.push(z.x, z.y, z.z),
            R.set(ue, O, re).normalize(),
            v.push(R.x, R.y, R.z),
            y.push($, 1 - I),
            k.push(x++)
        }
        E.push(k)
      }
      for (let N = 0; N < r; N++)
        for (let k = 0; k < s; k++) {
          const I = E[k][N],
            V = E[k + 1][N],
            Z = E[k + 1][N + 1],
            $ = E[k][N + 1]
          ;(e > 0 || k !== 0) && (p.push(I, V, $), (U += 3)),
            (t > 0 || k !== s - 1) && (p.push(V, Z, $), (U += 3))
        }
      d.addGroup(w, U, 0), (w += U)
    }
    function C(R) {
      const z = x,
        U = new We(),
        O = new q()
      let N = 0
      const k = R === !0 ? e : t,
        I = R === !0 ? 1 : -1
      for (let Z = 1; Z <= r; Z++)
        m.push(0, M * I, 0), v.push(0, I, 0), y.push(0.5, 0.5), x++
      const V = x
      for (let Z = 0; Z <= r; Z++) {
        const ee = (Z / r) * u + l,
          ue = Math.cos(ee),
          re = Math.sin(ee)
        ;(O.x = k * re),
          (O.y = M * I),
          (O.z = k * ue),
          m.push(O.x, O.y, O.z),
          v.push(0, I, 0),
          (U.x = ue * 0.5 + 0.5),
          (U.y = re * 0.5 * I + 0.5),
          y.push(U.x, U.y),
          x++
      }
      for (let Z = 0; Z < r; Z++) {
        const $ = z + Z,
          ee = V + Z
        R === !0 ? p.push(ee, ee + 1, $) : p.push(ee + 1, ee, $), (N += 3)
      }
      d.addGroup(w, N, R === !0 ? 1 : 2), (w += N)
    }
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new qd(
      e.radiusTop,
      e.radiusBottom,
      e.height,
      e.radialSegments,
      e.heightSegments,
      e.openEnded,
      e.thetaStart,
      e.thetaLength,
    )
  }
}
class uy extends qd {
  constructor(e = 1, t = 1, i = 32, r = 1, s = !1, o = 0, l = Math.PI * 2) {
    super(0, e, t, i, r, s, o, l),
      (this.type = "ConeGeometry"),
      (this.parameters = {
        radius: e,
        height: t,
        radialSegments: i,
        heightSegments: r,
        openEnded: s,
        thetaStart: o,
        thetaLength: l,
      })
  }
  static fromJSON(e) {
    return new uy(
      e.radius,
      e.height,
      e.radialSegments,
      e.heightSegments,
      e.openEnded,
      e.thetaStart,
      e.thetaLength,
    )
  }
}
class lc extends Gt {
  constructor(e = [], t = [], i = 1, r = 0) {
    super(),
      (this.type = "PolyhedronGeometry"),
      (this.parameters = { vertices: e, indices: t, radius: i, detail: r })
    const s = [],
      o = []
    l(r),
      d(i),
      p(),
      this.setAttribute("position", new vt(s, 3)),
      this.setAttribute("normal", new vt(s.slice(), 3)),
      this.setAttribute("uv", new vt(o, 2)),
      r === 0 ? this.computeVertexNormals() : this.normalizeNormals()
    function l(A) {
      const C = new q(),
        R = new q(),
        z = new q()
      for (let U = 0; U < t.length; U += 3)
        y(t[U + 0], C), y(t[U + 1], R), y(t[U + 2], z), u(C, R, z, A)
    }
    function u(A, C, R, z) {
      const U = z + 1,
        O = []
      for (let N = 0; N <= U; N++) {
        O[N] = []
        const k = A.clone().lerp(R, N / U),
          I = C.clone().lerp(R, N / U),
          V = U - N
        for (let Z = 0; Z <= V; Z++)
          Z === 0 && N === U ? (O[N][Z] = k) : (O[N][Z] = k.clone().lerp(I, Z / V))
      }
      for (let N = 0; N < U; N++)
        for (let k = 0; k < 2 * (U - N) - 1; k++) {
          const I = Math.floor(k / 2)
          k % 2 === 0
            ? (v(O[N][I + 1]), v(O[N + 1][I]), v(O[N][I]))
            : (v(O[N][I + 1]), v(O[N + 1][I + 1]), v(O[N + 1][I]))
        }
    }
    function d(A) {
      const C = new q()
      for (let R = 0; R < s.length; R += 3)
        (C.x = s[R + 0]),
          (C.y = s[R + 1]),
          (C.z = s[R + 2]),
          C.normalize().multiplyScalar(A),
          (s[R + 0] = C.x),
          (s[R + 1] = C.y),
          (s[R + 2] = C.z)
    }
    function p() {
      const A = new q()
      for (let C = 0; C < s.length; C += 3) {
        ;(A.x = s[C + 0]), (A.y = s[C + 1]), (A.z = s[C + 2])
        const R = M(A) / 2 / Math.PI + 0.5,
          z = w(A) / Math.PI + 0.5
        o.push(R, 1 - z)
      }
      x(), m()
    }
    function m() {
      for (let A = 0; A < o.length; A += 6) {
        const C = o[A + 0],
          R = o[A + 2],
          z = o[A + 4],
          U = Math.max(C, R, z),
          O = Math.min(C, R, z)
        U > 0.9 &&
          O < 0.1 &&
          (C < 0.2 && (o[A + 0] += 1),
          R < 0.2 && (o[A + 2] += 1),
          z < 0.2 && (o[A + 4] += 1))
      }
    }
    function v(A) {
      s.push(A.x, A.y, A.z)
    }
    function y(A, C) {
      const R = A * 3
      ;(C.x = e[R + 0]), (C.y = e[R + 1]), (C.z = e[R + 2])
    }
    function x() {
      const A = new q(),
        C = new q(),
        R = new q(),
        z = new q(),
        U = new We(),
        O = new We(),
        N = new We()
      for (let k = 0, I = 0; k < s.length; k += 9, I += 6) {
        A.set(s[k + 0], s[k + 1], s[k + 2]),
          C.set(s[k + 3], s[k + 4], s[k + 5]),
          R.set(s[k + 6], s[k + 7], s[k + 8]),
          U.set(o[I + 0], o[I + 1]),
          O.set(o[I + 2], o[I + 3]),
          N.set(o[I + 4], o[I + 5]),
          z.copy(A).add(C).add(R).divideScalar(3)
        const V = M(z)
        E(U, I + 0, A, V), E(O, I + 2, C, V), E(N, I + 4, R, V)
      }
    }
    function E(A, C, R, z) {
      z < 0 && A.x === 1 && (o[C] = A.x - 1),
        R.x === 0 && R.z === 0 && (o[C] = z / 2 / Math.PI + 0.5)
    }
    function M(A) {
      return Math.atan2(A.z, -A.x)
    }
    function w(A) {
      return Math.atan2(-A.y, Math.sqrt(A.x * A.x + A.z * A.z))
    }
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new lc(e.vertices, e.indices, e.radius, e.details)
  }
}
class fy extends lc {
  constructor(e = 1, t = 0) {
    const i = (1 + Math.sqrt(5)) / 2,
      r = 1 / i,
      s = [
        -1,
        -1,
        -1,
        -1,
        -1,
        1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        1,
        -1,
        -1,
        1,
        -1,
        1,
        1,
        1,
        -1,
        1,
        1,
        1,
        0,
        -r,
        -i,
        0,
        -r,
        i,
        0,
        r,
        -i,
        0,
        r,
        i,
        -r,
        -i,
        0,
        -r,
        i,
        0,
        r,
        -i,
        0,
        r,
        i,
        0,
        -i,
        0,
        -r,
        i,
        0,
        -r,
        -i,
        0,
        r,
        i,
        0,
        r,
      ],
      o = [
        3, 11, 7, 3, 7, 15, 3, 15, 13, 7, 19, 17, 7, 17, 6, 7, 6, 15, 17, 4, 8, 17, 8,
        10, 17, 10, 6, 8, 0, 16, 8, 16, 2, 8, 2, 10, 0, 12, 1, 0, 1, 18, 0, 18, 16, 6,
        10, 2, 6, 2, 13, 6, 13, 15, 2, 16, 18, 2, 18, 3, 2, 3, 13, 18, 1, 9, 18, 9, 11,
        18, 11, 3, 4, 14, 12, 4, 12, 0, 4, 0, 8, 11, 9, 5, 11, 5, 19, 11, 19, 7, 19, 5,
        14, 19, 14, 4, 19, 4, 17, 1, 12, 14, 1, 14, 5, 1, 5, 9,
      ]
    super(s, o, e, t),
      (this.type = "DodecahedronGeometry"),
      (this.parameters = { radius: e, detail: t })
  }
  static fromJSON(e) {
    return new fy(e.radius, e.detail)
  }
}
const c0 = new q(),
  u0 = new q(),
  p_ = new q(),
  f0 = new Zr()
class H3 extends Gt {
  constructor(e = null, t = 1) {
    if (
      (super(),
      (this.type = "EdgesGeometry"),
      (this.parameters = { geometry: e, thresholdAngle: t }),
      e !== null)
    ) {
      const r = Math.pow(10, 4),
        s = Math.cos(bu * t),
        o = e.getIndex(),
        l = e.getAttribute("position"),
        u = o ? o.count : l.count,
        d = [0, 0, 0],
        p = ["a", "b", "c"],
        m = new Array(3),
        v = {},
        y = []
      for (let x = 0; x < u; x += 3) {
        o
          ? ((d[0] = o.getX(x)), (d[1] = o.getX(x + 1)), (d[2] = o.getX(x + 2)))
          : ((d[0] = x), (d[1] = x + 1), (d[2] = x + 2))
        const { a: E, b: M, c: w } = f0
        if (
          (E.fromBufferAttribute(l, d[0]),
          M.fromBufferAttribute(l, d[1]),
          w.fromBufferAttribute(l, d[2]),
          f0.getNormal(p_),
          (m[0] = `${Math.round(E.x * r)},${Math.round(E.y * r)},${Math.round(
            E.z * r,
          )}`),
          (m[1] = `${Math.round(M.x * r)},${Math.round(M.y * r)},${Math.round(
            M.z * r,
          )}`),
          (m[2] = `${Math.round(w.x * r)},${Math.round(w.y * r)},${Math.round(
            w.z * r,
          )}`),
          !(m[0] === m[1] || m[1] === m[2] || m[2] === m[0]))
        )
          for (let A = 0; A < 3; A++) {
            const C = (A + 1) % 3,
              R = m[A],
              z = m[C],
              U = f0[p[A]],
              O = f0[p[C]],
              N = `${R}_${z}`,
              k = `${z}_${R}`
            k in v && v[k]
              ? (p_.dot(v[k].normal) <= s &&
                  (y.push(U.x, U.y, U.z), y.push(O.x, O.y, O.z)),
                (v[k] = null))
              : N in v || (v[N] = { index0: d[A], index1: d[C], normal: p_.clone() })
          }
      }
      for (const x in v)
        if (v[x]) {
          const { index0: E, index1: M } = v[x]
          c0.fromBufferAttribute(l, E),
            u0.fromBufferAttribute(l, M),
            y.push(c0.x, c0.y, c0.z),
            y.push(u0.x, u0.y, u0.z)
        }
      this.setAttribute("position", new vt(y, 3))
    }
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
}
class Cu extends Qp {
  constructor(e) {
    super(e), (this.uuid = vs()), (this.type = "Shape"), (this.holes = [])
  }
  getPointsHoles(e) {
    const t = []
    for (let i = 0, r = this.holes.length; i < r; i++) t[i] = this.holes[i].getPoints(e)
    return t
  }
  extractPoints(e) {
    return { shape: this.getPoints(e), holes: this.getPointsHoles(e) }
  }
  copy(e) {
    super.copy(e), (this.holes = [])
    for (let t = 0, i = e.holes.length; t < i; t++) {
      const r = e.holes[t]
      this.holes.push(r.clone())
    }
    return this
  }
  toJSON() {
    const e = super.toJSON()
    ;(e.uuid = this.uuid), (e.holes = [])
    for (let t = 0, i = this.holes.length; t < i; t++) {
      const r = this.holes[t]
      e.holes.push(r.toJSON())
    }
    return e
  }
  fromJSON(e) {
    super.fromJSON(e), (this.uuid = e.uuid), (this.holes = [])
    for (let t = 0, i = e.holes.length; t < i; t++) {
      const r = e.holes[t]
      this.holes.push(new Qp().fromJSON(r))
    }
    return this
  }
}
const f6 = {
  triangulate: function (n, e, t = 2) {
    const i = e && e.length,
      r = i ? e[0] * t : n.length
    let s = G3(n, 0, r, t, !0)
    const o = []
    if (!s || s.next === s.prev) return o
    let l, u, d, p, m, v, y
    if ((i && (s = g6(n, e, s, t)), n.length > 80 * t)) {
      ;(l = d = n[0]), (u = p = n[1])
      for (let x = t; x < r; x += t)
        (m = n[x]),
          (v = n[x + 1]),
          m < l && (l = m),
          v < u && (u = v),
          m > d && (d = m),
          v > p && (p = v)
      ;(y = Math.max(d - l, p - u)), (y = y !== 0 ? 32767 / y : 0)
    }
    return em(s, o, t, l, u, y, 0), o
  },
}
function G3(n, e, t, i, r) {
  let s, o
  if (r === A6(n, e, t, i) > 0) for (s = e; s < t; s += i) o = sb(s, n[s], n[s + 1], o)
  else for (s = t - i; s >= e; s -= i) o = sb(s, n[s], n[s + 1], o)
  return o && dy(o, o.next) && (nm(o), (o = o.next)), o
}
function Fu(n, e) {
  if (!n) return n
  e || (e = n)
  let t = n,
    i
  do
    if (((i = !1), !t.steiner && (dy(t, t.next) || Jn(t.prev, t, t.next) === 0))) {
      if ((nm(t), (t = e = t.prev), t === t.next)) break
      i = !0
    } else t = t.next
  while (i || t !== e)
  return e
}
function em(n, e, t, i, r, s, o) {
  if (!n) return
  !o && s && w6(n, i, r, s)
  let l = n,
    u,
    d
  for (; n.prev !== n.next; ) {
    if (((u = n.prev), (d = n.next), s ? h6(n, i, r, s) : d6(n))) {
      e.push((u.i / t) | 0),
        e.push((n.i / t) | 0),
        e.push((d.i / t) | 0),
        nm(n),
        (n = d.next),
        (l = d.next)
      continue
    }
    if (((n = d), n === l)) {
      o
        ? o === 1
          ? ((n = p6(Fu(n), e, t)), em(n, e, t, i, r, s, 2))
          : o === 2 && m6(n, e, t, i, r, s)
        : em(Fu(n), e, t, i, r, s, 1)
      break
    }
  }
}
function d6(n) {
  const e = n.prev,
    t = n,
    i = n.next
  if (Jn(e, t, i) >= 0) return !1
  const r = e.x,
    s = t.x,
    o = i.x,
    l = e.y,
    u = t.y,
    d = i.y,
    p = r < s ? (r < o ? r : o) : s < o ? s : o,
    m = l < u ? (l < d ? l : d) : u < d ? u : d,
    v = r > s ? (r > o ? r : o) : s > o ? s : o,
    y = l > u ? (l > d ? l : d) : u > d ? u : d
  let x = i.next
  for (; x !== e; ) {
    if (
      x.x >= p &&
      x.x <= v &&
      x.y >= m &&
      x.y <= y &&
      Ed(r, l, s, u, o, d, x.x, x.y) &&
      Jn(x.prev, x, x.next) >= 0
    )
      return !1
    x = x.next
  }
  return !0
}
function h6(n, e, t, i) {
  const r = n.prev,
    s = n,
    o = n.next
  if (Jn(r, s, o) >= 0) return !1
  const l = r.x,
    u = s.x,
    d = o.x,
    p = r.y,
    m = s.y,
    v = o.y,
    y = l < u ? (l < d ? l : d) : u < d ? u : d,
    x = p < m ? (p < v ? p : v) : m < v ? m : v,
    E = l > u ? (l > d ? l : d) : u > d ? u : d,
    M = p > m ? (p > v ? p : v) : m > v ? m : v,
    w = C1(y, x, e, t, i),
    A = C1(E, M, e, t, i)
  let C = n.prevZ,
    R = n.nextZ
  for (; C && C.z >= w && R && R.z <= A; ) {
    if (
      (C.x >= y &&
        C.x <= E &&
        C.y >= x &&
        C.y <= M &&
        C !== r &&
        C !== o &&
        Ed(l, p, u, m, d, v, C.x, C.y) &&
        Jn(C.prev, C, C.next) >= 0) ||
      ((C = C.prevZ),
      R.x >= y &&
        R.x <= E &&
        R.y >= x &&
        R.y <= M &&
        R !== r &&
        R !== o &&
        Ed(l, p, u, m, d, v, R.x, R.y) &&
        Jn(R.prev, R, R.next) >= 0)
    )
      return !1
    R = R.nextZ
  }
  for (; C && C.z >= w; ) {
    if (
      C.x >= y &&
      C.x <= E &&
      C.y >= x &&
      C.y <= M &&
      C !== r &&
      C !== o &&
      Ed(l, p, u, m, d, v, C.x, C.y) &&
      Jn(C.prev, C, C.next) >= 0
    )
      return !1
    C = C.prevZ
  }
  for (; R && R.z <= A; ) {
    if (
      R.x >= y &&
      R.x <= E &&
      R.y >= x &&
      R.y <= M &&
      R !== r &&
      R !== o &&
      Ed(l, p, u, m, d, v, R.x, R.y) &&
      Jn(R.prev, R, R.next) >= 0
    )
      return !1
    R = R.nextZ
  }
  return !0
}
function p6(n, e, t) {
  let i = n
  do {
    const r = i.prev,
      s = i.next.next
    !dy(r, s) &&
      W3(r, i, i.next, s) &&
      tm(r, s) &&
      tm(s, r) &&
      (e.push((r.i / t) | 0),
      e.push((i.i / t) | 0),
      e.push((s.i / t) | 0),
      nm(i),
      nm(i.next),
      (i = n = s)),
      (i = i.next)
  } while (i !== n)
  return Fu(i)
}
function m6(n, e, t, i, r, s) {
  let o = n
  do {
    let l = o.next.next
    for (; l !== o.prev; ) {
      if (o.i !== l.i && E6(o, l)) {
        let u = j3(o, l)
        ;(o = Fu(o, o.next)),
          (u = Fu(u, u.next)),
          em(o, e, t, i, r, s, 0),
          em(u, e, t, i, r, s, 0)
        return
      }
      l = l.next
    }
    o = o.next
  } while (o !== n)
}
function g6(n, e, t, i) {
  const r = []
  let s, o, l, u, d
  for (s = 0, o = e.length; s < o; s++)
    (l = e[s] * i),
      (u = s < o - 1 ? e[s + 1] * i : n.length),
      (d = G3(n, l, u, i, !1)),
      d === d.next && (d.steiner = !0),
      r.push(M6(d))
  for (r.sort(v6), s = 0; s < r.length; s++) t = y6(r[s], t)
  return t
}
function v6(n, e) {
  return n.x - e.x
}
function y6(n, e) {
  const t = x6(n, e)
  if (!t) return e
  const i = j3(t, n)
  return Fu(i, i.next), Fu(t, t.next)
}
function x6(n, e) {
  let t = e,
    i = -1 / 0,
    r
  const s = n.x,
    o = n.y
  do {
    if (o <= t.y && o >= t.next.y && t.next.y !== t.y) {
      const v = t.x + ((o - t.y) * (t.next.x - t.x)) / (t.next.y - t.y)
      if (v <= s && v > i && ((i = v), (r = t.x < t.next.x ? t : t.next), v === s))
        return r
    }
    t = t.next
  } while (t !== e)
  if (!r) return null
  const l = r,
    u = r.x,
    d = r.y
  let p = 1 / 0,
    m
  t = r
  do
    s >= t.x &&
      t.x >= u &&
      s !== t.x &&
      Ed(o < d ? s : i, o, u, d, o < d ? i : s, o, t.x, t.y) &&
      ((m = Math.abs(o - t.y) / (s - t.x)),
      tm(t, n) &&
        (m < p || (m === p && (t.x > r.x || (t.x === r.x && _6(r, t))))) &&
        ((r = t), (p = m))),
      (t = t.next)
  while (t !== l)
  return r
}
function _6(n, e) {
  return Jn(n.prev, n, e.prev) < 0 && Jn(e.next, n, n.next) < 0
}
function w6(n, e, t, i) {
  let r = n
  do
    r.z === 0 && (r.z = C1(r.x, r.y, e, t, i)),
      (r.prevZ = r.prev),
      (r.nextZ = r.next),
      (r = r.next)
  while (r !== n)
  ;(r.prevZ.nextZ = null), (r.prevZ = null), S6(r)
}
function S6(n) {
  let e,
    t,
    i,
    r,
    s,
    o,
    l,
    u,
    d = 1
  do {
    for (t = n, n = null, s = null, o = 0; t; ) {
      for (o++, i = t, l = 0, e = 0; e < d && (l++, (i = i.nextZ), !!i); e++);
      for (u = d; l > 0 || (u > 0 && i); )
        l !== 0 && (u === 0 || !i || t.z <= i.z)
          ? ((r = t), (t = t.nextZ), l--)
          : ((r = i), (i = i.nextZ), u--),
          s ? (s.nextZ = r) : (n = r),
          (r.prevZ = s),
          (s = r)
      t = i
    }
    ;(s.nextZ = null), (d *= 2)
  } while (o > 1)
  return n
}
function C1(n, e, t, i, r) {
  return (
    (n = ((n - t) * r) | 0),
    (e = ((e - i) * r) | 0),
    (n = (n | (n << 8)) & 16711935),
    (n = (n | (n << 4)) & 252645135),
    (n = (n | (n << 2)) & 858993459),
    (n = (n | (n << 1)) & 1431655765),
    (e = (e | (e << 8)) & 16711935),
    (e = (e | (e << 4)) & 252645135),
    (e = (e | (e << 2)) & 858993459),
    (e = (e | (e << 1)) & 1431655765),
    n | (e << 1)
  )
}
function M6(n) {
  let e = n,
    t = n
  do (e.x < t.x || (e.x === t.x && e.y < t.y)) && (t = e), (e = e.next)
  while (e !== n)
  return t
}
function Ed(n, e, t, i, r, s, o, l) {
  return (
    (r - o) * (e - l) >= (n - o) * (s - l) &&
    (n - o) * (i - l) >= (t - o) * (e - l) &&
    (t - o) * (s - l) >= (r - o) * (i - l)
  )
}
function E6(n, e) {
  return (
    n.next.i !== e.i &&
    n.prev.i !== e.i &&
    !T6(n, e) &&
    ((tm(n, e) &&
      tm(e, n) &&
      b6(n, e) &&
      (Jn(n.prev, n, e.prev) || Jn(n, e.prev, e))) ||
      (dy(n, e) && Jn(n.prev, n, n.next) > 0 && Jn(e.prev, e, e.next) > 0))
  )
}
function Jn(n, e, t) {
  return (e.y - n.y) * (t.x - e.x) - (e.x - n.x) * (t.y - e.y)
}
function dy(n, e) {
  return n.x === e.x && n.y === e.y
}
function W3(n, e, t, i) {
  const r = h0(Jn(n, e, t)),
    s = h0(Jn(n, e, i)),
    o = h0(Jn(t, i, n)),
    l = h0(Jn(t, i, e))
  return !!(
    (r !== s && o !== l) ||
    (r === 0 && d0(n, t, e)) ||
    (s === 0 && d0(n, i, e)) ||
    (o === 0 && d0(t, n, i)) ||
    (l === 0 && d0(t, e, i))
  )
}
function d0(n, e, t) {
  return (
    e.x <= Math.max(n.x, t.x) &&
    e.x >= Math.min(n.x, t.x) &&
    e.y <= Math.max(n.y, t.y) &&
    e.y >= Math.min(n.y, t.y)
  )
}
function h0(n) {
  return n > 0 ? 1 : n < 0 ? -1 : 0
}
function T6(n, e) {
  let t = n
  do {
    if (
      t.i !== n.i &&
      t.next.i !== n.i &&
      t.i !== e.i &&
      t.next.i !== e.i &&
      W3(t, t.next, n, e)
    )
      return !0
    t = t.next
  } while (t !== n)
  return !1
}
function tm(n, e) {
  return Jn(n.prev, n, n.next) < 0
    ? Jn(n, e, n.next) >= 0 && Jn(n, n.prev, e) >= 0
    : Jn(n, e, n.prev) < 0 || Jn(n, n.next, e) < 0
}
function b6(n, e) {
  let t = n,
    i = !1
  const r = (n.x + e.x) / 2,
    s = (n.y + e.y) / 2
  do
    t.y > s != t.next.y > s &&
      t.next.y !== t.y &&
      r < ((t.next.x - t.x) * (s - t.y)) / (t.next.y - t.y) + t.x &&
      (i = !i),
      (t = t.next)
  while (t !== n)
  return i
}
function j3(n, e) {
  const t = new R1(n.i, n.x, n.y),
    i = new R1(e.i, e.x, e.y),
    r = n.next,
    s = e.prev
  return (
    (n.next = e),
    (e.prev = n),
    (t.next = r),
    (r.prev = t),
    (i.next = t),
    (t.prev = i),
    (s.next = i),
    (i.prev = s),
    i
  )
}
function sb(n, e, t, i) {
  const r = new R1(n, e, t)
  return (
    i
      ? ((r.next = i.next), (r.prev = i), (i.next.prev = r), (i.next = r))
      : ((r.prev = r), (r.next = r)),
    r
  )
}
function nm(n) {
  ;(n.next.prev = n.prev),
    (n.prev.next = n.next),
    n.prevZ && (n.prevZ.nextZ = n.nextZ),
    n.nextZ && (n.nextZ.prevZ = n.prevZ)
}
function R1(n, e, t) {
  ;(this.i = n),
    (this.x = e),
    (this.y = t),
    (this.prev = null),
    (this.next = null),
    (this.z = 0),
    (this.prevZ = null),
    (this.nextZ = null),
    (this.steiner = !1)
}
function A6(n, e, t, i) {
  let r = 0
  for (let s = e, o = t - i; s < t; s += i)
    (r += (n[o] - n[s]) * (n[s + 1] + n[o + 1])), (o = s)
  return r
}
class qo {
  static area(e) {
    const t = e.length
    let i = 0
    for (let r = t - 1, s = 0; s < t; r = s++) i += e[r].x * e[s].y - e[s].x * e[r].y
    return i * 0.5
  }
  static isClockWise(e) {
    return qo.area(e) < 0
  }
  static triangulateShape(e, t) {
    const i = [],
      r = [],
      s = []
    ob(e), ab(i, e)
    let o = e.length
    t.forEach(ob)
    for (let u = 0; u < t.length; u++) r.push(o), (o += t[u].length), ab(i, t[u])
    const l = f6.triangulate(i, r)
    for (let u = 0; u < l.length; u += 3) s.push(l.slice(u, u + 3))
    return s
  }
}
function ob(n) {
  const e = n.length
  e > 2 && n[e - 1].equals(n[0]) && n.pop()
}
function ab(n, e) {
  for (let t = 0; t < e.length; t++) n.push(e[t].x), n.push(e[t].y)
}
class hy extends Gt {
  constructor(
    e = new Cu([
      new We(0.5, 0.5),
      new We(-0.5, 0.5),
      new We(-0.5, -0.5),
      new We(0.5, -0.5),
    ]),
    t = {},
  ) {
    super(),
      (this.type = "ExtrudeGeometry"),
      (this.parameters = { shapes: e, options: t }),
      (e = Array.isArray(e) ? e : [e])
    const i = this,
      r = [],
      s = []
    for (let l = 0, u = e.length; l < u; l++) {
      const d = e[l]
      o(d)
    }
    this.setAttribute("position", new vt(r, 3)),
      this.setAttribute("uv", new vt(s, 2)),
      this.computeVertexNormals()
    function o(l) {
      const u = [],
        d = t.curveSegments !== void 0 ? t.curveSegments : 12,
        p = t.steps !== void 0 ? t.steps : 1,
        m = t.depth !== void 0 ? t.depth : 1
      let v = t.bevelEnabled !== void 0 ? t.bevelEnabled : !0,
        y = t.bevelThickness !== void 0 ? t.bevelThickness : 0.2,
        x = t.bevelSize !== void 0 ? t.bevelSize : y - 0.1,
        E = t.bevelOffset !== void 0 ? t.bevelOffset : 0,
        M = t.bevelSegments !== void 0 ? t.bevelSegments : 3
      const w = t.extrudePath,
        A = t.UVGenerator !== void 0 ? t.UVGenerator : C6
      let C,
        R = !1,
        z,
        U,
        O,
        N
      w &&
        ((C = w.getSpacedPoints(p)),
        (R = !0),
        (v = !1),
        (z = w.computeFrenetFrames(p, !1)),
        (U = new q()),
        (O = new q()),
        (N = new q())),
        v || ((M = 0), (y = 0), (x = 0), (E = 0))
      const k = l.extractPoints(d)
      let I = k.shape
      const V = k.holes
      if (!qo.isClockWise(I)) {
        I = I.reverse()
        for (let ae = 0, Ee = V.length; ae < Ee; ae++) {
          const K = V[ae]
          qo.isClockWise(K) && (V[ae] = K.reverse())
        }
      }
      const $ = qo.triangulateShape(I, V),
        ee = I
      for (let ae = 0, Ee = V.length; ae < Ee; ae++) {
        const K = V[ae]
        I = I.concat(K)
      }
      function ue(ae, Ee, K) {
        return (
          Ee || console.error("THREE.ExtrudeGeometry: vec does not exist"),
          ae.clone().addScaledVector(Ee, K)
        )
      }
      const re = I.length,
        se = $.length
      function G(ae, Ee, K) {
        let Ke, Be, Oe
        const Pe = ae.x - Ee.x,
          He = ae.y - Ee.y,
          Se = K.x - ae.x,
          j = K.y - ae.y,
          B = Pe * Pe + He * He,
          ce = Pe * j - He * Se
        if (Math.abs(ce) > Number.EPSILON) {
          const Me = Math.sqrt(B),
            De = Math.sqrt(Se * Se + j * j),
            Ie = Ee.x - He / Me,
            st = Ee.y + Pe / Me,
            tt = K.x - j / De,
            it = K.y + Se / De,
            Et = ((tt - Ie) * j - (it - st) * Se) / (Pe * j - He * Se)
          ;(Ke = Ie + Pe * Et - ae.x), (Be = st + He * Et - ae.y)
          const je = Ke * Ke + Be * Be
          if (je <= 2) return new We(Ke, Be)
          Oe = Math.sqrt(je / 2)
        } else {
          let Me = !1
          Pe > Number.EPSILON
            ? Se > Number.EPSILON && (Me = !0)
            : Pe < -Number.EPSILON
            ? Se < -Number.EPSILON && (Me = !0)
            : Math.sign(He) === Math.sign(j) && (Me = !0),
            Me
              ? ((Ke = -He), (Be = Pe), (Oe = Math.sqrt(B)))
              : ((Ke = Pe), (Be = He), (Oe = Math.sqrt(B / 2)))
        }
        return new We(Ke / Oe, Be / Oe)
      }
      const ie = []
      for (
        let ae = 0, Ee = ee.length, K = Ee - 1, Ke = ae + 1;
        ae < Ee;
        ae++, K++, Ke++
      )
        K === Ee && (K = 0), Ke === Ee && (Ke = 0), (ie[ae] = G(ee[ae], ee[K], ee[Ke]))
      const Q = []
      let W,
        ne = ie.concat()
      for (let ae = 0, Ee = V.length; ae < Ee; ae++) {
        const K = V[ae]
        W = []
        for (
          let Ke = 0, Be = K.length, Oe = Be - 1, Pe = Ke + 1;
          Ke < Be;
          Ke++, Oe++, Pe++
        )
          Oe === Be && (Oe = 0), Pe === Be && (Pe = 0), (W[Ke] = G(K[Ke], K[Oe], K[Pe]))
        Q.push(W), (ne = ne.concat(W))
      }
      for (let ae = 0; ae < M; ae++) {
        const Ee = ae / M,
          K = y * Math.cos((Ee * Math.PI) / 2),
          Ke = x * Math.sin((Ee * Math.PI) / 2) + E
        for (let Be = 0, Oe = ee.length; Be < Oe; Be++) {
          const Pe = ue(ee[Be], ie[Be], Ke)
          me(Pe.x, Pe.y, -K)
        }
        for (let Be = 0, Oe = V.length; Be < Oe; Be++) {
          const Pe = V[Be]
          W = Q[Be]
          for (let He = 0, Se = Pe.length; He < Se; He++) {
            const j = ue(Pe[He], W[He], Ke)
            me(j.x, j.y, -K)
          }
        }
      }
      const ye = x + E
      for (let ae = 0; ae < re; ae++) {
        const Ee = v ? ue(I[ae], ne[ae], ye) : I[ae]
        R
          ? (O.copy(z.normals[0]).multiplyScalar(Ee.x),
            U.copy(z.binormals[0]).multiplyScalar(Ee.y),
            N.copy(C[0]).add(O).add(U),
            me(N.x, N.y, N.z))
          : me(Ee.x, Ee.y, 0)
      }
      for (let ae = 1; ae <= p; ae++)
        for (let Ee = 0; Ee < re; Ee++) {
          const K = v ? ue(I[Ee], ne[Ee], ye) : I[Ee]
          R
            ? (O.copy(z.normals[ae]).multiplyScalar(K.x),
              U.copy(z.binormals[ae]).multiplyScalar(K.y),
              N.copy(C[ae]).add(O).add(U),
              me(N.x, N.y, N.z))
            : me(K.x, K.y, (m / p) * ae)
        }
      for (let ae = M - 1; ae >= 0; ae--) {
        const Ee = ae / M,
          K = y * Math.cos((Ee * Math.PI) / 2),
          Ke = x * Math.sin((Ee * Math.PI) / 2) + E
        for (let Be = 0, Oe = ee.length; Be < Oe; Be++) {
          const Pe = ue(ee[Be], ie[Be], Ke)
          me(Pe.x, Pe.y, m + K)
        }
        for (let Be = 0, Oe = V.length; Be < Oe; Be++) {
          const Pe = V[Be]
          W = Q[Be]
          for (let He = 0, Se = Pe.length; He < Se; He++) {
            const j = ue(Pe[He], W[He], Ke)
            R ? me(j.x, j.y + C[p - 1].y, C[p - 1].x + K) : me(j.x, j.y, m + K)
          }
        }
      }
      oe(), fe()
      function oe() {
        const ae = r.length / 3
        if (v) {
          let Ee = 0,
            K = re * Ee
          for (let Ke = 0; Ke < se; Ke++) {
            const Be = $[Ke]
            Fe(Be[2] + K, Be[1] + K, Be[0] + K)
          }
          ;(Ee = p + M * 2), (K = re * Ee)
          for (let Ke = 0; Ke < se; Ke++) {
            const Be = $[Ke]
            Fe(Be[0] + K, Be[1] + K, Be[2] + K)
          }
        } else {
          for (let Ee = 0; Ee < se; Ee++) {
            const K = $[Ee]
            Fe(K[2], K[1], K[0])
          }
          for (let Ee = 0; Ee < se; Ee++) {
            const K = $[Ee]
            Fe(K[0] + re * p, K[1] + re * p, K[2] + re * p)
          }
        }
        i.addGroup(ae, r.length / 3 - ae, 0)
      }
      function fe() {
        const ae = r.length / 3
        let Ee = 0
        we(ee, Ee), (Ee += ee.length)
        for (let K = 0, Ke = V.length; K < Ke; K++) {
          const Be = V[K]
          we(Be, Ee), (Ee += Be.length)
        }
        i.addGroup(ae, r.length / 3 - ae, 1)
      }
      function we(ae, Ee) {
        let K = ae.length
        for (; --K >= 0; ) {
          const Ke = K
          let Be = K - 1
          Be < 0 && (Be = ae.length - 1)
          for (let Oe = 0, Pe = p + M * 2; Oe < Pe; Oe++) {
            const He = re * Oe,
              Se = re * (Oe + 1),
              j = Ee + Ke + He,
              B = Ee + Be + He,
              ce = Ee + Be + Se,
              Me = Ee + Ke + Se
            ze(j, B, ce, Me)
          }
        }
      }
      function me(ae, Ee, K) {
        u.push(ae), u.push(Ee), u.push(K)
      }
      function Fe(ae, Ee, K) {
        Ge(ae), Ge(Ee), Ge(K)
        const Ke = r.length / 3,
          Be = A.generateTopUV(i, r, Ke - 3, Ke - 2, Ke - 1)
        Ue(Be[0]), Ue(Be[1]), Ue(Be[2])
      }
      function ze(ae, Ee, K, Ke) {
        Ge(ae), Ge(Ee), Ge(Ke), Ge(Ee), Ge(K), Ge(Ke)
        const Be = r.length / 3,
          Oe = A.generateSideWallUV(i, r, Be - 6, Be - 3, Be - 2, Be - 1)
        Ue(Oe[0]), Ue(Oe[1]), Ue(Oe[3]), Ue(Oe[1]), Ue(Oe[2]), Ue(Oe[3])
      }
      function Ge(ae) {
        r.push(u[ae * 3 + 0]), r.push(u[ae * 3 + 1]), r.push(u[ae * 3 + 2])
      }
      function Ue(ae) {
        s.push(ae.x), s.push(ae.y)
      }
    }
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  toJSON() {
    const e = super.toJSON(),
      t = this.parameters.shapes,
      i = this.parameters.options
    return R6(t, i, e)
  }
  static fromJSON(e, t) {
    const i = []
    for (let s = 0, o = e.shapes.length; s < o; s++) {
      const l = t[e.shapes[s]]
      i.push(l)
    }
    const r = e.options.extrudePath
    return (
      r !== void 0 && (e.options.extrudePath = new bv[r.type]().fromJSON(r)),
      new hy(i, e.options)
    )
  }
}
const C6 = {
  generateTopUV: function (n, e, t, i, r) {
    const s = e[t * 3],
      o = e[t * 3 + 1],
      l = e[i * 3],
      u = e[i * 3 + 1],
      d = e[r * 3],
      p = e[r * 3 + 1]
    return [new We(s, o), new We(l, u), new We(d, p)]
  },
  generateSideWallUV: function (n, e, t, i, r, s) {
    const o = e[t * 3],
      l = e[t * 3 + 1],
      u = e[t * 3 + 2],
      d = e[i * 3],
      p = e[i * 3 + 1],
      m = e[i * 3 + 2],
      v = e[r * 3],
      y = e[r * 3 + 1],
      x = e[r * 3 + 2],
      E = e[s * 3],
      M = e[s * 3 + 1],
      w = e[s * 3 + 2]
    return Math.abs(l - p) < Math.abs(o - d)
      ? [new We(o, 1 - u), new We(d, 1 - m), new We(v, 1 - x), new We(E, 1 - w)]
      : [new We(l, 1 - u), new We(p, 1 - m), new We(y, 1 - x), new We(M, 1 - w)]
  },
}
function R6(n, e, t) {
  if (((t.shapes = []), Array.isArray(n)))
    for (let i = 0, r = n.length; i < r; i++) {
      const s = n[i]
      t.shapes.push(s.uuid)
    }
  else t.shapes.push(n.uuid)
  return (
    (t.options = Object.assign({}, e)),
    e.extrudePath !== void 0 && (t.options.extrudePath = e.extrudePath.toJSON()),
    t
  )
}
class py extends lc {
  constructor(e = 1, t = 0) {
    const i = (1 + Math.sqrt(5)) / 2,
      r = [
        -1,
        i,
        0,
        1,
        i,
        0,
        -1,
        -i,
        0,
        1,
        -i,
        0,
        0,
        -1,
        i,
        0,
        1,
        i,
        0,
        -1,
        -i,
        0,
        1,
        -i,
        i,
        0,
        -1,
        i,
        0,
        1,
        -i,
        0,
        -1,
        -i,
        0,
        1,
      ],
      s = [
        0, 11, 5, 0, 5, 1, 0, 1, 7, 0, 7, 10, 0, 10, 11, 1, 5, 9, 5, 11, 4, 11, 10, 2,
        10, 7, 6, 7, 1, 8, 3, 9, 4, 3, 4, 2, 3, 2, 6, 3, 6, 8, 3, 8, 9, 4, 9, 5, 2, 4,
        11, 6, 2, 10, 8, 6, 7, 9, 8, 1,
      ]
    super(r, s, e, t),
      (this.type = "IcosahedronGeometry"),
      (this.parameters = { radius: e, detail: t })
  }
  static fromJSON(e) {
    return new py(e.radius, e.detail)
  }
}
class Em extends lc {
  constructor(e = 1, t = 0) {
    const i = [1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 1, 0, 0, -1],
      r = [0, 2, 4, 0, 4, 3, 0, 3, 5, 0, 5, 2, 1, 2, 5, 1, 5, 3, 1, 3, 4, 1, 4, 2]
    super(i, r, e, t),
      (this.type = "OctahedronGeometry"),
      (this.parameters = { radius: e, detail: t })
  }
  static fromJSON(e) {
    return new Em(e.radius, e.detail)
  }
}
class my extends Gt {
  constructor(e = 0.5, t = 1, i = 32, r = 1, s = 0, o = Math.PI * 2) {
    super(),
      (this.type = "RingGeometry"),
      (this.parameters = {
        innerRadius: e,
        outerRadius: t,
        thetaSegments: i,
        phiSegments: r,
        thetaStart: s,
        thetaLength: o,
      }),
      (i = Math.max(3, i)),
      (r = Math.max(1, r))
    const l = [],
      u = [],
      d = [],
      p = []
    let m = e
    const v = (t - e) / r,
      y = new q(),
      x = new We()
    for (let E = 0; E <= r; E++) {
      for (let M = 0; M <= i; M++) {
        const w = s + (M / i) * o
        ;(y.x = m * Math.cos(w)),
          (y.y = m * Math.sin(w)),
          u.push(y.x, y.y, y.z),
          d.push(0, 0, 1),
          (x.x = (y.x / t + 1) / 2),
          (x.y = (y.y / t + 1) / 2),
          p.push(x.x, x.y)
      }
      m += v
    }
    for (let E = 0; E < r; E++) {
      const M = E * (i + 1)
      for (let w = 0; w < i; w++) {
        const A = w + M,
          C = A,
          R = A + i + 1,
          z = A + i + 2,
          U = A + 1
        l.push(C, R, U), l.push(R, z, U)
      }
    }
    this.setIndex(l),
      this.setAttribute("position", new vt(u, 3)),
      this.setAttribute("normal", new vt(d, 3)),
      this.setAttribute("uv", new vt(p, 2))
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new my(
      e.innerRadius,
      e.outerRadius,
      e.thetaSegments,
      e.phiSegments,
      e.thetaStart,
      e.thetaLength,
    )
  }
}
class gy extends Gt {
  constructor(
    e = new Cu([new We(0, 0.5), new We(-0.5, -0.5), new We(0.5, -0.5)]),
    t = 12,
  ) {
    super(),
      (this.type = "ShapeGeometry"),
      (this.parameters = { shapes: e, curveSegments: t })
    const i = [],
      r = [],
      s = [],
      o = []
    let l = 0,
      u = 0
    if (Array.isArray(e) === !1) d(e)
    else
      for (let p = 0; p < e.length; p++)
        d(e[p]), this.addGroup(l, u, p), (l += u), (u = 0)
    this.setIndex(i),
      this.setAttribute("position", new vt(r, 3)),
      this.setAttribute("normal", new vt(s, 3)),
      this.setAttribute("uv", new vt(o, 2))
    function d(p) {
      const m = r.length / 3,
        v = p.extractPoints(t)
      let y = v.shape
      const x = v.holes
      qo.isClockWise(y) === !1 && (y = y.reverse())
      for (let M = 0, w = x.length; M < w; M++) {
        const A = x[M]
        qo.isClockWise(A) === !0 && (x[M] = A.reverse())
      }
      const E = qo.triangulateShape(y, x)
      for (let M = 0, w = x.length; M < w; M++) {
        const A = x[M]
        y = y.concat(A)
      }
      for (let M = 0, w = y.length; M < w; M++) {
        const A = y[M]
        r.push(A.x, A.y, 0), s.push(0, 0, 1), o.push(A.x, A.y)
      }
      for (let M = 0, w = E.length; M < w; M++) {
        const A = E[M],
          C = A[0] + m,
          R = A[1] + m,
          z = A[2] + m
        i.push(C, R, z), (u += 3)
      }
    }
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  toJSON() {
    const e = super.toJSON(),
      t = this.parameters.shapes
    return P6(t, e)
  }
  static fromJSON(e, t) {
    const i = []
    for (let r = 0, s = e.shapes.length; r < s; r++) {
      const o = t[e.shapes[r]]
      i.push(o)
    }
    return new gy(i, e.curveSegments)
  }
}
function P6(n, e) {
  if (((e.shapes = []), Array.isArray(n)))
    for (let t = 0, i = n.length; t < i; t++) {
      const r = n[t]
      e.shapes.push(r.uuid)
    }
  else e.shapes.push(n.uuid)
  return e
}
class Tm extends Gt {
  constructor(e = 1, t = 32, i = 16, r = 0, s = Math.PI * 2, o = 0, l = Math.PI) {
    super(),
      (this.type = "SphereGeometry"),
      (this.parameters = {
        radius: e,
        widthSegments: t,
        heightSegments: i,
        phiStart: r,
        phiLength: s,
        thetaStart: o,
        thetaLength: l,
      }),
      (t = Math.max(3, Math.floor(t))),
      (i = Math.max(2, Math.floor(i)))
    const u = Math.min(o + l, Math.PI)
    let d = 0
    const p = [],
      m = new q(),
      v = new q(),
      y = [],
      x = [],
      E = [],
      M = []
    for (let w = 0; w <= i; w++) {
      const A = [],
        C = w / i
      let R = 0
      w === 0 && o === 0 ? (R = 0.5 / t) : w === i && u === Math.PI && (R = -0.5 / t)
      for (let z = 0; z <= t; z++) {
        const U = z / t
        ;(m.x = -e * Math.cos(r + U * s) * Math.sin(o + C * l)),
          (m.y = e * Math.cos(o + C * l)),
          (m.z = e * Math.sin(r + U * s) * Math.sin(o + C * l)),
          x.push(m.x, m.y, m.z),
          v.copy(m).normalize(),
          E.push(v.x, v.y, v.z),
          M.push(U + R, 1 - C),
          A.push(d++)
      }
      p.push(A)
    }
    for (let w = 0; w < i; w++)
      for (let A = 0; A < t; A++) {
        const C = p[w][A + 1],
          R = p[w][A],
          z = p[w + 1][A],
          U = p[w + 1][A + 1]
        ;(w !== 0 || o > 0) && y.push(C, R, U),
          (w !== i - 1 || u < Math.PI) && y.push(R, z, U)
      }
    this.setIndex(y),
      this.setAttribute("position", new vt(x, 3)),
      this.setAttribute("normal", new vt(E, 3)),
      this.setAttribute("uv", new vt(M, 2))
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new Tm(
      e.radius,
      e.widthSegments,
      e.heightSegments,
      e.phiStart,
      e.phiLength,
      e.thetaStart,
      e.thetaLength,
    )
  }
}
class vy extends lc {
  constructor(e = 1, t = 0) {
    const i = [1, 1, 1, -1, -1, 1, -1, 1, -1, 1, -1, -1],
      r = [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1]
    super(i, r, e, t),
      (this.type = "TetrahedronGeometry"),
      (this.parameters = { radius: e, detail: t })
  }
  static fromJSON(e) {
    return new vy(e.radius, e.detail)
  }
}
class yy extends Gt {
  constructor(e = 1, t = 0.4, i = 12, r = 48, s = Math.PI * 2) {
    super(),
      (this.type = "TorusGeometry"),
      (this.parameters = {
        radius: e,
        tube: t,
        radialSegments: i,
        tubularSegments: r,
        arc: s,
      }),
      (i = Math.floor(i)),
      (r = Math.floor(r))
    const o = [],
      l = [],
      u = [],
      d = [],
      p = new q(),
      m = new q(),
      v = new q()
    for (let y = 0; y <= i; y++)
      for (let x = 0; x <= r; x++) {
        const E = (x / r) * s,
          M = (y / i) * Math.PI * 2
        ;(m.x = (e + t * Math.cos(M)) * Math.cos(E)),
          (m.y = (e + t * Math.cos(M)) * Math.sin(E)),
          (m.z = t * Math.sin(M)),
          l.push(m.x, m.y, m.z),
          (p.x = e * Math.cos(E)),
          (p.y = e * Math.sin(E)),
          v.subVectors(m, p).normalize(),
          u.push(v.x, v.y, v.z),
          d.push(x / r),
          d.push(y / i)
      }
    for (let y = 1; y <= i; y++)
      for (let x = 1; x <= r; x++) {
        const E = (r + 1) * y + x - 1,
          M = (r + 1) * (y - 1) + x - 1,
          w = (r + 1) * (y - 1) + x,
          A = (r + 1) * y + x
        o.push(E, M, A), o.push(M, w, A)
      }
    this.setIndex(o),
      this.setAttribute("position", new vt(l, 3)),
      this.setAttribute("normal", new vt(u, 3)),
      this.setAttribute("uv", new vt(d, 2))
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new yy(e.radius, e.tube, e.radialSegments, e.tubularSegments, e.arc)
  }
}
class xy extends Gt {
  constructor(e = 1, t = 0.4, i = 64, r = 8, s = 2, o = 3) {
    super(),
      (this.type = "TorusKnotGeometry"),
      (this.parameters = {
        radius: e,
        tube: t,
        tubularSegments: i,
        radialSegments: r,
        p: s,
        q: o,
      }),
      (i = Math.floor(i)),
      (r = Math.floor(r))
    const l = [],
      u = [],
      d = [],
      p = [],
      m = new q(),
      v = new q(),
      y = new q(),
      x = new q(),
      E = new q(),
      M = new q(),
      w = new q()
    for (let C = 0; C <= i; ++C) {
      const R = (C / i) * s * Math.PI * 2
      A(R, s, o, e, y),
        A(R + 0.01, s, o, e, x),
        M.subVectors(x, y),
        w.addVectors(x, y),
        E.crossVectors(M, w),
        w.crossVectors(E, M),
        E.normalize(),
        w.normalize()
      for (let z = 0; z <= r; ++z) {
        const U = (z / r) * Math.PI * 2,
          O = -t * Math.cos(U),
          N = t * Math.sin(U)
        ;(m.x = y.x + (O * w.x + N * E.x)),
          (m.y = y.y + (O * w.y + N * E.y)),
          (m.z = y.z + (O * w.z + N * E.z)),
          u.push(m.x, m.y, m.z),
          v.subVectors(m, y).normalize(),
          d.push(v.x, v.y, v.z),
          p.push(C / i),
          p.push(z / r)
      }
    }
    for (let C = 1; C <= i; C++)
      for (let R = 1; R <= r; R++) {
        const z = (r + 1) * (C - 1) + (R - 1),
          U = (r + 1) * C + (R - 1),
          O = (r + 1) * C + R,
          N = (r + 1) * (C - 1) + R
        l.push(z, U, N), l.push(U, O, N)
      }
    this.setIndex(l),
      this.setAttribute("position", new vt(u, 3)),
      this.setAttribute("normal", new vt(d, 3)),
      this.setAttribute("uv", new vt(p, 2))
    function A(C, R, z, U, O) {
      const N = Math.cos(C),
        k = Math.sin(C),
        I = (z / R) * C,
        V = Math.cos(I)
      ;(O.x = U * (2 + V) * 0.5 * N),
        (O.y = U * (2 + V) * k * 0.5),
        (O.z = U * Math.sin(I) * 0.5)
    }
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  static fromJSON(e) {
    return new xy(e.radius, e.tube, e.tubularSegments, e.radialSegments, e.p, e.q)
  }
}
class _y extends Gt {
  constructor(
    e = new Zw(new q(-1, -1, 0), new q(-1, 1, 0), new q(1, 1, 0)),
    t = 64,
    i = 1,
    r = 8,
    s = !1,
  ) {
    super(),
      (this.type = "TubeGeometry"),
      (this.parameters = {
        path: e,
        tubularSegments: t,
        radius: i,
        radialSegments: r,
        closed: s,
      })
    const o = e.computeFrenetFrames(t, s)
    ;(this.tangents = o.tangents),
      (this.normals = o.normals),
      (this.binormals = o.binormals)
    const l = new q(),
      u = new q(),
      d = new We()
    let p = new q()
    const m = [],
      v = [],
      y = [],
      x = []
    E(),
      this.setIndex(x),
      this.setAttribute("position", new vt(m, 3)),
      this.setAttribute("normal", new vt(v, 3)),
      this.setAttribute("uv", new vt(y, 2))
    function E() {
      for (let C = 0; C < t; C++) M(C)
      M(s === !1 ? t : 0), A(), w()
    }
    function M(C) {
      p = e.getPointAt(C / t, p)
      const R = o.normals[C],
        z = o.binormals[C]
      for (let U = 0; U <= r; U++) {
        const O = (U / r) * Math.PI * 2,
          N = Math.sin(O),
          k = -Math.cos(O)
        ;(u.x = k * R.x + N * z.x),
          (u.y = k * R.y + N * z.y),
          (u.z = k * R.z + N * z.z),
          u.normalize(),
          v.push(u.x, u.y, u.z),
          (l.x = p.x + i * u.x),
          (l.y = p.y + i * u.y),
          (l.z = p.z + i * u.z),
          m.push(l.x, l.y, l.z)
      }
    }
    function w() {
      for (let C = 1; C <= t; C++)
        for (let R = 1; R <= r; R++) {
          const z = (r + 1) * (C - 1) + (R - 1),
            U = (r + 1) * C + (R - 1),
            O = (r + 1) * C + R,
            N = (r + 1) * (C - 1) + R
          x.push(z, U, N), x.push(U, O, N)
        }
    }
    function A() {
      for (let C = 0; C <= t; C++)
        for (let R = 0; R <= r; R++) (d.x = C / t), (d.y = R / r), y.push(d.x, d.y)
    }
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
  toJSON() {
    const e = super.toJSON()
    return (e.path = this.parameters.path.toJSON()), e
  }
  static fromJSON(e) {
    return new _y(
      new bv[e.path.type]().fromJSON(e.path),
      e.tubularSegments,
      e.radius,
      e.radialSegments,
      e.closed,
    )
  }
}
class X3 extends Gt {
  constructor(e = null) {
    if (
      (super(),
      (this.type = "WireframeGeometry"),
      (this.parameters = { geometry: e }),
      e !== null)
    ) {
      const t = [],
        i = new Set(),
        r = new q(),
        s = new q()
      if (e.index !== null) {
        const o = e.attributes.position,
          l = e.index
        let u = e.groups
        u.length === 0 && (u = [{ start: 0, count: l.count, materialIndex: 0 }])
        for (let d = 0, p = u.length; d < p; ++d) {
          const m = u[d],
            v = m.start,
            y = m.count
          for (let x = v, E = v + y; x < E; x += 3)
            for (let M = 0; M < 3; M++) {
              const w = l.getX(x + M),
                A = l.getX(x + ((M + 1) % 3))
              r.fromBufferAttribute(o, w),
                s.fromBufferAttribute(o, A),
                lb(r, s, i) === !0 && (t.push(r.x, r.y, r.z), t.push(s.x, s.y, s.z))
            }
        }
      } else {
        const o = e.attributes.position
        for (let l = 0, u = o.count / 3; l < u; l++)
          for (let d = 0; d < 3; d++) {
            const p = 3 * l + d,
              m = 3 * l + ((d + 1) % 3)
            r.fromBufferAttribute(o, p),
              s.fromBufferAttribute(o, m),
              lb(r, s, i) === !0 && (t.push(r.x, r.y, r.z), t.push(s.x, s.y, s.z))
          }
      }
      this.setAttribute("position", new vt(t, 3))
    }
  }
  copy(e) {
    return super.copy(e), (this.parameters = Object.assign({}, e.parameters)), this
  }
}
function lb(n, e, t) {
  const i = `${n.x},${n.y},${n.z}-${e.x},${e.y},${e.z}`,
    r = `${e.x},${e.y},${e.z}-${n.x},${n.y},${n.z}`
  return t.has(i) === !0 || t.has(r) === !0 ? !1 : (t.add(i), t.add(r), !0)
}
var cb = Object.freeze({
  __proto__: null,
  BoxGeometry: zu,
  CapsuleGeometry: ly,
  CircleGeometry: cy,
  ConeGeometry: uy,
  CylinderGeometry: qd,
  DodecahedronGeometry: fy,
  EdgesGeometry: H3,
  ExtrudeGeometry: hy,
  IcosahedronGeometry: py,
  LatheGeometry: Mm,
  OctahedronGeometry: Em,
  PlaneGeometry: jd,
  PolyhedronGeometry: lc,
  RingGeometry: my,
  ShapeGeometry: gy,
  SphereGeometry: Tm,
  TetrahedronGeometry: vy,
  TorusGeometry: yy,
  TorusKnotGeometry: xy,
  TubeGeometry: _y,
  WireframeGeometry: X3,
})
class Y3 extends er {
  static get type() {
    return "ShadowMaterial"
  }
  constructor(e) {
    super(),
      (this.isShadowMaterial = !0),
      (this.color = new ot(0)),
      (this.transparent = !0),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return super.copy(e), this.color.copy(e.color), (this.fog = e.fog), this
  }
}
class q3 extends Mo {
  static get type() {
    return "RawShaderMaterial"
  }
  constructor(e) {
    super(e), (this.isRawShaderMaterial = !0)
  }
}
class Qw extends er {
  static get type() {
    return "MeshStandardMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshStandardMaterial = !0),
      (this.defines = { STANDARD: "" }),
      (this.color = new ot(16777215)),
      (this.roughness = 1),
      (this.metalness = 0),
      (this.map = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.emissive = new ot(0)),
      (this.emissiveIntensity = 1),
      (this.emissiveMap = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = ac),
      (this.normalScale = new We(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.roughnessMap = null),
      (this.metalnessMap = null),
      (this.alphaMap = null),
      (this.envMap = null),
      (this.envMapRotation = new Bi()),
      (this.envMapIntensity = 1),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.flatShading = !1),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.defines = { STANDARD: "" }),
      this.color.copy(e.color),
      (this.roughness = e.roughness),
      (this.metalness = e.metalness),
      (this.map = e.map),
      (this.lightMap = e.lightMap),
      (this.lightMapIntensity = e.lightMapIntensity),
      (this.aoMap = e.aoMap),
      (this.aoMapIntensity = e.aoMapIntensity),
      this.emissive.copy(e.emissive),
      (this.emissiveMap = e.emissiveMap),
      (this.emissiveIntensity = e.emissiveIntensity),
      (this.bumpMap = e.bumpMap),
      (this.bumpScale = e.bumpScale),
      (this.normalMap = e.normalMap),
      (this.normalMapType = e.normalMapType),
      this.normalScale.copy(e.normalScale),
      (this.displacementMap = e.displacementMap),
      (this.displacementScale = e.displacementScale),
      (this.displacementBias = e.displacementBias),
      (this.roughnessMap = e.roughnessMap),
      (this.metalnessMap = e.metalnessMap),
      (this.alphaMap = e.alphaMap),
      (this.envMap = e.envMap),
      this.envMapRotation.copy(e.envMapRotation),
      (this.envMapIntensity = e.envMapIntensity),
      (this.wireframe = e.wireframe),
      (this.wireframeLinewidth = e.wireframeLinewidth),
      (this.wireframeLinecap = e.wireframeLinecap),
      (this.wireframeLinejoin = e.wireframeLinejoin),
      (this.flatShading = e.flatShading),
      (this.fog = e.fog),
      this
    )
  }
}
class $3 extends Qw {
  static get type() {
    return "MeshPhysicalMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshPhysicalMaterial = !0),
      (this.defines = { STANDARD: "", PHYSICAL: "" }),
      (this.anisotropyRotation = 0),
      (this.anisotropyMap = null),
      (this.clearcoatMap = null),
      (this.clearcoatRoughness = 0),
      (this.clearcoatRoughnessMap = null),
      (this.clearcoatNormalScale = new We(1, 1)),
      (this.clearcoatNormalMap = null),
      (this.ior = 1.5),
      Object.defineProperty(this, "reflectivity", {
        get: function () {
          return ri((2.5 * (this.ior - 1)) / (this.ior + 1), 0, 1)
        },
        set: function (t) {
          this.ior = (1 + 0.4 * t) / (1 - 0.4 * t)
        },
      }),
      (this.iridescenceMap = null),
      (this.iridescenceIOR = 1.3),
      (this.iridescenceThicknessRange = [100, 400]),
      (this.iridescenceThicknessMap = null),
      (this.sheenColor = new ot(0)),
      (this.sheenColorMap = null),
      (this.sheenRoughness = 1),
      (this.sheenRoughnessMap = null),
      (this.transmissionMap = null),
      (this.thickness = 0),
      (this.thicknessMap = null),
      (this.attenuationDistance = 1 / 0),
      (this.attenuationColor = new ot(1, 1, 1)),
      (this.specularIntensity = 1),
      (this.specularIntensityMap = null),
      (this.specularColor = new ot(1, 1, 1)),
      (this.specularColorMap = null),
      (this._anisotropy = 0),
      (this._clearcoat = 0),
      (this._dispersion = 0),
      (this._iridescence = 0),
      (this._sheen = 0),
      (this._transmission = 0),
      this.setValues(e)
  }
  get anisotropy() {
    return this._anisotropy
  }
  set anisotropy(e) {
    this._anisotropy > 0 != e > 0 && this.version++, (this._anisotropy = e)
  }
  get clearcoat() {
    return this._clearcoat
  }
  set clearcoat(e) {
    this._clearcoat > 0 != e > 0 && this.version++, (this._clearcoat = e)
  }
  get iridescence() {
    return this._iridescence
  }
  set iridescence(e) {
    this._iridescence > 0 != e > 0 && this.version++, (this._iridescence = e)
  }
  get dispersion() {
    return this._dispersion
  }
  set dispersion(e) {
    this._dispersion > 0 != e > 0 && this.version++, (this._dispersion = e)
  }
  get sheen() {
    return this._sheen
  }
  set sheen(e) {
    this._sheen > 0 != e > 0 && this.version++, (this._sheen = e)
  }
  get transmission() {
    return this._transmission
  }
  set transmission(e) {
    this._transmission > 0 != e > 0 && this.version++, (this._transmission = e)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.defines = { STANDARD: "", PHYSICAL: "" }),
      (this.anisotropy = e.anisotropy),
      (this.anisotropyRotation = e.anisotropyRotation),
      (this.anisotropyMap = e.anisotropyMap),
      (this.clearcoat = e.clearcoat),
      (this.clearcoatMap = e.clearcoatMap),
      (this.clearcoatRoughness = e.clearcoatRoughness),
      (this.clearcoatRoughnessMap = e.clearcoatRoughnessMap),
      (this.clearcoatNormalMap = e.clearcoatNormalMap),
      this.clearcoatNormalScale.copy(e.clearcoatNormalScale),
      (this.dispersion = e.dispersion),
      (this.ior = e.ior),
      (this.iridescence = e.iridescence),
      (this.iridescenceMap = e.iridescenceMap),
      (this.iridescenceIOR = e.iridescenceIOR),
      (this.iridescenceThicknessRange = [...e.iridescenceThicknessRange]),
      (this.iridescenceThicknessMap = e.iridescenceThicknessMap),
      (this.sheen = e.sheen),
      this.sheenColor.copy(e.sheenColor),
      (this.sheenColorMap = e.sheenColorMap),
      (this.sheenRoughness = e.sheenRoughness),
      (this.sheenRoughnessMap = e.sheenRoughnessMap),
      (this.transmission = e.transmission),
      (this.transmissionMap = e.transmissionMap),
      (this.thickness = e.thickness),
      (this.thicknessMap = e.thicknessMap),
      (this.attenuationDistance = e.attenuationDistance),
      this.attenuationColor.copy(e.attenuationColor),
      (this.specularIntensity = e.specularIntensity),
      (this.specularIntensityMap = e.specularIntensityMap),
      this.specularColor.copy(e.specularColor),
      (this.specularColorMap = e.specularColorMap),
      this
    )
  }
}
class Np extends er {
  static get type() {
    return "MeshPhongMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshPhongMaterial = !0),
      (this.color = new ot(16777215)),
      (this.specular = new ot(1118481)),
      (this.shininess = 30),
      (this.map = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.emissive = new ot(0)),
      (this.emissiveIntensity = 1),
      (this.emissiveMap = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = ac),
      (this.normalScale = new We(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.specularMap = null),
      (this.alphaMap = null),
      (this.envMap = null),
      (this.envMapRotation = new Bi()),
      (this.combine = gm),
      (this.reflectivity = 1),
      (this.refractionRatio = 0.98),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.flatShading = !1),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      this.color.copy(e.color),
      this.specular.copy(e.specular),
      (this.shininess = e.shininess),
      (this.map = e.map),
      (this.lightMap = e.lightMap),
      (this.lightMapIntensity = e.lightMapIntensity),
      (this.aoMap = e.aoMap),
      (this.aoMapIntensity = e.aoMapIntensity),
      this.emissive.copy(e.emissive),
      (this.emissiveMap = e.emissiveMap),
      (this.emissiveIntensity = e.emissiveIntensity),
      (this.bumpMap = e.bumpMap),
      (this.bumpScale = e.bumpScale),
      (this.normalMap = e.normalMap),
      (this.normalMapType = e.normalMapType),
      this.normalScale.copy(e.normalScale),
      (this.displacementMap = e.displacementMap),
      (this.displacementScale = e.displacementScale),
      (this.displacementBias = e.displacementBias),
      (this.specularMap = e.specularMap),
      (this.alphaMap = e.alphaMap),
      (this.envMap = e.envMap),
      this.envMapRotation.copy(e.envMapRotation),
      (this.combine = e.combine),
      (this.reflectivity = e.reflectivity),
      (this.refractionRatio = e.refractionRatio),
      (this.wireframe = e.wireframe),
      (this.wireframeLinewidth = e.wireframeLinewidth),
      (this.wireframeLinecap = e.wireframeLinecap),
      (this.wireframeLinejoin = e.wireframeLinejoin),
      (this.flatShading = e.flatShading),
      (this.fog = e.fog),
      this
    )
  }
}
class K3 extends er {
  static get type() {
    return "MeshToonMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshToonMaterial = !0),
      (this.defines = { TOON: "" }),
      (this.color = new ot(16777215)),
      (this.map = null),
      (this.gradientMap = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.emissive = new ot(0)),
      (this.emissiveIntensity = 1),
      (this.emissiveMap = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = ac),
      (this.normalScale = new We(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.alphaMap = null),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      this.color.copy(e.color),
      (this.map = e.map),
      (this.gradientMap = e.gradientMap),
      (this.lightMap = e.lightMap),
      (this.lightMapIntensity = e.lightMapIntensity),
      (this.aoMap = e.aoMap),
      (this.aoMapIntensity = e.aoMapIntensity),
      this.emissive.copy(e.emissive),
      (this.emissiveMap = e.emissiveMap),
      (this.emissiveIntensity = e.emissiveIntensity),
      (this.bumpMap = e.bumpMap),
      (this.bumpScale = e.bumpScale),
      (this.normalMap = e.normalMap),
      (this.normalMapType = e.normalMapType),
      this.normalScale.copy(e.normalScale),
      (this.displacementMap = e.displacementMap),
      (this.displacementScale = e.displacementScale),
      (this.displacementBias = e.displacementBias),
      (this.alphaMap = e.alphaMap),
      (this.wireframe = e.wireframe),
      (this.wireframeLinewidth = e.wireframeLinewidth),
      (this.wireframeLinecap = e.wireframeLinecap),
      (this.wireframeLinejoin = e.wireframeLinejoin),
      (this.fog = e.fog),
      this
    )
  }
}
class Z3 extends er {
  static get type() {
    return "MeshNormalMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshNormalMaterial = !0),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = ac),
      (this.normalScale = new We(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.flatShading = !1),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.bumpMap = e.bumpMap),
      (this.bumpScale = e.bumpScale),
      (this.normalMap = e.normalMap),
      (this.normalMapType = e.normalMapType),
      this.normalScale.copy(e.normalScale),
      (this.displacementMap = e.displacementMap),
      (this.displacementScale = e.displacementScale),
      (this.displacementBias = e.displacementBias),
      (this.wireframe = e.wireframe),
      (this.wireframeLinewidth = e.wireframeLinewidth),
      (this.flatShading = e.flatShading),
      this
    )
  }
}
class eS extends er {
  static get type() {
    return "MeshLambertMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshLambertMaterial = !0),
      (this.color = new ot(16777215)),
      (this.map = null),
      (this.lightMap = null),
      (this.lightMapIntensity = 1),
      (this.aoMap = null),
      (this.aoMapIntensity = 1),
      (this.emissive = new ot(0)),
      (this.emissiveIntensity = 1),
      (this.emissiveMap = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = ac),
      (this.normalScale = new We(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.specularMap = null),
      (this.alphaMap = null),
      (this.envMap = null),
      (this.envMapRotation = new Bi()),
      (this.combine = gm),
      (this.reflectivity = 1),
      (this.refractionRatio = 0.98),
      (this.wireframe = !1),
      (this.wireframeLinewidth = 1),
      (this.wireframeLinecap = "round"),
      (this.wireframeLinejoin = "round"),
      (this.flatShading = !1),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      this.color.copy(e.color),
      (this.map = e.map),
      (this.lightMap = e.lightMap),
      (this.lightMapIntensity = e.lightMapIntensity),
      (this.aoMap = e.aoMap),
      (this.aoMapIntensity = e.aoMapIntensity),
      this.emissive.copy(e.emissive),
      (this.emissiveMap = e.emissiveMap),
      (this.emissiveIntensity = e.emissiveIntensity),
      (this.bumpMap = e.bumpMap),
      (this.bumpScale = e.bumpScale),
      (this.normalMap = e.normalMap),
      (this.normalMapType = e.normalMapType),
      this.normalScale.copy(e.normalScale),
      (this.displacementMap = e.displacementMap),
      (this.displacementScale = e.displacementScale),
      (this.displacementBias = e.displacementBias),
      (this.specularMap = e.specularMap),
      (this.alphaMap = e.alphaMap),
      (this.envMap = e.envMap),
      this.envMapRotation.copy(e.envMapRotation),
      (this.combine = e.combine),
      (this.reflectivity = e.reflectivity),
      (this.refractionRatio = e.refractionRatio),
      (this.wireframe = e.wireframe),
      (this.wireframeLinewidth = e.wireframeLinewidth),
      (this.wireframeLinecap = e.wireframeLinecap),
      (this.wireframeLinejoin = e.wireframeLinejoin),
      (this.flatShading = e.flatShading),
      (this.fog = e.fog),
      this
    )
  }
}
class J3 extends er {
  static get type() {
    return "MeshMatcapMaterial"
  }
  constructor(e) {
    super(),
      (this.isMeshMatcapMaterial = !0),
      (this.defines = { MATCAP: "" }),
      (this.color = new ot(16777215)),
      (this.matcap = null),
      (this.map = null),
      (this.bumpMap = null),
      (this.bumpScale = 1),
      (this.normalMap = null),
      (this.normalMapType = ac),
      (this.normalScale = new We(1, 1)),
      (this.displacementMap = null),
      (this.displacementScale = 1),
      (this.displacementBias = 0),
      (this.alphaMap = null),
      (this.flatShading = !1),
      (this.fog = !0),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.defines = { MATCAP: "" }),
      this.color.copy(e.color),
      (this.matcap = e.matcap),
      (this.map = e.map),
      (this.bumpMap = e.bumpMap),
      (this.bumpScale = e.bumpScale),
      (this.normalMap = e.normalMap),
      (this.normalMapType = e.normalMapType),
      this.normalScale.copy(e.normalScale),
      (this.displacementMap = e.displacementMap),
      (this.displacementScale = e.displacementScale),
      (this.displacementBias = e.displacementBias),
      (this.alphaMap = e.alphaMap),
      (this.flatShading = e.flatShading),
      (this.fog = e.fog),
      this
    )
  }
}
class Q3 extends mr {
  static get type() {
    return "LineDashedMaterial"
  }
  constructor(e) {
    super(),
      (this.isLineDashedMaterial = !0),
      (this.scale = 1),
      (this.dashSize = 3),
      (this.gapSize = 1),
      this.setValues(e)
  }
  copy(e) {
    return (
      super.copy(e),
      (this.scale = e.scale),
      (this.dashSize = e.dashSize),
      (this.gapSize = e.gapSize),
      this
    )
  }
}
function wu(n, e, t) {
  return !n || (!t && n.constructor === e)
    ? n
    : typeof e.BYTES_PER_ELEMENT == "number"
    ? new e(n)
    : Array.prototype.slice.call(n)
}
function eR(n) {
  return ArrayBuffer.isView(n) && !(n instanceof DataView)
}
function tR(n) {
  function e(r, s) {
    return n[r] - n[s]
  }
  const t = n.length,
    i = new Array(t)
  for (let r = 0; r !== t; ++r) i[r] = r
  return i.sort(e), i
}
function P1(n, e, t) {
  const i = n.length,
    r = new n.constructor(i)
  for (let s = 0, o = 0; o !== i; ++s) {
    const l = t[s] * e
    for (let u = 0; u !== e; ++u) r[o++] = n[l + u]
  }
  return r
}
function tS(n, e, t, i) {
  let r = 1,
    s = n[0]
  for (; s !== void 0 && s[i] === void 0; ) s = n[r++]
  if (s === void 0) return
  let o = s[i]
  if (o !== void 0)
    if (Array.isArray(o))
      do (o = s[i]), o !== void 0 && (e.push(s.time), t.push.apply(t, o)), (s = n[r++])
      while (s !== void 0)
    else if (o.toArray !== void 0)
      do
        (o = s[i]),
          o !== void 0 && (e.push(s.time), o.toArray(t, t.length)),
          (s = n[r++])
      while (s !== void 0)
    else
      do (o = s[i]), o !== void 0 && (e.push(s.time), t.push(o)), (s = n[r++])
      while (s !== void 0)
}
function I6(n, e, t, i, r = 30) {
  const s = n.clone()
  s.name = e
  const o = []
  for (let u = 0; u < s.tracks.length; ++u) {
    const d = s.tracks[u],
      p = d.getValueSize(),
      m = [],
      v = []
    for (let y = 0; y < d.times.length; ++y) {
      const x = d.times[y] * r
      if (!(x < t || x >= i)) {
        m.push(d.times[y])
        for (let E = 0; E < p; ++E) v.push(d.values[y * p + E])
      }
    }
    m.length !== 0 &&
      ((d.times = wu(m, d.times.constructor)),
      (d.values = wu(v, d.values.constructor)),
      o.push(d))
  }
  s.tracks = o
  let l = 1 / 0
  for (let u = 0; u < s.tracks.length; ++u)
    l > s.tracks[u].times[0] && (l = s.tracks[u].times[0])
  for (let u = 0; u < s.tracks.length; ++u) s.tracks[u].shift(-1 * l)
  return s.resetDuration(), s
}
function L6(n, e = 0, t = n, i = 30) {
  i <= 0 && (i = 30)
  const r = t.tracks.length,
    s = e / i
  for (let o = 0; o < r; ++o) {
    const l = t.tracks[o],
      u = l.ValueTypeName
    if (u === "bool" || u === "string") continue
    const d = n.tracks.find(function (w) {
      return w.name === l.name && w.ValueTypeName === u
    })
    if (d === void 0) continue
    let p = 0
    const m = l.getValueSize()
    l.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (p = m / 3)
    let v = 0
    const y = d.getValueSize()
    d.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline && (v = y / 3)
    const x = l.times.length - 1
    let E
    if (s <= l.times[0]) {
      const w = p,
        A = m - p
      E = l.values.slice(w, A)
    } else if (s >= l.times[x]) {
      const w = x * m + p,
        A = w + m - p
      E = l.values.slice(w, A)
    } else {
      const w = l.createInterpolant(),
        A = p,
        C = m - p
      w.evaluate(s), (E = w.resultBuffer.slice(A, C))
    }
    u === "quaternion" && new Oi().fromArray(E).normalize().conjugate().toArray(E)
    const M = d.times.length
    for (let w = 0; w < M; ++w) {
      const A = w * y + v
      if (u === "quaternion") Oi.multiplyQuaternionsFlat(d.values, A, E, 0, d.values, A)
      else {
        const C = y - v * 2
        for (let R = 0; R < C; ++R) d.values[A + R] -= E[R]
      }
    }
  }
  return (n.blendMode = kw), n
}
const D6 = {
  convertArray: wu,
  isTypedArray: eR,
  getKeyframeOrder: tR,
  sortedArray: P1,
  flattenJSON: tS,
  subclip: I6,
  makeClipAdditive: L6,
}
class bm {
  constructor(e, t, i, r) {
    ;(this.parameterPositions = e),
      (this._cachedIndex = 0),
      (this.resultBuffer = r !== void 0 ? r : new t.constructor(i)),
      (this.sampleValues = t),
      (this.valueSize = i),
      (this.settings = null),
      (this.DefaultSettings_ = {})
  }
  evaluate(e) {
    const t = this.parameterPositions
    let i = this._cachedIndex,
      r = t[i],
      s = t[i - 1]
    e: {
      t: {
        let o
        n: {
          i: if (!(e < r)) {
            for (let l = i + 2; ; ) {
              if (r === void 0) {
                if (e < s) break i
                return (
                  (i = t.length), (this._cachedIndex = i), this.copySampleValue_(i - 1)
                )
              }
              if (i === l) break
              if (((s = r), (r = t[++i]), e < r)) break t
            }
            o = t.length
            break n
          }
          if (!(e >= s)) {
            const l = t[1]
            e < l && ((i = 2), (s = l))
            for (let u = i - 2; ; ) {
              if (s === void 0) return (this._cachedIndex = 0), this.copySampleValue_(0)
              if (i === u) break
              if (((r = s), (s = t[--i - 1]), e >= s)) break t
            }
            ;(o = i), (i = 0)
            break n
          }
          break e
        }
        for (; i < o; ) {
          const l = (i + o) >>> 1
          e < t[l] ? (o = l) : (i = l + 1)
        }
        if (((r = t[i]), (s = t[i - 1]), s === void 0))
          return (this._cachedIndex = 0), this.copySampleValue_(0)
        if (r === void 0)
          return (i = t.length), (this._cachedIndex = i), this.copySampleValue_(i - 1)
      }
      ;(this._cachedIndex = i), this.intervalChanged_(i, s, r)
    }
    return this.interpolate_(i, s, e, r)
  }
  getSettings_() {
    return this.settings || this.DefaultSettings_
  }
  copySampleValue_(e) {
    const t = this.resultBuffer,
      i = this.sampleValues,
      r = this.valueSize,
      s = e * r
    for (let o = 0; o !== r; ++o) t[o] = i[s + o]
    return t
  }
  interpolate_() {
    throw new Error("call to abstract method")
  }
  intervalChanged_() {}
}
class nR extends bm {
  constructor(e, t, i, r) {
    super(e, t, i, r),
      (this._weightPrev = -0),
      (this._offsetPrev = -0),
      (this._weightNext = -0),
      (this._offsetNext = -0),
      (this.DefaultSettings_ = { endingStart: yu, endingEnd: yu })
  }
  intervalChanged_(e, t, i) {
    const r = this.parameterPositions
    let s = e - 2,
      o = e + 1,
      l = r[s],
      u = r[o]
    if (l === void 0)
      switch (this.getSettings_().endingStart) {
        case xu:
          ;(s = e), (l = 2 * t - i)
          break
        case Yp:
          ;(s = r.length - 2), (l = t + r[s] - r[s + 1])
          break
        default:
          ;(s = e), (l = i)
      }
    if (u === void 0)
      switch (this.getSettings_().endingEnd) {
        case xu:
          ;(o = e), (u = 2 * i - t)
          break
        case Yp:
          ;(o = 1), (u = i + r[1] - r[0])
          break
        default:
          ;(o = e - 1), (u = t)
      }
    const d = (i - t) * 0.5,
      p = this.valueSize
    ;(this._weightPrev = d / (t - l)),
      (this._weightNext = d / (u - i)),
      (this._offsetPrev = s * p),
      (this._offsetNext = o * p)
  }
  interpolate_(e, t, i, r) {
    const s = this.resultBuffer,
      o = this.sampleValues,
      l = this.valueSize,
      u = e * l,
      d = u - l,
      p = this._offsetPrev,
      m = this._offsetNext,
      v = this._weightPrev,
      y = this._weightNext,
      x = (i - t) / (r - t),
      E = x * x,
      M = E * x,
      w = -v * M + 2 * v * E - v * x,
      A = (1 + v) * M + (-1.5 - 2 * v) * E + (-0.5 + v) * x + 1,
      C = (-1 - y) * M + (1.5 + y) * E + 0.5 * x,
      R = y * M - y * E
    for (let z = 0; z !== l; ++z)
      s[z] = w * o[p + z] + A * o[d + z] + C * o[u + z] + R * o[m + z]
    return s
  }
}
class nS extends bm {
  constructor(e, t, i, r) {
    super(e, t, i, r)
  }
  interpolate_(e, t, i, r) {
    const s = this.resultBuffer,
      o = this.sampleValues,
      l = this.valueSize,
      u = e * l,
      d = u - l,
      p = (i - t) / (r - t),
      m = 1 - p
    for (let v = 0; v !== l; ++v) s[v] = o[d + v] * m + o[u + v] * p
    return s
  }
}
class iR extends bm {
  constructor(e, t, i, r) {
    super(e, t, i, r)
  }
  interpolate_(e) {
    return this.copySampleValue_(e - 1)
  }
}
class Eo {
  constructor(e, t, i, r) {
    if (e === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined")
    if (t === void 0 || t.length === 0)
      throw new Error("THREE.KeyframeTrack: no keyframes in track named " + e)
    ;(this.name = e),
      (this.times = wu(t, this.TimeBufferType)),
      (this.values = wu(i, this.ValueBufferType)),
      this.setInterpolation(r || this.DefaultInterpolation)
  }
  static toJSON(e) {
    const t = e.constructor
    let i
    if (t.toJSON !== this.toJSON) i = t.toJSON(e)
    else {
      i = { name: e.name, times: wu(e.times, Array), values: wu(e.values, Array) }
      const r = e.getInterpolation()
      r !== e.DefaultInterpolation && (i.interpolation = r)
    }
    return (i.type = e.ValueTypeName), i
  }
  InterpolantFactoryMethodDiscrete(e) {
    return new iR(this.times, this.values, this.getValueSize(), e)
  }
  InterpolantFactoryMethodLinear(e) {
    return new nS(this.times, this.values, this.getValueSize(), e)
  }
  InterpolantFactoryMethodSmooth(e) {
    return new nR(this.times, this.values, this.getValueSize(), e)
  }
  setInterpolation(e) {
    let t
    switch (e) {
      case Xp:
        t = this.InterpolantFactoryMethodDiscrete
        break
      case Mv:
        t = this.InterpolantFactoryMethodLinear
        break
      case C0:
        t = this.InterpolantFactoryMethodSmooth
        break
    }
    if (t === void 0) {
      const i =
        "unsupported interpolation for " +
        this.ValueTypeName +
        " keyframe track named " +
        this.name
      if (this.createInterpolant === void 0)
        if (e !== this.DefaultInterpolation)
          this.setInterpolation(this.DefaultInterpolation)
        else throw new Error(i)
      return console.warn("THREE.KeyframeTrack:", i), this
    }
    return (this.createInterpolant = t), this
  }
  getInterpolation() {
    switch (this.createInterpolant) {
      case this.InterpolantFactoryMethodDiscrete:
        return Xp
      case this.InterpolantFactoryMethodLinear:
        return Mv
      case this.InterpolantFactoryMethodSmooth:
        return C0
    }
  }
  getValueSize() {
    return this.values.length / this.times.length
  }
  shift(e) {
    if (e !== 0) {
      const t = this.times
      for (let i = 0, r = t.length; i !== r; ++i) t[i] += e
    }
    return this
  }
  scale(e) {
    if (e !== 1) {
      const t = this.times
      for (let i = 0, r = t.length; i !== r; ++i) t[i] *= e
    }
    return this
  }
  trim(e, t) {
    const i = this.times,
      r = i.length
    let s = 0,
      o = r - 1
    for (; s !== r && i[s] < e; ) ++s
    for (; o !== -1 && i[o] > t; ) --o
    if ((++o, s !== 0 || o !== r)) {
      s >= o && ((o = Math.max(o, 1)), (s = o - 1))
      const l = this.getValueSize()
      ;(this.times = i.slice(s, o)), (this.values = this.values.slice(s * l, o * l))
    }
    return this
  }
  validate() {
    let e = !0
    const t = this.getValueSize()
    t - Math.floor(t) !== 0 &&
      (console.error("THREE.KeyframeTrack: Invalid value size in track.", this),
      (e = !1))
    const i = this.times,
      r = this.values,
      s = i.length
    s === 0 && (console.error("THREE.KeyframeTrack: Track is empty.", this), (e = !1))
    let o = null
    for (let l = 0; l !== s; l++) {
      const u = i[l]
      if (typeof u == "number" && isNaN(u)) {
        console.error("THREE.KeyframeTrack: Time is not a valid number.", this, l, u),
          (e = !1)
        break
      }
      if (o !== null && o > u) {
        console.error("THREE.KeyframeTrack: Out of order keys.", this, l, u, o),
          (e = !1)
        break
      }
      o = u
    }
    if (r !== void 0 && eR(r))
      for (let l = 0, u = r.length; l !== u; ++l) {
        const d = r[l]
        if (isNaN(d)) {
          console.error(
            "THREE.KeyframeTrack: Value is not a valid number.",
            this,
            l,
            d,
          ),
            (e = !1)
          break
        }
      }
    return e
  }
  optimize() {
    const e = this.times.slice(),
      t = this.values.slice(),
      i = this.getValueSize(),
      r = this.getInterpolation() === C0,
      s = e.length - 1
    let o = 1
    for (let l = 1; l < s; ++l) {
      let u = !1
      const d = e[l],
        p = e[l + 1]
      if (d !== p && (l !== 1 || d !== e[0]))
        if (r) u = !0
        else {
          const m = l * i,
            v = m - i,
            y = m + i
          for (let x = 0; x !== i; ++x) {
            const E = t[m + x]
            if (E !== t[v + x] || E !== t[y + x]) {
              u = !0
              break
            }
          }
        }
      if (u) {
        if (l !== o) {
          e[o] = e[l]
          const m = l * i,
            v = o * i
          for (let y = 0; y !== i; ++y) t[v + y] = t[m + y]
        }
        ++o
      }
    }
    if (s > 0) {
      e[o] = e[s]
      for (let l = s * i, u = o * i, d = 0; d !== i; ++d) t[u + d] = t[l + d]
      ++o
    }
    return (
      o !== e.length
        ? ((this.times = e.slice(0, o)), (this.values = t.slice(0, o * i)))
        : ((this.times = e), (this.values = t)),
      this
    )
  }
  clone() {
    const e = this.times.slice(),
      t = this.values.slice(),
      i = this.constructor,
      r = new i(this.name, e, t)
    return (r.createInterpolant = this.createInterpolant), r
  }
}
Eo.prototype.TimeBufferType = Float32Array
Eo.prototype.ValueBufferType = Float32Array
Eo.prototype.DefaultInterpolation = Mv
class Vu extends Eo {
  constructor(e, t, i) {
    super(e, t, i)
  }
}
Vu.prototype.ValueTypeName = "bool"
Vu.prototype.ValueBufferType = Array
Vu.prototype.DefaultInterpolation = Xp
Vu.prototype.InterpolantFactoryMethodLinear = void 0
Vu.prototype.InterpolantFactoryMethodSmooth = void 0
class iS extends Eo {}
iS.prototype.ValueTypeName = "color"
class kd extends Eo {}
kd.prototype.ValueTypeName = "number"
class rR extends bm {
  constructor(e, t, i, r) {
    super(e, t, i, r)
  }
  interpolate_(e, t, i, r) {
    const s = this.resultBuffer,
      o = this.sampleValues,
      l = this.valueSize,
      u = (i - t) / (r - t)
    let d = e * l
    for (let p = d + l; d !== p; d += 4) Oi.slerpFlat(s, 0, o, d - l, o, d, u)
    return s
  }
}
class $d extends Eo {
  InterpolantFactoryMethodLinear(e) {
    return new rR(this.times, this.values, this.getValueSize(), e)
  }
}
$d.prototype.ValueTypeName = "quaternion"
$d.prototype.InterpolantFactoryMethodSmooth = void 0
class Hu extends Eo {
  constructor(e, t, i) {
    super(e, t, i)
  }
}
Hu.prototype.ValueTypeName = "string"
Hu.prototype.ValueBufferType = Array
Hu.prototype.DefaultInterpolation = Xp
Hu.prototype.InterpolantFactoryMethodLinear = void 0
Hu.prototype.InterpolantFactoryMethodSmooth = void 0
class Fd extends Eo {}
Fd.prototype.ValueTypeName = "vector"
class Ud {
  constructor(e = "", t = -1, i = [], r = Qv) {
    ;(this.name = e),
      (this.tracks = i),
      (this.duration = t),
      (this.blendMode = r),
      (this.uuid = vs()),
      this.duration < 0 && this.resetDuration()
  }
  static parse(e) {
    const t = [],
      i = e.tracks,
      r = 1 / (e.fps || 1)
    for (let o = 0, l = i.length; o !== l; ++o) t.push(k6(i[o]).scale(r))
    const s = new this(e.name, e.duration, t, e.blendMode)
    return (s.uuid = e.uuid), s
  }
  static toJSON(e) {
    const t = [],
      i = e.tracks,
      r = {
        name: e.name,
        duration: e.duration,
        tracks: t,
        uuid: e.uuid,
        blendMode: e.blendMode,
      }
    for (let s = 0, o = i.length; s !== o; ++s) t.push(Eo.toJSON(i[s]))
    return r
  }
  static CreateFromMorphTargetSequence(e, t, i, r) {
    const s = t.length,
      o = []
    for (let l = 0; l < s; l++) {
      let u = [],
        d = []
      u.push((l + s - 1) % s, l, (l + 1) % s), d.push(0, 1, 0)
      const p = tR(u)
      ;(u = P1(u, 1, p)),
        (d = P1(d, 1, p)),
        !r && u[0] === 0 && (u.push(s), d.push(d[0])),
        o.push(new kd(".morphTargetInfluences[" + t[l].name + "]", u, d).scale(1 / i))
    }
    return new this(e, -1, o)
  }
  static findByName(e, t) {
    let i = e
    if (!Array.isArray(e)) {
      const r = e
      i = (r.geometry && r.geometry.animations) || r.animations
    }
    for (let r = 0; r < i.length; r++) if (i[r].name === t) return i[r]
    return null
  }
  static CreateClipsFromMorphTargetSequences(e, t, i) {
    const r = {},
      s = /^([\w-]*?)([\d]+)$/
    for (let l = 0, u = e.length; l < u; l++) {
      const d = e[l],
        p = d.name.match(s)
      if (p && p.length > 1) {
        const m = p[1]
        let v = r[m]
        v || (r[m] = v = []), v.push(d)
      }
    }
    const o = []
    for (const l in r) o.push(this.CreateFromMorphTargetSequence(l, r[l], t, i))
    return o
  }
  static parseAnimation(e, t) {
    if (!e)
      return (
        console.error("THREE.AnimationClip: No animation in JSONLoader data."), null
      )
    const i = function (m, v, y, x, E) {
        if (y.length !== 0) {
          const M = [],
            w = []
          tS(y, M, w, x), M.length !== 0 && E.push(new m(v, M, w))
        }
      },
      r = [],
      s = e.name || "default",
      o = e.fps || 30,
      l = e.blendMode
    let u = e.length || -1
    const d = e.hierarchy || []
    for (let m = 0; m < d.length; m++) {
      const v = d[m].keys
      if (!(!v || v.length === 0))
        if (v[0].morphTargets) {
          const y = {}
          let x
          for (x = 0; x < v.length; x++)
            if (v[x].morphTargets)
              for (let E = 0; E < v[x].morphTargets.length; E++)
                y[v[x].morphTargets[E]] = -1
          for (const E in y) {
            const M = [],
              w = []
            for (let A = 0; A !== v[x].morphTargets.length; ++A) {
              const C = v[x]
              M.push(C.time), w.push(C.morphTarget === E ? 1 : 0)
            }
            r.push(new kd(".morphTargetInfluence[" + E + "]", M, w))
          }
          u = y.length * o
        } else {
          const y = ".bones[" + t[m].name + "]"
          i(Fd, y + ".position", v, "pos", r),
            i($d, y + ".quaternion", v, "rot", r),
            i(Fd, y + ".scale", v, "scl", r)
        }
    }
    return r.length === 0 ? null : new this(s, u, r, l)
  }
  resetDuration() {
    const e = this.tracks
    let t = 0
    for (let i = 0, r = e.length; i !== r; ++i) {
      const s = this.tracks[i]
      t = Math.max(t, s.times[s.times.length - 1])
    }
    return (this.duration = t), this
  }
  trim() {
    for (let e = 0; e < this.tracks.length; e++) this.tracks[e].trim(0, this.duration)
    return this
  }
  validate() {
    let e = !0
    for (let t = 0; t < this.tracks.length; t++) e = e && this.tracks[t].validate()
    return e
  }
  optimize() {
    for (let e = 0; e < this.tracks.length; e++) this.tracks[e].optimize()
    return this
  }
  clone() {
    const e = []
    for (let t = 0; t < this.tracks.length; t++) e.push(this.tracks[t].clone())
    return new this.constructor(this.name, this.duration, e, this.blendMode)
  }
  toJSON() {
    return this.constructor.toJSON(this)
  }
}
function N6(n) {
  switch (n.toLowerCase()) {
    case "scalar":
    case "double":
    case "float":
    case "number":
    case "integer":
      return kd
    case "vector":
    case "vector2":
    case "vector3":
    case "vector4":
      return Fd
    case "color":
      return iS
    case "quaternion":
      return $d
    case "bool":
    case "boolean":
      return Vu
    case "string":
      return Hu
  }
  throw new Error("THREE.KeyframeTrack: Unsupported typeName: " + n)
}
function k6(n) {
  if (n.type === void 0)
    throw new Error("THREE.KeyframeTrack: track type undefined, can not parse")
  const e = N6(n.type)
  if (n.times === void 0) {
    const t = [],
      i = []
    tS(n.keys, t, i, "value"), (n.times = t), (n.values = i)
  }
  return e.parse !== void 0
    ? e.parse(n)
    : new e(n.name, n.times, n.values, n.interpolation)
}
const Ha = {
  enabled: !1,
  files: {},
  add: function (n, e) {
    this.enabled !== !1 && (this.files[n] = e)
  },
  get: function (n) {
    if (this.enabled !== !1) return this.files[n]
  },
  remove: function (n) {
    delete this.files[n]
  },
  clear: function () {
    this.files = {}
  },
}
class rS {
  constructor(e, t, i) {
    const r = this
    let s = !1,
      o = 0,
      l = 0,
      u
    const d = []
    ;(this.onStart = void 0),
      (this.onLoad = e),
      (this.onProgress = t),
      (this.onError = i),
      (this.itemStart = function (p) {
        l++, s === !1 && r.onStart !== void 0 && r.onStart(p, o, l), (s = !0)
      }),
      (this.itemEnd = function (p) {
        o++,
          r.onProgress !== void 0 && r.onProgress(p, o, l),
          o === l && ((s = !1), r.onLoad !== void 0 && r.onLoad())
      }),
      (this.itemError = function (p) {
        r.onError !== void 0 && r.onError(p)
      }),
      (this.resolveURL = function (p) {
        return u ? u(p) : p
      }),
      (this.setURLModifier = function (p) {
        return (u = p), this
      }),
      (this.addHandler = function (p, m) {
        return d.push(p, m), this
      }),
      (this.removeHandler = function (p) {
        const m = d.indexOf(p)
        return m !== -1 && d.splice(m, 2), this
      }),
      (this.getHandler = function (p) {
        for (let m = 0, v = d.length; m < v; m += 2) {
          const y = d[m],
            x = d[m + 1]
          if ((y.global && (y.lastIndex = 0), y.test(p))) return x
        }
        return null
      })
  }
}
const sR = new rS()
class Dr {
  constructor(e) {
    ;(this.manager = e !== void 0 ? e : sR),
      (this.crossOrigin = "anonymous"),
      (this.withCredentials = !1),
      (this.path = ""),
      (this.resourcePath = ""),
      (this.requestHeader = {})
  }
  load() {}
  loadAsync(e, t) {
    const i = this
    return new Promise(function (r, s) {
      i.load(e, r, t, s)
    })
  }
  parse() {}
  setCrossOrigin(e) {
    return (this.crossOrigin = e), this
  }
  setWithCredentials(e) {
    return (this.withCredentials = e), this
  }
  setPath(e) {
    return (this.path = e), this
  }
  setResourcePath(e) {
    return (this.resourcePath = e), this
  }
  setRequestHeader(e) {
    return (this.requestHeader = e), this
  }
}
Dr.DEFAULT_MATERIAL_NAME = "__DEFAULT"
const Oa = {}
class F6 extends Error {
  constructor(e, t) {
    super(e), (this.response = t)
  }
}
class Ko extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    e === void 0 && (e = ""),
      this.path !== void 0 && (e = this.path + e),
      (e = this.manager.resolveURL(e))
    const s = Ha.get(e)
    if (s !== void 0)
      return (
        this.manager.itemStart(e),
        setTimeout(() => {
          t && t(s), this.manager.itemEnd(e)
        }, 0),
        s
      )
    if (Oa[e] !== void 0) {
      Oa[e].push({ onLoad: t, onProgress: i, onError: r })
      return
    }
    ;(Oa[e] = []), Oa[e].push({ onLoad: t, onProgress: i, onError: r })
    const o = new Request(e, {
        headers: new Headers(this.requestHeader),
        credentials: this.withCredentials ? "include" : "same-origin",
      }),
      l = this.mimeType,
      u = this.responseType
    fetch(o)
      .then((d) => {
        if (d.status === 200 || d.status === 0) {
          if (
            (d.status === 0 &&
              console.warn("THREE.FileLoader: HTTP Status 0 received."),
            typeof ReadableStream > "u" ||
              d.body === void 0 ||
              d.body.getReader === void 0)
          )
            return d
          const p = Oa[e],
            m = d.body.getReader(),
            v = d.headers.get("X-File-Size") || d.headers.get("Content-Length"),
            y = v ? parseInt(v) : 0,
            x = y !== 0
          let E = 0
          const M = new ReadableStream({
            start(w) {
              A()
              function A() {
                m.read().then(
                  ({ done: C, value: R }) => {
                    if (C) w.close()
                    else {
                      E += R.byteLength
                      const z = new ProgressEvent("progress", {
                        lengthComputable: x,
                        loaded: E,
                        total: y,
                      })
                      for (let U = 0, O = p.length; U < O; U++) {
                        const N = p[U]
                        N.onProgress && N.onProgress(z)
                      }
                      w.enqueue(R), A()
                    }
                  },
                  (C) => {
                    w.error(C)
                  },
                )
              }
            },
          })
          return new Response(M)
        } else
          throw new F6(
            `fetch for "${d.url}" responded with ${d.status}: ${d.statusText}`,
            d,
          )
      })
      .then((d) => {
        switch (u) {
          case "arraybuffer":
            return d.arrayBuffer()
          case "blob":
            return d.blob()
          case "document":
            return d.text().then((p) => new DOMParser().parseFromString(p, l))
          case "json":
            return d.json()
          default:
            if (l === void 0) return d.text()
            {
              const m = /charset="?([^;"\s]*)"?/i.exec(l),
                v = m && m[1] ? m[1].toLowerCase() : void 0,
                y = new TextDecoder(v)
              return d.arrayBuffer().then((x) => y.decode(x))
            }
        }
      })
      .then((d) => {
        Ha.add(e, d)
        const p = Oa[e]
        delete Oa[e]
        for (let m = 0, v = p.length; m < v; m++) {
          const y = p[m]
          y.onLoad && y.onLoad(d)
        }
      })
      .catch((d) => {
        const p = Oa[e]
        if (p === void 0) throw (this.manager.itemError(e), d)
        delete Oa[e]
        for (let m = 0, v = p.length; m < v; m++) {
          const y = p[m]
          y.onError && y.onError(d)
        }
        this.manager.itemError(e)
      })
      .finally(() => {
        this.manager.itemEnd(e)
      }),
      this.manager.itemStart(e)
  }
  setResponseType(e) {
    return (this.responseType = e), this
  }
  setMimeType(e) {
    return (this.mimeType = e), this
  }
}
class U6 extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    const s = this,
      o = new Ko(this.manager)
    o.setPath(this.path),
      o.setRequestHeader(this.requestHeader),
      o.setWithCredentials(this.withCredentials),
      o.load(
        e,
        function (l) {
          try {
            t(s.parse(JSON.parse(l)))
          } catch (u) {
            r ? r(u) : console.error(u), s.manager.itemError(e)
          }
        },
        i,
        r,
      )
  }
  parse(e) {
    const t = []
    for (let i = 0; i < e.length; i++) {
      const r = Ud.parse(e[i])
      t.push(r)
    }
    return t
  }
}
class O6 extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    const s = this,
      o = [],
      l = new oy(),
      u = new Ko(this.manager)
    u.setPath(this.path),
      u.setResponseType("arraybuffer"),
      u.setRequestHeader(this.requestHeader),
      u.setWithCredentials(s.withCredentials)
    let d = 0
    function p(m) {
      u.load(
        e[m],
        function (v) {
          const y = s.parse(v, !0)
          ;(o[m] = {
            width: y.width,
            height: y.height,
            format: y.format,
            mipmaps: y.mipmaps,
          }),
            (d += 1),
            d === 6 &&
              (y.mipmapCount === 1 && (l.minFilter = Ri),
              (l.image = o),
              (l.format = y.format),
              (l.needsUpdate = !0),
              t && t(l))
        },
        i,
        r,
      )
    }
    if (Array.isArray(e)) for (let m = 0, v = e.length; m < v; ++m) p(m)
    else
      u.load(
        e,
        function (m) {
          const v = s.parse(m, !0)
          if (v.isCubemap) {
            const y = v.mipmaps.length / v.mipmapCount
            for (let x = 0; x < y; x++) {
              o[x] = { mipmaps: [] }
              for (let E = 0; E < v.mipmapCount; E++)
                o[x].mipmaps.push(v.mipmaps[x * v.mipmapCount + E]),
                  (o[x].format = v.format),
                  (o[x].width = v.width),
                  (o[x].height = v.height)
            }
            l.image = o
          } else
            (l.image.width = v.width),
              (l.image.height = v.height),
              (l.mipmaps = v.mipmaps)
          v.mipmapCount === 1 && (l.minFilter = Ri),
            (l.format = v.format),
            (l.needsUpdate = !0),
            t && t(l)
        },
        i,
        r,
      )
    return l
  }
}
class im extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    this.path !== void 0 && (e = this.path + e), (e = this.manager.resolveURL(e))
    const s = this,
      o = Ha.get(e)
    if (o !== void 0)
      return (
        s.manager.itemStart(e),
        setTimeout(function () {
          t && t(o), s.manager.itemEnd(e)
        }, 0),
        o
      )
    const l = Kp("img")
    function u() {
      p(), Ha.add(e, this), t && t(this), s.manager.itemEnd(e)
    }
    function d(m) {
      p(), r && r(m), s.manager.itemError(e), s.manager.itemEnd(e)
    }
    function p() {
      l.removeEventListener("load", u, !1), l.removeEventListener("error", d, !1)
    }
    return (
      l.addEventListener("load", u, !1),
      l.addEventListener("error", d, !1),
      e.slice(0, 5) !== "data:" &&
        this.crossOrigin !== void 0 &&
        (l.crossOrigin = this.crossOrigin),
      s.manager.itemStart(e),
      (l.src = e),
      l
    )
  }
}
class B6 extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    const s = new _m()
    s.colorSpace = Kr
    const o = new im(this.manager)
    o.setCrossOrigin(this.crossOrigin), o.setPath(this.path)
    let l = 0
    function u(d) {
      o.load(
        e[d],
        function (p) {
          ;(s.images[d] = p), l++, l === 6 && ((s.needsUpdate = !0), t && t(s))
        },
        void 0,
        r,
      )
    }
    for (let d = 0; d < e.length; ++d) u(d)
    return s
  }
}
class z6 extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    const s = this,
      o = new Yo(),
      l = new Ko(this.manager)
    return (
      l.setResponseType("arraybuffer"),
      l.setRequestHeader(this.requestHeader),
      l.setPath(this.path),
      l.setWithCredentials(s.withCredentials),
      l.load(
        e,
        function (u) {
          let d
          try {
            d = s.parse(u)
          } catch (p) {
            if (r !== void 0) r(p)
            else {
              console.error(p)
              return
            }
          }
          d.image !== void 0
            ? (o.image = d.image)
            : d.data !== void 0 &&
              ((o.image.width = d.width),
              (o.image.height = d.height),
              (o.image.data = d.data)),
            (o.wrapS = d.wrapS !== void 0 ? d.wrapS : Jr),
            (o.wrapT = d.wrapT !== void 0 ? d.wrapT : Jr),
            (o.magFilter = d.magFilter !== void 0 ? d.magFilter : Ri),
            (o.minFilter = d.minFilter !== void 0 ? d.minFilter : Ri),
            (o.anisotropy = d.anisotropy !== void 0 ? d.anisotropy : 1),
            d.colorSpace !== void 0 && (o.colorSpace = d.colorSpace),
            d.flipY !== void 0 && (o.flipY = d.flipY),
            d.format !== void 0 && (o.format = d.format),
            d.type !== void 0 && (o.type = d.type),
            d.mipmaps !== void 0 && ((o.mipmaps = d.mipmaps), (o.minFilter = Ho)),
            d.mipmapCount === 1 && (o.minFilter = Ri),
            d.generateMipmaps !== void 0 && (o.generateMipmaps = d.generateMipmaps),
            (o.needsUpdate = !0),
            t && t(o, d)
        },
        i,
        r,
      ),
      o
    )
  }
}
class oR extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    const s = new zn(),
      o = new im(this.manager)
    return (
      o.setCrossOrigin(this.crossOrigin),
      o.setPath(this.path),
      o.load(
        e,
        function (l) {
          ;(s.image = l), (s.needsUpdate = !0), t !== void 0 && t(s)
        },
        i,
        r,
      ),
      s
    )
  }
}
class cc extends cn {
  constructor(e, t = 1) {
    super(),
      (this.isLight = !0),
      (this.type = "Light"),
      (this.color = new ot(e)),
      (this.intensity = t)
  }
  dispose() {}
  copy(e, t) {
    return (
      super.copy(e, t), this.color.copy(e.color), (this.intensity = e.intensity), this
    )
  }
  toJSON(e) {
    const t = super.toJSON(e)
    return (
      (t.object.color = this.color.getHex()),
      (t.object.intensity = this.intensity),
      this.groundColor !== void 0 && (t.object.groundColor = this.groundColor.getHex()),
      this.distance !== void 0 && (t.object.distance = this.distance),
      this.angle !== void 0 && (t.object.angle = this.angle),
      this.decay !== void 0 && (t.object.decay = this.decay),
      this.penumbra !== void 0 && (t.object.penumbra = this.penumbra),
      this.shadow !== void 0 && (t.object.shadow = this.shadow.toJSON()),
      this.target !== void 0 && (t.object.target = this.target.uuid),
      t
    )
  }
}
class aR extends cc {
  constructor(e, t, i) {
    super(e, i),
      (this.isHemisphereLight = !0),
      (this.type = "HemisphereLight"),
      this.position.copy(cn.DEFAULT_UP),
      this.updateMatrix(),
      (this.groundColor = new ot(t))
  }
  copy(e, t) {
    return super.copy(e, t), this.groundColor.copy(e.groundColor), this
  }
}
const m_ = new mt(),
  ub = new q(),
  fb = new q()
class sS {
  constructor(e) {
    ;(this.camera = e),
      (this.intensity = 1),
      (this.bias = 0),
      (this.normalBias = 0),
      (this.radius = 1),
      (this.blurSamples = 8),
      (this.mapSize = new We(512, 512)),
      (this.map = null),
      (this.mapPass = null),
      (this.matrix = new mt()),
      (this.autoUpdate = !0),
      (this.needsUpdate = !1),
      (this._frustum = new wm()),
      (this._frameExtents = new We(1, 1)),
      (this._viewportCount = 1),
      (this._viewports = [new on(0, 0, 1, 1)])
  }
  getViewportCount() {
    return this._viewportCount
  }
  getFrustum() {
    return this._frustum
  }
  updateMatrices(e) {
    const t = this.camera,
      i = this.matrix
    ub.setFromMatrixPosition(e.matrixWorld),
      t.position.copy(ub),
      fb.setFromMatrixPosition(e.target.matrixWorld),
      t.lookAt(fb),
      t.updateMatrixWorld(),
      m_.multiplyMatrices(t.projectionMatrix, t.matrixWorldInverse),
      this._frustum.setFromProjectionMatrix(m_),
      i.set(0.5, 0, 0, 0.5, 0, 0.5, 0, 0.5, 0, 0, 0.5, 0.5, 0, 0, 0, 1),
      i.multiply(m_)
  }
  getViewport(e) {
    return this._viewports[e]
  }
  getFrameExtents() {
    return this._frameExtents
  }
  dispose() {
    this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose()
  }
  copy(e) {
    return (
      (this.camera = e.camera.clone()),
      (this.intensity = e.intensity),
      (this.bias = e.bias),
      (this.radius = e.radius),
      this.mapSize.copy(e.mapSize),
      this
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
  toJSON() {
    const e = {}
    return (
      this.intensity !== 1 && (e.intensity = this.intensity),
      this.bias !== 0 && (e.bias = this.bias),
      this.normalBias !== 0 && (e.normalBias = this.normalBias),
      this.radius !== 1 && (e.radius = this.radius),
      (this.mapSize.x !== 512 || this.mapSize.y !== 512) &&
        (e.mapSize = this.mapSize.toArray()),
      (e.camera = this.camera.toJSON(!1).object),
      delete e.camera.matrix,
      e
    )
  }
}
class V6 extends sS {
  constructor() {
    super(new Ci(50, 1, 0.5, 500)), (this.isSpotLightShadow = !0), (this.focus = 1)
  }
  updateMatrices(e) {
    const t = this.camera,
      i = Ld * 2 * e.angle * this.focus,
      r = this.mapSize.width / this.mapSize.height,
      s = e.distance || t.far
    ;(i !== t.fov || r !== t.aspect || s !== t.far) &&
      ((t.fov = i), (t.aspect = r), (t.far = s), t.updateProjectionMatrix()),
      super.updateMatrices(e)
  }
  copy(e) {
    return super.copy(e), (this.focus = e.focus), this
  }
}
class oS extends cc {
  constructor(e, t, i = 0, r = Math.PI / 3, s = 0, o = 2) {
    super(e, t),
      (this.isSpotLight = !0),
      (this.type = "SpotLight"),
      this.position.copy(cn.DEFAULT_UP),
      this.updateMatrix(),
      (this.target = new cn()),
      (this.distance = i),
      (this.angle = r),
      (this.penumbra = s),
      (this.decay = o),
      (this.map = null),
      (this.shadow = new V6())
  }
  get power() {
    return this.intensity * Math.PI
  }
  set power(e) {
    this.intensity = e / Math.PI
  }
  dispose() {
    this.shadow.dispose()
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      (this.distance = e.distance),
      (this.angle = e.angle),
      (this.penumbra = e.penumbra),
      (this.decay = e.decay),
      (this.target = e.target.clone()),
      (this.shadow = e.shadow.clone()),
      this
    )
  }
}
const db = new mt(),
  rp = new q(),
  g_ = new q()
class H6 extends sS {
  constructor() {
    super(new Ci(90, 1, 0.5, 500)),
      (this.isPointLightShadow = !0),
      (this._frameExtents = new We(4, 2)),
      (this._viewportCount = 6),
      (this._viewports = [
        new on(2, 1, 1, 1),
        new on(0, 1, 1, 1),
        new on(3, 1, 1, 1),
        new on(1, 1, 1, 1),
        new on(3, 0, 1, 1),
        new on(1, 0, 1, 1),
      ]),
      (this._cubeDirections = [
        new q(1, 0, 0),
        new q(-1, 0, 0),
        new q(0, 0, 1),
        new q(0, 0, -1),
        new q(0, 1, 0),
        new q(0, -1, 0),
      ]),
      (this._cubeUps = [
        new q(0, 1, 0),
        new q(0, 1, 0),
        new q(0, 1, 0),
        new q(0, 1, 0),
        new q(0, 0, 1),
        new q(0, 0, -1),
      ])
  }
  updateMatrices(e, t = 0) {
    const i = this.camera,
      r = this.matrix,
      s = e.distance || i.far
    s !== i.far && ((i.far = s), i.updateProjectionMatrix()),
      rp.setFromMatrixPosition(e.matrixWorld),
      i.position.copy(rp),
      g_.copy(i.position),
      g_.add(this._cubeDirections[t]),
      i.up.copy(this._cubeUps[t]),
      i.lookAt(g_),
      i.updateMatrixWorld(),
      r.makeTranslation(-rp.x, -rp.y, -rp.z),
      db.multiplyMatrices(i.projectionMatrix, i.matrixWorldInverse),
      this._frustum.setFromProjectionMatrix(db)
  }
}
class Av extends cc {
  constructor(e, t, i = 0, r = 2) {
    super(e, t),
      (this.isPointLight = !0),
      (this.type = "PointLight"),
      (this.distance = i),
      (this.decay = r),
      (this.shadow = new H6())
  }
  get power() {
    return this.intensity * 4 * Math.PI
  }
  set power(e) {
    this.intensity = e / (4 * Math.PI)
  }
  dispose() {
    this.shadow.dispose()
  }
  copy(e, t) {
    return (
      super.copy(e, t),
      (this.distance = e.distance),
      (this.decay = e.decay),
      (this.shadow = e.shadow.clone()),
      this
    )
  }
}
class G6 extends sS {
  constructor() {
    super(new Xd(-5, 5, 5, -5, 0.5, 500)), (this.isDirectionalLightShadow = !0)
  }
}
class aS extends cc {
  constructor(e, t) {
    super(e, t),
      (this.isDirectionalLight = !0),
      (this.type = "DirectionalLight"),
      this.position.copy(cn.DEFAULT_UP),
      this.updateMatrix(),
      (this.target = new cn()),
      (this.shadow = new G6())
  }
  dispose() {
    this.shadow.dispose()
  }
  copy(e) {
    return (
      super.copy(e),
      (this.target = e.target.clone()),
      (this.shadow = e.shadow.clone()),
      this
    )
  }
}
class lS extends cc {
  constructor(e, t) {
    super(e, t), (this.isAmbientLight = !0), (this.type = "AmbientLight")
  }
}
class lR extends cc {
  constructor(e, t, i = 10, r = 10) {
    super(e, t),
      (this.isRectAreaLight = !0),
      (this.type = "RectAreaLight"),
      (this.width = i),
      (this.height = r)
  }
  get power() {
    return this.intensity * this.width * this.height * Math.PI
  }
  set power(e) {
    this.intensity = e / (this.width * this.height * Math.PI)
  }
  copy(e) {
    return super.copy(e), (this.width = e.width), (this.height = e.height), this
  }
  toJSON(e) {
    const t = super.toJSON(e)
    return (t.object.width = this.width), (t.object.height = this.height), t
  }
}
class cR {
  constructor() {
    ;(this.isSphericalHarmonics3 = !0), (this.coefficients = [])
    for (let e = 0; e < 9; e++) this.coefficients.push(new q())
  }
  set(e) {
    for (let t = 0; t < 9; t++) this.coefficients[t].copy(e[t])
    return this
  }
  zero() {
    for (let e = 0; e < 9; e++) this.coefficients[e].set(0, 0, 0)
    return this
  }
  getAt(e, t) {
    const i = e.x,
      r = e.y,
      s = e.z,
      o = this.coefficients
    return (
      t.copy(o[0]).multiplyScalar(0.282095),
      t.addScaledVector(o[1], 0.488603 * r),
      t.addScaledVector(o[2], 0.488603 * s),
      t.addScaledVector(o[3], 0.488603 * i),
      t.addScaledVector(o[4], 1.092548 * (i * r)),
      t.addScaledVector(o[5], 1.092548 * (r * s)),
      t.addScaledVector(o[6], 0.315392 * (3 * s * s - 1)),
      t.addScaledVector(o[7], 1.092548 * (i * s)),
      t.addScaledVector(o[8], 0.546274 * (i * i - r * r)),
      t
    )
  }
  getIrradianceAt(e, t) {
    const i = e.x,
      r = e.y,
      s = e.z,
      o = this.coefficients
    return (
      t.copy(o[0]).multiplyScalar(0.886227),
      t.addScaledVector(o[1], 2 * 0.511664 * r),
      t.addScaledVector(o[2], 2 * 0.511664 * s),
      t.addScaledVector(o[3], 2 * 0.511664 * i),
      t.addScaledVector(o[4], 2 * 0.429043 * i * r),
      t.addScaledVector(o[5], 2 * 0.429043 * r * s),
      t.addScaledVector(o[6], 0.743125 * s * s - 0.247708),
      t.addScaledVector(o[7], 2 * 0.429043 * i * s),
      t.addScaledVector(o[8], 0.429043 * (i * i - r * r)),
      t
    )
  }
  add(e) {
    for (let t = 0; t < 9; t++) this.coefficients[t].add(e.coefficients[t])
    return this
  }
  addScaledSH(e, t) {
    for (let i = 0; i < 9; i++)
      this.coefficients[i].addScaledVector(e.coefficients[i], t)
    return this
  }
  scale(e) {
    for (let t = 0; t < 9; t++) this.coefficients[t].multiplyScalar(e)
    return this
  }
  lerp(e, t) {
    for (let i = 0; i < 9; i++) this.coefficients[i].lerp(e.coefficients[i], t)
    return this
  }
  equals(e) {
    for (let t = 0; t < 9; t++)
      if (!this.coefficients[t].equals(e.coefficients[t])) return !1
    return !0
  }
  copy(e) {
    return this.set(e.coefficients)
  }
  clone() {
    return new this.constructor().copy(this)
  }
  fromArray(e, t = 0) {
    const i = this.coefficients
    for (let r = 0; r < 9; r++) i[r].fromArray(e, t + r * 3)
    return this
  }
  toArray(e = [], t = 0) {
    const i = this.coefficients
    for (let r = 0; r < 9; r++) i[r].toArray(e, t + r * 3)
    return e
  }
  static getBasisAt(e, t) {
    const i = e.x,
      r = e.y,
      s = e.z
    ;(t[0] = 0.282095),
      (t[1] = 0.488603 * r),
      (t[2] = 0.488603 * s),
      (t[3] = 0.488603 * i),
      (t[4] = 1.092548 * i * r),
      (t[5] = 1.092548 * r * s),
      (t[6] = 0.315392 * (3 * s * s - 1)),
      (t[7] = 1.092548 * i * s),
      (t[8] = 0.546274 * (i * i - r * r))
  }
}
class uR extends cc {
  constructor(e = new cR(), t = 1) {
    super(void 0, t), (this.isLightProbe = !0), (this.sh = e)
  }
  copy(e) {
    return super.copy(e), this.sh.copy(e.sh), this
  }
  fromJSON(e) {
    return (this.intensity = e.intensity), this.sh.fromArray(e.sh), this
  }
  toJSON(e) {
    const t = super.toJSON(e)
    return (t.object.sh = this.sh.toArray()), t
  }
}
class wy extends Dr {
  constructor(e) {
    super(e), (this.textures = {})
  }
  load(e, t, i, r) {
    const s = this,
      o = new Ko(s.manager)
    o.setPath(s.path),
      o.setRequestHeader(s.requestHeader),
      o.setWithCredentials(s.withCredentials),
      o.load(
        e,
        function (l) {
          try {
            t(s.parse(JSON.parse(l)))
          } catch (u) {
            r ? r(u) : console.error(u), s.manager.itemError(e)
          }
        },
        i,
        r,
      )
  }
  parse(e) {
    const t = this.textures
    function i(s) {
      return (
        t[s] === void 0 && console.warn("THREE.MaterialLoader: Undefined texture", s),
        t[s]
      )
    }
    const r = this.createMaterialFromType(e.type)
    if (
      (e.uuid !== void 0 && (r.uuid = e.uuid),
      e.name !== void 0 && (r.name = e.name),
      e.color !== void 0 && r.color !== void 0 && r.color.setHex(e.color),
      e.roughness !== void 0 && (r.roughness = e.roughness),
      e.metalness !== void 0 && (r.metalness = e.metalness),
      e.sheen !== void 0 && (r.sheen = e.sheen),
      e.sheenColor !== void 0 && (r.sheenColor = new ot().setHex(e.sheenColor)),
      e.sheenRoughness !== void 0 && (r.sheenRoughness = e.sheenRoughness),
      e.emissive !== void 0 && r.emissive !== void 0 && r.emissive.setHex(e.emissive),
      e.specular !== void 0 && r.specular !== void 0 && r.specular.setHex(e.specular),
      e.specularIntensity !== void 0 && (r.specularIntensity = e.specularIntensity),
      e.specularColor !== void 0 &&
        r.specularColor !== void 0 &&
        r.specularColor.setHex(e.specularColor),
      e.shininess !== void 0 && (r.shininess = e.shininess),
      e.clearcoat !== void 0 && (r.clearcoat = e.clearcoat),
      e.clearcoatRoughness !== void 0 && (r.clearcoatRoughness = e.clearcoatRoughness),
      e.dispersion !== void 0 && (r.dispersion = e.dispersion),
      e.iridescence !== void 0 && (r.iridescence = e.iridescence),
      e.iridescenceIOR !== void 0 && (r.iridescenceIOR = e.iridescenceIOR),
      e.iridescenceThicknessRange !== void 0 &&
        (r.iridescenceThicknessRange = e.iridescenceThicknessRange),
      e.transmission !== void 0 && (r.transmission = e.transmission),
      e.thickness !== void 0 && (r.thickness = e.thickness),
      e.attenuationDistance !== void 0 &&
        (r.attenuationDistance = e.attenuationDistance),
      e.attenuationColor !== void 0 &&
        r.attenuationColor !== void 0 &&
        r.attenuationColor.setHex(e.attenuationColor),
      e.anisotropy !== void 0 && (r.anisotropy = e.anisotropy),
      e.anisotropyRotation !== void 0 && (r.anisotropyRotation = e.anisotropyRotation),
      e.fog !== void 0 && (r.fog = e.fog),
      e.flatShading !== void 0 && (r.flatShading = e.flatShading),
      e.blending !== void 0 && (r.blending = e.blending),
      e.combine !== void 0 && (r.combine = e.combine),
      e.side !== void 0 && (r.side = e.side),
      e.shadowSide !== void 0 && (r.shadowSide = e.shadowSide),
      e.opacity !== void 0 && (r.opacity = e.opacity),
      e.transparent !== void 0 && (r.transparent = e.transparent),
      e.alphaTest !== void 0 && (r.alphaTest = e.alphaTest),
      e.alphaHash !== void 0 && (r.alphaHash = e.alphaHash),
      e.depthFunc !== void 0 && (r.depthFunc = e.depthFunc),
      e.depthTest !== void 0 && (r.depthTest = e.depthTest),
      e.depthWrite !== void 0 && (r.depthWrite = e.depthWrite),
      e.colorWrite !== void 0 && (r.colorWrite = e.colorWrite),
      e.blendSrc !== void 0 && (r.blendSrc = e.blendSrc),
      e.blendDst !== void 0 && (r.blendDst = e.blendDst),
      e.blendEquation !== void 0 && (r.blendEquation = e.blendEquation),
      e.blendSrcAlpha !== void 0 && (r.blendSrcAlpha = e.blendSrcAlpha),
      e.blendDstAlpha !== void 0 && (r.blendDstAlpha = e.blendDstAlpha),
      e.blendEquationAlpha !== void 0 && (r.blendEquationAlpha = e.blendEquationAlpha),
      e.blendColor !== void 0 &&
        r.blendColor !== void 0 &&
        r.blendColor.setHex(e.blendColor),
      e.blendAlpha !== void 0 && (r.blendAlpha = e.blendAlpha),
      e.stencilWriteMask !== void 0 && (r.stencilWriteMask = e.stencilWriteMask),
      e.stencilFunc !== void 0 && (r.stencilFunc = e.stencilFunc),
      e.stencilRef !== void 0 && (r.stencilRef = e.stencilRef),
      e.stencilFuncMask !== void 0 && (r.stencilFuncMask = e.stencilFuncMask),
      e.stencilFail !== void 0 && (r.stencilFail = e.stencilFail),
      e.stencilZFail !== void 0 && (r.stencilZFail = e.stencilZFail),
      e.stencilZPass !== void 0 && (r.stencilZPass = e.stencilZPass),
      e.stencilWrite !== void 0 && (r.stencilWrite = e.stencilWrite),
      e.wireframe !== void 0 && (r.wireframe = e.wireframe),
      e.wireframeLinewidth !== void 0 && (r.wireframeLinewidth = e.wireframeLinewidth),
      e.wireframeLinecap !== void 0 && (r.wireframeLinecap = e.wireframeLinecap),
      e.wireframeLinejoin !== void 0 && (r.wireframeLinejoin = e.wireframeLinejoin),
      e.rotation !== void 0 && (r.rotation = e.rotation),
      e.linewidth !== void 0 && (r.linewidth = e.linewidth),
      e.dashSize !== void 0 && (r.dashSize = e.dashSize),
      e.gapSize !== void 0 && (r.gapSize = e.gapSize),
      e.scale !== void 0 && (r.scale = e.scale),
      e.polygonOffset !== void 0 && (r.polygonOffset = e.polygonOffset),
      e.polygonOffsetFactor !== void 0 &&
        (r.polygonOffsetFactor = e.polygonOffsetFactor),
      e.polygonOffsetUnits !== void 0 && (r.polygonOffsetUnits = e.polygonOffsetUnits),
      e.dithering !== void 0 && (r.dithering = e.dithering),
      e.alphaToCoverage !== void 0 && (r.alphaToCoverage = e.alphaToCoverage),
      e.premultipliedAlpha !== void 0 && (r.premultipliedAlpha = e.premultipliedAlpha),
      e.forceSinglePass !== void 0 && (r.forceSinglePass = e.forceSinglePass),
      e.visible !== void 0 && (r.visible = e.visible),
      e.toneMapped !== void 0 && (r.toneMapped = e.toneMapped),
      e.userData !== void 0 && (r.userData = e.userData),
      e.vertexColors !== void 0 &&
        (typeof e.vertexColors == "number"
          ? (r.vertexColors = e.vertexColors > 0)
          : (r.vertexColors = e.vertexColors)),
      e.uniforms !== void 0)
    )
      for (const s in e.uniforms) {
        const o = e.uniforms[s]
        switch (((r.uniforms[s] = {}), o.type)) {
          case "t":
            r.uniforms[s].value = i(o.value)
            break
          case "c":
            r.uniforms[s].value = new ot().setHex(o.value)
            break
          case "v2":
            r.uniforms[s].value = new We().fromArray(o.value)
            break
          case "v3":
            r.uniforms[s].value = new q().fromArray(o.value)
            break
          case "v4":
            r.uniforms[s].value = new on().fromArray(o.value)
            break
          case "m3":
            r.uniforms[s].value = new Xt().fromArray(o.value)
            break
          case "m4":
            r.uniforms[s].value = new mt().fromArray(o.value)
            break
          default:
            r.uniforms[s].value = o.value
        }
      }
    if (
      (e.defines !== void 0 && (r.defines = e.defines),
      e.vertexShader !== void 0 && (r.vertexShader = e.vertexShader),
      e.fragmentShader !== void 0 && (r.fragmentShader = e.fragmentShader),
      e.glslVersion !== void 0 && (r.glslVersion = e.glslVersion),
      e.extensions !== void 0)
    )
      for (const s in e.extensions) r.extensions[s] = e.extensions[s]
    if (
      (e.lights !== void 0 && (r.lights = e.lights),
      e.clipping !== void 0 && (r.clipping = e.clipping),
      e.size !== void 0 && (r.size = e.size),
      e.sizeAttenuation !== void 0 && (r.sizeAttenuation = e.sizeAttenuation),
      e.map !== void 0 && (r.map = i(e.map)),
      e.matcap !== void 0 && (r.matcap = i(e.matcap)),
      e.alphaMap !== void 0 && (r.alphaMap = i(e.alphaMap)),
      e.bumpMap !== void 0 && (r.bumpMap = i(e.bumpMap)),
      e.bumpScale !== void 0 && (r.bumpScale = e.bumpScale),
      e.normalMap !== void 0 && (r.normalMap = i(e.normalMap)),
      e.normalMapType !== void 0 && (r.normalMapType = e.normalMapType),
      e.normalScale !== void 0)
    ) {
      let s = e.normalScale
      Array.isArray(s) === !1 && (s = [s, s]), (r.normalScale = new We().fromArray(s))
    }
    return (
      e.displacementMap !== void 0 && (r.displacementMap = i(e.displacementMap)),
      e.displacementScale !== void 0 && (r.displacementScale = e.displacementScale),
      e.displacementBias !== void 0 && (r.displacementBias = e.displacementBias),
      e.roughnessMap !== void 0 && (r.roughnessMap = i(e.roughnessMap)),
      e.metalnessMap !== void 0 && (r.metalnessMap = i(e.metalnessMap)),
      e.emissiveMap !== void 0 && (r.emissiveMap = i(e.emissiveMap)),
      e.emissiveIntensity !== void 0 && (r.emissiveIntensity = e.emissiveIntensity),
      e.specularMap !== void 0 && (r.specularMap = i(e.specularMap)),
      e.specularIntensityMap !== void 0 &&
        (r.specularIntensityMap = i(e.specularIntensityMap)),
      e.specularColorMap !== void 0 && (r.specularColorMap = i(e.specularColorMap)),
      e.envMap !== void 0 && (r.envMap = i(e.envMap)),
      e.envMapRotation !== void 0 && r.envMapRotation.fromArray(e.envMapRotation),
      e.envMapIntensity !== void 0 && (r.envMapIntensity = e.envMapIntensity),
      e.reflectivity !== void 0 && (r.reflectivity = e.reflectivity),
      e.refractionRatio !== void 0 && (r.refractionRatio = e.refractionRatio),
      e.lightMap !== void 0 && (r.lightMap = i(e.lightMap)),
      e.lightMapIntensity !== void 0 && (r.lightMapIntensity = e.lightMapIntensity),
      e.aoMap !== void 0 && (r.aoMap = i(e.aoMap)),
      e.aoMapIntensity !== void 0 && (r.aoMapIntensity = e.aoMapIntensity),
      e.gradientMap !== void 0 && (r.gradientMap = i(e.gradientMap)),
      e.clearcoatMap !== void 0 && (r.clearcoatMap = i(e.clearcoatMap)),
      e.clearcoatRoughnessMap !== void 0 &&
        (r.clearcoatRoughnessMap = i(e.clearcoatRoughnessMap)),
      e.clearcoatNormalMap !== void 0 &&
        (r.clearcoatNormalMap = i(e.clearcoatNormalMap)),
      e.clearcoatNormalScale !== void 0 &&
        (r.clearcoatNormalScale = new We().fromArray(e.clearcoatNormalScale)),
      e.iridescenceMap !== void 0 && (r.iridescenceMap = i(e.iridescenceMap)),
      e.iridescenceThicknessMap !== void 0 &&
        (r.iridescenceThicknessMap = i(e.iridescenceThicknessMap)),
      e.transmissionMap !== void 0 && (r.transmissionMap = i(e.transmissionMap)),
      e.thicknessMap !== void 0 && (r.thicknessMap = i(e.thicknessMap)),
      e.anisotropyMap !== void 0 && (r.anisotropyMap = i(e.anisotropyMap)),
      e.sheenColorMap !== void 0 && (r.sheenColorMap = i(e.sheenColorMap)),
      e.sheenRoughnessMap !== void 0 && (r.sheenRoughnessMap = i(e.sheenRoughnessMap)),
      r
    )
  }
  setTextures(e) {
    return (this.textures = e), this
  }
  createMaterialFromType(e) {
    return wy.createMaterialFromType(e)
  }
  static createMaterialFromType(e) {
    const t = {
      ShadowMaterial: Y3,
      SpriteMaterial: Ww,
      RawShaderMaterial: q3,
      ShaderMaterial: Mo,
      PointsMaterial: Xw,
      MeshPhysicalMaterial: $3,
      MeshStandardMaterial: Qw,
      MeshPhongMaterial: Np,
      MeshToonMaterial: K3,
      MeshNormalMaterial: Z3,
      MeshLambertMaterial: eS,
      MeshDepthMaterial: Hw,
      MeshDistanceMaterial: Gw,
      MeshBasicMaterial: el,
      MeshMatcapMaterial: J3,
      LineDashedMaterial: Q3,
      LineBasicMaterial: mr,
      Material: er,
    }
    return new t[e]()
  }
}
class Cv {
  static decodeText(e) {
    if (
      (console.warn(
        "THREE.LoaderUtils: decodeText() has been deprecated with r165 and will be removed with r175. Use TextDecoder instead.",
      ),
      typeof TextDecoder < "u")
    )
      return new TextDecoder().decode(e)
    let t = ""
    for (let i = 0, r = e.length; i < r; i++) t += String.fromCharCode(e[i])
    try {
      return decodeURIComponent(escape(t))
    } catch {
      return t
    }
  }
  static extractUrlBase(e) {
    const t = e.lastIndexOf("/")
    return t === -1 ? "./" : e.slice(0, t + 1)
  }
  static resolveURL(e, t) {
    return typeof e != "string" || e === ""
      ? ""
      : (/^https?:\/\//i.test(t) &&
          /^\//.test(e) &&
          (t = t.replace(/(^https?:\/\/[^\/]+).*/i, "$1")),
        /^(https?:)?\/\//i.test(e) || /^data:.*,.*$/i.test(e) || /^blob:.*$/i.test(e)
          ? e
          : t + e)
  }
}
class fR extends Gt {
  constructor() {
    super(),
      (this.isInstancedBufferGeometry = !0),
      (this.type = "InstancedBufferGeometry"),
      (this.instanceCount = 1 / 0)
  }
  copy(e) {
    return super.copy(e), (this.instanceCount = e.instanceCount), this
  }
  toJSON() {
    const e = super.toJSON()
    return (e.instanceCount = this.instanceCount), (e.isInstancedBufferGeometry = !0), e
  }
}
class dR extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    const s = this,
      o = new Ko(s.manager)
    o.setPath(s.path),
      o.setRequestHeader(s.requestHeader),
      o.setWithCredentials(s.withCredentials),
      o.load(
        e,
        function (l) {
          try {
            t(s.parse(JSON.parse(l)))
          } catch (u) {
            r ? r(u) : console.error(u), s.manager.itemError(e)
          }
        },
        i,
        r,
      )
  }
  parse(e) {
    const t = {},
      i = {}
    function r(y, x) {
      if (t[x] !== void 0) return t[x]
      const M = y.interleavedBuffers[x],
        w = s(y, M.buffer),
        A = Sd(M.type, w),
        C = new sy(A, M.stride)
      return (C.uuid = M.uuid), (t[x] = C), C
    }
    function s(y, x) {
      if (i[x] !== void 0) return i[x]
      const M = y.arrayBuffers[x],
        w = new Uint32Array(M).buffer
      return (i[x] = w), w
    }
    const o = e.isInstancedBufferGeometry ? new fR() : new Gt(),
      l = e.data.index
    if (l !== void 0) {
      const y = Sd(l.type, l.array)
      o.setIndex(new bn(y, 1))
    }
    const u = e.data.attributes
    for (const y in u) {
      const x = u[y]
      let E
      if (x.isInterleavedBufferAttribute) {
        const M = r(e.data, x.data)
        E = new ku(M, x.itemSize, x.offset, x.normalized)
      } else {
        const M = Sd(x.type, x.array),
          w = x.isInstancedBufferAttribute ? Nd : bn
        E = new w(M, x.itemSize, x.normalized)
      }
      x.name !== void 0 && (E.name = x.name),
        x.usage !== void 0 && E.setUsage(x.usage),
        o.setAttribute(y, E)
    }
    const d = e.data.morphAttributes
    if (d)
      for (const y in d) {
        const x = d[y],
          E = []
        for (let M = 0, w = x.length; M < w; M++) {
          const A = x[M]
          let C
          if (A.isInterleavedBufferAttribute) {
            const R = r(e.data, A.data)
            C = new ku(R, A.itemSize, A.offset, A.normalized)
          } else {
            const R = Sd(A.type, A.array)
            C = new bn(R, A.itemSize, A.normalized)
          }
          A.name !== void 0 && (C.name = A.name), E.push(C)
        }
        o.morphAttributes[y] = E
      }
    e.data.morphTargetsRelative && (o.morphTargetsRelative = !0)
    const m = e.data.groups || e.data.drawcalls || e.data.offsets
    if (m !== void 0)
      for (let y = 0, x = m.length; y !== x; ++y) {
        const E = m[y]
        o.addGroup(E.start, E.count, E.materialIndex)
      }
    const v = e.data.boundingSphere
    if (v !== void 0) {
      const y = new q()
      v.center !== void 0 && y.fromArray(v.center),
        (o.boundingSphere = new pr(y, v.radius))
    }
    return e.name && (o.name = e.name), e.userData && (o.userData = e.userData), o
  }
}
class W6 extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    const s = this,
      o = this.path === "" ? Cv.extractUrlBase(e) : this.path
    this.resourcePath = this.resourcePath || o
    const l = new Ko(this.manager)
    l.setPath(this.path),
      l.setRequestHeader(this.requestHeader),
      l.setWithCredentials(this.withCredentials),
      l.load(
        e,
        function (u) {
          let d = null
          try {
            d = JSON.parse(u)
          } catch (m) {
            r !== void 0 && r(m),
              console.error("THREE:ObjectLoader: Can't parse " + e + ".", m.message)
            return
          }
          const p = d.metadata
          if (
            p === void 0 ||
            p.type === void 0 ||
            p.type.toLowerCase() === "geometry"
          ) {
            r !== void 0 && r(new Error("THREE.ObjectLoader: Can't load " + e)),
              console.error("THREE.ObjectLoader: Can't load " + e)
            return
          }
          s.parse(d, t)
        },
        i,
        r,
      )
  }
  async loadAsync(e, t) {
    const i = this,
      r = this.path === "" ? Cv.extractUrlBase(e) : this.path
    this.resourcePath = this.resourcePath || r
    const s = new Ko(this.manager)
    s.setPath(this.path),
      s.setRequestHeader(this.requestHeader),
      s.setWithCredentials(this.withCredentials)
    const o = await s.loadAsync(e, t),
      l = JSON.parse(o),
      u = l.metadata
    if (u === void 0 || u.type === void 0 || u.type.toLowerCase() === "geometry")
      throw new Error("THREE.ObjectLoader: Can't load " + e)
    return await i.parseAsync(l)
  }
  parse(e, t) {
    const i = this.parseAnimations(e.animations),
      r = this.parseShapes(e.shapes),
      s = this.parseGeometries(e.geometries, r),
      o = this.parseImages(e.images, function () {
        t !== void 0 && t(d)
      }),
      l = this.parseTextures(e.textures, o),
      u = this.parseMaterials(e.materials, l),
      d = this.parseObject(e.object, s, u, l, i),
      p = this.parseSkeletons(e.skeletons, d)
    if ((this.bindSkeletons(d, p), this.bindLightTargets(d), t !== void 0)) {
      let m = !1
      for (const v in o)
        if (o[v].data instanceof HTMLImageElement) {
          m = !0
          break
        }
      m === !1 && t(d)
    }
    return d
  }
  async parseAsync(e) {
    const t = this.parseAnimations(e.animations),
      i = this.parseShapes(e.shapes),
      r = this.parseGeometries(e.geometries, i),
      s = await this.parseImagesAsync(e.images),
      o = this.parseTextures(e.textures, s),
      l = this.parseMaterials(e.materials, o),
      u = this.parseObject(e.object, r, l, o, t),
      d = this.parseSkeletons(e.skeletons, u)
    return this.bindSkeletons(u, d), this.bindLightTargets(u), u
  }
  parseShapes(e) {
    const t = {}
    if (e !== void 0)
      for (let i = 0, r = e.length; i < r; i++) {
        const s = new Cu().fromJSON(e[i])
        t[s.uuid] = s
      }
    return t
  }
  parseSkeletons(e, t) {
    const i = {},
      r = {}
    if (
      (t.traverse(function (s) {
        s.isBone && (r[s.uuid] = s)
      }),
      e !== void 0)
    )
      for (let s = 0, o = e.length; s < o; s++) {
        const l = new Sm().fromJSON(e[s], r)
        i[l.uuid] = l
      }
    return i
  }
  parseGeometries(e, t) {
    const i = {}
    if (e !== void 0) {
      const r = new dR()
      for (let s = 0, o = e.length; s < o; s++) {
        let l
        const u = e[s]
        switch (u.type) {
          case "BufferGeometry":
          case "InstancedBufferGeometry":
            l = r.parse(u)
            break
          default:
            u.type in cb
              ? (l = cb[u.type].fromJSON(u, t))
              : console.warn(
                  `THREE.ObjectLoader: Unsupported geometry type "${u.type}"`,
                )
        }
        ;(l.uuid = u.uuid),
          u.name !== void 0 && (l.name = u.name),
          u.userData !== void 0 && (l.userData = u.userData),
          (i[u.uuid] = l)
      }
    }
    return i
  }
  parseMaterials(e, t) {
    const i = {},
      r = {}
    if (e !== void 0) {
      const s = new wy()
      s.setTextures(t)
      for (let o = 0, l = e.length; o < l; o++) {
        const u = e[o]
        i[u.uuid] === void 0 && (i[u.uuid] = s.parse(u)), (r[u.uuid] = i[u.uuid])
      }
    }
    return r
  }
  parseAnimations(e) {
    const t = {}
    if (e !== void 0)
      for (let i = 0; i < e.length; i++) {
        const r = e[i],
          s = Ud.parse(r)
        t[s.uuid] = s
      }
    return t
  }
  parseImages(e, t) {
    const i = this,
      r = {}
    let s
    function o(u) {
      return (
        i.manager.itemStart(u),
        s.load(
          u,
          function () {
            i.manager.itemEnd(u)
          },
          void 0,
          function () {
            i.manager.itemError(u), i.manager.itemEnd(u)
          },
        )
      )
    }
    function l(u) {
      if (typeof u == "string") {
        const d = u,
          p = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(d) ? d : i.resourcePath + d
        return o(p)
      } else
        return u.data
          ? { data: Sd(u.type, u.data), width: u.width, height: u.height }
          : null
    }
    if (e !== void 0 && e.length > 0) {
      const u = new rS(t)
      ;(s = new im(u)), s.setCrossOrigin(this.crossOrigin)
      for (let d = 0, p = e.length; d < p; d++) {
        const m = e[d],
          v = m.url
        if (Array.isArray(v)) {
          const y = []
          for (let x = 0, E = v.length; x < E; x++) {
            const M = v[x],
              w = l(M)
            w !== null &&
              (w instanceof HTMLImageElement
                ? y.push(w)
                : y.push(new Yo(w.data, w.width, w.height)))
          }
          r[m.uuid] = new _u(y)
        } else {
          const y = l(m.url)
          r[m.uuid] = new _u(y)
        }
      }
    }
    return r
  }
  async parseImagesAsync(e) {
    const t = this,
      i = {}
    let r
    async function s(o) {
      if (typeof o == "string") {
        const l = o,
          u = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(l) ? l : t.resourcePath + l
        return await r.loadAsync(u)
      } else
        return o.data
          ? { data: Sd(o.type, o.data), width: o.width, height: o.height }
          : null
    }
    if (e !== void 0 && e.length > 0) {
      ;(r = new im(this.manager)), r.setCrossOrigin(this.crossOrigin)
      for (let o = 0, l = e.length; o < l; o++) {
        const u = e[o],
          d = u.url
        if (Array.isArray(d)) {
          const p = []
          for (let m = 0, v = d.length; m < v; m++) {
            const y = d[m],
              x = await s(y)
            x !== null &&
              (x instanceof HTMLImageElement
                ? p.push(x)
                : p.push(new Yo(x.data, x.width, x.height)))
          }
          i[u.uuid] = new _u(p)
        } else {
          const p = await s(u.url)
          i[u.uuid] = new _u(p)
        }
      }
    }
    return i
  }
  parseTextures(e, t) {
    function i(s, o) {
      return typeof s == "number"
        ? s
        : (console.warn(
            "THREE.ObjectLoader.parseTexture: Constant should be in numeric form.",
            s,
          ),
          o[s])
    }
    const r = {}
    if (e !== void 0)
      for (let s = 0, o = e.length; s < o; s++) {
        const l = e[s]
        l.image === void 0 &&
          console.warn('THREE.ObjectLoader: No "image" specified for', l.uuid),
          t[l.image] === void 0 &&
            console.warn("THREE.ObjectLoader: Undefined image", l.image)
        const u = t[l.image],
          d = u.data
        let p
        Array.isArray(d)
          ? ((p = new _m()), d.length === 6 && (p.needsUpdate = !0))
          : (d && d.data ? (p = new Yo()) : (p = new zn()), d && (p.needsUpdate = !0)),
          (p.source = u),
          (p.uuid = l.uuid),
          l.name !== void 0 && (p.name = l.name),
          l.mapping !== void 0 && (p.mapping = i(l.mapping, j6)),
          l.channel !== void 0 && (p.channel = l.channel),
          l.offset !== void 0 && p.offset.fromArray(l.offset),
          l.repeat !== void 0 && p.repeat.fromArray(l.repeat),
          l.center !== void 0 && p.center.fromArray(l.center),
          l.rotation !== void 0 && (p.rotation = l.rotation),
          l.wrap !== void 0 &&
            ((p.wrapS = i(l.wrap[0], hb)), (p.wrapT = i(l.wrap[1], hb))),
          l.format !== void 0 && (p.format = l.format),
          l.internalFormat !== void 0 && (p.internalFormat = l.internalFormat),
          l.type !== void 0 && (p.type = l.type),
          l.colorSpace !== void 0 && (p.colorSpace = l.colorSpace),
          l.minFilter !== void 0 && (p.minFilter = i(l.minFilter, pb)),
          l.magFilter !== void 0 && (p.magFilter = i(l.magFilter, pb)),
          l.anisotropy !== void 0 && (p.anisotropy = l.anisotropy),
          l.flipY !== void 0 && (p.flipY = l.flipY),
          l.generateMipmaps !== void 0 && (p.generateMipmaps = l.generateMipmaps),
          l.premultiplyAlpha !== void 0 && (p.premultiplyAlpha = l.premultiplyAlpha),
          l.unpackAlignment !== void 0 && (p.unpackAlignment = l.unpackAlignment),
          l.compareFunction !== void 0 && (p.compareFunction = l.compareFunction),
          l.userData !== void 0 && (p.userData = l.userData),
          (r[l.uuid] = p)
      }
    return r
  }
  parseObject(e, t, i, r, s) {
    let o
    function l(v) {
      return (
        t[v] === void 0 && console.warn("THREE.ObjectLoader: Undefined geometry", v),
        t[v]
      )
    }
    function u(v) {
      if (v !== void 0) {
        if (Array.isArray(v)) {
          const y = []
          for (let x = 0, E = v.length; x < E; x++) {
            const M = v[x]
            i[M] === void 0 &&
              console.warn("THREE.ObjectLoader: Undefined material", M),
              y.push(i[M])
          }
          return y
        }
        return (
          i[v] === void 0 && console.warn("THREE.ObjectLoader: Undefined material", v),
          i[v]
        )
      }
    }
    function d(v) {
      return (
        r[v] === void 0 && console.warn("THREE.ObjectLoader: Undefined texture", v),
        r[v]
      )
    }
    let p, m
    switch (e.type) {
      case "Scene":
        ;(o = new Zp()),
          e.background !== void 0 &&
            (Number.isInteger(e.background)
              ? (o.background = new ot(e.background))
              : (o.background = d(e.background))),
          e.environment !== void 0 && (o.environment = d(e.environment)),
          e.fog !== void 0 &&
            (e.fog.type === "Fog"
              ? (o.fog = new ry(e.fog.color, e.fog.near, e.fog.far))
              : e.fog.type === "FogExp2" &&
                (o.fog = new iy(e.fog.color, e.fog.density)),
            e.fog.name !== "" && (o.fog.name = e.fog.name)),
          e.backgroundBlurriness !== void 0 &&
            (o.backgroundBlurriness = e.backgroundBlurriness),
          e.backgroundIntensity !== void 0 &&
            (o.backgroundIntensity = e.backgroundIntensity),
          e.backgroundRotation !== void 0 &&
            o.backgroundRotation.fromArray(e.backgroundRotation),
          e.environmentIntensity !== void 0 &&
            (o.environmentIntensity = e.environmentIntensity),
          e.environmentRotation !== void 0 &&
            o.environmentRotation.fromArray(e.environmentRotation)
        break
      case "PerspectiveCamera":
        ;(o = new Ci(e.fov, e.aspect, e.near, e.far)),
          e.focus !== void 0 && (o.focus = e.focus),
          e.zoom !== void 0 && (o.zoom = e.zoom),
          e.filmGauge !== void 0 && (o.filmGauge = e.filmGauge),
          e.filmOffset !== void 0 && (o.filmOffset = e.filmOffset),
          e.view !== void 0 && (o.view = Object.assign({}, e.view))
        break
      case "OrthographicCamera":
        ;(o = new Xd(e.left, e.right, e.top, e.bottom, e.near, e.far)),
          e.zoom !== void 0 && (o.zoom = e.zoom),
          e.view !== void 0 && (o.view = Object.assign({}, e.view))
        break
      case "AmbientLight":
        o = new lS(e.color, e.intensity)
        break
      case "DirectionalLight":
        ;(o = new aS(e.color, e.intensity)), (o.target = e.target || "")
        break
      case "PointLight":
        o = new Av(e.color, e.intensity, e.distance, e.decay)
        break
      case "RectAreaLight":
        o = new lR(e.color, e.intensity, e.width, e.height)
        break
      case "SpotLight":
        ;(o = new oS(e.color, e.intensity, e.distance, e.angle, e.penumbra, e.decay)),
          (o.target = e.target || "")
        break
      case "HemisphereLight":
        o = new aR(e.color, e.groundColor, e.intensity)
        break
      case "LightProbe":
        o = new uR().fromJSON(e)
        break
      case "SkinnedMesh":
        ;(p = l(e.geometry)),
          (m = u(e.material)),
          (o = new jw(p, m)),
          e.bindMode !== void 0 && (o.bindMode = e.bindMode),
          e.bindMatrix !== void 0 && o.bindMatrix.fromArray(e.bindMatrix),
          e.skeleton !== void 0 && (o.skeleton = e.skeleton)
        break
      case "Mesh":
        ;(p = l(e.geometry)), (m = u(e.material)), (o = new ui(p, m))
        break
      case "InstancedMesh":
        ;(p = l(e.geometry)), (m = u(e.material))
        const v = e.count,
          y = e.instanceMatrix,
          x = e.instanceColor
        ;(o = new D3(p, m, v)),
          (o.instanceMatrix = new Nd(new Float32Array(y.array), 16)),
          x !== void 0 &&
            (o.instanceColor = new Nd(new Float32Array(x.array), x.itemSize))
        break
      case "BatchedMesh":
        ;(p = l(e.geometry)),
          (m = u(e.material)),
          (o = new N3(e.maxInstanceCount, e.maxVertexCount, e.maxIndexCount, m)),
          (o.geometry = p),
          (o.perObjectFrustumCulled = e.perObjectFrustumCulled),
          (o.sortObjects = e.sortObjects),
          (o._drawRanges = e.drawRanges),
          (o._reservedRanges = e.reservedRanges),
          (o._visibility = e.visibility),
          (o._active = e.active),
          (o._bounds = e.bounds.map((E) => {
            const M = new Lr()
            M.min.fromArray(E.boxMin), M.max.fromArray(E.boxMax)
            const w = new pr()
            return (
              (w.radius = E.sphereRadius),
              w.center.fromArray(E.sphereCenter),
              {
                boxInitialized: E.boxInitialized,
                box: M,
                sphereInitialized: E.sphereInitialized,
                sphere: w,
              }
            )
          })),
          (o._maxInstanceCount = e.maxInstanceCount),
          (o._maxVertexCount = e.maxVertexCount),
          (o._maxIndexCount = e.maxIndexCount),
          (o._geometryInitialized = e.geometryInitialized),
          (o._geometryCount = e.geometryCount),
          (o._matricesTexture = d(e.matricesTexture.uuid)),
          e.colorsTexture !== void 0 && (o._colorsTexture = d(e.colorsTexture.uuid))
        break
      case "LOD":
        o = new L3()
        break
      case "Line":
        o = new Ja(l(e.geometry), u(e.material))
        break
      case "LineLoop":
        o = new k3(l(e.geometry), u(e.material))
        break
      case "LineSegments":
        o = new Qo(l(e.geometry), u(e.material))
        break
      case "PointCloud":
      case "Points":
        o = new F3(l(e.geometry), u(e.material))
        break
      case "Sprite":
        o = new I3(u(e.material))
        break
      case "Group":
        o = new Ql()
        break
      case "Bone":
        o = new Jp()
        break
      default:
        o = new cn()
    }
    if (
      ((o.uuid = e.uuid),
      e.name !== void 0 && (o.name = e.name),
      e.matrix !== void 0
        ? (o.matrix.fromArray(e.matrix),
          e.matrixAutoUpdate !== void 0 && (o.matrixAutoUpdate = e.matrixAutoUpdate),
          o.matrixAutoUpdate && o.matrix.decompose(o.position, o.quaternion, o.scale))
        : (e.position !== void 0 && o.position.fromArray(e.position),
          e.rotation !== void 0 && o.rotation.fromArray(e.rotation),
          e.quaternion !== void 0 && o.quaternion.fromArray(e.quaternion),
          e.scale !== void 0 && o.scale.fromArray(e.scale)),
      e.up !== void 0 && o.up.fromArray(e.up),
      e.castShadow !== void 0 && (o.castShadow = e.castShadow),
      e.receiveShadow !== void 0 && (o.receiveShadow = e.receiveShadow),
      e.shadow &&
        (e.shadow.intensity !== void 0 && (o.shadow.intensity = e.shadow.intensity),
        e.shadow.bias !== void 0 && (o.shadow.bias = e.shadow.bias),
        e.shadow.normalBias !== void 0 && (o.shadow.normalBias = e.shadow.normalBias),
        e.shadow.radius !== void 0 && (o.shadow.radius = e.shadow.radius),
        e.shadow.mapSize !== void 0 && o.shadow.mapSize.fromArray(e.shadow.mapSize),
        e.shadow.camera !== void 0 &&
          (o.shadow.camera = this.parseObject(e.shadow.camera))),
      e.visible !== void 0 && (o.visible = e.visible),
      e.frustumCulled !== void 0 && (o.frustumCulled = e.frustumCulled),
      e.renderOrder !== void 0 && (o.renderOrder = e.renderOrder),
      e.userData !== void 0 && (o.userData = e.userData),
      e.layers !== void 0 && (o.layers.mask = e.layers),
      e.children !== void 0)
    ) {
      const v = e.children
      for (let y = 0; y < v.length; y++) o.add(this.parseObject(v[y], t, i, r, s))
    }
    if (e.animations !== void 0) {
      const v = e.animations
      for (let y = 0; y < v.length; y++) {
        const x = v[y]
        o.animations.push(s[x])
      }
    }
    if (e.type === "LOD") {
      e.autoUpdate !== void 0 && (o.autoUpdate = e.autoUpdate)
      const v = e.levels
      for (let y = 0; y < v.length; y++) {
        const x = v[y],
          E = o.getObjectByProperty("uuid", x.object)
        E !== void 0 && o.addLevel(E, x.distance, x.hysteresis)
      }
    }
    return o
  }
  bindSkeletons(e, t) {
    Object.keys(t).length !== 0 &&
      e.traverse(function (i) {
        if (i.isSkinnedMesh === !0 && i.skeleton !== void 0) {
          const r = t[i.skeleton]
          r === void 0
            ? console.warn(
                "THREE.ObjectLoader: No skeleton found with UUID:",
                i.skeleton,
              )
            : i.bind(r, i.bindMatrix)
        }
      })
  }
  bindLightTargets(e) {
    e.traverse(function (t) {
      if (t.isDirectionalLight || t.isSpotLight) {
        const i = t.target,
          r = e.getObjectByProperty("uuid", i)
        r !== void 0 ? (t.target = r) : (t.target = new cn())
      }
    })
  }
}
const j6 = {
    UVMapping: Xv,
    CubeReflectionMapping: Ka,
    CubeRefractionMapping: rc,
    EquirectangularReflectionMapping: Pd,
    EquirectangularRefractionMapping: Wp,
    CubeUVReflectionMapping: Hd,
  },
  hb = { RepeatWrapping: Lu, ClampToEdgeWrapping: Jr, MirroredRepeatWrapping: jp },
  pb = {
    NearestFilter: Qi,
    NearestMipmapNearestFilter: Tw,
    NearestMipmapLinearFilter: wd,
    LinearFilter: Ri,
    LinearMipmapNearestFilter: Tp,
    LinearMipmapLinearFilter: Ho,
  }
class X6 extends Dr {
  constructor(e) {
    super(e),
      (this.isImageBitmapLoader = !0),
      typeof createImageBitmap > "u" &&
        console.warn("THREE.ImageBitmapLoader: createImageBitmap() not supported."),
      typeof fetch > "u" &&
        console.warn("THREE.ImageBitmapLoader: fetch() not supported."),
      (this.options = { premultiplyAlpha: "none" })
  }
  setOptions(e) {
    return (this.options = e), this
  }
  load(e, t, i, r) {
    e === void 0 && (e = ""),
      this.path !== void 0 && (e = this.path + e),
      (e = this.manager.resolveURL(e))
    const s = this,
      o = Ha.get(e)
    if (o !== void 0) {
      if ((s.manager.itemStart(e), o.then)) {
        o.then((d) => {
          t && t(d), s.manager.itemEnd(e)
        }).catch((d) => {
          r && r(d)
        })
        return
      }
      return (
        setTimeout(function () {
          t && t(o), s.manager.itemEnd(e)
        }, 0),
        o
      )
    }
    const l = {}
    ;(l.credentials = this.crossOrigin === "anonymous" ? "same-origin" : "include"),
      (l.headers = this.requestHeader)
    const u = fetch(e, l)
      .then(function (d) {
        return d.blob()
      })
      .then(function (d) {
        return createImageBitmap(
          d,
          Object.assign(s.options, { colorSpaceConversion: "none" }),
        )
      })
      .then(function (d) {
        return Ha.add(e, d), t && t(d), s.manager.itemEnd(e), d
      })
      .catch(function (d) {
        r && r(d), Ha.remove(e), s.manager.itemError(e), s.manager.itemEnd(e)
      })
    Ha.add(e, u), s.manager.itemStart(e)
  }
}
let p0
class cS {
  static getContext() {
    return (
      p0 === void 0 && (p0 = new (window.AudioContext || window.webkitAudioContext)()),
      p0
    )
  }
  static setContext(e) {
    p0 = e
  }
}
class Y6 extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    const s = this,
      o = new Ko(this.manager)
    o.setResponseType("arraybuffer"),
      o.setPath(this.path),
      o.setRequestHeader(this.requestHeader),
      o.setWithCredentials(this.withCredentials),
      o.load(
        e,
        function (u) {
          try {
            const d = u.slice(0)
            cS.getContext()
              .decodeAudioData(d, function (m) {
                t(m)
              })
              .catch(l)
          } catch (d) {
            l(d)
          }
        },
        i,
        r,
      )
    function l(u) {
      r ? r(u) : console.error(u), s.manager.itemError(e)
    }
  }
}
const mb = new mt(),
  gb = new mt(),
  ru = new mt()
class q6 {
  constructor() {
    ;(this.type = "StereoCamera"),
      (this.aspect = 1),
      (this.eyeSep = 0.064),
      (this.cameraL = new Ci()),
      this.cameraL.layers.enable(1),
      (this.cameraL.matrixAutoUpdate = !1),
      (this.cameraR = new Ci()),
      this.cameraR.layers.enable(2),
      (this.cameraR.matrixAutoUpdate = !1),
      (this._cache = {
        focus: null,
        fov: null,
        aspect: null,
        near: null,
        far: null,
        zoom: null,
        eyeSep: null,
      })
  }
  update(e) {
    const t = this._cache
    if (
      t.focus !== e.focus ||
      t.fov !== e.fov ||
      t.aspect !== e.aspect * this.aspect ||
      t.near !== e.near ||
      t.far !== e.far ||
      t.zoom !== e.zoom ||
      t.eyeSep !== this.eyeSep
    ) {
      ;(t.focus = e.focus),
        (t.fov = e.fov),
        (t.aspect = e.aspect * this.aspect),
        (t.near = e.near),
        (t.far = e.far),
        (t.zoom = e.zoom),
        (t.eyeSep = this.eyeSep),
        ru.copy(e.projectionMatrix)
      const r = t.eyeSep / 2,
        s = (r * t.near) / t.focus,
        o = (t.near * Math.tan(bu * t.fov * 0.5)) / t.zoom
      let l, u
      ;(gb.elements[12] = -r),
        (mb.elements[12] = r),
        (l = -o * t.aspect + s),
        (u = o * t.aspect + s),
        (ru.elements[0] = (2 * t.near) / (u - l)),
        (ru.elements[8] = (u + l) / (u - l)),
        this.cameraL.projectionMatrix.copy(ru),
        (l = -o * t.aspect - s),
        (u = o * t.aspect - s),
        (ru.elements[0] = (2 * t.near) / (u - l)),
        (ru.elements[8] = (u + l) / (u - l)),
        this.cameraR.projectionMatrix.copy(ru)
    }
    this.cameraL.matrixWorld.copy(e.matrixWorld).multiply(gb),
      this.cameraR.matrixWorld.copy(e.matrixWorld).multiply(mb)
  }
}
class uS {
  constructor(e = !0) {
    ;(this.autoStart = e),
      (this.startTime = 0),
      (this.oldTime = 0),
      (this.elapsedTime = 0),
      (this.running = !1)
  }
  start() {
    ;(this.startTime = vb()),
      (this.oldTime = this.startTime),
      (this.elapsedTime = 0),
      (this.running = !0)
  }
  stop() {
    this.getElapsedTime(), (this.running = !1), (this.autoStart = !1)
  }
  getElapsedTime() {
    return this.getDelta(), this.elapsedTime
  }
  getDelta() {
    let e = 0
    if (this.autoStart && !this.running) return this.start(), 0
    if (this.running) {
      const t = vb()
      ;(e = (t - this.oldTime) / 1e3), (this.oldTime = t), (this.elapsedTime += e)
    }
    return e
  }
}
function vb() {
  return performance.now()
}
const su = new q(),
  yb = new Oi(),
  $6 = new q(),
  ou = new q()
class K6 extends cn {
  constructor() {
    super(),
      (this.type = "AudioListener"),
      (this.context = cS.getContext()),
      (this.gain = this.context.createGain()),
      this.gain.connect(this.context.destination),
      (this.filter = null),
      (this.timeDelta = 0),
      (this._clock = new uS())
  }
  getInput() {
    return this.gain
  }
  removeFilter() {
    return (
      this.filter !== null &&
        (this.gain.disconnect(this.filter),
        this.filter.disconnect(this.context.destination),
        this.gain.connect(this.context.destination),
        (this.filter = null)),
      this
    )
  }
  getFilter() {
    return this.filter
  }
  setFilter(e) {
    return (
      this.filter !== null
        ? (this.gain.disconnect(this.filter),
          this.filter.disconnect(this.context.destination))
        : this.gain.disconnect(this.context.destination),
      (this.filter = e),
      this.gain.connect(this.filter),
      this.filter.connect(this.context.destination),
      this
    )
  }
  getMasterVolume() {
    return this.gain.gain.value
  }
  setMasterVolume(e) {
    return this.gain.gain.setTargetAtTime(e, this.context.currentTime, 0.01), this
  }
  updateMatrixWorld(e) {
    super.updateMatrixWorld(e)
    const t = this.context.listener,
      i = this.up
    if (
      ((this.timeDelta = this._clock.getDelta()),
      this.matrixWorld.decompose(su, yb, $6),
      ou.set(0, 0, -1).applyQuaternion(yb),
      t.positionX)
    ) {
      const r = this.context.currentTime + this.timeDelta
      t.positionX.linearRampToValueAtTime(su.x, r),
        t.positionY.linearRampToValueAtTime(su.y, r),
        t.positionZ.linearRampToValueAtTime(su.z, r),
        t.forwardX.linearRampToValueAtTime(ou.x, r),
        t.forwardY.linearRampToValueAtTime(ou.y, r),
        t.forwardZ.linearRampToValueAtTime(ou.z, r),
        t.upX.linearRampToValueAtTime(i.x, r),
        t.upY.linearRampToValueAtTime(i.y, r),
        t.upZ.linearRampToValueAtTime(i.z, r)
    } else
      t.setPosition(su.x, su.y, su.z), t.setOrientation(ou.x, ou.y, ou.z, i.x, i.y, i.z)
  }
}
class hR extends cn {
  constructor(e) {
    super(),
      (this.type = "Audio"),
      (this.listener = e),
      (this.context = e.context),
      (this.gain = this.context.createGain()),
      this.gain.connect(e.getInput()),
      (this.autoplay = !1),
      (this.buffer = null),
      (this.detune = 0),
      (this.loop = !1),
      (this.loopStart = 0),
      (this.loopEnd = 0),
      (this.offset = 0),
      (this.duration = void 0),
      (this.playbackRate = 1),
      (this.isPlaying = !1),
      (this.hasPlaybackControl = !0),
      (this.source = null),
      (this.sourceType = "empty"),
      (this._startedAt = 0),
      (this._progress = 0),
      (this._connected = !1),
      (this.filters = [])
  }
  getOutput() {
    return this.gain
  }
  setNodeSource(e) {
    return (
      (this.hasPlaybackControl = !1),
      (this.sourceType = "audioNode"),
      (this.source = e),
      this.connect(),
      this
    )
  }
  setMediaElementSource(e) {
    return (
      (this.hasPlaybackControl = !1),
      (this.sourceType = "mediaNode"),
      (this.source = this.context.createMediaElementSource(e)),
      this.connect(),
      this
    )
  }
  setMediaStreamSource(e) {
    return (
      (this.hasPlaybackControl = !1),
      (this.sourceType = "mediaStreamNode"),
      (this.source = this.context.createMediaStreamSource(e)),
      this.connect(),
      this
    )
  }
  setBuffer(e) {
    return (
      (this.buffer = e),
      (this.sourceType = "buffer"),
      this.autoplay && this.play(),
      this
    )
  }
  play(e = 0) {
    if (this.isPlaying === !0) {
      console.warn("THREE.Audio: Audio is already playing.")
      return
    }
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    this._startedAt = this.context.currentTime + e
    const t = this.context.createBufferSource()
    return (
      (t.buffer = this.buffer),
      (t.loop = this.loop),
      (t.loopStart = this.loopStart),
      (t.loopEnd = this.loopEnd),
      (t.onended = this.onEnded.bind(this)),
      t.start(this._startedAt, this._progress + this.offset, this.duration),
      (this.isPlaying = !0),
      (this.source = t),
      this.setDetune(this.detune),
      this.setPlaybackRate(this.playbackRate),
      this.connect()
    )
  }
  pause() {
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    return (
      this.isPlaying === !0 &&
        ((this._progress +=
          Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate),
        this.loop === !0 &&
          (this._progress = this._progress % (this.duration || this.buffer.duration)),
        this.source.stop(),
        (this.source.onended = null),
        (this.isPlaying = !1)),
      this
    )
  }
  stop(e = 0) {
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    return (
      (this._progress = 0),
      this.source !== null &&
        (this.source.stop(this.context.currentTime + e), (this.source.onended = null)),
      (this.isPlaying = !1),
      this
    )
  }
  connect() {
    if (this.filters.length > 0) {
      this.source.connect(this.filters[0])
      for (let e = 1, t = this.filters.length; e < t; e++)
        this.filters[e - 1].connect(this.filters[e])
      this.filters[this.filters.length - 1].connect(this.getOutput())
    } else this.source.connect(this.getOutput())
    return (this._connected = !0), this
  }
  disconnect() {
    if (this._connected !== !1) {
      if (this.filters.length > 0) {
        this.source.disconnect(this.filters[0])
        for (let e = 1, t = this.filters.length; e < t; e++)
          this.filters[e - 1].disconnect(this.filters[e])
        this.filters[this.filters.length - 1].disconnect(this.getOutput())
      } else this.source.disconnect(this.getOutput())
      return (this._connected = !1), this
    }
  }
  getFilters() {
    return this.filters
  }
  setFilters(e) {
    return (
      e || (e = []),
      this._connected === !0
        ? (this.disconnect(), (this.filters = e.slice()), this.connect())
        : (this.filters = e.slice()),
      this
    )
  }
  setDetune(e) {
    return (
      (this.detune = e),
      this.isPlaying === !0 &&
        this.source.detune !== void 0 &&
        this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01),
      this
    )
  }
  getDetune() {
    return this.detune
  }
  getFilter() {
    return this.getFilters()[0]
  }
  setFilter(e) {
    return this.setFilters(e ? [e] : [])
  }
  setPlaybackRate(e) {
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    return (
      (this.playbackRate = e),
      this.isPlaying === !0 &&
        this.source.playbackRate.setTargetAtTime(
          this.playbackRate,
          this.context.currentTime,
          0.01,
        ),
      this
    )
  }
  getPlaybackRate() {
    return this.playbackRate
  }
  onEnded() {
    this.isPlaying = !1
  }
  getLoop() {
    return this.hasPlaybackControl === !1
      ? (console.warn("THREE.Audio: this Audio has no playback control."), !1)
      : this.loop
  }
  setLoop(e) {
    if (this.hasPlaybackControl === !1) {
      console.warn("THREE.Audio: this Audio has no playback control.")
      return
    }
    return (
      (this.loop = e), this.isPlaying === !0 && (this.source.loop = this.loop), this
    )
  }
  setLoopStart(e) {
    return (this.loopStart = e), this
  }
  setLoopEnd(e) {
    return (this.loopEnd = e), this
  }
  getVolume() {
    return this.gain.gain.value
  }
  setVolume(e) {
    return this.gain.gain.setTargetAtTime(e, this.context.currentTime, 0.01), this
  }
}
const au = new q(),
  xb = new Oi(),
  Z6 = new q(),
  lu = new q()
class J6 extends hR {
  constructor(e) {
    super(e),
      (this.panner = this.context.createPanner()),
      (this.panner.panningModel = "HRTF"),
      this.panner.connect(this.gain)
  }
  connect() {
    super.connect(), this.panner.connect(this.gain)
  }
  disconnect() {
    super.disconnect(), this.panner.disconnect(this.gain)
  }
  getOutput() {
    return this.panner
  }
  getRefDistance() {
    return this.panner.refDistance
  }
  setRefDistance(e) {
    return (this.panner.refDistance = e), this
  }
  getRolloffFactor() {
    return this.panner.rolloffFactor
  }
  setRolloffFactor(e) {
    return (this.panner.rolloffFactor = e), this
  }
  getDistanceModel() {
    return this.panner.distanceModel
  }
  setDistanceModel(e) {
    return (this.panner.distanceModel = e), this
  }
  getMaxDistance() {
    return this.panner.maxDistance
  }
  setMaxDistance(e) {
    return (this.panner.maxDistance = e), this
  }
  setDirectionalCone(e, t, i) {
    return (
      (this.panner.coneInnerAngle = e),
      (this.panner.coneOuterAngle = t),
      (this.panner.coneOuterGain = i),
      this
    )
  }
  updateMatrixWorld(e) {
    if (
      (super.updateMatrixWorld(e),
      this.hasPlaybackControl === !0 && this.isPlaying === !1)
    )
      return
    this.matrixWorld.decompose(au, xb, Z6), lu.set(0, 0, 1).applyQuaternion(xb)
    const t = this.panner
    if (t.positionX) {
      const i = this.context.currentTime + this.listener.timeDelta
      t.positionX.linearRampToValueAtTime(au.x, i),
        t.positionY.linearRampToValueAtTime(au.y, i),
        t.positionZ.linearRampToValueAtTime(au.z, i),
        t.orientationX.linearRampToValueAtTime(lu.x, i),
        t.orientationY.linearRampToValueAtTime(lu.y, i),
        t.orientationZ.linearRampToValueAtTime(lu.z, i)
    } else t.setPosition(au.x, au.y, au.z), t.setOrientation(lu.x, lu.y, lu.z)
  }
}
class Q6 {
  constructor(e, t = 2048) {
    ;(this.analyser = e.context.createAnalyser()),
      (this.analyser.fftSize = t),
      (this.data = new Uint8Array(this.analyser.frequencyBinCount)),
      e.getOutput().connect(this.analyser)
  }
  getFrequencyData() {
    return this.analyser.getByteFrequencyData(this.data), this.data
  }
  getAverageFrequency() {
    let e = 0
    const t = this.getFrequencyData()
    for (let i = 0; i < t.length; i++) e += t[i]
    return e / t.length
  }
}
class pR {
  constructor(e, t, i) {
    ;(this.binding = e), (this.valueSize = i)
    let r, s, o
    switch (t) {
      case "quaternion":
        ;(r = this._slerp),
          (s = this._slerpAdditive),
          (o = this._setAdditiveIdentityQuaternion),
          (this.buffer = new Float64Array(i * 6)),
          (this._workIndex = 5)
        break
      case "string":
      case "bool":
        ;(r = this._select),
          (s = this._select),
          (o = this._setAdditiveIdentityOther),
          (this.buffer = new Array(i * 5))
        break
      default:
        ;(r = this._lerp),
          (s = this._lerpAdditive),
          (o = this._setAdditiveIdentityNumeric),
          (this.buffer = new Float64Array(i * 5))
    }
    ;(this._mixBufferRegion = r),
      (this._mixBufferRegionAdditive = s),
      (this._setIdentity = o),
      (this._origIndex = 3),
      (this._addIndex = 4),
      (this.cumulativeWeight = 0),
      (this.cumulativeWeightAdditive = 0),
      (this.useCount = 0),
      (this.referenceCount = 0)
  }
  accumulate(e, t) {
    const i = this.buffer,
      r = this.valueSize,
      s = e * r + r
    let o = this.cumulativeWeight
    if (o === 0) {
      for (let l = 0; l !== r; ++l) i[s + l] = i[l]
      o = t
    } else {
      o += t
      const l = t / o
      this._mixBufferRegion(i, s, 0, l, r)
    }
    this.cumulativeWeight = o
  }
  accumulateAdditive(e) {
    const t = this.buffer,
      i = this.valueSize,
      r = i * this._addIndex
    this.cumulativeWeightAdditive === 0 && this._setIdentity(),
      this._mixBufferRegionAdditive(t, r, 0, e, i),
      (this.cumulativeWeightAdditive += e)
  }
  apply(e) {
    const t = this.valueSize,
      i = this.buffer,
      r = e * t + t,
      s = this.cumulativeWeight,
      o = this.cumulativeWeightAdditive,
      l = this.binding
    if (((this.cumulativeWeight = 0), (this.cumulativeWeightAdditive = 0), s < 1)) {
      const u = t * this._origIndex
      this._mixBufferRegion(i, r, u, 1 - s, t)
    }
    o > 0 && this._mixBufferRegionAdditive(i, r, this._addIndex * t, 1, t)
    for (let u = t, d = t + t; u !== d; ++u)
      if (i[u] !== i[u + t]) {
        l.setValue(i, r)
        break
      }
  }
  saveOriginalState() {
    const e = this.binding,
      t = this.buffer,
      i = this.valueSize,
      r = i * this._origIndex
    e.getValue(t, r)
    for (let s = i, o = r; s !== o; ++s) t[s] = t[r + (s % i)]
    this._setIdentity(),
      (this.cumulativeWeight = 0),
      (this.cumulativeWeightAdditive = 0)
  }
  restoreOriginalState() {
    const e = this.valueSize * 3
    this.binding.setValue(this.buffer, e)
  }
  _setAdditiveIdentityNumeric() {
    const e = this._addIndex * this.valueSize,
      t = e + this.valueSize
    for (let i = e; i < t; i++) this.buffer[i] = 0
  }
  _setAdditiveIdentityQuaternion() {
    this._setAdditiveIdentityNumeric(),
      (this.buffer[this._addIndex * this.valueSize + 3] = 1)
  }
  _setAdditiveIdentityOther() {
    const e = this._origIndex * this.valueSize,
      t = this._addIndex * this.valueSize
    for (let i = 0; i < this.valueSize; i++) this.buffer[t + i] = this.buffer[e + i]
  }
  _select(e, t, i, r, s) {
    if (r >= 0.5) for (let o = 0; o !== s; ++o) e[t + o] = e[i + o]
  }
  _slerp(e, t, i, r) {
    Oi.slerpFlat(e, t, e, t, e, i, r)
  }
  _slerpAdditive(e, t, i, r, s) {
    const o = this._workIndex * s
    Oi.multiplyQuaternionsFlat(e, o, e, t, e, i), Oi.slerpFlat(e, t, e, t, e, o, r)
  }
  _lerp(e, t, i, r, s) {
    const o = 1 - r
    for (let l = 0; l !== s; ++l) {
      const u = t + l
      e[u] = e[u] * o + e[i + l] * r
    }
  }
  _lerpAdditive(e, t, i, r, s) {
    for (let o = 0; o !== s; ++o) {
      const l = t + o
      e[l] = e[l] + e[i + o] * r
    }
  }
}
const fS = "\\[\\]\\.:\\/",
  eH = new RegExp("[" + fS + "]", "g"),
  dS = "[^" + fS + "]",
  tH = "[^" + fS.replace("\\.", "") + "]",
  nH = /((?:WC+[\/:])*)/.source.replace("WC", dS),
  iH = /(WCOD+)?/.source.replace("WCOD", tH),
  rH = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", dS),
  sH = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", dS),
  oH = new RegExp("^" + nH + iH + rH + sH + "$"),
  aH = ["material", "materials", "bones", "map"]
class lH {
  constructor(e, t, i) {
    const r = i || sn.parseTrackName(t)
    ;(this._targetGroup = e), (this._bindings = e.subscribe_(t, r))
  }
  getValue(e, t) {
    this.bind()
    const i = this._targetGroup.nCachedObjects_,
      r = this._bindings[i]
    r !== void 0 && r.getValue(e, t)
  }
  setValue(e, t) {
    const i = this._bindings
    for (let r = this._targetGroup.nCachedObjects_, s = i.length; r !== s; ++r)
      i[r].setValue(e, t)
  }
  bind() {
    const e = this._bindings
    for (let t = this._targetGroup.nCachedObjects_, i = e.length; t !== i; ++t)
      e[t].bind()
  }
  unbind() {
    const e = this._bindings
    for (let t = this._targetGroup.nCachedObjects_, i = e.length; t !== i; ++t)
      e[t].unbind()
  }
}
class sn {
  constructor(e, t, i) {
    ;(this.path = t),
      (this.parsedPath = i || sn.parseTrackName(t)),
      (this.node = sn.findNode(e, this.parsedPath.nodeName)),
      (this.rootNode = e),
      (this.getValue = this._getValue_unbound),
      (this.setValue = this._setValue_unbound)
  }
  static create(e, t, i) {
    return e && e.isAnimationObjectGroup ? new sn.Composite(e, t, i) : new sn(e, t, i)
  }
  static sanitizeNodeName(e) {
    return e.replace(/\s/g, "_").replace(eH, "")
  }
  static parseTrackName(e) {
    const t = oH.exec(e)
    if (t === null) throw new Error("PropertyBinding: Cannot parse trackName: " + e)
    const i = {
        nodeName: t[2],
        objectName: t[3],
        objectIndex: t[4],
        propertyName: t[5],
        propertyIndex: t[6],
      },
      r = i.nodeName && i.nodeName.lastIndexOf(".")
    if (r !== void 0 && r !== -1) {
      const s = i.nodeName.substring(r + 1)
      aH.indexOf(s) !== -1 &&
        ((i.nodeName = i.nodeName.substring(0, r)), (i.objectName = s))
    }
    if (i.propertyName === null || i.propertyName.length === 0)
      throw new Error(
        "PropertyBinding: can not parse propertyName from trackName: " + e,
      )
    return i
  }
  static findNode(e, t) {
    if (
      t === void 0 ||
      t === "" ||
      t === "." ||
      t === -1 ||
      t === e.name ||
      t === e.uuid
    )
      return e
    if (e.skeleton) {
      const i = e.skeleton.getBoneByName(t)
      if (i !== void 0) return i
    }
    if (e.children) {
      const i = function (s) {
          for (let o = 0; o < s.length; o++) {
            const l = s[o]
            if (l.name === t || l.uuid === t) return l
            const u = i(l.children)
            if (u) return u
          }
          return null
        },
        r = i(e.children)
      if (r) return r
    }
    return null
  }
  _getValue_unavailable() {}
  _setValue_unavailable() {}
  _getValue_direct(e, t) {
    e[t] = this.targetObject[this.propertyName]
  }
  _getValue_array(e, t) {
    const i = this.resolvedProperty
    for (let r = 0, s = i.length; r !== s; ++r) e[t++] = i[r]
  }
  _getValue_arrayElement(e, t) {
    e[t] = this.resolvedProperty[this.propertyIndex]
  }
  _getValue_toArray(e, t) {
    this.resolvedProperty.toArray(e, t)
  }
  _setValue_direct(e, t) {
    this.targetObject[this.propertyName] = e[t]
  }
  _setValue_direct_setNeedsUpdate(e, t) {
    ;(this.targetObject[this.propertyName] = e[t]), (this.targetObject.needsUpdate = !0)
  }
  _setValue_direct_setMatrixWorldNeedsUpdate(e, t) {
    ;(this.targetObject[this.propertyName] = e[t]),
      (this.targetObject.matrixWorldNeedsUpdate = !0)
  }
  _setValue_array(e, t) {
    const i = this.resolvedProperty
    for (let r = 0, s = i.length; r !== s; ++r) i[r] = e[t++]
  }
  _setValue_array_setNeedsUpdate(e, t) {
    const i = this.resolvedProperty
    for (let r = 0, s = i.length; r !== s; ++r) i[r] = e[t++]
    this.targetObject.needsUpdate = !0
  }
  _setValue_array_setMatrixWorldNeedsUpdate(e, t) {
    const i = this.resolvedProperty
    for (let r = 0, s = i.length; r !== s; ++r) i[r] = e[t++]
    this.targetObject.matrixWorldNeedsUpdate = !0
  }
  _setValue_arrayElement(e, t) {
    this.resolvedProperty[this.propertyIndex] = e[t]
  }
  _setValue_arrayElement_setNeedsUpdate(e, t) {
    ;(this.resolvedProperty[this.propertyIndex] = e[t]),
      (this.targetObject.needsUpdate = !0)
  }
  _setValue_arrayElement_setMatrixWorldNeedsUpdate(e, t) {
    ;(this.resolvedProperty[this.propertyIndex] = e[t]),
      (this.targetObject.matrixWorldNeedsUpdate = !0)
  }
  _setValue_fromArray(e, t) {
    this.resolvedProperty.fromArray(e, t)
  }
  _setValue_fromArray_setNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t), (this.targetObject.needsUpdate = !0)
  }
  _setValue_fromArray_setMatrixWorldNeedsUpdate(e, t) {
    this.resolvedProperty.fromArray(e, t),
      (this.targetObject.matrixWorldNeedsUpdate = !0)
  }
  _getValue_unbound(e, t) {
    this.bind(), this.getValue(e, t)
  }
  _setValue_unbound(e, t) {
    this.bind(), this.setValue(e, t)
  }
  bind() {
    let e = this.node
    const t = this.parsedPath,
      i = t.objectName,
      r = t.propertyName
    let s = t.propertyIndex
    if (
      (e || ((e = sn.findNode(this.rootNode, t.nodeName)), (this.node = e)),
      (this.getValue = this._getValue_unavailable),
      (this.setValue = this._setValue_unavailable),
      !e)
    ) {
      console.warn(
        "THREE.PropertyBinding: No target node found for track: " + this.path + ".",
      )
      return
    }
    if (i) {
      let d = t.objectIndex
      switch (i) {
        case "materials":
          if (!e.material) {
            console.error(
              "THREE.PropertyBinding: Can not bind to material as node does not have a material.",
              this,
            )
            return
          }
          if (!e.material.materials) {
            console.error(
              "THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.",
              this,
            )
            return
          }
          e = e.material.materials
          break
        case "bones":
          if (!e.skeleton) {
            console.error(
              "THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.",
              this,
            )
            return
          }
          e = e.skeleton.bones
          for (let p = 0; p < e.length; p++)
            if (e[p].name === d) {
              d = p
              break
            }
          break
        case "map":
          if ("map" in e) {
            e = e.map
            break
          }
          if (!e.material) {
            console.error(
              "THREE.PropertyBinding: Can not bind to material as node does not have a material.",
              this,
            )
            return
          }
          if (!e.material.map) {
            console.error(
              "THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.",
              this,
            )
            return
          }
          e = e.material.map
          break
        default:
          if (e[i] === void 0) {
            console.error(
              "THREE.PropertyBinding: Can not bind to objectName of node undefined.",
              this,
            )
            return
          }
          e = e[i]
      }
      if (d !== void 0) {
        if (e[d] === void 0) {
          console.error(
            "THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.",
            this,
            e,
          )
          return
        }
        e = e[d]
      }
    }
    const o = e[r]
    if (o === void 0) {
      const d = t.nodeName
      console.error(
        "THREE.PropertyBinding: Trying to update property for track: " +
          d +
          "." +
          r +
          " but it wasn't found.",
        e,
      )
      return
    }
    let l = this.Versioning.None
    ;(this.targetObject = e),
      e.needsUpdate !== void 0
        ? (l = this.Versioning.NeedsUpdate)
        : e.matrixWorldNeedsUpdate !== void 0 &&
          (l = this.Versioning.MatrixWorldNeedsUpdate)
    let u = this.BindingType.Direct
    if (s !== void 0) {
      if (r === "morphTargetInfluences") {
        if (!e.geometry) {
          console.error(
            "THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.",
            this,
          )
          return
        }
        if (!e.geometry.morphAttributes) {
          console.error(
            "THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.",
            this,
          )
          return
        }
        e.morphTargetDictionary[s] !== void 0 && (s = e.morphTargetDictionary[s])
      }
      ;(u = this.BindingType.ArrayElement),
        (this.resolvedProperty = o),
        (this.propertyIndex = s)
    } else
      o.fromArray !== void 0 && o.toArray !== void 0
        ? ((u = this.BindingType.HasFromToArray), (this.resolvedProperty = o))
        : Array.isArray(o)
        ? ((u = this.BindingType.EntireArray), (this.resolvedProperty = o))
        : (this.propertyName = r)
    ;(this.getValue = this.GetterByBindingType[u]),
      (this.setValue = this.SetterByBindingTypeAndVersioning[u][l])
  }
  unbind() {
    ;(this.node = null),
      (this.getValue = this._getValue_unbound),
      (this.setValue = this._setValue_unbound)
  }
}
sn.Composite = lH
sn.prototype.BindingType = {
  Direct: 0,
  EntireArray: 1,
  ArrayElement: 2,
  HasFromToArray: 3,
}
sn.prototype.Versioning = { None: 0, NeedsUpdate: 1, MatrixWorldNeedsUpdate: 2 }
sn.prototype.GetterByBindingType = [
  sn.prototype._getValue_direct,
  sn.prototype._getValue_array,
  sn.prototype._getValue_arrayElement,
  sn.prototype._getValue_toArray,
]
sn.prototype.SetterByBindingTypeAndVersioning = [
  [
    sn.prototype._setValue_direct,
    sn.prototype._setValue_direct_setNeedsUpdate,
    sn.prototype._setValue_direct_setMatrixWorldNeedsUpdate,
  ],
  [
    sn.prototype._setValue_array,
    sn.prototype._setValue_array_setNeedsUpdate,
    sn.prototype._setValue_array_setMatrixWorldNeedsUpdate,
  ],
  [
    sn.prototype._setValue_arrayElement,
    sn.prototype._setValue_arrayElement_setNeedsUpdate,
    sn.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate,
  ],
  [
    sn.prototype._setValue_fromArray,
    sn.prototype._setValue_fromArray_setNeedsUpdate,
    sn.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate,
  ],
]
class cH {
  constructor() {
    ;(this.isAnimationObjectGroup = !0),
      (this.uuid = vs()),
      (this._objects = Array.prototype.slice.call(arguments)),
      (this.nCachedObjects_ = 0)
    const e = {}
    this._indicesByUUID = e
    for (let i = 0, r = arguments.length; i !== r; ++i) e[arguments[i].uuid] = i
    ;(this._paths = []),
      (this._parsedPaths = []),
      (this._bindings = []),
      (this._bindingsIndicesByPath = {})
    const t = this
    this.stats = {
      objects: {
        get total() {
          return t._objects.length
        },
        get inUse() {
          return this.total - t.nCachedObjects_
        },
      },
      get bindingsPerObject() {
        return t._bindings.length
      },
    }
  }
  add() {
    const e = this._objects,
      t = this._indicesByUUID,
      i = this._paths,
      r = this._parsedPaths,
      s = this._bindings,
      o = s.length
    let l,
      u = e.length,
      d = this.nCachedObjects_
    for (let p = 0, m = arguments.length; p !== m; ++p) {
      const v = arguments[p],
        y = v.uuid
      let x = t[y]
      if (x === void 0) {
        ;(x = u++), (t[y] = x), e.push(v)
        for (let E = 0, M = o; E !== M; ++E) s[E].push(new sn(v, i[E], r[E]))
      } else if (x < d) {
        l = e[x]
        const E = --d,
          M = e[E]
        ;(t[M.uuid] = x), (e[x] = M), (t[y] = E), (e[E] = v)
        for (let w = 0, A = o; w !== A; ++w) {
          const C = s[w],
            R = C[E]
          let z = C[x]
          ;(C[x] = R), z === void 0 && (z = new sn(v, i[w], r[w])), (C[E] = z)
        }
      } else
        e[x] !== l &&
          console.error(
            "THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.",
          )
    }
    this.nCachedObjects_ = d
  }
  remove() {
    const e = this._objects,
      t = this._indicesByUUID,
      i = this._bindings,
      r = i.length
    let s = this.nCachedObjects_
    for (let o = 0, l = arguments.length; o !== l; ++o) {
      const u = arguments[o],
        d = u.uuid,
        p = t[d]
      if (p !== void 0 && p >= s) {
        const m = s++,
          v = e[m]
        ;(t[v.uuid] = p), (e[p] = v), (t[d] = m), (e[m] = u)
        for (let y = 0, x = r; y !== x; ++y) {
          const E = i[y],
            M = E[m],
            w = E[p]
          ;(E[p] = M), (E[m] = w)
        }
      }
    }
    this.nCachedObjects_ = s
  }
  uncache() {
    const e = this._objects,
      t = this._indicesByUUID,
      i = this._bindings,
      r = i.length
    let s = this.nCachedObjects_,
      o = e.length
    for (let l = 0, u = arguments.length; l !== u; ++l) {
      const d = arguments[l],
        p = d.uuid,
        m = t[p]
      if (m !== void 0)
        if ((delete t[p], m < s)) {
          const v = --s,
            y = e[v],
            x = --o,
            E = e[x]
          ;(t[y.uuid] = m), (e[m] = y), (t[E.uuid] = v), (e[v] = E), e.pop()
          for (let M = 0, w = r; M !== w; ++M) {
            const A = i[M],
              C = A[v],
              R = A[x]
            ;(A[m] = C), (A[v] = R), A.pop()
          }
        } else {
          const v = --o,
            y = e[v]
          v > 0 && (t[y.uuid] = m), (e[m] = y), e.pop()
          for (let x = 0, E = r; x !== E; ++x) {
            const M = i[x]
            ;(M[m] = M[v]), M.pop()
          }
        }
    }
    this.nCachedObjects_ = s
  }
  subscribe_(e, t) {
    const i = this._bindingsIndicesByPath
    let r = i[e]
    const s = this._bindings
    if (r !== void 0) return s[r]
    const o = this._paths,
      l = this._parsedPaths,
      u = this._objects,
      d = u.length,
      p = this.nCachedObjects_,
      m = new Array(d)
    ;(r = s.length), (i[e] = r), o.push(e), l.push(t), s.push(m)
    for (let v = p, y = u.length; v !== y; ++v) {
      const x = u[v]
      m[v] = new sn(x, e, t)
    }
    return m
  }
  unsubscribe_(e) {
    const t = this._bindingsIndicesByPath,
      i = t[e]
    if (i !== void 0) {
      const r = this._paths,
        s = this._parsedPaths,
        o = this._bindings,
        l = o.length - 1,
        u = o[l],
        d = e[l]
      ;(t[d] = i), (o[i] = u), o.pop(), (s[i] = s[l]), s.pop(), (r[i] = r[l]), r.pop()
    }
  }
}
class mR {
  constructor(e, t, i = null, r = t.blendMode) {
    ;(this._mixer = e), (this._clip = t), (this._localRoot = i), (this.blendMode = r)
    const s = t.tracks,
      o = s.length,
      l = new Array(o),
      u = { endingStart: yu, endingEnd: yu }
    for (let d = 0; d !== o; ++d) {
      const p = s[d].createInterpolant(null)
      ;(l[d] = p), (p.settings = u)
    }
    ;(this._interpolantSettings = u),
      (this._interpolants = l),
      (this._propertyBindings = new Array(o)),
      (this._cacheIndex = null),
      (this._byClipCacheIndex = null),
      (this._timeScaleInterpolant = null),
      (this._weightInterpolant = null),
      (this.loop = t3),
      (this._loopCount = -1),
      (this._startTime = null),
      (this.time = 0),
      (this.timeScale = 1),
      (this._effectiveTimeScale = 1),
      (this.weight = 1),
      (this._effectiveWeight = 1),
      (this.repetitions = 1 / 0),
      (this.paused = !1),
      (this.enabled = !0),
      (this.clampWhenFinished = !1),
      (this.zeroSlopeAtStart = !0),
      (this.zeroSlopeAtEnd = !0)
  }
  play() {
    return this._mixer._activateAction(this), this
  }
  stop() {
    return this._mixer._deactivateAction(this), this.reset()
  }
  reset() {
    return (
      (this.paused = !1),
      (this.enabled = !0),
      (this.time = 0),
      (this._loopCount = -1),
      (this._startTime = null),
      this.stopFading().stopWarping()
    )
  }
  isRunning() {
    return (
      this.enabled &&
      !this.paused &&
      this.timeScale !== 0 &&
      this._startTime === null &&
      this._mixer._isActiveAction(this)
    )
  }
  isScheduled() {
    return this._mixer._isActiveAction(this)
  }
  startAt(e) {
    return (this._startTime = e), this
  }
  setLoop(e, t) {
    return (this.loop = e), (this.repetitions = t), this
  }
  setEffectiveWeight(e) {
    return (
      (this.weight = e),
      (this._effectiveWeight = this.enabled ? e : 0),
      this.stopFading()
    )
  }
  getEffectiveWeight() {
    return this._effectiveWeight
  }
  fadeIn(e) {
    return this._scheduleFading(e, 0, 1)
  }
  fadeOut(e) {
    return this._scheduleFading(e, 1, 0)
  }
  crossFadeFrom(e, t, i) {
    if ((e.fadeOut(t), this.fadeIn(t), i)) {
      const r = this._clip.duration,
        s = e._clip.duration,
        o = s / r,
        l = r / s
      e.warp(1, o, t), this.warp(l, 1, t)
    }
    return this
  }
  crossFadeTo(e, t, i) {
    return e.crossFadeFrom(this, t, i)
  }
  stopFading() {
    const e = this._weightInterpolant
    return (
      e !== null &&
        ((this._weightInterpolant = null), this._mixer._takeBackControlInterpolant(e)),
      this
    )
  }
  setEffectiveTimeScale(e) {
    return (
      (this.timeScale = e),
      (this._effectiveTimeScale = this.paused ? 0 : e),
      this.stopWarping()
    )
  }
  getEffectiveTimeScale() {
    return this._effectiveTimeScale
  }
  setDuration(e) {
    return (this.timeScale = this._clip.duration / e), this.stopWarping()
  }
  syncWith(e) {
    return (this.time = e.time), (this.timeScale = e.timeScale), this.stopWarping()
  }
  halt(e) {
    return this.warp(this._effectiveTimeScale, 0, e)
  }
  warp(e, t, i) {
    const r = this._mixer,
      s = r.time,
      o = this.timeScale
    let l = this._timeScaleInterpolant
    l === null && ((l = r._lendControlInterpolant()), (this._timeScaleInterpolant = l))
    const u = l.parameterPositions,
      d = l.sampleValues
    return (u[0] = s), (u[1] = s + i), (d[0] = e / o), (d[1] = t / o), this
  }
  stopWarping() {
    const e = this._timeScaleInterpolant
    return (
      e !== null &&
        ((this._timeScaleInterpolant = null),
        this._mixer._takeBackControlInterpolant(e)),
      this
    )
  }
  getMixer() {
    return this._mixer
  }
  getClip() {
    return this._clip
  }
  getRoot() {
    return this._localRoot || this._mixer._root
  }
  _update(e, t, i, r) {
    if (!this.enabled) {
      this._updateWeight(e)
      return
    }
    const s = this._startTime
    if (s !== null) {
      const u = (e - s) * i
      u < 0 || i === 0 ? (t = 0) : ((this._startTime = null), (t = i * u))
    }
    t *= this._updateTimeScale(e)
    const o = this._updateTime(t),
      l = this._updateWeight(e)
    if (l > 0) {
      const u = this._interpolants,
        d = this._propertyBindings
      switch (this.blendMode) {
        case kw:
          for (let p = 0, m = u.length; p !== m; ++p)
            u[p].evaluate(o), d[p].accumulateAdditive(l)
          break
        case Qv:
        default:
          for (let p = 0, m = u.length; p !== m; ++p)
            u[p].evaluate(o), d[p].accumulate(r, l)
      }
    }
  }
  _updateWeight(e) {
    let t = 0
    if (this.enabled) {
      t = this.weight
      const i = this._weightInterpolant
      if (i !== null) {
        const r = i.evaluate(e)[0]
        ;(t *= r),
          e > i.parameterPositions[1] &&
            (this.stopFading(), r === 0 && (this.enabled = !1))
      }
    }
    return (this._effectiveWeight = t), t
  }
  _updateTimeScale(e) {
    let t = 0
    if (!this.paused) {
      t = this.timeScale
      const i = this._timeScaleInterpolant
      if (i !== null) {
        const r = i.evaluate(e)[0]
        ;(t *= r),
          e > i.parameterPositions[1] &&
            (this.stopWarping(), t === 0 ? (this.paused = !0) : (this.timeScale = t))
      }
    }
    return (this._effectiveTimeScale = t), t
  }
  _updateTime(e) {
    const t = this._clip.duration,
      i = this.loop
    let r = this.time + e,
      s = this._loopCount
    const o = i === n3
    if (e === 0) return s === -1 ? r : o && (s & 1) === 1 ? t - r : r
    if (i === e3) {
      s === -1 && ((this._loopCount = 0), this._setEndings(!0, !0, !1))
      e: {
        if (r >= t) r = t
        else if (r < 0) r = 0
        else {
          this.time = r
          break e
        }
        this.clampWhenFinished ? (this.paused = !0) : (this.enabled = !1),
          (this.time = r),
          this._mixer.dispatchEvent({
            type: "finished",
            action: this,
            direction: e < 0 ? -1 : 1,
          })
      }
    } else {
      if (
        (s === -1 &&
          (e >= 0
            ? ((s = 0), this._setEndings(!0, this.repetitions === 0, o))
            : this._setEndings(this.repetitions === 0, !0, o)),
        r >= t || r < 0)
      ) {
        const l = Math.floor(r / t)
        ;(r -= t * l), (s += Math.abs(l))
        const u = this.repetitions - s
        if (u <= 0)
          this.clampWhenFinished ? (this.paused = !0) : (this.enabled = !1),
            (r = e > 0 ? t : 0),
            (this.time = r),
            this._mixer.dispatchEvent({
              type: "finished",
              action: this,
              direction: e > 0 ? 1 : -1,
            })
        else {
          if (u === 1) {
            const d = e < 0
            this._setEndings(d, !d, o)
          } else this._setEndings(!1, !1, o)
          ;(this._loopCount = s),
            (this.time = r),
            this._mixer.dispatchEvent({ type: "loop", action: this, loopDelta: l })
        }
      } else this.time = r
      if (o && (s & 1) === 1) return t - r
    }
    return r
  }
  _setEndings(e, t, i) {
    const r = this._interpolantSettings
    i
      ? ((r.endingStart = xu), (r.endingEnd = xu))
      : (e ? (r.endingStart = this.zeroSlopeAtStart ? xu : yu) : (r.endingStart = Yp),
        t ? (r.endingEnd = this.zeroSlopeAtEnd ? xu : yu) : (r.endingEnd = Yp))
  }
  _scheduleFading(e, t, i) {
    const r = this._mixer,
      s = r.time
    let o = this._weightInterpolant
    o === null && ((o = r._lendControlInterpolant()), (this._weightInterpolant = o))
    const l = o.parameterPositions,
      u = o.sampleValues
    return (l[0] = s), (u[0] = t), (l[1] = s + e), (u[1] = i), this
  }
}
const uH = new Float32Array(1)
class fH extends Jo {
  constructor(e) {
    super(),
      (this._root = e),
      this._initMemoryManager(),
      (this._accuIndex = 0),
      (this.time = 0),
      (this.timeScale = 1)
  }
  _bindAction(e, t) {
    const i = e._localRoot || this._root,
      r = e._clip.tracks,
      s = r.length,
      o = e._propertyBindings,
      l = e._interpolants,
      u = i.uuid,
      d = this._bindingsByRootAndName
    let p = d[u]
    p === void 0 && ((p = {}), (d[u] = p))
    for (let m = 0; m !== s; ++m) {
      const v = r[m],
        y = v.name
      let x = p[y]
      if (x !== void 0) ++x.referenceCount, (o[m] = x)
      else {
        if (((x = o[m]), x !== void 0)) {
          x._cacheIndex === null &&
            (++x.referenceCount, this._addInactiveBinding(x, u, y))
          continue
        }
        const E = t && t._propertyBindings[m].binding.parsedPath
        ;(x = new pR(sn.create(i, y, E), v.ValueTypeName, v.getValueSize())),
          ++x.referenceCount,
          this._addInactiveBinding(x, u, y),
          (o[m] = x)
      }
      l[m].resultBuffer = x.buffer
    }
  }
  _activateAction(e) {
    if (!this._isActiveAction(e)) {
      if (e._cacheIndex === null) {
        const i = (e._localRoot || this._root).uuid,
          r = e._clip.uuid,
          s = this._actionsByClip[r]
        this._bindAction(e, s && s.knownActions[0]), this._addInactiveAction(e, r, i)
      }
      const t = e._propertyBindings
      for (let i = 0, r = t.length; i !== r; ++i) {
        const s = t[i]
        s.useCount++ === 0 && (this._lendBinding(s), s.saveOriginalState())
      }
      this._lendAction(e)
    }
  }
  _deactivateAction(e) {
    if (this._isActiveAction(e)) {
      const t = e._propertyBindings
      for (let i = 0, r = t.length; i !== r; ++i) {
        const s = t[i]
        --s.useCount === 0 && (s.restoreOriginalState(), this._takeBackBinding(s))
      }
      this._takeBackAction(e)
    }
  }
  _initMemoryManager() {
    ;(this._actions = []),
      (this._nActiveActions = 0),
      (this._actionsByClip = {}),
      (this._bindings = []),
      (this._nActiveBindings = 0),
      (this._bindingsByRootAndName = {}),
      (this._controlInterpolants = []),
      (this._nActiveControlInterpolants = 0)
    const e = this
    this.stats = {
      actions: {
        get total() {
          return e._actions.length
        },
        get inUse() {
          return e._nActiveActions
        },
      },
      bindings: {
        get total() {
          return e._bindings.length
        },
        get inUse() {
          return e._nActiveBindings
        },
      },
      controlInterpolants: {
        get total() {
          return e._controlInterpolants.length
        },
        get inUse() {
          return e._nActiveControlInterpolants
        },
      },
    }
  }
  _isActiveAction(e) {
    const t = e._cacheIndex
    return t !== null && t < this._nActiveActions
  }
  _addInactiveAction(e, t, i) {
    const r = this._actions,
      s = this._actionsByClip
    let o = s[t]
    if (o === void 0)
      (o = { knownActions: [e], actionByRoot: {} }),
        (e._byClipCacheIndex = 0),
        (s[t] = o)
    else {
      const l = o.knownActions
      ;(e._byClipCacheIndex = l.length), l.push(e)
    }
    ;(e._cacheIndex = r.length), r.push(e), (o.actionByRoot[i] = e)
  }
  _removeInactiveAction(e) {
    const t = this._actions,
      i = t[t.length - 1],
      r = e._cacheIndex
    ;(i._cacheIndex = r), (t[r] = i), t.pop(), (e._cacheIndex = null)
    const s = e._clip.uuid,
      o = this._actionsByClip,
      l = o[s],
      u = l.knownActions,
      d = u[u.length - 1],
      p = e._byClipCacheIndex
    ;(d._byClipCacheIndex = p), (u[p] = d), u.pop(), (e._byClipCacheIndex = null)
    const m = l.actionByRoot,
      v = (e._localRoot || this._root).uuid
    delete m[v], u.length === 0 && delete o[s], this._removeInactiveBindingsForAction(e)
  }
  _removeInactiveBindingsForAction(e) {
    const t = e._propertyBindings
    for (let i = 0, r = t.length; i !== r; ++i) {
      const s = t[i]
      --s.referenceCount === 0 && this._removeInactiveBinding(s)
    }
  }
  _lendAction(e) {
    const t = this._actions,
      i = e._cacheIndex,
      r = this._nActiveActions++,
      s = t[r]
    ;(e._cacheIndex = r), (t[r] = e), (s._cacheIndex = i), (t[i] = s)
  }
  _takeBackAction(e) {
    const t = this._actions,
      i = e._cacheIndex,
      r = --this._nActiveActions,
      s = t[r]
    ;(e._cacheIndex = r), (t[r] = e), (s._cacheIndex = i), (t[i] = s)
  }
  _addInactiveBinding(e, t, i) {
    const r = this._bindingsByRootAndName,
      s = this._bindings
    let o = r[t]
    o === void 0 && ((o = {}), (r[t] = o)),
      (o[i] = e),
      (e._cacheIndex = s.length),
      s.push(e)
  }
  _removeInactiveBinding(e) {
    const t = this._bindings,
      i = e.binding,
      r = i.rootNode.uuid,
      s = i.path,
      o = this._bindingsByRootAndName,
      l = o[r],
      u = t[t.length - 1],
      d = e._cacheIndex
    ;(u._cacheIndex = d),
      (t[d] = u),
      t.pop(),
      delete l[s],
      Object.keys(l).length === 0 && delete o[r]
  }
  _lendBinding(e) {
    const t = this._bindings,
      i = e._cacheIndex,
      r = this._nActiveBindings++,
      s = t[r]
    ;(e._cacheIndex = r), (t[r] = e), (s._cacheIndex = i), (t[i] = s)
  }
  _takeBackBinding(e) {
    const t = this._bindings,
      i = e._cacheIndex,
      r = --this._nActiveBindings,
      s = t[r]
    ;(e._cacheIndex = r), (t[r] = e), (s._cacheIndex = i), (t[i] = s)
  }
  _lendControlInterpolant() {
    const e = this._controlInterpolants,
      t = this._nActiveControlInterpolants++
    let i = e[t]
    return (
      i === void 0 &&
        ((i = new nS(new Float32Array(2), new Float32Array(2), 1, uH)),
        (i.__cacheIndex = t),
        (e[t] = i)),
      i
    )
  }
  _takeBackControlInterpolant(e) {
    const t = this._controlInterpolants,
      i = e.__cacheIndex,
      r = --this._nActiveControlInterpolants,
      s = t[r]
    ;(e.__cacheIndex = r), (t[r] = e), (s.__cacheIndex = i), (t[i] = s)
  }
  clipAction(e, t, i) {
    const r = t || this._root,
      s = r.uuid
    let o = typeof e == "string" ? Ud.findByName(r, e) : e
    const l = o !== null ? o.uuid : e,
      u = this._actionsByClip[l]
    let d = null
    if ((i === void 0 && (o !== null ? (i = o.blendMode) : (i = Qv)), u !== void 0)) {
      const m = u.actionByRoot[s]
      if (m !== void 0 && m.blendMode === i) return m
      ;(d = u.knownActions[0]), o === null && (o = d._clip)
    }
    if (o === null) return null
    const p = new mR(this, o, t, i)
    return this._bindAction(p, d), this._addInactiveAction(p, l, s), p
  }
  existingAction(e, t) {
    const i = t || this._root,
      r = i.uuid,
      s = typeof e == "string" ? Ud.findByName(i, e) : e,
      o = s ? s.uuid : e,
      l = this._actionsByClip[o]
    return (l !== void 0 && l.actionByRoot[r]) || null
  }
  stopAllAction() {
    const e = this._actions,
      t = this._nActiveActions
    for (let i = t - 1; i >= 0; --i) e[i].stop()
    return this
  }
  update(e) {
    e *= this.timeScale
    const t = this._actions,
      i = this._nActiveActions,
      r = (this.time += e),
      s = Math.sign(e),
      o = (this._accuIndex ^= 1)
    for (let d = 0; d !== i; ++d) t[d]._update(r, e, s, o)
    const l = this._bindings,
      u = this._nActiveBindings
    for (let d = 0; d !== u; ++d) l[d].apply(o)
    return this
  }
  setTime(e) {
    this.time = 0
    for (let t = 0; t < this._actions.length; t++) this._actions[t].time = 0
    return this.update(e)
  }
  getRoot() {
    return this._root
  }
  uncacheClip(e) {
    const t = this._actions,
      i = e.uuid,
      r = this._actionsByClip,
      s = r[i]
    if (s !== void 0) {
      const o = s.knownActions
      for (let l = 0, u = o.length; l !== u; ++l) {
        const d = o[l]
        this._deactivateAction(d)
        const p = d._cacheIndex,
          m = t[t.length - 1]
        ;(d._cacheIndex = null),
          (d._byClipCacheIndex = null),
          (m._cacheIndex = p),
          (t[p] = m),
          t.pop(),
          this._removeInactiveBindingsForAction(d)
      }
      delete r[i]
    }
  }
  uncacheRoot(e) {
    const t = e.uuid,
      i = this._actionsByClip
    for (const o in i) {
      const l = i[o].actionByRoot,
        u = l[t]
      u !== void 0 && (this._deactivateAction(u), this._removeInactiveAction(u))
    }
    const r = this._bindingsByRootAndName,
      s = r[t]
    if (s !== void 0)
      for (const o in s) {
        const l = s[o]
        l.restoreOriginalState(), this._removeInactiveBinding(l)
      }
  }
  uncacheAction(e, t) {
    const i = this.existingAction(e, t)
    i !== null && (this._deactivateAction(i), this._removeInactiveAction(i))
  }
}
class hS {
  constructor(e) {
    this.value = e
  }
  clone() {
    return new hS(this.value.clone === void 0 ? this.value : this.value.clone())
  }
}
let dH = 0
class hH extends Jo {
  constructor() {
    super(),
      (this.isUniformsGroup = !0),
      Object.defineProperty(this, "id", { value: dH++ }),
      (this.name = ""),
      (this.usage = qp),
      (this.uniforms = [])
  }
  add(e) {
    return this.uniforms.push(e), this
  }
  remove(e) {
    const t = this.uniforms.indexOf(e)
    return t !== -1 && this.uniforms.splice(t, 1), this
  }
  setName(e) {
    return (this.name = e), this
  }
  setUsage(e) {
    return (this.usage = e), this
  }
  dispose() {
    return this.dispatchEvent({ type: "dispose" }), this
  }
  copy(e) {
    ;(this.name = e.name), (this.usage = e.usage)
    const t = e.uniforms
    this.uniforms.length = 0
    for (let i = 0, r = t.length; i < r; i++) {
      const s = Array.isArray(t[i]) ? t[i] : [t[i]]
      for (let o = 0; o < s.length; o++) this.uniforms.push(s[o].clone())
    }
    return this
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
class pH extends sy {
  constructor(e, t, i = 1) {
    super(e, t), (this.isInstancedInterleavedBuffer = !0), (this.meshPerAttribute = i)
  }
  copy(e) {
    return super.copy(e), (this.meshPerAttribute = e.meshPerAttribute), this
  }
  clone(e) {
    const t = super.clone(e)
    return (t.meshPerAttribute = this.meshPerAttribute), t
  }
  toJSON(e) {
    const t = super.toJSON(e)
    return (
      (t.isInstancedInterleavedBuffer = !0),
      (t.meshPerAttribute = this.meshPerAttribute),
      t
    )
  }
}
class mH {
  constructor(e, t, i, r, s) {
    ;(this.isGLBufferAttribute = !0),
      (this.name = ""),
      (this.buffer = e),
      (this.type = t),
      (this.itemSize = i),
      (this.elementSize = r),
      (this.count = s),
      (this.version = 0)
  }
  set needsUpdate(e) {
    e === !0 && this.version++
  }
  setBuffer(e) {
    return (this.buffer = e), this
  }
  setType(e, t) {
    return (this.type = e), (this.elementSize = t), this
  }
  setItemSize(e) {
    return (this.itemSize = e), this
  }
  setCount(e) {
    return (this.count = e), this
  }
}
const _b = new mt()
class gR {
  constructor(e, t, i = 0, r = 1 / 0) {
    ;(this.ray = new Wd(e, t)),
      (this.near = i),
      (this.far = r),
      (this.camera = null),
      (this.layers = new Au()),
      (this.params = {
        Mesh: {},
        Line: { threshold: 1 },
        LOD: {},
        Points: { threshold: 1 },
        Sprite: {},
      })
  }
  set(e, t) {
    this.ray.set(e, t)
  }
  setFromCamera(e, t) {
    t.isPerspectiveCamera
      ? (this.ray.origin.setFromMatrixPosition(t.matrixWorld),
        this.ray.direction
          .set(e.x, e.y, 0.5)
          .unproject(t)
          .sub(this.ray.origin)
          .normalize(),
        (this.camera = t))
      : t.isOrthographicCamera
      ? (this.ray.origin
          .set(e.x, e.y, (t.near + t.far) / (t.near - t.far))
          .unproject(t),
        this.ray.direction.set(0, 0, -1).transformDirection(t.matrixWorld),
        (this.camera = t))
      : console.error("THREE.Raycaster: Unsupported camera type: " + t.type)
  }
  setFromXRController(e) {
    return (
      _b.identity().extractRotation(e.matrixWorld),
      this.ray.origin.setFromMatrixPosition(e.matrixWorld),
      this.ray.direction.set(0, 0, -1).applyMatrix4(_b),
      this
    )
  }
  intersectObject(e, t = !0, i = []) {
    return I1(e, this, i, t), i.sort(wb), i
  }
  intersectObjects(e, t = !0, i = []) {
    for (let r = 0, s = e.length; r < s; r++) I1(e[r], this, i, t)
    return i.sort(wb), i
  }
}
function wb(n, e) {
  return n.distance - e.distance
}
function I1(n, e, t, i) {
  let r = !0
  if (
    (n.layers.test(e.layers) && n.raycast(e, t) === !1 && (r = !1),
    r === !0 && i === !0)
  ) {
    const s = n.children
    for (let o = 0, l = s.length; o < l; o++) I1(s[o], e, t, !0)
  }
}
class gH {
  constructor(e = 1, t = 0, i = 0) {
    return (this.radius = e), (this.phi = t), (this.theta = i), this
  }
  set(e, t, i) {
    return (this.radius = e), (this.phi = t), (this.theta = i), this
  }
  copy(e) {
    return (this.radius = e.radius), (this.phi = e.phi), (this.theta = e.theta), this
  }
  makeSafe() {
    return (this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi))), this
  }
  setFromVector3(e) {
    return this.setFromCartesianCoords(e.x, e.y, e.z)
  }
  setFromCartesianCoords(e, t, i) {
    return (
      (this.radius = Math.sqrt(e * e + t * t + i * i)),
      this.radius === 0
        ? ((this.theta = 0), (this.phi = 0))
        : ((this.theta = Math.atan2(e, i)),
          (this.phi = Math.acos(ri(t / this.radius, -1, 1)))),
      this
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
class vH {
  constructor(e = 1, t = 0, i = 0) {
    return (this.radius = e), (this.theta = t), (this.y = i), this
  }
  set(e, t, i) {
    return (this.radius = e), (this.theta = t), (this.y = i), this
  }
  copy(e) {
    return (this.radius = e.radius), (this.theta = e.theta), (this.y = e.y), this
  }
  setFromVector3(e) {
    return this.setFromCartesianCoords(e.x, e.y, e.z)
  }
  setFromCartesianCoords(e, t, i) {
    return (
      (this.radius = Math.sqrt(e * e + i * i)),
      (this.theta = Math.atan2(e, i)),
      (this.y = t),
      this
    )
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
class pS {
  constructor(e, t, i, r) {
    ;(pS.prototype.isMatrix2 = !0),
      (this.elements = [1, 0, 0, 1]),
      e !== void 0 && this.set(e, t, i, r)
  }
  identity() {
    return this.set(1, 0, 0, 1), this
  }
  fromArray(e, t = 0) {
    for (let i = 0; i < 4; i++) this.elements[i] = e[i + t]
    return this
  }
  set(e, t, i, r) {
    const s = this.elements
    return (s[0] = e), (s[2] = t), (s[1] = i), (s[3] = r), this
  }
}
const Sb = new We()
class yH {
  constructor(e = new We(1 / 0, 1 / 0), t = new We(-1 / 0, -1 / 0)) {
    ;(this.isBox2 = !0), (this.min = e), (this.max = t)
  }
  set(e, t) {
    return this.min.copy(e), this.max.copy(t), this
  }
  setFromPoints(e) {
    this.makeEmpty()
    for (let t = 0, i = e.length; t < i; t++) this.expandByPoint(e[t])
    return this
  }
  setFromCenterAndSize(e, t) {
    const i = Sb.copy(t).multiplyScalar(0.5)
    return this.min.copy(e).sub(i), this.max.copy(e).add(i), this
  }
  clone() {
    return new this.constructor().copy(this)
  }
  copy(e) {
    return this.min.copy(e.min), this.max.copy(e.max), this
  }
  makeEmpty() {
    return (this.min.x = this.min.y = 1 / 0), (this.max.x = this.max.y = -1 / 0), this
  }
  isEmpty() {
    return this.max.x < this.min.x || this.max.y < this.min.y
  }
  getCenter(e) {
    return this.isEmpty()
      ? e.set(0, 0)
      : e.addVectors(this.min, this.max).multiplyScalar(0.5)
  }
  getSize(e) {
    return this.isEmpty() ? e.set(0, 0) : e.subVectors(this.max, this.min)
  }
  expandByPoint(e) {
    return this.min.min(e), this.max.max(e), this
  }
  expandByVector(e) {
    return this.min.sub(e), this.max.add(e), this
  }
  expandByScalar(e) {
    return this.min.addScalar(-e), this.max.addScalar(e), this
  }
  containsPoint(e) {
    return (
      e.x >= this.min.x && e.x <= this.max.x && e.y >= this.min.y && e.y <= this.max.y
    )
  }
  containsBox(e) {
    return (
      this.min.x <= e.min.x &&
      e.max.x <= this.max.x &&
      this.min.y <= e.min.y &&
      e.max.y <= this.max.y
    )
  }
  getParameter(e, t) {
    return t.set(
      (e.x - this.min.x) / (this.max.x - this.min.x),
      (e.y - this.min.y) / (this.max.y - this.min.y),
    )
  }
  intersectsBox(e) {
    return (
      e.max.x >= this.min.x &&
      e.min.x <= this.max.x &&
      e.max.y >= this.min.y &&
      e.min.y <= this.max.y
    )
  }
  clampPoint(e, t) {
    return t.copy(e).clamp(this.min, this.max)
  }
  distanceToPoint(e) {
    return this.clampPoint(e, Sb).distanceTo(e)
  }
  intersect(e) {
    return (
      this.min.max(e.min), this.max.min(e.max), this.isEmpty() && this.makeEmpty(), this
    )
  }
  union(e) {
    return this.min.min(e.min), this.max.max(e.max), this
  }
  translate(e) {
    return this.min.add(e), this.max.add(e), this
  }
  equals(e) {
    return e.min.equals(this.min) && e.max.equals(this.max)
  }
}
const Mb = new q(),
  m0 = new q()
class xH {
  constructor(e = new q(), t = new q()) {
    ;(this.start = e), (this.end = t)
  }
  set(e, t) {
    return this.start.copy(e), this.end.copy(t), this
  }
  copy(e) {
    return this.start.copy(e.start), this.end.copy(e.end), this
  }
  getCenter(e) {
    return e.addVectors(this.start, this.end).multiplyScalar(0.5)
  }
  delta(e) {
    return e.subVectors(this.end, this.start)
  }
  distanceSq() {
    return this.start.distanceToSquared(this.end)
  }
  distance() {
    return this.start.distanceTo(this.end)
  }
  at(e, t) {
    return this.delta(t).multiplyScalar(e).add(this.start)
  }
  closestPointToPointParameter(e, t) {
    Mb.subVectors(e, this.start), m0.subVectors(this.end, this.start)
    const i = m0.dot(m0)
    let s = m0.dot(Mb) / i
    return t && (s = ri(s, 0, 1)), s
  }
  closestPointToPoint(e, t, i) {
    const r = this.closestPointToPointParameter(e, t)
    return this.delta(i).multiplyScalar(r).add(this.start)
  }
  applyMatrix4(e) {
    return this.start.applyMatrix4(e), this.end.applyMatrix4(e), this
  }
  equals(e) {
    return e.start.equals(this.start) && e.end.equals(this.end)
  }
  clone() {
    return new this.constructor().copy(this)
  }
}
const Eb = new q()
class _H extends cn {
  constructor(e, t) {
    super(),
      (this.light = e),
      (this.matrixAutoUpdate = !1),
      (this.color = t),
      (this.type = "SpotLightHelper")
    const i = new Gt(),
      r = [
        0, 0, 0, 0, 0, 1, 0, 0, 0, 1, 0, 1, 0, 0, 0, -1, 0, 1, 0, 0, 0, 0, 1, 1, 0, 0,
        0, 0, -1, 1,
      ]
    for (let o = 0, l = 1, u = 32; o < u; o++, l++) {
      const d = (o / u) * Math.PI * 2,
        p = (l / u) * Math.PI * 2
      r.push(Math.cos(d), Math.sin(d), 1, Math.cos(p), Math.sin(p), 1)
    }
    i.setAttribute("position", new vt(r, 3))
    const s = new mr({ fog: !1, toneMapped: !1 })
    ;(this.cone = new Qo(i, s)), this.add(this.cone), this.update()
  }
  dispose() {
    this.cone.geometry.dispose(), this.cone.material.dispose()
  }
  update() {
    this.light.updateWorldMatrix(!0, !1),
      this.light.target.updateWorldMatrix(!0, !1),
      this.parent
        ? (this.parent.updateWorldMatrix(!0),
          this.matrix
            .copy(this.parent.matrixWorld)
            .invert()
            .multiply(this.light.matrixWorld))
        : this.matrix.copy(this.light.matrixWorld),
      this.matrixWorld.copy(this.light.matrixWorld)
    const e = this.light.distance ? this.light.distance : 1e3,
      t = e * Math.tan(this.light.angle)
    this.cone.scale.set(t, t, e),
      Eb.setFromMatrixPosition(this.light.target.matrixWorld),
      this.cone.lookAt(Eb),
      this.color !== void 0
        ? this.cone.material.color.set(this.color)
        : this.cone.material.color.copy(this.light.color)
  }
}
const Vl = new q(),
  g0 = new mt(),
  v_ = new mt()
class wH extends Qo {
  constructor(e) {
    const t = vR(e),
      i = new Gt(),
      r = [],
      s = [],
      o = new ot(0, 0, 1),
      l = new ot(0, 1, 0)
    for (let d = 0; d < t.length; d++) {
      const p = t[d]
      p.parent &&
        p.parent.isBone &&
        (r.push(0, 0, 0), r.push(0, 0, 0), s.push(o.r, o.g, o.b), s.push(l.r, l.g, l.b))
    }
    i.setAttribute("position", new vt(r, 3)), i.setAttribute("color", new vt(s, 3))
    const u = new mr({
      vertexColors: !0,
      depthTest: !1,
      depthWrite: !1,
      toneMapped: !1,
      transparent: !0,
    })
    super(i, u),
      (this.isSkeletonHelper = !0),
      (this.type = "SkeletonHelper"),
      (this.root = e),
      (this.bones = t),
      (this.matrix = e.matrixWorld),
      (this.matrixAutoUpdate = !1)
  }
  updateMatrixWorld(e) {
    const t = this.bones,
      i = this.geometry,
      r = i.getAttribute("position")
    v_.copy(this.root.matrixWorld).invert()
    for (let s = 0, o = 0; s < t.length; s++) {
      const l = t[s]
      l.parent &&
        l.parent.isBone &&
        (g0.multiplyMatrices(v_, l.matrixWorld),
        Vl.setFromMatrixPosition(g0),
        r.setXYZ(o, Vl.x, Vl.y, Vl.z),
        g0.multiplyMatrices(v_, l.parent.matrixWorld),
        Vl.setFromMatrixPosition(g0),
        r.setXYZ(o + 1, Vl.x, Vl.y, Vl.z),
        (o += 2))
    }
    ;(i.getAttribute("position").needsUpdate = !0), super.updateMatrixWorld(e)
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose()
  }
}
function vR(n) {
  const e = []
  n.isBone === !0 && e.push(n)
  for (let t = 0; t < n.children.length; t++) e.push.apply(e, vR(n.children[t]))
  return e
}
class SH extends ui {
  constructor(e, t, i) {
    const r = new Tm(t, 4, 2),
      s = new el({ wireframe: !0, fog: !1, toneMapped: !1 })
    super(r, s),
      (this.light = e),
      (this.color = i),
      (this.type = "PointLightHelper"),
      (this.matrix = this.light.matrixWorld),
      (this.matrixAutoUpdate = !1),
      this.update()
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose()
  }
  update() {
    this.light.updateWorldMatrix(!0, !1),
      this.color !== void 0
        ? this.material.color.set(this.color)
        : this.material.color.copy(this.light.color)
  }
}
const MH = new q(),
  Tb = new ot(),
  bb = new ot()
class EH extends cn {
  constructor(e, t, i) {
    super(),
      (this.light = e),
      (this.matrix = e.matrixWorld),
      (this.matrixAutoUpdate = !1),
      (this.color = i),
      (this.type = "HemisphereLightHelper")
    const r = new Em(t)
    r.rotateY(Math.PI * 0.5),
      (this.material = new el({ wireframe: !0, fog: !1, toneMapped: !1 })),
      this.color === void 0 && (this.material.vertexColors = !0)
    const s = r.getAttribute("position"),
      o = new Float32Array(s.count * 3)
    r.setAttribute("color", new bn(o, 3)),
      this.add(new ui(r, this.material)),
      this.update()
  }
  dispose() {
    this.children[0].geometry.dispose(), this.children[0].material.dispose()
  }
  update() {
    const e = this.children[0]
    if (this.color !== void 0) this.material.color.set(this.color)
    else {
      const t = e.geometry.getAttribute("color")
      Tb.copy(this.light.color), bb.copy(this.light.groundColor)
      for (let i = 0, r = t.count; i < r; i++) {
        const s = i < r / 2 ? Tb : bb
        t.setXYZ(i, s.r, s.g, s.b)
      }
      t.needsUpdate = !0
    }
    this.light.updateWorldMatrix(!0, !1),
      e.lookAt(MH.setFromMatrixPosition(this.light.matrixWorld).negate())
  }
}
class TH extends Qo {
  constructor(e = 10, t = 10, i = 4473924, r = 8947848) {
    ;(i = new ot(i)), (r = new ot(r))
    const s = t / 2,
      o = e / t,
      l = e / 2,
      u = [],
      d = []
    for (let v = 0, y = 0, x = -l; v <= t; v++, x += o) {
      u.push(-l, 0, x, l, 0, x), u.push(x, 0, -l, x, 0, l)
      const E = v === s ? i : r
      E.toArray(d, y),
        (y += 3),
        E.toArray(d, y),
        (y += 3),
        E.toArray(d, y),
        (y += 3),
        E.toArray(d, y),
        (y += 3)
    }
    const p = new Gt()
    p.setAttribute("position", new vt(u, 3)), p.setAttribute("color", new vt(d, 3))
    const m = new mr({ vertexColors: !0, toneMapped: !1 })
    super(p, m), (this.type = "GridHelper")
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose()
  }
}
class bH extends Qo {
  constructor(e = 10, t = 16, i = 8, r = 64, s = 4473924, o = 8947848) {
    ;(s = new ot(s)), (o = new ot(o))
    const l = [],
      u = []
    if (t > 1)
      for (let m = 0; m < t; m++) {
        const v = (m / t) * (Math.PI * 2),
          y = Math.sin(v) * e,
          x = Math.cos(v) * e
        l.push(0, 0, 0), l.push(y, 0, x)
        const E = m & 1 ? s : o
        u.push(E.r, E.g, E.b), u.push(E.r, E.g, E.b)
      }
    for (let m = 0; m < i; m++) {
      const v = m & 1 ? s : o,
        y = e - (e / i) * m
      for (let x = 0; x < r; x++) {
        let E = (x / r) * (Math.PI * 2),
          M = Math.sin(E) * y,
          w = Math.cos(E) * y
        l.push(M, 0, w),
          u.push(v.r, v.g, v.b),
          (E = ((x + 1) / r) * (Math.PI * 2)),
          (M = Math.sin(E) * y),
          (w = Math.cos(E) * y),
          l.push(M, 0, w),
          u.push(v.r, v.g, v.b)
      }
    }
    const d = new Gt()
    d.setAttribute("position", new vt(l, 3)), d.setAttribute("color", new vt(u, 3))
    const p = new mr({ vertexColors: !0, toneMapped: !1 })
    super(d, p), (this.type = "PolarGridHelper")
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose()
  }
}
const Ab = new q(),
  v0 = new q(),
  Cb = new q()
class AH extends cn {
  constructor(e, t, i) {
    super(),
      (this.light = e),
      (this.matrix = e.matrixWorld),
      (this.matrixAutoUpdate = !1),
      (this.color = i),
      (this.type = "DirectionalLightHelper"),
      t === void 0 && (t = 1)
    let r = new Gt()
    r.setAttribute(
      "position",
      new vt([-t, t, 0, t, t, 0, t, -t, 0, -t, -t, 0, -t, t, 0], 3),
    )
    const s = new mr({ fog: !1, toneMapped: !1 })
    ;(this.lightPlane = new Ja(r, s)),
      this.add(this.lightPlane),
      (r = new Gt()),
      r.setAttribute("position", new vt([0, 0, 0, 0, 0, 1], 3)),
      (this.targetLine = new Ja(r, s)),
      this.add(this.targetLine),
      this.update()
  }
  dispose() {
    this.lightPlane.geometry.dispose(),
      this.lightPlane.material.dispose(),
      this.targetLine.geometry.dispose(),
      this.targetLine.material.dispose()
  }
  update() {
    this.light.updateWorldMatrix(!0, !1),
      this.light.target.updateWorldMatrix(!0, !1),
      Ab.setFromMatrixPosition(this.light.matrixWorld),
      v0.setFromMatrixPosition(this.light.target.matrixWorld),
      Cb.subVectors(v0, Ab),
      this.lightPlane.lookAt(v0),
      this.color !== void 0
        ? (this.lightPlane.material.color.set(this.color),
          this.targetLine.material.color.set(this.color))
        : (this.lightPlane.material.color.copy(this.light.color),
          this.targetLine.material.color.copy(this.light.color)),
      this.targetLine.lookAt(v0),
      (this.targetLine.scale.z = Cb.length())
  }
}
const y0 = new q(),
  ni = new xm()
class CH extends Qo {
  constructor(e) {
    const t = new Gt(),
      i = new mr({ color: 16777215, vertexColors: !0, toneMapped: !1 }),
      r = [],
      s = [],
      o = {}
    l("n1", "n2"),
      l("n2", "n4"),
      l("n4", "n3"),
      l("n3", "n1"),
      l("f1", "f2"),
      l("f2", "f4"),
      l("f4", "f3"),
      l("f3", "f1"),
      l("n1", "f1"),
      l("n2", "f2"),
      l("n3", "f3"),
      l("n4", "f4"),
      l("p", "n1"),
      l("p", "n2"),
      l("p", "n3"),
      l("p", "n4"),
      l("u1", "u2"),
      l("u2", "u3"),
      l("u3", "u1"),
      l("c", "t"),
      l("p", "c"),
      l("cn1", "cn2"),
      l("cn3", "cn4"),
      l("cf1", "cf2"),
      l("cf3", "cf4")
    function l(x, E) {
      u(x), u(E)
    }
    function u(x) {
      r.push(0, 0, 0),
        s.push(0, 0, 0),
        o[x] === void 0 && (o[x] = []),
        o[x].push(r.length / 3 - 1)
    }
    t.setAttribute("position", new vt(r, 3)),
      t.setAttribute("color", new vt(s, 3)),
      super(t, i),
      (this.type = "CameraHelper"),
      (this.camera = e),
      this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(),
      (this.matrix = e.matrixWorld),
      (this.matrixAutoUpdate = !1),
      (this.pointMap = o),
      this.update()
    const d = new ot(16755200),
      p = new ot(16711680),
      m = new ot(43775),
      v = new ot(16777215),
      y = new ot(3355443)
    this.setColors(d, p, m, v, y)
  }
  setColors(e, t, i, r, s) {
    const l = this.geometry.getAttribute("color")
    l.setXYZ(0, e.r, e.g, e.b),
      l.setXYZ(1, e.r, e.g, e.b),
      l.setXYZ(2, e.r, e.g, e.b),
      l.setXYZ(3, e.r, e.g, e.b),
      l.setXYZ(4, e.r, e.g, e.b),
      l.setXYZ(5, e.r, e.g, e.b),
      l.setXYZ(6, e.r, e.g, e.b),
      l.setXYZ(7, e.r, e.g, e.b),
      l.setXYZ(8, e.r, e.g, e.b),
      l.setXYZ(9, e.r, e.g, e.b),
      l.setXYZ(10, e.r, e.g, e.b),
      l.setXYZ(11, e.r, e.g, e.b),
      l.setXYZ(12, e.r, e.g, e.b),
      l.setXYZ(13, e.r, e.g, e.b),
      l.setXYZ(14, e.r, e.g, e.b),
      l.setXYZ(15, e.r, e.g, e.b),
      l.setXYZ(16, e.r, e.g, e.b),
      l.setXYZ(17, e.r, e.g, e.b),
      l.setXYZ(18, e.r, e.g, e.b),
      l.setXYZ(19, e.r, e.g, e.b),
      l.setXYZ(20, e.r, e.g, e.b),
      l.setXYZ(21, e.r, e.g, e.b),
      l.setXYZ(22, e.r, e.g, e.b),
      l.setXYZ(23, e.r, e.g, e.b),
      l.setXYZ(24, t.r, t.g, t.b),
      l.setXYZ(25, t.r, t.g, t.b),
      l.setXYZ(26, t.r, t.g, t.b),
      l.setXYZ(27, t.r, t.g, t.b),
      l.setXYZ(28, t.r, t.g, t.b),
      l.setXYZ(29, t.r, t.g, t.b),
      l.setXYZ(30, t.r, t.g, t.b),
      l.setXYZ(31, t.r, t.g, t.b),
      l.setXYZ(32, i.r, i.g, i.b),
      l.setXYZ(33, i.r, i.g, i.b),
      l.setXYZ(34, i.r, i.g, i.b),
      l.setXYZ(35, i.r, i.g, i.b),
      l.setXYZ(36, i.r, i.g, i.b),
      l.setXYZ(37, i.r, i.g, i.b),
      l.setXYZ(38, r.r, r.g, r.b),
      l.setXYZ(39, r.r, r.g, r.b),
      l.setXYZ(40, s.r, s.g, s.b),
      l.setXYZ(41, s.r, s.g, s.b),
      l.setXYZ(42, s.r, s.g, s.b),
      l.setXYZ(43, s.r, s.g, s.b),
      l.setXYZ(44, s.r, s.g, s.b),
      l.setXYZ(45, s.r, s.g, s.b),
      l.setXYZ(46, s.r, s.g, s.b),
      l.setXYZ(47, s.r, s.g, s.b),
      l.setXYZ(48, s.r, s.g, s.b),
      l.setXYZ(49, s.r, s.g, s.b),
      (l.needsUpdate = !0)
  }
  update() {
    const e = this.geometry,
      t = this.pointMap,
      i = 1,
      r = 1
    ni.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse),
      li("c", t, e, ni, 0, 0, -1),
      li("t", t, e, ni, 0, 0, 1),
      li("n1", t, e, ni, -i, -r, -1),
      li("n2", t, e, ni, i, -r, -1),
      li("n3", t, e, ni, -i, r, -1),
      li("n4", t, e, ni, i, r, -1),
      li("f1", t, e, ni, -i, -r, 1),
      li("f2", t, e, ni, i, -r, 1),
      li("f3", t, e, ni, -i, r, 1),
      li("f4", t, e, ni, i, r, 1),
      li("u1", t, e, ni, i * 0.7, r * 1.1, -1),
      li("u2", t, e, ni, -i * 0.7, r * 1.1, -1),
      li("u3", t, e, ni, 0, r * 2, -1),
      li("cf1", t, e, ni, -i, 0, 1),
      li("cf2", t, e, ni, i, 0, 1),
      li("cf3", t, e, ni, 0, -r, 1),
      li("cf4", t, e, ni, 0, r, 1),
      li("cn1", t, e, ni, -i, 0, -1),
      li("cn2", t, e, ni, i, 0, -1),
      li("cn3", t, e, ni, 0, -r, -1),
      li("cn4", t, e, ni, 0, r, -1),
      (e.getAttribute("position").needsUpdate = !0)
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose()
  }
}
function li(n, e, t, i, r, s, o) {
  y0.set(r, s, o).unproject(i)
  const l = e[n]
  if (l !== void 0) {
    const u = t.getAttribute("position")
    for (let d = 0, p = l.length; d < p; d++) u.setXYZ(l[d], y0.x, y0.y, y0.z)
  }
}
const x0 = new Lr()
class RH extends Qo {
  constructor(e, t = 16776960) {
    const i = new Uint16Array([
        0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7,
      ]),
      r = new Float32Array(24),
      s = new Gt()
    s.setIndex(new bn(i, 1)),
      s.setAttribute("position", new bn(r, 3)),
      super(s, new mr({ color: t, toneMapped: !1 })),
      (this.object = e),
      (this.type = "BoxHelper"),
      (this.matrixAutoUpdate = !1),
      this.update()
  }
  update(e) {
    if (
      (e !== void 0 &&
        console.warn("THREE.BoxHelper: .update() has no longer arguments."),
      this.object !== void 0 && x0.setFromObject(this.object),
      x0.isEmpty())
    )
      return
    const t = x0.min,
      i = x0.max,
      r = this.geometry.attributes.position,
      s = r.array
    ;(s[0] = i.x),
      (s[1] = i.y),
      (s[2] = i.z),
      (s[3] = t.x),
      (s[4] = i.y),
      (s[5] = i.z),
      (s[6] = t.x),
      (s[7] = t.y),
      (s[8] = i.z),
      (s[9] = i.x),
      (s[10] = t.y),
      (s[11] = i.z),
      (s[12] = i.x),
      (s[13] = i.y),
      (s[14] = t.z),
      (s[15] = t.x),
      (s[16] = i.y),
      (s[17] = t.z),
      (s[18] = t.x),
      (s[19] = t.y),
      (s[20] = t.z),
      (s[21] = i.x),
      (s[22] = t.y),
      (s[23] = t.z),
      (r.needsUpdate = !0),
      this.geometry.computeBoundingSphere()
  }
  setFromObject(e) {
    return (this.object = e), this.update(), this
  }
  copy(e, t) {
    return super.copy(e, t), (this.object = e.object), this
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose()
  }
}
class PH extends Qo {
  constructor(e, t = 16776960) {
    const i = new Uint16Array([
        0, 1, 1, 2, 2, 3, 3, 0, 4, 5, 5, 6, 6, 7, 7, 4, 0, 4, 1, 5, 2, 6, 3, 7,
      ]),
      r = [
        1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, -1,
        -1,
      ],
      s = new Gt()
    s.setIndex(new bn(i, 1)),
      s.setAttribute("position", new vt(r, 3)),
      super(s, new mr({ color: t, toneMapped: !1 })),
      (this.box = e),
      (this.type = "Box3Helper"),
      this.geometry.computeBoundingSphere()
  }
  updateMatrixWorld(e) {
    const t = this.box
    t.isEmpty() ||
      (t.getCenter(this.position),
      t.getSize(this.scale),
      this.scale.multiplyScalar(0.5),
      super.updateMatrixWorld(e))
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose()
  }
}
class IH extends Ja {
  constructor(e, t = 1, i = 16776960) {
    const r = i,
      s = [
        1, -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, 1, 0, -1, -1, 0, 1, -1, 0, 1, 1, 0,
      ],
      o = new Gt()
    o.setAttribute("position", new vt(s, 3)),
      o.computeBoundingSphere(),
      super(o, new mr({ color: r, toneMapped: !1 })),
      (this.type = "PlaneHelper"),
      (this.plane = e),
      (this.size = t)
    const l = [1, 1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, -1, -1, 0, 1, -1, 0],
      u = new Gt()
    u.setAttribute("position", new vt(l, 3)),
      u.computeBoundingSphere(),
      this.add(
        new ui(
          u,
          new el({
            color: r,
            opacity: 0.2,
            transparent: !0,
            depthWrite: !1,
            toneMapped: !1,
          }),
        ),
      )
  }
  updateMatrixWorld(e) {
    this.position.set(0, 0, 0),
      this.scale.set(0.5 * this.size, 0.5 * this.size, 1),
      this.lookAt(this.plane.normal),
      this.translateZ(-this.plane.constant),
      super.updateMatrixWorld(e)
  }
  dispose() {
    this.geometry.dispose(),
      this.material.dispose(),
      this.children[0].geometry.dispose(),
      this.children[0].material.dispose()
  }
}
const Rb = new q()
let _0, y_
class LH extends cn {
  constructor(
    e = new q(0, 0, 1),
    t = new q(0, 0, 0),
    i = 1,
    r = 16776960,
    s = i * 0.2,
    o = s * 0.2,
  ) {
    super(),
      (this.type = "ArrowHelper"),
      _0 === void 0 &&
        ((_0 = new Gt()),
        _0.setAttribute("position", new vt([0, 0, 0, 0, 1, 0], 3)),
        (y_ = new qd(0, 0.5, 1, 5, 1)),
        y_.translate(0, -0.5, 0)),
      this.position.copy(t),
      (this.line = new Ja(_0, new mr({ color: r, toneMapped: !1 }))),
      (this.line.matrixAutoUpdate = !1),
      this.add(this.line),
      (this.cone = new ui(y_, new el({ color: r, toneMapped: !1 }))),
      (this.cone.matrixAutoUpdate = !1),
      this.add(this.cone),
      this.setDirection(e),
      this.setLength(i, s, o)
  }
  setDirection(e) {
    if (e.y > 0.99999) this.quaternion.set(0, 0, 0, 1)
    else if (e.y < -0.99999) this.quaternion.set(1, 0, 0, 0)
    else {
      Rb.set(e.z, 0, -e.x).normalize()
      const t = Math.acos(e.y)
      this.quaternion.setFromAxisAngle(Rb, t)
    }
  }
  setLength(e, t = e * 0.2, i = t * 0.2) {
    this.line.scale.set(1, Math.max(1e-4, e - t), 1),
      this.line.updateMatrix(),
      this.cone.scale.set(i, t, i),
      (this.cone.position.y = e),
      this.cone.updateMatrix()
  }
  setColor(e) {
    this.line.material.color.set(e), this.cone.material.color.set(e)
  }
  copy(e) {
    return super.copy(e, !1), this.line.copy(e.line), this.cone.copy(e.cone), this
  }
  dispose() {
    this.line.geometry.dispose(),
      this.line.material.dispose(),
      this.cone.geometry.dispose(),
      this.cone.material.dispose()
  }
}
class DH extends Qo {
  constructor(e = 1) {
    const t = [0, 0, 0, e, 0, 0, 0, 0, 0, 0, e, 0, 0, 0, 0, 0, 0, e],
      i = [1, 0, 0, 1, 0.6, 0, 0, 1, 0, 0.6, 1, 0, 0, 0, 1, 0, 0.6, 1],
      r = new Gt()
    r.setAttribute("position", new vt(t, 3)), r.setAttribute("color", new vt(i, 3))
    const s = new mr({ vertexColors: !0, toneMapped: !1 })
    super(r, s), (this.type = "AxesHelper")
  }
  setColors(e, t, i) {
    const r = new ot(),
      s = this.geometry.attributes.color.array
    return (
      r.set(e),
      r.toArray(s, 0),
      r.toArray(s, 3),
      r.set(t),
      r.toArray(s, 6),
      r.toArray(s, 9),
      r.set(i),
      r.toArray(s, 12),
      r.toArray(s, 15),
      (this.geometry.attributes.color.needsUpdate = !0),
      this
    )
  }
  dispose() {
    this.geometry.dispose(), this.material.dispose()
  }
}
class NH {
  constructor() {
    ;(this.type = "ShapePath"),
      (this.color = new ot()),
      (this.subPaths = []),
      (this.currentPath = null)
  }
  moveTo(e, t) {
    return (
      (this.currentPath = new Qp()),
      this.subPaths.push(this.currentPath),
      this.currentPath.moveTo(e, t),
      this
    )
  }
  lineTo(e, t) {
    return this.currentPath.lineTo(e, t), this
  }
  quadraticCurveTo(e, t, i, r) {
    return this.currentPath.quadraticCurveTo(e, t, i, r), this
  }
  bezierCurveTo(e, t, i, r, s, o) {
    return this.currentPath.bezierCurveTo(e, t, i, r, s, o), this
  }
  splineThru(e) {
    return this.currentPath.splineThru(e), this
  }
  toShapes(e) {
    function t(w) {
      const A = []
      for (let C = 0, R = w.length; C < R; C++) {
        const z = w[C],
          U = new Cu()
        ;(U.curves = z.curves), A.push(U)
      }
      return A
    }
    function i(w, A) {
      const C = A.length
      let R = !1
      for (let z = C - 1, U = 0; U < C; z = U++) {
        let O = A[z],
          N = A[U],
          k = N.x - O.x,
          I = N.y - O.y
        if (Math.abs(I) > Number.EPSILON) {
          if (
            (I < 0 && ((O = A[U]), (k = -k), (N = A[z]), (I = -I)),
            w.y < O.y || w.y > N.y)
          )
            continue
          if (w.y === O.y) {
            if (w.x === O.x) return !0
          } else {
            const V = I * (w.x - O.x) - k * (w.y - O.y)
            if (V === 0) return !0
            if (V < 0) continue
            R = !R
          }
        } else {
          if (w.y !== O.y) continue
          if ((N.x <= w.x && w.x <= O.x) || (O.x <= w.x && w.x <= N.x)) return !0
        }
      }
      return R
    }
    const r = qo.isClockWise,
      s = this.subPaths
    if (s.length === 0) return []
    let o, l, u
    const d = []
    if (s.length === 1)
      return (l = s[0]), (u = new Cu()), (u.curves = l.curves), d.push(u), d
    let p = !r(s[0].getPoints())
    p = e ? !p : p
    const m = [],
      v = []
    let y = [],
      x = 0,
      E
    ;(v[x] = void 0), (y[x] = [])
    for (let w = 0, A = s.length; w < A; w++)
      (l = s[w]),
        (E = l.getPoints()),
        (o = r(E)),
        (o = e ? !o : o),
        o
          ? (!p && v[x] && x++,
            (v[x] = { s: new Cu(), p: E }),
            (v[x].s.curves = l.curves),
            p && x++,
            (y[x] = []))
          : y[x].push({ h: l, p: E[0] })
    if (!v[0]) return t(s)
    if (v.length > 1) {
      let w = !1,
        A = 0
      for (let C = 0, R = v.length; C < R; C++) m[C] = []
      for (let C = 0, R = v.length; C < R; C++) {
        const z = y[C]
        for (let U = 0; U < z.length; U++) {
          const O = z[U]
          let N = !0
          for (let k = 0; k < v.length; k++)
            i(O.p, v[k].p) && (C !== k && A++, N ? ((N = !1), m[k].push(O)) : (w = !0))
          N && m[C].push(O)
        }
      }
      A > 0 && w === !1 && (y = m)
    }
    let M
    for (let w = 0, A = v.length; w < A; w++) {
      ;(u = v[w].s), d.push(u), (M = y[w])
      for (let C = 0, R = M.length; C < R; C++) u.holes.push(M[C].h)
    }
    return d
  }
}
class kH extends Jo {
  constructor(e, t = null) {
    super(),
      (this.object = e),
      (this.domElement = t),
      (this.enabled = !0),
      (this.state = -1),
      (this.keys = {}),
      (this.mouseButtons = { LEFT: null, MIDDLE: null, RIGHT: null }),
      (this.touches = { ONE: null, TWO: null })
  }
  connect() {}
  disconnect() {}
  dispose() {}
  update() {}
}
class FH extends So {
  constructor(e = 1, t = 1, i = 1, r = {}) {
    console.warn(
      'THREE.WebGLMultipleRenderTargets has been deprecated and will be removed in r172. Use THREE.WebGLRenderTarget and set the "count" parameter to enable MRT.',
    ),
      super(e, t, { ...r, count: i }),
      (this.isWebGLMultipleRenderTargets = !0)
  }
  get texture() {
    return this.textures
  }
}
typeof __THREE_DEVTOOLS__ < "u" &&
  __THREE_DEVTOOLS__.dispatchEvent(
    new CustomEvent("register", { detail: { revision: mm } }),
  )
typeof window < "u" &&
  (window.__THREE__
    ? console.warn("WARNING: Multiple instances of Three.js being imported.")
    : (window.__THREE__ = mm))
const UH = Object.freeze(
  Object.defineProperty(
    {
      __proto__: null,
      ACESFilmicToneMapping: Ew,
      AddEquation: $l,
      AddOperation: XC,
      AdditiveAnimationBlendMode: kw,
      AdditiveBlending: y1,
      AgXToneMapping: ZC,
      AlphaFormat: Rw,
      AlwaysCompare: d3,
      AlwaysDepth: j0,
      AlwaysStencilFunc: S1,
      AmbientLight: lS,
      AnimationAction: mR,
      AnimationClip: Ud,
      AnimationLoader: U6,
      AnimationMixer: fH,
      AnimationObjectGroup: cH,
      AnimationUtils: D6,
      ArcCurve: U3,
      ArrayCamera: C3,
      ArrowHelper: LH,
      AttachedBindMode: w1,
      Audio: hR,
      AudioAnalyser: Q6,
      AudioContext: cS,
      AudioListener: K6,
      AudioLoader: Y6,
      AxesHelper: DH,
      BackSide: Ir,
      BasicDepthPacking: i3,
      BasicShadowMap: bC,
      BatchedMesh: N3,
      Bone: Jp,
      BooleanKeyframeTrack: Vu,
      Box2: yH,
      Box3: Lr,
      Box3Helper: PH,
      BoxGeometry: zu,
      BoxHelper: RH,
      BufferAttribute: bn,
      BufferGeometry: Gt,
      BufferGeometryLoader: dR,
      ByteType: bw,
      Cache: Ha,
      Camera: xm,
      CameraHelper: CH,
      CanvasTexture: i6,
      CapsuleGeometry: ly,
      CatmullRomCurve3: O3,
      CineonToneMapping: $C,
      CircleGeometry: cy,
      ClampToEdgeWrapping: Jr,
      Clock: uS,
      Color: ot,
      ColorKeyframeTrack: iS,
      ColorManagement: fn,
      CompressedArrayTexture: t6,
      CompressedCubeTexture: n6,
      CompressedTexture: oy,
      CompressedTextureLoader: O6,
      ConeGeometry: uy,
      ConstantAlphaFactor: GC,
      ConstantColorFactor: VC,
      Controls: kH,
      CubeCamera: _3,
      CubeReflectionMapping: Ka,
      CubeRefractionMapping: rc,
      CubeTexture: _m,
      CubeTextureLoader: B6,
      CubeUVReflectionMapping: Hd,
      CubicBezierCurve: qw,
      CubicBezierCurve3: B3,
      CubicInterpolant: nR,
      CullFaceBack: v1,
      CullFaceFront: TC,
      CullFaceFrontBack: LU,
      CullFaceNone: EC,
      Curve: Os,
      CurvePath: V3,
      CustomBlending: AC,
      CustomToneMapping: KC,
      CylinderGeometry: qd,
      Cylindrical: vH,
      Data3DTexture: Ow,
      DataArrayTexture: ey,
      DataTexture: Yo,
      DataTextureLoader: z6,
      DataUtils: jO,
      DecrementStencilOp: XU,
      DecrementWrapStencilOp: qU,
      DefaultLoadingManager: sR,
      DepthFormat: Tu,
      DepthStencilFormat: Nu,
      DepthTexture: Vw,
      DetachedBindMode: QC,
      DirectionalLight: aS,
      DirectionalLightHelper: AH,
      DiscreteInterpolant: iR,
      DodecahedronGeometry: fy,
      DoubleSide: Vo,
      DstAlphaFactor: FC,
      DstColorFactor: OC,
      DynamicCopyUsage: cO,
      DynamicDrawUsage: iO,
      DynamicReadUsage: oO,
      EdgesGeometry: H3,
      EllipseCurve: ay,
      EqualCompare: l3,
      EqualDepth: Y0,
      EqualStencilFunc: JU,
      EquirectangularReflectionMapping: Pd,
      EquirectangularRefractionMapping: Wp,
      Euler: Bi,
      EventDispatcher: Jo,
      ExtrudeGeometry: hy,
      FileLoader: Ko,
      Float16BufferAttribute: ZO,
      Float32BufferAttribute: vt,
      FloatType: Qr,
      Fog: ry,
      FogExp2: iy,
      FramebufferTexture: e6,
      FrontSide: $a,
      Frustum: wm,
      GLBufferAttribute: mH,
      GLSL1: fO,
      GLSL3: M1,
      GreaterCompare: c3,
      GreaterDepth: $0,
      GreaterEqualCompare: f3,
      GreaterEqualDepth: q0,
      GreaterEqualStencilFunc: nO,
      GreaterStencilFunc: eO,
      GridHelper: TH,
      Group: Ql,
      HalfFloatType: Gd,
      HemisphereLight: aR,
      HemisphereLightHelper: EH,
      IcosahedronGeometry: py,
      ImageBitmapLoader: X6,
      ImageLoader: im,
      ImageUtils: m3,
      IncrementStencilOp: jU,
      IncrementWrapStencilOp: YU,
      InstancedBufferAttribute: Nd,
      InstancedBufferGeometry: fR,
      InstancedInterleavedBuffer: pH,
      InstancedMesh: D3,
      Int16BufferAttribute: $O,
      Int32BufferAttribute: KO,
      Int8BufferAttribute: XO,
      IntType: Yv,
      InterleavedBuffer: sy,
      InterleavedBufferAttribute: ku,
      Interpolant: bm,
      InterpolateDiscrete: Xp,
      InterpolateLinear: Mv,
      InterpolateSmooth: C0,
      InvertStencilOp: $U,
      KeepStencilOp: fu,
      KeyframeTrack: Eo,
      LOD: L3,
      LatheGeometry: Mm,
      Layers: Au,
      LessCompare: a3,
      LessDepth: X0,
      LessEqualCompare: Fw,
      LessEqualDepth: Iu,
      LessEqualStencilFunc: QU,
      LessStencilFunc: ZU,
      Light: cc,
      LightProbe: uR,
      Line: Ja,
      Line3: xH,
      LineBasicMaterial: mr,
      LineCurve: $w,
      LineCurve3: z3,
      LineDashedMaterial: Q3,
      LineLoop: k3,
      LineSegments: Qo,
      LinearFilter: Ri,
      LinearInterpolant: nS,
      LinearMipMapLinearFilter: FU,
      LinearMipMapNearestFilter: kU,
      LinearMipmapLinearFilter: Ho,
      LinearMipmapNearestFilter: Tp,
      LinearSRGBColorSpace: Bu,
      LinearToneMapping: YC,
      LinearTransfer: ym,
      Loader: Dr,
      LoaderUtils: Cv,
      LoadingManager: rS,
      LoopOnce: e3,
      LoopPingPong: n3,
      LoopRepeat: t3,
      LuminanceAlphaFormat: Lw,
      LuminanceFormat: Iw,
      MOUSE: PU,
      Material: er,
      MaterialLoader: wy,
      MathUtils: yo,
      Matrix2: pS,
      Matrix3: Xt,
      Matrix4: mt,
      MaxEquation: IC,
      Mesh: ui,
      MeshBasicMaterial: el,
      MeshDepthMaterial: Hw,
      MeshDistanceMaterial: Gw,
      MeshLambertMaterial: eS,
      MeshMatcapMaterial: J3,
      MeshNormalMaterial: Z3,
      MeshPhongMaterial: Np,
      MeshPhysicalMaterial: $3,
      MeshStandardMaterial: Qw,
      MeshToonMaterial: K3,
      MinEquation: PC,
      MirroredRepeatWrapping: jp,
      MixOperation: jC,
      MultiplyBlending: _1,
      MultiplyOperation: gm,
      NearestFilter: Qi,
      NearestMipMapLinearFilter: NU,
      NearestMipMapNearestFilter: DU,
      NearestMipmapLinearFilter: wd,
      NearestMipmapNearestFilter: Tw,
      NeutralToneMapping: JC,
      NeverCompare: o3,
      NeverDepth: W0,
      NeverStencilFunc: KU,
      NoBlending: ja,
      NoColorSpace: za,
      NoToneMapping: Xo,
      NormalAnimationBlendMode: Qv,
      NormalBlending: Eu,
      NotEqualCompare: u3,
      NotEqualDepth: K0,
      NotEqualStencilFunc: tO,
      NumberKeyframeTrack: kd,
      Object3D: cn,
      ObjectLoader: W6,
      ObjectSpaceNormalMap: s3,
      OctahedronGeometry: Em,
      OneFactor: DC,
      OneMinusConstantAlphaFactor: WC,
      OneMinusConstantColorFactor: HC,
      OneMinusDstAlphaFactor: UC,
      OneMinusDstColorFactor: BC,
      OneMinusSrcAlphaFactor: G0,
      OneMinusSrcColorFactor: kC,
      OrthographicCamera: Xd,
      PCFShadowMap: jv,
      PCFSoftShadowMap: Ep,
      PMREMGenerator: E1,
      Path: Qp,
      PerspectiveCamera: Ci,
      Plane: Yl,
      PlaneGeometry: jd,
      PlaneHelper: IH,
      PointLight: Av,
      PointLightHelper: SH,
      Points: F3,
      PointsMaterial: Xw,
      PolarGridHelper: bH,
      PolyhedronGeometry: lc,
      PositionalAudio: J6,
      PropertyBinding: sn,
      PropertyMixer: pR,
      QuadraticBezierCurve: Kw,
      QuadraticBezierCurve3: Zw,
      Quaternion: Oi,
      QuaternionKeyframeTrack: $d,
      QuaternionLinearInterpolant: rR,
      RED_GREEN_RGTC2_Format: wv,
      RED_RGTC1_Format: Nw,
      REVISION: mm,
      RGBADepthPacking: r3,
      RGBAFormat: hr,
      RGBAIntegerFormat: Jv,
      RGBA_ASTC_10x10_Format: mv,
      RGBA_ASTC_10x5_Format: dv,
      RGBA_ASTC_10x6_Format: hv,
      RGBA_ASTC_10x8_Format: pv,
      RGBA_ASTC_12x10_Format: gv,
      RGBA_ASTC_12x12_Format: vv,
      RGBA_ASTC_4x4_Format: rv,
      RGBA_ASTC_5x4_Format: sv,
      RGBA_ASTC_5x5_Format: ov,
      RGBA_ASTC_6x5_Format: av,
      RGBA_ASTC_6x6_Format: lv,
      RGBA_ASTC_8x5_Format: cv,
      RGBA_ASTC_8x6_Format: uv,
      RGBA_ASTC_8x8_Format: fv,
      RGBA_BPTC_Format: Pp,
      RGBA_ETC2_EAC_Format: iv,
      RGBA_PVRTC_2BPPV1_Format: ev,
      RGBA_PVRTC_4BPPV1_Format: Q0,
      RGBA_S3TC_DXT1_Format: Ap,
      RGBA_S3TC_DXT3_Format: Cp,
      RGBA_S3TC_DXT5_Format: Rp,
      RGBDepthPacking: VU,
      RGBFormat: Pw,
      RGBIntegerFormat: UU,
      RGB_BPTC_SIGNED_Format: yv,
      RGB_BPTC_UNSIGNED_Format: xv,
      RGB_ETC1_Format: tv,
      RGB_ETC2_Format: nv,
      RGB_PVRTC_2BPPV1_Format: J0,
      RGB_PVRTC_4BPPV1_Format: Z0,
      RGB_S3TC_DXT1_Format: bp,
      RGDepthPacking: HU,
      RGFormat: Dw,
      RGIntegerFormat: Zv,
      RawShaderMaterial: q3,
      Ray: Wd,
      Raycaster: gR,
      RectAreaLight: lR,
      RedFormat: Kv,
      RedIntegerFormat: vm,
      ReinhardToneMapping: qC,
      RenderTarget: g3,
      RepeatWrapping: Lu,
      ReplaceStencilOp: WU,
      ReverseSubtractEquation: RC,
      RingGeometry: my,
      SIGNED_RED_GREEN_RGTC2_Format: Sv,
      SIGNED_RED_RGTC1_Format: _v,
      SRGBColorSpace: Kr,
      SRGBTransfer: Sn,
      Scene: Zp,
      ShaderChunk: Qt,
      ShaderLib: vo,
      ShaderMaterial: Mo,
      ShadowMaterial: Y3,
      Shape: Cu,
      ShapeGeometry: gy,
      ShapePath: NH,
      ShapeUtils: qo,
      ShortType: Aw,
      Skeleton: Sm,
      SkeletonHelper: wH,
      SkinnedMesh: jw,
      Source: _u,
      Sphere: pr,
      SphereGeometry: Tm,
      Spherical: gH,
      SphericalHarmonics3: cR,
      SplineCurve: Jw,
      SpotLight: oS,
      SpotLightHelper: _H,
      Sprite: I3,
      SpriteMaterial: Ww,
      SrcAlphaFactor: H0,
      SrcAlphaSaturateFactor: zC,
      SrcColorFactor: NC,
      StaticCopyUsage: lO,
      StaticDrawUsage: qp,
      StaticReadUsage: sO,
      StereoCamera: q6,
      StreamCopyUsage: uO,
      StreamDrawUsage: rO,
      StreamReadUsage: aO,
      StringKeyframeTrack: Hu,
      SubtractEquation: CC,
      SubtractiveBlending: x1,
      TOUCH: IU,
      TangentSpaceNormalMap: ac,
      TetrahedronGeometry: vy,
      Texture: zn,
      TextureLoader: oR,
      TextureUtils: NV,
      TorusGeometry: yy,
      TorusKnotGeometry: xy,
      Triangle: Zr,
      TriangleFanDrawMode: zU,
      TriangleStripDrawMode: BU,
      TrianglesDrawMode: OU,
      TubeGeometry: _y,
      UVMapping: Xv,
      Uint16BufferAttribute: ty,
      Uint32BufferAttribute: Bw,
      Uint8BufferAttribute: YO,
      Uint8ClampedBufferAttribute: qO,
      Uniform: hS,
      UniformsGroup: hH,
      UniformsLib: ut,
      UniformsUtils: x3,
      UnsignedByteType: wo,
      UnsignedInt248Type: Du,
      UnsignedInt5999Type: Cw,
      UnsignedIntType: Za,
      UnsignedShort4444Type: qv,
      UnsignedShort5551Type: $v,
      UnsignedShortType: Id,
      VSMShadowMap: go,
      Vector2: We,
      Vector3: q,
      Vector4: on,
      VectorKeyframeTrack: Fd,
      VideoTexture: QV,
      WebGL3DRenderTarget: kO,
      WebGLArrayRenderTarget: NO,
      WebGLCoordinateSystem: Go,
      WebGLCubeRenderTarget: w3,
      WebGLMultipleRenderTargets: FH,
      WebGLRenderTarget: So,
      WebGLRenderer: R3,
      WebGLUtils: A3,
      WebGPUCoordinateSystem: $p,
      WireframeGeometry: X3,
      WrapAroundEnding: Yp,
      ZeroCurvatureEnding: yu,
      ZeroFactor: LC,
      ZeroSlopeEnding: xu,
      ZeroStencilOp: GU,
      createCanvasElement: p3,
    },
    Symbol.toStringTag,
    { value: "Module" },
  ),
)
var x_ = { exports: {} },
  Hl = {}
/**
 * @license React
 * react-reconciler-constants.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Pb
function OH() {
  return (
    Pb ||
      ((Pb = 1),
      (Hl.ConcurrentRoot = 1),
      (Hl.ContinuousEventPriority = 4),
      (Hl.DefaultEventPriority = 16),
      (Hl.DiscreteEventPriority = 1),
      (Hl.IdleEventPriority = 536870912),
      (Hl.LegacyRoot = 0)),
    Hl
  )
}
var Ib
function BH() {
  return Ib || ((Ib = 1), (x_.exports = OH())), x_.exports
}
var Td = BH()
function zH(n) {
  let e
  const t = new Set(),
    i = (d, p) => {
      const m = typeof d == "function" ? d(e) : d
      if (m !== e) {
        const v = e
        ;(e = p ? m : Object.assign({}, e, m)), t.forEach((y) => y(e, v))
      }
    },
    r = () => e,
    s = (d, p = r, m = Object.is) => {
      console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware")
      let v = p(e)
      function y() {
        const x = p(e)
        if (!m(v, x)) {
          const E = v
          d((v = x), E)
        }
      }
      return t.add(y), () => t.delete(y)
    },
    u = {
      setState: i,
      getState: r,
      subscribe: (d, p, m) => (p || m ? s(d, p, m) : (t.add(d), () => t.delete(d))),
      destroy: () => t.clear(),
    }
  return (e = n(i, r, u)), u
}
const VH =
    typeof window > "u" ||
    !window.navigator ||
    /ServerSideRendering|^Deno\//.test(window.navigator.userAgent),
  Lb = VH ? Y.useEffect : Y.useLayoutEffect
function HH(n) {
  const e = typeof n == "function" ? zH(n) : n,
    t = (i = e.getState, r = Object.is) => {
      const [, s] = Y.useReducer((M) => M + 1, 0),
        o = e.getState(),
        l = Y.useRef(o),
        u = Y.useRef(i),
        d = Y.useRef(r),
        p = Y.useRef(!1),
        m = Y.useRef()
      m.current === void 0 && (m.current = i(o))
      let v,
        y = !1
      ;(l.current !== o || u.current !== i || d.current !== r || p.current) &&
        ((v = i(o)), (y = !r(m.current, v))),
        Lb(() => {
          y && (m.current = v),
            (l.current = o),
            (u.current = i),
            (d.current = r),
            (p.current = !1)
        })
      const x = Y.useRef(o)
      Lb(() => {
        const M = () => {
            try {
              const A = e.getState(),
                C = u.current(A)
              d.current(m.current, C) || ((l.current = A), (m.current = C), s())
            } catch {
              ;(p.current = !0), s()
            }
          },
          w = e.subscribe(M)
        return e.getState() !== x.current && M(), w
      }, [])
      const E = y ? v : m.current
      return Y.useDebugValue(E), E
    }
  return (
    Object.assign(t, e),
    (t[Symbol.iterator] = function () {
      console.warn("[useStore, api] = create() is deprecated and will be removed in v4")
      const i = [t, e]
      return {
        next() {
          const r = i.length <= 0
          return { value: i.shift(), done: r }
        },
      }
    }),
    t
  )
}
const GH = (n) => typeof n == "object" && typeof n.then == "function",
  Su = []
function yR(n, e, t = (i, r) => i === r) {
  if (n === e) return !0
  if (!n || !e) return !1
  const i = n.length
  if (e.length !== i) return !1
  for (let r = 0; r < i; r++) if (!t(n[r], e[r])) return !1
  return !0
}
function xR(n, e = null, t = !1, i = {}) {
  e === null && (e = [n])
  for (const s of Su)
    if (yR(e, s.keys, s.equal)) {
      if (t) return
      if (Object.prototype.hasOwnProperty.call(s, "error")) throw s.error
      if (Object.prototype.hasOwnProperty.call(s, "response"))
        return (
          i.lifespan &&
            i.lifespan > 0 &&
            (s.timeout && clearTimeout(s.timeout),
            (s.timeout = setTimeout(s.remove, i.lifespan))),
          s.response
        )
      if (!t) throw s.promise
    }
  const r = {
    keys: e,
    equal: i.equal,
    remove: () => {
      const s = Su.indexOf(r)
      s !== -1 && Su.splice(s, 1)
    },
    promise: (GH(n) ? n : n(...e))
      .then((s) => {
        ;(r.response = s),
          i.lifespan && i.lifespan > 0 && (r.timeout = setTimeout(r.remove, i.lifespan))
      })
      .catch((s) => (r.error = s)),
  }
  if ((Su.push(r), !t)) throw r.promise
}
const WH = (n, e, t) => xR(n, e, !1, t),
  jH = (n, e, t) => void xR(n, e, !0, t),
  XH = (n) => {
    if (n === void 0 || n.length === 0) Su.splice(0, Su.length)
    else {
      const e = Su.find((t) => yR(n, t.keys, t.equal))
      e && e.remove()
    }
  }
var __ = { exports: {} },
  w_ = { exports: {} },
  S_ = {}
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var Db
function YH() {
  return (
    Db ||
      ((Db = 1),
      (function (n) {
        function e(G, ie) {
          var Q = G.length
          G.push(ie)
          e: for (; 0 < Q; ) {
            var W = (Q - 1) >>> 1,
              ne = G[W]
            if (0 < r(ne, ie)) (G[W] = ie), (G[Q] = ne), (Q = W)
            else break e
          }
        }
        function t(G) {
          return G.length === 0 ? null : G[0]
        }
        function i(G) {
          if (G.length === 0) return null
          var ie = G[0],
            Q = G.pop()
          if (Q !== ie) {
            G[0] = Q
            e: for (var W = 0, ne = G.length, ye = ne >>> 1; W < ye; ) {
              var oe = 2 * (W + 1) - 1,
                fe = G[oe],
                we = oe + 1,
                me = G[we]
              if (0 > r(fe, Q))
                we < ne && 0 > r(me, fe)
                  ? ((G[W] = me), (G[we] = Q), (W = we))
                  : ((G[W] = fe), (G[oe] = Q), (W = oe))
              else if (we < ne && 0 > r(me, Q)) (G[W] = me), (G[we] = Q), (W = we)
              else break e
            }
          }
          return ie
        }
        function r(G, ie) {
          var Q = G.sortIndex - ie.sortIndex
          return Q !== 0 ? Q : G.id - ie.id
        }
        if (typeof performance == "object" && typeof performance.now == "function") {
          var s = performance
          n.unstable_now = function () {
            return s.now()
          }
        } else {
          var o = Date,
            l = o.now()
          n.unstable_now = function () {
            return o.now() - l
          }
        }
        var u = [],
          d = [],
          p = 1,
          m = null,
          v = 3,
          y = !1,
          x = !1,
          E = !1,
          M = typeof setTimeout == "function" ? setTimeout : null,
          w = typeof clearTimeout == "function" ? clearTimeout : null,
          A = typeof setImmediate < "u" ? setImmediate : null
        typeof navigator < "u" &&
          navigator.scheduling !== void 0 &&
          navigator.scheduling.isInputPending !== void 0 &&
          navigator.scheduling.isInputPending.bind(navigator.scheduling)
        function C(G) {
          for (var ie = t(d); ie !== null; ) {
            if (ie.callback === null) i(d)
            else if (ie.startTime <= G)
              i(d), (ie.sortIndex = ie.expirationTime), e(u, ie)
            else break
            ie = t(d)
          }
        }
        function R(G) {
          if (((E = !1), C(G), !x))
            if (t(u) !== null) (x = !0), re(z)
            else {
              var ie = t(d)
              ie !== null && se(R, ie.startTime - G)
            }
        }
        function z(G, ie) {
          ;(x = !1), E && ((E = !1), w(N), (N = -1)), (y = !0)
          var Q = v
          try {
            for (
              C(ie), m = t(u);
              m !== null && (!(m.expirationTime > ie) || (G && !V()));

            ) {
              var W = m.callback
              if (typeof W == "function") {
                ;(m.callback = null), (v = m.priorityLevel)
                var ne = W(m.expirationTime <= ie)
                ;(ie = n.unstable_now()),
                  typeof ne == "function" ? (m.callback = ne) : m === t(u) && i(u),
                  C(ie)
              } else i(u)
              m = t(u)
            }
            if (m !== null) var ye = !0
            else {
              var oe = t(d)
              oe !== null && se(R, oe.startTime - ie), (ye = !1)
            }
            return ye
          } finally {
            ;(m = null), (v = Q), (y = !1)
          }
        }
        var U = !1,
          O = null,
          N = -1,
          k = 5,
          I = -1
        function V() {
          return !(n.unstable_now() - I < k)
        }
        function Z() {
          if (O !== null) {
            var G = n.unstable_now()
            I = G
            var ie = !0
            try {
              ie = O(!0, G)
            } finally {
              ie ? $() : ((U = !1), (O = null))
            }
          } else U = !1
        }
        var $
        if (typeof A == "function")
          $ = function () {
            A(Z)
          }
        else if (typeof MessageChannel < "u") {
          var ee = new MessageChannel(),
            ue = ee.port2
          ;(ee.port1.onmessage = Z),
            ($ = function () {
              ue.postMessage(null)
            })
        } else
          $ = function () {
            M(Z, 0)
          }
        function re(G) {
          ;(O = G), U || ((U = !0), $())
        }
        function se(G, ie) {
          N = M(function () {
            G(n.unstable_now())
          }, ie)
        }
        ;(n.unstable_IdlePriority = 5),
          (n.unstable_ImmediatePriority = 1),
          (n.unstable_LowPriority = 4),
          (n.unstable_NormalPriority = 3),
          (n.unstable_Profiling = null),
          (n.unstable_UserBlockingPriority = 2),
          (n.unstable_cancelCallback = function (G) {
            G.callback = null
          }),
          (n.unstable_continueExecution = function () {
            x || y || ((x = !0), re(z))
          }),
          (n.unstable_forceFrameRate = function (G) {
            0 > G || 125 < G
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported",
                )
              : (k = 0 < G ? Math.floor(1e3 / G) : 5)
          }),
          (n.unstable_getCurrentPriorityLevel = function () {
            return v
          }),
          (n.unstable_getFirstCallbackNode = function () {
            return t(u)
          }),
          (n.unstable_next = function (G) {
            switch (v) {
              case 1:
              case 2:
              case 3:
                var ie = 3
                break
              default:
                ie = v
            }
            var Q = v
            v = ie
            try {
              return G()
            } finally {
              v = Q
            }
          }),
          (n.unstable_pauseExecution = function () {}),
          (n.unstable_requestPaint = function () {}),
          (n.unstable_runWithPriority = function (G, ie) {
            switch (G) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break
              default:
                G = 3
            }
            var Q = v
            v = G
            try {
              return ie()
            } finally {
              v = Q
            }
          }),
          (n.unstable_scheduleCallback = function (G, ie, Q) {
            var W = n.unstable_now()
            switch (
              (typeof Q == "object" && Q !== null
                ? ((Q = Q.delay), (Q = typeof Q == "number" && 0 < Q ? W + Q : W))
                : (Q = W),
              G)
            ) {
              case 1:
                var ne = -1
                break
              case 2:
                ne = 250
                break
              case 5:
                ne = 1073741823
                break
              case 4:
                ne = 1e4
                break
              default:
                ne = 5e3
            }
            return (
              (ne = Q + ne),
              (G = {
                id: p++,
                callback: ie,
                priorityLevel: G,
                startTime: Q,
                expirationTime: ne,
                sortIndex: -1,
              }),
              Q > W
                ? ((G.sortIndex = Q),
                  e(d, G),
                  t(u) === null &&
                    G === t(d) &&
                    (E ? (w(N), (N = -1)) : (E = !0), se(R, Q - W)))
                : ((G.sortIndex = ne), e(u, G), x || y || ((x = !0), re(z))),
              G
            )
          }),
          (n.unstable_shouldYield = V),
          (n.unstable_wrapCallback = function (G) {
            var ie = v
            return function () {
              var Q = v
              v = ie
              try {
                return G.apply(this, arguments)
              } finally {
                v = Q
              }
            }
          })
      })(S_)),
    S_
  )
}
var Nb
function _R() {
  return Nb || ((Nb = 1), (w_.exports = YH())), w_.exports
}
/**
 * @license React
 * react-reconciler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var M_, kb
function qH() {
  return (
    kb ||
      ((kb = 1),
      (M_ = function (e) {
        var t = {},
          i = sc(),
          r = _R(),
          s = Object.assign
        function o(f) {
          for (
            var h = "https://reactjs.org/docs/error-decoder.html?invariant=" + f, _ = 1;
            _ < arguments.length;
            _++
          )
            h += "&args[]=" + encodeURIComponent(arguments[_])
          return (
            "Minified React error #" +
            f +
            "; visit " +
            h +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          )
        }
        var l = i.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
          u = Symbol.for("react.element"),
          d = Symbol.for("react.portal"),
          p = Symbol.for("react.fragment"),
          m = Symbol.for("react.strict_mode"),
          v = Symbol.for("react.profiler"),
          y = Symbol.for("react.provider"),
          x = Symbol.for("react.context"),
          E = Symbol.for("react.forward_ref"),
          M = Symbol.for("react.suspense"),
          w = Symbol.for("react.suspense_list"),
          A = Symbol.for("react.memo"),
          C = Symbol.for("react.lazy"),
          R = Symbol.for("react.offscreen"),
          z = Symbol.iterator
        function U(f) {
          return f === null || typeof f != "object"
            ? null
            : ((f = (z && f[z]) || f["@@iterator"]), typeof f == "function" ? f : null)
        }
        function O(f) {
          if (f == null) return null
          if (typeof f == "function") return f.displayName || f.name || null
          if (typeof f == "string") return f
          switch (f) {
            case p:
              return "Fragment"
            case d:
              return "Portal"
            case v:
              return "Profiler"
            case m:
              return "StrictMode"
            case M:
              return "Suspense"
            case w:
              return "SuspenseList"
          }
          if (typeof f == "object")
            switch (f.$$typeof) {
              case x:
                return (f.displayName || "Context") + ".Consumer"
              case y:
                return (f._context.displayName || "Context") + ".Provider"
              case E:
                var h = f.render
                return (
                  (f = f.displayName),
                  f ||
                    ((f = h.displayName || h.name || ""),
                    (f = f !== "" ? "ForwardRef(" + f + ")" : "ForwardRef")),
                  f
                )
              case A:
                return (h = f.displayName || null), h !== null ? h : O(f.type) || "Memo"
              case C:
                ;(h = f._payload), (f = f._init)
                try {
                  return O(f(h))
                } catch {}
            }
          return null
        }
        function N(f) {
          var h = f.type
          switch (f.tag) {
            case 24:
              return "Cache"
            case 9:
              return (h.displayName || "Context") + ".Consumer"
            case 10:
              return (h._context.displayName || "Context") + ".Provider"
            case 18:
              return "DehydratedFragment"
            case 11:
              return (
                (f = h.render),
                (f = f.displayName || f.name || ""),
                h.displayName || (f !== "" ? "ForwardRef(" + f + ")" : "ForwardRef")
              )
            case 7:
              return "Fragment"
            case 5:
              return h
            case 4:
              return "Portal"
            case 3:
              return "Root"
            case 6:
              return "Text"
            case 16:
              return O(h)
            case 8:
              return h === m ? "StrictMode" : "Mode"
            case 22:
              return "Offscreen"
            case 12:
              return "Profiler"
            case 21:
              return "Scope"
            case 13:
              return "Suspense"
            case 19:
              return "SuspenseList"
            case 25:
              return "TracingMarker"
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
              if (typeof h == "function") return h.displayName || h.name || null
              if (typeof h == "string") return h
          }
          return null
        }
        function k(f) {
          var h = f,
            _ = f
          if (f.alternate) for (; h.return; ) h = h.return
          else {
            f = h
            do (h = f), (h.flags & 4098) !== 0 && (_ = h.return), (f = h.return)
            while (f)
          }
          return h.tag === 3 ? _ : null
        }
        function I(f) {
          if (k(f) !== f) throw Error(o(188))
        }
        function V(f) {
          var h = f.alternate
          if (!h) {
            if (((h = k(f)), h === null)) throw Error(o(188))
            return h !== f ? null : f
          }
          for (var _ = f, T = h; ; ) {
            var P = _.return
            if (P === null) break
            var F = P.alternate
            if (F === null) {
              if (((T = P.return), T !== null)) {
                _ = T
                continue
              }
              break
            }
            if (P.child === F.child) {
              for (F = P.child; F; ) {
                if (F === _) return I(P), f
                if (F === T) return I(P), h
                F = F.sibling
              }
              throw Error(o(188))
            }
            if (_.return !== T.return) (_ = P), (T = F)
            else {
              for (var J = !1, pe = P.child; pe; ) {
                if (pe === _) {
                  ;(J = !0), (_ = P), (T = F)
                  break
                }
                if (pe === T) {
                  ;(J = !0), (T = P), (_ = F)
                  break
                }
                pe = pe.sibling
              }
              if (!J) {
                for (pe = F.child; pe; ) {
                  if (pe === _) {
                    ;(J = !0), (_ = F), (T = P)
                    break
                  }
                  if (pe === T) {
                    ;(J = !0), (T = F), (_ = P)
                    break
                  }
                  pe = pe.sibling
                }
                if (!J) throw Error(o(189))
              }
            }
            if (_.alternate !== T) throw Error(o(190))
          }
          if (_.tag !== 3) throw Error(o(188))
          return _.stateNode.current === _ ? f : h
        }
        function Z(f) {
          return (f = V(f)), f !== null ? $(f) : null
        }
        function $(f) {
          if (f.tag === 5 || f.tag === 6) return f
          for (f = f.child; f !== null; ) {
            var h = $(f)
            if (h !== null) return h
            f = f.sibling
          }
          return null
        }
        function ee(f) {
          if (f.tag === 5 || f.tag === 6) return f
          for (f = f.child; f !== null; ) {
            if (f.tag !== 4) {
              var h = ee(f)
              if (h !== null) return h
            }
            f = f.sibling
          }
          return null
        }
        var ue = Array.isArray,
          re = e.getPublicInstance,
          se = e.getRootHostContext,
          G = e.getChildHostContext,
          ie = e.prepareForCommit,
          Q = e.resetAfterCommit,
          W = e.createInstance,
          ne = e.appendInitialChild,
          ye = e.finalizeInitialChildren,
          oe = e.prepareUpdate,
          fe = e.shouldSetTextContent,
          we = e.createTextInstance,
          me = e.scheduleTimeout,
          Fe = e.cancelTimeout,
          ze = e.noTimeout,
          Ge = e.isPrimaryRenderer,
          Ue = e.supportsMutation,
          ae = e.supportsPersistence,
          Ee = e.supportsHydration,
          K = e.getInstanceFromNode,
          Ke = e.preparePortalMount,
          Be = e.getCurrentEventPriority,
          Oe = e.detachDeletedInstance,
          Pe = e.supportsMicrotasks,
          He = e.scheduleMicrotask,
          Se = e.supportsTestSelectors,
          j = e.findFiberRoot,
          B = e.getBoundingRect,
          ce = e.getTextContent,
          Me = e.isHiddenSubtree,
          De = e.matchAccessibilityRole,
          Ie = e.setFocusIfFocusable,
          st = e.setupIntersectionObserver,
          tt = e.appendChild,
          it = e.appendChildToContainer,
          Et = e.commitTextUpdate,
          je = e.commitMount,
          Je = e.commitUpdate,
          At = e.insertBefore,
          Pt = e.insertInContainerBefore,
          ft = e.removeChild,
          Wt = e.removeChildFromContainer,
          Nt = e.resetTextContent,
          dn = e.hideInstance,
          he = e.hideTextInstance,
          rt = e.unhideInstance,
          Ne = e.unhideTextInstance,
          Ve = e.clearContainer,
          lt = e.cloneInstance,
          at = e.createContainerChildSet,
          Ut = e.appendChildToContainerChildSet,
          vn = e.finalizeContainerChildren,
          Vn = e.replaceContainerChildren,
          an = e.cloneHiddenInstance,
          zi = e.cloneHiddenTextInstance,
          Vi = e.canHydrateInstance,
          tl = e.canHydrateTextInstance,
          To = e.canHydrateSuspenseInstance,
          ys = e.isSuspenseInstancePending,
          ns = e.isSuspenseInstanceFallback,
          ea = e.registerSuspenseInstanceRetry,
          is = e.getNextHydratableSibling,
          bo = e.getFirstHydratableChild,
          Gu = e.getFirstHydratableChildWithinContainer,
          nl = e.getFirstHydratableChildWithinSuspenseInstance,
          Wu = e.hydrateInstance,
          xs = e.hydrateTextInstance,
          ju = e.hydrateSuspenseInstance,
          Xu = e.getNextHydratableInstanceAfterSuspenseInstance,
          Yu = e.commitHydratedContainer,
          X = e.commitHydratedSuspenseInstance,
          ge = e.clearSuspenseBoundary,
          Ae = e.clearSuspenseBoundaryFromContainer,
          Ce = e.shouldDeleteUnhydratedTailInstances,
          xe = e.didNotMatchHydratedContainerTextInstance,
          Qe = e.didNotMatchHydratedTextInstance,
          qe
        function yt(f) {
          if (qe === void 0)
            try {
              throw Error()
            } catch (_) {
              var h = _.stack.trim().match(/\n( *(at )?)/)
              qe = (h && h[1]) || ""
            }
          return (
            `
` +
            qe +
            f
          )
        }
        var xt = !1
        function kt(f, h) {
          if (!f || xt) return ""
          xt = !0
          var _ = Error.prepareStackTrace
          Error.prepareStackTrace = void 0
          try {
            if (h)
              if (
                ((h = function () {
                  throw Error()
                }),
                Object.defineProperty(h.prototype, "props", {
                  set: function () {
                    throw Error()
                  },
                }),
                typeof Reflect == "object" && Reflect.construct)
              ) {
                try {
                  Reflect.construct(h, [])
                } catch (Ze) {
                  var T = Ze
                }
                Reflect.construct(f, [], h)
              } else {
                try {
                  h.call()
                } catch (Ze) {
                  T = Ze
                }
                f.call(h.prototype)
              }
            else {
              try {
                throw Error()
              } catch (Ze) {
                T = Ze
              }
              f()
            }
          } catch (Ze) {
            if (Ze && T && typeof Ze.stack == "string") {
              for (
                var P = Ze.stack.split(`
`),
                  F = T.stack.split(`
`),
                  J = P.length - 1,
                  pe = F.length - 1;
                1 <= J && 0 <= pe && P[J] !== F[pe];

              )
                pe--
              for (; 1 <= J && 0 <= pe; J--, pe--)
                if (P[J] !== F[pe]) {
                  if (J !== 1 || pe !== 1)
                    do
                      if ((J--, pe--, 0 > pe || P[J] !== F[pe])) {
                        var ke =
                          `
` + P[J].replace(" at new ", " at ")
                        return (
                          f.displayName &&
                            ke.includes("<anonymous>") &&
                            (ke = ke.replace("<anonymous>", f.displayName)),
                          ke
                        )
                      }
                    while (1 <= J && 0 <= pe)
                  break
                }
            }
          } finally {
            ;(xt = !1), (Error.prepareStackTrace = _)
          }
          return (f = f ? f.displayName || f.name : "") ? yt(f) : ""
        }
        var Ot = Object.prototype.hasOwnProperty,
          wt = [],
          $t = -1
        function en(f) {
          return { current: f }
        }
        function Tt(f) {
          0 > $t || ((f.current = wt[$t]), (wt[$t] = null), $t--)
        }
        function Yt(f, h) {
          $t++, (wt[$t] = f.current), (f.current = h)
        }
        var Ft = {},
          dt = en(Ft),
          In = en(!1),
          tn = Ft
        function Yn(f, h) {
          var _ = f.type.contextTypes
          if (!_) return Ft
          var T = f.stateNode
          if (T && T.__reactInternalMemoizedUnmaskedChildContext === h)
            return T.__reactInternalMemoizedMaskedChildContext
          var P = {},
            F
          for (F in _) P[F] = h[F]
          return (
            T &&
              ((f = f.stateNode),
              (f.__reactInternalMemoizedUnmaskedChildContext = h),
              (f.__reactInternalMemoizedMaskedChildContext = P)),
            P
          )
        }
        function Ln(f) {
          return (f = f.childContextTypes), f != null
        }
        function Hn() {
          Tt(In), Tt(dt)
        }
        function rs(f, h, _) {
          if (dt.current !== Ft) throw Error(o(168))
          Yt(dt, h), Yt(In, _)
        }
        function yn(f, h, _) {
          var T = f.stateNode
          if (((h = h.childContextTypes), typeof T.getChildContext != "function"))
            return _
          T = T.getChildContext()
          for (var P in T) if (!(P in h)) throw Error(o(108, N(f) || "Unknown", P))
          return s({}, _, T)
        }
        function Hi(f) {
          return (
            (f =
              ((f = f.stateNode) && f.__reactInternalMemoizedMergedChildContext) || Ft),
            (tn = dt.current),
            Yt(dt, f),
            Yt(In, In.current),
            !0
          )
        }
        function _s(f, h, _) {
          var T = f.stateNode
          if (!T) throw Error(o(169))
          _
            ? ((f = yn(f, h, tn)),
              (T.__reactInternalMemoizedMergedChildContext = f),
              Tt(In),
              Tt(dt),
              Yt(dt, f))
            : Tt(In),
            Yt(In, _)
        }
        var An = Math.clz32 ? Math.clz32 : qu,
          Nr = Math.log,
          tr = Math.LN2
        function qu(f) {
          return (f >>>= 0), f === 0 ? 32 : (31 - ((Nr(f) / tr) | 0)) | 0
        }
        var il = 64,
          hn = 4194304
        function rl(f) {
          switch (f & -f) {
            case 1:
              return 1
            case 2:
              return 2
            case 4:
              return 4
            case 8:
              return 8
            case 16:
              return 16
            case 32:
              return 32
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return f & 4194240
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return f & 130023424
            case 134217728:
              return 134217728
            case 268435456:
              return 268435456
            case 536870912:
              return 536870912
            case 1073741824:
              return 1073741824
            default:
              return f
          }
        }
        function uc(f, h) {
          var _ = f.pendingLanes
          if (_ === 0) return 0
          var T = 0,
            P = f.suspendedLanes,
            F = f.pingedLanes,
            J = _ & 268435455
          if (J !== 0) {
            var pe = J & ~P
            pe !== 0 ? (T = rl(pe)) : ((F &= J), F !== 0 && (T = rl(F)))
          } else (J = _ & ~P), J !== 0 ? (T = rl(J)) : F !== 0 && (T = rl(F))
          if (T === 0) return 0
          if (
            h !== 0 &&
            h !== T &&
            (h & P) === 0 &&
            ((P = T & -T), (F = h & -h), P >= F || (P === 16 && (F & 4194240) !== 0))
          )
            return h
          if (((T & 4) !== 0 && (T |= _ & 16), (h = f.entangledLanes), h !== 0))
            for (f = f.entanglements, h &= T; 0 < h; )
              (_ = 31 - An(h)), (P = 1 << _), (T |= f[_]), (h &= ~P)
          return T
        }
        function Kd(f, h) {
          switch (f) {
            case 1:
            case 2:
            case 4:
              return h + 250
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return h + 5e3
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return -1
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
              return -1
            default:
              return -1
          }
        }
        function Pm(f, h) {
          for (
            var _ = f.suspendedLanes,
              T = f.pingedLanes,
              P = f.expirationTimes,
              F = f.pendingLanes;
            0 < F;

          ) {
            var J = 31 - An(F),
              pe = 1 << J,
              ke = P[J]
            ke === -1
              ? ((pe & _) === 0 || (pe & T) !== 0) && (P[J] = Kd(pe, h))
              : ke <= h && (f.expiredLanes |= pe),
              (F &= ~pe)
          }
        }
        function $u(f) {
          return (
            (f = f.pendingLanes & -1073741825),
            f !== 0 ? f : f & 1073741824 ? 1073741824 : 0
          )
        }
        function Ku(f) {
          for (var h = [], _ = 0; 31 > _; _++) h.push(f)
          return h
        }
        function ta(f, h, _) {
          ;(f.pendingLanes |= h),
            h !== 536870912 && ((f.suspendedLanes = 0), (f.pingedLanes = 0)),
            (f = f.eventTimes),
            (h = 31 - An(h)),
            (f[h] = _)
        }
        function Zu(f, h) {
          var _ = f.pendingLanes & ~h
          ;(f.pendingLanes = h),
            (f.suspendedLanes = 0),
            (f.pingedLanes = 0),
            (f.expiredLanes &= h),
            (f.mutableReadLanes &= h),
            (f.entangledLanes &= h),
            (h = f.entanglements)
          var T = f.eventTimes
          for (f = f.expirationTimes; 0 < _; ) {
            var P = 31 - An(_),
              F = 1 << P
            ;(h[P] = 0), (T[P] = -1), (f[P] = -1), (_ &= ~F)
          }
        }
        function ws(f, h) {
          var _ = (f.entangledLanes |= h)
          for (f = f.entanglements; _; ) {
            var T = 31 - An(_),
              P = 1 << T
            ;(P & h) | (f[T] & h) && (f[T] |= h), (_ &= ~P)
          }
        }
        var Jt = 0
        function Bs(f) {
          return (
            (f &= -f),
            1 < f ? (4 < f ? ((f & 268435455) !== 0 ? 16 : 536870912) : 4) : 1
          )
        }
        var na = r.unstable_scheduleCallback,
          sl = r.unstable_cancelCallback,
          Ao = r.unstable_shouldYield,
          Sy = r.unstable_requestPaint,
          si = r.unstable_now,
          ia = r.unstable_ImmediatePriority,
          My = r.unstable_UserBlockingPriority,
          Ju = r.unstable_NormalPriority,
          Qu = r.unstable_IdlePriority,
          fc = null,
          Ss = null
        function dc(f) {
          if (Ss && typeof Ss.onCommitFiberRoot == "function")
            try {
              Ss.onCommitFiberRoot(fc, f, void 0, (f.current.flags & 128) === 128)
            } catch {}
        }
        function hc(f, h) {
          return (f === h && (f !== 0 || 1 / f === 1 / h)) || (f !== f && h !== h)
        }
        var Gi = typeof Object.is == "function" ? Object.is : hc,
          kr = null,
          ef = !1,
          Zd = !1
        function tf(f) {
          kr === null ? (kr = [f]) : kr.push(f)
        }
        function nf(f) {
          ;(ef = !0), tf(f)
        }
        function Fr() {
          if (!Zd && kr !== null) {
            Zd = !0
            var f = 0,
              h = Jt
            try {
              var _ = kr
              for (Jt = 1; f < _.length; f++) {
                var T = _[f]
                do T = T(!0)
                while (T !== null)
              }
              ;(kr = null), (ef = !1)
            } catch (P) {
              throw (kr !== null && (kr = kr.slice(f + 1)), na(ia, Fr), P)
            } finally {
              ;(Jt = h), (Zd = !1)
            }
          }
          return null
        }
        var Im = l.ReactCurrentBatchConfig
        function ss(f, h) {
          if (Gi(f, h)) return !0
          if (typeof f != "object" || f === null || typeof h != "object" || h === null)
            return !1
          var _ = Object.keys(f),
            T = Object.keys(h)
          if (_.length !== T.length) return !1
          for (T = 0; T < _.length; T++) {
            var P = _[T]
            if (!Ot.call(h, P) || !Gi(f[P], h[P])) return !1
          }
          return !0
        }
        function Jd(f) {
          switch (f.tag) {
            case 5:
              return yt(f.type)
            case 16:
              return yt("Lazy")
            case 13:
              return yt("Suspense")
            case 19:
              return yt("SuspenseList")
            case 0:
            case 2:
            case 15:
              return (f = kt(f.type, !1)), f
            case 11:
              return (f = kt(f.type.render, !1)), f
            case 1:
              return (f = kt(f.type, !0)), f
            default:
              return ""
          }
        }
        function nr(f, h) {
          if (f && f.defaultProps) {
            ;(h = s({}, h)), (f = f.defaultProps)
            for (var _ in f) h[_] === void 0 && (h[_] = f[_])
            return h
          }
          return h
        }
        var pc = en(null),
          ra = null,
          zs = null,
          rf = null
        function Wi() {
          rf = zs = ra = null
        }
        function sa(f, h, _) {
          Ge
            ? (Yt(pc, h._currentValue), (h._currentValue = _))
            : (Yt(pc, h._currentValue2), (h._currentValue2 = _))
        }
        function mc(f) {
          var h = pc.current
          Tt(pc), Ge ? (f._currentValue = h) : (f._currentValue2 = h)
        }
        function oa(f, h, _) {
          for (; f !== null; ) {
            var T = f.alternate
            if (
              ((f.childLanes & h) !== h
                ? ((f.childLanes |= h), T !== null && (T.childLanes |= h))
                : T !== null && (T.childLanes & h) !== h && (T.childLanes |= h),
              f === _)
            )
              break
            f = f.return
          }
        }
        function ol(f, h) {
          ;(ra = f),
            (rf = zs = null),
            (f = f.dependencies),
            f !== null &&
              f.firstContext !== null &&
              ((f.lanes & h) !== 0 && (pi = !0), (f.firstContext = null))
        }
        function ir(f) {
          var h = Ge ? f._currentValue : f._currentValue2
          if (rf !== f)
            if (((f = { context: f, memoizedValue: h, next: null }), zs === null)) {
              if (ra === null) throw Error(o(308))
              ;(zs = f), (ra.dependencies = { lanes: 0, firstContext: f })
            } else zs = zs.next = f
          return h
        }
        var Ur = null,
          Or = !1
        function al(f) {
          f.updateQueue = {
            baseState: f.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, interleaved: null, lanes: 0 },
            effects: null,
          }
        }
        function Qd(f, h) {
          ;(f = f.updateQueue),
            h.updateQueue === f &&
              (h.updateQueue = {
                baseState: f.baseState,
                firstBaseUpdate: f.firstBaseUpdate,
                lastBaseUpdate: f.lastBaseUpdate,
                shared: f.shared,
                effects: f.effects,
              })
        }
        function Vs(f, h) {
          return {
            eventTime: f,
            lane: h,
            tag: 0,
            payload: null,
            callback: null,
            next: null,
          }
        }
        function Co(f, h) {
          var _ = f.updateQueue
          _ !== null &&
            ((_ = _.shared),
            $n !== null && (f.mode & 1) !== 0 && (qt & 2) === 0
              ? ((f = _.interleaved),
                f === null
                  ? ((h.next = h), Ur === null ? (Ur = [_]) : Ur.push(_))
                  : ((h.next = f.next), (f.next = h)),
                (_.interleaved = h))
              : ((f = _.pending),
                f === null ? (h.next = h) : ((h.next = f.next), (f.next = h)),
                (_.pending = h)))
        }
        function sf(f, h, _) {
          if (
            ((h = h.updateQueue), h !== null && ((h = h.shared), (_ & 4194240) !== 0))
          ) {
            var T = h.lanes
            ;(T &= f.pendingLanes), (_ |= T), (h.lanes = _), ws(f, _)
          }
        }
        function of(f, h) {
          var _ = f.updateQueue,
            T = f.alternate
          if (T !== null && ((T = T.updateQueue), _ === T)) {
            var P = null,
              F = null
            if (((_ = _.firstBaseUpdate), _ !== null)) {
              do {
                var J = {
                  eventTime: _.eventTime,
                  lane: _.lane,
                  tag: _.tag,
                  payload: _.payload,
                  callback: _.callback,
                  next: null,
                }
                F === null ? (P = F = J) : (F = F.next = J), (_ = _.next)
              } while (_ !== null)
              F === null ? (P = F = h) : (F = F.next = h)
            } else P = F = h
            ;(_ = {
              baseState: T.baseState,
              firstBaseUpdate: P,
              lastBaseUpdate: F,
              shared: T.shared,
              effects: T.effects,
            }),
              (f.updateQueue = _)
            return
          }
          ;(f = _.lastBaseUpdate),
            f === null ? (_.firstBaseUpdate = h) : (f.next = h),
            (_.lastBaseUpdate = h)
        }
        function af(f, h, _, T) {
          var P = f.updateQueue
          Or = !1
          var F = P.firstBaseUpdate,
            J = P.lastBaseUpdate,
            pe = P.shared.pending
          if (pe !== null) {
            P.shared.pending = null
            var ke = pe,
              Ze = ke.next
            ;(ke.next = null), J === null ? (F = Ze) : (J.next = Ze), (J = ke)
            var gt = f.alternate
            gt !== null &&
              ((gt = gt.updateQueue),
              (pe = gt.lastBaseUpdate),
              pe !== J &&
                (pe === null ? (gt.firstBaseUpdate = Ze) : (pe.next = Ze),
                (gt.lastBaseUpdate = ke)))
          }
          if (F !== null) {
            var zt = P.baseState
            ;(J = 0), (gt = Ze = ke = null), (pe = F)
            do {
              var It = pe.lane,
                Kt = pe.eventTime
              if ((T & It) === It) {
                gt !== null &&
                  (gt = gt.next =
                    {
                      eventTime: Kt,
                      lane: 0,
                      tag: pe.tag,
                      payload: pe.payload,
                      callback: pe.callback,
                      next: null,
                    })
                e: {
                  var ht = f,
                    Ei = pe
                  switch (((It = h), (Kt = _), Ei.tag)) {
                    case 1:
                      if (((ht = Ei.payload), typeof ht == "function")) {
                        zt = ht.call(Kt, zt, It)
                        break e
                      }
                      zt = ht
                      break e
                    case 3:
                      ht.flags = (ht.flags & -65537) | 128
                    case 0:
                      if (
                        ((ht = Ei.payload),
                        (It = typeof ht == "function" ? ht.call(Kt, zt, It) : ht),
                        It == null)
                      )
                        break e
                      zt = s({}, zt, It)
                      break e
                    case 2:
                      Or = !0
                  }
                }
                pe.callback !== null &&
                  pe.lane !== 0 &&
                  ((f.flags |= 64),
                  (It = P.effects),
                  It === null ? (P.effects = [pe]) : It.push(pe))
              } else
                (Kt = {
                  eventTime: Kt,
                  lane: It,
                  tag: pe.tag,
                  payload: pe.payload,
                  callback: pe.callback,
                  next: null,
                }),
                  gt === null ? ((Ze = gt = Kt), (ke = zt)) : (gt = gt.next = Kt),
                  (J |= It)
              if (((pe = pe.next), pe === null)) {
                if (((pe = P.shared.pending), pe === null)) break
                ;(It = pe),
                  (pe = It.next),
                  (It.next = null),
                  (P.lastBaseUpdate = It),
                  (P.shared.pending = null)
              }
            } while (!0)
            if (
              (gt === null && (ke = zt),
              (P.baseState = ke),
              (P.firstBaseUpdate = Ze),
              (P.lastBaseUpdate = gt),
              (h = P.shared.interleaved),
              h !== null)
            ) {
              P = h
              do (J |= P.lane), (P = P.next)
              while (P !== h)
            } else F === null && (P.shared.lanes = 0)
            ;(bs |= J), (f.lanes = J), (f.memoizedState = zt)
          }
        }
        function Lm(f, h, _) {
          if (((f = h.effects), (h.effects = null), f !== null))
            for (h = 0; h < f.length; h++) {
              var T = f[h],
                P = T.callback
              if (P !== null) {
                if (((T.callback = null), (T = _), typeof P != "function"))
                  throw Error(o(191, P))
                P.call(T)
              }
            }
        }
        var Dm = new i.Component().refs
        function eh(f, h, _, T) {
          ;(h = f.memoizedState),
            (_ = _(T, h)),
            (_ = _ == null ? h : s({}, h, _)),
            (f.memoizedState = _),
            f.lanes === 0 && (f.updateQueue.baseState = _)
        }
        var lf = {
          isMounted: function (f) {
            return (f = f._reactInternals) ? k(f) === f : !1
          },
          enqueueSetState: function (f, h, _) {
            f = f._reactInternals
            var T = pn(),
              P = ds(f),
              F = Vs(T, P)
            ;(F.payload = h),
              _ != null && (F.callback = _),
              Co(f, F),
              (h = Ni(f, P, T)),
              h !== null && sf(h, f, P)
          },
          enqueueReplaceState: function (f, h, _) {
            f = f._reactInternals
            var T = pn(),
              P = ds(f),
              F = Vs(T, P)
            ;(F.tag = 1),
              (F.payload = h),
              _ != null && (F.callback = _),
              Co(f, F),
              (h = Ni(f, P, T)),
              h !== null && sf(h, f, P)
          },
          enqueueForceUpdate: function (f, h) {
            f = f._reactInternals
            var _ = pn(),
              T = ds(f),
              P = Vs(_, T)
            ;(P.tag = 2),
              h != null && (P.callback = h),
              Co(f, P),
              (h = Ni(f, T, _)),
              h !== null && sf(h, f, T)
          },
        }
        function th(f, h, _, T, P, F, J) {
          return (
            (f = f.stateNode),
            typeof f.shouldComponentUpdate == "function"
              ? f.shouldComponentUpdate(T, F, J)
              : h.prototype && h.prototype.isPureReactComponent
              ? !ss(_, T) || !ss(P, F)
              : !0
          )
        }
        function Nm(f, h, _) {
          var T = !1,
            P = Ft,
            F = h.contextType
          return (
            typeof F == "object" && F !== null
              ? (F = ir(F))
              : ((P = Ln(h) ? tn : dt.current),
                (T = h.contextTypes),
                (F = (T = T != null) ? Yn(f, P) : Ft)),
            (h = new h(_, F)),
            (f.memoizedState = h.state !== null && h.state !== void 0 ? h.state : null),
            (h.updater = lf),
            (f.stateNode = h),
            (h._reactInternals = f),
            T &&
              ((f = f.stateNode),
              (f.__reactInternalMemoizedUnmaskedChildContext = P),
              (f.__reactInternalMemoizedMaskedChildContext = F)),
            h
          )
        }
        function km(f, h, _, T) {
          ;(f = h.state),
            typeof h.componentWillReceiveProps == "function" &&
              h.componentWillReceiveProps(_, T),
            typeof h.UNSAFE_componentWillReceiveProps == "function" &&
              h.UNSAFE_componentWillReceiveProps(_, T),
            h.state !== f && lf.enqueueReplaceState(h, h.state, null)
        }
        function nh(f, h, _, T) {
          var P = f.stateNode
          ;(P.props = _), (P.state = f.memoizedState), (P.refs = Dm), al(f)
          var F = h.contextType
          typeof F == "object" && F !== null
            ? (P.context = ir(F))
            : ((F = Ln(h) ? tn : dt.current), (P.context = Yn(f, F))),
            (P.state = f.memoizedState),
            (F = h.getDerivedStateFromProps),
            typeof F == "function" && (eh(f, h, F, _), (P.state = f.memoizedState)),
            typeof h.getDerivedStateFromProps == "function" ||
              typeof P.getSnapshotBeforeUpdate == "function" ||
              (typeof P.UNSAFE_componentWillMount != "function" &&
                typeof P.componentWillMount != "function") ||
              ((h = P.state),
              typeof P.componentWillMount == "function" && P.componentWillMount(),
              typeof P.UNSAFE_componentWillMount == "function" &&
                P.UNSAFE_componentWillMount(),
              h !== P.state && lf.enqueueReplaceState(P, P.state, null),
              af(f, _, P, T),
              (P.state = f.memoizedState)),
            typeof P.componentDidMount == "function" && (f.flags |= 4194308)
        }
        var ll = [],
          Ro = 0,
          cf = null,
          uf = 0,
          Br = [],
          gr = 0,
          aa = null,
          Hs = 1,
          Gs = ""
        function la(f, h) {
          ;(ll[Ro++] = uf), (ll[Ro++] = cf), (cf = f), (uf = h)
        }
        function Fm(f, h, _) {
          ;(Br[gr++] = Hs), (Br[gr++] = Gs), (Br[gr++] = aa), (aa = f)
          var T = Hs
          f = Gs
          var P = 32 - An(T) - 1
          ;(T &= ~(1 << P)), (_ += 1)
          var F = 32 - An(h) + P
          if (30 < F) {
            var J = P - (P % 5)
            ;(F = (T & ((1 << J) - 1)).toString(32)),
              (T >>= J),
              (P -= J),
              (Hs = (1 << (32 - An(h) + P)) | (_ << P) | T),
              (Gs = F + f)
          } else (Hs = (1 << F) | (_ << P) | T), (Gs = f)
        }
        function ih(f) {
          f.return !== null && (la(f, 1), Fm(f, 1, 0))
        }
        function rh(f) {
          for (; f === cf; )
            (cf = ll[--Ro]), (ll[Ro] = null), (uf = ll[--Ro]), (ll[Ro] = null)
          for (; f === aa; )
            (aa = Br[--gr]),
              (Br[gr] = null),
              (Gs = Br[--gr]),
              (Br[gr] = null),
              (Hs = Br[--gr]),
              (Br[gr] = null)
        }
        var ji = null,
          xi = null,
          Dn = !1,
          cl = !1,
          zr = null
        function sh(f, h) {
          var _ = Mr(5, null, null, 0)
          ;(_.elementType = "DELETED"),
            (_.stateNode = h),
            (_.return = f),
            (h = f.deletions),
            h === null ? ((f.deletions = [_]), (f.flags |= 16)) : h.push(_)
        }
        function oh(f, h) {
          switch (f.tag) {
            case 5:
              return (
                (h = Vi(h, f.type, f.pendingProps)),
                h !== null ? ((f.stateNode = h), (ji = f), (xi = bo(h)), !0) : !1
              )
            case 6:
              return (
                (h = tl(h, f.pendingProps)),
                h !== null ? ((f.stateNode = h), (ji = f), (xi = null), !0) : !1
              )
            case 13:
              if (((h = To(h)), h !== null)) {
                var _ = aa !== null ? { id: Hs, overflow: Gs } : null
                return (
                  (f.memoizedState = {
                    dehydrated: h,
                    treeContext: _,
                    retryLane: 1073741824,
                  }),
                  (_ = Mr(18, null, null, 0)),
                  (_.stateNode = h),
                  (_.return = f),
                  (f.child = _),
                  (ji = f),
                  (xi = null),
                  !0
                )
              }
              return !1
            default:
              return !1
          }
        }
        function ff(f) {
          return (f.mode & 1) !== 0 && (f.flags & 128) === 0
        }
        function Po(f) {
          if (Dn) {
            var h = xi
            if (h) {
              var _ = h
              if (!oh(f, h)) {
                if (ff(f)) throw Error(o(418))
                h = is(_)
                var T = ji
                h && oh(f, h)
                  ? sh(T, _)
                  : ((f.flags = (f.flags & -4097) | 2), (Dn = !1), (ji = f))
              }
            } else {
              if (ff(f)) throw Error(o(418))
              ;(f.flags = (f.flags & -4097) | 2), (Dn = !1), (ji = f)
            }
          }
        }
        function Um(f) {
          for (f = f.return; f !== null && f.tag !== 5 && f.tag !== 3 && f.tag !== 13; )
            f = f.return
          ji = f
        }
        function gc(f) {
          if (!Ee || f !== ji) return !1
          if (!Dn) return Um(f), (Dn = !0), !1
          if (
            f.tag !== 3 &&
            (f.tag !== 5 || (Ce(f.type) && !fe(f.type, f.memoizedProps)))
          ) {
            var h = xi
            if (h) {
              if (ff(f)) {
                for (f = xi; f; ) f = is(f)
                throw Error(o(418))
              }
              for (; h; ) sh(f, h), (h = is(h))
            }
          }
          if ((Um(f), f.tag === 13)) {
            if (!Ee) throw Error(o(316))
            if (((f = f.memoizedState), (f = f !== null ? f.dehydrated : null), !f))
              throw Error(o(317))
            xi = Xu(f)
          } else xi = ji ? is(f.stateNode) : null
          return !0
        }
        function ul() {
          Ee && ((xi = ji = null), (cl = Dn = !1))
        }
        function df(f) {
          zr === null ? (zr = [f]) : zr.push(f)
        }
        function fl(f, h, _) {
          if (
            ((f = _.ref), f !== null && typeof f != "function" && typeof f != "object")
          ) {
            if (_._owner) {
              if (((_ = _._owner), _)) {
                if (_.tag !== 1) throw Error(o(309))
                var T = _.stateNode
              }
              if (!T) throw Error(o(147, f))
              var P = T,
                F = "" + f
              return h !== null &&
                h.ref !== null &&
                typeof h.ref == "function" &&
                h.ref._stringRef === F
                ? h.ref
                : ((h = function (J) {
                    var pe = P.refs
                    pe === Dm && (pe = P.refs = {}),
                      J === null ? delete pe[F] : (pe[F] = J)
                  }),
                  (h._stringRef = F),
                  h)
            }
            if (typeof f != "string") throw Error(o(284))
            if (!_._owner) throw Error(o(290, f))
          }
          return f
        }
        function Io(f, h) {
          throw (
            ((f = Object.prototype.toString.call(h)),
            Error(
              o(
                31,
                f === "[object Object]"
                  ? "object with keys {" + Object.keys(h).join(", ") + "}"
                  : f,
              ),
            ))
          )
        }
        function dl(f) {
          var h = f._init
          return h(f._payload)
        }
        function Om(f) {
          function h(be, ve) {
            if (f) {
              var Le = be.deletions
              Le === null ? ((be.deletions = [ve]), (be.flags |= 16)) : Le.push(ve)
            }
          }
          function _(be, ve) {
            if (!f) return null
            for (; ve !== null; ) h(be, ve), (ve = ve.sibling)
            return null
          }
          function T(be, ve) {
            for (be = new Map(); ve !== null; )
              ve.key !== null ? be.set(ve.key, ve) : be.set(ve.index, ve),
                (ve = ve.sibling)
            return be
          }
          function P(be, ve) {
            return (be = io(be, ve)), (be.index = 0), (be.sibling = null), be
          }
          function F(be, ve, Le) {
            return (
              (be.index = Le),
              f
                ? ((Le = be.alternate),
                  Le !== null
                    ? ((Le = Le.index), Le < ve ? ((be.flags |= 2), ve) : Le)
                    : ((be.flags |= 2), ve))
                : ((be.flags |= 1048576), ve)
            )
          }
          function J(be) {
            return f && be.alternate === null && (be.flags |= 2), be
          }
          function pe(be, ve, Le, ct) {
            return ve === null || ve.tag !== 6
              ? ((ve = Bf(Le, be.mode, ct)), (ve.return = be), ve)
              : ((ve = P(ve, Le)), (ve.return = be), ve)
          }
          function ke(be, ve, Le, ct) {
            var Ct = Le.type
            return Ct === p
              ? gt(be, ve, Le.props.children, ct, Le.key)
              : ve !== null &&
                (ve.elementType === Ct ||
                  (typeof Ct == "object" &&
                    Ct !== null &&
                    Ct.$$typeof === C &&
                    dl(Ct) === ve.type))
              ? ((ct = P(ve, Le.props)),
                (ct.ref = fl(be, ve, Le)),
                (ct.return = be),
                ct)
              : ((ct = Of(Le.type, Le.key, Le.props, null, be.mode, ct)),
                (ct.ref = fl(be, ve, Le)),
                (ct.return = be),
                ct)
          }
          function Ze(be, ve, Le, ct) {
            return ve === null ||
              ve.tag !== 4 ||
              ve.stateNode.containerInfo !== Le.containerInfo ||
              ve.stateNode.implementation !== Le.implementation
              ? ((ve = zf(Le, be.mode, ct)), (ve.return = be), ve)
              : ((ve = P(ve, Le.children || [])), (ve.return = be), ve)
          }
          function gt(be, ve, Le, ct, Ct) {
            return ve === null || ve.tag !== 7
              ? ((ve = Pa(Le, be.mode, ct, Ct)), (ve.return = be), ve)
              : ((ve = P(ve, Le)), (ve.return = be), ve)
          }
          function zt(be, ve, Le) {
            if ((typeof ve == "string" && ve !== "") || typeof ve == "number")
              return (ve = Bf("" + ve, be.mode, Le)), (ve.return = be), ve
            if (typeof ve == "object" && ve !== null) {
              switch (ve.$$typeof) {
                case u:
                  return (
                    (Le = Of(ve.type, ve.key, ve.props, null, be.mode, Le)),
                    (Le.ref = fl(be, null, ve)),
                    (Le.return = be),
                    Le
                  )
                case d:
                  return (ve = zf(ve, be.mode, Le)), (ve.return = be), ve
                case C:
                  var ct = ve._init
                  return zt(be, ct(ve._payload), Le)
              }
              if (ue(ve) || U(ve))
                return (ve = Pa(ve, be.mode, Le, null)), (ve.return = be), ve
              Io(be, ve)
            }
            return null
          }
          function It(be, ve, Le, ct) {
            var Ct = ve !== null ? ve.key : null
            if ((typeof Le == "string" && Le !== "") || typeof Le == "number")
              return Ct !== null ? null : pe(be, ve, "" + Le, ct)
            if (typeof Le == "object" && Le !== null) {
              switch (Le.$$typeof) {
                case u:
                  return Le.key === Ct ? ke(be, ve, Le, ct) : null
                case d:
                  return Le.key === Ct ? Ze(be, ve, Le, ct) : null
                case C:
                  return (Ct = Le._init), It(be, ve, Ct(Le._payload), ct)
              }
              if (ue(Le) || U(Le)) return Ct !== null ? null : gt(be, ve, Le, ct, null)
              Io(be, Le)
            }
            return null
          }
          function Kt(be, ve, Le, ct, Ct) {
            if ((typeof ct == "string" && ct !== "") || typeof ct == "number")
              return (be = be.get(Le) || null), pe(ve, be, "" + ct, Ct)
            if (typeof ct == "object" && ct !== null) {
              switch (ct.$$typeof) {
                case u:
                  return (
                    (be = be.get(ct.key === null ? Le : ct.key) || null),
                    ke(ve, be, ct, Ct)
                  )
                case d:
                  return (
                    (be = be.get(ct.key === null ? Le : ct.key) || null),
                    Ze(ve, be, ct, Ct)
                  )
                case C:
                  var jt = ct._init
                  return Kt(be, ve, Le, jt(ct._payload), Ct)
              }
              if (ue(ct) || U(ct))
                return (be = be.get(Le) || null), gt(ve, be, ct, Ct, null)
              Io(ve, ct)
            }
            return null
          }
          function ht(be, ve, Le, ct) {
            for (
              var Ct = null, jt = null, Vt = ve, un = (ve = 0), ei = null;
              Vt !== null && un < Le.length;
              un++
            ) {
              Vt.index > un ? ((ei = Vt), (Vt = null)) : (ei = Vt.sibling)
              var ln = It(be, Vt, Le[un], ct)
              if (ln === null) {
                Vt === null && (Vt = ei)
                break
              }
              f && Vt && ln.alternate === null && h(be, Vt),
                (ve = F(ln, ve, un)),
                jt === null ? (Ct = ln) : (jt.sibling = ln),
                (jt = ln),
                (Vt = ei)
            }
            if (un === Le.length) return _(be, Vt), Dn && la(be, un), Ct
            if (Vt === null) {
              for (; un < Le.length; un++)
                (Vt = zt(be, Le[un], ct)),
                  Vt !== null &&
                    ((ve = F(Vt, ve, un)),
                    jt === null ? (Ct = Vt) : (jt.sibling = Vt),
                    (jt = Vt))
              return Dn && la(be, un), Ct
            }
            for (Vt = T(be, Vt); un < Le.length; un++)
              (ei = Kt(Vt, be, un, Le[un], ct)),
                ei !== null &&
                  (f &&
                    ei.alternate !== null &&
                    Vt.delete(ei.key === null ? un : ei.key),
                  (ve = F(ei, ve, un)),
                  jt === null ? (Ct = ei) : (jt.sibling = ei),
                  (jt = ei))
            return (
              f &&
                Vt.forEach(function (ro) {
                  return h(be, ro)
                }),
              Dn && la(be, un),
              Ct
            )
          }
          function Ei(be, ve, Le, ct) {
            var Ct = U(Le)
            if (typeof Ct != "function") throw Error(o(150))
            if (((Le = Ct.call(Le)), Le == null)) throw Error(o(151))
            for (
              var jt = (Ct = null), Vt = ve, un = (ve = 0), ei = null, ln = Le.next();
              Vt !== null && !ln.done;
              un++, ln = Le.next()
            ) {
              Vt.index > un ? ((ei = Vt), (Vt = null)) : (ei = Vt.sibling)
              var ro = It(be, Vt, ln.value, ct)
              if (ro === null) {
                Vt === null && (Vt = ei)
                break
              }
              f && Vt && ro.alternate === null && h(be, Vt),
                (ve = F(ro, ve, un)),
                jt === null ? (Ct = ro) : (jt.sibling = ro),
                (jt = ro),
                (Vt = ei)
            }
            if (ln.done) return _(be, Vt), Dn && la(be, un), Ct
            if (Vt === null) {
              for (; !ln.done; un++, ln = Le.next())
                (ln = zt(be, ln.value, ct)),
                  ln !== null &&
                    ((ve = F(ln, ve, un)),
                    jt === null ? (Ct = ln) : (jt.sibling = ln),
                    (jt = ln))
              return Dn && la(be, un), Ct
            }
            for (Vt = T(be, Vt); !ln.done; un++, ln = Le.next())
              (ln = Kt(Vt, be, un, ln.value, ct)),
                ln !== null &&
                  (f &&
                    ln.alternate !== null &&
                    Vt.delete(ln.key === null ? un : ln.key),
                  (ve = F(ln, ve, un)),
                  jt === null ? (Ct = ln) : (jt.sibling = ln),
                  (jt = ln))
            return (
              f &&
                Vt.forEach(function (Uh) {
                  return h(be, Uh)
                }),
              Dn && la(be, un),
              Ct
            )
          }
          function Er(be, ve, Le, ct) {
            if (
              (typeof Le == "object" &&
                Le !== null &&
                Le.type === p &&
                Le.key === null &&
                (Le = Le.props.children),
              typeof Le == "object" && Le !== null)
            ) {
              switch (Le.$$typeof) {
                case u:
                  e: {
                    for (var Ct = Le.key, jt = ve; jt !== null; ) {
                      if (jt.key === Ct) {
                        if (((Ct = Le.type), Ct === p)) {
                          if (jt.tag === 7) {
                            _(be, jt.sibling),
                              (ve = P(jt, Le.props.children)),
                              (ve.return = be),
                              (be = ve)
                            break e
                          }
                        } else if (
                          jt.elementType === Ct ||
                          (typeof Ct == "object" &&
                            Ct !== null &&
                            Ct.$$typeof === C &&
                            dl(Ct) === jt.type)
                        ) {
                          _(be, jt.sibling),
                            (ve = P(jt, Le.props)),
                            (ve.ref = fl(be, jt, Le)),
                            (ve.return = be),
                            (be = ve)
                          break e
                        }
                        _(be, jt)
                        break
                      } else h(be, jt)
                      jt = jt.sibling
                    }
                    Le.type === p
                      ? ((ve = Pa(Le.props.children, be.mode, ct, Le.key)),
                        (ve.return = be),
                        (be = ve))
                      : ((ct = Of(Le.type, Le.key, Le.props, null, be.mode, ct)),
                        (ct.ref = fl(be, ve, Le)),
                        (ct.return = be),
                        (be = ct))
                  }
                  return J(be)
                case d:
                  e: {
                    for (jt = Le.key; ve !== null; ) {
                      if (ve.key === jt)
                        if (
                          ve.tag === 4 &&
                          ve.stateNode.containerInfo === Le.containerInfo &&
                          ve.stateNode.implementation === Le.implementation
                        ) {
                          _(be, ve.sibling),
                            (ve = P(ve, Le.children || [])),
                            (ve.return = be),
                            (be = ve)
                          break e
                        } else {
                          _(be, ve)
                          break
                        }
                      else h(be, ve)
                      ve = ve.sibling
                    }
                    ;(ve = zf(Le, be.mode, ct)), (ve.return = be), (be = ve)
                  }
                  return J(be)
                case C:
                  return (jt = Le._init), Er(be, ve, jt(Le._payload), ct)
              }
              if (ue(Le)) return ht(be, ve, Le, ct)
              if (U(Le)) return Ei(be, ve, Le, ct)
              Io(be, Le)
            }
            return (typeof Le == "string" && Le !== "") || typeof Le == "number"
              ? ((Le = "" + Le),
                ve !== null && ve.tag === 6
                  ? (_(be, ve.sibling), (ve = P(ve, Le)), (ve.return = be), (be = ve))
                  : (_(be, ve),
                    (ve = Bf(Le, be.mode, ct)),
                    (ve.return = be),
                    (be = ve)),
                J(be))
              : _(be, ve)
          }
          return Er
        }
        var Ws = Om(!0),
          Bm = Om(!1),
          hl = {},
          rr = en(hl),
          ca = en(hl),
          ua = en(hl)
        function os(f) {
          if (f === hl) throw Error(o(174))
          return f
        }
        function hf(f, h) {
          Yt(ua, h), Yt(ca, f), Yt(rr, hl), (f = se(h)), Tt(rr), Yt(rr, f)
        }
        function pl() {
          Tt(rr), Tt(ca), Tt(ua)
        }
        function zm(f) {
          var h = os(ua.current),
            _ = os(rr.current)
          ;(h = G(_, f.type, h)), _ !== h && (Yt(ca, f), Yt(rr, h))
        }
        function ah(f) {
          ca.current === f && (Tt(rr), Tt(ca))
        }
        var Un = en(0)
        function pf(f) {
          for (var h = f; h !== null; ) {
            if (h.tag === 13) {
              var _ = h.memoizedState
              if (_ !== null && ((_ = _.dehydrated), _ === null || ys(_) || ns(_)))
                return h
            } else if (h.tag === 19 && h.memoizedProps.revealOrder !== void 0) {
              if ((h.flags & 128) !== 0) return h
            } else if (h.child !== null) {
              ;(h.child.return = h), (h = h.child)
              continue
            }
            if (h === f) break
            for (; h.sibling === null; ) {
              if (h.return === null || h.return === f) return null
              h = h.return
            }
            ;(h.sibling.return = h.return), (h = h.sibling)
          }
          return null
        }
        var vr = []
        function fa() {
          for (var f = 0; f < vr.length; f++) {
            var h = vr[f]
            Ge
              ? (h._workInProgressVersionPrimary = null)
              : (h._workInProgressVersionSecondary = null)
          }
          vr.length = 0
        }
        var vc = l.ReactCurrentDispatcher,
          yr = l.ReactCurrentBatchConfig,
          da = 0,
          On = null,
          fi = null,
          di = null,
          mf = !1,
          Ms = !1,
          ha = 0,
          yc = 0
        function hi() {
          throw Error(o(321))
        }
        function gf(f, h) {
          if (h === null) return !1
          for (var _ = 0; _ < h.length && _ < f.length; _++)
            if (!Gi(f[_], h[_])) return !1
          return !0
        }
        function ml(f, h, _, T, P, F) {
          if (
            ((da = F),
            (On = h),
            (h.memoizedState = null),
            (h.updateQueue = null),
            (h.lanes = 0),
            (vc.current = f === null || f.memoizedState === null ? hh : ph),
            (f = _(T, P)),
            Ms)
          ) {
            F = 0
            do {
              if (((Ms = !1), (ha = 0), 25 <= F)) throw Error(o(301))
              ;(F += 1),
                (di = fi = null),
                (h.updateQueue = null),
                (vc.current = mh),
                (f = _(T, P))
            } while (Ms)
          }
          if (
            ((vc.current = xl),
            (h = fi !== null && fi.next !== null),
            (da = 0),
            (di = fi = On = null),
            (mf = !1),
            h)
          )
            throw Error(o(300))
          return f
        }
        function Lo() {
          var f = ha !== 0
          return (ha = 0), f
        }
        function as() {
          var f = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          }
          return di === null ? (On.memoizedState = di = f) : (di = di.next = f), di
        }
        function ls() {
          if (fi === null) {
            var f = On.alternate
            f = f !== null ? f.memoizedState : null
          } else f = fi.next
          var h = di === null ? On.memoizedState : di.next
          if (h !== null) (di = h), (fi = f)
          else {
            if (f === null) throw Error(o(310))
            ;(fi = f),
              (f = {
                memoizedState: fi.memoizedState,
                baseState: fi.baseState,
                baseQueue: fi.baseQueue,
                queue: fi.queue,
                next: null,
              }),
              di === null ? (On.memoizedState = di = f) : (di = di.next = f)
          }
          return di
        }
        function Es(f, h) {
          return typeof h == "function" ? h(f) : h
        }
        function xc(f) {
          var h = ls(),
            _ = h.queue
          if (_ === null) throw Error(o(311))
          _.lastRenderedReducer = f
          var T = fi,
            P = T.baseQueue,
            F = _.pending
          if (F !== null) {
            if (P !== null) {
              var J = P.next
              ;(P.next = F.next), (F.next = J)
            }
            ;(T.baseQueue = P = F), (_.pending = null)
          }
          if (P !== null) {
            ;(F = P.next), (T = T.baseState)
            var pe = (J = null),
              ke = null,
              Ze = F
            do {
              var gt = Ze.lane
              if ((da & gt) === gt)
                ke !== null &&
                  (ke = ke.next =
                    {
                      lane: 0,
                      action: Ze.action,
                      hasEagerState: Ze.hasEagerState,
                      eagerState: Ze.eagerState,
                      next: null,
                    }),
                  (T = Ze.hasEagerState ? Ze.eagerState : f(T, Ze.action))
              else {
                var zt = {
                  lane: gt,
                  action: Ze.action,
                  hasEagerState: Ze.hasEagerState,
                  eagerState: Ze.eagerState,
                  next: null,
                }
                ke === null ? ((pe = ke = zt), (J = T)) : (ke = ke.next = zt),
                  (On.lanes |= gt),
                  (bs |= gt)
              }
              Ze = Ze.next
            } while (Ze !== null && Ze !== F)
            ke === null ? (J = T) : (ke.next = pe),
              Gi(T, h.memoizedState) || (pi = !0),
              (h.memoizedState = T),
              (h.baseState = J),
              (h.baseQueue = ke),
              (_.lastRenderedState = T)
          }
          if (((f = _.interleaved), f !== null)) {
            P = f
            do (F = P.lane), (On.lanes |= F), (bs |= F), (P = P.next)
            while (P !== f)
          } else P === null && (_.lanes = 0)
          return [h.memoizedState, _.dispatch]
        }
        function _c(f) {
          var h = ls(),
            _ = h.queue
          if (_ === null) throw Error(o(311))
          _.lastRenderedReducer = f
          var T = _.dispatch,
            P = _.pending,
            F = h.memoizedState
          if (P !== null) {
            _.pending = null
            var J = (P = P.next)
            do (F = f(F, J.action)), (J = J.next)
            while (J !== P)
            Gi(F, h.memoizedState) || (pi = !0),
              (h.memoizedState = F),
              h.baseQueue === null && (h.baseState = F),
              (_.lastRenderedState = F)
          }
          return [F, T]
        }
        function lh() {}
        function ch(f, h) {
          var _ = On,
            T = ls(),
            P = h(),
            F = !Gi(T.memoizedState, P)
          if (
            (F && ((T.memoizedState = P), (pi = !0)),
            (T = T.queue),
            gl(js.bind(null, _, T, f), [f]),
            T.getSnapshot !== h || F || (di !== null && di.memoizedState.tag & 1))
          ) {
            if (
              ((_.flags |= 2048),
              Sc(9, fh.bind(null, _, T, P, h), void 0, null),
              $n === null)
            )
              throw Error(o(349))
            ;(da & 30) !== 0 || uh(_, h, P)
          }
          return P
        }
        function uh(f, h, _) {
          ;(f.flags |= 16384),
            (f = { getSnapshot: h, value: _ }),
            (h = On.updateQueue),
            h === null
              ? ((h = { lastEffect: null, stores: null }),
                (On.updateQueue = h),
                (h.stores = [f]))
              : ((_ = h.stores), _ === null ? (h.stores = [f]) : _.push(f))
        }
        function fh(f, h, _, T) {
          ;(h.value = _), (h.getSnapshot = T), vf(h) && Ni(f, 1, -1)
        }
        function js(f, h, _) {
          return _(function () {
            vf(h) && Ni(f, 1, -1)
          })
        }
        function vf(f) {
          var h = f.getSnapshot
          f = f.value
          try {
            var _ = h()
            return !Gi(f, _)
          } catch {
            return !0
          }
        }
        function wc(f) {
          var h = as()
          return (
            typeof f == "function" && (f = f()),
            (h.memoizedState = h.baseState = f),
            (f = {
              pending: null,
              interleaved: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: Es,
              lastRenderedState: f,
            }),
            (h.queue = f),
            (f = f.dispatch = Ey.bind(null, On, f)),
            [h.memoizedState, f]
          )
        }
        function Sc(f, h, _, T) {
          return (
            (f = { tag: f, create: h, destroy: _, deps: T, next: null }),
            (h = On.updateQueue),
            h === null
              ? ((h = { lastEffect: null, stores: null }),
                (On.updateQueue = h),
                (h.lastEffect = f.next = f))
              : ((_ = h.lastEffect),
                _ === null
                  ? (h.lastEffect = f.next = f)
                  : ((T = _.next), (_.next = f), (f.next = T), (h.lastEffect = f))),
            f
          )
        }
        function Vm() {
          return ls().memoizedState
        }
        function Do(f, h, _, T) {
          var P = as()
          ;(On.flags |= f),
            (P.memoizedState = Sc(1 | h, _, void 0, T === void 0 ? null : T))
        }
        function yf(f, h, _, T) {
          var P = ls()
          T = T === void 0 ? null : T
          var F = void 0
          if (fi !== null) {
            var J = fi.memoizedState
            if (((F = J.destroy), T !== null && gf(T, J.deps))) {
              P.memoizedState = Sc(h, _, F, T)
              return
            }
          }
          ;(On.flags |= f), (P.memoizedState = Sc(1 | h, _, F, T))
        }
        function xf(f, h) {
          return Do(8390656, 8, f, h)
        }
        function gl(f, h) {
          return yf(2048, 8, f, h)
        }
        function Mn(f, h) {
          return yf(4, 2, f, h)
        }
        function _f(f, h) {
          return yf(4, 4, f, h)
        }
        function Mc(f, h) {
          if (typeof h == "function")
            return (
              (f = f()),
              h(f),
              function () {
                h(null)
              }
            )
          if (h != null)
            return (
              (f = f()),
              (h.current = f),
              function () {
                h.current = null
              }
            )
        }
        function vl(f, h, _) {
          return (
            (_ = _ != null ? _.concat([f]) : null), yf(4, 4, Mc.bind(null, h, f), _)
          )
        }
        function wf() {}
        function Sf(f, h) {
          var _ = ls()
          h = h === void 0 ? null : h
          var T = _.memoizedState
          return T !== null && h !== null && gf(h, T[1])
            ? T[0]
            : ((_.memoizedState = [f, h]), f)
        }
        function yl(f, h) {
          var _ = ls()
          h = h === void 0 ? null : h
          var T = _.memoizedState
          return T !== null && h !== null && gf(h, T[1])
            ? T[0]
            : ((f = f()), (_.memoizedState = [f, h]), f)
        }
        function Mf(f, h) {
          var _ = Jt
          ;(Jt = _ !== 0 && 4 > _ ? _ : 4), f(!0)
          var T = yr.transition
          yr.transition = {}
          try {
            f(!1), h()
          } finally {
            ;(Jt = _), (yr.transition = T)
          }
        }
        function pa() {
          return ls().memoizedState
        }
        function Hm(f, h, _) {
          var T = ds(f)
          ;(_ = {
            lane: T,
            action: _,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            Gm(f)
              ? dh(h, _)
              : (Ec(f, h, _), (_ = pn()), (f = Ni(f, T, _)), f !== null && Tc(f, h, T))
        }
        function Ey(f, h, _) {
          var T = ds(f),
            P = { lane: T, action: _, hasEagerState: !1, eagerState: null, next: null }
          if (Gm(f)) dh(h, P)
          else {
            Ec(f, h, P)
            var F = f.alternate
            if (
              f.lanes === 0 &&
              (F === null || F.lanes === 0) &&
              ((F = h.lastRenderedReducer), F !== null)
            )
              try {
                var J = h.lastRenderedState,
                  pe = F(J, _)
                if (((P.hasEagerState = !0), (P.eagerState = pe), Gi(pe, J))) return
              } catch {
              } finally {
              }
            ;(_ = pn()), (f = Ni(f, T, _)), f !== null && Tc(f, h, T)
          }
        }
        function Gm(f) {
          var h = f.alternate
          return f === On || (h !== null && h === On)
        }
        function dh(f, h) {
          Ms = mf = !0
          var _ = f.pending
          _ === null ? (h.next = h) : ((h.next = _.next), (_.next = h)), (f.pending = h)
        }
        function Ec(f, h, _) {
          $n !== null && (f.mode & 1) !== 0 && (qt & 2) === 0
            ? ((f = h.interleaved),
              f === null
                ? ((_.next = _), Ur === null ? (Ur = [h]) : Ur.push(h))
                : ((_.next = f.next), (f.next = _)),
              (h.interleaved = _))
            : ((f = h.pending),
              f === null ? (_.next = _) : ((_.next = f.next), (f.next = _)),
              (h.pending = _))
        }
        function Tc(f, h, _) {
          if ((_ & 4194240) !== 0) {
            var T = h.lanes
            ;(T &= f.pendingLanes), (_ |= T), (h.lanes = _), ws(f, _)
          }
        }
        var xl = {
            readContext: ir,
            useCallback: hi,
            useContext: hi,
            useEffect: hi,
            useImperativeHandle: hi,
            useInsertionEffect: hi,
            useLayoutEffect: hi,
            useMemo: hi,
            useReducer: hi,
            useRef: hi,
            useState: hi,
            useDebugValue: hi,
            useDeferredValue: hi,
            useTransition: hi,
            useMutableSource: hi,
            useSyncExternalStore: hi,
            useId: hi,
            unstable_isNewReconciler: !1,
          },
          hh = {
            readContext: ir,
            useCallback: function (f, h) {
              return (as().memoizedState = [f, h === void 0 ? null : h]), f
            },
            useContext: ir,
            useEffect: xf,
            useImperativeHandle: function (f, h, _) {
              return (
                (_ = _ != null ? _.concat([f]) : null),
                Do(4194308, 4, Mc.bind(null, h, f), _)
              )
            },
            useLayoutEffect: function (f, h) {
              return Do(4194308, 4, f, h)
            },
            useInsertionEffect: function (f, h) {
              return Do(4, 2, f, h)
            },
            useMemo: function (f, h) {
              var _ = as()
              return (
                (h = h === void 0 ? null : h), (f = f()), (_.memoizedState = [f, h]), f
              )
            },
            useReducer: function (f, h, _) {
              var T = as()
              return (
                (h = _ !== void 0 ? _(h) : h),
                (T.memoizedState = T.baseState = h),
                (f = {
                  pending: null,
                  interleaved: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: f,
                  lastRenderedState: h,
                }),
                (T.queue = f),
                (f = f.dispatch = Hm.bind(null, On, f)),
                [T.memoizedState, f]
              )
            },
            useRef: function (f) {
              var h = as()
              return (f = { current: f }), (h.memoizedState = f)
            },
            useState: wc,
            useDebugValue: wf,
            useDeferredValue: function (f) {
              var h = wc(f),
                _ = h[0],
                T = h[1]
              return (
                xf(
                  function () {
                    var P = yr.transition
                    yr.transition = {}
                    try {
                      T(f)
                    } finally {
                      yr.transition = P
                    }
                  },
                  [f],
                ),
                _
              )
            },
            useTransition: function () {
              var f = wc(!1),
                h = f[0]
              return (f = Mf.bind(null, f[1])), (as().memoizedState = f), [h, f]
            },
            useMutableSource: function () {},
            useSyncExternalStore: function (f, h, _) {
              var T = On,
                P = as()
              if (Dn) {
                if (_ === void 0) throw Error(o(407))
                _ = _()
              } else {
                if (((_ = h()), $n === null)) throw Error(o(349))
                ;(da & 30) !== 0 || uh(T, h, _)
              }
              P.memoizedState = _
              var F = { value: _, getSnapshot: h }
              return (
                (P.queue = F),
                xf(js.bind(null, T, F, f), [f]),
                (T.flags |= 2048),
                Sc(9, fh.bind(null, T, F, _, h), void 0, null),
                _
              )
            },
            useId: function () {
              var f = as(),
                h = $n.identifierPrefix
              if (Dn) {
                var _ = Gs,
                  T = Hs
                ;(_ = (T & ~(1 << (32 - An(T) - 1))).toString(32) + _),
                  (h = ":" + h + "R" + _),
                  (_ = ha++),
                  0 < _ && (h += "H" + _.toString(32)),
                  (h += ":")
              } else (_ = yc++), (h = ":" + h + "r" + _.toString(32) + ":")
              return (f.memoizedState = h)
            },
            unstable_isNewReconciler: !1,
          },
          ph = {
            readContext: ir,
            useCallback: Sf,
            useContext: ir,
            useEffect: gl,
            useImperativeHandle: vl,
            useInsertionEffect: Mn,
            useLayoutEffect: _f,
            useMemo: yl,
            useReducer: xc,
            useRef: Vm,
            useState: function () {
              return xc(Es)
            },
            useDebugValue: wf,
            useDeferredValue: function (f) {
              var h = xc(Es),
                _ = h[0],
                T = h[1]
              return (
                gl(
                  function () {
                    var P = yr.transition
                    yr.transition = {}
                    try {
                      T(f)
                    } finally {
                      yr.transition = P
                    }
                  },
                  [f],
                ),
                _
              )
            },
            useTransition: function () {
              var f = xc(Es)[0],
                h = ls().memoizedState
              return [f, h]
            },
            useMutableSource: lh,
            useSyncExternalStore: ch,
            useId: pa,
            unstable_isNewReconciler: !1,
          },
          mh = {
            readContext: ir,
            useCallback: Sf,
            useContext: ir,
            useEffect: gl,
            useImperativeHandle: vl,
            useInsertionEffect: Mn,
            useLayoutEffect: _f,
            useMemo: yl,
            useReducer: _c,
            useRef: Vm,
            useState: function () {
              return _c(Es)
            },
            useDebugValue: wf,
            useDeferredValue: function (f) {
              var h = _c(Es),
                _ = h[0],
                T = h[1]
              return (
                gl(
                  function () {
                    var P = yr.transition
                    yr.transition = {}
                    try {
                      T(f)
                    } finally {
                      yr.transition = P
                    }
                  },
                  [f],
                ),
                _
              )
            },
            useTransition: function () {
              var f = _c(Es)[0],
                h = ls().memoizedState
              return [f, h]
            },
            useMutableSource: lh,
            useSyncExternalStore: ch,
            useId: pa,
            unstable_isNewReconciler: !1,
          }
        function gh(f, h) {
          try {
            var _ = "",
              T = h
            do (_ += Jd(T)), (T = T.return)
            while (T)
            var P = _
          } catch (F) {
            P =
              `
Error generating stack: ` +
              F.message +
              `
` +
              F.stack
          }
          return { value: f, source: h, stack: P }
        }
        function Ef(f, h) {
          try {
            console.error(h.value)
          } catch (_) {
            setTimeout(function () {
              throw _
            })
          }
        }
        var Ty = typeof WeakMap == "function" ? WeakMap : Map
        function Wm(f, h, _) {
          ;(_ = Vs(-1, _)), (_.tag = 3), (_.payload = { element: null })
          var T = h.value
          return (
            (_.callback = function () {
              Tl || ((Tl = !0), (Rn = T)), Ef(f, h)
            }),
            _
          )
        }
        function Tf(f, h, _) {
          ;(_ = Vs(-1, _)), (_.tag = 3)
          var T = f.type.getDerivedStateFromError
          if (typeof T == "function") {
            var P = h.value
            ;(_.payload = function () {
              return T(P)
            }),
              (_.callback = function () {
                Ef(f, h)
              })
          }
          var F = f.stateNode
          return (
            F !== null &&
              typeof F.componentDidCatch == "function" &&
              (_.callback = function () {
                Ef(f, h),
                  typeof T != "function" &&
                    (fs === null ? (fs = new Set([this])) : fs.add(this))
                var J = h.stack
                this.componentDidCatch(h.value, { componentStack: J !== null ? J : "" })
              }),
            _
          )
        }
        function Xs(f, h, _) {
          var T = f.pingCache
          if (T === null) {
            T = f.pingCache = new Ty()
            var P = new Set()
            T.set(h, P)
          } else (P = T.get(h)), P === void 0 && ((P = new Set()), T.set(h, P))
          P.has(_) || (P.add(_), (f = Nh.bind(null, f, h, _)), h.then(f, f))
        }
        function vh(f) {
          do {
            var h
            if (
              ((h = f.tag === 13) &&
                ((h = f.memoizedState), (h = h !== null ? h.dehydrated !== null : !0)),
              h)
            )
              return f
            f = f.return
          } while (f !== null)
          return null
        }
        function ma(f, h, _, T, P) {
          return (f.mode & 1) === 0
            ? (f === h
                ? (f.flags |= 65536)
                : ((f.flags |= 128),
                  (_.flags |= 131072),
                  (_.flags &= -52805),
                  _.tag === 1 &&
                    (_.alternate === null
                      ? (_.tag = 17)
                      : ((h = Vs(-1, 1)), (h.tag = 2), Co(_, h))),
                  (_.lanes |= 1)),
              f)
            : ((f.flags |= 65536), (f.lanes = P), f)
        }
        function oi(f) {
          f.flags |= 4
        }
        function _l(f, h) {
          if (f !== null && f.child === h.child) return !0
          if ((h.flags & 16) !== 0) return !1
          for (f = h.child; f !== null; ) {
            if ((f.flags & 12854) !== 0 || (f.subtreeFlags & 12854) !== 0) return !1
            f = f.sibling
          }
          return !0
        }
        var xr, ga, bf, Af
        if (Ue)
          (xr = function (f, h) {
            for (var _ = h.child; _ !== null; ) {
              if (_.tag === 5 || _.tag === 6) ne(f, _.stateNode)
              else if (_.tag !== 4 && _.child !== null) {
                ;(_.child.return = _), (_ = _.child)
                continue
              }
              if (_ === h) break
              for (; _.sibling === null; ) {
                if (_.return === null || _.return === h) return
                _ = _.return
              }
              ;(_.sibling.return = _.return), (_ = _.sibling)
            }
          }),
            (ga = function () {}),
            (bf = function (f, h, _, T, P) {
              if (((f = f.memoizedProps), f !== T)) {
                var F = h.stateNode,
                  J = os(rr.current)
                ;(_ = oe(F, _, f, T, P, J)), (h.updateQueue = _) && oi(h)
              }
            }),
            (Af = function (f, h, _, T) {
              _ !== T && oi(h)
            })
        else if (ae) {
          xr = function (f, h, _, T) {
            for (var P = h.child; P !== null; ) {
              if (P.tag === 5) {
                var F = P.stateNode
                _ && T && (F = an(F, P.type, P.memoizedProps, P)), ne(f, F)
              } else if (P.tag === 6)
                (F = P.stateNode), _ && T && (F = zi(F, P.memoizedProps, P)), ne(f, F)
              else if (P.tag !== 4) {
                if (P.tag === 22 && P.memoizedState !== null)
                  (F = P.child), F !== null && (F.return = P), xr(f, P, !0, !0)
                else if (P.child !== null) {
                  ;(P.child.return = P), (P = P.child)
                  continue
                }
              }
              if (P === h) break
              for (; P.sibling === null; ) {
                if (P.return === null || P.return === h) return
                P = P.return
              }
              ;(P.sibling.return = P.return), (P = P.sibling)
            }
          }
          var No = function (f, h, _, T) {
            for (var P = h.child; P !== null; ) {
              if (P.tag === 5) {
                var F = P.stateNode
                _ && T && (F = an(F, P.type, P.memoizedProps, P)), Ut(f, F)
              } else if (P.tag === 6)
                (F = P.stateNode), _ && T && (F = zi(F, P.memoizedProps, P)), Ut(f, F)
              else if (P.tag !== 4) {
                if (P.tag === 22 && P.memoizedState !== null)
                  (F = P.child), F !== null && (F.return = P), No(f, P, !0, !0)
                else if (P.child !== null) {
                  ;(P.child.return = P), (P = P.child)
                  continue
                }
              }
              if (P === h) break
              for (; P.sibling === null; ) {
                if (P.return === null || P.return === h) return
                P = P.return
              }
              ;(P.sibling.return = P.return), (P = P.sibling)
            }
          }
          ;(ga = function (f, h) {
            var _ = h.stateNode
            if (!_l(f, h)) {
              f = _.containerInfo
              var T = at(f)
              No(T, h, !1, !1), (_.pendingChildren = T), oi(h), vn(f, T)
            }
          }),
            (bf = function (f, h, _, T, P) {
              var F = f.stateNode,
                J = f.memoizedProps
              if ((f = _l(f, h)) && J === T) h.stateNode = F
              else {
                var pe = h.stateNode,
                  ke = os(rr.current),
                  Ze = null
                J !== T && (Ze = oe(pe, _, J, T, P, ke)),
                  f && Ze === null
                    ? (h.stateNode = F)
                    : ((F = lt(F, Ze, _, J, T, h, f, pe)),
                      ye(F, _, T, P, ke) && oi(h),
                      (h.stateNode = F),
                      f ? oi(h) : xr(F, h, !1, !1))
              }
            }),
            (Af = function (f, h, _, T) {
              _ !== T
                ? ((f = os(ua.current)),
                  (_ = os(rr.current)),
                  (h.stateNode = we(T, f, _, h)),
                  oi(h))
                : (h.stateNode = f.stateNode)
            })
        } else (ga = function () {}), (bf = function () {}), (Af = function () {})
        function Ys(f, h) {
          if (!Dn)
            switch (f.tailMode) {
              case "hidden":
                h = f.tail
                for (var _ = null; h !== null; )
                  h.alternate !== null && (_ = h), (h = h.sibling)
                _ === null ? (f.tail = null) : (_.sibling = null)
                break
              case "collapsed":
                _ = f.tail
                for (var T = null; _ !== null; )
                  _.alternate !== null && (T = _), (_ = _.sibling)
                T === null
                  ? h || f.tail === null
                    ? (f.tail = null)
                    : (f.tail.sibling = null)
                  : (T.sibling = null)
            }
        }
        function qn(f) {
          var h = f.alternate !== null && f.alternate.child === f.child,
            _ = 0,
            T = 0
          if (h)
            for (var P = f.child; P !== null; )
              (_ |= P.lanes | P.childLanes),
                (T |= P.subtreeFlags & 14680064),
                (T |= P.flags & 14680064),
                (P.return = f),
                (P = P.sibling)
          else
            for (P = f.child; P !== null; )
              (_ |= P.lanes | P.childLanes),
                (T |= P.subtreeFlags),
                (T |= P.flags),
                (P.return = f),
                (P = P.sibling)
          return (f.subtreeFlags |= T), (f.childLanes = _), h
        }
        function Cf(f, h, _) {
          var T = h.pendingProps
          switch ((rh(h), h.tag)) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return qn(h), null
            case 1:
              return Ln(h.type) && Hn(), qn(h), null
            case 3:
              return (
                (T = h.stateNode),
                pl(),
                Tt(In),
                Tt(dt),
                fa(),
                T.pendingContext &&
                  ((T.context = T.pendingContext), (T.pendingContext = null)),
                (f === null || f.child === null) &&
                  (gc(h)
                    ? oi(h)
                    : f === null ||
                      (f.memoizedState.isDehydrated && (h.flags & 256) === 0) ||
                      ((h.flags |= 1024), zr !== null && (Oc(zr), (zr = null)))),
                ga(f, h),
                qn(h),
                null
              )
            case 5:
              ah(h), (_ = os(ua.current))
              var P = h.type
              if (f !== null && h.stateNode != null)
                bf(f, h, P, T, _),
                  f.ref !== h.ref && ((h.flags |= 512), (h.flags |= 2097152))
              else {
                if (!T) {
                  if (h.stateNode === null) throw Error(o(166))
                  return qn(h), null
                }
                if (((f = os(rr.current)), gc(h))) {
                  if (!Ee) throw Error(o(175))
                  ;(f = Wu(h.stateNode, h.type, h.memoizedProps, _, f, h, !cl)),
                    (h.updateQueue = f),
                    f !== null && oi(h)
                } else {
                  var F = W(P, T, _, f, h)
                  xr(F, h, !1, !1), (h.stateNode = F), ye(F, P, T, _, f) && oi(h)
                }
                h.ref !== null && ((h.flags |= 512), (h.flags |= 2097152))
              }
              return qn(h), null
            case 6:
              if (f && h.stateNode != null) Af(f, h, f.memoizedProps, T)
              else {
                if (typeof T != "string" && h.stateNode === null) throw Error(o(166))
                if (((f = os(ua.current)), (_ = os(rr.current)), gc(h))) {
                  if (!Ee) throw Error(o(176))
                  if (
                    ((f = h.stateNode),
                    (T = h.memoizedProps),
                    (_ = xs(f, T, h, !cl)) && ((P = ji), P !== null))
                  )
                    switch (((F = (P.mode & 1) !== 0), P.tag)) {
                      case 3:
                        xe(P.stateNode.containerInfo, f, T, F)
                        break
                      case 5:
                        Qe(P.type, P.memoizedProps, P.stateNode, f, T, F)
                    }
                  _ && oi(h)
                } else h.stateNode = we(T, f, _, h)
              }
              return qn(h), null
            case 13:
              if (
                (Tt(Un),
                (T = h.memoizedState),
                Dn && xi !== null && (h.mode & 1) !== 0 && (h.flags & 128) === 0)
              ) {
                for (f = xi; f; ) f = is(f)
                return ul(), (h.flags |= 98560), h
              }
              if (T !== null && T.dehydrated !== null) {
                if (((T = gc(h)), f === null)) {
                  if (!T) throw Error(o(318))
                  if (!Ee) throw Error(o(344))
                  if (
                    ((f = h.memoizedState), (f = f !== null ? f.dehydrated : null), !f)
                  )
                    throw Error(o(317))
                  ju(f, h)
                } else
                  ul(),
                    (h.flags & 128) === 0 && (h.memoizedState = null),
                    (h.flags |= 4)
                return qn(h), null
              }
              return (
                zr !== null && (Oc(zr), (zr = null)),
                (h.flags & 128) !== 0
                  ? ((h.lanes = _), h)
                  : ((T = T !== null),
                    (_ = !1),
                    f === null ? gc(h) : (_ = f.memoizedState !== null),
                    T &&
                      !_ &&
                      ((h.child.flags |= 8192),
                      (h.mode & 1) !== 0 &&
                        (f === null || (Un.current & 1) !== 0
                          ? Wn === 0 && (Wn = 3)
                          : kf())),
                    h.updateQueue !== null && (h.flags |= 4),
                    qn(h),
                    null)
              )
            case 4:
              return (
                pl(), ga(f, h), f === null && Ke(h.stateNode.containerInfo), qn(h), null
              )
            case 10:
              return mc(h.type._context), qn(h), null
            case 17:
              return Ln(h.type) && Hn(), qn(h), null
            case 19:
              if ((Tt(Un), (P = h.memoizedState), P === null)) return qn(h), null
              if (((T = (h.flags & 128) !== 0), (F = P.rendering), F === null))
                if (T) Ys(P, !1)
                else {
                  if (Wn !== 0 || (f !== null && (f.flags & 128) !== 0))
                    for (f = h.child; f !== null; ) {
                      if (((F = pf(f)), F !== null)) {
                        for (
                          h.flags |= 128,
                            Ys(P, !1),
                            f = F.updateQueue,
                            f !== null && ((h.updateQueue = f), (h.flags |= 4)),
                            h.subtreeFlags = 0,
                            f = _,
                            T = h.child;
                          T !== null;

                        )
                          (_ = T),
                            (P = f),
                            (_.flags &= 14680066),
                            (F = _.alternate),
                            F === null
                              ? ((_.childLanes = 0),
                                (_.lanes = P),
                                (_.child = null),
                                (_.subtreeFlags = 0),
                                (_.memoizedProps = null),
                                (_.memoizedState = null),
                                (_.updateQueue = null),
                                (_.dependencies = null),
                                (_.stateNode = null))
                              : ((_.childLanes = F.childLanes),
                                (_.lanes = F.lanes),
                                (_.child = F.child),
                                (_.subtreeFlags = 0),
                                (_.deletions = null),
                                (_.memoizedProps = F.memoizedProps),
                                (_.memoizedState = F.memoizedState),
                                (_.updateQueue = F.updateQueue),
                                (_.type = F.type),
                                (P = F.dependencies),
                                (_.dependencies =
                                  P === null
                                    ? null
                                    : {
                                        lanes: P.lanes,
                                        firstContext: P.firstContext,
                                      })),
                            (T = T.sibling)
                        return Yt(Un, (Un.current & 1) | 2), h.child
                      }
                      f = f.sibling
                    }
                  P.tail !== null &&
                    si() > Uo &&
                    ((h.flags |= 128), (T = !0), Ys(P, !1), (h.lanes = 4194304))
                }
              else {
                if (!T)
                  if (((f = pf(F)), f !== null)) {
                    if (
                      ((h.flags |= 128),
                      (T = !0),
                      (f = f.updateQueue),
                      f !== null && ((h.updateQueue = f), (h.flags |= 4)),
                      Ys(P, !0),
                      P.tail === null && P.tailMode === "hidden" && !F.alternate && !Dn)
                    )
                      return qn(h), null
                  } else
                    2 * si() - P.renderingStartTime > Uo &&
                      _ !== 1073741824 &&
                      ((h.flags |= 128), (T = !0), Ys(P, !1), (h.lanes = 4194304))
                P.isBackwards
                  ? ((F.sibling = h.child), (h.child = F))
                  : ((f = P.last),
                    f !== null ? (f.sibling = F) : (h.child = F),
                    (P.last = F))
              }
              return P.tail !== null
                ? ((h = P.tail),
                  (P.rendering = h),
                  (P.tail = h.sibling),
                  (P.renderingStartTime = si()),
                  (h.sibling = null),
                  (f = Un.current),
                  Yt(Un, T ? (f & 1) | 2 : f & 1),
                  h)
                : (qn(h), null)
            case 22:
            case 23:
              return (
                Bc(),
                (T = h.memoizedState !== null),
                f !== null && (f.memoizedState !== null) !== T && (h.flags |= 8192),
                T && (h.mode & 1) !== 0
                  ? (Di & 1073741824) !== 0 &&
                    (qn(h), Ue && h.subtreeFlags & 6 && (h.flags |= 8192))
                  : qn(h),
                null
              )
            case 24:
              return null
            case 25:
              return null
          }
          throw Error(o(156, h.tag))
        }
        var yh = l.ReactCurrentOwner,
          pi = !1
        function Gn(f, h, _, T) {
          h.child = f === null ? Bm(h, null, _, T) : Ws(h, f.child, _, T)
        }
        function En(f, h, _, T, P) {
          _ = _.render
          var F = h.ref
          return (
            ol(h, P),
            (T = ml(f, h, _, T, F, P)),
            (_ = Lo()),
            f !== null && !pi
              ? ((h.updateQueue = f.updateQueue),
                (h.flags &= -2053),
                (f.lanes &= ~P),
                sr(f, h, P))
              : (Dn && _ && ih(h), (h.flags |= 1), Gn(f, h, T, P), h.child)
          )
        }
        function wn(f, h, _, T, P) {
          if (f === null) {
            var F = _.type
            return typeof F == "function" &&
              !Uf(F) &&
              F.defaultProps === void 0 &&
              _.compare === null &&
              _.defaultProps === void 0
              ? ((h.tag = 15), (h.type = F), qs(f, h, F, T, P))
              : ((f = Of(_.type, null, T, h, h.mode, P)),
                (f.ref = h.ref),
                (f.return = h),
                (h.child = f))
          }
          if (((F = f.child), (f.lanes & P) === 0)) {
            var J = F.memoizedProps
            if (
              ((_ = _.compare), (_ = _ !== null ? _ : ss), _(J, T) && f.ref === h.ref)
            )
              return sr(f, h, P)
          }
          return (
            (h.flags |= 1),
            (f = io(F, T)),
            (f.ref = h.ref),
            (f.return = h),
            (h.child = f)
          )
        }
        function qs(f, h, _, T, P) {
          if (f !== null && ss(f.memoizedProps, T) && f.ref === h.ref)
            if (((pi = !1), (f.lanes & P) !== 0)) (f.flags & 131072) !== 0 && (pi = !0)
            else return (h.lanes = f.lanes), sr(f, h, P)
          return $s(f, h, _, T, P)
        }
        function _i(f, h, _) {
          var T = h.pendingProps,
            P = T.children,
            F = f !== null ? f.memoizedState : null
          if (T.mode === "hidden")
            if ((h.mode & 1) === 0)
              (h.memoizedState = { baseLanes: 0, cachePool: null }),
                Yt(Ta, Di),
                (Di |= _)
            else if ((_ & 1073741824) !== 0)
              (h.memoizedState = { baseLanes: 0, cachePool: null }),
                (T = F !== null ? F.baseLanes : _),
                Yt(Ta, Di),
                (Di |= T)
            else
              return (
                (f = F !== null ? F.baseLanes | _ : _),
                (h.lanes = h.childLanes = 1073741824),
                (h.memoizedState = { baseLanes: f, cachePool: null }),
                (h.updateQueue = null),
                Yt(Ta, Di),
                (Di |= f),
                null
              )
          else
            F !== null ? ((T = F.baseLanes | _), (h.memoizedState = null)) : (T = _),
              Yt(Ta, Di),
              (Di |= T)
          return Gn(f, h, P, _), h.child
        }
        function Xi(f, h) {
          var _ = h.ref
          ;((f === null && _ !== null) || (f !== null && f.ref !== _)) &&
            ((h.flags |= 512), (h.flags |= 2097152))
        }
        function $s(f, h, _, T, P) {
          var F = Ln(_) ? tn : dt.current
          return (
            (F = Yn(h, F)),
            ol(h, P),
            (_ = ml(f, h, _, T, F, P)),
            (T = Lo()),
            f !== null && !pi
              ? ((h.updateQueue = f.updateQueue),
                (h.flags &= -2053),
                (f.lanes &= ~P),
                sr(f, h, P))
              : (Dn && T && ih(h), (h.flags |= 1), Gn(f, h, _, P), h.child)
          )
        }
        function va(f, h, _, T, P) {
          if (Ln(_)) {
            var F = !0
            Hi(h)
          } else F = !1
          if ((ol(h, P), h.stateNode === null))
            f !== null && ((f.alternate = null), (h.alternate = null), (h.flags |= 2)),
              Nm(h, _, T),
              nh(h, _, T, P),
              (T = !0)
          else if (f === null) {
            var J = h.stateNode,
              pe = h.memoizedProps
            J.props = pe
            var ke = J.context,
              Ze = _.contextType
            typeof Ze == "object" && Ze !== null
              ? (Ze = ir(Ze))
              : ((Ze = Ln(_) ? tn : dt.current), (Ze = Yn(h, Ze)))
            var gt = _.getDerivedStateFromProps,
              zt =
                typeof gt == "function" ||
                typeof J.getSnapshotBeforeUpdate == "function"
            zt ||
              (typeof J.UNSAFE_componentWillReceiveProps != "function" &&
                typeof J.componentWillReceiveProps != "function") ||
              ((pe !== T || ke !== Ze) && km(h, J, T, Ze)),
              (Or = !1)
            var It = h.memoizedState
            ;(J.state = It),
              af(h, T, J, P),
              (ke = h.memoizedState),
              pe !== T || It !== ke || In.current || Or
                ? (typeof gt == "function" && (eh(h, _, gt, T), (ke = h.memoizedState)),
                  (pe = Or || th(h, _, pe, T, It, ke, Ze))
                    ? (zt ||
                        (typeof J.UNSAFE_componentWillMount != "function" &&
                          typeof J.componentWillMount != "function") ||
                        (typeof J.componentWillMount == "function" &&
                          J.componentWillMount(),
                        typeof J.UNSAFE_componentWillMount == "function" &&
                          J.UNSAFE_componentWillMount()),
                      typeof J.componentDidMount == "function" && (h.flags |= 4194308))
                    : (typeof J.componentDidMount == "function" && (h.flags |= 4194308),
                      (h.memoizedProps = T),
                      (h.memoizedState = ke)),
                  (J.props = T),
                  (J.state = ke),
                  (J.context = Ze),
                  (T = pe))
                : (typeof J.componentDidMount == "function" && (h.flags |= 4194308),
                  (T = !1))
          } else {
            ;(J = h.stateNode),
              Qd(f, h),
              (pe = h.memoizedProps),
              (Ze = h.type === h.elementType ? pe : nr(h.type, pe)),
              (J.props = Ze),
              (zt = h.pendingProps),
              (It = J.context),
              (ke = _.contextType),
              typeof ke == "object" && ke !== null
                ? (ke = ir(ke))
                : ((ke = Ln(_) ? tn : dt.current), (ke = Yn(h, ke)))
            var Kt = _.getDerivedStateFromProps
            ;(gt =
              typeof Kt == "function" ||
              typeof J.getSnapshotBeforeUpdate == "function") ||
              (typeof J.UNSAFE_componentWillReceiveProps != "function" &&
                typeof J.componentWillReceiveProps != "function") ||
              ((pe !== zt || It !== ke) && km(h, J, T, ke)),
              (Or = !1),
              (It = h.memoizedState),
              (J.state = It),
              af(h, T, J, P)
            var ht = h.memoizedState
            pe !== zt || It !== ht || In.current || Or
              ? (typeof Kt == "function" && (eh(h, _, Kt, T), (ht = h.memoizedState)),
                (Ze = Or || th(h, _, Ze, T, It, ht, ke) || !1)
                  ? (gt ||
                      (typeof J.UNSAFE_componentWillUpdate != "function" &&
                        typeof J.componentWillUpdate != "function") ||
                      (typeof J.componentWillUpdate == "function" &&
                        J.componentWillUpdate(T, ht, ke),
                      typeof J.UNSAFE_componentWillUpdate == "function" &&
                        J.UNSAFE_componentWillUpdate(T, ht, ke)),
                    typeof J.componentDidUpdate == "function" && (h.flags |= 4),
                    typeof J.getSnapshotBeforeUpdate == "function" && (h.flags |= 1024))
                  : (typeof J.componentDidUpdate != "function" ||
                      (pe === f.memoizedProps && It === f.memoizedState) ||
                      (h.flags |= 4),
                    typeof J.getSnapshotBeforeUpdate != "function" ||
                      (pe === f.memoizedProps && It === f.memoizedState) ||
                      (h.flags |= 1024),
                    (h.memoizedProps = T),
                    (h.memoizedState = ht)),
                (J.props = T),
                (J.state = ht),
                (J.context = ke),
                (T = Ze))
              : (typeof J.componentDidUpdate != "function" ||
                  (pe === f.memoizedProps && It === f.memoizedState) ||
                  (h.flags |= 4),
                typeof J.getSnapshotBeforeUpdate != "function" ||
                  (pe === f.memoizedProps && It === f.memoizedState) ||
                  (h.flags |= 1024),
                (T = !1))
          }
          return Li(f, h, _, T, F, P)
        }
        function Li(f, h, _, T, P, F) {
          Xi(f, h)
          var J = (h.flags & 128) !== 0
          if (!T && !J) return P && _s(h, _, !1), sr(f, h, F)
          ;(T = h.stateNode), (yh.current = h)
          var pe =
            J && typeof _.getDerivedStateFromError != "function" ? null : T.render()
          return (
            (h.flags |= 1),
            f !== null && J
              ? ((h.child = Ws(h, f.child, null, F)), (h.child = Ws(h, null, pe, F)))
              : Gn(f, h, pe, F),
            (h.memoizedState = T.state),
            P && _s(h, _, !0),
            h.child
          )
        }
        function bc(f) {
          var h = f.stateNode
          h.pendingContext
            ? rs(f, h.pendingContext, h.pendingContext !== h.context)
            : h.context && rs(f, h.context, !1),
            hf(f, h.containerInfo)
        }
        function xh(f, h, _, T, P) {
          return ul(), df(P), (h.flags |= 256), Gn(f, h, _, T), h.child
        }
        var Ac = { dehydrated: null, treeContext: null, retryLane: 0 }
        function ya(f) {
          return { baseLanes: f, cachePool: null }
        }
        function _h(f, h, _) {
          var T = h.pendingProps,
            P = Un.current,
            F = !1,
            J = (h.flags & 128) !== 0,
            pe
          if (
            ((pe = J) ||
              (pe = f !== null && f.memoizedState === null ? !1 : (P & 2) !== 0),
            pe
              ? ((F = !0), (h.flags &= -129))
              : (f === null || f.memoizedState !== null) && (P |= 1),
            Yt(Un, P & 1),
            f === null)
          )
            return (
              Po(h),
              (f = h.memoizedState),
              f !== null && ((f = f.dehydrated), f !== null)
                ? ((h.mode & 1) === 0
                    ? (h.lanes = 1)
                    : ns(f)
                    ? (h.lanes = 8)
                    : (h.lanes = 1073741824),
                  null)
                : ((P = T.children),
                  (f = T.fallback),
                  F
                    ? ((T = h.mode),
                      (F = h.child),
                      (P = { mode: "hidden", children: P }),
                      (T & 1) === 0 && F !== null
                        ? ((F.childLanes = 0), (F.pendingProps = P))
                        : (F = Hc(P, T, 0, null)),
                      (f = Pa(f, T, _, null)),
                      (F.return = h),
                      (f.return = h),
                      (F.sibling = f),
                      (h.child = F),
                      (h.child.memoizedState = ya(_)),
                      (h.memoizedState = Ac),
                      f)
                    : cs(h, P))
            )
          if (((P = f.memoizedState), P !== null)) {
            if (((pe = P.dehydrated), pe !== null)) {
              if (J)
                return h.flags & 256
                  ? ((h.flags &= -257), Rc(f, h, _, Error(o(422))))
                  : h.memoizedState !== null
                  ? ((h.child = f.child), (h.flags |= 128), null)
                  : ((F = T.fallback),
                    (P = h.mode),
                    (T = Hc({ mode: "visible", children: T.children }, P, 0, null)),
                    (F = Pa(F, P, _, null)),
                    (F.flags |= 2),
                    (T.return = h),
                    (F.return = h),
                    (T.sibling = F),
                    (h.child = T),
                    (h.mode & 1) !== 0 && Ws(h, f.child, null, _),
                    (h.child.memoizedState = ya(_)),
                    (h.memoizedState = Ac),
                    F)
              if ((h.mode & 1) === 0) h = Rc(f, h, _, null)
              else if (ns(pe)) h = Rc(f, h, _, Error(o(419)))
              else if (((T = (_ & f.childLanes) !== 0), pi || T)) {
                if (((T = $n), T !== null)) {
                  switch (_ & -_) {
                    case 4:
                      F = 2
                      break
                    case 16:
                      F = 8
                      break
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                      F = 32
                      break
                    case 536870912:
                      F = 268435456
                      break
                    default:
                      F = 0
                  }
                  ;(T = (F & (T.suspendedLanes | _)) !== 0 ? 0 : F),
                    T !== 0 && T !== P.retryLane && ((P.retryLane = T), Ni(f, T, -1))
                }
                kf(), (h = Rc(f, h, _, Error(o(421))))
              } else
                ys(pe)
                  ? ((h.flags |= 128),
                    (h.child = f.child),
                    (h = $m.bind(null, f)),
                    ea(pe, h),
                    (h = null))
                  : ((_ = P.treeContext),
                    Ee &&
                      ((xi = nl(pe)),
                      (ji = h),
                      (Dn = !0),
                      (zr = null),
                      (cl = !1),
                      _ !== null &&
                        ((Br[gr++] = Hs),
                        (Br[gr++] = Gs),
                        (Br[gr++] = aa),
                        (Hs = _.id),
                        (Gs = _.overflow),
                        (aa = h))),
                    (h = cs(h, h.pendingProps.children)),
                    (h.flags |= 4096))
              return h
            }
            return F
              ? ((T = Rf(f, h, T.children, T.fallback, _)),
                (F = h.child),
                (P = f.child.memoizedState),
                (F.memoizedState =
                  P === null ? ya(_) : { baseLanes: P.baseLanes | _, cachePool: null }),
                (F.childLanes = f.childLanes & ~_),
                (h.memoizedState = Ac),
                T)
              : ((_ = Cc(f, h, T.children, _)), (h.memoizedState = null), _)
          }
          return F
            ? ((T = Rf(f, h, T.children, T.fallback, _)),
              (F = h.child),
              (P = f.child.memoizedState),
              (F.memoizedState =
                P === null ? ya(_) : { baseLanes: P.baseLanes | _, cachePool: null }),
              (F.childLanes = f.childLanes & ~_),
              (h.memoizedState = Ac),
              T)
            : ((_ = Cc(f, h, T.children, _)), (h.memoizedState = null), _)
        }
        function cs(f, h) {
          return (
            (h = Hc({ mode: "visible", children: h }, f.mode, 0, null)),
            (h.return = f),
            (f.child = h)
          )
        }
        function Cc(f, h, _, T) {
          var P = f.child
          return (
            (f = P.sibling),
            (_ = io(P, { mode: "visible", children: _ })),
            (h.mode & 1) === 0 && (_.lanes = T),
            (_.return = h),
            (_.sibling = null),
            f !== null &&
              ((T = h.deletions),
              T === null ? ((h.deletions = [f]), (h.flags |= 16)) : T.push(f)),
            (h.child = _)
          )
        }
        function Rf(f, h, _, T, P) {
          var F = h.mode
          f = f.child
          var J = f.sibling,
            pe = { mode: "hidden", children: _ }
          return (
            (F & 1) === 0 && h.child !== f
              ? ((_ = h.child),
                (_.childLanes = 0),
                (_.pendingProps = pe),
                (h.deletions = null))
              : ((_ = io(f, pe)), (_.subtreeFlags = f.subtreeFlags & 14680064)),
            J !== null ? (T = io(J, T)) : ((T = Pa(T, F, P, null)), (T.flags |= 2)),
            (T.return = h),
            (_.return = h),
            (_.sibling = T),
            (h.child = _),
            T
          )
        }
        function Rc(f, h, _, T) {
          return (
            T !== null && df(T),
            Ws(h, f.child, null, _),
            (f = cs(h, h.pendingProps.children)),
            (f.flags |= 2),
            (h.memoizedState = null),
            f
          )
        }
        function jm(f, h, _) {
          f.lanes |= h
          var T = f.alternate
          T !== null && (T.lanes |= h), oa(f.return, h, _)
        }
        function Ts(f, h, _, T, P) {
          var F = f.memoizedState
          F === null
            ? (f.memoizedState = {
                isBackwards: h,
                rendering: null,
                renderingStartTime: 0,
                last: T,
                tail: _,
                tailMode: P,
              })
            : ((F.isBackwards = h),
              (F.rendering = null),
              (F.renderingStartTime = 0),
              (F.last = T),
              (F.tail = _),
              (F.tailMode = P))
        }
        function xa(f, h, _) {
          var T = h.pendingProps,
            P = T.revealOrder,
            F = T.tail
          if ((Gn(f, h, T.children, _), (T = Un.current), (T & 2) !== 0))
            (T = (T & 1) | 2), (h.flags |= 128)
          else {
            if (f !== null && (f.flags & 128) !== 0)
              e: for (f = h.child; f !== null; ) {
                if (f.tag === 13) f.memoizedState !== null && jm(f, _, h)
                else if (f.tag === 19) jm(f, _, h)
                else if (f.child !== null) {
                  ;(f.child.return = f), (f = f.child)
                  continue
                }
                if (f === h) break e
                for (; f.sibling === null; ) {
                  if (f.return === null || f.return === h) break e
                  f = f.return
                }
                ;(f.sibling.return = f.return), (f = f.sibling)
              }
            T &= 1
          }
          if ((Yt(Un, T), (h.mode & 1) === 0)) h.memoizedState = null
          else
            switch (P) {
              case "forwards":
                for (_ = h.child, P = null; _ !== null; )
                  (f = _.alternate),
                    f !== null && pf(f) === null && (P = _),
                    (_ = _.sibling)
                ;(_ = P),
                  _ === null
                    ? ((P = h.child), (h.child = null))
                    : ((P = _.sibling), (_.sibling = null)),
                  Ts(h, !1, P, _, F)
                break
              case "backwards":
                for (_ = null, P = h.child, h.child = null; P !== null; ) {
                  if (((f = P.alternate), f !== null && pf(f) === null)) {
                    h.child = P
                    break
                  }
                  ;(f = P.sibling), (P.sibling = _), (_ = P), (P = f)
                }
                Ts(h, !0, _, null, F)
                break
              case "together":
                Ts(h, !1, null, null, void 0)
                break
              default:
                h.memoizedState = null
            }
          return h.child
        }
        function sr(f, h, _) {
          if (
            (f !== null && (h.dependencies = f.dependencies),
            (bs |= h.lanes),
            (_ & h.childLanes) === 0)
          )
            return null
          if (f !== null && h.child !== f.child) throw Error(o(153))
          if (h.child !== null) {
            for (
              f = h.child, _ = io(f, f.pendingProps), h.child = _, _.return = h;
              f.sibling !== null;

            )
              (f = f.sibling), (_ = _.sibling = io(f, f.pendingProps)), (_.return = h)
            _.sibling = null
          }
          return h.child
        }
        function Pf(f, h, _) {
          switch (h.tag) {
            case 3:
              bc(h), ul()
              break
            case 5:
              zm(h)
              break
            case 1:
              Ln(h.type) && Hi(h)
              break
            case 4:
              hf(h, h.stateNode.containerInfo)
              break
            case 10:
              sa(h, h.type._context, h.memoizedProps.value)
              break
            case 13:
              var T = h.memoizedState
              if (T !== null)
                return T.dehydrated !== null
                  ? (Yt(Un, Un.current & 1), (h.flags |= 128), null)
                  : (_ & h.child.childLanes) !== 0
                  ? _h(f, h, _)
                  : (Yt(Un, Un.current & 1),
                    (f = sr(f, h, _)),
                    f !== null ? f.sibling : null)
              Yt(Un, Un.current & 1)
              break
            case 19:
              if (((T = (_ & h.childLanes) !== 0), (f.flags & 128) !== 0)) {
                if (T) return xa(f, h, _)
                h.flags |= 128
              }
              var P = h.memoizedState
              if (
                (P !== null &&
                  ((P.rendering = null), (P.tail = null), (P.lastEffect = null)),
                Yt(Un, Un.current),
                T)
              )
                break
              return null
            case 22:
            case 23:
              return (h.lanes = 0), _i(f, h, _)
          }
          return sr(f, h, _)
        }
        function If(f, h) {
          switch ((rh(h), h.tag)) {
            case 1:
              return (
                Ln(h.type) && Hn(),
                (f = h.flags),
                f & 65536 ? ((h.flags = (f & -65537) | 128), h) : null
              )
            case 3:
              return (
                pl(),
                Tt(In),
                Tt(dt),
                fa(),
                (f = h.flags),
                (f & 65536) !== 0 && (f & 128) === 0
                  ? ((h.flags = (f & -65537) | 128), h)
                  : null
              )
            case 5:
              return ah(h), null
            case 13:
              if (
                (Tt(Un), (f = h.memoizedState), f !== null && f.dehydrated !== null)
              ) {
                if (h.alternate === null) throw Error(o(340))
                ul()
              }
              return (
                (f = h.flags), f & 65536 ? ((h.flags = (f & -65537) | 128), h) : null
              )
            case 19:
              return Tt(Un), null
            case 4:
              return pl(), null
            case 10:
              return mc(h.type._context), null
            case 22:
            case 23:
              return Bc(), null
            case 24:
              return null
            default:
              return null
          }
        }
        var Yi = !1,
          mi = !1,
          _a = typeof WeakSet == "function" ? WeakSet : Set,
          nt = null
        function Vr(f, h) {
          var _ = f.ref
          if (_ !== null)
            if (typeof _ == "function")
              try {
                _(null)
              } catch (T) {
                $i(f, h, T)
              }
            else _.current = null
        }
        function Ks(f, h, _) {
          try {
            _()
          } catch (T) {
            $i(f, h, T)
          }
        }
        var wh = !1
        function Sh(f, h) {
          for (ie(f.containerInfo), nt = h; nt !== null; )
            if (((f = nt), (h = f.child), (f.subtreeFlags & 1028) !== 0 && h !== null))
              (h.return = f), (nt = h)
            else
              for (; nt !== null; ) {
                f = nt
                try {
                  var _ = f.alternate
                  if ((f.flags & 1024) !== 0)
                    switch (f.tag) {
                      case 0:
                      case 11:
                      case 15:
                        break
                      case 1:
                        if (_ !== null) {
                          var T = _.memoizedProps,
                            P = _.memoizedState,
                            F = f.stateNode,
                            J = F.getSnapshotBeforeUpdate(
                              f.elementType === f.type ? T : nr(f.type, T),
                              P,
                            )
                          F.__reactInternalSnapshotBeforeUpdate = J
                        }
                        break
                      case 3:
                        Ue && Ve(f.stateNode.containerInfo)
                        break
                      case 5:
                      case 6:
                      case 4:
                      case 17:
                        break
                      default:
                        throw Error(o(163))
                    }
                } catch (pe) {
                  $i(f, f.return, pe)
                }
                if (((h = f.sibling), h !== null)) {
                  ;(h.return = f.return), (nt = h)
                  break
                }
                nt = f.return
              }
          return (_ = wh), (wh = !1), _
        }
        function Zs(f, h, _) {
          var T = h.updateQueue
          if (((T = T !== null ? T.lastEffect : null), T !== null)) {
            var P = (T = T.next)
            do {
              if ((P.tag & f) === f) {
                var F = P.destroy
                ;(P.destroy = void 0), F !== void 0 && Ks(h, _, F)
              }
              P = P.next
            } while (P !== T)
          }
        }
        function wi(f, h) {
          if (
            ((h = h.updateQueue), (h = h !== null ? h.lastEffect : null), h !== null)
          ) {
            var _ = (h = h.next)
            do {
              if ((_.tag & f) === f) {
                var T = _.create
                _.destroy = T()
              }
              _ = _.next
            } while (_ !== h)
          }
        }
        function qi(f) {
          var h = f.ref
          if (h !== null) {
            var _ = f.stateNode
            switch (f.tag) {
              case 5:
                f = re(_)
                break
              default:
                f = _
            }
            typeof h == "function" ? h(f) : (h.current = f)
          }
        }
        function Cn(f, h, _) {
          if (Ss && typeof Ss.onCommitFiberUnmount == "function")
            try {
              Ss.onCommitFiberUnmount(fc, h)
            } catch {}
          switch (h.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              if (
                ((f = h.updateQueue), f !== null && ((f = f.lastEffect), f !== null))
              ) {
                var T = (f = f.next)
                do {
                  var P = T,
                    F = P.destroy
                  ;(P = P.tag),
                    F !== void 0 && ((P & 2) !== 0 || (P & 4) !== 0) && Ks(h, _, F),
                    (T = T.next)
                } while (T !== f)
              }
              break
            case 1:
              if (
                (Vr(h, _),
                (f = h.stateNode),
                typeof f.componentWillUnmount == "function")
              )
                try {
                  ;(f.props = h.memoizedProps),
                    (f.state = h.memoizedState),
                    f.componentWillUnmount()
                } catch (J) {
                  $i(h, _, J)
                }
              break
            case 5:
              Vr(h, _)
              break
            case 4:
              Ue
                ? Th(f, h, _)
                : ae && ae && ((h = h.stateNode.containerInfo), (_ = at(h)), Vn(h, _))
          }
        }
        function Hr(f, h, _) {
          for (var T = h; ; )
            if ((Cn(f, T, _), T.child === null || (Ue && T.tag === 4))) {
              if (T === h) break
              for (; T.sibling === null; ) {
                if (T.return === null || T.return === h) return
                T = T.return
              }
              ;(T.sibling.return = T.return), (T = T.sibling)
            } else (T.child.return = T), (T = T.child)
        }
        function Mh(f) {
          var h = f.alternate
          h !== null && ((f.alternate = null), Mh(h)),
            (f.child = null),
            (f.deletions = null),
            (f.sibling = null),
            f.tag === 5 && ((h = f.stateNode), h !== null && Oe(h)),
            (f.stateNode = null),
            (f.return = null),
            (f.dependencies = null),
            (f.memoizedProps = null),
            (f.memoizedState = null),
            (f.pendingProps = null),
            (f.stateNode = null),
            (f.updateQueue = null)
        }
        function Eh(f) {
          return f.tag === 5 || f.tag === 3 || f.tag === 4
        }
        function Lf(f) {
          e: for (;;) {
            for (; f.sibling === null; ) {
              if (f.return === null || Eh(f.return)) return null
              f = f.return
            }
            for (
              f.sibling.return = f.return, f = f.sibling;
              f.tag !== 5 && f.tag !== 6 && f.tag !== 18;

            ) {
              if (f.flags & 2 || f.child === null || f.tag === 4) continue e
              ;(f.child.return = f), (f = f.child)
            }
            if (!(f.flags & 2)) return f.stateNode
          }
        }
        function Df(f) {
          if (Ue) {
            e: {
              for (var h = f.return; h !== null; ) {
                if (Eh(h)) break e
                h = h.return
              }
              throw Error(o(160))
            }
            var _ = h
            switch (_.tag) {
              case 5:
                ;(h = _.stateNode),
                  _.flags & 32 && (Nt(h), (_.flags &= -33)),
                  (_ = Lf(f)),
                  wl(f, _, h)
                break
              case 3:
              case 4:
                ;(h = _.stateNode.containerInfo), (_ = Lf(f)), Nf(f, _, h)
                break
              default:
                throw Error(o(161))
            }
          }
        }
        function Nf(f, h, _) {
          var T = f.tag
          if (T === 5 || T === 6) (f = f.stateNode), h ? Pt(_, f, h) : it(_, f)
          else if (T !== 4 && ((f = f.child), f !== null))
            for (Nf(f, h, _), f = f.sibling; f !== null; ) Nf(f, h, _), (f = f.sibling)
        }
        function wl(f, h, _) {
          var T = f.tag
          if (T === 5 || T === 6) (f = f.stateNode), h ? At(_, f, h) : tt(_, f)
          else if (T !== 4 && ((f = f.child), f !== null))
            for (wl(f, h, _), f = f.sibling; f !== null; ) wl(f, h, _), (f = f.sibling)
        }
        function Th(f, h, _) {
          for (var T = h, P = !1, F, J; ; ) {
            if (!P) {
              P = T.return
              e: for (;;) {
                if (P === null) throw Error(o(160))
                switch (((F = P.stateNode), P.tag)) {
                  case 5:
                    J = !1
                    break e
                  case 3:
                    ;(F = F.containerInfo), (J = !0)
                    break e
                  case 4:
                    ;(F = F.containerInfo), (J = !0)
                    break e
                }
                P = P.return
              }
              P = !0
            }
            if (T.tag === 5 || T.tag === 6)
              Hr(f, T, _), J ? Wt(F, T.stateNode) : ft(F, T.stateNode)
            else if (T.tag === 18) J ? Ae(F, T.stateNode) : ge(F, T.stateNode)
            else if (T.tag === 4) {
              if (T.child !== null) {
                ;(F = T.stateNode.containerInfo),
                  (J = !0),
                  (T.child.return = T),
                  (T = T.child)
                continue
              }
            } else if ((Cn(f, T, _), T.child !== null)) {
              ;(T.child.return = T), (T = T.child)
              continue
            }
            if (T === h) break
            for (; T.sibling === null; ) {
              if (T.return === null || T.return === h) return
              ;(T = T.return), T.tag === 4 && (P = !1)
            }
            ;(T.sibling.return = T.return), (T = T.sibling)
          }
        }
        function ko(f, h) {
          if (Ue) {
            switch (h.tag) {
              case 0:
              case 11:
              case 14:
              case 15:
                Zs(3, h, h.return), wi(3, h), Zs(5, h, h.return)
                return
              case 1:
                return
              case 5:
                var _ = h.stateNode
                if (_ != null) {
                  var T = h.memoizedProps
                  f = f !== null ? f.memoizedProps : T
                  var P = h.type,
                    F = h.updateQueue
                  ;(h.updateQueue = null), F !== null && Je(_, F, P, f, T, h)
                }
                return
              case 6:
                if (h.stateNode === null) throw Error(o(162))
                ;(_ = h.memoizedProps),
                  Et(h.stateNode, f !== null ? f.memoizedProps : _, _)
                return
              case 3:
                Ee &&
                  f !== null &&
                  f.memoizedState.isDehydrated &&
                  Yu(h.stateNode.containerInfo)
                return
              case 12:
                return
              case 13:
                Sl(h)
                return
              case 19:
                Sl(h)
                return
              case 17:
                return
            }
            throw Error(o(163))
          }
          switch (h.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              Zs(3, h, h.return), wi(3, h), Zs(5, h, h.return)
              return
            case 12:
              return
            case 13:
              Sl(h)
              return
            case 19:
              Sl(h)
              return
            case 3:
              Ee &&
                f !== null &&
                f.memoizedState.isDehydrated &&
                Yu(h.stateNode.containerInfo)
              break
            case 22:
            case 23:
              return
          }
          e: if (ae) {
            switch (h.tag) {
              case 1:
              case 5:
              case 6:
                break e
              case 3:
              case 4:
                ;(h = h.stateNode), Vn(h.containerInfo, h.pendingChildren)
                break e
            }
            throw Error(o(163))
          }
        }
        function Sl(f) {
          var h = f.updateQueue
          if (h !== null) {
            f.updateQueue = null
            var _ = f.stateNode
            _ === null && (_ = f.stateNode = new _a()),
              h.forEach(function (T) {
                var P = Km.bind(null, f, T)
                _.has(T) || (_.add(T), T.then(P, P))
              })
          }
        }
        function by(f, h) {
          for (nt = h; nt !== null; ) {
            h = nt
            var _ = h.deletions
            if (_ !== null)
              for (var T = 0; T < _.length; T++) {
                var P = _[T]
                try {
                  var F = f
                  Ue ? Th(F, P, h) : Hr(F, P, h)
                  var J = P.alternate
                  J !== null && (J.return = null), (P.return = null)
                } catch (Ct) {
                  $i(P, h, Ct)
                }
              }
            if (((_ = h.child), (h.subtreeFlags & 12854) !== 0 && _ !== null))
              (_.return = h), (nt = _)
            else
              for (; nt !== null; ) {
                h = nt
                try {
                  var pe = h.flags
                  if ((pe & 32 && Ue && Nt(h.stateNode), pe & 512)) {
                    var ke = h.alternate
                    if (ke !== null) {
                      var Ze = ke.ref
                      Ze !== null &&
                        (typeof Ze == "function" ? Ze(null) : (Ze.current = null))
                    }
                  }
                  if (pe & 8192)
                    switch (h.tag) {
                      case 13:
                        if (h.memoizedState !== null) {
                          var gt = h.alternate
                          ;(gt === null || gt.memoizedState === null) && (Fc = si())
                        }
                        break
                      case 22:
                        var zt = h.memoizedState !== null,
                          It = h.alternate,
                          Kt = It !== null && It.memoizedState !== null
                        if (((_ = h), Ue)) {
                          e: if (((T = _), (P = zt), (F = null), Ue))
                            for (var ht = T; ; ) {
                              if (ht.tag === 5) {
                                if (F === null) {
                                  F = ht
                                  var Ei = ht.stateNode
                                  P ? dn(Ei) : rt(ht.stateNode, ht.memoizedProps)
                                }
                              } else if (ht.tag === 6) {
                                if (F === null) {
                                  var Er = ht.stateNode
                                  P ? he(Er) : Ne(Er, ht.memoizedProps)
                                }
                              } else if (
                                ((ht.tag !== 22 && ht.tag !== 23) ||
                                  ht.memoizedState === null ||
                                  ht === T) &&
                                ht.child !== null
                              ) {
                                ;(ht.child.return = ht), (ht = ht.child)
                                continue
                              }
                              if (ht === T) break
                              for (; ht.sibling === null; ) {
                                if (ht.return === null || ht.return === T) break e
                                F === ht && (F = null), (ht = ht.return)
                              }
                              F === ht && (F = null),
                                (ht.sibling.return = ht.return),
                                (ht = ht.sibling)
                            }
                        }
                        if (zt && !Kt && (_.mode & 1) !== 0) {
                          nt = _
                          for (var be = _.child; be !== null; ) {
                            for (_ = nt = be; nt !== null; ) {
                              T = nt
                              var ve = T.child
                              switch (T.tag) {
                                case 0:
                                case 11:
                                case 14:
                                case 15:
                                  Zs(4, T, T.return)
                                  break
                                case 1:
                                  Vr(T, T.return)
                                  var Le = T.stateNode
                                  if (typeof Le.componentWillUnmount == "function") {
                                    var ct = T.return
                                    try {
                                      ;(Le.props = T.memoizedProps),
                                        (Le.state = T.memoizedState),
                                        Le.componentWillUnmount()
                                    } catch (Ct) {
                                      $i(T, ct, Ct)
                                    }
                                  }
                                  break
                                case 5:
                                  Vr(T, T.return)
                                  break
                                case 22:
                                  if (T.memoizedState !== null) {
                                    Ah(_)
                                    continue
                                  }
                              }
                              ve !== null ? ((ve.return = T), (nt = ve)) : Ah(_)
                            }
                            be = be.sibling
                          }
                        }
                    }
                  switch (pe & 4102) {
                    case 2:
                      Df(h), (h.flags &= -3)
                      break
                    case 6:
                      Df(h), (h.flags &= -3), ko(h.alternate, h)
                      break
                    case 4096:
                      h.flags &= -4097
                      break
                    case 4100:
                      ;(h.flags &= -4097), ko(h.alternate, h)
                      break
                    case 4:
                      ko(h.alternate, h)
                  }
                } catch (Ct) {
                  $i(h, h.return, Ct)
                }
                if (((_ = h.sibling), _ !== null)) {
                  ;(_.return = h.return), (nt = _)
                  break
                }
                nt = h.return
              }
          }
        }
        function Pc(f, h, _) {
          ;(nt = f), Ic(f)
        }
        function Ic(f, h, _) {
          for (var T = (f.mode & 1) !== 0; nt !== null; ) {
            var P = nt,
              F = P.child
            if (P.tag === 22 && T) {
              var J = P.memoizedState !== null || Yi
              if (!J) {
                var pe = P.alternate,
                  ke = (pe !== null && pe.memoizedState !== null) || mi
                pe = Yi
                var Ze = mi
                if (((Yi = J), (mi = ke) && !Ze))
                  for (nt = P; nt !== null; )
                    (J = nt),
                      (ke = J.child),
                      J.tag === 22 && J.memoizedState !== null
                        ? wa(P)
                        : ke !== null
                        ? ((ke.return = J), (nt = ke))
                        : wa(P)
                for (; F !== null; ) (nt = F), Ic(F), (F = F.sibling)
                ;(nt = P), (Yi = pe), (mi = Ze)
              }
              bh(f)
            } else
              (P.subtreeFlags & 8772) !== 0 && F !== null
                ? ((F.return = P), (nt = F))
                : bh(f)
          }
        }
        function bh(f) {
          for (; nt !== null; ) {
            var h = nt
            if ((h.flags & 8772) !== 0) {
              var _ = h.alternate
              try {
                if ((h.flags & 8772) !== 0)
                  switch (h.tag) {
                    case 0:
                    case 11:
                    case 15:
                      mi || wi(5, h)
                      break
                    case 1:
                      var T = h.stateNode
                      if (h.flags & 4 && !mi)
                        if (_ === null) T.componentDidMount()
                        else {
                          var P =
                            h.elementType === h.type
                              ? _.memoizedProps
                              : nr(h.type, _.memoizedProps)
                          T.componentDidUpdate(
                            P,
                            _.memoizedState,
                            T.__reactInternalSnapshotBeforeUpdate,
                          )
                        }
                      var F = h.updateQueue
                      F !== null && Lm(h, F, T)
                      break
                    case 3:
                      var J = h.updateQueue
                      if (J !== null) {
                        if (((_ = null), h.child !== null))
                          switch (h.child.tag) {
                            case 5:
                              _ = re(h.child.stateNode)
                              break
                            case 1:
                              _ = h.child.stateNode
                          }
                        Lm(h, J, _)
                      }
                      break
                    case 5:
                      var pe = h.stateNode
                      _ === null && h.flags & 4 && je(pe, h.type, h.memoizedProps, h)
                      break
                    case 6:
                      break
                    case 4:
                      break
                    case 12:
                      break
                    case 13:
                      if (Ee && h.memoizedState === null) {
                        var ke = h.alternate
                        if (ke !== null) {
                          var Ze = ke.memoizedState
                          if (Ze !== null) {
                            var gt = Ze.dehydrated
                            gt !== null && X(gt)
                          }
                        }
                      }
                      break
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                      break
                    default:
                      throw Error(o(163))
                  }
                mi || (h.flags & 512 && qi(h))
              } catch (zt) {
                $i(h, h.return, zt)
              }
            }
            if (h === f) {
              nt = null
              break
            }
            if (((_ = h.sibling), _ !== null)) {
              ;(_.return = h.return), (nt = _)
              break
            }
            nt = h.return
          }
        }
        function Ah(f) {
          for (; nt !== null; ) {
            var h = nt
            if (h === f) {
              nt = null
              break
            }
            var _ = h.sibling
            if (_ !== null) {
              ;(_.return = h.return), (nt = _)
              break
            }
            nt = h.return
          }
        }
        function wa(f) {
          for (; nt !== null; ) {
            var h = nt
            try {
              switch (h.tag) {
                case 0:
                case 11:
                case 15:
                  var _ = h.return
                  try {
                    wi(4, h)
                  } catch (ke) {
                    $i(h, _, ke)
                  }
                  break
                case 1:
                  var T = h.stateNode
                  if (typeof T.componentDidMount == "function") {
                    var P = h.return
                    try {
                      T.componentDidMount()
                    } catch (ke) {
                      $i(h, P, ke)
                    }
                  }
                  var F = h.return
                  try {
                    qi(h)
                  } catch (ke) {
                    $i(h, F, ke)
                  }
                  break
                case 5:
                  var J = h.return
                  try {
                    qi(h)
                  } catch (ke) {
                    $i(h, J, ke)
                  }
              }
            } catch (ke) {
              $i(h, h.return, ke)
            }
            if (h === f) {
              nt = null
              break
            }
            var pe = h.sibling
            if (pe !== null) {
              ;(pe.return = h.return), (nt = pe)
              break
            }
            nt = h.return
          }
        }
        var Lc = 0,
          Sa = 1,
          Ma = 2,
          Js = 3,
          Ml = 4
        if (typeof Symbol == "function" && Symbol.for) {
          var Ea = Symbol.for
          ;(Lc = Ea("selector.component")),
            (Sa = Ea("selector.has_pseudo_class")),
            (Ma = Ea("selector.role")),
            (Js = Ea("selector.test_id")),
            (Ml = Ea("selector.text"))
        }
        function Dc(f) {
          var h = K(f)
          if (h != null) {
            if (typeof h.memoizedProps["data-testname"] != "string") throw Error(o(364))
            return h
          }
          if (((f = j(f)), f === null)) throw Error(o(362))
          return f.stateNode.current
        }
        function Nc(f, h) {
          switch (h.$$typeof) {
            case Lc:
              if (f.type === h.value) return !0
              break
            case Sa:
              e: {
                ;(h = h.value), (f = [f, 0])
                for (var _ = 0; _ < f.length; ) {
                  var T = f[_++],
                    P = f[_++],
                    F = h[P]
                  if (T.tag !== 5 || !Me(T)) {
                    for (; F != null && Nc(T, F); ) P++, (F = h[P])
                    if (P === h.length) {
                      h = !0
                      break e
                    } else for (T = T.child; T !== null; ) f.push(T, P), (T = T.sibling)
                  }
                }
                h = !1
              }
              return h
            case Ma:
              if (f.tag === 5 && De(f.stateNode, h.value)) return !0
              break
            case Ml:
              if (
                (f.tag === 5 || f.tag === 6) &&
                ((f = ce(f)), f !== null && 0 <= f.indexOf(h.value))
              )
                return !0
              break
            case Js:
              if (
                f.tag === 5 &&
                ((f = f.memoizedProps["data-testname"]),
                typeof f == "string" && f.toLowerCase() === h.value.toLowerCase())
              )
                return !0
              break
            default:
              throw Error(o(365))
          }
          return !1
        }
        function Fo(f) {
          switch (f.$$typeof) {
            case Lc:
              return "<" + (O(f.value) || "Unknown") + ">"
            case Sa:
              return ":has(" + (Fo(f) || "") + ")"
            case Ma:
              return '[role="' + f.value + '"]'
            case Ml:
              return '"' + f.value + '"'
            case Js:
              return '[data-testname="' + f.value + '"]'
            default:
              throw Error(o(365))
          }
        }
        function _r(f, h) {
          var _ = []
          f = [f, 0]
          for (var T = 0; T < f.length; ) {
            var P = f[T++],
              F = f[T++],
              J = h[F]
            if (P.tag !== 5 || !Me(P)) {
              for (; J != null && Nc(P, J); ) F++, (J = h[F])
              if (F === h.length) _.push(P)
              else for (P = P.child; P !== null; ) f.push(P, F), (P = P.sibling)
            }
          }
          return _
        }
        function Qs(f, h) {
          if (!Se) throw Error(o(363))
          ;(f = Dc(f)), (f = _r(f, h)), (h = []), (f = Array.from(f))
          for (var _ = 0; _ < f.length; ) {
            var T = f[_++]
            if (T.tag === 5) Me(T) || h.push(T.stateNode)
            else for (T = T.child; T !== null; ) f.push(T), (T = T.sibling)
          }
          return h
        }
        var Ch = Math.ceil,
          kc = l.ReactCurrentDispatcher,
          us = l.ReactCurrentOwner,
          xn = l.ReactCurrentBatchConfig,
          qt = 0,
          $n = null,
          _n = null,
          Nn = 0,
          Di = 0,
          Ta = en(0),
          Wn = 0,
          El = null,
          bs = 0,
          wr = 0,
          ba = 0,
          eo = null,
          Qn = null,
          Fc = 0,
          Uo = 1 / 0
        function Aa() {
          Uo = si() + 500
        }
        var Tl = !1,
          Rn = null,
          fs = null,
          bl = !1,
          As = null,
          Ca = 0,
          Ra = 0,
          to = null,
          Tn = -1,
          jn = 0
        function pn() {
          return (qt & 6) !== 0 ? si() : Tn !== -1 ? Tn : (Tn = si())
        }
        function ds(f) {
          return (f.mode & 1) === 0
            ? 1
            : (qt & 2) !== 0 && Nn !== 0
            ? Nn & -Nn
            : Im.transition !== null
            ? (jn === 0 &&
                ((f = il), (il <<= 1), (il & 4194240) === 0 && (il = 64), (jn = f)),
              jn)
            : ((f = Jt), f !== 0 ? f : Be())
        }
        function Ni(f, h, _) {
          if (50 < Ra) throw ((Ra = 0), (to = null), Error(o(185)))
          var T = Oo(f, h)
          return T === null
            ? null
            : (ta(T, h, _),
              ((qt & 2) === 0 || T !== $n) &&
                (T === $n && ((qt & 2) === 0 && (wr |= h), Wn === 4 && Mi(T, Nn)),
                or(T, _),
                h === 1 && qt === 0 && (f.mode & 1) === 0 && (Aa(), ef && Fr())),
              T)
        }
        function Oo(f, h) {
          f.lanes |= h
          var _ = f.alternate
          for (_ !== null && (_.lanes |= h), _ = f, f = f.return; f !== null; )
            (f.childLanes |= h),
              (_ = f.alternate),
              _ !== null && (_.childLanes |= h),
              (_ = f),
              (f = f.return)
          return _.tag === 3 ? _.stateNode : null
        }
        function or(f, h) {
          var _ = f.callbackNode
          Pm(f, h)
          var T = uc(f, f === $n ? Nn : 0)
          if (T === 0)
            _ !== null && sl(_), (f.callbackNode = null), (f.callbackPriority = 0)
          else if (((h = T & -T), f.callbackPriority !== h)) {
            if ((_ != null && sl(_), h === 1))
              f.tag === 0 ? nf(Sr.bind(null, f)) : tf(Sr.bind(null, f)),
                Pe
                  ? He(function () {
                      qt === 0 && Fr()
                    })
                  : na(ia, Fr),
                (_ = null)
            else {
              switch (Bs(T)) {
                case 1:
                  _ = ia
                  break
                case 4:
                  _ = My
                  break
                case 16:
                  _ = Ju
                  break
                case 536870912:
                  _ = Qu
                  break
                default:
                  _ = Ju
              }
              _ = Ff(_, Si.bind(null, f))
            }
            ;(f.callbackPriority = h), (f.callbackNode = _)
          }
        }
        function Si(f, h) {
          if (((Tn = -1), (jn = 0), (qt & 6) !== 0)) throw Error(o(327))
          var _ = f.callbackNode
          if (Cs() && f.callbackNode !== _) return null
          var T = uc(f, f === $n ? Nn : 0)
          if (T === 0) return null
          if ((T & 30) !== 0 || (T & f.expiredLanes) !== 0 || h) h = zc(f, T)
          else {
            h = T
            var P = qt
            qt |= 2
            var F = Ih()
            ;($n !== f || Nn !== h) && (Aa(), no(f, h))
            do
              try {
                Ym()
                break
              } catch (pe) {
                Ph(f, pe)
              }
            while (!0)
            Wi(),
              (kc.current = F),
              (qt = P),
              _n !== null ? (h = 0) : (($n = null), (Nn = 0), (h = Wn))
          }
          if (h !== 0) {
            if (
              (h === 2 && ((P = $u(f)), P !== 0 && ((T = P), (h = Uc(f, P)))), h === 1)
            )
              throw ((_ = El), no(f, 0), Mi(f, T), or(f, si()), _)
            if (h === 6) Mi(f, T)
            else {
              if (
                ((P = f.current.alternate),
                (T & 30) === 0 &&
                  !Rh(P) &&
                  ((h = zc(f, T)),
                  h === 2 && ((F = $u(f)), F !== 0 && ((T = F), (h = Uc(f, F)))),
                  h === 1))
              )
                throw ((_ = El), no(f, 0), Mi(f, T), or(f, si()), _)
              switch (((f.finishedWork = P), (f.finishedLanes = T), h)) {
                case 0:
                case 1:
                  throw Error(o(345))
                case 2:
                  hs(f, Qn)
                  break
                case 3:
                  if (
                    (Mi(f, T), (T & 130023424) === T && ((h = Fc + 500 - si()), 10 < h))
                  ) {
                    if (uc(f, 0) !== 0) break
                    if (((P = f.suspendedLanes), (P & T) !== T)) {
                      pn(), (f.pingedLanes |= f.suspendedLanes & P)
                      break
                    }
                    f.timeoutHandle = me(hs.bind(null, f, Qn), h)
                    break
                  }
                  hs(f, Qn)
                  break
                case 4:
                  if ((Mi(f, T), (T & 4194240) === T)) break
                  for (h = f.eventTimes, P = -1; 0 < T; ) {
                    var J = 31 - An(T)
                    ;(F = 1 << J), (J = h[J]), J > P && (P = J), (T &= ~F)
                  }
                  if (
                    ((T = P),
                    (T = si() - T),
                    (T =
                      (120 > T
                        ? 120
                        : 480 > T
                        ? 480
                        : 1080 > T
                        ? 1080
                        : 1920 > T
                        ? 1920
                        : 3e3 > T
                        ? 3e3
                        : 4320 > T
                        ? 4320
                        : 1960 * Ch(T / 1960)) - T),
                    10 < T)
                  ) {
                    f.timeoutHandle = me(hs.bind(null, f, Qn), T)
                    break
                  }
                  hs(f, Qn)
                  break
                case 5:
                  hs(f, Qn)
                  break
                default:
                  throw Error(o(329))
              }
            }
          }
          return or(f, si()), f.callbackNode === _ ? Si.bind(null, f) : null
        }
        function Uc(f, h) {
          var _ = eo
          return (
            f.current.memoizedState.isDehydrated && (no(f, h).flags |= 256),
            (f = zc(f, h)),
            f !== 2 && ((h = Qn), (Qn = _), h !== null && Oc(h)),
            f
          )
        }
        function Oc(f) {
          Qn === null ? (Qn = f) : Qn.push.apply(Qn, f)
        }
        function Rh(f) {
          for (var h = f; ; ) {
            if (h.flags & 16384) {
              var _ = h.updateQueue
              if (_ !== null && ((_ = _.stores), _ !== null))
                for (var T = 0; T < _.length; T++) {
                  var P = _[T],
                    F = P.getSnapshot
                  P = P.value
                  try {
                    if (!Gi(F(), P)) return !1
                  } catch {
                    return !1
                  }
                }
            }
            if (((_ = h.child), h.subtreeFlags & 16384 && _ !== null))
              (_.return = h), (h = _)
            else {
              if (h === f) break
              for (; h.sibling === null; ) {
                if (h.return === null || h.return === f) return !0
                h = h.return
              }
              ;(h.sibling.return = h.return), (h = h.sibling)
            }
          }
          return !0
        }
        function Mi(f, h) {
          for (
            h &= ~ba,
              h &= ~wr,
              f.suspendedLanes |= h,
              f.pingedLanes &= ~h,
              f = f.expirationTimes;
            0 < h;

          ) {
            var _ = 31 - An(h),
              T = 1 << _
            ;(f[_] = -1), (h &= ~T)
          }
        }
        function Sr(f) {
          if ((qt & 6) !== 0) throw Error(o(327))
          Cs()
          var h = uc(f, 0)
          if ((h & 1) === 0) return or(f, si()), null
          var _ = zc(f, h)
          if (f.tag !== 0 && _ === 2) {
            var T = $u(f)
            T !== 0 && ((h = T), (_ = Uc(f, T)))
          }
          if (_ === 1) throw ((_ = El), no(f, 0), Mi(f, h), or(f, si()), _)
          if (_ === 6) throw Error(o(345))
          return (
            (f.finishedWork = f.current.alternate),
            (f.finishedLanes = h),
            hs(f, Qn),
            or(f, si()),
            null
          )
        }
        function Al(f) {
          As !== null && As.tag === 0 && (qt & 6) === 0 && Cs()
          var h = qt
          qt |= 1
          var _ = xn.transition,
            T = Jt
          try {
            if (((xn.transition = null), (Jt = 1), f)) return f()
          } finally {
            ;(Jt = T), (xn.transition = _), (qt = h), (qt & 6) === 0 && Fr()
          }
        }
        function Bc() {
          ;(Di = Ta.current), Tt(Ta)
        }
        function no(f, h) {
          ;(f.finishedWork = null), (f.finishedLanes = 0)
          var _ = f.timeoutHandle
          if ((_ !== ze && ((f.timeoutHandle = ze), Fe(_)), _n !== null))
            for (_ = _n.return; _ !== null; ) {
              var T = _
              switch ((rh(T), T.tag)) {
                case 1:
                  ;(T = T.type.childContextTypes), T != null && Hn()
                  break
                case 3:
                  pl(), Tt(In), Tt(dt), fa()
                  break
                case 5:
                  ah(T)
                  break
                case 4:
                  pl()
                  break
                case 13:
                  Tt(Un)
                  break
                case 19:
                  Tt(Un)
                  break
                case 10:
                  mc(T.type._context)
                  break
                case 22:
                case 23:
                  Bc()
              }
              _ = _.return
            }
          if (
            (($n = f),
            (_n = f = io(f.current, null)),
            (Nn = Di = h),
            (Wn = 0),
            (El = null),
            (ba = wr = bs = 0),
            (Qn = eo = null),
            Ur !== null)
          ) {
            for (h = 0; h < Ur.length; h++)
              if (((_ = Ur[h]), (T = _.interleaved), T !== null)) {
                _.interleaved = null
                var P = T.next,
                  F = _.pending
                if (F !== null) {
                  var J = F.next
                  ;(F.next = P), (T.next = J)
                }
                _.pending = T
              }
            Ur = null
          }
          return f
        }
        function Ph(f, h) {
          do {
            var _ = _n
            try {
              if ((Wi(), (vc.current = xl), mf)) {
                for (var T = On.memoizedState; T !== null; ) {
                  var P = T.queue
                  P !== null && (P.pending = null), (T = T.next)
                }
                mf = !1
              }
              if (
                ((da = 0),
                (di = fi = On = null),
                (Ms = !1),
                (ha = 0),
                (us.current = null),
                _ === null || _.return === null)
              ) {
                ;(Wn = 1), (El = h), (_n = null)
                break
              }
              e: {
                var F = f,
                  J = _.return,
                  pe = _,
                  ke = h
                if (
                  ((h = Nn),
                  (pe.flags |= 32768),
                  ke !== null && typeof ke == "object" && typeof ke.then == "function")
                ) {
                  var Ze = ke,
                    gt = pe,
                    zt = gt.tag
                  if ((gt.mode & 1) === 0 && (zt === 0 || zt === 11 || zt === 15)) {
                    var It = gt.alternate
                    It
                      ? ((gt.updateQueue = It.updateQueue),
                        (gt.memoizedState = It.memoizedState),
                        (gt.lanes = It.lanes))
                      : ((gt.updateQueue = null), (gt.memoizedState = null))
                  }
                  var Kt = vh(J)
                  if (Kt !== null) {
                    ;(Kt.flags &= -257),
                      ma(Kt, J, pe, F, h),
                      Kt.mode & 1 && Xs(F, Ze, h),
                      (h = Kt),
                      (ke = Ze)
                    var ht = h.updateQueue
                    if (ht === null) {
                      var Ei = new Set()
                      Ei.add(ke), (h.updateQueue = Ei)
                    } else ht.add(ke)
                    break e
                  } else {
                    if ((h & 1) === 0) {
                      Xs(F, Ze, h), kf()
                      break e
                    }
                    ke = Error(o(426))
                  }
                } else if (Dn && pe.mode & 1) {
                  var Er = vh(J)
                  if (Er !== null) {
                    ;(Er.flags & 65536) === 0 && (Er.flags |= 256),
                      ma(Er, J, pe, F, h),
                      df(ke)
                    break e
                  }
                }
                ;(F = ke),
                  Wn !== 4 && (Wn = 2),
                  eo === null ? (eo = [F]) : eo.push(F),
                  (ke = gh(ke, pe)),
                  (pe = J)
                do {
                  switch (pe.tag) {
                    case 3:
                      ;(pe.flags |= 65536), (h &= -h), (pe.lanes |= h)
                      var be = Wm(pe, ke, h)
                      of(pe, be)
                      break e
                    case 1:
                      F = ke
                      var ve = pe.type,
                        Le = pe.stateNode
                      if (
                        (pe.flags & 128) === 0 &&
                        (typeof ve.getDerivedStateFromError == "function" ||
                          (Le !== null &&
                            typeof Le.componentDidCatch == "function" &&
                            (fs === null || !fs.has(Le))))
                      ) {
                        ;(pe.flags |= 65536), (h &= -h), (pe.lanes |= h)
                        var ct = Tf(pe, F, h)
                        of(pe, ct)
                        break e
                      }
                  }
                  pe = pe.return
                } while (pe !== null)
              }
              Dh(_)
            } catch (Ct) {
              ;(h = Ct), _n === _ && _ !== null && (_n = _ = _.return)
              continue
            }
            break
          } while (!0)
        }
        function Ih() {
          var f = kc.current
          return (kc.current = xl), f === null ? xl : f
        }
        function kf() {
          ;(Wn === 0 || Wn === 3 || Wn === 2) && (Wn = 4),
            $n === null ||
              ((bs & 268435455) === 0 && (wr & 268435455) === 0) ||
              Mi($n, Nn)
        }
        function zc(f, h) {
          var _ = qt
          qt |= 2
          var T = Ih()
          ;($n === f && Nn === h) || no(f, h)
          do
            try {
              Xm()
              break
            } catch (P) {
              Ph(f, P)
            }
          while (!0)
          if ((Wi(), (qt = _), (kc.current = T), _n !== null)) throw Error(o(261))
          return ($n = null), (Nn = 0), Wn
        }
        function Xm() {
          for (; _n !== null; ) Lh(_n)
        }
        function Ym() {
          for (; _n !== null && !Ao(); ) Lh(_n)
        }
        function Lh(f) {
          var h = Fh(f.alternate, f, Di)
          ;(f.memoizedProps = f.pendingProps),
            h === null ? Dh(f) : (_n = h),
            (us.current = null)
        }
        function Dh(f) {
          var h = f
          do {
            var _ = h.alternate
            if (((f = h.return), (h.flags & 32768) === 0)) {
              if (((_ = Cf(_, h, Di)), _ !== null)) {
                _n = _
                return
              }
            } else {
              if (((_ = If(_, h)), _ !== null)) {
                ;(_.flags &= 32767), (_n = _)
                return
              }
              if (f !== null)
                (f.flags |= 32768), (f.subtreeFlags = 0), (f.deletions = null)
              else {
                ;(Wn = 6), (_n = null)
                return
              }
            }
            if (((h = h.sibling), h !== null)) {
              _n = h
              return
            }
            _n = h = f
          } while (h !== null)
          Wn === 0 && (Wn = 5)
        }
        function hs(f, h) {
          var _ = Jt,
            T = xn.transition
          try {
            ;(xn.transition = null), (Jt = 1), qm(f, h, _)
          } finally {
            ;(xn.transition = T), (Jt = _)
          }
          return null
        }
        function qm(f, h, _) {
          do Cs()
          while (As !== null)
          if ((qt & 6) !== 0) throw Error(o(327))
          var T = f.finishedWork,
            P = f.finishedLanes
          if (T === null) return null
          if (((f.finishedWork = null), (f.finishedLanes = 0), T === f.current))
            throw Error(o(177))
          ;(f.callbackNode = null), (f.callbackPriority = 0)
          var F = T.lanes | T.childLanes
          if (
            (Zu(f, F),
            f === $n && ((_n = $n = null), (Nn = 0)),
            ((T.subtreeFlags & 2064) === 0 && (T.flags & 2064) === 0) ||
              bl ||
              ((bl = !0),
              Ff(Ju, function () {
                return Cs(), null
              })),
            (F = (T.flags & 15990) !== 0),
            (T.subtreeFlags & 15990) !== 0 || F)
          ) {
            ;(F = xn.transition), (xn.transition = null)
            var J = Jt
            Jt = 1
            var pe = qt
            ;(qt |= 4),
              (us.current = null),
              Sh(f, T),
              by(f, T),
              Q(f.containerInfo),
              (f.current = T),
              Pc(T),
              Sy(),
              (qt = pe),
              (Jt = J),
              (xn.transition = F)
          } else f.current = T
          if (
            (bl && ((bl = !1), (As = f), (Ca = P)),
            (F = f.pendingLanes),
            F === 0 && (fs = null),
            dc(T.stateNode),
            or(f, si()),
            h !== null)
          )
            for (_ = f.onRecoverableError, T = 0; T < h.length; T++) _(h[T])
          if (Tl) throw ((Tl = !1), (f = Rn), (Rn = null), f)
          return (
            (Ca & 1) !== 0 && f.tag !== 0 && Cs(),
            (F = f.pendingLanes),
            (F & 1) !== 0 ? (f === to ? Ra++ : ((Ra = 0), (to = f))) : (Ra = 0),
            Fr(),
            null
          )
        }
        function Cs() {
          if (As !== null) {
            var f = Bs(Ca),
              h = xn.transition,
              _ = Jt
            try {
              if (((xn.transition = null), (Jt = 16 > f ? 16 : f), As === null))
                var T = !1
              else {
                if (((f = As), (As = null), (Ca = 0), (qt & 6) !== 0))
                  throw Error(o(331))
                var P = qt
                for (qt |= 4, nt = f.current; nt !== null; ) {
                  var F = nt,
                    J = F.child
                  if ((nt.flags & 16) !== 0) {
                    var pe = F.deletions
                    if (pe !== null) {
                      for (var ke = 0; ke < pe.length; ke++) {
                        var Ze = pe[ke]
                        for (nt = Ze; nt !== null; ) {
                          var gt = nt
                          switch (gt.tag) {
                            case 0:
                            case 11:
                            case 15:
                              Zs(8, gt, F)
                          }
                          var zt = gt.child
                          if (zt !== null) (zt.return = gt), (nt = zt)
                          else
                            for (; nt !== null; ) {
                              gt = nt
                              var It = gt.sibling,
                                Kt = gt.return
                              if ((Mh(gt), gt === Ze)) {
                                nt = null
                                break
                              }
                              if (It !== null) {
                                ;(It.return = Kt), (nt = It)
                                break
                              }
                              nt = Kt
                            }
                        }
                      }
                      var ht = F.alternate
                      if (ht !== null) {
                        var Ei = ht.child
                        if (Ei !== null) {
                          ht.child = null
                          do {
                            var Er = Ei.sibling
                            ;(Ei.sibling = null), (Ei = Er)
                          } while (Ei !== null)
                        }
                      }
                      nt = F
                    }
                  }
                  if ((F.subtreeFlags & 2064) !== 0 && J !== null)
                    (J.return = F), (nt = J)
                  else
                    e: for (; nt !== null; ) {
                      if (((F = nt), (F.flags & 2048) !== 0))
                        switch (F.tag) {
                          case 0:
                          case 11:
                          case 15:
                            Zs(9, F, F.return)
                        }
                      var be = F.sibling
                      if (be !== null) {
                        ;(be.return = F.return), (nt = be)
                        break e
                      }
                      nt = F.return
                    }
                }
                var ve = f.current
                for (nt = ve; nt !== null; ) {
                  J = nt
                  var Le = J.child
                  if ((J.subtreeFlags & 2064) !== 0 && Le !== null)
                    (Le.return = J), (nt = Le)
                  else
                    e: for (J = ve; nt !== null; ) {
                      if (((pe = nt), (pe.flags & 2048) !== 0))
                        try {
                          switch (pe.tag) {
                            case 0:
                            case 11:
                            case 15:
                              wi(9, pe)
                          }
                        } catch (Ct) {
                          $i(pe, pe.return, Ct)
                        }
                      if (pe === J) {
                        nt = null
                        break e
                      }
                      var ct = pe.sibling
                      if (ct !== null) {
                        ;(ct.return = pe.return), (nt = ct)
                        break e
                      }
                      nt = pe.return
                    }
                }
                if (
                  ((qt = P), Fr(), Ss && typeof Ss.onPostCommitFiberRoot == "function")
                )
                  try {
                    Ss.onPostCommitFiberRoot(fc, f)
                  } catch {}
                T = !0
              }
              return T
            } finally {
              ;(Jt = _), (xn.transition = h)
            }
          }
          return !1
        }
        function Vc(f, h, _) {
          ;(h = gh(_, h)),
            (h = Wm(f, h, 1)),
            Co(f, h),
            (h = pn()),
            (f = Oo(f, 1)),
            f !== null && (ta(f, 1, h), or(f, h))
        }
        function $i(f, h, _) {
          if (f.tag === 3) Vc(f, f, _)
          else
            for (; h !== null; ) {
              if (h.tag === 3) {
                Vc(h, f, _)
                break
              } else if (h.tag === 1) {
                var T = h.stateNode
                if (
                  typeof h.type.getDerivedStateFromError == "function" ||
                  (typeof T.componentDidCatch == "function" &&
                    (fs === null || !fs.has(T)))
                ) {
                  ;(f = gh(_, f)),
                    (f = Tf(h, f, 1)),
                    Co(h, f),
                    (f = pn()),
                    (h = Oo(h, 1)),
                    h !== null && (ta(h, 1, f), or(h, f))
                  break
                }
              }
              h = h.return
            }
        }
        function Nh(f, h, _) {
          var T = f.pingCache
          T !== null && T.delete(h),
            (h = pn()),
            (f.pingedLanes |= f.suspendedLanes & _),
            $n === f &&
              (Nn & _) === _ &&
              (Wn === 4 || (Wn === 3 && (Nn & 130023424) === Nn && 500 > si() - Fc)
                ? no(f, 0)
                : (ba |= _)),
            or(f, h)
        }
        function kh(f, h) {
          h === 0 &&
            ((f.mode & 1) === 0
              ? (h = 1)
              : ((h = hn), (hn <<= 1), (hn & 130023424) === 0 && (hn = 4194304)))
          var _ = pn()
          ;(f = Oo(f, h)), f !== null && (ta(f, h, _), or(f, _))
        }
        function $m(f) {
          var h = f.memoizedState,
            _ = 0
          h !== null && (_ = h.retryLane), kh(f, _)
        }
        function Km(f, h) {
          var _ = 0
          switch (f.tag) {
            case 13:
              var T = f.stateNode,
                P = f.memoizedState
              P !== null && (_ = P.retryLane)
              break
            case 19:
              T = f.stateNode
              break
            default:
              throw Error(o(314))
          }
          T !== null && T.delete(h), kh(f, _)
        }
        var Fh
        Fh = function (f, h, _) {
          if (f !== null)
            if (f.memoizedProps !== h.pendingProps || In.current) pi = !0
            else {
              if ((f.lanes & _) === 0 && (h.flags & 128) === 0)
                return (pi = !1), Pf(f, h, _)
              pi = (f.flags & 131072) !== 0
            }
          else (pi = !1), Dn && (h.flags & 1048576) !== 0 && Fm(h, uf, h.index)
          switch (((h.lanes = 0), h.tag)) {
            case 2:
              var T = h.type
              f !== null &&
                ((f.alternate = null), (h.alternate = null), (h.flags |= 2)),
                (f = h.pendingProps)
              var P = Yn(h, dt.current)
              ol(h, _), (P = ml(null, h, T, f, P, _))
              var F = Lo()
              return (
                (h.flags |= 1),
                typeof P == "object" &&
                P !== null &&
                typeof P.render == "function" &&
                P.$$typeof === void 0
                  ? ((h.tag = 1),
                    (h.memoizedState = null),
                    (h.updateQueue = null),
                    Ln(T) ? ((F = !0), Hi(h)) : (F = !1),
                    (h.memoizedState =
                      P.state !== null && P.state !== void 0 ? P.state : null),
                    al(h),
                    (P.updater = lf),
                    (h.stateNode = P),
                    (P._reactInternals = h),
                    nh(h, T, f, _),
                    (h = Li(null, h, T, !0, F, _)))
                  : ((h.tag = 0), Dn && F && ih(h), Gn(null, h, P, _), (h = h.child)),
                h
              )
            case 16:
              T = h.elementType
              e: {
                switch (
                  (f !== null &&
                    ((f.alternate = null), (h.alternate = null), (h.flags |= 2)),
                  (f = h.pendingProps),
                  (P = T._init),
                  (T = P(T._payload)),
                  (h.type = T),
                  (P = h.tag = Ay(T)),
                  (f = nr(T, f)),
                  P)
                ) {
                  case 0:
                    h = $s(null, h, T, f, _)
                    break e
                  case 1:
                    h = va(null, h, T, f, _)
                    break e
                  case 11:
                    h = En(null, h, T, f, _)
                    break e
                  case 14:
                    h = wn(null, h, T, nr(T.type, f), _)
                    break e
                }
                throw Error(o(306, T, ""))
              }
              return h
            case 0:
              return (
                (T = h.type),
                (P = h.pendingProps),
                (P = h.elementType === T ? P : nr(T, P)),
                $s(f, h, T, P, _)
              )
            case 1:
              return (
                (T = h.type),
                (P = h.pendingProps),
                (P = h.elementType === T ? P : nr(T, P)),
                va(f, h, T, P, _)
              )
            case 3:
              e: {
                if ((bc(h), f === null)) throw Error(o(387))
                ;(T = h.pendingProps),
                  (F = h.memoizedState),
                  (P = F.element),
                  Qd(f, h),
                  af(h, T, null, _)
                var J = h.memoizedState
                if (((T = J.element), Ee && F.isDehydrated))
                  if (
                    ((F = {
                      element: T,
                      isDehydrated: !1,
                      cache: J.cache,
                      transitions: J.transitions,
                    }),
                    (h.updateQueue.baseState = F),
                    (h.memoizedState = F),
                    h.flags & 256)
                  ) {
                    ;(P = Error(o(423))), (h = xh(f, h, T, _, P))
                    break e
                  } else if (T !== P) {
                    ;(P = Error(o(424))), (h = xh(f, h, T, _, P))
                    break e
                  } else
                    for (
                      Ee &&
                        ((xi = Gu(h.stateNode.containerInfo)),
                        (ji = h),
                        (Dn = !0),
                        (zr = null),
                        (cl = !1)),
                        _ = Bm(h, null, T, _),
                        h.child = _;
                      _;

                    )
                      (_.flags = (_.flags & -3) | 4096), (_ = _.sibling)
                else {
                  if ((ul(), T === P)) {
                    h = sr(f, h, _)
                    break e
                  }
                  Gn(f, h, T, _)
                }
                h = h.child
              }
              return h
            case 5:
              return (
                zm(h),
                f === null && Po(h),
                (T = h.type),
                (P = h.pendingProps),
                (F = f !== null ? f.memoizedProps : null),
                (J = P.children),
                fe(T, P) ? (J = null) : F !== null && fe(T, F) && (h.flags |= 32),
                Xi(f, h),
                Gn(f, h, J, _),
                h.child
              )
            case 6:
              return f === null && Po(h), null
            case 13:
              return _h(f, h, _)
            case 4:
              return (
                hf(h, h.stateNode.containerInfo),
                (T = h.pendingProps),
                f === null ? (h.child = Ws(h, null, T, _)) : Gn(f, h, T, _),
                h.child
              )
            case 11:
              return (
                (T = h.type),
                (P = h.pendingProps),
                (P = h.elementType === T ? P : nr(T, P)),
                En(f, h, T, P, _)
              )
            case 7:
              return Gn(f, h, h.pendingProps, _), h.child
            case 8:
              return Gn(f, h, h.pendingProps.children, _), h.child
            case 12:
              return Gn(f, h, h.pendingProps.children, _), h.child
            case 10:
              e: {
                if (
                  ((T = h.type._context),
                  (P = h.pendingProps),
                  (F = h.memoizedProps),
                  (J = P.value),
                  sa(h, T, J),
                  F !== null)
                )
                  if (Gi(F.value, J)) {
                    if (F.children === P.children && !In.current) {
                      h = sr(f, h, _)
                      break e
                    }
                  } else
                    for (F = h.child, F !== null && (F.return = h); F !== null; ) {
                      var pe = F.dependencies
                      if (pe !== null) {
                        J = F.child
                        for (var ke = pe.firstContext; ke !== null; ) {
                          if (ke.context === T) {
                            if (F.tag === 1) {
                              ;(ke = Vs(-1, _ & -_)), (ke.tag = 2)
                              var Ze = F.updateQueue
                              if (Ze !== null) {
                                Ze = Ze.shared
                                var gt = Ze.pending
                                gt === null
                                  ? (ke.next = ke)
                                  : ((ke.next = gt.next), (gt.next = ke)),
                                  (Ze.pending = ke)
                              }
                            }
                            ;(F.lanes |= _),
                              (ke = F.alternate),
                              ke !== null && (ke.lanes |= _),
                              oa(F.return, _, h),
                              (pe.lanes |= _)
                            break
                          }
                          ke = ke.next
                        }
                      } else if (F.tag === 10) J = F.type === h.type ? null : F.child
                      else if (F.tag === 18) {
                        if (((J = F.return), J === null)) throw Error(o(341))
                        ;(J.lanes |= _),
                          (pe = J.alternate),
                          pe !== null && (pe.lanes |= _),
                          oa(J, _, h),
                          (J = F.sibling)
                      } else J = F.child
                      if (J !== null) J.return = F
                      else
                        for (J = F; J !== null; ) {
                          if (J === h) {
                            J = null
                            break
                          }
                          if (((F = J.sibling), F !== null)) {
                            ;(F.return = J.return), (J = F)
                            break
                          }
                          J = J.return
                        }
                      F = J
                    }
                Gn(f, h, P.children, _), (h = h.child)
              }
              return h
            case 9:
              return (
                (P = h.type),
                (T = h.pendingProps.children),
                ol(h, _),
                (P = ir(P)),
                (T = T(P)),
                (h.flags |= 1),
                Gn(f, h, T, _),
                h.child
              )
            case 14:
              return (
                (T = h.type),
                (P = nr(T, h.pendingProps)),
                (P = nr(T.type, P)),
                wn(f, h, T, P, _)
              )
            case 15:
              return qs(f, h, h.type, h.pendingProps, _)
            case 17:
              return (
                (T = h.type),
                (P = h.pendingProps),
                (P = h.elementType === T ? P : nr(T, P)),
                f !== null &&
                  ((f.alternate = null), (h.alternate = null), (h.flags |= 2)),
                (h.tag = 1),
                Ln(T) ? ((f = !0), Hi(h)) : (f = !1),
                ol(h, _),
                Nm(h, T, P),
                nh(h, T, P, _),
                Li(null, h, T, !0, f, _)
              )
            case 19:
              return xa(f, h, _)
            case 22:
              return _i(f, h, _)
          }
          throw Error(o(156, h.tag))
        }
        function Ff(f, h) {
          return na(f, h)
        }
        function Zm(f, h, _, T) {
          ;(this.tag = f),
            (this.key = _),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.ref = null),
            (this.pendingProps = h),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = T),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null)
        }
        function Mr(f, h, _, T) {
          return new Zm(f, h, _, T)
        }
        function Uf(f) {
          return (f = f.prototype), !(!f || !f.isReactComponent)
        }
        function Ay(f) {
          if (typeof f == "function") return Uf(f) ? 1 : 0
          if (f != null) {
            if (((f = f.$$typeof), f === E)) return 11
            if (f === A) return 14
          }
          return 2
        }
        function io(f, h) {
          var _ = f.alternate
          return (
            _ === null
              ? ((_ = Mr(f.tag, h, f.key, f.mode)),
                (_.elementType = f.elementType),
                (_.type = f.type),
                (_.stateNode = f.stateNode),
                (_.alternate = f),
                (f.alternate = _))
              : ((_.pendingProps = h),
                (_.type = f.type),
                (_.flags = 0),
                (_.subtreeFlags = 0),
                (_.deletions = null)),
            (_.flags = f.flags & 14680064),
            (_.childLanes = f.childLanes),
            (_.lanes = f.lanes),
            (_.child = f.child),
            (_.memoizedProps = f.memoizedProps),
            (_.memoizedState = f.memoizedState),
            (_.updateQueue = f.updateQueue),
            (h = f.dependencies),
            (_.dependencies =
              h === null ? null : { lanes: h.lanes, firstContext: h.firstContext }),
            (_.sibling = f.sibling),
            (_.index = f.index),
            (_.ref = f.ref),
            _
          )
        }
        function Of(f, h, _, T, P, F) {
          var J = 2
          if (((T = f), typeof f == "function")) Uf(f) && (J = 1)
          else if (typeof f == "string") J = 5
          else
            e: switch (f) {
              case p:
                return Pa(_.children, P, F, h)
              case m:
                ;(J = 8), (P |= 8)
                break
              case v:
                return (f = Mr(12, _, h, P | 2)), (f.elementType = v), (f.lanes = F), f
              case M:
                return (f = Mr(13, _, h, P)), (f.elementType = M), (f.lanes = F), f
              case w:
                return (f = Mr(19, _, h, P)), (f.elementType = w), (f.lanes = F), f
              case R:
                return Hc(_, P, F, h)
              default:
                if (typeof f == "object" && f !== null)
                  switch (f.$$typeof) {
                    case y:
                      J = 10
                      break e
                    case x:
                      J = 9
                      break e
                    case E:
                      J = 11
                      break e
                    case A:
                      J = 14
                      break e
                    case C:
                      ;(J = 16), (T = null)
                      break e
                  }
                throw Error(o(130, f == null ? f : typeof f, ""))
            }
          return (
            (h = Mr(J, _, h, P)), (h.elementType = f), (h.type = T), (h.lanes = F), h
          )
        }
        function Pa(f, h, _, T) {
          return (f = Mr(7, f, T, h)), (f.lanes = _), f
        }
        function Hc(f, h, _, T) {
          return (
            (f = Mr(22, f, T, h)),
            (f.elementType = R),
            (f.lanes = _),
            (f.stateNode = {}),
            f
          )
        }
        function Bf(f, h, _) {
          return (f = Mr(6, f, null, h)), (f.lanes = _), f
        }
        function zf(f, h, _) {
          return (
            (h = Mr(4, f.children !== null ? f.children : [], f.key, h)),
            (h.lanes = _),
            (h.stateNode = {
              containerInfo: f.containerInfo,
              pendingChildren: null,
              implementation: f.implementation,
            }),
            h
          )
        }
        function Vf(f, h, _, T, P) {
          ;(this.tag = h),
            (this.containerInfo = f),
            (this.finishedWork =
              this.pingCache =
              this.current =
              this.pendingChildren =
                null),
            (this.timeoutHandle = ze),
            (this.callbackNode = this.pendingContext = this.context = null),
            (this.callbackPriority = 0),
            (this.eventTimes = Ku(0)),
            (this.expirationTimes = Ku(-1)),
            (this.entangledLanes =
              this.finishedLanes =
              this.mutableReadLanes =
              this.expiredLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = Ku(0)),
            (this.identifierPrefix = T),
            (this.onRecoverableError = P),
            Ee && (this.mutableSourceEagerHydrationData = null)
        }
        function Jm(f, h, _, T, P, F, J, pe, ke) {
          return (
            (f = new Vf(f, h, _, pe, ke)),
            h === 1 ? ((h = 1), F === !0 && (h |= 8)) : (h = 0),
            (F = Mr(3, null, null, h)),
            (f.current = F),
            (F.stateNode = f),
            (F.memoizedState = {
              element: T,
              isDehydrated: _,
              cache: null,
              transitions: null,
            }),
            al(F),
            f
          )
        }
        function Qm(f) {
          if (!f) return Ft
          f = f._reactInternals
          e: {
            if (k(f) !== f || f.tag !== 1) throw Error(o(170))
            var h = f
            do {
              switch (h.tag) {
                case 3:
                  h = h.stateNode.context
                  break e
                case 1:
                  if (Ln(h.type)) {
                    h = h.stateNode.__reactInternalMemoizedMergedChildContext
                    break e
                  }
              }
              h = h.return
            } while (h !== null)
            throw Error(o(171))
          }
          if (f.tag === 1) {
            var _ = f.type
            if (Ln(_)) return yn(f, _, h)
          }
          return h
        }
        function eg(f) {
          var h = f._reactInternals
          if (h === void 0)
            throw typeof f.render == "function"
              ? Error(o(188))
              : ((f = Object.keys(f).join(",")), Error(o(268, f)))
          return (f = Z(h)), f === null ? null : f.stateNode
        }
        function Gr(f, h) {
          if (((f = f.memoizedState), f !== null && f.dehydrated !== null)) {
            var _ = f.retryLane
            f.retryLane = _ !== 0 && _ < h ? _ : h
          }
        }
        function Gc(f, h) {
          Gr(f, h), (f = f.alternate) && Gr(f, h)
        }
        function Hf(f) {
          return (f = Z(f)), f === null ? null : f.stateNode
        }
        function tg() {
          return null
        }
        return (
          (t.attemptContinuousHydration = function (f) {
            if (f.tag === 13) {
              var h = pn()
              Ni(f, 134217728, h), Gc(f, 134217728)
            }
          }),
          (t.attemptHydrationAtCurrentPriority = function (f) {
            if (f.tag === 13) {
              var h = pn(),
                _ = ds(f)
              Ni(f, _, h), Gc(f, _)
            }
          }),
          (t.attemptSynchronousHydration = function (f) {
            switch (f.tag) {
              case 3:
                var h = f.stateNode
                if (h.current.memoizedState.isDehydrated) {
                  var _ = rl(h.pendingLanes)
                  _ !== 0 && (ws(h, _ | 1), or(h, si()), (qt & 6) === 0 && (Aa(), Fr()))
                }
                break
              case 13:
                var T = pn()
                Al(function () {
                  return Ni(f, 1, T)
                }),
                  Gc(f, 1)
            }
          }),
          (t.batchedUpdates = function (f, h) {
            var _ = qt
            qt |= 1
            try {
              return f(h)
            } finally {
              ;(qt = _), qt === 0 && (Aa(), ef && Fr())
            }
          }),
          (t.createComponentSelector = function (f) {
            return { $$typeof: Lc, value: f }
          }),
          (t.createContainer = function (f, h, _, T, P, F, J) {
            return Jm(f, h, !1, null, _, T, P, F, J)
          }),
          (t.createHasPseudoClassSelector = function (f) {
            return { $$typeof: Sa, value: f }
          }),
          (t.createHydrationContainer = function (f, h, _, T, P, F, J, pe, ke) {
            return (
              (f = Jm(_, T, !0, f, P, F, J, pe, ke)),
              (f.context = Qm(null)),
              (_ = f.current),
              (T = pn()),
              (P = ds(_)),
              (F = Vs(T, P)),
              (F.callback = h ?? null),
              Co(_, F),
              (f.current.lanes = P),
              ta(f, P, T),
              or(f, T),
              f
            )
          }),
          (t.createPortal = function (f, h, _) {
            var T =
              3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null
            return {
              $$typeof: d,
              key: T == null ? null : "" + T,
              children: f,
              containerInfo: h,
              implementation: _,
            }
          }),
          (t.createRoleSelector = function (f) {
            return { $$typeof: Ma, value: f }
          }),
          (t.createTestNameSelector = function (f) {
            return { $$typeof: Js, value: f }
          }),
          (t.createTextSelector = function (f) {
            return { $$typeof: Ml, value: f }
          }),
          (t.deferredUpdates = function (f) {
            var h = Jt,
              _ = xn.transition
            try {
              return (xn.transition = null), (Jt = 16), f()
            } finally {
              ;(Jt = h), (xn.transition = _)
            }
          }),
          (t.discreteUpdates = function (f, h, _, T, P) {
            var F = Jt,
              J = xn.transition
            try {
              return (xn.transition = null), (Jt = 1), f(h, _, T, P)
            } finally {
              ;(Jt = F), (xn.transition = J), qt === 0 && Aa()
            }
          }),
          (t.findAllNodes = Qs),
          (t.findBoundingRects = function (f, h) {
            if (!Se) throw Error(o(363))
            ;(h = Qs(f, h)), (f = [])
            for (var _ = 0; _ < h.length; _++) f.push(B(h[_]))
            for (h = f.length - 1; 0 < h; h--) {
              _ = f[h]
              for (
                var T = _.x, P = T + _.width, F = _.y, J = F + _.height, pe = h - 1;
                0 <= pe;
                pe--
              )
                if (h !== pe) {
                  var ke = f[pe],
                    Ze = ke.x,
                    gt = Ze + ke.width,
                    zt = ke.y,
                    It = zt + ke.height
                  if (T >= Ze && F >= zt && P <= gt && J <= It) {
                    f.splice(h, 1)
                    break
                  } else if (T !== Ze || _.width !== ke.width || It < F || zt > J) {
                    if (!(F !== zt || _.height !== ke.height || gt < T || Ze > P)) {
                      Ze > T && ((ke.width += Ze - T), (ke.x = T)),
                        gt < P && (ke.width = P - Ze),
                        f.splice(h, 1)
                      break
                    }
                  } else {
                    zt > F && ((ke.height += zt - F), (ke.y = F)),
                      It < J && (ke.height = J - zt),
                      f.splice(h, 1)
                    break
                  }
                }
            }
            return f
          }),
          (t.findHostInstance = eg),
          (t.findHostInstanceWithNoPortals = function (f) {
            return (
              (f = V(f)),
              (f = f !== null ? ee(f) : null),
              f === null ? null : f.stateNode
            )
          }),
          (t.findHostInstanceWithWarning = function (f) {
            return eg(f)
          }),
          (t.flushControlled = function (f) {
            var h = qt
            qt |= 1
            var _ = xn.transition,
              T = Jt
            try {
              ;(xn.transition = null), (Jt = 1), f()
            } finally {
              ;(Jt = T), (xn.transition = _), (qt = h), qt === 0 && (Aa(), Fr())
            }
          }),
          (t.flushPassiveEffects = Cs),
          (t.flushSync = Al),
          (t.focusWithin = function (f, h) {
            if (!Se) throw Error(o(363))
            for (f = Dc(f), h = _r(f, h), h = Array.from(h), f = 0; f < h.length; ) {
              var _ = h[f++]
              if (!Me(_)) {
                if (_.tag === 5 && Ie(_.stateNode)) return !0
                for (_ = _.child; _ !== null; ) h.push(_), (_ = _.sibling)
              }
            }
            return !1
          }),
          (t.getCurrentUpdatePriority = function () {
            return Jt
          }),
          (t.getFindAllNodesFailureDescription = function (f, h) {
            if (!Se) throw Error(o(363))
            var _ = 0,
              T = []
            f = [Dc(f), 0]
            for (var P = 0; P < f.length; ) {
              var F = f[P++],
                J = f[P++],
                pe = h[J]
              if (
                (F.tag !== 5 || !Me(F)) &&
                (Nc(F, pe) && (T.push(Fo(pe)), J++, J > _ && (_ = J)), J < h.length)
              )
                for (F = F.child; F !== null; ) f.push(F, J), (F = F.sibling)
            }
            if (_ < h.length) {
              for (f = []; _ < h.length; _++) f.push(Fo(h[_]))
              return (
                `findAllNodes was able to match part of the selector:
  ` +
                (T.join(" > ") +
                  `

No matching component was found for:
  `) +
                f.join(" > ")
              )
            }
            return null
          }),
          (t.getPublicRootInstance = function (f) {
            if (((f = f.current), !f.child)) return null
            switch (f.child.tag) {
              case 5:
                return re(f.child.stateNode)
              default:
                return f.child.stateNode
            }
          }),
          (t.injectIntoDevTools = function (f) {
            if (
              ((f = {
                bundleType: f.bundleType,
                version: f.version,
                rendererPackageName: f.rendererPackageName,
                rendererConfig: f.rendererConfig,
                overrideHookState: null,
                overrideHookStateDeletePath: null,
                overrideHookStateRenamePath: null,
                overrideProps: null,
                overridePropsDeletePath: null,
                overridePropsRenamePath: null,
                setErrorHandler: null,
                setSuspenseHandler: null,
                scheduleUpdate: null,
                currentDispatcherRef: l.ReactCurrentDispatcher,
                findHostInstanceByFiber: Hf,
                findFiberByHostInstance: f.findFiberByHostInstance || tg,
                findHostInstancesForRefresh: null,
                scheduleRefresh: null,
                scheduleRoot: null,
                setRefreshHandler: null,
                getCurrentFiber: null,
                reconcilerVersion: "18.0.0-fc46dba67-20220329",
              }),
              typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
            )
              f = !1
            else {
              var h = __REACT_DEVTOOLS_GLOBAL_HOOK__
              if (h.isDisabled || !h.supportsFiber) f = !0
              else {
                try {
                  ;(fc = h.inject(f)), (Ss = h)
                } catch {}
                f = !!h.checkDCE
              }
            }
            return f
          }),
          (t.isAlreadyRendering = function () {
            return !1
          }),
          (t.observeVisibleRects = function (f, h, _, T) {
            if (!Se) throw Error(o(363))
            f = Qs(f, h)
            var P = st(f, _, T).disconnect
            return {
              disconnect: function () {
                P()
              },
            }
          }),
          (t.registerMutableSourceForHydration = function (f, h) {
            var _ = h._getVersion
            ;(_ = _(h._source)),
              f.mutableSourceEagerHydrationData == null
                ? (f.mutableSourceEagerHydrationData = [h, _])
                : f.mutableSourceEagerHydrationData.push(h, _)
          }),
          (t.runWithPriority = function (f, h) {
            var _ = Jt
            try {
              return (Jt = f), h()
            } finally {
              Jt = _
            }
          }),
          (t.shouldError = function () {
            return null
          }),
          (t.shouldSuspend = function () {
            return !1
          }),
          (t.updateContainer = function (f, h, _, T) {
            var P = h.current,
              F = pn(),
              J = ds(P)
            return (
              (_ = Qm(_)),
              h.context === null ? (h.context = _) : (h.pendingContext = _),
              (h = Vs(F, J)),
              (h.payload = { element: f }),
              (T = T === void 0 ? null : T),
              T !== null && (h.callback = T),
              Co(P, h),
              (f = Ni(P, J, F)),
              f !== null && sf(f, P, J),
              J
            )
          }),
          t
        )
      })),
    M_
  )
}
var Fb
function $H() {
  return Fb || ((Fb = 1), (__.exports = qH())), __.exports
}
var KH = $H()
const ZH = rm(KH)
var Ub = _R()
const mS = {},
  JH = (n) => void Object.assign(mS, n)
function QH(n, e) {
  function t(p, { args: m = [], attach: v, ...y }, x) {
    let E = `${p[0].toUpperCase()}${p.slice(1)}`,
      M
    if (p === "primitive") {
      if (y.object === void 0)
        throw new Error("R3F: Primitives without 'object' are invalid!")
      const w = y.object
      M = md(w, { type: p, root: x, attach: v, primitive: !0 })
    } else {
      const w = mS[E]
      if (!w)
        throw new Error(
          `R3F: ${E} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`,
        )
      if (!Array.isArray(m)) throw new Error("R3F: The args prop must be an array!")
      M = md(new w(...m), { type: p, root: x, attach: v, memoizedProps: { args: m } })
    }
    return (
      M.__r3f.attach === void 0 &&
        (M instanceof Gt
          ? (M.__r3f.attach = "geometry")
          : M instanceof er && (M.__r3f.attach = "material")),
      E !== "inject" && b_(M, y),
      M
    )
  }
  function i(p, m) {
    let v = !1
    if (m) {
      var y, x
      ;(y = m.__r3f) != null && y.attach
        ? T_(p, m, m.__r3f.attach)
        : m.isObject3D && p.isObject3D && (p.add(m), (v = !0)),
        v || (x = p.__r3f) == null || x.objects.push(m),
        m.__r3f || md(m, {}),
        (m.__r3f.parent = p),
        D1(m),
        gd(m)
    }
  }
  function r(p, m, v) {
    let y = !1
    if (m) {
      var x, E
      if ((x = m.__r3f) != null && x.attach) T_(p, m, m.__r3f.attach)
      else if (m.isObject3D && p.isObject3D) {
        ;(m.parent = p),
          m.dispatchEvent({ type: "added" }),
          p.dispatchEvent({ type: "childadded", child: m })
        const M = p.children.filter((A) => A !== m),
          w = M.indexOf(v)
        ;(p.children = [...M.slice(0, w), m, ...M.slice(w)]), (y = !0)
      }
      y || (E = p.__r3f) == null || E.objects.push(m),
        m.__r3f || md(m, {}),
        (m.__r3f.parent = p),
        D1(m),
        gd(m)
    }
  }
  function s(p, m, v = !1) {
    p && [...p].forEach((y) => o(m, y, v))
  }
  function o(p, m, v) {
    if (m) {
      var y, x, E
      if (
        (m.__r3f && (m.__r3f.parent = null),
        (y = p.__r3f) != null &&
          y.objects &&
          (p.__r3f.objects = p.__r3f.objects.filter((R) => R !== m)),
        (x = m.__r3f) != null && x.attach)
      )
        Hb(p, m, m.__r3f.attach)
      else if (m.isObject3D && p.isObject3D) {
        var M
        p.remove(m), (M = m.__r3f) != null && M.root && a7(P0(m), m)
      }
      const A = (E = m.__r3f) == null ? void 0 : E.primitive,
        C = !A && (v === void 0 ? m.dispose !== null : v)
      if (!A) {
        var w
        s((w = m.__r3f) == null ? void 0 : w.objects, m, C), s(m.children, m, C)
      }
      if ((delete m.__r3f, C && m.dispose && m.type !== "Scene")) {
        const R = () => {
          try {
            m.dispose()
          } catch {}
        }
        typeof IS_REACT_ACT_ENVIRONMENT > "u"
          ? Ub.unstable_scheduleCallback(Ub.unstable_IdlePriority, R)
          : R()
      }
      gd(p)
    }
  }
  function l(p, m, v, y) {
    var x
    const E = (x = p.__r3f) == null ? void 0 : x.parent
    if (!E) return
    const M = t(m, v, p.__r3f.root)
    if (p.children) {
      for (const w of p.children) w.__r3f && i(M, w)
      p.children = p.children.filter((w) => !w.__r3f)
    }
    p.__r3f.objects.forEach((w) => i(M, w)),
      (p.__r3f.objects = []),
      p.__r3f.autoRemovedBeforeAppend || o(E, p),
      M.parent && (M.__r3f.autoRemovedBeforeAppend = !0),
      i(E, M),
      M.raycast && M.__r3f.eventCount && P0(M).getState().internal.interaction.push(M),
      [y, y.alternate].forEach((w) => {
        w !== null &&
          ((w.stateNode = M),
          w.ref && (typeof w.ref == "function" ? w.ref(M) : (w.ref.current = M)))
      })
  }
  const u = () => {}
  return {
    reconciler: ZH({
      createInstance: t,
      removeChild: o,
      appendChild: i,
      appendInitialChild: i,
      insertBefore: r,
      supportsMutation: !0,
      isPrimaryRenderer: !1,
      supportsPersistence: !1,
      supportsHydration: !1,
      noTimeout: -1,
      appendChildToContainer: (p, m) => {
        if (!m) return
        const v = p.getState().scene
        v.__r3f && ((v.__r3f.root = p), i(v, m))
      },
      removeChildFromContainer: (p, m) => {
        m && o(p.getState().scene, m)
      },
      insertInContainerBefore: (p, m, v) => {
        if (!m || !v) return
        const y = p.getState().scene
        y.__r3f && r(y, m, v)
      },
      getRootHostContext: () => null,
      getChildHostContext: (p) => p,
      finalizeInitialChildren(p) {
        var m
        return !!((m = p == null ? void 0 : p.__r3f) != null ? m : {}).handlers
      },
      prepareUpdate(p, m, v, y) {
        var x
        if (
          ((x = p == null ? void 0 : p.__r3f) != null ? x : {}).primitive &&
          y.object &&
          y.object !== p
        )
          return [!0]
        {
          const { args: M = [], children: w, ...A } = y,
            { args: C = [], children: R, ...z } = v
          if (!Array.isArray(M)) throw new Error("R3F: the args prop must be an array!")
          if (M.some((O, N) => O !== C[N])) return [!0]
          const U = AR(p, A, z, !0)
          return U.changes.length ? [!1, U] : null
        }
      },
      commitUpdate(p, [m, v], y, x, E, M) {
        m ? l(p, y, E, M) : b_(p, v)
      },
      commitMount(p, m, v, y) {
        var x
        const E = (x = p.__r3f) != null ? x : {}
        p.raycast &&
          E.handlers &&
          E.eventCount &&
          P0(p).getState().internal.interaction.push(p)
      },
      getPublicInstance: (p) => p,
      prepareForCommit: () => null,
      preparePortalMount: (p) => md(p.getState().scene),
      resetAfterCommit: () => {},
      shouldSetTextContent: () => !1,
      clearContainer: () => !1,
      hideInstance(p) {
        var m
        const { attach: v, parent: y } = (m = p.__r3f) != null ? m : {}
        v && y && Hb(y, p, v), p.isObject3D && (p.visible = !1), gd(p)
      },
      unhideInstance(p, m) {
        var v
        const { attach: y, parent: x } = (v = p.__r3f) != null ? v : {}
        y && x && T_(x, p, y),
          ((p.isObject3D && m.visible == null) || m.visible) && (p.visible = !0),
          gd(p)
      },
      createTextInstance: u,
      hideTextInstance: u,
      unhideTextInstance: u,
      getCurrentEventPriority: () => (e ? e() : Td.DefaultEventPriority),
      beforeActiveInstanceBlur: () => {},
      afterActiveInstanceBlur: () => {},
      detachDeletedInstance: () => {},
      now:
        typeof performance < "u" && kn.fun(performance.now)
          ? performance.now
          : kn.fun(Date.now)
          ? Date.now
          : () => 0,
      scheduleTimeout: kn.fun(setTimeout) ? setTimeout : void 0,
      cancelTimeout: kn.fun(clearTimeout) ? clearTimeout : void 0,
    }),
    applyProps: b_,
  }
}
var Ob, Bb
const E_ = (n) => "colorSpace" in n || "outputColorSpace" in n,
  wR = () => {
    var n
    return (n = mS.ColorManagement) != null ? n : null
  },
  SR = (n) => n && n.isOrthographicCamera,
  e7 = (n) => n && n.hasOwnProperty("current"),
  Am =
    typeof window < "u" &&
    (((Ob = window.document) != null && Ob.createElement) ||
      ((Bb = window.navigator) == null ? void 0 : Bb.product) === "ReactNative")
      ? Y.useLayoutEffect
      : Y.useEffect
function MR(n) {
  const e = Y.useRef(n)
  return Am(() => void (e.current = n), [n]), e
}
function t7({ set: n }) {
  return Am(() => (n(new Promise(() => null)), () => n(!1)), [n]), null
}
class ER extends Y.Component {
  constructor(...e) {
    super(...e), (this.state = { error: !1 })
  }
  componentDidCatch(e) {
    this.props.set(e)
  }
  render() {
    return this.state.error ? null : this.props.children
  }
}
ER.getDerivedStateFromError = () => ({ error: !0 })
const TR = "__default",
  zb = new Map(),
  n7 = (n) => n && !!n.memoized && !!n.changes
function bR(n) {
  var e
  const t = typeof window < "u" ? ((e = window.devicePixelRatio) != null ? e : 2) : 1
  return Array.isArray(n) ? Math.min(Math.max(n[0], t), n[1]) : n
}
const sp = (n) => {
  var e
  return (e = n.__r3f) == null ? void 0 : e.root.getState()
}
function P0(n) {
  let e = n.__r3f.root
  for (; e.getState().previousRoot; ) e = e.getState().previousRoot
  return e
}
const kn = {
  obj: (n) => n === Object(n) && !kn.arr(n) && typeof n != "function",
  fun: (n) => typeof n == "function",
  str: (n) => typeof n == "string",
  num: (n) => typeof n == "number",
  boo: (n) => typeof n == "boolean",
  und: (n) => n === void 0,
  arr: (n) => Array.isArray(n),
  equ(n, e, { arrays: t = "shallow", objects: i = "reference", strict: r = !0 } = {}) {
    if (typeof n != typeof e || !!n != !!e) return !1
    if (kn.str(n) || kn.num(n) || kn.boo(n)) return n === e
    const s = kn.obj(n)
    if (s && i === "reference") return n === e
    const o = kn.arr(n)
    if (o && t === "reference") return n === e
    if ((o || s) && n === e) return !0
    let l
    for (l in n) if (!(l in e)) return !1
    if (s && t === "shallow" && i === "shallow") {
      for (l in r ? e : n)
        if (!kn.equ(n[l], e[l], { strict: r, objects: "reference" })) return !1
    } else for (l in r ? e : n) if (n[l] !== e[l]) return !1
    if (kn.und(l)) {
      if (
        (o && n.length === 0 && e.length === 0) ||
        (s && Object.keys(n).length === 0 && Object.keys(e).length === 0)
      )
        return !0
      if (n !== e) return !1
    }
    return !0
  },
}
function i7(n) {
  const e = { nodes: {}, materials: {} }
  return (
    n &&
      n.traverse((t) => {
        t.name && (e.nodes[t.name] = t),
          t.material &&
            !e.materials[t.material.name] &&
            (e.materials[t.material.name] = t.material)
      }),
    e
  )
}
function r7(n) {
  n.dispose && n.type !== "Scene" && n.dispose()
  for (const e in n) e.dispose == null || e.dispose(), delete n[e]
}
function md(n, e) {
  const t = n
  return (
    (t.__r3f = {
      type: "",
      root: null,
      previousAttach: null,
      memoizedProps: {},
      eventCount: 0,
      handlers: {},
      objects: [],
      parent: null,
      ...e,
    }),
    n
  )
}
function L1(n, e) {
  let t = n
  if (e.includes("-")) {
    const i = e.split("-"),
      r = i.pop()
    return (t = i.reduce((s, o) => s[o], n)), { target: t, key: r }
  } else return { target: t, key: e }
}
const Vb = /-\d+$/
function T_(n, e, t) {
  if (kn.str(t)) {
    if (Vb.test(t)) {
      const s = t.replace(Vb, ""),
        { target: o, key: l } = L1(n, s)
      Array.isArray(o[l]) || (o[l] = [])
    }
    const { target: i, key: r } = L1(n, t)
    ;(e.__r3f.previousAttach = i[r]), (i[r] = e)
  } else e.__r3f.previousAttach = t(n, e)
}
function Hb(n, e, t) {
  var i, r
  if (kn.str(t)) {
    const { target: s, key: o } = L1(n, t),
      l = e.__r3f.previousAttach
    l === void 0 ? delete s[o] : (s[o] = l)
  } else (i = e.__r3f) == null || i.previousAttach == null || i.previousAttach(n, e)
  ;(r = e.__r3f) == null || delete r.previousAttach
}
function AR(
  n,
  { children: e, key: t, ref: i, ...r },
  { children: s, key: o, ref: l, ...u } = {},
  d = !1,
) {
  const p = n.__r3f,
    m = Object.entries(r),
    v = []
  if (d) {
    const x = Object.keys(u)
    for (let E = 0; E < x.length; E++)
      r.hasOwnProperty(x[E]) || m.unshift([x[E], TR + "remove"])
  }
  m.forEach(([x, E]) => {
    var M
    if (((M = n.__r3f) != null && M.primitive && x === "object") || kn.equ(E, u[x]))
      return
    if (/^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/.test(x))
      return v.push([x, E, !0, []])
    let w = []
    x.includes("-") && (w = x.split("-")), v.push([x, E, !1, w])
    for (const A in r) {
      const C = r[A]
      A.startsWith(`${x}-`) && v.push([A, C, !1, A.split("-")])
    }
  })
  const y = { ...r }
  return (
    p != null &&
      p.memoizedProps &&
      p != null &&
      p.memoizedProps.args &&
      (y.args = p.memoizedProps.args),
    p != null &&
      p.memoizedProps &&
      p != null &&
      p.memoizedProps.attach &&
      (y.attach = p.memoizedProps.attach),
    { memoized: y, changes: v }
  )
}
function b_(n, e) {
  var t
  const i = n.__r3f,
    r = i == null ? void 0 : i.root,
    s = r == null || r.getState == null ? void 0 : r.getState(),
    { memoized: o, changes: l } = n7(e) ? e : AR(n, e),
    u = i == null ? void 0 : i.eventCount
  n.__r3f && (n.__r3f.memoizedProps = o)
  for (let p = 0; p < l.length; p++) {
    let [m, v, y, x] = l[p]
    if (E_(n)) {
      const A = "srgb",
        C = "srgb-linear"
      m === "encoding"
        ? ((m = "colorSpace"), (v = v === 3001 ? A : C))
        : m === "outputEncoding" && ((m = "outputColorSpace"), (v = v === 3001 ? A : C))
    }
    let E = n,
      M = E[m]
    if (x.length && ((M = x.reduce((w, A) => w[A], n)), !(M && M.set))) {
      const [w, ...A] = x.reverse()
      ;(E = A.reverse().reduce((C, R) => C[R], n)), (m = w)
    }
    if (v === TR + "remove")
      if (E.constructor) {
        let w = zb.get(E.constructor)
        w || ((w = new E.constructor()), zb.set(E.constructor, w)), (v = w[m])
      } else v = 0
    if (y && i)
      v ? (i.handlers[m] = v) : delete i.handlers[m],
        (i.eventCount = Object.keys(i.handlers).length)
    else if (M && M.set && (M.copy || M instanceof Au)) {
      if (Array.isArray(v)) M.fromArray ? M.fromArray(v) : M.set(...v)
      else if (M.copy && v && v.constructor && M.constructor === v.constructor)
        M.copy(v)
      else if (v !== void 0) {
        const w = M instanceof ot
        !w && M.setScalar
          ? M.setScalar(v)
          : M instanceof Au && v instanceof Au
          ? (M.mask = v.mask)
          : M.set(v),
          !wR() && s && !s.linear && w && M.convertSRGBToLinear()
      }
    } else if (
      ((E[m] = v), E[m] instanceof zn && E[m].format === hr && E[m].type === wo && s)
    ) {
      const w = E[m]
      E_(w) && E_(s.gl)
        ? (w.colorSpace = s.gl.outputColorSpace)
        : (w.encoding = s.gl.outputEncoding)
    }
    gd(n)
  }
  if (i && i.parent && n.raycast && u !== i.eventCount) {
    const p = P0(n).getState().internal,
      m = p.interaction.indexOf(n)
    m > -1 && p.interaction.splice(m, 1), i.eventCount && p.interaction.push(n)
  }
  return (
    !(l.length === 1 && l[0][0] === "onUpdate") &&
      l.length &&
      (t = n.__r3f) != null &&
      t.parent &&
      D1(n),
    n
  )
}
function gd(n) {
  var e, t
  const i =
    (e = n.__r3f) == null || (t = e.root) == null || t.getState == null
      ? void 0
      : t.getState()
  i && i.internal.frames === 0 && i.invalidate()
}
function D1(n) {
  n.onUpdate == null || n.onUpdate(n)
}
function s7(n, e) {
  n.manual ||
    (SR(n)
      ? ((n.left = e.width / -2),
        (n.right = e.width / 2),
        (n.top = e.height / 2),
        (n.bottom = e.height / -2))
      : (n.aspect = e.width / e.height),
    n.updateProjectionMatrix(),
    n.updateMatrixWorld())
}
function w0(n) {
  return (n.eventObject || n.object).uuid + "/" + n.index + n.instanceId
}
function o7() {
  var n
  const e = (typeof self < "u" && self) || (typeof window < "u" && window)
  if (!e) return Td.DefaultEventPriority
  switch ((n = e.event) == null ? void 0 : n.type) {
    case "click":
    case "contextmenu":
    case "dblclick":
    case "pointercancel":
    case "pointerdown":
    case "pointerup":
      return Td.DiscreteEventPriority
    case "pointermove":
    case "pointerout":
    case "pointerover":
    case "pointerenter":
    case "pointerleave":
    case "wheel":
      return Td.ContinuousEventPriority
    default:
      return Td.DefaultEventPriority
  }
}
function CR(n, e, t, i) {
  const r = t.get(e)
  r && (t.delete(e), t.size === 0 && (n.delete(i), r.target.releasePointerCapture(i)))
}
function a7(n, e) {
  const { internal: t } = n.getState()
  ;(t.interaction = t.interaction.filter((i) => i !== e)),
    (t.initialHits = t.initialHits.filter((i) => i !== e)),
    t.hovered.forEach((i, r) => {
      ;(i.eventObject === e || i.object === e) && t.hovered.delete(r)
    }),
    t.capturedMap.forEach((i, r) => {
      CR(t.capturedMap, e, i, r)
    })
}
function l7(n) {
  function e(u) {
    const { internal: d } = n.getState(),
      p = u.offsetX - d.initialClick[0],
      m = u.offsetY - d.initialClick[1]
    return Math.round(Math.sqrt(p * p + m * m))
  }
  function t(u) {
    return u.filter((d) =>
      ["Move", "Over", "Enter", "Out", "Leave"].some((p) => {
        var m
        return (m = d.__r3f) == null ? void 0 : m.handlers["onPointer" + p]
      }),
    )
  }
  function i(u, d) {
    const p = n.getState(),
      m = new Set(),
      v = [],
      y = d ? d(p.internal.interaction) : p.internal.interaction
    for (let w = 0; w < y.length; w++) {
      const A = sp(y[w])
      A && (A.raycaster.camera = void 0)
    }
    p.previousRoot || p.events.compute == null || p.events.compute(u, p)
    function x(w) {
      const A = sp(w)
      if (!A || !A.events.enabled || A.raycaster.camera === null) return []
      if (A.raycaster.camera === void 0) {
        var C
        A.events.compute == null ||
          A.events.compute(u, A, (C = A.previousRoot) == null ? void 0 : C.getState()),
          A.raycaster.camera === void 0 && (A.raycaster.camera = null)
      }
      return A.raycaster.camera ? A.raycaster.intersectObject(w, !0) : []
    }
    let E = y
      .flatMap(x)
      .sort((w, A) => {
        const C = sp(w.object),
          R = sp(A.object)
        return !C || !R
          ? w.distance - A.distance
          : R.events.priority - C.events.priority || w.distance - A.distance
      })
      .filter((w) => {
        const A = w0(w)
        return m.has(A) ? !1 : (m.add(A), !0)
      })
    p.events.filter && (E = p.events.filter(E, p))
    for (const w of E) {
      let A = w.object
      for (; A; ) {
        var M
        ;(M = A.__r3f) != null && M.eventCount && v.push({ ...w, eventObject: A }),
          (A = A.parent)
      }
    }
    if ("pointerId" in u && p.internal.capturedMap.has(u.pointerId))
      for (let w of p.internal.capturedMap.get(u.pointerId).values())
        m.has(w0(w.intersection)) || v.push(w.intersection)
    return v
  }
  function r(u, d, p, m) {
    const v = n.getState()
    if (u.length) {
      const y = { stopped: !1 }
      for (const x of u) {
        const E = sp(x.object) || v,
          { raycaster: M, pointer: w, camera: A, internal: C } = E,
          R = new q(w.x, w.y, 0).unproject(A),
          z = (I) => {
            var V, Z
            return (V =
              (Z = C.capturedMap.get(I)) == null ? void 0 : Z.has(x.eventObject)) !=
              null
              ? V
              : !1
          },
          U = (I) => {
            const V = { intersection: x, target: d.target }
            C.capturedMap.has(I)
              ? C.capturedMap.get(I).set(x.eventObject, V)
              : C.capturedMap.set(I, new Map([[x.eventObject, V]])),
              d.target.setPointerCapture(I)
          },
          O = (I) => {
            const V = C.capturedMap.get(I)
            V && CR(C.capturedMap, x.eventObject, V, I)
          }
        let N = {}
        for (let I in d) {
          let V = d[I]
          typeof V != "function" && (N[I] = V)
        }
        let k = {
          ...x,
          ...N,
          pointer: w,
          intersections: u,
          stopped: y.stopped,
          delta: p,
          unprojectedPoint: R,
          ray: M.ray,
          camera: A,
          stopPropagation() {
            const I = "pointerId" in d && C.capturedMap.get(d.pointerId)
            if (
              (!I || I.has(x.eventObject)) &&
              ((k.stopped = y.stopped = !0),
              C.hovered.size &&
                Array.from(C.hovered.values()).find(
                  (V) => V.eventObject === x.eventObject,
                ))
            ) {
              const V = u.slice(0, u.indexOf(x))
              s([...V, x])
            }
          },
          target: {
            hasPointerCapture: z,
            setPointerCapture: U,
            releasePointerCapture: O,
          },
          currentTarget: {
            hasPointerCapture: z,
            setPointerCapture: U,
            releasePointerCapture: O,
          },
          nativeEvent: d,
        }
        if ((m(k), y.stopped === !0)) break
      }
    }
    return u
  }
  function s(u) {
    const { internal: d } = n.getState()
    for (const p of d.hovered.values())
      if (
        !u.length ||
        !u.find(
          (m) =>
            m.object === p.object &&
            m.index === p.index &&
            m.instanceId === p.instanceId,
        )
      ) {
        const v = p.eventObject.__r3f,
          y = v == null ? void 0 : v.handlers
        if ((d.hovered.delete(w0(p)), v != null && v.eventCount)) {
          const x = { ...p, intersections: u }
          y.onPointerOut == null || y.onPointerOut(x),
            y.onPointerLeave == null || y.onPointerLeave(x)
        }
      }
  }
  function o(u, d) {
    for (let p = 0; p < d.length; p++) {
      const m = d[p].__r3f
      m == null || m.handlers.onPointerMissed == null || m.handlers.onPointerMissed(u)
    }
  }
  function l(u) {
    switch (u) {
      case "onPointerLeave":
      case "onPointerCancel":
        return () => s([])
      case "onLostPointerCapture":
        return (d) => {
          const { internal: p } = n.getState()
          "pointerId" in d &&
            p.capturedMap.has(d.pointerId) &&
            requestAnimationFrame(() => {
              p.capturedMap.has(d.pointerId) &&
                (p.capturedMap.delete(d.pointerId), s([]))
            })
        }
    }
    return function (p) {
      const { onPointerMissed: m, internal: v } = n.getState()
      v.lastEvent.current = p
      const y = u === "onPointerMove",
        x = u === "onClick" || u === "onContextMenu" || u === "onDoubleClick",
        M = i(p, y ? t : void 0),
        w = x ? e(p) : 0
      u === "onPointerDown" &&
        ((v.initialClick = [p.offsetX, p.offsetY]),
        (v.initialHits = M.map((C) => C.eventObject))),
        x && !M.length && w <= 2 && (o(p, v.interaction), m && m(p)),
        y && s(M)
      function A(C) {
        const R = C.eventObject,
          z = R.__r3f,
          U = z == null ? void 0 : z.handlers
        if (z != null && z.eventCount)
          if (y) {
            if (
              U.onPointerOver ||
              U.onPointerEnter ||
              U.onPointerOut ||
              U.onPointerLeave
            ) {
              const O = w0(C),
                N = v.hovered.get(O)
              N
                ? N.stopped && C.stopPropagation()
                : (v.hovered.set(O, C),
                  U.onPointerOver == null || U.onPointerOver(C),
                  U.onPointerEnter == null || U.onPointerEnter(C))
            }
            U.onPointerMove == null || U.onPointerMove(C)
          } else {
            const O = U[u]
            O
              ? (!x || v.initialHits.includes(R)) &&
                (o(
                  p,
                  v.interaction.filter((N) => !v.initialHits.includes(N)),
                ),
                O(C))
              : x &&
                v.initialHits.includes(R) &&
                o(
                  p,
                  v.interaction.filter((N) => !v.initialHits.includes(N)),
                )
          }
      }
      r(M, p, w, A)
    }
  }
  return { handlePointer: l }
}
const RR = (n) => !!(n != null && n.render),
  PR = Y.createContext(null),
  c7 = (n, e) => {
    const t = HH((l, u) => {
        const d = new q(),
          p = new q(),
          m = new q()
        function v(w = u().camera, A = p, C = u().size) {
          const { width: R, height: z, top: U, left: O } = C,
            N = R / z
          A instanceof q ? m.copy(A) : m.set(...A)
          const k = w.getWorldPosition(d).distanceTo(m)
          if (SR(w))
            return {
              width: R / w.zoom,
              height: z / w.zoom,
              top: U,
              left: O,
              factor: 1,
              distance: k,
              aspect: N,
            }
          {
            const I = (w.fov * Math.PI) / 180,
              V = 2 * Math.tan(I / 2) * k,
              Z = V * (R / z)
            return {
              width: Z,
              height: V,
              top: U,
              left: O,
              factor: R / Z,
              distance: k,
              aspect: N,
            }
          }
        }
        let y
        const x = (w) => l((A) => ({ performance: { ...A.performance, current: w } })),
          E = new We()
        return {
          set: l,
          get: u,
          gl: null,
          camera: null,
          raycaster: null,
          events: { priority: 1, enabled: !0, connected: !1 },
          xr: null,
          scene: null,
          invalidate: (w = 1) => n(u(), w),
          advance: (w, A) => e(w, A, u()),
          legacy: !1,
          linear: !1,
          flat: !1,
          controls: null,
          clock: new uS(),
          pointer: E,
          mouse: E,
          frameloop: "always",
          onPointerMissed: void 0,
          performance: {
            current: 1,
            min: 0.5,
            max: 1,
            debounce: 200,
            regress: () => {
              const w = u()
              y && clearTimeout(y),
                w.performance.current !== w.performance.min && x(w.performance.min),
                (y = setTimeout(() => x(u().performance.max), w.performance.debounce))
            },
          },
          size: { width: 0, height: 0, top: 0, left: 0, updateStyle: !1 },
          viewport: {
            initialDpr: 0,
            dpr: 0,
            width: 0,
            height: 0,
            top: 0,
            left: 0,
            aspect: 0,
            distance: 0,
            factor: 0,
            getCurrentViewport: v,
          },
          setEvents: (w) => l((A) => ({ ...A, events: { ...A.events, ...w } })),
          setSize: (w, A, C, R, z) => {
            const U = u().camera,
              O = { width: w, height: A, top: R || 0, left: z || 0, updateStyle: C }
            l((N) => ({ size: O, viewport: { ...N.viewport, ...v(U, p, O) } }))
          },
          setDpr: (w) =>
            l((A) => {
              const C = bR(w)
              return {
                viewport: {
                  ...A.viewport,
                  dpr: C,
                  initialDpr: A.viewport.initialDpr || C,
                },
              }
            }),
          setFrameloop: (w = "always") => {
            const A = u().clock
            A.stop(),
              (A.elapsedTime = 0),
              w !== "never" && (A.start(), (A.elapsedTime = 0)),
              l(() => ({ frameloop: w }))
          },
          previousRoot: void 0,
          internal: {
            active: !1,
            priority: 0,
            frames: 0,
            lastEvent: Y.createRef(),
            interaction: [],
            hovered: new Map(),
            subscribers: [],
            initialClick: [0, 0],
            initialHits: [],
            capturedMap: new Map(),
            subscribe: (w, A, C) => {
              const R = u().internal
              return (
                (R.priority = R.priority + (A > 0 ? 1 : 0)),
                R.subscribers.push({ ref: w, priority: A, store: C }),
                (R.subscribers = R.subscribers.sort((z, U) => z.priority - U.priority)),
                () => {
                  const z = u().internal
                  z != null &&
                    z.subscribers &&
                    ((z.priority = z.priority - (A > 0 ? 1 : 0)),
                    (z.subscribers = z.subscribers.filter((U) => U.ref !== w)))
                }
              )
            },
          },
        }
      }),
      i = t.getState()
    let r = i.size,
      s = i.viewport.dpr,
      o = i.camera
    return (
      t.subscribe(() => {
        const { camera: l, size: u, viewport: d, gl: p, set: m } = t.getState()
        if (u.width !== r.width || u.height !== r.height || d.dpr !== s) {
          var v
          ;(r = u), (s = d.dpr), s7(l, u), p.setPixelRatio(d.dpr)
          const y =
            (v = u.updateStyle) != null
              ? v
              : typeof HTMLCanvasElement < "u" &&
                p.domElement instanceof HTMLCanvasElement
          p.setSize(u.width, u.height, y)
        }
        l !== o &&
          ((o = l),
          m((y) => ({
            viewport: { ...y.viewport, ...y.viewport.getCurrentViewport(l) },
          })))
      }),
      t.subscribe((l) => n(l)),
      t
    )
  }
let S0,
  u7 = new Set(),
  f7 = new Set(),
  d7 = new Set()
function A_(n, e) {
  if (n.size) for (const { callback: t } of n.values()) t(e)
}
function op(n, e) {
  switch (n) {
    case "before":
      return A_(u7, e)
    case "after":
      return A_(f7, e)
    case "tail":
      return A_(d7, e)
  }
}
let C_, R_
function P_(n, e, t) {
  let i = e.clock.getDelta()
  for (
    e.frameloop === "never" &&
      typeof n == "number" &&
      ((i = n - e.clock.elapsedTime),
      (e.clock.oldTime = e.clock.elapsedTime),
      (e.clock.elapsedTime = n)),
      C_ = e.internal.subscribers,
      S0 = 0;
    S0 < C_.length;
    S0++
  )
    (R_ = C_[S0]), R_.ref.current(R_.store.getState(), i, t)
  return (
    !e.internal.priority && e.gl.render && e.gl.render(e.scene, e.camera),
    (e.internal.frames = Math.max(0, e.internal.frames - 1)),
    e.frameloop === "always" ? 1 : e.internal.frames
  )
}
function h7(n) {
  let e = !1,
    t = !1,
    i,
    r,
    s
  function o(d) {
    ;(r = requestAnimationFrame(o)), (e = !0), (i = 0), op("before", d), (t = !0)
    for (const m of n.values()) {
      var p
      ;(s = m.store.getState()),
        s.internal.active &&
          (s.frameloop === "always" || s.internal.frames > 0) &&
          !((p = s.gl.xr) != null && p.isPresenting) &&
          (i += P_(d, s))
    }
    if (((t = !1), op("after", d), i === 0))
      return op("tail", d), (e = !1), cancelAnimationFrame(r)
  }
  function l(d, p = 1) {
    var m
    if (!d) return n.forEach((v) => l(v.store.getState(), p))
    ;((m = d.gl.xr) != null && m.isPresenting) ||
      !d.internal.active ||
      d.frameloop === "never" ||
      (p > 1
        ? (d.internal.frames = Math.min(60, d.internal.frames + p))
        : t
        ? (d.internal.frames = 2)
        : (d.internal.frames = 1),
      e || ((e = !0), requestAnimationFrame(o)))
  }
  function u(d, p = !0, m, v) {
    if ((p && op("before", d), m)) P_(d, m, v)
    else for (const y of n.values()) P_(d, y.store.getState())
    p && op("after", d)
  }
  return { loop: o, invalidate: l, advance: u }
}
function p7() {
  const n = Y.useContext(PR)
  if (!n) throw new Error("R3F: Hooks can only be used within the Canvas component!")
  return n
}
function m7(n, e = 0) {
  const t = p7(),
    i = t.getState().internal.subscribe,
    r = MR(n)
  return Am(() => i(r, e, t), [e, i, t]), null
}
const Gb = new WeakMap()
function IR(n, e) {
  return function (t, ...i) {
    let r = Gb.get(t)
    return (
      r || ((r = new t()), Gb.set(t, r)),
      n && n(r),
      Promise.all(
        i.map(
          (s) =>
            new Promise((o, l) =>
              r.load(
                s,
                (u) => {
                  u.scene && Object.assign(u, i7(u.scene)), o(u)
                },
                e,
                (u) =>
                  l(
                    new Error(`Could not load ${s}: ${u == null ? void 0 : u.message}`),
                  ),
              ),
            ),
        ),
      )
    )
  }
}
function Cm(n, e, t, i) {
  const r = Array.isArray(e) ? e : [e],
    s = WH(IR(t, i), [n, ...r], { equal: kn.equ })
  return Array.isArray(e) ? s : s[0]
}
Cm.preload = function (n, e, t) {
  const i = Array.isArray(e) ? e : [e]
  return jH(IR(t), [n, ...i])
}
Cm.clear = function (n, e) {
  const t = Array.isArray(e) ? e : [e]
  return XH([n, ...t])
}
const Od = new Map(),
  { invalidate: Wb, advance: jb } = h7(Od),
  { reconciler: Rv, applyProps: dd } = QH(Od, o7),
  hd = { objects: "shallow", strict: !1 },
  g7 = (n, e) => {
    const t = typeof n == "function" ? n(e) : n
    return RR(t)
      ? t
      : new R3({
          powerPreference: "high-performance",
          canvas: e,
          antialias: !0,
          alpha: !0,
          ...n,
        })
  }
function v7(n, e) {
  const t = typeof HTMLCanvasElement < "u" && n instanceof HTMLCanvasElement
  if (e) {
    const { width: i, height: r, top: s, left: o, updateStyle: l = t } = e
    return { width: i, height: r, top: s, left: o, updateStyle: l }
  } else if (
    typeof HTMLCanvasElement < "u" &&
    n instanceof HTMLCanvasElement &&
    n.parentElement
  ) {
    const {
      width: i,
      height: r,
      top: s,
      left: o,
    } = n.parentElement.getBoundingClientRect()
    return { width: i, height: r, top: s, left: o, updateStyle: t }
  } else if (typeof OffscreenCanvas < "u" && n instanceof OffscreenCanvas)
    return { width: n.width, height: n.height, top: 0, left: 0, updateStyle: t }
  return { width: 0, height: 0, top: 0, left: 0 }
}
function y7(n) {
  const e = Od.get(n),
    t = e == null ? void 0 : e.fiber,
    i = e == null ? void 0 : e.store
  e && console.warn("R3F.createRoot should only be called once!")
  const r = typeof reportError == "function" ? reportError : console.error,
    s = i || c7(Wb, jb),
    o = t || Rv.createContainer(s, Td.ConcurrentRoot, null, !1, null, "", r, null)
  e || Od.set(n, { fiber: o, store: s })
  let l,
    u = !1,
    d
  return {
    configure(p = {}) {
      let {
          gl: m,
          size: v,
          scene: y,
          events: x,
          onCreated: E,
          shadows: M = !1,
          linear: w = !1,
          flat: A = !1,
          legacy: C = !1,
          orthographic: R = !1,
          frameloop: z = "always",
          dpr: U = [1, 2],
          performance: O,
          raycaster: N,
          camera: k,
          onPointerMissed: I,
        } = p,
        V = s.getState(),
        Z = V.gl
      V.gl || V.set({ gl: (Z = g7(m, n)) })
      let $ = V.raycaster
      $ || V.set({ raycaster: ($ = new gR()) })
      const { params: ee, ...ue } = N || {}
      if (
        (kn.equ(ue, $, hd) || dd($, { ...ue }),
        kn.equ(ee, $.params, hd) || dd($, { params: { ...$.params, ...ee } }),
        !V.camera || (V.camera === d && !kn.equ(d, k, hd)))
      ) {
        d = k
        const Q = k instanceof xm,
          W = Q ? k : R ? new Xd(0, 0, 0, 0, 0.1, 1e3) : new Ci(75, 0, 0.1, 1e3)
        Q ||
          ((W.position.z = 5),
          k &&
            (dd(W, k),
            ("aspect" in k ||
              "left" in k ||
              "right" in k ||
              "bottom" in k ||
              "top" in k) &&
              ((W.manual = !0), W.updateProjectionMatrix())),
          !V.camera && !(k != null && k.rotation) && W.lookAt(0, 0, 0)),
          V.set({ camera: W }),
          ($.camera = W)
      }
      if (!V.scene) {
        let Q
        y instanceof Zp ? (Q = y) : ((Q = new Zp()), y && dd(Q, y)),
          V.set({ scene: md(Q) })
      }
      if (!V.xr) {
        var re
        const Q = (ye, oe) => {
            const fe = s.getState()
            fe.frameloop !== "never" && jb(ye, !0, fe, oe)
          },
          W = () => {
            const ye = s.getState()
            ;(ye.gl.xr.enabled = ye.gl.xr.isPresenting),
              ye.gl.xr.setAnimationLoop(ye.gl.xr.isPresenting ? Q : null),
              ye.gl.xr.isPresenting || Wb(ye)
          },
          ne = {
            connect() {
              const ye = s.getState().gl
              ye.xr.addEventListener("sessionstart", W),
                ye.xr.addEventListener("sessionend", W)
            },
            disconnect() {
              const ye = s.getState().gl
              ye.xr.removeEventListener("sessionstart", W),
                ye.xr.removeEventListener("sessionend", W)
            },
          }
        typeof ((re = Z.xr) == null ? void 0 : re.addEventListener) == "function" &&
          ne.connect(),
          V.set({ xr: ne })
      }
      if (Z.shadowMap) {
        const Q = Z.shadowMap.enabled,
          W = Z.shadowMap.type
        if (((Z.shadowMap.enabled = !!M), kn.boo(M))) Z.shadowMap.type = Ep
        else if (kn.str(M)) {
          var se
          const ne = { basic: bC, percentage: jv, soft: Ep, variance: go }
          Z.shadowMap.type = (se = ne[M]) != null ? se : Ep
        } else kn.obj(M) && Object.assign(Z.shadowMap, M)
        ;(Q !== Z.shadowMap.enabled || W !== Z.shadowMap.type) &&
          (Z.shadowMap.needsUpdate = !0)
      }
      const G = wR()
      G &&
        ("enabled" in G ? (G.enabled = !C) : "legacyMode" in G && (G.legacyMode = C)),
        u || dd(Z, { outputEncoding: w ? 3e3 : 3001, toneMapping: A ? Xo : Ew }),
        V.legacy !== C && V.set(() => ({ legacy: C })),
        V.linear !== w && V.set(() => ({ linear: w })),
        V.flat !== A && V.set(() => ({ flat: A })),
        m && !kn.fun(m) && !RR(m) && !kn.equ(m, Z, hd) && dd(Z, m),
        x && !V.events.handlers && V.set({ events: x(s) })
      const ie = v7(n, v)
      return (
        kn.equ(ie, V.size, hd) ||
          V.setSize(ie.width, ie.height, ie.updateStyle, ie.top, ie.left),
        U && V.viewport.dpr !== bR(U) && V.setDpr(U),
        V.frameloop !== z && V.setFrameloop(z),
        V.onPointerMissed || V.set({ onPointerMissed: I }),
        O &&
          !kn.equ(O, V.performance, hd) &&
          V.set((Q) => ({ performance: { ...Q.performance, ...O } })),
        (l = E),
        (u = !0),
        this
      )
    },
    render(p) {
      return (
        u || this.configure(),
        Rv.updateContainer(
          D.jsx(x7, { store: s, children: p, onCreated: l, rootElement: n }),
          o,
          null,
          () => {},
        ),
        s
      )
    },
    unmount() {
      LR(n)
    },
  }
}
function x7({ store: n, children: e, onCreated: t, rootElement: i }) {
  return (
    Am(() => {
      const r = n.getState()
      r.set((s) => ({ internal: { ...s.internal, active: !0 } })),
        t && t(r),
        n.getState().events.connected || r.events.connect == null || r.events.connect(i)
    }, []),
    D.jsx(PR.Provider, { value: n, children: e })
  )
}
function LR(n, e) {
  const t = Od.get(n),
    i = t == null ? void 0 : t.fiber
  if (i) {
    const r = t == null ? void 0 : t.store.getState()
    r && (r.internal.active = !1),
      Rv.updateContainer(null, i, null, () => {
        r &&
          setTimeout(() => {
            try {
              var s, o, l, u
              r.events.disconnect == null || r.events.disconnect(),
                (s = r.gl) == null ||
                  (o = s.renderLists) == null ||
                  o.dispose == null ||
                  o.dispose(),
                (l = r.gl) == null ||
                  l.forceContextLoss == null ||
                  l.forceContextLoss(),
                (u = r.gl) != null && u.xr && r.xr.disconnect(),
                r7(r),
                Od.delete(n)
            } catch {}
          }, 500)
      })
  }
}
Rv.injectIntoDevTools({
  bundleType: 0,
  rendererPackageName: "@react-three/fiber",
  version: Y.version,
})
const I_ = {
  onClick: ["click", !1],
  onContextMenu: ["contextmenu", !1],
  onDoubleClick: ["dblclick", !1],
  onWheel: ["wheel", !0],
  onPointerDown: ["pointerdown", !0],
  onPointerUp: ["pointerup", !0],
  onPointerLeave: ["pointerleave", !0],
  onPointerMove: ["pointermove", !0],
  onPointerCancel: ["pointercancel", !0],
  onLostPointerCapture: ["lostpointercapture", !0],
}
function _7(n) {
  const { handlePointer: e } = l7(n)
  return {
    priority: 1,
    enabled: !0,
    compute(t, i, r) {
      i.pointer.set(
        (t.offsetX / i.size.width) * 2 - 1,
        -(t.offsetY / i.size.height) * 2 + 1,
      ),
        i.raycaster.setFromCamera(i.pointer, i.camera)
    },
    connected: void 0,
    handlers: Object.keys(I_).reduce((t, i) => ({ ...t, [i]: e(i) }), {}),
    update: () => {
      var t
      const { events: i, internal: r } = n.getState()
      ;(t = r.lastEvent) != null &&
        t.current &&
        i.handlers &&
        i.handlers.onPointerMove(r.lastEvent.current)
    },
    connect: (t) => {
      var i
      const { set: r, events: s } = n.getState()
      s.disconnect == null || s.disconnect(),
        r((o) => ({ events: { ...o.events, connected: t } })),
        Object.entries((i = s.handlers) != null ? i : []).forEach(([o, l]) => {
          const [u, d] = I_[o]
          t.addEventListener(u, l, { passive: d })
        })
    },
    disconnect: () => {
      const { set: t, events: i } = n.getState()
      if (i.connected) {
        var r
        Object.entries((r = i.handlers) != null ? r : []).forEach(([s, o]) => {
          if (i && i.connected instanceof HTMLElement) {
            const [l] = I_[s]
            i.connected.removeEventListener(l, o)
          }
        }),
          t((s) => ({ events: { ...s.events, connected: void 0 } }))
      }
    },
  }
}
var L_, Xb
function w7() {
  if (Xb) return L_
  Xb = 1
  function n(e, t, i) {
    var r, s, o, l, u
    t == null && (t = 100)
    function d() {
      var m = Date.now() - l
      m < t && m >= 0
        ? (r = setTimeout(d, t - m))
        : ((r = null), i || ((u = e.apply(o, s)), (o = s = null)))
    }
    var p = function () {
      ;(o = this), (s = arguments), (l = Date.now())
      var m = i && !r
      return r || (r = setTimeout(d, t)), m && ((u = e.apply(o, s)), (o = s = null)), u
    }
    return (
      (p.clear = function () {
        r && (clearTimeout(r), (r = null))
      }),
      (p.flush = function () {
        r && ((u = e.apply(o, s)), (o = s = null), clearTimeout(r), (r = null))
      }),
      p
    )
  }
  return (n.debounce = n), (L_ = n), L_
}
var S7 = w7()
const Yb = rm(S7)
var M7 = Object.defineProperty,
  E7 = Object.defineProperties,
  T7 = Object.getOwnPropertyDescriptors,
  qb = Object.getOwnPropertySymbols,
  b7 = Object.prototype.hasOwnProperty,
  A7 = Object.prototype.propertyIsEnumerable,
  $b = (n, e, t) =>
    e in n
      ? M7(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t })
      : (n[e] = t),
  Kb = (n, e) => {
    for (var t in e || (e = {})) b7.call(e, t) && $b(n, t, e[t])
    if (qb) for (var t of qb(e)) A7.call(e, t) && $b(n, t, e[t])
    return n
  },
  C7 = (n, e) => E7(n, T7(e)),
  Zb,
  Jb
typeof window < "u" &&
(((Zb = window.document) != null && Zb.createElement) ||
  ((Jb = window.navigator) == null ? void 0 : Jb.product) === "ReactNative")
  ? Y.useLayoutEffect
  : Y.useEffect
function DR(n, e, t) {
  if (!n) return
  if (t(n) === !0) return n
  let i = n.child
  for (; i; ) {
    const r = DR(i, e, t)
    if (r) return r
    i = i.sibling
  }
}
function NR(n) {
  try {
    return Object.defineProperties(n, {
      _currentRenderer: {
        get() {
          return null
        },
        set() {},
      },
      _currentRenderer2: {
        get() {
          return null
        },
        set() {},
      },
    })
  } catch {
    return n
  }
}
const Qb = console.error
console.error = function () {
  const n = [...arguments].join("")
  if (n != null && n.startsWith("Warning:") && n.includes("useContext")) {
    console.error = Qb
    return
  }
  return Qb.apply(this, arguments)
}
const gS = NR(Y.createContext(null))
class kR extends Y.Component {
  render() {
    return Y.createElement(
      gS.Provider,
      { value: this._reactInternals },
      this.props.children,
    )
  }
}
function R7() {
  const n = Y.useContext(gS)
  if (n === null)
    throw new Error("its-fine: useFiber must be called within a <FiberProvider />!")
  const e = Y.useId()
  return Y.useMemo(() => {
    for (const i of [n, n == null ? void 0 : n.alternate]) {
      if (!i) continue
      const r = DR(i, !1, (s) => {
        let o = s.memoizedState
        for (; o; ) {
          if (o.memoizedState === e) return !0
          o = o.next
        }
      })
      if (r) return r
    }
  }, [n, e])
}
function P7() {
  const n = R7(),
    [e] = Y.useState(() => new Map())
  e.clear()
  let t = n
  for (; t; ) {
    if (t.type && typeof t.type == "object") {
      const r =
        t.type._context === void 0 && t.type.Provider === t.type
          ? t.type
          : t.type._context
      r && r !== gS && !e.has(r) && e.set(r, Y.useContext(NR(r)))
    }
    t = t.return
  }
  return e
}
function I7() {
  const n = P7()
  return Y.useMemo(
    () =>
      Array.from(n.keys()).reduce(
        (e, t) => (i) =>
          Y.createElement(
            e,
            null,
            Y.createElement(t.Provider, C7(Kb({}, i), { value: n.get(t) })),
          ),
        (e) => Y.createElement(kR, Kb({}, e)),
      ),
    [n],
  )
}
function L7(
  { debounce: n, scroll: e, polyfill: t, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1,
  },
) {
  const r = t || (typeof window < "u" && window.ResizeObserver),
    [s, o] = Y.useState({
      left: 0,
      top: 0,
      width: 0,
      height: 0,
      bottom: 0,
      right: 0,
      x: 0,
      y: 0,
    })
  if (!r) return (s.width = 1280), (s.height = 800), [() => {}, s, () => {}]
  const l = Y.useRef({
      element: null,
      scrollContainers: null,
      resizeObserver: null,
      lastBounds: s,
      orientationHandler: null,
    }),
    u = n ? (typeof n == "number" ? n : n.scroll) : null,
    d = n ? (typeof n == "number" ? n : n.resize) : null,
    p = Y.useRef(!1)
  Y.useEffect(() => ((p.current = !0), () => void (p.current = !1)))
  const [m, v, y] = Y.useMemo(() => {
    const w = () => {
      if (!l.current.element) return
      const {
          left: A,
          top: C,
          width: R,
          height: z,
          bottom: U,
          right: O,
          x: N,
          y: k,
        } = l.current.element.getBoundingClientRect(),
        I = { left: A, top: C, width: R, height: z, bottom: U, right: O, x: N, y: k }
      l.current.element instanceof HTMLElement &&
        i &&
        ((I.height = l.current.element.offsetHeight),
        (I.width = l.current.element.offsetWidth)),
        Object.freeze(I),
        p.current && !F7(l.current.lastBounds, I) && o((l.current.lastBounds = I))
    }
    return [w, d ? Yb(w, d) : w, u ? Yb(w, u) : w]
  }, [o, i, u, d])
  function x() {
    l.current.scrollContainers &&
      (l.current.scrollContainers.forEach((w) =>
        w.removeEventListener("scroll", y, !0),
      ),
      (l.current.scrollContainers = null)),
      l.current.resizeObserver &&
        (l.current.resizeObserver.disconnect(), (l.current.resizeObserver = null)),
      l.current.orientationHandler &&
        ("orientation" in screen && "removeEventListener" in screen.orientation
          ? screen.orientation.removeEventListener(
              "change",
              l.current.orientationHandler,
            )
          : "onorientationchange" in window &&
            window.removeEventListener(
              "orientationchange",
              l.current.orientationHandler,
            ))
  }
  function E() {
    var w
    l.current.element &&
      ((l.current.resizeObserver = new r(v)),
      (w = l.current.resizeObserver) == null || w.observe(l.current.element),
      e &&
        l.current.scrollContainers &&
        l.current.scrollContainers.forEach((A) =>
          A.addEventListener("scroll", y, { capture: !0, passive: !0 }),
        ),
      (l.current.orientationHandler = () => {
        y()
      }),
      "orientation" in screen && "addEventListener" in screen.orientation
        ? screen.orientation.addEventListener("change", l.current.orientationHandler)
        : "onorientationchange" in window &&
          window.addEventListener("orientationchange", l.current.orientationHandler))
  }
  const M = (w) => {
    !w ||
      w === l.current.element ||
      (x(), (l.current.element = w), (l.current.scrollContainers = FR(w)), E())
  }
  return (
    N7(y, !!e),
    D7(v),
    Y.useEffect(() => {
      x(), E()
    }, [e, y, v]),
    Y.useEffect(() => x, []),
    [M, s, m]
  )
}
function D7(n) {
  Y.useEffect(() => {
    const e = n
    return (
      window.addEventListener("resize", e),
      () => void window.removeEventListener("resize", e)
    )
  }, [n])
}
function N7(n, e) {
  Y.useEffect(() => {
    if (e) {
      const t = n
      return (
        window.addEventListener("scroll", t, { capture: !0, passive: !0 }),
        () => void window.removeEventListener("scroll", t, !0)
      )
    }
  }, [n, e])
}
function FR(n) {
  const e = []
  if (!n || n === document.body) return e
  const { overflow: t, overflowX: i, overflowY: r } = window.getComputedStyle(n)
  return (
    [t, i, r].some((s) => s === "auto" || s === "scroll") && e.push(n),
    [...e, ...FR(n.parentElement)]
  )
}
const k7 = ["x", "y", "top", "bottom", "left", "right", "width", "height"],
  F7 = (n, e) => k7.every((t) => n[t] === e[t]),
  U7 = Y.forwardRef(function (
    {
      children: e,
      fallback: t,
      resize: i,
      style: r,
      gl: s,
      events: o = _7,
      eventSource: l,
      eventPrefix: u,
      shadows: d,
      linear: p,
      flat: m,
      legacy: v,
      orthographic: y,
      frameloop: x,
      dpr: E,
      performance: M,
      raycaster: w,
      camera: A,
      scene: C,
      onPointerMissed: R,
      onCreated: z,
      ...U
    },
    O,
  ) {
    Y.useMemo(() => JH(UH), [])
    const N = I7(),
      [k, I] = L7({ scroll: !0, debounce: { scroll: 50, resize: 0 }, ...i }),
      V = Y.useRef(null),
      Z = Y.useRef(null)
    Y.useImperativeHandle(O, () => V.current)
    const $ = MR(R),
      [ee, ue] = Y.useState(!1),
      [re, se] = Y.useState(!1)
    if (ee) throw ee
    if (re) throw re
    const G = Y.useRef(null)
    Am(() => {
      const Q = V.current
      I.width > 0 &&
        I.height > 0 &&
        Q &&
        (G.current || (G.current = y7(Q)),
        G.current.configure({
          gl: s,
          events: o,
          shadows: d,
          linear: p,
          flat: m,
          legacy: v,
          orthographic: y,
          frameloop: x,
          dpr: E,
          performance: M,
          raycaster: w,
          camera: A,
          scene: C,
          size: I,
          onPointerMissed: (...W) => ($.current == null ? void 0 : $.current(...W)),
          onCreated: (W) => {
            W.events.connect == null ||
              W.events.connect(l ? (e7(l) ? l.current : l) : Z.current),
              u &&
                W.setEvents({
                  compute: (ne, ye) => {
                    const oe = ne[u + "X"],
                      fe = ne[u + "Y"]
                    ye.pointer.set(
                      (oe / ye.size.width) * 2 - 1,
                      -(fe / ye.size.height) * 2 + 1,
                    ),
                      ye.raycaster.setFromCamera(ye.pointer, ye.camera)
                  },
                }),
              z == null || z(W)
          },
        }),
        G.current.render(
          D.jsx(N, {
            children: D.jsx(ER, {
              set: se,
              children: D.jsx(Y.Suspense, {
                fallback: D.jsx(t7, { set: ue }),
                children: e,
              }),
            }),
          }),
        ))
    }),
      Y.useEffect(() => {
        const Q = V.current
        if (Q) return () => LR(Q)
      }, [])
    const ie = l ? "none" : "auto"
    return D.jsx("div", {
      ref: Z,
      style: {
        position: "relative",
        width: "100%",
        height: "100%",
        overflow: "hidden",
        pointerEvents: ie,
        ...r,
      },
      ...U,
      children: D.jsx("div", {
        ref: k,
        style: { width: "100%", height: "100%" },
        children: D.jsx("canvas", { ref: V, style: { display: "block" }, children: t }),
      }),
    })
  }),
  O7 = Y.forwardRef(function (e, t) {
    return D.jsx(kR, { children: D.jsx(U7, { ...e, ref: t }) })
  }),
  B7 = parseInt(mm.replace(/\D+/g, "")),
  z7 = B7 >= 125 ? "uv1" : "uv2"
var Ns = Uint8Array,
  ec = Uint16Array,
  N1 = Uint32Array,
  UR = new Ns([
    0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5,
    0, 0, 0, 0,
  ]),
  OR = new Ns([
    0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11,
    12, 12, 13, 13, 0, 0,
  ]),
  V7 = new Ns([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15]),
  BR = function (n, e) {
    for (var t = new ec(31), i = 0; i < 31; ++i) t[i] = e += 1 << n[i - 1]
    for (var r = new N1(t[30]), i = 1; i < 30; ++i)
      for (var s = t[i]; s < t[i + 1]; ++s) r[s] = ((s - t[i]) << 5) | i
    return [t, r]
  },
  zR = BR(UR, 2),
  VR = zR[0],
  H7 = zR[1]
;(VR[28] = 258), (H7[258] = 28)
var G7 = BR(OR, 0),
  W7 = G7[0],
  k1 = new ec(32768)
for (var Bn = 0; Bn < 32768; ++Bn) {
  var Gl = ((Bn & 43690) >>> 1) | ((Bn & 21845) << 1)
  ;(Gl = ((Gl & 52428) >>> 2) | ((Gl & 13107) << 2)),
    (Gl = ((Gl & 61680) >>> 4) | ((Gl & 3855) << 4)),
    (k1[Bn] = (((Gl & 65280) >>> 8) | ((Gl & 255) << 8)) >>> 1)
}
var kp = function (n, e, t) {
    for (var i = n.length, r = 0, s = new ec(e); r < i; ++r) ++s[n[r] - 1]
    var o = new ec(e)
    for (r = 0; r < e; ++r) o[r] = (o[r - 1] + s[r - 1]) << 1
    var l
    if (t) {
      l = new ec(1 << e)
      var u = 15 - e
      for (r = 0; r < i; ++r)
        if (n[r])
          for (
            var d = (r << 4) | n[r],
              p = e - n[r],
              m = o[n[r] - 1]++ << p,
              v = m | ((1 << p) - 1);
            m <= v;
            ++m
          )
            l[k1[m] >>> u] = d
    } else
      for (l = new ec(i), r = 0; r < i; ++r)
        n[r] && (l[r] = k1[o[n[r] - 1]++] >>> (15 - n[r]))
    return l
  },
  Rm = new Ns(288)
for (var Bn = 0; Bn < 144; ++Bn) Rm[Bn] = 8
for (var Bn = 144; Bn < 256; ++Bn) Rm[Bn] = 9
for (var Bn = 256; Bn < 280; ++Bn) Rm[Bn] = 7
for (var Bn = 280; Bn < 288; ++Bn) Rm[Bn] = 8
var HR = new Ns(32)
for (var Bn = 0; Bn < 32; ++Bn) HR[Bn] = 5
var j7 = kp(Rm, 9, 1),
  X7 = kp(HR, 5, 1),
  D_ = function (n) {
    for (var e = n[0], t = 1; t < n.length; ++t) n[t] > e && (e = n[t])
    return e
  },
  ho = function (n, e, t) {
    var i = (e / 8) | 0
    return ((n[i] | (n[i + 1] << 8)) >> (e & 7)) & t
  },
  N_ = function (n, e) {
    var t = (e / 8) | 0
    return (n[t] | (n[t + 1] << 8) | (n[t + 2] << 16)) >> (e & 7)
  },
  Y7 = function (n) {
    return ((n / 8) | 0) + (n & 7 && 1)
  },
  q7 = function (n, e, t) {
    ;(t == null || t > n.length) && (t = n.length)
    var i = new (n instanceof ec ? ec : n instanceof N1 ? N1 : Ns)(t - e)
    return i.set(n.subarray(e, t)), i
  },
  $7 = function (n, e, t) {
    var i = n.length
    if (!i || (t && !t.l && i < 5)) return e || new Ns(0)
    var r = !e || t,
      s = !t || t.i
    t || (t = {}), e || (e = new Ns(i * 3))
    var o = function (we) {
        var me = e.length
        if (we > me) {
          var Fe = new Ns(Math.max(me * 2, we))
          Fe.set(e), (e = Fe)
        }
      },
      l = t.f || 0,
      u = t.p || 0,
      d = t.b || 0,
      p = t.l,
      m = t.d,
      v = t.m,
      y = t.n,
      x = i * 8
    do {
      if (!p) {
        t.f = l = ho(n, u, 1)
        var E = ho(n, u + 1, 3)
        if (((u += 3), E))
          if (E == 1) (p = j7), (m = X7), (v = 9), (y = 5)
          else if (E == 2) {
            var C = ho(n, u, 31) + 257,
              R = ho(n, u + 10, 15) + 4,
              z = C + ho(n, u + 5, 31) + 1
            u += 14
            for (var U = new Ns(z), O = new Ns(19), N = 0; N < R; ++N)
              O[V7[N]] = ho(n, u + N * 3, 7)
            u += R * 3
            for (var k = D_(O), I = (1 << k) - 1, V = kp(O, k, 1), N = 0; N < z; ) {
              var Z = V[ho(n, u, I)]
              u += Z & 15
              var M = Z >>> 4
              if (M < 16) U[N++] = M
              else {
                var $ = 0,
                  ee = 0
                for (
                  M == 16
                    ? ((ee = 3 + ho(n, u, 3)), (u += 2), ($ = U[N - 1]))
                    : M == 17
                    ? ((ee = 3 + ho(n, u, 7)), (u += 3))
                    : M == 18 && ((ee = 11 + ho(n, u, 127)), (u += 7));
                  ee--;

                )
                  U[N++] = $
              }
            }
            var ue = U.subarray(0, C),
              re = U.subarray(C)
            ;(v = D_(ue)), (y = D_(re)), (p = kp(ue, v, 1)), (m = kp(re, y, 1))
          } else throw "invalid block type"
        else {
          var M = Y7(u) + 4,
            w = n[M - 4] | (n[M - 3] << 8),
            A = M + w
          if (A > i) {
            if (s) throw "unexpected EOF"
            break
          }
          r && o(d + w), e.set(n.subarray(M, A), d), (t.b = d += w), (t.p = u = A * 8)
          continue
        }
        if (u > x) {
          if (s) throw "unexpected EOF"
          break
        }
      }
      r && o(d + 131072)
      for (var se = (1 << v) - 1, G = (1 << y) - 1, ie = u; ; ie = u) {
        var $ = p[N_(n, u) & se],
          Q = $ >>> 4
        if (((u += $ & 15), u > x)) {
          if (s) throw "unexpected EOF"
          break
        }
        if (!$) throw "invalid length/literal"
        if (Q < 256) e[d++] = Q
        else if (Q == 256) {
          ;(ie = u), (p = null)
          break
        } else {
          var W = Q - 254
          if (Q > 264) {
            var N = Q - 257,
              ne = UR[N]
            ;(W = ho(n, u, (1 << ne) - 1) + VR[N]), (u += ne)
          }
          var ye = m[N_(n, u) & G],
            oe = ye >>> 4
          if (!ye) throw "invalid distance"
          u += ye & 15
          var re = W7[oe]
          if (oe > 3) {
            var ne = OR[oe]
            ;(re += N_(n, u) & ((1 << ne) - 1)), (u += ne)
          }
          if (u > x) {
            if (s) throw "unexpected EOF"
            break
          }
          r && o(d + 131072)
          for (var fe = d + W; d < fe; d += 4)
            (e[d] = e[d - re]),
              (e[d + 1] = e[d + 1 - re]),
              (e[d + 2] = e[d + 2 - re]),
              (e[d + 3] = e[d + 3 - re])
          d = fe
        }
      }
      ;(t.l = p), (t.p = ie), (t.b = d), p && ((l = 1), (t.m = v), (t.d = m), (t.n = y))
    } while (!l)
    return d == e.length ? e : q7(e, 0, d)
  },
  K7 = new Ns(0),
  Z7 = function (n) {
    if ((n[0] & 15) != 8 || n[0] >>> 4 > 7 || ((n[0] << 8) | n[1]) % 31)
      throw "invalid zlib data"
    if (n[1] & 32) throw "invalid zlib data: preset dictionaries not supported"
  }
function J7(n, e) {
  return $7((Z7(n), n.subarray(2, -4)), e)
}
var Q7 = typeof TextDecoder < "u" && new TextDecoder(),
  e9 = 0
try {
  Q7.decode(K7, { stream: !0 }), (e9 = 1)
} catch {}
function GR(n) {
  if (typeof TextDecoder < "u") return new TextDecoder().decode(n)
  let e = ""
  for (let t = 0, i = n.length; t < i; t++) e += String.fromCharCode(n[t])
  try {
    return decodeURIComponent(escape(e))
  } catch {
    return e
  }
}
function WR(n, e, t) {
  const i = t.length - n - 1
  if (e >= t[i]) return i - 1
  if (e <= t[n]) return n
  let r = n,
    s = i,
    o = Math.floor((r + s) / 2)
  for (; e < t[o] || e >= t[o + 1]; )
    e < t[o] ? (s = o) : (r = o), (o = Math.floor((r + s) / 2))
  return o
}
function t9(n, e, t, i) {
  const r = [],
    s = [],
    o = []
  r[0] = 1
  for (let l = 1; l <= t; ++l) {
    ;(s[l] = e - i[n + 1 - l]), (o[l] = i[n + l] - e)
    let u = 0
    for (let d = 0; d < l; ++d) {
      const p = o[d + 1],
        m = s[l - d],
        v = r[d] / (p + m)
      ;(r[d] = u + p * v), (u = m * v)
    }
    r[l] = u
  }
  return r
}
function n9(n, e, t, i) {
  const r = WR(n, i, e),
    s = t9(r, i, n, e),
    o = new on(0, 0, 0, 0)
  for (let l = 0; l <= n; ++l) {
    const u = t[r - n + l],
      d = s[l],
      p = u.w * d
    ;(o.x += u.x * p), (o.y += u.y * p), (o.z += u.z * p), (o.w += u.w * d)
  }
  return o
}
function i9(n, e, t, i, r) {
  const s = []
  for (let m = 0; m <= t; ++m) s[m] = 0
  const o = []
  for (let m = 0; m <= i; ++m) o[m] = s.slice(0)
  const l = []
  for (let m = 0; m <= t; ++m) l[m] = s.slice(0)
  l[0][0] = 1
  const u = s.slice(0),
    d = s.slice(0)
  for (let m = 1; m <= t; ++m) {
    ;(u[m] = e - r[n + 1 - m]), (d[m] = r[n + m] - e)
    let v = 0
    for (let y = 0; y < m; ++y) {
      const x = d[y + 1],
        E = u[m - y]
      l[m][y] = x + E
      const M = l[y][m - 1] / l[m][y]
      ;(l[y][m] = v + x * M), (v = E * M)
    }
    l[m][m] = v
  }
  for (let m = 0; m <= t; ++m) o[0][m] = l[m][t]
  for (let m = 0; m <= t; ++m) {
    let v = 0,
      y = 1
    const x = []
    for (let E = 0; E <= t; ++E) x[E] = s.slice(0)
    x[0][0] = 1
    for (let E = 1; E <= i; ++E) {
      let M = 0
      const w = m - E,
        A = t - E
      m >= E && ((x[y][0] = x[v][0] / l[A + 1][w]), (M = x[y][0] * l[w][A]))
      const C = w >= -1 ? 1 : -w,
        R = m - 1 <= A ? E - 1 : t - m
      for (let U = C; U <= R; ++U)
        (x[y][U] = (x[v][U] - x[v][U - 1]) / l[A + 1][w + U]),
          (M += x[y][U] * l[w + U][A])
      m <= A && ((x[y][E] = -x[v][E - 1] / l[A + 1][m]), (M += x[y][E] * l[m][A])),
        (o[E][m] = M)
      const z = v
      ;(v = y), (y = z)
    }
  }
  let p = t
  for (let m = 1; m <= i; ++m) {
    for (let v = 0; v <= t; ++v) o[m][v] *= p
    p *= t - m
  }
  return o
}
function r9(n, e, t, i, r) {
  const s = r < n ? r : n,
    o = [],
    l = WR(n, i, e),
    u = i9(l, i, n, s, e),
    d = []
  for (let p = 0; p < t.length; ++p) {
    const m = t[p].clone(),
      v = m.w
    ;(m.x *= v), (m.y *= v), (m.z *= v), (d[p] = m)
  }
  for (let p = 0; p <= s; ++p) {
    const m = d[l - n].clone().multiplyScalar(u[p][0])
    for (let v = 1; v <= n; ++v) m.add(d[l - n + v].clone().multiplyScalar(u[p][v]))
    o[p] = m
  }
  for (let p = s + 1; p <= r + 1; ++p) o[p] = new on(0, 0, 0)
  return o
}
function s9(n, e) {
  let t = 1
  for (let r = 2; r <= n; ++r) t *= r
  let i = 1
  for (let r = 2; r <= e; ++r) i *= r
  for (let r = 2; r <= n - e; ++r) i *= r
  return t / i
}
function o9(n) {
  const e = n.length,
    t = [],
    i = []
  for (let s = 0; s < e; ++s) {
    const o = n[s]
    ;(t[s] = new q(o.x, o.y, o.z)), (i[s] = o.w)
  }
  const r = []
  for (let s = 0; s < e; ++s) {
    const o = t[s].clone()
    for (let l = 1; l <= s; ++l) o.sub(r[s - l].clone().multiplyScalar(s9(s, l) * i[l]))
    r[s] = o.divideScalar(i[0])
  }
  return r
}
function a9(n, e, t, i, r) {
  const s = r9(n, e, t, i, r)
  return o9(s)
}
class eA extends Os {
  constructor(e, t, i, r, s) {
    super(),
      (this.degree = e),
      (this.knots = t),
      (this.controlPoints = []),
      (this.startKnot = r || 0),
      (this.endKnot = s || this.knots.length - 1)
    for (let o = 0; o < i.length; ++o) {
      const l = i[o]
      this.controlPoints[o] = new on(l.x, l.y, l.z, l.w)
    }
  }
  getPoint(e, t) {
    const i = t || new q(),
      r =
        this.knots[this.startKnot] +
        e * (this.knots[this.endKnot] - this.knots[this.startKnot]),
      s = n9(this.degree, this.knots, this.controlPoints, r)
    return s.w != 1 && s.divideScalar(s.w), i.set(s.x, s.y, s.z)
  }
  getTangent(e, t) {
    const i = t || new q(),
      r = this.knots[0] + e * (this.knots[this.knots.length - 1] - this.knots[0]),
      s = a9(this.degree, this.knots, this.controlPoints, r, 1)
    return i.copy(s[1]).normalize(), i
  }
}
let rn, ci, $r
class vS extends Dr {
  constructor(e) {
    super(e)
  }
  load(e, t, i, r) {
    const s = this,
      o = s.path === "" ? Cv.extractUrlBase(e) : s.path,
      l = new Ko(this.manager)
    l.setPath(s.path),
      l.setResponseType("arraybuffer"),
      l.setRequestHeader(s.requestHeader),
      l.setWithCredentials(s.withCredentials),
      l.load(
        e,
        function (u) {
          try {
            t(s.parse(u, o))
          } catch (d) {
            r ? r(d) : console.error(d), s.manager.itemError(e)
          }
        },
        i,
        r,
      )
  }
  parse(e, t) {
    if (h9(e)) rn = new d9().parse(e)
    else {
      const r = qR(e)
      if (!p9(r)) throw new Error("THREE.FBXLoader: Unknown format.")
      if (nA(r) < 7e3)
        throw new Error(
          "THREE.FBXLoader: FBX version not supported, FileVersion: " + nA(r),
        )
      rn = new f9().parse(r)
    }
    const i = new oR(this.manager)
      .setPath(this.resourcePath || t)
      .setCrossOrigin(this.crossOrigin)
    return new l9(i, this.manager).parse(rn)
  }
}
class l9 {
  constructor(e, t) {
    ;(this.textureLoader = e), (this.manager = t)
  }
  parse() {
    ci = this.parseConnections()
    const e = this.parseImages(),
      t = this.parseTextures(e),
      i = this.parseMaterials(t),
      r = this.parseDeformers(),
      s = new c9().parse(r)
    return this.parseScene(r, s, i), $r
  }
  parseConnections() {
    const e = new Map()
    return (
      "Connections" in rn &&
        rn.Connections.connections.forEach(function (i) {
          const r = i[0],
            s = i[1],
            o = i[2]
          e.has(r) || e.set(r, { parents: [], children: [] })
          const l = { ID: s, relationship: o }
          e.get(r).parents.push(l), e.has(s) || e.set(s, { parents: [], children: [] })
          const u = { ID: r, relationship: o }
          e.get(s).children.push(u)
        }),
      e
    )
  }
  parseImages() {
    const e = {},
      t = {}
    if ("Video" in rn.Objects) {
      const i = rn.Objects.Video
      for (const r in i) {
        const s = i[r],
          o = parseInt(r)
        if (((e[o] = s.RelativeFilename || s.Filename), "Content" in s)) {
          const l = s.Content instanceof ArrayBuffer && s.Content.byteLength > 0,
            u = typeof s.Content == "string" && s.Content !== ""
          if (l || u) {
            const d = this.parseImage(i[r])
            t[s.RelativeFilename || s.Filename] = d
          }
        }
      }
    }
    for (const i in e) {
      const r = e[i]
      t[r] !== void 0 ? (e[i] = t[r]) : (e[i] = e[i].split("\\").pop())
    }
    return e
  }
  parseImage(e) {
    const t = e.Content,
      i = e.RelativeFilename || e.Filename,
      r = i.slice(i.lastIndexOf(".") + 1).toLowerCase()
    let s
    switch (r) {
      case "bmp":
        s = "image/bmp"
        break
      case "jpg":
      case "jpeg":
        s = "image/jpeg"
        break
      case "png":
        s = "image/png"
        break
      case "tif":
        s = "image/tiff"
        break
      case "tga":
        this.manager.getHandler(".tga") === null &&
          console.warn("FBXLoader: TGA loader not found, skipping ", i),
          (s = "image/tga")
        break
      default:
        console.warn('FBXLoader: Image type "' + r + '" is not supported.')
        return
    }
    if (typeof t == "string") return "data:" + s + ";base64," + t
    {
      const o = new Uint8Array(t)
      return window.URL.createObjectURL(new Blob([o], { type: s }))
    }
  }
  parseTextures(e) {
    const t = new Map()
    if ("Texture" in rn.Objects) {
      const i = rn.Objects.Texture
      for (const r in i) {
        const s = this.parseTexture(i[r], e)
        t.set(parseInt(r), s)
      }
    }
    return t
  }
  parseTexture(e, t) {
    const i = this.loadTexture(e, t)
    ;(i.ID = e.id), (i.name = e.attrName)
    const r = e.WrapModeU,
      s = e.WrapModeV,
      o = r !== void 0 ? r.value : 0,
      l = s !== void 0 ? s.value : 0
    if (
      ((i.wrapS = o === 0 ? Lu : Jr), (i.wrapT = l === 0 ? Lu : Jr), "Scaling" in e)
    ) {
      const u = e.Scaling.value
      ;(i.repeat.x = u[0]), (i.repeat.y = u[1])
    }
    return i
  }
  loadTexture(e, t) {
    let i
    const r = this.textureLoader.path,
      s = ci.get(e.id).children
    s !== void 0 &&
      s.length > 0 &&
      t[s[0].ID] !== void 0 &&
      ((i = t[s[0].ID]),
      (i.indexOf("blob:") === 0 || i.indexOf("data:") === 0) &&
        this.textureLoader.setPath(void 0))
    let o
    const l = e.FileName.slice(-3).toLowerCase()
    if (l === "tga") {
      const u = this.manager.getHandler(".tga")
      u === null
        ? (console.warn(
            "FBXLoader: TGA loader not found, creating placeholder texture for",
            e.RelativeFilename,
          ),
          (o = new zn()))
        : (u.setPath(this.textureLoader.path), (o = u.load(i)))
    } else
      l === "psd"
        ? (console.warn(
            "FBXLoader: PSD textures are not supported, creating placeholder texture for",
            e.RelativeFilename,
          ),
          (o = new zn()))
        : (o = this.textureLoader.load(i))
    return this.textureLoader.setPath(r), o
  }
  parseMaterials(e) {
    const t = new Map()
    if ("Material" in rn.Objects) {
      const i = rn.Objects.Material
      for (const r in i) {
        const s = this.parseMaterial(i[r], e)
        s !== null && t.set(parseInt(r), s)
      }
    }
    return t
  }
  parseMaterial(e, t) {
    const i = e.id,
      r = e.attrName
    let s = e.ShadingModel
    if ((typeof s == "object" && (s = s.value), !ci.has(i))) return null
    const o = this.parseParameters(e, t, i)
    let l
    switch (s.toLowerCase()) {
      case "phong":
        l = new Np()
        break
      case "lambert":
        l = new eS()
        break
      default:
        console.warn(
          'THREE.FBXLoader: unknown material type "%s". Defaulting to MeshPhongMaterial.',
          s,
        ),
          (l = new Np())
        break
    }
    return l.setValues(o), (l.name = r), l
  }
  parseParameters(e, t, i) {
    const r = {}
    e.BumpFactor && (r.bumpScale = e.BumpFactor.value),
      e.Diffuse
        ? (r.color = new ot().fromArray(e.Diffuse.value))
        : e.DiffuseColor &&
          (e.DiffuseColor.type === "Color" || e.DiffuseColor.type === "ColorRGB") &&
          (r.color = new ot().fromArray(e.DiffuseColor.value)),
      e.DisplacementFactor && (r.displacementScale = e.DisplacementFactor.value),
      e.Emissive
        ? (r.emissive = new ot().fromArray(e.Emissive.value))
        : e.EmissiveColor &&
          (e.EmissiveColor.type === "Color" || e.EmissiveColor.type === "ColorRGB") &&
          (r.emissive = new ot().fromArray(e.EmissiveColor.value)),
      e.EmissiveFactor && (r.emissiveIntensity = parseFloat(e.EmissiveFactor.value)),
      e.Opacity && (r.opacity = parseFloat(e.Opacity.value)),
      r.opacity < 1 && (r.transparent = !0),
      e.ReflectionFactor && (r.reflectivity = e.ReflectionFactor.value),
      e.Shininess && (r.shininess = e.Shininess.value),
      e.Specular
        ? (r.specular = new ot().fromArray(e.Specular.value))
        : e.SpecularColor &&
          e.SpecularColor.type === "Color" &&
          (r.specular = new ot().fromArray(e.SpecularColor.value))
    const s = this
    return (
      ci.get(i).children.forEach(function (o) {
        const l = o.relationship
        switch (l) {
          case "Bump":
            r.bumpMap = s.getTexture(t, o.ID)
            break
          case "Maya|TEX_ao_map":
            r.aoMap = s.getTexture(t, o.ID)
            break
          case "DiffuseColor":
          case "Maya|TEX_color_map":
            ;(r.map = s.getTexture(t, o.ID)),
              r.map !== void 0 &&
                ("colorSpace" in r.map
                  ? (r.map.colorSpace = "srgb")
                  : (r.map.encoding = 3001))
            break
          case "DisplacementColor":
            r.displacementMap = s.getTexture(t, o.ID)
            break
          case "EmissiveColor":
            ;(r.emissiveMap = s.getTexture(t, o.ID)),
              r.emissiveMap !== void 0 &&
                ("colorSpace" in r.emissiveMap
                  ? (r.emissiveMap.colorSpace = "srgb")
                  : (r.emissiveMap.encoding = 3001))
            break
          case "NormalMap":
          case "Maya|TEX_normal_map":
            r.normalMap = s.getTexture(t, o.ID)
            break
          case "ReflectionColor":
            ;(r.envMap = s.getTexture(t, o.ID)),
              r.envMap !== void 0 &&
                ((r.envMap.mapping = Pd),
                "colorSpace" in r.envMap
                  ? (r.envMap.colorSpace = "srgb")
                  : (r.envMap.encoding = 3001))
            break
          case "SpecularColor":
            ;(r.specularMap = s.getTexture(t, o.ID)),
              r.specularMap !== void 0 &&
                ("colorSpace" in r.specularMap
                  ? (r.specularMap.colorSpace = "srgb")
                  : (r.specularMap.encoding = 3001))
            break
          case "TransparentColor":
          case "TransparencyFactor":
            ;(r.alphaMap = s.getTexture(t, o.ID)), (r.transparent = !0)
            break
          case "AmbientColor":
          case "ShininessExponent":
          case "SpecularFactor":
          case "VectorDisplacementColor":
          default:
            console.warn(
              "THREE.FBXLoader: %s map is not supported in three.js, skipping texture.",
              l,
            )
            break
        }
      }),
      r
    )
  }
  getTexture(e, t) {
    return (
      "LayeredTexture" in rn.Objects &&
        t in rn.Objects.LayeredTexture &&
        (console.warn(
          "THREE.FBXLoader: layered textures are not supported in three.js. Discarding all but first layer.",
        ),
        (t = ci.get(t).children[0].ID)),
      e.get(t)
    )
  }
  parseDeformers() {
    const e = {},
      t = {}
    if ("Deformer" in rn.Objects) {
      const i = rn.Objects.Deformer
      for (const r in i) {
        const s = i[r],
          o = ci.get(parseInt(r))
        if (s.attrType === "Skin") {
          const l = this.parseSkeleton(o, i)
          ;(l.ID = r),
            o.parents.length > 1 &&
              console.warn(
                "THREE.FBXLoader: skeleton attached to more than one geometry is not supported.",
              ),
            (l.geometryID = o.parents[0].ID),
            (e[r] = l)
        } else if (s.attrType === "BlendShape") {
          const l = { id: r }
          ;(l.rawTargets = this.parseMorphTargets(o, i)),
            (l.id = r),
            o.parents.length > 1 &&
              console.warn(
                "THREE.FBXLoader: morph target attached to more than one geometry is not supported.",
              ),
            (t[r] = l)
        }
      }
    }
    return { skeletons: e, morphTargets: t }
  }
  parseSkeleton(e, t) {
    const i = []
    return (
      e.children.forEach(function (r) {
        const s = t[r.ID]
        if (s.attrType !== "Cluster") return
        const o = {
          ID: r.ID,
          indices: [],
          weights: [],
          transformLink: new mt().fromArray(s.TransformLink.a),
        }
        "Indexes" in s && ((o.indices = s.Indexes.a), (o.weights = s.Weights.a)),
          i.push(o)
      }),
      { rawBones: i, bones: [] }
    )
  }
  parseMorphTargets(e, t) {
    const i = []
    for (let r = 0; r < e.children.length; r++) {
      const s = e.children[r],
        o = t[s.ID],
        l = {
          name: o.attrName,
          initialWeight: o.DeformPercent,
          id: o.id,
          fullWeights: o.FullWeights.a,
        }
      if (o.attrType !== "BlendShapeChannel") return
      ;(l.geoID = ci.get(parseInt(s.ID)).children.filter(function (u) {
        return u.relationship === void 0
      })[0].ID),
        i.push(l)
    }
    return i
  }
  parseScene(e, t, i) {
    $r = new Ql()
    const r = this.parseModels(e.skeletons, t, i),
      s = rn.Objects.Model,
      o = this
    r.forEach(function (u) {
      const d = s[u.ID]
      o.setLookAtProperties(u, d),
        ci.get(u.ID).parents.forEach(function (m) {
          const v = r.get(m.ID)
          v !== void 0 && v.add(u)
        }),
        u.parent === null && $r.add(u)
    }),
      this.bindSkeleton(e.skeletons, t, r),
      this.createAmbientLight(),
      $r.traverse(function (u) {
        if (u.userData.transformData) {
          u.parent &&
            ((u.userData.transformData.parentMatrix = u.parent.matrix),
            (u.userData.transformData.parentMatrixWorld = u.parent.matrixWorld))
          const d = XR(u.userData.transformData)
          u.applyMatrix4(d), u.updateWorldMatrix()
        }
      })
    const l = new u9().parse()
    $r.children.length === 1 &&
      $r.children[0].isGroup &&
      (($r.children[0].animations = l), ($r = $r.children[0])),
      ($r.animations = l)
  }
  parseModels(e, t, i) {
    const r = new Map(),
      s = rn.Objects.Model
    for (const o in s) {
      const l = parseInt(o),
        u = s[o],
        d = ci.get(l)
      let p = this.buildSkeleton(d, e, l, u.attrName)
      if (!p) {
        switch (u.attrType) {
          case "Camera":
            p = this.createCamera(d)
            break
          case "Light":
            p = this.createLight(d)
            break
          case "Mesh":
            p = this.createMesh(d, t, i)
            break
          case "NurbsCurve":
            p = this.createCurve(d, t)
            break
          case "LimbNode":
          case "Root":
            p = new Jp()
            break
          case "Null":
          default:
            p = new Ql()
            break
        }
        ;(p.name = u.attrName ? sn.sanitizeNodeName(u.attrName) : ""), (p.ID = l)
      }
      this.getTransformData(p, u), r.set(l, p)
    }
    return r
  }
  buildSkeleton(e, t, i, r) {
    let s = null
    return (
      e.parents.forEach(function (o) {
        for (const l in t) {
          const u = t[l]
          u.rawBones.forEach(function (d, p) {
            if (d.ID === o.ID) {
              const m = s
              ;(s = new Jp()),
                s.matrixWorld.copy(d.transformLink),
                (s.name = r ? sn.sanitizeNodeName(r) : ""),
                (s.ID = i),
                (u.bones[p] = s),
                m !== null && s.add(m)
            }
          })
        }
      }),
      s
    )
  }
  createCamera(e) {
    let t, i
    if (
      (e.children.forEach(function (r) {
        const s = rn.Objects.NodeAttribute[r.ID]
        s !== void 0 && (i = s)
      }),
      i === void 0)
    )
      t = new cn()
    else {
      let r = 0
      i.CameraProjectionType !== void 0 && i.CameraProjectionType.value === 1 && (r = 1)
      let s = 1
      i.NearPlane !== void 0 && (s = i.NearPlane.value / 1e3)
      let o = 1e3
      i.FarPlane !== void 0 && (o = i.FarPlane.value / 1e3)
      let l = window.innerWidth,
        u = window.innerHeight
      i.AspectWidth !== void 0 &&
        i.AspectHeight !== void 0 &&
        ((l = i.AspectWidth.value), (u = i.AspectHeight.value))
      const d = l / u
      let p = 45
      i.FieldOfView !== void 0 && (p = i.FieldOfView.value)
      const m = i.FocalLength ? i.FocalLength.value : null
      switch (r) {
        case 0:
          ;(t = new Ci(p, d, s, o)), m !== null && t.setFocalLength(m)
          break
        case 1:
          t = new Xd(-l / 2, l / 2, u / 2, -u / 2, s, o)
          break
        default:
          console.warn("THREE.FBXLoader: Unknown camera type " + r + "."),
            (t = new cn())
          break
      }
    }
    return t
  }
  createLight(e) {
    let t, i
    if (
      (e.children.forEach(function (r) {
        const s = rn.Objects.NodeAttribute[r.ID]
        s !== void 0 && (i = s)
      }),
      i === void 0)
    )
      t = new cn()
    else {
      let r
      i.LightType === void 0 ? (r = 0) : (r = i.LightType.value)
      let s = 16777215
      i.Color !== void 0 && (s = new ot().fromArray(i.Color.value))
      let o = i.Intensity === void 0 ? 1 : i.Intensity.value / 100
      i.CastLightOnObject !== void 0 && i.CastLightOnObject.value === 0 && (o = 0)
      let l = 0
      i.FarAttenuationEnd !== void 0 &&
        (i.EnableFarAttenuation !== void 0 && i.EnableFarAttenuation.value === 0
          ? (l = 0)
          : (l = i.FarAttenuationEnd.value))
      const u = 1
      switch (r) {
        case 0:
          t = new Av(s, o, l, u)
          break
        case 1:
          t = new aS(s, o)
          break
        case 2:
          let d = Math.PI / 3
          i.InnerAngle !== void 0 && (d = yo.degToRad(i.InnerAngle.value))
          let p = 0
          i.OuterAngle !== void 0 &&
            ((p = yo.degToRad(i.OuterAngle.value)), (p = Math.max(p, 1))),
            (t = new oS(s, o, l, d, p, u))
          break
        default:
          console.warn(
            "THREE.FBXLoader: Unknown light type " +
              i.LightType.value +
              ", defaulting to a PointLight.",
          ),
            (t = new Av(s, o))
          break
      }
      i.CastShadows !== void 0 && i.CastShadows.value === 1 && (t.castShadow = !0)
    }
    return t
  }
  createMesh(e, t, i) {
    let r,
      s = null,
      o = null
    const l = []
    return (
      e.children.forEach(function (u) {
        t.has(u.ID) && (s = t.get(u.ID)), i.has(u.ID) && l.push(i.get(u.ID))
      }),
      l.length > 1
        ? (o = l)
        : l.length > 0
        ? (o = l[0])
        : ((o = new Np({ color: 13421772 })), l.push(o)),
      "color" in s.attributes &&
        l.forEach(function (u) {
          u.vertexColors = !0
        }),
      s.FBX_Deformer
        ? ((r = new jw(s, o)), r.normalizeSkinWeights())
        : (r = new ui(s, o)),
      r
    )
  }
  createCurve(e, t) {
    const i = e.children.reduce(function (s, o) {
        return t.has(o.ID) && (s = t.get(o.ID)), s
      }, null),
      r = new mr({ color: 3342591, linewidth: 1 })
    return new Ja(i, r)
  }
  getTransformData(e, t) {
    const i = {}
    "InheritType" in t && (i.inheritType = parseInt(t.InheritType.value)),
      "RotationOrder" in t
        ? (i.eulerOrder = YR(t.RotationOrder.value))
        : (i.eulerOrder = "ZYX"),
      "Lcl_Translation" in t && (i.translation = t.Lcl_Translation.value),
      "PreRotation" in t && (i.preRotation = t.PreRotation.value),
      "Lcl_Rotation" in t && (i.rotation = t.Lcl_Rotation.value),
      "PostRotation" in t && (i.postRotation = t.PostRotation.value),
      "Lcl_Scaling" in t && (i.scale = t.Lcl_Scaling.value),
      "ScalingOffset" in t && (i.scalingOffset = t.ScalingOffset.value),
      "ScalingPivot" in t && (i.scalingPivot = t.ScalingPivot.value),
      "RotationOffset" in t && (i.rotationOffset = t.RotationOffset.value),
      "RotationPivot" in t && (i.rotationPivot = t.RotationPivot.value),
      (e.userData.transformData = i)
  }
  setLookAtProperties(e, t) {
    "LookAtProperty" in t &&
      ci.get(e.ID).children.forEach(function (r) {
        if (r.relationship === "LookAtProperty") {
          const s = rn.Objects.Model[r.ID]
          if ("Lcl_Translation" in s) {
            const o = s.Lcl_Translation.value
            e.target !== void 0
              ? (e.target.position.fromArray(o), $r.add(e.target))
              : e.lookAt(new q().fromArray(o))
          }
        }
      })
  }
  bindSkeleton(e, t, i) {
    const r = this.parsePoseNodes()
    for (const s in e) {
      const o = e[s]
      ci.get(parseInt(o.ID)).parents.forEach(function (u) {
        if (t.has(u.ID)) {
          const d = u.ID
          ci.get(d).parents.forEach(function (m) {
            i.has(m.ID) && i.get(m.ID).bind(new Sm(o.bones), r[m.ID])
          })
        }
      })
    }
  }
  parsePoseNodes() {
    const e = {}
    if ("Pose" in rn.Objects) {
      const t = rn.Objects.Pose
      for (const i in t)
        if (t[i].attrType === "BindPose" && t[i].NbPoseNodes > 0) {
          const r = t[i].PoseNode
          Array.isArray(r)
            ? r.forEach(function (s) {
                e[s.Node] = new mt().fromArray(s.Matrix.a)
              })
            : (e[r.Node] = new mt().fromArray(r.Matrix.a))
        }
    }
    return e
  }
  createAmbientLight() {
    if ("GlobalSettings" in rn && "AmbientColor" in rn.GlobalSettings) {
      const e = rn.GlobalSettings.AmbientColor.value,
        t = e[0],
        i = e[1],
        r = e[2]
      if (t !== 0 || i !== 0 || r !== 0) {
        const s = new ot(t, i, r)
        $r.add(new lS(s, 1))
      }
    }
  }
}
class c9 {
  parse(e) {
    const t = new Map()
    if ("Geometry" in rn.Objects) {
      const i = rn.Objects.Geometry
      for (const r in i) {
        const s = ci.get(parseInt(r)),
          o = this.parseGeometry(s, i[r], e)
        t.set(parseInt(r), o)
      }
    }
    return t
  }
  parseGeometry(e, t, i) {
    switch (t.attrType) {
      case "Mesh":
        return this.parseMeshGeometry(e, t, i)
      case "NurbsCurve":
        return this.parseNurbsGeometry(t)
    }
  }
  parseMeshGeometry(e, t, i) {
    const r = i.skeletons,
      s = [],
      o = e.parents.map(function (m) {
        return rn.Objects.Model[m.ID]
      })
    if (o.length === 0) return
    const l = e.children.reduce(function (m, v) {
      return r[v.ID] !== void 0 && (m = r[v.ID]), m
    }, null)
    e.children.forEach(function (m) {
      i.morphTargets[m.ID] !== void 0 && s.push(i.morphTargets[m.ID])
    })
    const u = o[0],
      d = {}
    "RotationOrder" in u && (d.eulerOrder = YR(u.RotationOrder.value)),
      "InheritType" in u && (d.inheritType = parseInt(u.InheritType.value)),
      "GeometricTranslation" in u && (d.translation = u.GeometricTranslation.value),
      "GeometricRotation" in u && (d.rotation = u.GeometricRotation.value),
      "GeometricScaling" in u && (d.scale = u.GeometricScaling.value)
    const p = XR(d)
    return this.genGeometry(t, l, s, p)
  }
  genGeometry(e, t, i, r) {
    const s = new Gt()
    e.attrName && (s.name = e.attrName)
    const o = this.parseGeoNode(e, t),
      l = this.genBuffers(o),
      u = new vt(l.vertex, 3)
    if (
      (u.applyMatrix4(r),
      s.setAttribute("position", u),
      l.colors.length > 0 && s.setAttribute("color", new vt(l.colors, 3)),
      t &&
        (s.setAttribute("skinIndex", new ty(l.weightsIndices, 4)),
        s.setAttribute("skinWeight", new vt(l.vertexWeights, 4)),
        (s.FBX_Deformer = t)),
      l.normal.length > 0)
    ) {
      const d = new Xt().getNormalMatrix(r),
        p = new vt(l.normal, 3)
      p.applyNormalMatrix(d), s.setAttribute("normal", p)
    }
    if (
      (l.uvs.forEach(function (d, p) {
        z7 === "uv2" && p++
        const m = p === 0 ? "uv" : `uv${p}`
        s.setAttribute(m, new vt(l.uvs[p], 2))
      }),
      o.material && o.material.mappingType !== "AllSame")
    ) {
      let d = l.materialIndex[0],
        p = 0
      if (
        (l.materialIndex.forEach(function (m, v) {
          m !== d && (s.addGroup(p, v - p, d), (d = m), (p = v))
        }),
        s.groups.length > 0)
      ) {
        const m = s.groups[s.groups.length - 1],
          v = m.start + m.count
        v !== l.materialIndex.length && s.addGroup(v, l.materialIndex.length - v, d)
      }
      s.groups.length === 0 && s.addGroup(0, l.materialIndex.length, l.materialIndex[0])
    }
    return this.addMorphTargets(s, e, i, r), s
  }
  parseGeoNode(e, t) {
    const i = {}
    if (
      ((i.vertexPositions = e.Vertices !== void 0 ? e.Vertices.a : []),
      (i.vertexIndices = e.PolygonVertexIndex !== void 0 ? e.PolygonVertexIndex.a : []),
      e.LayerElementColor && (i.color = this.parseVertexColors(e.LayerElementColor[0])),
      e.LayerElementMaterial &&
        (i.material = this.parseMaterialIndices(e.LayerElementMaterial[0])),
      e.LayerElementNormal && (i.normal = this.parseNormals(e.LayerElementNormal[0])),
      e.LayerElementUV)
    ) {
      i.uv = []
      let r = 0
      for (; e.LayerElementUV[r]; )
        e.LayerElementUV[r].UV && i.uv.push(this.parseUVs(e.LayerElementUV[r])), r++
    }
    return (
      (i.weightTable = {}),
      t !== null &&
        ((i.skeleton = t),
        t.rawBones.forEach(function (r, s) {
          r.indices.forEach(function (o, l) {
            i.weightTable[o] === void 0 && (i.weightTable[o] = []),
              i.weightTable[o].push({ id: s, weight: r.weights[l] })
          })
        })),
      i
    )
  }
  genBuffers(e) {
    const t = {
      vertex: [],
      normal: [],
      colors: [],
      uvs: [],
      materialIndex: [],
      vertexWeights: [],
      weightsIndices: [],
    }
    let i = 0,
      r = 0,
      s = !1,
      o = [],
      l = [],
      u = [],
      d = [],
      p = [],
      m = []
    const v = this
    return (
      e.vertexIndices.forEach(function (y, x) {
        let E,
          M = !1
        y < 0 && ((y = y ^ -1), (M = !0))
        let w = [],
          A = []
        if ((o.push(y * 3, y * 3 + 1, y * 3 + 2), e.color)) {
          const C = M0(x, i, y, e.color)
          u.push(C[0], C[1], C[2])
        }
        if (e.skeleton) {
          if (
            (e.weightTable[y] !== void 0 &&
              e.weightTable[y].forEach(function (C) {
                A.push(C.weight), w.push(C.id)
              }),
            A.length > 4)
          ) {
            s ||
              (console.warn(
                "THREE.FBXLoader: Vertex has more than 4 skinning weights assigned to vertex. Deleting additional weights.",
              ),
              (s = !0))
            const C = [0, 0, 0, 0],
              R = [0, 0, 0, 0]
            A.forEach(function (z, U) {
              let O = z,
                N = w[U]
              R.forEach(function (k, I, V) {
                if (O > k) {
                  ;(V[I] = O), (O = k)
                  const Z = C[I]
                  ;(C[I] = N), (N = Z)
                }
              })
            }),
              (w = C),
              (A = R)
          }
          for (; A.length < 4; ) A.push(0), w.push(0)
          for (let C = 0; C < 4; ++C) p.push(A[C]), m.push(w[C])
        }
        if (e.normal) {
          const C = M0(x, i, y, e.normal)
          l.push(C[0], C[1], C[2])
        }
        e.material &&
          e.material.mappingType !== "AllSame" &&
          (E = M0(x, i, y, e.material)[0]),
          e.uv &&
            e.uv.forEach(function (C, R) {
              const z = M0(x, i, y, C)
              d[R] === void 0 && (d[R] = []), d[R].push(z[0]), d[R].push(z[1])
            }),
          r++,
          M &&
            (v.genFace(t, e, o, E, l, u, d, p, m, r),
            i++,
            (r = 0),
            (o = []),
            (l = []),
            (u = []),
            (d = []),
            (p = []),
            (m = []))
      }),
      t
    )
  }
  genFace(e, t, i, r, s, o, l, u, d, p) {
    for (let m = 2; m < p; m++)
      e.vertex.push(t.vertexPositions[i[0]]),
        e.vertex.push(t.vertexPositions[i[1]]),
        e.vertex.push(t.vertexPositions[i[2]]),
        e.vertex.push(t.vertexPositions[i[(m - 1) * 3]]),
        e.vertex.push(t.vertexPositions[i[(m - 1) * 3 + 1]]),
        e.vertex.push(t.vertexPositions[i[(m - 1) * 3 + 2]]),
        e.vertex.push(t.vertexPositions[i[m * 3]]),
        e.vertex.push(t.vertexPositions[i[m * 3 + 1]]),
        e.vertex.push(t.vertexPositions[i[m * 3 + 2]]),
        t.skeleton &&
          (e.vertexWeights.push(u[0]),
          e.vertexWeights.push(u[1]),
          e.vertexWeights.push(u[2]),
          e.vertexWeights.push(u[3]),
          e.vertexWeights.push(u[(m - 1) * 4]),
          e.vertexWeights.push(u[(m - 1) * 4 + 1]),
          e.vertexWeights.push(u[(m - 1) * 4 + 2]),
          e.vertexWeights.push(u[(m - 1) * 4 + 3]),
          e.vertexWeights.push(u[m * 4]),
          e.vertexWeights.push(u[m * 4 + 1]),
          e.vertexWeights.push(u[m * 4 + 2]),
          e.vertexWeights.push(u[m * 4 + 3]),
          e.weightsIndices.push(d[0]),
          e.weightsIndices.push(d[1]),
          e.weightsIndices.push(d[2]),
          e.weightsIndices.push(d[3]),
          e.weightsIndices.push(d[(m - 1) * 4]),
          e.weightsIndices.push(d[(m - 1) * 4 + 1]),
          e.weightsIndices.push(d[(m - 1) * 4 + 2]),
          e.weightsIndices.push(d[(m - 1) * 4 + 3]),
          e.weightsIndices.push(d[m * 4]),
          e.weightsIndices.push(d[m * 4 + 1]),
          e.weightsIndices.push(d[m * 4 + 2]),
          e.weightsIndices.push(d[m * 4 + 3])),
        t.color &&
          (e.colors.push(o[0]),
          e.colors.push(o[1]),
          e.colors.push(o[2]),
          e.colors.push(o[(m - 1) * 3]),
          e.colors.push(o[(m - 1) * 3 + 1]),
          e.colors.push(o[(m - 1) * 3 + 2]),
          e.colors.push(o[m * 3]),
          e.colors.push(o[m * 3 + 1]),
          e.colors.push(o[m * 3 + 2])),
        t.material &&
          t.material.mappingType !== "AllSame" &&
          (e.materialIndex.push(r), e.materialIndex.push(r), e.materialIndex.push(r)),
        t.normal &&
          (e.normal.push(s[0]),
          e.normal.push(s[1]),
          e.normal.push(s[2]),
          e.normal.push(s[(m - 1) * 3]),
          e.normal.push(s[(m - 1) * 3 + 1]),
          e.normal.push(s[(m - 1) * 3 + 2]),
          e.normal.push(s[m * 3]),
          e.normal.push(s[m * 3 + 1]),
          e.normal.push(s[m * 3 + 2])),
        t.uv &&
          t.uv.forEach(function (v, y) {
            e.uvs[y] === void 0 && (e.uvs[y] = []),
              e.uvs[y].push(l[y][0]),
              e.uvs[y].push(l[y][1]),
              e.uvs[y].push(l[y][(m - 1) * 2]),
              e.uvs[y].push(l[y][(m - 1) * 2 + 1]),
              e.uvs[y].push(l[y][m * 2]),
              e.uvs[y].push(l[y][m * 2 + 1])
          })
  }
  addMorphTargets(e, t, i, r) {
    if (i.length === 0) return
    ;(e.morphTargetsRelative = !0), (e.morphAttributes.position = [])
    const s = this
    i.forEach(function (o) {
      o.rawTargets.forEach(function (l) {
        const u = rn.Objects.Geometry[l.geoID]
        u !== void 0 && s.genMorphGeometry(e, t, u, r, l.name)
      })
    })
  }
  genMorphGeometry(e, t, i, r, s) {
    const o = t.PolygonVertexIndex !== void 0 ? t.PolygonVertexIndex.a : [],
      l = i.Vertices !== void 0 ? i.Vertices.a : [],
      u = i.Indexes !== void 0 ? i.Indexes.a : [],
      d = e.attributes.position.count * 3,
      p = new Float32Array(d)
    for (let x = 0; x < u.length; x++) {
      const E = u[x] * 3
      ;(p[E] = l[x * 3]), (p[E + 1] = l[x * 3 + 1]), (p[E + 2] = l[x * 3 + 2])
    }
    const m = { vertexIndices: o, vertexPositions: p },
      v = this.genBuffers(m),
      y = new vt(v.vertex, 3)
    ;(y.name = s || i.attrName), y.applyMatrix4(r), e.morphAttributes.position.push(y)
  }
  parseNormals(e) {
    const t = e.MappingInformationType,
      i = e.ReferenceInformationType,
      r = e.Normals.a
    let s = []
    return (
      i === "IndexToDirect" &&
        ("NormalIndex" in e
          ? (s = e.NormalIndex.a)
          : "NormalsIndex" in e && (s = e.NormalsIndex.a)),
      { dataSize: 3, buffer: r, indices: s, mappingType: t, referenceType: i }
    )
  }
  parseUVs(e) {
    const t = e.MappingInformationType,
      i = e.ReferenceInformationType,
      r = e.UV.a
    let s = []
    return (
      i === "IndexToDirect" && (s = e.UVIndex.a),
      { dataSize: 2, buffer: r, indices: s, mappingType: t, referenceType: i }
    )
  }
  parseVertexColors(e) {
    const t = e.MappingInformationType,
      i = e.ReferenceInformationType,
      r = e.Colors.a
    let s = []
    return (
      i === "IndexToDirect" && (s = e.ColorIndex.a),
      { dataSize: 4, buffer: r, indices: s, mappingType: t, referenceType: i }
    )
  }
  parseMaterialIndices(e) {
    const t = e.MappingInformationType,
      i = e.ReferenceInformationType
    if (t === "NoMappingInformation")
      return {
        dataSize: 1,
        buffer: [0],
        indices: [0],
        mappingType: "AllSame",
        referenceType: i,
      }
    const r = e.Materials.a,
      s = []
    for (let o = 0; o < r.length; ++o) s.push(o)
    return { dataSize: 1, buffer: r, indices: s, mappingType: t, referenceType: i }
  }
  parseNurbsGeometry(e) {
    if (eA === void 0)
      return (
        console.error(
          "THREE.FBXLoader: The loader relies on NURBSCurve for any nurbs present in the model. Nurbs will show up as empty geometry.",
        ),
        new Gt()
      )
    const t = parseInt(e.Order)
    if (isNaN(t))
      return (
        console.error(
          "THREE.FBXLoader: Invalid Order %s given for geometry ID: %s",
          e.Order,
          e.id,
        ),
        new Gt()
      )
    const i = t - 1,
      r = e.KnotVector.a,
      s = [],
      o = e.Points.a
    for (let m = 0, v = o.length; m < v; m += 4) s.push(new on().fromArray(o, m))
    let l, u
    if (e.Form === "Closed") s.push(s[0])
    else if (e.Form === "Periodic") {
      ;(l = i), (u = r.length - 1 - l)
      for (let m = 0; m < i; ++m) s.push(s[m])
    }
    const p = new eA(i, r, s, l, u).getPoints(s.length * 12)
    return new Gt().setFromPoints(p)
  }
}
class u9 {
  parse() {
    const e = [],
      t = this.parseClips()
    if (t !== void 0)
      for (const i in t) {
        const r = t[i],
          s = this.addClip(r)
        e.push(s)
      }
    return e
  }
  parseClips() {
    if (rn.Objects.AnimationCurve === void 0) return
    const e = this.parseAnimationCurveNodes()
    this.parseAnimationCurves(e)
    const t = this.parseAnimationLayers(e)
    return this.parseAnimStacks(t)
  }
  parseAnimationCurveNodes() {
    const e = rn.Objects.AnimationCurveNode,
      t = new Map()
    for (const i in e) {
      const r = e[i]
      if (r.attrName.match(/S|R|T|DeformPercent/) !== null) {
        const s = { id: r.id, attr: r.attrName, curves: {} }
        t.set(s.id, s)
      }
    }
    return t
  }
  parseAnimationCurves(e) {
    const t = rn.Objects.AnimationCurve
    for (const i in t) {
      const r = {
          id: t[i].id,
          times: t[i].KeyTime.a.map(m9),
          values: t[i].KeyValueFloat.a,
        },
        s = ci.get(r.id)
      if (s !== void 0) {
        const o = s.parents[0].ID,
          l = s.parents[0].relationship
        l.match(/X/)
          ? (e.get(o).curves.x = r)
          : l.match(/Y/)
          ? (e.get(o).curves.y = r)
          : l.match(/Z/)
          ? (e.get(o).curves.z = r)
          : l.match(/d|DeformPercent/) && e.has(o) && (e.get(o).curves.morph = r)
      }
    }
  }
  parseAnimationLayers(e) {
    const t = rn.Objects.AnimationLayer,
      i = new Map()
    for (const r in t) {
      const s = [],
        o = ci.get(parseInt(r))
      o !== void 0 &&
        (o.children.forEach(function (u, d) {
          if (e.has(u.ID)) {
            const p = e.get(u.ID)
            if (
              p.curves.x !== void 0 ||
              p.curves.y !== void 0 ||
              p.curves.z !== void 0
            ) {
              if (s[d] === void 0) {
                const m = ci.get(u.ID).parents.filter(function (v) {
                  return v.relationship !== void 0
                })[0].ID
                if (m !== void 0) {
                  const v = rn.Objects.Model[m.toString()]
                  if (v === void 0) {
                    console.warn("THREE.FBXLoader: Encountered a unused curve.", u)
                    return
                  }
                  const y = {
                    modelName: v.attrName ? sn.sanitizeNodeName(v.attrName) : "",
                    ID: v.id,
                    initialPosition: [0, 0, 0],
                    initialRotation: [0, 0, 0],
                    initialScale: [1, 1, 1],
                  }
                  $r.traverse(function (x) {
                    x.ID === v.id &&
                      ((y.transform = x.matrix),
                      x.userData.transformData &&
                        (y.eulerOrder = x.userData.transformData.eulerOrder))
                  }),
                    y.transform || (y.transform = new mt()),
                    "PreRotation" in v && (y.preRotation = v.PreRotation.value),
                    "PostRotation" in v && (y.postRotation = v.PostRotation.value),
                    (s[d] = y)
                }
              }
              s[d] && (s[d][p.attr] = p)
            } else if (p.curves.morph !== void 0) {
              if (s[d] === void 0) {
                const m = ci.get(u.ID).parents.filter(function (w) {
                    return w.relationship !== void 0
                  })[0].ID,
                  v = ci.get(m).parents[0].ID,
                  y = ci.get(v).parents[0].ID,
                  x = ci.get(y).parents[0].ID,
                  E = rn.Objects.Model[x],
                  M = {
                    modelName: E.attrName ? sn.sanitizeNodeName(E.attrName) : "",
                    morphName: rn.Objects.Deformer[m].attrName,
                  }
                s[d] = M
              }
              s[d][p.attr] = p
            }
          }
        }),
        i.set(parseInt(r), s))
    }
    return i
  }
  parseAnimStacks(e) {
    const t = rn.Objects.AnimationStack,
      i = {}
    for (const r in t) {
      const s = ci.get(parseInt(r)).children
      s.length > 1 &&
        console.warn(
          "THREE.FBXLoader: Encountered an animation stack with multiple layers, this is currently not supported. Ignoring subsequent layers.",
        )
      const o = e.get(s[0].ID)
      i[r] = { name: t[r].attrName, layer: o }
    }
    return i
  }
  addClip(e) {
    let t = []
    const i = this
    return (
      e.layer.forEach(function (r) {
        t = t.concat(i.generateTracks(r))
      }),
      new Ud(e.name, -1, t)
    )
  }
  generateTracks(e) {
    const t = []
    let i = new q(),
      r = new Oi(),
      s = new q()
    if (
      (e.transform && e.transform.decompose(i, r, s),
      (i = i.toArray()),
      (r = new Bi().setFromQuaternion(r, e.eulerOrder).toArray()),
      (s = s.toArray()),
      e.T !== void 0 && Object.keys(e.T.curves).length > 0)
    ) {
      const o = this.generateVectorTrack(e.modelName, e.T.curves, i, "position")
      o !== void 0 && t.push(o)
    }
    if (e.R !== void 0 && Object.keys(e.R.curves).length > 0) {
      const o = this.generateRotationTrack(
        e.modelName,
        e.R.curves,
        r,
        e.preRotation,
        e.postRotation,
        e.eulerOrder,
      )
      o !== void 0 && t.push(o)
    }
    if (e.S !== void 0 && Object.keys(e.S.curves).length > 0) {
      const o = this.generateVectorTrack(e.modelName, e.S.curves, s, "scale")
      o !== void 0 && t.push(o)
    }
    if (e.DeformPercent !== void 0) {
      const o = this.generateMorphTrack(e)
      o !== void 0 && t.push(o)
    }
    return t
  }
  generateVectorTrack(e, t, i, r) {
    const s = this.getTimesForAllAxes(t),
      o = this.getKeyframeTrackValues(s, t, i)
    return new Fd(e + "." + r, s, o)
  }
  generateRotationTrack(e, t, i, r, s, o) {
    t.x !== void 0 &&
      (this.interpolateRotations(t.x), (t.x.values = t.x.values.map(yo.degToRad))),
      t.y !== void 0 &&
        (this.interpolateRotations(t.y), (t.y.values = t.y.values.map(yo.degToRad))),
      t.z !== void 0 &&
        (this.interpolateRotations(t.z), (t.z.values = t.z.values.map(yo.degToRad)))
    const l = this.getTimesForAllAxes(t),
      u = this.getKeyframeTrackValues(l, t, i)
    r !== void 0 &&
      ((r = r.map(yo.degToRad)),
      r.push(o),
      (r = new Bi().fromArray(r)),
      (r = new Oi().setFromEuler(r))),
      s !== void 0 &&
        ((s = s.map(yo.degToRad)),
        s.push(o),
        (s = new Bi().fromArray(s)),
        (s = new Oi().setFromEuler(s).invert()))
    const d = new Oi(),
      p = new Bi(),
      m = []
    for (let v = 0; v < u.length; v += 3)
      p.set(u[v], u[v + 1], u[v + 2], o),
        d.setFromEuler(p),
        r !== void 0 && d.premultiply(r),
        s !== void 0 && d.multiply(s),
        d.toArray(m, (v / 3) * 4)
    return new $d(e + ".quaternion", l, m)
  }
  generateMorphTrack(e) {
    const t = e.DeformPercent.curves.morph,
      i = t.values.map(function (s) {
        return s / 100
      }),
      r = $r.getObjectByName(e.modelName).morphTargetDictionary[e.morphName]
    return new kd(e.modelName + ".morphTargetInfluences[" + r + "]", t.times, i)
  }
  getTimesForAllAxes(e) {
    let t = []
    if (
      (e.x !== void 0 && (t = t.concat(e.x.times)),
      e.y !== void 0 && (t = t.concat(e.y.times)),
      e.z !== void 0 && (t = t.concat(e.z.times)),
      (t = t.sort(function (i, r) {
        return i - r
      })),
      t.length > 1)
    ) {
      let i = 1,
        r = t[0]
      for (let s = 1; s < t.length; s++) {
        const o = t[s]
        o !== r && ((t[i] = o), (r = o), i++)
      }
      t = t.slice(0, i)
    }
    return t
  }
  getKeyframeTrackValues(e, t, i) {
    const r = i,
      s = []
    let o = -1,
      l = -1,
      u = -1
    return (
      e.forEach(function (d) {
        if (
          (t.x && (o = t.x.times.indexOf(d)),
          t.y && (l = t.y.times.indexOf(d)),
          t.z && (u = t.z.times.indexOf(d)),
          o !== -1)
        ) {
          const p = t.x.values[o]
          s.push(p), (r[0] = p)
        } else s.push(r[0])
        if (l !== -1) {
          const p = t.y.values[l]
          s.push(p), (r[1] = p)
        } else s.push(r[1])
        if (u !== -1) {
          const p = t.z.values[u]
          s.push(p), (r[2] = p)
        } else s.push(r[2])
      }),
      s
    )
  }
  interpolateRotations(e) {
    for (let t = 1; t < e.values.length; t++) {
      const i = e.values[t - 1],
        r = e.values[t] - i,
        s = Math.abs(r)
      if (s >= 180) {
        const o = s / 180,
          l = r / o
        let u = i + l
        const d = e.times[t - 1],
          m = (e.times[t] - d) / o
        let v = d + m
        const y = [],
          x = []
        for (; v < e.times[t]; ) y.push(v), (v += m), x.push(u), (u += l)
        ;(e.times = iA(e.times, t, y)), (e.values = iA(e.values, t, x))
      }
    }
  }
}
class f9 {
  getPrevNode() {
    return this.nodeStack[this.currentIndent - 2]
  }
  getCurrentNode() {
    return this.nodeStack[this.currentIndent - 1]
  }
  getCurrentProp() {
    return this.currentProp
  }
  pushStack(e) {
    this.nodeStack.push(e), (this.currentIndent += 1)
  }
  popStack() {
    this.nodeStack.pop(), (this.currentIndent -= 1)
  }
  setCurrentProp(e, t) {
    ;(this.currentProp = e), (this.currentPropName = t)
  }
  parse(e) {
    ;(this.currentIndent = 0),
      (this.allNodes = new jR()),
      (this.nodeStack = []),
      (this.currentProp = []),
      (this.currentPropName = "")
    const t = this,
      i = e.split(/[\r\n]+/)
    return (
      i.forEach(function (r, s) {
        const o = r.match(/^[\s\t]*;/),
          l = r.match(/^[\s\t]*$/)
        if (o || l) return
        const u = r.match("^\\t{" + t.currentIndent + "}(\\w+):(.*){", ""),
          d = r.match("^\\t{" + t.currentIndent + "}(\\w+):[\\s\\t\\r\\n](.*)"),
          p = r.match("^\\t{" + (t.currentIndent - 1) + "}}")
        u
          ? t.parseNodeBegin(r, u)
          : d
          ? t.parseNodeProperty(r, d, i[++s])
          : p
          ? t.popStack()
          : r.match(/^[^\s\t}]/) && t.parseNodePropertyContinued(r)
      }),
      this.allNodes
    )
  }
  parseNodeBegin(e, t) {
    const i = t[1].trim().replace(/^"/, "").replace(/"$/, ""),
      r = t[2].split(",").map(function (u) {
        return u.trim().replace(/^"/, "").replace(/"$/, "")
      }),
      s = { name: i },
      o = this.parseNodeAttr(r),
      l = this.getCurrentNode()
    this.currentIndent === 0
      ? this.allNodes.add(i, s)
      : i in l
      ? (i === "PoseNode"
          ? l.PoseNode.push(s)
          : l[i].id !== void 0 && ((l[i] = {}), (l[i][l[i].id] = l[i])),
        o.id !== "" && (l[i][o.id] = s))
      : typeof o.id == "number"
      ? ((l[i] = {}), (l[i][o.id] = s))
      : i !== "Properties70" && (i === "PoseNode" ? (l[i] = [s]) : (l[i] = s)),
      typeof o.id == "number" && (s.id = o.id),
      o.name !== "" && (s.attrName = o.name),
      o.type !== "" && (s.attrType = o.type),
      this.pushStack(s)
  }
  parseNodeAttr(e) {
    let t = e[0]
    e[0] !== "" && ((t = parseInt(e[0])), isNaN(t) && (t = e[0]))
    let i = "",
      r = ""
    return (
      e.length > 1 && ((i = e[1].replace(/^(\w+)::/, "")), (r = e[2])),
      { id: t, name: i, type: r }
    )
  }
  parseNodeProperty(e, t, i) {
    let r = t[1].replace(/^"/, "").replace(/"$/, "").trim(),
      s = t[2].replace(/^"/, "").replace(/"$/, "").trim()
    r === "Content" && s === "," && (s = i.replace(/"/g, "").replace(/,$/, "").trim())
    const o = this.getCurrentNode()
    if (o.name === "Properties70") {
      this.parseNodeSpecialProperty(e, r, s)
      return
    }
    if (r === "C") {
      const u = s.split(",").slice(1),
        d = parseInt(u[0]),
        p = parseInt(u[1])
      let m = s.split(",").slice(3)
      ;(m = m.map(function (v) {
        return v.trim().replace(/^"/, "")
      })),
        (r = "connections"),
        (s = [d, p]),
        v9(s, m),
        o[r] === void 0 && (o[r] = [])
    }
    r === "Node" && (o.id = s),
      r in o && Array.isArray(o[r]) ? o[r].push(s) : r !== "a" ? (o[r] = s) : (o.a = s),
      this.setCurrentProp(o, r),
      r === "a" && s.slice(-1) !== "," && (o.a = F_(s))
  }
  parseNodePropertyContinued(e) {
    const t = this.getCurrentNode()
    ;(t.a += e), e.slice(-1) !== "," && (t.a = F_(t.a))
  }
  parseNodeSpecialProperty(e, t, i) {
    const r = i.split('",').map(function (p) {
        return p.trim().replace(/^\"/, "").replace(/\s/, "_")
      }),
      s = r[0],
      o = r[1],
      l = r[2],
      u = r[3]
    let d = r[4]
    switch (o) {
      case "int":
      case "enum":
      case "bool":
      case "ULongLong":
      case "double":
      case "Number":
      case "FieldOfView":
        d = parseFloat(d)
        break
      case "Color":
      case "ColorRGB":
      case "Vector3D":
      case "Lcl_Translation":
      case "Lcl_Rotation":
      case "Lcl_Scaling":
        d = F_(d)
        break
    }
    ;(this.getPrevNode()[s] = { type: o, type2: l, flag: u, value: d }),
      this.setCurrentProp(this.getPrevNode(), s)
  }
}
class d9 {
  parse(e) {
    const t = new tA(e)
    t.skip(23)
    const i = t.getUint32()
    if (i < 6400)
      throw new Error("THREE.FBXLoader: FBX version not supported, FileVersion: " + i)
    const r = new jR()
    for (; !this.endOfContent(t); ) {
      const s = this.parseNode(t, i)
      s !== null && r.add(s.name, s)
    }
    return r
  }
  endOfContent(e) {
    return e.size() % 16 === 0
      ? ((e.getOffset() + 160 + 16) & -16) >= e.size()
      : e.getOffset() + 160 + 16 >= e.size()
  }
  parseNode(e, t) {
    const i = {},
      r = t >= 7500 ? e.getUint64() : e.getUint32(),
      s = t >= 7500 ? e.getUint64() : e.getUint32()
    t >= 7500 ? e.getUint64() : e.getUint32()
    const o = e.getUint8(),
      l = e.getString(o)
    if (r === 0) return null
    const u = []
    for (let v = 0; v < s; v++) u.push(this.parseProperty(e))
    const d = u.length > 0 ? u[0] : "",
      p = u.length > 1 ? u[1] : "",
      m = u.length > 2 ? u[2] : ""
    for (i.singleProperty = s === 1 && e.getOffset() === r; r > e.getOffset(); ) {
      const v = this.parseNode(e, t)
      v !== null && this.parseSubNode(l, i, v)
    }
    return (
      (i.propertyList = u),
      typeof d == "number" && (i.id = d),
      p !== "" && (i.attrName = p),
      m !== "" && (i.attrType = m),
      l !== "" && (i.name = l),
      i
    )
  }
  parseSubNode(e, t, i) {
    if (i.singleProperty === !0) {
      const r = i.propertyList[0]
      Array.isArray(r) ? ((t[i.name] = i), (i.a = r)) : (t[i.name] = r)
    } else if (e === "Connections" && i.name === "C") {
      const r = []
      i.propertyList.forEach(function (s, o) {
        o !== 0 && r.push(s)
      }),
        t.connections === void 0 && (t.connections = []),
        t.connections.push(r)
    } else if (i.name === "Properties70")
      Object.keys(i).forEach(function (s) {
        t[s] = i[s]
      })
    else if (e === "Properties70" && i.name === "P") {
      let r = i.propertyList[0],
        s = i.propertyList[1]
      const o = i.propertyList[2],
        l = i.propertyList[3]
      let u
      r.indexOf("Lcl ") === 0 && (r = r.replace("Lcl ", "Lcl_")),
        s.indexOf("Lcl ") === 0 && (s = s.replace("Lcl ", "Lcl_")),
        s === "Color" ||
        s === "ColorRGB" ||
        s === "Vector" ||
        s === "Vector3D" ||
        s.indexOf("Lcl_") === 0
          ? (u = [i.propertyList[4], i.propertyList[5], i.propertyList[6]])
          : (u = i.propertyList[4]),
        (t[r] = { type: s, type2: o, flag: l, value: u })
    } else
      t[i.name] === void 0
        ? typeof i.id == "number"
          ? ((t[i.name] = {}), (t[i.name][i.id] = i))
          : (t[i.name] = i)
        : i.name === "PoseNode"
        ? (Array.isArray(t[i.name]) || (t[i.name] = [t[i.name]]), t[i.name].push(i))
        : t[i.name][i.id] === void 0 && (t[i.name][i.id] = i)
  }
  parseProperty(e) {
    const t = e.getString(1)
    let i
    switch (t) {
      case "C":
        return e.getBoolean()
      case "D":
        return e.getFloat64()
      case "F":
        return e.getFloat32()
      case "I":
        return e.getInt32()
      case "L":
        return e.getInt64()
      case "R":
        return (i = e.getUint32()), e.getArrayBuffer(i)
      case "S":
        return (i = e.getUint32()), e.getString(i)
      case "Y":
        return e.getInt16()
      case "b":
      case "c":
      case "d":
      case "f":
      case "i":
      case "l":
        const r = e.getUint32(),
          s = e.getUint32(),
          o = e.getUint32()
        if (s === 0)
          switch (t) {
            case "b":
            case "c":
              return e.getBooleanArray(r)
            case "d":
              return e.getFloat64Array(r)
            case "f":
              return e.getFloat32Array(r)
            case "i":
              return e.getInt32Array(r)
            case "l":
              return e.getInt64Array(r)
          }
        const l = J7(new Uint8Array(e.getArrayBuffer(o))),
          u = new tA(l.buffer)
        switch (t) {
          case "b":
          case "c":
            return u.getBooleanArray(r)
          case "d":
            return u.getFloat64Array(r)
          case "f":
            return u.getFloat32Array(r)
          case "i":
            return u.getInt32Array(r)
          case "l":
            return u.getInt64Array(r)
        }
      default:
        throw new Error("THREE.FBXLoader: Unknown property type " + t)
    }
  }
}
class tA {
  constructor(e, t) {
    ;(this.dv = new DataView(e)),
      (this.offset = 0),
      (this.littleEndian = t !== void 0 ? t : !0)
  }
  getOffset() {
    return this.offset
  }
  size() {
    return this.dv.buffer.byteLength
  }
  skip(e) {
    this.offset += e
  }
  getBoolean() {
    return (this.getUint8() & 1) === 1
  }
  getBooleanArray(e) {
    const t = []
    for (let i = 0; i < e; i++) t.push(this.getBoolean())
    return t
  }
  getUint8() {
    const e = this.dv.getUint8(this.offset)
    return (this.offset += 1), e
  }
  getInt16() {
    const e = this.dv.getInt16(this.offset, this.littleEndian)
    return (this.offset += 2), e
  }
  getInt32() {
    const e = this.dv.getInt32(this.offset, this.littleEndian)
    return (this.offset += 4), e
  }
  getInt32Array(e) {
    const t = []
    for (let i = 0; i < e; i++) t.push(this.getInt32())
    return t
  }
  getUint32() {
    const e = this.dv.getUint32(this.offset, this.littleEndian)
    return (this.offset += 4), e
  }
  getInt64() {
    let e, t
    return (
      this.littleEndian
        ? ((e = this.getUint32()), (t = this.getUint32()))
        : ((t = this.getUint32()), (e = this.getUint32())),
      t & 2147483648
        ? ((t = ~t & 4294967295),
          (e = ~e & 4294967295),
          e === 4294967295 && (t = (t + 1) & 4294967295),
          (e = (e + 1) & 4294967295),
          -(t * 4294967296 + e))
        : t * 4294967296 + e
    )
  }
  getInt64Array(e) {
    const t = []
    for (let i = 0; i < e; i++) t.push(this.getInt64())
    return t
  }
  getUint64() {
    let e, t
    return (
      this.littleEndian
        ? ((e = this.getUint32()), (t = this.getUint32()))
        : ((t = this.getUint32()), (e = this.getUint32())),
      t * 4294967296 + e
    )
  }
  getFloat32() {
    const e = this.dv.getFloat32(this.offset, this.littleEndian)
    return (this.offset += 4), e
  }
  getFloat32Array(e) {
    const t = []
    for (let i = 0; i < e; i++) t.push(this.getFloat32())
    return t
  }
  getFloat64() {
    const e = this.dv.getFloat64(this.offset, this.littleEndian)
    return (this.offset += 8), e
  }
  getFloat64Array(e) {
    const t = []
    for (let i = 0; i < e; i++) t.push(this.getFloat64())
    return t
  }
  getArrayBuffer(e) {
    const t = this.dv.buffer.slice(this.offset, this.offset + e)
    return (this.offset += e), t
  }
  getString(e) {
    let t = []
    for (let r = 0; r < e; r++) t[r] = this.getUint8()
    const i = t.indexOf(0)
    return i >= 0 && (t = t.slice(0, i)), GR(new Uint8Array(t))
  }
}
class jR {
  add(e, t) {
    this[e] = t
  }
}
function h9(n) {
  const e = "Kaydara FBX Binary  \0"
  return n.byteLength >= e.length && e === qR(n, 0, e.length)
}
function p9(n) {
  const e = [
    "K",
    "a",
    "y",
    "d",
    "a",
    "r",
    "a",
    "\\",
    "F",
    "B",
    "X",
    "\\",
    "B",
    "i",
    "n",
    "a",
    "r",
    "y",
    "\\",
    "\\",
  ]
  let t = 0
  function i(r) {
    const s = n[r - 1]
    return (n = n.slice(t + r)), t++, s
  }
  for (let r = 0; r < e.length; ++r) if (i(1) === e[r]) return !1
  return !0
}
function nA(n) {
  const e = /FBXVersion: (\d+)/,
    t = n.match(e)
  if (t) return parseInt(t[1])
  throw new Error("THREE.FBXLoader: Cannot find the version number for the file given.")
}
function m9(n) {
  return n / 46186158e3
}
const g9 = []
function M0(n, e, t, i) {
  let r
  switch (i.mappingType) {
    case "ByPolygonVertex":
      r = n
      break
    case "ByPolygon":
      r = e
      break
    case "ByVertice":
      r = t
      break
    case "AllSame":
      r = i.indices[0]
      break
    default:
      console.warn("THREE.FBXLoader: unknown attribute mapping type " + i.mappingType)
  }
  i.referenceType === "IndexToDirect" && (r = i.indices[r])
  const s = r * i.dataSize,
    o = s + i.dataSize
  return y9(g9, i.buffer, s, o)
}
const k_ = new Bi(),
  pd = new q()
function XR(n) {
  const e = new mt(),
    t = new mt(),
    i = new mt(),
    r = new mt(),
    s = new mt(),
    o = new mt(),
    l = new mt(),
    u = new mt(),
    d = new mt(),
    p = new mt(),
    m = new mt(),
    v = new mt(),
    y = n.inheritType ? n.inheritType : 0
  if ((n.translation && e.setPosition(pd.fromArray(n.translation)), n.preRotation)) {
    const I = n.preRotation.map(yo.degToRad)
    I.push(n.eulerOrder), t.makeRotationFromEuler(k_.fromArray(I))
  }
  if (n.rotation) {
    const I = n.rotation.map(yo.degToRad)
    I.push(n.eulerOrder), i.makeRotationFromEuler(k_.fromArray(I))
  }
  if (n.postRotation) {
    const I = n.postRotation.map(yo.degToRad)
    I.push(n.eulerOrder), r.makeRotationFromEuler(k_.fromArray(I)), r.invert()
  }
  n.scale && s.scale(pd.fromArray(n.scale)),
    n.scalingOffset && l.setPosition(pd.fromArray(n.scalingOffset)),
    n.scalingPivot && o.setPosition(pd.fromArray(n.scalingPivot)),
    n.rotationOffset && u.setPosition(pd.fromArray(n.rotationOffset)),
    n.rotationPivot && d.setPosition(pd.fromArray(n.rotationPivot)),
    n.parentMatrixWorld && (m.copy(n.parentMatrix), p.copy(n.parentMatrixWorld))
  const x = t.clone().multiply(i).multiply(r),
    E = new mt()
  E.extractRotation(p)
  const M = new mt()
  M.copyPosition(p)
  const w = M.clone().invert().multiply(p),
    A = E.clone().invert().multiply(w),
    C = s,
    R = new mt()
  if (y === 0) R.copy(E).multiply(x).multiply(A).multiply(C)
  else if (y === 1) R.copy(E).multiply(A).multiply(x).multiply(C)
  else {
    const V = new mt().scale(new q().setFromMatrixScale(m)).clone().invert(),
      Z = A.clone().multiply(V)
    R.copy(E).multiply(x).multiply(Z).multiply(C)
  }
  const z = d.clone().invert(),
    U = o.clone().invert()
  let O = e
    .clone()
    .multiply(u)
    .multiply(d)
    .multiply(t)
    .multiply(i)
    .multiply(r)
    .multiply(z)
    .multiply(l)
    .multiply(o)
    .multiply(s)
    .multiply(U)
  const N = new mt().copyPosition(O),
    k = p.clone().multiply(N)
  return v.copyPosition(k), (O = v.clone().multiply(R)), O.premultiply(p.invert()), O
}
function YR(n) {
  n = n || 0
  const e = ["ZYX", "YZX", "XZY", "ZXY", "YXZ", "XYZ"]
  return n === 6
    ? (console.warn(
        "THREE.FBXLoader: unsupported Euler Order: Spherical XYZ. Animations and rotations may be incorrect.",
      ),
      e[0])
    : e[n]
}
function F_(n) {
  return n.split(",").map(function (t) {
    return parseFloat(t)
  })
}
function qR(n, e, t) {
  return (
    e === void 0 && (e = 0),
    t === void 0 && (t = n.byteLength),
    GR(new Uint8Array(n, e, t))
  )
}
function v9(n, e) {
  for (let t = 0, i = n.length, r = e.length; t < r; t++, i++) n[i] = e[t]
}
function y9(n, e, t, i) {
  for (let r = t, s = 0; r < i; r++, s++) n[s] = e[r]
  return n
}
function iA(n, e, t) {
  return n.slice(0, e).concat(t).concat(n.slice(e))
}
function yS(n) {
  return Cm(vS, n)
}
yS.preload = (n) => Cm.preload(vS, n)
yS.clear = (n) => Cm.clear(vS, n)
const x9 = ({
    color: n,
    rotationY: e,
    rotationX: t,
    modelUrl:
      i = "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Star_Model.fbx?v=1740606433",
  }) => {
    const r = new Zp(),
      s = Y.useRef()
    m7((d, p) => {
      ;(s.current.rotation.y += e), (s.current.rotation.x += t)
    })
    const o = new el({ color: new ot(n) }),
      l = yS(i),
      u = Y.useMemo(() => l.clone(!0), [])
    return (
      u.children.forEach((d, p) => {
        d.material = o
      }),
      r.add(u),
      D.jsxs(D.Fragment, {
        children: [
          D.jsx("primitive", { ref: s, object: r, scale: [3, 3, 3] }),
          D.jsx("ambientLight", {}),
        ],
      })
    )
  },
  U_ = ({ color: n, rotationY: e = 0, rotationX: t = 0, modelUrl: i }) =>
    D.jsx(D.Fragment, {
      children: D.jsx("div", {
        className:
          "w-full h-full absolute transition-opacity duration-300 top-0 left-0 z-2",
        children: D.jsx(O7, {
          camera: { fov: 60, position: [120, 120, 120] },
          children: D.jsx(x9, { color: n, rotationY: e, rotationX: t, modelUrl: i }),
        }),
      }),
    }),
  Wl = {
    big_yellow: {
      landing: {
        poster:
          "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Big_Yellow.png?v=1741197661",
        mobile:
          "https://cdn.shopify.com/videos/c/o/v/c72f0af08ed24919b2844216b68d9589.mp4",
        webm: "https://cdn.shopify.com/videos/c/o/v/c84ad54c7b104a4c8034d5121a50d046.webm",
        mp4: "https://cdn.shopify.com/videos/c/o/v/717921c5cc764c97ae99209fbe67ea0c.mp4",
      },
    },
    coconut_balm: {
      landing: {
        poster:
          "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Coconut_Balm.png?v=1741197662",
        mobile:
          "https://cdn.shopify.com/videos/c/o/v/504ed3a693fa45cea5610b6023c2511f.mp4",
        webm: "https://cdn.shopify.com/videos/c/o/v/33ec102c80d84996979b53af0b698d42.webm",
        mp4: "https://cdn.shopify.com/videos/c/o/v/46653365cbbf4c5399eef14c6d480124.mp4",
      },
    },
    mango_balm: {
      landing: {
        poster:
          "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Mango_Balm.png?v=1741197661",
        mobile:
          "https://cdn.shopify.com/videos/c/o/v/cf462a3d8170449e8fddab3d779f75a0.mp4",
        webm: "https://cdn.shopify.com/videos/c/o/v/fa1236746ebc4064b823b62336f94d8f.webm",
        mp4: "https://cdn.shopify.com/videos/c/o/v/69fc4c85be5840b889ef71a1bf265ef8.mp4",
      },
    },
    starwash: {
      landing: {
        poster:
          "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Star_Wash.png?v=1741197661",
        mobile:
          "https://cdn.shopify.com/videos/c/o/v/ff0cd1858cd34407999c330d00611aff.mp4",
        webm: "https://cdn.shopify.com/videos/c/o/v/9ee06dd440414687a37e1f3cae6a558f.webm",
        mp4: "https://cdn.shopify.com/videos/c/o/v/d14d5f7564a84f89979af56a3965e847.mp4",
      },
    },
    starcream: {
      landing: {
        poster:
          "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Star_Cream.png?v=1741197661",
        mobile:
          "https://cdn.shopify.com/videos/c/o/v/c52890ef7a4249178fe151b029e3531e.mp4",
        webm: "https://cdn.shopify.com/videos/c/o/v/7b0fe59b89f040c1908ffccd42ed6ab0.webm",
        mp4: "https://cdn.shopify.com/videos/c/o/v/4048e4278a554802aa87355948edcecd.mp4",
      },
    },
    ingredients: {
      landing: {
        poster:
          "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Ingredients.png?v=1741197661",
        mobile:
          "https://cdn.shopify.com/videos/c/o/v/9aebb9acdfd54825add8924f92b66cb6.mp4",
        webm: "https://cdn.shopify.com/videos/c/o/v/115a2063234943d2b80b06e3fe173805.webm",
        mp4: "https://cdn.shopify.com/videos/c/o/v/2dea7c47f3764cd68267305c88426869.mp4",
      },
    },
    how: {
      landing: {
        poster:
          "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Routine_Orb_1.png?v=1741197662",
        mobile:
          "https://cdn.shopify.com/videos/c/o/v/1ef482ae863c47fc80e0fb6f22026d52.mp4",
        webm: "https://cdn.shopify.com/videos/c/o/v/ae785c8736394c259168d275b2dcf7d5.webm",
        mp4: "https://cdn.shopify.com/videos/c/o/v/1ef482ae863c47fc80e0fb6f22026d52.mp4",
      },
    },
    quiz: {
      landing: {
        poster:
          "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/Quiz.png?v=1741197661",
        mobile:
          "https://cdn.shopify.com/videos/c/o/v/f4d0b89ed9864ced81ab6f7a8f79c673.mp4",
        webm: "https://cdn.shopify.com/videos/c/o/v/4f4ab939915448189d2f620f4e6125ab.webm",
        mp4: "https://cdn.shopify.com/videos/c/o/v/99e4a35c9eb541c9bed53cd9eda52e86.mp4",
      },
    },
  },
  _9 = (n) => {
    let e, t, i
    function r(d, p) {
      ;(t.x -= d.deltaX),
        (t.y -= d.deltaY),
        n.container.dispatchEvent(new CustomEvent(p, { detail: { x: t.x, y: t.y } }))
    }
    function s(d) {
      ;(t = { x: d.pageX, y: d.pageY }), r(d, "ksDragStart")
    }
    function o(d) {
      r(d, "ksDrag")
    }
    function l(d) {
      r(d, "ksDragEnd")
    }
    function u(d) {
      d.preventDefault(),
        i || (s(d), (i = !0)),
        o(d),
        clearTimeout(e),
        (e = setTimeout(() => {
          ;(i = !1), l(d)
        }, 50))
    }
    n.on("created", () => {
      n.container.addEventListener("wheel", u, { passive: !1 })
    })
  }
function rA() {
  return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
}
const sA = typeof InstallTrigger < "u",
  jl = ({ landing: n }) => {
    const [e, t] = Y.useState(!1)
    Y.useRef(null)
    const [i, r] = Y.useState(!1),
      s = Y.useRef(null),
      o = Y.useRef(null)
    return (
      Y.useEffect(() => {
        const l = new IntersectionObserver(
          (u) => {
            u.forEach((d) => {
              d.isIntersecting && r(!0),
                d.target.children[0] === s.current &&
                  (d.isIntersecting
                    ? d.target.children[0].play()
                    : d.target.children[0].pause())
            })
          },
          { threshold: 0.1 },
        )
        return (
          o.current && l.observe(o.current),
          () => {
            o.current && l.unobserve(o.current)
          }
        )
      }, []),
      D.jsx("div", {
        ref: o,
        children:
          i &&
          D.jsxs(D.Fragment, {
            children: [
              D.jsx("video", {
                ref: s,
                muted: !0,
                playsInline: !0,
                loop: !0,
                poster: n.poster,
                className:
                  "w-full h-auto 800:hidden object-cover user-select-none pointer-events-none",
                children:
                  rA() || sA
                    ? D.jsx("source", { src: n.webm, type: "video/webm" })
                    : D.jsx("source", { src: n.mp4, type: "video/mp4" }),
              }),
              D.jsx("video", {
                autoPlay: !0,
                muted: !0,
                playsInline: !0,
                loop: !0,
                poster: n.poster,
                className:
                  "w-full h-auto hidden 800:block object-cover user-select-none pointer-events-none",
                children:
                  sA || rA()
                    ? D.jsxs(D.Fragment, {
                        children: [
                          D.jsx("source", { src: n.webm, type: "video/webm" }),
                          D.jsx("source", { src: n.mp4, type: "video/mp4" }),
                        ],
                      })
                    : D.jsxs(D.Fragment, {
                        children: [
                          D.jsx("source", { src: n.mp4, type: "video/mp4" }),
                          D.jsx("source", { src: n.webm, type: "video/webm" }),
                        ],
                      }),
              }),
            ],
          }),
      })
    )
  },
  O_ = { duration: 18e4, easing: (n) => n }
function w9() {
  const [n, e] = Y.useState(!1),
    [t, i] = Y.useState(!1),
    [r, s] = Y.useState(!1),
    [o, l] = Y.useState(!1),
    [u, d] = Y.useState(!1),
    [p, m] = Y.useState(null),
    [v, y] = Y.useState(null),
    [x, E] = Y.useState(3),
    {
      message: M,
      setMessage: w,
      setIngredientHover: A,
    } = cA(
      (O) => ({
        message: O.message,
        setMessage: O.setMessage,
        setIngredientHover: O.setIngredientHover,
      }),
      aA,
    )
  console.log("HEY STUFF")
  const [C] = RP.useKeenSlider(
      {
        loop: !0,
        rubberband: !0,
        vertical: !1,
        mode: "free",
        defaultAnimation: { duration: 1e5, easing: (O) => O },
        dragSpeed: 0.8,
        initial: 0.2,
        slides: { perView: "auto" },
        breakpoints: {
          "(min-width: 800px)": { slides: { perView: "auto", origin: 1.05 } },
        },
        created(O) {
          O.moveToIdx(5, !0, O_)
        },
        updated(O) {
          O.moveToIdx(O.track.details.abs + 5, !0, O_)
        },
        animationEnded(O) {
          O.moveToIdx(O.track.details.abs + 5, !0, O_)
        },
      },
      [_9],
    ),
    R =
      "text-black 800:opacity-0 800:group-hover:opacity-100 duration-300 whitespace-nowrap font-abc font-black text-[14px] leading-[16px] p-2 px-6 bg-yellow border-2 border-black",
    z = Y.useMemo(
      () =>
        D.jsxs("div", {
          className: "h-screen w-[1400px] relative max-h-[600px] screen-size",
          children: [
            D.jsxs("button", {
              onClick: () => {
                s(!0), E(3)
              },
              onMouseEnter: () => {
                A("ingredients"),
                  w("can't wait 2 tell u abt all the star ingredients in my world ⭐")
              },
              className:
                "absolute no-bg-button group top-[5%] -left-[50px] w-[320px] h-auto",
              children: [
                D.jsx(jl, { landing: Wl.ingredients.landing }),
                D.jsx("span", {
                  className: Xn(
                    R,
                    "absolute top-[40%] right-[4%] transform -rotate-[40deg]",
                  ),
                  children: "ingredients",
                }),
              ],
            }),
            D.jsx("button", {
              onClick: () => {
                m("hydrostars"), y(1), i(!0)
              },
              className:
                "absolute no-bg-button group bottom-[10%] z-10 left-[20px] w-[180px] h-[180px] 800:bottom-[0%]",
              children: D.jsx(U_, {
                color: "#00CCED",
                rotationY: -0.002,
                rotationX: -0.008,
              }),
            }),
            D.jsx("button", {
              onClick: () => {
                m("hydrostars"), y(2), i(!0)
              },
              className:
                "absolute no-bg-button group top-[15%] z-10 left-[26%] w-[120px] h-[120px]",
              children: D.jsx(U_, {
                color: "#FF00D3",
                rotationY: 0.002,
                rotationX: 0.008,
              }),
            }),
            D.jsxs("div", {
              onMouseEnter: () => {
                A("star balm-m"), w("mmm star balm <3 delish + super hydrating! ")
              },
              onClick: () => {
                m("starbalm"), y(3), i(!0)
              },
              className:
                "absolute no-bg-button group max-w-[160px] h-auto -top-[6%] left-[44%] 800:left-[34%] lander_mango",
              children: [
                D.jsx(jl, { landing: Wl.mango_balm.landing }),
                D.jsx("span", {
                  className: Xn(
                    R,
                    "absolute -bottom-[10%] left-[50%] transform -rotate-[40deg]",
                  ),
                  children: "star balm",
                }),
              ],
            }),
            D.jsxs("button", {
              onMouseEnter: () => {
                A("hydro-stars"),
                  w("good pick… everybody's fav hydrocolloid pimple patches :)")
              },
              onClick: () => {
                m("hydrostars"), y(0), i(!0)
              },
              className:
                "absolute no-bg-button group max-w-[220px] left-[16%] bottom-[20%] lander_yellow",
              children: [
                D.jsx(jl, { landing: Wl.big_yellow.landing }),
                D.jsx("span", {
                  className: Xn(
                    R,
                    "absolute -bottom-[14%] left-[28%] transform rotate-[6deg]",
                  ),
                  children: "hydro-stars",
                }),
              ],
            }),
            D.jsxs("button", {
              onMouseEnter: () => {
                A("starwash"),
                  w(
                    "omg it's the newest duo for breakout-prone and sensitive skin :') ",
                  )
              },
              onClick: () => {
                m("skincare"), y(0), i(!0)
              },
              className:
                "absolute no-bg-button group max-w-[240px] h-auto left-[33%] bottom-[10%] 800:-bottom-[10%] lander_wash",
              children: [
                D.jsx(jl, { landing: Wl.starwash.landing }),
                D.jsx("span", {
                  className: Xn(
                    R,
                    "absolute bottom-[1%] left-[45%] transform -rotate-[12deg]",
                  ),
                  children: "skincare",
                }),
              ],
            }),
            D.jsxs("button", {
              onClick: () => {
                e(!0)
              },
              onMouseEnter: () => {
                A("how-it-works"), w("here's the full star routine 4 u :)")
              },
              className:
                "absolute no-bg-button group max-w-[180px] left-[51%] 800:left-[51%] bottom-[140px] 800:bottom-[15%] lander_how",
              children: [
                D.jsx(jl, { landing: Wl.how.landing }),
                D.jsx("span", {
                  className: Xn(
                    R,
                    "absolute -bottom-[18%] left-[28%] transform -rotate-[12deg]",
                  ),
                  children: "how it works",
                }),
              ],
            }),
            D.jsx("button", {
              onClick: () => {
                m("hydrostars"), y(4), i(!0)
              },
              className:
                "absolute no-bg-button group top-[26%] 800:top-[12%] left-[58%] 800:left-[48%] w-[100px] 800:w-[180px] h-[100px] 800:h-[180px]",
              children: D.jsx("img", {
                src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/landing-star-green.png?v=1740602037",
                alt: "how-it-works",
                className: "animate-star-2 transform",
              }),
            }),
            D.jsx("button", {
              onClick: () => {
                m("hydrostars"), y(0), i(!0)
              },
              className:
                "absolute no-bg-button group bottom-[23%] left-[66%] w-[80px] h-[90px] landing_yellow",
              children: D.jsx(U_, { color: "#FDFF00", rotationY: -0.005 }),
            }),
            D.jsx("button", {
              onClick: () => {
                m("hydrostars"), y(3), i(!0)
              },
              className:
                "absolute no-bg-button group -bottom-[4%] left-[53%] w-[120px] 800:-bottom-[10%] h-[120px] landing_purple",
              children: D.jsx("img", {
                src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/landing-star-purple.png?v=1740602037",
                alt: "how-it-works",
                className: "animate-star transform",
              }),
            }),
            D.jsxs("button", {
              onMouseEnter: () => {
                A("starcream"),
                  w(
                    "omg it's the newest duo for breakout-prone and sensitive skin :') ",
                  )
              },
              onClick: () => {
                m("skincare"), y(1), i(!0)
              },
              className:
                "absolute no-bg-button group max-w-[140px] left-[67%] 800:left-[68%] top-[5%] lander_cream",
              children: [
                D.jsx(jl, { landing: Wl.starcream.landing }),
                D.jsx("span", {
                  className: Xn(
                    R,
                    "absolute -bottom-[10%] left-[26%] transform rotate-[12deg]",
                  ),
                  children: "skincare",
                }),
              ],
            }),
            D.jsxs("button", {
              onClick: () => {
                l(!0)
              },
              onMouseEnter: () => {
                A("quiz"), w("take my lil quiz + find the patch 4 u !")
              },
              className:
                "absolute no-bg-button group max-w-[240px] 800:max-w-[280px] left-[69%] 800:left-[67%] bottom-[10%] 800:-bottom-[4%] landing_quiz",
              children: [
                D.jsx(jl, { landing: Wl.quiz.landing }),
                D.jsx("span", {
                  className: Xn(
                    R,
                    "absolute top-[30%] -right-[2%] transform -rotate-[65deg]",
                  ),
                  children: "star quiz",
                }),
              ],
            }),
            D.jsxs("button", {
              onMouseEnter: () => {
                A("starbalm"), w("mmm star balm <3 delish + super hydrating! ")
              },
              onClick: () => {
                m("starbalm"), y(4), i(!0)
              },
              className:
                "absolute no-bg-button group max-w-[160px] right-[0%] bottom-[90px] 800:bottom-[60px] landing_coconut",
              children: [
                D.jsx(jl, { landing: Wl.coconut_balm.landing }),
                D.jsx("span", {
                  className: Xn(
                    R,
                    "absolute -bottom-[10%] left-[30%] transform -rotate-[4deg]",
                  ),
                  children: "star balm",
                }),
              ],
            }),
            D.jsx("button", {
              onClick: () => {
                m("hydrostars"), y(2), i(!0)
              },
              className:
                "absolute opacity-50 no-bg-button group -top-[5%] right-[5%] w-[190px] h-[190px] ",
              children: D.jsx("img", {
                src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/landing-star-clear.png?v=1740602037",
                alt: "how-it-works",
                className: "how-bounce transform",
              }),
            }),
          ],
        }),
      [0],
    ),
    U = new Date().getFullYear()
  return D.jsxs("div", {
    className: "w-screen h-screen",
    children: [
      D.jsx("div", {
        className:
          "css-color-changer fixed left-0 top-0 w-full h-full -z-10 pointer-events-none",
      }),
      D.jsx(T9, { isOpen: n, setIsOpen: e }),
      D.jsx(S9, {
        isOpen: t,
        setIsOpen: i,
        product: p,
        setProduct: m,
        nestedProduct: v,
        setNestedProduct: y,
      }),
      D.jsx(b9, { isOpen: r, setIsOpen: s, ingredientIndex: x }),
      D.jsx(E9, { isOpen: o, setIsOpen: l }),
      D.jsx(M9, {
        isOpen: u,
        setIsOpen: d,
        openProduct: i,
        setProduct: m,
        setNestedProduct: y,
        openQuiz: l,
        openHowTo: e,
        setIngredientIndex: E,
        openIngredients: s,
      }),
      D.jsx(EU, { landingMessage: M }),
      D.jsx("div", {
        className:
          "fixed -top-1 left-5 800:left-10 800:top-6 z-1 text-black text-[14px] leading-[16px]",
        children: D.jsx("div", {
          className: "flex flex-col ",
          children: D.jsx("img", {
            src: "https://cdn.shopify.com/s/files/1/0070/8388/4615/files/star-corner-logo.svg?v=1741113312",
            alt: "starcorner",
            className: "w-[180px] h-[180px] 800:w-[260px] 800:h-[200px]",
          }),
        }),
      }),
      D.jsx("div", {
        className: "h-screen overflow-hidden w-screen flex items-center justify-center",
        children: D.jsxs("div", {
          ref: C,
          className: "keen-slider w-screen",
          children: [
            D.jsx("div", {
              className: "keen-slider__slide w-full text-[white] relative",
              style: { minWidth: "1400px" },
              children: z,
            }),
            D.jsx("div", {
              className: "keen-slider__slide w-full text-[white] relative",
              style: { minWidth: "1400px" },
              children: z,
            }),
            D.jsx("div", {
              className: "keen-slider__slide w-full text-[white] relative",
              style: { minWidth: "1400px" },
              children: z,
            }),
          ],
        }),
      }),
      D.jsx("div", {
        className:
          "fixed bottom-[22px] 800:bottom-5 right-5 z-1 text-black ff font-gt text-[14px] leading-[16px]",
        children: D.jsx("div", {
          className: "flex gap-8",
          children: D.jsx("button", {
            onClick: () => d(!0),
            className: "inline no-bg-button underline",
            children: "index",
          }),
        }),
      }),
      D.jsx("div", {
        className:
          "fixed bottom-5 left-5 z-1 text-black ff font-gt text-[11px] 800:text-[14px] leading-[16px]",
        children: D.jsx("div", {
          className: "flex gap-8",
          children: D.jsxs("span", {
            children: [
              "© ",
              U,
              ", ",
              D.jsx("a", {
                href: "https://www.starface.world",
                target: "_blank",
                className: "underline",
                children: "starface world",
              }),
              ", inc. all rights reserved.",
            ],
          }),
        }),
      }),
    ],
  })
}
function S9({
  isOpen: n,
  setIsOpen: e,
  product: t,
  setProduct: i,
  nestedProduct: r,
  setNestedProduct: s,
}) {
  return D.jsx(Ou, {
    show: n,
    enter: "transition duration-400 ease-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-100 opacity-100",
    leave: "transition duration-400 ease-out",
    leaveFrom: "transform scale-100 opacity-100",
    leaveTo: "transform scale-95 opacity-0",
    as: Y.Fragment,
    children: D.jsx(lm, {
      onClose: () => e(!1),
      className: "w-screen h-dvh 800:h-screen z-10 fixed top-0 left-0",
      children: D.jsx("div", {
        className:
          "w-full h-full bg-black overflow-hidden border-[5px] border-black relative",
        children: D.jsx(MU, {
          setIsOpen: e,
          product: t,
          setProduct: i,
          nestedProduct: r,
          setNestedProduct: s,
        }),
      }),
    }),
  })
}
function M9({
  isOpen: n,
  setIsOpen: e,
  openProduct: t,
  setProduct: i,
  setNestedProduct: r,
  openQuiz: s,
  openHowTo: o,
  openIngredients: l,
  setIngredientIndex: u,
}) {
  return D.jsx(Ou, {
    show: n,
    enter: "transition duration-400 ease-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-100 opacity-100",
    leave: "transition duration-400 ease-out",
    leaveFrom: "transform scale-100 opacity-100",
    leaveTo: "transform scale-95 opacity-0",
    as: Y.Fragment,
    children: D.jsx(lm, {
      onClose: () => e(!1),
      className: "w-screen h-dvh 800:h-screen z-10 fixed top-0 left-0",
      children: D.jsx("div", {
        className:
          "w-full h-full bg-black overflow-hidden border-[5px] border-black relative 1000:max-h-full",
        children: D.jsx(RU, {
          setIsOpen: e,
          openProduct: t,
          setProduct: i,
          setNestedProduct: r,
          openQuiz: s,
          openHowTo: o,
          openIngredients: l,
          setIngredientIndex: u,
        }),
      }),
    }),
  })
}
function E9({ isOpen: n, setIsOpen: e }) {
  return D.jsx(Ou, {
    show: n,
    enter: "transition duration-400 ease-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-100 opacity-100",
    leave: "transition duration-400 ease-out",
    leaveFrom: "transform scale-100 opacity-100",
    leaveTo: "transform scale-95 opacity-0",
    as: Y.Fragment,
    children: D.jsx(lm, {
      onClose: () => e(!1),
      className: "w-screen h-dvh 800:h-screen z-10 fixed top-0 left-0",
      children: D.jsx("div", {
        className:
          "w-full h-full bg-black overflow-hidden border-[5px] border-black relative",
        children: D.jsx(AU, { setIsOpen: e }),
      }),
    }),
  })
}
function T9({ isOpen: n, setIsOpen: e }) {
  return D.jsx(Ou, {
    show: n,
    enter: "transition duration-400 ease-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-100 opacity-100",
    leave: "transition duration-400 ease-out",
    leaveFrom: "transform scale-100 opacity-100",
    leaveTo: "transform scale-95 opacity-0",
    as: Y.Fragment,
    children: D.jsx(lm, {
      onClose: () => e(!1),
      className: "w-screen h-dvh 800:h-screen z-10 fixed top-0 left-0",
      children: D.jsx("div", {
        className:
          "w-full h-full bg-black overflow-hidden border-[5px] border-black relative",
        children: D.jsx(BF, { setIsOpen: e }),
      }),
    }),
  })
}
function b9({ isOpen: n, setIsOpen: e, ingredientIndex: t }) {
  return D.jsx(Ou, {
    show: n,
    enter: "transition duration-400 ease-out",
    enterFrom: "transform scale-95 opacity-0",
    enterTo: "transform scale-100 opacity-100",
    leave: "transition duration-400 ease-out",
    leaveFrom: "transform scale-100 opacity-100",
    leaveTo: "transform scale-95 opacity-0",
    as: Y.Fragment,
    children: D.jsx(lm, {
      onClose: () => e(!1),
      className: "w-screen h-dvh 800:h-screen z-10 fixed top-0 left-0",
      children: D.jsx("div", {
        className:
          "w-full h-full bg-black overflow-hidden border-[5px] border-black relative",
        children: D.jsx(TU, { setIsOpen: e, ingredientIndex: t }),
      }),
    }),
  })
}
AP.createRoot(document.getElementById("root")).render(
  D.jsx(Y.StrictMode, { children: D.jsx(w9, {}) }),
)
